'use strict';

function sbCronTaskComponent($scope, $element, $transclude, gridService) {
  const ctrl = this;

  //#region Private fields
  var isRendered = false;
  //#endregion

  //#region Public fields
  var _cronModel = undefined;
  var _addDisabled = undefined;
  var _deleteFunction = undefined;

  Object.defineProperty(ctrl, 'cronModel', {
    get: function() {
      return _cronModel;
    },
    set: function(cronModel) {
      _cronModel = cronModel;
    },
  });

  Object.defineProperty(ctrl, 'addDisabled', {
    get: function() {
      return _addDisabled;
    },
    set: function(addDisabled) {
      _addDisabled = addDisabled;
    },
  });

  Object.defineProperty(ctrl, 'deleteFunction', {
    get: function() {
      return _deleteFunction;
    },
    set: function(deleteFunction) {
      _deleteFunction = deleteFunction;
    },
  });

  //#endregion

  ctrl.testel = function(x) {};

  //#region Public methods
  ctrl.$onChanges = function $onChanges(changes) {
    if (!!changes.cronModel) {
      createDataSource(changes.cronModel.currentValue);
      if (isRendered) {
        ctrl.dailyCronListViewSource.read();
        ctrl.weeklyCronListViewSource.read();
        ctrl.monthlyCronListViewSource.read();
      }
    }
  };

  ctrl.$onInit = function $onInit() {
    ctrl.tabs = [
      { id: 'daily', title: 'Naponta' },
      { id: 'weekly', title: 'Hetente' },
      { id: 'monthly', title: 'Havonta' },
    ];
    ctrl.activeSubItemTab = 0;
    ctrl.addDisabled = _addDisabled;
    createDataSource(_cronModel);
    ctrl.renderingListView();
  };

  //#endregion

  //#region Private methods
  function createDataSource(cronModel) {
    if (typeof cronModel !== 'object') {
      throw new Error(`DataModel is missing!`);
    }
    if (!!cronModel.monthlyCronDtoList) {
      cronModel.monthlyCronDtoList.forEach(function(x) {
        x.IsDay = x.IsDay.toString();
      });
    }
    //create ObservableArray from model
    cronModel['dailyCronDtoList'] = !!cronModel.dailyCronDtoList
      ? new kendo.data.ObservableArray(cronModel.dailyCronDtoList)
      : new kendo.data.ObservableArray([]);
    cronModel['weeklyCronDtoList'] = !!cronModel.weeklyCronDtoList
      ? new kendo.data.ObservableArray(cronModel.weeklyCronDtoList)
      : new kendo.data.ObservableArray([]);
    cronModel['monthlyCronDtoList'] = !!cronModel.monthlyCronDtoList
      ? new kendo.data.ObservableArray(cronModel.monthlyCronDtoList)
      : new kendo.data.ObservableArray([]);
    //set activeTab
    if (cronModel['monthlyCronDtoList'].length > 0) ctrl.activeSubItemTab = 2;
    if (cronModel['weeklyCronDtoList'].length > 0) ctrl.activeSubItemTab = 1;
    if (cronModel['dailyCronDtoList'].length > 0) ctrl.activeSubItemTab = 0;
  }
  ctrl.addNewCron = function addNewCron(index) {
    if (index == '0') {
      $('#dailyCronListView')
        .data('kendoListView')
        .add();
    }
    if (index == '1') {
      $('#weeklyCronListView')
        .data('kendoListView')
        .add();
    }
    if (index == '2') {
      $('#monthlyCronListView')
        .data('kendoListView')
        .add();
    }
  };
  ctrl.renderingListView = function() {
    ctrl.dailyCronListViewSource = createSourceForListView(
      $('#dailyCronListView'),
      'dailyCronDtoList',
      'CronExpressionId'
    );
    ctrl.dailyCronTemplate = $('#dailyCronTemplate').html();
    ctrl.dailyCronEditTemplate = $('#dailyCronEditTemplate').html();

    ctrl.weeklyCronListViewSource = createSourceForListView(
      $('#weeklyCronListView'),
      'weeklyCronDtoList',
      'CronExpressionId'
    );
    ctrl.weeklyCronTemplate = $('#weeklyCronTemplate').html();
    ctrl.weeklyCronEditTemplate = $('#weeklyCronEditTemplate').html();

    ctrl.monthlyCronListViewSource = createSourceForListView(
      $('#monthlyCronListView'),
      'monthlyCronDtoList',
      'CronExpressionId'
    );
    ctrl.monthlyCronTemplate = $('#monthlyCronTemplate').html();
    ctrl.monthlyCronEditTemplate = $('#monthlyCronEditTemplate').html();

    ctrl.timePickerOptions = { format: 'HH:mm', dateInput: true, interval: 10 };

    ctrl.dayPickerOptions = {
      autobind: false,
      placeholder: '',
      dataTextField: 'text',
      dataValueField: 'key',
      filter: 'contains',
      valuePrimitive: true,
      dataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Task/WeekDaysList',
          },
        },
        schema: {
          data: function(response) {
            let data = response?.data ?? response;
            return data;
          },
          model: {
            fields: {
              key: { type: 'string' },
              value: 'string',
            },
          },
        },
        pageSize: 8,
      }),
      dataBound: function(e) {
        $('#weekday').val(this.value().length > 0 ? '' : 'ok');
      },
      change: function(e) {
        if (this.value().includes('ALL')) {
          var data = this.dataSource.data();
          var result = [];
          for (var item in data) {
            if (typeof data[item].key !== 'undefined' && data[item].key !== 'ALL') {
              result.push(data[item].key);
            }
          }
          this.value(result);
          this.$angular_scope.dataItem.Days = this.value();
          this.$angular_scope.$apply();
        }
      },
      select: function(e) {
        $('#weekday').val('ok');
      },
      deselect: function(e) {
        var values = this.value();
        $('#weekday').val(values.length <= 1 ? '' : 'ok');
      },
    };
    ctrl.monthPickerOptions = {
      autobind: false,
      placeholder: 'Hónap',
      dataTextField: 'text',
      dataValueField: 'key',
      filter: 'contains',
      valuePrimitive: true,
      dataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Task/MonthNamesList',
          },
        },
        schema: {
          data: function(response) {
            let data = response?.data ?? response;
            return data;
          },
          model: {
            fields: {
              key: { type: 'string' },
              value: 'string',
            },
          },
        },
        pageSize: 13,
      }),
      dataBound: function(e) {
        $('#monthMulti').val(this.value().length > 0 ? '' : 'ok');
      },
      change: function(e) {
        if (this.value().includes('13')) {
          var data = this.dataSource.data();
          var result = [];
          for (var item in data) {
            if (typeof data[item].key !== 'undefined' && data[item].key !== '13') {
              result.push(data[item].key);
            }
          }
          this.value(result);
          this.$angular_scope.dataItem.Months = this.value();
          this.$angular_scope.$apply();
        }
      },
      select: function() {
        $('#monthMulti').val('ok');
      },
      deselect: function(e) {
        var values = this.value();
        $('#monthMulti').val(values.length <= 1 ? '' : 'ok');
      },
    };

    ctrl.dayNumberPickerOptions = {
      autobind: false,
      placeholder: '',
      dataTextField: 'text',
      dataValueField: 'key',
      filter: 'contains',
      valuePrimitive: true,
      dataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Task/MonthDayNumberList',
          },
        },
        schema: {
          data: function(response) {
            let data = response?.data ?? response;
            return data;
          },
          model: {
            fields: {
              key: { type: 'string' },
              value: 'string',
            },
          },
        },
        pageSize: 33,
      }),
      dataBound: function(e) {
        $('#dayNumberMulti').val(this.value().length > 0 ? '' : 'ok');
      },
      change: function(e) {
        if (this.value().includes('Összes')) {
          var data = this.dataSource.data();
          var result = [];
          for (var item in data) {
            if (typeof data[item].key !== 'undefined' && data[item].key !== 'Összes') {
              result.push(data[item].key);
            }
          }
          this.value(result);
          this.$angular_scope.dataItem.DayNumber = this.value();
          this.$angular_scope.$apply();
        }
      },
      select: function() {
        $('#dayNumberMulti').val('ok');
      },
      deselect: function(e) {
        var values = this.value();
        $('#dayNumberMulti').val(values.length <= 1 ? '' : 'ok');
      },
    };

    ctrl.dayComboOptions = {
      autobind: true,
      placeholder: '',
      dataTextField: 'text',
      dataValueField: 'key',
      filter: 'contains',
      dataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Task/MonthDayList',
          },
        },
        schema: {
          data: function(response) {
            let data = response?.data ?? response;
            return data;
          },
          model: {
            fields: {
              key: { type: 'string' },
              value: 'string',
            },
          },
        },
        pageSize: 7,
      }),
      change: function() {},
    };
    isRendered = true;
  };

  ctrl.teszttt = function(dataItem, value) {
    debugger;
  };

  function createSourceForListView(listView, dataItem, idField) {
    return new kendo.data.DataSource({
      transport: {
        read: function(options) {
          options.success(_cronModel[dataItem]);
          ctrl.cronHasEdit = false;
        },
        create: function(options) {
          var item = options.data;
          item[idField] = kendo.guid();
          item.ModelState = 2;
          options.success(item);
        },
        update: function(options) {
          var item = options.data;
          item.ModelState = item.ModelState == 0 ? 3 : item.ModelState;
          options.success(item);
        },
        destroy: function(options) {
          if (
            (options.data.ModelState === 0 || options.data.ModelState === 3) &&
            angular.isFunction(ctrl.deleteFunction)
          ) {
            ctrl.deleteFunction(options);
          } else {
            options.success();
          }
        },
      },
      error: function(e) {
        this.cancelChanges();
        ctrl.cronModel[dataItem] = e.sender.data();
      },
      schema: {
        data: function(response) {
          let data = response?.data ?? response;
          return data;
        },
        model: {
          id: idField,
        },
      },
      batch: false,
      pageSize: 1,
      change: function(e) {
        if (e.action === 'add') {
          e.items[0].CronExpressionIsErasable = true;
          //alapértelmezett értékek
          ctrl.cronHasEdit = true;
          e.items[0].Time = '06:00';
          if (dataItem == 'monthlyCronDtoList') {
            e.items[0].IsDay = 'true';
          }
        } else {
          ctrl.cronHasEdit = false;
        }

        if (e.action === 'sync') {
          var item = e.items[0];
          if (item) {
            item.ModelState = item.ModelState == 0 ? 3 : item.ModelState;
          }
          //ha az utolsó lap lett törölve, visszaugrunk az elejére:
          let sourceName = dataItem.replace('DtoList', 'ListViewSource');
          if (ctrl[sourceName].data().length < ctrl[sourceName].page()) ctrl[sourceName].page(0);
        }
      },
    });
  }
  //#endregion
}

const sbCronTaskComponentOptions = {
  templateUrl: 'App/ui-kit/sb-cron-task/sb-cron-task.component.html',
  controller: sbCronTaskComponent,
  transclude: true,
  bindings: {
    cronModel: '<',
    addDisabled: '<',
    ngDisabled: '<',
    deleteFunction: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbCronTask: sbCronTaskComponentOptions,
  };

  const sbCronTaskModule = angular.module('sbCronTask', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbCronTaskModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbGridWrapperComponent($scope, $element, $transclude, gridService, $rootScope, AuthService, $http) {
  const ctrl = this;

  const { BehaviorSubject, interval, of } = rxjs;
  const { debounce, map, switchMap, filter, tap, concatMap } = rxjs.operators;

  //#region Private fields

  /**
   * @type {
   *   $transcludedElement: jQueryElement,
   *   transclusionScope: scopeObject
   * }
   */
  var prevTranscluded = undefined;

  const _isLoading$ = new BehaviorSubject(false);
  const _kendoConfig$ = new BehaviorSubject(undefined);

  //#endregion

  //#region Public fields

  var _kendoConfig = undefined;

  Object.defineProperty(ctrl, 'kendoConfig', {
    get: function() {
      return _kendoConfig;
    },
    set: function(kendoConfig) {
      _kendoConfig = kendoConfig;
      _kendoConfig$?.next(kendoConfig);
    },
  });

  ctrl.isLoading$ = _isLoading$.pipe(
    debounce(isLoading => {
      if (!!isLoading) {
        return interval(100);
      } else {
        return of(isLoading);
      }
    })
  );

  //#endregion

  var _subscription = undefined;

  //#region Public methods
  function init() {
    if (_subscription) return;

    _subscription = _kendoConfig$
      .pipe(
        filter(kendoConfig => !!kendoConfig),
        tap(() => _isLoading$.next(true)),
        map(kendoConfig => {
          if (!!AuthService.parameters?.FWCOID) {
            kendoConfig.disableOptions = { GridStateSave: true, GridStateRestore: true };

            if (kendoConfig.filterable !== false) {
              kendoConfig.filterable = { mode: 'row', show: 'row' };
            }
          }
          if (kendoConfig?.pageSizes) {
            kendoConfig.pageable.pageSizes = kendoConfig.pageSizes;
          }
          return kendoConfig;
        }),
        map(kendoConfig =>
          addResetButtonWhenLoaded(kendoConfig, kendoGrid => {
            delete _kendoConfig.dataBound;
            kendoGrid.setOptions(_kendoConfig);
            kendoGrid.setDataSource(_kendoConfig.dataSource);
            gridService.saveKendoGrid(kendoGrid);
          })
        ),
        map(kendoConfig => addExcelButtonWhenLoaded(kendoConfig, kendoGrid => {})),
        map(kendoConfig => addTextSizeWhenLoaded(kendoConfig, kendoGrid => {})),
        map(kendoConfig =>
          addFilterToggle(kendoConfig, kendoGrid => {
            if (kendoGrid.options.filterable.mode === 'row' && kendoConfig.filterable.show !== 'row') {
              kendoGrid.setOptions({ filterable: Object.assign({}, kendoGrid.options.filterable, { mode: true }) });
            } else if (!!kendoGrid.options.filterable.mode) {
              kendoGrid.setOptions({ filterable: Object.assign({}, kendoGrid.options.filterable, { mode: 'row' }) });
            }
            gridService.saveKendoGrid(kendoGrid);
          })
        ),
        map(kendoConfig => addIdentity(kendoConfig, $rootScope, AuthService)),
        map(kendoConfig => saveOnColumnHide(kendoConfig)),
        map(kendoConfig => saveOnColumnShow(kendoConfig)),
        map(kendoConfig => saveOnColumnReorder(kendoConfig)),
        map(kendoConfig => saveOnColumnResize(kendoConfig)),
        map(kendoConfig => saveOnColumnLock(kendoConfig)),
        map(kendoConfig => saveOnColumnUnlock(kendoConfig)),
        map(kendoConfig => saveOnChange(kendoConfig)),
        map(kendoConfig => saveOnFiltering(kendoConfig)),
        map(kendoConfig => saveOnSorting(kendoConfig)),
        map(kendoConfig => saveOnGrouping(kendoConfig)),
        map(kendoConfig => saveOnPaging(kendoConfig)),
        concatMap(kendoConfig => {
          return new Promise(async (resolve, reject) => {
            if (!AuthService.parameters?.FWCOID && !!kendoConfig?.storageKey) {
              try {
                await gridService.downloadGridState(kendoConfig);
              } catch (e) {
                console.warn('downloadGridState failed, continuing without state.', e);
              }
              resolve(kendoConfig);
            } else {
              resolve(kendoConfig);
            }
          });
        }),
        concatMap(kendoConfig => {
          return new Promise(async (resolve, reject) => {
            if (!AuthService.parameters?.FWCOID && !!kendoConfig?.storageKey) {
              try {
                let rules = await gridService.downloadGridDisplayRules(kendoConfig);
                const dataBound = kendoConfig.dataBound;
                kendoConfig.dataBound = function(e) {
                  typeof dataBound === 'function' && dataBound.call(this, ...arguments);
                  loadGridDisplayRules(e, rules.Value.GridDisplayRules);
                };
              } catch (e) {
                console.warn('downloadGridDisplayRules failed, continuing without display rules.', e);
              }
              resolve(kendoConfig);
            } else {
              resolve(kendoConfig);
            }
          });
        }),
        concatMap(async kendoConfig => {
          const restoredConfig = await gridService.restoreState(kendoConfig).toPromise();
          kendo.destroy($element.find('.kendo-grid-container'));
          await renderGrid(restoredConfig);
          _isLoading$?.next(false);
        })
      )
      .subscribe(() => {});
  }

  ctrl.$onInit = function $onInit() {
    if (!AuthService?.parameters && AuthService?.getUserParametersFromServer) {
      AuthService?.getUserParametersFromServer()?.finally(() => {
        init();
      });
    } else {
      init();
    }
  };

  ctrl.$onDestroy = function $onDestroy() {
    if (_subscription) {
      _subscription.unsubscribe();
      _subscription = undefined;
    }
  };

  //#endregion

  //#region Private methods

  async function removePreviousTranscluded() {
    if (!!prevTranscluded) {
      prevTranscluded?.transclusionScope?.$destroy();
      if (prevTranscluded.$transcludedElement) {
        kendo.destroy(prevTranscluded.$transcludedElement);
      }
      await prevTranscluded?.$transcludedElement?.remove();
      await delete prevTranscluded?.$transcludedElement;
    }
  }

  async function renderGrid($kendoConfig) {
    await new Promise(resolve => {
      $transclude(async function(clone, transclusionScope) {
        if ($element.find('.kendo-grid-container')?.first()?.length < 1) {
          transclusionScope.$destroy();
          kendo.destroy($(clone));
          resolve();
          return;
        }
        await removePreviousTranscluded();
        if (!!AuthService?.parameters?.FWCOID) {
          $kendoConfig?.columns.forEach(x => {
            if (
              !!$kendoConfig.dataSource.schema?.model?.fields[x.field] &&
              $kendoConfig.dataSource.schema.model.fields[x.field]['type'] === 'number'
            ) {
              x.format = null;
              $kendoConfig.dataSource.schema.model.fields[x.field]['type'] = 'string';
            }
            return x;
          });
        }
        transclusionScope.$kendoConfig = $kendoConfig;

        const $transcludedElement = $(clone);
        if ($element.find('.kendo-grid-container')?.first()?.length > 0) {
          $transcludedElement?.appendTo($element.find('.kendo-grid-container').first());
        }
        prevTranscluded = {
          $transcludedElement,
          transclusionScope,
        };
        resolve();
      });
    });
  }

  function addResetButtonWhenLoaded(_kendoConfig, onReset) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const dataBound = kendoConfig.dataBound;
    kendoConfig.dataBound = function() {
      if (!!this.$angular_scope?.$parent?.$ctrl) {
        this.$angular_scope.$parent.$ctrl.gridElement = this;
      }
      const kendoGridRef = this;
      let textSize = kendoGridRef?.options?.textSize ?? kendoConfig?.textSize;
      if (textSize) {
        setFontSize(textSize);
      }
      this.origKendoConfig = _kendoConfig;
      typeof dataBound === 'function' && dataBound.call(this, ...arguments);

      const $pagerWrapElement = $element.find('.k-pager-wrap.k-grid-pager');

      $('[data-field="checkAll"] .k-header-column-menu').remove();

      if ($pagerWrapElement.find('.sb-reset-grid-state-button').length < 1) {
        const $resetButton = $(
          `<a href="#" id="filterrefresh-a" class="k-pager-refresh k-link sb-reset-grid-state-button" title="Állapot visszaállítása" aria-label="Állapot visszaállítása">
             <span id="filterrefresh-span" class="fa fa-undo"></span>
           </a>`
        );
        $resetButton.on('click', function(event) {
          event.preventDefault();
          if (!kendoGridRef?.options?.textChange) {
            kendoGridRef.options.textSize = null;
          }
          typeof onReset === 'function' && onReset.call(this, kendoGridRef, ...arguments);
        });
        $resetButton.appendTo($pagerWrapElement);
      }
    };

    return kendoConfig;
  }
  function addExcelButtonWhenLoaded(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const dataBound = kendoConfig.dataBound;
    kendoConfig.dataBound = function() {
      const kendoGridRef = this;
      this.origKendoConfig = _kendoConfig;
      typeof dataBound === 'function' && dataBound.call(this, ...arguments);

      const $pagerWrapElement = $element.find('.k-pager-wrap.k-grid-pager');
      const $gridExcelButton = $(
        `<a href="#" id="gridexcel-a" class="sb-grid-excel k-pager-button" title="Exportálás excelbe" aria-label="Exportálás excelbe" 
            >
               <span id="gridexcel-span" class="fa fa-file-excel-o"></span>
             </a>`
      );
      if (!$pagerWrapElement.find('#gridexcel-a').length) {
        $gridExcelButton.on('click', function(event, kendoGridRef) {
          event.preventDefault();
          let grid = $(this.parentElement.parentElement);
          grid.data('kendoGrid').bind('excelExport', function(e) {
            e.workbook.fileName =
              'Export_' +
              new Date()
                .toLocaleDateString()
                .replaceAll(' ', '')
                .replaceAll('.', '_') +
              e.sender.options.descriptorName +
              '.xlsx';
            kendo.ui.progress(grid, false);
          });
          kendo.ui.progress(grid, true);
          let gridData = grid.data('kendoGrid');
          gridData.saveAsExcel();
        });
        $gridExcelButton.appendTo($pagerWrapElement);
      }
    };

    return kendoConfig;
  }
  function addTextSizeWhenLoaded(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);
    if (!kendoConfig?.textSizeCombo) {
      return kendoConfig;
    }
    const dataBound = kendoConfig.dataBound;
    kendoConfig.dataBound = function() {
      const kendoGridRef = this;
      this.origKendoConfig = _kendoConfig;
      typeof dataBound === 'function' && dataBound.call(this, ...arguments);

      const $pagerWrapElement = $element.find('.k-pager-wrap.k-grid-pager');
      const $gridTextSizeButton = $(`<select class="textsizecombo" style="width:50px"></select>`);
      if (!$pagerWrapElement.find('.textsizecombo').length) {
        $gridTextSizeButton.appendTo($pagerWrapElement);
        var fontSize =
          kendoConfig?.textSize ??
          $element
            .find('th')
            .css('font-size')
            ?.replace('px', '');
        let ddl = $pagerWrapElement.find('.textsizecombo').kendoDropDownList({
          dataTextField: 'Id',
          dataValueField: 'Id',
          dataSource: new kendo.data.DataSource({
            data: [{ Id: 6 }, { Id: 8 }, { Id: 10 }, { Id: 12 }, { Id: 14 }, { Id: 16 }, { Id: 18 }, { Id: 20 }],
          }),
          filterable: false,
          clearButton: false,
          suggest: true,
          value: fontSize,
          autoClose: false,
          change: textDDLChange,
        });
        kendoGridRef.textDDL = $(ddl).data('kendoDropDownList');
        function textDDLChange(e) {
          let ddl = kendoGridRef.textDDL ?? this;
          if (fontSize == ddl.value()) {
            return;
          }
          fontSize = ddl.value();
          setFontSize(ddl.value());
          kendoGridRef.options.textSize = ddl.value();
          if (kendoGridRef?.options?.textChange) {
            typeof kendoGridRef.options.textChange === 'function' && kendoGridRef.options.textChange(ddl.value());
          }
          setTimeout(() => {
            gridService.saveKendoGrid(kendoGridRef);
          }, 0);
        }
        $pagerWrapElement
          .find('.textsizecombo .k-i-arrow-s')
          .replaceWith($('<span id="gridtsize-span" title="Betű méret" class="fa fa-font"/>'));
        kendoGridRef.textDDLChange = textDDLChange;
      }
    };

    return kendoConfig;
  }
  function setFontSize(size) {
    var value = size + 'px';
    $element.find('th').css('font-size', value);
    $element.find('td').css('font-size', value);
  }
  function addIdentity(_kendoConfig, $rootScope, AuthService) {
    const kendoConfig = _.cloneDeep(_kendoConfig);
    if (!AuthService.parameters?.FWCOID) {
      return kendoConfig;
    }

    const dataBound = kendoConfig.dataBound;
    kendoConfig.dataBound = function(e) {
      const kendoGridRef = this;
      typeof dataBound === 'function' && dataBound.call(this, ...arguments);

      var gridIdColumn;
      if (!!this.options?.idColumn) {
        gridIdColumn = this.options.idColumn;
      } else if (!!this.$angular_scope.$parent?.$parent?.f2Options?.gridOptions?.tableKey) {
        gridIdColumn = this.$angular_scope.$parent.$parent.f2Options.gridOptions.tableKey;
      } else if (!!this.$angular_scope.$parent?.$parent?.f4Options?.gridOptions?.tableKey) {
        gridIdColumn = this.$angular_scope.$parent.$parent.f4Options.gridOptions.tableKey;
      } else if (!!this.$angular_scope.$parent?.miCtrl?.gridIdMapping) {
        gridIdColumn = this.$angular_scope.$parent?.miCtrl?.gridIdMapping;
      }

      var gridId = this.options.id;

      var rowNumber = 0;
      $element.find('tr[data-uid]').each(function(index, elementTr) {
        rowNumber++;
        let uid = $(this).attr('data-uid');
        let addClass = gridId + '_row_' + rowNumber;
        if (!$(elementTr).hasClass(addClass)) {
          let classes = $(elementTr).attr('class');
          $(elementTr)
            .removeClass()
            .addClass(addClass + ' ' + classes);

          $(elementTr)
            .find('td')
            .each(function(index, elementTd) {
              let columnName = $(elementTd)
                .find('span')
                .attr('ng-bind')
                ?.split('.')[1];
              let addClass = gridId + '_' + columnName + '_cell';
              if (!$(elementTd).hasClass(addClass)) {
                let classes = $(elementTd).attr('class');
                $(elementTd)
                  .removeClass()
                  .addClass(addClass + ' ' + classes);
              }
              addClass = gridId + '_' + columnName + '_cell';
              $(elementTd)
                .find('*')
                .each(function(index, element) {
                  if (!$(element).hasClass(addClass)) {
                    let classes = $(element).attr('class');
                    $(element)
                      .removeClass()
                      .addClass(addClass + ' ' + classes);
                  }
                });
            });
        }
        uid = 0;
      });
      $element
        .find('tr *')
        .has('th[role=columnheader]')
        .each(function(index, elementTr) {
          let addClass = gridId + '_hrow';
          if (!$(elementTr).hasClass(addClass)) {
            let classes = $(elementTr).attr('class');
            $(elementTr)
              .removeClass()
              .addClass(addClass + ' ' + classes);
          }
          $(elementTr)
            .find('th')
            .each(function(index, elementTd) {
              let columnName = $(elementTd).attr('data-field');
              let addClass = gridId + '_' + columnName + '_';
              $(elementTd).attr('id', addClass);

              addClass = gridId + '_' + columnName + '_hcin';
              $(elementTd)
                .find('*')
                .each(function(index, element) {
                  let classes = $(element).attr('class');
                  let type = $(element).prop('nodeName');
                  $(element).attr('id', addClass + '_' + type + '_' + classes);
                });
            });
        });
      var ids = [];
      $element.find('.k-filter-row th ').each(function(index, elementTh) {
        let columnName = $(elementTh)
          .find('span')
          .attr('data-field');
        let addClass = gridId + '_' + columnName + '_';
        let classes = $(elementTh).attr('class');
        let type = $(elementTh).prop('nodeName');
        let idTh = (addClass + '_filter_' + type + '_' + classes).replace(/[\.:\ \(\)]/g, '_');
        ids[idTh] = ids[idTh] > 0 ? ids[idTh] + 1 : 1;
        idTh += ids[idTh] > 1 ? ids[idTh] : '';
        $(elementTh).attr('id', idTh);
        $(elementTh)
          .find('*')
          .each(function(index, element) {
            let addClass = gridId + '_' + columnName + '_';
            let classes = $(element).attr('class');
            let type = $(element).prop('nodeName');
            if (classes == 'k-input-inner') {
              classes = 'k-input';
            }
            let idElement = (addClass + '_filter_' + type + '_' + classes).replace(/[\.:\ \(\)]/g, '_');
            ids[idElement] = ids[idElement] > 0 ? ids[idElement] + 1 : 1;
            idElement += ids[idElement] > 1 ? ids[idElement] : '';
            $(element).attr('id', idElement);
          });
      });
      $element.find('div[data-role=pager]:first *').each(function(index, element) {
        let addClass = gridId + '_pager_' + $(element).prop('nodeName');
        let type = $(element).prop('nodeName');
        let classes = $(element).attr('class');
        $(element)
          .removeClass()
          .addClass(addClass + ' ' + classes);
      });
    };
    return kendoConfig;
  }

  function addFilterToggle(_kendoConfig, filterModeChange) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const dataBound = kendoConfig.dataBound;
    kendoConfig.dataBound = function() {
      const kendoGridRef = this;
      typeof dataBound === 'function' && dataBound.call(this, ...arguments);

      let toggleDisplay = !AuthService.parameters?.FWCOID ? '' : ' style="display:none;" ';

      const $pagerWrapElement = $element.find('.k-pager-wrap.k-grid-pager');
      if ($pagerWrapElement.find('.sb-filter-mode-toggle').length < 1) {
        const $addFilterButton = $(
          `<a href="#" id="filtershow-a" class="k-pager-refresh k-link sb-filter-mode-toggle sb-filters-add" title="Sor szűrők megjelenítése" aria-label="Sor szűrők megjelenítése" ` +
            toggleDisplay +
            `>
               <span id="filtershow-span" class="k-icon k-i-filter"></span>
             </a>`
        );

        const $removeFilterButton = $(
          `<a href="#" id="filterclear_a" class="k-pager-refresh k-link sb-filter-mode-toggle sb-filters-remove" title="Sor szűrők eltüntetése" aria-label="Sor szűrők eltüntetése" ` +
            toggleDisplay +
            `>
                 <span id="filterclear_span" class="k-icon k-i-filter-clear"></span>
               </a>`
        );

        $addFilterButton.on('click', function(event) {
          event.preventDefault();

          typeof filterModeChange === 'function' && filterModeChange.call(this, kendoGridRef);

          $addFilterButton.remove();
          $removeFilterButton.appendTo($pagerWrapElement);
        });

        $removeFilterButton.on('click', function(event) {
          event.preventDefault();

          typeof filterModeChange === 'function' && filterModeChange.call(this, kendoGridRef);

          $removeFilterButton.remove();
          $addFilterButton.appendTo($pagerWrapElement);
        });

        if (kendoGridRef.options.filterable.mode === 'row') {
          $removeFilterButton.appendTo($pagerWrapElement);
        } else if (kendoGridRef.options.filterable !== false) {
          $addFilterButton.appendTo($pagerWrapElement);
        }
      }
      if (!!this.dataSource.filter()) {
        $pagerWrapElement?.find('.sb-filter-mode-toggle')?.addClass('sb-columns-filtered');
      } else {
        $pagerWrapElement?.find('.sb-filter-mode-toggle')?.removeClass('sb-columns-filtered');
      }
    };

    return kendoConfig;
  }

  function saveOnColumnHide(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnHide = kendoConfig.columnHide;
    kendoConfig.columnHide = function() {
      typeof columnHide === 'function' && columnHide.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnColumnShow(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnShow = kendoConfig.columnShow;
    kendoConfig.columnShow = function() {
      typeof columnShow === 'function' && columnShow.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnColumnReorder(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnReorder = kendoConfig.columnReorder;
    kendoConfig.columnReorder = function() {
      typeof columnReorder === 'function' && columnReorder.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnColumnResize(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnResize = kendoConfig.columnResize;
    kendoConfig.columnResize = function() {
      typeof columnResize === 'function' && columnResize.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnColumnLock(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnLock = kendoConfig.columnLock;
    kendoConfig.columnLock = function() {
      typeof columnLock === 'function' && columnLock.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnColumnUnlock(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const columnUnlock = kendoConfig.columnUnlock;
    kendoConfig.columnUnlock = function() {
      typeof columnUnlock === 'function' && columnUnlock.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnChange(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const change = kendoConfig.change;
    kendoConfig.change = function() {
      typeof change === 'function' && change.call(this, ...arguments);
      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnFiltering(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const onFiltering = kendoConfig.filter;
    kendoConfig.filter = function() {
      typeof onFiltering === 'function' && onFiltering.call(this, ...arguments);

      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnSorting(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const onSorting = kendoConfig.filter;
    kendoConfig.sort = function() {
      typeof onSorting === 'function' && onSorting.call(this, ...arguments);

      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnGrouping(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const onGrouping = kendoConfig.filter;
    kendoConfig.group = function() {
      typeof onGrouping === 'function' && onGrouping.call(this, ...arguments);

      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function saveOnPaging(_kendoConfig) {
    const kendoConfig = _.cloneDeep(_kendoConfig);

    const onPaging = kendoConfig.filter;
    kendoConfig.page = function() {
      typeof onPaging === 'function' && onPaging.call(this, ...arguments);

      setTimeout(() => {
        gridService.saveKendoGrid(this);
      }, 0);
    };

    return kendoConfig;
  }

  function loadGridDisplayRules(e, rules) {
    e.sender.tbody.children('.k-master-row').each(function() {
      var row = $(this);
      var detailRow = row.next('.k-detail-row');
      var title = [];
      var item = e.sender.dataItem(row);
      if (item) {
        rules.forEach(_rule => {
          var match = new kendo.data.Query([item]).filter(JSON.parse(_rule.ExpressionJson)).data.length > 0;
          if (match) {
            row
              .attr('title', _rule.RuleName)
              .addClass('grid-display-rule')
              .css(JSON.parse(_rule.CssJson));
            detailRow
              .attr('title', _rule.RuleName)
              .addClass('grid-display-rule')
              .css(JSON.parse(_rule.CssJson));
            title.push(_rule.RuleName);
          }
        });
        if (angular.isArray(title) && title.length > 0) {
          row.attr('title', 'Kiemelés oka: ' + title.join(', '));
          detailRow.attr('title', 'Kiemelés oka: ' + title.join(', '));
        }
      }
    });
  }

  //#endregion
}

const sbGridWrapperComponentOptions = {
  templateUrl: 'App/ui-kit/sb-grid-wrapper/sb-grid-wrapper.component.html',
  controller: sbGridWrapperComponent,
  transclude: true,
  bindings: {
    kendoConfig: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbGridWrapper: sbGridWrapperComponentOptions,
  };

  const sbGridWrapperModule = angular.module('sbGridWrapper', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbGridWrapperModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbDmsButtonComponent(LanguageService, AuthService, $state, $http, $element, $window) {
  const ctrl = this;

  const { BehaviorSubject } = rxjs;
  const { debounceTime } = rxjs.operators;
  const loadCount = new BehaviorSubject();

  loadCount.pipe(debounceTime(1000)).subscribe(x => refreshBadge(x));

  //#region Private fields
  var authService = AuthService;
  ctrl.useDas = authService.getForrasParameterValue('fordas') === '1';
  ctrl.useDms = authService.getForrasParameterValue('fordms') === '1';
  //#endregion
  let labels = LanguageService?.getDictionary()?.dms;
  ctrl.labels = labels ?? {
    newDocument: 'Új dokumentum csatolása',
    attachDocuments: 'Kapcsolt dokumentumok',
    title: 'Dokumentum csatolás',
  };
  //#region Public fields
  var _dasModel = undefined;
  ctrl.hasBadge = false;

  Object.defineProperty(ctrl, 'dasModel', {
    get: function() {
      return _dasModel;
    },
    set: function(dasModel) {
      _dasModel = dasModel;
    },
  });
  //#endregion

  //#region Public methods
  ctrl.$onChanges = function $onChanges(changes) {
    ctrl.hasBadge = false;
    if (!!changes.dasModel && !!changes.dasModel.currentValue) {
      ctrl.hasDasModel = !!ctrl.dasModel && !!ctrl.dasModel.tableId && !!ctrl.dasModel.ownerId;
      loadCount.next(changes.dasModel.currentValue);
    }
  };

  ctrl.$onInit = function $onInit() {
    ctrl.hasButton = ctrl.useDas === true || ctrl.useDms === true;
    ctrl.dasModel = _dasModel;

    if (!!ctrl.actionState) {
      let controller = $state.router.urlRouter._rules.find(x => x.state.name == ctrl.actionState)?.state?.options
        ?.mvcController;
      if (!!controller) {
        ctrl.action = controller;
      }
    }
    if (!!ctrl.action) {
      AuthService.executeActionWithPermission(ctrl, 'attachDocument', ctrl.action, true, $element);
      AuthService.executeActionWithPermission(ctrl, 'attachDocument', ctrl.action, true, $element);
    }
  };
  //#endregion

  //#region Private methods
  ctrl.attachDocument = function() {
    if (ctrl.useDas) {
      let params = { tableId: ctrl.dasModel.tableId, ownerId: ctrl.dasModel.ownerId };
      //$state.go(ctrl.dasModel.routeId, params);
      var url = $state.href(ctrl.dasModel.routeId, params);
      $window.open(url, '_blank');
      return true;
    }

    if (ctrl.useDms) {
      let params = {
        dasTableId: ctrl.dasModel.tableId,
        dasOwnerId: ctrl.dasModel.ownerId,
        lockPreviousState: true,
      };
      //$state.go('Document.DocumentNav', params);
      var url = $state.href('Document.DocumentNavOpen', params);
      $window.open(url, '_blank');
      return true;
    }
  };
  ctrl.newDocument = function() {
    let params = {
      id: 0,
      dasTableId: ctrl.dasModel.tableId,
      dasOwnerId: ctrl.dasModel.ownerId,
    };
    var url = $state.href('Document.DocumentCreate', params);
    $window.open(url, '_blank');
    return true;
  };

  ctrl.forrasDocLib = function() {
    let params = { tableId: ctrl.dasModel.tableId, ownerId: ctrl.dasModel.ownerId };
    var url = $state.href('ForrasDoclib.DocumentNav', params);
    $window.open(url, '_blank');
  };

  function refreshBadge(_dasModel) {
    if (!!_dasModel && !!_dasModel.tableId && _dasModel.ownerId) {
      $http
        .get('Dms/Document/getAttachedDocuments', {
          params: { tableId: _dasModel.tableId, ownerId: _dasModel.ownerId, useDas: ctrl.useDas === true },
        })
        .then(function(result) {
          ctrl.count = result.data;
          ctrl.hasBadge = ctrl.count >= 0;
        });
    }
  }

  //#endregion
}

const sbDmsButtonComponentOptions = {
  templateUrl: 'App/ui-kit/sb-dms-button/sb-dms-button.component.html',
  controller: sbDmsButtonComponent,
  transclude: true,
  bindings: {
    dasModel: '<',
    ngDisabled: '<',
    title: '@',
    action: '@',
    actionState: '@',
  },
};

'use strict';

(function() {
  const components = {
    sbDmsButton: sbDmsButtonComponentOptions,
  };

  const sbDmsButtonModule = angular.module('sbDmsButton', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbDmsButtonModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbSaveButtonComponent($scope, $document, $interval, $element, AuthService, $state, LanguageService) {
  const ctrl = this;

  $scope.errorMessages = LanguageService.getDictionary()?.errorMessages;

  $document.on('click', function(e) {
    var target = $(e.target);
    if (!target.parents('div.saveButton').length) {
      $('.saveButton .errors').slideUp(300);
    }
  });

  ctrl.createFieldList = function(fieldList) {
    let _fieldModel = {};
    angular.forEach(ctrl.fieldList, function(field, key) {
      _fieldModel[field.FormlyFieldDescriptor.name] = {
        fieldId: field.FormlyFieldDescriptor.key,
        domId: field.FormlyFieldDescriptor.templateOptions.DOMId,
        panelId: field.ContainerPanelId || field.ContainerPanelId2,
        panelName: 'TODO - Panelnév',
        label: field.FormlyFieldDescriptor.templateOptions.label || '',
      };
    });
    let _sortedModel = Object.entries(_fieldModel).sort(function(a, b) {
      return a[1].label.localeCompare(b[1].label);
    });

    ctrl.fieldModel = {};
    angular.forEach(_sortedModel, function(a, b) {
      ctrl.fieldModel[a[0]] = a[1];
    });
  };

  //#region Public methods
  ctrl.$onInit = function $onInit() {
    ctrl.save = function() {
      if (ctrl.formIsValid) {
        ctrl.savingInProgress = true;
        let sp = ctrl.saveCallback();

        if (typeof sp?.catch === 'function') {
          sp.catch(function() {
            ctrl.savingInProgress = false;
          });
        }

        if (typeof sp?.then === 'function') {
          sp.then(function() {
            ctrl.savingInProgress = false;
          });
        }

        if (typeof sp?.then !== 'function' || typeof sp?.catch !== 'function') {
          ctrl.savingInProgress = false;
        }
        //e nélkül nem vált vissza a gomb, mert 500-as hiba esetén van then, angularból.
        ctrl.savingInProgress = false;
      } else {
        ctrl.toggleList();
      }
    };

    if (!!ctrl.actionState) {
      let controller = $state.router.urlRouter._rules.find(x => x.state.name == ctrl.actionState)?.state?.options
        ?.mvcController;
      if (!!controller) {
        ctrl.action = controller;
      }
    }
    if (!!ctrl.action) {
      AuthService.executeActionWithPermission(ctrl, 'save', ctrl.action, true, $element);
    }

    ctrl.toggleList = function() {
      $('.saveButton .errors').slideToggle(300);
    };

    $interval(ctrl.createFieldList, 1500, 1);
  };

  ctrl.findField = function(field) {
    if (angular.isFunction(ctrl.collapseFn)) {
      ctrl.collapseFn(field.panelId);
    }

    //Egyes kendo komponensek saját focus() függvénnyel rendelkeznek, mivel az eredeti input mezőt elfedik:
    let _kkd = ctrl.fieldList[field.fieldId].FormlyFieldDescriptor.formControl.$$element.data('kendoDropDownList');
    if (_kkd) {
      return _kkd.focus();
    }
    let _ddl = ctrl.fieldList[field.fieldId].FormlyFieldDescriptor.formControl.$$element.data('kendoNumericTextBox');
    if (_ddl) {
      return _ddl.focus();
    }
    //látzó inputokkal rendelkező kendo komponenesek esetében:
    ctrl.fieldList[field.fieldId].FormlyFieldDescriptor.templateOptions.focus = false;
    setTimeout(function() {
      ctrl.fieldList[field.fieldId].FormlyFieldDescriptor.templateOptions.focus = true;
      $scope.$applyAsync();
    }, 0);
  };
  //#endregion
}

const sbSaveButtonComponentOptions = {
  templateUrl: 'App/ui-kit/sb-save-button/sb-save-button.component.html',
  controller: sbSaveButtonComponent,
  transclude: true,
  bindings: {
    collapseFn: '=',
    formIsValid: '<',
    fieldList: '<',
    ngDisabled: '<',
    saveCallback: '&',
    action: '@',
    actionState: '@',
  },
};

'use strict';

(function() {
  const components = {
    sbSaveButton: sbSaveButtonComponentOptions,
  };

  const sbSaveButtonModule = angular.module('sbSaveButton', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbSaveButtonModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbPanelSidebarComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;

  //#region Public methods
  ctrl.$onInit = function $onInit() {
    //Ha nincs megadva, akkor minden panelcsoport váltás után futtatjuk a CustomExpression-okat
    ctrl.collapseHelper.disableRunExpression = ctrl.collapseHelper.disableRunExpression ?? false;

    //Következő panelcsoport funkció, ezt hívjuk a html-ben lévő gombbal komponensen kívülről.
    ctrl.collapseHelper.nextPanel = function() {
      /*
	  //Ha az utolsó után ugorjon az elsőre:
	  let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let nextPanelName =
        Object.keys(ctrl.panelGroups).find(key => ctrl.panelGroups[key].Position > openedPanelPos) ??
        Object.keys(ctrl.panelGroups).find(key => ctrl.panelGroups[key].Position > 0);

      ctrl.collapsePanel(ctrl.panelGroups[nextPanelName]);
	  */

      //Ne ugorjon az első panelcsoportra:
      let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let nextPanelName = Object.keys(ctrl.panelGroups).find(
        key =>
          !ctrl.panelGroups[key].Disabled &&
          !ctrl.panelGroups[key].Hide &&
          ctrl.panelGroups[key].Position > openedPanelPos
      );
      if (!!nextPanelName) {
        ctrl.collapsePanel(ctrl.panelGroups[nextPanelName]);
      }
    };

    ctrl.collapseHelper.prevPanel = function() {
      //Ne ugorjon az utolsó panelcsoportra:
      let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let prevPanelName = Object.keys(ctrl.panelGroups)
        .reverse()
        .find(
          key =>
            !ctrl.panelGroups[key].Disabled &&
            !ctrl.panelGroups[key].Hide &&
            ctrl.panelGroups[key].Position < openedPanelPos
        );
      if (!!prevPanelName) {
        ctrl.collapsePanel(ctrl.panelGroups[prevPanelName]);
      }
    };

    //Konkrét panelcsoportra ugrás funkció, ezt hívjuk a html-ben lévő hibalistás mentés komponensenből
    ctrl.collapseHelper.showPanel = function(panelName) {
      let panelGroupName = ctrl.panels[panelName].ContainerGroupId;
      ctrl.collapsePanel(ctrl.panelGroups[panelGroupName]);
    };

    //belső funkció, a panel nyitogatásra
    //bemenő paramétere a választott (kattintott, gombbal hívott) panelcsoport
    ctrl.collapsePanel = function(except) {
      //ha nem megjelenítendő panel, akkor kilépünk:
      if (except.Disabled && except.Hide) return;
      //Meghatározzuk, hogy mely panelcsoportoknak kell mindig nyitva lennie
      ctrl.collapseHelper.openedPanels = Object.keys(ctrl.panelGroups).filter(
        key => ctrl.panelGroups[key].Freeze === true
      );
      //Ha nincs benne akkor hozzáadjuk a jelenleg nyitandót
      if (ctrl.collapseHelper.openedPanels.findIndex(x => x == except.Name)) {
        ctrl.collapseHelper.openedPanels.push(except.Name);
      }
      //a helperbe beírjuk a letiltott panelcsoportokat
      ctrl.collapseHelper.disabledPanels = Object.keys(ctrl.panelGroups).filter(
        key =>
          (ctrl.panelGroups[key].Freeze === true && except.Name !== ctrl.panelGroups[key].Name) ||
          ctrl.panelGroups[key].Disabled === true ||
          ctrl.panelGroups[key].Hide === true
      );
      //a helperbe beírjuk a kijelölt panelcsoportot
      ctrl.collapseHelper.selectedPanel = except;
      //a helperbe beírjuk hogy ez az utolsó panelcsoport-e (pl: következő gomb elrejtése/megjelenítése
      ctrl.collapseHelper.selectedPanelIsLast = !Object.keys(ctrl.panelGroups).find(
        key => ctrl.panelGroups[key].Position > except.Position
      );
      ctrl.collapseHelper.selectedPanelIsFirst = !Object.keys(ctrl.panelGroups).find(
        key => ctrl.panelGroups[key].Position < except.Position
      );

      //Ha nincs tilta, a megjelenő paneleken lefuttatjuk a customExpressionokat.
      //Erre a fix paneleken történő mezőtiltások miatt van szükség.
      //Ha a *ModModel.cs fájlban meg van adva az adott panelekhez a panelcsoport, akkor csak azokra futtat, amire szükséges, ha nincs akkor minden mezőre.
      if (!ctrl.collapseHelper.disableRunExpression) {
        let panelNames = getPanelNames(ctrl.panels, except.Name);
        let fieldList = Object.keys(ctrl.fields).filter(
          key => panelNames.length === 0 || panelNames.indexOf(ctrl.fields[key].ContainerPanelId) !== -1
        );
        angular.forEach(fieldList, function(value, key) {
          if (angular.isFunction(ctrl.fields[value].FormlyFieldDescriptor.runExpressions)) {
            ctrl.fields[value].FormlyFieldDescriptor.runExpressions();
          }
        });
      }
    };

    //inicializáláskor nyitandó panelcsoport
    ctrl.collapsePanel(ctrl.panelGroups[ctrl.collapseHelper.startPanelGroupName]);

    //#endregion
  };

  function getPanelNames(panels, panelGroupName) {
    return Object.keys(panels).filter(
      key => ctrl.collapseHelper.openedPanels.indexOf(panels[key].ContainerGroupId) !== -1
    );
  }
}

const sbPanelSidebarComponentOptions = {
  templateUrl: 'App/ui-kit/sb-panel-sidebar/sb-panel-sidebar.component.html',
  controller: sbPanelSidebarComponent,
  transclude: true,
  bindings: {
    panelGroups: '<',
    panels: '<',
    fields: '=',
    collapseHelper: '=',
    nextPanel: '=',
    runExpressionCallback: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbPanelSidebar: sbPanelSidebarComponentOptions,
  };

  const sbPanelSidebarModule = angular.module('sbPanelSidebar', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbPanelSidebarModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbPanelHorizontalComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;

  //#region Public methods

  ctrl.$onChanges = function $onChanges(changes) {};

  ctrl.$onInit = function $onInit() {
    //Ha nincs megadva, akkor minden panelcsoport váltás után futtatjuk a CustomExpression-okat
    ctrl.collapseHelper.disableRunExpression = ctrl.collapseHelper.disableRunExpression ?? false;

    //Következő panelcsoport funkció, ezt hívjuk a html-ben lévő gombbal komponensen kívülről.
    ctrl.collapseHelper.nextPanel = function() {
      /*
	  //Ha az utolsó után ugorjon az elsőre:
	  let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let nextPanelName =
        Object.keys(ctrl.panelGroups).find(key => ctrl.panelGroups[key].Position > openedPanelPos) ??
        Object.keys(ctrl.panelGroups).find(key => ctrl.panelGroups[key].Position > 0);

      ctrl.collapsePanel(ctrl.panelGroups[nextPanelName]);
	  */

      //Ne ugorjon az első panelcsoportra:
      let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let nextPanelName = Object.keys(ctrl.panelGroups).find(
        key =>
          !ctrl.panelGroups[key].Disabled &&
          !ctrl.panelGroups[key].Hide &&
          ctrl.panelGroups[key].Position > openedPanelPos
      );
      if (!!nextPanelName) {
        ctrl.collapsePanel(ctrl.panelGroups[nextPanelName]);
      }
    };

    ctrl.collapseHelper.prevPanel = function() {
      //Ne ugorjon az utolsó panelcsoportra:
      let openedPanelPos = !ctrl.collapseHelper.selectedPanel ? 0 : ctrl.collapseHelper.selectedPanel.Position;
      let prevPanelName = Object.keys(ctrl.panelGroups)
        .reverse()
        .find(
          key =>
            !ctrl.panelGroups[key].Disabled &&
            !ctrl.panelGroups[key].Hide &&
            ctrl.panelGroups[key].Position < openedPanelPos
        );
      if (!!prevPanelName) {
        ctrl.collapsePanel(ctrl.panelGroups[prevPanelName]);
      }
    };

    //Konkrét panelcsoportra ugrás funkció, ezt hívjuk a html-ben lévő hibalistás mentés komponensenből
    ctrl.collapseHelper.showPanel = function(panelName) {
      let panelGroupName = ctrl.panels[panelName].ContainerGroupId;
      ctrl.collapsePanel(ctrl.panelGroups[panelGroupName]);
    };

    //belső funkció, a panel nyitogatásra
    //bemenő paramétere a választott (kattintott, gombbal hívott) panelcsoport
    ctrl.collapsePanel = function(except) {
      //ha nem megjelenítendő panel, akkor kilépünk:
      if (except.Disabled && except.Hide) return;
      //Meghatározzuk, hogy mely panelcsoportoknak kell mindig nyitva lennie
      ctrl.collapseHelper.openedPanels = Object.keys(ctrl.panelGroups).filter(
        key =>
          ctrl.panelGroups[key].Freeze === true && ctrl.panelGroups[key].FreezeOnPanels?.indexOf(except.Name) !== -1
      );
      //Ha nincs benne akkor hozzáadjuk a jelenleg nyitandót
      if (ctrl.collapseHelper.openedPanels.findIndex(x => x == except.Name)) {
        ctrl.collapseHelper.openedPanels.push(except.Name);
      }
      //a helperbe beírjuk a letiltott panelcsoportokat
      ctrl.collapseHelper.disabledPanels = Object.keys(ctrl.panelGroups).filter(
        key =>
          (ctrl.panelGroups[key].Freeze === true && except.Name !== ctrl.panelGroups[key].Name) ||
          ctrl.panelGroups[key].Disabled === true ||
          ctrl.panelGroups[key].Hide === true
      );
      //a helperbe beírjuk a kijelölt panelcsoportot
      ctrl.collapseHelper.selectedPanel = except;
      //a helperbe beírjuk hogy ez az utolsó panelcsoport-e (pl: következő gomb elrejtése/megjelenítése
      ctrl.collapseHelper.selectedPanelIsLast = !Object.keys(ctrl.panelGroups).find(
        key => ctrl.panelGroups[key].Position > except.Position
      );
      ctrl.collapseHelper.selectedPanelIsFirst = !Object.keys(ctrl.panelGroups).find(
        key => ctrl.panelGroups[key].Position < except.Position
      );

      //Ha nincs tilta, a megjelenő paneleken lefuttatjuk a customExpressionokat.
      //Erre a fix paneleken történő mezőtiltások miatt van szükség.
      //Ha a *ModModel.cs fájlban meg van adva az adott panelekhez a panelcsoport, akkor csak azokra futtat, amire szükséges, ha nincs akkor minden mezőre.
      if (!ctrl.collapseHelper.disableRunExpression) {
        let panelNames = getPanelNames(ctrl.panels, except.Name);
        let fieldList = Object.keys(ctrl.fields).filter(
          key => panelNames.length === 0 || panelNames.indexOf(ctrl.fields[key].ContainerPanelId) !== -1
        );
        angular.forEach(fieldList, function(value, key) {
          if (angular.isFunction(ctrl.fields[value].FormlyFieldDescriptor.runExpressions)) {
            ctrl.fields[value].FormlyFieldDescriptor.runExpressions();
          }
        });
      }
    };

    //inicializáláskor nyitandó panelcsoport
    ctrl.collapsePanel(ctrl.panelGroups[ctrl.collapseHelper.startPanelGroupName]);
    ctrl.DDLInitData = function() {
      ctrl.data = [];
      for (const [key, value] of Object.entries(ctrl.panelGroups).sort(([, a], [, b]) =>
        a.Position > b.Position ? 1 : -1
      )) {
        if (value.Hide) continue;
        ctrl.data.push({ id: key, name: value.Title, pg: value, ch: ctrl.collapseHelper });
      }
      return ctrl.data;
    };
    ctrl.DDLInit = function() {
      var dataSource = new kendo.data.DataSource({
        data: ctrl.DDLInitData(),
      });
      $element.find('input.hp-chooser').kendoDropDownList({
        dataTextField: 'name',
        dataValueField: 'id',
        valueTemplate: $('.panelComboTemplate').html(),
        template: $('.panelComboTemplate').html(),
        dataSource: dataSource,
        change: function(e) {
          var dataItem = this.value();
          var panelGroup = ctrl.panelGroups[dataItem];
          ctrl.collapsePanel(panelGroup);
          $scope.$applyAsync();
        },
        select: function(e) {
          if (e.dataItem.pg.Disabled || e.dataItem.pg.Hide) {
            e.preventDefault();
          }
        },
        height: 400,
      });
      ctrl.data.forEach((value, index) => {
        if (ctrl.collapseHelper.selectedPanel.Name == value.id) {
          $element
            .find('input.hp-chooser')
            .data('kendoDropDownList')
            .select(index);
          return;
        }
      });
    };
    if (ctrl.collapseHelper.comboMenu) {
      ctrl.DDLInit();
    }
    //hiba kijelzés
    ctrl.collapseHelper.hasError = function(ddlrefresh = true) {
      let panelGroups = [];
      angular.forEach(ctrl.fields, function(value, key) {
        if (!angular.equals(value.FormlyFieldDescriptor.formControl?.$error || {}, {})) {
          if (!!ctrl.panels[value.ContainerPanelId] && ctrl.panels[value.ContainerPanelId].ContainerGroupId) {
            panelGroups.push(ctrl.panels[value.ContainerPanelId].ContainerGroupId);
          }
        }
      });
      if (
        ddlrefresh &&
        ctrl.collapseHelper.comboMenu &&
        (JSON.stringify(panelGroups) !== JSON.stringify(ctrl.savedPanelGroups) ||
          ctrl.savedSelectedPanelName !== ctrl.collapseHelper.selectedPanel.Name)
      ) {
        $element
          .find('input.hp-chooser')
          .data('kendoDropDownList')
          .dataSource.data(ctrl.DDLInitData());
        ctrl.data.forEach((value, index) => {
          if (ctrl.collapseHelper.selectedPanel.Name == value.id) {
            $element
              .find('input.hp-chooser')
              .data('kendoDropDownList')
              .select(index);
            return;
          }
        });
      }
      ctrl.savedPanelGroups = angular.copy(panelGroups);
      ctrl.savedSelectedPanelName = angular.copy(ctrl.collapseHelper.selectedPanel.Name);
      return [...new Set(panelGroups)];
    };

    //#endregion
  };

  function getPanelNames(panels, panelGroupName) {
    return Object.keys(panels).filter(
      key => ctrl.collapseHelper.openedPanels.indexOf(panels[key].ContainerGroupId) !== -1
    );
  }
}

const sbPanelHorizontalComponentOptions = {
  templateUrl: 'App/ui-kit/sb-panel-horizontal/sb-panel-horizontal.component.html',
  controller: sbPanelHorizontalComponent,
  transclude: true,
  bindings: {
    panelGroups: '<',
    panels: '<',
    fields: '=',
    collapseHelper: '=',
    nextPanel: '=',
    runExpressionCallback: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbPanelHorizontal: sbPanelHorizontalComponentOptions,
  };

  const sbPanelHorizontalModule = angular.module('sbPanelHorizontal', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbPanelHorizontalModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbPanelStepperComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;

  //#region Public methods
  ctrl.$onInit = function $onInit() {};

  //#endregion
}

const sbPanelStepperComponentOptions = {
  templateUrl: 'App/ui-kit/sb-panel-Stepper/sb-panel-Stepper.component.html',
  controller: sbPanelStepperComponent,
  transclude: true,
  bindings: {
    collapseHelper: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbPanelStepper: sbPanelStepperComponentOptions,
  };

  const sbPanelStepperModule = angular.module('sbPanelStepper', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbPanelStepperModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbModuserBoxComponent($scope, $document, $http) {
  const ctrl = this;

  //#region Public methods
  ctrl.$onInit = function $onInit() {
    if (ctrl.userModel) {
      $http
        .get('FlgrSystem/GetModUserName/', {
          params: { userid: ctrl.userModel },
        })
        .then(function(response) {
          if (!!response.data.Text) {
            ctrl.userModel = response.data.Value + ' - ' + response.data.Text;
          }
        });
    }
  };
  //#endregion
}

const sbModuserBoxComponentOptions = {
  templateUrl: 'App/ui-kit/sb-moduser-box/sb-moduser-box.component.html',
  controller: sbModuserBoxComponent,
  transclude: true,
  bindings: {
    userModel: '<',
    options: '<',
    to: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbModuserBox: sbModuserBoxComponentOptions,
  };

  const sbModuserBoxModule = angular.module('sbModuserBox', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbModuserBoxModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbInfoTooltipComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;

  //#region Public methods
  ctrl.$onInit = function $onInit() {
    if (!ctrl.content) {
      ctrl.content = ctrl.contentString;
    }
  };

  //#endregion
}

const sbInfoTooltipComponentOptions = {
  templateUrl: 'App/ui-kit/sb-info-tooltip/sb-info-tooltip.component.html',
  controller: sbInfoTooltipComponent,
  transclude: true,
  bindings: {
    content: '=?',
    contentString: '@',
  },
};

'use strict';

(function() {
  const components = {
    sbInfoTooltip: sbInfoTooltipComponentOptions,
  };

  const sbInfoTooltipModule = angular.module('sbInfoTooltip', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbInfoTooltipModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbMapComponent($http, $q, $state, $window, NgMap, GMapsService) {
  var ctrl = this;
  ctrl.googleMapsUrl = window.googleMapsUrl;

  ctrl.points = [];
  ctrl.types = ctrl.options?.utilities;

  ctrl.icon = GMapsService.getMarkerIcon();

  if (ctrl.types) {
    ctrl.checked = { types: [ctrl.types[0]] };
  }

  ctrl.$onInit = function $onInit() {
    ctrl.model.refreshPoints = function() {
      NgMap.getMap().then(function(map) {
        ctrl.map = map;
        if (!!ctrl.model.clearRefresh) {
          ctrl.points.length = 0;
        }

        $http({
          method: 'POST',
          url: ctrl.model.controllerUrl,
          data: ctrl.controllerParameter(),
        }).then(function successcallback(response) {
          ctrl.mapSource = response.data.result.Data;
          createPoints(ctrl.mapSource).then(function() {
            panToMarkers();
          });
        });
      });
    };
    ctrl.model.refreshPoints();
    ctrl.model.$onChanges = function $onChanges(changes) {
      ctrl.model.refreshPoints();
    };
  };

  var createPoints = function(list) {
    var deferred = $q.defer();
    var counter = list.length;
    list.forEach(function(obj) {
      var newObj = {};
      newObj['title'] = obj.Address;
      newObj['address'] = obj.Address;
      newObj['tenement'] = obj.Tenement;
      newObj['propertyid'] = obj.PropertyId;

      if (obj.Northern !== 0 || obj.Eastern !== 0) {
        newObj['latitude'] = obj.Northern;
        newObj['longitude'] = obj.Eastern;
        ctrl.points.push(newObj);
        counter--;
        if (counter <= 0) {
          deferred.resolve();
        }
      } else if (obj.Address) {
        GMapsService.addressConvert(obj.Address).then(function(pos) {
          newObj['latitude'] = pos.lat();
          newObj['longitude'] = pos.lng();
          ctrl.points.push(newObj);
          counter--;
          if (counter <= 0) {
            deferred.resolve();
          }
        });
      }
    });
    return deferred.promise;
  };

  function panToMarkers() {
    var latlngbounds = new google.maps.LatLngBounds();
    for (var i = 0; i < ctrl.points.length; i++) {
      var point = ctrl.points[i];
      latlngbounds.extend(new google.maps.LatLng(point.latitude, point.longitude));
    }
    ctrl.map.fitBounds(latlngbounds);
  }
  ctrl.controllerParameter = function() {
    if (ctrl.model.controllerParameter)
      if ({}.toString.call(ctrl.model.controllerParameter) === '[object Function]') {
        return ctrl.model.controllerParameter();
      } else {
        return ctrl.model.controllerParameter;
      }
    else {
      return {};
    }
  };

  ctrl.onClickMarker = function(e, v, z) {
    if (ctrl.model.onClickMarker && {}.toString.call(ctrl.model.onClickMarker) === '[object Function]') {
      ctrl.model.onClickMarker(this);
    } else {
      return;
    }
  };
}

const sbMapComponentOptions = {
  templateUrl: 'App/ui-kit/sb-map/sb-map.component.html',
  controller: sbMapComponent,
  bindings: {
    model: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbMap: sbMapComponentOptions,
  };

  const sbMapModule = angular.module('sbMap', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbMapModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbSignatureComponent($scope, $state, $http, $element, $transclude, LanguageService) {
  const ctrl = this;
  const element = $element;
  const errorMessages = LanguageService.getDictionary().errorMessages;

  //#region Public methods
  ctrl.$onInit = function $onInit() {
    ctrl.errorMessages = errorMessages;
    ctrl.isEmpty = !ctrl.model;
    ctrl.signOptions = {
      penColor: '#000',
      width: 300,
      height: 125,
      maxWidth: 1,
      minWidth: 1,
    };
    //signature-pad
    window.devicePixelRatio = 1;
    ctrl.div = element.find('.signature-field')[0];
    ctrl.div.style.width = `${ctrl.signOptions.width}px`;
    ctrl.div.style.height = `${ctrl.signOptions.height}px`;
    ctrl.canvas = element.find('canvas.signature-pad')[0];
    ctrl.canvas.width = ctrl.signOptions.width;
    ctrl.canvas.height = ctrl.signOptions.height;
    ctrl.options.signaturePad = new SignaturePad(ctrl.canvas, ctrl.signOptions);

    ctrl.options.clear = function() {
      ctrl.options.signaturePad.clear();
      ctrl.isEmpty = true;
      $scope.$applyAsync();
    };
    ctrl.options.setData = function(data) {
      ctrl.isEmpty = false;
      ctrl.options.signaturePad.fromDataURL(data);
    };
    ctrl.options.getData = function() {
      return ctrl.options.signaturePad.toDataURL()?.split(',')[1];
    };
    ctrl.options.disable = function() {
      ctrl.options.signaturePad.off();
    };

    ctrl.options.signaturePad.addEventListener(
      'beginStroke',
      () => {
        ctrl.isEmpty = false;
        $scope.$applyAsync();
      },
      { once: false }
    );

    ctrl.options.signaturePad.addEventListener(
      'endStroke',
      () => {
        ctrl.model = ctrl.options.getData();
        $scope.$applyAsync();
      },
      { once: false }
    );

    $scope.$watch(
      function() {
        return ctrl.model;
      },
      function(newValue, oldValue) {
        if (!!newValue) {
          ctrl.options.setData('data:image/png;base64,' + newValue);
        } else {
          ctrl.options.signaturePad.clear();
        }
      }
    );

    var sigResetBtn = element.find('.sig-reset');
    sigResetBtn.on('click', function() {
      ctrl.model = null;
      ctrl.options.clear();
    });

    if (ctrl.disabled) {
      ctrl.options.disable();
      sigResetBtn[0].disabled = true;
    }
  };

  //#endregion
}

const sbSignatureComponentOptions = {
  templateUrl: 'App/ui-kit/sb-signature/sb-signature.component.html',
  controller: sbSignatureComponent,
  transclude: true,
  bindings: {
    model: '=ngModel',
    disabled: '=ngDisabled',
    type: '@',
    options: '=options',
  },
};

'use strict';

(function() {
  const components = {
    sbSignature: sbSignatureComponentOptions,
  };

  const sbSignatureModule = angular.module('sbSignature', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbSignatureModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbNtbCalculatorComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;
  const element = $element;

  ctrl.$onInit = function $onInit() {
    ctrl.numericTextBox = $('[dom-id="' + ctrl.to.DOMId + '"')?.getKendoNumericTextBox();
    const focused = ctrl.to.focused;
    ctrl.to.focused = function() {
      ctrl.onFocus = true;
      typeof focused === 'function' && focused(...arguments);
    };

    const onBlur = ctrl.to.onBlur;
    ctrl.to.onBlur = function() {
      ctrl.onFocus = false;
      ctrl.value = '';
      typeof onBlur === 'function' && onBlur(...arguments);
    };

    ctrl.to.colorChanged = function() {
      ctrl.labelColorChanged = true;
    };
  };

  ctrl.calculatorFocus = function() {
    ctrl.onCalculatorFocus = true;
    ctrl.calculatorLabel = '';
  };

  ctrl.calculatorBlur = async function(e) {
    ctrl.onCalculatorFocus = false;
    var equation = '';
    ctrl.calculatorLabel = '';
    if (!!ctrl.value) {
      try {
        equation = eval(ctrl.value.replaceAll(/,/g, '.').replaceAll(/:/g, '/'));
        if (equation === Infinity) {
          throw new ReferenceError();
        }
      } catch (e) {
        if (e instanceof ReferenceError) {
          ctrl.calculatorLabel = 'Hibás egyenlet!';
          return;
        }
      }
    }
    ctrl.numericValue = await equation;
    ctrl.calculatorLabel = ctrl.value;
    ctrl.labelColorChanged = false;
    setTimeout(function() {
      ctrl.numericTextBox?.trigger('change');
    }, 400);
  };

  ctrl.change = function() {
    ctrl.value = ctrl.value.replaceAll(/[^\(\)\+\-\*\ \.,0-9\/\:]/g, '');
  };
}

const sbNtbCalculatorComponentOptions = {
  templateUrl: 'App/ui-kit/sb-ntb-calculator/sb-ntb-calculator.component.html',
  controller: sbNtbCalculatorComponent,
  transclude: true,
  bindings: {
    to: '<',
    numericValue: '=',
    visible: '=',
    calculatorLabel: '=',
    labelColorChanged: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbNtbCalculator: sbNtbCalculatorComponentOptions,
  };

  const sbNtbCalculatorModule = angular.module('sbNtbCalculator', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbNtbCalculatorModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbMultiformPanelComponent($scope, $document, $http) {
  const ctrl = this;

  //#region Public methods

  ctrl.$onChanges = function $onChanges(changes) {};

  ctrl.$onInit = function $onInit() {
    if (ctrl.readOnly === true) {
      angular.forEach(ctrl.pageModel.Fields, function(value, key) {
        value.FormlyFieldDescriptor.templateOptions.disabled = true;
      });
    }

    ctrl.multiFormPanel = createMultiFormPanels(ctrl.pageModel, ctrl.panelName);
    ctrl.bindName = bindNameFn;
    ctrl.addRow = addRow;

    ctrl.panelError = function() {
      let hasError = false;

      angular.forEach(ctrl.formlys, function(value, key) {
        if (value.$invalid === true) {
          hasError = true;
        }
      });
      return hasError;
    };

    if (ctrl.panelData == null) {
      ctrl.panelData = [];
    }
  };
  //#endregion

  function addRow(dataModel) {
    dataModel.push({});
  }

  function createMultiFormPanels(pageModel, panel) {
    let multiFormPanels = [];
    let headers = [];
    let descriptions = GenerateFormlyFormPanelsFromPageModel(pageModel);

    angular.forEach(pageModel.Fields, function(item) {
      if (item.ContainerPanelId === panel /*&& item.FormlyFieldDescriptor.hide != true*/) {
        item.FormlyFieldDescriptor.id = item.FormlyFieldDescriptor.templateOptions.DOMId;
        var _e = {
          class: item.FormlyFieldDescriptor.className,
          label: item.FormlyFieldDescriptor.templateOptions.label,
          required: item.FormlyFieldDescriptor.templateOptions.required,
        };
        if (item.FormlyFieldDescriptor.hide !== true) {
          //ki lehessen kapcsolni a fejlécben a feliratot
          _e.label = item.FormlyFieldDescriptor.templateOptions.options['hideLabelFromHEader'] !== true ? _e.label : '';
          headers.push(_e);
        }

        if (item.FormlyFieldDescriptor.type === 'button') {
          item.FormlyFieldDescriptor.templateOptions.title = item.FormlyFieldDescriptor.templateOptions.label;
        }

        item.FormlyFieldDescriptor.templateOptions.label = '';
      }
    });
    return {
      panel: { panel, title: pageModel.Panels[panel].Title },
      headers,
      fields: descriptions[panel].FormlyDescriptor,
    };
  }

  function bindNameFn(fields, index) {
    //Ha a formly-form repeat-ban van, a fileds leírót másolni kell és egyedi id-t adni:
    var _field = angular.copy(fields);
    angular.forEach(_field[0].fieldGroup[0].fieldGroup, function(field) {
      field.id = field.id + '_' + index;
    });
    return _field;
  }
}

const sbMultiformPanelComponentOptions = {
  templateUrl: 'App/ui-kit/sb-multiform-panel/sb-multiform-panel.component.html',
  controller: sbMultiformPanelComponent,
  transclude: true,
  bindings: {
    panelName: '<',
    pageModel: '=',
    panelData: '<',
    panelError: '=',
    readOnly: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbMultiformPanel: sbMultiformPanelComponentOptions,
  };

  const sbMultiformPanelModule = angular.module('sbMultiformPanel', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbMultiformPanelModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbEditorComponent($scope, $state, $http, $element, $transclude) {
  const ctrl = this;
  ctrl.element = $element;
  //#region Public methods
  ctrl.$onInit = function $onInit() {};
  $(ctrl.element).ready(function() {
    ctrl.queryLoad = function(queryName) {
      queryName = queryName.toLowerCase();
      if (ctrl.options.none.includes(queryName) || queryName.length < 4) {
        return;
      }
      let queryShortName = queryName.substr(0, 4);
      let queryKey = Object.keys(ctrl.options.loading).find(key => key.includes(queryShortName));
      const d = new Date();
      let time = parseInt(d.getTime());
      if (queryKey && ctrl.options.loading[queryKey]) {
        if (time - ctrl.options.loading[queryKey] < 30000) {
          return;
        }
      }
      ctrl.options.loading[queryShortName] = time;
      $http
        .post('Template/GetTemplateQueryData', {
          queryName: queryName,
          id: { [ctrl.options.parameterIdName]: ctrl.options.parameterId },
        })
        .then(function(response) {
          let keys = Object.keys(response.data?.QueryData[0]);
          if (keys?.length > 0) {
            let values = response.data?.QueryData[0];
            keys.forEach(x => {
              let concreteKey = `|{${queryName}.${x.toLowerCase()}}|`;
              if (!ctrl.options.rowData.hasOwnProperty(concreteKey)) {
                ctrl.options.rowData[concreteKey] = values[x];
              }
              ctrl.options.onChange();
            });
          } else {
            ctrl.none.push(queryName);
          }
          delete ctrl.options.loading[queryShortName];
        });
    };
    if (!ctrl.options) {
      ctrl.options = {};
    }
    ctrl.options.rowData = ctrl.rowData ?? {};
    ctrl.options.none = ctrl.options.none ?? [];
    ctrl.options.loading = ctrl.options.loading ?? {};
    ctrl.options.insert = function(text) {
      ctrl.editor.exec('inserthtml', { value: text });
    };
    ctrl.preview = ctrl.element.find('.preview')?.getKendoEditor();
    ctrl.editor = ctrl.element.find('.editor')?.getKendoEditor();

    var observer = new MutationObserver(function(mutations) {
      ctrl.options.onChange();
    });
    if (ctrl.options.disable) {
      ctrl.element.find('.k-editor-toolbar').hide();
      $(ctrl.editor.body)?.attr('contenteditable', false);
    }

    observer.observe(ctrl.editor.body, { characterData: true, attributes: false, childList: false, subtree: true });

    ctrl.options.onChange = function() {
      let body = angular.copy(ctrl.editor.body?.innerHTML);
      //if (body == ctrl.options.model) return;
      const regex = /\|\{[^\.]+\.[^\}]+\}\|/gi;
      let match;
      let matchElement = [];
      do {
        match = regex.exec(body);
        if (match?.length) {
          matchElement.push(match[0]);
        }
      } while (match);
      matchElement.forEach(x => {
        if (ctrl.options.rowData[x.toLowerCase()]) {
          body = body.replaceAll(x, ctrl.options.rowData[x.toLowerCase()]);
        } else {
          let tableName = x.replace(/\.[^\}]+\}\|/, '').replace(/\|\{/, '');
          if (
            !!ctrl.options.parameterIdName &&
            !!ctrl.options.parameterId &&
            !Object.keys(ctrl.options.rowData).some(key => key.includes(tableName.toLowerCase() + '.'))
          ) {
            ctrl.queryLoad(tableName);
          }
        }
      });
      ctrl.preview.body.innerHTML = body;
    };
    $(ctrl.preview.body)?.attr('contenteditable', false);
    ctrl.preview.toolbar.element.remove();
    ctrl.preview.body.innerHTML = angular.copy(ctrl.editor.body?.innerHTML);
    ctrl.options.onChange();
  });
  //#endregion
}

const sbEditorComponentOptions = {
  templateUrl: 'App/ui-kit/sb-editor/sb-editor.component.html',
  controller: sbEditorComponent,
  transclude: true,
  bindings: {
    options: '=?',
  },
};

'use strict';

(function() {
  const components = {
    sbEditor: sbEditorComponentOptions,
  };

  const sbEditorModule = angular.module('sbEditor', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbEditorModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbChartComponent($http, LanguageService, $element, $window, lodash) {
  const ctrl = this;

  const element = $element;
  var center;
  var radius;
  ctrl.class = ctrl.defaultClass;
  ctrl.dataBound = function(e) {
    ctrl.options.chart.options.legend.visible = ctrl.options.legend.visible;
  };
  ctrl.getOptions = function(options = null) {
    let series = [
      {
        field: 'value',
        categoryField: 'category',
        autoFit: true,
        labels: {
          color: '#000',
          position: 'outsideEnd',
          template: '#: category #',
          visible: true,
        },
        visual: function(e) {
          center = e.center;
          radius = e.radius;
          return e.createVisual();
        },
      },
    ];
    if (ctrl.type == 'column' || ctrl.type == 'bar') {
      series[0].labels.visible = false;
    }
    let tempOptions = {
      title: {
        position: 'top',
        text: '',
      },
      legend: {
        visible: false,
      },
      chartArea: {
        background: '#000000',
      },
      tooltip: {
        visible: true,
        format: '{0}%',
      },
      series: series,
      dataBound: ctrl.dataBound,
      render: function(e) {
        if (!ctrl.options?.centerText) return;
        let centerText =
          {}.toString.call(ctrl.options.centerText) === '[object Function]'
            ? ctrl.options.centerText(e)
            : ctrl.options.centerText;
        var draw = kendo.drawing;
        var geom = kendo.geometry;
        var circleGeometry = new geom.Circle(center, radius);
        var bbox = circleGeometry.bbox();
        var text = new draw.Text(centerText, [0, 0], {
          font: '18px Verdana,Arial,sans-serif',
        });
        draw.align([text], bbox, 'center');
        draw.vAlign([text], bbox, 'center');
        e.sender.surface.draw(text);
      },
      chartArea: {
        // border: {
        //   width: 1,
        // },
      },
    };
    if (!!ctrl.dataSource) {
      tempOptions.dataSource = ctrl.dataSource;
    }
    if (!!ctrl.data) {
      tempOptions.dataSource = {
        data: ctrl.data,
      };
    }
    options = lodash.merge({}, tempOptions, options ?? ctrl.options);
    options.legend.visible = false;
    return options;
  };

  ctrl.createChart = function(options = null) {
    $(element.find('.sbChart')).kendoChart(ctrl.getOptions(options));
    if (!!ctrl.options) {
      ctrl.options.chart = element.find('.sbChart').data('kendoChart');
    }
    // ctrl.chart.read = ctrl.read;
  };

  $element.ready(function() {
    ctrl.labels = LanguageService.getDictionary().dashboard;
    ctrl.zoomClass = ctrl.defaultClass.replace(/(col-..-)(\d{1,2})/, '$112');
    ctrl.class = ctrl.defaultClass;
    if (ctrl.options.controller) {
      ctrl.dataSource = new kendo.data.DataSource({
        transport: {
          read: {
            url: function() {
              return ctrl.options.controller;
            },
            dataType: 'json',
          },
        },

        group: {
          field: 'field',
        },

        sort: {
          field: 'category',
          dir: 'asc',
        },

        // schema: {
        //     model: {
        //         fields: {
        //           category: {
        //                 type: "date"
        //             }
        //         }
        //     }
        // }
      });
      //ctrl.read();
    }
    ctrl.createChart();
    ctrl.options.chart.resize();
  });

  ctrl.zoomPlus = function() {
    ctrl.zoomVariable = true;
    $(element)
      .find('.chartMain')
      .removeClass(ctrl.defaultClass)
      .addClass(ctrl.zoomClass);
    $('#page-content-wrapper *').hide();
    $(element).show();
    $(element)
      .find('*')
      .show();
    $(element)
      .parentsUntil('#page-content-wrapper')
      .each(function(index) {
        let elem = $(this)[0];
        if (typeof elem.className == 'string') {
          elem.className = elem.className.replace(/(col-..-\d{1,2})/, 'del_$1');
        }
        $(elem).show();
      });
    ctrl.resize();
  };
  ctrl.zoomMinus = function() {
    ctrl.zoomVariable = false;
    $('#page-content-wrapper *').each(function(index) {
      let elem = $(this)[0];
      if (typeof elem.className == 'string') {
        elem.className = elem.className.replace(/del_(col-..-\d{1,2})/, '$1');
      }
      $(elem).show();
    });
    $(element)
      .find('.chartMain')
      .removeClass(ctrl.zoomClass)
      .addClass(ctrl.defaultClass);
    $(element.find('.sbChart')).css('height', '');
    ctrl.resize();
  };
  ctrl.resize = function() {
    if (ctrl.zoomVariable) {
      $(element.find('.sbChart')).height($(window).height() - $('#page-content-wrapper').position().top - 200);
    }
    ctrl.options.chart.resize();
  };

  var w = angular.element($window);
  w.on('resize', function() {
    ctrl.resize();
  });
  angular.element($(document)).on('resize', function() {
    ctrl.resize();
  });

  ctrl.$onChanges = function $onChanges(changes) {
    // if (!!changes.type) {
    //   ctrl.model.options.seriesDefaults.type = changes.type.currentValue;
    // }
    // ctrl.read();
  };

  ctrl.$onInit = function $onInit() {};

  ctrl.read = function(callback = null) {
    $http
      .post(ctrl.options.controller, ctrl.options.params ?? {})
      .then(function(response) {
        ctrl.options.chart?.dataSource?.data(response.data?.series);
        ctrl.options.chart.options.categoryAxis.categories = response.data?.categories;
        if (!!ctrl.options.chart?.dataSource?.data()?.length) {
          ctrl.options.chart?.dataSource?.refresh();
        }
      })
      .catch(function(e) {
        //  toastr.error(e.statusText);
        return;
      });
  };
}

const sbChartComponentOptions = {
  templateUrl: 'App/ui-kit/sb-chart/sb-chart.component.html',
  controller: sbChartComponent,
  bindings: {
    type: '<',
    chart: '=',
    options: '=',
    zoomVariable: '<zoom',
    defaultClass: '@defaultClass',
  },
};

'use strict';

(function() {
  const components = {
    sbChart: sbChartComponentOptions,
  };

  const sbChartModule = angular.module('sbChart', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbChartModule.component(componentTag, componentOptions);
  });
})();

'use strict';
function sbFormInitButtonComponent($element, LanguageService, AuthService, FormInitService, $state, $uibModal) {
  const ctrl = this;
  ctrl.formId = ctrl.formId ?? $state.current.params.controllerOptions.ctrlId;
  let labels = LanguageService?.getDictionary()?.sbFormInit;
  ctrl.SBFormInitOff = localStorage.getItem('SBFormInitOff');
  ctrl.show = true;
  ctrl.defaultEnable = ctrl.defaultEnable ?? true;
  ctrl.labels = labels ?? {
    remove: 'Törlés',
    default: 'Alapértelmezett',
    save: 'Mezőállapotok<br/>mentése',
    load: 'Betöltés',
    modalTitle: 'Mezőállapotok mentése sablonba',
    modalFormFieldName: 'Megnevezés',
    modalFormFieldDefault: 'Alapértelmezett',
    individual: 'Egyéni',
    global: 'Globális',
  };
  ctrl.removeRow = function(item, type = 'u') {
    bootbox.dialog({
      message: ctrl.scope.messages.ConfirmDelete,
      title: ctrl.scope.messages.Warning,
      buttons: {
        cancel: {
          label: ctrl.scope.actions.btnCancel.Title,
          className: 'btn-default',
          callback: function() {},
        },
        confirm: {
          label: ctrl.scope.actions.btnOk.Title,
          className: 'btn-primary',
          callback: function() {
            FormInitService.DeleteFormData(ctrl.formId, item, type)
              .then(function() {
                toastr.success(ctrl.scope.messages.DeleteSuccessful);
                FormInitService.FormDatasList(ctrl.formId, function(data) {
                  ctrl.FormDatasListCallback(data);
                });
              })
              .catch(function(response) {
                toastr.error(ctrl.scope.messages.DeleteFailed);
              });
          },
        },
      },
    });
  };
  ctrl.loadData = function(item, type = 'u') {
    FormInitService.DownloadAndLoadFormData(ctrl.formId, item, ctrl.formModel, ctrl.generateFormly, type);
  };
  ctrl.saveForm = function(model = {}, type = 'u') {
    var modalInstance = $uibModal.open({
      templateUrl: 'App/ui-kit/sb-form-init-button/sb-form-init-button.SaveModal.html',
      controller: [
        '$uibModalInstance',
        function(mi) {
          var vm = this;
          vm.labels = ctrl.labels;
          vm.actions = ctrl.scope.actions;
          vm.messages = ctrl.scope.messages;
          vm.modalFormModel = model;

          if (!!vm.modalFormModel.name) {
            vm.modalFormModel.item = vm.modalFormModel.name;
          }
          vm.modalFormFields = [
            {
              key: 'name',
              type: 'input',
              templateOptions: {
                type: 'text',
                label: vm.labels.modalFormFieldName,
                required: true,
              },
            },
          ];
          if (ctrl.defaultEnable) {
            vm.modalFormFields.push({
              key: 'default',
              type: 'checkbox',
              templateOptions: {
                DOMId: 'formInitModalCheckbox',
                label: vm.labels.modalFormFieldDefault,
                noLabelStyle: true,
              },
            });
          }
          if (jQuery.isEmptyObject(model) && !!ctrl.globalInitializer) {
            vm.modalFormFields.push({
              key: 'global',
              type: 'checkbox',
              templateOptions: {
                DOMId: 'formInitModalCheckbox',
                label: vm.labels.global,
                noLabelStyle: true,
              },
            });
          }
          $('#formInitModalCheckbox_label div').ready(function() {
            $('#formInitModalCheckbox_label div').css('top', '0');
          });
          vm.save = function() {
            vm.modalFormModel.type = type;
            mi.close(vm.modalFormModel);
          };

          vm.cancel = function() {
            mi.close();
          };
        },
      ],
      controllerAs: 'vm',
      backdrop: 'static', //mellékattintásnál ne záródjon be
    });

    modalInstance.result.then(function(result) {
      if (!!result.global) {
        result.type = 'g';
      }
      if (!!result?.name) {
        FormInitService.UploadFormData(
          ctrl.formId,
          result.name,
          ctrl.formModel,
          ctrl.pageModel,
          ctrl.formly,
          result.default ?? false,
          result.item == result.name ? '' : result.item,
          result.type
        );
        FormInitService.FormDatasList(ctrl.formId, function(data) {
          ctrl.FormDatasListCallback(data);
        });
      }
    });
  };
  ctrl.getFormInitList = function() {
    return ctrl.formInitList;
  };
  ctrl.changeFavourite = function(item, type = 'u') {
    if (type == 'u') {
      if (ctrl.favouriteIndex === item) {
        ctrl.favouriteIndex = null;
        FormInitService.DeleteFormDefault(ctrl.formId, type);
      } else {
        ctrl.favouriteIndex = item;
        FormInitService.UploadFormDefault(ctrl.formId, item, type);
      }
    } else {
      if (ctrl.favouriteGlobalIndex === item) {
        ctrl.favouriteGlobalIndex = null;
        FormInitService.DeleteFormDefault(ctrl.formId, type);
      } else {
        ctrl.favouriteGlobalIndex = item;
        FormInitService.UploadFormDefault(ctrl.formId, item, type);
      }
    }
  };
  //#region Public methods
  ctrl.$onInit = function $onInit() {
    ctrl.globalInitializer = AuthService.globalInitializer;
    ctrl.formId = ctrl.formId ?? $state.current.params.controllerOptions.ctrlId;
    if ($state.current.params.controllerOptions.waitFormGenerate) {
      $state.current.params.controllerOptions.waitFormGenerate = false;
      FormInitService.DownloadFormDefaultData(ctrl.formId, function(data) {
        if (data) {
          FormInitService.FormDataGenerate(ctrl.formModel, ctrl.generateFormly(), data);
        } else {
          ctrl.generateFormly();
        }
      });
    }
    $(document).ready(function() {
      $('li.dropdown-submenu a[data-toggle="dropdown"]').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $('li.dropdown-submenu')
          .not($(this).parent())
          .removeClass('open');
        $(this)
          .parent()
          .toggleClass('open');
      });
      $('.subddm *').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
      });
    });
    ctrl.FormDatasListCallback = function(data) {
      ctrl.formInitList = data?.data ?? [];
      ctrl.formInitGlobalList = data?.globalData ?? [];
      ctrl.favouriteIndex = data.def;
      ctrl.favouriteGlobalIndex = data.globalDef;
      $('.subddm *').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
      });
    };
    FormInitService.FormDatasList(ctrl.formId, function(data) {
      ctrl.FormDatasListCallback(data);
    });
    if (!!ctrl.actionState) {
      let controller = $state.router.urlRouter._rules.find(x => x.state.name == ctrl.actionState)?.state?.options
        ?.mvcController;
      if (!!controller) {
        ctrl.action = controller;
      }
    }
    if (!!ctrl.action) {
      AuthService.executeActionWithPermission(ctrl, 'save', ctrl.action, true, $element);
    }
  };

  //#endregion
}

const sbFormInitButtonComponentOptions = {
  templateUrl: 'App/ui-kit/sb-form-init-button/sb-form-init-button.component.html',
  controller: sbFormInitButtonComponent,
  transclude: true,
  bindings: {
    scope: '<',
    formId: '<',
    fieldList: '<',
    formly: '<',
    pageModel: '<',
    formModel: '<',
    ngDisabled: '<',
    loadDefault: '<',
    defaultEnable: '<',
    action: '@',
    actionState: '@',
    generateFormly: '&',
  },
};

'use strict';

(function() {
  const components = {
    sbFormInitButton: sbFormInitButtonComponentOptions,
  };

  const sbFormInitButtonModule = angular.module('sbFormInitButton', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbFormInitButtonModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbCardListComponent($element, $uibModal, $scope, DasService, $state, $window) {
  const ctrl = this;

  ctrl.$onChanges = function $onChanges(changes) {};
  ctrl.formFieldsKey = [];
  ctrl.downloadTextOption = false;
  ctrl.autoInit = function() {
    if (ctrl.checkInit()) {
      return;
    }

    ctrl.pageModelWatcher = $scope.$watch('$ctrl.pageModel', ctrl.initWatcher);
    ctrl.panelNameWatcher = $scope.$watch('$ctrl.panelName', ctrl.initWatcher);
    ctrl.modelWatcher = $scope.$watch('$ctrl.model', ctrl.initWatcher);
    ctrl.formFieldsWatcher = $scope.$watch('$ctrl.formFields', ctrl.initWatcher);
  };
  ctrl.checkInit = function() {
    if (!!ctrl.pageModel && !ctrl.formFields) {
      ctrl.downloadTexts();
    }
    if (
      !!ctrl.pageModel &&
      !!ctrl.panelName &&
      Array.isArray(ctrl.model) &&
      (ctrl.kendoDDLTexts != {} || ctrl.downloadTextOption)
    ) {
      ctrl.formFields.forEach(fields => {
        fields.fieldGroup.forEach(fieldGroup => {
          Object.entries(fieldGroup).forEach(value => {
            if (Array.isArray(value[1])) {
              value[1].map(field => {
                if (!!field.key) {
                  ctrl.formFieldsKey.push(field.key);
                }
              });
            }
          });
        });
      });
      ctrl.init();
      return true;
    }
    return false;
  };
  ctrl.initWatcher = function(newValue) {
    if (ctrl.checkInit()) {
      ctrl.pageModelWatcher();
      ctrl.panelNameWatcher();
      ctrl.modelWatcher();
      ctrl.formFieldsWatcher();
    }
  };

  ctrl.formInit = function(t) {
    console.log('formInit');
  };

  ctrl.$onInit = function $onInit() {
    ctrl.pageModel = _.cloneDeep(ctrl.pageModel);
    Object.keys(ctrl.pageModel.Fields).forEach(x => {
      if (ctrl.pageModel.Fields[x].ContainerPanelId !== ctrl.panelName)
        ctrl.pageModel.Fields[x].ContainerPanelId = null;
    });
    ctrl.modalOpened = false;
    ctrl.changeKendoDDlText = function(item) {
      $('[' + item + ']').each((index, elem) => {
        let key = $(elem).attr(item);
        if (!!ctrl.kendoDDLTexts[item]) {
          $(elem).html(ctrl.kendoDDLTexts[item][key] ?? '');
        }
      });
    };
    ctrl.changeAllKendoDDlText = function() {
      Object.keys(ctrl.kendoDDLTexts).forEach(x => ctrl.changeKendoDDlText(x));
    };
    ctrl.addKendoDDlDataBound = function(item) {
      ctrl.pageModel.Fields[item].FormlyFieldDescriptor.templateOptions.dataBound = function(e) {
        ctrl.kendoDDLTexts[item] = {};
        e.sender.dataItems().forEach(x => {
          ctrl.kendoDDLTexts[item][x.key] = x.text;
        });
        ctrl.changeKendoDDlText(item);
      };
    };
    ctrl.addKendoCBMCDataBound = function(item) {
      ctrl.pageModel.Fields[item].FormlyFieldDescriptor.templateOptions.dataBound = function(e) {
        ctrl.kendoDDLTexts[item] = {};
        var textField = e.sender.$angular_scope.to.options.dataTextField;
        var valueField = e.sender.$angular_scope.to.options.dataValueField;
        e.sender.dataItems().forEach(x => {
          ctrl.kendoDDLTexts[item][x[valueField]] = x[textField];
        });
        ctrl.changeAllKendoDDlText();
      };
    };
    ctrl.kendoDDLTexts = {};
    ctrl.downloadTexts = function(reload = true) {
      if (!!ctrl.formFields && !reload) {
        return;
      }
      // Object.entries(ctrl.pageModel.Fields).forEach(value => {
      //   if (value[1].ContainerPanelId) {
      //     if (value[1].FormlyFieldDescriptor.type === 'kendoDDL') {
      //       value[1].FormlyFieldDescriptor.templateOptions.options.autoBind = value[1].FormlyFieldDescriptor.templateOptions.options.autoBind;
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBindSave = value[1].FormlyFieldDescriptor.templateOptions.autoBind;
      //       value[1].FormlyFieldDescriptor.templateOptions.options.autoBind = ctrl.downloadTextOption;
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBind = ctrl.downloadTextOption;
      //       if(ctrl.downloadTextOption){
      //         ctrl.addKendoCBMCDataBound(value[0]);
      //       }
      //     } else if (value[1].FormlyFieldDescriptor.type === 'kendoCBMC') {
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBindSave = value[1].FormlyFieldDescriptor.templateOptions.autoBind;
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBind = ctrl.downloadTextOption;
      //       if(ctrl.downloadTextOption){
      //         ctrl.addKendoCBMCDataBound(value[0]);
      //       }
      //     }
      //   }
      // });
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(ctrl.pageModel);
      ctrl.formFields = formlyFormPanelDescriptors[ctrl.panelName].FormlyDescriptor;
      // Object.entries(ctrl.pageModel.Fields).forEach(value => {
      //   if (value[1].ContainerPanelId) {
      //     if (value[1].FormlyFieldDescriptor.type === 'kendoDDL') {
      //       value[1].FormlyFieldDescriptor.templateOptions.options.autoBind = value[1].FormlyFieldDescriptor.templateOptions.options.autoBindSave;
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBind = value[1].FormlyFieldDescriptor.templateOptions.autoBindSave;
      //     } else if (value[1].FormlyFieldDescriptor.type === 'kendoCBMC') {
      //       value[1].FormlyFieldDescriptor.templateOptions.autoBind = value[1].FormlyFieldDescriptor.templateOptions.autoBindSave;
      //     }
      //   }
      // });
    };
    ctrl.btn = ctrl.pageModel.Actions;
    ctrl.msg = ctrl.pageModel.Messages;
    ctrl.data = [];
    ctrl.convertData = function() {
      ctrl.data = [];
      ctrl.model?.forEach((model, key) => {
        let data = {};
        ctrl.formFieldsKey.forEach(fieldId => {
          if (!!fieldId) {
            var ffd = ctrl.pageModel.Fields[fieldId]?.FormlyFieldDescriptor;
            var name = ffd?.templateOptions?.label;
            if (!!ffd?.templateOptions?.labelCL?.trim()) {
              name = ffd.templateOptions.labelCL.trim();
            }
            if (!!name) {
              data[fieldId] = {
                value: angular.isFunction(ffd.templateOptions.FieldView)
                  ? ffd.templateOptions.FieldView(model)
                  : (typeof model[fieldId + 'CLText'] != 'undefined' ? model[fieldId + 'CLText'] : model[fieldId]) ??
                    '',
                name: name,
                hide: angular.isFunction(ffd.templateOptions.FieldHide)
                  ? ffd.templateOptions.FieldHide(model)
                  : ffd.hide,
                key: fieldId,
                type: ffd.type,
              };
            }
          }
        });
        let viewLabel = ctrl.viewLabel(),
          viewLabelText = '',
          viewLabelResult = null;
        if (viewLabel) {
          viewLabelResult = viewLabel(ctrl, data, key);
          viewLabelText = viewLabelResult.Title ?? '';
        }
        let e;
        ctrl.data.push({
          dataitem: data,
          key: key,
          isReadOnly: ctrl.isReadOnly,
          editLabel: ctrl.btn?.btnEdit?.Title ?? '',
          viewLabel: !!viewLabelText ? viewLabelText : ctrl.btn?.btnView?.Title ?? '',
          viewDisable: !!viewLabelResult ? viewLabelResult.Disable ?? false : false,
          deleteLabel: ctrl.btn?.btnDelete?.Title ?? '',
          docLabel: ctrl.btn?.btnAttachDoc?.Title ?? '',
          edit: angular.isFunction(ctrl.pageModel.Panels[ctrl.panelName]?.EditShow)
            ? ctrl.pageModel.Panels[ctrl.panelName].EditShow(model)
            : ctrl.editShow ?? false,
          view: angular.isFunction(ctrl.pageModel.Panels[ctrl.panelName]?.ViewShow)
            ? ctrl.pageModel.Panels[ctrl.panelName].ViewShow(model)
            : (ctrl.viewShow || ctrl.viewFunc() || ctrl.viewLabel() || ctrl.subCard) ?? false,
          del: angular.isFunction(ctrl.pageModel.Panels[ctrl.panelName]?.DelShow)
            ? ctrl.pageModel.Panels[ctrl.panelName].DelShow(model)
            : ctrl.deleteShow ?? false,
          doc: angular.isFunction(ctrl.pageModel.Panels[ctrl.panelName]?.DocShow)
            ? ctrl.pageModel.Panels[ctrl.panelName].DocShow(model)
            : (ctrl.docShow ?? false) && !!ctrl.dasModel,
        });
      });
    };
    ctrl.init = function() {
      ctrl.convertData();
      if (!$element.find('.cardListView').data('kendoListView')) {
        $element.find('.cardListView').kendoListView({
          dataSource: {
            data: ctrl.data,
            pageSize: ctrl.pageSize ?? 21,
          },
          template: kendo.template($('.cardListTemplate').html()),
          pageable: ctrl.pageable ?? true,
          remove: function(e) {
            e.preventDefault();

            bootbox.dialog({
              message: ctrl.msg.ConfirmDelete,
              title: ctrl.msg.Warning,
              buttons: {
                cancel: {
                  label: ctrl.msg.Cancel,
                  className: 'btn-default',
                  callback: function() {
                    return;
                  },
                },
                confirm: {
                  label: ctrl.msg.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    if (ctrl.preDelCallback && {}.toString.call(ctrl.preDelCallback) === '[object Function]') {
                      let result = ctrl.preDelCallback(ctrl.model[e.model.key], ctrl.pageModel, ctrl, e);
                      if (result === false) {
                        return;
                      }
                    }
                    ctrl.model.splice(e.model.key, 1);
                    e.sender.dataSource.remove(e.sender.dataItem(e.item));
                  },
                },
              },
            });
          },
          dataBound: function() {
            //ctrl.changeAllKendoDDlText();
          },
        });
      }
    };
    ctrl.autoInit();
  };
  ctrl.elementData = function(data) {
    $element
      .find('.cardListView')
      .data('kendoListView')
      .dataSource.data(data);
  };
  ctrl.doc = function(button, id) {
    if (ctrl.preDocCallback && {}.toString.call(ctrl.preDocCallback) === '[object Function]') {
      let result = ctrl.preDocCallback(ctrl.model[id], ctrl.pageModel, ctrl);
      if (result === false) {
        return;
      }
    }

    if (Object.keys(ctrl.dasModel.tables?.idTables ?? {})?.length > 0) {
      for (const [key, value] of Object.entries(ctrl.dasModel.tables.idTables)) {
        ctrl.dasModel.tables[key] = ctrl.model[id][value];
      }
    }

    if (ctrl.dasModel.routeId.includes('Create')) {
      let params = {
        dasTableId: ctrl.dasModel.dasTableId ?? objectTobase64(ctrl.dasModel.tables, true),
        dasOwnerId: ctrl.dasModel.dasOwnerId ?? 1,
        id: 0,
      };
      var url = $state.href(ctrl.dasModel.routeId, params);
      $window.open(url, '_blank');
    } else {
      DasService.NavigateToDas(
        ctrl.msg,
        ctrl.dasModel?.routeId,
        ctrl.dasModel.dasTableId ?? objectTobase64(ctrl.dasModel.tables, true),
        ctrl.dasModel.dasOwnerId ?? 1
      );
    }
  };
  ctrl.view = function(scope, id) {
    if (ctrl.viewFunc()) {
      ctrl.viewFunc(ctrl, id)(ctrl, id);
    } else {
      ctrl.edit(scope, id, true);
    }
  };
  ctrl.edit = function(scope, id, view = false) {
    if (ctrl.modalOpened) return;
    ctrl.modalOpened = true;

    try {
      let openParam = {
        templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
        controller: 'SbCardListEditModalCtrl',
        controllerAs: 'vm',
        resolve: {
          model: {
            pageModel: ctrl.pageModel,
            dto: ctrl.model[id],
            state: view ? 'view' : 'edit',
            id: id,
            panelName: ctrl.panelName,
            preGenerateCallback: ctrl.preGenerateCallback,
            afterGenerateCallback: ctrl.afterGenerateCallback,
          },
          params: {},
        },
        backdrop: 'static',
      };
      if (view && !!ctrl.subCard) {
        openParam.resolve.model.subCard = ctrl.subCard;
        let parentId = ctrl.model[id][ctrl.subCard.parentId];
        if (!!ctrl.subCard.model) {
          openParam.resolve.model.subCardModel = ctrl.subCard.model.filter(x => x[ctrl.subCard.parentId] === parentId);
        }
      }
      var modalInstance = $uibModal.open(openParam);

      modalInstance.result.then(async function(result) {
        if (result?.dto) {
          ctrl.model[result.id] = await result.dto;
          await ctrl.convertData();
          await ctrl.elementData(ctrl.data);
          if (ctrl.downloadTextOption) {
            ctrl.changeAllKendoDDlText();
          }
          ctrl.modalOpened = false;
        }
      });
      modalInstance.opened.then(function() {
        ctrl.modalOpened = true;
      });
      modalInstance.closed.then(function() {
        ctrl.modalOpened = false;
      });
      modalInstance.result.catch(function() {
        ctrl.modalOpened = false;
      });
    } catch (err) {
      ctrl.modalOpened = false;
    }
  };
  ctrl.new = function() {
    if (ctrl.newCallback && {}.toString.call(ctrl.newCallback) === '[object Function]') {
      let result = ctrl.newCallback(ctrl.pageModel, ctrl);
      return;
    }
    if (ctrl.modalOpened) return;
    ctrl.modalOpened = true;
    try {
      var modalInstance = $uibModal.open({
        templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
        controller: 'SbCardListEditModalCtrl',
        controllerAs: 'vm',
        resolve: {
          model: {
            pageModel: ctrl.pageModel,
            dto: null,
            id: 0,
            state: 'new',
            panelName: ctrl.panelName,
            preGenerateCallback: ctrl.preGenerateCallback,
            afterGenerateCallback: ctrl.afterGenerateCallback,
          },
          params: {},
        },
        backdrop: 'static',
      });
      modalInstance.result.then(function(result) {
        if (result?.dto) {
          ctrl.model.push(result.dto);
          ctrl.convertData();
          ctrl.elementData(ctrl.data);
          if (ctrl.downloadTextOption) {
            ctrl.changeAllKendoDDlText();
          }
          ctrl.modalOpened = false;
        }
      });
      modalInstance.opened.then(function() {
        ctrl.modalOpened = true;
      });
      modalInstance.closed.then(function() {
        ctrl.modalOpened = false;
      });
      modalInstance.result.catch(function() {
        ctrl.modalOpened = false;
      });
    } catch (err) {
      ctrl.modalOpened = false;
    }
  };
}

const sbCardListComponentOptions = {
  templateUrl: 'App/ui-kit/sb-card-list/sb-card-list.component.html',
  controller: sbCardListComponent,
  transclude: true,
  bindings: {
    isReadOnly: '<',
    pageModel: '<',
    panelName: '@',
    model: '=',
    dasModel: '=',
    editShow: '<',
    viewFunc: '&viewFunc',
    viewLabel: '&viewLabel',
    deleteShow: '<',
    docShow: '<',
    newRow: '<',
    newLabel: '<',
    newDisabled: '<',
    newCallback: '=',
    pageSize: '<',
    pageable: '<',
    afterGenerateCallback: '=',
    preGenerateCallback: '=',
    preDocCallback: '=',
    preDelCallback: '=',
    subCard: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbCardList: sbCardListComponentOptions,
  };

  const sbCardListModule = angular.module('sbCardList', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbCardListModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbGridDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  ctrl.data = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    if (ctrl.onChanges && {}.toString.call(ctrl.onChanges) === '[object Function]') {
      return ctrl.onChanges(ctrl);
    } else {
      return null;
    }
  };

  ctrl.showTabs = function(tab) {
    if (ctrl.showTabsFunc && {}.toString.call(ctrl.showTabsFunc) === '[object Function]') {
      return ctrl.showTabsFunc(ctrl);
    } else {
      return true;
    }
  };

  //#endregion
}

const sbGridDetailComponentOptions = {
  templateUrl: 'App/ui-kit/sb-grid-detail/sb-grid-detail.component.html',
  controller: sbGridDetailComponent,
  bindings: {
    onChanges: '=',
    showTabsFunc: '=',
    row: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbGridDetail: sbGridDetailComponentOptions,
  };

  const sbGridDetailModule = angular.module('sbGridDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbGridDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = [
    'sbMap',
    'sbGridWrapper',
    'sbCronTask',
    'sbDmsButton',
    'sbSaveButton',
    'sbPanelSidebar',
    'sbPanelHorizontal',
    'sbPanelStepper',
    'sbModuserBox',
    'sbInfoTooltip',
    'sbSignature',
    'sbNtbCalculator',
    'sbMultiformPanel',
    'sbEditor',
    'sbChart',
    'sbFormInitButton',
    'sbCardList',
    'sbGridDetail',
  ];

  const sbUiKitModule = angular.module('sbUiKit', modules);
})();

(function() {
  var _ddlPlugin = $.fn.kendoDropDownList;
  if (!_ddlPlugin) return;
  $.fn.kendoDropDownList = function() {
    if (typeof arguments[0] === 'string' && !this.data('kendoDropDownList')) {
      return this;
    }
    return _ddlPlugin.apply(this, arguments);
  };
  $.extend($.fn.kendoDropDownList, _ddlPlugin);
})();

$(function() {
  toastr.options = {
    closeButton: false,
    debug: false,
    progressBar: true,
    positionClass: 'toast-bottom-center',
    onclick: null,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 3200,
    extendedTimeOut: 1000,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };

  window.onerror = function(errorMsg, url, lineNumber) {
    toastr.error(lineNumber + ' | ' + errorMsg);

    PostJavaScriptError(errorMsg);

    return false;
  };

  bootbox.setDefaults({ locale: 'hu' });
  moment.locale('hu');
  kendo.culture('hu');
});

/**
 * Synchronous dependency resolver function for use in ui-router state/rotue definitions to resolve
 * PageModels / other required dependencies from controllers to complete state transition.
 * @param {} url url to resolve with possible parameters in it
 * @param {} params HTTP GET parameters as javascript object
 * @param {} paramNames names of parameters which are not present in url, but are part of current $stateParams context
 *           and want to be sent over as HTTP GET param.
 * @returns {} a promise that should be resolved by the router
 */
function RouteResolveFunc(url, params, paramNames, preprocessFunction) {
  return [
    '$rootScope',
    '$http',
    '$stateParams',
    '$state',
    function($rootScope, $http, $stateParams, $state) {
      let copyOfUrl = undefined;
      if (preprocessFunction) {
        copyOfUrl = preprocessFunction($stateParams);
      } else {
        copyOfUrl = angular.copy(url);
      }
      var httpGetParams = {};
      if (!!params) {
        httpGetParams = params;
      }
      angular.forEach($stateParams, function(value, key) {
        var search = '{' + key + '}';
        if (copyOfUrl.indexOf(search) !== -1) {
          copyOfUrl = copyOfUrl.replace(new RegExp(search, 'g'), value);
        } else {
          if (!!paramNames) {
            for (var i = 0; i < paramNames.length; i++) {
              if (paramNames[i] === key) {
                httpGetParams[key] = value;
                break;
              }
            }
          }
        }
      });
      if (!params && !paramNames) {
        return $http
          .get(copyOfUrl)
          .then(function(response) {
            if (!!response?.data && !!$stateParams.controllerOptions?.ctrlIdTemplate) {
              $rootScope.controllerResolvedData[$stateParams.controllerOptions?.ctrlIdTemplate] = angular.copy(
                response.data
              );
            }
            return response.data;
          })
          .catch(function(error) {
            if (error.status === 401) {
              // in case of auth error we need to resolve the route (the login redirection will do the auth protection)
              return Promise.resolve();
            }

            throw error;
          });
      } else {
        return $http({
          method: 'GET',
          url: copyOfUrl,
          params: httpGetParams,
        }).then(
          function(response) {
            if (!!response?.data && !!$stateParams.controllerOptions?.ctrlIdTemplate) {
              $rootScope.controllerResolvedData[$stateParams.controllerOptions.ctrlIdTemplate] = angular.copy(
                response.data
              );
            }
            return response.data;
          },
          function(error) {
            console.log('error: ', error);
            if (IsValidJSONStr(error.statusText)) {
              var parsedErrorMessages = JSON.parse(error.statusText);
              if (error.status === 401) {
                // in case of auth error we need to resolve the route (the login redirection will do the auth protection)
                return Promise.resolve();
              }

              if (error.status === 403) {
                parsedErrorMessages.forEach(function(m) {
                  //toastr.warning(m);
                  console.log(m);
                });
              }
            }

            return Promise.reject();
          }
        );
      }
    },
  ];
}

function RouteResolvePostFunc(url, params, paramNames) {
  return [
    '$http',
    '$stateParams',
    function($http, $stateParams) {
      var copyOfUrl = angular.copy(url);
      var data = {};
      if (!!params) {
        data = params;
      }
      angular.forEach($stateParams, function(value, key) {
        var search = '{' + key + '}';
        if (copyOfUrl.indexOf(search) !== -1) {
          copyOfUrl = url.replace(new RegExp(search, 'g'), value);
        } else {
          if (!!paramNames) {
            for (var i = 0; i < paramNames.length; i++) {
              if (paramNames[i] == key) {
                data[key] =
                  typeof value === 'string' || value instanceof String
                    ? value.startsWith('{')
                      ? JSON.parse(value)
                      : value
                    : value;
                break;
              }
            }
          }
        }
      });

      if (!params && !paramNames) {
        return $http.get(copyOfUrl).then(function(response) {
          return response;
        });
      } else {
        return $http({
          method: 'Post',
          url: copyOfUrl,
          data: data,
        }).then(
          function(response) {
            return response.data;
          },
          function(error) {}
        );
      }
    },
  ];
}

function RouteResolveParamFunc(url, params, paramNames) {
  return RouteResolveFunc(url, params, paramNames, function($stateParams) {
    let copyOfUrl = angular.copy(url);

    angular.forEach($stateParams, function(value, key) {
      var search = '{' + key + '}';
      if (copyOfUrl.indexOf(search) !== -1) {
        copyOfUrl = copyOfUrl.replace(new RegExp(search, 'g'), value);
      }
    });
    return copyOfUrl;
  });
}

/**
 * @return {boolean}
 * @return {boolean}
 */
function IsValidJSONStr(str) {
  return /^[\],:{}\s]*$/.test(
    str
      .replace(/\\["\\\/bfnrtu]/g, '@')
      .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
      .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
  );
}

//Szervernek elküld egy hiba üzenetet, ami itt a kliens oldalon történt.
// TODO kell ez?
function PostJavaScriptError(error, service, method) {
  $.ajax({
    type: 'POST',
    url: 'Auth/JavascriptError',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      error: JSON.stringify({ errorMsg: error }),
      service: service + '; url: ' + document.URL,
      method: method,
    }),
  });
}

String.format = function() {
  var theString = arguments[0];
  for (var i = 1; i < arguments.length; i++) {
    var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
    theString = theString.replace(regEx, arguments[i]);
  }
  return theString;
};

// Bármilyen objektumon végig megy és ha talál olyat, aminek a tartalma /Date(...,
// akkor azt átalakítja Javascript Date objektummá
function JsonDateToJsDate(param) {
  if (!param) return param;

  if (angular.isString(param)) {
    // Ha már string, akkor ide kell belépni, különben végig lépked a string betűin.
    if (param.indexOf('/Date(') !== -1) return new Date(parseInt(param.replace('/Date(', '')));
    else return param;
  } else if (angular.isObject(param)) {
    angular.forEach(param, function(value, key) {
      param[key] = JsonDateToJsDate(value);
    });
    return param;
  } else return param;
}

// angular-formly fields tömbjéből keresi ki a paraméterben megadott kulcsú elemet.
// Példa: vm.fields.getField("tema")
Array.prototype.getField = function(key) {
  var field = null;

  $.each(this, function(index, value) {
    if (angular.isArray(value.fieldGroup)) {
      var f = value.fieldGroup.getField(key);
      if (f) field = f;
    } else if (value.key === key) field = value;
  });

  return field;
};

Array.prototype.remove = function(item) {
  var index = this.indexOf(item);
  this.splice(index, 1);
  return this;
};

var KendoDataSourceErrorFunc = function(response) {
  if (response.xhr.status === 401) location.reload();
  else toastr.error(response.errorThrown);
};

const sortExceptions = ['month', 'day'];

function FormlyCreateDDLOption(options, elementType) {
  // options = { url: <string>, transData: <function || {}>, autoBind: <true|false>, index: <int>,
  //             optionLabel: <string>, group: <{}>, data: <[]>, transType: "GET|POST", autoClose: True|False }
  options = angular.extend(
    {
      textField: 'Text',
      valueField: 'Value',
      index: 0,
      autoBind: true,
      transType: 'GET',
      autoClose: true,
    },
    options
  );
  options.data = options.data || [];
  const dataSourceInit = new kendo.data.DataSource({
    transport:
      (!options.data || options.data.length == 0) && options.url
        ? {
            read: {
              dataType: 'json',
              url: options.url,
              data: options.transData
                ? options.transData
                : function() {
                    var getType = {};
                    if (options.otherParams && getType.toString.call(options.otherParams) === '[object Function]') {
                      var result = options.otherParams();
                      return {
                        queryParameters: JSON.stringify(result),
                      };
                    } else {
                      if (options.otherParams) {
                        return options.otherParams;
                      }
                    }
                  }, //options.transData,
              type: options.transType,
              cache: false, //IE miatt kell!!
            },
          }
        : {
            read: function(readOptions) {
              readOptions.success(options.data);
            },
          },
    data: !options.url ? options.data : undefined,
    group: options.group, // { field: "SzervezodesNev" }
    error: KendoDataSourceErrorFunc,
    schema: {
      data: function(response) {
        let data = response?.data ?? response;
        if (typeof data !== 'string' && !data?.ErrorCode) {
          Object.keys(data).forEach(function(key, index) {
            if (!data[key].extraProperties) {
              data[key].extraProperties = [];
              data[key].extraProperties.push({ key: 'extText', value: null });
              data[key].extraProperties.push({ key: 'disabled', value: false });
              data[key].extraProperties.push({ key: 'highlight', value: false });
            }
          });
        }
        if (!!data?.length && typeof dataSourceInit.sort() == 'undefined') {
          if (response?.AutoSort) {
            dataSourceInit.sort(
              sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))
                ? null
                : { field: options.textField, dir: 'asc' }
            );
          } else {
            dataSourceInit.sort({});
          }
        }
        if (options.schemaDataFunc && {}.toString.call(options.schemaDataFunc) === '[object Function]') {
          return options.schemaDataFunc(data);
        }
        return data; // the response from the service is { Data: [array of objects] }
      },
    },
  });
  return {
    dataTextField: options.textField,
    dataValueField: options.valueField,
    filter: 'contains',
    autoBind: options.autoBind,
    selectFirst: options.selectFirst,
    index: options.index,
    optionLabel:
      options.autoBind === false && !options.optionLabel
        ? kendo.ui.FilterMenu.prototype.options.messages.selectValue
        : options.optionLabel,
    height: 350,
    autoClose: options.autoClose, // Ez csak MultiSelect-nél van
    dataBound: function(e) {
      var self = this;
      var scope = self.$angular_scope;
      if (scope && !scope._ddlDestroyHandlerRegistered) {
        scope._ddlDestroyHandlerRegistered = true;
        scope.$on('$destroy', function() {
          if (self.dataSource) {
            self.dataSource.unbind('change');
            self.dataSource.unbind('progress');
            self.dataSource.unbind('error');
          }
        });
      }

      if (elementType == 'textCombo') {
        if (e.sender.$angular_scope.to.defaultValue) {
          e.sender.$angular_scope.model[e.sender.$angular_scope.options.key] = e.sender.$angular_scope.to.defaultValue;
          e.sender.$angular_scope.to.defaultValue = undefined;
        }
        //Ha nincs találat a szűkítésre a listában jelenjen meg minden és zárja be a combot...
        if (!this.dataSource?.view()?.length && e.sender.dataSource.filter()) {
          this.dataSource.filter(null);
          e.sender.close(e);
        }
        //ha nincs választék ne lehessen lenyitni a combot...
        this.input
          .parent()
          .parent()
          .find('button')
          .toggle((this.dataSource?.data()?.length ?? 0) > 0);
      }

      $('.ddid')
        .parent()
        .click(false);
      $('.ddid')
        .parent()
        .parent()
        .click(false);
      if (
        (this.selectedIndex ?? -1) < 0 &&
        this.dataSource?.data()?.length === 1 &&
        !!this.$angular_scope.to.required &&
        this.options.selectFirst
      ) {
        this.select(0);
        this.trigger('change');
      }
      if (options.dataBound && {}.toString.call(options.dataBound) === '[object Function]') {
        options.dataBound(e);
      }
    },
    template:
      '<span class="# if (extraProperties.find(x => x.key=="disabled")?.value == \'1\') { #ddid# } #' +
      '# if (extraProperties.find(x => x.key=="highlight")?.value == \'1\') { #ComboHighlight#}# ">' +
      '#: ' +
      options.textField +
      ' # ' +
      '# if (!!extraProperties.find(x => x.key=="extText")?.value) { # (#:extraProperties.find(x => x.key=="extText")?.value #) #}# ' +
      '</span>',
    filtering: function(e, a, b) {
      //e.preventDefault();
    },
    open: function(e) {
      e.sender.close(e);
      if (elementType == 'textCombo') {
        if (!this.dataSource?.view()?.length) {
          e.preventDefault();
        }
      }

      let dataItems = this.dataSource.view().map(a => a.key);
      let id = this.$angular_scope.to.id;
      this.$angular_scope.to.addClassOrIdToElement(this.ul.find('li'), id, id, dataItems);
    },
    dataSource: dataSourceInit,
  };
}

function FormlyCreateDDMCLOption(options) {
  // options = { url: <string>, transData: <function || {}>, autoBind: <true|false>, index: <int>,
  //             optionLabel: <string>, group: <{}>, data: <[]>, transType: "GET|POST", autoClose: True|False }
  options = angular.extend(
    {
      textField: 'Text',
      valueField: 'Value',
      index: 0,
      autoBind: false,
      transType: 'GET',
      autoClose: true,
    },
    options
  );
  const dataSourceInit = new kendo.data.DataSource({
    transport: !options.data
      ? {
          read: {
            dataType: 'json',
            url: options.url,
            data: options.transData
              ? options.transData
              : function() {
                  var getType = {};
                  if (options.otherParams && getType.toString.call(options.otherParams) === '[object Function]') {
                    var result = options.otherParams();
                    return {
                      queryParameters: JSON.stringify(result),
                    };
                  } else {
                    if (options.otherParams) {
                      return options.otherParams;
                    }
                  }
                }, //options.transData,
            type: options.transType,
            cache: false, //IE miatt kell!!
          },
        }
      : null,
    data: options.data,
    group: options.group, // { field: "SzervezodesNev" }
    error: KendoDataSourceErrorFunc,
    schema: {
      data: function(response) {
        let data = response?.data ?? response;
        if (!!data?.length && !dataSourceInit.sort()?.length) {
          if (response?.AutoSort) {
            dataSourceInit.sort(
              sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))
                ? null
                : { field: options.textField, dir: 'asc' }
            );
          } else {
            dataSourceInit.sort({});
          }
        }
        return data; // the response from the service is { Data: [array of objects] }
      },
    },
  });
  return {
    dataTextField: options.textField,
    dataValueField: options.valueField,
    columns: options.columns,
    filter: 'contains',
    filterFields: options.filterFields,
    suggest: true,
    autoBind: options.autoBind,
    index: options.index,
    placeholder:
      options.autoBind === false && !options.optionLabel
        ? kendo.ui.FilterMenu.prototype.options.messages.selectValue
        : options.optionLabel,
    optionLabel:
      options.autoBind === false && !options.optionLabel
        ? kendo.ui.FilterMenu.prototype.options.messages.selectValue
        : options.optionLabel,
    // popup: {
    // position: "top center"
    // },
    dataBound: function(e) {
      var combo = this;
      let setNullValue = !combo.dataSource.data().some(function(item) {
        return item[e.sender.$angular_scope.to.options.dataValueField] == e.sender.$angular_scope.lastModelValue;
      });
      if (setNullValue) {
        this.value(null);
        //e.sender.$angular_scope.to.applyChange(null);
      }

      if (options.dataBound && {}.toString.call(options.dataBound) === '[object Function]') {
        options.dataBound(e);
      }
    },
    autoClose: options.autoClose,
    dataSource: dataSourceInit,
  };
}

function FormlyCreateLBOption(options) {
  // options = { url: <string>, transData: <function || {}>, autoBind: <true|false>, index: <int>,
  //             optionLabel: <string>, group: <{}>, data: <[]>, transType: "GET|POST", autoClose: True|False }
  options = angular.extend(
    {
      textField: 'Text',
      valueField: 'Value',
      index: 0,
      autoBind: false,
      transType: 'GET',
      autoClose: true,
    },
    options
  );
  const dataSourceInit = new kendo.data.DataSource({
    transport:
      options.data == null
        ? {
            read: {
              dataType: 'json',
              url: options.url,
              data: options.transData
                ? options.transData
                : function() {
                    var getType = {};
                    if (options.otherParams && getType.toString.call(options.otherParams) === '[object Function]') {
                      var result = options.otherParams();
                      return {
                        queryParameters: JSON.stringify(result),
                      };
                    } else {
                      if (options.otherParams) {
                        return options.otherParams;
                      }
                    }
                  }, //options.transData,
              type: options.transType,
              cache: false, //IE miatt kell!!
            },
          }
        : null,
    data: options.data,
    group: options.group, // { field: "SzervezodesNev" }
    error: KendoDataSourceErrorFunc,
    schema: {
      data: function(response) {
        let data = response?.data ?? response;
        if (!!data?.length && !dataSourceInit.sort()?.length) {
          if (response?.AutoSort) {
            dataSourceInit.sort(
              sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))
                ? null
                : { field: options.textField, dir: 'asc' }
            );
          } else {
            dataSourceInit.sort({});
          }
        }
        return data; // the response from the service is { Data: [array of objects] }
      },
    },
  });
  return {
    dataTextField: options.textField,
    dataValueField: options.valueField,
    connectWith: 'selected',
    draggable: true,
    toolbar: {
      position: 'right',
      tools: ['moveUp', 'moveDown'],
    },
    dataSource: dataSourceInit,
  };
}

function FormlyCreateMSOption(options) {
  // options = { url: <string>, transData: <function || {}>, autoBind: <true|false>, index: <int>,
  //             optionLabel: <string>, group: <{}>, data: <[]>, transType: "GET|POST", autoClose: True|False }
  options = angular.extend(
    {
      textField: 'Text',
      valueField: 'Value',
      index: 0,
      autoBind: true,
      transType: 'GET',
      autoClose: true,
      singleTagType: true,
      singleTagNumber: 3,
    },
    options
  );
  const dataSourceInit = new kendo.data.DataSource({
    transport:
      options.data == null
        ? {
            read: {
              dataType: 'json',
              url: options.url,
              data: options.transData
                ? options.transData
                : function() {
                    var getType = {};
                    if (options.otherParams && getType.toString.call(options.otherParams) === '[object Function]') {
                      var result = options.otherParams();
                      return {
                        queryParameters: JSON.stringify(result),
                      };
                    } else {
                      if (options.otherParams) {
                        return options.otherParams;
                      }
                    }
                  }, //options.transData,
              type: options.transType,
              cache: false, //IE miatt kell!!
            },
          }
        : null,

    data: options.data,
    group: options.group, // { field: "SzervezodesNev" }
    error: KendoDataSourceErrorFunc,
    schema: {
      data: function(response) {
        let data = response?.data ?? response;
        if (!!data?.length && !dataSourceInit.sort()?.length) {
          if (response?.AutoSort) {
            dataSourceInit.sort(
              sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))
                ? null
                : { field: options.textField, dir: 'asc' }
            );
          } else {
            dataSourceInit.sort({});
          }
        }
        return data; // the response from the service is { Data: [array of objects] }
      },
    },
  });
  return {
    dataTextField: options.textField,
    dataValueField: options.valueField,
    tagTemplate: !!options.singleTagType
      ? '   # var z = angular.element($("[dom-id=\'' +
        options.DOMId +
        '\']")).scope(); # ' +
        '   # if (dataItems.length < ' +
        (options.singleTagNumber + 1) +
        ' || !!z?.to?.disabled) { # ' +
        '  # for (var idx = 0; idx < values.length; idx++) { # ' +
        '      <span style="white-space:nowrap">#:dataItems[idx].text## if (idx < values.length - 1) {#, #} #</span>  ' +
        '  # } # ' +
        ' # } else { # ' +
        ' <span style="white-space:nowrap">#:values.length# elem kiválasztva</span> ' +
        '# } #'
      : null,
    tagMode: !!options.singleTagType ? 'single' : 'multiple',
    filter: 'contains',
    autoBind: options.autoBind,
    index: options.index,
    placeholder: options.placeHolder, //Multiselect Combonál legyen placeholder...
    optionLabel:
      options.autoBind === false && !options.optionLabel
        ? kendo.ui.FilterMenu.prototype.options.messages.selectValue
        : options.optionLabel,
    height: 350,
    autoClose: options.autoClose, // Ez csak MultiSelect-nél van
    dataBound: options.dataBound,
    change: function(e) {
      let dataItems = e.sender.value();
      if (!sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))) {
        let dataRows = [];
        angular.forEach(e.sender.dataItems(), element => (dataRows[element.key] = element.text));
        e.sender.value(dataItems.sort((x, y) => localizeCompare(dataRows[x], dataRows[y])));
      }
      let id = this.$angular_scope.to.id;
      this.$angular_scope.to.addClassOrIdToElement(this.ul.find('ul.k-reset li'), id, id, dataItems);
      options.change(e, this);
    },
    open: function() {
      let dataItems = this.dataSource.view().map(a => a.key);
      let id = this.$angular_scope.to.id;
      this.$angular_scope.to.addClassOrIdToElement(this.ul.find('li'), id, id, dataItems);
      this.$angular_scope.to.addClassOrIdToElement($(this.optionLabel), id, id, null);
    },
    filtering: function() {
      let dataItems = this.dataSource.view().map(a => a.key);
      let id = this.$angular_scope.to.id;
      this.$angular_scope.to.addClassOrIdToElement(this.ul.find('li'), id, id, dataItems);
    },
    maxSelectedItems: options.maxSelectedItems,
    dataSource: dataSourceInit,
  };
}

function FormlyCreateFileUpload(originalOptions, options) {
  var parsedParams = options.dynamicOptions;

  return angular.extend(originalOptions, {
    autoUpload: parsedParams.AutoUpload ? parsedParams.AutoUpload : false,
    multipleFileUpload: parsedParams.MultipleFileUpload ? parsedParams.MultipleFileUpload : false,
    saveUrl: parsedParams.SaveUrl,
    removeUrl: parsedParams.RemoveUrl,
    showFileList: parsedParams.ShowFileList ? parsedParams.ShowFileList : true,
  });
}

function CreateDropDownOption(options) {
  // options = { url: <string>, transData: <function || {}>, autoBind: <true|false>, index: <int>,
  //             optionLabel: <string>, group: <{}>, data: <[]>, dataBound: function, onChange: function, template:<string> }
  options = angular.extend(
    {
      textField: 'Text',
      valueField: 'Value',
      index: 0,
      autoBind: false,
      template: null,
      valueTemplate: null,
    },
    options
  );
  const dataSourceInit = new kendo.data.DataSource({
    transport: !options.data
      ? {
          read: {
            dataType: 'json',
            url: options.url,
            data: options.transData
              ? options.transData
              : function() {
                  var getType = {};
                  if (options.otherParams && getType.toString.call(options.otherParams) === '[object Function]') {
                    var result = options.otherParams();
                    return {
                      queryParameters: JSON.stringify(result),
                    };
                  } else {
                    return options.otherParams;
                  }
                }, //options.transData,
            type: 'POST',
            cache: false, //IE miatt kell!!
          },
        }
      : null,
    data: options.data,
    group: options.group, // { field: "SzervezodesNev" }
    error: KendoDataSourceErrorFunc,
    schema: {
      data: function(response) {
        let data = response?.data ?? response;
        if (!!data?.length && !dataSourceInit.sort()?.length) {
          if (response?.AutoSort) {
            dataSourceInit.sort(
              sortExceptions.some(v => options.url?.toLowerCase()?.includes(v))
                ? null
                : { field: options.textField, dir: 'asc' }
            );
          } else {
            dataSourceInit.sort({});
          }
        }
        return data; // the response from the service is { Data: [array of objects] }
      },
    },
  });
  return {
    dataTextField: options.textField,
    dataValueField: options.valueField,
    filter: 'contains',
    valueTemplate: options.valueTemplate,
    template: options.template,
    autoBind: options.autoBind,
    index: options.index,
    optionLabel:
      options.autoBind === false && !options.optionLabel
        ? kendo.ui.FilterMenu.prototype.options.messages.selectValue
        : options.optionLabel,
    height: 350,
    dataBound: function(e) {
      console.log('DDL dataBound called: e: ', e, '(this): ', this);
    },
    //options.autoBind === true ? options.dataBound : null,
    change: options.onChange,
    dataSource: dataSourceInit,
  };
}

function FormlyCreateACOption(options) {
  var _itemHeight = 26;
  var _height = (options.PageSize / 4) * _itemHeight;
  return {
    dataTextField: options.TextFieldName, //options.textField,
    filter: options.FilterMOde,
    minLength: options.MinChar,
    height: _height,
    ignoreCase: false,
    noDataTemplate: 'Nincs adat!',
    virtual: options.DynPager ? { itemHeight: _itemHeight } : null,
    dataSource: new kendo.data.DataSource({
      serverFiltering: true,
      pageSize: options.PageSize,
      schema: {
        data: function(response) {
          return response.Data;
        },
        total: function(response) {
          return response.Total;
        },
      },
      serverPaging: true,
      transport: {
        read: {
          url: 'AutoComplete/AutoCompleteData',
          dataType: 'json',
          type: 'POST',
          cache: false, //IE miatt kell!!
        },
        parameterMap: function(data, type) {
          var mappedData = {
            page: data.page,
            pageSize: data.pageSize,
            sort: options.TextFieldName + '-asc',
            tableName: options.TableName,
            idColumn: options.IdColumn,
            columnCsv: options.ColumnNames,
            adopter: options.Adopter,
            filter:
              !!data.filter && data.filter.filters.length > 0
                ? '(' +
                  data.filter.filters[0].field +
                  '~' +
                  data.filter.filters[0].operator +
                  "~'" +
                  data.filter.filters[0].value +
                  "')"
                : '',
          };
          return mappedData;
        },
      },
      error: KendoDataSourceErrorFunc,
    }),
  };
}

/////////////////////////////// [ Kendo GRID Helper functions ] ///////////////////////////////////
function KendoGridSetDetailRow(grid, field, expand) {
  var dataSource = grid.dataSource;
  grid.element.find('tr.k-master-row').each(function() {
    var row = $(this);
    var data = dataSource.getByUid(row.data('uid'));
    //Csak akkor lehet lenyitni a sort, ha van hozzá detail
    if (!data.get(field)) {
      row
        .find('.k-hierarchy-cell a')
        .css({ opacity: 0.3, cursor: 'default' })
        .click(function(e) {
          e.stopImmediatePropagation();
          return false;
        });
    } else if (expand) {
      grid.expandRow(row);
    }
  });
}

function SetComboOptions(field, url) {
  field.templateOptions.options = FormlyCreateDDLOption({
    url: url,
    textField: field.templateOptions.ComboOptions.textField,
    valueField: field.templateOptions.ComboOptions.textField,
  });
}

function SetGridOptions(field, url, gridFields) {
  field.templateOptions.options = {
    title: field.templateOptions.GridOptions.title,
    fieldKey: field.templateOptions.GridOptions.fieldKey,
    fieldText: field.templateOptions.GridOptions.fieldText,
    gridOptions: {
      url: url,
      fields: gridFields,
    },
  };
}

function SetGridColumnToDateTime(gridModel, grids, columns) {
  angular.forEach(grids, function(_grid) {
    var _json = JSON.parse(gridModel[_grid].Fields);
    angular.forEach(columns, function(_column) {
      _json[_column].type = 'datetime';
    });
    gridModel[_grid].Fields = JSON.stringify(_json);
  });
}

function SetGridModelColumnToDateTime(gridModel, columns) {
  var _json = JSON.parse(gridModel.Fields);
  angular.forEach(columns, function(_column) {
    _json[_column].type = 'datetime';
  });
  gridModel.Fields = JSON.stringify(_json);
}

// Query selected grid elements dynamically
function GetSelectedGridItems(grid) {
  if (!!grid && !!grid.element) {
    var row = grid.select();

    var dataItemList = [];

    if (row.length !== 0) {
      dataItemList = $.map(row, function(item) {
        return grid.dataItem(item);
      });
    }
    return dataItemList;
  }

  return [];
}
function exportExcel(grids, sheetLabels, fileName) {
  if (!grids) {
    grids = [$('#resultGrid').getKendoGrid()];
  }

  let sheets = [];
  let sheetCounter = 0;

  angular.forEach(grids, function(grid) {
    if (!!grid) {
      let rows = [
        {
          cells: grid.columns
            .filter(x => {
              return !x.hidden;
            })
            .map(x => {
              return { value: x.title };
            }),
        },
      ];

      angular.forEach(grid.dataSource.data(), function(value) {
        rows.push({
          cells: grid.columns
            .filter(x => {
              return !x.hidden;
            })
            .map(x => {
              return { value: value[x.field] };
            }),
        });
      });

      sheets.push({
        columns: [{ autoWidth: true }, { autoWidth: true }, { autoWidth: true }, { autoWidth: true }],
        title:
          Array.isArray(sheetLabels) && sheetLabels[sheetCounter] !== undefined
            ? sheetLabels[sheetCounter]
            : 'Sheet' + sheetCounter,
        rows: rows,
      });
    }
    sheetCounter++;
  });

  var workbook = new kendo.ooxml.Workbook({
    sheets: sheets,
  });

  workbook.toDataURLAsync().then(function(dataURL) {
    kendo.saveAs({
      dataURI: dataURL,
      fileName: fileName || 'Report.xlsx',
    });
  });
}

function kendoMSInit(pageModel, fields) {
  angular.forEach(fields, function(field, key) {
    pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
  });
}

function localizeCompare(a, b, options) {
  const collator = new Intl.Collator(options?.language ?? kendo.culture().name);
  if (isNaN(a) && isNaN(b)) {
    return collator.compare(a.toString(), b.toString());
  } else return a - b;
}

function base64ToObject(b64, urlsafe = false) {
  let obj;
  try {
    if (urlsafe) {
      b64 = decodeURIComponent(b64);
    }
    obj = JSON.parse(decodeURIComponent(window.atob(b64)));
  } catch (e) {
    return {};
  }
  return obj;
}
function objectTobase64(obj, urlsafe = false) {
  let b64;
  try {
    b64 = btoa(encodeURIComponent(JSON.stringify(obj)));
    if (urlsafe) {
      b64 = encodeURIComponent(b64);
    }
  } catch (e) {
    return '';
  }
  return b64;
}
function changeModelFromParam(model, params) {
  if (typeof model !== 'object' || !model) {
    return;
  }
  let decodedParams = base64ToObject(params);
  Object.assign(model, decodedParams);
}
function addGetterToRouteState(pagemodel, field, model, inParam, fixParam) {
  let routeState = pagemodel?.Fields[field]?.FormlyFieldDescriptor?.templateOptions?.RouteState;
  if (!routeState) {
    return;
  }
  routeState = pagemodel.Fields[field].FormlyFieldDescriptor.templateOptions.RouteState = routeStateToObject(
    routeState
  );

  const inParams = inParam;
  if (typeof fixParam === 'object' && fixParam) {
    Object.assign(routeState.params, fixParam);
  }
  routeState.getParams = function() {
    let newInParam = {};
    inParams.forEach(x => {
      if (typeof x === 'object') {
        let key = Object.keys(x)[0];
        if (!key) return;
        newInParam[key] = model[x[key]];
      } else {
        if (!x) return;
        newInParam[x] = model[x];
      }
    });
    let encodedParams = objectTobase64(newInParam);
    routeState.params['param'] = encodedParams;
    return routeState.params;
  };
}
function routeStateToObject(routeState) {
  if (!!routeState && typeof routeState !== 'object') {
    const linkRegex = /^[^(]+/;
    const paramRegex = /\([^\)]+\)/;
    const removeRegex = /[\(\)]/g;
    const link = routeState;
    let realLink = link.match(linkRegex)?.length > 0 ? link.match(linkRegex)[0] : '';
    if (!realLink) {
      return null;
    }
    let params = link.match(paramRegex)?.length > 0 ? link.match(paramRegex)[0]?.replace(removeRegex, '') : '';
    var paramsObj = !!params ? JSON.parse(params) : {};
    return {
      state: realLink,
      params: paramsObj,
      getParams: function() {
        return paramsObj;
      },
    };
  } else {
    return routeState;
  }
}
function ctrlInit(scope, name, stateParams) {
  scope.ctrlId = name;
  if (stateParams) {
    if (stateParams.MDType) {
      scope.ctrlId += '_' + stateParams.MDType;
    }
    if (stateParams.ObjectType) {
      scope.ctrlId += '_' + stateParams.ObjectType;
    }
    if (stateParams.InvoiceTypeFilter) {
      scope.ctrlId += '_' + stateParams.InvoiceTypeFilter;
    }
  }
}

function sysEmailValidate(email) {
  var EMAIL_REGEXP = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return EMAIL_REGEXP.test(email);
}
function $GenerateRiport($http, $uibModal, FileSaver, params) {
  $http
    .post(params.getController)
    .then(function(resultModel) {
      params.uibParams.pageModel = resultModel?.data?.pageModel;
      params.uibParams.dto = resultModel?.data?.dto;
      params.uibParams.id = params.uibParams.id ?? 0;
      params.uibParams.state = params.uibParams.state ?? 'edit';
      params.uibParams.panelName = params.uibParams.panelName ?? 'PanelForm';
      params.uibParams.btnSave = params.uibParams.btnSave ?? {
        text: params.uibParams.pageModel.Actions.btnGenerate.Title,
      };
      var modalInstance = $uibModal.open({
        templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
        controller: 'SbCardListEditModalCtrl',
        controllerAs: 'vm',
        resolve: {
          model: params.uibParams,
          params: {},
        },
        backdrop: 'static',
      });
      modalInstance.result.then(function(result) {
        if (result) {
          $http
            .post(params.generateController, { dto: result?.dto, report: params.report })
            .then(function(result) {
              $FileSaveAs(
                FileSaver,
                result.data.Report,
                params.FileNameExt ?? result.data.FileNameExt,
                params.MimeType ?? result.data.MimeType
              );
            })
            .catch(function(response) {
              toastr.error(params.model.pageModel.Messages.GenerateFailed);
            });
        }
      });
    })
    .catch(function(response) {
      toastr.error(params.model.pageModel.Messages.GenerateFailed);
    });
}

function $FileSaveAs(FileSaver, data, fileName, fileType) {
  var raw = window.atob(data);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));
  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  var fs = new Blob([array], {
    type: fileType,
  });
  FileSaver.saveAs(fs, fileName);
}

function setFocusOnField(scope, fieldId) {
  if (scope.options.key == fieldId) {
    setTimeout(function() {
      //Egyes kendo komponensek saját focus() függvénnyel rendelkeznek, mivel az eredeti input mezőt elfedik:
      let component = $(document.getElementById(scope.id));

      let _ddl = component.data('kendoDropDownList');
      if (_ddl) {
        return _ddl.focus();
      }
      let _ntb = component.data('kendoNumericTextBox');
      if (_ntb) {
        return _ntb.focus();
      }
      //látszó inputokkal rendelkező kendo komponenesek esetében:
      scope.to.focus = true;
    }, 0);
  }
}

////////////////////////////////////////////////////////////////////////////////////////////////

function setF2Options(field, url) {
  if (!field.templateOptions.GridOptions || !field.templateOptions.GridOptions.gridModel) return;

  function isManual() {
    //console.log(field.templateOptions.GridOptions.fieldText);
    //console.log(field.templateOptions.GridOptions.fieldValues[Object.keys(field.templateOptions.GridOptions.fieldValues)[0]]);
    return (
      field.templateOptions.GridOptions.fieldText ===
      field.templateOptions.GridOptions.fieldValues[Object.keys(field.templateOptions.GridOptions.fieldValues)[0]]
    );
  }

  var f2options = {
    title: field.templateOptions.label,
    fieldKey: field.templateOptions.GridOptions.fieldValues,
    fieldText: field.templateOptions.GridOptions.fieldText,
    isManual: isManual(),
    maxlength: field.templateOptions.maxlength,
    mask: field.templateOptions.mask,
    RouteState: field.templateOptions.RouteState,
    gridOptions: {
      url: url,
      otherParams: field.templateOptions.QueryParameters,
      groupable: false,
      height: 350,
      fields: JSONfn.parse(field.templateOptions.GridOptions.gridModel.Fields),
      columns: field.templateOptions.GridOptions.gridModel.Columns,
    },
    otherParams: field.templateOptions.QueryParameters,
    selectFirst: field.templateOptions.selectFirst ?? true,
  };
  field.templateOptions.options = f2options;
}

///
//                 !!!                                      _
//                                                          \`\
//             B E W A R E                        /./././.   | |
//   !!!    Experimental Code    !!!            /        `/. | |
//                Ahead                       /  __    `/'/'  /
//                                          /\__/\ /'  `\    /
//                 !!!                     |  oo  |      `.,.|
//                                          \vvvv/        ||||
//                                            ||||        ||||
//                                            ||||        ||||
//                                            `'`'        `'`'
///

function SetModelExtraPropBasedOnSelectedItem(extraProps, propName, selectedItem) {
  if (!!extraProps) {
    for (var i = 0; i < extraProps.length; i++) {
      if (extraProps[i].key === propName) {
        if (!!selectedItem.extraProperties) {
          for (var j = 0; j < selectedItem.extraProperties.length; j++) {
            if (selectedItem.extraProperties[0].key === propName) {
              extraProps[i].value = selectedItem.extraProperties[0].value;
              return;
            }
          }
        }
        extraProps[i].value = undefined;
        return;
      }
    }
  }
}

function ShowFieldBasedOnExtraProp(extraProps, propName, showValues) {
  if (!!extraProps) {
    for (var i = 0; i < extraProps.length; i++) {
      if (extraProps[i].key === propName) {
        for (var j = 0; j < showValues.length; j++) {
          if (extraProps[i].value === showValues[j]) return true;
        }
      }
    }
  }
  return false;
}

function InsertCustomTypes(pageModel, customTypes) {
  if (!customTypes) {
    return;
  }
  __setFDProperties(pageModel, 'type', customTypes);
}

function InsertCustomClasses(pageModel, customDirectives) {
  if (!customDirectives) {
    return;
  }
  __insertFDStringProperties(pageModel, 'className', customDirectives);
}

function InsertOnBlurFunctions(pageModel, onBlurFunctions) {
  if (!onBlurFunctions) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', onBlurFunctions, 'onBlur');
}

function InsertOnChangeFunctions(pageModel, onChangeFunctions) {
  if (!onChangeFunctions) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', onChangeFunctions, 'changed');
}

function InsertOnClickFunctions(pageModel, onClickFunctions) {
  if (!onClickFunctions) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', onClickFunctions, 'click');
}

function InsertCustomCallbackFunctions(pageModel, cbFunctions) {
  if (!cbFunctions) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', cbFunctions, 'customCallback');
}

function InsertInputMasks(pageModel, customMasks) {
  if (!customMasks) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', customMasks, 'mask');
}

function InsertNumericOptions(pageModel, numericOptions) {
  if (!numericOptions) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', numericOptions, 'options');
}

function InsertCustomExpressionProperties(pageModel, expressionProperties) {
  if (!expressionProperties) {
    return;
  }
  __setFDProperties(pageModel, 'expressionProperties', expressionProperties);
}

function InsertHideExpressions(pageModel, hideExpressions) {
  if (!hideExpressions) {
    return;
  }
  __setFDProperties(pageModel, 'hideExpression', hideExpressions);
}

function InsertFormatters(pageModel, formatters) {
  if (!formatters) {
    return;
  }
  __insertFDArrayProperties(pageModel, 'formatters', formatters);
}

function InsertParsers(pageModel, parsers) {
  if (!parsers) {
    return;
  }
  __insertFDArrayProperties(pageModel, 'parsers', parsers);
}

function InsertSyncValidators(pageModel, validators) {
  if (!validators) {
    return;
  }
  __insertFDObjProperties(pageModel, 'validators', validators);
}

function InsertAsyncValidators(pageModel, asyncValidators) {
  if (!asyncValidators) {
    return;
  }
  __insertFDObjProperties(pageModel, 'asyncValidators', asyncValidators);
}

function InsertDynamicQueryParameters(pageModel, dynamicQP) {
  if (!dynamicQP) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', dynamicQP, 'QueryParameters');
}

function InsertEventHandlers(pageModel, eventHandlers) {
  if (!eventHandlers) {
    return;
  }
  __setFDProperties(pageModel, 'templateOptions', eventHandlers, 'eventHandlers');
}

function InsertOptions(pageModel, options) {
  if (!options) {
    return;
  }
  __insertFDObjProperties(pageModel, 'templateOptions', options);
}

function __insertFDStringProperties(pageModel, propertyName, properties) {
  angular.forEach(properties, function(value, key) {
    if (!!pageModel.Fields[key]) {
      if (!pageModel.Fields[key].FormlyFieldDescriptor[propertyName]) {
        pageModel.Fields[key].FormlyFieldDescriptor[propertyName] = value;
      } else {
        pageModel.Fields[key].FormlyFieldDescriptor[propertyName] += ' ' + value;
      }
    }
  });
}

function __setFDProperties(pageModel, propertyName, properties, innerPropName) {
  angular.forEach(properties, function(value, key) {
    if (!!pageModel.Fields[key]) {
      if (!!innerPropName) {
        if (!!pageModel.Fields[key].FormlyFieldDescriptor[propertyName]) {
          pageModel.Fields[key].FormlyFieldDescriptor[propertyName][innerPropName] = value;
        }
      } else {
        pageModel.Fields[key].FormlyFieldDescriptor[propertyName] = value;
      }
    }
  });
}

function __insertFDArrayProperties(pageModel, propertyName, properties) {
  angular.forEach(properties, function(value, key) {
    if (!!pageModel.Fields[key]) {
      if (!pageModel.Fields[key].FormlyFieldDescriptor[propertyName]) {
        var o = {};
        o[propertyName] = value;
        angular.extend(pageModel.Fields[key].FormlyFieldDescriptor, o);
      } else {
        pageModel.Fields[key].FormlyFieldDescriptor[propertyName].push(value);
      }
    }
  });
}

function __insertFDObjProperties(pageModel, propertyName, properties) {
  angular.forEach(properties, function(value, key) {
    if (!!pageModel.Fields[key]) {
      if (!pageModel.Fields[key].FormlyFieldDescriptor[propertyName]) {
        var o = {};
        o[propertyName] = value;
        angular.extend(pageModel.Fields[key].FormlyFieldDescriptor, o);
      } else {
        angular.extend(pageModel.Fields[key].FormlyFieldDescriptor[propertyName], value);
      }
    }
  });
}

/**
 *
 * @param {} panelDescriptors
 * @param {} tabDescriptors
 * @param {} formlyPanelDescriptors
 * @returns {}
 */
function ExtractFormlyPanelsInTabs(panelDescriptors, tabDescriptors, formlyPanelDescriptors) {
  var formlyPanelsInTabs = {};
  angular.forEach(panelDescriptors, function(value, key) {
    // if panel has a container tab set, add it also has a formly descriptor
    // add it to the tab
    if (!!value.ContainerTabId && formlyPanelDescriptors.hasOwnProperty(key)) {
      if (!!formlyPanelsInTabs[value.ContainerTabId]) {
        formlyPanelsInTabs[value.ContainerTabId].push(formlyPanelDescriptors[key]);
      } else {
        formlyPanelsInTabs[value.ContainerTabId] = [formlyPanelDescriptors[key]];
      }
    }
  });

  var tabsWithFormlyPanels = [];
  angular.forEach(formlyPanelsInTabs, function(value, key) {
    var formlyPanelDescriptorsConcat = [];
    angular.forEach(value, function(value) {
      formlyPanelDescriptorsConcat.push(value.FormlyDescriptor[0]);
    });

    tabsWithFormlyPanels.push({
      title: tabDescriptors[key].Title,
      active: true,
      fields: formlyPanelDescriptorsConcat,
    });
  });

  return tabsWithFormlyPanels;
}

function setFieldPosition(pagemodel, formlyDescriptor, fieldName, fieldGroup, number) {
  let panel = pagemodel.Fields[fieldName]?.ContainerPanelId,
    formlyRow = panel ? formlyDescriptor[panel]?.FormlyDescriptor[0].fieldGroup : null;
  if (!formlyRow) return;
  formlyRow.forEach(groupValue => {
    if (groupValue.fieldGroup) groupValue.fieldGroup = groupValue.fieldGroup.filter(x => x.key !== fieldName);
  });
  formlyRow[(fieldGroup - 1) * 2].fieldGroup.splice(number - 1, 0, pagemodel.Fields[fieldName].FormlyFieldDescriptor);
}

function processFieldDescriptor(fieldDescriptor, controllerUrlPrefix) {
  if (!fieldDescriptor) return fieldDescriptor;
  if (!fieldDescriptor?.FormlyFieldDescripto?.validators) {
    var o = {};
    o['validators'] = {};
    angular.extend(fieldDescriptor.FormlyFieldDescriptor, o);
  }

  // if type = "maskedInput" is defined in FormlyDescriptor, ignore maxlength attribute
  if (
    fieldDescriptor.FormlyFieldDescriptor.type !== 'maskedInput' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'f2Input' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'f22Input' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'pathSelector' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'digitSign' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoNTB' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'radio' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'radioGroup' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'checkbox' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoDDL' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoCB' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoFU' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoLB' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoMS' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'kendoAC' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'button' &&
    fieldDescriptor.FormlyFieldDescriptor.type !== 'rating'
  ) {
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.maxlength = fieldDescriptor.MaxLength;
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.showCounter = fieldDescriptor.ShowCounter;
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoNTB') {
    if (fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat) {
      if (
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals ||
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals === 0
      ) {
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.decimals =
          fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals;
      }
      if (fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.format) {
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.format =
          fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.format;
      }

      fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.min =
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.min;
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.max =
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.max;
    }
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'checkbox') {
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.required = undefined;
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'f2Input') {
    //TODO: ezt kitakarítani
    var controllerMethod = fieldDescriptor.ControllerMethod;
    if (controllerMethod.indexOf('/') === -1) {
      controllerMethod = 'F2/' + controllerMethod;
    }
    setF2Options(fieldDescriptor.FormlyFieldDescriptor, controllerMethod);
    if (fieldDescriptor.FormlyFieldDescriptor.templateOptions.hideInput) {
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.label = null;
    }
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options['DynamicOptions'] =
      fieldDescriptor.FormlyFieldDescriptor.DynamicOptions;
    if (!!fieldDescriptor.MaxLength) {
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.f2maxlength = fieldDescriptor.MaxLength;
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        maxlength: FVF_InvalidF2MaxLength,
      });
    }
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'f22Input') {
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.f2maxlength = fieldDescriptor.MaxLength;
    F22Helpers.setF22Options(fieldDescriptor.FormlyFieldDescriptor, controllerMethod);
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options['DynamicOptions'] =
      fieldDescriptor.FormlyFieldDescriptor.DynamicOptions;
    if (!!fieldDescriptor.MaxLength) {
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        maxlength: FVF_InvalidF2MaxLength,
      });
    }
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'pathSelector') {
    var pathSelectorOptions = {
      title: fieldDescriptor.FormlyFieldDescriptor.templateOptions.label,
      mask: fieldDescriptor.FormlyFieldDescriptor.templateOptions.mask,
      treeOptions: {
        url: fieldDescriptor.ControllerMethod,
      },
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
    };
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = pathSelectorOptions;

    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options['DynamicOptions'] =
      fieldDescriptor.FormlyFieldDescriptor.DynamicOptions;
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'digitSign') {
    var digitSignOptions = {
      title: fieldDescriptor.FormlyFieldDescriptor.templateOptions.label,
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
    };
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = digitSignOptions;

    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options['DynamicOptions'] =
      fieldDescriptor.FormlyFieldDescriptor.DynamicOptions;
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'f4Input') {
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.f2maxlength = fieldDescriptor.MaxLength;
    F4Helpers.setF4Options(fieldDescriptor.FormlyFieldDescriptor, controllerMethod);
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options['DynamicOptions'] =
      fieldDescriptor.FormlyFieldDescriptor.DynamicOptions;
    if (!!fieldDescriptor.MaxLength) {
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        maxlength: FVF_InvalidF2MaxLength,
      });
    }
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'textCombo') {
    var DDLOptionArg = {
      url: fieldDescriptor.ControllerMethod,
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
      data: fieldDescriptor.Data,
      valueField: 'text',
      textField: 'text',
    };

    if (!!fieldDescriptor.transData) {
      DDLOptionArg.transData = fieldDescriptor.transData;
    }
    DDLOptionArg.autoBind = !!fieldDescriptor.FormlyFieldDescriptor.templateOptions.autoBind;
    DDLOptionArg.selectFirst = fieldDescriptor.FormlyFieldDescriptor.templateOptions.selectFirst ?? true;
    if (!!fieldDescriptor.FormlyFieldDescriptor.templateOptions.required) {
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        required: FVF_RequiredDropdown,
      });
      DDLOptionArg.autoBind = DDLOptionArg.selectFirst;
    }
    DDLOptionArg.dataBound = fieldDescriptor.FormlyFieldDescriptor.templateOptions.dataBound;
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateDDLOption(
      DDLOptionArg,
      fieldDescriptor.FormlyFieldDescriptor.type
    );
  }

  if (
    fieldDescriptor.FormlyFieldDescriptor.type === 'kendoDDL' ||
    fieldDescriptor.FormlyFieldDescriptor.type === 'kendoLB'
  ) {
    var DDLOptionArg = {
      url: fieldDescriptor.ControllerMethod,
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
      valueField: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.valueField || 'key',
      textField: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.textField || 'text',
      //workflowból
      schema: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.schema,
      data: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.data,
    };

    if (!!fieldDescriptor.transData) {
      DDLOptionArg.transData = fieldDescriptor.transData;
    }
    DDLOptionArg.autoBind = !!fieldDescriptor.FormlyFieldDescriptor.templateOptions.autoBind;
    DDLOptionArg.selectFirst = fieldDescriptor.FormlyFieldDescriptor.templateOptions.selectFirst ?? true;
    if (!!fieldDescriptor.FormlyFieldDescriptor.templateOptions.required) {
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        required: FVF_RequiredDropdown,
      });
      DDLOptionArg.autoBind = DDLOptionArg.selectFirst;
    }
    DDLOptionArg.dataBound = fieldDescriptor.FormlyFieldDescriptor.templateOptions.dataBound;
    DDLOptionArg.schemaDataFunc = fieldDescriptor.FormlyFieldDescriptor.templateOptions.schemaDataFunc;
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateDDLOption(
      DDLOptionArg,
      fieldDescriptor.FormlyFieldDescriptor.type
    );
  }
  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoMS') {
    var DDLOptionArg = {
      url: fieldDescriptor.ControllerMethod,
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
      valueField: 'key',
      textField: 'text',
      placeHolder: fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.placeHolder,
      fieldDescriptor: fieldDescriptor,
      autoClose: false,
      maxSelectedItems: fieldDescriptor.FormlyFieldDescriptor.templateOptions.maxSelectedItems ?? 9999999,
      singleTagType: fieldDescriptor.FormlyFieldDescriptor.templateOptions.singleTagType ?? true,
      singleTagNumber: fieldDescriptor.FormlyFieldDescriptor.templateOptions.singleTagNumber ?? 3,
      DOMId: fieldDescriptor.FormlyFieldDescriptor.templateOptions.DOMId,
      dataBound: function(e) {
        let scope = e.sender?.$angular_scope;
        if (!scope.to.selectedItems) {
          if (!!scope.to.originalModel) {
            let dataRows = [];
            let selectedItems =
              scope.to.itemType === 'Array' ? scope.to.originalModel : scope.to.originalModel.split(',');
            angular.forEach(e.sender.dataSource.data(), element => (dataRows[element.key] = element.text));
            selectedItems.sort((x, y) => localizeCompare(dataRows[x], dataRows[y]));
            scope.to.selectedItems = selectedItems;
          } else {
            scope.to.selectedItems = [];
          }
        }
      },
      change: function(e) {
        let scope = e.sender?.$angular_scope,
          formElement = scope?.form[scope.options.id];

        if (angular.isFunction(scope?.to.changed)) {
          scope.to.changed(scope.to.selectedItems);
        }
        if (e.sender.value().includes('__ALL__')) {
          var data = e.sender.dataSource.data();
          var result = [];
          for (var item in data) {
            if (typeof data[item].key !== 'undefined' && data[item].key !== '__ALL__') {
              result.push(data[item].key);
            }
          }
          e.sender.value(result);
          scope.to.selectedItems = result;
        }
      },
    };
    if (!!fieldDescriptor.transData) {
      DDLOptionArg.transData = fieldDescriptor.transData;
    }

    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateMSOption(DDLOptionArg);
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoAC') {
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateACOption(
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.DynamicOptions
    );
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoCB') {
    var DDLOptionArg = {
      url: fieldDescriptor.ControllerMethod,
      valueField: 'key',
      textField: 'text',
    };
    if (!!fieldDescriptor.transData) {
      DDLOptionArg.transData = fieldDescriptor.transData;
    }
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateDDLOption(
      DDLOptionArg,
      fieldDescriptor.FormlyFieldDescriptor.type
    );
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoCBMC') {
    var DDLOptionArg = {
      url: fieldDescriptor.ControllerMethod,
      valueField: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.valueField,
      textField: fieldDescriptor.FormlyFieldDescriptor.templateOptions.ComboOptions.textField,
      columns: fieldDescriptor.FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns,
      filterFields: fieldDescriptor.FormlyFieldDescriptor.templateOptions.DynamicOptions.FilterFields,
      otherParams: fieldDescriptor.FormlyFieldDescriptor.templateOptions.QueryParameters,
      autoBind: fieldDescriptor.FormlyFieldDescriptor.templateOptions.autoBind,
    };
    if (!!fieldDescriptor.transData) {
      DDLOptionArg.transData = fieldDescriptor.transData;
    }
    DDLOptionArg.dataBound = fieldDescriptor.FormlyFieldDescriptor.templateOptions.dataBound;
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateDDMCLOption(DDLOptionArg);
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoDP') {
    // in case of kendoDP, add general moment.js dateValidator function
    angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
      wrongdate: FVF_InvalidDate,
    });

    if (!!fieldDescriptor.FormlyFieldDescriptor.templateOptions.required) {
      angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
        required: FVF_RequiredDate,
      });
    }
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoTP') {
    // in case of kendoDP, add general moment.js dateValidator function
    angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
      wrongtime: FVF_InvalidTime,
    });

    //if (!!fieldDescriptor.FormlyFieldDescriptor.templateOptions.required) {
    //    angular.extend(fieldDescriptor.FormlyFieldDescriptor["validators"], {
    //        "required": FVF_RequiredDate
    //    });
    //}
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoDTP') {
    // in case of kendoDP, add general moment.js dateValidator function
    angular.extend(fieldDescriptor.FormlyFieldDescriptor['validators'], {
      wrongdatetime: FVF_InvalidDateTime,
    });

    //if (!!fieldDescriptor.FormlyFieldDescriptor.templateOptions.required) {
    //    angular.extend(fieldDescriptor.FormlyFieldDescriptor["validators"], {
    //        "required": FVF_RequiredDate
    //    });
    //}
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoFU') {
    var FUOptionsArg = {
      dynamicOptions: fieldDescriptor.FormlyFieldDescriptor.templateOptions.DynamicOptions,
    };

    fieldDescriptor.FormlyFieldDescriptor.templateOptions.options = FormlyCreateFileUpload(
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.options,
      FUOptionsArg
    );
    fieldDescriptor.FormlyFieldDescriptor.templateOptions.DynamicOptions = undefined;
  }

  if (fieldDescriptor.FormlyFieldDescriptor.type === 'kendoRating') {
    if (fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat) {
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.min =
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.min;
      fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.max =
        fieldDescriptor.FormlyFieldDescriptor.templateOptions.options.fieldFormat.max;
    }
  }

  return fieldDescriptor;
}

/**
 * Generate FormlyForm descriptors from PageModel
 * @param {} pageModel
 * @returns {}
 */
function GenerateFormlyFormPanelsFromPageModel(pageModel, formlyPanels = {}) {
  var fieldDescriptors = pageModel.Fields;
  var panelDescriptors = pageModel.Panels;
  // Extract fields to panels
  // if ContainerPanelId is empty, the field is not being added to the form!
  var panels = {};

  angular.forEach(fieldDescriptors, function(value) {
    if (!!value.ContainerPanelId) {
      if (!!panels[value.ContainerPanelId]) {
        panels[value.ContainerPanelId].push(processFieldDescriptor(value));
      } else {
        panels[value.ContainerPanelId] = [processFieldDescriptor(value)];
      }
    }
  });

  // Extract fields within panels to groups
  angular.forEach(panels, function(value, key) {
    var fieldGroups = {};
    angular.forEach(value, function(fValue) {
      if (!!fieldGroups[fValue.FieldGroup]) {
        fieldGroups[fValue.FieldGroup].push(fValue);
      } else {
        fieldGroups[fValue.FieldGroup] = [fValue];
      }
    });
    // Go through each fieldGroup, ordering their fields by FieldOrder property
    angular.forEach(fieldGroups, function(value) {
      value.sort(function(a, b) {
        return a.FieldOrder - b.FieldOrder;
      });
      // Strip everything from field except from FormlyFieldDescriptor
      for (var i = 0; i < value.length; i++) {
        value[i] = value[i].FormlyFieldDescriptor;
      }
    });
    // Create Formly field groups from virtual field groups
    var formlyFieldGroupsForPanel = [];
    angular.forEach(fieldGroups, function(value) {
      formlyFieldGroupsForPanel.push(
        {
          className: 'row',
          fieldGroup: value,
        },
        {
          className: 'col-md-12',
          template: '',
        }
      );
    });

    // Create a structure holding Formly panel descriptors from virtual panels
    // + container information
    if (!panelDescriptors[key]) {
      console.error('Missing paneldescriptor for key: ' + key);
    }

    formlyPanels[key] = {
      FormlyDescriptor: [
        {
          className: 'col-md-' + panelDescriptors[key].ColNumber,
          fieldGroup: formlyFieldGroupsForPanel,
        },
      ],
    };
  });

  return formlyPanels;
}

function initModel($http, $state, $stateParams, vm, model, $window) {
  vm.pageModel = model.pageModel;
  vm.messages = model.pageModel.Messages;
  vm.labels = model.pageModel.Labels;
  vm.actions = model.pageModel.Actions;

  var as = actionSetter;
  if ($stateParams.backState !== undefined) {
    vm.back = as.getBackAction($state, $stateParams.backState, vm, $stateParams.backStateParams);
  }
}

function initViewModel($http, $state, $stateParams, vm, model, $window) {
  vm.formMode = $stateParams.formMode;
  var as = actionSetter;

  if ($stateParams.createState !== undefined) {
    vm.createItem = as.getCreateAction($state, $stateParams.createState);
  }
  if ($stateParams.editState !== undefined) {
    vm.editItem = as.getEditActionFromGrid($state, vm, $stateParams.editState);
  }
  if ($stateParams.duplicateState !== undefined) {
    vm.duplicateItem = as.getDuplicateActionFromGrid($state, vm, $stateParams.duplicateState);
  }
  if ($stateParams.viewState !== undefined) {
    vm.viewItem = as.getViewActionFromGrid($state, vm, $stateParams.viewState);
  }
  if ($stateParams.deleteState !== undefined) {
    vm.deleteItem = as.getDeleteActionFromGrid($http, vm, $stateParams.deleteState);
  }
  if ($stateParams.subState !== undefined) {
    vm.createSubItem = as.getCreateSubAction($state, vm, $stateParams.subState, $stateParams.mainGridIdName);
  }
  if ($stateParams.subState !== undefined) {
    vm.editSubItem = as.getEditSubActionFromGrid($state, vm, $stateParams.subState, $stateParams.mainGridIdName);
  }
  if ($stateParams.subState !== undefined) {
    vm.duplicateSubItem = as.getDuplicateSubActionFromGrid(
      $state,
      vm,
      $stateParams.subState,
      $stateParams.mainGridIdName
    );
  }
  if ($stateParams.subDeleteState !== undefined) {
    vm.deleteSubItem = as.getDeleteSubActionFromGrid(
      $http,
      vm,
      $stateParams.subDeleteState,
      $stateParams.mainGridIdName
    );
  }
  if ($stateParams.documentEntity !== undefined) {
    vm.document = as.getDocumentActionFromGrid($state, vm, $stateParams.documentEntity);
  }

  if ($stateParams.postUrl !== undefined) {
    var backStateAfterSave = $stateParams.backStateAfterSave;
    if (backStateAfterSave === undefined) {
      backStateAfterSave = $stateParams.backState;
    }
    vm.save = as.getSaveAction(
      $http,
      $state,
      vm,
      $stateParams.postUrl,
      backStateAfterSave,
      $stateParams.backStateAfterSaveParams,
      vm.formMode === 'Create'
    );
  }
}

function initFormModel($http, $state, $stateParams, vm, model, $window) {
  vm.dataModel = model.dto;

  vm.behavior = {
    hideExpressions: {},
    onChangeFunctions: {},
    onBlurFunctions: {},
    syncValidators: {},
    asyncValidators: {},
    formatters: {},
    parsers: {},
    customClasses: {},
    customTypes: {},
    inputMasks: {},
    customExpressionProperties: {},
    dynamicQueryParameters: {},
  };

  vm.formMode = $stateParams.formMode;
  var as = actionSetter;

  if ($stateParams.createState !== undefined) {
    vm.create = as.getCreateAction($state, $stateParams.createState);
  }
  if ($stateParams.editState !== undefined) {
    vm.edit = as.getEditActionFromGrid($state, vm, $stateParams.editState);
  }
  if ($stateParams.duplicateState !== undefined) {
    vm.duplicate = as.getDuplicateActionFromGrid($state, vm, $stateParams.duplicateState);
  }
  if ($stateParams.viewState !== undefined) {
    vm.view = as.getViewActionFromGrid($state, vm, $stateParams.viewState);
  }
  if ($stateParams.deleteState !== undefined) {
    vm.delete = as.getDeleteActionFromGrid($http, vm, $stateParams.deleteState);
  }
  if ($stateParams.documentEntity !== undefined) {
    vm.document = as.getDocumentActionFromGrid($state, vm, $stateParams.documentEntity);
  }

  if ($stateParams.postUrl !== undefined) {
    var backStateAfterSave = $stateParams.backStateAfterSave;
    if (backStateAfterSave === undefined) {
      backStateAfterSave = $stateParams.backState;
    }
    vm.save = as.getSaveAction(
      $http,
      $state,
      vm,
      $stateParams.postUrl,
      backStateAfterSave,
      $stateParams.backStateAfterSaveParams,
      vm.formMode === 'Create'
    );
  }
}

function initMainGrid(vm, gridName, readUrl, selectFunction, transportData, detailInit, whereCondition, custGridVars) {
  // Get Id column of Grid to perform data manipulation on selected item(s)
  if (custGridVars == null) custGridVars = false;
  var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
  vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

  if (vm.pageModel.Grids[gridName].Table) {
    readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
    if (!transportData) {
      transportData = {};
    }
    angular.extend(transportData, {
      tableName: vm.pageModel.Grids[gridName].Table,
      whereCondition: whereCondition,
      adopter: vm.pageModel.Grids[gridName].Adopter,
      installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
      columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
      idColumn: vm.pageModel.Grids[gridName].IdColumn,
    });
  }

  var mainGrid = custGridVars ? gridName : 'mainGrid';
  vm[mainGrid] = $('#mainGrid').data('kendoGrid');

  // Kendo-grid reference for main GRID
  var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
  vm[mainGridOptions] = getGridOptions(
    vm.pageModel.Grids[gridName],
    readUrl,
    selectFunction,
    transportData,
    detailInit
  );
}

function getSelectedRowId(grid, idFieldName) {
  var selectedItems = GetSelectedGridItems(grid);
  if (selectedItems.length === 0) return -1;

  return selectedItems[0][idFieldName];
}

function getSelectedRowIdFromMainGrid(vm) {
  if (typeof vm === 'undefined') return null;
  if (typeof vm.mainGrid === 'undefined') return null;
  if (typeof vm.mainGridIdField === 'undefined') return null;

  return getSelectedRowId(vm.mainGrid, vm.mainGridIdField);
}

function getSelectedRowFromMainGrid(vm) {
  if (typeof vm === 'undefined') return null;
  if (typeof vm.mainGrid === 'undefined') return null;
  if (typeof vm.mainGridIdField === 'undefined') return null;

  var selectedItems = GetSelectedGridItems(vm.mainGrid);
  if (selectedItems.length === 0) return;
  return selectedItems[0];
}

function getSelectedRowIdFromSubGrid(vm, gridName, gridIdName) {
  var gridRef = vm.subGrids[gridName];
  if (typeof gridRef === 'undefined' || gridRef === null) {
    // flgr
    gridRef = $('#subGrid' + gridName).data('kendoGrid');
  }
  var selectedItems = GetSelectedGridItems(gridRef);
  if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
    return selectedItems[0][gridIdName];
  }
  return -1;
}

function changeGridFilter(vm, $scope, targetGrid, gridIdField, subGrid) {
  var selectedItems = GetSelectedGridItems(targetGrid);
  if (selectedItems.length === 0) {
    vm.selectedMainGridItemId = 0;
    $scope.$applyAsync();
    return;
  }
  vm.selectedMainGridItemId = selectedItems[0][gridIdField];
  vm.disabled = vm.selectedMainGridItemId !== undefined ? false : true;
  $scope.$applyAsync();
  if (!!subGrid) {
    subGrid.dataSource.read();
  }
}

function changeSubGridDisable(vm, targetGrid, $scope, detailGrid) {
  var selectedItems = GetSelectedGridItems(targetGrid);
  if (selectedItems.length === 0) {
    $scope.$applyAsync();
    return;
  } else {
    vm.subDisabled = false;
    if (!!detailGrid) {
      detailGrid.dataSource.read();
    }
    $scope.$applyAsync();
    return;
  }
}

function initSubGrids(vm, gridUrlController, transportData, filteredTabNames) {
  vm.activeSubItemTab = 0;

  const gridServiceInstance = angular
    .element('html')
    .injector()
    .get('gridService');

  var generatedGridTabs = gridServiceInstance.CreateGridContainerTabsWithGrids(
    vm.pageModel.Tabs,
    vm.pageModel.Panels,
    vm.pageModel.Grids,
    filteredTabNames,
    function(gridModel) {
      gridModel.ControllerMethod = `${gridUrlController}/${gridModel.ControllerMethod}`;
      return {
        gridModel,
        transportData,
      };
    }
  );
  vm.subItemTabs = generatedGridTabs.tabs;
  vm.subGridOptions = generatedGridTabs.gridOptions;
  vm.subGrids = generatedGridTabs.grids;
}

var fieldSetter = {
  vm: {},
  setMask: function(fieldName, mask) {
    setCustomType(this.vm, fieldName, 'maskedInput');
    setInputMask(this.vm, fieldName, mask);
  },
  setF2Mask: function(fieldName, mask) {
    setInputMask(this.vm, fieldName, mask);
  },
  setAsSeparatorDash: function(fieldName) {
    setCustomType(this.vm, fieldName, 'separatorDash');
    this.setDisabled(fieldName, 'true');
  },
  setFocus: function(fieldName, isFocused) {
    setCustomExpressionProperty(this.vm, fieldName, {
      'templateOptions.options.focus': isFocused,
    });
  },
  setReadOnly: function(fieldName, isReadonly) {
    setCustomExpressionProperty(this.vm, fieldName, {
      'templateOptions.readonly': isReadonly,
    });
  },
  setRequired: function(fieldName, isRequired) {
    setCustomExpressionProperty(this.vm, fieldName, {
      'templateOptions.required': isRequired,
    });
  },

  setDisabled: function(fieldName, isDisabled) {
    setCustomExpressionProperty(this.vm, fieldName, {
      'templateOptions.disabled': isDisabled,
    });
  },
  setLabel: function(fieldName, label) {
    setCustomExpressionProperty(this.vm, fieldName, {
      'templateOptions.label': function() {
        return label;
      },
    });
  },
  hideLabel: function(fieldName) {
    this.setLabel(fieldName, '\u00A0');
  },
  hideField: function(fieldName, isHidden) {
    // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
    this.vm.behavior.hideExpressions[fieldName] = isHidden;
  },
  setOnChangeFunction: function(fieldName, onChangeFunction) {
    // Usage: "fieldName": onChangeFunction(selectedItem)
    this.vm.behavior.onChangeFunctions[fieldName] = onChangeFunction;
  },

  setOnBlurFunction: function(fieldName, onBlurFunction) {
    // Usage: "fieldName": onBlurFunction(selectedItem)
    this.vm.behavior.onBlurFunctions[fieldName] = onBlurFunction;
  },

  setSyncValidator: function(fieldName, validatorName, validator) {
    // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
    if (!this.vm.behavior.syncValidators.hasOwnProperty(fieldName)) {
      this.vm.behavior.syncValidators[fieldName] = {};
    }
    this.vm.behavior.syncValidators[fieldName][validatorName] = validator;
  },

  setAsyncValidator: function(fieldName, validatorName, validator) {
    // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
    if (!this.vm.behavior.asyncValidators.hasOwnProperty(fieldName)) {
      this.vm.behavior.asyncValidators[fieldName] = {};
    }
    this.vm.behavior.asyncValidators[fieldName][validatorName] = validator;
  },

  setFormatters: function(fieldName, formatters) {
    // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
    this.vm.behavior.formatters[fieldName] = formatters;
  },

  setParsers: function(fieldName, parsers) {
    // Usage: "fieldName": [parserFunction1,parserFunctionN]
    this.vm.behavior.parsers[fieldName] = parsers;
  },
  setCustomClass: function(fieldName, className) {
    // Usage: "fieldName": "className"
    this.vm.behavior.customClasses[fieldName] = className;
  },
  setDynamicQueryParameters: function(fieldName, dynamicQueryParameters) {
    // Usage: "fieldName": "dynamicQueryParameters"
    this.vm.behavior.dynamicQueryParameters[fieldName] = dynamicQueryParameters;
  },
};

function setCustomType(vm, fieldName, typeName) {
  // Usage: "fieldName": "typeName"
  vm.behavior.customTypes[fieldName] = typeName;
}

function setInputMask(vm, fieldName, mask) {
  // Usage: "fieldName": "inputMask"
  vm.behavior.inputMasks[fieldName] = mask;
}

function setCustomExpressionProperty(vm, fieldName, expressionProperty) {
  if (!!vm.behavior.customExpressionProperties[fieldName]) {
    angular.extend(vm.behavior.customExpressionProperties[fieldName], expressionProperty);
  } else {
    vm.behavior.customExpressionProperties[fieldName] = expressionProperty;
  }
}

function setBehavior(vm) {
  ////////////////////////////////////////////////////////////////////////////////////////
  //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
  // These must be ran before generating formly descriptors from general field descriptors
  InsertCustomClasses(vm.pageModel, vm.behavior.customClasses);
  InsertSyncValidators(vm.pageModel, vm.behavior.syncValidators);
  InsertFormatters(vm.pageModel, vm.behavior.formatters);
  InsertParsers(vm.pageModel, vm.behavior.parsers);
  InsertInputMasks(vm.pageModel, vm.behavior.inputMasks);
  InsertCustomTypes(vm.pageModel, vm.behavior.customTypes);
  InsertCustomExpressionProperties(vm.pageModel, vm.behavior.customExpressionProperties);
  InsertHideExpressions(vm.pageModel, vm.behavior.hideExpressions);
  InsertOnChangeFunctions(vm.pageModel, vm.behavior.onChangeFunctions);
  InsertOnBlurFunctions(vm.pageModel, vm.behavior.onBlurFunctions);
  InsertDynamicQueryParameters(vm.pageModel, vm.behavior.dynamicQueryParameters);
}

function generateForm(vm) {
  setBehavior(vm);

  ////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
  // Generate Formly form descriptors from pageModel
  vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
  // Extract fomrly panels to tabs
  //TODO: ez nem kell mindig
  vm.MainItemTabs = ExtractFormlyPanelsInTabs(vm.pageModel.Panels, vm.pageModel.Tabs, vm.FormlyFormPanelDescriptors);
}

var actionSetter = {
  getBackAction: function($state, backState, vm, backStateParams) {
    if (typeof vm !== 'undefined' && typeof backStateParams !== 'undefined') {
      // FLGR impl
      return function() {
        if (backStateParams !== undefined) {
          var params = {};
          for (var i = 0; i < backStateParams.length; i++) {
            var p = backStateParams[i];
            params[p.name] = vm.dataModel[p.modelName];
          }
          $state.go(backState, params);
        } else {
          $state.go(backState);
        }
      };
    } else {
      // Frame impl
      return function() {
        $state.go(backState);
      };
    }
  },
  getSaveAction: function($http, $state, vm, saveUrl, backState, backStateParams, backStateParamsFromResponse) {
    return function() {
      $http
        .post(saveUrl, vm.dataModel)
        .then(function(response) {
          toastr.success(vm.pageModel.Messages.SaveSuccessful);
          var params = {};
          for (var i = 0; i < backStateParams.length; i++) {
            var p = backStateParams[i];
            if (backStateParamsFromResponse) {
              params[p.name] = response.data[p.modelName];
            } else {
              params[p.name] = vm.dataModel[p.modelName];
            }
          }
          $state.go(backState, params);
        })
        .catch(function(response) {
          toastr.error(vm.pageModel.Messages.SaveFailed);
        });
    };
  },
  getCreateAction: function($state, createState) {
    return function() {
      $state.go(createState, { id: 0 });
    };
  },
  getEditActionFromGrid: function($state, vm, editState) {
    return function() {
      var id = getSelectedRowIdFromMainGrid(vm);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        $state.go(editState, { id: id });
      }
    };
  },
  getDuplicateActionFromGrid: function($state, vm, duplicateState) {
    return function() {
      var id = getSelectedRowIdFromMainGrid(vm);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        $state.go(duplicateState, { id: id });
      }
    };
  },
  getViewActionFromGrid: function($state, vm, viewState) {
    return function() {
      var id = getSelectedRowIdFromMainGrid(vm);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        $state.go(viewState, { id: id });
      }
    };
  },
  getDeleteActionFromGrid: function($http, vm, deleteState) {
    return function() {
      var id = getSelectedRowIdFromMainGrid(vm);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get(deleteState + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  //var gridRef = vm.grids[gridName];
                  //gridRef.dataSource.read();
                  vm.mainGrid.dataSource.read();
                });
              },
            },
          },
        });
      }
    };
  },
  getCreateSubAction: function($state, vm, subState, mainGridIdName) {
    return function(forceCreate) {
      forceCreate = typeof forceCreate !== 'undefined' ? forceCreate : false;
      var id = 0;
      var name = mainGridIdName;
      var mainGridItemId = vm.dataModel[name];

      var mainGridItemId = getSelectedRowIdFromMainGrid(vm);

      if (mainGridItemId === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        var call_frame_code = true;
        if (mainGridItemId === null) {
          // flgr
          mainGridItemId = vm.dataModel[name];
          call_frame_code = false;
        }

        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var obj = { id: id };

        if (forceCreate) {
          // Partner modul osztott jogosultság kezelése
          obj[mainGridIdName] = mainGridItemId;
          $state.go(subState + gridName + 'Create', obj);
        } else if (call_frame_code) {
          obj[vm.mainGridIdField] = mainGridItemId;
          $state.go(subState + gridName + 'Create', obj);
        } else {
          // flgr
          obj[mainGridIdName] = mainGridItemId;
          $state.go(subState + gridName + 'Edit', obj);
        }
      }
    };
  },
  getEditSubActionFromGrid: function($state, vm, subState, mainGridIdName) {
    return function() {
      var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
      var gridIdName = vm.pageModel.Grids[gridName].IdColumn;

      var mainGridItemId = getSelectedRowIdFromMainGrid(vm);
      var call_frame_code = true;
      if (mainGridItemId === null) {
        // flgr
        mainGridItemId = vm.dataModel[mainGridIdName];
        call_frame_code = false;
      }

      var id = getSelectedRowIdFromSubGrid(vm, gridName, gridIdName);

      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        var obj = { id: id };

        if (call_frame_code) {
          obj[vm.mainGridIdField] = mainGridItemId;
          $state.go(subState + gridName + 'Edit', obj);
        } else {
          //flgr
          obj[mainGridIdName] = mainGridItemId;
          $state.go(subState + gridName + 'Edit', obj);
        }
      }
    };
  },
  getDuplicateSubActionFromGrid: function($state, vm, subState, mainGridIdName) {
    return function() {
      var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
      var gridIdName = vm.pageModel.Grids[gridName].IdColumn;

      var mainGridItemId = getSelectedRowIdFromMainGrid(vm);
      var call_frame_code = true;
      if (mainGridItemId === null) {
        // flgr
        mainGridItemId = vm.dataModel[mainGridIdName];
        call_frame_code = false;
      }

      var id = getSelectedRowIdFromSubGrid(vm, gridName, gridIdName);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        var obj = { id: id };

        if (call_frame_code) {
          obj[vm.mainGridIdField] = mainGridItemId;
          $state.go(subState + gridName + 'Duplicate', obj);
        } else {
          //flgr
          obj[mainGridIdName] = mainGridItemId;
          $state.go(subState + gridName + 'Duplicate', obj);
        }
      }
    };
  },
  getDeleteSubActionFromGrid: function($http, vm, subDeleteState, mainGridIdName) {
    return function() {
      var deferred = $.Deferred();
      var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
      var gridIdName = vm.pageModel.Grids[gridName].IdColumn;
      var id = getSelectedRowIdFromSubGrid(vm, gridName, gridIdName);

      var delete_url = '';
      var kendoGrid = null;
      var call_frame_code = typeof vm.mainGrid !== 'undefined' && typeof vm.mainGridIdField !== 'undefined';
      if (call_frame_code) {
        delete_url = subDeleteState + id;
        kendoGrid = vm.subGrids[gridName];
      } else {
        delete_url = subDeleteState + gridName + 'Delete/' + id;
        kendoGrid = $('#subGrid' + gridName).data('kendoGrid');
      }

      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {
                deferred.reject();
              },
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http
                  .get(delete_url)
                  .then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    kendoGrid.dataSource.read();
                    deferred.resolve({ gridName: gridName });
                  })
                  .catch(function() {
                    deferred.reject();
                  });
              },
            },
          },
        });
      }
      return deferred.promise();
    };
  },
  getDocumentActionFromGrid: function($state, vm, entity) {
    return function() {
      var id = getSelectedRowIdFromMainGrid(vm);
      if (id === -1) {
        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      } else {
        $state.go('Document.Nav', { entity: entity, id: id });
      }
    };
  },
};

///
//      [F]ormly
//  [F]ilter[F]unctions                          |\__/,|   (`\
//      [F]or Angular                          _.|o o  |_   ) )
//                                         ---(((---(((---------
//  v0.1
///
function FF_ToUpperCase(value) {
  var ret = (value || '').toUpperCase();
  return ret;
}

function FF_ToLowerCase(value) {
  var ret = (value || '').toLowerCase();
  return ret;
}

function FF_IBAN(value) {
  var v = value || '';
}

///
//         [F]ormly
//   [V]alidator[F]unctions                         |\__/,|   (`\
//         [F]or Angular                          _.|o o  |_   ) )
//                                         ---(((---(((---------
//  v0.1
///

/**
 * Angular-Formly validator function to validate date time picker field value with moment.js
 * @param {} modelValue
 * @param {} viewValue
 * @param {} $scope
 * @returns {}
 */
function FVF_InvalidDate(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    var date1 = new moment(modelValue, [moment.ISO_8601, kendo.culture().calendar.patterns.d.toUpperCase()], true);
    var date2 = new moment(viewValue, [moment.ISO_8601, kendo.culture().calendar.patterns.d.toUpperCase()], true);
    if (!date1.isValid() || !date2.isValid()) {
      return false;
    }
    return true;
  }
  return true;
}

function FVF_InvalidTime(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    var time1 = new moment(modelValue, kendo.culture().calendar.patterns.t);
    var timedefault = new moment(modelValue);
    var time2 = new moment(viewValue, kendo.culture().calendar.patterns.t);
    if (!(time1.isValid() || timedefault.isValid()) || !time2.isValid()) {
      return false;
    }
    return true;
  }
  return true;
}

function FVF_InvalidDateTime(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    if (/_/.test(modelValue) || /_/.test(viewValue)) {
      return false;
    }
    var datetime1 = new moment(
      modelValue,
      kendo.culture().calendar.patterns.d + ' ' + kendo.culture().calendar.patterns.t
    );
    var datetimedefault1 = new moment(modelValue, true);
    var datetime2 = new moment(
      viewValue,
      kendo.culture().calendar.patterns.d + ' ' + kendo.culture().calendar.patterns.t
    );
    var datetimedefault2 = new moment(viewValue, true);
    if (!(datetime1.isValid() || datetimedefault1.isValid()) || !(datetime2.isValid() || datetimedefault2.isValid())) {
      return false;
    }
    return true;
  }
  return true;
}

function FVF_NoSpecialChar(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    if (!/^[a-z0-9]*$/i.test(modelValue)) {
      return false;
    }
    if (!/^[a-z0-9]*$/i.test(viewValue)) {
      return false;
    }
    return true;
  } else {
    if ($scope.options.templateOptions.required) {
      return false;
    } else {
      return true;
    }
  }
}

function FVF_InvalidF2MaxLength(modelValue, viewValue, $scope) {
  if (
    !!$scope.options.templateOptions.f2maxlength &&
    !!modelValue &&
    !!viewValue &&
    !!modelValue.Value &&
    !!viewValue.Value
  ) {
    if (angular.isNumber(modelValue.Value) || angular.isNumber(viewValue.Value)) {
      //console.log("FUTOK: FVF_InvalidF2MaxLength");
      return true;
    }
    return (
      $scope.options.templateOptions.f2maxlength >= modelValue.Value.length &&
      $scope.options.templateOptions.f2maxlength >= viewValue.Value.length
    );
  }
  return true;
}

function FVF_RequiredDate(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    //var date1 = new moment(modelValue,
    //    kendo.culture().calendar.patterns.d.toUpperCase());
    //var date2 = new moment(viewValue,
    //    kendo.culture().calendar.patterns.d.toUpperCase());
    //if (!date1.isValid() ||
    //    !date2.isValid()) {
    //    return false;
    //}
    //if (!date1.isAfter("0001-01-01 00:00:00.000") ||
    //    !date2.isAfter("0001-01-01 00:00:00.000")) {
    //    return false;
    //}
    return true;
  } else {
    if ($scope.options.templateOptions.required) {
      return false;
    } else {
      return true;
    }
  }
}

function FVF_RequiredDropdown(modelValue, viewValue, $scope) {
  if (!!modelValue && !!viewValue) {
    return !(modelValue === 0 || viewValue === 0 || modelValue === '' || viewValue === '');
  } else {
    if ($scope.options.templateOptions.required) {
      return false;
    } else {
      return true;
    }
  }
}

function addMenuItemwithState($state, menu, text, icon, className, state, isback) {
  //console.log("state: " + state);
  //addMenuItem($state, menu, text, icon, className, function () { $state.go(state); });
  menu.push({
    title: text,
    icon: icon,
    className: className,
    event: function() {
      $state.go(state);
    },
    state: state,
    isBack: isback ? isback : false,
  });
}

function addMenuItem($state, menu, text, icon, className, event, isback) {
  menu.push({
    title: text,
    icon: icon,
    className: className,
    event: event,
    isBack: isback ? isback : false,
  });
}

//function addMenuItemFromDb($state, authService, menu, origMenu, id, icon, className) {
//    //console.log(origMenu);
//    var m = origMenu.filter(function (item) {
//        return item.Id.toLowerCase() === id.toLowerCase();
//    });
//    if (m.length > 0) {
//        addMenuItem($state, menu, m[0].Text, icon, className, m[0].State);
//    } else {
//        //console.log("id:" + id );
//    }
//}

function buildMenu($state, authService, parentId, className, backMenu, authMenuDesc) {
  //if (backMenu) {
  //    if (backMenu.event) {
  //        addMenuItem($state, menu, backMenu.text, backMenu.icon, className, backMenu.event, true);
  //    } else {
  //        addMenuItemwithState($state, menu, backMenu.text, backMenu.icon, className, backMenu.state, true);
  //    }
  //}
  var deferred = $.Deferred();
  authService.getMenu(parentId).then(function(result) {
    var menu = [];
    var authmenu = result;
    if (!authmenu?.length) {
      return deferred.promise();
    }
    for (var i = 0; i < authmenu.length; i++) {
      for (var key in authMenuDesc) {
        if (!authMenuDesc.hasOwnProperty(key)) {
          continue;
        }

        if (key.toLowerCase() === authmenu[i].Id.toLowerCase()) {
          var d = authMenuDesc[key];

          var opacity;

          var j = i;

          if (j > 7) {
            j = j - 8;
          } else if (j > 3) {
            j = j - 4;
          }

          if (j == 0) {
            opacity = 1;
          } else if (j == 1) {
            opacity = 2;
          } else if (j == 2) {
            opacity = 3;
          } else if (j == 3) {
            opacity = 4;
          } else {
            opacity = 1;
          }

          //if (isActive(authmenu[i].State)) {
          //    opacity = 1;
          //}
          addMenuItemwithState(
            $state,
            menu,
            authmenu[i].Text,
            d.icon,
            className + ' menuItem_' + opacity,
            authmenu[i].State
          );
        }
      }
    }
    deferred.resolve(menu);
  });
  return deferred.promise();
}

function stateUpdateFromMenu(states, authMenu, $stateProvider, module) {
  //console.log(authMenu);
  angular.forEach(states, function(value, key) {
    key = key.replace('_', '.');
    if (authMenu !== null) {
      var m = authMenu.filter(function(item) {
        return item.State.toLowerCase() === key.toLowerCase();
      });

      for (var i = 0; i < m.length; i++) {
        if (!value['ncyBreadcrumb']) {
          value['ncyBreadcrumb'] = {};
        }
        value['ncyBreadcrumb']['label'] = m[0].Text;

        if (m[0].ParentState && m[0].ParentState.length > 0) {
          value['ncyBreadcrumb']['parent'] = m[0].ParentState;
        } else {
          value['ncyBreadcrumb']['parent'] = module;
        }
      }
    }
    $stateProvider.state(key, value);
  });
}

function stateUpdate($http, $stateProvider, states, module) {
  $http({
    method: 'GET',
    url: 'Auth/GetMenusByParent',
    params: { parent: module },
  }).then(
    function successCallback(response) {
      stateUpdate(response.data);
      //stateUpdate({"Partner" : "Partnerek"});
    },
    function errorCallback(response) {}
  );

  var stateUpdate = function(authMenu) {
    stateUpdateFromMenu(states, authMenu, $stateProvider, module);
  };
}

class SBTimer {
  static #instance = []; // Holds the single instance
  constructor(instance = 'default') {
    if (SBTimer.#instance[instance]) {
      return SBTimer.#instance[instance]; // If exists, return it
    }
    SBTimer.#instance[instance] = this;
    this.instanceName = instance;
    this.events = [];
    this.startTime = this.elapsedTime = 0;
    this.running = this.paused = false;
    this.tickIntervalId = null;
    this._tickTime = 100;
    Object.defineProperty(this, 'tickTime', {
      get: function() {
        return this._tickTime;
      },
      set: function(value) {
        this._tickTime = value;
        if (this.tickIntervalId != null) {
          clearInterval(this.tickIntervalId);
          this.tickIntervalId = setInterval(() => {
            this.tick();
          }, this._tickTime);
        }
      },
    });
    this.endTime = null;
  }
  static getInstance(instance = 'default') {
    if (!SBTimer.#instance[instance]) {
      SBTimer.#instance[instance] = new SBTimer(instance);
    }
    return SBTimer.#instance[instance];
  }
  subscribe(eventName, listener) {
    this.events[eventName] = this.events[eventName] || [];
    this.events[eventName].push(listener);
  }
  unsubscribe(eventName, listener) {
    if (!this.events[eventName]) return;
    this.events[eventName] = this.events[eventName].filter(l => l !== listener);
    if (this.events[eventName].length === 0) {
      delete this.events[eventName];
    }
  }
  publish(eventName, data) {
    if (!this.events[eventName]) return;
    this.events[eventName].forEach(listener => {
      try {
        listener(data);
      } catch (e) {
        console.error(`SBTimer[${this.instanceName}] '${eventName}' listener error:`, e);
      }
    });
  }

  start() {
    if (this.running || this.paused) return;
    this.running = true;
    this.startTime = Date.now();
    this.publish('started');
    console.log(`${this.instanceName} started.`);

    this.tickIntervalId = setInterval(() => {
      this.tick();
    }, this._tickTime);
  }

  pause() {
    if (!this.running) return;
    this.elapsedTime = this.getDuration();
    this.running = false;
    this.paused = true;
    clearInterval(this.tickIntervalId);
    this.publish('paused', this.elapsedTime / 1000);
    console.log(`${this.instanceName} Current: ${(this.elapsedTime / 1000).toFixed(2)}s.`);
  }

  stop() {
    if (!this.running && !this.paused) return 0;
    clearInterval(this.tickIntervalId);
    this.tickIntervalId = null;
    this.running = this.paused = false;

    const durationInSeconds = this.getDuration() / 1000;
    this.startTime = this.elapsedTime = 0;

    this.publish('stopped', durationInSeconds);
    console.log(`${this.instanceName} stopped. Total: ${durationInSeconds.toFixed(2)}s.`);
    return durationInSeconds;
  }
  resume() {
    if (!this.paused) return;
    this.running = true;
    this.paused = false;
    this.startTime = Date.now() - this.elapsedTime;
    this.publish('resume');
    console.log(`${this.instanceName} resumed.`);

    this.tickIntervalId = setInterval(() => {
      this.tick();
    }, this.tickTime);
  }
  tick() {
    let duration = this.getDuration();
    if (this.endTime && duration >= this.endTime) {
      this.stop();
      return;
    }
    if (this.running) {
      this.publish('tick', this.getDuration() / 1000);
    }
  }

  getDuration() {
    const duration = Date.now() - this.startTime;
    return duration;
  } // Omitted for brevity
}

(function () {
    "use strict";

    var dasApp = angular.module("dasApp", [
        "ui.router",
        "ui.bootstrap",
        "ui.mask",
        "angular-loading-bar",
        "kendo.directives",
        "ngMessages",
        "formly",
        "formlyBootstrap",
        "textAngular",
        "timer",
        "ncy-angular-breadcrumb",
        "ngMap",
        "checklist-model",
        "ngFileSaver",
        "LocalStorageModule"
    ]);

})();
(function (module) {
    "use strict";

    module.controller("DasMenuCtrl", ["$http", "$state", "AuthService",
        function ($http, $state, authService) {
            var vm = this;
            vm.currentState = $state.current.name;
            var backMenu = { icon: "fa fa-reply", text: "Vissza", state: "main" };

            var desc = {
            }; 
            
            var itemsCnt = Object.keys(desc).length;
            if (itemsCnt > 0) {

            }

		    vm.menus = [];
            buildMenu($state, authService, "Das", "das", backMenu, desc).then(
                function (m) {
                    vm.menus = m;            
                }
            );

            
        }]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";

    /**********************************/
    /*** Service: DasLockService    ***/
    /**********************************/
    module.service("DasLockService", ["$state", "$http", "$uibModal", "$uibModalStack", "$location", function ($state, $http, $uibModal, $uibModalStack, $location) {
        var vm = this;

        vm.LOCKING_IS_OFF = false;
        vm.SHOW_LOCK_MESSAGES_IN_MODALS = false;
		vm.SILENT = false;
		
        vm.http = $http;
        vm.modal = $uibModal;

        vm.lastLockedUrl = '';

        this.shouldShowInitialiLockAndUnlockMessageInModals = function () {
            return vm.SHOW_LOCK_MESSAGES_IN_MODALS;
        };
		this.shouldSilent = function () {
                return vm.SILENT;
        };

          this.initiateLock = function (programId, id, callback) {
            vm.lastLockedUrl = $location.absUrl();

            console.log('Lock: initiateLock called');
            if (vm.LOCKING_IS_OFF) {
                return;
            }

            $(window).on('beforeunload', function () {
                //UnlockWhenLeavingPage
                vm.http.post("DasSystem/UnlockWhenLeavingPage", {})
                    .then(function (response) {
                        //unregister leaving page event
                        $(window).off('beforeunload', function () {
                            // do nothing
                        });
                    })
                    .catch(function (response) {
                        // do nothing
                    });
            });

            var modalInstance = $uibModal.open({
                templateUrl: "App/Das/DasLock/LockOverlay.html",
                controller: "DasLockOverlayCtrl",
                controllerAs: "vm",
                resolve: {
                    lockParameters: {
                        programId: programId,
                        id: id
                    }
                },
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function () {
				if (angular.isFunction(callback)) callback(result);
            });
        };

        this.initiateUnlock = function (programId, id) {
            vm.lastLockedUrl = '';
            console.log('Lock: initiateUnlock called');
            if (vm.LOCKING_IS_OFF) {
                return;
            }

            // unregister leaving page event
            $(window).off('beforeunload', function () {
                // do nothing
            });

            var modalInstance = $uibModal.open({
                templateUrl: "App/Das/DasLock/UnlockOverlay.html",
                controller: "DasUnlockOverlayCtrl",
                controllerAs: "vm",
                resolve: {
                    lockParameters: {
                        programId: programId,
                        id: id
                    }
                },
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function () {

            });
        };

        function logLockLog(response) {
            if (response == null) return;
            if (response.data == null) return;
            if (response.data.LockLog == null) return;

            var lockLog = response.data.LockLog;
            console.log(lockLog);
        }

        this.isLockable = function (programId, id, successCallback, errorCallback) {
            console.log('Lock: isLockable called');
            if (vm.LOCKING_IS_OFF) {
                return;
            }

            if (id === 0 || id == null) {
                // Return lockable when creating new items
                var result = {
                    ResultStatus: true,
                    LockedBy: []
                };
                setTimeout(() => successCallback(result), 1000);
                return;
            }

            vm.http.post("DasSystem/IsLockable", { programId: programId, id: id })
                .then(function (response) {
                    logLockLog(response);
                    successCallback(response.data.result);
                    return;
                })
                .catch(function (response) {
                    logLockLog(response);
                    errorCallback();
                    return;
                });
        };

        this.lock = function (programId, id, successCallback, errorCallback) {
            console.log('Lock: lock called');
            if (vm.LOCKING_IS_OFF) {
                return;
            }

            if (id === 0 || id == null) {
                // do not lock / unlock when creating new items
                setTimeout(successCallback, 1000);
                return;
            }

            vm.http.post("DasSystem/Lock", { programId: programId, id: id })
                .then(function (response) {
                    logLockLog(response);
                    successCallback();
                    return;
                })
                .catch(function (response) {
                    logLockLog(response);
                    errorCallback();
                    return;
                });
        };

        this.unlock = function (programId, id, successCallback, errorCallback) {
            console.log('Lock: unlock called');
            if (vm.LOCKING_IS_OFF) {
                return;
            }

            if (id === 0 || id == null) {
                // do not lock / unlock when creating new items
                setTimeout(successCallback, 1000);
                return;
            }

            vm.http.post("DasSystem/Unlock", { programId: programId, id: id })
                .then(function (response) {
                    logLockLog(response);
                    successCallback();
                    return;
                })
                .catch(function (response) {
                    logLockLog(response);
                    errorCallback();
                    return;
                });
        }

        this.closeAllModals = function () {
            // console.log('dismissing all modals...');
            $uibModalStack.dismissAll();
        }

        this.unlockWhenLeavingPage = function (nextUrl) {
            if (vm.lastLockedUrl == nextUrl) {
                console.log('Lock: unlockWhenLeavingPage called, but was rejected because it would run on the currently locked page.');
                return;
            }
            vm.lastLockedUrl = '';
            console.log('Lock: unlockWhenLeavingPage called');
            vm.closeAllModals();
            if (vm.LOCKING_IS_OFF) {
                return;
            }
            vm.http.post("DasSystem/UnlockWhenLeavingPage")
                .then(function (response) {
                    logLockLog(response);
                    return;
                })
                .catch(function (response) {
                    logLockLog(response);
                    return;
                });
        }

        this.unlockAllInSessionWithCallback = function (successCallback, errorCallback) {
            console.log('Lock: unlockAllInSessionWithCallback called');
            vm.lastLockedUrl = '';
            vm.closeAllModals();
            if (vm.LOCKING_IS_OFF) {
                return;
            }
            vm.http.post("DasSystem/UnlockWhenLeavingPage")
                .then(function (response) {
                    logLockLog(response);
                    successCallback(response);
                    return;
                })
                .catch(function (response) {
                    logLockLog(response);
                    errorCallback(response);
                    return;
                });
        }

    }]
    );
})(angular.module("dasApp"));
(function (module) {
    "use strict";
    module.controller("DasLockOverlayCtrl", ["$scope", "$http", "$state", "$stateParams", "$uibModal", "$uibModalInstance", "lockParameters", "DasLockService",
        function ($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {

            var vm = this;
            vm.isLocked = false;
            vm.hasError = false;
            vm.lockedBy = [];
            vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();
			vm.SILENT = lockService.shouldSilent();
			
            init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

            function init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {

                var programId = lockParameters.programId;
                var id = lockParameters.id;

                console.log('Locking: programId:' + programId +', id:' + id);

                lockService.isLockable(
                    programId, 
                    id, 
                    function (response) {
                        // success
                        var lockable = response.ResultStatus;
                        vm.isLocked = !lockable;
                        vm.lockedBy = response.LockedBy;
                        
                        if (vm.isLocked) {
                            console.log('Editor is locked by: ' + vm.lockedBy);
							if (vm.SILENT === true) $uibModalInstance.close({isLocked: vm.isLocked, lockedBy: vm.lockedBy});
                        } else {
                            console.log('Editor is accessible.');
                        }

                        if (lockable) {
                            lockService.lock(
                                    programId, 
                                    id, 
                                    function () {
                                        // lock succeeded
                                        console.log('Lock succeeded.');
                                        $uibModalInstance.close();
                                    },
                                    function () {
                                        // error
                                        console.log('Lock FAILED!');
                                        vm.hasError = true;
                                    }
                                );
                        }

                        // end success
                    },
                    function (response) { 
                        // error
                        vm.hasError = true;
                    }
                );

            }
        }
    ]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";
    module.controller("DasUnlockOverlayCtrl", ["$scope", "$http", "$state", "$stateParams", "$uibModal", "$uibModalInstance", "lockParameters", "DasLockService",
        function ($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {

            var vm = this;
            vm.isLockable = true;
            vm.hasError = false;
            vm.lockedBy = [];
            vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();

            init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

            function init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {

                var programId = lockParameters.programId;
                var id = lockParameters.id;

                console.log('Unlocking: programId:' + programId + ', id:' + id);

                lockService.isLockable(
                    programId,
                    id,
                    function (response) {
                        // success
                        vm.isLockable = response.ResultStatus;
                        vm.lockedBy = response.LockedBy;

                        if (vm.isLockable) {
                            // No need to unlock
                            // This can happen - maybe we have unlocked the record after save, and the modal remained open and calls an unlock on close
                            //
                            // If the installService cannot handle this, uncomment below
                            // However, this can cause missing unlock calls when the lock feature is turned on at the server side, as vm.IsLockable will always be true in that case

                            //console.log('Record is already unlocked. Unlock succeeded.');
                            //$uibModalInstance.close();
                            //return;
                        }

                        lockService.unlock(
                            programId,
                            id,
                            function () {
                                // unlock succeeded
                                console.log('Unlock succeeded.');
                                $uibModalInstance.close();
                            },
                            function () {
                                // error
                                console.log('Unlock FAILED!');
                                vm.hasError = true;
                            }
                        );

                        // end success
                    },
                    function (response) {
                        // error
                        vm.hasError = true;
                    }
                );

            }
        }
    ]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";

    module.controller("DocumentsLayoutCtrl", ["$http", "$state", "$uibModal", "$filter", "AuthService",
        function ($http, $state, $uibModal, $filter, authService) {
            var vm = this; 
        }]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";
    module.controller("DocumentsLinkedDocCtrl", ["$scope", "$http", "$state", "$stateParams", "options", "$filter", "AuthService", "$uibModal","$uibModalInstance",
        function ($scope, $http, $state, $stateParams, options, $filter, authService, $uibModal,mi) {
            var vm = this;

            init();
            
            function init() {

                initModel($http, $state, $stateParams, vm, options, $uibModal)
                initViewModel($http, $state, $stateParams, vm, options, $uibModal);
                initFormModel($http, $state, $stateParams, vm, options, $uibModal);
				//table and ownerId from options
				vm.dataModel.f_tableid = $stateParams.tableId;
				vm.dataModel.f_ownerid = $stateParams.ownerId;
				vm.isFormReadOnly = options.isFormReadOnly;
				vm.isUrl = !!vm.dataModel.f_url && (vm.dataModel.f_url.startsWith('http://') || vm.dataModel.f_url.startsWith('https://'));
				vm.isFile = !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI";				
                var fs = fieldSetter;
                fs.vm = vm;

				
				//ha nézet és file akkor letöltjük és bezárjuk a modalt.
				// if(vm.isFormReadOnly && vm.isFile) {					
					
					// window.location="Das/Documents/GetDocFile?docId="+vm.dataModel.f_docid;											
				// }
				
				

				fs.setOnChangeFunction(
					 "f_docform",
					 function (selectedItem) {                     
						 //kendo file upload set allowed extensions:
						 var upload = $("input[type='file']").data("kendoUpload");
						 vm.dataModel.extraProperties = selectedItem.extraProperties;
						 if (!!upload) {
							 upload.clearAllFiles();                         
							 if (!!selectedItem.extraProperties) {                            
								upload.options.validation.allowedExtensions = selectedItem.extraProperties[2].value == "IVNN" ? [] : getFileExtensionFromExtraProperties(selectedItem);
							 }
						 }                     
                 });

//-----------------------------------------------------------------------------------------------------------------------------
                 fs.setDisabled(
					  "f_doctype",
					  function () {
						  return vm.isFormReadOnly || !!vm.dataModel.f_doctype;
                  });
                 
				 fs.setDisabled(
					  "f_docform",
					  function () {
					     return vm.isFormReadOnly || !!vm.dataModel.f_docform;
                  });

					
				  //KendoUploadra nem működik!
                  // fs.setDisabled(
					  // "f_file",
					  // function () {
						  // return true; 
                  // });
//-----------------------------------------------------------------------------------------------------------------------------
                fs.setRequired(
                   "f_text",
                   function () {
                       return !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNI" && vm.dataModel.extraProperties[2].value == "IVNN";
                   });
				fs.setRequired(
                   "f_intdate",
                   function () {
                       return !vm.isUrl && !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNI" && vm.dataModel.extraProperties[2].value == "IVNN";
                });
                fs.setRequired(
                  "f_refid",
                  function () {
                      return !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNN"
                  });
                fs.setRequired(
                   "f_file",
                   function () {
                       return !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI"
                });
                fs.setRequired(
                   "f_vpath",
                   function () {
                       return !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI";
                });
//-----------------------------------------------------------------------------------------------------------------------------
				fs.hideField(
                        "f_doctype",
                        function () { 
                            return vm.isUrl; //vm.isFormReadOnly;
                        });
				fs.hideField(
                        "f_docform",
                        function () { 
                            return vm.isUrl; //vm.isFormReadOnly;
                        });
                fs.hideField(
                        "f_text",
                        function () { 
                            return !(!!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNI" && vm.dataModel.extraProperties[2].value == "IVNN");
                        });
				fs.hideField(
                        "f_intdate",
                        function () { 
                            return !(!!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNI" && vm.dataModel.extraProperties[2].value == "IVNN");
                        });				
				fs.hideField(
                        "f_refid",
                        function () {                           
                            return !(!!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNN");
                        });
                fs.hideField(
                        "f_file",
                        function () {                           
                            return  !(!!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI");
                        });
                fs.hideField(
                        "f_vpath",
                        function () {                           
                            return  !(!!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI");
                        });
				fs.hideField(
                        "f_url",
                        function () {                           							
                            return !(vm.dataModel.f_docform==null && vm.isUrl);
                        });
//-----------------------------------------------------------------------------------------------------------------------------

				vm.fileUploadInvalid = function () {
					return vm.pageModel.Fields.f_file.FormlyFieldDescriptor.templateOptions.required 
							&& !!vm.dataModel.f_file					
							&& vm.dataModel.f_file.getErrors()!=0					
				}		

			
			// Set editability of fields based on controllerOptions
            if (vm.isFormReadOnly) {
                angular.forEach(vm.pageModel.Fields, function (value, key) {                    
                        value.FormlyFieldDescriptor.templateOptions.disabled = true;
                });
            }
			
			
			generateForm(vm);
			}
            // vm.pageModel.Fields.f_file.FormlyFieldDescriptor.templateOptions.changed = function () {
               // vm;
            // }
			
			var eventHandlers = {
                "f_file": {
                    "onComplete": function (e) {
                        
                    },
                    "onError": function (e) {
                        
                    },
                    "onSuccess": function (e) {
                        if (e.response) {
                            if (e.response.ResultStatus) {
                                if (e.operation === 'upload') {
                                    if (!vm.dataModel.UploadedFiles) {
                                        vm.dataModel.UploadedFiles = e.response.FileIdentifiers;
                                    } else {
                                        angular.forEach(e.response.FileIdentifiers, function (value) {
                                            vm.dataModel.UploadedFiles.push({
                                                StoredName: value.StoredName,
                                                OriginalName: value.OriginalName
                                            });
                                        });
                                    }
                                } else if (e.operation === 'remove') {
                                    if (vm.dataModel.UploadedFiles) {
                                        var forDelete = [];
                                        angular.forEach(e.response.FileIdentifiers, function (value) {
                                            forDelete.push(value);
                                        });
                                        for (var i = 0; i < forDelete.length; i++) {
                                            for (var j = 0; j < vm.dataModel.UploadedFiles.length; j++) {
                                                if (forDelete[i] === vm.dataModel.UploadedFiles[j].StoredName) {
                                                    vm.dataModel.UploadedFiles.splice(j, 1);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                }
            };
            InsertEventHandlers(vm.pageModel, eventHandlers);

            function getFileExtensionFromExtraProperties(selectedItem) {
                return selectedItem.extraProperties[0].value.replace(/\*/g, "").split(/,|;| /);
            }
            
            vm.back = function() {             
                mi.close();
            }

            vm.save = function () {
                $http.post("Das/Documents/Edit", { model: vm.dataModel})
                    .then(function (response) {                       
                        toastr.success(vm.pageModel.Messages.SaveSuccessful);
                        mi.close();
                    })
                    .catch(function (response) {
                        toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
            };
		
        }]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";
    module.controller("DocumentsLinkModalCtrl_das", ["$scope", "$http", "$state", "$stateParams", "options", "$filter", "AuthService", "$uibModal", "$uibModalInstance",
        function ($scope, $http, $state, $stateParams, options, $filter, authService, $uibModal, $uibModalInstance) {
            var vm = this;

            init();

            function init() {

                initModel($http, $state, $stateParams, vm, options, $uibModal)
                initViewModel($http, $state, $stateParams, vm, options, $uibModal);
                initFormModel($http, $state, $stateParams, vm, options, $uibModal);

                vm.dto = options.dto;
                vm.modal = $uibModalInstance;
  
                var fs = fieldSetter;
                fs.vm = vm; 
                fs.setSyncValidator(
                    "LinkUrl", "Url_should_start_with_http_Failed",
                    function (modelValue, viewValue) {
                        if (typeof modelValue === 'undefined') {
                            return false;
                        }
                        var str = String(modelValue);
                        return str.startsWith('http://') || str.startsWith('https://');
                });

                generateForm(vm);
            }

            vm.back = function() {
                vm.modal.close();
            }

            vm.save = function() {
                $http.post("Documents/CreateLink", { dto: vm.dto })
                .then(function (data) {
					toastr.success(vm.pageModel.Messages.SaveSuccessful);
                    vm.modal.close(vm.dto);
                });
            }
            
        }]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";

    module.controller("DocumentsMenuCtrl", ["$http", "$state", "AuthService",
    function ($http, $state, authService) {
        var vm = this;
        vm.currentState = $state.current.name;
        var backMenu = { icon: "fa fa-reply", text: "Vissza" };
        backMenu.state = "main";

        var desc = {
        };

        vm.menus = buildMenu($state, authService, "Document", "document", backMenu, desc).then(
                function (m) {
                    vm.menus = m;
                }
           );
    }]);
})(angular.module("dasApp"));
(function (module) {
    "use strict";
    module.controller("DocumentsNavCtrl", ["$window", "$scope", "$http", "$state", "$stateParams", "options", "$filter", "AuthService", "$uibModal",
        function ($window, $scope, $http, $state, $stateParams, options, $filter, authService, $uibModal) {
            var vm = this;

            init();

            function init() {

                initModel($http, $state, $stateParams, vm, options, $uibModal)
                initViewModel($http, $state, $stateParams, vm, options, $uibModal);
                initFormModel($http, $state, $stateParams, vm, options, $uibModal);
                
                vm.dataModel = options.dto;
				vm.docLinkModalPageModel = options.docLinkModalPageModel;
                vm.docLinkModalDto = options.docLinkModalDto;

				vm.docFeedbackModalPageModel = options.docFeedbackModalPageModel
				vm.docFeedbackModalDto = options.docFeedbackModalDto;
                
                // Get the parameters from the angularjs route
                vm.docLinkModalDto.TableId = $state.params.tableId;
                vm.docLinkModalDto.OwnerId = $state.params.ownerId;

                vm.hasDasParameters = function () {
                    if (!vm.docLinkModalDto.TableId) return false;
                    if (!vm.docLinkModalDto.OwnerId) return false;

                    if (vm.docLinkModalDto.TableId === '') return false;
                    if (vm.docLinkModalDto.OwnerId === '') return false;

                    return true;
                }
				
				//prevState mentése:------------------------------------------------------------------------------------------------				
				//a *routes.js-be fel kell venni a das-os statehez a "lockPreviousState: true" paramétert, hogy a kiindulás state megmaradjon.
				if (!!$state.previous && !!$state.previous.name && $state.previous.name!="" && $state.params.lockPreviousState) {
						localStorage.setItem("dasBackToState", $state.previous.name );						
				} 
				//------------------------------------------------------------------------------------------------------------------

                vm.getWhereCondition = function () {
                    if (!vm.hasDasParameters()) {
                        return null;
                    }
                    return "f_tableid~eq~'"+vm.docLinkModalDto.TableId+"'~and~f_ownerid~eq~'"+vm.docLinkModalDto.OwnerId+"'";
                }
				
				vm.getParameterFilter = function () {
                    return {"tableId": vm.docLinkModalDto.TableId, "ownerId": vm.docLinkModalDto.OwnerId};
                }
				
			vm.pageModel.Grids.GridDocuments.ControllerMethod="Das/Documents/DocumentsGridData";
               initMainGrid(vm, "GridDocuments",
                    "Das/DocumentsGridData",
                    function () {
                        changeSubItemGridFilter(vm.mainGrid);
                    }, vm.getParameterFilter(),                    
                    function (e) {  
                        //initdetail
                    },
					vm.getWhereCondition);

					
	// vm.mainGridOptions.dataSource.serverFiltering = false;
	// vm.mainGridOptions.dataSource.serverPaging = false;		
	// vm.mainGridOptions.dataSource.serverSorting = false;		
					
                vm.back = function () {									
					var backState = localStorage.getItem("dasBackToState");										
					if (!!backState)  {
						$state.go(backState); 
					} else {
						$state.go($stateParam.back);	
					}
                }

                vm.createItem = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: "App/Das/Documents/DocumentsLinkedDocModal.html",
                        controller: "DocumentsLinkedDocCtrl",
                        controllerAs: "vm",
                        resolve: {
                            options: RouteResolveFunc("Das/Documents/Create"),                            
                            parameter: {
                                CreateOrEdit: "Create",
                                dto: angular.copy(vm.docLinkModalDto)
                            }
                        }
                    });
					
					modalInstance.result.then(function (result) {
                         vm.mainGrid.dataSource.read();
                    });
                } 

                vm.addFromDms = function () {
                    //var url = '/#!/document/nav/' + vm.docLinkModalDto.TableId + '/' + vm.docLinkModalDto.OwnerId; 
                    //$window.location.href = url;
                    $state.go("Document.DocumentNav", { dasTableId: vm.docLinkModalDto.TableId, dasOwnerId: vm.docLinkModalDto.OwnerId });
                }

                vm.addLink= function() {
                    var modalInstance = $uibModal.open({
                            templateUrl: "App/Das/Documents/DocumentsLinkModal.html",
                            controller: "DocumentsLinkModalCtrl_das",
                            controllerAs: "vm",
                            resolve: {
                                options: {
                                    pageModel: vm.docLinkModalPageModel,
                                    dto: angular.copy(vm.docLinkModalDto)
                                }
                            }
                            
                        });

                    modalInstance.result.then(function (result) {
                         vm.mainGrid.dataSource.read();
                    });
                }

                vm.feedBack = function () {
                     var modalInstance = $uibModal.open({
                          templateUrl: "App/Das/Documents/DocumentsFeedbackModal.html",
                            controller: "DocumentsFeedbackModalCtrl_das",
                            controllerAs: "vm",
                            resolve: {
                                options: {
                                    pageModel: vm.docFeedbackModalPageModel,
                                    dto: angular.copy(vm.docFeedbackModalDto)
                                }
                            }
                            
                        });

                    modalInstance.result.then(function (result) {
                         vm.mainGrid.dataSource.read();
                    });
                }
                vm.deleteItem = function () {
                    var docId = vm.selectedMainGridItemId;

                    bootbox.dialog({
                        message: 'Biztosan törölni szeretné a kijelölt elemet?',
                        title: 'Törlés',
                        buttons: {
                            cancel: {
                                label: 'Mégsem',
                                className: "btn-default",
                                callback: function () {
                                }
                            },
                            confirm: {
                                label: 'Törlés',
                                className: "btn-primary",
                                callback: function () {
                                    $http.post("Das/Documents/Delete", { documentId: docId })
                                        .then(function (response) {
                                            //console.log("response: " + response);
                                            toastr.success(vm.pageModel.Messages.SaveSuccessful);
                                            vm.mainGrid.dataSource.read();
                                        })
                                        .catch(function (response) {
                                            toastr.error(vm.pageModel.Messages.SaveFailed);
                                        }
                                    );
                                }
                            }
                        }
                    });
                    // end of vm.deleteItem = function () {
                }

				
				vm.viewItem = function () {
				
					var selectedItems = GetSelectedGridItems(vm.mainGrid);					
                    if (selectedItems.length === 0) {                    
                        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
                        return false;
                    }
					//is feedback?
					if (!!selectedItems[0].f_lnktbl && selectedItems[0].f_lnktbl != "" && !!selectedItems[0].f_lnkid && selectedItems[0].f_lnkid != "") {
						
						if (vm.docLinkModalDto.TableId == selectedItems[0].f_lnktbl) {
							//Ha visszacsatolás <<<<<<
							$state.go("dasDocuments.Nav", { tableId: selectedItems[0].f_tableid, ownerId: selectedItems[0].f_ownerid});
						} else {
							//Ha viosszacsatolás >>>>>
							$state.go("dasDocuments.Nav", { tableId: selectedItems[0].f_lnktbl, ownerId: selectedItems[0].f_lnkid});
						}
						
						return true;
					}
					//isUrl?
					if (!!selectedItems[0].f_filename && (selectedItems[0].f_filename.startsWith('http://') || selectedItems[0].f_filename.startsWith('https://'))) {
						window.open(selectedItems[0].f_filename, "_blank");
						return true;
					}
					
					//notUrl:					
					var controller = (selectedItems[0]["f_doclibid"]>0? "GetDocFileFromDmsWcf": "GetDocFile");
					var downloadedDocId = (selectedItems[0]["f_doclibid"]>0? selectedItems[0]["f_doclibid"]: selectedItems[0][vm.mainGridIdField]);
					$http.post('Das/Documents/'+controller, {docId:  downloadedDocId})					
						.then(function (data) {							
							if (selectedItems[0]["f_doclibid"]>0 || data.data.IsFile) 								
								vm.downloadDocFile(downloadedDocId, data.data.FileName, controller);											
								else {
									//Ha nem fájl, nyitjuk a modalt
									 var modalInstance = $uibModal.open({
										templateUrl: "App/Das/Documents/DocumentsLinkedDocModal.html",
										controller: "DocumentsLinkedDocCtrl",
										controllerAs: "vm",
										resolve: {
											options: RouteResolveFunc("Das/Documents/View", {docId:  downloadedDocId,}),                            							
											parameter: {
												CreateOrEdit: "View",    							
											}
										}
									});
								}
						});
					
				 }
				
                vm.downloadDocFile = function (docId, fileName, controller) {
					$http.post('Das/Documents/'+controller, {docId:  docId, download: true},
					{
						responseType: 'arraybuffer',
						transformResponse: function (data) {
							var file;
							if (data) {
								file = new Blob([data], {
									type: "octet/stream"
								});
							}
							return {
								response: file
							};
						}
					}).then(function (data) {
						var hdrs = data.headers();
						var fileURL = URL.createObjectURL(data.data.response);
						var a = document.createElement('a');
						a.href = fileURL;
						a.target = '_blank';
						a.download = fileName;							
						document.body.appendChild(a);
						a.click(); 
					 });
                }
			}
			
			// vm.parseFilenameFromContentDisposition = function (contentDisposition) {
				// if (!contentDisposition) return null;
				// let matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
				// return matches && matches.length > 1 ? matches[1] : null;
			// }
            function changeSubItemGridFilter(targetGrid) {
                vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);
                $scope.$apply();
            }
        }]);
})(angular.module("dasApp"));
angular.module('dasApp').config(['$stateProvider', function ($stateProvider) {
    var states = {
        "dasDocuments": {
            url: "/das/documents",
            templateUrl: "App/das/Documents/DocumentsLayout.html",
            controller: "DocumentsLayoutCtrl as vm",
            redirectTo: "dasDocuments.Nav",
            ncyBreadcrumb: {
                //skip: true,
                label: "Dokumentumok",
                parent: "main"
            }
        },
        "dasDocuments.Nav": {
            url: "/list/:tableId/:ownerId",
            params: {
                module: "documents",
                formMode: "Nav"
            },
            views: {
                "menu": {
                    templateUrl: "App/TileMenu.html",
                    controller: "DasMenuCtrl as vm"
                },
                "content": {
                    templateUrl: "App/Das/Documents/DocumentsNav.html",
                    controller: "DocumentsNavCtrl as vm"
				}
			},
			resolve: {
				options: RouteResolveFunc("Das/Documents/DocumentsListOptions/")
			},
            ncyBreadcrumb: {
                skip: true,
                label: "Csatolt dokumentumok kezelése"
            }
        }	       
    };

    angular.forEach(states, function (value, key) {
        key = key.replace("_", ".");
        $stateProvider.state(key, value);
    });
}]);
(function (module) {
    "use strict";
    module.controller("DocumentsFeedbackModalCtrl_das", ["$scope", "$http", "$state", "$stateParams", "options", "$filter", "AuthService", "$uibModal","$uibModalInstance",
        function ($scope, $http, $state, $stateParams, options, $filter, authService, $uibModal,mi) {
            var vm = this;

            init();
            
            function init() {

                initModel($http, $state, $stateParams, vm, options, $uibModal)
                initViewModel($http, $state, $stateParams, vm, options, $uibModal);
                initFormModel($http, $state, $stateParams, vm, options, $uibModal);
				//table and ownerId from options
				vm.dataModel.f_tableid = $stateParams.tableId;
				vm.dataModel.f_ownerid = $stateParams.ownerId;
				vm.isFormReadOnly = options.isFormReadOnly;
				vm.isUrl = !!vm.dataModel.f_url && (vm.dataModel.f_url.startsWith('http://') || vm.dataModel.f_url.startsWith('https://'));
				vm.isFile = !!vm.dataModel.extraProperties && vm.dataModel.extraProperties[1].value == "IVNN" && vm.dataModel.extraProperties[2].value == "IVNI";				
				vm.tableWhereCondition = function() {return "subsystem~in~'"+vm.dataModel.usedSubmodule+"')"; }
                var fs = fieldSetter;
                fs.vm = vm;

			
			// Set editability of fields based on controllerOptions
            if (vm.isFormReadOnly) {
                angular.forEach(vm.pageModel.Fields, function (value, key) {                    
                        value.FormlyFieldDescriptor.templateOptions.disabled = true;
                });
            }
			
			   var fs = fieldSetter;
               fs.vm = vm; 
			   fs.setOnChangeFunction(
                       "f_lnktbl",
                       function (selectedItem) {
						    vm.dataModel.f_lnkid = {Value: null, Text: null};
						    if (!!selectedItem.GridItem) {								
								$http.post('F22/GetF22FieldModelFromTableId', { subsystem: selectedItem.GridItem.subsystem, table: selectedItem.GridItem.tableid, idcolumn: selectedItem.GridItem.idcolumn})
								.then(function (fieldModel) {											
									vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.type = "f22Input";
									vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions = fieldModel.data.templateOptions;
									vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions.required = true;
									vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions.label = "Dokumentum formátumok";									
									vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);				
									vm.pageModel.Fields.f_lnktbl.FormlyFieldDescriptor.templateOptions.options.whereCondition = vm.tableWhereCondition;									
								}).catch(function (data, status, headers, config) {
									//vm.formModel.Value = {Value: null, Text: null};
									//TODO
								});
							}
                       });
			
			generateForm(vm);

			vm.pageModel.Fields.f_lnktbl.FormlyFieldDescriptor.templateOptions.options.whereCondition = vm.tableWhereCondition;			
			
			}            
			
            vm.back = function() {             
                mi.close();
            }

            vm.save = function () {
                $http.post("Das/Documents/FeedbackEdit", { model: vm.dataModel})
                    .then(function (response) {                       
                        toastr.success(vm.pageModel.Messages.SaveSuccessful);
                        mi.close();
                    })
                    .catch(function (response) {
                        toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
            };
		
        }]);
})(angular.module("dasApp"));
(function() {
  'use strict';

  var myApp = angular.module('dmsApp', [
    'ui.router',
    'ui.bootstrap',
    'ui.mask',
    'angular-loading-bar',
    'kendo.directives',
    'ngMessages',
    'formly',
    'formlyBootstrap',
    'textAngular',
    'timer',
    'ncy-angular-breadcrumb',
    'ngMap',
    'checklist-model',
    'ngFileSaver',
    'LocalStorageModule',
  ]);
})();

(function(module) {
  'use strict';

  /**********************************/
  /*** Service: DmsLockService    ***/
  /**********************************/
  module.service('DmsLockService', [
    '$state',
    '$http',
    '$uibModal',
    '$uibModalStack',
    '$location',
    function($state, $http, $uibModal, $uibModalStack, $location) {
      var vm = this;

      vm.LOCKING_IS_OFF = false;
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = false;
      vm.SILENT = false;

      vm.http = $http;
      vm.modal = $uibModal;

      vm.lastLockedUrl = '';

      this.shouldShowInitialiLockAndUnlockMessageInModals = function() {
        return vm.SHOW_LOCK_MESSAGES_IN_MODALS;
      };
      this.shouldSilent = function() {
        return vm.SILENT;
      };

      this.initiateLock = function(programId, id, callback) {
        vm.lastLockedUrl = $location.absUrl();

        console.log('Lock: initiateLock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        $(window).on('beforeunload', function() {
          //UnlockWhenLeavingPage
          vm.http
            .post('DmsSystem/UnlockWhenLeavingPage', {})
            .then(function(response) {
              //unregister leaving page event
              $(window).off('beforeunload', function() {
                // do nothing
              });
            })
            .catch(function(response) {
              // do nothing
            });
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/DmsLock/LockOverlay.html',
          controller: 'DmsLockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        modalInstance.result.then(function() {
          if (angular.isFunction(callback)) callback(result);
        });
      };

      this.initiateUnlock = function(programId, id) {
        vm.lastLockedUrl = '';
        console.log('Lock: initiateUnlock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        // unregister leaving page event
        $(window).off('beforeunload', function() {
          // do nothing
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/DmsLock/UnlockOverlay.html',
          controller: 'DmsUnlockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        modalInstance.result.then(function() {});
      };

      function logLockLog(response) {
        if (response == null) return;
        if (response.data == null) return;
        if (response.data.LockLog == null) return;

        var lockLog = response.data.LockLog;
        console.log(lockLog);
      }

      this.isLockable = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: isLockable called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // Return lockable when creating new items
          var result = {
            ResultStatus: true,
            LockedBy: [],
          };
          setTimeout(() => successCallback(result), 1000);
          return;
        }

        vm.http
          .post('DmsSystem/IsLockable', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback(response.data.result);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.lock = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: lock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        vm.http
          .post('DmsSystem/Lock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.unlock = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: unlock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        vm.http
          .post('DmsSystem/Unlock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.closeAllModals = function() {
        // console.log('dismissing all modals...');
        $uibModalStack.dismissAll();
      };

      this.unlockWhenLeavingPage = function(nextUrl) {
        if (vm.lastLockedUrl == nextUrl) {
          console.log(
            'Lock: unlockWhenLeavingPage called, but was rejected because it would run on the currently locked page.'
          );
          return;
        }
        vm.lastLockedUrl = '';
        console.log('Lock: unlockWhenLeavingPage called');
        vm.closeAllModals();
        if (vm.LOCKING_IS_OFF) {
          return;
        }
        vm.http
          .post('DmsSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            return;
          });
      };

      this.unlockAllInSessionWithCallback = function(successCallback, errorCallback) {
        console.log('Lock: unlockAllInSessionWithCallback called');
        vm.lastLockedUrl = '';
        vm.closeAllModals();
        if (vm.LOCKING_IS_OFF) {
          return;
        }
        vm.http
          .post('DmsSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            successCallback(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback(response);
            return;
          });
      };
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';
  module.controller('DmsLockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'DmsLockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DmsLockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLocked = false;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();
      vm.SILENT = lockService.shouldSilent();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Locking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            var lockable = response.ResultStatus;
            vm.isLocked = !lockable;
            vm.lockedBy = response.LockedBy;

            if (vm.isLocked) {
              console.log('Editor is locked by: ' + vm.lockedBy);
              if (vm.SILENT === true) $uibModalInstance.close({ isLocked: vm.isLocked, lockedBy: vm.lockedBy });
            } else {
              console.log('Editor is accessible.');
            }

            if (lockable) {
              lockService.lock(
                programId,
                id,
                function() {
                  // lock succeeded
                  console.log('Lock succeeded.');
                  $uibModalInstance.close();
                },
                function() {
                  // error
                  console.log('Lock FAILED!');
                  vm.hasError = true;
                }
              );
            }

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';
  module.controller('DmsUnlockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'DmsLockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DmsUnlockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLockable = true;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Unlocking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            vm.isLockable = response.ResultStatus;
            vm.lockedBy = response.LockedBy;

            if (vm.isLockable) {
              // No need to unlock
              // This can happen - maybe we have unlocked the record after save, and the modal remained open and calls an unlock on close
              //
              // If the installService cannot handle this, uncomment below
              // However, this can cause missing unlock calls when the lock feature is turned on at the server side, as vm.IsLockable will always be true in that case
              //console.log('Record is already unlocked. Unlock succeeded.');
              //$uibModalInstance.close();
              //return;
            }

            lockService.unlock(
              programId,
              id,
              function() {
                // unlock succeeded
                console.log('Unlock succeeded.');
                $uibModalInstance.close();
              },
              function() {
                // error
                console.log('Unlock FAILED!');
                vm.hasError = true;
              }
            );

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocPropertyModCtrl_dms', [
    '$scope',
    '$http',
    '$state',
    'options',
    '$uibModalInstance',
    function($scope, $http, $state, options, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocPropertyModCtrl_dms', stateParams);
      }
      var vm = this;
      vm.pageModelDocProp = options.pageModel;
      vm.formModelDocProp = options.dto;
      vm.EditOrDuplicate = $state.params.EditOrDuplicate;
      vm.title = vm.pageModelDocProp.Labels.LabelTitle.Title;
      var init = function() {
        var customExpressionProperties = {
          value: {
            'templateOptions.required': function() {
              var isF2 =
                (!!vm.formModelDocProp.table && vm.formModelDocProp.table != '') ||
                (!!vm.formModelDocProp.ForrasProp &&
                  !!vm.formModelDocProp.ForrasProp.extraProperties &&
                  vm.formModelDocProp.ForrasProp.extraProperties[0].value != '');
              return isF2;
            },
            'templateOptions.disabled': function() {
              return !vm.formModelDocProp.propertyID;
            },
          },
          valueString: {
            'templateOptions.required': function() {
              var isF2 =
                (!!vm.formModelDocProp.table && vm.formModelDocProp.table != '') ||
                (!!vm.formModelDocProp.ForrasProp &&
                  !!vm.formModelDocProp.ForrasProp.extraProperties &&
                  vm.formModelDocProp.ForrasProp.extraProperties[0].value != '');
              return !isF2;
            },
            'templateOptions.disabled': function() {
              return !vm.formModelDocProp.propertyID;
            },
          },
        };

        var getTableOrViewName = function(extraProps) {
          if (!!extraProps) {
            return extraProps[5].value != '' ? extraProps[5].value : extraProps[0].value;
          }
          return null;
        };

        var onChangeFunctions = {
          propertyID: function(selectedItem) {
            if (!!selectedItem) {
              vm.formModelDocProp.propertyID = selectedItem.key;
              vm.formModelDocProp.value = { Value: null, Text: null };
              vm.formModelDocProp.propertyname = selectedItem.text;

              vm.formModelDocProp.table = getTableOrViewName(selectedItem.extraProperties);
              vm.formModelDocProp.key = !!selectedItem.extraProperties ? selectedItem.extraProperties[1].value : null;
              vm.formModelDocProp.showData = !!selectedItem.extraProperties
                ? selectedItem.extraProperties[2].value
                : null;
              vm.formModelDocProp.adopter = !!selectedItem.extraProperties
                ? selectedItem.extraProperties[3].value
                : null;
              vm.formModelDocProp.multiple = !!selectedItem.extraProperties
                ? selectedItem.extraProperties[4].value == 'True'
                : null;

              if (selectedItem.key != '' && selectedItem.extraProperties[0].value != '') {
                $http
                  .post('F22/GetDynamicF22FieldModel', {
                    table: getTableOrViewName(selectedItem.extraProperties),
                    key: selectedItem.extraProperties[1].value,
                    value:
                      !!selectedItem.extraProperties[2].value && selectedItem.extraProperties[2].value != ''
                        ? selectedItem.extraProperties[2].value
                        : selectedItem.extraProperties[1].value,
                    freeText: false,
                    writable: true,
                    filteringMode: 1,
                    patternMatchMode: 0,
                    adopter:
                      !!selectedItem.extraProperties[3].value && selectedItem.extraProperties[3].value != ''
                        ? selectedItem.extraProperties[3].value
                        : vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter,
                    installAdopter:
                      vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.DynamicOptions
                        .InstallAdopter,
                  })
                  .then(function(fieldModel) {
                    vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.type = 'f22Input';
                    vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions =
                      fieldModel.data.templateOptions;
                    vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.label = 'Érték';
                    vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.DynamicOptions.ModalTitle =
                      vm.formModelDocProp.propertyname;
                    var _pageModelDocProp = angular.copy(vm.pageModelDocProp);
                    var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(_pageModelDocProp);
                    vm.fields = formlyFormPanelDescriptors.Paneldocprop.FormlyDescriptor;
                  })
                  .catch(function(data, status, headers, config) {
                    vm.formModelDocProp.value = { Value: null, Text: null };
                    //TODO
                  });
              }
            }
          },
        };

        var hideExpressions = {
          value: function($viewValue, $modelValue, scope) {
            var isF2 =
              (!!vm.formModelDocProp.table && vm.formModelDocProp.table != '') ||
              (!!vm.formModelDocProp.ForrasProp &&
                !!vm.formModelDocProp.ForrasProp.extraProperties &&
                vm.formModelDocProp.ForrasProp.extraProperties[0].value != '');
            return !isF2;
          },
          valueString: function($viewValue, $modelValue, scope) {
            var isF2 =
              (!!vm.formModelDocProp.table && vm.formModelDocProp.table != '') ||
              (!!vm.formModelDocProp.ForrasProp &&
                !!vm.formModelDocProp.ForrasProp.extraProperties &&
                vm.formModelDocProp.ForrasProp.extraProperties[0].value != '');
            return isF2;
          },
        };

        InsertCustomExpressionProperties(vm.pageModelDocProp, customExpressionProperties);
        InsertOnChangeFunctions(vm.pageModelDocProp, onChangeFunctions);
        InsertHideExpressions(vm.pageModelDocProp, hideExpressions);

        var _pageModelDocProp = angular.copy(vm.pageModelDocProp);
        var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(_pageModelDocProp);
        vm.fields = formlyFormPanelDescriptors.Paneldocprop.FormlyDescriptor;

        //var _ForrasProp = vm.pageModelDocProp.Fields.propertyID.FormlyFieldDescriptor.templateOptions.options.dataSource.data();
        //vm.formModelDocProp.ForrasProp = _ForrasProp.find(function(e,f) {return e.key == vm.formModelDocProp.propertyID;})

        vm.cancel = function() {
          mi.close();
        };

        vm.save = function() {
          mi.close(vm.formModelDocProp);
        };
      };

      if (!!vm.formModelDocProp.propertyID && !!vm.formModelDocProp.table && vm.formModelDocProp.table != '') {
        $http
          .post('F22/GetDynamicF22FieldModel', {
            table: vm.formModelDocProp.table,
            key: vm.formModelDocProp.key,
            value:
              !!vm.formModelDocProp.showData && vm.formModelDocProp.showData != ''
                ? vm.formModelDocProp.showData
                : vm.formModelDocProp.key,
            freeText: false,
            writable: true,
            filteringMode: 1,
            patternMatchMode: 0,
            adopter: vm.formModelDocProp.adopter,
            installAdopter:
              vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
          })
          .then(function(fieldModel) {
            vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.type = 'f22Input';
            vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions = fieldModel.data.templateOptions;
            vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.label = 'Érték';
            //vm.pageModelDocProp.Fields.value.FormlyFieldDescriptor.templateOptions.DynamicOptions.ModalTitle = vm.formModelDocProp.ForrasProp.text;
            init();
          })
          .catch(function(data, status, headers, config) {
            init();
            //TODO
          });
      } else {
        vm.formModelDocProp.value = null;
        init();
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocSearchCtrl_dms', [
    '$scope',
    '$http',
    '$state',
    'options',
    '$uibModal',
    '$uibModalInstance',
    'lodash',
    function($scope, $http, $state, options, $uibModal, mi, lodash) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocSearchCtrl_dms', stateParams);
      }
      var vm = this;

      vm.pageModel = angular.copy(options.pageModel);
      vm.formModel = angular.copy(options.dto);
      vm.searchPropertiesPageModel = angular.copy(options.searchPropertiesPageModel);
      vm.searchPropertiesModel = angular.copy(options.searchPropertiesDto);
      vm.title = vm.pageModel.Labels.LabelTitle.Title;
      vm.actions = options.pageModel.Actions;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.fields = formlyFormPanelDescriptors.Panelsearch.FormlyDescriptor;

      vm.docPropGrid = vm.pageModel.Grids.GridDocProp;
      var tempOptions = getGridOptions(
        vm.pageModel.Grids.GridDocProp,
        'Dms/Document/GetDocProperties/',
        function(selected) {},
        function() {
          return {};
        }
      );

      vm.pageModel.Fields.DocSubtype.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function() {
        return {
          doctypeId: vm.formModel.DocType,
        };
      };

      var onChangeFunctions = {
        DocType: function(selectedItem) {
          if (!selectedItem.key) {
            vm.formModel.DocSubtype = null;
            return;
          } else {
            vm.pageModel.Fields.DocSubtype.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function() {
              return {
                doctypeId: selectedItem.key,
              };
            };
            vm.pageModel.Fields.DocSubtype.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        DocSubtype: {
          'templateOptions.disabled': function() {
            return !vm.formModel.DocType;
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      if (!Array.isArray(vm.formModel.Properties)) vm.formModel.Properties = [];

      tempOptions.dataSource = {
        data: vm.formModel.Properties,
        pageSize: 20,
      };
      vm.docPropGridOptions = tempOptions;

      // Set functions
      vm.addItem = addItem;
      vm.removeItem = removeItem;
      vm.f22_prop_changed = f22_prop_changed;

      //=====
      // Grid
      //=====
      vm.dataSource = new kendo.data.ObservableArray([]);

      // Get labels & f22options from page model
      var propLabel = vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.label;
      var propValueLabel = vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.label;
      vm.f22options_prop = vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options;
      vm.f22options_val = vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.options;

      vm.docPropGrid = vm.pageModel.Grids.GridgridSearch;
      var tempOptions = getGridOptions(
        vm.pageModel.Grids.GridDocProp,
        'Document/NotUsed/',
        function(selected) {},
        function() {
          return {};
        }
      );

      function grid_databound(e) {
        $('.btn-remove').prop('title', vm.actions.ActionDelete.Title);
        $('.btn-new').prop('title', vm.actions.ActionNew.Title);
      }

      function getEmptyRow(rowId) {
        var row = {
          rowId: rowId,
          initialized: true,
          f22_prop: { Text: '', Value: '' },
          f22_val: { Text: '', Value: '' },
          f22options_prop: vm.f22options_prop,
          f22options_val: vm.f22options_val,
          f22_val_disabled: true,
        };
        return row;
      }

      //Selectable bugfix, ha selectable ="row" a két modális ablakban lévő f22 összeakad, és "kikékül" az F22 összes eleme...
      tempOptions.selectable = '';
      tempOptions.autoBind = true;
      //----------------------------------------------------------------------------------------------------------------------
      tempOptions.dataSource = {
        data: vm.dataSource,
        pageSize: 20,
        transport: {
          read: function(options) {
            options.success(vm.dataSource);
          },
        },
        change: function(options) {},
        batch: false,
        schema: {
          model: {
            id: 'rowId',
            fields: {
              rowId: { defaultValue: '' },
              f22_prop: { defaultValue: { Value: null } },
              f22_value: { defaultValue: { Value: null } },
              sword_value: { defaultValue: '' },
              Add: { editable: false },
              initialized: true,
              f22_val_disabled: true,
            },
          },
        },
      };

      tempOptions.columns = [
        {
          field: 'button_remove',
          title: ' ',
          filterable: false,
          template:
            '<button type="button" class="btn btn-default btn-remove" id="{{dataItem.rowId}}" title="" ng-disabled="vm.eventModel.IsReadOnly" ng-click="vm.removeItem($event)"><i class="griff-remove"></i></button>',
          width: '64px',
          attributes: {
            style: 'text-align: center;',
          },
        },
        {
          field: 'f22_prop',
          title: propLabel,
          filterable: false,
          template:
            '<f22-input id="f22_prop_{{dataItem.rowId}}" ng-model="dataItem.f22_prop" f2-options="vm.f22options_prop" changed="vm.f22_prop_changed(this, selectedItem)"></f22-input>',
        },
        {
          field: 'f22_val',
          title: propValueLabel,
          filterable: false,
          template:
            '<f22-input id="f22_val_{{dataItem.rowId}}" ng-if="dataItem.initialized" ng-disabled="dataItem.f22_val_disabled" style="width: 100%" ng-model="dataItem.f22_val" f2-options="dataItem.f22options_val" ></f22-input>' +
            '<input ng-if="!dataItem.initialized" ng-disabled="!!dataItem.f22_prop && !!dataItem.f22_prop.value" class="form-control" type="text" ng-model="dataItem.sword_value" />',
        },
        {
          field: 'button_new',
          title: ' ',
          filterable: false,
          template:
            '<button type="button" id="{{dataItem.rowId}}" class="btn btn-default btn-new" title="" ng-disabled="vm.eventModel.IsReadOnly" ng-click="vm.addItem($event)"><i class="griff-add"></i></button>',
          width: '64px',
          attributes: {
            style: 'text-align: center;',
          },
        },
      ];
      tempOptions.dataBound = grid_databound;
      vm.searchGridOptions = tempOptions;

      // initial data for the grid
      //------------------
      var row = getEmptyRow(0);
      vm.dataSource.push(row);
      // End of init

      function f22_prop_changed(element, selectedItem) {
        if (!selectedItem.GridItem) {
          return;
        }

        var rowId = element.dataItem.rowId;
        var gridItem = selectedItem.GridItem;
        var text = selectedItem.Text;
        var value = selectedItem.Value;

        var adopterId = '';
        var jointable = '';
        var joinfield = '';
        var freeText = false;
        var writeable = false;
        var patternMatchMode = 0;
        var filteringMode = 0;
        if (typeof gridItem !== 'undefined') {
          adopterId = gridItem.adopterid;
          jointable = gridItem.jointable;
          joinfield = gridItem.joinfield;
        }

        // Get new gridOptions to value f22
        var rowIndex = getIndexByRowId(rowId);
        vm.dataSource[rowIndex].f22_val.Text = '';
        vm.dataSource[rowIndex].f22_val.Value = '';
        vm.dataSource[rowIndex].initialized = false;

        if (!!adopterId && adopterId != '') {
          if (jointable == '' || joinfield == '') {
            return;
          }
          $http
            .post('F22/GetDynamicF22FieldModel', {
              installAdopter:
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
              adopter: adopterId,
              table: jointable,
              key: joinfield,
              value: gridItem.showdata,
              freeText: false,
              writable: false,
              filteringMode: 0,
              patternMatchMode: 0,
            })
            .then(function(result) {
              // Set it on the appropriate f22 value input
              var f22_fieldModel = result.data;

              // generate options by field model
              F22Helpers.setF22Options(f22_fieldModel);
              f22_fieldModel.templateOptions.options.adopter = adopterId;

              vm.dataSource[rowIndex].f22options_val = f22_fieldModel.templateOptions.options;
              vm.dataSource[rowIndex].f22_val_disabled = false;
              vm.dataSource[rowIndex].f22options_val.modalTitle = text;
              // re-init f22 with bound ngif
              vm.dataSource[rowIndex].initialized = true;
            });
        }
      }

      function getIndexByRowId(rowId) {
        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (row.rowId == rowId) {
            return i;
          }
        }
        //not found
        return -1;
      }
      function getMaxRowId() {
        var maxRowId = -1;
        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (row.rowId > maxRowId) {
            maxRowId = row.rowId;
          }
        }
        return maxRowId;
      }

      function addItem($event) {
        var rowId = getMaxRowId() + 1;
        var row = getEmptyRow(rowId);
        vm.dataSource.push(row);
      }

      function removeItem($event) {
        var grid = $('#gridSearch').data('kendoGrid');

        var rowId = $event.currentTarget.id;
        var rowIndex = getIndexByRowId(rowId);

        var dataItem = vm.dataSource[rowIndex];
        grid.dataSource.remove(dataItem);

        if (vm.dataSource.length <= 0) {
          // Do not let the rows to be cleared
          // as the user will not be able to add new rows!
          var row = getEmptyRow(0);
          vm.dataSource.push(row);
        }
      }

      vm.createProperty = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/Document/DocPropertyModModal.html',
          controller: 'DocPropertyModCtrl_dms',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve: {
            options: {
              pageModel: vm.searchPropertiesPageModel,
              dto: angular.copy(vm.searchPropertiesModel),
            },
          },
        });

        modalInstance.result.then(function(result) {
          result.DocPropId = lodash.maxBy(vm.formModel.Properties, 'DocPropId') + 1;
          vm.formModel.Properties.push(result);
          vm.docPropGrid.dataSource.read();
        });
      };

      vm.editProperty = function() {
        var selectedItem = vm.docPropGrid.dataItem(vm.docPropGrid.select());
        if (!selected) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
          return;
        }
        var selectedIndex = lodash.findIndex(vm.formModel.Properties, selectedItem);

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/Document/DocPropertyModModal.html',
          controller: 'DocPropertyModCtrl_dms',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve: {
            options: {
              pageModel: vm.searchPropertiesPageModel,
              dto: selectedItem,
            },
          },
        });

        modalInstance.result.then(function(result) {
          vm.formModel.Properties[selectedIndex].PropertyId = result.PropertyId;
          vm.formModel.Properties[selectedIndex].Value = result.Value;
          vm.formModel.Properties[selectedIndex].OriginalPropertyId = result.OriginalPropertyId;
          vm.docPropGrid.dataSource.read();
        });
      };

      vm.deleteProperty = function() {
        var selected = vm.docPropGrid.dataItem(vm.docPropGrid.select());
        if (!selected) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
          return;
        }

        var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Confirm,
              className: 'btn-primary',
              callback: function() {
                lodash.remove(vm.formModel.Properties, function(p) {
                  return selected.DocPropId == p.DocPropId;
                });
                vm.docPropGrid.dataSource.read();
              },
            },
          },
        });
      };

      vm.cancel = function() {
        mi.close();
      };

      vm.save = function() {
        //build result set
        var resultSet = vm.formModel;

        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (!isNullOrEmpty(row.f22_prop.Value)) {
            //F22 value
            if (!isNullOrEmpty(row.f22_val.Value)) {
              resultSet.Properties.push({
                PropertyId: row.f22_prop.Value,
                Value: {
                  Value: row.f22_val.Value,
                  Text: row.f22_val.Text,
                },
                SearchMode: 'f22',
              });
            }
            //FreeText
            else if (!isNullOrEmpty(row.sword_value)) {
              resultSet.Properties.push({
                PropertyId: row.f22_prop.Value,
                Value: {
                  Value: row.sword_value,
                  Text: row.sword_value,
                },
                SearchMode: 'freetext',
              });
            }
          }
        }

        mi.close(resultSet);
      };

      function isNullOrEmpty(str) {
        if (typeof str == 'undefined') return true;
        if (str == null) return true;
        if (str == '') return true;

        return false;
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentEditCtrl_dms', [
    '$rootScope',
    '$scope',
    '$http',
    '$state',
    'options',
    '$filter',
    'AuthService',
    '$uibModal',
    'lodash',
    'DmsLockService',
    'UIHelperService',
    function($rootScope, $scope, $http, $state, options, $filter, authService, $uibModal, lodash, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentEditCtrl_dms', stateParams);
      }
      main: {
        var vm = this;

        vm.back = back;
        vm.hasDasParameters = hasDasParameters;

        if (!!options.DisableRejection) {
          vm.formModel = 0;
          vm.back();
          break main;
        }
       $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
         vm.tokenLogin = !!authService?.user?.tokenLogin;
    });
      vm.tokenLogin = !!authService?.user?.tokenLogin;
      vm.tokenLoginFunc = function() {
        return vm.tokenLogin;
      }
        vm.UIHelperService = UIHelperService;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        vm.securedProgramId = options.programId;
        vm.securedId = options.id;
        lockService.initiateLock(vm.securedProgramId, vm.securedId);

        vm.pageModel = options.pageModel;
        vm.formModel = options.dto;

        function kendoMSInit(field) {
          vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
        }

        kendoMSInit('permission');
        //ha nem új feltöltés, nincs multiselect!
        vm.pageModel.Fields.Files.FormlyFieldDescriptor.templateOptions.DynamicOptions.MultipleFileUpload =
          vm.formModel.ModelState == 2;

        vm.docPropertiesPageModel = options.docPropertiesPageModel;
        vm.docPropertiesModel = options.docPropertiesDto;
        vm.defaultPropDocId = vm.formModel.ModelState == 3 ? vm.formModel.docID : 0;
        vm.properties =
          lodash.map(options.docProperties, function(p) {
            return convertPropertyModToPropertyGridItemOnLoad(p);
          }) ?? [];
        vm.isFormReadOnly = $state.params.controllerOptions.isFormReadOnly;
        vm.selectedPath = { text: '', id: '' };
        // Get the parameters from the angularjs route
        var dasTableId = $state.params.dasTableId;
        var dasOwnerId = $state.params.dasOwnerId;
        vm.formModel.DasTableId = dasTableId;
        vm.formModel.DasOwnerId = dasOwnerId;

        //Lementjük a modellt, hogy meg lehessen állapítani, hogy változott-e valami
        vm.origModel = angular.copy(vm.formModel);
        vm.origProperties = lodash.map(vm.properties, function(p) {
          return convertPropertyGridItemToPropertyMod(p);
        });

        function hasDasParameters() {
          if (!vm.formModel.DasTableId) return false;
          if (!vm.formModel.DasOwnerId) return false;

          if (vm.formModel.DasTableId === '') return false;
          if (vm.formModel.DasOwnerId === '') return false;

          return true;
        }

        if (vm.isFormReadOnly) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            if (key !== 'Valid') {
              value.FormlyFieldDescriptor.templateOptions.disabled = true;
            }
          });
        } else {
          if (vm.formModel.ModelState == 3 && vm.formModel.docID != 0) {
            vm.pageModel.Fields.type.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        }

        $scope.$watch('vm.formModel.type', function(newValue, oldValue) {
          if (newValue == 0) {
            vm.formModel.storageplace = null;
          }
          if (newValue == 1) {
            vm.formModel.Files = null;
            //TODO az uploaded file listát kiüríteni
          }
          if (newValue == 2) {
            vm.formModel.Files = null;
            //TODO az uploaded file listát kiüríteni
            vm.formModel.storageplace = null;
          }
        });

        function back() {
          if (vm.hasDasParameters()) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go($state.params.BackTo, {
              dasTableId: vm.formModel.DasTableId,
              dasOwnerId: vm.formModel.DasOwnerId,
              lockPreviousState: false,
            });
          } else {
            $state.go($state.params.BackTo);
          }
        }

        vm.cancel = function() {
          if (vm.hasDasParameters()) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go($state.params.BackTo, {
              dasTableId: vm.formModel.DasTableId,
              dasOwnerId: vm.formModel.DasOwnerId,
              lockPreviousState: false,
            });
          } else {
            $state.go($state.params.BackTo);
          }
        };

        /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
        var eventHandlers = {
          Files: {
            onComplete: function(e) {
              console.log(e);
            },
            onError: function(e) {},
            onSuccess: function(e) {
                if (e.response?.ResultStatus) {
                  if (e.operation === 'upload') {
                    //Csak akkor vegye át a fájlnevet, ha az üres
                    if (!vm.formModel.name || vm.formModel.name.trim() == '')
                      vm.formModel.name = e.response.FileIdentifiers[0].OriginalName.replace(/\.[^.$]+$/, '');
                    $scope.$apply();
                    if (!vm.formModel.UploadedFiles) {
                      vm.formModel.UploadedFiles = e.response.FileIdentifiers;
                    } else {
                      angular.forEach(e.response.FileIdentifiers, function(value) {
                        vm.formModel.UploadedFiles.push({
                          StoredName: value.StoredName,
                          OriginalName: value.OriginalName,
                        });
                      });
                    }
                  } else if (e.operation === 'remove') {
                    if (vm.formModel.UploadedFiles) {
                      var forDelete = [];
                      angular.forEach(e.response.FileIdentifiers, function(value) {
                        forDelete.push(value);
                      });
                      for (var i = 0; i < forDelete.length; i++) {
                        for (var j = 0; j < vm.formModel.UploadedFiles.length; j++) {
                          if (forDelete[i].StoredName === vm.formModel.UploadedFiles[j].StoredName) {
                            vm.formModel.UploadedFiles.splice(j, 1);
                          }
                        }
                      }
                    }
                  }
                }
                else{
                  e.preventDefault();
                  toastr.error(e.response.ErrorMessages);
                }
            },
            onRemoveFileFromDb: function(file) {
              //már tárolt dokumentumot csak új verzió létrehozásakor lehet törölni, ilyenkor már csak egy tárolt dokumentum van a tömbben, így törölhető.
              if (file) {
                vm.formModel.StoredFiles = [];
              }
              //ez akkor szükséges, ha módosításnál is változtatható a dokumentum (jelenleg nem)
              //if (file) {
              //    var sf = lodash.findLast(vm.formModel.StoredFiles, function (sf) { return sf.DocFilesId === file.storedDoc.DocFilesId; });
              //    sf.ToRemove = true;
              //}
            },
          },
        };
        ////////////////////////////////////////////////////////////////////////////////////////

        var onChangeFunctions = {
          doctypeId: function(selectedItem) {
            if (!selectedItem.key) {
              vm.formModel.docsubtypeId = null;
              return;
            } else {
              vm.pageModel.Fields.docsubtypeId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function() {
                return {
                  doctypeId: selectedItem.key,
                };
              };
              vm.pageModel.Fields.docsubtypeId.FormlyFieldDescriptor.templateOptions.options?.dataSource?.read();
            }
            //lekérjük a típushoz rendelt tulajdonságokat
            $http
              .post('Dms/Document/GetDocPropertiesByDocType', { docTypeId: selectedItem.key })
              .then(function(response) {
                var mapped = lodash.map(response.data.props, function(p) {
                  return convertPropertyModToPropertyGridItem(p);
                });
                var diff = lodash.differenceBy(mapped, vm.properties, 'propertyID');
                vm.properties.push.apply(vm.properties, diff);
                vm.docPropGrid?.dataSource();
              })
              .catch(function(response) {
                //TODO
              });
          },
          permission: function(selectedItem) {
            if (!!selectedItem) {
              let index = selectedItem.indexOf('0'),
                length = selectedItem.length;
              if (length > 1 && index >= 0) {
                selectedItem.splice(index, 1);
              } else if (length < 1) {
                selectedItem.push(0);
              }
            }
            vm.formModel.permission = selectedItem.join();
          },
        };

        var customExpressionProperties = {
          Files: {
            'templateOptions.disabled': function() {
              if (vm.formModel.ModelState == 0 || vm.formModel.ModelState == 1) return true;
              //Type már nincs használatban?
              //return vm.formModel.type != '0' && vm.formModel.type != '1';

              return vm.formModel.docID > 0 && vm.formModel.ModelState == 3; //ha módosításban vagyunk és van docId
            },
          },
          begindate: {
            'templateOptions.disabled': function() {
              return vm.formModel.docID != 0;
            },
          },
          docsubtypeId: {
            'templateOptions.disabled': function() {
              return !vm.formModel.doctypeId;
            },
          },
        };

        var syncValidators = {
          enddate: {
            EndDateValidator: function(modelValue) {
              if (modelValue) {
                var begin = new Date(vm.formModel.begindate);
                var end = new Date(modelValue);
                return end >= begin;
              }
              return true;
            },
          },
        };

        InsertEventHandlers(vm.pageModel, eventHandlers);
        InsertSyncValidators(vm.pageModel, syncValidators);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        if (!vm.isFormReadOnly) {
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.documentFields = formlyFormPanelDescriptors.PanelDocuments.FormlyDescriptor;

        vm.docPropGrid = vm.pageModel.Grids.GridDocProp;
        vm.selectedGridItem = null;
        var tempOptions = getGridOptions(
          vm.pageModel.Grids.GridDocProp,
          'Dms/Document/GetDocProperties/',
          function(selected) {
            vm.selectedGridItem = selected;
            $scope.$apply();
          },
          function() {
            return { docId: vm.formModel.docID, docTypeId: vm.formModel.doctypeId };
          }
        );
        tempOptions.dataSource = {
          data: null,
          pageSize: 20,
        };
        tempOptions.dataBound = function(e) {
          if (JSON.stringify(e.sender.dataSource.data()) !== JSON.stringify(vm.properties)) {
            e.sender.dataSource.data(vm.properties);
          }
        };
        vm.docPropGridOptions = tempOptions;

        $scope.$watch('vm.docPropGrid.setOptions', function(newvalue, oldvalue) {
          if (!oldvalue && !!newvalue) {
            vm.docPropGrid.setOptions(vm.docPropGridOptions);
          }
        });

        vm.pageModel.Fields.docsubtypeId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function() {
          return {
            doctypeId: vm.formModel.doctypeId,
          };
        };

        vm.createProperty = function() {
          //var url = "Document/DocumentPropertiesEdit";

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Dms/Document/DocPropertyModModal.html',
            controller: 'DocPropertyModCtrl_dms',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              options: {
                pageModel: angular.copy(vm.docPropertiesPageModel),
                dto: angular.copy(vm.docPropertiesModel),
              },
            },
          });

          modalInstance.result.then(function(result) {
            if (!result) return;
            var item = convertPropertyModToPropertyGridItem(result);
            if (
              !result.multiple &&
              lodash.some(vm.properties, function(p, k) {
                return item.propertyID == p.propertyID;
              })
            ) {
              toastr.warning(
                (item.propertyName != '' ? 'A(z) ' + item.propertyName + ' n' : 'N') +
                  'em többszörösen csatolható tulajdonság!',
                vm.pageModel.Messages.Warning
              );
              return;
            }

            if (
              lodash.some(vm.properties, function(p, k) {
                return item.propertyID == p.propertyID && item.value == p.value;
              })
            ) {
              toastr.warning('Már létező tulajdonság!', vm.pageModel.Messages.Warning);
              return;
            }

            vm.properties.push(item);
            vm.formly.$setDirty();
            vm.docPropGrid?.dataSource?.read();
          });
        };

        vm.editProperty = function() {
          var selected = vm.docPropGrid.dataItem(vm.docPropGrid.select());
          if (!selected) {
            toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
            return;
          }
          var selectedItem = convertPropertyGridItemToPropertyMod(selected);
          var selectedIndex = vm.docPropGrid.select().index();

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Dms/Document/DocPropertyModModal.html',
            controller: 'DocPropertyModCtrl_dms',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              options: {
                pageModel: vm.docPropertiesPageModel,
                dto: selectedItem,
              },
            },
          });

          modalInstance.result.then(function(result) {
            //cancel
            if (!result) return;
            //save
            var item = convertPropertyModToPropertyGridItem(result);
            if (
              !result.multiple &&
              lodash.some(vm.properties, function(p, k) {
                return k != selectedIndex && item.propertyID == p.propertyID;
              })
            ) {
              toastr.warning(
                (item.propertyName != '' ? 'A(z) ' + item.propertyName + ' n' : 'N') +
                  'em többszörösen csatolható tulajdonság!',
                vm.pageModel.Messages.Warning
              );
              return;
            }
            if (
              lodash.some(vm.properties, function(p, k) {
                return k != selectedIndex && item.propertyID == p.propertyID && item.value == p.value;
              })
            ) {
              toastr.warning('Már létező tulajdonság!', vm.pageModel.Messages.Warning);
              return;
            }
            vm.properties[selectedIndex] = item;
            vm.formly.$setDirty();
            vm.docPropGrid?.dataSource?.read();
          });
        };

        vm.deleteProperty = function() {
          var selected = vm.docPropGrid.dataItem(vm.docPropGrid.select());
          if (!selected) {
            toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
            return;
          }

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  lodash.remove(vm.properties, function(p) {
                    return selected.propertyID == p.propertyID && selected.value == p.value;
                  });
                  vm.formly.$setDirty();
                  vm.docPropGrid?.dataSource?.read();
                },
              },
            },
          });
        };

        vm.duplicateProperty = function() {
          var selected = vm.docPropGrid.dataItem(vm.docPropGrid.select());
          if (!selected) {
            toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
            return;
          }
          var selectedItem = convertPropertyGridItemToPropertyMod(selected);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Dms/Document/DocPropertyModModal.html',
            controller: 'DocPropertyModCtrl_dms',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              options: {
                pageModel: vm.docPropertiesPageModel,
                dto: selectedItem,
              },
            },
          });

          modalInstance.result.then(function(result) {
            if (!result) return;
            var item = convertPropertyModToPropertyGridItem(result);
            if (
              !result.multiple &&
              lodash.some(vm.properties, function(p, k) {
                return item.propertyID == p.propertyID;
              })
            ) {
              toastr.warning(
                (item.propertyName != '' ? 'A(z) ' + item.propertyName + ' n' : 'N') +
                  'em többszörösen csatolható tulajdonság!',
                vm.pageModel.Messages.Warning
              );
              return;
            }

            if (
              lodash.some(vm.properties, function(p, k) {
                return item.propertyID == p.propertyID && item.value == p.value;
              })
            ) {
              toastr.warning('Már létező tulajdonság!', vm.pageModel.Messages.Warning);
              return;
            }
            vm.properties.push(item);
            vm.formly.$setDirty();
            vm.docPropGrid?.dataSource?.read();
          });
        };

        function convertPropertyGridItemToPropertyMod(item) {
          var itemCopy = angular.copy(vm.docPropertiesModel);
          itemCopy.value = { Value: item.value, Text: item.name };
          itemCopy.valueString = item.value;
          itemCopy.docpropID = item.docpropID;
          itemCopy.propertyID = item.propertyID;
          itemCopy.propertyname = item.propertyName;
          itemCopy.table = item.table;
          itemCopy.key = item.key;
          itemCopy.showData = item.showData;
          itemCopy.adopter = item.adopter;
          itemCopy.multiple = item.multiple;
          return itemCopy;
        }

        function convertPropertyModToPropertyGridItem(item) {
          var isF2 = !!item.table && item.table != '';
          return {
            docID: vm.formModel.ModelState == 3 ? vm.formModel.docID : 0,
            docpropID: vm.formModel.ModelState == 3 ? item.docpropID : 0,
            propertyID: item.propertyID,
            name: isF2 ? (item.value ? item.value.Text : null) : item.valueString ? item.valueString : null,
            value: isF2 ? (item.value ? item.value.Value : null) : item.valueString ? item.valueString : null,
            propertyName: item.propertyname,
            table: item.table,
            key: item.key,
            showData: item.showData,
            adopter: item.adopter,
            multiple: item.multiple,
            readOnly: item.readOnly,
          };
        }

        function convertPropertyModToPropertyGridItemOnLoad(item) {
          return {
            docID: vm.formModel.ModelState == 3 ? vm.formModel.docID : 0,
            docpropID: vm.formModel.ModelState == 3 ? item.docpropID : 0,
            propertyID: item.propertyID,
            name: item.value ? item.value.Text : null,
            value: item.value ? item.value.Value : null,
            propertyName: item.propertyname,
            table: item.table,
            key: item.key,
            showData: item.showData,
            adopter: item.adopter,
            multiple: item.multiple,
            readOnly: item.readOnly,
          };
        }

        vm.formNotChanged = function() {
          return (
            angular.equals(vm.formModel, vm.origModel) &&
            angular.equals(
              lodash.map(vm.properties, function(p) {
                return convertPropertyGridItemToPropertyMod(p);
              }),
              vm.origProperties
            )
          );
        };

        vm.save = function() {
          //tulajdonságok vizsgálata
          //TODO: Backenden viszgálva van, de kell vizsgálni JS-ből is???
          // if (lodash.filter(vm.properties, function (p) { return (p.propertyID.startsWith("fp") && !p.value) ? true : false; }).length > 0) {
          // toastr.warning("Nincs minden tulajdonsághoz érték");
          // return;
          // }

          var url = 'Dms/Document/DocumentEdit';

          if ($state.params.controllerOptions.isNewVersion === true) {
            if (vm.formNotChanged()) {
              toastr.warning('Nem történt változás, nem hozható létre új verzió!', vm.pageModel.Messages.Warning);
              return false;
            }
            url = 'Dms/Document/DocumentNewVersion';
          } else {
            if (vm.formModel.ModelState == 4) {
              vm.formModel.docID = 0;
            }
          }

          $http
            .post(url, {
              model: vm.formModel,
              properties: lodash.map(vm.properties, function(p) {
                return convertPropertyGridItemToPropertyMod(p);
              }),
            })
            .then(function(response) {
              vm.formly.$setPristine();
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              if (!!response.data.ids && response.data.ids.length === 1) {
                $state.go('Document.DocumentEdit', {
                  id: response.data.ids[0],
                  dasTableId: vm.formModel.DasTableId,
                  dasOwnerId: vm.formModel.DasOwnerId,
                });
              } else if (vm.formModel.docID > 0 && $state.params.controllerOptions.isNewVersion !== true) {
                $state.go(
                  'Document.DocumentEdit',
                  { id: vm.formModel.docID, dasTableId: vm.formModel.DasTableId, dasOwnerId: vm.formModel.DasOwnerId },
                  { reload: true }
                );
              } else {
                $state.go('Document.DocumentNavOpen', {
                  dasTableId: vm.formModel.DasTableId,
                  dasOwnerId: vm.formModel.DasOwnerId,
                });
              }
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
              vm.formly.$setDirty();
            });
        };
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentLayoutCtrl_dms', [
    'breadcrumbRoots',
    '$scope',
    'UIHelperService',
    function(breadcrumbRoots, $scope, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentLayoutCtrl_dms', stateParams);
      }
      var vm = this;

      $scope.breadcrumbRoot = breadcrumbRoots.dmsApp && breadcrumbRoots.dmsApp.document;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentMenuCtrl_dms', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentMenuCtrl_dms', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'main' };

      //var desc = {};

      var desc = {
        Document_DocumentNav: { icon: 'fa fa-file-text' },
        Masterdata_Document: { icon: 'fa fa-file-text' },
      };

      var itemsCnt = Object.keys(desc).length;
      if (itemsCnt > 0) {
      }
      vm.menus = [];
      buildMenu($state, authService, 'Document', 'document', backMenu, desc).then(function(m) {
        vm.menus = m;
        console.log('menus: ', m);
      });
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentNavCtrl_dms', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$http',
    '$state',
    'options',
    '$filter',
    'AuthService',
    '$uibModal',
    'gridService',
    'UIHelperService',
    '$location',
    function(
      $rootScope,
      $scope,
      $timeout,
      $http,
      $state,
      options,
      $filter,
      authService,
      $uibModal,
      gridService,
      UIHelperService,
      $location
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentNavCtrl_dms', stateParams);
      }
      var vm = this;
       $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
         vm.tokenLogin = !!authService?.user?.tokenLogin;
    });
      vm.tokenLogin = !!authService?.user?.tokenLogin;
            vm.tokenLoginFunc = function() {
        return vm.tokenLogin;
      }
      vm.showBackButton = !$state.params?.window;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.searchModel = options.searchModel;
      vm.searchDto = options.searchDto;
      vm.searchDtoEmpty = options.searchDto;
      vm.searchPropertiesPageModel = options.searchPropertiesPageModel;
      vm.searchPropertiesDto = options.searchPropertiesDto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.pathTree = options.pathTree;
      vm.currentUserID = authService.user.id;
      vm.isDocumentCheckedOut = true;
      vm.notAttachedState = false;
      vm.notAttachedStateAll = false;
      vm.hasDms = options.hasDms;

      // Get the parameters from the angularjs route
      var dasTableId = $state.params.dasTableId;
      var dasOwnerId = $state.params.dasOwnerId;
      var getLocalStorageKeyForNavView = function() {
        return 'Is.' + authService.user.id + '.DmsDocumentNavViewGridOrTree';
      };

      vm.formModel.DasTableId = dasTableId;
      vm.formModel.DasOwnerId = dasOwnerId;

      vm.hasDasParameters = function() {
        if (!vm.formModel.DasTableId) return false;
        if (!vm.formModel.DasOwnerId) return false;

        if (vm.formModel.DasTableId === '') return false;
        if (vm.formModel.DasOwnerId === '') return false;

        return true;
      };

      vm.hasAttachedGrid = vm.hasDasParameters() && vm.hasDms;

      //prevState mentése:------------------------------------------------------------------------------------------------
      //state.go esetén, ha aparaméterben jön a lockPreviousState = true, akkor mentjük az előző state-et:
      if (
        !!$state.previous &&
        !!$state.previous.name &&
        $state.previous.name != '' &&
        $state.params.lockPreviousState
      ) {
        localStorage.setItem(
          'dmsBackToStateAndParams',
          JSON.stringify({
            state: '' + $state.previous.name + '',
            params: $state.previous.params,
          })
        );
      }
      //------------------------------------------------------------------------------------------------------------------

      vm.back = function() {
        var backState = localStorage.getItem('dmsBackToStateAndParams');
        if (!!backState) {
          var backStateJson = JSON.parse(backState);
          $state.go(backStateJson.state, backStateJson.params);
        } else {
          if (!!$state.previous && !!$state.previous.name && $state.previous.name != '') {
            if (vm.hasDasParameters) {
              $state.go($state.previous.name, {
                tableId: vm.formModel.DasTableId,
                ownerId: vm.formModel.DasOwnerId,
                lockPreviousState: false,
                id: vm.formModel.DasOwnerId,
              });
            } else {
              $state.go($state.previous.name, $state.previous.params);
            }
          } else $state.go(!!$state.params.BackTo ? $state.params.BackTo : 'main');
        }
      };

      vm.activeSubItemTab = 0;
      vm.activeMainItemTab = 0;

      vm.getFilters = function() {
        // build & set dto parameters
        var properties = [];
        if (!!vm.searchDto) {
          angular.forEach(vm.searchDto.Properties, function(value, key) {
            properties.push({
              Id: angular.copy(key),
              PropertyId: angular.copy(value.PropertyId),
              Value: {
                Value: angular.copy(value.Value.Value),
                Text: angular.copy(value.Value.Text),
              },
            });
          });
          vm.searchDto.Properties = properties;
          return angular.copy(vm.searchDto);
        }
        return null;
      };
      //TreeView fnkciók-------------------------------------------------------------------------------------------------------------------------------------------------------------------
      var localData = '';

      vm.gridView = function() {
        delete vm.selectedMainGridItem;
        delete vm.selectedMainGridItemId;

        vm.gridViewEnabled = true;
        vm.treeViewEnabled = false;
        //törlöm a treeViewhez tartozó adatokat;
        delete vm.treeOptions;
        delete vm.detailsFormModel;
        delete vm.detailsPageModel;
        delete vm.detailsFields;
        //elmentem hogy grid jelenjen meg ha visszanavigálunk majd
        localStorage.setItem(getLocalStorageKeyForNavView(), 'grid');
      };

      vm.treeView = function() {
        delete vm.selectedMainGridItem;
        delete vm.selectedMainGridItemId;

        vm.gridViewEnabled = false;
        vm.treeViewEnabled = true;

        vm.orientation = 'horizontal';
        vm.panes = [{ collapsible: true, size: '40%' }, { collapsible: true }];

        localStorage.setItem(getLocalStorageKeyForNavView(), 'tree');
        $http({
          method: 'POST',
          url: 'Dms/Document/GetFileTree/',
          data: { searchDto: vm.getFilters() },
        }).then(function successCallback(response) {
          localData = response.data;
          vm.treeOptions = {
            dataSource: {
              transport: {
                read: function(options) {
                  var id = options.data.docID;
                  var data = get(localData, id);
                  console.log(data);
                  if (data) {
                    // item is available in local data
                    options.success(data);
                  } else {
                    console.log('else');
                    $.ajax({
                      type: 'POST',
                      url: 'Dms/Document/GetFileTree',
                      cache: false,
                      data: {
                        pathId: options.data.docID,
                        searchDto: vm.getFilters(),
                      },
                      success: function(result) {
                        options.success(result);
                      },
                    });
                  }
                },
              },
              schema: {
                model: {
                  id: 'docID',
                  fields: {
                    id: { type: 'number' },
                    isFile: { type: 'boolean' },
                    isDocument: { type: 'boolean' },
                    text: { type: 'string' },
                    filename: { type: 'string' },
                    parentId: { type: 'number' },
                  },
                },
              },
            },
            select: function(e) {
              e.preventDefault();
              var tree = $('#treeView').data('kendoTreeView');
              var dataItem = tree.dataItem(e.node);
              vm.treeViewId = dataItem.docID;
              vm.selectedMainGridItem = dataItem;
              if (dataItem.isFile) {
                $('.treeViewSelectedFile').removeClass('treeViewSelectedFile');
                loadSelectedTreeItemFields(dataItem.docID);
                $(e.node)
                  .find('span.k-in')
                  .addClass('treeViewSelectedFile');
              } else {
                if (dataItem.expanded) tree.collapse(e.node);
                else tree.expand(e.node);
              }
            },
          };
        });
      };
      //init grid/tree view:

      if (localStorage.getItem(getLocalStorageKeyForNavView()) === 'tree') {
        vm.treeView();
      } else {
        vm.gridView();
      }

      function loadSelectedTreeItemFields(id) {
        $http({
          method: 'GET',
          url: 'Dms/Document/DocumentQuickView',
          params: { id: id },
        }).then(function successCallback(response) {
          vm.detailsPageModel = response.data.pageModel;
          vm.detailsFormModel = response.data.dto;

          vm.detailsPageModel.Fields['permission'].FormlyFieldDescriptor.type = 'kendoMS';
          vm.detailsPageModel.Fields['permission'].FormlyFieldDescriptor.templateOptions.disabled = true;

          angular.forEach(vm.detailsPageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });

          var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.detailsPageModel);
          vm.detailsFields = formlyFormPanelDescriptors.PanelDocuments.FormlyDescriptor;
          InsertEventHandlers(vm.detailsPageModel, eventHandlers);
          var gridRef = $('#subGridDocPropInTree').data('kendoGrid');
          gridRef?.dataSource?.read();
        });
      }

      function get(data, id) {
        if (!id) {
          return data;
        } else {
          for (var i = 0; i < data.length; i++) {
            vm.selectedMainGridItemId = id;
            if (data[i].id === id) {
              return data[i].items;
            } else if (data[i].items) {
              var result = get(data[i].items, id);
              if (result) return result;
            }
          }
        }
      }
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      var eventHandlers = {
        Files: {
          onComplete: function(e) {},
          onError: function(e) {},
          onSuccess: function(e) {},
          onRemoveFileFromDb: function(file) {},
        },
      };
      ////////////////////////////////////////////////////////////////////////////////////////

      // Main item menu actions
      vm.createMainItem = function() {
        $state.go('Document.DocumentCreate', {
          id: 0,
          dasTableId: vm.formModel.DasTableId,
          dasOwnerId: vm.formModel.DasOwnerId,
        });
      };

      vm.getSelectedId = function() {
        if (vm.gridViewEnabled) {
          if (!vm.selectedMainGridItem || !vm.selectedMainGridItem['docID']) {
            toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
            return false;
          }
          return vm.selectedMainGridItem['docID'];
        }

        if (vm.treeViewEnabled) {
          if (!vm.detailsFormModel || !vm.detailsFormModel.docID) {
            toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
            return false;
          }
          return vm.detailsFormModel.docID;
        }

        return false;
      };

      vm.editMainItem = function() {
        var id = vm.getSelectedId();
        $state.go('Document.DocumentEdit', {
          id: id,
          dasTableId: vm.formModel.DasTableId,
          dasOwnerId: vm.formModel.DasOwnerId,
        });
      };

      vm.duplicateMainItem = function() {
        var id = vm.getSelectedId();
        $state.go('Document.DocumentDuplicate', {
          id: id,
          dasTableId: vm.formModel.DasTableId,
          dasOwnerId: vm.formModel.DasOwnerId,
          isDuplicate: true,
        });
      };

      vm.viewMainItem = function(openNewTab) {
        if (!vm.selectedMainGridItem || !vm.selectedMainGridItem['docID']) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
          return;
        }
        if (vm.selectedMainGridItem.isDocument) {
          if (openNewTab === true) {
            var newTab = window.open('Dms/Document/DocumentOpenByDocId/' + vm.selectedMainGridItem['docID'], '_blank');
            newTab.onload = function() {
              setTimeout(function() {
                newTab.document.title =
                  vm.selectedMainGridItem.name + vm.selectedMainGridItem.extension === vm.selectedMainGridItem.filename
                    ? vm.selectedMainGridItem.filename
                    : vm.selectedMainGridItem.name + ' (' + vm.selectedMainGridItem.filename + ')';
              }, 500);
            };
            newTab.onbeforeunload = function(e) {
              toastr.warning(
                'A kért fájl megjelenítése a böngészőben nem lehetséges! A fájl letöltésre került.',
                vm.pageModel.Messages.Warning
              );
            };
          } else {
            vm.downloadFile(vm.selectedMainGridItem['docID'], vm.selectedMainGridItem.filename);
          }
          return;
        }
        var id = vm.getSelectedId();
        $state.go('Document.DocumentView', {
          id: id,
          dasTableId: vm.formModel.DasTableId,
          dasOwnerId: vm.formModel.DasOwnerId,
        });
      };

      vm.downloadFile = function(docid, docname) {
        $http
          .post(
            'Dms/Document/DocumentDownloadByDocId',
            { id: docid },
            {
              responseType: 'arraybuffer',
              transformResponse: function(data) {
                var pdf;
                if (data) {
                  pdf = new Blob([data], {
                    type: 'application/pdf',
                  });
                }
                return {
                  response: pdf,
                };
              },
            }
          )
          .then(function(data, status, headers, config) {
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(data.data.response, docname);
            } else {
              var fileURL = URL.createObjectURL(data.data.response);
              var a = document.createElement('a');
              a.href = fileURL;
              a.target = '_blank';
              a.download = docname;
              document.body.appendChild(a);
              a.click();
            }
          })
          .catch(function(data, status, headers, config) {
            //TODO when WS error
          });
      };

      vm.deleteMainItem = function() {
        var id = vm.getSelectedId();
        var dialogMessage = vm.pageModel.Messages.ConfirmArchive;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Confirm,
              className: 'btn-primary',
              callback: function() {
                $http.post('Dms/Document/DocumentDelete', { id: id }).then(function(data) {
                  toastr.success(vm.messages.ArchiveSuccessful);
                  vm.refreshActiveTab();
                });
              },
            },
          },
        });
      };

      vm.destroyMainItem = function() {
        var id = vm.getSelectedId();
        var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Confirm,
              className: 'btn-primary',
              callback: function() {
                $http.post('Dms/Document/DocumentDestroy', { id: id }).then(function(data) {
                  toastr.success(vm.messages.DeleteSuccessful);
                  vm.refreshActiveTab();
                });
              },
            },
          },
        });
      };

      vm.search = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/Document/DocSearchModal.html',
          controller: 'DocSearchCtrl_dms',
          controllerAs: 'vm',
          backdrop: 'static',
          size: 'lg',
          keyboard: false,
          resolve: {
            options: {
              pageModel: vm.searchModel,
              dto: angular.copy(vm.searchDtoEmpty),
              searchPropertiesPageModel: angular.copy(vm.searchPropertiesPageModel),
              searchPropertiesDto: angular.copy(vm.searchPropertiesDto),
            },
          },
        });

        modalInstance.result.then(function(result) {
          if (!!result) vm.searchDto = result;
          else vm.searchDto = angular.copy(vm.searchDtoEmpty);
          if (vm.treeViewEnabled) {
            vm.treeView();
          } else {
            vm.refreshActiveTab();
          }
        });
      };

      vm.newVersionMainItem = function() {
        var id = vm.getSelectedId();
        $state.go('Document.DocumentNewVersion', {
          id: id,
          dasTableId: vm.formModel.DasTableId,
          dasOwnerId: vm.formModel.DasOwnerId,
        });
      };

      vm.borrowMainItem = function() {
        //elméletileg ez kellene, de nem lehet az ID-re visszaállni frissítés után. bent hagyom, ha vissza kell térni rá meglegyen.
        var id = vm.getSelectedId();
        $http.post('Dms/Document/DocumentBorrow', { docId: id }).then(function(data, status, headers, config) {
          toastr.success('A dokumentumot sikeresen kikölcsönözte!');
          vm.refreshActiveTab();
        });
      };

      vm.borrowMainItemAndOpen = function() {
        var id = vm.getSelectedId();
        $http
          .post('Dms/Document/DocumentBorrow', { docId: id })
          .then(function(data, status, headers, config) {
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Dms/Document/modalTemplateForDocumentNav.html',
              controller: function($scope, $uibModalInstance) {
                $scope.cancel = function() {
                  $uibModalInstance.close();
                };
                $scope.open = function() {
                  $uibModalInstance.close(true);
                };
              },
              backdrop: 'static',
              controllerAs: 'vm',
            });

            modalInstance.result.then(
              function(result) {
                if (result) {
                  vm.viewMainItem();
                }
                vm.selectedMainGridItem.checkout;
              },
              function() {
                vm.refreshActiveTab();
              }
            );
          })
          .catch(function(data, status, headers, config) {
            //TODO
          });
      };
      vm.giveBackMainItem = function() {
        var id = vm.getSelectedId();
        $http
          .post('Dms/Document/DocumentGiveBack', { docId: id })
          .then(function(data, status, headers, config) {
            toastr.success('A dokumentumot sikeresen visszaadta!');
            vm.refreshActiveTab();
          })
          .catch(function(data, status, headers, config) {
            //TODO
          });
      };

      vm.linkToDas = function() {
        var id = vm.getSelectedId();
        var filename = vm.selectedMainGridItem.filename;
        var dasTableId = vm.formModel.DasTableId;
        var dasOwnerId = vm.formModel.DasOwnerId;

        $http
          .post('Dms/Document/DocumentLinkDmsToDas', {
            dasTableId: dasTableId,
            dasOwnerId: dasOwnerId,
            documentId: id,
            documentFileName: filename,
          })
          .then(function(response) {
            //console.log("response: " + response);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //$state.go("Document.DocumentNav", { dasTableId: vm.formModel.DasTableId, dasOwnerId: vm.formModel.DasOwnerId });
            if (!!vm.grids && vm.grids.GridDocumentsAttached) {
              vm.grids.GridDocumentsAttached?.dataSource?.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.removeDasLink = function() {
        var id = vm.getSelectedId();
        var dasTableId = vm.formModel.DasTableId;
        var dasOwnerId = vm.formModel.DasOwnerId;

        $http
          .post('Das/Documents/RemoveLinkFromDas', {
            doclibId: id,
            tableId: dasTableId,
            ownerId: dasOwnerId,
          })
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.DeleteSuccessful);
            if (!!vm.grids && vm.grids.GridDocumentsAttached) {
              vm.grids.GridDocumentsAttached?.dataSource?.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.DeleteFailed);
          });
      };
      vm.sbTabs = gridService.buildTabModelsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        vm.hasAttachedGrid
          ? ['PanelDocumentsAttached', 'PanelDocuments', 'PanelDocumentsAll']
          : ['PanelDocuments', 'PanelDocumentsAll'],
        function(gridModel) {
          switch (gridModel.Name) {
            case 'GridDocumentsAttached':
              return {
                gridModel,
                selectFunction: selectFunction,
                transportData:  function (){
                  let tables = base64ToObject(vm.formModel.DasTableId, true), condition="", idTables = tables.idTables ?? {};
                
                  if(Object.keys(tables)?.length > 0){
                    for (const [key, value] of Object.entries(tables)) {
                      if(idTables[key] !== undefined){
                       condition += "(f_tableid~eq~'" + key + "'~and~f_ownerid~eq~'" + value + "')~and~";
                      }
                    }
                    condition = condition.slice(0, -5);
                  }
                  else{
                    condition = "(f_tableid~eq~'" + vm.formModel.DasTableId + "'~and~f_ownerid~eq~'" + vm.formModel.DasOwnerId + "')";
                  } 
                  return createGeneralParameters(
                    gridModel,
                    condition
                  );
               },
              
              };
            case 'GridDocuments':
              return {
                gridModel,
                selectFunction: selectFunction,
                toolbar: kendo.template($('#toolBarTemplate').html()),
                transportData: function() {
                  return createGeneralParameters(
                    gridModel,
                    "(nextID~isnull~or~nextID~eq~0)~and~(enddate~isnull~or~enddate~gte~datetime'" +
                      moment().toISOString() +
                      ')',
                    { searchDto: vm.getFilters(), notAttachedState: vm.notAttachedState }
                  );
                },
              };
            case 'GridDocumentsAll':
              return {
                gridModel,
                selectFunction: selectFunction,
                toolbar: kendo.template($('#toolBarTemplateAll').html()),
                transportData: function() {
                  return createGeneralParameters(gridModel, '', {
                    searchDto: vm.getFilters(),
                    notAttachedState: vm.notAttachedStateAll,
                  });
                },
              };
            default:
              break;
          }
        }
      );

      vm.toggleNotAttachedState = function() {
        vm.refreshActiveTab();
      };

      vm.toggleNotAttachedStateAll = function() {
        vm.refreshActiveTab();
      };

      function selectFunction(selectedItem) {
        vm.selectedMainGridItem = selectedItem;
        vm.isDocumentCheckedOut =
          !vm.selectedMainGridItem || vm.selectedMainGridItem.checkout != vm.currentUserID ? true : false;
        $scope.$apply();
        vm.refreshActiveSubTab();
      }

      vm.sbSubTabs = gridService.buildTabModelsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelDocProp', 'PanelVersions', 'PanelDocLink'], //PanelDocRel
        function(gridModel) {
          switch (gridModel.Name) {
            case 'GridDocProp':
              return {
                gridModel,
                transportData: createGeneralParameters(gridModel, function() {
                  return (
                    'docID~eq~' +
                    (!vm.selectedMainGridItem || !vm.selectedMainGridItem.docID ? 0 : vm.selectedMainGridItem.docID)
                  );
                }),
              };
            case 'GridVersions':
              return {
                gridModel,
                transportData: function() {
                  return {
                    docId:
                      !vm.selectedMainGridItem || !vm.selectedMainGridItem.docID ? 0 : vm.selectedMainGridItem.docID,
                  };
                },
              };
            case 'GridDocLink':
              return {
                gridModel,
                transportData: function() {
                  return {
                    docId:
                      !vm.selectedMainGridItem || !vm.selectedMainGridItem.docID ? 0 : vm.selectedMainGridItem.docID,
                  };
                },
              };
            default:
              break;
          }
        }
      );

      function selectHandlerCore() {
        console.log('select', vm.subGrids['GridDocLink'].selectedIds);
      }

      gridService.setupMultiSelect(vm.sbSubTabs[1].kendoConfig, {
        idField: 'DocId',
        selectHandler: selectHandlerCore,
        selectAllHandler: selectHandlerCore,
      });

      vm.refreshActiveTab = function() {
        var gridRef = $(`#${vm.sbTabs[vm.activeMainItemTab].gridName}`).data('kendoGrid');
        if (!!gridRef) {
          gridRef?.dataSource?.read();
        }
      };

      vm.refreshActiveSubTab = function() {
        var gridRef = $(`#${vm.sbSubTabs[vm.activeSubItemTab].gridName}`).data('kendoGrid');
        gridRef?.dataSource?.read();
      };

      vm.openLinks = function() {
        if (!vm.subGrids['GridDocLink'].selectedIds || vm.subGrids['GridDocLink'].selectedIds.length == 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
          return false;
        }
        let list = vm.subGrids['GridDocLink']._data.filter(function(row) {
          return vm.subGrids['GridDocLink'].selectedIds.includes(row.DocId.toString());
        });
        let flgrUrlBase = $location.absUrl().replace($location.url(), '');
        angular.forEach(list, function(value, key) {
          console.log(key, value);
          window.open(flgrUrlBase + '/document/navopen/' + value.TableId + '/' + value.EntityId, '_blank');
        });
      };

      vm.removeLinksFromDas = function() {
        if (!vm.subGrids['GridDocLink'].selectedIds || vm.subGrids['GridDocLink'].selectedIds.length == 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.pageModel.Labels.LabelRemoveLinkQuestion.Title,
          title: vm.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Confirm,
              className: 'btn-primary',
              callback: function() {
                $http({
                  method: 'POST',
                  url: 'Dms/Document/RemoveLinksFromDas/',
                  data: { docIdList: vm.subGrids['GridDocLink'].selectedIds },
                })
                  .then(function successCallback(response) {
                    vm.subGrids['GridDocLink'].selectedIds = [];
                    vm.subGrids['GridDocLink']?.dataSource?.read();
                    toastr.success(vm.pageModel.Messages.DeleteSuccessful);
                  })
                  .catch(function successCallback(response) {
                    toastr.error(vm.pageModel.Messages.DeleteFailed);
                  });
              },
            },
          },
        });
      };

      function createGeneralParameters(gridModel, whereCondition, parameter) {
        //set default parameter, if not exists
        if (!parameter) parameter = {};
        //add generalGrid parameters
        angular.extend(parameter, {
          tableName: gridModel.Table,
          adopter: gridModel.Adopter,
          installAdopter: gridModel.InstallAdopter,
          columnCsv: _.map(gridModel.Columns, 'field').join(),
          idColumn: gridModel.IdColumn,
        });
        //add whereCondition
        if (!!whereCondition) {
          angular.extend(parameter, {
            whereCondition: whereCondition,
          });
        }
        return parameter;
      }
    },
  ]);
})(angular.module('dmsApp'));

angular.module('dmsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Document: {
        url: '/document',
        templateUrl: 'App/Dms/Document/DocumentLayout.html',
        controller: 'DocumentLayoutCtrl_dms as vm',
        redirectTo: 'Document.DocumentNav',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'Document.DocumentNav': {
        url: '/nav/:dasTableId/:dasOwnerId',
        params: {
          module: 'document',
          formMode: 'Nav',
          lockPreviousState: ':lockPreviousState',
          dasTableId: {
            value: null,
          },
          dasOwnerId: {
            value: null,
          },
          documentEntity: 'document_documentnav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentNav.html',
            controller: 'DocumentNavCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/Document/DocumentNavOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum navigáció',
        },
      },
      'Document.DocumentNavOpen': {
        url: '/navopen/:dasTableId/:dasOwnerId',
        params: {
          module: 'document',
          window: true,
          formMode: 'Nav',
          lockPreviousState: ':lockPreviousState',
          dasTableId: {
            value: null,
          },
          dasOwnerId: {
            value: null,
          },
          documentEntity: 'document_documentnav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentNav.html',
            controller: 'DocumentNavCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/Document/DocumentNavOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum navigáció',
        },
      },
      'Document.DocumentCreate': {
        url: '/documentcreate/{id:int}/:dasTableId/:dasOwnerId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_dms as vm',
          },
        },
        resolve: {
            options: RouteResolveFunc('Dms/Document/DocumentCreate/', undefined, ['id', 'dasTableId', 'dasOwnerId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          BackTo: 'Document.DocumentNavOpen',
          module: 'Document',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Új dokumentum feltöltése',
        },
      },
      'Document.DocumentEdit': {
        url: '/documentedit/{id:int}/:dasTableId/:dasOwnerId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/Document/DocumentEdit/', undefined, ['id', 'dasTableId', 'dasOwnerId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          BackTo: 'Document.DocumentNavOpen',
          module: 'Document',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum szerkesztése',
        },
      },
      'Document.DocumentDuplicate': {
        url: '/documentduplicate/{id:int}/:dasTableId/:dasOwnerId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_dms as vm',
          },
        },
        resolve: {
            options: RouteResolveFunc('Dms/Document/DocumentDuplicate/', { isDuplicate: true }, [
            'id',
            'dasTableId',
            'dasOwnerId',
          ]),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          BackTo: 'Document.DocumentNav',
          module: 'Document',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Új dokumentum feltöltése',
        },
      },
      'Document.DocumentNewVersion': {
        url: '/documentnewversion/{id:int}/:dasTableId/:dasOwnerId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/Document/DocumentNewVersion/', undefined, ['id', 'dasTableId', 'dasOwnerId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
            isNewVersion: true,
          },
          BackTo: 'Document.DocumentNav',
          module: 'Document',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Új verzió létrehozása',
        },
      },
      'Document.DocumentView': {
        url: '/documentview/{id:int}/:dasTableId/:dasOwnerId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/Document/DocumentEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          BackTo: 'Document.DocumentNav',
          module: 'Document',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum megtekintése',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Document");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('DocumentMasterDataCtrl_dms', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    function(options, $http, $state, $stateParams) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentMasterDataCtrl_dms', stateParams);
      }
      var vm = this;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'Dms/MasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};
      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          //console.log("going to state with: " + JSON.stringify(vm.formModifiers));
          $state.go(vm.type + 'List', {
            formModifiers: vm.formModifiers[vm.type],
          });
        }
      }
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataDuplicateCtrl_dms', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'DmsLockService',
    function(mi, $http, fModel, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataDuplicateCtrl_dms', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.MDType = $stateParams.MDType;

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      if (vm.MDType == 'Period') {
        var onChangeFunctions = {
          FinancialYear: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'PartnerMasterData/PeriodLastMonth',
              params: { financialYear: vm.formModel.FinancialYear },
            }).then(function successCallback(response) {
              if (response.data != null && response.data != '') {
                vm.formModel.Period = response.data.Period;
                vm.formModel.Name = response.data.Name;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post(vm.ModulType + 'Dms/MasterData/' + vm.MDType + 'Duplicate', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikeresen megtörtént!');
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikertelen!');
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataEditCtrl_dms', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'formModifiers',
    '$stateParams',
    'AuthService',
    'DmsLockService',
    function(mi, $http, fModel, formModifiers, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataEditCtrl_dms', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.pageModelR = fModel.pageModelR;
      //console.log("formModifiers: " + JSON.stringify(formModifiers));
      vm.formModifiers = formModifiers;
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      console.log('pageModel: ', JSON.stringify(vm.pageModel));

      vm.formModel = fModel.dto;
      vm.MDType = $stateParams.MDType;

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      console.log('formFields: ', JSON.stringify(vm.formFields));

      if (vm.MDType == 'ResponsibleType') {
        var customExpressionProperties = {
          IsHandler: {
            'templateOptions.disabled': function() {
              if (vm.formModel.IsPartnerTribe == false) {
                vm.formModel.IsHandler = false;
                return true;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Period') {
        var onChangeFunctions = {
          FinancialYear: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'PartnerMasterData/PeriodLastMonth',
              params: { financialYear: vm.formModel.FinancialYear },
            }).then(function successCallback(response) {
              if (response.data != null && response.data != '') {
                vm.formModel.Period = response.data.Period;
                vm.formModel.Name = response.data.Name;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      if (vm.MDType == 'EqualMultiplier') {
        var syncValidators = {
          Multiplier: {
            MultiplierValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return /^[0-9]*(,[0-9]{1,2})?$/.test(modelValue);
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'VatCode') {
        var syncValidators = {
          Vat: {
            NumValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }

              return modelValue >= 0 && modelValue <= 100;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);

        var vatcode = vm.formModel.VatCode;
        var customExpressionProperties = {
          VatCode: {
            'templateOptions.disabled': function() {
              if (vatcode != '' && vatcode != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Repeat') {
        var syncValidators = {
          UnitNum: {
            NumValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }

              return modelValue >= 0;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'Post') {
        var syncValidators = {
          Square: {
            NumValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }

              return modelValue >= 0;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'Currency') {
        var syncValidators = {
          SmallestUnit: {
            NumValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }

              return modelValue >= 0;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'CurrencyExchange') {
        var syncValidators = {
          RateDate: {
            RateDateValidator: function(modelValue) {
              var today = new Date();
              var date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
              var todayDateValue = new moment(date, kendo.culture().calendar.patterns.d.toUpperCase());
              var rateDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

              return !rateDateValue.isAfter(todayDateValue);
            },
          },
          BuyingRate: {
            VatValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0;
            },
          },
          CentralRate: {
            VatValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0;
            },
          },
          SellingRate: {
            VatValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'PostCode') {
        var syncValidators = {
          NumberFrom: {
            NumberFromValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= -3;
            },
          },
          NumberTo: {
            NumberToValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue > 0;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'Deposit') {
        if (!vm.formModel.DepositId) {
          vm.formModel.Vat = 0;
          vm.formModel.MoRental = 0;
          vm.formModel.MoPropServ = 0;
          vm.formModel.OtPercent = 0;
        }

        var syncValidators = {
          Vat: {
            VatValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0;
            },
          },
          MoRental: {
            MoRentalValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0 && modelValue == parseInt(modelValue);
            },
          },
          MoPropServ: {
            MoRentalValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0 && modelValue == parseInt(modelValue);
            },
          },
          OtPercent: {
            MoRentalValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0 && modelValue == parseInt(modelValue);
            },
          },
        };
        var customExpressionProperties = {
          Vat: {
            'templateOptions.disabled': function() {
              if (vm.formModel.Fixed) {
                vm.formModel.Vat = 0;
              }
              return vm.formModel.Fixed;
            },
          },
          MoRental: {
            'templateOptions.disabled': function() {
              if (vm.formModel.Fixed) {
                vm.formModel.MoRental = 0;
              }
              return vm.formModel.Fixed;
            },
          },
          MoPropServ: {
            'templateOptions.disabled': function() {
              if (vm.formModel.Fixed) {
                vm.formModel.MoPropServ = 0;
              }
              return vm.formModel.Fixed;
            },
          },
          OtPercent: {
            'templateOptions.disabled': function() {
              if (vm.formModel.Fixed) {
                vm.formModel.OtPercent = 0;
              }
              return vm.formModel.Fixed;
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'ContractType') {
        var syncValidators = {
          Prefix: {
            PrefixValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return /[a-zA-Z]/.test(modelValue);
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'SupplyContrStatusType') {
        var syncValidators = {
          RanKing: {
            MoRentalValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0 && modelValue == parseInt(modelValue);
            },
          },
        };

        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      if (vm.MDType == 'UsageFee') {
        var syncValidators = {
          WithoutTitelMonth: {
            NumberToValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue > 0;
            },
          },
          WithoutTitelMultiplier: {
            WithoutTitelMultiplierValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue > 0;
            },
          },
        };
        InsertSyncValidators(vm.pageModel, syncValidators);
      }

      //beírható azonosítóknál módosításnál ne legyen módosítható az azonosító
      if (vm.MDType == 'Nationality') {
        var nationality = vm.formModel.Nationality;
        var customExpressionProperties = {
          Nationality: {
            'templateOptions.disabled': function() {
              if (nationality != '' && nationality != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Floor') {
        var floor = vm.formModel.Floor;
        var customExpressionProperties = {
          Floor: {
            'templateOptions.disabled': function() {
              if (floor != '' && floor != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'FinancialItem') {
        var financialItem = vm.formModel.FinancialItem;
        var customExpressionProperties = {
          FinancialItem: {
            'templateOptions.disabled': function() {
              if (financialItem != '' && financialItem != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Classification') {
        var classification = vm.formModel.Classification;
        var customExpressionProperties = {
          Classification: {
            'templateOptions.disabled': function() {
              if (classification != '' && classification != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Language') {
        var language = vm.formModel.Language;
        var customExpressionProperties = {
          Language: {
            'templateOptions.disabled': function() {
              if (language != '' && language != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Country') {
        var country = vm.formModel.Country;
        var customExpressionProperties = {
          Country: {
            'templateOptions.disabled': function() {
              if (country != '' && country != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Payment') {
        var payment = vm.formModel.Payment;
        var customExpressionProperties = {
          Payment: {
            'templateOptions.disabled': function() {
              if (payment != '' && payment != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'Currency') {
        var currency = vm.formModel.Currency;
        var customExpressionProperties = {
          Currency: {
            'templateOptions.disabled': function() {
              if (currency != '' && currency != null) {
                return true;
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType == 'ConstructionElement') {
        var onChangeFunctions = {
          GroupId: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'ConstructionMasterData/GetClassifyName',
              params: { groupId: vm.formModel.GroupId },
            }).then(function successCallback(response) {
              if (response.data != null && response.data != '') {
                vm.formModel.ConstructionClassify = response.data.Dto.ClassifyName;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }
      if (vm.MDType == 'ConstructionGroup') {
        var onChangeFunctions = {
          ConstructionClassify: function(selectedItem) {
            console.log(vm);
            $http({
              method: 'GET',
              url: 'ConstructionMasterData/GetGroupRanking',
              params: { ConstructionClassify: vm.formModel.ConstructionClassify },
            }).then(function successCallback(response) {
              if (response.data != null && response.data != '') {
                vm.formModel.Ranking = response.data.Dto.Ranking;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      vm.save = function() {
        $http
          .post(vm.ModulType + 'Dms/MasterData/' + vm.MDType + 'Edit', vm.formModel)
          .then(function(response) {
            //console.log(vm.pageModel.Labels);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          })
          .catch(function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataLayoutCtrl_dms', [
    'breadcrumbRoots',
    '$scope',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function(breadcrumbRoots, $scope, $http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataLayoutCtrl_dms', stateParams);
      }
      var vm = this;

      $scope.breadcrumbRoot = breadcrumbRoots.dmsApp && breadcrumbRoots.dmsApp.dmsMasterdata;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('dmsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataMenuCtrl_dms', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataMenuCtrl_dms', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'main' };

      var desc = {
        Masterdata_Document_DocType: { icon: 'fa fa-file-text' },
        Masterdata_Document_DocSubtype: { icon: 'fa fa-file-text' },
        Masterdata_Document_File: { icon: 'fa fa-file-text' },
        Masterdata_Document_Path: { icon: 'fa fa-file-text' },
        Masterdata_Document_Properties: { icon: 'fa fa-file-text' },
        Masterdata_Document_PropReq: { icon: 'fa fa-file-text' },
        Masterdata_Document_Relation: { icon: 'fa fa-file-text' },
      };

      var itemsCnt = Object.keys(desc).length;
      if (itemsCnt > 0) {
      }

      vm.menus = [];
      buildMenu($state, authService, 'Masterdata_Document', 'masterdata', backMenu, desc).then(function(m) {
        vm.menus = m;
        console.log('menus: ', m);
      });
    },
  ]);
})(angular.module('dmsApp'));

angular.module('dmsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      dmsMasterdata: {
        url: '/master-data',
        templateUrl: 'App/Dms/MasterData/MasterDataLayout.html',
        controller: 'MasterDataLayoutCtrl_dms as vm',
        redirectTo: 'dmsMasterdata.Nav',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'dmsMasterdata.Nav': {
        url: '/nav',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DocumentMenuCtrl_dms as vm',
          },
          content: {
            templateUrl: 'App/Dms/MasterData/MasterDataDocument.html',
            controller: 'DocumentMasterDataCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        params: {
          module: 'masterdata',
          documentEntity: 'document_documentcreate',
        },
        ncyBreadcrumb: {
          label: 'Törzsek',
        },
      },
      'dmsMasterdata.Nav.PropertiesList': {
        url: '/property',
        params: { MDType: 'propertiesMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_propertieslist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdonságok',
        },
      },
      'dmsMasterdata.Nav.DocTypesList': {
        url: '/doctype',
        params: { MDType: 'doctypeMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_doctypeslist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum típusok',
        },
      },
      'dmsMasterdata.Nav.DocSubtypesList': {
        url: '/docsubtype',
        params: { MDType: 'docSubtypeMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_docsubtypeslist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum altípusok',
        },
      },
      //     "dmsMasterdata.Nav.RelationsList": {
      //         url: "/relations",
      //         params: { MDType: "relationsMod", ModulType: "", documentEntity: 'dmsmasterdata_nav_relationslist', },
      //         views: {
      //             "masterData": {
      //                 templateUrl: "App/Dms/MasterData/MasterDataView.html",
      //                 controller: "MasterDataViewCtrl_dms as vm"
      //	}
      //},
      //resolve: {
      //	options: RouteResolveFunc("Dms/MasterData/ListOptions/")
      //},
      //         ncyBreadcrumb: {
      //             label: "Dokumentum kapcsolat típusok"
      //         }
      //     },
      'dmsMasterdata.Nav.ExtensionsList': {
        url: '/extensions',
        params: { MDType: 'extensionsMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_extensionslist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'File típusok',
        },
      },
      'dmsMasterdata.Nav.PropReqList': {
        url: '/propreq',
        params: { MDType: 'propreqMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_propreqlist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum típus-tulajdonság',
        },
      },
      'dmsMasterdata.Nav.PathList': {
        url: '/path',
        params: { MDType: 'pathMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_pathlist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Mappák',
        },
      },
      'dmsMasterdata.Nav.PermissionList': {
        url: '/permission',
        params: { MDType: 'permissionMod', ModulType: '', documentEntity: 'dmsmasterdata_nav_permissionlist' },
        views: {
          masterData: {
            templateUrl: 'App/Dms/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_dms as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Dms/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum tartalombiztonság',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('MasterDataViewCtrl_dms', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    function(options, $http, $state, $stateParams, $uibModal, AuthService, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataViewCtrl_dms', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      //vm.disabled = true;
      vm.MDType = $stateParams.MDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      vm.back = function() {
        $state.go('main');
      };

      vm.selectedgridItemId = 0;
      // MenuItems
      vm.create = createItem;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;

      //hide Delete Button
      vm.hideDelete = false;

      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');
      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        vm.getModulType() + 'Dms/MasterData/' + vm.getMDType() + 'List/',
        function() {
          if (vm.MDType == 'EquipmentGroup') {
            selectGridItem();
          }
          changeGridFilter(vm, $scope, vm.grid, vm.gridIdField);
        }
      );
      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {
        //"propertiesMod": {
        //    customExpressionProperties: {
        //        "joinfield": {
        //            "templateOptions.disabled": function (a, b, c) {
        //                return c.model.jointable ? false : true;
        //            },
        //            "templateOptions.required": function (a, b, c) {
        //                return c.model.jointable ? true : false;
        //            }
        //        }
        //    }
        //}
      };

      if (vm.MDType == 'propertiesMod') {
        vm.hideDelete = true;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
          var url = vm.getModulType() + 'Dms/MasterData/' + vm.getMDType() + 'Create';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Dms/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl_dms',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getMDType()],
          },
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }
      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'Dms/MasterData/' + vm.getMDType() + 'Edit';
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Dms/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl_dms',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              fModel: RouteResolveFunc(url, { id: encodeURIComponent(id) }),
              formModifiers: vm.formModifiers[vm.getMDType()],
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }
      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);

        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var dialogMessage = vm.pageModel.Labels.LabelConfirmDelete.Title;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Labels.LabelDeleteWarning.Title,
            buttons: {
              cancel: {
                label: vm.pageModel.Labels.LabelDeleteCancel.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Labels.LabelDeleteOk.Title,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'Dms/MasterData/' + vm.getMDType() + 'Delete/' + id).then(function() {
                    toastr.success(vm.pageModel.Labels.LabelDeleteSuccessful.Title);
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'Dms/MasterData/' + vm.getMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Dms/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl_dms',
            controllerAs: 'vm',
            backdrop: 'static',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('dmsApp'));

(function() {
  'use strict';

  var myApp = angular.module('mrsApp', [
    'ui.router',
    'ui.bootstrap',
    'ui.mask',
    'angular-loading-bar',
    'kendo.directives',
    'ngMessages',
    'formly',
    'formlyBootstrap',
    'textAngular',
    'timer',
    'ncy-angular-breadcrumb',
    'ngMap',
    'checklist-model',
    'ngFileSaver',
    'LocalStorageModule',
  ]);
})();

(function(module) {
  'use strict';

  /**********************************/
  /*** Service: MrsLockService    ***/
  /**********************************/
  module.service('MrsLockService', [
    '$state',
    '$http',
    '$uibModal',
    '$uibModalStack',
    '$location',
    function($state, $http, $uibModal, $uibModalStack, $location) {
      var vm = this;

      vm.LOCKING_IS_OFF = false;
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = false;

      vm.http = $http;
      vm.modal = $uibModal;

      vm.lastLockedUrl = '';

      this.shouldShowInitialiLockAndUnlockMessageInModals = function() {
        return vm.SHOW_LOCK_MESSAGES_IN_MODALS;
      };

      this.initiateLock = function(programId, id) {
        vm.lastLockedUrl = $location.absUrl();

        console.log('Lock: initiateLock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        $(window).on('beforeunload', function() {
          //UnlockWhenLeavingPage
          vm.http
            .post('MrsSystem/UnlockWhenLeavingPage', {})
            .then(function(response) {
              //unregister leaving page event
              $(window).off('beforeunload', function() {
                // do nothing
              });
            })
            .catch(function(response) {
              // do nothing
            });
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Mrs/MrsLock/LockOverlay.html',
          controller: 'MrsLockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        modalInstance.result.then(function() {});
      };

      this.initiateUnlock = function(programId, id) {
        vm.lastLockedUrl = '';
        console.log('Lock: initiateUnlock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        // unregister leaving page event
        $(window).off('beforeunload', function() {
          // do nothing
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Mrs/MrsLock/UnlockOverlay.html',
          controller: 'MrsUnlockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        modalInstance.result.then(function() {});
      };

      function logLockLog(response) {
        if (response == null) return;
        if (response.data == null) return;
        if (response.data.LockLog == null) return;

        var lockLog = response.data.LockLog;
        console.log(lockLog);
      }

      this.isLockable = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: isLockable called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // Return lockable when creating new items
          var result = {
            ResultStatus: true,
            LockedBy: [],
          };
          setTimeout(() => successCallback(result), 1000);
          return;
        }

        vm.http
          .post('MrsSystem/IsLockable', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback(response.data.result);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.lock = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: lock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        vm.http
          .post('MrsSystem/Lock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.unlock = function(programId, id, successCallback, errorCallback) {
        console.log('Lock: unlock called');
        if (vm.LOCKING_IS_OFF) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        vm.http
          .post('MrsSystem/Unlock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.closeAllModals = function() {
        // console.log('dismissing all modals...');
        $uibModalStack.dismissAll();
      };

      this.unlockWhenLeavingPage = function(nextUrl) {
        if (vm.lastLockedUrl == nextUrl) {
          console.log(
            'Lock: unlockWhenLeavingPage called, but was rejected because it would run on the currently locked page.'
          );
          return;
        }
        vm.lastLockedUrl = '';
        console.log('Lock: unlockWhenLeavingPage called');
        vm.closeAllModals();
        if (vm.LOCKING_IS_OFF) {
          return;
        }
        vm.http
          .post('MrsSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            return;
          });
      };

      this.unlockAllInSessionWithCallback = function(successCallback, errorCallback) {
        console.log('Lock: unlockAllInSessionWithCallback called');
        vm.lastLockedUrl = '';
        vm.closeAllModals();
        if (vm.LOCKING_IS_OFF) {
          return;
        }
        vm.http
          .post('MrsSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            successCallback(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback(response);
            return;
          });
      };
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';
  module.controller('MrsLockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MrsLockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLocked = false;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Locking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            var lockable = response.ResultStatus;
            vm.isLocked = !lockable;
            vm.lockedBy = response.LockedBy;

            if (vm.isLocked) {
              console.log('Editor is locked by: ' + vm.lockedBy);
            } else {
              console.log('Editor is accessible.');
            }

            if (lockable) {
              lockService.lock(
                programId,
                id,
                function() {
                  // lock succeeded
                  console.log('Lock succeeded.');
                  $uibModalInstance.close();
                },
                function() {
                  // error
                  console.log('Lock FAILED!');
                  vm.hasError = true;
                }
              );
            }

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';
  module.controller('MrsUnlockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MrsUnlockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLockable = true;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Unlocking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            vm.isLockable = response.ResultStatus;
            vm.lockedBy = response.LockedBy;

            if (vm.isLockable) {
              // No need to unlock
              // This can happen - maybe we have unlocked the record after save, and the modal remained open and calls an unlock on close
              //
              // If the installService cannot handle this, uncomment below
              // However, this can cause missing unlock calls when the lock feature is turned on at the server side, as vm.IsLockable will always be true in that case
              //console.log('Record is already unlocked. Unlock succeeded.');
              //$uibModalInstance.close();
              //return;
            }

            lockService.unlock(
              programId,
              id,
              function() {
                // unlock succeeded
                console.log('Unlock succeeded.');
                $uibModalInstance.close();
              },
              function() {
                // error
                console.log('Unlock FAILED!');
                vm.hasError = true;
              }
            );

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MrsMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MrsMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'main' };

      var desc = {
        Mrs_DocumentNav: { icon: 'fa fa-file-text' },
        Mrs_RegBookNav: { icon: 'fa fa-file-text' },
        Mrs_TopicNav: { icon: 'fa fa-file-text' },
        Mrs_MasterDataNav: { icon: 'fa fa-file-text' },
      };

      vm.menus = [];
      buildMenu($state, authService, 'Mrs', 'mrs', backMenu, desc).then(function(m) {
        vm.menus = m;
        console.log('menus: ', m);
      });
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('DocPropEditCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$filter',
    'AuthService',
    '$uibModal',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, model, $filter, authService, $uibModal, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocPropEditCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      if (model.dto.PropertyId && !model.dto.FreeText) {
        vm.saveTemplateOptionsForF2 = angular.copy(model.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions);
        vm.f2NameField =
          !!model.dto.ForrasProp.ShowData && model.dto.ForrasProp.ShowData != ''
            ? model.dto.ForrasProp.ShowData
            : model.dto.ForrasProp.Field;
        $http
          .post('F22/GetDynamicF22FieldModel', {
            table: model.dto.ForrasProp.Table,
            key: model.dto.ForrasProp.Field,
            value: model.dto.ForrasProp.Field,
            freeText: false,
            writable: true,
            filteringMode: 1,
            patternMatchMode: 0,
            adopter: model.dto.ForrasProp.AdopterId,
            installAdopter:
              model.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
          })
          .then(function(fieldModel) {
            model.pageModel.Fields.Value.FormlyFieldDescriptor.type = 'f22Input';
            model.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions = fieldModel.data.templateOptions;
            model.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.label =
              vm.saveTemplateOptionsForF2.label;
            init();
          })
          .catch(function(data, status, headers, config) {
            init();
            //TODO
          });
      } else {
        init();
      }

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.fields = formlyFormPanelDescriptors.PaneldocProp.FormlyDescriptor;

        var fs = fieldSetter;
        fs.vm = vm;
        fs.setOnChangeFunction('PropertyId', function(selectedItem) {
          //F2
          if (!!selectedItem && !!selectedItem.extraProperties[0] && selectedItem.extraProperties[0].value != '') {
            vm.pageModel = angular.copy(vm.tempModel);
            vm.dataModel.Value = { Value: null, Text: null };
            vm.dataModel.StringValue = '';
            vm.dataModel.FreeText = false;
            vm.saveTemplateOptionsForF2 = angular.copy(vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions);
            vm.f2NameField =
              !!selectedItem.extraProperties[2].value && selectedItem.extraProperties[2].value != ''
                ? selectedItem.extraProperties[2].value
                : selectedItem.extraProperties[1].value;
            vm.f2ModalTitle = selectedItem.text;
            $http
              .post('F22/GetDynamicF22FieldModel', {
                table: selectedItem.extraProperties[0].value,
                key: selectedItem.extraProperties[1].value,
                value: selectedItem.extraProperties[1].value,
                //value: !!selectedItem.extraProperties[2].value && selectedItem.extraProperties[2].value!=""? selectedItem.extraProperties[2].value : selectedItem.extraProperties[1].value,
                freeText: false,
                writable: true,
                filteringMode: 1,
                patternMatchMode: 0,
                adopter:
                  !!selectedItem.extraProperties[3].value && selectedItem.extraProperties[3].value != ''
                    ? selectedItem.extraProperties[3].value
                    : vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter,
                installAdopter:
                  vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
              })

              .then(function(fieldModel) {
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.type = 'f22Input';
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions = fieldModel.data.templateOptions;
                var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
                vm.fields = formlyFormPanelDescriptors.PaneldocProp.FormlyDescriptor;
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.changed =
                  vm.saveTemplateOptionsForF2.changed;
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.label =
                  vm.saveTemplateOptionsForF2.label;
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.options.modalTitle = vm.f2ModalTitle;
              })
              .catch(function(data, status, headers, config) {
                //TODO
              });
          }
          //Szabadszöveg
          if (!!selectedItem && (!selectedItem.extraProperties[0] || selectedItem.extraProperties[0].value == '')) {
            vm.dataModel.Value = { Value: null, Text: null };
            vm.dataModel.StringValue = '';
            vm.dataModel.FreeText = true;
          }
        });

        fs.setOnChangeFunction('Value', function(selectedItem) {
          if (!!selectedItem && !!selectedItem.GridItem) {
            vm.dataModel.Name = selectedItem.GridItem[vm.f2NameField];
          } else {
            if (selectedItem.Value == null) vm.dataModel.Name = null;
          }
        });

        fs.hideField('Value', function() {
          return vm.dataModel.FreeText;
        });

        fs.hideField('Name', function() {
          return vm.dataModel.FreeText;
        });
        fs.hideField('StringValue', function() {
          return !vm.dataModel.FreeText;
        });

        vm.back = function() {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.DocumentEdit', {
            id: vm.dataModel.DocumentId,
          });
        };

        generateForm(vm);
        vm.tempModel = angular.copy(vm.pageModel);
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentEditCtrl_mrs', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    'lodash',
    '$uibModal',
    'HistoryService',
    'DasService',
    'MrsLockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      $state,
      lodash,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentEditCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabdoc',
        disableRunExpression: false,
      };

      function headerIsDisabled() {
        return vm.collapseHelper?.disabledPanels?.indexOf('PGTabdoc') !== -1;
      }

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.UIHelperService.setDefaultSidebarStatus();

      if (options === undefined) {
        $state.go('MrsDocument.Nav');
        return false;
      }

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.deputyAdmins = options.deputyAdmins;
      vm.actions = vm.pageModel.Actions;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.selectedMainGridItemId = vm.formModel.DocumentId;
      vm.messages = options.pageModel.Messages;
      vm.loggedUser = AuthService.user.id;

      vm.isAdmin = lodash.includes(options.admins, AuthService.user.id.toUpperCase());

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      //TODO átírni a navigáció nevére
      //var level = "Document";

      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('MrsDocument.Nav');
      };

      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};
      // Usage: "fieldName": "className"
      var customClasses = {};

      var isRegBookIdDisabled = !!vm.formModel.RegBookId && vm.formModel.RegBookId.Value > 0;

      var customExpressionProperties = {
        RegBookId: {
          'templateOptions.disabled': function() {
            return isRegBookIdDisabled;
          },
        },
        Status: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 2 || headerIsDisabled();
          },
        },
        DossierId: {
          'templateOptions.disabled': function() {
            return vm.formModel.selectedDossier || headerIsDisabled();
          },
        },
        Direction: {
          'templateOptions.disabled': function() {
            return vm.formModel.selectedDirection || headerIsDisabled();
          },
        },
        ClientCompUnit: {
          'templateOptions.disabled': function() {
            return vm.formModel.Direction == 'R';
          },
        },
        //"ClientPartner": {
        //   "templateOptions.disabled": function () {
        //       return vm.formModel.Direction=="R";
        //   }
        //},
        ClientUser: {
          'templateOptions.disabled': function() {
            return vm.formModel.Direction == 'R';
          },
        },
        ClientOther: {
          'templateOptions.disabled': function() {
            return vm.formModel.Direction == 'R';
          },
        },
        Subject: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        Previous: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        RegDate: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        ArrivalDate: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        DeadlineDate: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        Confidential: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        DossierId: function(selectedItem) {
          if (selectedItem.Value === null && selectedItem.Text === null) {
            //ha töröljük az DossierId F2-őt, töröljük a TopicId.t is!
            vm.formModel.TopicId = { Text: null, Value: null };
          }
          if (selectedItem.GridItem) {
            $http
              .get('Mrs/Document/getTopicData', {
                params: { topicId: selectedItem.GridItem.TopicId },
              })
              .then(function(response) {
                vm.formModel.TopicId = {
                  Text: response.data.dto.Name,
                  Value: response.data.dto.TopicId,
                };
                var deadlineDate = new moment(
                  vm.formModel.ArrivalDate,
                  kendo.culture().calendar.patterns.d.toUpperCase()
                ).add(response.data.dto.Deadline, 'days');
                vm.formModel.DeadlineDate = deadlineDate.format(deadlineDate._f);
              });
          }
        },
        Direction: function(selectedItem) {
          if (!!selectedItem && selectedItem.key == 'B') {
            if (!vm.formModel.ClientPartner || !vm.formModel.ClientPartner.Value)
              vm.formModel.ClientPartner = angular.copy(vm.formModel.SenderPartner);
            if (!vm.formModel.ClientUser || !vm.formModel.ClientUser.Value)
              vm.formModel.ClientUser = angular.copy(vm.formModel.SenderUser);
            if (!vm.formModel.ClientCompUnit || !vm.formModel.ClientCompUnit.Value)
              vm.formModel.ClientCompUnit = angular.copy(vm.formModel.SenderCompUnit);
          }

          if (!!selectedItem && selectedItem.key == 'K') {
            if (!vm.formModel.ClientPartner || !vm.formModel.ClientPartner.Value)
              vm.formModel.ClientPartner = angular.copy(vm.formModel.TargetPartner);
            if (!vm.formModel.ClientUser || !vm.formModel.ClientUser.Value)
              vm.formModel.ClientUser = angular.copy(vm.formModel.TargetUser);
            if (!vm.formModel.ClientCompUnit || !vm.formModel.ClientCompUnit.Value)
              vm.formModel.ClientCompUnit = angular.copy(vm.formModel.TargetCompUnit);
          }

          if (!!selectedItem && selectedItem.key == 'R') {
            vm.formModel.ClientCompUnit = { Value: null, Text: null };
            vm.formModel.ClientPartner = { Value: null, Text: null };
            vm.formModel.ClientUser = { Value: null, Text: null };
            vm.formModel.ClientOther = null;
          }
        },
        SenderPartner: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'B' &&
            (!vm.formModel.ClientPartner || !vm.formModel.ClientPartner.Value)
          )
            vm.formModel.ClientPartner = angular.copy(vm.formModel.SenderPartner);
        },
        SenderUser: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'B' &&
            (!vm.formModel.ClientUser || !vm.formModel.ClientUser.Value)
          )
            vm.formModel.ClientUser = angular.copy(vm.formModel.SenderUser);
        },
        SenderCompUnit: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'B' &&
            (!vm.formModel.ClientCompUnit || !vm.formModel.ClientCompUnit.Value)
          )
            vm.formModel.ClientCompUnit = angular.copy(vm.formModel.SenderCompUnit);
        },
        SenderOther: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'B' &&
            (!vm.formModel.ClientOther || !vm.formModel.ClientOther.Value)
          )
            vm.formModel.ClientOther = angular.copy(vm.formModel.SenderOther);
        },
        TargetPartner: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'K' &&
            (!vm.formModel.ClientPartner || !vm.formModel.ClientPartner.Value)
          )
            vm.formModel.ClientPartner = angular.copy(vm.formModel.TargetPartner);
        },
        TargetUser: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'K' &&
            (!vm.formModel.ClientUser || !vm.formModel.ClientUser.Value)
          )
            vm.formModel.ClientUser = angular.copy(vm.formModel.TargetUser);
        },
        TargetCompUnit: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'K' &&
            (!vm.formModel.ClientCompUnit || !vm.formModel.ClientCompUnit.Value)
          )
            vm.formModel.ClientCompUnit = angular.copy(vm.formModel.TargetCompUnit);
        },
        TargetOther: function(selectedItem) {
          if (
            (!!selectedItem.GridItem || (!selectedItem.GridItem && selectedItem.Value == null)) && //formbetöltésnél ne vegye át az értékeket
            vm.formModel.Direction == 'K' &&
            (!vm.formModel.ClientOther || !vm.formModel.ClientOther.Value)
          )
            vm.formModel.ClientOther = angular.copy(vm.formModel.TargetOther);
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        // "SenderPartner": function(selectedItem) {
        // debugger;
        // },
        // "SenderUser": function(selectedItem) {
        // debugger;
        // },
        // "SenderCompUnit": function(selectedItem) {
        // debugger;
        // },
        // "SenderOther": function(selectedItem) {
        // debugger;
        // }
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      var dynamicQueryParameters = {};
      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomClasses(vm.pageModel, customClasses);

      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertParsers(vm.pageModel, parsers);
      InsertFormatters(vm.pageModel, formatters);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formlyFieldsDoc = formlyFormPanelDescriptors.Paneldoc.FormlyDescriptor;
      vm.formlyFieldsSender = formlyFormPanelDescriptors.Panelsender.FormlyDescriptor;
      vm.formlyFieldsClient = formlyFormPanelDescriptors.Panelclient.FormlyDescriptor;
      vm.formlyFieldsTarget = formlyFormPanelDescriptors.Paneltarget.FormlyDescriptor;
      vm.formlyFieldsOther = formlyFormPanelDescriptors.Panelother.FormlyDescriptor;

      function saveItem() {
        $http
          .post('Mrs/Document/Document' + (vm.formModel.ModelState === 2 ? 'Create' : vm.EditOrDuplicate), vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (
              !!response.data.DocumentId ||
              (!response.data.DocumentId && (response.data.Value === true || vm.formModel.RegNumber === ''))
            ) {
              var _id = !!response.data.DocumentId ? response.data.DocumentId : vm.formModel.DocumentId;
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              $state.go('MrsDocument.DocumentEdit', { id: _id }, { reload: true, inherit: false });
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.takeOverEnabled = function() {
        return (
          !!vm.selectedTaskFromGrid &&
          vm.selectedTaskFromGrid.TaskType == 1 &&
          (vm.formModel.IsSuperUser ||
            (vm.formModel.Status == 1 &&
              !vm.formModel.IsAdmin &&
              lodash.includes(vm.deputyAdmins, vm.selectedTaskFromGrid.UserId.toUpperCase())))
        );
      };

      var whereForPrevious = function() {
        return (
          'RegBookId~eq~' +
          (!!vm.formModel.RegBookId && !!vm.formModel.RegBookId.Value ? vm.formModel.RegBookId.Value : 0)
        );
      };

      vm.pageModel.Fields.Previous.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereForPrevious;

      vm.pageModel.Fields.RegBookId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return vm.formModel.IsReadOnly ? '' : 'Status~eq~1';
      };

      //////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////////[Subgrids]//////////////////////////////////////////

      vm.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.getSelectedMainGridItemId = function(item) {
        return {
          DocumentId: vm.selectedMainGridItemId,
        };
      };

      vm.subHistory = function SubHistory() {
        if (vm.activeSubItemTab === 0) {
          var selectedItems = GetSelectedGridItems(vm.detailItemGrids.Gridtask);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          } else {
            var table = 'mrs_Task';
            var id = selectedItems[0][vm.pageModel.Grids.Gridtask.IdColumn];
            if (!!table) {
              HistoryService.NavigateToHistory(table, id, vm, $state, true, vm.pageModel.Grids.Gridtask.IdColumn);
            }
          }
        }
        //else if (vm.activeSubItemTab === 1) {
        //    var selectedItems = GetSelectedGridItems(vm.detailItemGrids.GriddocProp);
        //    if (selectedItems.length === 0) {
        //        toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        //        return false;
        //    } else {
        //        var table = 'mrs_DocProp';
        //        var id = selectedItems[0][vm.pageModel.Grids.GriddocProp.IdColumn];
        //        if (!!table) {
        //            HistoryService.NavigateToHistory(table, id, vm, $state, true, vm.pageModel.Grids.GriddocProp.IdColumn);
        //        }
        //    }
        //}
      };

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['Paneltask', 'PaneldocProp', 'PanellinkedDoc'],
        function(gridModel) {
          if (gridModel.Name === 'Gridtask') {
            gridModel.ControllerMethod = 'Mrs/Document/TaskList/';
            return {
              gridModel,
              selectFunction: function(item) {
                vm.selectedTaskFromGrid = item;
                $scope.$apply();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GriddocProp') {
            gridModel.ControllerMethod = 'Mrs/Document/DocPropList/';
            return {
              gridModel,
              selectFunction: function(item) {
                vm.selectedPropFromGrid = item;
                $scope.$apply();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          gridModel.ControllerMethod = `Document/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.detailItemGrids = generatedGridTabs.grids;
      vm.detailItemTabs = generatedGridTabs.tabs;
      vm.detailItemGridOptions = generatedGridTabs.gridOptions;

      vm.attachDocument = function() {
        var id = !!vm.formModel.DocumentId ? vm.formModel.DocumentId : null;
        dasService.NavigateToDas(vm.messages, 'MrsDocument.DasDocumentsNav', 'mrs_Document', id);
      };

      vm.createItem = function() {
        if (vm.activeSubItemTab === 0) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.TaskCreate', {
            id: 0,
            documentId: vm.getSelectedMainGridItemId().DocumentId,
          });
        } else if (vm.activeSubItemTab === 1) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.DocPropCreate', {
            id: 0,
            documentId: vm.getSelectedMainGridItemId().DocumentId,
          });
        }
      };

      vm.editItem = function() {
        if (vm.activeSubItemTab === 0) {
          var selectedItems = GetSelectedGridItems(vm.detailItemGrids.Gridtask);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          } else if (selectedItems[0]['TaskType'] === 1 && selectedItems[0]['UserId'] != vm.loggedUser) {
            toastr.warning('Más ügyintéző Ügyintézés feladattípusa nem szerkeszthető!', vm.messages.Warning);
            return false;
          }
          id = selectedItems[0][vm.pageModel.Grids.Gridtask.IdColumn];

          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.TaskEdit', {
            id: id,
            documentId: vm.getSelectedMainGridItemId().DocumentId,
          });
        } else if (vm.activeSubItemTab === 1) {
          var id = getSelectedRowId(vm.detailItemGrids.GriddocProp, vm.pageModel.Grids.GriddocProp.IdColumn);
          if (!(id > 0)) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          }
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.DocPropEdit', {
            id: id,
            documentId: vm.getSelectedMainGridItemId().DocumentId,
          });
        }
      };

      vm.deleteItem = function() {
        var id = 0;
        var method = '';
        if (vm.activeSubItemTab === 0) {
          var selectedItems = GetSelectedGridItems(vm.detailItemGrids.Gridtask);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          } else if (selectedItems[0]['TaskType'] === 1 && selectedItems[0]['UserId'] != vm.loggedUser) {
            toastr.warning('Más ügyintéző Ügyintézés feladattípusa nem törölhető!', vm.messages.Warning);
            return false;
          }
          id = selectedItems[0][vm.pageModel.Grids.Gridtask.IdColumn];
          method = 'Mrs/Document/TaskDelete';
        } else if (vm.activeSubItemTab === 1) {
          id = getSelectedRowId(vm.detailItemGrids.GriddocProp, vm.pageModel.Grids.GriddocProp.IdColumn);
          if (!(id > 0)) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          }
          method = 'Mrs/Document/DocPropDelete';
        }
        bootbox.dialog({
          message: vm.pageModel.Messages.ConfirmDelete,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.post(method, { id: id, documentId: vm.formModel.DocumentId }).then(function(data) {
                  if (vm.activeSubItemTab === 0) {
                    toastr.success(vm.pageModel.Messages.DeleteSuccessful);
                    vm.detailItemGrids.Gridtask.dataSource.read();
                    vm.formModel.IsAdmin =
                      lodash.includes(data.data.Value, AuthService.user.id) || vm.formModel.IsSuperUser;
                  } else if (vm.activeSubItemTab === 1) {
                    toastr.success(vm.pageModel.Messages.DeleteSuccessful);
                    vm.detailItemGrids.GriddocProp.dataSource.read();
                  }
                });
              },
            },
          },
        });
      };

      vm.duplicateItem = function() {
        if (vm.activeSubItemTab === 0) {
          var id = getSelectedRowId(vm.detailItemGrids.Gridtask, vm.pageModel.Grids.Gridtask.IdColumn);
          if (!(id > 0)) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          }
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.TaskDuplicate', { id: id });
        } else if (vm.activeSubItemTab === 1) {
          var id = getSelectedRowId(vm.detailItemGrids.GriddocProp, vm.pageModel.Grids.GriddocProp.IdColumn);
          if (!(id > 0)) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          }
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.DocPropDuplicate', { id: id });
        }
      };

      vm.passItem = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Mrs/Document/PassMod.html',
          controller: 'PassModCtrl_mrs',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc('Mrs/Document/TaskPass'),
          },
        });

        modalInstance.result.then(function(userId) {
          $http
            .post('Mrs/Document/TaskPass', {
              documentId: vm.formModel.DocumentId,
              userId: userId,
            })
            .then(function() {
              vm.formModel.IsAdmin = vm.formModel.IsSuperUser;
              vm.detailItemGrids.Gridtask.dataSource.read();
            });
        });
      };

      vm.takeOverItem = function() {
        bootbox.dialog({
          message: vm.pageModel.Labels.LabelTaskTakeOverConfirm.Title,
          title: vm.pageModel.Labels.LabelTaskTakeOverTitle.Title,
          buttons: {
            cancel: {
              label: vm.pageModel.Labels.LabelCancel.Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Labels.LabelOk.Title,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('Mrs/Document/TakeOver', {
                    taskId: vm.selectedTaskFromGrid.TaskId,
                  })
                  .then(function() {
                    toastr.success(vm.pageModel.Labels.LabelTakeOverSuccessful.Title);
                    vm.detailItemGrids.Gridtask.dataSource.read();
                    $state.go('MrsDocument.DocumentEdit', { id: vm.formModel.DocumentId }, { reload: true });
                  })
                  .catch(function(response) {
                    //toastr.error("hiba");
                  });
              },
            },
          },
        });
      };

      vm.readyItem = function() {
        var id = getSelectedRowId(vm.detailItemGrids.Gridtask, vm.pageModel.Grids.Gridtask.IdColumn);
        if (!(id > 0)) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        bootbox.dialog({
          message: vm.pageModel.Labels.LabelReadyConfirm.Title,
          title: vm.pageModel.Labels.LabelReadyTitle.Title,
          buttons: {
            cancel: {
              label: vm.pageModel.Labels.LabelCancel.Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Labels.LabelOk.Title,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('Mrs/Document/TaskReady', { taskId: id })
                  .then(function() {
                    toastr.success(vm.pageModel.Labels.LabelReadySuccessful.Title);
                    vm.detailItemGrids.Gridtask.dataSource.read();
                  })
                  .catch(function(response) {
                    //toastr.error("hiba");
                  });
              },
            },
          },
        });
      };
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentLayoutCtrl_mrs', [
    '$scope',
    'breadcrumbRoots',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($scope, breadcrumbRoots, $http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentLayoutCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      $scope.breadcrumbRoot = breadcrumbRoots.mrsApp && breadcrumbRoots.mrsApp.document;
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentMenuCtrl_mrs', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentMenuCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {};

      vm.menus = buildMenu($state, authService, 'Document', 'document', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('DocumentNavCtrl_mrs', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'DasService',
    'WalService',
    'gridService',
    'AuthService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      HistoryService,
      dasService,
      walService,
      gridService,
      authService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentNavCtrl_mrs', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.searchPageModel = options.searchPageModel;
      vm.searchDto = options.searchDto;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createItem = createItem;
      vm.editItem = editItem;
      vm.viewItem = viewItem;
      vm.duplicateItem = duplicateItem;
      vm.search = search;
      vm.lockItem = lockItem;
      vm.WAL = WAL;

      vm.formModel.SearchFilters = [];

      vm.back = function() {
        $state.go('main');
      };

      vm.mainHistory = function MainHistory() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        HistoryService.NavigateToHistory(
          'mrs_Document',
          id,
          vm,
          $state,
          true,
          vm.pageModel.Grids.Griddocument.IdColumn
        );
      };

      vm.subHistory = function SubHistory() {
        if (vm.activeSubItemTab === 0) {
          var selectedItems = GetSelectedGridItems(vm.detailItemGrids.Gridtask);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          } else {
            var table = 'mrs_Task';
            var id = selectedItems[0][vm.pageModel.Grids.Gridtask.IdColumn];
            if (!!table) {
              HistoryService.NavigateToHistory(table, id, vm, $state, true, vm.pageModel.Grids.Gridtask.IdColumn);
            }
          }
        } else if (vm.activeSubItemTab === 1) {
          var selectedItems = GetSelectedGridItems(vm.detailItemGrids.GriddocProp);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return false;
          } else {
            var table = 'mrs_DocProp';
            var id = selectedItems[0][vm.pageModel.Grids.GriddocProp.IdColumn];
            if (!!table) {
              HistoryService.NavigateToHistory(table, id, vm, $state, true, vm.pageModel.Grids.GriddocProp.IdColumn);
            }
          }
        }
      };

      vm.getSelectedMainGridItemId = function() {
        return {
          DocumentId: vm.selectedMainGridItemId,
        };
      };

      vm.mainGridIdField = vm.pageModel.Grids['Griddocument'].IdColumn;
      //   vm.mainGrid = $("#mainGrid").data("kendoGrid");
      vm.selectedMainGridItemId = 0;
      vm.selectedSubGridItemId = 0;

      var getStoredRegbook = function() {
        var str = localStorage.getItem('Is.' + authService.user.id + '.SelectedRegBook');
        try {
          return JSON.parse(str);
        } catch (e) {
          return;
        }
      };

      var setStoredRegbook = function(id, direction) {
        if (id > 0) {
          localStorage.setItem(
            'Is.' + authService.user.id + '.SelectedRegBook',
            '{"id":' + id + ',"direction":"' + direction + '"}'
          );
        } else {
          clearStoredRegbook();
        }
      };

      var clearStoredRegbook = function(id, direction) {
        localStorage.clear('Is.' + authService.user.id + '.SelectedRegBook');
      };

      //init Filter:
      var selectedRegBook = getStoredRegbook();
      if (!!selectedRegBook) {
        vm.formModel.RegBookId = { Value: selectedRegBook.id };
        vm.EnableReplyButton = selectedRegBook.direction === 'N';
      } else {
        vm.EnableReplyButton = false;
      }

      // Grid row select teszthez
      // vm.formModel.RegBookId  = {Value: 4, Text: "teszt"};
      vm.formModel.DossierId = { Value: null, Text: null };
      //vm.formModel.Status = 1;

      vm.getFilter = function() {
        return {
          dto: vm.formModel,
        };
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.Griddocument,
        'Mrs/Document/DocumentList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
          setDasModel();
        },
        vm.getFilter
      );

      vm.mainGridOptions.dataBound = function(e) {
        changeMainGridFilter(e.sender);
      };

      vm.formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.activeSubItemTab = 0;

      //FORMLY MODIFIERS
      var onChangeFunctions = {
        RegBookId: function(selectedItem) {
          //Get RegBook direction
          if (!!selectedItem.GridItem) {
            setStoredRegbook(selectedItem.Value, selectedItem.GridItem.Direction);
            vm.EnableReplyButton = selectedItem.GridItem.Direction === 'N';
            vm.InactiveStatus = selectedItem.GridItem.Status == 2;
            vm.mainGrid.dataSource.read();
          } else {
            if (selectedItem.Value == null) {
              clearStoredRegbook();
              vm.EnableReplyButton = false;
              setTimeout(function() {
                vm.mainGrid.dataSource.read();
              }, 0);
            }
          }
        },
        DossierId: function(selectedItem) {
          if (!!selectedItem.GridItem) {
            vm.mainGrid.dataSource.read();
          }
        },
        Status: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },

        IAmIn: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        Admin: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
      };
      var onBlurFunctions = {
        IAmIn: function(selectedItem) {},
        Admin: function(selectedItem) {},
      };

      var customCallbackFunctions = {
        IAmIn: function(selectedItem) {
          vm.mainGrid.dataSource.read(refreshSubGrids);
        },
        Admin: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['Paneltask', 'PaneldocProp', 'PanellinkedDoc'],
        function(gridModel) {
          if (gridModel.Name === 'Gridtask') {
            gridModel.ControllerMethod = 'Mrs/Document/TaskList/';
            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GriddocProp') {
            gridModel.ControllerMethod = 'Mrs/Document/DocPropList/';
            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          gridModel.ControllerMethod = `Document/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.detailItemGrids = generatedGridTabs.grids;
      vm.detailItemTabs = generatedGridTabs.tabs;
      vm.detailItemGridOptions = generatedGridTabs.gridOptions;

      $scope.$watch('vm.formModel.Type', function(newValue, oldValue) {
        if (newValue == 0) {
          vm.formModel.StoragePlace = null;
        }
        if (newValue == 1) {
          vm.formModel.Files = null;
          //TODO az uploaded file listát kiüríteni
        }
        if (newValue == 2) {
          vm.formModel.Files = null;
          //TODO az uploaded file listát kiüríteni
          vm.formModel.StoragePlace = null;
        }
      });

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          //ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedMainGridItemId = 0;
          vm.RightToModify = false;
          vm.RightToClose = false;
          vm.RightFromStatus = false;
          $scope.$apply();
          refreshSubGrids();
          return;
        }

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.RightToModify = selectedItems[0].RightToModify;
        vm.RightToClose = selectedItems[0].RightToClose;
        vm.RightFromStatus = selectedItems[0].Status == 1;
        // $scope frissítése;
        $scope.$apply();
        refreshSubGrids();
      }

      function refreshSubGrids() {
        //subGridek frissítése
        var subGridRefs = {};
        angular.forEach(vm.detailItemGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          !!value && value.dataSource.read();
        });
      }

      function changeSubGridFilter() {
        var targetGrid = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]];
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          //ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedSubGridItemId = 0;
          $scope.$apply();
          return;
        }

        vm.selectedSubGridItemId = selectedItems[0][targetGrid.IdColumn];
        // $scope frissítése;
        $scope.$apply();
      }

      function createItem() {
        $state.go('MrsDocument.DocumentCreate', {
          id: 0,
          regBookId: vm.formModel.RegBookId.Value,
          dossierId: vm.formModel.DossierId.Value,
        });
      }

      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('MrsDocument.DocumentEdit', { id: id });
        }
      }

      function viewItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('MrsDocument.DocumentView', { id: id });
        }
      }

      function duplicateItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('MrsDocument.DocumentDuplicate', { id: id });
        }
      }

      vm.reply = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (selectedItems[0].Direction > 2) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        var id = selectedItems[0][vm.mainGridIdField];
        $state.go('MrsDocument.DocumentReply', {
          id: id,
          dossierId: vm.formModel.DossierId.Value,
        });
      };

      function search() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Mrs/Document/DocumentSearchingMod.html',
          controller: 'DocumentSearchingModCtrl_mrs',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: {
              pageModel: vm.searchPageModel,
              dto: angular.copy(vm.searchDto),
              //searchPropertiesPageModel: vm.searchPropertiesPageModel,
              //searchPropertiesDto: vm.searchPropertiesDto
            },
          },
        });

        modalInstance.result.then(function(result) {
          var resultSet = result;

          // build & set dto parameters
          var searchFilters = [];
          for (var i = 0; i < resultSet.filters.length; i++) {
            var dto = angular.copy(vm.searchDto);
            dto.Nav = resultSet.use_nav_filters;
            dto.PropertyId = {
              Value: resultSet.filters[i].Property.Value,
              Text: resultSet.filters[i].Property.Text,
            };
            dto.Value = {
              Value: resultSet.filters[i].Value.Value,
              Text: resultSet.filters[i].Value.Text,
            };
            dto.SearchMode = resultSet.filters[i].SearchMode;
            searchFilters.push(dto);
          }
          vm.formModel.SearchFilters = searchFilters;

          // reload grid
          vm.mainGrid.dataSource.read();
        });
      }

      function lockItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
        var id = getSelectedRowId(vm.mainGrid, vm.mainGridIdField);
        var method = 'Mrs/Document/DocumentClose';
        bootbox.dialog({
          message: 'Biztos, hogy lezárja az iratot? ', //vm.pageModel.Messages.ConfirmClose,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post(method, { docId: id })
                  .then(function(data) {
                    toastr.success('Irat lezárása sikeres!'); //vm.pageModel.Messages.CloseSuccessful
                    vm.mainGrid.dataSource.read();
                  })
                  .catch(function(data) {
                    toastr.error('Irat lezárása sikertelen!'); //vm.pageModel.Messages.CloseFailed
                  });
              },
            },
          },
        });
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['Griddocument'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$apply();
      }

      function WAL() {
        walService.NavigateToWal('Mrs/Document', 'DocumentNavWal', 'mrs_Document');
      }
    },
  ]);
})(angular.module('mrsApp'));

angular.module('mrsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      MrsDocument: {
        url: '/mrs/document-module',
        templateUrl: 'App/Mrs/Document/DocumentLayout.html',
        controller: 'DocumentLayoutCtrl_mrs as vm',
        redirectTo: 'MrsDocument.Nav',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'MrsDocument.Nav': {
        url: '/document',
        params: {
          module: 'document',
          formMode: 'Nav',
          createState: 'MrsDocument.DocumentCreate',
          editState: 'MrsDocument.DocumentEdit',
          duplicateState: 'MrsDocument.DocumentDuplicate',
          //deleteState: "Mrs/RegBook/RegBookDelete/",
          bstates: ['MrsDocument.DocumentCreate'],
          documentEntity: 'mrsdocument_nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentNav.html',
            controller: 'DocumentNavCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Iktatás',
        },
      },
      'MrsDocument.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          lockPreviousState: true,
          documentEntity: '',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/', undefined, ['tableId', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'MrsDocument.DocumentView': {
        url: '/documentview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentView/', undefined, ['id', 'tableId', 'ownerId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'Edit',
          documentEntity: 'iktatas-karbantarto',
        },
        ncyBreadcrumb: {
          label: 'Iktatás megtekintés',
        },
      },
      'MrsDocument.DocumentCreate': {
        url: '/documentcreate/{id:int}?regBookId&dossierId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentCreate/', undefined, ['id', 'regBookId', 'dossierId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          documentEntity: 'iktatas-karbantarto',
        },
        ncyBreadcrumb: {
          label: 'Iktatás hozzáadása',
          parent: 'MrsDocument.Nav',
        },
      },
      'MrsDocument.DocumentEdit': {
        url: '/documentedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          bstates: [
            'MrsDocument.DocumentEdit',
            'MrsDocument.DocumentDuplicate',
            'MrsDocument.TaskEdit',
            'MrsDocument.TaskDuplicate',
            'MrsDocument.DocPropEdit',
            'MrsDocument.DocPropDuplicate',
          ],
          documentEntity: 'iktatas-karbantarto',
        },
        ncyBreadcrumb: {
          label: 'Iktatás szerkesztése',
          parent: 'MrsDocument.Nav',
        },
      },
      'MrsDocument.DocumentDuplicate': {
        url: '/documentduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          documentEntity: 'iktatas-karbantarto',
        },
        ncyBreadcrumb: {
          label: 'Iktatás másolása',
        },
      },
      'MrsDocument.DocumentReply': {
        url: '/documentreply/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocumentEdit.html',
            controller: 'DocumentEditCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Document/DocumentReply/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Reply',
          documentEntity: 'iktatas-valasz',
        },
        ncyBreadcrumb: {
          label: 'Válasz iratra',
        },
      },
      'MrsDocument.TaskCreate': {
        url: '/taskcreate/?id&documentId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/TaskEdit.html',
            controller: 'TaskEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/TaskCreate', undefined, ['id', 'documentId']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Document/TaskCreate',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsDocument.DocumentEdit',
          documentEntity: 'iktatas-feladat',
        },
        ncyBreadcrumb: {
          label: 'Feladat hozzáadása',
        },
      },
      'MrsDocument.TaskEdit': {
        url: '/taskedit/?id',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/TaskEdit.html',
            controller: 'TaskEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/TaskEdit', undefined, ['id']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Document/TaskEdit',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsDocument.DocumentEdit',
          documentEntity: 'iktatas-feladat',
        },
        ncyBreadcrumb: {
          label: 'Feladat szerkesztése',
        },
      },
      'MrsDocument.TaskDuplicate': {
        url: '/taskduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/TaskEdit.html',
            controller: 'TaskEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/TaskDuplicate/', undefined, ['id']),
        },
        params: {
          formMode: 'Duplicate',
          postUrl: 'Mrs/Document/TaskDuplicate',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'iktatas-feladat',
        },
        ncyBreadcrumb: {
          label: 'Feladat duplikálása',
        },
      },
      'MrsDocument.DocPropCreate': {
        url: '/docpropcreate/?id&documentId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocPropEdit.html',
            controller: 'DocPropEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/DocPropCreate/', undefined, ['id', 'documentId']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Document/DocPropCreate',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.DocumentEdit',
          documentEntity: 'iktatas-irat-tulajdonsag',
        },
        ncyBreadcrumb: {
          label: 'Irat tulajdonság hozzáadása',
        },
      },
      'MrsDocument.DocPropEdit': {
        url: '/docpropedit/?id&documentId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocPropEdit.html',
            controller: 'DocPropEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/DocPropEdit/', undefined, ['id', 'documentId']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Document/DocPropEdit',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.DocumentEdit',
          documentEntity: 'iktatas-irat-tulajdonsag',
        },
        ncyBreadcrumb: {
          label: 'Irat tulajdonság szerkesztése',
        },
      },
      'MrsDocument.DocPropDuplicate': {
        url: '/docpropduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Document/DocPropEdit.html',
            controller: 'DocPropEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Document/DocPropDuplicate/', undefined, ['id']),
        },
        params: {
          formMode: 'Duplicate',
          postUrl: 'Mrs/Document/DocPropDuplicate',
          backStateAfterSave: 'MrsDocument.DocumentEdit',
          backState: 'MrsDocument.DocumentEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'DocumentId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsDocument.DocumentEdit',
          documentEntity: 'iktatas-irat-tulajdonsag',
        },
        ncyBreadcrumb: {
          label: 'Irat tulajdonság másolása',
        },
      },
      'MrsDocument.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/Document/DocumentHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'MrsTask.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/Task/TaskHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'MrsDocProp.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/DocProp/DocPropHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('DocumentSearchingModCtrl_mrs', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    '$uibModalInstance',
    function($scope, options, $http, $state, $uibModal, $uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocumentSearchingModCtrl_mrs', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      //initModel($http, $state, $stateParams, vm, options, $uibModal)
      //initViewModel($http, $state, $stateParams, vm, options, $uibModal);
      //initFormModel($http, $state, $stateParams, vm, options, $uibModal);
      init();

      function init() {
        vm.pageModel = angular.copy(options.pageModel);
        vm.messages = angular.copy(options.pageModel.Messages);
        vm.labels = options.pageModel.Labels;
        vm.actions = options.pageModel.Actions;

        // Set page title
        vm.title = vm.pageModel.Labels.LabelTitle.Title;

        // Set functions
        vm.addItem = addItem;
        vm.removeItem = removeItem;
        vm.cancel = cancel;
        vm.find = find;
        vm.f22_prop_changed = f22_prop_changed;

        //=======
        // Formly
        //=======
        var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.DocumentSeachModId = 'frmDocumentSearchMod';
        vm.DocumentSeachModName = 'Document search';
        vm.DocumentSeachModModel = {};
        vm.DocumentSeachModFields = formlyFormPanelDescriptors.Panelprop.FormlyDescriptor;

        //=====
        // Grid
        //=====
        vm.dataSource = new kendo.data.ObservableArray([]);

        // Get labels & f22options from page model
        var propLabel = vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.label;
        var propValueLabel = vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.label;
        vm.f22options_prop = vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options;
        vm.f22options_val = vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.options;

        vm.docPropGrid = vm.pageModel.Grids.GridgridSearch;
        var tempOptions = getGridOptions(
          vm.pageModel.Grids.GridSearch,
          'Document/NotUsed/',
          function(selected) {},
          function() {
            return {};
          }
        );

        //Selectable bugfix, ha selectable ="row" a két modális ablakban lévő f22 összeakad, és "kikékül" az F22 összes eleme...
        tempOptions.selectable = '';
        tempOptions.autoBind = true;
        //----------------------------------------------------------------------------------------------------------------------
        tempOptions.dataSource = {
          data: vm.dataSource,
          pageSize: 20,
          transport: {
            read: function(options) {
              options.success(vm.dataSource);
            },
          },
          change: function(options) {},
          batch: false,
          schema: {
            model: {
              id: 'rowId',
              fields: {
                rowId: { defaultValue: '' },
                f22_prop: { defaultValue: { Value: null } },
                f22_value: { defaultValue: { Value: null } },
                sword_value: { defaultValue: '' },
                Add: { editable: false },
                initialized: true,
                f22_val_disabled: true,
              },
            },
          },
        };

        tempOptions.columns = [
          {
            field: 'button_remove',
            title: ' ',
            filterable: false,
            template:
              '<button type="button" class="btn btn-default btn-remove" id="{{dataItem.rowId}}" title="" ng-disabled="vm.eventModel.IsReadOnly" ng-click="vm.removeItem($event)"><i class="griff-remove"></i></button>',
            width: '64px',
            attributes: {
              style: 'text-align: center;',
            },
          },
          {
            field: 'f22_prop',
            title: propLabel,
            template:
              '<f22-input id="f22_prop_{{dataItem.rowId}}" ng-model="dataItem.f22_prop" f2-options="vm.f22options_prop" changed="vm.f22_prop_changed(this, selectedItem)"></f22-input>',
          },
          {
            field: 'f22_val',
            title: propValueLabel,
            template:
              '<f22-input id="f22_val_{{dataItem.rowId}}" ng-if="dataItem.initialized" ng-disabled="dataItem.f22_val_disabled" style="width: 100%" ng-model="dataItem.f22_val" f2-options="dataItem.f22options_val" ></f22-input>' +
              '<input ng-if="!dataItem.initialized" ng-disabled="!!dataItem.f22_prop && !!dataItem.f22_prop.value" class="form-control" type="text" ng-model="dataItem.sword_value" />',
          },
          {
            field: 'button_new',
            title: ' ',
            filterable: false,
            template:
              '<button type="button" id="{{dataItem.rowId}}" class="btn btn-default btn-new" title="" ng-disabled="vm.eventModel.IsReadOnly" ng-click="vm.addItem($event)"><i class="griff-add"></i></button>',
            width: '64px',
            attributes: {
              style: 'text-align: center;',
            },
          },
        ];
        tempOptions.dataBound = grid_databound;
        vm.searchGridOptions = tempOptions;

        // initial data for the grid
        //------------------
        var row = getEmptyRow(0);
        vm.dataSource.push(row);
        // End of init
      }

      function getEmptyRow(rowId) {
        var row = {
          rowId: rowId,
          initialized: true,
          f22_prop: { Text: '', Value: '' },
          f22_val: { Text: '', Value: '' },
          f22options_prop: vm.f22options_prop,
          f22options_val: vm.f22options_val,
          f22_val_disabled: true,
        };
        return row;
      }

      function grid_databound(e) {
        $('.btn-remove').prop('title', vm.actions.ActionDelete.Title);
        $('.btn-new').prop('title', vm.actions.ActionNew.Title);
      }
      function f22_prop_changed(element, selectedItem) {
        if (!selectedItem.GridItem) {
          return;
        }

        var rowId = element.dataItem.rowId;
        var gridItem = selectedItem.GridItem;
        var text = selectedItem.Text;
        var value = selectedItem.Value;

        var adopterId = '';
        var jointable = '';
        var joinfield = '';
        var freeText = false;
        var writeable = false;
        var patternMatchMode = 0;
        var filteringMode = 0;
        if (typeof gridItem !== 'undefined') {
          adopterId = gridItem.adopterid;
          jointable = gridItem.jointable;
          joinfield = gridItem.joinfield;
        }

        // Get new gridOptions to value f22
        var rowIndex = getIndexByRowId(rowId);
        vm.dataSource[rowIndex].f22_val.Text = '';
        vm.dataSource[rowIndex].f22_val.Value = '';
        vm.dataSource[rowIndex].initialized = false;

        if (!!adopterId && adopterId != '') {
          if (jointable == '' || joinfield == '') {
            return;
          }
          $http
            .post('F22/GetDynamicF22FieldModel', {
              installAdopter:
                vm.pageModel.Fields.Value.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
              adopter: adopterId,
              table: jointable,
              key: joinfield,
              value: gridItem.showdata,
              freeText: false,
              writable: false,
              filteringMode: 0,
              patternMatchMode: 0,
            })
            .then(function(result) {
              // Set it on the appropriate f22 value input
              var f22_fieldModel = result.data;

              // generate options by field model
              F22Helpers.setF22Options(f22_fieldModel);
              f22_fieldModel.templateOptions.options.adopter = adopterId;

              vm.dataSource[rowIndex].f22options_val = f22_fieldModel.templateOptions.options;
              vm.dataSource[rowIndex].f22_val_disabled = false;

              // re-init f22 with bound ngif
              vm.dataSource[rowIndex].initialized = true;
            });
        }
      }

      function getIndexByRowId(rowId) {
        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (row.rowId == rowId) {
            return i;
          }
        }
        //not found
        return -1;
      }
      function getMaxRowId() {
        var maxRowId = -1;
        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (row.rowId > maxRowId) {
            maxRowId = row.rowId;
          }
        }
        return maxRowId;
      }

      function addItem($event) {
        var rowId = getMaxRowId() + 1;
        var row = getEmptyRow(rowId);
        vm.dataSource.push(row);
      }

      function removeItem($event) {
        var grid = $('#gridSearch').data('kendoGrid');

        var rowId = $event.currentTarget.id;
        var rowIndex = getIndexByRowId(rowId);

        var dataItem = vm.dataSource[rowIndex];
        grid.dataSource.remove(dataItem);

        if (vm.dataSource.length <= 0) {
          // Do not let the rows to be cleared
          // as the user will not be able to add new rows!
          var row = getEmptyRow(0);
          vm.dataSource.push(row);
        }
      }
      function cancel() {
        $uibModalInstance.dismiss('cancel');
      }
      function find() {
        //build result set
        var resultSet = {
          use_nav_filters: !!vm.DocumentSeachModModel.Nav && vm.DocumentSeachModModel.Nav,
          filters: [],
        };

        for (var i = 0; i < vm.dataSource.length; i++) {
          var row = vm.dataSource[i];
          if (!isNullOrEmpty(row.f22_prop.Value)) {
            //F22 value
            if (!isNullOrEmpty(row.f22_val.Value)) {
              resultSet.filters.push({
                Property: {
                  Value: row.f22_prop.Value,
                  Text: row.f22_prop.Text,
                },
                Value: {
                  Value: row.f22_val.Value,
                  Text: row.f22_val.Text,
                },
                SearchMode: 'f22',
              });
            }
            //FreeText
            else if (!isNullOrEmpty(row.sword_value)) {
              resultSet.filters.push({
                Property: {
                  Value: row.f22_prop.Value,
                  Text: row.f22_prop.Text,
                },
                Value: {
                  Value: row.sword_value,
                  Text: row.sword_value,
                },
                SearchMode: 'freetext',
              });
            }
          }
        }

        $uibModalInstance.close(resultSet);
      }

      function isNullOrEmpty(str) {
        if (typeof str == 'undefined') return true;
        if (str == null) return true;
        if (str == '') return true;

        return false;
      }

      // End.
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('PassModCtrl_mrs', [
    'options',
    '$uibModalInstance',
    function(options, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PassModCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.Panelpass.FormlyDescriptor;

      vm.save = function() {
        var userId = vm.formModel.UserId;
        mi.close(userId);
      };
      vm.cancel = function() {
        mi.dismiss();
      };
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('TaskEditCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$filter',
    'AuthService',
    '$uibModal',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, model, $filter, authService, $uibModal, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskEditCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.originalDoneDate = angular.copy(vm.dataModel.DoneDate);

        vm.back = function() {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('MrsDocument.DocumentEdit', {
            id: vm.dataModel.DocumentId,
          });
        };

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setRequired('DoneDate', function() {
          return vm.dataModel.Status === '2';
        });

        fs.setOnChangeFunction('Status', function(modelValue) {
          if (!!modelValue && modelValue.key === '2') {
            vm.dataModel.DoneDate = moment().format(kendo.culture().calendar.patterns.d.toUpperCase());
          } else {
            vm.dataModel.DoneDate = vm.originalDoneDate;
          }
        });

        generateForm(vm);
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataCtrl_mrs', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    function(options, $http, $state, $stateParams, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataCtrl_mrs', stateParams);
      }
      var vm = this;

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'Mrs/MasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type);
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataDuplicateCtrl_mrs', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'MrsLockService',
    function(mi, $http, fModel, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataDuplicateCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.MDType = $stateParams.MDType;

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      if (vm.MDType == 'Period') {
        var onChangeFunctions = {
          FinancialYear: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'PartnerMasterData/PeriodLastMonth',
              params: { financialYear: vm.formModel.FinancialYear },
            }).then(function successCallback(response) {
              if (response.data != null && response.data != '') {
                vm.formModel.Period = response.data.Period;
                vm.formModel.Name = response.data.Name;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Mrs/MasterData/' + vm.MDType + 'Duplicate', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikeresen megtörtént!');
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikertelen!');
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.dismiss('cancel');
      };
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataEditCtrl_mrs', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'formModifiers',
    '$stateParams',
    'AuthService',
    'MrsLockService',
    function(mi, $http, fModel, formModifiers, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataEditCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.pageModelR = fModel.pageModelR;
      //console.log("formModifiers: " + JSON.stringify(formModifiers));
      vm.formModifiers = formModifiers;
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }
      ////////////////////////////////////////////////////////////////////////////////////////

      vm.formModel = fModel.dto;
      vm.MDType = $stateParams.MDType;

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      console.log('formFields: ', JSON.stringify(vm.formFields));

      if (vm.MDType == 'MrsDeputy') {
        var customExpressionProperties = {
          UserId: {
            'templateOptions.disabled': function() {
              return vm.formModel.IsReadOnly;
            },
          },
          DeputyUser: {
            'templateOptions.disabled': function() {
              return vm.formModel.IsReadOnly;
            },
          },
          ValidTo: {
            'templateOptions.disabled': function() {
              return vm.formModel.IsReadOnly;
            },
          },
          ValidFrom: {
            'templateOptions.disabled': function() {
              return vm.formModel.IsReadOnly;
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      vm.save = function() {
        $http
          .post('Mrs/MasterData/' + vm.MDType + (vm.formModel.ModelState === 2 ? 'Create' : 'Edit'), vm.formModel)
          .then(function(response) {
            //console.log(vm.pageModel.Labels);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          })
          .catch(function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.dismiss('cancel');
      };
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataLayoutCtrl_mrs', [
    '$scope',
    'breadcrumbRoots',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($scope, breadcrumbRoots, $http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataLayoutCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      $scope.breadcrumbRoot = breadcrumbRoots.mrsApp && breadcrumbRoots.mrsApp.mrsMasterdata;
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataMenuCtrl_mrs', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataMenuCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'main' };

      var desc = {
        Masterdata_Document_Admin: { icon: 'fa fa-file-text' },
        Masterdata_Document_Deputy: { icon: 'fa fa-file-text' },
        Masterdata_Document_SendMode: { icon: 'fa fa-file-text' },
      };

      vm.menus = [];
      buildMenu($state, authService, 'Mrs_MasterDataNav', 'mrs', backMenu, desc).then(function(m) {
        vm.menus = m;
        console.log('menus: ', m);
      });
    },
  ]);
})(angular.module('mrsApp'));

angular.module('mrsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      MrsMasterData: {
        url: '/mrs/master-data-module',
        templateUrl: 'App/Mrs/MasterData/MasterDataLayout.html',
        controller: 'MasterDataLayoutCtrl_mrs as vm',
        redirectTo: 'MrsMasterData.MasterData',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'MrsMasterData.MasterData': {
        url: '/main',
        params: { module: 'masterdata', documentEntity: 'mrsmasterdata_masterdata' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/MasterData/MasterData.html',
            controller: 'MasterDataCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Törzsadatok',
        },
      },
      'MrsMasterData.MasterData.SendModeList': {
        url: '/sendmode',
        params: {
          MDType: 'MrsSendMode',
          ModulType: 'MasterData',
          backTo: 'main',
          documentEntity: 'mrsmasterdata_masterdata_sendmodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/Mrs/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Küldési mód',
        },
      },
      'MrsMasterData.MasterData.AdminList': {
        url: '/admin',
        params: {
          MDType: 'MrsAdmin',
          ModulType: 'MasterData',
          backTo: 'main',
          documentEntity: 'mrsmasterdata_masterdata_adminlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/Mrs/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szervezeti ügyintéző',
        },
      },
      'MrsMasterData.MasterData.DeputyList': {
        url: '/deputy',
        params: {
          MDType: 'MrsDeputy',
          ModulType: 'MasterData',
          backTo: 'main',
          documentEntity: 'mrsmasterdata_masterdata_deputylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/Mrs/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/MasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyettesítő',
        },
      },

      'MrsMasterData.MasterData.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/MasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('MasterDataViewCtrl_mrs', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'HistoryService',
    'DasService',
    function(options, $http, $state, $stateParams, $uibModal, AuthService, $scope, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataViewCtrl_mrs', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      //vm.disabled = true;
      vm.MDType = $stateParams.MDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      vm.back = function() {
        $state.go('main');
      };

      vm.selectedgridItemId = 0;
      // MenuItems
      vm.create = createItem;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;

      vm.history = function History() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.gridIdField] : null;
        HistoryService.NavigateToHistory('mrs_' + vm.MDType.substring(3), id, vm, $state, true, vm.gridIdField, false);
      };

      vm.attachDocument = function() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.gridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'MrsDocument.DasDocumentsNav', 'mrs_' + vm.MDType.substring(3), id);
      };

      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');
      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        'Mrs/MasterData/' + vm.getMDType() + 'List/',
        function() {
          if (vm.MDType == 'EquipmentGroup') {
            selectGridItem();
          }
          changeGridFilter(vm, $scope, vm.grid, vm.gridIdField);
        }
      );
      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {
        propertiesMod: {
          customExpressionProperties: {
            joinfield: {
              'templateOptions.disabled': function(a, b, c) {
                return c.model.jointable ? false : true;
              },
              'templateOptions.required': function(a, b, c) {
                return c.model.jointable ? true : false;
              },
            },
          },
        },
      };

      if (vm.MDType == 'EquipmentGroup') {
        vm.pageModelR = options.pageModelR;

        function selectGridItem() {
          var selectedItems = GetSelectedGridItems(vm.grid);

          if (selectedItems.length === 0) return;

          vm.selectedgridItemId = selectedItems[0][vm.gridIdField];
          vm.equipmentRecipientGrid.dataSource.read();
        }

        vm.getSelectedGridItemId = function() {
          return {
            EqGroupId: vm.selectedgridItemId,
          };
        };

        vm.equipmentRecipientGrid = options.pageModel.Grids.GridEquipmentRecipient;
        vm.equipmentRecipientGridOptions = getGridOptions(
          options.pageModel.Grids.GridEquipmentRecipient,
          'EquipmentMasterData/EquipmentRecipientList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        var url = 'Mrs/MasterData/' + vm.getMDType() + 'Edit/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Mrs/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl_mrs',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getMDType()],
          },
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }
      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Mrs/MasterData/' + vm.getMDType() + 'Edit';
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Mrs/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl_mrs',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url, { id: encodeURIComponent(id) }),
              formModifiers: vm.formModifiers[vm.getMDType()],
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }
      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);

        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var dialogMessage = vm.pageModel.Labels.LabelConfirmDelete.Title;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Labels.LabelDeleteWarning.Title,
            buttons: {
              cancel: {
                label: vm.pageModel.Labels.LabelDeleteCancel.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Labels.LabelDeleteOk.Title,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Mrs/MasterData/' + vm.getMDType() + 'Delete/' + id).then(function() {
                    toastr.success(vm.pageModel.Labels.LabelDeleteSuccessful.Title);
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Mrs/MasterData/' + vm.getMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Mrs/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl_mrs',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('RegBookEditCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$filter',
    'AuthService',
    '$uibModal',
    'MrsLockService',
    'UIHelperService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      model,
      $filter,
      authService,
      $uibModal,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RegBookEditCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.backWithUnlock = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.back();
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setMask('Year', '9999');
        //fs.setOnChangeFunction(
        //        "CloseDate",
        //        function () {
        //            debugger;
        //            if (!!vm.dataModel.CloseDate) vm.dataModel.Status = 2; else vm.dataModel.Status = 1;
        //        });
        //fs.setOnChangeFunction(
        //        "Status",
        //        function (selectedItem) {
        //            debugger;
        //            if (selectedItem==1) vm.dataModel.CloseDate = null;
        //        });
        //fs.setSyncValidator(
        //       "CloseDate","CloseDateValidator",
        //       function (modelValue, viewValue) {
        //           var openDateValue = new moment(vm.dataModel.OpenDate,
        //               kendo.culture()
        //               .calendar.patterns.d.toUpperCase());
        //           var closeDateValue = new moment(modelValue,
        //               kendo.culture()
        //               .calendar.patterns.d.toUpperCase());
        //           debugger;
        //            //Ha nincs vége dátum és a státusz Aktív vagy van vég e dátum és a státusz inaktív
        //           return (!modelValue && vm.dataModel.Status==1 ) || (openDateValue.isBefore(closeDateValue) && vm.dataModel.Status==2);
        //       });
        //fs.setSyncValidator(
        //    "Status", "StatusValidator",
        //    function (modelValue, viewValue) {
        //        debugger;
        //        return modelValue == 2 || (modelValue == 1 && !vm.dataModel.CloseDate)
        //    });
        //fs.setSyncValidator(
        //   "StartNumber", "StartNumberValidator",
        //   function (modelValue, viewValue) {
        //       //debugger;
        //       if (vm.dataModel.EndNumber>0)
        //            return modelValue < vm.dataModel.StartNumber;
        //       else return modelValue==0
        //   });
        //fs.setSyncValidator(
        //  "EndNumber", "EndNumberValidator",
        //  function (modelValue, viewValue) {
        //      //debugger;
        //      if (vm.dataModel.StartNumber > 0)
        //          return modelValue > vm.dataModel.StartNumber;
        //      else return modelValue == 0
        //  });
        generateForm(vm);
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';
  module.controller('RegBookLayoutCtrl_mrs', [
    '$scope',
    'breadcrumbRoots',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($scope, breadcrumbRoots, $http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RegBookLayoutCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      $scope.breadcrumbRoot = breadcrumbRoots.mrsApp && breadcrumbRoots.mrsApp.mrsRegBook;
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('RegBookNavCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'options',
    '$filter',
    'AuthService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      options,
      $filter,
      authService,
      $uibModal,
      HistoryService,
      dasService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RegBookNavCtrl_mrs', stateParams);
      }
      var vm = this;

      vm.back = function() {
        $state.go('main');
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        initMainGrid(
          vm,
          'GridRegBook',
          'Mrs/RegBook/RegBookList',
          function() {
            changeSubItemGridFilter(vm.mainGrid);
            setDasModel();
          },
          vm.getParameterFilter
        );
      }

      vm.history = function History() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        HistoryService.NavigateToHistory(
          'mrs_RegBook',
          id,
          vm,
          $state,
          true,
          vm.pageModel.Grids['GridRegBook'].IdColumn
        );
      };

      function changeSubItemGridFilter(targetGrid) {
        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);
        $scope.$apply();
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridRegBook'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$apply();
      }
    },
  ]);
})(angular.module('mrsApp'));

angular.module('mrsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      MrsRegBook: {
        url: '/mrs/regbook',
        templateUrl: 'App/Mrs/RegBook/RegBookLayout.html',
        controller: 'RegBookLayoutCtrl_mrs as vm',
        redirectTo: 'MrsRegBook.Nav',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'MrsRegBook.Nav': {
        url: '/nav',
        params: {
          module: 'regbook',
          formMode: 'Nav',
          createState: 'MrsRegBook.Create',
          editState: 'MrsRegBook.Edit',
          duplicateState: 'MrsRegBook.Duplicate',
          deleteState: 'Mrs/RegBook/RegBookDelete/',
          bstates: ['MrsRegBook.Create'],
          documentEntity: 'mrsregbook_nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/RegBook/RegBookNav.html',
            controller: 'RegBookNavCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/RegBook/RegBookNavOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Iktatókönyv',
        },
      },
      'MrsRegBook.Create': {
        url: '/create/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/RegBook/RegBookEdit.html',
            controller: 'RegBookEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/RegBook/RegBookCreate/'),
        },
        params: {
          formMode: 'Create',
          postUrl: 'Mrs/RegBook/RegBookCreate',
          backStateAfterSave: 'MrsRegBook.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'RegBookId' }],
          backState: 'MrsRegBook.Nav',
          createState: 'MrsRegBook.Create',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsRegBook.Nav',
          documentEntity: 'mrsregbook_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Iktatókönyv hozzáadása',
        },
      },
      'MrsRegBook.Edit': {
        url: '/edit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/RegBook/RegBookEdit.html',
            controller: 'RegBookEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/RegBook/RegBookEdit/', undefined, ['id']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/RegBook/RegBookEdit',
          backStateAfterSave: 'MrsRegBook.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'RegBookId' }],
          backState: 'MrsRegBook.Nav',
          createState: 'MrsRegBook.Create',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsRegBook.Nav',
          documentEntity: 'mrsregbook_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Iktatókönyv módosítás',
        },
      },
      'MrsRegBook.Duplicate': {
        url: '/duplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/RegBook/RegBookEdit.html',
            controller: 'RegBookEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/RegBook/RegBookDuplicate/', undefined, ['id']),
        },
        params: {
          formMode: 'Edit',
          EditOrDuplicate: 'Duplicate',
          postUrl: 'Mrs/RegBook/RegBookEdit',
          backStateAfterSave: 'MrsRegBook.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'RegBookId' }],
          backState: 'MrsRegBook.Nav',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsRegBook.Nav',
          documentEntity: 'mrsregbook_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Iktatókönyv másolása',
        },
      },
      'MrsRegBook.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/RegBook/RegBookHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Document");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('DossierEditCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$filter',
    'AuthService',
    '$uibModal',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, model, $filter, authService, $uibModal, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DossierEditCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.backWithUnlock = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.back();
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setMask('ScrappingYear', '9999');
        fs.setMask('ArchiveYear', '9999');

        fs.setDisabled('CloseDate', function() {
          return vm.dataModel.ModelState == 2;
        });
        fs.setDisabled('ScrappingYear', function() {
          return vm.dataModel.Status == 1;
        });
        fs.setDisabled('ArchiveYear', function() {
          return vm.dataModel.Status == 1;
        });
        fs.setDisabled('Status', function() {
          return !!vm.dataModel.CloseDate || vm.dataModel.ModelState == 2;
        });

        fs.setRequired('CloseDate', function() {
          return vm.dataModel.Status == 2;
        });

        fs.setOnChangeFunction('Status', function(selectedItem) {
          if (selectedItem.key == 1) vm.dataModel.CloseDate = undefined;
          vm.dataModel.ScrappingYear = undefined;
          vm.dataModel.ArchiveYear = undefined;
        });

        // fs.setOnChangeFunction(
        // "OpenDate",
        // function (selectedItem) {
        // });

        fs.setOnChangeFunction('CloseDate', function(selectedItem) {
          vm.dataModel.Status = 2;
          var closeYear = moment(vm.dataModel.CloseDate).year();
          if (vm.dataModel.ScrappingFromTopic > 0)
            vm.dataModel.ScrappingYear = closeYear + vm.dataModel.ScrappingFromTopic;
          if (vm.dataModel.ArchiveFromTopic > 0) vm.dataModel.ArchiveYear = closeYear + vm.dataModel.ArchiveFromTopic;
        });

        var whereForPrevious = function() {
          return (
            'TopicId~eq~' + (!!vm.dataModel.TopicId && !!vm.dataModel.TopicId.Value ? vm.dataModel.TopicId.Value : 0)
          );
        };

        generateForm(vm);
        vm.pageModel.Fields.Previous.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereForPrevious;
        //a setDisabled nem működik KendoDatePickeren?
        if (vm.dataModel.ModelState == 2)
          vm.pageModel.Fields.CloseDate.FormlyFieldDescriptor.templateOptions.disabled = true;
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('TopicEditCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$filter',
    'AuthService',
    '$uibModal',
    'MrsLockService',
    function($scope, $http, $state, $stateParams, model, $filter, authService, $uibModal, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TopicEditCtrl_mrs', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.backWithUnlock = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.back();
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var fs = fieldSetter;
        fs.vm = vm;

        generateForm(vm);
      }
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('TopicLayoutCtrl_mrs', [
    '$scope',
    'breadcrumbRoots',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($scope, breadcrumbRoots, $http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TopicLayoutCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      $scope.breadcrumbRoot = breadcrumbRoots.mrsApp && breadcrumbRoots.mrsApp.mrsTopic;
    },
  ]);
})(angular.module('mrsApp'));

(function(module) {
  'use strict';

  module.controller('TopicNavCtrl_mrs', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'options',
    '$filter',
    'AuthService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      options,
      $filter,
      authService,
      $uibModal,
      HistoryService,
      dasService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TopicNavCtrl_mrs', stateParams);
      }
      var vm = this;
      vm.stateParams = $stateParams;
      vm.prevState = $state.previous;
      vm.back = function() {
        $state.go('main');
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        initMainGrid(
          vm,
          'GridTopic',
          'Mrs/Topic/TopicList',
          function(a) {
            changeSubItemGridFilter(vm.mainGrid);
            setTopicDasModel();
          },
          vm.getParameterFilter
        );

        initSubGrids(
          vm,
          'Mrs/Topic/DossierList',
          function() {
            return {
              targetTopicId: getSelectedRowIdFromMainGrid(vm),
            };
          },
          ['PanelDossier']
        );

        createSubGridIdFinder(['GridDossier']);
      }

      vm.mainHistory = function MainHistory() {
        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);
        if (!vm.selectedMainGridItemId) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = vm.selectedMainGridItemId;
          HistoryService.NavigateToHistory('mrs_Topic', id, vm, $state, true, vm.pageModel.Grids['GridTopic'].IdColumn);
        }
      };

      vm.subHistory = function SubHistory() {
        if (!vm.selectedSubGridItemId) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = vm.selectedSubGridItemId.GridDossier;
          HistoryService.NavigateToHistory(
            'mrs_Dossier',
            id,
            vm,
            $state,
            true,
            vm.pageModel.Grids['GridDossier'].IdColumn
          );
        }
      };

      function changeSubItemGridFilter(targetGrid) {
        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);
        angular.forEach(vm.selectedSubGridItemId, function(value, key) {
          vm.selectedSubGridItemId[key] = -1;
        });
        $scope.$apply();
        vm.subGrids['GridDossier'].dataSource.read();
      }

      function createSubGridIdFinder(grids) {
        vm.selectedSubGridItemId = {};
        angular.forEach(grids, function(value, key) {
          vm.selectedSubGridItemId[value] = -1;
          vm.subGridOptions[value].change = function(e) {
            var grid = e.sender;
            var rowData = grid.dataItem(this.select());
            vm.selectedSubGridItemId[grid.options.descriptorName] = angular.isDefined(rowData) ? rowData.DossierId : -1;
            setDossierDasModel();
            $scope.$apply();
          };
        });
      }

      function setTopicDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridTopic'].DasDescriptor;
        vm.dasTopicModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: getSelectedRowIdFromMainGrid(vm),
        };
        $scope.$apply();
      }

      function setDossierDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridDossier'].DasDescriptor;
        vm.dasDossierModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: vm.selectedSubGridItemId['GridDossier'],
        };
        $scope.$apply();
      }
    },
  ]);
})(angular.module('mrsApp'));

angular.module('mrsApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      MrsTopic: {
        url: '/mrs/topic',
        templateUrl: 'App/Mrs/Topic/TopicLayout.html',
        controller: 'TopicLayoutCtrl_mrs as vm',
        redirectTo: 'MrsTopic.Nav',
        ncyBreadcrumb: {
          label: '{{breadcrumbRoot}}',
          parent: 'main',
        },
      },
      'MrsTopic.Nav': {
        url: '/nav',
        params: {
          module: 'topic',
          formMode: 'Nav',
          createState: 'MrsTopic.Create',
          editState: 'MrsTopic.Edit',
          duplicateState: 'MrsTopic.Duplicate',
          deleteState: 'Mrs/Topic/TopicDelete/',
          bstates: ['MrsTopic.GridDossierCreate', 'MrsTopic.GridDossierEdit', 'MrsTopic.GridDossierDuplicate'],
          subState: 'MrsTopic.',
          subDeleteState: 'Mrs/Topic/DossierDelete/',
          documentEntity: 'mrstopic_nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/TopicNav.html',
            controller: 'TopicNavCtrl_mrs as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Mrs/Topic/TopicNavOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ügykör és ügyirat',
        },
      },
      'MrsTopic.Create': {
        url: '/topic/create/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/TopicEdit.html',
            controller: 'TopicEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Topic/TopicCreate/'),
        },
        params: {
          formMode: 'Create',
          postUrl: 'Topic/TopicCreate',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          createState: 'MrsTopic.Create',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügykör hozzáadása',
        },
      },
      'MrsTopic.Edit': {
        url: '/topic/edit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/TopicEdit.html',
            controller: 'TopicEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Topic/TopicEdit/', undefined, ['id']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Topic/TopicEdit',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          createState: 'MrsTopic.Create',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügykör szerkesztése',
        },
      },
      'MrsTopic.Duplicate': {
        url: '/topic/duplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/TopicEdit.html',
            controller: 'TopicEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Topic/TopicDuplicate/', undefined, ['id']),
        },
        params: {
          formMode: 'Edit',
          EditOrDuplicate: 'Duplicate',
          postUrl: 'Mrs/Topic/TopicEdit',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_create',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügykör  másolása',
        },
      },
      'MrsTopic.GridDossierCreate': {
        url: '/topic/createdossier/?id&TopicId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/DossierEdit.html',
            controller: 'DossierEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Topic/DossierCreate/', undefined, ['TopicId']),
        },
        params: {
          formMode: 'Create',
          postUrl: 'Topic/DossierCreate',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          createState: 'MrsTopic.GridDossierCreate',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_griddossiercreate',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügyirat hozzáadása',
        },
      },
      'MrsTopic.GridDossierEdit': {
        url: '/topic/dossieredit/?id&TopicId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/DossierEdit.html',
            controller: 'DossierEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Topic/DossierEdit/', undefined, ['id', 'TopicId']),
        },
        params: {
          formMode: 'Edit',
          postUrl: 'Mrs/Topic/DossierEdit',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          createState: 'MrsTopic.GridDossierCreate',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_griddossiercreate',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügyirat szerkesztése',
        },
      },
      'MrsTopic.GridDossierDuplicate': {
        url: '/topic/dossierduplicate/?id&TopicId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Mrs/Topic/DossierEdit.html',
            controller: 'DossierEditCtrl_mrs as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Mrs/Topic/DossierDuplicate/', undefined, ['id', 'TopicId']),
        },
        params: {
          formMode: 'Edit',
          EditOrDuplicate: 'Duplicate',
          postUrl: 'Mrs/Topic/DossierEdit',
          backStateAfterSave: 'MrsTopic.Nav',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TopicId' }],
          backState: 'MrsTopic.Nav',
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'MrsTopic.Nav',
          documentEntity: 'mrstopic_griddossiercreate',
        },
        ncyBreadcrumb: {
          parent: 'main',
          label: 'Ügyirat másolása',
        },
      },
      'MrsTopic.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
          documentEntity: '',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MrsMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Mrs/Topic/TopicHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Document");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

var myApp = angular.module('myApp', [
  // "ngRaven",
  'dasApp',
  'dmsApp',
  'mrsApp',
  'sbProperty',
  'sbService',
  'sbPartner',
  'sbUtility',
  'sbContract',
  'sbUtilization',
  'sbSupplyContract',
  'sbBudget',
  'sbForrasDoclib',
  'ui.router',
  'ui.router.state.events',
  'ui.bootstrap',
  'ui.mask',
  'angular-loading-bar',
  'kendo.directives',
  'ngMessages',
  'formly',
  'formlyBootstrap',
  'timer',
  'ncy-angular-breadcrumb',
  'ngMap',
  'checklist-model',
  'ngFileSaver',
  'LocalStorageModule',
  'ngLodash',
  'asyncFilter',
  'sbUiKit',
  'ngAnimate',
  'ngSanitize',
]);

myApp.filter('format', function() {
  return function(input, ...args) {
    if (!input) return input;
    return input.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  };
});

myApp.constant('breadcrumbRoots', {
  dmsApp: {
    document: 'Dokumentumtár',
    dmsMasterdata: 'Dokumentumtár',
  },
  mrsApp: {
    document: 'Posta iktatás',
    mrsMasterdata: 'Posta iktatás',
    mrsRegBook: 'Posta iktatás',
    mrsTopic: 'Posta iktatás',
  },
});

//-------------------------------
//-- Spinner configuration
//-------------------------------
myApp.config([
  'cfpLoadingBarProvider',
  '$qProvider',
  function(loadingBar, $qProvider) {
    // HACK: Formly's TextAngular dependency is only compatible until Angular 1.6, as Angular deprecated the lowercase function...
    /* https://stackoverflow.com/questions/50448326/uncaught-typeerror-angular-lowercase-is-not-a-function */
    //angular.lowercase = text => text.toLowerCase();
    angular.lowercase = angular.$$lowercase;

    //Turn the spinner off
    loadingBar.includeSpinner = false;
    $qProvider.errorOnUnhandledRejections(false);
  },
]);

//-------------------------------
//-- Run
//-------------------------------
myApp
  .run(['ConfigService', function(ConfigService) {}])
  .run([
    'AuthService',
    '$rootScope',
    function(authService, $rootScope) {
      $rootScope.loadedUserContext = function() {
        if (!!authService.parameters) {
          if (!!authService.parameters.FWCOID) {
            toastr.options.timeOut = 6200;
          } else {
            authService.parameters.FWCOID = false;
          }
        }
      };
      //--> getUserContext
      authService.check().then(function(isLoggedIn) {
        authService.isLoggedIn = isLoggedIn;
        if (authService.isLoggedIn) {
          authService.getUserContext(false, $rootScope.loadedUserContext);
        }
      });
    },
  ])
  .run([
    '$http',
    '$rootScope',
    '$state',
    '$timeout',
    'AuthService',
    'FormInitService',
    'gridService',
    'DasService',
    'localStorageService',
    'formlyConfig',
    '$location',
    'AppConstant',
    '$uibModalStack',
    'LockService',
    'HelpAndManualService',
    'UIHelperService',
    '$urlRouter',
    function(
      $http,
      $rootScope,
      $state,
      $timeout,
      authService,
      formInitService,
      gridService,
      dasService,
      localStorageService,
      fc,
      $location,
      appConstant,
      $uibModalStack,
      lockService,
      hmService,
      UIHelperService,
      $urlRouter
    ) {
      const toastrWarning = toastr.warning;
      const toastrSuccess = toastr.success;
      const toastrError = toastr.error;
      const toastrInfo = toastr.info;
      $rootScope.formInitService = formInitService;

      toastr.warning = function() {
        this.callBack = arguments[2]?.callBack;
        return typeof toastrWarning === 'function' && toastrWarning(...arguments);
      };
      toastr.success = function() {
        typeof toastrSuccess === 'function' && toastrSuccess(...arguments);
        return (this.callBack = arguments[2]?.callBack);
      };
      toastr.error = function() {
        typeof toastrError === 'function' && toastrError(...arguments);
        return (this.callBack = arguments[2]?.callBack);
      };
      toastr.info = function() {
        typeof toastrInfo === 'function' && toastrInfo(...arguments);
        return (this.callBack = arguments[2]?.callBack);
      };
      toastr.options.onHidden = function() {
        $('.toastrshow', '').remove();
        return typeof this.callBack === 'function' && this.callBack();
      };
      toastr.options.onShown = function() {
        let type = this.className.replace(/^.+toast-([^ $]+).*/, '$1');
        let text = $(this)
          .find('.toast-message')
          .text();
        $('[ui-view]').before('<span name="toastrshow" class="toastrshow" value="' + type + '|' + text + '"></span>');
      };

      var bindAjaxSendEvent = function(e, f, t) {
        authService.lastCall();
        if (authService.parameters?.FWCOID === false) {
          $(document)
            .unbind('ajaxSend', bindAjaxSendEvent)
            .unbind('ajaxComplete', bindAjaxCompleteEvent);
        }
        if (!t?.url?.match(/Event\/|Favourite\/|dist\//g)) {
          $('[ui-view]').append('<div name="pageCalls" class="' + t?.url?.replace(/[^\w\s]/gi, '') + '"></div>');
        }
      };
      var bindAjaxCompleteEvent = function(event, f, t) {
        authService.lastCall();
        if (authService.parameters?.FWCOID === false) {
          $(document)
            .unbind('ajaxSend', bindAjaxSendEvent)
            .unbind('ajaxComplete', bindAjaxCompleteEvent);
        }
        if (!t?.url?.match(/Event\/|Favourite\/|dist\//g)) {
          if (!!t?.url) {
            $('.' + t.url.replace(/[^\w\s]/gi, '')).remove();
          }
        }
      };
      $(document)
        .bind('ajaxSend', bindAjaxSendEvent)
        .bind('ajaxComplete', bindAjaxCompleteEvent);
      (function() {
        var __xhr = window.XMLHttpRequest;

        function XMLHttpRequest() {
          if (authService.parameters?.FWCOID === false) {
            window.XMLHttpRequest = __xhr;
          }
          let xhr = new __xhr();
          xhr.addEventListener('loadstart', startHandleEvent);
          xhr.addEventListener('load', startHandleEvent);
          xhr.addEventListener('progress', startHandleEvent);
          xhr.addEventListener('loadend', endHandleEvent);
          xhr.addEventListener('timeout', endHandleEvent);
          return xhr;
          function startHandleEvent(e, f, t) {
            authService.lastCall();
            if (!this.responseURL.match(/Event\/|Favourite\/|dist\//g)) {
              let url = this.responseURL == '' ? 'pageCalls' : this.responseURL.replace(/[^\w\s]/gi, '');
              $('[ui-view]').append('<div name="pageCalls" class="' + url + '"></div>');
            }
          }
          function endHandleEvent(e, f, t) {
            //  if(this.responseURL!='' && !this.responseURL.match(/Event\/|Favourite\/|dist\//g)){
            authService.lastCall();
            if (!!this.responseURL) {
              $('.' + this.responseURL.replace(/[^\w\s]/gi, '')).remove();
              $('.pageCalls', '').remove();
            }
            //            }
          }
        }
        window.XMLHttpRequest = XMLHttpRequest;
      })();

      if (!!apiCheck?.globalConfig) {
        apiCheck.globalConfig.disabled = true;
      }
      $rootScope.controllerResolvedData = {};
      $rootScope.$on('$stateAndRefreshForElement', function(event, scope) {
        scope.goState = function() {
          let params = scope.RouteState.getParams();
          let link =
            $state.href(scope.RouteState.state, params) ?? $state.href(scope.RouteState.state + 'List', params);
          window.open(link);
        };
        scope.refresh = function() {
          scope.options.dataSource.read();
        };
        scope.RouteState = routeStateToObject(scope.RouteState);

        scope.dropDownMenuItems = [];
        if (!!scope?.RouteState) {
          scope.dropDownMenuItems.push({ click: scope.goState, name: 'Törzs új lapon' });
        }
        if (!!scope?.Refresh) {
          scope.dropDownMenuItems.push({ click: scope.refresh, name: 'Frissítés' });
        }
      });

      $rootScope.$on('$addClassOrIdToElement', function(event, inElement, addClass, addId, ids) {
        let data = '';
        if (inElement.length > 1) {
          inElement.each(function(index, element) {
            if (!!ids) {
              data = '_' + ids[index];
            }
            if (!!addClass && !$(element).hasClass(addClass + data)) {
              let classes = $(element).attr('class');
              $(element)
                .removeClass()
                .addClass(addClass + data + ' ' + classes);
            }
            if (!!addId) {
              $(element).attr('id', addId + data);
            }
          });
        } else {
          if (!!addClass && !$(inElement).hasClass(addClass)) {
            let classes = $(inElement).attr('class');
            $(inElement)
              .removeClass()
              .addClass(addClass + ' ' + classes);
          }
          if (!!addId) {
            $(inElement).attr('id', addId);
          }
        }
      });

      $rootScope.$on('$locationChangeStart', function(ev, next, current) {
        //if (next.includes("/partner/")) {
        //    UIHelperService.toggleBurgerStatus(true);
        //} else  UIHelperService.toggleBurgerStatus(false);
        $urlRouter.location = decodeURIComponent(next)
          .replace('#!#!', '#!')
          .split('#!')[1];
        $urlRouter.update();
        UIHelperService.previouspageUrl = current;
        lockService.unlockWhenLeavingPage(next);
        // end
      });

      ///--> stateChangeError
      $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        if (error) {
          if (error.status === 401) {
            $state.go(appConstant.loginStateName, {
              redirectTo: encodeURIComponent($location.url()),
            });
          }
        }
      });

      //--> stateChangeStart
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        $('.PageOnLoad').remove();
        var needAuth = angular.isDefined(toState.needAuth) ? toState.needAuth : true;

        if (needAuth) {
          authService
            .check()
            .then(
              function(isLoggedIn) {
                let tokenLogin =
                  !!authService?.user?.tokenLogin && !authService.user.tokenLogin.states.includes(toState.name);
                if (!isLoggedIn) {
                  event.preventDefault();
                  if (authService?.user?.tokenLogin?.states?.includes(toState.name)) {
                    $state.go('loginToken', { token: authService?.user?.tokenLogin.token });
                  }
                  $state.go(appConstant.loginStateName, { redirectTo: encodeURIComponent($location.url()) });
                } else if (tokenLogin) {
                  event.preventDefault();
                  authService?.logout();
                }
              },
              function() {
                authService?.logout();
              }
            )
            .catch(function() {
              authService?.logout();
            });
        }
        $rootScope.$on('AuthService:setMenu', function() {
          if (!authService.menu) return;
          let menus = {
            menu: authService.menu,
            mainMenu: authService.mainMenu,
            unpermittedMenu: authService.unpermittedMenu,
          };
          const foundUnpermittedMenu = menus.unpermittedMenu?.find(el => el.State === toState.name);
          if (!!foundUnpermittedMenu) {
            event?.preventDefault();
            toastr.warning('Önnek nincs jogosultsága a menüpont végrehajtásához: ' + foundUnpermittedMenu?.Text + ' !');
            $state.go(
              !!fromState.name && toState.name != fromState.name
                ? fromState.name
                : foundUnpermittedMenu.state == 'main'
                ? ''
                : 'main'
            );
          }
        });
      });

      $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        toState.stateTransitionInfo = {
          previousStateName: fromState.name,
        };
        if ((authService?.parameters?.FWFIDL ?? true) && toParams.controllerOptions) {
          toParams.controllerOptions.ctrlId = toState.views.content.controller.replace(/^([a-zA-Z]+).*$/, '$1');
          if (toParams.controllerOptions.ctrlIdTemplate) {
            toParams.controllerOptions.ctrlId = event.currentScope.formInitService.CompileCtrlId(
              toParams.controllerOptions.ctrlIdTemplate,
              toParams,
              event.currentScope.controllerResolvedData[toParams.controllerOptions.ctrlIdTemplate]
            );
          }
          toParams.controllerOptions.waitFormGenerate = true;
        }
        // Add {fromParams} to {from}
        fromState.params = fromParams;
        // Assign {from} to {previous} in $state
        $state.previous = fromState;
        if (toState.params) {
          hmService.setActiveHMPage(toState.params.helpAndManualPageId);
        } else {
          hmService.setActiveHMPage(undefined);
        }
      });

      //--> viewContentLoaded
      $rootScope.$on('$viewContentLoaded', function(event, toState, toParams, fromState, fromParams) {
        $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
          let tokenLogin = !!authService?.user?.tokenLogin;
          if (tokenLogin) {
            $('.content-header').css('position', 'fixed');
            $('.navbar-breadcrumb').remove();
            $('.navbar:first').remove();
            $('.content-header').css('top', '0px');
            $('.content-header').css('display', 'flex');
            $('.content-header').css('justify-content', 'flex-end');
            $('body').css('padding-top', '60px');
          }
        });
        let tokenLogin = !!authService?.user?.tokenLogin;
        if (tokenLogin) {
          $('.content-header').css('position', 'fixed');
          $('.navbar-breadcrumb').remove();
          $('.navbar:first').remove();
          $('.content-header').css('top', '0px');
          $('.content-header').css('display', 'flex');
          $('.content-header').css('justify-content', 'flex-end');
          $('body').css('padding-top', '60px');
        }
        if (event.targetScope.vm) {
          var targetVM = event.targetScope.vm;
          var transitionInfo = event.targetScope.$resolve.$transition$;
          if (transitionInfo) {
            transitionInfo['currentStateParams'] = event.targetScope.$resolve.$stateParams;
            if (!!event.targetScope.$resolve.$state$.stateTransitionInfo) {
              transitionInfo['previousStateName'] =
                event.targetScope.$resolve.$state$.stateTransitionInfo.previousStateName;
            }
          }
          angular.element(document).ready(function() {
            $('[ui-view]').append('<div class="PageOnLoad"></div>');
          });
        }
      });

      //--> angular-formly

      fc.setType({
        name: 'kendoAC',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/autocomplete.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'input',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/input.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'textCombo',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/kendoTextComboBox.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$state',
          '$stateParams',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $state, $stateParams, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $rootScope.$emit('$stateAndRefreshForElement', $scope.to);
            //A INT 0-át a combobox értéknek veszi, mivel ilyen id soha nincs a listában, így rögtön null értéket vesz fel a model,
            //amitől dirty lesz a from, ezért előtte (int)0 -> null konverzió kell #38582
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if (!!authService.parameters?.FWCOID) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
                let elementNumber = 0;
                $(element)
                  .find("span[id*='-']")
                  .each(function(index, element) {
                    element.id = (!!addId ? addId : addClass) + '_kid' + elementNumber++;
                  });
              }
            };

            if (!!$scope.fields) {
              angular.forEach($scope.fields, function(field, key) {
                if (field.type === 'textCombo' && angular.isFunction(field.value)) {
                  $scope.to.defaultValue = field.value();
                }
              });
            }
          },
        ],
        link: function(scope, el, attrs) {
          $(el)
            .find('input')
            .attr('maxlength', scope.to.maxlength);
          scope.to.id =
            scope.to.DOMId ?? scope.id.replace(/(vm.formly|formly)_*([\d]{0,2})_kendo[^_]+_([^_]+)[_\d]+/g, '$3$2');
          scope.to.addClassOrIdToElement($(el).find('span, input'), 'k-input');
          scope.to.addClassOrIdToElement($(el).find('span, input'), scope.to.id + '_click');
          scope.$on('$destroy', function() {
            scope.to?.options?.dataSource?.unbind('change');
          });
        },
      });
      fc.setType({
        name: 'password',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/password.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'textarea',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/textarea.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          '$rootScope',
          'AuthService',
          function($scope, $stateParams) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.to.applyChange = function(changedTo) {
              if (!changedTo?.length) {
                changedTo = '';
                $scope.model[$scope.options.key] = '';
              }
              $scope.to.length = changedTo?.length ?? 0;
              $('[id="' + $scope.options.id + '"]')[0].value = $scope.model[$scope.options.key];
              if (angular.isFunction($scope.to.changed)) {
                $scope.to.changed(changedTo);
              }
            };
            $scope.to.length = $scope.model[$scope.options.key]?.length ?? 0;
          },
        ],
      });
      fc.setType({
        name: 'myInput',
        extends: 'input',
        templateUrl: 'App/templates/formly/custom/myInput.html',
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'checkbox',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/checkbox.html',
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'f2Input',
        templateUrl: 'App/templates/formly/f2Input.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'f22Input',
        templateUrl: 'App/templates/formly/f22Input.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'pathSelector',
        templateUrl: 'App/templates/formly/pathSelector.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'digitSign',
        templateUrl: 'App/templates/formly/digitSign.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'f4Input',
        templateUrl: 'App/templates/formly/f4Input.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'radioGroup',
        templateUrl: 'App/templates/formly/radioGroup.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'kendoDDL',
        templateUrl: 'App/templates/formly/kendoDropDownList.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: { templateOptions: { options: {} } },
        controller: [
          '$scope',
          '$state',
          '$stateParams',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $state, $stateParams, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $rootScope.$emit('$stateAndRefreshForElement', $scope.to);
            //A INT 0-át a combobox értéknek veszi, mivel ilyen id soha nincs a listában, így rögtön null értéket vesz fel a model,
            //amitől dirty lesz a from, ezért előtte (int)0 -> null konverzió kell #38582
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if (!!authService.parameters?.FWCOID) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
                let elementNumber = 0;
                $(element)
                  .find("span[id*='-']")
                  .each(function(index, element) {
                    element.id = (!!addId ? addId : addClass) + '_kid' + elementNumber++;
                  });
              }
            };

            if (!!$scope.fields) {
              angular.forEach($scope.fields, function(field, key) {
                if (field.type === 'kendoDDL' && angular.isFunction(field.value) && field.value() === 0) {
                  field.value(null);
                }
              });
            }
          },
        ],
        link: function(scope, el, attrs) {
          scope.to.id =
            scope.to.DOMId ?? scope.id.replace(/(vm.formly|formly)_*([\d]{0,2})_kendo[^_]+_([^_]+)[_\d]+/g, '$3$2');
          scope.to.addClassOrIdToElement($(el).find('span, input'), 'k-input');
          scope.to.addClassOrIdToElement($(el).find('span, input'), scope.to.id + '_click');
          scope.$on('$destroy', function() {
            scope.to?.options?.dataSource?.unbind('change');
          });
        },
      });
      fc.setType({
        name: 'kendoCB',
        templateUrl: 'App/templates/formly/kendoComboBox.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: { templateOptions: { options: {} } },
        controller: [
          '$scope',
          '$stateParams',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $stateParams, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if (!!authService.parameters?.FWCOID) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
              }
            };
          },
        ],
      });
      fc.setType({
        name: 'kendoCBMC',
        templateUrl: 'App/templates/formly/kendoComboMultiColumn.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: { templateOptions: { options: {} } },
        controller: [
          '$scope',
          '$stateParams',
          '$rootScope',
          'LanguageService',
          function($scope, $stateParams, $rootScope, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            //DataBindingbe bevisszük a kiinduló értéket, hogy ha nincs az értékkészletben az adott érték, ki tudjuk nullozni
            $scope.lastModelValue = $scope.originalModel[$scope.options.key];
            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $rootScope.$emit('$stateAndRefreshForElement', $scope.to);
            $scope.to.applyChange = function(changedTo) {
              let value = changedTo === null ? null : changedTo[$scope.options.templateOptions.options.dataValueField];
              if (!value) {
                $scope.model[$scope.options.key] = null;
              }
              if (angular.isFunction($scope.to.changed)) {
                $scope.to.changed(value, changedTo);
              }
              $scope.lastModelValue = $scope.model[$scope.options.key];
            };
          },
        ],
      });
      fc.setType({
        name: 'kendoMS',
        templateUrl: 'App/templates/formly/kendoMultiSelect.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: {
          templateOptions: { options: {} },
        },
        controller: [
          '$scope',
          '$stateParams',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $stateParams, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $rootScope.$emit('$stateAndRefreshForElement', $scope.to);

            var copyModel = $scope.originalModel[$scope.options.key];
            $scope.model[$scope.options.key] = copyModel;
            $scope.to.originalModel = copyModel;
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if (!!authService.parameters?.FWCOID) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
              }
            };
            $scope.to.ownValidate = function(form, scope) {
              let allKey = Array.from(scope.to?.options?.dataSource?.data(), x => x.key.toString());
              let existsKey = scope.to.selectedItems?.some(x => allKey.includes(x.toString()));
              let valid = !scope.to.required || !!existsKey;
              form?.$setValidity('required', valid);
              form?.$setValidity('parse', valid);
            };

            $scope.$watch('to.selectedItems', function(newValue, oldValue, e) {
              let scope = e,
                formElement = e?.form[e.options.id];
              scope.to.ownValidate(formElement, scope);
              if (!!scope.to.selectedItems) {
                scope.model[scope.options.key] = angular.copy(
                  scope.to.itemType === 'Array' ? scope.to.selectedItems : scope.to.selectedItems.join()
                );
                $(document.getElementById(scope.id))
                  ?.data('kendoMultiSelect')
                  ?.value(scope.to.selectedItems);
              }
            });
          },
        ],
        link: function(scope, el, attrs) {
          scope.to.id =
            scope.to.DOMId ?? scope.id.replace(/(vm.formly|formly)_*([\d]{0,2})_kendo[^_]+_([^_]+)[_\d]+/g, '$3$2');
          scope.to.addClassOrIdToElement($(el).find('span, input'), scope.to.id);
          scope.to.addClassOrIdToElement($(el).find('span, input'), scope.to.id + '_click');
          scope.to.addClassOrIdToElement($(el).find('.k-multiselect-wrap'), scope.to.id);
        },
      });
      fc.setType({
        name: 'kendoDP',
        templateUrl: 'App/templates/formly/kendoDatePicker.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: { templateOptions: { options: {} } },
        controller: [
          '$scope',
          '$stateParams',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $stateParams, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            let model = new moment($scope.model[$scope.options.key], kendo.culture().calendar.patterns.d.toUpperCase());
            let minDate = moment('0001-01-02', kendo.culture().calendar.patterns.d.toUpperCase());
            if (model.isBefore(minDate)) {
              $scope.model[$scope.options.key] = null;
            }
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if (!!authService.parameters?.FWCOID) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
              }
            };
            $scope.clear = function() {
              $scope.model[$scope.options.key] = null;
              if (angular.isFunction($scope.to.changed)) $scope.to.changed();
            };
            if (
              $scope.options.templateOptions.DateTimeOptions &&
              $scope.options.templateOptions.DateTimeOptions.interval &&
              $scope.options.templateOptions.DateTimeOptions.interval > 0
            ) {
              $scope.options.templateOptions.options.interval = $scope.options.templateOptions.DateTimeOptions.interval;
            }
          },
        ],
        link: function(scope, el, attrs) {
          scope.to.id =
            scope.to.DOMId ?? scope.id.replace(/(vm.formly|formly)_*([\d]{0,2})_kendo[^_]+_([^_]+)[_\d]+/g, '$3$2');
          scope.to.addClassOrIdToElement($(el).find('.k-i-calendar'), scope.to.id + 'cal');
          let calButton = $(el)
            .find('.k-i-calendar')
            .parent();
          if ($(calButton)[0]?.type == 'button') {
            scope.to.addClassOrIdToElement(calButton, scope.to.id + 'cal');
          }
          scope.$watch('model[options.key]', function(newValue) {
            if (newValue === '') {
              scope.model[scope.options.key] = null;
            }
          });
        },
      });
      fc.setType({
        name: 'kendoDTP',
        extends: 'kendoDP',
        templateUrl: 'App/templates/formly/kendoDateTimePicker.html',
        defaultOptions: { templateOptions: { options: { interval: 15 } } },
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);
            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });

      fc.setType({
        name: 'kendoTP',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        extends: 'kendoDP',
        templateUrl: 'App/templates/formly/kendoTimePicker.html',
        defaultOptions: { templateOptions: { options: { interval: 15 } } },
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $scope.clear = function() {
              $scope.model[$scope.options.key] = null;
              if (angular.isFunction($scope.to.changed)) $scope.to.changed();
            };
            var dateTime = new moment($scope.options.initialValue);
            $scope.model[$scope.options.key] = dateTime.isValid() ? dateTime.format('LT') : null;
            if (
              $scope.options.templateOptions.DateTimeOptions.interval &&
              $scope.options.templateOptions.DateTimeOptions.interval > 0
            ) {
              $scope.options.templateOptions.options.interval = $scope.options.templateOptions.DateTimeOptions.interval;
            }
          },
        ],
      });
      fc.setType({
        name: 'kendoCP',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/kendoColorPicker.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });

      fc.setType({
        name: 'kendoEditor',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/kendoEditor.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: {
          templateOptions: {
            options: {
              change: function(e) {
                e.sender.$angular_scope.model[e.sender.$angular_scope.options.key] = e.sender.$angular_scope.htmlText;
              },
              //keyup: function (e) {
              //    e.sender.$angular_scope.model[e.sender.$angular_scope.options.key] = e.sender.value();
              //    //e.sender.$angular_scope.form[e.sender.$angular_scope.id].$setValidity("required", e.sender.value() ? true : false);
              //}
            },
          },
          validators: {
            required: function(viewValue, modelValue, scope) {
              return !!modelValue;
            },
          },
        },
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $scope.htmlText = $scope.model[$scope.options.key];
          },
        ],
      });

      fc.setType({
        name: 'kendoNTB',
        templateUrl: 'App/templates/formly/kendoNumericTextBox.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: { templateOptions: { options: { decimals: 2, format: 'n2', min: null, max: null } } },
        controller: [
          '$scope',
          '$stateParams',
          '$state',
          '$rootScope',
          'AuthService',
          'LanguageService',
          function($scope, $stateParams, $state, $rootScope, authService, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $scope.to.FWCOID = !!authService.parameters?.FWCOID;
            $scope.to.addClassOrIdToElement = function(element, addClass, addId, ids) {
              if ($scope.to.FWCOID || true) {
                $rootScope.$emit('$addClassOrIdToElement', element, addClass, addId, ids);
              }
            };
          },
        ],
        link: function(scope, el, attrs) {
          if (
            !el.find('.k-numerictextbox.k-input-inner')?.length &&
            el.parents('sb-property-short-details-form').length !== 0
          ) {
            el.find('.k-numerictextbox').addClass('k-input-inner');
          }
          if (scope.to.FWCOID) {
            $('[id="' + scope.id + '"]').attr('style', 'display: inline-block');
            $(el)
              .find('input:first')
              .remove();
            $('[id="' + scope.id + '"]').bind('DOMSubtreeModified', function(event) {
              $(this).attr('style', 'display: inline-block');
            });

            var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutationRecord) {
                if ($(mutationRecord.target).attr('style') != 'display: inline-block') {
                  $(mutationRecord.target).attr('style', 'display: inline-block');
                }
              });
            });
            var target = document.getElementById(scope.id);
            observer.observe(target, {
              attributes: true,
              attributeFilter: ['style'],
            });
          }
        },
      });
      fc.setType({
        name: 'kendoMTB',
        extends: 'input',
        templateUrl: 'App/templates/formly/kendoMaskedTextBox.html',
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'kendoLB',
        extends: 'input',
        templateUrl: 'App/templates/formly/kendoListBox.html',
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });
      fc.setType({
        name: 'labelBox',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/labelBox.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            $scope.to.labelValue = $scope.to.label;
            delete $scope.to.label;
          },
        ],
      });
      fc.setType({
        name: 'kendoFU',
        templateUrl: 'App/templates/formly/kendoFileUpload.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: {
          templateOptions: { showFileList: true, multipleFileUpload: false, files: [], accept: '' },
          validators: {
            fileSize: function(viewValue, modelValue, scope) {
              var value = modelValue || viewValue;
              var maxFileSize = scope.to.maxFileSize;
              return value && value.size && maxFileSize ? value.size <= maxFileSize : true;
            },
          },
        },
        controller: [
          '$scope',
          'lodash',
          'LanguageService',
          function($scope, lodash, languageService) {
            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
            var sFile = null;

            function fireChange() {
              $scope.$apply(function() {
                var fMeta = sFile
                  ? {
                      name: sFile.name,
                      size: sFile.size,
                      type: sFile.rawFile.type,
                      getFile: function() {
                        return sFile.rawFile;
                      },
                      getErrors: function() {
                        return !!sFile.validationErrors ? sFile.validationErrors.length : 0;
                      },
                    }
                  : null;

                $scope.model[$scope.options.key] = fMeta;

                if (angular.isFunction($scope.to.changed)) $scope.to.changed();
              });
            }

            $scope.select = function(event) {
              if (event.sender.multiple === false && event.sender.getFiles().length > 0) {
                toastr.warning(
                  'Több fájl kiválasztása nem támogatott! Törölje a meglévő fájlt az új kiválasztása előtt!',
                  'Figyelem!'
                );
                event.preventDefault();
              } else if (angular.isFunction($scope.to.eventHandlers.onSelect)) $scope.to.eventHandlers.onSelect(event);
              var file = event.files[0];
              sFile = file;
              fireChange();
            };

            $scope.remove = function(event) {
              var file = event.files[0];

              if (sFile === file) {
                sFile = null;
                fireChange();
              }
              if (file.loadedFromDb) {
                event.sender.clearFile(function(f) {
                  return f[0].uid === file.uid;
                });
                fireChange();
                if ($scope.to.eventHandlers.onRemoveFileFromDb) {
                  $scope.to.eventHandlers.onRemoveFileFromDb(file);
                }
                event.preventDefault();
                return true;
              }
              if (angular.isFunction($scope.to.eventHandlers.onRemove)) $scope.to.eventHandlers.onRemove(event);
            };
            if ($scope.to.DocumentDto) {
              if ($scope.model[$scope.to.DocumentDto].StoredFiles) {
                lodash
                  .map($scope.model[$scope.to.DocumentDto].StoredFiles, function(file) {
                    return {
                      name: file.DocName,
                      size: file.DocSize,
                      extension: file.DocExt,
                      loadedFromDb: true,
                      storedDoc: file,
                    };
                  })
                  .forEach(function(item) {
                    $scope.to.files.push(item);
                  });
              }
            } else {
              if ($scope.model.StoredFiles) {
                lodash
                  .map($scope.model.StoredFiles, function(file) {
                    return {
                      name: file.DocName,
                      size: file.DocSize,
                      extension: file.DocExt,
                      loadedFromDb: true,
                      storedDoc: file,
                    };
                  })
                  .forEach(function(item) {
                    $scope.to.files.push(item);
                  });
              }
            }
          },
        ],
        link: function(scope, el) {},
      });
      fc.setType({
        name: 'modUserBox',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/moduserBox.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });

      fc.setType({
        name: 'button',
        templateUrl: 'App/templates/formly/button.html',
        wrapper: [],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.options.templateOptions.title =
              $scope.options.templateOptions.title || $scope.options.templateOptions.label;
            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });

      fc.setType({
        name: 'kendoRating',
        overwriteOk: true,
        templateUrl: 'App/templates/formly/kendoRating.html',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        controller: [
          '$scope',
          '$stateParams',
          'LanguageService',
          function($scope, $stateParams, languageService) {
            //Ha state-ben érkezik paraméter, fókusban helyezzük a mezőt
            setFocusOnField($scope, $stateParams.focusToField);

            $scope.errorMessages = languageService.getDictionary()?.errorMessages;
          },
        ],
      });

      // Add custom formly types
      if (angular.isArray(appConstant.customFormlyTypes)) {
        angular.forEach(appConstant.customFormlyTypes, function(type) {
          fc.setType(type);
        });
      }

      // please don't hurt me for this...
      fc.extras.defaultHideDirective = 'ng-show';

      fc.extras.errorExistsAndShouldBeVisibleExpression = 'fc.$touched';
    },
  ]);

/**
 * Provide gridService
 */
myApp.service('gridService', ['AuthService', 'localStorageService', '$state', '$http', GridService]);

//-------------------------------
//-- Config: Interceptor
//-------------------------------
myApp.config([
  '$httpProvider',
  'AppConstant',
  function($httpProvider, appConstant) {
    $httpProvider.useApplyAsync(true);
    // ------------- { IE miatt kell -------------
    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) $httpProvider.defaults.headers.get = {};

    // Answer edited to include suggestions from comments
    // because previous version of code introduced browser-related errors

    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
    // ------------- } IE miatt kell -------------
    function isAnonymousAction(url) {
      var result =
        url.endsWith('.html') ||
        url === 'Auth/StartCheck' ||
        url === 'Auth/GetVersion' ||
        url === 'Auth/LanguageOptions' ||
        url === 'Auth/LoginOptions' ||
        url === 'Auth/Login' ||
        url === 'Auth/GetLoginNamUrl' ||
        url === 'Auth/NamResponse' ||
        url === 'Auth/LoginNam' ||
        url === 'Auth/LoginWithApplicationSelector' ||
        url === 'Auth/LoginWinAuth' ||
        url === 'Auth/GetApplicationInfo' ||
        url === 'Auth/SelectGroupSSO' ||
        url === 'Auth/HasEms' ||
        url === 'Auth/NamCheck';
      return result;
    }
    // http://www.webdeveasy.com/interceptors-in-angularjs-and-useful-examples/
    var errorInterceptor = [
      '$q',
      '$location',
      '$injector',
      function($q, $location, $injector) {
        var errorValidator = function(rejection) {
          switch (rejection.status) {
            case 401:
              $location.path(appConstant.otherwise).search({
                redirectTo: encodeURIComponent($location.url()),
              });
              break;
            case 403:
              try {
                var message = JSON.parse(rejection.statusText)[0];
                toastr.warning(message || 'A szerver visszautasította a kérést!');
              } catch (e) {
                toastr.warning(rejection.statusText || 'A szerver visszautasította a kérést!');
              }
              break;
            case 405:
              try {
                var message = JSON.parse(rejection.statusText)[0];
                toastr.success(message || 'Sikeres művelet!');
              } catch (e) {
                toastr.warning(rejection.statusText || 'A szerver visszautasította a kérést!');
              }
              break;
            case 500:
              try {
                if (!!rejection.data.Parameters?.RefTable) {
                  myApp.refTable = rejection.data.Parameters.RefTable;
                  myApp.refId = rejection.data.Parameters.RefId;
                  toastr.options.onclick = function() {
                    var modalInstance = $injector.get('$uibModal').open({
                      templateUrl: 'App/Delete/ReferenceIntegrityListModal.html',
                      controller: 'ReferenceIntegrityListModalCtrl',
                      controllerAs: 'vm',
                      backdrop: 'static',
                      resolve: {
                        // model: RouteResolveFunc('FlgrSystem/ReferenceIntegrityList', { refTable : myApp.refTable, refId : myApp.refId }),
                        parameters: {
                          refTable: myApp.refTable,
                          refId: myApp.refId,
                        },
                      },
                    });
                  };
                  rejection.statusText += '<br><br>További információkért kattintson a feliratra.';
                }

                var errorMessages = JSON.parse(rejection.statusText);
                if (errorMessages instanceof Array) {
                  errorMessages.forEach(errorMsg => {
                    toastr.error(errorMsg);
                  });
                } else if (typeof errorMessages === 'object') {
                  Object.keys(errorMessages).forEach(key => {
                    toastr.error(errorMessages[key]);
                  });
                } else {
                  toastr.error(rejection.statusText || 'A szerver visszautasította a kérést!');
                }
              } catch (err) {
                toastr.error(rejection.statusText || 'A szerver visszautasította a kérést!');
              }
              break;
            default:
              toastr.error(rejection.statusText || 'A szerver visszautasította a kérést!');
              break;
          }
        };

        return {
          request: function(request) {
            if (isAnonymousAction(request.url)) {
              return request || $q.when(request);
            }
            var uat = localStorage.getItem('sb-uat');
            request.headers['GAS-Authorization'] = uat;

            return request || $q.when(request);
          },
          response: function(response) {
            var authResult = response.headers('GAS-WWW-Authenticate');
            if (authResult) {
              localStorage.setItem('sb-uat', authResult);
            }

            if (!!response.data && !!response.data.ErrorCode) {
              response.status = parseInt(response.data.ErrorCode);
              response.statusText = response.data.ErrorMessages;
              if (response.data.ErrorCode === 200) {
                return response;
              } else {
                errorValidator(response);
                return !!response.data.DisableRejection ? response : $q.reject(response);
              }
            }

            return response;
          },

          responseError: function(rejection) {
            errorValidator(rejection);
            return $q.reject(rejection);
          },
        };
      },
    ];

    $httpProvider.interceptors.push(errorInterceptor);
  },
]);

//-------------------------------
//-- $exceptionHandler
//-------------------------------
myApp.factory('$exceptionHandler', [
  'SendJsErrorService',
  function(sendJsErrorService) {
    return function(exception, cause) {
      sendJsErrorService.SendJsError(exception, cause);
    };
  },
]);

angular.element(function() {
  var text = $('input#dynamicModules').val();
  if (!text) {
    angular.bootstrap(document, [myApp.name]);
    return;
  }

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  var dynamicModules = text
    .split(';')
    .filter(function(n) {
      return n !== undefined && n !== '';
    })
    .filter(onlyUnique);
  Array.prototype.push.apply(myApp.requires, dynamicModules);
  angular.bootstrap(document, [myApp.name]);
});

(function(module) {
  'use strict';
  module.controller('ReferenceIntegrityListModalCtrl', [
    '$scope',
    '$uibModalInstance',
    'parameters',
    '$http',
    function($scope, mi, parameters, $http) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReferenceIntegrityListModalCtrl', stateParams);
      }
      var vm = this;
      vm.refTable = parameters.refTable;
      vm.refId = parameters.refId;

      $http
        .post('FlgrSystem/ReferenceIntegrityList', {
          refTable: myApp.refTable,
          refId: myApp.refId,
        })
        .then(function(response) {
          vm.referenceIntegrityList = response.data.result.Value;
        })
        .catch(function(response) {});

      vm.ok = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  //-------------------------------
  //-- AppConstant
  //-------------------------------
  module.constant('AppConstant', {
    loginStateName: 'login',
    customFormlyTypes: [
      {
        extends: 'kendoMS',
        name: 'kendoMS_custom',
        templateUrl: 'App/templates/formly/custom/kendoMultiSelect.html',
      },
      {
        extends: 'kendoDDL',
        name: 'kendoDDL_custom',
        templateUrl: 'App/templates/formly/custom/kendoDropDownList.html',
      },
      {
        extends: 'input',
        name: 'maskedInput',
        template:
          '<input class="form-control" ng-model="model[options.key]" ng-class="{\'required\': to.required,\'disabled\': to.disabled, \'not-marking\': !to.required || !!to.notMarking || (to.disabled && !to.showDisabledMarking)}" ng-change="to.changed(model[options.key])"/><div ng-include="\'App/templates/formly/formlyNgMessages.html\'"></div>',
        wrapper: ['bootstrapLabel', 'bootstrapHasError'],
        defaultOptions: {
          ngModelAttrs: {
            mask: {
              attribute: 'ui-mask',
            },
            maskPlaceholder: {
              attribute: 'ui-mask-placeholder',
            },
          },
          templateOptions: {
            maskPlaceholder: '',
          },
        },
      },
      {
        extends: 'input',
        name: 'KendoAC',
        templateUrl: 'App/templates/formly/autocomplete.html',
      },
      {
        extends: 'input',
        name: 'separatorDash',
        template:
          '<label for="sepaDash">&nbsp;</label>' +
          '<input disabled id="sepaDash" class="col-md-1 form-control" value="-" ' +
          'style="text-align: center; font-weight: bold;" />',
      },
      {
        extends: 'input',
        name: 'separatorSlash',
        template:
          '<label for="sepaDash">&nbsp;</label>' +
          '<input disabled id="sepaDash" class="col-md-1 form-control" value="/" ' +
          'style="text-align: center; font-weight: bold;" />',
      },
    ],
  });
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.directive('keydownEvents', [
    '$document',
    '$rootScope',
    '$window',
    'HelpAndManualService',
    function($document, $rootScope, $window, hmService) {
      return {
        restrict: 'A',
        link: function() {
          $document.bind('keydown', function(e) {
            var keyCode = e.originalEvent.keyCode || e.originalEvent.which;
            if (keyCode === 112) {
              e.preventDefault();
              var isPageExist = hmService.getActiveHMPageUrl();
              if (isPageExist !== undefined) {
                let anchorId =
                  $(e.target).attr('dom-id') ||
                  $(e.target)
                    .find('[dom-id]:first')
                    .attr('dom-id') ||
                  $(e.target)
                    .parents('[dom-id]:first')
                    .attr('dom-id');
                $window.open(hmService.getActiveHMPageUrl(anchorId), '_blank');
              }
            }
          });
        },
      };
    },
  ]);

  //*****************************/
  //*** directive: form-input ***/
  //*****************************/
  module.directive('formInput', [
    '$compile',
    function($compile) {
      return {
        restrict: 'A',
        require: '^form',
        link: function(scope, element, attributes, form) {
          //var inputName = setupDom(element);
          //addMessages(form, element, inputName, $compile, scope);
          //scope.$watch(watcherFor(form, inputName), updaterFor(element));
        },
      };

      function watcherFor(form, inputName) {
        return function() {
          if (inputName && form[inputName]) {
            return form[inputName].$invalid && form[inputName].$touched;
          }
        };
      }

      function updaterFor(element) {
        return function(hasError) {
          if (hasError) element.addClass('has-error');
          //element.removeClass("has-success").addClass("has-error");
          else element.removeClass('has-error'); //element.addClass("has-success").removeClass("has-error");
        };
      }

      function setupDom(element) {
        element[0].classList.add('form-group');

        var input = element[0].querySelector('input, textarea, select');
        var type = input.getAttribute('type');

        var inputName = input.getAttribute('name');

        if (angular.isDefined(type) && type !== 'checkbox' && type !== 'radio') input.classList.add('form-control');

        var controlLabel = element[0].querySelector('label');
        if (controlLabel) controlLabel.classList.add('control-label');

        return inputName;
      }

      function addMessages(form, element, inputName, $compile, scope) {
        if (!form.$name) console.warn('A form-nak nincs neve!');
        else if (!inputName) console.warn('Az inputnak nincs neve!');
        else {
          var messages = String.format(
            "<div ng-messages='{0}.{1}.$error' class='help-block'>" +
              "<div ng-messages-include='templates/messages.html'></div></div>",
            form.$name,
            inputName
          );
          element.append($compile(messages)(scope));
        }
      }
    },
  ]);

  //*****************************/
  //*** directive: form-input ***/
  //*****************************/
  module.directive('sendData', [
    '$compile',
    function($compile) {
      return {
        restrict: 'A',
        require: '^form',
        link: function(scope, element, attributes, form) {
          console.log(scope);
        },
      };
    },
  ]);

  module.directive('parsedate', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        function parsedate(text, format) {
          return kendo.toString(text, attr.parsedate);
        }

        ngModel.$parsers.push(parsedate);
      },
    };
  });

  module.directive('kntbfloatfix', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        function kntbfloatfix(text, format) {
          return kendo.parseFloat(ngModel.$$lastCommittedViewValue);
        }

        ngModel.$parsers.push(kntbfloatfix);
      },
    };
  });

  //***************************/
  //*** directive: f2-input ***/
  //***************************/
  //var peldaOptions =
  //{
  //    title: "F2-es elem választó",
  //    fieldKey: "email",
  //    fieldText: "name",
  //    readonly: true, // Optional ( Az input mezőre vonatkozik, a megnyitó gomb attól még él )
  //    modalSize: "lg", // "sm" | "lg" Más mérethez a kódban van leírás mit kell csinálni
  //    gridOptions: {
  //            url: "TableData/Fakenames",
  //            otherParams: { f1: "f1 value", f2: 5 }, // Optional: Adatok lekérésekor plusz paraméterben megy
  //            fields: {
  //                name: { title: "Name", type: "string" },
  //                city: { title: "City", type: "string" },
  //                email: { title: "Email", type: "string" },
  //                height: { title: "Height", type: "number" },
  //                birthday: { title: "Birthday", type: "date", format: "{0:yyyy-MM-dd}" }
  //            }
  //    }
  //}
  module.directive('f2Input', [
    '$parse',
    '$compile',
    '$uibModal',
    '$q',
    '$http',
    'gridService',
    function($parse, $compile, $uibModal, $q, $http, gridService) {
      var template =
        "<table style='width: 100%;'><tbody><tr><td>" +
        "<div class='input-group'>" +
        "<input type='text' class='form-control sbText' ng-change=\"inputOnChange(f2Value.Text, 'f2Value.Text')\" ng-keydown='inputOnKeyPress($event)' ng-blur='onBlur($event)'" +
        " formly-focus='{{formlyFocus}}'" +
        ' focus-wait={{formlyWait}}' +
        ' refocus' +
        ' ui-mask-placeholder ui-mask-placeholder-char="_" ui-mask="{{f2Options.mask}}"' +
        "ng-readonly='f2Options.readonly' ng-model='f2Value.Text' ng-disabled='disabled && !f2Options.readonly' />" +
        "<span class='input-group-btn'>" +
        "<button tabindex='-1' style='height: 2.1em !important;' class='btn btn-default f2-btn' type='button' ng-click='openF2Modal()' ng-disabled='disabled'>" +
        "<span class='glyphicon glyphicon-th-list' aria-hidden='true'></span>" +
        '</button>' +
        '</span>' +
        '</div>' +
        '</td><td>' +
        "<button type='button' tabindex='-1' class='close' aria-label='Üres' ng-click='onClear($event)' ng-if='!(disabled && !f2Options.readonly)' style='margin-left:0.2em;'><span aria-hidden='true'>&times;</span></button>" +
        '</td></tr></tbody></table>';
      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          f2Value: '=ngModel',
          f2Options: '=',
          formlyFocus: '@',
          formlyWait: '@',
          disabled: '=ngDisabled',
          changed: '&',
          blur: '&',
          ngClick: '&',
          gridModel: '<',
        },
        controller: [
          '$scope',
          '$rootScope',
          'AuthService',
          function($scope, $rootScope, authService) {
            $scope.disableGridState = function() {
              if (!!authService.parameters?.FWCOID) {
                $scope.f2Options.disableOptions = { GridStateSave: true, GridStateRestore: true };
              }
            };

            if (!authService?.parameters) {
              authService.getUserContext(false, $scope.disableGridState);
            } else {
              $scope.disableGridState();
            }
          },
        ],
        link: function(scope, element, attrs, ngModCont) {
          var self = scope;
          element.append(template);
          $compile(element.contents())(scope);
          var emptyValue = { Text: null, Value: null };
          var inF2Call = false;
          var isInit = true;

          var parentNgModCont = element.controller('ngModel');
          // Init: f2Options
          self.f2Options = angular.extend(
            {
              title: 'Nincs beállítva az f2-options!',
              readonly: false,
              isManual: false,
              maxlength: null,
              modalSize: 'lg',
              gridOptions: { url: null, fields: null },
              RouteState: self.RouteState,
            },
            self.f2Options
          );

          self.f2Options.selectFirstElement = selectFirstElement;

          var maskOptions = {
            unmaskOnPost: true,
          };

          function selectFirstElement(filter = null, multiLine = false, justErrorWarning = false) {
            let postData = angular.extend(
              {},
              angular.isFunction(self.f2Options.gridOptions.otherParams)
                ? { queryParameters: JSON.stringify(self.f2Options.gridOptions.otherParams()) }
                : self.f2Options.gridOptions.otherParams
            );
            postData = angular.extend(postData, { filter: filter, pageSize: 2, page: 1 });
            $http
              .post(self.f2Options.gridOptions.url, postData, { ignoreLoadingBar: true })
              .then(function(response) {
                if (
                  (response.data.Data?.length === 1 && self.f2Options.selectFirst) ||
                  (multiLine && response.data.Data?.length > 0)
                ) {
                  var item = response.data.Data[0];
                  setSelectedItem(item);
                  if (angular.isFunction(self.blur)) {
                    self.blur({
                      selectedItem: item,
                    });
                  }
                } else if (self.f2Options.isManual) {
                  var item = { Text: self.newVal, Value: self.newVal };
                  self.f2Value = item;
                } else {
                  self.f2Value = angular.copy(emptyValue);
                  ngModCont.$setValidity('validvalue', false);
                  if (!justErrorWarning && multiLine) {
                    toastr.warning('Érvénytelen érték');
                  }
                }
              })
              .catch(function onError(response) {
                if (justErrorWarning && multiLine) {
                  self.f2Value = angular.copy(emptyValue);
                  if (multiLine) {
                    toastr.warning('Érvénytelen érték');
                  }
                }
              });
          }
          attrs.$observe('required', function(value) {
            setRequiredValidity(attrs.required);
          });

          if (self.f2Value === null) {
            self.f2Value = emptyValue;
          }
          setRequiredValidity(attrs.required);

          self.gridId = function() {
            return 'f2_' + self.gridModel.Id;
          };

          self.onBlur = function(event) {
            if (inF2Call) {
              return;
            }
            ngModCont.$setValidity('validvalue', true);

            if (self.newVal === self.oldVal) {
              return;
            } else {
              self.oldVal = self.newVal;
            }

            if (self.f2Options.isManual) {
              var item = { Text: self.newVal, Value: self.newVal };
              self.f2Value = item;
            }
            var filter =
              '' + self.f2Options.fieldText + "~eq~'" + (self.f2Value.Text || '').replace(/[\\"']/g, '') + "'";
            selectFirstElement(filter, true);
            parentNgModCont.$setTouched();
            setRequiredValidity(attrs.required);
          };

          self.onClear = function(event) {
            self.selectedItem = null;
            setSelectedItem(null);
            parentNgModCont.$setTouched();
            //áthelyezve scope.$watch('f2Value'...)-ból
            fireOnChanged();
          };

          scope.$watch(
            'f2Value',
            function(newValue, oldValue) {
              var needToTouch = false;
              if (newValue === null) {
                newValue = emptyValue;
              }
              if (attrs.required && (!newValue || !newValue?.Value) && self.f2Options.selectFirst) {
                selectFirstElement();
                if (!!oldValue?.Value) {
                  needToTouch = true;
                }
              }
              ngModCont.$setValidity('validvalue', true);
              if (ngModCont.$untouched && (!newValue || angular.equals(emptyValue, newValue))) {
                self.f2Value = angular.copy(emptyValue);
                isInit = false;
              } else {
                if (self.f2Options.isManual) {
                  if (!!self.f2Value && (self.f2Value.Text === null || self.f2Value.Text === '')) {
                    var val = self.f2Value.Value;
                    self.f2Value = { Text: val, Value: val };
                  }
                }
                if (
                  newValue &&
                  (!newValue.hasOwnProperty('Value') ||
                    (newValue.Text === '' && !!newValue.Value) ||
                    (newValue.Text === null && !!newValue.Value))
                ) {
                  var filter =
                    '' +
                    self.f2Options.fieldKey[Object.keys(self.f2Options.fieldKey)[0]] +
                    "~eq~'" +
                    (newValue.Value || newValue) +
                    "'";
                  selectFirstElement(filter, true, true);
                }
              }
              if (attrs.required && (!newValue?.hasOwnProperty('Value') || !newValue?.Value)) {
                ngModCont.$setValidity('validvalue', false);
              }
              if (needToTouch) {
                parentNgModCont.$setTouched();
                setRequiredValidity(attrs.required);
                if (attrs.maxlength && newValue && newValue.Value) {
                  ngModCont.$setValidity('maxlength', newValue.Value.length >= attrs.maxlength);
                  parentNgModCont.$setValidity('maxlength', newValue.Value.length >= attrs.maxlength);
                }
              }
              //  fireOnChanged();
              self.selectedItem = null;
            },
            true
          );
          ////console.log(self.f2Value);

          // Init: Validation1 // Kivettem, mert a formly validálásba bele szólt
          //ngModCont.$validators.required = function(value) {
          //    return !attrs.required || (value && value.text !== "");
          //}

          // Init: Validation2
          self.inputOnChange = function(newVal, oldVal) {
            self.oldVal = oldVal;
            self.newVal = newVal;
          };

          self.inputOnKeyPress = function(event) {
            if (attrs.disabled) return;
            if (event.which === 113) self.openF2Modal();
          };

          function setSelectedItem(selectedItem) {
            var newValue = angular.copy(emptyValue);
            if (!!selectedItem) {
              newValue = {
                Value: selectedItem[self.f2Options.fieldKey[Object.keys(self.f2Options.fieldKey)[0]]],
                Text: selectedItem[self.f2Options.fieldText],
              };
            }

            ////console.log(newValue);
            ////console.log(selectedItem);

            self.f2Value = newValue;
            if (selectedItem) {
              self.selectedItem = selectedItem;
              fireOnChanged();
            }
          }

          function getFilter() {
            var result = '';
            if (!self.f2Value) return result;
            if (!angular.equals(self.f2Value.Value, null) && !angular.equals(self.f2Value.Text, null)) {
              var text = null;
              if (!!self.f2Value.Text) {
                text = encodeURI(self.f2Value.Text.replace(/[\\"']/g, ''));
              }
              //result = "(" + self.f2Options.fieldKey[Object.keys(self.f2Options.fieldKey)[0]] + "~eq~'" + encodeURI(self.f2Value.Value) +
              //        "'~or~" + self.f2Options.fieldText + "~startswith~'" + !!self.f2Value.Text ? encodeURI(self.f2Value.Text.replace(/[\\"']/g, '')) : encodeURI(self.f2Value.Text) + "')";
              if (text != null) {
                result = self.f2Options.fieldText + "~startswith~'" + text + "'";
              }
            }
            return result;
          }

          // Method: openF2
          self.openF2Modal = function() {
            inF2Call = true;
            var modalInstance = $uibModal.open({
              templateUrl: 'App/templates/f2ModalWindow.html',
              controller: [
                '$scope',
                '$uibModalInstance',
                'f2Options',
                'f2gridOptions',
                '$document',
                'gridModel',
                'gridId',
                'gridService',
                '$rootScope',
                'AuthService',
                function(
                  scope,
                  mi,
                  f2Options,
                  f2gridOptions,
                  $document,
                  gridModel,
                  gridId,
                  gridService,
                  $rootScope,
                  authService
                ) {
                  var miSelf = this;
                  $rootScope.$emit('$stateAndRefreshForElement', f2Options);

                  f2gridOptions.columns
                    .filter(x => (gridModel.DefaultPrecisionFields || []).indexOf(x.field) !== -1)
                    .forEach(x => (x.format = getDefFeeAmountPrecisionFormat()));

                  gridService.restoreState(f2gridOptions).subscribe(restoredConfig => {
                    miSelf.gridOptions = restoredConfig;
                  });
                  miSelf.title = f2Options.title;
                  miSelf.sItem = null;
                  miSelf.isFiltered = true;
                  miSelf.f2Options = f2Options;
                  miSelf.ok = function() {
                    mi.close(miSelf.sItem);
                  };
                  miSelf.grid = {};
                  miSelf.erase = function() {
                    mi.close(null);
                  };
                  miSelf.reset = function() {
                    miSelf.grid.dataSource.filter([]);
                  };
                  miSelf.cancel = function() {
                    mi.close();
                  };

                  miSelf.gridId = gridId;
                  miSelf.gridIdMapping = f2Options.fieldKey && Object.keys(f2Options.fieldKey)[0];
                  gridService.loadGrid(gridId);

                  var getGridElements = function() {
                    return $document.find('#' + gridId);
                  };

                  function getDefFeeAmountPrecisionFormat() {
                    return '{0:n' + (authService.parameters?.DEFFPR || 2) + '}';
                  }

                  scope.$on('modal.closing', function() {
                    // store grid state
                    if (miSelf.grid) {
                      gridService.saveKendoGrid(miSelf.grid);
                    }
                  });
                },
              ],
              controllerAs: 'miCtrl',
              f2Options: self.f2Options,
              resolve: {
                gridId: self.gridId,
                f2Options: self.f2Options,
                f2gridOptions: resolveGridFields(self.f2Options.gridOptions),
                gridModel: self.gridModel,
              },
              backdrop: 'static', //mellékattintásnál ne záródjon be
              size: self.f2Options.modalSize, // Egyéb: xl példa -> Bele kell rakni a bootstrap.css-be: @media (min-width: 992px) {.modal-xl {width: 900px;}}@media (min-width: 1700px) {.modal-xl {width: 1500px;}}
            });
            modalInstance.result.then(
              function(selectedItem) {
                inF2Call = false;
                if (!!selectedItem) {
                  setSelectedItem(selectedItem);
                }
              },
              function() {
                inF2Call = false;
              }
            );
          };

          function resolveGridFields(option) {
            var deferred = $q.defer();

            var filterString = getFilter();
            var initialFilter = filterString ? gridService.parseFilterString(filterString) : null;

            var callCreateOption = function(options) {
              const { url, fields, otherParams, dsChanged, toolbar, groupable } = options;
              const columns =
                options.columns ||
                Object.keys(fields).map(function(fieldKey) {
                  return Object.assign({ field: key }, fields[fieldKey]);
                });
              if (typeof self.f2Options.disableOptions?.AutoComplete !== 'boolean') {
                if (!self.f2Options.disableOptions) {
                  self.f2Options.disableOptions = {};
                }
                self.f2Options.disableOptions.AutoComplete = true;
                self.f2Options.disableOptions.FilterRestore = true;
              }

              return gridService.buildKendoConfig({
                gridId: self.gridId(),
                autoBind: true,
                dataSourceOptions: {
                  url,
                  schema: {
                    data: 'Data',
                    total: 'Total',
                    fields: fields,
                    model: {
                      fields: fields,
                    },
                  },
                  transportData: function() {
                    if (typeof otherParams === 'function') {
                      return {
                        queryParameters: JSON.stringify(otherParams()),
                      };
                    }
                    return otherParams;
                  },
                  change: function() {
                    if (typeof dsChanged === 'function') {
                      dsChanged(this.data());
                    }
                  },
                  filter: initialFilter,
                  page: 1,
                  pageSize: 10,
                },
                columns,
                toolbar,
                groupable,
                disableOptions: self.f2Options.disableOptions,
              });
            };

            return new Promise(function(resolve, reject) {
              if (typeof option.fields === 'function') {
                $q.when(option.fields()).then(function(response) {
                  var tmp = angular.copy(option);
                  if (response.status) {
                    tmp.fields = response.data;
                  } else {
                    tmp.fields = response;
                  }
                  deferred.resolve(resolve(tmp));
                });
              } else {
                resolve(option);
              }
            }).then(option => {
              return callCreateOption(option);
            });
          }
          function fireOnChanged(setValue) {
            //if (isInit == true)
            //    return;
            if (angular.isFunction(self.changed)) self.changed({ selectedItem: self.selectedItem });
            if (isInit !== true) ngModCont.$setViewValue(self.f2Value);
            isInit = false;
            setRequiredValidity(attrs.required);
          }
          function setRequiredValidity(required) {
            ngModCont.$setValidity('validvalue', true);
            if (required) {
              //setTimeout(function() {
              ngModCont.$setValidity(
                'required',
                !self.f2Value || (self.f2Value.hasOwnProperty('Text') && self.f2Value.Text !== null)
              );
              parentNgModCont.$setValidity(
                'required',
                !self.f2Value || (self.f2Value.hasOwnProperty('Text') && self.f2Value.Text !== null)
              );
              //});
            }
          }
        },
      };
    },
  ]);

  module.directive('pathSelector', [
    '$parse',
    '$compile',
    '$uibModal',
    '$q',
    '$http',
    function($parse, $compile, $uibModal, $q, $http) {
      var template =
        "<table style='width: 100%;'><tbody><tr><td>" +
        "<div class='input-group' style='width: 100%;'>" +
        "<input name='path' value='{{selectedPath.Text }}' readonly ng-click='openFolders()' k-options=\"maskOptions\" k-mask=\"'{{pathSelectorOptions.mask}}'\" type='text' class='form-control' />" +
        "<span class='input-group-btn' >" +
        "<button class='btn btn-default f2-btn' type='button' ng-click='openFolders()' ng-disabled='disabled'>" +
        "<span class='fa fa-folder-open-o' aria-hidden='true'></span>" +
        '</button></span ></div ></td ><td>' +
        "<button type='button' tabindex='-1' class='close' aria-label='Üres' ng-click='onClear($event)' ng-if='!(disabled && !pathSelectorOptions.readonly)' ng-disabled='disabled' style='margin-left:0.2em;'><span aria-hidden='true'>&times;</span></button>" +
        '</td></tr></tbody></table>';
      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          selectedPath: '=ngModel',
          pathSelectorOptions: '=',
          disabled: '=ngDisabled',
          required: '=',
          changed: '&',
          blur: '&',
          ngClick: '&',
        },
        link: function(scope, element, attrs, ngModCont) {
          var self = scope;
          element.append(template);
          $compile(element.contents())(scope);

          var parentNgModCont = element.controller('ngModel');
          // Init: pathSelectorOptions
          self.pathSelectorOptions = angular.extend(
            {
              title: 'Nincs beállítva a pathSelector-options!',
              readonly: false,
              isManual: false,
              maxlength: null,
              modalSize: 'lg',
              treeOptions: { url: null },
            },
            self.pathSelectorOptions
          );

          var maskOptions = {
            unmaskOnPost: true,
          };

          self.onClear = function(event) {
            self.selectedPath = null;
            parentNgModCont.$setTouched();
            if (attrs.required) {
              ngModCont.$setValidity(
                'required',
                !!self.selectedPath && self.selectedPath.hasOwnProperty('Text') && !!self.selectedPath.Text
              );
              parentNgModCont.$setValidity(
                'required',
                !!self.selectedPath && self.selectedPath.hasOwnProperty('Text') && !!self.selectedPath.Text
              );
            }
          };

          self.openFolders = function() {
            var modalInstance = $uibModal.open({
              templateUrl: 'App/templates/pathSelectorModalWindow.html',
              controller: [
                '$uibModalInstance',
                'options',
                function(mi, options) {
                  var vm = this;
                  vm.pathTree = options.pathTree;
                  vm.treeData = new kendo.data.HierarchicalDataSource({
                    data: vm.pathTree,
                  });

                  vm.select = function() {
                    var selected = vm.selectedItem;
                    mi.close(selected);
                  };

                  vm.cancel = function() {
                    mi.close();
                  };
                },
              ],
              controllerAs: 'vm',
              resolve: {
                options: RouteResolveFunc(self.pathSelectorOptions.treeOptions.url),
              },
              backdrop: 'static', //mellékattintásnál ne záródjon be
              size: self.pathSelectorOptions.modalSize,
            });

            modalInstance.result.then(function(result) {
              self.selectedPath = { Text: result.text, Id: result.id };
            });
          };
        },
      };
    },
  ]);

  app.directive('radioGroup', [
    function() {
      return {
        restrict: 'E',
        require: 'ngModel',
        scope: {
          ngModel: '=',
          options: '=radioGroupOptions',
          disabled: '=ngDisabled',
          required: '=',
          changed: '&',
        },
        replace: true,
        template:
          "<div style='width:100%;padding-bottom:5px;' ng-class=\"(options.isVertical||false) ? 'btn-group-vertical' : 'btn-group'\">" +
          "<label class='btn {{!!options.btnClass ? options.btnClass : \"btn-default\"}}' ng-repeat='option in options.dataSource' " +
          'ng-model="ngModel" ' +
          "ng-click='option.disabled !== true && change(option.value)' " +
          "ng-disabled='disabled || option.disabled === true' " +
          "ng-if='option.hide !== true' " +
          'ng-class="{\'active\': option.value == selected}" ' +
          'uib-btn-radio="\'{{option.value}}\'">{{option.text}}</label>' +
          '</div>',
        link: function(scope, elem, attrs, ngModCont) {
          scope.selected = scope.ngModel;
          scope.$watch(
            'ngModel',
            function(newValue, oldValue) {
              ngModCont.$setViewValue(newValue);
              scope.selected = newValue;
              if (newValue != oldValue) {
                scope.changed({ selectedItem: newValue });
              }
            },
            true
          );
          scope.change = function(value) {
            if (!scope.disabled) {
              scope.ngModel = value;
            }
          };
        },
      };
    },
  ]);

  //*************************************/
  //*** directive: resize-grid="150" ***/
  //************************************/
  // Kendo grid magasságát állítja be, hogy kitöltse a rendelkezésre álló függőleges helyet scrollozás nélkül
  module.directive('resizeGrid', [
    function() {
      return {
        restrict: 'A',
        scope: true,
        link: function(scope, grid, attr) {
          if (!attr.resizeGrid) console.warn("Nincs megadva az offset: resize-grid='150'");

          resizeGrid();

          $(window)
            .off('resize', resizeGrid)
            .on('resize', resizeGrid);

          function resizeGrid() {
            var height = $(window).height() - attr.resizeGrid;

            grid[0].style.height = height + 'px';

            var dataArea = grid.find('.k-grid-content');
            var gridHeight = grid.innerHeight();
            var otherElements = grid.children().not('.k-grid-content');
            var otherElementsHeight = 0;

            otherElements.each(function() {
              otherElementsHeight += $(this).outerHeight();
            });

            dataArea.height(gridHeight - otherElementsHeight);
          }
        },
      };
    },
  ]);

  module.directive('resizeDiv', [
    function() {
      return {
        restrict: 'A',
        scope: true,
        link: function(scope, div, attr) {
          if (!attr.resizeDiv) console.warn("Nincs megadva az offset: resize-div='150'");

          resizeDiv();

          $(window)
            .off('resize', resizeDiv)
            .on('resize', resizeDiv);

          function resizeDiv() {
            var height = $(window).height() - attr.resizeDiv;

            div[0].style.height = height + 'px';
          }
        },
      };
    },
  ]);

  module.directive('mainUi', function($window) {
    return function($element) {
      const contentPaddingTop = 5;
      $($element).ready(function() {
        if (!!$("[ui-view='content'] .content-header").length) {
          resize();
        }
      });
      let w = angular.element($window);
      w.on('resize', function() {
        resize();
      });
      function resize() {
        let header = $("[ui-view='content'] .content-header"),
          content = $("[ui-view='content']");
        let top = header?.offset()?.top;
        if (top) {
          let headerBottom = top + header.outerHeight(true) + contentPaddingTop;
          if (content.offset().top != headerBottom) {
            content.position({ top: headerBottom });
          }
        }
      }
    };
  });

  /**
   * directive: duplicate="[array-of-values]"
   * input validátor, akkor lesz valid az input, ha az érték NEM szerepel a paraméterül megadott tömbben
   */
  module.directive('duplicate', [
    function() {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: { duplicate: '=' },
        link: function(scope, elm, attrs, ctrl) {
          ctrl.$validators.duplicate = function(modelValue) {
            return scope.duplicate.indexOf(modelValue) === -1;
          };
        },
      };
    },
  ]);

  //-------------------------------
  //-- directive: editDeleteDropdown
  //-------------------------------
  module.directive('editDeleteDropdown', function() {
    // usage: <edit-delete-dropdown selected-item="vm.selectedItem" modosit="vm.modosit()" torol="vm.torol()" />
    return {
      scope: { selectedItem: '=', modosit: '&', torol: '&', ngDisabled: '=' },
      restrict: 'E',
      template:
        "<div class='btn-group' role='group'>" +
        "<button type='button' class='btn btn-default dropdown-toggle' data-toggle='dropdown' title='Műveletek' ng-disabled='!selectedItem || ngDisabled'>" +
        "<i class='fa fa-lg fa-cog'></i> <span class='caret'></span>" +
        '</button>' +
        "<ul class='dropdown-menu dropdown-menu-icon'>" +
        "<li><a href ng-click='modosit()' title='Módosít'><i class='fa fa-pencil'></i></a></li>" +
        "<li><a href ng-click='delete()' title='Töröl'><i class='fa fa-trash'></i></a></li>" +
        '</ul>' +
        '</div>',
      link: function(scope, elm, attrs) {
        scope.delete = function() {
          bootbox.confirm('Biztos törölni szeretné a kiválasztott elemet?', function(confirmResult) {
            if (confirmResult && angular.isFunction(scope.torol)) scope.torol();
          });
        };
      },
    };
  });

  /**
   *  Éves naptár megjelenítéséhez calendar direktíva
   * ng-model={year: x.year, selected: array[365/366] elemei: '+'/'-'}
   */
  module.directive('calendar', function() {
    return {
      restrict: 'E',
      require: '?ngModel',
      templateUrl: 'App/templates/calendar.html',
      scope: {
        data: '=ngModel',
      },
      link: function(scope, element, attrs, ngModel) {
        if (!ngModel) return;
        var self = scope;
        self.data.year = self.data.year || moment().year();
        self.data.selected = self.data.selected || [];

        scope.$watch('data.selected', function(newValue, oldValue) {
          ngModel.$render();
        });

        ngModel.$render = function() {
          _buildYear(self);
        };

        self.toggle = function(day) {
          if (!day.isCurrentMonth) return;
          var newVal = self.data.selected[day.date.dayOfYear() - 1] === '+' ? '-' : '+';
          self.data.selected[day.date.dayOfYear() - 1] = newVal;
          day.isWorkDay = !day.isWorkDay;
        };

        self.next = function() {
          self.data.year++;
          _buildYear(self);
        };

        self.previous = function() {
          self.data.year--;
          _buildYear(self);
        };
      },
    };

    function _buildYear(scope) {
      scope.months = [];
      scope.daynames = [];

      var dow = moment.localeData().firstDayOfWeek();

      angular.forEach(
        moment.weekdaysMin(),
        function(value, key) {
          this.push({ index: key < dow ? key - dow + 7 : key - dow, name: value });
        },
        scope.daynames
      );

      for (var i = 0; i < 12; i++) {
        var month = moment({ year: scope.data.year, month: i });
        scope.months.push({ start: month, weeks: _buildMonth(scope, month, dow) });
      }
    }

    function _removeTime(date) {
      return date
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0);
    }

    function _buildMonth(scope, month, dow) {
      var weeks = [];
      var done = false,
        date = month
          .clone()
          .date(1)
          .isoWeekday(dow),
        monthIndex = date.month(),
        count = 0;
      while (!done) {
        weeks.push({ days: _buildWeek(scope, date.clone(), month, dow) });
        date.add(1, 'w');
        done = count++ > 2 && monthIndex !== date.month();
        monthIndex = date.month();
      }
      return weeks;
    }

    function _buildWeek(scope, date, month, dow) {
      var days = [];
      for (var i = 0; i < 7; i++) {
        days.push({
          dow: date.format('E'),
          name: date.format('dd'),
          number: date.date(),
          isCurrentMonth: date.month() === month.month(),
          isToday: date.isSame(new Date(), 'day'),
          isWorkDay: date.month() === month.month() && scope.data.selected[date.dayOfYear() - 1] === '+',
          date: date,
        });
        date = date.clone();
        date.add(1, 'd');
      }
      return days;
    }
  });

  //-------------------------------
  //-- directive: Navigációs gombok
  //-- usage: Üresen: <navigation-buttons /> | Tartalommal: <navigation-buttons>ide kerülhet valami</navigation-buttons>
  //-------------------------------
  module.directive('navigationButtons', [
    'AuthService',
    '$http',
    function(authService, $http) {
      return {
        restrict: 'E',
        transclude: true,
        scope: {},
        templateUrl: 'App/Login/NavigationButtons.html',
        link: function(scope, elm, attrs) {
          scope.roles = authService.roles;

          scope.olvasatlanUzenetekSzama = 0;

          //$http.get("Uzenofal/OlvasatlanUzenetekSzama").then(function(response) {
          //    scope.olvasatlanUzenetekSzama = response;
          //});
        },
      };
    },
  ]);

  /**
   * directive: state váltáskor illetve ablakbezáráskor felugró konfirmációs ablak direktíva
   * usage: <div confirm-on-exit="bool()"/>
   */
  module.directive('confirmOnExit', [
    'AuthService',
    function(authService) {
      return {
        scope: {
          confirmOnExit: '&',
          confirmMessageWindow: '@',
          confirmMessageRoute: '@',
          confirmMessage: '@',
          stateChangeCallback: '&',
        },
        link: function($scope, elem, attrs) {
          $scope.confirmed = true;
          $scope.parameters = authService.parameters;

          window.onbeforeunload = function() {
            if (!$scope.parameters?.FWCOID && $scope.confirmOnExit()) {
              return $scope.confirmMessageWindow || $scope.confirmMessage;
            }
          };
          window.onunload = function(x) {
            if ($scope.confirmOnExit() && angular.isFunction($scope.stateChangeCallback)) {
              $scope.stateChangeCallback();
            }
          };

          var $stateChangeStartUnbind = $scope.$on('$stateChangeStart', function(
            event,
            next,
            nextParams,
            current,
            currentParams
          ) {
            if (!$scope.parameters?.FWCOID && $scope.confirmOnExit()) {
              if (!confirm($scope.confirmMessageRoute || $scope.confirmMessage)) {
                event.preventDefault();
              } else if (angular.isFunction($scope.stateChangeCallback)) {
                $scope.stateChangeCallback();
              }
            }
          });

          $scope.$on('$destroy', function() {
            window.onbeforeunload = null;
            window.onunload = null;
            $stateChangeStartUnbind();
          });
        },
      };
    },
  ]);

  /** Custom directive for kendo-date-picker inputs to support input-masking based on current kendo culture.
   *  usage: <input ... kdpcidv ..../>
   */
  module.directive('kdpcidv', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        var dateTimePattern = kendo.culture().calendar.patterns.d;

        function escapeDateTimeSeparatorsForKMask(dtPat) {
          return dtPat
            .replace(/\./g, '\\.')
            .replace(/\//g, '\\/')
            .replace(/dd/g, '00')
            .replace(/d/g, '00')
            .replace(/MM/g, '00')
            .replace(/M/g, '00')
            .replace(/H/g, '00')
            .replace(/h/g, '00')
            .replace(/[t]/g, 'L')
            .replace(/[ym]/g, '0')
            .toString();
        }

        $(element).kendoMaskedTextBox({
          mask: escapeDateTimeSeparatorsForKMask(dateTimePattern),
        });
        $(element).removeClass('k-textbox');
      },
    };
  });

  module.directive('ktpcidv', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        var timePattern = kendo.culture().calendar.patterns.t;
        console.log(timePattern);

        function escapeTimeSeparatorsForKMask(tPat) {
          return tPat
            .replace(/\./g, '\\.')
            .replace(/\//g, '\\/')
            .replace(/dd/g, '00')
            .replace(/d/g, '00')
            .replace(/MM/g, '00')
            .replace(/M/g, '00')
            .replace(/H/g, '00')
            .replace(/h/g, '00')
            .replace(/[t]/g, 'L')
            .replace(/[ym]/g, '0')
            .toString();
        }

        $(element).kendoMaskedTextBox({
          mask: escapeTimeSeparatorsForKMask(timePattern),
        });
        $(element).removeClass('k-textbox');
      },
    };
  });

  module.directive('kdtpcidv', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attr, ngModel) {
        var dateTimePattern = kendo.culture().calendar.patterns.d + ' ' + kendo.culture().calendar.patterns.t;
        console.log(dateTimePattern);

        function escapeDateTimeSeparatorsForKMask(dtPat) {
          return dtPat
            .replace(/\./g, '\\.')
            .replace(/\//g, '\\/')
            .replace(/dd/g, '00')
            .replace(/d/g, '00')
            .replace(/MM/g, '00')
            .replace(/M/g, '00')
            .replace(/H/g, '00')
            .replace(/h/g, '00')
            .replace(/[t]/g, 'L')
            .replace(/[ym]/g, '0')
            .toString();
        }

        $(element).kendoMaskedTextBox({
          mask: escapeDateTimeSeparatorsForKMask(dateTimePattern),
        });
        $(element).removeClass('k-textbox');
      },
    };
  });

  module.directive('customedit', [
    '$timeout',
    function($timeout) {
      return {
        restrict: 'A',
        scope: true,
        link: function(scope, element, attr) {
          $timeout(function() {
            if (attr.customedit !== 'true') {
              $(element).on('keypress', function(e) {
                e.preventDefault();
              });
            }
          }, 0);
        },
      };
    },
  ]);
  module.directive('focusFirstField', [
    '$timeout',
    '$parse',
    function($timeout, $parse) {
      return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
          //     var inputs = $element.find("input");
          //     var attemptsLeft = parseInt($attrs.focusFirstFieldTimeoutAttempts);
          //     if (isNaN(attemptsLeft)) attemptsLeft = 5;
          //     var isModal = $element.closest(".modal-dialog").length > 0;
          //     // Workaround: Bootstrap modal ablakban kötelező mezőre rakott fókusz
          //     // esetén a modal cancel event-je bug-os, kétszer kell a gombra kattintani
          //     if (isModal) {
          //         return;
          //     }
          //     function go() {
          //         var stop = false;
          //         var first = null;
          //
          //         angular.forEach(inputs, function (input) {
          //             if (!first) {
          //                 first = input;
          //             }
          //             var dropdown = $(input).data("kendoDropDownList");
          //             var jqLiteInput = angular.element(input);
          //             var isOk = jqLiteInput.is(":enabled");
          //             if (!!dropdown && !stop && isOk) {
          //                 dropdown.focus();
          //                 stop = true;
          //             }
          //
          //             if (!stop && isOk) {
          //                 //console.log("INPUT-->STOP");
          //                 //console.log(jqLiteInput);
          //                 input.focus();
          //                 stop = true;
          //             }
          //         });
          //
          //         if (!stop && first) {
          //             first.focus();
          //         }
          //     }
          //
          //     function attempt() {
          //         $timeout(function () {
          //             inputs = $element.find("input");
          //             if (--attemptsLeft >= 0) {
          //                 check();
          //             }
          //         });
          //     }
          //
          //     function check() {
          //         if (inputs.length) {
          //             go();
          //         }
          //         else {
          //             attempt();
          //         }
          //     }
          //
          //     if ($parse($attrs.focusFirstFieldTrigger).assign) {
          //         $scope.$watch($attrs.focusFirstFieldTrigger, function (newValue) {
          //             if (newValue) {
          //                 check();
          //             }
          //         });
          //     }
          //     else {
          //         $timeout(check);
          //     }
        },
      };
    },
  ]);

  module.directive('langSelector', [
    '$compile',
    'LanguageService',
    function($compile, languageService) {
      //var template1 = "<a href><span class=\"lang-sm lang-lbl\" lang='{{ngModel}}'></span></a>";
      //var template2 = "<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\"><span class=\"lang-sm lang-lbl\" lang='{{ngModel}}'></span><span class=\"caret\"></span></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"item in langSource\"><a href ng-click=\"change('{{item.Key}}')\"><span class=\"lang-sm lang-lbl\" lang=\"{{item.Value}}\"></span></a></li></ul>";
      return {
        require: 'ngModel',
        restrict: 'A',
        transclude: true,
        replace: true,
        template:
          '<div uib-dropdown class="btn-group"><button id="single-button" type="button" class="btn" uib-dropdown-toggle data-toggle="dropdown"><span class="lang-sm lang-lbl" style="padding:4px 10px 0 40px;" lang=\'{{ngModel}}\'></span><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="single-button"><li role="menuitem" ng-repeat=\'item in langSource\'><a href ng-click=\'change(item.Key)\'><span class="lang-sm lang-lbl" lang="{{item.Value}}"></span></a></li></ul></button></div>',
        scope: {
          ngModel: '=',
          langSource: '=',
          ngDisabled: '=',
        },

        link: function(scope, element, attr, ngModCont, transclude) {
          var self = scope;
          //attr.$set("class", "dropdown");
          scope.$watch('ngModel', function(newValue, oldValue) {
            ngModCont.$setViewValue(newValue);
          });

          self.change = function(value) {
            let vm = self.$parent.vm;
            languageService.setLang(value, function() {
              vm.labels = languageService.getDictionary().login;
            });
            self.ngModel = languageService.currentLang();
          };
        },
      };
    },
  ]);

  module.directive('favouriteMarker', [
    'FavouriteService',
    '$state',
    '$compile',
    '$rootScope',
    function(FavouriteService, $state, $compile, $rootScope) {
      return {
        restrict: 'E',
        template:
          '<div ng-if="show" ng-click="toggle($event)">' +
          '<span ng-if="!isFavourite" class="fa fa-star-o favourites-star" ></span>' +
          '<span ng-if="isFavourite" class="fa fa-star favourites-star" ></span>' +
          '</div>',
        scope: {
          //show: "@"
        },
        controller: function($scope, $element) {
          function evaluateForState(currentState) {
            if ((currentState.params ? true : false) && currentState.params.showFavouriteMarker !== undefined) {
              $scope.show = currentState.params.showFavouriteMarker ? true : false;
              if ($scope.show) {
                $scope.isFavourite = FavouriteService.isContainState(currentState);
              }
            } else {
              $scope.show = true;
              $scope.isFavourite = FavouriteService.isContainState(currentState);
            }
          }

          $scope.$watch(
            function() {
              return $state.current;
            },
            function(newValue) {
              evaluateForState(newValue);
            }
          );

          $scope.$watch(
            function() {
              return FavouriteService.favourites;
            },
            function(newValue) {
              if (newValue) {
                evaluateForState($state.current);
              }
            }
          );

          $scope.show = true;
          $scope.isFavourite = false;
          $scope.toggle = function($event) {
            $event.stopPropagation();
            var state = $state.current;
            if ($scope.isFavourite) {
              FavouriteService.remove(state);
            } else {
              FavouriteService.add(state);
            }
            $scope.isFavourite = !$scope.isFavourite;
          };
        },
      };
    },
  ]);

  module.directive('backButton', [
    '$rootScope',
    '$state',
    '$parse',
    function($rootScope, $state, $parse) {
      return {
        restrict: 'EA',
        link: function(scope, el, attrs) {
          var defaultState, defaultStateParams;

          el.click(function() {
            var stateName, stateParams;

            if ($state.previous) {
              stateName = $state.previous.name;
              stateParams = $state.previous.params;
            } else {
              stateName = defaultState;
              stateParams = defaultStateParams;
            }

            if (stateName) $state.go(stateName, stateParams);
          });

          attrs.$observe('defaultState', function() {
            defaultState = attrs.defaultState;
          });
          attrs.$observe('defaultStateParams', function() {
            defaultStateParams = $parse(attrs.defaultStateParams)(scope);
          });

          $rootScope.$watch('previousState', function(val) {
            el.attr('disabled', !$state.previous && !defaultState);
          });
        },
      };
    },
  ]);

  app.directive('button', function() {
    return {
      restrict: 'E',
      scope: {
        ngClick: '@ngClick',
        action: '@action',
        actionState: '@actionState',
        actionType: '@actionType',
      },
      controller: [
        'AuthService',
        '$element',
        '$window',
        function(authService, $element, $window) {
          if ($element[0]?.attributes['data-toggle']?.value == 'dropdown') {
            dropdownOnScreen($element, $window);
          }
          let parent = $element.parents('[ui-view]:first');
          if (!!parent.find('[elementsHided]').length) {
            authService.addingPermissionCheckToElement(parent);
          }
        },
      ],
    };
  });

  app.directive('uiView', function() {
    return {
      restrict: 'A',
      controller: [
        'AuthService',
        '$element',
        function($authService, $element) {
          const element = $element;
          var authService = $authService;

          $element.ready(function() {
            if (!!authService) {
              authService.addingPermissionCheckToElement(element);
              element.prepend('<div elementsHided></div>');
            }
          });
        },
      ],
      link: function(scope, element, attrs) {},
    };
  });
  // afw-gridColOrderDnD
  module.directive('afwGridDataColumnOrderDnd', [
    'LanguageService',
    '$rootScope',
    '$state',
    '$parse',
    '$timeout',
    function(LanguageService, $rootScope, $state, $parse, $timeout) {
      return {
        restrict: 'E',
        scope: {
          gridElement: '=gridElement',
        },
        template:
          `
         <div class="input-group" ng-show="!!gridElement.dataSource._sort.length">
            <div class="input-group-addon" style="font-size:12px;"><b>` +
          (LanguageService.getDictionary()?.index?.orderBy ?? 'Rendezési sorrend') +
          `:</b></div>
            <div id="sortable-horizontal" class="input-group-addon"> 
            <div style="font-size:12px;" ng-repeat="(k, v) in gridElement.dataSource._sort" ng-click="elementClick(k, v)">
                    {{getColumnTitle(gridElement.columns, v.field)}}
                    <span class='k-icon k-i-sort-{{v.dir}}-sm'></span>
                </div>
            </div>
            </div>     
                `,
        link: function(scope, element, attrs) {
          scope.gridColOrderContainerCollapsed = false;
          scope.placeholder = function(element) {
            return element
              .clone()
              .addClass('placeholder')
              .text('drop here');
          };
          scope.hint = function(element) {
            return element.clone().addClass('hint');
          };

          scope.elementClick = function(index, item) {
            // direction default value: asc
            switch (item.dir) {
              case 'asc':
                scope.gridElement.dataSource._sort[index].dir = 'desc';
                scope.gridElement.dataSource._sortFields[item.field].dir = 'desc';
                break;
              case 'desc':
                scope.gridElement.dataSource._sort.splice(index, 1);
                delete scope.gridElement.dataSource._sortFields[item.field];
                break;
              default:
                break;
            }
            scope.gridElement.refresh();
            scope.gridElement.dataSource.read();
          };
          scope.element = element;
          scope.element
            .parent()
            .find('[kendo-grid]')
            .ready(function() {
              scope.gridElement = scope.element
                .parent()
                .find('[kendo-grid]')
                .data('kendoGrid');
            });
          scope.getColumnTitle = function(gridFields, colName) {
            for (let i = 0; i < gridFields.length; i++) {
              if (gridFields[i].field === colName) {
                return gridFields[i].title;
              }
            }
          };

          scope.onSortEnd = function(e) {
            e.sender.draggable.dropped = true;
            e.preventDefault();
            $timeout(function() {
              scope.gridElement.dataSource._sort.splice(
                e.newIndex,
                0,
                scope.gridElement.dataSource._sort.splice(e.oldIndex, 1)[0]
              );
              scope.gridElement.dataSource.read();
            });
          };

          $('#sortable-horizontal').kendoSortable({
            axis: 'x',
            cursor: 'move',
            container: '#sortable-horizontal',
            placeholder: "<div class='placeholder'>Új pozíció!</div>",
            hint: function(element) {
              return element.clone().addClass('tooltip');
            },
            end: scope.onSortEnd,
          });
        },
      };
    },
  ]);
  app.directive('label', function() {
    return {
      restrict: 'E',
      controller: [
        '$scope',
        '$element',
        function($scope, $element) {
          const scope = $scope;
          $element.ready(function() {
            $element.kendoTooltip({
              hide: function(e) {
                this.content.parent().css('visibility', 'hidden');
              },
              showOn: 'click mouseenter',
              position: 'center',
              content: '',
              show: function(e) {
                this.content.parent().css('visibility', 'hidden');
                var $c = $element
                  .find('ng-transclude')
                  .clone()
                  .css({ display: 'inline', width: 'auto', visibility: 'hidden' })
                  .appendTo('body');

                if (
                  $element.hasClass('control-label') &&
                  $c.width() > $element.parent().width() - 2
                  //||($element.find('div').hasClass('formly-field-checkbox-label') && $c.width() > $element.width())
                ) {
                  this.content.parent().css('visibility', 'visible');
                  this.content.html(
                    $element
                      .find('ng-transclude')
                      .html()
                      .trim()
                  );
                }

                $c.remove();
              },
            });
            $element.find('i').kendoTooltip({
              content: scope.$parent.to?.tooltipToLabel,
            });
          });
        },
      ],
      transclude: true,
      template:
        '<ng-transclude></ng-transclude>&nbsp;<i ng-if="to.tooltipToLabel" class="fa fa-info-circle" aria-hidden="true"></i>',
    };
  });
  module.directive('uibModalWindow', [
    function() {
      return {
        restrict: 'EA',
        link: function(scope, element) {
          let dcontent = element.find('.modal-content');
          draggableModal(dcontent);
        },
      };
    },
  ]);
  module.directive('f2Modal', [
    function() {
      return {
        restrict: 'C',
        link: function(scope, element) {
          let dcontent = element.find('.modal-content');
          draggableModal(dcontent);
        },
      };
    },
  ]);
  module.directive('f4Modal', [
    function() {
      return {
        restrict: 'C',
        link: function(scope, element) {
          let dcontent = element.find('.modal-content');
          draggableModal(dcontent);
        },
      };
    },
  ]);
  function draggableModal(element) {
    element.draggable({
      handle: '.modal-header',
      containment: '.DivVP',
      drag: function(event, ui) {},
      start: function(event, ui) {},
      cursor: 'move',
    });
    $(window).resize(function(event, ui) {
      let divvpRect = $('.DivVP')[0]?.getBoundingClientRect();
      let elementRect = element[0]?.getBoundingClientRect();
      let width = element.width();
      let newx, newy;
      if (!elementRect) {
        return;
      }
      if (elementRect.x < 0) {
        newx = 0;
      } else if (elementRect.right > divvpRect.right) {
        newx = elementRect.x - (elementRect.right - divvpRect.right);
        if (newx < 0) {
          newx = 0;
        }
      }
      if (elementRect.y < 0) {
        newy = 0;
      } else if (elementRect.bottom > divvpRect.bottom) {
        newy = elementRect.y - (elementRect.bottom - divvpRect.bottom);
        if (newy < 0) {
          newy = 0;
        }
      }
      if (newx != null || newy != null) {
        let x = newx ?? elementRect.x;
        let y = newy ?? elementRect.y;
        element.css({ top: x, left: y, position: 'fixed' });
        element.width(width);
      }
    });
  }

  function dropdownOnScreen(element, $window) {
    angular.element($window).on('resize', function() {
      reposition();
    });
    let menu = $(element.find('.dropdown-menu'));
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {
        if ($(mutationRecord.target).attr('aria-expanded') === 'true') {
          reposition();
        }
      });
    });
    observer.observe(element[0], {
      attributes: true,
      attributeFilter: ['aria-expanded'],
    });

    function reposition() {
      let padding = 3;
      if ($(element).attr('aria-expanded') === 'true') {
        const rectElement = element[0]?.getBoundingClientRect();
        const rectMenu = menu[0]?.getBoundingClientRect();
        if (!rectMenu) {
          return;
        }
        let width = (window.innerWidth || document.documentElement.clientWidth) - padding,
          height = (window.innerHeight || document.documentElement.clientHeight) - padding;
        if (rectMenu.left > padding) {
          let newLeft = width - rectMenu.width;
          if (rectMenu.right >= width && newLeft > padding) {
            menu.offset({ left: newLeft });
          } else if (rectMenu.left != rectElement.left && newLeft > rectElement.left) {
            menu.offset({ left: element.offset().left });
          }
        } else {
          menu.offset({ left: padding });
        }
        if (rectElement.bottom + rectMenu.height + padding > height) {
          if (rectMenu.bottom >= height && rectElement.top > rectMenu.height + padding) {
            menu.offset({ top: element.offset().top - rectMenu.height });
          }
        } else {
          menu.offset({ top: element.offset().bottom });
        }
      }
    }
  }
})(angular.module('myApp'));

(function(module) {
  'use strict';

  /***********************/
  /*** Filter: numeral ***/
  /***********************/
  module.filter('numeral', function() {
    return function(input, format) {
      return numeral(input).format(format);
    };
  });

  module.filter('capitalize', function() {
    return function(input) {
      return !!input ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
  });

  module.filter('formatIBAN', function() {
    return function(input) {
      return !!input ? input.toUpperCase() : '';
    };
  });
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('MapCtrl', [
    '$http',
    '$q',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$uibModal',
    '$window',
    '$timeout',
    'NgMap',
    'GMapsService',
    'UIHelperService',
    function(
      $http,
      $q,
      options,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      $window,
      $timeout,
      NgMap,
      gmaps,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MapCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.mapModel = {};
      vm.points = [];
      vm.mapSource = options.result.Data;
      vm.dto = options.dto;
      vm.types = options.utilities;

      if (options.pageModel) {
        ////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
        var customExpressionProperties = {
          OpUnitId: {
            'templateOptions.disabled': function() {
              return vm.mapModel.ZoneId === null || typeof vm.mapModel.ZoneId === 'undefined';
            },
          },
          Object: {
            'templateOptions.disabled': function() {
              return (
                vm.mapModel.OpUnitId === null ||
                vm.mapModel.OpUnitId === '' ||
                typeof vm.mapModel.OpUnitId === 'undefined'
              );
            },
          },
          PropertyId: {
            'templateOptions.disabled': function() {
              if (vm.mapModel.Object && vm.mapModel.Object.Value) {
                return vm.mapModel.Object === null || vm.mapModel.Object.Value === null;
              } else {
                return false;
              }
            },
          },
        };

        // Usage: "fieldName": onChangeFunction(selectedItem)
        var onChangeFunctions = {
          ZoneId: function() {
            if (
              (vm.mapModel.ZoneId !== null && typeof vm.mapModel.ZoneId !== 'undefined') ||
              (options.dto.ZoneId !== null && typeof options.dto.ZoneId !== 'undefined')
            ) {
              vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
                zoneId: vm.mapModel.ZoneId || options.dto.ZoneId,
              };
              //reload
              vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            }
          },
          OpUnitId: function() {
            if (
              vm.mapModel.ZoneId !== null &&
              typeof vm.mapModel.ZoneId !== 'undefined' &&
              vm.mapModel.OpUnitId !== null &&
              typeof vm.mapModel.OpUnitId !== 'undefined'
            ) {
              vm.pageModel.Fields.Object.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                zone: vm.mapModel.ZoneId,
                opUnitId: vm.mapModel.OpUnitId,
              };
            }
            getMarkers();
          },
          Object: function(selectedItem) {
            if (selectedItem !== null && selectedItem.PropertyId > 0) {
              vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                objectId: selectedItem.PropertyId,
              };
            }
            setTimeout(getMarkers, 0);
          },
          PropertyId: function() {
            setTimeout(getMarkers, 0);
          },
        };

        vm.pageModel = options.pageModel;
        vm.messages = options.pageModel.Messages;

        ////////////////////////////////////////////////////////////////////////////////////////
        //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
        // These must be ran before generating formly descriptors from general field descriptors
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

        // Generate Formly form descriptors from pageModel
        vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

        if (!!$stateParams.propertyId) {
          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            objectId: options.dto.Object.Value,
          };

          vm.pageModel.Fields.Object.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            zoneId: options.dto.ZoneId,
            opUnitId: options.dto.OpUnitId,
          };
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            zoneId: options.dto.ZoneId,
          };
          $timeout(function() {
            vm.mapModel.ZoneId = options.dto.ZoneId;
            vm.mapModel.OpUnitId = options.dto.OpUnitId;
            vm.mapModel.Object = options.dto.Object;
            $timeout(function() {
              vm.mapModel.PropertyId = options.dto.PropertyId;
            });
          });
        }
      }

      vm.icon = gmaps.getMarkerIcon();

      if (vm.types) {
        vm.checked = { types: [vm.types[0]] };
      }

      vm.back = function() {
        $state.go('Utility.MeterNav');
      };

      vm.checkListChange = function() {
        if (
          typeof vm.mapModel.ZoneId !== 'undefined' &&
          vm.mapModel.ZoneId !== null &&
          typeof vm.mapModel.OpUnitId !== 'undefined' &&
          vm.mapModel.OpUnitId !== null &&
          vm.mapModel.OpUnitId !== ''
        ) {
          getMarkers();
        }
      };

      NgMap.getMap().then(function(map) {
        vm.map = map;

        /* Automatikusan töltse be a markereket, ha betöltődik a térkép */
        if ($state.current.name === 'Property.Map' || $state.current.name === 'Partner.AddressMap') {
          createPoints(vm.mapSource).then(function() {
            panToMarkers();
          });
        }
      });

      var createPoints = function(list) {
        var deferred = $q.defer();
        var counter = list.length;
        list.forEach(function(obj) {
          var newObj = {};
          newObj['title'] = obj.Address;
          newObj['address'] = obj.Address;
          newObj['tenement'] = obj.Tenement;
          newObj['propertyid'] = obj.PropertyId;

          if (obj.Northern !== 0 || obj.Eastern !== 0) {
            newObj['latitude'] = obj.Northern;
            newObj['longitude'] = obj.Eastern;
            vm.points.push(newObj);
            counter--;
            if (counter <= 0) {
              deferred.resolve();
            }
          } else if (obj.Address) {
            gmaps.addressConvert(obj.Address).then(function(pos) {
              newObj['latitude'] = pos.lat();
              newObj['longitude'] = pos.lng();
              vm.points.push(newObj);
              counter--;
              if (counter <= 0) {
                deferred.resolve();
              }
            });
          }
        });
        return deferred.promise;
      };

      function panToMarkers() {
        var latlngbounds = new google.maps.LatLngBounds();
        for (var i = 0; i < vm.points.length; i++) {
          var point = vm.points[i];
          latlngbounds.extend(new google.maps.LatLng(point.latitude, point.longitude));
        }
        vm.map.fitBounds(latlngbounds);
      }

      var createKeys = function(obj) {
        var newObj = {};
        newObj = obj.key;
        return newObj;
      };

      var getMarkers = function() {
        vm.points = [];
        var propertyId = null;
        var objectId = null;

        if (!vm.mapModel.ZoneId || vm.mapModel.ZoneId === '') return;

        if (!vm.mapModel.OpUnitId || vm.mapModel.OpUnitId === '') return;

        if (!!vm.mapModel.Object && vm.mapModel.Object.Value !== null) {
          objectId = vm.mapModel.Object.Value;
        }

        if (!!vm.mapModel.PropertyId && vm.mapModel.PropertyId.Value !== null) {
          propertyId = vm.mapModel.PropertyId.Value;
        }

        var keylist = vm.checked.types.map(createKeys);

        $http({
          method: 'POST',
          url: 'Utility/GetMapSource',
          data: {
            zoneId: vm.mapModel.ZoneId,
            opUnitId: vm.mapModel.OpUnitId,
            objectId: objectId,
            propertyId: propertyId,
            uIds: keylist,
          },
        }).then(function successcallback(response) {
          vm.mapSource = response.data.Data;
          createPoints(vm.mapSource).then(function() {
            panToMarkers();
          });
        });
      };
      /*
      if (vm.mapModel.ZoneId !== 0) {
        setTimeout(getMarkers, 1000);
      }
*/
      vm.listMeters = function() {
        var tenement = this.tenement;
        var propertyid = this.propertyid;

        var keylist = vm.checked.types.map(createKeys);

        $uibModal.open({
          templateUrl: 'App/Utility/MapMeter.html',
          controller: 'MapMeterCtrl',
          controllerAs: 'vm',
          resolve: {
            types: function() {
              return keylist;
            },
            tenement: function() {
              return tenement;
            },
            propertyid: function() {
              return propertyid;
            },
            fModel: RouteResolveFunc('Utility/MeterListOptions/'),
          },
          backdrop: 'static',
        });
      };

      vm.openPropertyGrid = function() {
        $window.sessionStorage.setItem('tenement', $(this).attr('tenement') === null ? '' : $(this).attr('tenement'));
        $state.go('Property.PyramidNav');
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.factory('ConfigService', [
    '$http',
    function($http) {
      var service = {
        values: {
          gmaps_api_key: 'AIzaSyCrnz5tdBZ5c242Fa_NecGpn9h0mWFAIyM',
          supportedLangs: ['en-US', 'hu-HU'],
          defaultLang: ['hu'],
          defaultLangCode: ['hu-HU'],
        },
        getConfig: getConfig,
        loaded: false,
      };
      getConfig()
        .then(function(res) {
          return service;
        })
        .catch(function(res) {
          return service;
        });
      return service;

      function getConfig(reload = false) {
        return new Promise(function(resolve, reject) {
          if (!reload && service.loaded) {
            resolve(service.values);
          }
          $http
            .get(`dist/sbc.txt`)
            .then(function(res) {
              service.values = res.data.hu_griffsoft;
              window.googleMapsUrl =
                '//maps.google.com/maps/api/js?key=' +
                (res.data.hu_griffsoft.gmaps_api_key ?? service.values.gmaps_api_key).replace(/\"/g, '');
              kendo.culture(res.data.hu_griffsoft.defaultLangCode ?? defaultLangCode);
              service.loaded = true;
              resolve(res.data.hu_griffsoft);
            })
            .catch(function(res) {
              resolve(service.values);
            });
        });
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.factory('FormInitService', [
    '$http',
    '$state',
    '$stateParams',
    'LanguageService',
    function($http, $state, $stateParams, languageService) {
      var service = {
        DownloadAndLoadFormData: DownloadAndLoadFormData,
        DownloadAndLoadFormDefaultData: DownloadAndLoadFormDefaultData,
        DownloadFormDefaultData: DownloadFormDefaultData,
        FormDataGenerate: FormDataGenerate,
        UploadFormData: UploadFormData,
        UploadFormDefault: UploadFormDefault,
        DeleteFormDefault: DeleteFormDefault,
        DeleteFormData: DeleteFormData,
        FormDatasList: FormDatasList,
        CompileCtrlId: CompileCtrlId,
      };

      return service;

      function CompileCtrlId(template, params, data) {
        template = template.replace('{ctrl}', params.controllerOptions.ctrlId);
        var match;
        do {
          match = /\{[^\}]+\}/g.exec(template);
          if (match) {
            let value = GetValue(data, match[0]);
            template = template.replace(match[0], value);
          }
        } while (match);
        return template;
      }
      function GetValue(params, variable) {
        let tempVariable = params;
        variable
          ?.replaceAll(/[\{\}]/g, '')
          ?.split('.')
          ?.forEach(x => {
            if (!tempVariable) return false;
            tempVariable = tempVariable[x];
          });
        return tempVariable ?? '';
      }
      function DownloadAndLoadFormData(id, key, formModel, generateFormly, type = 'u') {
        return $http
          .post('Initialization/DownloadFormData', {
            id: id,
            key: key,
            type: type,
          })
          .then(function successCallback(response) {
            FormDataGenerate(formModel, generateFormly, response?.data?.data);
          })
          .catch(function errorCallback(response) {});
      }
      function DownloadAndLoadFormDefaultData(id, formModel, generateFormly) {
        return $http
          .post('Initialization/DownloadFormDefaultData', {
            id: id,
          })
          .then(function successCallback(response) {
            FormDataGenerate(formModel, generateFormly, response?.data?.data);
          })
          .catch(function errorCallback(response) {});
      }
      function DownloadFormDefaultData(id, callback) {
        return $http
          .post('Initialization/DownloadFormDefaultData', {
            id: id,
          })
          .then(function successCallback(response) {
            if (callback) {
              callback(response?.data?.data);
            } else {
              return response?.data?.data;
            }
          })
          .catch(function errorCallback(response) {});
      }
      function FormDataGenerate(formModel, generateFormly, data) {
        if (!!data) {
          let dataModel = JSON.parse(JSON.parse(data.replaceAll('(.)', '$1')));
          if (!!dataModel) {
            Object.keys(formModel).forEach(function(key, index) {
              if (!!dataModel[key]) {
                if (
                  (formModel[key]?.hasOwnProperty('value') || !formModel[key]) &&
                  dataModel[key]?.hasOwnProperty('value')
                ) {
                  formModel[key] = { value: dataModel[key].value, Text: null };
                } else if (
                  (formModel[key]?.hasOwnProperty('Value') || !formModel[key]) &&
                  dataModel[key]?.hasOwnProperty('Value')
                ) {
                  formModel[key] = { Value: dataModel[key].Value, Text: null };
                } else {
                  formModel[key] = dataModel[key];
                }
              }
            });
            if (generateFormly) {
              generateFormly();
            }
          }
        }
      }

      function UploadFormData(id, key, formModel, pagemodel, formly, defData = false, old = '', type = 'u') {
        let dto = {};
        if (formly?.$$controls) {
          formly.$$controls.forEach(function(value) {
            if (!!value.$modelValue || value.$modelValue == 0) {
              let key = Object.keys(pagemodel.Fields).find(
                x => pagemodel.Fields[x].FormlyFieldDescriptor.id == value.$name
              );
              if (!!key && value.$$attr.disabled !== true && !!value.$valid) {
                if (value.$modelValue?.hasOwnProperty('Value')) {
                  dto[key] = { Value: value.$modelValue.Value, Text: null };
                } else if (value.$modelValue?.hasOwnProperty('value')) {
                  dto[key] = { value: value.$modelValue.value, Text: null };
                } else {
                  dto[key] = value.$modelValue;
                }
              }
            }
          });
        } else {
          Object.keys(formModel).forEach(function(key, index) {
            if (
              (!!formModel[key] || formModel[key] == 0) &&
              ((!!pagemodel &&
                pagemodel.Fields[key]?.FormlyFieldDescriptor?.formControl?.$valid &&
                !pagemodel.Fields[key]?.FormlyFieldDescriptor?.templateOptions?.disabled) ||
                !pagemodel)
            ) {
              if (formModel[key]?.hasOwnProperty('Value')) {
                dto[key] = { value: formModel[key].Value, Text: null };
              } else if (formModel[key]?.hasOwnProperty('value')) {
                dto[key] = { value: formModel[key].value, Text: null };
              } else {
                dto[key] = formModel[key];
              }
            }
          });
        }
        return $http
          .post('Initialization/UploadFormData', {
            id: id,
            key: key,
            data: JSON.stringify(dto),
            defData: defData,
            type: type,
            old: old,
          })
          .then(function successCallback(response) {})
          .catch(function errorCallback(response) {});
      }
      function UploadFormDefault(id, key, type = 'u') {
        return $http
          .post('Initialization/UploadFormDefault', {
            id: id,
            key: key,
            type: type,
          })
          .then(function successCallback(response) {})
          .catch(function errorCallback(response) {});
      }
      function DeleteFormDefault(id, type = 'u') {
        return $http
          .post('Initialization/DeleteFormDefault', {
            id: id,
            type: type,
          })
          .then(function successCallback(response) {})
          .catch(function errorCallback(response) {});
      }
      function DeleteFormData(id, key, type = 'u') {
        return $http
          .post('Initialization/DeleteFormData', {
            id: id,
            key: key,
            type: type,
          })
          .then(function successCallback(response) {})
          .catch(function errorCallback(response) {});
      }
      function FormDatasList(id, callback) {
        $http
          .post('Initialization/FormDatasList', {
            id: id,
            global: true,
          })
          .then(function successCallback(response) {
            return callback(response.data);
          })
          .catch(function errorCallback(response) {
            return null;
          });
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.factory('AuthService', [
    '$http',
    '$state',
    '$q',
    'AppConstant',
    'LanguageService',
    '$rootScope',
    '$location',
    '$location',
    function($http, $state, $q, appConstant, langService, $rootScope, $location) {
      var service = {
        user: {
          name: '',
          id: '',
          hasRole: hasRole,
          lang: '',
          langCode: '',
          token: '',
          ttl: '',
          group: 'group',
          activeAdopter: '',
          tokenLogin: null,
        },
        _isLoggedIn: false,
        get isLoggedIn() {
          return this._isLoggedIn;
        },
        set isLoggedIn(value) {
          this._isLoggedIn = value;
          if (value) {
            $rootScope.$broadcast('AuthService:loggedIn');
          }
        },
        login: login,
        logout: logout,
        loggedIn: loggedIn,
        check: check,
        getUserContext: getUserContextFromServer,
        getUserContextReloadMenus: getUserContextReloadMenusFromServer,
        setUserContext: setLocalUserContext,
        changePassword: changePassword,
        getMenu: getMenu,
        getMenuItemLabel: getMenuItemLabel,
        getAuthToken: getAuthToken,
        getForrasParameterValue: getForrasParameterValue,
        getUserParametersFromServer: getUserParametersFromServer,
        getSBType: getSBType,
        getSBFormInit: getSBFormInit,
        getSBMainState: getSBMainState,
        executeActionWithPermission: executeActionWithPermission,
        hideElementsForPermission: hideElementsForPermission,
        addingPermissionCheckToElement: addingPermissionCheckToElement,
        controllerPermissions: {},
        redirectTo: redirectTo,
        lastCall: lastCall,
      };
      const generateHash = string => {
        let hash = 0;
        for (const char of string) {
          hash = (hash << 5) - hash + char.charCodeAt(0);
          hash |= 0; // Constrain to 32bit integer
        }
        return hash;
      };
      service.callBackArray = [];
      service.checkCallBackArray = [];
      service.LoginTimer = SBTimer.getInstance('login');
      service.hostId = generateHash($location.$$absUrl.replace($location.$$url, ''));
      service.hostIdLogin = service.hostId + generateHash('Login');
      service.hostIdLogOut = service.hostId + generateHash('LogOut');
      service.hostIdAction = service.hostId + generateHash('Action');
      service.LoginTimer.subscribe('tick', d => {
        if (service.callTime > 0 && service.LoginTimer?.endTime > 0) {
          let callTime = Date.now() - service.callTime;
          if (callTime > service.LoginTimer.endTime - (4000 + service.LoginTimer.tickTime)) {
            service.check();
            service.callTime = Date.now() + service.LoginTimer.tickTime;
          }
        }
        //console.log(`fut at ${d.toFixed(2)}s.   ${Date.now() - service.callTime} ${service.LoginTimer.endTime} `);
      });
      service.LoginTimer.subscribe('stopped', d => {
        service.logout(null, null, true);
      });

      window.addEventListener('storage', event => {
        if (event.isTrusted) {
          if (event.key === service.hostIdLogin && !service.isLoggedIn) {
            location.reload();
          } else if (event.key === service.hostIdLogOut && service.isLoggedIn) {
            location.reload();
          } else if (event.key === service.hostIdAction && service.isLoggedIn) {
            if (service.isLoggedIn && event.newValue > service.LoginTimer.startTime) {
              service.LoginTimer.startTime = event.newValue;
            }
          }
        }
      });
      service.sac = new BroadcastChannel('SB_auth_channel');
      service.sac.onmessage = event => {
        if (event.isTrusted && event.data?.id === service.hostId) {
          if (event.data?.type === 'Login' && !service.isLoggedIn) {
            location.reload();
          } else if (event.data?.type === 'LogOut' && service.isLoggedIn) {
            location.reload();
          } else if (event.data?.type === 'Action' && service.isLoggedIn) {
            if (service.isLoggedIn && event.data?.data > service.LoginTimer.startTime) {
              service.LoginTimer.startTime = event.data?.data;
            }
          }
        }
      };
      return service;
      function onAction(event) {
        service.LoginTimer.startTime = Date.now();
        service.sac.postMessage({ id: service.hostId, type: 'Action', data: service.LoginTimer.startTime });
        localStorage.setItem(service.hostIdAction, service.LoginTimer.startTime);
      }
      function onVisibilityChange(event) {
        if (!document.hidden) {
          onAction(event);
        }
      }
      function login(data, noLogin = false) {
        if (noLogin) {
          setEvents();
          setTimer();
          service.LoginTimer.start();
          service.sac.postMessage({ id: service.hostId, type: 'Login' });
          service.sac.postMessage({ id: service.hostId, type: 'Action', data: Date.now() });
          localStorage.setItem(service.hostIdLogIn, Date.now());
          localStorage.setItem(service.hostIdAction, service.LoginTimer.startTime);
          return;
        }
        return $http.post('Auth/Login', data);
      }
      function lastCall() {
        if (service.LoginTimer) {
          service.callTime = Date.now() + service.LoginTimer.tickTime;
        }
      }
      function redirectTo() {
        $location.hash('');
        var redirectTo = decodeURIComponent($location.search().redirectTo);
        if (redirectTo !== 'undefined') $location.path(redirectTo).search({});
        else $state.go('main', null, { reload: true });
      }

      function logout(stateName, data, reload = false) {
        if (service._isLoggingOut) return;
        service._isLoggingOut = true;
        service.isLoggedIn = false;
        document.removeEventListener('visibilitychange', onVisibilityChange, true);
        document.removeEventListener('mousemove', onAction, true);
        document.removeEventListener('click', onAction, true);
        document.removeEventListener('keyup', onAction, true);
        service.LoginTimer = SBTimer.getInstance('login');
        service.LoginTimer.stop();
        let isLoggedIn = service.isLoggedIn;
        service.user.name = '';
        $http
          .get('Auth/Logout')
          .then(
            function(response) {
              afterLogout(reload, response.data);
            },
            function(response) {
              afterLogout(reload, null);
            }
          )
          .catch(e => {
            afterLogout(reload, null);
          });
        function afterLogout(reload, logoutData) {
          service._isLoggingOut = false;
          localStorage.removeItem('sb-uat');
          service.sac.postMessage({ id: service.hostId, type: 'LogOut' });
          localStorage.setItem(service.hostIdLogOut, Date.now());

          // Keycloak logout - a backend olvassa a tokeneket szerver oldali storage-ból
          var isKeycloak = logoutData?.isKeycloak === true;
          if (isKeycloak) {
            service._isLoggingOut = false;
            window.location.href = 'auth/kclogout';
            return;
          }

          // Fallback - régi mód, ha nem jött token
          var isKeycloakFallback = localStorage.getItem('sb-keycloak') === '1';
          if (isKeycloakFallback) {
            service._isLoggingOut = false;
            window.location.href = 'auth/kclogout';
            return;
          }

          if (reload) {
            location.reload();
            return;
          } else {
            $state.go(stateName ?? appConstant.loginStateName, data ?? {}, { reload: true });
          }
        }
      }
      function loggedIn() {
        service.isLoggedIn = true;
        service.login(null, true);
      }
      function checkCallBack() {
        service.checkCallBackArray.forEach(element => element());
        service.checkCallBackArray = [];
      }

      function check() {
        return new Promise(function(resolve, reject) {
          $http
            .get('Auth/Check')
            .then(function(resp) {
              let logged = resp.status === 200;
              if (service.isLoggedIn != logged) {
                service.isLoggedIn = logged;
                if (logged) {
                  service.login(null, true);
                } else {
                  location.reload();
                }
              }
              service.user.tokenLogin = resp.data?.tokenLogin ?? null;
              checkCallBack();
              resolve(service.isLoggedIn);
            })
            .catch(function(msg) {
              if (msg.status == 401) {
                service.isLoggedIn = false;
                checkCallBack();
                resolve(service.isLoggedIn);
              } else {
                checkCallBack();
                reject(msg);
              }
            });
        });
      }

      function getAuthToken(data) {
        var getUserTokenJson = { userID: '', pwd: '' };

        getUserTokenJson.userID = data.nickName;
        getUserTokenJson.pwd = data.password;

        $http({
          method: 'POST',
          url: 'http://localhost:61044/api/v1_0_0Login',
          data: getUserTokenJson,
        })
          .then(function(data, status, headers, config) {
            service.user.token = data.token;
            service.user.ttl = data.ttl;
          })
          .catch(function(data, status, headers, config) {});
      }

      function getUserParametersFromServer() {
        if (!service.isLoggedIn) {
          return Promise.resolve();
        }
        return $http
          .get('Auth/GetUserParameters')
          .then(function(success) {
            setLocalUserParameters(success.data);
          })
          .catch(function(error) {
            //console.error('getUserParametersFromServer() error: ', error);
          });
      }

      function getSBType() {
        return new Promise(function(resolve, reject) {
          $http.get('Auth/GetSBType').then(function(resp) {
            resolve((service['sbType'] = resp.data.sbtype));
          });
        });
      }
      function getSBMainState() {
        return new Promise(function(resolve, reject) {
          $http.get('Auth/GetSBMainState').then(function(resp) {
            resolve((service['sbMainState'] = resp.data.sbMainState));
          });
        });
      }

      function getSBFormInit() {
        return new Promise(function(resolve, reject) {
          $http.get('Auth/GetSBFormInit').then(function(resp) {
            resolve((service['SBFormInitOff'] = resp.data.sbFormInit));
          });
        });
      }
      function getUserContextFromServer(reloadMenus = !service.parameters?.FWCOID, callback, reloadContext = false) {
        if (!service.isLoggedIn) {
          return () => Promise.resolve();
        }
        if ((!!service.loading && !reloadContext) || !!service.loaded) {
          if (!!callback) {
            service.callBackArray.push(callback);
          }
          return () => Promise.resolve();
        }
        let param = '';
        if ((reloadMenus = true)) {
          param = reloadMenus ? '?refreshMenu=true' : '';
        }
        service.loading = true;

        getUserParametersFromServer().then(function() {
          console.log(moment().format() + ' - Parameters query success!');
        });

        return $http
          .get('Auth/GetUserContext' + param)
          .then(function(success) {
            console.log(moment().format() + ' - UserContext query success!');
            setLocalUserContext(success.data);
            service.loading = false;
            service.loaded = true;
            service.callBackArray.forEach(element => element());
            service.callBackArray = [];
          })
          .catch(function(error) {
            //console.error('getUserContextFromServer() error: ', error);
            service.loading = false;
            service.callBackArray.forEach(element => element());
            service.callBackArray = [];
          });
      }

      function getUserContextReloadMenusFromServer() {
        if (!$state.$current.name || $state.$current.name == 'main' || !!service.parameters?.FWCOID) {
          return new Promise((resolve, reject) => {});
        }
        return $http
          .get('Auth/UserContextReloadMenus')
          .then(function(success) {
            service.menu = success.data.menu;
            service.mainMenu = success.data.mainMenu;
            service.unpermittedMenu = success.data.unpermittedMenu;
            $rootScope.$broadcast('AuthService:setMenu');
          })
          .catch(function(error) {
            //console.error('getUserContextFromServer() error: ', error);
          });
      }

      function getForrasParameterValue(paramId) {
        //console.log(service.forrasParam);
        var row = service.forrasParam?.find(function(o) {
          return o.ParamId === paramId;
        });
        return !!row && !!row.Value ? row.Value : undefined;
      }

      function setLocalUserContext(response, options) {
        service.stateBreadcrumbLabel = response.stateBreadcrumbLabel;
        service.user.name = response.name;
        service.user.id = response.id;
        service.user.lang = response.lang;
        service.user.langCode = response.langCode;
        service.user.opUnitList = response.opUnitList;
        service.user.group = response.group;
        service.user.activeAdopter = response.activeAdopter;
        service.user.tokenLogin = response.tokenLogin;
        langService.setLang(service.user.langCode);
        langService.setStateBreadcrumbLabel(service.user.langCode, service);
        // Set: service.roles
        var i = 1;
        angular.forEach(service.roles, function(value, key) {
          service.roles[key].isSet = $.inArray(i++, response.roles) !== -1;
        });
        service.title = response.title;
        service.menu = response.menu;
        service.mainMenu = response.mainMenu;
        service.unpermittedMenu = response.unpermittedMenu;
        $rootScope.$broadcast('AuthService:setMenu');
        service.forrasParam = response.forrasParams;
        service.parameters = response.parameters;
        service.globalInitializer = response.globalInitializer == 'True';
        if (options?.clearControllerPermissions) {
          if (!service.parameters?.FWCOID) {
            service.controllerPermissions = {};
          }
        }
        setEvents();
        setTimer();
        $rootScope.$broadcast('AuthService:setLocalUserContextSuccess');
      }

      function setEvents() {
        if (!service.parameters?.UserActivity) {
          return;
        }
        const events = ['visibilitychange', 'mousemove', 'click', 'keyup'];
        events.forEach(x => {
          if (service.parameters.UserActivity.includes(x)) {
            document.addEventListener(x, x === 'visibilitychange' ? onVisibilityChange : onAction, true);
          } else {
            document.removeEventListener(x, x === 'visibilitychange' ? onVisibilityChange : onAction, true);
          }
        });
        service.eventsAdded = true;
      }
      function setTimer() {
        service.LoginTimer = SBTimer.getInstance('login');
        service.LoginTimer.tickTime = (service.parameters?.SessionTick ?? 5) * 1000;
        service.LoginTimer.endTime = (service.parameters?.SessionTimeout ?? 30) * 60000;
      }

      function setLocalUserParameters(response) {
        service.forrasParam = response.forrasParams;
        service.parameters = response.parameters;
        $rootScope.$broadcast('AuthService:setLocalUserContextSuccess');
      }

      function changePassword(data) {
        return $http.post('Auth/ChangePassword', data);
      }

      function hasRole(role) {
        return service.roles[role.Value].isSet;
      }

      async function getMenu(parent) {
        var deferred = $q.defer();
        if (!service.menu && !!service.getUserContext) {
          await service.getUserContext().then(function() {
            var menu = resolveMenu(parent);
            deferred.resolve(menu);
          });
        } else {
          var menu = resolveMenu(parent);
          deferred.resolve(menu);
        }
        return deferred.reject();
      }

      function resolveMenu(parent) {
        var menus = service.menu.filter(function(item) {
          return item.ParentId === parent;
        });
        var smenus = menus.sort(function(a, b) {
          if (a.Pos < b.Pos) {
            return -1;
          }
          if (a.Pos > b.Pos) {
            return 1;
          }
          // a must be equal to b
          return 0;
        });
        return smenus;
      }

      function getMenuItemLabel(id) {
        return 'aaaa';
      }

      function executeActionWithPermission(scope, localFunction, controller, writeResult = true, element = null) {
        var actionType = service.parameters?.FWAPBU ?? 'FWAPBU_WARN';
        if (!!$(element)?.attr('action-type')) {
          actionType =
            'FWAPBU_' +
            $(element)
              .attr('action-type')
              .toUpperCase();
        }
        if (actionType === 'FWAPBU_NO' || controller.includes('{{')) {
          return;
        }
        var params = { contr: [controller] };
        const clonedFunction = scope[localFunction];
        var checkPermissionWarn = function() {
          const args = arguments;
          let pre = params['contr'].some(x => x.includes('Dms/')) ? 'Dms/Document/' : 'Auth/';
          $http
            .post(pre + 'GetUserPermissionForController', params)
            .then(function(response) {
              let result = Object.values(response.data.resultList)[0];
              if (!result.Value) {
                if (!!result?.Errors?.length) {
                  if (!result.ResultStatus) {
                    toastr.error(result?.Errors[0]?.Message);
                  }
                } else {
                  toastr.warning(result?.Messages?.[0]?.Message);
                }
                return response;
              } else {
                return typeof clonedFunction === 'function' && clonedFunction(...args);
              }
            })
            .catch(function(response) {
              toastr.error('Nem lehet a tevékenységjogosultságot lekérdezni!');
              return response;
            });
        };
        scope[localFunction] = checkPermissionWarn;
      }

      function addingPermissionCheckToElement(element) {
        let actionElements = $(element).find('[action]:not("[verified]"), [action-state]:not("[verified]")');
        let elementControllers = {};
        if (!!actionElements.length) {
          actionElements.each(function() {
            var action = this.attributes?.action?.value;
            if (!!this.attributes['action-state']?.value) {
              let controller = $state.router.urlRouter._rules.find(
                x => x.state.name == this.attributes['action-state'].value
              )?.state?.options?.mvcController;
              if (!!controller) {
                action = controller;
              }
            }
            if (!action || action.includes('{{')) {
              return;
            }
            if (!elementControllers[action]) {
              elementControllers[action] = [];
            }
            elementControllers[action].push(this);
            let scope = angular.element(this).scope();
            var func = scope,
              funcList = $(this)
                .attr('ng-click')
                ?.trim()
                ?.replace(/(.+)\(.*\)/, '$1')
                ?.split('.'),
              lastFuncElement = funcList?.pop();
            funcList?.every(element => {
              if (!!func[element]) {
                func = func[element];
                return true;
              }
            });
            if (!!func && !!lastFuncElement) {
              service.executeActionWithPermission(func, lastFuncElement, action, true, this);
            }
            $(this).attr('verified', '1');
          });
          service.hideElementsForPermission(elementControllers);
        }
      }
      async function hideElementsForPermission(elements) {
        var actionType = service.parameters?.FWAPBU ?? 'FWAPBU_WARN';
        let controllers = [];
        let allController = Object.keys(elements);
        angular.forEach(allController, function(value) {
          if (!service.controllerPermissions[value] && !controllers.includes(value)) {
            controllers.push(value);
          }
        });
        const elementList = elements;
        var result;
        if (!!controllers.length) {
          var params = { contr: controllers };

          let pre = !controllers.some(x => x.includes('Dms/')) ? 'Auth/' : 'Dms/Document/';

          result = await $http
            .post(pre + 'GetUserPermissionForController', params)
            .then(function(response) {
              return response;
            })
            .catch(function(response) {
              return response;
            });
          angular.merge(service.controllerPermissions, result.data.resultList);
        }
        angular.forEach(allController, function(controller) {
          angular.forEach(elementList[controller], function(element) {
            if (!!$(element)?.attr('action-type')) {
              actionType =
                'FWAPBU_' +
                $(element)
                  .attr('action-type')
                  .toUpperCase();
            }
            if (
              actionType === 'FWAPBU_HIDE' &&
              !!service.controllerPermissions[controller]?.ResultStatus &&
              !service.controllerPermissions[controller]?.Value
            ) {
              $(element).remove();
            }
          });
        });
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.factory('LanguageService', [
    '$state',
    '$http',
    '$rootScope',
    'ConfigService',
    function($state, $http, $rootScope, ConfigService) {
      var supportedLangCodes = ['en-US', 'hu-HU'];
      var defaultLangCode = 'hu-HU';
      var defaultLang = 'hu';
      var service = {
        currentLang: getCurrentLang,
        currentLangCode: getCurrentLangCode,
        setLang: setLang,
        updateLang: updateLang,
        setStateBreadcrumbLabel: setStateBreadcrumbLabel,
        getDictionary: getDictionary,
        mLang: null,
        mLangCode: null,
        dictionary: {},
        cultureScripts: {},
        localeScripts: {},
      };

      ConfigService.getConfig().then(function(config) {
        supportedLangCodes = config.supportedLangCodes ?? supportedLangCodes;
        defaultLang = config.defaultLang ?? defaultLang;
        const defaultLangSimple = config.defaultLangCode ?? defaultLangCode;

        setLang(localStorage.getItem('SBLangCode') ?? defaultLangCode);
      });
      setLang(localStorage.getItem('SBLangCode') ?? defaultLangCode);
      return service;

      function getCurrentLang() {
        return service.mLang || defaultLang;
      }

      function getCurrentLangCode() {
        return service.mLangCode || defaultLangCode;
      }

      function setStateBreadcrumbLabel(langCode, authService) {
        var states = $state.get();
        if (authService?.stateBreadcrumbLabel) {
          states.forEach(element => {
            if (authService.stateBreadcrumbLabel[element.name]) {
              if (!element.ncyBreadcrumb) {
                element.ncyBreadcrumb = {};
              }
              element.ncyBreadcrumb.label = authService.stateBreadcrumbLabel[element.name];
            }
          });
        }
      }

      function setLang(langCode, callback) {
        if (!langCode || !supportedLangCodes.includes(langCode)) {
          langCode = defaultLangCode;
        }
        var lang = langCode.split('-')[0];
        bootbox.setDefaults({ locale: lang });
        moment.locale(lang);
        service.mLang = lang;
        service.mLangCode = langCode;
        if (service.dictionary[langCode]) {
          if (angular.isFunction(callback)) {
            callback();
          }
        } else {
          $http.get(`dist/language/${langCode}.txt`).then(function(res) {
            service.dictionary[langCode] = res.data;
            if (angular.isFunction(callback)) {
              callback();
            }
          });
        }
        changeCulture(langCode);
        changeAngularLocale(langCode);
      }

      function getDictionary() {
        return service.dictionary[getCurrentLangCode()];
      }
      function updateLang() {
        var lang = service.mLang || 'hu';
        var langCode = service.mLangCode || 'hu-HU';
        bootbox.setDefaults({ locale: lang });
        moment.locale(lang);

        changeCulture(langCode);
        changeAngularLocale(langCode);
      }

      function changeAngularLocale(langCode) {
        if (service.localeScripts[langCode]) {
          eval(service.localeScripts[langCode]);
        } else {
          $.getScript('dist/angular-locale/angular-locale_' + langCode.toString().toLowerCase() + '.js', function(
            script
          ) {
            service.localeScripts[langCode] = script;
          });
        }
      }

      function changeCulture(langCode) {
        if (service.cultureScripts[langCode]) {
          eval(service.cultureScripts[langCode]);
          setCulture(langCode);
        } else {
          $.getScript('dist/messages/kendo.messages.' + langCode + '.min.js', function(script) {
            service.cultureScripts[langCode] = script;
            setCulture(langCode);
          });
        }
      }

      function setCulture(langCode) {
        kendo.culture(langCode);

        if (langCode === 'hu-HU') {
          kendo.ui.MultiColumnComboBox.prototype.options.messages = $.extend(
            true,
            kendo.ui.MultiSelect.prototype.options.messages,
            {
              singleTag: 'kijelölve',
              clear: 'Törlés',
              deleteTag: 'Törlés',
              noData: 'Nincs találat!',
              downArrow: 'választás',
            }
          );
          kendo.ui.ColumnMenu.prototype.options.messages = $.extend(
            true,
            kendo.ui.ColumnMenu.prototype.options.messages,
            {
              apply: 'Alkalmaz',
              buttonTitle: '{0} oszlopbeállítások',
              cancel: 'Mégse',
              clear: 'Töröl',
              column: 'Oszlop',
              columnVisibility: 'Oszlop láthatóság',
              reset: 'Alaphelyzet',
              setColumnPosition: 'Oszlop pozició beállítása',
              stick: 'Hozzáad',
              unstick: 'Leválaszt',
            }
          );
        }
        var datePickerOptions = {
          format: kendo.culture().calendar.patterns.d,
        };

        var dateTimePickerOptions = {
          format: kendo.culture().calendar.patterns.d + ' ' + kendo.culture().calendar.patterns.t,
        };

        var timePickerOptions = {
          format: kendo.culture().calendar.patterns.t,
        };

        var kendoDP = $('[name*="_kendoDP_"]');
        kendoDP.each(function(index) {
          var dp = $(this).data('kendoDatePicker');
          if (dp) {
            dp.setOptions(datePickerOptions);
          }
        });

        var kendoDTP = $('[name*="_kendoDTP_"]');
        kendoDTP.each(function(index) {
          var dtp = $(this).data('kendoDateTimePicker');
          if (dtp) {
            dtp.setOptions(dateTimePickerOptions);
          }
        });

        var kendoTP = $('[name*="_kendoTP_"]');
        kendoTP.each(function(index) {
          var dtp = $(this).data('kendoTimePicker');
          if (dtp) {
            dtp.setOptions(timePickerOptions);
          }
        });

        var numericTB = $('[name*="_kendoNTB_"]');
        numericTB.each(function(index) {
          var ntb = $(this).data('kendoNumericTextBox');
          if (ntb) ntb.value(ntb.value());
        });

        var kendoGrid = $('div[kendo-grid]');
        kendoGrid.each(function(index) {
          var grid = $(this).data('kendoGrid');
          if (grid != null) grid.refresh();
        });
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

function GridService(authService, localStorageService, $state, $http) {
  const { Subject, of, Observable } = rxjs;
  const { filter, tap, debounceTime, switchMap, catchError, map, shareReplay } = rxjs.operators;

  const service = this;

  //#region Private fields
  var _statesToSaves$ = {};
  var _states$;
  function newStatesToSave(key, authService) {
    _statesToSaves$[key] = new Subject();
    var storageKey;
    _statesToSaves$[key]
      .pipe(
        filter(kendoGridRef => !!kendoGridRef),
        map(kendoGridRef => {
          storageKey = getLocalStorageKey(kendoGridRef.options.storageKey);

          return [
            storageKey,
            {
              filterMode: kendoGridRef.options.filterable && kendoGridRef.options.filterable.mode,
              Selected: service.getSelectedItems(kendoGridRef),
              Options: getGridConfigForPersistence(kendoGridRef),
            },
            kendoGridRef,
          ];
        }),
        tap(([storageKey, state, kendoGridRef]) => {
          if (!!kendoGridRef?.disableOptions?.GridStateSave || !!kendoGridRef?.options?.disableOptions?.GridStateSave) {
            return of(false);
          }
          localStorageService.set(storageKey, state);
        }),
        debounceTime(2000),
        switchMap(([storageKey, state, kendoGridRef]) => {
          if (!!kendoGridRef?.disableOptions?.GridStateSave || !!kendoGridRef?.options?.disableOptions?.GridStateSave) {
            return of(false);
          }
          return new Observable(subscriber => {
            $http
              .post('Grid/UploadGridState', {
                Key: storageKey,
                GridState: JSON.stringify(state),
              })
              .then(response => {
                subscriber.next(response);
                subscriber.complete();
              })
              .catch(err => {
                subscriber.error(err);
              });
          }).pipe(
            catchError(err => {
              console.error('A grid állapotok mentése sikertelenül zárult le!', err);
              return of(false);
            })
          );
        })
      )
      .subscribe();

    // if (!authService.parameters?.FWCOID) {
    //   _states$ = new Observable(subscriber => {
    //     $http
    //       .get('Grid/DownloadGridStates/')
    //       .then(response => {
    //         subscriber.next(response);
    //         subscriber.complete();
    //       })
    //       .catch(err => {
    //         subscriber.error(err);
    //       });
    //   }).pipe(
    //     catchError(err => {
    //       console.error('A GridÁllapotok letöltése sikertelen!', err);
    //       return of({ data: [] });
    //     }),
    //     map(response => {
    //       return response.data || [];
    //     }),
    //     tap(downloadedStates => {
    //       downloadedStates
    //         .filter(state => !!state)
    //         .forEach(state => {
    //           if (typeof state.GridState === 'string') {
    //             localStorageService.set(state.Key, JSON.parse(state.GridState));
    //           } else {
    //             localStorageService.set(state.Key, state.GridState);
    //           }
    //         });
    //     }),
    //   );
    // } else {
    //   _states$ = of({ data: [] });
    // }
  }

  const _baseKendoOptions = {
    autoBind: false,
    groupable: false,
    reorderable: true,
    resizable: true,
    selectable: true,
    columnMenu: true,
    filterable: false,
    excel: {
      allPages: true,
      filterable: true,
    },
    excelExport: function(e) {
      var sheet = e.workbook.sheets[0];
      sheet.rows
        .filter(x => x.type == 'footer')
        .forEach(x => {
          for (var i = 0; i < x.cells.length; i++) {
            x.cells[i].bold = true;
            x.cells[i].textAlign = 'right';
            x.cells[i].value = x.cells[i].value.replaceAll(/<[^>]+>/gi, '');
          }
        });
    },
    sortable: {
      mode: 'multiple',
      allowUnsort: true,
    },
    pageable: {
      refresh: true,
      pageSizes: [5, 10, 20, 50, 100],
      buttonCount: 5,
    },
    detailExpand: function(e) {
      if (!!e.masterRow) {
        e.sender.select(e.masterRow);
      }
    },
  };

  const _baseKendoDataSourceOptions = {
    //type: 'aspnetmvc-ajax',
    error: KendoDataSourceErrorFunc,
    requestEnd: function(e) {
      //ha üres lapon maradna grid frissítés után (nincs rekord az aktuális page-en) lapozzon vissza az 1-es oldalra
      if (!!e.response && e.response.Total != null) {
        const total = e.response.Total;
        const page = e.sender.page();
        const pageSize = e.sender.pageSize();
        const lastPage = Math.ceil(total / pageSize);
        if (total > 0 && lastPage < page) {
          e.sender.page(1);
        }
      }
    },
  };

  //#endregion

  //#region Private methods

  function getLocalStorageKey(storageKey) {
    return authService.user.id + '.' + 'GridState.' + $state.current.name + '.' + storageKey;
  }

  function setFieldAttributes(kendoGridConfig) {
    function determineFieldAttributes(gridOptions, fieldName) {
      if (fieldName) {
        switch (gridOptions.dataSource.schema['model']['fields'][fieldName]['type']) {
          case 'number':
            return { style: 'text-align:right;' };
          case 'string':
            break;
          case 'boolean':
            break;
        }
      }
    }

    angular.forEach(kendoGridConfig.columns, function(v) {
      var fieldName = v['field'];
      if (fieldName !== '' && fieldName !== 'checkAll') {
        v['attributes'] = determineFieldAttributes(kendoGridConfig, fieldName);
        if (v.color) {
          //  v.template = "<span style='background-color: #: data.Color#; display: block'>&nbsp</span>";
        }
      }
    });

    angular.forEach(kendoGridConfig.columns, function(v) {
      var fieldName = v['field'];
      if (fieldName && fieldName !== 'checkAll') {
        v['attributes'] = determineFieldAttributes(kendoGridConfig, fieldName);
        switch (kendoGridConfig.dataSource.schema['model']['fields'][fieldName]['type']) {
          case 'number':
            break;
          case 'string':
            if (
              !!kendoGridConfig.disableOptions?.AutoComplete ||
              !!kendoGridConfig.disableOptions?.options?.AutoComplete
            ) {
              v.filterable = {
                cell: {
                  suggestionOperator: 'contains',
                  operator: 'contains',
                  template: function(e) {
                    e.element.kendoAutoComplete({
                      serverFiltering: false,
                      valuePrimitive: true,
                      noDataTemplate: '',
                      change: function(e) {
                        console.log(this.value());
                      },
                    });
                  },
                },
              };
            } else {
              v.filterable = { cell: { suggestionOperator: 'contains', operator: 'contains' } };
            }

            break;
          case 'boolean':
            v.template =
              '<input type="checkbox" #= ' + v.field + ' ? "checked=checked" : "" # disabled="disabled"></input>';
            break;
          case 'color':
            kendoGridConfig.dataSource.schema['model']['fields'][v['field']]['type'] = 'string';
            break;
          case 'date':
            v.filterable = {
              cell: {
                template: function(args) {
                  var dateTimePattern = kendo.culture().calendar.patterns.d;

                  function escapeDateTimeSeparatorsForKMask(dtPat) {
                    return dtPat
                      .replace(/\./g, '\\.')
                      .replace(/\//g, '\\/')
                      .replace(/dd/g, '00')
                      .replace(/d/g, '00')
                      .replace(/MM/g, '00')
                      .replace(/M/g, '00')
                      .replace(/H/g, '00')
                      .replace(/h/g, '00')
                      .replace(/[t]/g, 'L')
                      .replace(/[ym]/g, '0')
                      .toString();
                  }

                  args.element.kendoDatePicker({});
                  args.element.kendoMaskedTextBox({
                    mask: escapeDateTimeSeparatorsForKMask(dateTimePattern),
                  });
                  args.element.removeClass('k-textbox');
                },
                showOperators: true,
              },
            };
            break;
          case 'datetime':
            //csak a format-ban tér el jelenleg a dátumtól
            //az esetleges későbbi fejlesztések miatt került külön ágra
            //beállítása az adoptt pageModel-len: SetGridColumnToDateTime(vm.pageModel.Grids,['Gridticket'],['CreateDateTime']);
            var dateTimePattern = kendo.culture().calendar.patterns.d + ' ' + kendo.culture().calendar.patterns.T;
            kendoGridConfig.dataSource.schema['model']['fields'][v['field']]['type'] = 'date';
            v.format = '{0:' + dateTimePattern + '}';
            v.filterable = {
              cell: {
                template: function(args) {
                  var dateTimePattern = kendo.culture().calendar.patterns.d;

                  function escapeDateTimeSeparatorsForKMask(dtPat) {
                    return dtPat
                      .replace(/\./g, '\\.')
                      .replace(/\//g, '\\/')
                      .replace(/dd/g, '00')
                      .replace(/d/g, '00')
                      .replace(/MM/g, '00')
                      .replace(/M/g, '00')
                      .replace(/H/g, '00')
                      .replace(/h/g, '00')
                      .replace(/[t]/g, 'L')
                      .replace(/[ym]/g, '0')
                      .toString();
                  }

                  args.element.kendoDatePicker({});
                  args.element.kendoMaskedTextBox({
                    mask: escapeDateTimeSeparatorsForKMask(dateTimePattern),
                  });
                  args.element.removeClass('k-textbox');
                },
                showOperators: true,
              },
            };
            break;
        }
      }
    });

    return kendoGridConfig;
  }

  function mergeColumns(originalColumns, savedColumnStates) {
    if (!savedColumnStates || savedColumnStates.length === 0) {
      return [...originalColumns];
    }

    const originalMap = new Map(originalColumns.map(col => [col.field, col]));

    const savedFields = new Set(savedColumnStates.map(s => s?.field));

    const mergedSavedColumns = savedColumnStates
      .filter(saved => saved && saved.field && saved.field !== 'checkAll' && originalMap.has(saved.field))
      .map(saved => ({ ...originalMap.get(saved.field), ...saved }));

    const missingOriginalColumns = originalColumns.filter(
      orig => orig.field !== 'checkAll' && !savedFields.has(orig.field)
    );

    const finalColumns = [];
    const checkAllColumn = originalMap.get('checkAll');

    if (checkAllColumn) {
      const savedCheckAll = savedColumnStates.find(s => s?.field === 'checkAll');
      finalColumns.push(savedCheckAll ? { ...checkAllColumn, ...savedCheckAll } : checkAllColumn);
    }

    return finalColumns.concat(mergedSavedColumns, missingOriginalColumns);
  }

  function colorFields(event, a, b, c) {
    var rows = event.sender.content.find('tr');

    var indexColor = event.sender.wrapper.find('.k-grid-header [data-field=' + 'Color' + ']').index();
    if (indexColor > 0) {
      rows.each(function(index, row) {
        var dataItem = event.sender.dataItem(row);
        var fieldColor = $(row).children('td:eq(' + indexColor + ')');
        if (dataItem && dataItem.Color !== null) {
          fieldColor.html(
            "<span style='background-color: #" + dataItem.Color.replace('#', '') + "; display: block'>&nbsp</span>"
          );
        }
        //fieldColor.css("background", "#"+dataItem.Color.replace("#", ""));
      });
    }

    var indexTextColor = event.sender.wrapper.find('.k-grid-header [data-field=' + 'TextColor' + ']').index();
    if (indexTextColor > 0) {
      rows.each(function(index, row) {
        var dataItem = event.sender.dataItem(row);
        var fieldColor = $(row).children('td:eq(' + indexTextColor + ')');
        if (dataItem.TextColor) {
          fieldColor.html(
            "<span style='background-color: #" + dataItem.TextColor.replace('#', '') + "; display: block'>&nbsp</span>"
          );
        }
      });
    }
  }

  function restoreSelection(kendoGrid, selection) {
    if (!!kendoGrid && !!selection && selection.length > 0) {
      const elementsToSelect = kendoGrid
        .items()
        .toArray()
        .map(function(element) {
          return $(element);
        })
        .filter(function($element) {
          const dataItem = kendoGrid.dataItem($element);
          const idColumn = kendoGrid.options.idColumn;
          const id = dataItem[idColumn];

          return selection.includes(id);
        });

      if (elementsToSelect.length > 0) {
        kendoGrid.select(
          $(elementsToSelect).map(function() {
            return this.toArray();
          })
        );
        kendoGrid.trigger('change', { event: 'GridStateRestore' });
      }
    }
  }

  function getGridConfigForPersistence(grid) {
    var currentFilter = grid.dataSource.filter();
    var options = {
      columns: grid.columns
        .filter(function(column) {
          return !!column.field && !!column.title;
        })
        .map(function(column, index) {
          return {
            field: column.field,
            width: typeof column.width === 'string' ? column.width : `${column.width}px`,
            hidden: column.hidden,
          };
        }),
      dataSource: {
        page: grid.dataSource.page(),
        pageSize: grid.dataSource.pageSize(),
        sort: grid.dataSource.sort(),
        filter:
          (grid?.options?.gridstates?.filter ?? true) === false
            ? undefined
            : currentFilter && typeof currentFilter === 'object' && Object.keys(currentFilter).length > 0
            ? currentFilter
            : undefined,
        group: grid.dataSource.group(),
      },
    };
    if (!!grid?.options?.textSize) {
      options['textSize'] = grid.options.textSize;
    }
    return options;
  }

  function customParameterMap(data, type) {
    const valueToString = function(value) {
      if (value instanceof Date) {
        return `'${value.toISOString()}'`;
      }
      return !!value || value === 0 || value === false ? `'${value}'` : undefined;
    };

    const getAllowedFields = function(columnCsv) {
      if (typeof columnCsv !== 'string' || columnCsv.length === 0) {
        return null;
      }

      const allowedFields = columnCsv
        .split(',')
        .map(field => field && field.trim())
        .filter(field => !!field);

      return allowedFields.length > 0 ? new Set(allowedFields) : null;
    };

    const sanitizeFilterExpression = function(expression, allowedFields) {
      if (!allowedFields || !expression || !expression.filters || expression.filters.length < 1) {
        return expression;
      }

      const filters = expression.filters
        .map(filter => {
          if (!filter) {
            return null;
          }

          if (filter.filters) {
            return sanitizeFilterExpression(filter, allowedFields);
          }

          return allowedFields.has(filter.field) ? filter : null;
        })
        .filter(filter => !!filter && (!filter.filters || filter.filters.length > 0));

      return filters.length > 0
        ? Object.assign({}, expression, {
            filters,
          })
        : undefined;
    };

    const sanitizeSort = function(sort, allowedFields) {
      if (!allowedFields || !Array.isArray(sort)) {
        return sort;
      }

      return sort.filter(currentSort => !!currentSort && allowedFields.has(currentSort.field));
    };

    const KendoFilterToString = function(filter) {
      filter.value = TryParseValueToDateObject(filter.value);

      if (typeof filter.value === 'boolean' && filter.value === false) {
        return `(${filter.field}~${filter.operator}~'false'~or~${filter.field}~${filter.operator}~${valueToString(
          filter.value
        )})`;
      } else if (angular.isDate(filter.value) && filter.operator == 'eq') {
        var startOfDay = moment(filter.value).format('YYYY-MM-DDT00:00:00');
        var endOfDay = moment(filter.value).format('YYYY-MM-DDT23:59:59');
        return `${filter.field}~gte~'${startOfDay}'~and~${filter.field}~lte~'${endOfDay}'`;
      } else if (angular.isDate(filter.value) && filter.operator == 'neq') {
        var startOfDay = moment(filter.value).format('YYYY-MM-DDT00:00:00');
        var endOfDay = moment(filter.value).format('YYYY-MM-DDT23:59:59');
        return `(${filter.field}~lt~'${startOfDay}'~or~${filter.field}~gt~'${endOfDay}')`;
      } else {
        return `${filter.field}~${filter.operator}~${valueToString(filter.value)}`;
      }
    };

    const TryParseValueToDateObject = function TryParseValueToDateObject(value) {
      if (!angular.isDate(value)) {
        var timeObject = moment.utc(value, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true);
        return timeObject.isValid() ? timeObject.toDate() : value;
      }
      return value;
    };

    const KendoFilterExpressionToString = function(expression) {
      if (!expression || !expression.filters || expression.filters.length < 1) {
        return '';
      }

      const filters = expression.filters.filter(filter => !!filter && (!!filter.operator || !!filter.filters));

      const filterStrings = filters
        .map(current => {
          let nextFilterString = '';
          if (current.filters) {
            nextFilterString = KendoFilterExpressionToString(current);
          } else {
            nextFilterString = KendoFilterToString(current);
          }
          return nextFilterString ? `(${nextFilterString})` : '';
        })
        .filter(filterString => !!filterString);

      return filterStrings.join(`~${expression.logic}~`);
    };

    const KendoSortToString = function(sort) {
      return (sort || []).map(sort => `${sort.field}-${sort.dir}`).join('~');
    };

    const allowedFields = getAllowedFields(data.columnCsv);
    data.filter = sanitizeFilterExpression(data.filter, allowedFields);
    data.sort = sanitizeSort(data.sort, allowedFields);
    data.filter = KendoFilterExpressionToString(data.filter);
    data.sort = KendoSortToString(data.sort);
    if (angular.isFunction(data.whereCondition)) {
      data.whereCondition = data.whereCondition();
    }
    if (type === 'non') {
      return data;
    } else {
      return kendo.stringify(data);
    }
  }

  /**
   * Function which sets up multiselection on a gridConfig
   * @param {*} gridConfig The grid configuration on which we setting up multiselection
   * @param {
   *  idField?: string,
   *  selectHandler?: function
   * } options The options for multiselection
   */
  function setupMultiSelect(gridConfig, options) {
    function defaultSelectHandler(grid, idField, selectHandler, currentId, value) {
      var selectedItems = _.filter(grid.dataSource.data(), function(d) {
        var dstring = d[idField].toString();
        return _.includes(grid.fw_selectedIds ? Object.keys(grid.fw_selectedIds) : [], dstring);
      });

      var temp = {};
      _.forEach(selectedItems, function(value, key) {
        temp[value[idField]] = value;
      });

      grid.selectedItems = _.assignIn(grid.selectedItems, temp);
      grid.resetGridSelection = resetGridSelection;

      //var allChecked = $(grid.thead).find('.fw-select-all-checkbox')[0].checked;
      setSelectedIds(grid);
      if (selectHandler) {
        selectHandler(currentId, value, grid);
      }
    }

    service.setSelectedIds = setSelectedIds;
    function setSelectedIds(grid) {
      var selectedIds = grid.fw_selectedIds ? Object.keys(grid.fw_selectedIds) : [];
      grid.selectedIds = selectedIds;

      let _total =
        grid.dataSource.options.serverPaging === false
          ? $(grid.tbody.find('.fw-select-checkbox')).length
          : grid.dataSource._total;

      $(transformIdForSelector('#selectedCount_' + gridConfig.id))[0].innerText = selectedIds.length + '/' + _total;
    }

    function resetGridSelection(grid) {
      grid.fw_selectedIds = {};
      grid.selectedItems = {};
      grid.selectedIds = [];
      applySelectionOnCheckbox(grid);
      if (selectAllHandler) {
        selectAllHandler(grid);
      }
    }

    function selectAll(grid) {
      grid.fw_selectedIds = {};
      grid.selectedItems = {};
      grid.selectedIds = [];

      //Ha frontendes a lapozás, akkor ott van minden adat, ne hívjon be újra a backendre...
      let _ds = angular.copy(grid.dataSource);
      if (_ds.options.serverPaging === false) {
        $(grid.tbody.find('.fw-select-checkbox').prop('checked', true)).each(function(i, t) {
          var v = grid.dataItem(
            $(t)
              .parent()
              .parent()
              .parent()
          );
          grid.selectedItems[v[idField]] = v; //grid.options.idColumn
          grid.selectedIds[v[idField]];
          grid.fw_selectedIds[v[idField]] = true;
        });
        applySelectionOnCheckbox(grid);
        if (selectAllHandler) {
          selectAllHandler(grid);
        }
      } else {
        _ds.read({ pageSize: 0 }).then(function() {
          var view = _ds.view();
          angular.forEach(view, function(v) {
            grid.selectedItems[v[idField]] = v; //grid.options.idColumn
            grid.selectedIds[v[idField]];
            grid.fw_selectedIds[v[idField]] = true;
          });
          applySelectionOnCheckbox(grid);
          if (selectAllHandler) {
            selectAllHandler(grid);
          }
        });
      }
    }

    function applySelectionOnCheckbox(grid) {
      var pageData = grid.dataSource._data;
      for (var i = 0; i < pageData.length; i++) {
        var row = grid.table.find("tr[data-uid='" + pageData[i].uid + "']");
        row.find('.fw-select-checkbox').prop('checked', grid.fw_selectedIds[pageData[i][idField]] === true);
        row.toggleClass('k-state-selected', grid.fw_selectedIds[pageData[i][idField]] === true);
      }
      setSelectedIds(grid);
    }

    const idField = options.idField || 'id';
    const selectHandler = options.selectHandler;
    const selectAllHandler = options.selectAllHandler;
    const checkBoxVisibilityStatementStr = options.checkBoxVisibilityStatementStr || 'true';

    gridConfig._disableCheckboxState = options.disableCheckbox === true;

    const checkboxColumn = {
      field: 'checkAll',
      title: 'Összes kijelölése',
      headerTemplate:
        '<div class="text-center"><input type="checkbox" disabled="{{options.disableCheckbox}}" class="fw-select-all-checkbox" title="{{vm.selectAllTip}}" /><div id="selectedCount_' +
        gridConfig.id +
        '">0/0</div></div>',
      template:
        '<div class="text-center" style="min-width:28px"><input ng-if="' +
        checkBoxVisibilityStatementStr +
        '" type="checkbox" disabled="{{options.disableCheckbox}}" class="fw-select-checkbox"/></div>',
      width: '60px',
      sortable: false,
      filterable: false,
      columnMenu: false,
    };

    gridConfig.columns.splice(0, 0, checkboxColumn);
    gridConfig.selectable = 'single, row';

    const superDataBoundFunction = gridConfig.dataBound;
    gridConfig.dataBound = function(e) {
      if (typeof superDataBoundFunction === 'function') {
        superDataBoundFunction.call(this, e);
      }

      const grid = this;
      const isDisabled = grid.options && grid.options._disableCheckboxState === true;
      grid.hasCheckBoxVisibilityStatement = !!options.checkBoxVisibilityStatementStr;
      let _total =
        grid.dataSource.options.serverPaging === false
          ? $(grid.tbody.find('.fw-select-checkbox')).length
          : grid.dataSource._total;
      //data-ba is bekerüljön az oszlop
      //gridConfig.dataSource.schema.model.fields['checkAll'] = {type: 'boolean', defaultValue: false};
      $("[data-field='checkAll']")
        .width('20px')
        .css('padding-bottom', '0px');
      $("[data-field='checkAll'] .k-column-title").width('100%');

      $(transformIdForSelector('#selectedCount_' + gridConfig.id))[0].innerText =
        (grid.fw_selectedIds ? Object.keys(grid.fw_selectedIds).length : 0) + '/' + _total;

      if (grid.fw_selectedIds === undefined) {
        grid.fw_selectedIds = {};
      }
      $(grid.thead)
        .find('.fw-select-all-checkbox')
        .prop('disabled', _total === 0 || isDisabled);

      $(this.tbody)
        .find('.fw-select-checkbox')
        .off('change')
        .prop('disabled', isDisabled)
        .bind('change', function(e) {
          var row = $(e.target).closest('tr');
          var rowId = grid.dataItem(row)[idField];

          row.toggleClass('k-state-selected', this.checked === true);
          if (grid.options.keepSelectionBackground) {
            row.toggleClass('k-state-multiselected', this.checked === true);
          }

          if (this.checked) {
            grid.fw_selectedIds[rowId] = true;
          } else {
            delete grid.fw_selectedIds[rowId];
            delete grid.selectedItems[rowId];
            grid.selectedIds = _.without(grid.selectedIds, rowId);
          }
          $(grid.thead)
            .find('.fw-select-all-checkbox')
            .prop('checked', Object.keys(grid.fw_selectedIds).length === _total);

          setSelectedIds(grid);
          defaultSelectHandler(grid, idField, selectHandler, rowId, this.checked);
        });

      $(this.thead)
        .find('.fw-select-all-checkbox')
        .off('change')
        .bind('change', function(e) {
          if (this.checked) {
            selectAll(grid);
          } else {
            resetGridSelection(grid);
          }
          e.preventDefault();
        });

      applySelectionOnCheckbox(grid);
    };

    service.setCheckboxState = function setCheckboxState(grid, state) {
      let chkBoxHead = $(grid.thead).find('.fw-select-all-checkbox');
      chkBoxHead.prop('disabled', state);
      if (state === true) chkBoxHead.prop('checked', false);

      let chkBoxBody = $(grid.tbody).find('.fw-select-checkbox');
      chkBoxBody.prop('disabled', state);
      if (state === true) chkBoxBody.prop('checked', false);

      if (!grid.options) {
        grid.options = {};
      }
      grid.options._disableCheckboxState = state === true;
      //service.resetCheckboxSelection(grid);
    };

    service.resetCheckboxSelection = function resetCheckboxSelection(grid) {
      grid.fw_selectedIds = {};
      grid.selectedItems = {};
      grid.selectedIds = [];
      //applySelectionOnCheckbox(grid);
    };

    return gridConfig;
  }

  service.setupMultiSelect = setupMultiSelect;
  /**
   * Builds the filterable config for a kendo grid
   * @param {boolean|'row'} filterMode
   */
  function buildFilterable(filterMode) {
    if (typeof filterMode !== 'boolean' && filterMode !== 'row') {
      throw new Error(`Value of filterMode is not valid! It must either be a boolean or 'row'!`, filterMode);
    }

    if (!filterMode) {
      return false;
    } else {
      return {
        mode: filterMode,
        operators: {
          string: {
            contains: kendo.ui.FilterMenu.prototype.options.operators.string.contains,
            startswith: kendo.ui.FilterMenu.prototype.options.operators.string.startswith,
            eq: kendo.ui.FilterMenu.prototype.options.operators.string.eq,
            neq: kendo.ui.FilterMenu.prototype.options.operators.string.neq,
            doesnotcontain: kendo.ui.FilterMenu.prototype.options.operators.string.doesnotcontain,
            endswith: kendo.ui.FilterMenu.prototype.options.operators.string.endswith,
            isnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnull,
            isnotnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnotnull,
            isempty: kendo.ui.FilterMenu.prototype.options.operators.string.isempty,
            isnotempty: kendo.ui.FilterMenu.prototype.options.operators.string.isnotempty,
          },
          number: {
            eq: kendo.ui.FilterMenu.prototype.options.operators.number.eq,
            neq: kendo.ui.FilterMenu.prototype.options.operators.number.neq,
            isnull: kendo.ui.FilterMenu.prototype.options.operators.number.isnull,
            isnotnull: kendo.ui.FilterMenu.prototype.options.operators.number.isnotnull,
            gte: kendo.ui.FilterMenu.prototype.options.operators.number.gte,
            gt: kendo.ui.FilterMenu.prototype.options.operators.number.gt,
            lte: kendo.ui.FilterMenu.prototype.options.operators.number.lte,
            lt: kendo.ui.FilterMenu.prototype.options.operators.number.lt,
          },
          date: {
            eq: kendo.ui.FilterMenu.prototype.options.operators.date.eq,
            neq: kendo.ui.FilterMenu.prototype.options.operators.date.neq,
            isnull: kendo.ui.FilterMenu.prototype.options.operators.date.isnull,
            isnotnull: kendo.ui.FilterMenu.prototype.options.operators.date.isnotnull,
            gte: kendo.ui.FilterMenu.prototype.options.operators.date.gte,
            gt: kendo.ui.FilterMenu.prototype.options.operators.date.gt,
            lte: kendo.ui.FilterMenu.prototype.options.operators.date.lte,
            lt: kendo.ui.FilterMenu.prototype.options.operators.date.lt,
          },
          enums: {
            eq: kendo.ui.FilterMenu.prototype.options.operators.enums.eq,
            neq: kendo.ui.FilterMenu.prototype.options.operators.enums.neq,
            isnull: kendo.ui.FilterMenu.prototype.options.operators.enums.isnull,
            isnotnull: kendo.ui.FilterMenu.prototype.options.operators.enums.isnotnull,
          },
        },
      };
    }
  }

  //#endregion

  //#region Public methods

  /**
   * @param {
   *  url: string,
   *  schema: object,
   *  errorHandler?: function,
   *  transportData?: object | function,
   *  data?: object,
   *  change?: function,
   *  filter?: object,
   *  sort?: object,
   *  group?: object,
   *  aggregate?: object,
   *  pageSize?: number,
   *  page?: number,
   *  serverAggregates?: boolean || false,
   *  serverFiltering?: boolean || true,
   *  serverGrouping?: boolean || false,
   *  serverPaging?: boolean || true,
   *  serverSorting?: boolean || true,
   * } options
   */
  service.buildKendoDataSource = function buildKendoDataSource(options) {
    if ((options.url == null || typeof options.url !== 'string') && options.data == null) {
      throw new Error('No url or data was given or url is in incorrect type!');
    }

    if (options.schema == null) {
      throw new Error('No schema was specified!');
    }

    if (options.change != null && typeof options.change !== 'function') {
      throw new Error('Type of change is not function!');
    }
    if (!!options.data && options.url != null) {
      throw new Error('You should either give a url or data, but not both!');
    }

    const errorHandler = typeof options.errorHandler == 'function' ? options.errorHandler : KendoDataSourceErrorFunc;

    return Object.assign({}, _baseKendoDataSourceOptions, {
      transport: !options.data
        ? {
            read: {
              url: options.url,
              contentType: 'application/json; charset=UTF-8',
              type: 'POST',
              data: options.transportData,
              cache: false, //IE miatt kell!!
            },
            parameterMap: customParameterMap,
          }
        : undefined,
      data: options.data,
      // We're falling back to undefined precisely,
      // so if someone specifies null we are deleting it in the finaly config
      change: options.change || undefined,
      filter: options.filter || undefined,
      sort: options.sort || undefined,
      group: options.group,
      aggregate: options.aggregate,
      error: errorHandler,
      pageSize: options.pageSize || 20,
      page: options.page || 1,
      schema: options.schema,
      serverAggregates: options.serverAggregates ?? false,
      serverFiltering: options.serverFiltering ?? true,
      serverGrouping: options.serverGrouping ?? false,
      serverPaging: options.serverPaging ?? true,
      serverSorting: options.serverSorting ?? true,
    });
  };

  /**
   * @param {
   *  gridId: string,
   *  dataSourceOptions: {
   *    url: string,
   *    schema: object,
   *    errorHandler?: function,
   *    transportData?: object | function,
   *    data?: object,
   *    change?: function,
   *    filter?: object,
   *    sort?: object,
   *    group?: object,
   *    aggregate?: object,
   *    pageSize?: number,
   *    page?: number,
   *  },
   *  columns: {*}[],
   *  filterMode?: boolean | 'row',
   *  autoBind?: boolean,
   *  toolbar?: object,
   *  editable?: boolean,
   *  groupable?: boolean,
   *  multiselect?: {
   *    idField?: string,
   *    selectHandler?: function
   *  },
   *  dataBound?: function,
   *  selectionChanged?: function,
   *  detailInit: function,
   *  additionalOptions?: object
   * } options
   */
  service.buildKendoConfig = function buildKendoConfig(options) {
    if (options.gridId == null || typeof options.gridId !== 'string') {
      throw new Error('No gridId was given or type of gridId is not string!');
    }

    if (options.dataSourceOptions == null || typeof options.dataSourceOptions !== 'object') {
      throw new Error('No dataSourceOptions was given or it is in the wrong type!');
    }

    if (options.columns == null || !(options.columns instanceof Array)) {
      throw new Error('No columns were given or it is not an instance of Array!');
    }

    const {
      gridId,
      dataSourceOptions,
      columns,
      filterMode,
      toolbar,
      editable,
      groupable,
      dataBound,
      selectionChanged,
      detailInit,
      additionalOptions,
      autoBind,
      disableOptions,
      storageKey,
    } = options;

    let kendoConfig = Object.assign({}, additionalOptions || {}, _baseKendoOptions, {
      id: gridId,
      storageKey: storageKey ?? additionalOptions?.descriptorName ?? gridId,
      editable: !!editable,
      groupable: !!groupable,
      autoBind: !!autoBind,
      disableOptions: disableOptions ?? {},

      columns: columns,
      filterable: buildFilterable(filterMode == null ? true : filterMode),
      toolbar,
      dataBound: function(event, a, b, c) {
        colorFields(event, a, b, c);
        typeof dataBound === 'function' && dataBound.call(this, event, a, b, c);
      },
      change: function(e) {
        typeof selectionChanged === 'function' && selectionChanged.call(this, e);
        service.saveKendoGrid(this);
      },
      detailInit:
        typeof detailInit === 'function'
          ? function(...args) {
              typeof detailInit === 'function' && detailInit.call(this, ...args);
            }
          : undefined,
      dataSource: service.buildKendoDataSource(dataSourceOptions),
    });

    if (!!options.multiselect) {
      kendoConfig = setupMultiSelect(kendoConfig, options.multiselect);
    }

    return setFieldAttributes(kendoConfig);
  };

  /**
   * @param {
   *  gridModel: object,
   *  dataSourceOptions?: {
   *    sort?: object,
   *  },
   *  transportData?: object | function,
   *  filterMode?: boolean | 'row',
   *  editable?: boolean,
   *  groupable?: boolean,
   *  group?: object,
   *  filter?: object
   *  aggregate?: object,
   *  multiselect?: {
   *    idField?: string,
   *    selectHandler?: function
   * },
   *  selectFunction?: function,
   *  dataBound?: function,
   *  detailInit?: function,
   *  autoBind?: boolean,
   * } options
   */
  service.buildKendoConfigForGridModel = function buildKendoConfigForGridModel(options) {
    const {
      gridModel,
      dataSourceOptions,
      transportData,
      filterMode,
      editable,
      groupable,
      group,
      filter,
      aggregate,
      multiselect,
      selectFunction,
      dataBound,
      detailInit,
      autoBind,
      toolbar,
      disableOptions,
    } = options;

    if (gridModel == null) {
      throw new Error('No gridModel was given!');
    }

    return service.buildKendoConfig({
      gridId: gridModel.Id,
      dataSourceOptions: {
        url: gridModel.ControllerMethod,
        schema: {
          data: function(result) {
            return result.Data;
          },
          total: 'Total',
          model: {
            Id: gridModel.Id,
            fields: JSON.parse(gridModel.Fields),
          },
        },
        // We're using an undefined as a fallback so we're not sending null
        // if null was setted as transportData
        transportData: transportData || undefined,
        sort: dataSourceOptions && dataSourceOptions.sort,
        group,
        filter,
        aggregate,
      },
      columns: gridModel.Columns,
      filterMode,
      editable: !!editable,
      groupable: !!groupable,
      multiselect,
      dataBound,
      selectionChanged: function(e) {
        const grid = e.sender;
        const selectedItem = grid.dataItem(this.select());
        typeof selectFunction === 'function' && selectFunction(selectedItem, e);
      },
      detailInit,
      autoBind: autoBind == null ? true : autoBind,
      toolbar: toolbar || undefined,
      additionalOptions: {
        descriptorName: gridModel.Name,
        parentGridId: gridModel.ParentGridId,
        idColumn: gridModel.IdColumn,
        gridstates: { all: true },
      },
      storageKey: gridModel.storageKey,
      disableOptions: disableOptions,
    });
  };

  /**
   * Restores the state of a grid given the kendo grid config for it
   */
  service.restoreState = function restoreState(config) {
    //Ne legyen gridState visszatöltés, ha le van titlva (jelenleg csak frontend, options generálás után!)
    if (!_states$) {
      _states$ = of({ data: [] });
    }

    if (!!config?.disableOptions?.GridStateRestore || !!config?.options?.disableOptions?.GridStateRestore) {
      return _states$.pipe(
        map(() => {
          const clonedConfig = _.cloneDeep(config);
          return clonedConfig;
        })
      );
    }
    return _states$.pipe(
      map(() => {
        const clonedConfig = _.cloneDeep(config);
        const savedState =
          ((config?.gridstates?.all ?? true) &&
            !config?.disableOptions?.GridStateRestore &&
            !config?.options?.disableOptions?.GridStateRestore) === false
            ? {}
            : localStorageService.get(getLocalStorageKey(config.storageKey)) || {};
        const savedColumns = savedState.Options && savedState.Options.columns;
        const savedDataSource = (savedState.Options && savedState.Options.dataSource) || {};

        clonedConfig.filterable =
          savedState.filterMode === false
            ? false
            : Object.assign(clonedConfig.filterable, { mode: savedState.filterMode || true });
        clonedConfig.columns = mergeColumns(clonedConfig.columns, savedColumns || []);
        if (!!savedState.Selected) {
          const superDataBound = clonedConfig.dataBound;
          clonedConfig.dataBound = function(...args) {
            const [event] = args;
            superDataBound.call(this, ...args);
            const savedState =
              localStorageService.get(getLocalStorageKey(event.sender.options.storageKey ?? event.sender.options.id)) ||
              {};
            restoreSelection(event.sender, savedState.Selected);
          };
        }
        if (!!savedState?.Options?.textSize) {
          clonedConfig.textSize = savedState.Options.textSize;
        }
        // We are giving value to this with an 'OR' so that if someone sets up a dataSourceOption initially, we aren't override it with the saved state
        // as that would probably be undesireable

        //Pontos hibát nem sikerült behatárolni, de ha új dataSource van létrehozva frontenden (JSON alapján),
        //nem működik a lapozás visszatöltése, nem írható felül, ha pl a dataSource.pageSize egy fv!
        if (
          !angular.isFunction(clonedConfig.dataSource.filter) &&
          (config?.gridstates?.filter ?? true) === true &&
          !config?.disableOptions?.FilterRestore &&
          !config?.options?.disableOptions?.FilterRestore
        ) {
          if (
            savedDataSource.filter &&
            typeof savedDataSource.filter === 'object' &&
            Object.keys(savedDataSource.filter).length > 0
          ) {
            clonedConfig.dataSource.filter = savedDataSource.filter;
          }
        }
        if (!angular.isFunction(clonedConfig.dataSource.sort)) {
          clonedConfig.dataSource.sort = savedDataSource.sort || clonedConfig.dataSource.sort;
        }
        if (!angular.isFunction(clonedConfig.dataSource.pageSize)) {
          clonedConfig.dataSource.pageSize = savedDataSource.pageSize || clonedConfig.dataSource.pageSize;
        }
        if (!angular.isFunction(clonedConfig.dataSource.page)) {
          clonedConfig.dataSource.page = savedDataSource.page || clonedConfig.dataSource.page;
        }

        return clonedConfig;
      })
    );
  };

  /**
   * Builds a correct kendoGrid configuration form the given parameters
   * @deprecated Use GridService.buildKendoConfigForGridModel instead
   * @param {*} gridModel The model of the grid, got from the server
   * @param {*} readUrl The url which the dataSource of the grid will read
   * @param {*} selectFunction The function to run, when the selection changes
   * @param {*} transportData The function which will be called on every request to get data to transport to the server or a simple object which will always be sent
   * @param {*} detailInit Function which will be called, when initializing the detail template
   */
  service.getGridOptions = function getGridOptions(gridModel, readUrl, selectFunction, transportData, detailInit) {
    gridModel = !!readUrl ? Object.assign({}, gridModel, { ControllerMethod: readUrl }) : gridModel;

    return service.buildKendoConfigForGridModel({
      gridModel,
      transportData,
      selectionChanged: selectFunction,
      detailInit,
    });
  };
  service.downloadGridStates = function() {
    return $http
      .get('Grid/DownloadGridStates/')
      .then(response => {
        if (response?.data) {
          response.data
            .filter(state => !!state)
            .forEach(state => {
              if (typeof state.GridState === 'string') {
                localStorageService.set(state.Key, JSON.parse(state.GridState));
              } else {
                localStorageService.set(state.Key, state.GridState);
              }
            });
        }
        return response?.data || [];
      })
      .catch(err => {
        console.error('A GridÁllapotok letöltése sikertelen!', err);
        return { data: [] };
      });
  };

  service.downloadGridState = function(kendoConfig, force = false) {
    const $kendoConfig = kendoConfig || {};
    const $force = force;
    if (!authService?.user?.id) {
      authService.getUserContext(false, callback);
    } else {
      callback();
    }
    function callback() {
      service.downloadGridStateFunc(kendoConfig, force);
    }
  };
  service.downloadGridStateFunc = function(kendoConfig, force = false) {
    if (!kendoConfig?.storageKey) {
      return [];
    }
    const storageKey = getLocalStorageKey(kendoConfig.storageKey);
    if (!force) {
      let local = localStorageService.get(storageKey);
      if (local) {
        return local;
      }
    }
    return $http
      .get('Grid/DownloadGridState/?key=' + storageKey)
      .then(response => {
        if (response?.data) {
          var state = response.data;
          var cleanState = state;
          if (state.GridState) {
            try {
              var parsedState = typeof state.GridState === 'string' ? JSON.parse(state.GridState) : state.GridState;
              if (parsedState.Options && parsedState.Options.dataSource) {
                var filter = parsedState.Options.dataSource.filter;
                if (!filter || (typeof filter === 'object' && Object.keys(filter).length === 0)) {
                  parsedState.Options.dataSource.filter = undefined;
                }
              }
              cleanState = { ...state, GridState: JSON.stringify(parsedState) };
            } catch (e) {
              console.warn('GridState tisztítása sikertelen:', e);
            }
          }
          if (typeof cleanState.GridState === 'string') {
            localStorageService.set(cleanState.Key, JSON.parse(cleanState.GridState));
          } else {
            localStorageService.set(cleanState.Key, cleanState.GridState);
          }
        }
        return response?.data || [];
      })
      .catch(err => {
        console.error('A GridÁllapotok letöltése sikertelen!', err);
        return { data: [] };
      });
  };
  service.saveKendoGrid = function(kendoGridRef) {
    if (!!kendoGridRef?.disableOptions?.GridStateSave || !!kendoGridRef?.options?.disableOptions?.GridStateSave) return;
    const storageKey = getLocalStorageKey(kendoGridRef.options.storageKey);
    if (!_statesToSaves$[storageKey]) {
      newStatesToSave(storageKey, authService);
    }
    _statesToSaves$[storageKey].next(kendoGridRef);
  };

  service.downloadGridDisplayRules = async function(kendoConfig, force = false) {
    const $kendoConfig = kendoConfig || {};
    const $force = force;
    const gridKey = $state.current.name + '.' + kendoConfig.descriptorName;
    return $http
      .get('Service/DownloadGridDisplayRules/?key=' + gridKey)
      .then(response => {
        return response?.data || [];
      })
      .catch(err => {
        console.error('A Grid megjelenítési szabályok letöltése sikertelen!', err);
        return { data: [] };
      });
  };

  service.getSelectedItems = function getSelectedItems(grid) {
    if (grid.selectable) {
      return grid
        .select()
        .toArray()
        .map(rowElement => $(rowElement))
        .map($row => grid.dataItem($row))
        .filter(data => !!data)
        .map(data => data[grid.options.idColumn]);
    } else {
      return [];
    }
  };

  service.loadGrid = function loadGrid(gridName) {
    service.getGridRef(gridName).then(function(gridRef) {
      gridRef.dataSource.read();
    });
  };

  service.getGridRef = function getGridRef(gridName) {
    return new Promise((resolve, reject) => {
      const kendoGrid = $(`#${gridName}`).data('kendoGrid');
      if (!kendoGrid) {
        setTimeout(function() {
          service.getGridRef(gridName).then(gridRef => resolve(gridRef));
        }, 100);
      } else {
        resolve(kendoGrid);
      }
    });
  };

  /**
   * Build tab models with grid containing grid configs
   * @param {[key:string]: any} tabs
   * @param {[key:string]: any} panels
   * @param {Array<string>} filteredPanelNames
   * @param {(gridDescriptor, tabModel, tabPanel) => buildKendoConfig function's config parameter} gridConfigMapper, function which will be called to get the correct kendoGrid config for the tab
   */
  service.buildTabModelsWithGrids = function buildTabModelsWithGrids(
    tabs,
    panels,
    gridDescriptors,
    filteredPanelNames,
    gridConfigMapper
  ) {
    tabs = Object.keys(tabs).map(function(name) {
      return tabs[name];
    });
    panels = Object.keys(panels).map(function(name) {
      return panels[name];
    });
    gridDescriptors = Object.keys(gridDescriptors).map(function(id) {
      return gridDescriptors[id];
    });

    // filter out the tabs if we need to
    if (!!filteredPanelNames && filteredPanelNames.length > 0) {
      tabs = tabs.filter(function(tab) {
        const tabsPanel = panels.find(function(panel) {
          return panel.ContainerTabId === tab.Name;
        });
        return !!tabsPanel && filteredPanelNames.includes(tabsPanel.Name);
      });
    }

    return tabs.reduce(function(builtTabs, tab) {
      const tabPanel = panels.find(function(panel) {
        return tab.Name === panel.ContainerTabId;
      });

      if (!tabPanel) {
        return builtTabs;
      }

      let tabGridDescriptor = gridDescriptors.find(function(descriptor) {
        return tabPanel.Name === descriptor.ContainerPanel;
      });

      if (!tabGridDescriptor) {
        return builtTabs;
      }

      tabGridDescriptor = Object.assign({}, tabGridDescriptor);
      let builderConfig = null;
      if (typeof gridConfigMapper === 'function') {
        builderConfig = gridConfigMapper(tabGridDescriptor, tab, tabPanel);
      }

      builderConfig = builderConfig || {
        gridModel: tabGridDescriptor,
      };
      builderConfig.gridModel.Id = `${tab.Name}.${tabPanel.Name}.${builderConfig.gridModel.Id}`;
      builderConfig.gridModel.storageKey = builderConfig.gridModel.storageKey || builderConfig.gridModel.Name;

      return [
        ...builtTabs,
        {
          name: tabPanel.ContainerTabId,
          title: tab.Title,
          active: false,
          disable: false,
          visible: false,
          gridId: builderConfig.gridModel.Id,
          gridName: builderConfig.gridModel.Name,
          storageKey: builderConfig.gridModel.storageKey,
          kendoConfig: service.buildKendoConfigForGridModel(Object.assign({ autoBind: true }, builderConfig)),
        },
      ];
    }, []);
  };

  /**
   * @deprecated Use gridService.buildTabModelsWithGrids instead
   */
  service.CreateGridContainerTabsWithGrids = function CreateGridContainerTabsWithGrids(
    tabs,
    panels,
    gridDescriptors,
    filteredPanelNames,
    gridConfigMapper
  ) {
    const sbTabs = service.buildTabModelsWithGrids(tabs, panels, gridDescriptors, filteredPanelNames, gridConfigMapper);

    return {
      tabs: sbTabs.map(function(sbTab) {
        return Object.assign(sbTab, { key: sbTab.name });
      }),
      gridOptions: sbTabs.reduce(function(options, sbTab) {
        options[sbTab.gridName] = sbTab.kendoConfig;
        return options;
      }, {}),
      grids: sbTabs.map(function(sbTab) {
        return sbTab.gridName;
      }),
    };
  };

  service.parseFilterString = function parseFilterString(filterString) {
    // Remove all of the ' characters from the string.
    filterString = filterString.replace(/[']/g, '');

    // Split the string into an array of strings, using the ~ as a delimiter.
    var ss = filterString.split('~'); // ss stands for "split string". I'm clever.

    var F = []; // Used to store all of the parsed filters.
    var fIndex = -1; // Used to track filter index.
    var cIndex = 0; // Used to track filter index within a composite filter object.
    var isComposite = false; // Used to indicate if a composite filter is currently being parsed.

    for (var i = 0; i < ss.length; i++) {
      if (i % 4 === 0) {
        // Field.
        if (!!ss[i].match(/^\s*\(/g)) {
          // If we're starting a composite object, create a composite object and add it to the parsed filters.
          F.push({
            filters: [],
            logic: '',
          });
          fIndex++; // We added an object to the array, so increment the counter.
          F[fIndex].filters.push({
            field: ss[i].replace(/^\s*\(/g, ''),
            operator: '',
            value: '',
          });
          cIndex = 0; // We added the first filter to the composite object, so set the counter.
          isComposite = true;
        } else if (isComposite) {
          // If we're parsing the second filter in a composite filter object, then add the field to the child filter.
          F[fIndex].filters.push({
            field: ss[i],
            operator: '',
            value: '',
          });
          cIndex++; // We added the second filter to the composite object, so increment the counter.
        } else {
          // Add the field as normal.
          F.push({
            field: ss[i],
            operator: '',
            value: '',
          });
          fIndex++; // We added an object to the array, so increment the counter.
        }
      }
      if (i % 4 === 1) {
        // Operator.
        if (isComposite) {
          F[fIndex].filters[cIndex].operator = ss[i];
        } else {
          F[fIndex].operator = ss[i];
        }
      }
      if (i % 4 === 2) {
        var tempValue = decodeURI(ss[i]).replace(/\)\s*$/g, '');
        if (isComposite) {
          F[fIndex].filters[cIndex].value = tempValue;
        } else {
          F[fIndex].value = tempValue;
        }
      }
      if (i % 4 === 3) {
        // Logic.
        if (isComposite) {
          F[fIndex].logic = ss[i]; // Add the logic to the composite filter object.
        }
        // If the filter is not composite, the logic will always be "and". So, we just don't do anything if that's the case.
      }
    }

    return {
      filters: F,
      logic: 'and',
    };
  };

  /**
   * Add aggregate fields to kendoGridOption
   * @param {*} gridOptions The builded model of the grid
   * @param {*} agregateType Type of aggregate mode: sum, min, max, count
   * @param {*} aggregateColumn
   * @param {*} groupBy (optional) If completed aggregate by column,
   * @param {*} footerTemplate value/function (optional) If not completed, show value by aggregateType
   */
  service.addAggregateToFooter = function addAggregateToColumn(
    gridOptions,
    agregateType,
    aggregateColumn,
    groupBy,
    footerTemplate
  ) {
    let column = gridOptions.columns.find(obj => {
      return obj.field === aggregateColumn;
    });

    //set dataSource
    if (!groupBy) {
      if (!!gridOptions.dataSource.aggregate) {
        gridOptions.dataSource.aggregate.push({ field: aggregateColumn, aggregate: agregateType });
      } else {
        Object.assign(gridOptions.dataSource, { aggregate: [{ field: aggregateColumn, aggregate: agregateType }] });
      }
    } else {
      if (!!gridOptions.dataSource.group && gridOptions.dataSource.group['field'] === groupBy) {
        gridOptions.dataSource.group.aggregates.push({ field: aggregateColumn, aggregate: agregateType });
      } else {
        Object.assign(gridOptions.dataSource, {
          group: { field: groupBy, aggregates: [{ field: aggregateColumn, aggregate: agregateType }] },
        });
      }
    }

    //set Columns
    let templateType = !groupBy ? 'footerTemplate' : 'groupFooterTemplate';
    column[templateType] = footerTemplate || '#=' + agregateType + '#';
  };

  service.setPrecision = function setPrecision(grid, fields, precision) {
    if (!angular.isArray(fields)) fields = new Array(fields);
    angular.forEach(
      grid.Columns.filter(x => fields.indexOf(x.field) != -1),
      function(value, key) {
        value.format = '{0:n' + precision + '}';
      }
    );
  };

  //#endregion
}

/**
 * Builds a correct kendoGrid configuration form the given parameters
 * @deprecated Use GridService.buildKendoConfigForGridModel instead
 * @param {*} gridModel The model of the grid, got from the server
 * @param {*} readUrl The url which the dataSource of the grid will read
 * @param {*} selectFunction The function to run, when the selection changes
 * @param {*} transportData The function which will be called on every request to get data to transport to the server or a simple object which will always be sent
 * @param {*} detailInit Function which will be called, when initializing the detail template
 */
function getGridOptions(gridModel, readUrl, selectFunction, transportData, detailInit) {
  const gridServiceInstance = angular
    .element('html')
    .injector()
    .get('gridService');

  return gridServiceInstance.buildKendoConfigForGridModel({
    gridModel: Object.assign({}, gridModel, { ControllerMethod: readUrl || gridModel.ControllerMethod }),
    selectFunction,
    transportData,
    detailInit,
  });
}

function transformIdForSelector(_id) {
  return _id.replaceAll('.', '\\.');
}

'use strict';

(function(module) {
  module.service('FileUploadService', [
    '$http',
    function($http) {
      this.postWithFile = function(url, postData) {
        return $http.post(url, postData, {
          transformRequest: function(data) {
            var formData = new FormData();

            angular.forEach(data, function(value, key) {
              if (angular.isArray(value)) {
                angular.forEach(value, function(arrayValue) {
                  formData.append(key, arrayValue);
                });
              } else formData.append(key, value);
            });

            return formData;
          },
          headers: { 'Content-Type': undefined },
        });
      };

      this.postWithFileWf = function(url, postData) {
        return $http.post(url, postData, {
          transformRequest: function(data) {
            var formData = objectToFormData(data);
            return formData;
          },
          headers: { 'Content-Type': undefined },
        });
      };

      // takes a {} object and returns a FormData object
      var objectToFormData = function(obj, form, namespace) {
        var fd = form || new FormData();
        var formKey;

        for (var property in obj) {
          if (obj.hasOwnProperty(property)) {
            if (namespace) {
              formKey = namespace + '[' + property + ']';
            } else {
              formKey = property;
            }

            // if the property is an object, but not a File,
            // use recursivity.
            if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
              objectToFormData(obj[property], fd, formKey);
            } else {
              // if it's a string or a File object
              fd.append(formKey, obj[property]);
            }
          }
        }
        return fd;
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('WalService', [
    '$http',
    '$window',
    'LanguageService',
    function($http, $window, LanguageService) {
      var lang = LanguageService.currentLang();
      this.NavigateToWal = function(controller, walFunctionName, viewTable) {
        // http keres az adott controllerbe
        $http
          .get(controller.toString() + '/' + walFunctionName.toString() + '/?tableName=' + viewTable.toString())
          .then(res => {
            let result = res.data;
            let url =
              result.WalUrl +
              '?' +
              'Install=' +
              result.Install +
              '&' +
              'Adopter=' +
              result.Adopter +
              '&' +
              'Group=' +
              result.Group +
              '&' +
              'Module=' +
              result.Module +
              '&' +
              'UserId=' +
              result.UserId +
              '&' +
              'TableViewName=' +
              result.TableViewName +
              '&' +
              'Language=' +
              lang;
            $window.open(url, '_blank');
          });
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('LockService', [
    '$state',
    '$http',
    '$uibModal',
    '$uibModalStack',
    '$location',
    'AuthService',
    function($state, $http, $uibModal, $uibModalStack, $location, authService) {
      const lockService = this;

      lockService.loadParameter = false;
      //#region Tag attributes
      lockService.setLockService = async function() {
        if (!!lockService.loadParameter) {
          return;
        }
        if (!authService?.parameters) {
          await authService.getUserContext(false, lockService.setParameters);
        } else {
          await lockService.setParameters();
        }
      };
      lockService.setParameters = function() {
        lockService.LOCKING_IS_OFF = authService.parameters?.LockOff == null ? true : authService.parameters.LockOff;
        lockService.SHOW_LOCK_MESSAGES_IN_MODALS =
          authService.parameters?.LockModal == null ? false : authService.parameters.LockModal;
        lockService.SILENT = authService.parameters?.LockSilent == null ? true : authService.parameters.LockSilent;
        if (!!authService?.parameters) {
          lockService.loadParameter = true;
        }
      };

      lockService.http = $http;
      lockService.modal = $uibModal;

      lockService.lastLockedUrl = '';
      lockService.setLockService();
      //#endregion

      this.shouldShowInitialiLockAndUnlockMessageInModals = function() {
        return lockService.SHOW_LOCK_MESSAGES_IN_MODALS;
      };

      this.shouldSilent = function() {
        return lockService.SILENT;
      };

      this.initiateLock = async function(programId, id, callback) {
        await lockService.setLockService();

        //console.log('Lock: initiateLock called');
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }

        lockService.lastLockedUrl = $location.absUrl();

        $(window).on('beforeunload', function() {
          //UnlockWhenLeavingPage
          lockService.http
            .post('FlgrSystem/UnlockWhenLeavingPage', {})
            .then(function(response) {
              //unregister leaving page event
              $(window).off('beforeunload', function() {
                // do nothing
              });
            })
            .catch(function(response) {
              // do nothing
            });
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Lock/LockOverlay.html',
          controller: 'LockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        return modalInstance.result.then(function(result) {
          if (angular.isFunction(callback)) callback(result);
        });
      };

      this.initiateUnlock = async function(programId, id, callback) {
        await lockService.setLockService();
        lockService.lastLockedUrl = '';
        //console.log('Lock: initiateUnlock called');
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }

        // unregister leaving page event
        $(window).off('beforeunload', function() {
          // do nothing
        });

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Lock/UnlockOverlay.html',
          controller: 'UnlockOverlayCtrl',
          controllerAs: 'vm',
          resolve: {
            lockParameters: {
              programId: programId,
              id: id,
            },
          },
          backdrop: 'static',
          keyboard: false,
        });

        return modalInstance.result
          .then(function() {
            return callback && callback();
          })
          .catch(function() {});
      };

      /**
       * Autolocking a Promise
       * Initiate a lock befaore calling the given function, then after the Promise returned by the given function ends
       * initiates the unlock
       *
       * @param programId The programId to lock and unlock
       * @param id The id to lock under the programId
       * @param func The function to call between the lock and unlock. It must return a Promise
       */
      this.autoLock = function(programId, id, func) {
        return lockService
          .initiateLock(programId, id)
          .then(func())
          .then(function() {
            return lockService.initiateUnlock(programId, id);
          });
      };

      this.isLockable = function(programId, id, successCallback, errorCallback) {
        //console.log('Lock: isLockable called');
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }

        if (id === 0 || id == null) {
          // Return lockable when creating new items
          var result = {
            ResultStatus: true,
            LockedBy: [],
          };
          setTimeout(() => successCallback(result), 1000);
          return;
        }

        lockService.http
          .post('FlgrSystem/IsLockable', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback(response.data.result);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.lock = function(programId, id, successCallback, errorCallback) {
        //console.log('Lock: lock called');
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        lockService.http
          .post('FlgrSystem/Lock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.unlock = function(programId, id, successCallback, errorCallback) {
        //console.log('Lock: unlock called');
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }

        if (id === 0 || id == null) {
          // do not lock / unlock when creating new items
          setTimeout(successCallback, 1000);
          return;
        }

        lockService.http
          .post('FlgrSystem/Unlock', { programId: programId, id: id })
          .then(function(response) {
            logLockLog(response);
            successCallback();
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback();
            return;
          });
      };

      this.closeAllModals = function() {
        // console.log('dismissing all modals...');
        $uibModalStack.dismissAll();
      };

      this.unlockWhenLeavingPage = async function(nextUrl) {
        await lockService.setLockService();
        if (lockService.lastLockedUrl == nextUrl) {
          //console.log(
          //            'Lock: unlockWhenLeavingPage called, but was rejected because it would run on the currently locked page.'
          //        );
          return;
        }
        lockService.lastLockedUrl = '';
        //console.log('Lock: unlockWhenLeavingPage called');
        lockService.closeAllModals();
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }
        lockService.http
          .post('FlgrSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            return;
          });
      };

      this.unlockAllInSessionWithCallback = async function(successCallback, errorCallback) {
        await lockService.setLockService();
        //console.log('Lock: unlockAllInSessionWithCallback called');
        lockService.lastLockedUrl = '';
        lockService.closeAllModals();
        if (lockService.LOCKING_IS_OFF || !lockService?.loadParameter) {
          return;
        }
        lockService.http
          .post('FlgrSystem/UnlockWhenLeavingPage')
          .then(function(response) {
            logLockLog(response);
            successCallback(response);
            return;
          })
          .catch(function(response) {
            logLockLog(response);
            errorCallback(response);
            return;
          });
      };

      function logLockLog(response) {
        if (response == null) return;
        if (response.data == null) return;
        if (response.data.LockLog == null) return;

        var lockLog = response.data.LockLog;
        //console.log(lockLog);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.service('DoclibcsService', [
    '$http',
    '$uibModal',
    'lodash',
    function($http, $uibModal, lodash) {
      this.isStringJson = isStringJson;

      this.getKendoDateTimeFormat = getKendoDateTimeFormat;
      this.getKendoDateFormat = getKendoDateFormat;
      this.setKendoDropDownListMultiLine = setKendoDropDownListMultiLine;

      this.getDefaultMultiColumnSettings = getDefaultMultiColumnSettings;
      this.setKendoDropDownListMultiColumnWidth = setKendoDropDownListMultiColumnWidth;
      this.getErrorsFromDatabaseString = getErrorsFromDatabaseString;
      this.getErrorsFromJsonString = getErrorsFromJsonString;
      this.processErrors = processErrors;
      this.getAdditionalOptions = getAdditionalOptions;

      this.openDynamicModalInstance = openDynamicModalInstance;
      this.openStartErrorModalInstance = openStartErrorModalInstance;
      this.openErrorModalInstance = openErrorModalInstance;
      this.openVegrehajtoFelhasznaloModalInstance = openVegrehajtoFelhasznaloModalInstance;
      this.openVegrehajtoSzerepkorModalInstance = openVegrehajtoSzerepkorModalInstance;
      this.openDocumentDynamicModalInstance = openDocumentDynamicModalInstance;
      this.openDynamicDocumentGridRowsModalInstance = openDynamicDocumentGridRowsModalInstance;

      this.filingDocumentFromDocumentTab = filingDocumentFromDocumentTab;

      this.sortGroupActivityFeladatpeldanyok = sortGroupActivityFeladatpeldanyok;
      this.checkGroupActivityFeladatpeldanyok = checkGroupActivityFeladatpeldanyok;
      this.checkGroupActivityFeladatpeldanyokVegrehajtoUser = checkGroupActivityFeladatpeldanyokVegrehajtoUser;
      this.openGroupActivityStartErrorModalInstance = openGroupActivityStartErrorModalInstance;
      this.openGroupActivityStartModalInstance = openGroupActivityStartModalInstance;
      this.openGroupActivityDocumentParametersInstance = openGroupActivityDocumentParametersInstance;
      this.getGroupActivityParams = getGroupActivityParams;
      this.CreateGroupActivityExcel = CreateGroupActivityExcel;
      this.AddRowToGroupActivityExcel = AddRowToGroupActivityExcel;
      this.getGroupActivityOptions = getGroupActivityOptions;
      this.getGroupActivityInfos = getGroupActivityInfos;

      function isStringJson(stringToTryParse) {
        try {
          JSON.parse(stringToTryParse);
        } catch (e) {
          return false;
        }
        return true;
      }

      function getKendoDateTimeFormat() {
        return {
          cell: {
            template: function(args) {
              args.element.kendoDateTimePicker({
                format: 'yyyy.MM.dd. HH:mm:ss',
                parseFormats: [
                  'yyyy.MM.dd. HH:mm:ss',
                  'yyyy.MM.dd HH:mm:ss',
                  'yyyyMMdd HH:mm:ss',
                  'yyyy-MM-dd HH:mm:ss',
                  'yyyy/MM/dd HH:mm:ss',
                  'yyyy.MM.dd. H:mm:ss',
                  'yyyy.MM.dd H:mm:ss',
                  'yyyyMMdd H:mm:ss',
                  'yyyy-MM-dd H:mm:ss',
                  'yyyy/MM/dd H:mm:ss',
                  'yyyy.MM.dd. HH:mm',
                  'yyyy.MM.dd HH:mm',
                  'yyyyMMdd HH:mm',
                  'yyyy-MM-dd HH:mm',
                  'yyyy/MM/dd HH:mm',
                  'yyyy.MM.dd. H:mm',
                  'yyyy.MM.dd H:mm',
                  'yyyyMMdd H:mm',
                  'yyyy-MM-dd H:mm',
                  'yyyy/MM/dd H:mm',
                  'yyyy.MM.dd.',
                  'yyyy.MM.dd',
                  'yyyyMMdd',
                  'yyyy-MM-dd',
                  'yyyy/MM/dd',
                ],
              });
            },
          },
          operators: {
            date: {
              gte: kendo.ui.FilterMenu.prototype.options.operators.date.gte,
              gt: kendo.ui.FilterMenu.prototype.options.operators.date.gt,
              eq: kendo.ui.FilterMenu.prototype.options.operators.date.eq,
              neq: kendo.ui.FilterMenu.prototype.options.operators.date.neq,
              lte: kendo.ui.FilterMenu.prototype.options.operators.date.lte,
              lt: kendo.ui.FilterMenu.prototype.options.operators.date.lt,
            },
          },
        };
      }

      function getKendoDateFormat() {
        return {
          cell: {
            template: function(args) {
              args.element.kendoDatePicker({
                format: 'yyyy.MM.dd.',
                parseFormats: ['yyyy.MM.dd.', 'yyyy.MM.dd', 'yyyyMMdd', 'yyyy-MM-dd', 'yyyy/MM/dd'],
              });
            },
          },
          operators: {
            date: {
              gte: kendo.ui.FilterMenu.prototype.options.operators.date.gte,
              gt: kendo.ui.FilterMenu.prototype.options.operators.date.gt,
              eq: kendo.ui.FilterMenu.prototype.options.operators.date.eq,
              neq: kendo.ui.FilterMenu.prototype.options.operators.date.neq,
              lte: kendo.ui.FilterMenu.prototype.options.operators.date.lte,
              lt: kendo.ui.FilterMenu.prototype.options.operators.date.lt,
            },
          },
        };
      }

      function getDefaultMultiColumnSettings() {
        return JSON.stringify({
          textField2: 'f_nev2',
          textFieldCaption: 'Megnevezés',
          textField2Caption: 'Megnevezés 2',
          textFieldWidthPercent: 50,
          textField2WidthPercent: 50,
        });
      }

      function setKendoDropDownListMultiColumnWidth(e, kendoDropDownListId) {
        // Set combobox dynamic width
        /*var comboStringLength = 20;
            angular.forEach(e.sender.dataSource._data, function (value, key) {
                if (comboStringLength < value.f_nev1.length) {
                    comboStringLength = value.f_nev1.length;
                }
            });*/

        var comboBox = $('#' + kendoDropDownListId).data('kendoDropDownList');
        //comboBox.list.width(comboStringLength * 12);
        comboBox.list.width(700);
      }

      function setKendoDropDownListMultiLine(selectedItem, kendoDropDownListId, textField2) {
        var comboBox = $('#' + kendoDropDownListId).data('kendoDropDownList');

        if (selectedItem[textField2]) {
          comboBox.wrapper.height(60);
          comboBox.wrapper[0].firstChild.style.height = '60px';
          comboBox.wrapper[0].firstChild.children[0].style.height = '60px';
        } else {
          comboBox.wrapper.height(30);
          comboBox.wrapper[0].firstChild.style.height = '30px';
          comboBox.wrapper[0].firstChild.children[0].style.height = '30px';
        }
      }

      function getErrorsFromDatabaseString(errorType, errorMessage) {
        var errors = [];
        var currentErrorType = '';
        var errorCaption = '';

        if (errorType == 'ERR') {
          currentErrorType = 'error';
          errorCaption = 'Hiba';
        } else {
          currentErrorType = 'warning';
          errorCaption = 'Figyelmeztetés';
        }

        var stringErrorMessage = errorMessage.toString();

        // Replace commas to special chars
        stringErrorMessage = stringErrorMessage.split('\\,').join('*_*');
        stringErrorMessage = stringErrorMessage.split('\\;').join('*-*');

        var errorMessageArray = [];
        if (stringErrorMessage.includes(',') || stringErrorMessage.includes(';')) {
          errorMessageArray = stringErrorMessage.split(/,|;/);
        } else {
          errorMessageArray[0] = stringErrorMessage;
        }

        for (var i = 0; i < errorMessageArray.length; i++) {
          if (!isEmptyOrSpaces(errorMessageArray[i])) {
            errorMessageArray[i] = errorMessageArray[i].split('*_*').join(',');
            errorMessageArray[i] = errorMessageArray[i].split('*-*').join(';');

            errors.push({
              type: currentErrorType,
              title: errorCaption,
              description: errorMessageArray[i],
            });
          }
        }

        return errors;
      }

      function getErrorsFromJsonString(errorMessage) {
        var parsedErrorMessage = JSON.parse(errorMessage);
        var errors = [];

        angular.forEach(parsedErrorMessage.SessionErrors, function(value, key) {
          errors.push({
            type: 'error',
            title: 'Hiba',
            description: value,
          });
        });

        angular.forEach(parsedErrorMessage.SessionWarnings, function(value, key) {
          errors.push({
            type: 'warning',
            title: 'Figyelmeztetés',
            description: value,
          });
        });

        angular.forEach(parsedErrorMessage.SessionInfos, function(value, key) {
          errors.push({
            type: 'info',
            title: 'Tájékoztatás',
            description: value,
          });
        });

        return errors;
      }

      function processErrors(result) {
        var errors = [];
        var errorType = '';
        if (result.data.Status == 0) {
          //végrehajtotta ha volt warning azt a result.data.Messages-ben visszaadja
          errors = lodash.map(result.data.Messages, function(m) {
            return {
              type: 'warning',
              title: 'Figyelmeztetés',
              description: m,
            };
          });
          errorType = 'WF_WARNINGS';
        } else if (result.data.Status != 20) {
          errors = lodash.map(result.data.Errors, function(e) {
            return {
              type: 'error',
              title: 'Hiba',
              description: e,
            };
          });

          // feltetel warning-ok
          lodash.forEach(result.data.FeltetelWarnings, function(w) {
            errors.push({
              type: 'warning',
              title: 'Figyelmeztetés',
              description: w,
            });
          });

          //ha kényszerített volt, akkor lehet warning is benne
          lodash.forEach(result.data.Messages, function(m) {
            errors.push({
              type: 'warning',
              title: 'Figyelmeztetés',
              description: m,
            });
          });
          errorType = 'WF_ERRORS';
        } else {
          //újraküldhető ág
          errors = lodash.map(result.data.Errors, function(e) {
            return {
              type: 'error',
              title: 'Hiba',
              description: e,
            };
          });

          lodash.forEach(result.data.FeltetelWarnings, function(w) {
            errors.push({
              type: 'warning',
              title: 'Figyelmeztetés',
              description: w,
            });
          });
          errorType = 'WF_TEV_FELT_WARNINGS';
        }

        // tájékoztató üzenetek
        lodash.forEach(result.data.Infos, function(m) {
          errors.push({
            type: 'info',
            title: 'Tájékoztatás',
            description: m,
          });
        });

        // feltétel tájékoztató üzenetek
        lodash.forEach(result.data.FeltetelInfos, function(m) {
          errors.push({
            type: 'info',
            title: 'Tájékoztatás',
            description: m,
          });
        });

        return { errors, errorType };
      }

      function getAdditionalOptions(
        dataModel,
        dynamicModalParams,
        workflowAdopterId,
        installAdopterId,
        adopterType,
        adopter,
        module
      ) {
        var vegrehajtoSzerepkorok = '';
        if (dynamicModalParams.vegrehajtoSzerepkorok !== undefined) {
          vegrehajtoSzerepkorok = dynamicModalParams.vegrehajtoSzerepkorok;
        }

        var vegrehajtoFelhasznalok = '';
        if (dynamicModalParams.vegrehajtoFelhasznalok !== undefined) {
          vegrehajtoFelhasznalok = dynamicModalParams.vegrehajtoFelhasznalok;
        }

        return {
          felPeldAzon: dataModel.f_felpeldid,
          folyPeldAzon: dataModel.f_folypeldid,
          statusAzon: dataModel.f_feldefsid,
          tevekenysegDefAzon: dynamicModalParams.tevekenysegAzon,
          isStart: false,
          ssrsParam: dynamicModalParams.SSRSParam,
          eloke: dynamicModalParams.Eloke,
          elokeParam: dynamicModalParams.ElokeParam,
          webParam: dynamicModalParams.WebParam,
          tevekenysegTip: dynamicModalParams.tevekenysegTip,
          tevekenysegURL: dynamicModalParams.tevekenysegURL,
          f_hosszfut: dynamicModalParams.HosszFut,
          f_hosszfutuz: dynamicModalParams.HosszFutUz,
          modalTitle: dynamicModalParams.tevekenysegNev + ' tevékenység végrehajtása',
          cancelTitle: 'Mégse',
          submitTitle: 'Rendben',
          adopter: adopter,
          workflowAdopterId: workflowAdopterId,
          installAdopterId: installAdopterId,
          adopterType: adopterType,
          uzletiAdopter: adopter,
          installId: dataModel.installId,
          felDefAzon: dataModel.f_feldefid,
          vegrehajtoSzerepkor: dataModel.f_vegszkorid,
          szerepkor: dataModel.f_szkorid,
          vegrehajtoSzerepkorok: vegrehajtoSzerepkorok,
          vegrehajtoFelhasznalok: vegrehajtoFelhasznalok,
          feldefStatusId: dataModel.f_feldefsid,
          module: module,
        };
      }

      function openDynamicModalInstance(
        tevekenysegAzonosito,
        felPeldAzon,
        folyPeldAzon,
        uzletiAdopter,
        additionalOptions,
        ownerid,
        tableid,
        isStart,
        noStatusCheck,
        groupActivityOptions,
        groupActivityInfos
      ) {
        var groupActivityCsoportosParameter = false;
        if (typeof groupActivityOptions !== 'undefined') {
          groupActivityCsoportosParameter = groupActivityOptions.groupActivityCsoportosParameter;
        }

        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/DynamicModal.html',
          controller: 'DynamicModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            options: RouteResolveFunc('Tasks/FeladTevekenysegParameterek', {
              tevekenysegAzonosito: tevekenysegAzonosito,
              felPeldAzon: felPeldAzon,
              folyPeldAzon: folyPeldAzon,
              uzletiAdopter: uzletiAdopter,
              isStart: isStart,
              noStatusCheck: noStatusCheck,
              tableid: tableid,
              ownerid: ownerid,
              groupActivityCsoportosParameter: groupActivityCsoportosParameter,
            }),
            additionalOptions: additionalOptions,
            groupActivityOptions: groupActivityOptions,
            groupActivityInfos: groupActivityInfos,
          },
          backdrop: 'static',
          keyboard: false,
        });
      }

      function openStartErrorModalInstance(processErrorsResult, result) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/StartErrorModal.html',
          controller: 'StartErrorModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: {
              errors: processErrorsResult.errors,
              errorType: processErrorsResult.errorType,
              isMessages: result.data.IsMessages,
              status: result.data.Status,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openGroupActivityStartErrorModalInstance(
        processErrorsResult,
        result,
        lastGroupActivity,
        groupActivityInfos
      ) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/GroupActivity/GroupActivityStartErrorModal.html',
          controller: 'GroupActivityStartErrorModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: {
              errors: processErrorsResult.errors,
              errorType: processErrorsResult.errorType,
              isMessages: result.data.IsMessages,
              status: result.data.Status,
              lastGroupActivity: lastGroupActivity,
              groupActivityInfos: groupActivityInfos,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openErrorModalInstance(errors) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/ErrorModal.html',
          controller: 'ErrorModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: {
              errors: errors,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openVegrehajtoFelhasznaloModalInstance(
        vegrehajtoSzerepkorok,
        tevekenysegAzonosito,
        uzletiAdopter,
        feladatPeldanyAzonosito,
        tevekenysegPeldanyId,
        groupActivityCsoportosVegrehajtoSzerepkor,
        groupActivityInfos
      ) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/StartVegrehajtoFelhasznaloModal.html',
          controller: 'StartVegrehajtoFelhasznaloModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc('Tasks/StartVegrehajtoFelhasznaloModalOptions', {
              vegrehajtoSzerepkorok: vegrehajtoSzerepkorok,
              tevekenysegAzonosito: tevekenysegAzonosito,
              uzletiAdopter: uzletiAdopter,
              feladatPeldanyAzonosito: feladatPeldanyAzonosito,
              tevekenysegPeldanyId: tevekenysegPeldanyId,
            }),
            groupActivityCsoportosVegrehajtoSzerepkor: groupActivityCsoportosVegrehajtoSzerepkor,
            groupActivityInfos: groupActivityInfos,
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openVegrehajtoSzerepkorModalInstance(
        tevekenysegAzonosito,
        uzletiAdopter,
        feladatPeldanyAzonosito,
        tevekenysegPeldanyId,
        groupActivityCsoportosVegrehajtoSzerepkor,
        groupActivityInfos
      ) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/StartVegrehajtoModal.html',
          controller: 'StartVegrehajtoModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc('Tasks/StartVegrehajtoModalOptions', {
              tevekenysegAzonosito: tevekenysegAzonosito,
              uzletiAdopter: uzletiAdopter,
              feladatPeldanyAzonosito: feladatPeldanyAzonosito,
              tevekenysegPeldanyId: tevekenysegPeldanyId,
            }),
            groupActivityCsoportosVegrehajtoSzerepkor: groupActivityCsoportosVegrehajtoSzerepkor,
            groupActivityInfos: groupActivityInfos,
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openDocumentDynamicModalInstance(
        modalTitle,
        cancelTitle,
        submitTitle,
        adopterType,
        uzletiAdopter,
        installId,
        tableId,
        ownerId,
        parameters,
        module
      ) {
        return $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentDynamicModal.html',
          controller: 'DocumentDynamicModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            additionalOptions: {
              modalTitle: modalTitle,
              cancelTitle: cancelTitle,
              submitTitle: submitTitle,
              adopterType: adopterType,
              uzletiAdopter: uzletiAdopter,
              installId: installId,
              tableId: tableId,
              ownerId: ownerId,
              parameters: parameters,
              module: module,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openDynamicDocumentGridRowsModalInstance(
        modalTitle,
        cancelTitle,
        submitTitle,
        adopterType,
        uzletiAdopter,
        installId,
        f_docsrcid,
        searchParameters
      ) {
        return $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentDynamicGridModal.html',
          controller: 'DocumentDynamicGridModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolvePostFunc('DocumentWF/GetDynamicDocumentGridRows', {
              f_docsrcid: f_docsrcid,
              searchParametersJson: JSON.stringify(searchParameters),
              uzletiAdopter: uzletiAdopter,
            }),
            additionalOptions: {
              modalTitle: modalTitle,
              cancelTitle: cancelTitle,
              submitTitle: submitTitle,
              adopterType: adopterType,
              uzletiAdopter: uzletiAdopter,
              installId: installId,
              f_docsrcid: f_docsrcid,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'xlg',
        });
      }

      function filingDocumentFromDocumentTab(
        linkedDoc,
        currentDocId,
        adopterType,
        uzletiAdopter,
        currentDossier,
        installId,
        moduleId,
        f_ownerid,
        f_tableid
      ) {
        $http
          .post('DocumentWF/CheckFilingDocument', {
            linkedDoc: linkedDoc,
            f_docid: currentDocId,
            f_docsrcid: linkedDoc.f_docsrcid,
            f_uzletiAdopter: uzletiAdopter,
            f_currentDossier: currentDossier,
            f_ownerid: f_ownerid,
            f_tableid: f_tableid,
          })
          .then(function(response) {
            if (response.data.Value.toLowerCase() == 'true') {
              toastr.error('A dokumentumot már iktatták.');
              return;
            }

            $http
              .post('DocumentWF/GetFilingDocumentFields', {
                f_doctype: linkedDoc.f_doctype,
                f_docid: currentDocId,
                f_docsrcid: linkedDoc.f_docsrcid,
                f_uzletiAdopter: uzletiAdopter,
                f_currentDossier: currentDossier,
                f_ownerid: f_ownerid,
                f_tableid: f_tableid,
              })
              .then(function(fieldRes) {
                var dynamicModalInstance = openDocumentDynamicModalInstance(
                  'Iktatás adatok',
                  'Mégse',
                  'Rendben',
                  adopterType,
                  uzletiAdopter,
                  installId,
                  fieldRes.data.parameters,
                  moduleId
                );

                dynamicModalInstance.result
                  .then(function(modalResult) {
                    $http
                      .post('DocumentWF/FilingDocument', {
                        linkedDoc: linkedDoc,
                        f_docid: currentDocId,
                        f_docsrcid: linkedDoc.f_docsrcid,
                        f_uzletiAdopter: uzletiAdopter,
                        f_currentDossier: currentDossier,
                        f_ownerid: f_ownerid,
                        f_tableid: f_tableid,
                        bejovoParameterek: modalResult.bejovoParameterek,
                      })
                      .then(function(filingRes) {
                        toastr.success('Sikeres iktatás');
                      })
                      .catch(function(error) {
                        console.error(error); // Note: this logs the js type error
                      });
                  })
                  .catch(function(res) {
                    if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
                      throw res;
                    }
                  });
              })
              .catch(function(error) {
                console.error(error); // Note: this logs the js type error
              });
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function isEmptyOrSpaces(str) {
        return str === null || str.match(/^ *$/) !== null;
      }

      function sortGroupActivityFeladatpeldanyok(sortList, selectedRows) {
        sortList.forEach(currentSort => {
          if (currentSort.dir == 'asc') {
            selectedRows.sort(dynamicSort(currentSort.field));
          } else {
            selectedRows.sort(dynamicSort('-' + currentSort.field));
          }
        });

        return selectedRows;
      }

      function checkGroupActivityFeladatpeldanyok(selectedRows) {
        var errorString = '';
        var feldefid;
        var feldefsid;
        var vegszkorid;
        selectedRows.forEach(currentRow => {
          if (typeof feldefid === 'undefined') {
            feldefid = currentRow.f_feldefid;
          } else {
            if (feldefid != currentRow.f_feldefid && errorString == '') {
              errorString = 'A kijelölt feladat példányok feladat definíciója nem egyezik meg!';
            }
          }

          if (typeof feldefsid === 'undefined') {
            feldefsid = currentRow.f_feldefsid;
          } else {
            if (feldefsid != currentRow.f_feldefsid && errorString == '') {
              errorString = 'A kijelölt feladat példányok státusza nem egyezik meg!';
            }
          }

          if (typeof vegszkorid === 'undefined') {
            vegszkorid = currentRow.f_vegszkorid;
          } else {
            if (vegszkorid != currentRow.f_vegszkorid && errorString == '') {
              errorString = 'A kijelölt feladat példányok végrehajtó szerepköre nem egyezik meg!';
            }
          }
        });

        return {
          errorString: errorString,
          feldefid: feldefid,
          feldefsid: feldefsid,
          vegszkorid: vegszkorid,
        };
      }

      function checkGroupActivityFeladatpeldanyokVegrehajtoUser(selectedRows, userid, helyettesitettUserids) {
        var errorString = '';

        selectedRows.forEach(currentRow => {
          var currentRowIsValid = false;

          if (currentRow.f_veguserid == userid) {
            currentRowIsValid = true;
          }

          helyettesitettUserids.forEach(helyettesitettUserid => {
            if (currentRow.f_veguserid == helyettesitettUserid.helyettesitettid) {
              currentRowIsValid = true;
            }
          });

          if (currentRowIsValid == false) {
            errorString =
              'A kijelölt feladat példányok végrehajtó felhasználója nem egyezik meg és nem helyettesíthető az aktuális felhasználóval!';
          }
        });

        return errorString;
      }

      function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === '-') {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function(a, b) {
          /* next line works with strings and numbers,
           * and you may want to customize it to your needs
           */
          var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }

      function getGroupActivityOptions(
        groupActivity,
        lastGroupActivity,
        groupActivityCsoportosParameter,
        groupActivityParameters
      ) {
        return {
          groupActivity: groupActivity,
          lastGroupActivity: lastGroupActivity,
          groupActivityCsoportosParameter: groupActivityCsoportosParameter,
          groupActivityParameters: groupActivityParameters,
        };
      }

      function getGroupActivityInfos(currentRow) {
        var resultObject = {
          f_folypeldid: currentRow.f_folypeldid,
          f_felpeldid: currentRow.f_felpeldid,
          f_bizlat: currentRow.f_bizlat,
          f_leiras: currentRow.f_leiras,
        };
        return resultObject;
      }

      function openGroupActivityStartModalInstance(felDefAzon, feldefStatusId, modalTitle) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/GroupActivity/GroupActivityStartModal.html',
          controller: 'GroupActivityStartModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc('Tasks/GroupActivityStartModalOptions', {
              felDefAzon: felDefAzon,
              feldefStatusId: feldefStatusId,
            }),
            additionalOptions: {
              modalTitle: modalTitle,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'md',
        });
      }

      function openGroupActivityDocumentParametersInstance(documentList, modalTitle) {
        return $uibModal.open({
          templateUrl: 'App/Workflow/Tasks/GroupActivity/GroupActivityDocumentParameters.html',
          controller: 'GroupActivityDocumentParametersCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc('Tasks/GroupActivityDocumentParametersOptions', {}),
            additionalOptions: {
              modalTitle: modalTitle,
              documentList: documentList,
            },
          },
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
        });
      }

      function getGroupActivityParams(result) {
        return {
          tevekenysegAzon: result.selectedTevekenyseg.TevekenysegAzonosito,
          tevekenysegNev: result.selectedTevekenyseg.TevekenysegNev,
          tevekenysegTip: result.selectedTevekenyseg.TevekenysegTipus,
          tevekenysegURL: result.selectedTevekenyseg.TevekenysegURL,
          Eloke: result.selectedTevekenyseg.Eloke,
          ElokeParam: result.selectedTevekenyseg.ElokeParam,
          SSRSParam: result.selectedTevekenyseg.SSRSParam,
          HosszFut: result.selectedTevekenyseg.HosszFut,
          HosszFutUz: result.selectedTevekenyseg.HosszFutUz,
          WebParam: result.selectedTevekenyseg.WebParam,
        };
      }

      function CreateGroupActivityExcel(data) {
        var byteArray = new Uint8Array(data.data.FileData.FileContents);

        var linkElement = document.createElement('a');
        try {
          var blob = new Blob([byteArray], { type: 'application/octet-stream' });
          var url = window.URL.createObjectURL(blob);

          linkElement.setAttribute('href', url);
          linkElement.setAttribute('download', data.data.FileName);

          var clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          linkElement.dispatchEvent(clickEvent);
        } catch (ex) {
          console.log(ex);
        }
      }

      function AddRowToGroupActivityExcel(currentRow, run_result, run_successful, groupActivityName) {
        var resultObject = {
          f_folypeldid: currentRow.f_folypeldid,
          f_felpeldid: currentRow.f_felpeldid,
          f_bizlat: currentRow.f_bizlat,
          f_leiras: currentRow.f_leiras,
          f_defnev: currentRow.f_defnev,
          groupActivityName: groupActivityName,
          run_result: run_result,
          run_successful: run_successful,
        };
        return resultObject;
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('HistoryService', [
    '$http',
    '$window',
    function($http, $window) {
      this.NavigateToHistory = function(tableIdParam, ownerIdParam, vm, $state, isNav, idColumnParam, prefix) {
        if (!prefix) {
          prefix = '';
        }

        if (!ownerIdParam || ownerIdParam === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }

        if (!idColumnParam) {
          const index = tableIdParam.indexOf('Flg');
          idColumnParam =
            index !== -1
              ? (tableIdParam.substring(index) + 'Id').replace('Flg', '')
              : (tableIdParam + 'Id').replace('Flg', '');
        }

        function navigateToHistoryPage(idColumnParam) {
          var currentState = $state.$current.self.name;
          var historyState = '';
          var statename = '';

          currentState = currentState.split('.');
          for (var i = 0; i < currentState.length - 1; i++) {
            historyState += currentState[i] + '.';
          }

          if (vm.hasOwnProperty('MDType')) {
            //törzsadat
            if (currentState[0].includes('Mrs')) {
              statename = historyState + 'HistoryNav';
              tableIdParam = tableIdParam.replace('mrs_', 'Mrs');
            } else {
              var currentModul = $state.$current.params.ModulType.config.value;
              statename = 'Masterdata.' + currentModul + 'HistoryNav';
            }
          } else {
            //nem törzsadat
            statename = historyState + 'HistoryNav';
          }

          $state.go(statename, {
            tableId: tableIdParam,
            idColumn: idColumnParam,
            ownerId: ownerIdParam,
            prefix: prefix,
          });
        }

        if (isNav) {
          navigateToHistoryPage(idColumnParam);
        } else {
          bootbox.dialog({
            message: 'A nem mentett adatok elvesznek. Biztos, hogy továbblép?', //vm.messages.HistoryConfimMessage,
            title: 'Megerősítés', //vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  navigateToHistoryPage(idColumnParam);
                },
              },
            },
          });
        }
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('HelpAndManualService', [
    '$rootScope',
    'AuthService',
    '$state',
    '$http',
    'lodash',
    '$stateParams',
    'LanguageService',
    function($rootScope, AuthService, $state, $http, lodash, $stateParams, languageService) {
      const self = this;

      self.setActiveHMPage = function(pageId) {
        if (pageId === '') {
          self.activeHMPage = undefined;
        } else {
          self.activeHMPage = pageId;
        }
      };

      self.getActiveHMPage = function() {
        return self.activeHMPage;
      };

      self.getActiveHMPageUrl = function(anchorId) {
        if ($state.current?.params?.documentEntity) {
          let link_core = $state.current.params.documentEntity.toLowerCase().replace(/[.]/g, '_');
          return (
            AuthService.parameters.HelpAndManualUrl +
            '/' +
            languageService.currentLangCode() +
            '/' +
            'index.html?' +
            link_core +
            '.html' +
            (!!anchorId ? '#' + anchorId : '')
          );
        } else {
          return AuthService.parameters.HelpAndManualUrl + '/' + languageService.currentLangCode() + '/' + 'index.html';
        }
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('FavouriteService', [
    '$rootScope',
    'localStorageService',
    'AuthService',
    '$state',
    '$http',
    'lodash',
    '$stateParams',
    function($rootScope, localStorageService, AuthService, $state, $http, lodash, $stateParams) {
      var self = this;
      self.add = add;
      self.remove = remove;
      self.isContainState = isContainState;
      self.goToFavourite = function(state) {
        $state.go(state.name, state.params, true);
      };
      self.updateOrder = updateOrder;
      var userid = AuthService.user.id;
      var prefix = 'flgr_favaourite_';
      var key = prefix + userid;

      $rootScope.$watch(
        function() {
          return AuthService.user.id;
        },
        function(newValue, oldValue) {
          if (!!AuthService.user.id) {
            $http.get('Favourite/GetFavourites').then(
              function(data) {
                key = prefix + AuthService.user.id;
                var stored = localStorageService.get(key);
                self.favourites = stored ? stored : [];
              },
              function(error) {
                // TODO
                console.error('GetFavourites() error');
              }
            );
          }
        }
      );

      //var menu = AuthService.getMenu();
      var state = $state.current.name;

      function add(state) {
        const lo = _.merge({}, $stateParams);
        $http.post('Favourite/AddFavourite', { state: state.name }).then(
          function(data) {
            state.params = lo;
            if (!self.isContainState(state)) {
              var menu = lodash.findLast(AuthService.menu, function(m) {
                return m.State === state.name;
              });
              var moduleId = '',
                menuId = '',
                parentMenuText = '',
                menuText = '';
              if (!!menu) {
                menuId = menu.Id;
                let parentMenu;
                if (menu.ParentId) {
                  parentMenu = lodash.findLast(AuthService.menu, function(m) {
                    return m.Id === menu.ParentId;
                  });
                  moduleId = menu.ParentId;
                }
                parentMenuText = parentMenu ? parentMenu.Text : '';
                menuText = menu.Text;
              } else {
                if (!!state.params['InvoiceTypeFilter']) {
                  if (state.params['InvoiceTypeFilter'] === 'INTRM') {
                    menuText = 'Bérleti díj számla';
                  } else if (state.params['InvoiceTypeFilter'] === 'INTCU') {
                    menuText = 'Vevő számla';
                  } else if (state.params['InvoiceTypeFilter'] === 'INTSU') {
                    menuText = 'Szállítói számla';
                  } else if (state.params['InvoiceTypeFilter'] === 'INTCO') {
                    menuText = 'Óvadék/Biztosítás';
                  } else if (state.params['InvoiceTypeFilter'] === 'INTCP') {
                    menuText = 'Bérbeszámítás';
                  } else if (state.params['InvoiceTypeFilter'] === 'INTCI') {
                    menuText = 'Elidegenítés';
                  } else {
                    menuText = state.params['InvoiceTypeFilter'] + ' számla';
                  }
                  parentMenuText = $state.$current.self.ncyBreadcrumbLabel;
                } else {
                  menuText = $state.$current.self.ncyBreadcrumbLabel;
                  parentMenuText = $state.$current.parent.self.ncyBreadcrumbLabel;
                }
              }
              var maxNumber = lodash.maxBy(self.favourites, function(f) {
                return f.Number;
              });
              //if (!!state.params['id']) state.params['id'] = 0;
              maxNumber = maxNumber ? maxNumber.Number : 0;
              self.favourites.push({
                FavouriteId: '',
                MenuId: menuId,
                ModuleId: moduleId,
                ModuleText: parentMenuText,
                MenuText: menuText,
                userid: userid,
                Number: maxNumber + 1,
                State: _.merge({}, state),
              });
              localStorageService.set(key, self.favourites);
            }
          },
          function(error) {
            // TODO
            console.error('AddFavourite() error');
          }
        );
      }

      function isContainState(state) {
        if (!AuthService.isLoggedIn) {
          return;
        }

        var minimalState = {
          name: state.name,
          params: JSON.parse(
            JSON.stringify(state.params || {}, function(key, value) {
              return key.indexOf('$$') === 0 ? undefined : value;
            })
          ),
        };
        var response = $.ajax({
          type: 'GET',
          url: 'Favourite/CheckIsFavourite',
          data: { state: JSON.stringify(minimalState) },
          async: false,
          cache: false, // IE miatt kell
        });

        //TODO jelenleg nincs FavouriteId, majd ha lesz, akkor át kell térni annak a használatára
        return (
          lodash.findIndex(self.favourites, function(f) {
            return f.State.name === state.name && f.State.params.InvoiceTypeFilter === $stateParams.InvoiceTypeFilter;
          }) >= 0
        );
      }

      function remove(state) {
        $http.post('Favourite/RemoveFavourite', { state: state }).then(
          function(data) {
            //TODO jelenleg nincs FavouriteId, majd ha lesz, akkor át kell térni annak a használatára
            lodash.remove(self.favourites, function(f) {
              return f.State.name === state.name && f.State.params.InvoiceTypeFilter === $stateParams.InvoiceTypeFilter;
            });
            localStorageService.set(key, self.favourites);
          },
          function(error) {
            // TODO
            console.error('RemoveFavourite() error');
          }
        );
      }

      function updateOrder(states) {
        $http.post('Favourite/UpdateOrder', { states: states }).then(
          function(data) {
            self.favourites = states;
            localStorageService.set(key, self.favourites);
          },
          function(error) {
            // TODO
            console.error('AddFavourite() error');
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('MessagesService', [
    'AuthService',
    '$http',
    '$rootScope',
    'lodash',
    function(AuthService, $http, $rootScope, lodash) {
      var self = this;
      self.unreadedCount = 0;
      self.messages = [];
      self.messagesRead = messagesRead;
      self.save = save;
      self.remove = remove;
      //self.init = refreshMessages;

      // $rootScope.$watch(
      //   function() {
      //     return AuthService.isLoggedIn;
      //   },
      //   function(newValue, oldValue) {
      //     if (AuthService.isLoggedIn) {
      //       refreshMessages();
      //     }
      //   }
      // );

      function save(message, navigateCallback) {
        $http.post('Service/SaveMessage', message).then(function(data) {
          if (message.MessageId) {
            //update
            var index = lodash.findIndex(self.messages, { MessageId: message.MessageId });
            if (index >= 0) {
              self.messages[index] = data;
            }
          } else {
            //az id-t a szerver tölti fel
            self.messages.unshift(data);
          }
          if (navigateCallback) {
            navigateCallback();
          }
        });
      }

      function remove(messageId, navigateCallback) {
        $http.delete('Service/RemoveMessage', { params: { messageId: messageId } }).then(function(isSuccessful) {
          if (isSuccessful) {
            lodash.remove(self.messages, function(m) {
              return m.MessageId === messageId;
            });
            if (navigateCallback) {
              navigateCallback();
            }
          }
        });
      }

      function refreshMessages() {
        $http.get('Service/ListMessages').then(function(data) {
          self.messages = data.messages;
          self.unreadedCount = lodash.filter(data.messages, { IsReaded: false }).length;
        });
      }

      function messagesRead() {
        self.unreadedCount = 0;
        $http.post('Service/MessageRead');
      }

      var messagesHub = $.connection.MessagesHub;
      messagesHub.client.NewMessage = function(opUnitIds, userId) {
        if (lodash.intersection(AuthService.user.opUnitList, opUnitIds) && userId !== AuthService.user.id) {
          refreshMessages();
        }
      };
      $.connection.hub.start();
    },
  ]);
})(angular.module('myApp'));

'use strict';
(function(module) {
  module.service('SendJsErrorService', [
    '$log',
    '$state',
    function($log, $state) {
      var self = this;
      self.SendJsErrorParameter = true;
      $.get('Auth/GetJavascriptErrorParameter')
        .then(function(response) {
          self.SendJsErrorParameter = response.HideJavascriptError;
        })
        .catch(function(error) {
          self.SendJsErrorParameter = true;
        });

      self.SendJsError = function(exception, cause) {
        if (self.SendJsErrorParameter === false) {
          $log.error(exception);
          console.error(cause);
          toastr.error(exception.message);
        } else {
          $log.error('Angular/Js error');
          toastr.error('Angular/Js error');
        }
        PostJavaScriptError(
          JSON.stringify(exception.stack),
          $state.current?.params?.module,
          $state.current?.views?.menu?.controller
        );
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('GMapsService', [
    '$http',
    '$timeout',
    '$q',
    function($http, $timeout, $q) {
      var self = this;
      self.addressConvert = addressConvert;
      self.getAddress = getAddress;
      self.getLanLng = getLanLng;
      self.getCurrentPosition = getCurrentPosition;
      self.getMarkerIcon = getMarkerIcon;
      self.setMapCenter = setMapCenter;
      self.zoomTo = zoomTo;

      var geocoder = null;

      var markerIcon = {
        //FontAwesome marker svg
        path:
          'M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z',
        scale: 0.5,
        strokeWeight: 0.2,
        strokeColor: 'red',
        strokeOpacity: 1,
        fillColor: 'red',
        fillOpacity: 0.7,
      };

      function getMarkerIcon(color) {
        var icon = angular.copy(markerIcon);
        if (color) {
          icon.strokeColor = color;
          icon.fillColor = color;
        }
        return icon;
      }

      function getLanLng(address) {
        var deferred = $q.defer();
        geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          { address: address },
          function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
                deferred.resolve(results[0].geometry.location);
              }
            }
            deferred.resolve(new google.maps.LatLng(0, 0));
          },
          function() {
            deferred.resolve(new google.maps.LatLng(0, 0));
          }
        );
        return deferred.promise;
      }

      function getAddress(position) {
        var deferred = $q.defer();
        geocoder = new google.maps.Geocoder();
        var latlng = { lat: position.lat(), lng: position.lng() };
        geocoder.geocode(
          { location: latlng },
          function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
                deferred.resolve(results[0].formatted_address);
              }
            }
            deferred.resolve(null);
          },
          function() {
            deferred.resolve(null);
          }
        );
        return deferred.promise;
      }

      function addressConvert(address) {
        //console.log(">>> addressConvert('", address, "') called");
        var deferred = $q.defer();
        geocoder = new google.maps.Geocoder();
        geocoder.geocode(
          { address: address },
          function(results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (status !== google.maps.GeocoderStatus.ZERO_RESULTS) {
                deferred.resolve(results[0].geometry.location);
              }
            }
            deferred.resolve(new google.maps.LatLng(0, 0));
          },
          function() {
            deferred.resolve(new google.maps.LatLng(0, 0));
          }
        );
        return deferred.promise;
      }

      function getCurrentPosition(callbackFn) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(callbackFn);
        } else {
          console.warning('GMapsService: Geolocation is not supported by this browser.');
        }
      }

      function setMapCenter(map, position) {
        map.setCenter(position);
        animateMapZoomTo(map, 12);
      }

      function zoomTo(map, position, level) {
        map.setCenter(position);
        animateMapZoomTo(map, level);
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('DasService', [
    '$state',
    'AuthService',
    '$window',
    function($state, authService, $window) {
      /**
       * @return {boolean}
       */
      this.NavigateToDas = function(messages, dasstate, tableid, ownerid) {
        var useDas = authService.getForrasParameterValue('fordas') === '1';
        var useDms = authService.getForrasParameterValue('fordms') === '1';

        if (!messages || !dasstate || dasstate === '') {
          toastr.warning('Hiányos paraméterezés!', messages.Warning);
          return false;
        }

        if (!useDas && !useDms) {
          toastr.warning('Ez a funkció nincs használatban!', messages.Warning);
          return false;
        }

        if (!tableid || tableid === '' || !ownerid || ownerid === '' || ownerid === 0 || ownerid === '0') {
          toastr.warning(messages.NotSelectedItem, messages.Warning);
          return false;
        }

        if (useDas) {
          let params = { tableId: tableid, ownerId: ownerid };
          var url = $state.href('ForrasDoclib.DocumentNav', params);
          $window.open(url, '_blank');
          return true;
        }

        if (useDms) {
          //$state.go('Document.DocumentNav', { dasTableId: tableid, dasOwnerId: ownerid, lockPreviousState: true });
          var url = $state.href('Document.DocumentNavOpen', {
            dasTableId: tableid,
            dasOwnerId: ownerid,
            lockPreviousState: true,
          });
          $window.open(url, '_blank');
          return true;
        }
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

(function(module) {
  module.service('UIHelperService', [
    function() {
      const { BehaviorSubject } = rxjs;

      this.sidebar$ = new BehaviorSubject(false);
      //this.isBurgerOn$ = new BehaviorSubject(false);

      //this.toggleBurgerStatus = function (state) {
      //    this.isBurgerOn$.next(state);
      //}

      this.previouspageUrl = 'default';
      this.activeSubMenuId = 'headerIsCollapsed';

      this.toggleSidebarStatus = function() {
        //this.sidebar = !this.sidebar;
        this.sidebar$.next(!this.sidebar$.value);
      };

      this.setDefaultSidebarStatus = function() {
        this.sidebar$.next(false);
      };

      this.panelGroupIsCollapsed = function(collapseHelper, panelGroupName) {
        return (
          !collapseHelper ||
          !collapseHelper.disabledPanels ||
          collapseHelper?.openedPanels?.indexOf(panelGroupName) === -1
        );
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  module.service('stateServiceForBudgetDetailGrid', [
    function() {
      var sharedData = {
        enabledGrid: 0,
      };

      return {
        getValue: function() {
          return sharedData.enabledGrid;
        },
        setValue: function(newValue) {
          sharedData.enabledGrid = newValue;
        },
        subscribe: function(scope, callback) {
          var handler = scope.$watch(
            function() {
              return sharedData.enabledGrid;
            },
            function(newValue, oldValue) {
              if (newValue !== oldValue) {
                callback(newValue);
              }
            }
          );

          scope.$on('$destroy', handler);
        },
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SbCardListEditModalCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    'params',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, params, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SbCardListEditModalCtrl', stateParams);
      }
      var vm = this;
      vm.saveInProgress = false;
      vm.closeWithData = function() {
        mi.close({ dto: vm.formModel, id: vm.id });
      };
      vm.mi = mi;
      vm.pageModel = _.cloneDeep(model?.pageModel ?? params?.pageModel);
      vm.btnSave = model?.btnSave ?? params?.btnSave;
      vm.title = model?.title ?? params?.title;
      vm.formModel = model?.dto ?? params?.dto ?? {};
      vm.panelName = model?.panelName ?? params?.panelName;
      vm.messages = model?.pageModel?.Messages ?? params?.pageModel?.Messages;
      vm.btn = model?.pageModel?.Actions ?? params?.pageModel?.Actions;
      vm.id = model?.id ?? params?.id;
      vm.subCard = model?.subCard ?? params?.subCard;
      vm.subCardModel = model?.subCardModel ?? params?.subCardModel;
      vm.preGenerateCallback = model?.preGenerateCallback ?? params?.preGenerateCallback;
      vm.afterGenerateCallback = model?.afterGenerateCallback ?? params?.afterGenerateCallback;
      vm.preSave = model?.preSave ?? params?.preSave;
      vm.state = model?.state ?? params?.state;

      if (!vm.title) {
        switch (vm.state) {
          case 'new':
            vm.title = vm.btn.btnNew.Title;
            break;
          case 'view':
            vm.title = vm.btn.btnView.Title;
            break;
          default:
            vm.title = vm.btn.btnEdit.Title;
        }
      }

      vm.minMax = function(scope, model) {
        Object.entries(vm.pageModel.Fields).forEach(x => {
          if (x[1]?.FormlyFieldDescriptor?.type == 'kendoNTB') {
            let opt = x[1].FormlyFieldDescriptor?.templateOptions?.options;
            if (opt?.max != null && Number(opt?.max) != NaN && opt.max < scope[model][x[0]]) {
              scope[model][x[0]] = opt.max;
            } else if (opt?.min != null && Number(opt?.min) != NaN && opt.min > scope[model][x[0]]) {
              scope[model][x[0]] = opt.min;
            }
          }
        });
      };

      if (vm.preGenerateCallback && {}.toString.call(vm.preGenerateCallback) === '[object Function]') {
        let preGen = vm.preGenerateCallback(vm.pageModel, vm.formModel, vm);
        if (preGen === false) {
          mi.opened.then(function() {
            mi.close(false);
          });
        }
      }
      var onBlur = {};
      Object.entries(vm.pageModel.Fields).forEach(value => {
        if (value[1].FormlyFieldDescriptor.type === 'kendoDDL' || value[1].FormlyFieldDescriptor.type === 'kendoCBMC') {
          value[1].FormlyFieldDescriptor.templateOptions.autoBind = false;
        }
        if (value[1]?.FormlyFieldDescriptor?.type == 'kendoNTB') {
          onBlur[value[0]] = function() {
            vm.minMax(vm, 'formModel');
          };
        }
        if (vm.state === 'view') {
          value[1].FormlyFieldDescriptor.templateOptions.disabled = true;
        }
      });
      InsertOnBlurFunctions(vm.pageModel, onBlur);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors[vm.panelName].FormlyDescriptor;

      if (vm.afterGenerateCallback && {}.toString.call(vm.afterGenerateCallback) === '[object Function]') {
        vm.afterGenerateCallback(vm.pageModel, vm.formModel, vm);
      }
      vm.save = async function() {
        vm.saveInProgress = true;
        if (vm.preSave && {}.toString.call(vm.preSave) === '[object Function]') {
          if (vm.preSaveRun) {
            return;
          }
          vm.preSaveRun = true;
          let result = await vm.preSave(vm);
          vm.preSaveRun = false;
          return;
        }

        vm.minMax(vm, 'formModel');
        for (const [key, value] of Object.entries(vm.formModel)) {
          let formDesc = vm.pageModel.Fields[key]?.FormlyFieldDescriptor;
          var text;
          if (formDesc?.type == 'kendoCBMC') {
            let data = $('#' + formDesc.id)
              ?.data('kendoMultiColumnComboBox')
              ?.dataSource?.data();
            let element = data?.find(x => x[formDesc?.templateOptions?.options?.dataValueField] == vm.formModel[key]);
            if (element) {
              text = element[formDesc?.templateOptions?.options?.dataTextField];
              vm.formModel[key + 'CLText'] = text ?? '';
            } else {
              vm.formModel[key + 'CLText'] = '';
            }
          }
          if (formDesc?.type == 'kendoDDL') {
            let data = $('#' + formDesc.id)
              ?.data('kendoDropDownList')
              ?.dataSource?.data();
            let element = data?.find(x => x[formDesc?.templateOptions?.options?.dataValueField] == vm.formModel[key]);
            if (element) {
              text = element[formDesc?.templateOptions?.options?.dataTextField];
              vm.formModel[key + 'CLText'] = text ?? '';
            } else {
              vm.formModel[key + 'CLText'] = '';
            }
          }
        }
        vm.closeWithData();
      };
      vm.cancel = function() {
        mi.close(false);
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';
(function(module) {
  module.service('InvoiceValuesCalculatorService', [
    'AuthService',
    function(AuthService) {
      const DEFFPR = AuthService.parameters.DEFFPR;

      var ctrl = this;
      var _model = null;
      var CURRND = 0;

      ctrl.setModel = function(model) {
        _model = model;
        if (!_model.Discount) _model.Discount = 0;
        if (!_model.DiscountPercent) _model.DiscountPercent = 0;
      };

      ctrl.getModel = function() {
        return _model;
      };

      ctrl.setCurrentRound = function(currnd) {
        CURRND = currnd;
      };

      ctrl.CalcFromBaseUnitPrice = function() {
        _model.LastCalcType = 'CalcFromBaseUnitPrice';
        //Nettó kedvezmények nélküli egységár (BaseUnitPrice) érkezik
        if (_model.CalcMode == 0) {
          //Kedvezményekkel csökkentett nettó érték:
          let net = (_model.BaseUnitPrice * _model.Quantity - _model.Discount) * ((100 - _model.DiscountPercent) / 100);
          //Nettó kerekítve
          _model.Net = roundTo(net, CURRND);
          //Nettó kerekítettből kiszámoljuk a kedvezményes egységárat
          _model.UnitPrice =
            !(1 * _model.Discount) && !(1 * _model.DiscountPercent)
              ? _model.BaseUnitPrice
              : roundTo(_model.Net / _model.Quantity, DEFFPR);

          //Nettó kerekítettből kiszámoljuk az áfa értéket:
          _model.VatAmount = roundTo(_model.Net * (_model.Vat / 100), CURRND);
          //Majd a bruttó végösszeget:
          _model.Gross = roundTo(_model.Net + _model.VatAmount, CURRND);

          //kedvezményekkel csökkentett bruttó egységár
          _model.GrossUnitPrice = roundTo(_model.Gross / _model.Quantity, DEFFPR);
          //Kedvezményekkel nélküli bruttó egységár:
          let baseGross =
            (_model.Gross + _model.Discount * ((100 + _model.Vat) / 100)) / (1 - _model.DiscountPercent / 100);
          _model.BaseGrossUnitPrice = roundTo(baseGross / _model.Quantity, DEFFPR);
        }
        //Bruttó kedvezmények nélküli egységár (BaseGrossUnitPrice) érkezik
        else if (_model.CalcMode == 1) {
          //bruttó érték
          let gross =
            (_model.BaseGrossUnitPrice * _model.Quantity - _model.Discount) * ((100 - _model.DiscountPercent) / 100);
          //Kiszámoljuk a kedvezménnyel csökkentett bruttó értéket:
          _model.Gross = roundTo(gross, CURRND);
          //Abból az áfa értéket:
          let vatAmount = (_model.Gross / (100 + _model.Vat)) * _model.Vat;
          _model.VatAmount = roundTo(vatAmount, CURRND);
          //Majd a nettó végösszeget:
          _model.Net = roundTo(_model.Gross - _model.VatAmount, CURRND);

          _model.UnitPrice = roundTo(_model.Net / _model.Quantity, DEFFPR);
          _model.GrossUnitPrice = roundTo(_model.Gross / _model.Quantity, DEFFPR);

          let baseNet =
            (_model.Net + _model.Discount / ((100 + _model.Vat) / 100)) / (1 - _model.DiscountPercent / 100);
          _model.BaseUnitPrice = roundTo(baseNet / _model.Quantity, DEFFPR);
        }
      };

      ctrl.CalcFromTotalAmount = function() {
        _model.LastCalcType = 'CalcFromTotalAmount';
        //Nettó végösszeg (Net) érkezik
        if (_model.CalcMode == 0) {
          //Nettót le kell kerekíteni:
          _model.Net = roundTo(_model.Net, CURRND);
          //Nettó kerekítettből kiszámoljuk a kedvezményes egységárat
          _model.UnitPrice = roundTo(_model.Net / _model.Quantity, DEFFPR);
          //Nettó kerekítettből kiszámoljuk a kedvezmény nélküli egységárat
          _model.BaseUnitPrice = roundTo(
            (_model.Net + _model.Discount) / (1 - _model.DiscountPercent / 100) / _model.Quantity,
            DEFFPR
          );

          //Nettó kerekítettből kiszámoljuk az áfa értéket:
          _model.VatAmount = roundTo(_model.Net * (_model.Vat / 100), CURRND);
          //Majd a bruttó végösszeget:
          _model.Gross = roundTo(_model.Net + _model.VatAmount, CURRND);
          //kedvezményekkel csökkentett bruttó egységár
          _model.GrossUnitPrice = roundTo(_model.Gross / _model.Quantity, DEFFPR);
          //Kedvezményekkel nélküli bruttó egységár:
          let baseGross =
            (_model.Gross + _model.Discount * ((100 + _model.Vat) / 100)) / (1 - _model.DiscountPercent / 100);
          _model.BaseGrossUnitPrice = roundTo(baseGross / _model.Quantity, DEFFPR);
        } //Bruttó végösszeg (Gross) érkezik
        else if (_model.CalcMode == 1) {
          //Bruttót le kell kerekíteni:
          _model.Gross = roundTo(_model.Gross, CURRND);
          //Bruttó kerekítettből kiszámoljuk a bruttó kedvezményes egységárat
          _model.GrossUnitPrice = roundTo(_model.Gross / _model.Quantity, DEFFPR);
          //Bruttó kerekítettből kiszámoljuk a kedvezmény nélküli egységárat
          _model.BaseGrossUnitPrice = roundTo(
            (_model.Gross + _model.Discount) / (1 - _model.DiscountPercent / 100) / _model.Quantity,
            DEFFPR
          );
          //Bruttó kerekítettből kiszámoljuk az áfa értéket:
          _model.VatAmount = roundTo((_model.Gross / (100 + _model.Vat)) * _model.Vat, CURRND);
          //Majd a nettó végösszeget:
          _model.Net = roundTo(_model.Gross - _model.VatAmount, CURRND);

          //Kedvezményekkel csökkentett Nettó egységár
          _model.UnitPrice = roundTo(_model.Net / _model.Quantity, DEFFPR);
          //Kedvezményekkel nélküli bruttó egységár:
          let baseNet =
            (_model.Net + _model.Discount / ((100 + _model.Vat) / 100)) / (1 - _model.DiscountPercent / 100);
          _model.BaseUnitPrice = roundTo(baseNet / _model.Quantity, DEFFPR);
        }
      };

      //--------------------------------------
      ctrl.ReCalc = function() {
        ctrl[_model.LastCalcType || 'CalcFromBaseUnitPrice']();
      };

      ctrl.ResetAmounts = function() {
        vm.formModel.BaseUnitPrice = 0;
        vm.formModel.BaseGrossUnitPrice = 0;

        vm.formModel.UnitPrice = 0;
        vm.formModel.GrossUnitPrice = 0;

        vm.formModel.Discount = 0;
        vm.formModel.DiscountPercent = 0;

        vm.formModel.Net = 0;
        vm.formModel.VatAmount = 0;
        vm.formModel.Gross = 0;
      };

      //--------------------------------------
      function roundTo(value, decimals) {
        const factor = Math.pow(10, decimals);
        return Math.round(value * factor) / factor;
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

function PyramidTreeViewComponent($http, $scope, $element) {
  var ctrl = this;

  ctrl._localData = null;

  ctrl.tree = undefined;
  ctrl.treeHeader = undefined;
  ctrl.treeOptions = undefined;

  ctrl.element = $element;

  ctrl.filterParams = undefined;

  ctrl.selectedNodeType;

  ctrl.panelName = 'PanelProperty';

  ctrl.$onInit = function $onInit() {
    ctrl.treeOptions = {
      dataSource: new kendo.data.HierarchicalDataSource({
        transport: {
          read: {
            url: 'Property/TreeSearch/',
            data: function(e) {
              return ctrl._filterParamsToHttpParams(ctrl.filterParams);
            },
          },
        },
        schema: {
          model: {
            id: 'id',
            fields: {
              id: { type: 'number' },
              text: { type: 'string' },
              parentId: { type: 'number' },
              hasChild: { type: 'boolean' },
            },
          },
        },
      }),
      expand: function(e) {
        //kinyitas event
        ctrl.selectedNodeType = e.sender.dataItem(e.node).nodeType;
      },
      select: function(e) {
        //ide akkor fut be, mikor konkrétan a node-ra van kattintva -> oldalsó infó kihozása
        e.preventDefault();
        let dataItem = ctrl.tree.dataItem(e.node);
        ctrl.selectedItemId = dataItem.id;
        ctrl.selectedItemType = dataItem.nodeType;

        $(e.sender.element)
          .find('div')
          .removeClass('SelectedTreeItem');
        $(e.node)
          .find('div .k-in div')
          .first()
          .addClass('SelectedTreeItem');

        if (ctrl.selectedItemType !== 'Objektum') {
          $(e.node)
            .parents('li')
            .each(function(index, val) {
              if (ctrl.tree.dataItem(val)?.nodeType == 'Objektum') {
                $(val)
                  .find('div .k-in div')
                  .first()
                  .addClass('SelectedTreeItem');
                return;
              }
            });
        }

        ctrl._getProperty(dataItem.id).then(function(response) {
          let selectedProperty = response.data.propertyDto;

          if (['PPRRU', 'PPROB'].indexOf(response.data.level) == -1) {
            selectedProperty.Level = response.data.level;
          }
          selectedProperty.pageModel = response.data.propertyPageModel;

          ctrl.selectedChanged({
            selectedProperty,
          });
        });
      },
    };
  };

  ctrl.$onChanges = function $onChanges(changes) {
    if (changes.filterParams && ctrl.tree) {
      ctrl.tree.dataSource.read();
    }
  };

  ctrl.$postLink = function $postLink() {
    ctrl.tree = $('#pyramid-tree').data('kendoTreeView');

    // Initial read to show the first search results
    ctrl.tree.dataSource.read();
  };

  ctrl._getFromCache = function _getFromCache(id) {
    if (!id) {
      return ctrl._localData;
    } else {
      for (var i = 0; i < ctrl._localData.length; i++) {
        if (ctrl._localData[i].id === id) {
          return ctrl._localData[i].items;
        } else if (ctrl._localData[i].items) {
          return get(ctrl._localData[i].items, id);
        }
      }
    }
  };

  ctrl._addressIsNotEmpty = function _addressIsNotEmpty(filterParams) {
    return (
      !!filterParams.PostCode &&
      !!filterParams.PostCode.Value &&
      !!filterParams.Locality &&
      !!filterParams.Locality.Value &&
      !!filterParams.Street &&
      !!filterParams.StreetChar
    );
  };

  ctrl._filterParamsToHttpParams = function _filterParamsToHttpParams(filterParams) {
    return {
      zoneId: ctrl.filterParams && ctrl.filterParams.ZoneId,
      opUnit: ctrl.filterParams && ctrl.filterParams.OpUnitId,
      topogrNumber: ctrl.filterParams && ctrl.filterParams.TopogrNumber,
      tenement: ctrl.filterParams && ctrl.filterParams.Tenement && ctrl.filterParams.Tenement.Value,
      filterField: ctrl.filterParams && ctrl.filterParams.FilterField,
      nodeType: ctrl.selectedNodeType,
    };
  };

  ctrl._getProperty = function _getProperty(id) {
    var nodeType = ctrl.selectedItemType;
    return $http.get('Property/PropertyFieldsLoader/', { params: { id, nodeType } }).then(function(response) {
      response.data.propertyDto.LevelName = response.data.propertyDto.Level;
      return response;
    });
  };
}

var pyramidTreeViewComponentOptions = {
  bindings: {
    filterParams: '<',
    selectedChanged: '&',
  },
  controller: PyramidTreeViewComponent,
  templateUrl: 'App/Property/pyramid/pyramid-tree-view/pyramid-tree-view.component.html',
};

var pyramidTreeViewComponentTag = 'sbPyramidTreeView';

'use strict';

function PropertyShortDetailsFormComponent($element) {
  var ctrl = this,
    element = $element;

  ctrl.property = undefined;
  ctrl.propertyPageModel = undefined;
  ctrl.propertyFormFields = undefined;

  //gmap init
  ctrl.gmaps = {};
  ctrl.gmaps.controllerUrl = 'Property/Map';
  ctrl.gmaps.clearRefresh = true;
  ctrl.gmaps.controllerParameter = function() {
    return {
      propertyId: ctrl.property.PropertyId,
    };
  };
  ctrl.gmaps.onClickMarker = function(data) {};
  ctrl.$onChanges = function $onChanges(changes) {
    if (!!ctrl.property && !!ctrl.propertyPageModel) {
      ctrl.property.pageModel = undefined;

      let formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(ctrl.propertyPageModel);
      ctrl.propertyFormFields = formlyFormPanelDescriptors.PanelProperty.FormlyDescriptor;
      if (!!ctrl.gmaps?.refreshPoints && {}.toString.call(ctrl.gmaps.refreshPoints) === '[object Function]') {
        return ctrl.gmaps.refreshPoints();
      }
    }
  };
}

var propertyShortDetailsFormTag = 'sbPropertyShortDetailsForm';

var propertyShortDetailsFormOptions = {
  bindings: {
    property: '<',
    propertyPageModel: '<',
    titles: '<',
    panelType: '<',
  },
  templateUrl: 'App/Property/pyramid/property-short-details-form/property-short-details-form.component.html',
  controller: PropertyShortDetailsFormComponent,
};

'use strict';

function PyramidTableViewComponent(gridService, $state) {
  var ctrl = this;
  ctrl._filterParams = undefined;
  Object.defineProperty(ctrl, 'filterParams', {
    get: function() {
      return ctrl._filterParams.dto;
    },
    set: function(value) {
      ctrl._filterParams = {
        dto: value,
      };
    },
  });

  ctrl.gridModel = undefined;
  ctrl.propGrid = undefined;
  ctrl.propGridOptions = undefined;

  ctrl.premiseGridModel = undefined;

  ctrl.$onInit = function $onInit() {
    ctrl.prevState = $state.previous.name;
    ctrl.propGridOptions = gridService.buildKendoConfigForGridModel({
      gridModel: Object.assign(_.cloneDeep(ctrl.gridModel), { ControllerMethod: 'Property/PropertyList/' }),
      transportData: function() {
        return ctrl._filterParams;
      },
      dataBound: function(e) {
        var rows = e.sender.tbody.children();
        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.Level == 'PPROB') {
            row.find('td.k-hierarchy-cell .k-icon').removeClass();
          }
        }
      },
      selectFunction: function onGridSelectChanged(rowData, e) {
        ctrl.selectedChanged({ selectedProperty: rowData });
        e.event == 'GridStateRestore' && e.sender.expandRow(e.sender.select());
      },
      filterMode: true,
      filter: {
        logic: 'and',
        filters: [{ field: 'EndingDate', operator: 'isnull' }],
      },
    });
  };

  ctrl.$onChanges = function $onChanges(changes) {
    if (changes.filterParams && !!ctrl.propGrid) {
      if (ctrl.filterParams && !!changes.filterParams.previousValue) {
        ctrl.propGrid.dataSource.page(1);
      }
    }
  };
}

var pyramidTableViewTag = 'sbPyramidTableView';

var pyramidTableViewOptions = {
  bindings: {
    filterParams: '<',
    gridModel: '<',
    premiseGridModel: '<',
    selectedChanged: '&',
    pageModel: '<',
  },
  templateUrl: 'App/Property/pyramid/pyramid-table-view/pyramid-table-view.component.html',
  controller: PyramidTableViewComponent,
};

'use strict';

function premiseTableViewComponent(gridService, $state, $scope, LanguageService) {
  var ctrl = this;
  ctrl.premiseGrid = undefined;
  ctrl.premiseGridOptions = undefined;
  ctrl.premiseGridModel = undefined;
  ctrl.labels = LanguageService.getDictionary().property;
  ctrl.tmFilterState = false;
  ctrl.$onInit = function $onInit() {
    ctrl.prevState = $state.previous.name;
    ctrl.premiseGridOptions = gridService.buildKendoConfigForGridModel({
      gridModel: Object.assign(_.cloneDeep(ctrl.premiseGridModel), {
        ControllerMethod: 'Property/PyramidPremiseList/',
      }),
      transportData: function() {
        return { dto: ctrl.filterParams, filterTM: ctrl.tmFilterState === false };
      },
      dataBound: function(e) {
        var rows = e.sender.tbody.children();
        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.Level == 'PPROB') {
            row.find('td.k-hierarchy-cell .k-icon').removeClass();
          }
        }
      },
      selectFunction: function onGridSelectChanged(rowData, e) {
        ctrl.selectedChanged({ selectedProperty: rowData });
        e.event == 'GridStateRestore' && e.sender.expandRow(e.sender.select());
      },
    });

    ctrl.tmFilterStateChange = function() {
      ctrl.premiseGrid.dataSource.read();
    };

    ctrl.tmFilterStateClick = function() {
      ctrl.tmFilterState = !ctrl.tmFilterState;
      ctrl.premiseGrid.dataSource.read();
    };
  };

  //ctrl.$onChanges = function $onChanges(changes) {};
}

var premiseTableViewTag = 'sbPremiseTableView';

var premiseTableViewOptions = {
  bindings: {
    filterParams: '<',
    premiseGridModel: '<',
    selectedChanged: '&',
    pageModel: '<',
    selectedChanged: '&',
    premiseGrid: '=',
  },
  templateUrl: 'App/Property/pyramid/premise-table-view/premise-table-view.component.html',
  controller: premiseTableViewComponent,
};

'use strict';

function premiseTableDetailComponent(gridService, $state, $uibModal, $http, $scope, WalService, HistoryService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  ctrl.activeTab = 0;
  ctrl.generatedTabs = undefined;
  ctrl.contract = undefined;
  ctrl.tabs = undefined;
  ctrl.panels = undefined;
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onInit = function $onInit() {
    console.log('ctrl value:', ctrl);
    ctrl.subGridTabs = gridService.CreateGridContainerTabsWithGrids(
      ctrl.pageModel.Tabs,
      ctrl.pageModel.Panels,
      ctrl.pageModel.Grids,
      ['PanelRoomInventory', 'PanelRoomSurface', 'PanelPremiseTask', 'PanelTenantsAndUsersOfPremise'],
      function(gridDescriptor) {
        if (gridDescriptor.Name === 'GridRoomInventory') {
          return {
            gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Property/RoomInventoryList/' }),
            transportData: function() {
              return { targetPremiseId: ctrl.premise.PremiseId, filterTM: ctrl.tmFilterState === true };
            },
            selectFunction: function() {
              setDasSubPremiseModel();
            },
          };
        }

        if (gridDescriptor.Name === 'GridRoomSurface') {
          return {
            gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Property/RoomSurfaceList' }),
            transportData: function() {
              return { targetPremiseId: ctrl.premise.PremiseId, filterTM: ctrl.tmFilterState === true };
            },
            selectFunction: function() {
              setDasSubPremiseModel();
            },
          };
        }

        if (gridDescriptor.Name === 'GridPremiseTask') {
          return {
            gridModel: Object.assign({}, gridDescriptor, {
              ControllerMethod: 'Property/PremiseTaskList',
            }),
            transportData: function() {
              return { targetPremiseId: ctrl.premise.PremiseId, filterTM: ctrl.tmFilterState === true };
            },
            selectFunction: function() {
              setDasSubPremiseModel();
            },
          };
        }

        if (gridDescriptor.Name === 'GridTenantsAndUsersOfPremise') {
          return {
            gridModel: Object.assign({}, gridDescriptor, {
              ControllerMethod: 'Property/TenantsAndUsersList',
            }),
            transportData: function() {
              return {
                targetPremiseOrPropertyId: ctrl.premise.PremiseId,
                isProperty: false,
                filterTM: ctrl.tmFilterState === true,
              };
            },
            selectFunction: function() {},
          };
        }

        return null;
      }
    );
    ctrl.createPremiseSubItem = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedPremise = ctrl.premise;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (gridName === 'GridPremiseTask') {
        var url = 'Task/PremiseTaskCreate?id=' + 0 + '&premiseId=' + ctrl.premise.PremiseId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PremiseTaskEdit.html',
          controller: 'PremiseTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            propertyId: ctrl.premise.PropertyId,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          gridRef.dataSource.read();
        });
      } else {
        if (ctrl.premise.RentUnitId > 0) {
          $state.go('Property.' + gridName + 'CreateRentableUnit', {
            id: 0,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.RentUnitId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'CreateImmovable', {
            id: id,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.PropertyId,
            Security: 'Immovable',
          });
        }
      }
    };

    ctrl.editPremiseSubItem = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedPremise = ctrl.premise;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];

      if (gridName === 'GridPremiseTask') {
        var url = 'Task/PremiseTaskEdit?id=' + id + '&premiseId=' + ctrl.premise.PremiseId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PremiseTaskEdit.html',
          controller: 'PremiseTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            propertyId: ctrl.premise.PropertyId,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          gridRef.dataSource.read();
        });
      } else {
        if (ctrl.premise.RentUnitId > 0) {
          $state.go('Property.' + gridName + 'EditRentableUnit', {
            id: 0,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.RentUnitId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'EditImmovable', {
            id: id,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.PropertyId,
            Security: 'Immovable',
          });
        }
      }
    };

    ctrl.viewPremiseSubItem = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedPremise = ctrl.premise;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];

      if (gridName === 'GridPremiseTask') {
        var url = 'Task/PremiseTaskView?id=' + id + '&premiseId=' + ctrl.premise.PremiseId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PremiseTaskEdit.html',
          controller: 'PremiseTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            propertyId: ctrl.premise.PropertyId,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          gridRef.dataSource.read();
        });
      } else {
        if (ctrl.premise.RentUnitId > 0) {
          $state.go('Property.' + gridName + 'ViewRentableUnit', {
            id: 0,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.RentUnitId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'ViewImmovable', {
            id: id,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.PropertyId,
            Security: 'Immovable',
          });
        }
      }
    };

    ctrl.duplicatePremiseSubItem = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedPremise = ctrl.premise;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];

      if (gridName === 'GridPremiseTask') {
        var url = 'Task/PremiseTaskDuplicate?id=' + id + '&premiseId=' + ctrl.premise.PremiseId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PremiseTaskEdit.html',
          controller: 'PremiseTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            propertyId: ctrl.premise.PropertyId,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          gridRef.dataSource.read();
        });
      } else {
        if (ctrl.premise.RentUnitId > 0) {
          $state.go('Property.' + gridName + 'DuplicateRentableUnit', {
            id: 0,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.RentUnitId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'DuplicateImmovable', {
            id: id,
            PremiseId: ctrl.premise.PremiseId,
            PropertyId: ctrl.premise.PropertyId,
            Security: 'Immovable',
          });
        }
      }
    };

    ctrl.deletePremiseSubItem = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedPremise = ctrl.premise;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];
      var urlPrefix = gridName.substring(0, 4) === 'Grid' ? gridName.substring(4) : gridName;

      bootbox.dialog({
        message: ctrl.pageModel.Messages.ConfirmDelete,
        title: ctrl.pageModel.Messages.Confirm,
        buttons: {
          cancel: {
            label: ctrl.pageModel.Messages.Cancel,
            className: 'btn-default',
            callback: function() {},
          },
          confirm: {
            label: ctrl.pageModel.Messages.Ok,
            className: 'btn-primary',
            callback: function() {
              var url = 'Property/' + urlPrefix + 'DeleteImmovable/' + id;
              if (gridName == 'GridPremiseTask') {
                url = 'Task/PremiseTaskDelete/' + id;
              }

              $http.get(url).then(function() {
                toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                gridRef.dataSource.read();
              });
            },
          },
        },
      });
    };

    ctrl.attachDocument = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];
      var urlPrefix = gridName.substring(0, 4) === 'Grid' ? gridName.substring(4) : gridName;
      dasService.NavigateToDas(
        ctrl.pageModel.messages,
        'Property.PropImmovableNavDasDocumentsNav',
        'Flg' + urlPrefix,
        id
      );
    };

    function setDasSubPremiseModel() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedItem = GetSelectedGridItems(gridRef)[0];
      var dasDescriptor = ctrl.pageModel.Grids[gridName].DasDescriptor;

      ctrl.dasSubPremiseModel = {
        routeId: dasDescriptor.routeId,
        tableId: dasDescriptor.tableId,
        ownerId: selectedItem[dasDescriptor.ownerColumn],
      };
      $scope.$applyAsync();
    }

    ctrl.usedRentableUnitGridEnum = Object.freeze({
      TOVABBI_ADATOK: 1,
      HELYISEG_ADATOK: 2,
    });

    ctrl.WAL = function() {
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var name = gridName.substring(0, 4) === 'Grid' ? gridName.substring(4) : gridName;
      WalService.NavigateToWal('Property', 'RentableUnit' + name + 'NavWal', 'Flg' + name);
    };

    ctrl.history = function() {
      var gridRef = ctrl.subGridTabs.tabs[ctrl.activeTab].grid;
      var gridName = ctrl.subGridTabs.tabs[ctrl.activeTab].gridName;
      var selectedItem = GetSelectedGridItems(gridRef)[0];

      if (typeof selectedItem === 'undefined') {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return false;
      }

      var id = selectedItem[ctrl.pageModel.Grids[gridName].IdColumn];
      var urlPrefix = gridName.substring(0, 4) === 'Grid' ? gridName.substring(4) : gridName;

      var historyBinding = {
        GridRoomInventory: { fieldid: 'InventoryId', tableid: 'FlgRoomInventory' },
        GridRoomSurface: { fieldid: 'RoomSId', tableid: 'FlgRoomSurface' },
        GridPremiseTask: { fieldid: 'PremiseTaskId', tableid: 'FlgPremiseTask' },
      };

      HistoryService.NavigateToHistory(
        historyBinding[gridName].tableid,
        id,
        { messages: ctrl.pageModel.Messages },
        $state,
        true,
        historyBinding[gridName].fieldid,
        'RentableUnit'
      );
    };
  };

  ctrl.clearDasModel = function() {
    delete ctrl.dasSubPremiseModel;
  };

  ctrl.$onChanges = function $onChanges(changes) {
    if (changes.tmFilterState) {
      ctrl?.subGridTabs?.tabs[ctrl.activeTab].grid.dataSource.read();
    }
  };

  ctrl.showTabs = function(tab) {
    return tab.name !== 'TabTenantsAndUsersOfPremise' || ctrl.premise.RentUnitId > 0;
  };

  //#endregion
}

var premiseTableDetailComponentTag = 'sbPremiseTableDetail';

const premiseTableDetailComponentOptions = {
  templateUrl: 'App/Property/pyramid/premise-table-detail/premise-table-detail.component.html',
  controller: premiseTableDetailComponent,
  bindings: {
    premise: '<',
    pageModel: '<',
    tmFilterState: '<',
  },
};

'use strict';

var _nextPropertyGridDetailPremiseGridId = 0;

function PropertyGridDetailComponent($timeout, gridService, $state, $scope, $http, WalService, HistoryService) {
  var ctrl = this;
  ctrl.gridId = `sb-property-detail-premise-grid-${_nextPropertyGridDetailPremiseGridId}`;
  _nextPropertyGridDetailPremiseGridId++;

  ctrl.property = undefined;

  ctrl.premiseGridModel = undefined;
  ctrl.premiseGrid = undefined;
  ctrl.premiseGridOptions = undefined;

  ctrl.$onChanges = function $onChanges(changes) {
    if (ctrl.property && ctrl.premiseGridModel) {
      ctrl.premiseGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign(_.cloneDeep(ctrl.premiseGridModel), {
          ControllerMethod: `Property/${ctrl.premiseGridModel.ControllerMethod}`,
        }),
        selectFunction: function(item) {
          ctrl.selectedItem = item;
          ctrl.dasModel = {
            routeId: 'Property.DasDocumentsNav',
            tableId: 'FlgPremise',
            ownerId: item.PremiseId,
          };
          $scope.$applyAsync();
        },
        transportData: function transportData() {
          return {
            targetPropertyId: ctrl.property.PropertyId,
          };
        },
        filterMode: false,
        filter: {
          logic: 'and',
          filters: [
            { field: 'ValidFrom', operator: 'le', value: new Date() },
            {
              logic: 'or',
              filters: [
                { field: 'ValidTo', operator: 'isnull' },
                { field: 'ValidTo', operator: 'ge', value: new Date() },
              ],
            },
          ],
        },
      });
    }
  };

  //functions

  ctrl.CreatePremise = function CreatePremise() {
    if (ctrl.property.Level == 'PPRRU') {
      $state.go('Property.GridPremiseCreateRentableUnit', {
        id: 0,
        RentUnitId: ctrl.property.PropertyId,
        Level: 'PPRRU',
        Security: 'RentableUnit',
      });
    } else {
      $state.go('Property.GridPremiseCreateImmovable', {
        id: 0,
        PropertyId: ctrl.property.PropertyId,
        Level: 'PPRIM',
        Security: 'Immovable',
      });
    }
  };

  ctrl.EditPremise = function EditPremise() {
    if (ctrl.property.Level == 'PPRRU') {
      $state.go('Property.GridPremiseEditRentableUnit', {
        id: ctrl.selectedItem.PremiseId,
        RentUnitId: ctrl.property.PropertyId,
        Level: 'PPRRU',
        Security: 'RentableUnit',
      });
    } else {
      $state.go('Property.GridPremiseEditImmovable', {
        id: ctrl.selectedItem.PremiseId,
        PropertyId: ctrl.property.PropertyId,
        Level: 'PPRIM',
        Security: 'Immovable',
      });
    }
  };

  ctrl.DuplicatePremise = function DuplicatePremise(premiseTS = false) {
    if (ctrl.property.Level == 'PPRRU') {
      $state.go('Property.GridPremiseDuplicateRentableUnit', {
        id: ctrl.selectedItem.PremiseId,
        RentUnitId: ctrl.property.PropertyId,
        PremiseTS: premiseTS,
        Level: 'PPRRU',
        Security: 'RentableUnit',
      });
    } else {
      $state.go('Property.GridPremiseDuplicateImmovable', {
        id: ctrl.selectedItem.PremiseId,
        PropertyId: ctrl.property.PropertyId,
        PremiseTS: premiseTS,
        Level: 'PPRIM',
        Security: 'Immovable',
      });
    }
  };

  ctrl.DeletePremise = function DeletePremise() {
    bootbox.dialog({
      message: ctrl.pageModel.Messages.ConfirmDelete,
      title: ctrl.pageModel.Messages.Confirm,
      buttons: {
        cancel: {
          label: ctrl.pageModel.Messages.Cancel,
          className: 'btn-default',
          callback: function() {},
        },
        confirm: {
          label: ctrl.pageModel.Messages.Ok,
          className: 'btn-primary',
          callback: function() {
            var url = 'Property/PremiseDeleteRentableUnit/' + ctrl.selectedItem.PremiseId;
            $http.get(url).then(function() {
              toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
              ctrl.premiseGrid.dataSource.read();
            });
          },
        },
      },
    });
  };

  ctrl.ViewPremise = function ViewPremise() {
    if (ctrl.property.Level == 'PPRRU') {
      $state.go('Property.GridPremiseViewRentableUnit', {
        id: ctrl.selectedItem.PremiseId,
        Level: 'PPRRU',
      });
    } else {
      $state.go('Property.GridPremiseViewImmovable', {
        id: ctrl.selectedItem.PremiseId,
        Level: 'PPRIM',
      });
    }
  };

  ctrl.WAL = function WAL() {
    WalService.NavigateToWal(
      'Property',
      ctrl.property.Level == 'PPRRU' ? 'RentableUnitPremiseNavWal' : 'PropImmovablePremiseViewWal',
      'FlgPremise'
    );
  };

  ctrl.History = function History() {
    HistoryService.NavigateToHistory(
      'FlgPremise',
      ctrl.selectedItem.PremiseId,
      { messages: ctrl.pageModel.Messages },
      $state,
      true,
      'PremiseId',
      ctrl.property.Level == 'PPRRU' ? 'RentableUnit' : 'PropImmovable'
    );
  };

  function createStateName(level, func) {}
}

var propertyGridDetailTag = 'sbPropertyGridDetail';

var propertyGridDetailOptions = {
  bindings: {
    property: '<',
    premiseGridModel: '<',
    pageModel: '<',
  },
  templateUrl: 'App/Property/pyramid/property-grid-detail/property-grid-detail.component.html',
  controller: PropertyGridDetailComponent,
};

'use strict';

const PyramidStateSessionKey = 'SB_PYRAMID_STATE_SESSION_KEY';
const PyramidPGSessionKey = 'SB_PYRAMID_PG_SESSION_KEY';

// #region Publics

function PyramidComponent($http, $state, $scope, $uibModal, DasService, WalService, HistoryService, UIHelperService) {
  var ctrl = this;
  ctrl.UIHelperService = UIHelperService;

  // @Input
  ctrl.options = undefined;
  ctrl.isGridviewEnabled = true;
  ctrl.isTreeViewEnabled = false;
  ctrl.actions = undefined;
  ctrl.filterFormCollapsed = { PGPremise: true, PGPremise: false };
  ctrl.headerModel = undefined;
  ctrl.headerFields = undefined;

  ctrl.filterParams = undefined;
  ctrl.selectedItem = undefined;
  ctrl.propertyPageModel = undefined;
  ctrl.propGridModel = undefined;
  ctrl.premiseSubGridModel = undefined;

  ctrl.premiseGridModel = undefined;

  ctrl.orientation = 'horizontal';
  ctrl.panes = [{ collapsible: true, size: '40%' }, { collapsible: true }];

  ctrl.filterOnChangeFunctions = {
    Tenement: function() {
      ctrl._checkAddressTenement();
    },
    ZoneId: function(selectedItem) {
      let opUnitDataSource =
        ctrl.options.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource;

      if (ctrl.headerModel.ZoneId && !!opUnitDataSource) {
        opUnitDataSource.transport.options.read.data = {
          zoneId: selectedItem.key,
        };
        ctrl.options.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.SelectedItems = [];
        opUnitDataSource.read();
      }
    },
  };

  ctrl.onBlurFunctions = {
    PostCode: function(selectedItem) {
      if (!!selectedItem && !!selectedItem.Value) {
        if (!!selectedItem.GridItem) {
          ctrl.headerModel.Locality = {
            Text: selectedItem.GridItem.Locality,
            Value: selectedItem.GridItem.Locality,
          };
        } else {
          $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Value).then(
            function(result) {
              var locality = result.data.result.Value;
              if (locality) {
                ctrl.headerModel.Locality = {
                  Text: locality,
                  Value: locality,
                };
              }
            },
            function(error) {}
          );
        }
      }
    },
    Locality: function(selectedItem) {
      if (!!selectedItem && selectedItem.Value) {
        if (selectedItem.GridItem) {
          ctrl.headerModel.PostCode = {
            Text: selectedItem.GridItem.PostCode,
            Value: selectedItem.GridItem.PostCode,
          };
        } else {
          $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
            function(result) {
              var postcode = result.data.result.Value;
              if (postcode) {
                if (
                  !ctrl.headerModel.PostCode ||
                  !ctrl.headerModel.PostCode.Value ||
                  postcode === ctrl.headerModel.PostCode.Value
                ) {
                  ctrl.headerModel.PostCode = {
                    Text: postcode,
                    Value: postcode,
                  };
                } else {
                  $http.get('Partner/GetAllLocalities?postcode=' + ctrl.headerModel.PostCode.Value).then(
                    function(result) {
                      var localities = result.data.result.Localities;
                      if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                        ctrl.headerModel.PostCode = {
                          Text: postcode,
                          Value: postcode,
                        };
                      }
                    },
                    function(error) {}
                  );
                }
              }
            },
            function(error) {}
          );
        }
      }
    },
  };

  ctrl.refreshPremiseGrid = function() {
    setTimeout(() => {
      ctrl.premiseGrid.dataSource.read();
    }, '100');
  };
  ctrl.premiseFilterAdditional = {};
  ctrl.premiseFilterOnChangeFunctions = {
    ConPropertyId: function(selectedItem) {
      ctrl.premiseFilterAdditional['ConPropertyId'] = selectedItem.GridItem;
      ctrl.refreshPremiseGrid();
    },
    PropertyId: function(selectedItem) {
      ctrl.premiseFilterAdditional['PropertyId'] = selectedItem.GridItem;
      ctrl.refreshPremiseGrid();
    },
    RentUnitId: function(selectedItem) {
      ctrl.premiseFilterAdditional['RentUnitId'] = selectedItem.GridItem;
      ctrl.refreshPremiseGrid();
    },
    BudgetId: function(selectedItem) {
      ctrl.refreshPremiseGrid();
    },
    PremiseType: function(selectedItem) {
      ctrl.refreshPremiseGrid();
    },
    PremiseFunction: function(selectedItem) {
      ctrl.refreshPremiseGrid();
    },
    PremiseSubFunction: function(selectedItem) {
      ctrl.refreshPremiseGrid();
    },
  };

  ctrl.premiseFilterOnClickFunctions = {
    ResetFilter: function(selectedItem) {
      ctrl.headerPremiseTabModel.ConPropertyId = { Value: null, Text: null };
      ctrl.headerPremiseTabModel.PropertyId = { Value: null, Text: null };
      ctrl.headerPremiseTabModel.RentUnitId = { Value: null, Text: null };
      ctrl.headerPremiseTabModel.BudgetId = { Value: null, Text: null };
      ctrl.headerPremiseTabModel.PremiseType = '';
      ctrl.headerPremiseTabModel.PremiseFunction = '';
      ctrl.headerPremiseTabModel.PremiseSubFunction = '';
      ctrl.refreshPremiseGrid();
    },
  };

  ctrl.$onInit = function $onInit() {
    ctrl.collapseHelper = {
      startPanelGroupName: window.sessionStorage.getItem(PyramidPGSessionKey) || 'PGProperty',
      openedPanels: {},
      disableRunExpression: true,
      tabOnlyFunction: true,
      extClass: 'tabulator',
    };

    $scope.$watch('$ctrl.collapseHelper.openedPanels', function(newValue, oldValue) {
      window.sessionStorage.setItem(PyramidPGSessionKey, newValue);
    });

    ctrl.actions = ctrl.options.pageModel.Actions;
    ctrl.headerModel = ctrl.options.dto;
    ctrl.headerPremiseTabModel = ctrl.options.premiseDto;

    ctrl.options.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function tenementWhereCondition() {
      if (ctrl.headerModel.ZoneId) {
        return "ZoneId~eq~'" + ctrl.headerModel.ZoneId + "'";
      }
    };

    ctrl.options.premisePageModel.Fields.ConPropertyId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
      return "Level~eq~'PPROB'";
    };

    ctrl.options.premisePageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
      return (
        "Level~in~'PPRBU,PPRED,PPRLA'" +
        (ctrl.headerPremiseTabModel.ConPropertyId?.Value > 0
          ? '~and~ConPropertyId~eq~' + ctrl.headerPremiseTabModel.ConPropertyId.Value
          : '')
      );
    };

    ctrl.options.premisePageModel.Fields.RentUnitId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
      let whereCondition = "Level~eq~'PPRRU'";
      if (ctrl.headerPremiseTabModel.PropertyId?.Value > 0) {
        whereCondition +=
          "~and~Tenement1~eq~'" +
          ctrl.premiseFilterAdditional.ConPropertyId.Tenement1 +
          "'~and~Tenement2~eq~'" +
          ctrl.premiseFilterAdditional.PropertyId.Tenement2 +
          "'";
      } else if (ctrl.headerPremiseTabModel.ConPropertyId?.Value > 0) {
        whereCondition += "~and~Tenement1~eq~'" + ctrl.premiseFilterAdditional.ConPropertyId.Tenement1 + "'";
      }
      return whereCondition;
    };

    ctrl.headerFields = GenerateFormlyFormPanelsFromPageModel(ctrl.options.pageModel).PanelHeader.FormlyDescriptor;
    ctrl.headerPremiseTabFields = GenerateFormlyFormPanelsFromPageModel(
      ctrl.options.premisePageModel
    ).PanelHeader.FormlyDescriptor;

    ctrl.propGridModel = ctrl.options.pageModel.Grids.GridPyramid;
    ctrl.premiseSubGridModel = ctrl.options.pageModel.Grids.GridPremise;

    ctrl.premiseGridModel = ctrl.options.premisePageModel.Grids.GridPyramidPremise;

    InsertOnBlurFunctions(ctrl.options.pageModel, ctrl.onBlurFunctions);
    InsertOnChangeFunctions(ctrl.options.pageModel, ctrl.filterOnChangeFunctions);

    InsertOnChangeFunctions(ctrl.options.premisePageModel, ctrl.premiseFilterOnChangeFunctions);
    InsertOnClickFunctions(ctrl.options.premisePageModel, ctrl.premiseFilterOnClickFunctions);

    ctrl._restoreStateFromStorage();
    let opUnitDataSource =
      ctrl.options.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource;

    if (ctrl.headerModel.ZoneId && !!opUnitDataSource) {
      opUnitDataSource.transport.options.read.data = {
        zoneId: ctrl.headerModel.ZoneId,
      };
      ctrl.options.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.SelectedItems = [];
      opUnitDataSource.read();
    }
  };

  ctrl.$postLink = function $postLink() {
    ctrl.isGridviewEnabled && ctrl.goToGridView();
  };

  // #region Click listeners

  ctrl.back = function back() {
    $state.go('main');
  };

  ctrl.createObject = function createObject() {
    $state.go('Property.ObjectCreate', {
      id: 0,
      zoneId: ctrl.headerModel.ZoneId,
      opUnitId: ctrl.headerModel.OpUnitId,
    });
  };

  ctrl.createProperty = function createProperty() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    let level = ctrl.getLevel(ctrl.selectedItem);
    let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

    if (level === 'PPROB') {
      $state.go('Property.PropImmovableCreate', { id: id, isnew: true });
    } else {
      toastr.warning(ctrl.options.pageModel.Messages.ObjectMustBeSelected);
    }
  };

  ctrl.createRentableUnit = function createRentableUnit() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    let level = ctrl.getLevel(ctrl.selectedItem);
    let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

    if (level === 'PPRBU' || level === 'PPRED' || level === 'PPRLA') {
      $state.go('Property.RentableUnitCreate', { id: id, isnew: true });
    } else {
      toastr.warning('Ingatlan típust kell kiválasztani!');
    }
  };

  ctrl.createFacility = function createFacility() {
    $state.go('Property.FacilityCreate', {});
  };

  ctrl.connections = function connections() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.collapseHelper.openedPanels[0] == 'PGPremise') {
      if ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0) {
        $state.go('Property.RentableUnitNav', { id: ctrl.selectedItem.RentUnitId });
      } else {
        $state.go('Property.PropImmovableNav', { id: ctrl.selectedItem.PropertyId });
      }
    } else {
      let level = ctrl.getLevel(ctrl.selectedItem);
      let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

      let type = ctrl.getType(level);

      $state.go(`Property.${type}Nav`, { id });
    }
  };

  ctrl.editMainItem = function editMainItem() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.selectedItem?.PremiseId > 0) {
      if ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0) {
        $state.go('Property.GridPremiseEditRentableUnit', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.RentUnitId,
          Level: 'PPRRU',
          Security: 'RentableUnit',
        });
      } else {
        $state.go('Property.GridPremiseEditImmovable', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.PropertyId,
          Level: 'PPRIM',
          Security: 'Immovable',
        });
      }
    } else {
      let level = ctrl.getLevel(ctrl.selectedItem);
      let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

      let type = ctrl.getType(level);

      $state.go(`Property.${type}Edit`, {
        id,
        zoneId: type === 'Object' ? ctrl.headerModel.ZoneId : undefined,
        opUnitId: type === 'Object' ? ctrl.headerModel.OpUnitId : undefined,
      });
    }
  };

  ctrl.duplicateMainItem = function duplicateMainItem(premiseTS = false) {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.selectedItem?.PremiseId > 0) {
      if ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0) {
        $state.go('Property.GridPremiseDuplicateRentableUnit', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.RentUnitId,
          Level: 'PPRRU',
          Security: 'RentableUnit',
          PremiseTS: premiseTS,
        });
      } else {
        $state.go('Property.GridPremiseDuplicateImmovable', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.PropertyId,
          Level: 'PPRIM',
          Security: 'Immovable',
          PremiseTS: premiseTS,
        });
      }
    } else {
      let level = ctrl.getLevel(ctrl.selectedItem);
      let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

      let type = ctrl.getType(level);
      $state.go(`Property.${type}Duplicate`, { id });
    }
  };

  ctrl.deleteMainItem = function deleteMainItem() {
    let id;
    let url;

    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.selectedItem?.PremiseId > 0) {
      id = ctrl.selectedItem?.PremiseId;
      url = 'Property/PremiseDeleteImmovable/' + id;
    } else {
      let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];
      let level = ctrl.getLevel(ctrl.selectedItem);
      url = 'Property/' + ctrl.getType(level) + 'Delete/' + id;
    }
    bootbox.dialog({
      message: ctrl.options.pageModel.Messages.DeleteDialogConfirmMessage,
      title: ctrl.options.pageModel.Messages.Confirm,
      buttons: {
        cancel: {
          label: ctrl.options.pageModel.Messages.Cancel,
          className: 'btn-default',
          callback: function() {},
        },
        confirm: {
          label: ctrl.options.pageModel.Messages.Ok,
          className: 'btn-primary',
          callback: function() {
            $http.get(url).then(function() {
              toastr.success(ctrl.options.pageModel.Messages.DeleteSuccessful);

              // We need to copy it so that angular can detect it as a change
              ctrl.filterParams = angular.copy(ctrl.headerModel);
            });
          },
        },
      },
    });
  };

  ctrl.viewMainItem = function viewMainItem() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.selectedItem?.PremiseId > 0) {
      if ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0) {
        $state.go('Property.GridPremiseViewRentableUnit', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.RentUniId,
          Level: 'PPRRU',
          Security: 'RentableUnit',
          BackTo: 'Main',
        });
      } else {
        $state.go('Property.GridPremiseViewImmovable', {
          id: ctrl.selectedItem?.PremiseId,
          PropertyId: ctrl.selectedItem?.targetPropertyId || ctrl.selectedItem?.PropertyId,
          Level: 'PPRIM',
          Security: 'Immovable',
          BackTo: 'Main',
        });
      }
    } else {
      let level = ctrl.getLevel(ctrl.selectedItem);
      let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

      let type = ctrl.getType(level);
      $state.go(`Property.${type}View`, { id });
    }
  };

  ctrl.mapMainItem = function mapMainItem() {
    if (!ctrl.selectedItem) {
      $http
        .post('/Property/PropertyList/', {
          dto: ctrl.filterParams,
          filter: '',
          page: 1,
          pageSize: 999999999,
          skip: 0,
          sort: '',
          take: 999999999,
        })
        .then(function(result) {
          const pprobs = result.data.Data.filter(function(property) {
            return property.Level === 'PPROB';
          }).map(function(property) {
            return property.PropertyId;
          });

          if (pprobs.length > 0) {
            var url = $state.href('Property.Map', {
              ids: pprobs,
            });
            window.open(url, '_blank');
          } else {
            toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem, ctrl.options.pageModel.Messages.Warning);
          }
        });
    } else {
      var url = $state.href('Property.Map', {
        propertyId: ctrl.selectedItem.PropertyId,
      });
      window.open(url, '_blank');
    }
  };

  ctrl.navigateToEditPropertyState = function navigateToEditPropertyState() {
    return (
      ctrl.selectedItem?.Level != 'PPRRU' &&
      !((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0)
    );
  };

  ctrl.navigateToEditProperty = function navigateToEditProperty() {
    if (!!ctrl.selectedItem) {
      $state.go('Property.GridTenancyChequeCreateRentableUnit', {
        id: 0,
        PropertyId:
          ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId || ctrl.selectedItem.PropertyId,
        Level: 'PPRRU',
        Security: 'RentableUnit',
      });
    }
  };

  ctrl.newPremiseMainItem = function newPremiseMainItem() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    let level = ctrl.getLevel(ctrl.selectedItem);
    let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];
    if (level === 'PPROB') {
      toastr.warning('Ingatlan, vagy bérlemény típust kell kiválasztani!');
      return;
    } else if (level === 'PPRRU') {
      $state.go('Property.GridPremiseCreateRentableUnit', {
        id: 0,
        RentUnitId: id,
        Level: level,
        Security: 'RentableUnit',
      });
    } else {
      $state.go('Property.GridPremiseEditImmovable', {
        id: 0,
        PropertyId: id,
        Level: level,
        Security: 'Immovable',
      });
    }
  };

  ctrl.newPremiseItem = function newPremiseItem() {
    if (ctrl.selectedItem?.PremiseId > 0) {
      if ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0) {
        $state.go('Property.GridPremiseCreateRentableUnit', {
          id: 0,
          RentUnitId: ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId,
          Level: 'PPRRU',
          Security: 'RentableUnit',
        });
      } else {
        $state.go('Property.GridPremiseEditImmovable', {
          id: 0,
          PropertyId: ctrl.selectedItem?.PropertyId?.Value || ctrl.selectedItem?.PropertyId,
          Level: 'PPRIM',
          Security: 'Immovable',
        });
      }
    }
  };

  ctrl.newInventoryMainItem = function newInventoryMainItem() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    let level = ctrl.getLevel(ctrl.selectedItem);
    let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridPyramid'].IdColumn];

    if (level === 'PPROB') {
      toastr.warning('Ingatlan, vagy bérlemény típust kell kiválasztani!');
      return;
    } else {
      $state.go(`Property.RoomInventoryCreate`, { PropertyId: id, Level: level });
    }
  };

  ctrl.setDasModel = function setDasModel() {
    var dasDescriptor =
      ctrl.collapseHelper.openedPanels[0] == 'PGPremise' || ctrl.selectedItem?.PremiseId > 0
        ? ctrl.options.premisePageModel.Grids['GridPyramidPremise'].DasDescriptor
        : ctrl.options.pageModel.Grids['GridPyramid'].DasDescriptor;

    ctrl.dasModel = {
      routeId: dasDescriptor.routeId,
      tableId: dasDescriptor.tableId,
      ownerId: ctrl.selectedItem[dasDescriptor.ownerColumn],
    };
    if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
      $scope.$applyAsync();
    } else {
      setTimeout(function() {
        $scope.$applyAsync();
      }, 2000);
    }
  };

  ctrl.WAL = function WAL() {
    if (ctrl.collapseHelper.openedPanels[0] == 'PGPremise' || ctrl.selectedItem?.PremiseId > 0) {
      WalService.NavigateToWal('Property', 'PyramidNavWal', 'FlgPremiseView');
    } else {
      WalService.NavigateToWal('Property', 'PyramidNavWal', 'FlgPropertyView');
    }
  };

  ctrl.History = function History() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    if (ctrl.collapseHelper.openedPanels[0] == 'PGPremise' || ctrl.selectedItem?.PremiseId > 0) {
      HistoryService.NavigateToHistory(
        ((ctrl.selectedItem?.RentUnitId?.Value || ctrl.selectedItem?.RentUnitId) > 0
          ? 'RentableUnit'
          : 'PropImmovable') + 'FlgPremise',
        ctrl.selectedItem.PremiseId,
        { messages: ctrl.options.pageModel.Messages },
        $state,
        true
      );
    } else {
      HistoryService.NavigateToHistory(
        'FlgProperty',
        ctrl.selectedItem.PropertyId,
        { messages: ctrl.options.pageModel.Messages },
        $state,
        true
      );
    }
  };

  ctrl.openEmptyFlatTransmissionFeeReport = function openEmptyFlatTransmissionFeeReport() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    $uibModal
      .open({
        templateUrl: 'App/Property/EmptyFlatTransmissionFeeReport.html',
        controller: 'EmptyFlatTransmissionFeeReportCtrl',
        controllerAs: 'vm',
        backdrop: 'static',
        resolve: {
          options: RouteResolveFunc('Property/EFTransFeeReportModal'),
        },
      })
      .result.then(function(areaRentalId) {
        if (
          ctrl.selectedItem.Level === 'PPRRU' &&
          ctrl.selectedItem.TenType === 'PTEFL' &&
          ctrl.selectedItem.IsRentable
        ) {
          ctrl.generateEFTReport(ctrl.selectedItem.PropertyId, areaRentalId);
        } else {
          toastr.warning('A kiválasztott elemre nem generálható riport', ctrl.options.pageModel.Messages.Warning);
        }
      });
  };

  ctrl.generateEFTReport = function generateEFTReport(propertyId, areaRentalId) {
    $http
      .post('Property/GenerateEFTransFeeReport', {
        propertyId: propertyId,
        areaRentalId: areaRentalId,
      })
      .then(
        function(result) {
          var file = JSON.parse(result.data);
          var raw = atob(file.Report);
          var rawLength = raw.length;
          var array = new Uint8Array(new ArrayBuffer(rawLength));
          for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }
          var fs = new Blob([array], { type: file.MimeType });
          saveAs(fs, decodeURIComponent(file.FileName));
          toastr.success('Sikeres generálás!');
        },
        function(err) {
          console.err(err);
          toastr.error('Sikertelen mentés!');
        }
      );
  };

  ctrl.taskToRoom = function taskToRoom() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    $uibModal
      .open({
        templateUrl: 'App/Task/PremiseTaskEdit.html',
        controller: 'PremiseTaskEditCtrl',
        controllerAs: 'vm',
        resolve: {
          model: RouteResolveFunc(`Task/PropertyTaskMassEdit?propertyId=${ctrl.selectedItem.PropertyId}`),
        },
        backdrop: 'static',
      })
      .result.then(function() {
        //TODO szeretnenk frissiteni gridet?
      })
      .catch(function(err) {
        console.error(err);
      });
  };

  // #endregion

  ctrl.goToTreeView = function goToTreeView() {
    ctrl.isGridviewEnabled = false;
    ctrl.isTreeViewEnabled = true;
    ctrl.selectedItem = null;

    ctrl
      ._checkAddressTenement()
      .then(function() {
        return ctrl._checkAddressTopogrNumber();
      })
      .then(function() {
        // We need to copy it so that angular can detect it as a change
        ctrl.filterParams = angular.copy(ctrl.headerModel);

        window.sessionStorage.setItem(PyramidStateSessionKey, JSON.stringify(ctrl._getCurrentState()));
      });
  };

  ctrl.goToGridView = function goToGridView() {
    ctrl.isGridviewEnabled = true;
    ctrl.isTreeViewEnabled = false;
    ctrl.selectedItem = null;

    ctrl
      ._checkAddressTenement()
      .then(function() {
        return ctrl._checkAddressTopogrNumber();
      })
      .then(function() {
        // We need to copy it so that angular can detect it as a change
        ctrl.filterParams = angular.copy(ctrl.headerModel);

        window.sessionStorage.setItem(PyramidStateSessionKey, JSON.stringify(ctrl._getCurrentState()));
      });
  };

  ctrl.deleteFilter = function deleteFilter() {
    ctrl._resetFilter();
    ctrl.goToGridView();
  };

  ctrl.selectionChanged = function selectionChanged(item) {
    ctrl.selectedItem = item;
    ctrl.propertyPageModel = item.pageModel;
    //ctrl.isGridviewEnabled && $scope.$apply();
    ctrl.setDasModel();
  };

  ctrl.getLevel = function getLevel(item) {
    if (item.Level.length == 5) {
      return item.Level;
    } else if (!!item?.TenType) {
      return 'PPRRU';
    } else if (!!item?.PremiseId) {
      return 'PPRRU';
    }
    return 'PPROB';
  };
  ctrl.getType = function getType(level) {
    let type = 'Object';
    if (level?.length == 5) {
      if (level === 'PPRRU') {
        type = 'RentableUnit';
      } else if (level !== 'PPROB') {
        type = 'PropImmovable';
      }
    }
    return type;
  };

  ctrl._checkAddressTenement = function _checkAddressTenement() {
    if (ctrl.headerModel.Tenement && ctrl.headerModel.Tenement.Value) {
      return $http({
        method: 'GET',
        url: 'Property/AddressTenementLoader/',
        params: {
          tenement: ctrl.headerModel.Tenement.Value,
        },
      });
    }

    return Promise.resolve();
  };

  ctrl._checkAddressTopogrNumber = function _checkAddressTopogrNumber() {
    if ((!ctrl.headerModel.Tenement || !ctrl.headerModel.Tenement.Value) && ctrl.headerModel.TopogrNumber) {
      return $http({
        method: 'GET',
        url: 'Property/AddressTopogrNumberLoader/',
        params: { topogrNumber: ctrl.headerModel.TopogrNumber },
      });
    }

    return Promise.resolve();
  };

  ctrl._resetFilter = function _resetFilter() {
    ctrl.headerModel.ZoneId = 0;
    ctrl.headerModel.OpUnitId = '';
    ctrl.headerModel.TopogrNumber = '';
    ctrl.headerModel.Tenement.Value = '';
    ctrl.headerModel.Tenement.Text = '';
    ctrl.headerModel.FilterField = '';
  };

  ctrl._getCurrentState = function _getCurrentState() {
    return {
      isGridviewEnabled: ctrl.isGridviewEnabled,
      isTreeViewEnabled: ctrl.isTreeViewEnabled,
      filterParams: {
        ZoneId: ctrl.filterParams.ZoneId,
        OpUnitId: ctrl.filterParams.OpUnitId,
        TopogrNumber: ctrl.filterParams.TopogrNumber || '',
        Tenement: ctrl._convertNullable(ctrl.filterParams.Tenement),
        FilterField: ctrl.filterParams.FilterField || '',
      },
    };
  };

  ctrl._restoreStateFromStorage = function _restoreStateFromStorage() {
    let storedState = JSON.parse(window.sessionStorage.getItem(PyramidStateSessionKey) || '{}');

    if (Object.keys(storedState).length > 0) {
      ctrl.headerModel.ZoneId = storedState.filterParams.ZoneId;
      ctrl.headerModel.OpUnitId = storedState.filterParams.OpUnitId;
      ctrl.headerModel.TopogrNumber = storedState.filterParams.TopogrNumber;
      ctrl.headerModel.Tenement = storedState.filterParams.Tenement && {
        Text: storedState.filterParams.Tenement,
        Value: storedState.filterParams.Tenement,
      };

      if (storedState.isGridviewEnabled) {
        ctrl.goToGridView();
      } else if (storedState.isTreeViewEnabled) {
        ctrl.goToTreeView();
      }
    }
  };

  ctrl._convertNullable = function _convertNullable(param) {
    return !!param && !!param.Value && param.Value !== 'null' ? param.Value : '';
  };
}

var pyramidComponentOptions = {
  bindings: {
    options: '<',
  },
  controller: PyramidComponent,
  templateUrl: 'App/Property/pyramid/pyramid-nav/pyramid.component.html',
};

var pyramidComponentTag = 'sbPyramidNav';

// #endregion

'use strict';

// #region Publics

function PropertyEditComponent($http, $state, $stateParams, $uibModal, DasService, LockService, UIHelperService) {
  var ctrl = this;
  ctrl.UIHelperService = UIHelperService;

  ctrl.options = undefined;
  ctrl.pageModel = undefined;
  ctrl.formModel = undefined;
  ctrl.isView = undefined;
  ctrl.securedProgramId = undefined;
  ctrl.securedId = undefined;
  ctrl.label = undefined;
  ctrl.isParent = undefined;
  ctrl.zoneId = undefined;
  ctrl.opUnitId = undefined;
  ctrl.validFrom = undefined;

  ctrl.isFormReadOnly = $stateParams.isFormReadOnly;
  ctrl.ObjectType = $stateParams.ObjectType;
  ctrl.TypeName = $stateParams.Name;
  ctrl.EditOrDuplicate = $stateParams.EditOrDuplicate;
  ctrl.isCreate = $stateParams.isCreate;
  ctrl.dynamicTabName = 'PGTab' + $stateParams.ObjectType;
  ctrl.collapseHelper = {
    startPanelGroupName: $stateParams.openedPanelGroup || ctrl.dynamicTabName,
    disableRunExpression: false,
  };

  if ($stateParams.ObjectType === 'Object') {
    var customExpressionProperties = {
      ZoneId: {
        'templateOptions.disabled': function() {
          if (ctrl.EditOrDuplicate !== 'Duplicate' && ctrl.isCreate == false) {
            return true;
          } else {
            return ctrl.zoneId !== null && ctrl.zoneId !== 0;
          }
        },
      },
      ValidFrom: {
        'templateOptions.disabled': function() {
          return !ctrl.isCreate && ctrl.EditOrDuplicate !== 'Duplicate';
        },
      },
      OpUnitId: {
        'templateOptions.required': function() {
          return true;
        },
        'templateOptions.disabled': function() {
          if (ctrl.EditOrDuplicate !== 'Duplicate' && ctrl.isCreate == false && ctrl.isParent === true) {
            return true;
          } else {
            return ctrl.opUnitId !== null && ctrl.opUnitId !== 0 && ctrl.isParent === true;
          }
        },
      },
      Owner: {
        'templateOptions.disabled': function() {
          if (ctrl.EditOrDuplicate !== 'Duplicate' && ctrl.isCreate === false && ctrl.isParent === true) {
            return true;
          }
        },
      },
      Country: {
        'templateOptions.disabled': function() {
          if (ctrl.EditOrDuplicate !== 'Duplicate' && ctrl.isCreate === false && ctrl.isParent === true) {
            return true;
          }
        },
      },
      FloorSpace: {
        'templateOptions.disabled': function() {
          return true;
        },
      },
      TopogrNumber: {
        'templateOptions.disabled': function() {
          return false;
        },
      },
      StreetNumber: {
        'templateOptions.disabled': function() {
          return false;
        },
      },
    };
    var syncValidators = {
      ValidFrom: {
        ObjectValidFromValidator: function(modelValue, viewValue) {
          var currValidFrom = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

          if (ctrl.formModel.PropertyId === 0) {
            return currValidFrom.isSameOrAfter(ctrl.validFrom);
          } else {
            return true;
          }
        },
      },
    };

    var onChangeFunctions = {
      ZoneId: function() {
        SetZoneIdViewComboListFilter();
      },

      RegionCode: function(selectedItem) {
        if (!!selectedItem?.key) {
          ctrl.formModel.PostCode = ctrl.formModel.Locality = {
            Text: null,
            Value: null,
          };
        }
      },
    };

    var onBlurFunctions = {
      PostCode: function(selectedItem) {
        if (((!!selectedItem && selectedItem.Value) || selectedItem.Text) && ctrl.postCodeValue !== selectedItem.Value)
          if (selectedItem.GridItem) {
            ctrl.formModel.Locality = {
              Text: selectedItem.GridItem.Locality,
              Value: selectedItem.GridItem.Locality,
            };
            ctrl.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
              selectedItem.GridItem.Locality
            );
            ctrl.formModel.Quarter = selectedItem.GridItem.Quarter;
            ctrl.formModel.RegionCode = selectedItem.GridItem.RegionCode;
            ctrl.formModel.Street = selectedItem.GridItem.Street;
            ctrl.formModel.StreetChar = selectedItem.GridItem.StreetChar;
          } else {
            $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Value).then(
              function(result) {
                var address = result.data.result.Dto;
                var locality = address.Locality.Value;
                if (locality) {
                  ctrl.formModel.Locality = {
                    Text: locality,
                    Value: locality,
                  };
                  ctrl.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
                    locality
                  );
                  ctrl.formModel.Country = address.Country ? address.Country : '';
                  ctrl.formModel.Quarter = address.Quarter;
                  ctrl.formModel.RegionCode = address.RegionCode;
                  ctrl.formModel.Street = address.Street;
                  ctrl.formModel.StreetChar = address.StreetChar;
                }
              },
              function(error) {}
            );
          }
        ctrl.postCodeValue = ctrl.formModel.PostCode.Value;
      },
      Locality: function(selectedItem) {
        if (!!selectedItem && selectedItem.Value) {
          if (selectedItem.GridItem) {
            ctrl.formModel.PostCode = {
              Text: selectedItem.GridItem.PostCode,
              Value: selectedItem.GridItem.PostCode,
            };
            ctrl.formModel.Quarter = selectedItem.GridItem.Quarter;
            ctrl.formModel.RegionCode = selectedItem.GridItem.RegionCode;
            ctrl.formModel.Street = selectedItem.GridItem.Street;
            ctrl.formModel.StreetChar = selectedItem.GridItem.StreetChar;
          } else {
            $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
              function(result) {
                var postcode = result.data.result.Value;
                if (postcode) {
                  if (
                    !ctrl.formModel.PostCode ||
                    !ctrl.formModel.PostCode.Value ||
                    postcode === ctrl.formModel.PostCode.Value
                  ) {
                    ctrl.formModel.PostCode = {
                      Text: postcode,
                      Value: postcode,
                    };
                  } else {
                    $http.get('Partner/GetAllLocalities?postcode=' + ctrl.formModel.PostCode.Value).then(
                      function(result) {
                        var localities = result.data.result.Localities;
                        if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                          ctrl.formModel.PostCode = {
                            Text: postcode,
                            Value: postcode,
                          };
                        }
                      },
                      function(error) {}
                    );
                  }
                }
              },
              function(error) {}
            );
          }
        }
      },
    };
    var numericOptions = {
      Eastern: {
        decimals: 10,
        format: 'n9',
        max: 90,
        min: -90,
      },
      Northern: {
        decimals: 11,
        format: 'n9',
        max: 180,
        min: -180,
      },
      FloorSpace: {
        decimals: 2,
        format: 'n10',
        max: 9999999999,
        min: 0,
      },
    };
  } else if ($stateParams.ObjectType === 'RentableUnit') {
    var customExpressionProperties = {
      FloorSpace: {
        'templateOptions.disabled': function() {
          return !ctrl.formModel.RoomAtomatically;
        },
      },
      RentableSpace: {
        'templateOptions.disabled': function() {
          return !ctrl.formModel.RoomAtomatically;
        },
      },
      CubicMeter: {
        'templateOptions.disabled': function() {
          return !ctrl.formModel.RoomAtomatically;
        },
      },
      ValidFrom: {
        'templateOptions.disabled': function() {
          return !(ctrl.isCreate || ctrl.EditOrDuplicate === 'Duplicate');
        },
        'templateOptions.required': function() {
          return true;
        },
      },
      StairWay: {
        'templateOptions.disabled': function() {
          return !(ctrl.formModel.TenType === 'PTEFL' || ctrl.formModel.TenType === 'PTEPR');
        },
      },
    };
    var syncValidators = {
      TopogrNumber: {
        TopogrNumberValidator: function(modelValue) {
          if (!modelValue) {
            return true;
          }
          return true;
        },
      },
      ValidFrom: {
        AidDecisionValidFromValidator: function(modelValue, viewValue) {
          if (!modelValue || !viewValue) {
            return true;
          }

          var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
          var validToValue = new moment(ctrl.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

          if (isNaN(validToValue)) {
            return true;
          }
          return validToValue.isSameOrAfter(validFromValue);
        },
        // RentableUnitCreateValidFromNowValidator: function(modelValue) {
        // var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
        // var d = new Date();
        // if (ValidFromValue._d >= d) {
        // return false;
        // }
        // return true;
        // },
      },
      FloorSpace: {
        PositiveNumberValidator: function(modelValue) {
          if (!ctrl.formModel.RoomAtomatically) {
            return true;
          }
          if (kendo.parseInt(modelValue) > 0) {
            return true;
          }
          return false;
        },
      },
      RentableSpace: {
        FloorSpaceFullAreaValidator: function(modelValue) {
          if (!ctrl.formModel.RoomAtomatically) {
            return true;
          }
          if (kendo.parseInt(modelValue) >= ctrl.formModel.RentableSpace) {
            return true;
          }
          return false;
        },
      },
      CubicMeter: {
        DecimalValidator: function(modelValue) {
          if (!ctrl.formModel.RoomAtomatically) {
            return true;
          }
          if (kendo.parseInt(modelValue) >= 0) {
            return true;
          }
          return false;
        },
      },
    };
    var onChangeFunctions = {};
    var onBlurFunctions = {
      //   Name: function(selectedItem) {
      //     if ((!selectedItem.Name || selectedItem.Name === '') && ctrl.formModel.Name === '') {
      //       ctrl.formModel.Name = ctrl.formModel.Address;
      //     }
      //   },
    };
    var numericOptions = {
      RentableSpace: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
      FloorSpace: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
      CubicMeter: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
    };
  } else {
    var customExpressionProperties = {
      Level: {
        'templateOptions.disabled': function() {
          if (ctrl.formModel.PropertyId !== 0 && ctrl.EditOrDuplicate !== 'Duplicate') {
            return true;
          }
        },
      },
      TopogrNumber: {
        'templateOptions.required': function() {
          return false;
        },
      },
    };
    var syncValidators = {
      TopogrNumber: {
        TopogrNumberValidator: function(modelValue) {
          if (!modelValue) {
            return true;
          }
          return true;
        },
      },
    };
    var onChangeFunctions = {};
    var onChangeFunctions = {};
    var numericOptions = {
      RentableSpace: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
      FloorSpace: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
      CubicMetre: {
        decimals: 2,
        format: 'n2',
        max: 99999999999999,
        min: 0,
      },
    };
  }

  ctrl.$onInit = function $onInit() {
    ctrl.pageModel = ctrl.options.pageModel;
    ctrl.formModel = ctrl.options.dto;
    ctrl.isView = ctrl.isFormReadOnly || ctrl.formModel.IsReadOnly;
    ctrl.securedProgramId = ctrl.options.programId;
    ctrl.securedId = ctrl.options.id;
    ctrl.isParent = !!ctrl.options.dto.IsParent ? ctrl.options.dto.IsParent : false;

    ctrl.zoneId = !!ctrl.formModel.ZoneId ? ctrl.formModel.ZoneId : null;
    ctrl.opUnitId = !!ctrl.formModel.OpUnitId ? ctrl.formModel.OpUnitId : null;
    ctrl.validFrom = !!ctrl.formModel.ValidFrom
      ? new moment(ctrl.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase())
      : null;

    var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(ctrl.pageModel);
    if ($stateParams.ObjectType === 'Object') {
      ctrl.label = ctrl.pageModel.Labels['LabelObjectData'].Title;
      ctrl.formFields = formlyFormPanelDescriptors.PanelObjectPanel.FormlyDescriptor;
      ctrl.formOtherInfoFieldsLeft = formlyFormPanelDescriptors.ObjectOtherInfoPanelLeft.FormlyDescriptor;
      ctrl.formOtherInfoFieldsRight = formlyFormPanelDescriptors.ObjectOtherInfoPanelRight.FormlyDescriptor;
      ctrl.formOtherInfoFieldsBottom = formlyFormPanelDescriptors.ObjectOtherInfoPanelBottom.FormlyDescriptor;
      if (!ctrl.opUnitId) {
        SetZoneIdViewComboListFilter();
      }
      ctrl.RegionCodeWhereCondition = function() {
        return !ctrl.formModel.RegionCode ? '' : "RegionCode~eq~'" + ctrl.formModel.RegionCode + "'";
      };

      ctrl.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        ctrl.RegionCodeWhereCondition;
      ctrl.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        ctrl.RegionCodeWhereCondition;
    } else if ($stateParams.ObjectType === 'RentableUnit') {
      changeModelFromParam(ctrl.formModel, $stateParams.param);
      ctrl.label = ctrl.pageModel.Labels['LabelTitle'].Title;
      ctrl.formFields = formlyFormPanelDescriptors.PanelRentable.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsLeft = formlyFormPanelDescriptors.PanelDimensionLeft.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsRight = formlyFormPanelDescriptors.PanelDimensionRight.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsBottom = formlyFormPanelDescriptors.PanelDimensionBottom.FormlyDescriptor;
      ctrl.pageModel.Fields.RoomAtomatically.FormlyFieldDescriptor.hide = true;
    } else {
      ctrl.label = ctrl.pageModel.Labels['LabelImmovable'].Title;
      ctrl.formFields = formlyFormPanelDescriptors.PanelPropIm.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsLeft = formlyFormPanelDescriptors.PanelDimensionLeft.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsRight = formlyFormPanelDescriptors.PanelDimensionRight.FormlyDescriptor;
      ctrl.panelDimensionFormFieldsBottom = formlyFormPanelDescriptors.PanelDimensionBottom.FormlyDescriptor;
    }

    // Lock
    // This will spawn a modal what cannot be closed until the lock is done
    if ($stateParams.ObjectType === 'Object' || $stateParams.ObjectType === 'PropImmovable') {
      if (!ctrl.isView) {
        LockService.initiateLock(ctrl.securedProgramId, ctrl.securedId);
      }
    } else if ($stateParams.ObjectType === 'RentableUnit') {
      if (!ctrl.isView && !ctrl.isCreate) {
        LockService.initiateLock(ctrl.securedProgramId, ctrl.securedId);
      }
      ctrl.pageModel.Fields.Name.FormlyFieldDescriptor.templateOptions.placeholder = ctrl.formModel.Address;
    }

    // Set editability of fields based on controllerOptions
    if (ctrl.isFormReadOnly || ctrl.pageModel.IsReadOnly) {
      angular.forEach(ctrl.pageModel.Fields, function(value, key) {
        if (key !== 'Valid') {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        }
      });
    }

    if (!ctrl.isView) {
      InsertCustomExpressionProperties(ctrl.pageModel, customExpressionProperties);
    }
    InsertSyncValidators(ctrl.pageModel, syncValidators);
    InsertOnChangeFunctions(ctrl.pageModel, onChangeFunctions);
    InsertOnBlurFunctions(ctrl.pageModel, onBlurFunctions);
    InsertNumericOptions(ctrl.pageModel, numericOptions);
  };

  function SetZoneIdViewComboListFilter() {
    if (ctrl.formModel.ZoneId !== null && typeof ctrl.formModel.ZoneId !== 'undefined') {
      ctrl.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        zoneId: ctrl.formModel.ZoneId,
      };
    }
    ctrl.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
  }

  ctrl.back = function back() {
    if ($stateParams.ObjectType === 'Object' || $stateParams.ObjectType === 'PropImmovable') {
      if (!ctrl.isView) {
        LockService.initiateUnlock(ctrl.securedProgramId, ctrl.securedId);
      }
      $state.go('Property.PyramidNav', { id: ctrl.formModel.PropertyId });
    } else if ($stateParams.ObjectType === 'RentableUnit') {
      $state.go('Property.PyramidNav');
    }
  };

  ctrl.save = function save() {
    if ($stateParams.ObjectType === 'Object' || $stateParams.ObjectType === 'PropImmovable') {
      if ($stateParams.ObjectType === 'Object') {
        var checkModel = angular.extend({}, ctrl.formModel, {
          PropertyId: ctrl.EditOrDuplicate === 'Duplicate' ? 0 : ctrl.formModel.PropertyId,
        });
        $http.post('Property/ObjectCheckDuplicateAddress', checkModel).then(
          function(response) {
            var data = response.data && response.data.result ? response.data.result : response.data;
            if (data && data.Exists) {
              openDuplicateWarning(data.Tenement);
            } else {
              doObjectSave();
            }
          },
          function() {
            doObjectSave();
          }
        );
      } else {
        doObjectSave();
      }
    } else if ($stateParams.ObjectType === 'RentableUnit') {
      $http
        .post(`Property/${ctrl.ObjectType}${ctrl.EditOrDuplicate}`, ctrl.formModel)
        .then(function(postResult) {
          ctrl.formly.$setPristine();
          toastr.success(ctrl.pageModel.Messages.SaveSuccessful);
          $state.go('Property.PyramidNav');
        })
        .catch(function(response) {
          toastr.error(ctrl.pageModel.Messages.SaveFailed);
        });
    }
  };

  function doObjectSave() {
    $http
      .post(`Property/${ctrl.ObjectType}${ctrl.EditOrDuplicate}`, ctrl.formModel)
      .then(function(response) {
        ctrl.formly.$setPristine();
        if (!ctrl.isView) {
          LockService.initiateUnlock(ctrl.securedProgramId, ctrl.securedId);
        }
        toastr.success(ctrl.pageModel.Messages.SaveSuccessful);
        if ($stateParams.ObjectType === 'Object' && ctrl.formModel.DEFBAC && response?.data?.InsertedId > 0) {
          ctrl.createBudgetModal(response.data.InsertedId);
        } else {
          $state.go('Property.PyramidNav');
        }
      })
      .catch(function(response) {
        toastr.error(ctrl.pageModel.Messages.SaveFailed);
      });
  }

  function openDuplicateWarning(tenement) {
    var messages = ctrl.pageModel.Messages;
    var labels = ctrl.pageModel.Labels;
    $uibModal
      .open({
        backdrop: 'static',
        windowClass: 'modal-warning',
        template:
          '<div class="modal-header">' +
          '  <h4 class="modal-title">{{mvm.warningTitle}}</h4>' +
          '</div>' +
          '<div class="modal-body">' +
          '  <p>{{mvm.warningText}}</p>' +
          '  <p ng-if="mvm.tenement"><strong>{{mvm.tenementLabel}}: {{mvm.tenement}}</strong></p>' +
          '  <p>{{mvm.confirmText}}</p>' +
          '</div>' +
          '<div class="modal-footer">' +
          '  <button type="button" class="btn btn-default" ng-click="mvm.cancel()">{{mvm.cancelLabel}}</button>' +
          '  <button type="button" class="btn btn-primary" ng-click="mvm.ok()">{{mvm.okLabel}}</button>' +
          '</div>',
        controllerAs: 'mvm',
        controller: [
          '$uibModalInstance',
          function($uibModalInstance) {
            var mvm = this;
            mvm.tenement = tenement;
            mvm.warningTitle = messages.Warning;
            mvm.warningText = labels.LabelObjectDuplicateAddress.Title;
            mvm.tenementLabel = labels.LabelObjectTenement.Title;
            mvm.confirmText = labels.LabelConfirmSave.Title;
            mvm.cancelLabel = messages.Cancel;
            mvm.okLabel = messages.Ok;
            mvm.ok = function() {
              $uibModalInstance.close();
            };
            mvm.cancel = function() {
              $uibModalInstance.dismiss('cancel');
            };
          },
        ],
      })
      .result.then(function() {
        doObjectSave();
      })
      .catch(function() {});
  }
  ctrl.createBudgetModal = function(id) {
    var modalInstance = $uibModal.open({
      templateUrl: 'App/Budget/SubItems/BudgetGenerateModal.html',
      controller: 'BudgetGenerateModalCtrl',
      controllerAs: 'vm',
      backdrop: 'static',
      resolve: {
        model: RouteResolveFunc('Budget/BudgetGenerate', { propertyId: id }),
      },
    });

    modalInstance.result.then(function(resultData) {
      $state.go('Property.PyramidNav');
    });
  };
  ctrl.attachDocument = function attachDocument() {
    var id = ctrl.formModel.PropertyId;
    DasService.NavigateToDas(ctrl.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgProperty', id);
  };

  ctrl.openEmptyFlatTransmissionFeeReport = function openEmptyFlatTransmissionFeeReport() {
    var modalInstance = $uibModal.open({
      templateUrl: 'App/Property/EmptyFlatTransmissionFeeReport.html',
      controller: 'EmptyFlatTransmissionFeeReportCtrl',
      controllerAs: 'vm',
      backdrop: 'static',
      resolve: {
        options: RouteResolveFunc('Property/EFTransFeeReportModal'),
      },
    });

    modalInstance.result.then(function(areaRentalId) {
      if (ctrl.formModel.TenType === 'PTEFL' && ctrl.formModel.IsRentable == true) {
        ctrl.generateEFTReport(ctrl.formModel.PropertyId, areaRentalId);
      } else {
        toastr.warning('A bérleményre nem generálható riport');
      }
    });
  };

  ctrl.generateEFTReport = function generateEFTReport(propertyId, areaRentalId) {
    $http
      .post('Property/GenerateEFTransFeeReport', {
        propertyId: propertyId,
        areaRentalId: areaRentalId,
      })
      .then(
        function(result) {
          var file = JSON.parse(result.data);
          var raw = atob(file.Report);
          var rawLength = raw.length;
          var array = new Uint8Array(new ArrayBuffer(rawLength));
          for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }
          var fs = new Blob([array], { type: file.MimeType });
          saveAs(fs, decodeURIComponent(file.FileName));
          toastr.success('Sikeres generálás!');
        },
        function(err) {
          console.err(err);
          // TODO error: toastr
        }
      );
  };

  ctrl.disableEmptyFlatTransmissionFeeReportButton = function disableEmptyFlatTransmissionFeeReportButton() {
    return !(ctrl.formModel.TenType === 'PTEFL' && ctrl.formModel.IsRentable);
  };
}

var propertyEditComponentOptions = {
  bindings: {
    options: '<',
  },
  controller: PropertyEditComponent,
  templateUrl: 'App/Property/property-edit/property-edit.component.html',
};

var propertyEditComponentTag = 'sbPropertyEdit';

// #endregion

function propertyRouting() {
  return {
    Property: {
      url: '/property',
      templateUrl: 'App/Property/PropertyLayout.html',
      controller: 'PropertyLayoutCtrl as vm',
      redirectTo: 'Property.PyramidNav',
      ncyBreadcrumb: {
        label: 'Ingatlan piramis',
        parent: 'main',
      },
    },
    'Property.PyramidNav': {
      url: '/pyramid',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        bstates: [
          'Property.Create',
          'Property.ObjectEdit',
          'Property.PropImmovableEdit',
          'Property.RentableUnitEdit',
          'Property.Duplicate',
          'Property.PartnerDelete',
          'Property.ObejectNav',
          'Property.PropImmovableNav',
          'Property.RentableUnitNav',
        ],
        documentEntity: 'Property_pyramid',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-pyramid-nav options="wrapper.options"></sb-pyramid-nav>',
          controller: 'pyramidWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PyramidListOptions/'),
      },
      ncyBreadcrumb: {
        skip: true,
        label: 'Navigáció',
      },
    },
    'Property.DasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/', undefined, ['tableId', 'ownerId']),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Property.ObjectNav': {
      url: '/pyramid/object/{id:int}',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        bstates: [
          'Property.GridResponsibleEdit',
          'Property.GridResponsibleDuplicate',
          'Property.GridPropertyDiscountEdit',
          'Property.GridPropertyDiscountDuplicate',
          'Property.GridPropertyDimEdit',
          'Property.GridPropertyDimDuplicate',
          'Property.GridObjAddressEdit',
          'Property.GridObjAddressDuplicate',
          'Property.GridCadastralEdit',
          'Property.GridCadastralDuplicate',
          'Property.GridProprietorsEdit',
          'Property.GridProprietorsDuplicate',
        ],
        documentEntity: 'Property_objectnav',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectNav.html',
          controller: 'ObjectNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectListOptions/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        //skip: true,
        label: 'Objektum további adatai',
      },
    },
    'Property.ObjectNavDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Property.ObjectView': {
      url: '/pyramid/objectview/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectView/', undefined, ['id']),
      },
      params: {
        isFormReadOnly: true,
        ObjectType: 'Object',
        Name: 'Objektum',
        documentEntity: 'property_objectedit',
        isCreate: false,
        EditOrDuplicate: '',
      },
      ncyBreadcrumb: {
        label: 'Objektum megtekintés',
      },
    },
    'Property.ObjectCreate': {
      url: '/pyramid/objectcreate/{id:int}?zoneId?opUnitId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectCreate/', undefined, ['id', 'zoneId', 'opUnitId']),
      },
      params: {
        isFormReadOnly: false,
        isCreate: true,
        ObjectType: 'Object',
        Name: 'Objektum',
        documentEntity: 'property_objectedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum szerkesztés',
      },
    },
    'Property.ObjectEdit': {
      url: '/pyramid/objectedit/{id:int}?zoneId?opUnitId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectEdit/', undefined, ['id', 'zoneId', 'opUnitId']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'Object',
        Name: 'Objektum',
        documentEntity: 'property_objectedit',
        isCreate: false,
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum szerkesztés',
      },
    },
    'Property.ObjectDuplicate': {
      url: '/pyramid/objectduplicate/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectDuplicate/', undefined, ['id']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'Object',
        Name: 'Objektum',
        documentEntity: 'property_objectedit',
        isCreate: false,
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Objektum szerkesztés',
      },
    },
    'Property.PropImmovableNav': {
      url: '/pyramid/propimmovable/{id:int}',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        bstates: [
          'Property.GridPremiseEdit',
          'Property.GridPremiseDuplicate',
          'Property.GridResponsibleEdit',
          'Property.GridResponsibleDuplicate',
          'Property.GridPropertyDiscountEdit',
          'Property.GridPropertyDiscountDuplicate',
          'Property.GridPropertyDimEdit',
          'Property.GridPropertyDimDuplicate',
          'Property.GridProprietorsEdit',
          'Property.GridProprietorsDuplicate',
          'Property.GridRealtiesValueEdit',
          'Property.GridRealtiesValueDuplicate',
          'Property.GridPropertyTaskEdit',
          'Property.GridPropertyTaskDuplicate',
          'Property.GridBuildingCadastralEdit',
          'Property.GridBuildingCadastralDuplicate',
          'Property.GridAnnexeEdit',
          'Property.GridAnnexeDuplicate',
          'Property.GridBlockEdit',
          'Property.GridBlockDuplicate',
          'Property.GridCertificateEdit',
          'Property.GridCertificateDuplicate',
          'Property.GridRoomInventoryCreateImmovable',
          'Property.GridRoomInventoryEditImmovable',
          'Property.GridRoomInventoryDuplicateImmovable',
          'Property.GridRoomSurfaceCreateImmovable',
          'Property.GridRoomSurfaceEditImmovable',
          'Property.GridRoomSurfaceDuplicateImmovable',
        ],
        documentEntity: 'Property_PropImmovableNav',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropImmovableNav.html',
          controller: 'PropImmovableNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableListOptions/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        //skip: true,
        label: 'Ingatlan további adatai',
      },
    },
    'Property.PropImmovableNavDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Property.PropImmovableView': {
      url: '/pyramid/propimmovableview/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableView/', undefined, ['id']),
      },
      params: {
        isFormReadOnly: true,
        ObjectType: 'PropImmovable',
        Name: 'Ingatlan',
        documentEntity: 'Property_PropImmovableedit',
        EditOrDuplicate: '',
      },
      ncyBreadcrumb: {
        label: 'Ingatlan megtekintés',
      },
    },
    'Property.PropImmovableEdit': {
      url: '/pyramid/propimmovabledit/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableEdit/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'PropImmovable',
        Name: 'Ingatlan',
        documentEntity: 'Property_PropImmovableedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Ingatlan szerkesztés',
      },
    },
    'Property.GridPropertyTaskEdit': {
      url: '/propertytask/{id:int}?propertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Task/PropertyTaskEdit.html',
          controller: 'PropertyTaskEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Task/PropertyTaskEdit/', undefined, ['id', 'propertyId']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'PropImmovable',
        Name: 'Ingatlan',
        documentEntity: 'Property_PropImmovableedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Ingatlan szerkesztés',
      },
    },
    'Property.PropImmovableCreate': {
      url: '/pyramid/propimmovablcreate/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableCreate/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'PropImmovable',
        Name: 'Ingatlan',
        documentEntity: 'Property_PropImmovableedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Ingatlan szerkesztés',
      },
    },
    'Property.PropImmovableDuplicate': {
      url: '/pyramid/propimmovablduplicate/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableDuplicate/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'PropImmovable',
        Name: 'Ingatlan',
        documentEntity: 'Property_PropImmovableedit',
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Ingatlan duplikálás',
      },
    },
    'Property.RentableUnitNav': {
      url: '/pyramid/rentableunit/{id:int}',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        bstates: [
          'Property.GridPremiseEdit',
          'Property.GridPremiseDuplicate',
          'Property.GridPropertyDimEdit',
          'Property.GridPropertyDimDuplicate',
          'Property.GridPropertyDiscountEdit',
          'Property.GridPropertyDiscountDuplicate',
          'Property.GridTenancyUtilisationEdit',
          'Property.GridTenancyUtilisationDuplicate',
          'Property.GridTenancyServiceEdit',
          'Property.GridTenancyServiceDuplicate',
          'Property.GridProprietorsEdit',
          'Property.GridProprietorsDuplicate',
          'Property.GridRealtiesValueEdit',
          'Property.GridRealtiesValueDuplicate',
          'Property.GridRentUnitCadastralEdit',
          'Property.GridRentUnitCadastralDuplicate',
          'Property.GridTenancyChequeEdit',
          'Property.GridTenancyChequeDuplicate',
          'Property.GridPropertyTaskEdit',
          'Property.GridPropertyTaskDuplicate',
          'Property.GridCertificateEdit',
          'Property.GridCertificateDuplicate',
        ],
        documentEntity: 'Property_rentableunitnav',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentableUnitNav.html',
          controller: 'RentableUnitNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentableUnitListOptions/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        //skip: true,
        label: 'Bérlemény további adatai',
      },
    },
    'Property.TenancyChequeNav': {
      url: '/pyramid/tenancycheque',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        documentEntity: 'Property_tenancychequenav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeNav.html',
          controller: 'TenancyChequeNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés',
      },
    },
    'Property.TenancyChequeEdit': {
      url: '/pyramid/tenancychequemainedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
        backState: 'Property.TenancyChequeNav',
        saveState: 'Property.TenancyChequeEdit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
      },
    },
    'Property.TenancyChequeCreate': {
      url: '/pyramid/tenancychequemainedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeCreateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
        backState: 'Property.TenancyChequeNav',
        saveState: 'Property.TenancyChequeEdit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés hozzáadása',
      },
    },
    'Property.TenancyChequeDuplicate': {
      url: '/pyramid/tenancychequemainduplicate/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
        backState: 'Property.TenancyChequeNav',
        saveState: 'Property.TenancyChequeEdit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
      },
    },
    'Property.TenancyChequeView': {
      url: '/pyramid/tenancychequemainview/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
        backState: 'Property.TenancyChequeNav',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
      },
    },
    'Property.RentableUnitNavDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Property.RentableUnitView': {
      url: '/pyramid/rentableunitview/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentableUnitView/', undefined, ['id']),
      },
      params: {
        isFormReadOnly: true,
        ObjectType: 'RentableUnit',
        Name: 'Bérlemény',
        documentEntity: 'Property_rentableunitedit',
        EditOrDuplicate: '',
        isCreate: false,
      },
      ncyBreadcrumb: {
        label: 'Bérlemény megtekintés',
      },
    },
    'Property.RentableUnitEdit': {
      url: '/pyramid/rentableunitedit/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentableUnitEdit/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'RentableUnit',
        Name: 'Bérlemény',
        documentEntity: 'Property_rentableunitedit',
        EditOrDuplicate: 'Edit',
        isCreate: false,
      },
      ncyBreadcrumb: {
        label: 'Bérlemény szerkesztés',
      },
    },
    'Property.RentableUnitCreate': {
      url: '/pyramid/rentableunitcreate/{id:int}?isnew&param',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentableUnitCreate/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'RentableUnit',
        Name: 'Bérlemény',
        documentEntity: 'Property_rentableunitedit',
        EditOrDuplicate: 'Edit',
        isCreate: true,
      },
      ncyBreadcrumb: {
        label: 'Bérlemény szerkesztés',
      },
    },
    'Property.RentableUnitDuplicate': {
      url: '/pyramid/rentableunitduplicate/{id:int}?isnew',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          template: '<sb-property-edit options="wrapper.options"></sb-property-edit>',
          controller: 'propertyEditWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentableUnitDuplicate/', undefined, ['id', 'isnew']),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'RentableUnit',
        Name: 'Bérlemény',
        documentEntity: 'Property_rentableunitedit',
        EditOrDuplicate: 'Duplicate',
        isCreate: false,
      },
      ncyBreadcrumb: {
        label: 'Bérlemény duplikálás',
      },
    },
    'Property.GridCertificateEdit': {
      url: '/pyramid/certificateedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        documentEntity: 'property_GridCertificateEdit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
      },
    },
    'Property.GridCertificateDuplicate': {
      url: '/pyramid/certificateduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        documentEntity: 'property_GridCertificateEdit',
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
      },
    },
    'Property.Map': {
      url: '/map/?{propertyId:int}?ids',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/Map.html',
          controller: 'MapCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/Map/', undefined, ['propertyId', 'ids']),
      },
      params: {
        propertyId: -1,
        ids: { array: true },
      },
      ncyBreadcrumb: {
        label: 'Térkép',
      },
    },
    'Property.CreditContractNav': {
      url: '/creditcontractnav',
      params: {
        module: 'property',
        formMode: 'Nav',
        backState: 'main',
        bstates: [
          'Property.CreditContractEdit',
          'Property.CreditContractDuplicate',
          'Property.CreditFrameworkEdit',
          'Property.ExtraInpaymentEdit',
          'Property.FinalPayOffEdit',
          'Property.CreditFrameworkDuplicate',
          'Property.ExtraInpaymentDuplicate',
          'Property.FinalPayOffDuplicate',
        ],
        documentEntity: 'property_creditcontractnav',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditContractNav.html',
          controller: 'CreditContractNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditContractListOptions/'),
      },
      ncyBreadcrumb: {
        //skip: true,
        //label: 'Bérlemény hitelszerződés megtekintése',
        label: 'Elidegenítés',
      },
    },
    'Property.CreditContractEdit': {
      url: '/CreditContractEdit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditContractEdit.html',
          controller: 'CreditContractEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditContractEdit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'CreditContractNav',
        module: 'Property',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény hitelszerződés megtekintése',
      },
    },
    'Property.CreditContractCreate': {
      url: '/CreditContractCreate/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditContractEdit.html',
          controller: 'CreditContractEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditContractCreate/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'CreditContractNav',
        module: 'Property',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény hitelszerződés megtekintése',
      },
    },
    'Property.CreditContractView': {
      url: '/CreditContractView/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditContractEdit.html',
          controller: 'CreditContractEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditContractEdit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'CreditContractNav',
        module: 'Property',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény hitelszerződés szerkesztése',
      },
    },
    'Property.CreditContractDuplicate': {
      url: '/CreditContractDuplicate/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditContractEdit.html',
          controller: 'CreditContractEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditContractDuplicate/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'CreditContractNav',
        module: 'Property',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény hitelszerződés szerkesztése',
      },
    },
    'Property.CreditFrameworkView': {
      url: '/creditframeworkview/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditFrameworkEdit.html',
          controller: 'CreditFrameworkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditFrameworkEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: '',
      },
      ncyBreadcrumb: {
        label: 'Éves hitelszerkezet megtekintése',
      },
    },
    'Property.CreditFrameworkCreate': {
      url: '/creditframeworkcreate?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditFrameworkEdit.html',
          controller: 'CreditFrameworkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditFrameworkCreate/', undefined, ['creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Éves hitelszerkezet hozzáadása',
      },
    },
    'Property.CreditFrameworkEdit': {
      url: '/creditframeworkedit/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditFrameworkEdit.html',
          controller: 'CreditFrameworkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditFrameworkEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Éves hitelszerkezet szerkesztése',
      },
    },
    'Property.CreditFrameworkDuplicate': {
      url: '/creditframeworkduplicate/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CreditFrameworkEdit.html',
          controller: 'CreditFrameworkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CreditFrameworkDuplicate/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Éves hitelszerkezet szerkesztése',
      },
    },
    'Property.FinalPayOffView': {
      url: '/finalpayoffview/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FinalPayOffEdit.html',
          controller: 'FinalPayOffEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FinalPayOffEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: '',
      },
      ncyBreadcrumb: {
        label: 'Végtörlesztés megtekintése',
      },
    },
    'Property.FinalPayOffCreate': {
      url: '/finalpayoffcreate/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FinalPayOffEdit.html',
          controller: 'FinalPayOffEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FinalPayOffCreate/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Végtörlesztés hozzáadása',
      },
    },
    'Property.FinalPayOffEdit': {
      url: '/finalpayoffedit/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FinalPayOffEdit.html',
          controller: 'FinalPayOffEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FinalPayOffEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Végtörlesztés szerkesztése',
      },
    },
    'Property.FinalPayOffDuplicate': {
      url: '/finalpayoffduplicate/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FinalPayOffEdit.html',
          controller: 'FinalPayOffEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FinalPayOffDuplicate/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Végtörlesztés szerkesztése',
      },
    },
    'Property.ExtraInpaymentView': {
      url: '/extrainpaymentview/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ExtraInpaymentEdit.html',
          controller: 'ExtraInpaymentEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ExtraInpaymentEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: '',
      },
      ncyBreadcrumb: {
        label: 'Rendkívüli befizetés megtekintése',
      },
    },
    'Property.ExtraInpaymentCreate': {
      url: '/extrainpaymentcreate/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ExtraInpaymentEdit.html',
          controller: 'ExtraInpaymentEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ExtraInpaymentCreate/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Rendkívüli befizetés hozzáadása',
      },
    },
    'Property.ExtraInpaymentEdit': {
      url: '/extrainpaymentedit/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ExtraInpaymentEdit.html',
          controller: 'ExtraInpaymentEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ExtraInpaymentEdit/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Rendkívüli befizetés szerkesztése',
      },
    },
    'Property.ExtraInpaymentDuplicate': {
      url: '/extrainpaymentduplicate/{id:int}?creditContractId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ExtraInpaymentEdit.html',
          controller: 'ExtraInpaymentEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ExtraInpaymentDuplicate/', undefined, ['id', 'creditContractId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Rendkívüli befizetés szerkesztése',
      },
    },
    'Property.NewFrameworkMod': {
      url: '/pyramid/NewFrameworkMod/',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/NewFrameworkMod.html',
          controller: 'NewFrameworkModCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/NewFrameworkMod/'),
      },
      ncyBreadcrumb: {
        label: 'Éves hitelszerkezet generálás paraméterek új évre',
      },
    },
    'Property.NextYearGenParam': {
      url: '/pyramid/NextYearGenParam/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/NextYearGenParam.html',
          controller: 'NextYearGenParamCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/NextYearGenParam/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        label: 'Követő évi számlák generálása',
      },
    },
    'Property.RoomInventoryCreate': {
      url: '/pyramid/roominventorycreate/premise/?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryCreatePremise/', undefined, ['PropertyId', 'Level']),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Premise',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
      },
    },
    'Property.FirstYearGenParam': {
      url: '/pyramid/FirstYearGenParam/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FirstYearGenParam.html',
          controller: 'FirstYearGenParamCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FirstYearGenParam/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        label: 'Első évi számlák generálása',
      },
    },
    'Property.HistoryNav': {
      url: '/history/:tableId/:idColumn/:ownerId',
      params: {
        module: 'history',
        formMode: 'Nav',
        prefix: '',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/History/HistoryNav.html',
          controller: 'HistoryNavCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveParamFunc('Property/{prefix}{tableId}History/', undefined, [
          'tableId',
          'idColumn',
          'ownerId',
        ]),
      },
      ncyBreadcrumb: {
        label: 'Történetiségi adatok',
      },
    },
    'Property.FacilityCreate': {
      url: '/pyramid/facilitycreate/',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/FacilityEdit.html',
          controller: 'FacilityEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/FacilityCreate/', undefined),
      },
      params: {
        isFormReadOnly: false,
        ObjectType: 'Facility',
        Name: 'Létesítmény',
        documentEntity: 'Property_facilityedit',
        EditOrDuplicate: 'Edit',
        isCreate: true,
      },
      ncyBreadcrumb: {
        label: 'Egylépéses létesítmény rögzítés',
      },
    },
  };
}

function propertyImmovableGridsRouting() {
  return {
    'Property.GridResponsibleEditImmovable': {
      url: '/pyramid/responsibleedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridresponsibleedit',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleViewImmovable': {
      url: '/pyramid/responsibleview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'ImmovableNav',
        Security: 'Immovable',
        documentEntity: 'property_gridresponsibleedit',
      },
      ncyBreadcrumb: {
        label: 'Felelősök megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleCreateImmovable': {
      url: '/pyramid/responsibleedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridresponsibleedit',
      },
      ncyBreadcrumb: {
        label: 'Felelős hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleDuplicateImmovable': {
      url: '/pyramid/responsibleduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleDuplicateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridresponsibleedit',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    'Property.GridBuildingCadastralEditImmovable': {
      url: '/pyramid/buildingcadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralViewImmovable': {
      url: '/pyramid/buildingcadastralview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralCreateImmovable': {
      url: '/pyramid/buildingcadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralDuplicateImmovable': {
      url: '/pyramid/buildingcadastralduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralDuplicateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralSimpliEditImmovable': {
      url: '/pyramid/buildingcadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyszerűsített egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralSimpliViewImmovable': {
      url: '/pyramid/buildingcadastralsimpliview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület kataszteri adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralSimpliCreateImmovable': {
      url: '/pyramid/buildingcadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület kataszteri adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralSimpliDuplicateImmovable': {
      url: '/pyramid/buildingcadastralsimpliduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliDuplicateImmovable/', undefined, [
          'id',
          'PropertyId',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Épület egyszerűsített egyéb adatok másolása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    'Property.GridPropertyDiscountEditImmovable': {
      url: '/pyramid/propertydiscountedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: true,
        Security: 'Immovable',
        documentEntity: 'kedvezmenyek2',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountViewImmovable': {
      url: '/pyramid/propertydiscountview/immovable/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountViewImmovable/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: false,
        Security: 'Immovable',
        documentEntity: 'kedvezmenyek2',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountCreateImmovable': {
      url: '/pyramid/propertydiscountcreate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountCreateImmovable/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Create',
        IsEdit: false,
        Security: 'Immovable',
        documentEntity: 'kedvezmenyek2',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmény hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountDuplicateImmovable': {
      url: '/pyramid/propertydiscountduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountDuplicateImmovable/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        IsEdit: false,
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
        documentEntity: 'kedvezmenyek2',
      },
    },

    'Property.GridProprietorsEditImmovable': {
      url: '/pyramid/proprietorsedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridproprietorsedit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsViewImmovable': {
      url: '/pyramid/proprietorsview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridproprietorsedit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsCreateImmovable': {
      url: '/pyramid/proprietorsedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridproprietorsedit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsDuplicateImmovable': {
      url: '/pyramid/proprietorsduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsDuplicateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridproprietorsedit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralEditImmovable': {
      url: '/pyramid/edificecadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralViewImmovable': {
      url: '/pyramid/edificecadastralview/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralViewImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralCreateImmovable': {
      url: '/pyramid/edificecadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralDuplicateImmovable': {
      url: '/pyramid/edificecadastralduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralDuplicateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralSimpliEditImmovable': {
      url: '/pyramid/edificecadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Építmény egyszerűsített kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralSimpliCreateImmovable': {
      url: '/pyramid/edificecadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyszerűsített kataszteri adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridEdificeCadastralSimpliDuplicateImmovable': {
      url: '/pyramid/edificecadastralsimpliduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliDuplicateImmovable/', undefined, [
          'id',
          'PropertyId',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Építmény egyszerűsített kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralViewImmovable': {
      url: '/pyramid/landcadastralview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralEditImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralEditImmovable': {
      url: '/pyramid/landcadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralCreateImmovable': {
      url: '/pyramid/landcadastraledit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralDuplicateImmovable': {
      url: '/pyramid/landcadastralduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralDuplicateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralSimpliViewImmovable': {
      url: '/pyramid/landcadastralsimpliview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliEditImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'egyeb-adatok',
      },
      ncyBreadcrumb: {
        label: 'Földterület egyszerűsített kataszteri adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralSimpliEditImmovable': {
      url: '/pyramid/landcadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliEditImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület egyszerű kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralSimpliCreateImmovable': {
      url: '/pyramid/landcadastralsimpliedit/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliCreateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület egyszerű kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridLandCadastralSimpliDuplicateImmovable': {
      url: '/pyramid/landcadastralsimpliduplicate/immovable/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliDuplicateImmovable/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Földterület egyszerű kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseEditImmovable': {
      url: '/pyramid/premiseedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Helyiség szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseCreateImmovable': {
      url: '/pyramid/premisecreate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Helyiség szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseViewImmovable': {
      url: '/pyramid/premiseview/immovable/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/GridPremiseViewImmovable/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseCreateImmovable': {
      url: '/pyramid/premiseedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseDuplicateImmovable': {
      url: '/pyramid/premiseduplicate/immovable/{id:int}?PropertyId?Level?PremiseTS',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseDuplicateImmovable/', undefined, [
          'id',
          'PropertyId',
          'Level',
          'PremiseTS',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueEditImmovable': {
      url: '/pyramid/realtiesvalueedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridrealtiesedit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueViewImmovable': {
      url: '/pyramid/realtiesvalueview/immovable/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueViewImmovable/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridrealtiesedit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueCreateImmovable': {
      url: '/pyramid/realtiesvalueedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridrealtiesedit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueDuplicateImmovable': {
      url: '/pyramid/realtiesvalueduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueDuplicateImmovable/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridrealtiesedit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    'Property.GridAnnexeEditImmovable': {
      url: '/pyramid/annexeedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridannexeedit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridAnnexeViewImmovable': {
      url: '/pyramid/annexeview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridannexeedit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridAnnexeCreateImmovable': {
      url: '/pyramid/annexeedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        Security: 'Immovable',
        EditOrDuplicate: 'Edit',
        documentEntity: 'property_gridannexeedit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridAnnexeDuplicateImmovable': {
      url: '/pyramid/annexeduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeDuplicateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridannexeedit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBlockEditImmovable': {
      url: '/pyramid/blockedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockEditImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridblockedit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBlockViewImmovable': {
      url: '/pyramid/blockview/immovable/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockViewImmovable/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridblockedit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBlockCreateImmovable': {
      url: '/pyramid/blockedit/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockCreateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridblockedit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBlockDuplicateImmovable': {
      url: '/pyramid/blockduplicate/immovable/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockDuplicateImmovable/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridblockedit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryEditImmovable': {
      url: '/pyramid/roominventoryedit/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryEditImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridroominventoryedit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryCreateImmovable': {
      url: '/pyramid/roominventoryedit/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryCreateImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridroominventoryedit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryDuplicateImmovable': {
      url: '/pyramid/roominventoryduplicate/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryDuplicateImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridroominventoryedit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryViewImmovable': {
      url: '/pyramid/roominventoryview/immovable/{id:int}?PremiseId?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryViewImmovable/', undefined, ['id', 'PremiseId', 'PropertyId']),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridroominventoryedit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceEditImmovable': {
      url: '/pyramid/roomsurfaceedit/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceEditImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceViewImmovable': {
      url: '/pyramid/roomsurfaceview/immovable/{id:int}?PremiseId?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceViewImmovable/', undefined, ['id', 'PremiseId', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceCreateImmovable': {
      url: '/pyramid/roomsurfaceedit/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceCreateImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Felület hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceDuplicateImmovable': {
      url: '/pyramid/roomsurfaceduplicate/immovable/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceDuplicateImmovable/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateEditImmovable': {
      url: '/pyramid/certificateedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableCertificateEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridcertificateedit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.dataModel && !!$scope.vm.dataModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.dataModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateViewImmovable': {
      url: '/pyramid/certificateview/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableCertificateView/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridcertificateedit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.dataModel && !!$scope.vm.dataModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.dataModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateCreateImmovable': {
      url: '/pyramid/certificateedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableCertificateCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Immovable',
        documentEntity: 'property_gridcertificateedit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.dataModel && !!$scope.vm.dataModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.dataModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateDuplicateImmovable': {
      url: '/pyramid/certificateduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropImmovableCertificateDuplicate/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Immovable',
        documentEntity: 'property_gridcertificateedit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.dataModel && !!$scope.vm.dataModel.PropertyId
            ? 'Property.PropImmovableNav({id: ' + $scope.vm.dataModel.PropertyId + '})'
            : 'main';
        },
      },
    },
  };
}

function propertyObjectGridsRouting() {
  return {
    'Property.GridResponsibleEditObject': {
      url: '/pyramid/responsibleedit/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleEditObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: 'Property.ObjectNav',
      },
    },
    'Property.GridResponsibleCreateObject': {
      url: '/pyramid/responsiblecreate/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleCreateObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Felelős hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleDuplicateObject': {
      url: '/pyramid/responsibleduplicate/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleDuplicateObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleViewObject': {
      url: '/pyramid/responsibleview/object/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleViewObject/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        BackTo: 'ObjectNav',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralEditObject': {
      url: '/pyramid/cadastraledit/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralEditObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: false,
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralCreateObject': {
      url: '/pyramid/cadastralcreate/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralCreateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: true,
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralViewObject': {
      url: '/pyramid/cadastralview/object/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjectCadastralView/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralDuplicateObject': {
      url: '/pyramid/cadastralduplicate/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralDuplicateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: false,
        EditOrDuplicate: 'Duplicate',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralSimpliEditObject': {
      url: '/pyramid/cadastralsimpliedit/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralSimpliEdit.html',
          controller: 'ObjectCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralSimpliEditObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: false,
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyszerű kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralSimpliCreateObject': {
      url: '/pyramid/cadastralsimplicreate/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralSimpliEdit.html',
          controller: 'ObjectCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralSimpliCreateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: true,
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyszerű kataszteri adat hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralSimpliViewObject': {
      url: '/pyramid/cadastralsimpliview/object/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralSimpliEdit.html',
          controller: 'ObjectCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralSimpliViewObject/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyszerű kataszteri adatok szerkesztése',
      },
    },
    'Property.GridCadastralSimpliDuplicateObject': {
      url: '/pyramid/cadastralsimpliduplicate/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralSimpliEdit.html',
          controller: 'ObjectCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralSimpliDuplicateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        isCreate: false,
        EditOrDuplicate: 'Duplicate',
        Security: 'Object',
        documentEntity: 'property_gridcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyszerű kataszteri adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountEditObject': {
      url: '/pyramid/propertydiscountedit/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountEditObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: true,
        Security: 'Object',
        documentEntity: 'property_gridpropertydiscountedit',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountCreateObject': {
      url: '/pyramid/propertydiscountcreate/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountCreateObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Create',
        IsEdit: false,
        Security: 'Object',
        documentEntity: 'property_gridpropertydiscountedit',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmény hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountDuplicateObject': {
      url: '/pyramid/propertydiscountduplicate/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountDuplicateObject/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        IsEdit: false,
        Security: 'Object',
        documentEntity: 'property_gridpropertydiscountedit',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountViewObject': {
      url: '/pyramid/propertydiscountview/object/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountViewObject/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: false,
        Security: 'Object',
        documentEntity: 'property_gridpropertydiscountedit',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    //objektum címek
    'Property.GridObjAddressEditObject': {
      url: '/pyramid/objaddressedit/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressEditObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridobjaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Objektum címek szerkesztése',
        parent: 'Property.ObjectNav({id: "PropertyId"})',
      },
    },
    'Property.GridObjAddressCreateObject': {
      url: '/pyramid/objaddressedit/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressCreateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
        documentEntity: 'property_gridobjaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Objektum cím hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridObjAddressDuplicateObject': {
      url: '/pyramid/objaddressduplicate/object/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressDuplicateObject/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Object',
        documentEntity: 'property_gridobjaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Objektum címek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridObjAddressViewObject': {
      url: '/pyramid/objaddressview/object/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressView/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'Object',
        documentEntity: 'property_gridobjaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Objektum címek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    //objektum címek vége

    'Property.GridProprietorsCreateObject': {
      url: '/pyramid/proprietorsedit/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsCreateObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostárs hozzáadása',
      },
    },
    'Property.GridProprietorsEditObject': {
      url: '/pyramid/proprietorsedit/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsEditObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsViewObject': {
      url: '/pyramid/proprietorsview/object/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsViewObject/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'Object',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    'Property.GridProprietorsDuplicateObject': {
      url: '/pyramid/proprietorsduplicate/object/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsDuplicateObject/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'object',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
  };
}

function rentableUnitGridsRouting() {
  return {
    'Property.GridTenancyServiceEditRentableUnit': {
      url: '/pyramid/tenancyserviceedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyserviceedit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyServiceViewRentableUnit': {
      url: '/pyramid/tenancyserviceview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyserviceedit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyServiceCreateRentableUnit': {
      url: '/pyramid/tenancyserviceedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceCreateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyserviceedit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatás hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyServiceDuplicateRentableUnit': {
      url: '/pyramid/tenancyserviceduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyserviceedit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyUtilisationEditRentableUnit': {
      url: '/pyramid/tenancyutilisationedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyutilisationedit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyUtilisationViewRentableUnit': {
      url: '/pyramid/tenancyutilisationview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyutilisationedit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyUtilisationCreateRentableUnit': {
      url: '/pyramid/tenancyutilisationedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationCreateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyutilisationedit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyUtilisationDuplicateRentableUnit': {
      url: '/pyramid/tenancyutilisationduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancyutilisationedit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountEditRentableUnit': {
      url: '/pyramid/propertydiscountedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountEditRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: true,
        Security: 'RentableUnit',
        documentEntity: 'kedvezmenyek3',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountViewRentableUnit': {
      url: '/pyramid/propertydiscountview/rentableunit/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountViewRentableUnit/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: false,
        Security: 'RentableUnit',
        documentEntity: 'kedvezmenyek3',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountCreateRentableUnit': {
      url: '/pyramid/propertydiscountcreate/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountCreateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Create',
        IsEdit: false,
        Security: 'RentableUnit',
        documentEntity: 'kedvezmenyek3',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmény hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountDuplicateRentableUnit': {
      url: '/pyramid/propertydiscountduplicate/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountDuplicateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        IsEdit: false,
        Security: 'RentableUnit',
        documentEntity: 'kedvezmenyek3',
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },

    'Property.GridProprietorsEditRentableUnit': {
      url: '/pyramid/proprietorsedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsEditRentableUnit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'tulajdonreszek',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsViewRentableUnit': {
      url: '/pyramid/proprietorsview/rentableunit/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsViewRentableUnit/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'tulajdonreszek',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsCreateRentableUnit': {
      url: '/pyramid/proprietorsedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsCreateRentableUnit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'tulajdonreszek',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridProprietorsDuplicateRentableUnit': {
      url: '/pyramid/proprietorsduplicate/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsDuplicateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'tulajdonreszek',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },

    'Property.GridPremiseEditRentableUnit': {
      url: '/pyramid/premiseedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseEditRentableUnit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'helyisegek2',
      },
      ncyBreadcrumb: {
        label: 'Helyiség szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseViewRentableUnit': {
      url: '/pyramid/premiseview/rentableunit/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/GridPremiseViewRentableUnit/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'helyisegek2',
      },
      ncyBreadcrumb: {
        label: 'Helyiség megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseCreateRentableUnit': {
      url: '/pyramid/premiseedit/rentableunit/{id:int}?RentUnitId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseCreateRentableUnit/', undefined, ['id', 'RentUnitId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'helyisegek2',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPremiseDuplicateRentableUnit': {
      url: '/pyramid/premiseduplicate/rentableunit/{id:int}?PropertyId?Level?PremiseTS',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseDuplicateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
          'PremiseTS',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'helyisegek2',
      },
      ncyBreadcrumb: {
        label: 'Helyiség másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueEditRentableUnit': {
      url: '/pyramid/realtiesvalueedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueEditRentableUnit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'ertekelesek',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueViewRentableUnit': {
      url: '/pyramid/realtiesvalueview/rentableunit/{id:int}?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueViewRentableUnit/', undefined, ['id', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'ertekelesek',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueCreateRentableUnit': {
      url: '/pyramid/realtiesvalueedit/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueCreateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'ertekelesek',
      },
      ncyBreadcrumb: {
        label: 'Értékelés hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRealtiesValueDuplicateRentableUnit': {
      url: '/pyramid/realtiesvalueduplicate/rentableunit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueDuplicateRentableUnit/', undefined, [
          'id',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'ertekelesek',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },

    'Property.GridTenancyChequeEditRentableUnit': {
      url: '/pyramid/tenancychequeedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyChequeViewRentableUnit': {
      url: '/pyramid/tenancychequeview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyChequeCreateRentableUnit': {
      url: '/pyramid/tenancychequeedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeCreateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridTenancyChequeDuplicateRentableUnit': {
      url: '/pyramid/tenancychequeduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridtenancychequeedit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateEditRentableUnit': {
      url: '/pyramid/certificateedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.dataModel &&
            !!$scope.vm.dataModel.RentUnitId &&
            !!$scope.vm.dataModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateViewRentableUnit': {
      url: '/pyramid/certificateview/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateView/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateCreateRentableUnit': {
      url: '/pyramid/certificateedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridCertificateDuplicateRentableUnit': {
      url: '/pyramid/certificateduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/CertificateEdit.html',
          controller: 'CertificateEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CertificateDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Energia tanúsítvány szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralEditRentableUnit': {
      url: '/pyramid/rentunitcadastraledit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralViewRentableUnit': {
      url: '/pyramid/rentunitcadastralview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralCreateRentableUnit': {
      url: '/pyramid/rentunitcadastraledit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralCreateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralDuplicateRentableUnit': {
      url: '/pyramid/rentunitcadastralduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralSimpliEditRentableUnit': {
      url: '/pyramid/rentunitcadastralsimpliedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyszerűsített egyéb adatok szerkesztése',
        parent: function($scope) {
          // return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.RentUnitId && !!$scope.vm.formModel.RentUnitId.Value
          // ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
          // : 'main';
          return !!$scope.vm && !!$scope.vm.formModel.PropertyId
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralSimpliViewRentableUnit': {
      url: '/pyramid/rentunitcadastralsimpliview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyszerűsített egyéb adatok megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralSimpliCreateRentableUnit': {
      url: '/pyramid/rentunitcadastralsimpliedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliCreateRentableUnit/', undefined, [
          'id',
          'PropertyId',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyszerűsített egyéb adatok hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRentUnitCadastralSimpliDuplicateRentableUnit': {
      url: '/pyramid/rentunitcadastralsimpliduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliDuplicateRentableUnit/', undefined, [
          'id',
          'PropertyId',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_gridrentunitcadastraledit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyszerűsített egyéb adatok másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryEditRentableUnit': {
      url: '/pyramid/roominventoryedit/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryEditRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryCreateRentableUnit': {
      url: '/pyramid/roominventoryedit/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryCreateRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryDuplicateRentableUnit': {
      url: '/pyramid/roominventoryduplicate/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryDuplicateRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomInventoryViewRentableUnit': {
      url: '/pyramid/roominventoryview/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryEditRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceEditRentableUnit': {
      url: '/pyramid/roomsurfaceedit/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceEditRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceCreateRentableUnit': {
      url: '/pyramid/roomsurfaceedit/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceCreateRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceDuplicateRentableUnit': {
      url: '/pyramid/roomsurfaceduplicate/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceDuplicateRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridRoomSurfaceViewRentableUnit': {
      url: '/pyramid/roomsurfaceview/rentableunit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceEditRentableUnit/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyUsageEditRentableUnit': {
      url: '/pyramid/propertyusageedit/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyUsageEdit.html',
          controller: 'PropertyUsageEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyUsageEditRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_GridPropertyUsageEdit',
      },
      ncyBreadcrumb: {
        label: 'Használatra kiadás szerkesztése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyUsageViewRentableUnit': {
      url: '/pyramid/propertyusageview/rentableunit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyUsageEdit.html',
          controller: 'PropertyUsageEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyUsageViewRentableUnit/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_GridPropertyUsageedit',
      },
      ncyBreadcrumb: {
        label: 'Használatra kiadás megtekintése',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyUsageCreateRentableUnit': {
      url: '/pyramid/propertyusagecreate/rentableunit/?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyUsageEdit.html',
          controller: 'PropertyUsageEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyUsageCreateRentableUnit/', undefined, ['PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        Security: 'RentableUnit',
        documentEntity: 'property_GridPropertyUsageedit',
      },
      ncyBreadcrumb: {
        label: 'Használatra kiadás hozzáadása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyUsageDuplicateRentableUnit': {
      url: '/pyramid/propertyusageduplicate/rentableunit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyUsageEdit.html',
          controller: 'PropertyUsageEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyUsageDuplicateRentableUnit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        Security: 'RentableUnit',
        documentEntity: 'property_GridPropertyUsageedit',
      },
      ncyBreadcrumb: {
        label: 'Használatra kiadás másolása',
        parent: function($scope) {
          return !!$scope.vm &&
            !!$scope.vm.formModel &&
            !!$scope.vm.formModel.RentUnitId &&
            !!$scope.vm.formModel.RentUnitId.Value
            ? 'Property.RentableUnitNav({id: ' + $scope.vm.formModel.RentUnitId.Value + '})'
            : 'main';
        },
      },
    },
  };
}

function propertyAllGridsRouting() {
  return {
    'Property.GridResponsibleEdit': {
      url: '/pyramid/responsibleedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleCreate': {
      url: '/pyramid/responsibleedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Felelős hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridResponsibleDuplicate': {
      url: '/pyramid/responsibleduplicate/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ResponsibleEdit.html',
          controller: 'ResponsibleEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ResponsibleDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Felelősök szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralEdit': {
      url: '/pyramid/cadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralCreate': {
      url: '/pyramid/cadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridCadastralDuplicate': {
      url: '/pyramid/cadastralduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjectCadastralEdit.html',
          controller: 'ObjectCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/CadastralDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Objektum egyéb adatok szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridBuildingCadastralEdit': {
      url: '/pyramid/buildingcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok szerkesztése',
      },
    },
    'Property.GridBuildingCadastralCreate': {
      url: '/pyramid/buildingcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok hozzáadása',
      },
    },
    'Property.GridBuildingCadastralDuplicate': {
      url: '/pyramid/buildingcadastralduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralEdit.html',
          controller: 'BuildingCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Épület egyéb adatok szerkesztése',
      },
    },

    'Property.GridTenancyServiceEdit': {
      url: '/pyramid/tenancyserviceedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások szerkesztése',
      },
    },
    'Property.GridTenancyServiceCreate': {
      url: '/pyramid/tenancyserviceedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások szerkesztése',
      },
    },
    'Property.GridTenancyServiceDuplicate': {
      url: '/pyramid/tenancyserviceduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyServiceEdit.html',
          controller: 'TenancyServiceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyServiceDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Kiépített szolgáltatások szerkesztése',
      },
    },
    'Property.GridTenancyUtilisationEdit': {
      url: '/pyramid/tenancyutilisationedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság szerkesztése',
      },
    },
    'Property.GridTenancyUtilisationCreate': {
      url: '/pyramid/tenancyutilisationedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság szerkesztése',
      },
    },
    'Property.GridTenancyUtilisationDuplicate': {
      url: '/pyramid/tenancyutilisationduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyUtilisationEdit.html',
          controller: 'TenancyUtilisationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyUtilisationDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Kihasználtság szerkesztése',
      },
    },
    'Property.GridPropertyDiscountEdit': {
      url: '/pyramid/propertydiscountedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        IsEdit: true,
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountCreate': {
      url: '/pyramid/propertydiscountcreate/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Create',
        IsEdit: false,
      },
      ncyBreadcrumb: {
        label: 'Kedvezmény hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridPropertyDiscountDuplicate': {
      url: '/pyramid/propertydiscountduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PropertyDiscountEdit.html',
          controller: 'PropertyDiscountEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PropertyDiscountDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        IsEdit: false,
      },
      ncyBreadcrumb: {
        label: 'Kedvezmények szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },

    //objektum címek
    'Property.GridObjAddressEdit': {
      url: '/pyramid/objaddressedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum címek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridObjAddressCreate': {
      url: '/pyramid/objaddressedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Objektum cím hozzáadása',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    'Property.GridObjAddressDuplicate': {
      url: '/pyramid/objaddressduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ObjAddressEdit.html',
          controller: 'ObjAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ObjAddressDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Objektum címek szerkesztése',
        parent: function($scope) {
          return !!$scope.vm && !!$scope.vm.formModel && !!$scope.vm.formModel.PropertyId
            ? 'Property.ObjectNav({id: ' + $scope.vm.formModel.PropertyId + '})'
            : 'main';
        },
      },
    },
    //objektum címek vége

    'Property.GridProprietorsEdit': {
      url: '/pyramid/proprietorsedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
      },
    },
    'Property.GridProprietorsCreate': {
      url: '/pyramid/proprietorsedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostárs hozzáadása',
      },
    },
    'Property.GridProprietorsDuplicate': {
      url: '/pyramid/proprietorsduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/ProprietorsEdit.html',
          controller: 'ProprietorsEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/ProprietorsDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Tulajdonostársak szerkesztése',
      },
    },
    'Property.GridEdificeCadastralEdit': {
      url: '/pyramid/edificecadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridEdificeCadastralCreate': {
      url: '/pyramid/edificecadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridEdificeCadastralDuplicate': {
      url: '/pyramid/edificecadastralduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralEdit.html',
          controller: 'EdificeCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralEdit': {
      url: '/pyramid/landcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralCreate': {
      url: '/pyramid/landcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralDuplicate': {
      url: '/pyramid/landcadastralduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralEdit.html',
          controller: 'LandCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridRentUnitCadastralEdit': {
      url: '/pyramid/rentunitcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok szerkesztése',
      },
    },
    'Property.GridRentUnitCadastralCreate': {
      url: '/pyramid/rentunitcadastraledit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok hozzáadása',
      },
    },
    'Property.GridRentUnitCadastralDuplicate': {
      url: '/pyramid/rentunitcadastralduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralEdit.html',
          controller: 'RentUnitCadastralEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény egyéb adatok szerkesztése',
      },
    },
    'Property.GridPremiseEdit': {
      url: '/pyramid/premiseedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
      },
    },
    'Property.GridPremiseCreate': {
      url: '/pyramid/premiseedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
      },
    },
    'Property.GridPremiseDuplicate': {
      url: '/pyramid/premiseduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/PremiseEdit.html',
          controller: 'PremiseEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/PremiseDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Új helyiség létrehozása',
      },
    },
    'Property.GridRealtiesValueEdit': {
      url: '/pyramid/realtiesvalueedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
      },
    },
    'Property.GridRealtiesValueCreate': {
      url: '/pyramid/realtiesvalueedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Értékelés hozzáadása',
      },
    },
    'Property.GridRealtiesValueDuplicate': {
      url: '/pyramid/realtiesvalueduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RealtiesValueEdit.html',
          controller: 'RealtiesValueEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RealtiesValueDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Értékelés szerkesztése',
      },
    },
    'Property.GridRoomSurfaceEdit': {
      url: '/pyramid/roomsurfaceedit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceEdit/', undefined, ['id', 'PremiseId', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
      },
    },
    'Property.GridRoomSurfaceCreate': {
      url: '/pyramid/roomsurfaceedit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceCreate/', undefined, ['id', 'PremiseId', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
      },
    },
    'Property.GridRoomSurfaceDuplicate': {
      url: '/pyramid/roomsurfaceduplicate{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomSurfaceEdit.html',
          controller: 'RoomSurfaceEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomSurfaceDuplicate/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Felületek szerkesztése',
      },
    },
    'Property.GridRoomInventoryEdit': {
      url: '/pyramid/roominventoryedit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryEdit/', undefined, ['id', 'PremiseId', 'PropertyId', 'Level']),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
      },
    },
    'Property.GridRoomInventoryCreate': {
      url: '/pyramid/roominventoryedit/{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryCreate/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
      },
    },
    'Property.GridRoomInventoryDuplicate': {
      url: '/pyramid/roominventoryduplicate{id:int}?PremiseId?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RoomInventoryEdit.html',
          controller: 'RoomInventoryEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RoomInventoryDuplicate/', undefined, [
          'id',
          'PremiseId',
          'PropertyId',
          'Level',
        ]),
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Berendezés helyiségekhez rendelése',
      },
    },
    'Property.GridAnnexeEdit': {
      url: '/pyramid/annexeedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny szerkesztése',
      },
    },
    'Property.GridAnnexeCreate': {
      url: '/pyramid/annexeedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny hozzáadása',
      },
    },
    'Property.GridAnnexeDuplicate': {
      url: '/pyramid/annexeduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/AnnexeEdit.html',
          controller: 'AnnexeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/AnnexeDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Épületszárny szerkesztése',
      },
    },
    'Property.GridBlockEdit': {
      url: '/pyramid/blockedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockEdit/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk szerkesztése',
      },
    },
    'Property.GridBlockCreate': {
      url: '/pyramid/blockedit/{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockCreate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk hozzáadása',
      },
    },
    'Property.GridBlockDuplicate': {
      url: '/pyramid/blockduplicate{id:int}?PropertyId?Level',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BlockEdit.html',
          controller: 'BlockEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BlockDuplicate/', undefined, ['id', 'PropertyId', 'Level']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Épületblokk szerkesztése',
      },
    },
    'Property.GridTenancyChequeEdit': {
      url: '/pyramid/tenancychequeedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
      },
    },
    'Property.GridTenancyChequeCreate': {
      url: '/pyramid/tenancychequeedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés hozzáadása',
      },
    },
    'Property.GridTenancyChequeDuplicate': {
      url: '/pyramid/tenancychequeduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/TenancyChequeEdit.html',
          controller: 'TenancyChequeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/TenancyChequeDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Bérleményellenőrzés szerkesztése',
      },
    },

    'Property.GridBuildingCadastralSimpliEdit': {
      url: '/pyramid/buildingcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridBuildingCadastralSimpliCreate': {
      url: '/pyramid/buildingcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Épület kataszteri adatok hozzáadása',
      },
    },
    'Property.GridBuildingCadastralSimpliDuplicate': {
      url: '/pyramid/buildingcadastralsimpliduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/BuildingCadastralSimpliEdit.html',
          controller: 'BuildingCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/BuildingCadastralSimpliDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Épület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridEdificeCadastralSimpliEdit': {
      url: '/pyramid/edificecadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridEdificeCadastralSimpliCreate': {
      url: '/pyramid/edificecadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridEdificeCadastralSimpliDuplicate': {
      url: '/pyramid/edificecadastralsimpliduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/EdificeCadastralSimpliEdit.html',
          controller: 'EdificeCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/EdificeCadastralSimpliDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Építmény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralSimpliEdit': {
      url: '/pyramid/landcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralSimpliCreate': {
      url: '/pyramid/landcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridLandCadastralSimpliDuplicate': {
      url: '/pyramid/landcadastralsimpliduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/LandCadastralSimpliEdit.html',
          controller: 'LandCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/LandCadastralSimpliDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Földterület kataszteri adatok szerkesztése',
      },
    },
    'Property.GridRentUnitCadastralSimpliEdit': {
      url: '/pyramid/rentunitcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliEdit/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény kataszteri adatok szerkesztése',
      },
    },
    'Property.GridRentUnitCadastralSimpliCreate': {
      url: '/pyramid/rentunitcadastralsimpliedit/{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliCreate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény kataszteri adatok hozzáadása',
      },
    },
    'Property.GridRentUnitCadastralSimpliDuplicate': {
      url: '/pyramid/rentunitcadastralsimpliduplicate{id:int}?PropertyId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Property/RentUnitCadastralSimpliEdit.html',
          controller: 'RentUnitCadastralSimpliEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Property/RentUnitCadastralSimpliDuplicate/', undefined, ['id', 'PropertyId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Bérlemény kataszteri adatok szerkesztése',
      },
    },
  };
}

var propertyModule = angular
  .module('sbProperty', [])
  .component(pyramidTreeViewComponentTag, pyramidTreeViewComponentOptions)
  .component(propertyShortDetailsFormTag, propertyShortDetailsFormOptions)
  .component(propertyGridDetailTag, propertyGridDetailOptions)
  .component(pyramidTableViewTag, pyramidTableViewOptions)
  .component(premiseTableViewTag, premiseTableViewOptions)
  .component(pyramidComponentTag, pyramidComponentOptions)
  .component(propertyEditComponentTag, propertyEditComponentOptions)
  .component(premiseTableDetailComponentTag, premiseTableDetailComponentOptions)
  .config([
    '$stateProvider',
    function($stateProvider) {
      let propertyRoutingStates = propertyRouting();

      angular.forEach(propertyRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });

      let propertyImmovableGridsRoutingStates = propertyImmovableGridsRouting();

      angular.forEach(propertyImmovableGridsRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });

      let propertyObjectGridsRoutingStates = propertyObjectGridsRouting();

      angular.forEach(propertyObjectGridsRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });

      let rentableUnitGridsRoutingStates = rentableUnitGridsRouting();

      angular.forEach(rentableUnitGridsRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });

      let allGridsStates = propertyAllGridsRouting();

      angular.forEach(allGridsStates, function(value, key) {
        $stateProvider.state(key, value);
      });
    },
  ]).name;

'use strict';

(function(module) {
  module.controller('pyramidWrapperCtrl', [
    'options',
    function(options) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'pyramidWrapperCtrl', stateParams);
      }
      var vm = this;

      vm.options = options;
    },
  ]);
})(angular.module('sbProperty'));

'use strict';

(function(module) {
  module.controller('propertyEditWrapperCtrl', [
    'options',
    '$stateParams',
    function(options, $stateParams) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'propertyEditWrapperCtrl', stateParams);
      }
      var vm = this;

      vm.options = options;
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ObjectEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ObjectEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.IsParent = options.dto.IsParent;
      vm.ObjectType = $stateParams.ObjectType;
      vm.TypeName = $stateParams.Name;
      vm.isCreate = $stateParams.isCreate;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isView = vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly;
      var zoneId = vm.formModel.ZoneId;
      var opUnitId = vm.formModel.OpUnitId;
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.isView) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      // Usage: "fieldName": {expressionFnName1: expressionFn1, expressionFnName2: expressionFn2}
      var customExpressionProperties = {
        ZoneId: {
          'templateOptions.disabled': function() {
            if (vm.IsParent && vm.EditOrDuplicate !== 'Duplicate') {
              return true;
            } else {
              return zoneId !== null && zoneId !== 0;
            }
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !vm.isCreate;
          },
        },
        OpUnitId: {
          'templateOptions.required': function() {
            return true;
          },
          'templateOptions.disabled': function() {
            if (vm.IsParent && vm.EditOrDuplicate !== 'Duplicate') {
              return true;
            } else {
              return opUnitId !== null && opUnitId !== 0;
            }
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            if (vm.IsParent && vm.EditOrDuplicate !== 'Duplicate') {
              return true;
            }
          },
        },
        Country: {
          'templateOptions.disabled': function() {
            if (vm.IsParent && vm.EditOrDuplicate !== 'Duplicate') {
              return true;
            }
          },
        },
        FloorSpace: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        TopogrNumber: {
          'templateOptions.disabled': function() {
            return false;
          },
        },
        StreetNumber: {
          'templateOptions.disabled': function() {
            return false;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatorFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        ValidFrom: {
          ObjectValidFromValidator: function(modelValue, viewValue) {
            var currValidFrom = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (vm.formModel.PropertyId === 0) {
              return currValidFrom.isSameOrAfter(validFrom);
            } else {
              return true;
            }
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatorFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ZoneId: function() {
          SetZoneIdViewComboListFilter();
        },
      };

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};
      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem) --lostfocus
      var onBlurFunctions = {
        PostCode: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Value).then(
                function(result) {
                  var locality = result.data.result.Value;
                  if (locality) {
                    vm.formModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                  }
                },
                function(error) {}
              );
            }
          }
        },
        Locality: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
                function(result) {
                  var postcode = result.data.result.Value;
                  if (postcode) {
                    if (
                      !vm.formModel.PostCode ||
                      !vm.formModel.PostCode.Value ||
                      postcode === vm.formModel.PostCode.Value
                    ) {
                      vm.formModel.PostCode = {
                        Text: postcode,
                        Value: postcode,
                      };
                    } else {
                      $http.get('Partner/GetAllLocalities?postcode=' + vm.formModel.PostCode.Value).then(
                        function(result) {
                          var localities = result.data.result.Localities;
                          if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                            vm.formModel.PostCode = {
                              Text: postcode,
                              Value: postcode,
                            };
                          }
                        },
                        function(error) {}
                      );
                    }
                  }
                },
                function(error) {}
              );
            }
          }
        },
      };

      var numericOptions = {
        Eastern: {
          decimals: 10,
          format: 'n9',
          max: 90,
          min: -90,
        },
        Northern: {
          decimals: 11,
          format: 'n9',
          max: 180,
          min: -180,
        },
        FloorSpace: {
          decimals: 2,
          format: 'n10',
          max: 9999999999,
          min: 0,
        },
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors

      InsertCustomClasses(vm.pageModel, customClasses);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////

      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.pageModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelObjectPanel.FormlyDescriptor;

      SetZoneIdViewComboListFilter();

      function SetZoneIdViewComboListFilter() {
        if (vm.formModel.ZoneId !== null && typeof vm.formModel.ZoneId !== 'undefined') {
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            zoneId: vm.formModel.ZoneId,
          };
        }
        vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      vm.save = function() {
        $http
          .post('Property/' + vm.ObjectType + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            if (!vm.isView) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            toastr.success('Mentés sikeresen megtörtént!'); // TODO általános label
            $state.go('Property.PyramidNav');
          })
          .catch(function(response) {
            toastr.error(response.message); // TODO általános label
          });
      };

      vm.back = function() {
        if (!vm.isView) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Property.PyramidNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        // var id = vm.formModel.ResponsibleId;
        // dasService.NavigateToDas(vm.pageModel.Messages,"Property.DasDocumentsNav","FlgResponsible", id );
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      };

      function validateTopogrNumber(topogrNumber) {
        return /^[0-9]{3,6}(\/[0-9]{1,3})?$/.test(topogrNumber);
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RentableUnitEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    '$uibModal',
    'DasService',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, $state, $uibModal, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentableUnitEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.ObjectType = $stateParams.ObjectType;
      vm.TypeName = $stateParams.Name;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isCreate = $stateParams.isCreate;
      vm.attachDocument = attachDocument;
      vm.isView = vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.isView && !vm.isCreate) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      var floorSpace = vm.formModel.FloorSpace;
      var cubicMetre = vm.formModel.CubicMetre;
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.pageModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.panelRentableFormFields = formlyFormPanelDescriptors.PanelRentable.FormlyDescriptor;
      vm.panelDimensionFormFields = formlyFormPanelDescriptors.PanelDimension.FormlyDescriptor;
      vm.pageModel.Fields.RoomAtomatically.FormlyFieldDescriptor.hide = true;

      var customExpressionProperties = {
        //TenType: {
        //  'templateOptions.disabled': function() {
        //    if (vm.formModel.PropertyId !== 0 && vm.EditOrDuplicate !== 'Duplicate') {
        //      return true;
        //    }
        //  },
        //},
        FloorSpace: {
          'templateOptions.disabled': function() {
            return !vm.formModel.RoomAtomatically;
          },
        },
        RentableSpace: {
          'templateOptions.disabled': function() {
            return !vm.formModel.RoomAtomatically;
          },
        },
        CubicMeter: {
          'templateOptions.disabled': function() {
            return !vm.formModel.RoomAtomatically;
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !(vm.isCreate || vm.EditOrDuplicate === 'Duplicate');
          },
          'templateOptions.required': function() {
            return true;
          },
        },
        StairWay: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.TenType === 'PTEFL' || vm.formModel.TenType === 'PTEPR');
          },
        },
        Floor: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.TenType === 'PTEFL' || vm.formModel.TenType === 'PTEPR');
          },
        },
        Door: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.TenType === 'PTEFL' || vm.formModel.TenType === 'PTEPR');
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        TopogrNumber: {
          TopogrNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return true;
          },
        },
        ValidFrom: {
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
          RentableUnitCreateValidFromNowValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var d = new Date();
            if (ValidFromValue._d >= d) {
              return false;
            }
            return true;
          },
        },
        FloorSpace: {
          PositiveNumberValidator: function(modelValue) {
            if (!vm.formModel.RoomAtomatically) {
              return true;
            }
            if (kendo.parseInt(modelValue) > 0) {
              return true;
            }
            return false;
          },
        },
        RentableSpace: {
          FloorSpaceFullAreaValidator: function(modelValue) {
            if (!vm.formModel.RoomAtomatically) {
              return true;
            }
            if (kendo.parseInt(modelValue) >= vm.formModel.RentableSpace) {
              return true;
            }
            return false;
          },
        },
        CubicMeter: {
          DecimalValidator: function(modelValue) {
            if (!vm.formModel.RoomAtomatically) {
              return true;
            }
            if (kendo.parseInt(modelValue) >= 0) {
              return true;
            }
            return false;
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var numericOptions = {
        RentableSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        FloorSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        CubicMeter: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
      };

      InsertNumericOptions(vm.pageModel, numericOptions);

      vm.save = function() {
        $http
          .post(`Property/${vm.ObjectType}${vm.EditOrDuplicate}`, vm.formModel)
          .then(function(postResult) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.PyramidNav');
          })
          .catch(function(error) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        $state.go('Property.PyramidNav');
      };

      vm.openEmptyFlatTransmissionFeeReport = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Property/EmptyFlatTransmissionFeeReport.html',
          controller: 'EmptyFlatTransmissionFeeReportCtrl',
          controllerAs: 'vm',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('Property/EFTransFeeReportModal'),
          },
        });

        modalInstance.result.then(function(areaRentalId) {
          if (vm.formModel.TenType === 'PTEFL' && vm.formModel.IsRentable == true) {
            vm.generateEFTReport(vm.formModel.PropertyId, areaRentalId);
          } else {
            toastr.warning('A bérleményre nem generálható riport');
          }
        });
      };

      vm.generateEFTReport = function(propertyId, areaRentalId) {
        $http
          .post('Property/GenerateEFTransFeeReport', {
            propertyId: propertyId,
            areaRentalId: areaRentalId,
          })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
              toastr.success('Sikeres generálás!');
            },
            function(err) {
              console.err(err);
              // TODO error: toastr
            }
          );
      };

      vm.disableEmptyFlatTransmissionFeeReportButton = function() {
        return !(vm.formModel.TenType === 'PTEFL' && vm.formModel.IsRentable);
      };

      // Usage: "fieldName": onBlurFunction(selectedItem) --lostfocus
      var onBlurFunctions = {
        Name: function(selectedItem) {
          if ((!selectedItem.Name || selectedItem.Name === '') && vm.formModel.Name === '') {
            vm.formModel.Name = vm.formModel.Address;
          }
        },
      };
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      function attachDocument() {
        var id = vm.formModel.PropertyId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Equipment.DasDocumentsNav', 'FlgProperty', id);
      }

      function validateTopogrNumber(topogrNumber) {
        return (
          /^[0-9]{3,6}(\/[0-9]{1,3})?$/.test(topogrNumber) ||
          /^[0-9]{3,6}\/[A-Z]{1}\/[1-9]{1,3}?$/.test(topogrNumber) ||
          /^[0-9]{3,6}(\/[0-9]{0,3})\/[A-Z]{1}\/[1-9]{1,3}?$/.test(topogrNumber)
        );
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('BudgetItemPropertyEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetItemPropertyEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var fs = fieldSetter;
        fs.vm = vm;
        fs.setOnChangeFunction('CorrValue', function(value) {
          vm.dataModel.Value = vm.dataModel.PlanValue + vm.dataModel.CorrValue;
        });

        fs.setDisabled('InvoiceItem', function() {
          return vm.dataModel.ServiceType === 'CSEPU';
        });

        vm.cancel = cancel;
        vm.save = save;

        generateForm(vm);
      }

      function save() {
        $http
          .post('Property/BudgetItemPropertyEditRentableUnit', vm.dataModel)
          .then(function() {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PropertyLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PropertyMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Property_Pyramid: { icon: 'fa fa-university' },
        Property_CreditContract: { icon: 'fa fa-file-text' },
        Masterdata_Property: { icon: 'fa fa-home' },
        Masterdata_Building: { icon: 'fa fa-building-o' },
        Masterdata_Premises: { icon: 'fa fa-bed' },
        Masterdata_Tenement: { icon: 'fa fa-building' },
        Masterdata_Equipment: { icon: 'fa fa-desktop' },
      };

      buildMenu($state, authService, 'Property', 'property', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PyramidEditMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PyramidEditMenuCtrl', stateParams);
      }
      var vm = this;

      vm.main = function() {
        $state.go('Property.PyramidNav');
      };
      vm.propertyCat = function() {
        $state.go('Masterdata.Property');
      };
      vm.equipment = function() {
        $state.go('Masterdata.Equipment.EquipmentList');
      };
      vm.pyramid = function() {
        $state.go('Property.PyramidNav');
      };
      vm.building = function() {
        $state.go('Masterdata.Building');
      };
      vm.tenement = function() {
        $state.go('Masterdata.Tenement');
      };
      vm.premises = function() {
        $state.go('Masterdata.Premises');
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PropImmovableEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropImmovableEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.ObjectType = $stateParams.ObjectType;
      vm.TypeName = $stateParams.Name;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      var floorSpace = vm.formModel.FloorSpace;
      var validFrom = vm.formModel.ValidFrom;
      vm.isView = vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.isView) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.pageModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.panelPropImFormFields = formlyFormPanelDescriptors.PanelPropIm.FormlyDescriptor;
      vm.panelDimensionFormFields = formlyFormPanelDescriptors.PanelDimension.FormlyDescriptor;

      // Usage: "fieldName": {expressionFnName1: expressionFn1, expressionFnName2: expressionFn2}
      var customExpressionProperties = {
        Level: {
          'templateOptions.disabled': function() {
            if (vm.formModel.PropertyId !== 0 && vm.EditOrDuplicate !== 'Duplicate') {
              return true;
            }
          },
        },
        TopogrNumber: {
          'templateOptions.required': function() {
            return false;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        TopogrNumber: {
          TopogrNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return true;
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var numericOptions = {
        RentableSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        FloorSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        CubicMetre: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
      };
      InsertNumericOptions(vm.pageModel, numericOptions);

      vm.save = function() {
        $http
          .post('Property/' + vm.ObjectType + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            if (!vm.isView) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            toastr.success('Mentés sikeresen megtörtént!'); // TODO általános label
            $state.go('Property.PyramidNav');
          })
          .catch(function(response) {
            toastr.error('Mentés sikeresen megtörtént!'); // TODO általános label
            //  $state.go("Property.PyramidNav");
          });
      };

      vm.back = function() {
        if (!vm.isView) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Property.PyramidNav');
      };

      vm.attachDocument = function() {
        // var id = vm.formModel.ObjAddrId;
        // dasService.NavigateToDas(vm.pageModel.Messages,"Property.DasDocumentsNav","FlgObjAddress", id );
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      };

      function validateTopogrNumber(topogrNumber) {
        return (
          /^[0-9]{3,6}(\/[0-9]{1,3})?$/.test(topogrNumber) ||
          /^[0-9]{3,6}\/[A-Z]{1}?$/.test(topogrNumber) ||
          /^[0-9]{3,6}\/[0-9]{0,3}\/[A-Z]{1}?$/.test(topogrNumber)
        );
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ObjectNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'DasService',
    'gridService',
    'HistoryService',
    'LanguageService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      walService,
      dasService,
      gridService,
      HistoryService,
      LanguageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ObjectNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.headerPageModel = options.headerPageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.labels = Object.assign(vm.labels, LanguageService.getDictionary().property);
      vm.actions = options.pageModel.Actions;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.attachDocument = attachDocument;
      vm.viewMainItem = viewMainItem;
      vm.WAL = WAL;
      vm.TMfilterState = false;

      //CadastralGrids
      var cadastralGrids = [
        'GridEdificeCadastral',
        'GridBuildingCadastral',
        'GridLandCadastral',
        'GridRentUnitCadastral',
        'GridObjactCadastral',
      ];

      vm.deleteDisabled = deleteDisabled;

      vm.loadGridsOnTab = function(gridName) {
        var grid = $('#' + gridName).data('kendoGrid');
        if (grid) {
          if (!grid.dataSource.hadInit) {
            grid.dataSource.hadInit = true;
            grid.dataSource.read();
          }
        }
      };

      var propertyId = options.dto.PropertyId;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('Property.PyramidNav');
      };

      vm.getSelectedPropertyId = function() {
        return {
          targetPropertyId: propertyId,
          filterTM: !vm.TMfilterState,
        };
      };
      //History adatok
      var historyBinding = {
        GridResponsible: { fieldid: 'ResponsibleId', tableid: 'FlgResponsible' },
        GridPropertyDim: { fieldid: 'DimId', tableid: 'FlgPropertyDim' },
        GridPropertyDiscount: { fieldid: 'PropDiscId', tableid: 'FlgPropertyDiscount' },
        GridObjAddress: { fieldid: 'ObjAdrId', tableid: 'FlgObjAddress' },
        GridCadastral: { fieldid: 'CadastralId', tableid: 'FlgObjectCadastral' },
        GridProprietors: { fieldid: 'ProprietorId', tableid: 'FlgProprietors' },
      };

      vm.hasHistoryOnSelectedGrid = function hasHistoryOnSelectedGrid() {
        let gridName = vm.tabs[vm.activeSubItemTab].gridName;
        return !historyBinding[gridName];
      };
      vm.History = function History() {
        let gridName = vm.tabs[vm.activeSubItemTab].gridName;
        let selectedItem = getSelectedSubGridItem();
        if (!selectedItem) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem);
          return;
        }
        let id = selectedItem[vm.pageModel.Grids[gridName].IdColumn];

        HistoryService.NavigateToHistory(
          historyBinding[gridName].tableid,
          id,
          { messages: vm.pageModel.Messages },
          $state,
          true,
          historyBinding[gridName].fieldid,
          'Object'
        );
      };

      //felső fejadatok
      var formlyHeaderFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.headerPageModel);
      vm.formFields = formlyHeaderFormPanelDescriptors.PanelNavHeader.FormlyDescriptor;

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        [
          'PanelResponsible',
          'PanelPropertyDim',
          'PanelPropertyD',
          'PanelAddress',
          'PanelCadastral',
          'PanelProprietors',
        ],
        function(gridModel) {
          if (gridModel.Name === 'GridCadastral') {
            gridModel.ControllerMethod = 'Property/ObjectCadastralList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridResponsible') {
            gridModel.ControllerMethod = 'Property/ResponsibleList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridPropertyDim') {
            gridModel.ControllerMethod = 'Property/PropertyDimList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridPropertyDiscount') {
            gridModel.ControllerMethod = 'Property/PropertyDiscountList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridObjAddress') {
            gridModel.ControllerMethod = 'Property/ObjAddressList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridProprietors') {
            gridModel.ControllerMethod = 'Property/ProprietorsList/';

            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
            };
          }

          return null;
        }
      );
      vm.tabs = generatedGridTabs.tabs;
      vm.gridOptions = generatedGridTabs.gridOptions;
      vm.grids = generatedGridTabs.grids;

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      function loadGrid(gridName) {
        var grid = $('#' + gridName).data('kendoGrid');
        if (grid) {
          grid.dataSource.read();
        }
      }

      vm.tabSelected = loadGrid;

      function createSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        if (typeof lfs.targetPropertyId === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go(
          'Property.' +
            gridName +
            (!vm.formModel.ReportMandatory && cadastralGrids.includes(gridName) ? 'Simpli' : '') +
            'CreateObject',
          {
            id: 0,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPROB',
            Security: 'Object',
          }
        );
      }

      function deleteDisabled() {
        vm.mainGrid = $('#GridCadastral').data('kendoGrid');
        if (vm.mainGrid) {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (!!selectedItems && selectedItems.length > 0 && selectedItems[0].ValidTo !== null) {
            return true;
          }
        }
        return false;
      }

      function editSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go(
          'Property.' +
            gridName +
            (!vm.formModel.ReportMandatory && cadastralGrids.includes(gridName) ? 'Simpli' : '') +
            'EditObject',
          {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPROB',
            Security: 'Object',
          }
        );
      }

      function duplicateSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go(
          'Property.' +
            gridName +
            (!vm.formModel.ReportMandatory && cadastralGrids.includes(gridName) ? 'Simpli' : '') +
            'DuplicateObject',
          {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPROB',
            Security: 'Object',
          }
        );
      }

      function viewMainItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridCadastral') {
          $state.go('Property.' + gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli') + 'ViewObject', {
            id: id,
          });
        } else {
          $state.go('Property.' + gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli') + 'ViewObject', {
            id: id,
            Level: 'PPROB',
          });
        }
      }

      function deleteSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        // ????
        //var vTo = getSelectedSubGridItemValidTo();
        //if (vTo !== null) {
        //    return false;
        //}
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                //
                $http.get('Property/' + urlPrefix + 'DeleteObject/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  var gridRef = vm.grids[gridName];
                  gridRef.dataSource.read();
                });
              },
            },
          },
        });
      }

      function getSelectedSubGridItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.grids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function getSelectedSubGridItemValidTo() {
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item['ValidTo'];
        }
        return undefined;
      }

      function attachDocument() {
        var id = getSelectedSubGridItemId();
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }

        switch (gridName) {
          case 'GridCadastral':
            dasService.NavigateToDas(vm.messages, 'Property.ObjectNavDasDocumentsNav', 'FlgObjectCadastral', id);
            break;
          default:
            dasService.NavigateToDas(vm.messages, 'Property.ObjectNavDasDocumentsNav', 'Flg' + urlPrefix, id);
            break;
        }
      }

      vm.toggleTMFilterState = function() {
        let gridName = vm.tabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.grids[gridName];
        gridRef.dataSource.read();
      };

      function WAL() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        switch (gridName) {
          case 'GridCadastral':
            walService.NavigateToWal('Property', 'ObjectCadastralNavWal', 'FlgObjectCadastral');
            break;
          case 'GridResponsible':
            walService.NavigateToWal('Property', 'ObjectResponsibleNavWal', 'FlgResponsible');
            break;
          case 'GridPropertyDim':
            walService.NavigateToWal('Property', 'ObjectPropertyDimNavWal', 'FlgPropertyDim');
            break;
          case 'GridPropertyDiscount':
            walService.NavigateToWal('Property', 'ObjectPropertyDiscountNavWal', 'FlgPropertyDiscount');
            break;
          case 'GridObjAddress':
            walService.NavigateToWal('Property', 'ObjAddressNavWal', 'FlgObjAddress');
            break;
          case 'GridProprietors':
            walService.NavigateToWal('Property', 'ObjectGridProprietorsNavWal', 'FlgProprietors');
            break;
          default:
            walService.NavigateToWal('Property', 'Object' + gridName + 'NavWal', 'Flg' + gridName);
            break;
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PropImmovableNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$timeout',
    'WalService',
    '$uibModal',
    'DasService',
    'gridService',
    'UIHelperService',
    'HistoryService',
    'LanguageService',
    function(
      $scope,
      options,
      $http,
      $state,
      $timeout,
      walService,
      $uibModal,
      dasService,
      gridService,
      UIHelperService,
      HistoryService,
      LanguageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropImmovableNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.headerPageModel = options.headerPageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.labels = Object.assign(vm.labels, LanguageService.getDictionary().property);
      vm.actions = options.pageModel.Actions;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.TMfilterState = false;
      vm.attachTask = attachTask;
      vm.attachDocumentPremiseSubItem = attachDocumentPremiseSubItem;
      vm.WALPremiseSubItem = WALPremiseSubItem;
      vm.viewMainItem = viewMainItem;

      vm.activePremiseSubItemTab = 0;
      vm.activeSubItemTab = 0;

      vm.lastLoadedGrid = undefined;
      vm.loadGridsOnTab = function(sbTab) {
        $timeout(
          function() {
            const gridElement = $(`#${sbTab.gridId}`);
            if (!!gridElement) {
              const kendoGrid = gridElement.data('kendoGrid');
              kendoGrid && kendoGrid.dataSource.read();
              vm.lastLoadedGrid = gridElement;
            }
          },
          0,
          false
        );
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem(
          $state.previous.name + '_' + escape(vm.formModel.LevelName) + '_' + 'activeTab',
          vm.activeSubItemTab
        );
        localStorage.setItem(
          $state.previous.name + '_' + escape(vm.formModel.LevelName) + '_' + 'activePremiseTab',
          vm.activePremiseSubItemTab
        );
      });
      var propertyId = options.dto.PropertyId;

      //History adatok
      var historyBinding = {
        GridResponsible: { fieldid: 'ResponsibleId', tableid: 'FlgResponsible' },
        GridPropertyDim: { fieldid: 'DimId', tableid: 'FlgPropertyDim' },
        GridPropertyDiscount: { fieldid: 'PropDiscId', tableid: 'FlgPropertyDiscount' },
        GridObjAddress: { fieldid: 'ObjAdrId', tableid: 'FlgObjAddress' },
        GridCadastral: { fieldid: 'CadastralId', tableid: 'FlgObjectCadastral' },
        GridProprietors: { fieldid: 'ProprietorId', tableid: 'FlgProprietors' },
        GridPremise: { fieldid: 'PremiseId', tableid: 'FlgPremise' },
        GridRealtiesValue: { fieldid: 'ValueId', tableid: 'FlgRealtiesValue' },
        GridPropertyTask: { fieldid: 'PropertyTaskId', tableid: 'FlgPropertyTask' },
        GridBuildingCadastral: { fieldid: 'BuildingCadId', tableid: 'FlgBuildingCadastral' },
        GridEdificeCadastral: { fieldid: 'CadastralId', tableid: 'FlgEdificeCadastral' },
        GridLandCadastral: { fieldid: 'CadastralId', tableid: 'FlgLandCadastral' },
        GridRentUnitCadastral: { fieldid: 'CadastralId', tableid: 'FlgRentUnitCadastral' },
        GridAnnexe: { fieldid: 'AnnexeId', tableid: 'FlgAnnexe' },
        GridBlock: { fieldid: 'BlockId', tableid: 'FlgBlock' },
        GridCertificate: { fieldid: 'CertificateId', tableid: 'FlgCertificate' },
        GridRoomInventory: { fieldid: 'InventoryId', tableid: 'FlgRoomInventory' },
        GridRoomSurface: { fieldid: 'RoomSId', tableid: 'FlgRoomSurface' },
        GridPremiseTask: { fieldid: 'PremiseTaskId', tableid: 'FlgPremiseTask' },
        GridContrUsers: { fieldid: 'ContrUserId', tableid: 'FlgContrUser' },
        GridTenancyUtilisation: { fieldid: 'TenUtilId', tableid: 'FlgTenancyUtilisation' },
        GridTenancyService: { fieldid: 'TenServId', tableid: 'FlgTenancyService' },
        GridTenancyCheque: { fieldid: 'TenChequeId', tableid: 'FlgTenancyCheque' },
        GridChequeContract: { fieldid: 'ChequeContractId', tableid: 'FlgChequeContract' },
        GridChequePublicUtilities: { fieldid: 'ChequePubUtilId', tableid: 'FlgChequePublicUtilities' },
        GridChequeSurface: { fieldid: 'ChequeSurfaceId', tableid: 'FlgChequeSurface' },
        GridChequeEquipment: { fieldid: 'ChequeEquipmentId', tableid: 'FlgChequeEquipment' },
      };
      vm.hasHistoryOnSelectedGrid = function hasHistoryOnSelectedGrid(targetGrid) {
        let gridName = undefined;
        if (targetGrid == 'PremiseGrid') {
          gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        } else {
          gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        }
        return !historyBinding[gridName];
      };
      vm.History = function History(targetGrid) {
        let id = undefined;
        let selectedItems = undefined;
        let gridName = undefined;

        if (targetGrid == 'PremiseGrid') {
          gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
          let gridRef = vm.sbPremiseGrids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        } else {
          gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
          let gridRef = vm.sbGrids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        }

        if (!!selectedItems) {
          id = selectedItems[vm.pageModel.Grids[gridName].IdColumn];
        } else {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem);
          return;
        }

        HistoryService.NavigateToHistory(
          historyBinding[gridName].tableid,
          id,
          { messages: vm.pageModel.Messages },
          $state,
          true,
          historyBinding[gridName].fieldid,
          'PropImmovable'
        );
      };

      vm.back = function() {
        $state.go('Property.PyramidNav');
      };

      vm.getSelectedPropertyId = function() {
        return {
          targetPropertyId: propertyId,
          filterTM: !vm.TMfilterState,
        };
      };

      //CadastralGrids
      var cadastralGrids = [
        'GridEdificeCadastral',
        'GridBuildingCadastral',
        'GridLandCadastral',
        'GridRentUnitCadastral',
        'GridObjactCadastral',
      ];

      //felső fejadatok
      var formlyHeaderFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.headerPageModel);
      vm.formFields = formlyHeaderFormPanelDescriptors.PanelNavHeader.FormlyDescriptor;
      vm.activeSubItemTab = 0;

      //Leveltől függően állítja össze a panellistát, ez a gereratedGridTabs-nál kell
      var PanelListByLevel = [];
      if (vm.formModel.LevelName === 'Építmény') {
        PanelListByLevel = [
          'PanelPremise',
          'PanelPropertyDim',
          'PanelPropertyDiscount',
          'PanelProprietors',
          'PanelRealtiesValue',
          'PanelPropertyTask',
          'PanelResponsible',
          'PanelECadastral',
          'PanelCertificate',
        ];
      }
      if (vm.formModel.LevelName === 'Épület') {
        PanelListByLevel = [
          'PanelPremise',
          'PanelPropertyDim',
          'PanelPropertyDiscount',
          'PanelProprietors',
          'PanelRealtiesValue',
          'PanelPropertyTask',
          'PanelResponsible',
          'PanelPropertyTask',
          'PanelBCadastral',
          'PanelAnnexe',
          'PanelBlock',
          'PanelCertificate',
        ];
      }
      if (vm.formModel.LevelName === 'Földterület') {
        PanelListByLevel = [
          'PanelPremise',
          'PanelPropertyDim',
          'PanelPropertyDiscount',
          'PanelProprietors',
          'PanelRealtiesValue',
          'PanelPropertyTask',
          'PanelResponsible',
          'PanelLCadastral',
        ];
      }

      vm.sbTabs = gridService.buildTabModelsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        PanelListByLevel,
        function(gridModel) {
          switch (gridModel.Name) {
            case 'GridResponsible':
              gridModel.ControllerMethod = 'Property/ResponsibleList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridPropertyDim':
              gridModel.ControllerMethod = 'Property/PropertyDimList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridPropertyDiscount':
              gridModel.ControllerMethod = 'Property/PropertyDiscountList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridProprietors':
              gridModel.ControllerMethod = 'Property/ProprietorsList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridPremise':
              gridModel.ControllerMethod = 'Property/PremiseList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
                selectFunction: function() {
                  changePremiseMainGridFilter();
                },
              };
            case 'GridRealtiesValue':
              gridModel.ControllerMethod = 'Property/RealtiesValueList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridPropertyTask':
              gridModel.ControllerMethod = 'Property/PropertyTaskList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridAnnexe':
              gridModel.ControllerMethod = 'Property/AnnexeList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridBlock':
              gridModel.ControllerMethod = 'Property/BlockList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridCertificate':
              gridModel.ControllerMethod = 'Property/CertificateList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridEdificeCadastral':
              gridModel.ControllerMethod = 'Property/EdificeCadastralList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridBuildingCadastral':
              gridModel.ControllerMethod = 'Property/BuildingCadastralList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };
            case 'GridLandCadastral':
              gridModel.ControllerMethod = 'Property/LandCadastralList/';
              return {
                gridModel,
                transportData: vm.getSelectedPropertyId,
              };

            default:
              break;
          }
        }
      );

      function viewMainItem() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var id = getSelectedSubGridItemId();
        var lfs = vm.getSelectedPropertyId();

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPropertyTask') {
          var url = 'Task/PropertyTaskView?id=' + id + '&propertyId=' + lfs.targetPropertyId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PropertyTaskEdit.html',
            controller: 'PropertyTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $(`#GridPropertyTask`)
              .data('kendoGrid')
              .dataSource.read();
          });
        } else if (
          gridName === 'GridProprietors' ||
          gridName === 'GridPremise' ||
          gridName === 'GridRealtiesValue' ||
          gridName === 'GridPropertyDiscount'
        ) {
          $state.go('Property.' + gridName + 'ViewImmovable', {
            id: id,
            Level: 'PPRIM',
          });
        } else {
          $state.go('Property.' + gridName + 'ViewImmovable', {
            id: id,
          });
        }
      }

      function createSubItem() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();

        if (gridName === 'GridPropertyTask') {
          var url = 'Task/PropertyTaskCreate?id=' + 0 + '&propertyId=' + lfs.targetPropertyId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PropertyTaskEdit.html',
            controller: 'PropertyTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $(`#GridPropertyTask`)
              .data('kendoGrid')
              .dataSource.read();
          });
        } else if (cadastralGrids.includes(gridName)) {
          $state.go('Property.' + gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli') + 'CreateImmovable', {
            id: 0,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRIM',
            Security: 'Immovable',
          });
        } else {
          $state.go('Property.' + gridName + 'CreateImmovable', {
            id: 0,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRIM',
            Security: 'Immovable',
          });
        }
      }

      function editSubItem() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPropertyTask') {
          var url = 'Task/PropertyTaskEdit?id=' + id + '&propertyId=' + lfs.targetPropertyId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PropertyTaskEdit.html',
            controller: 'PropertyTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPropertyTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else if (gridName === 'GridPremise') {
          editSubItemCall(gridName, id, lfs);
        } else if (cadastralGrids.includes(gridName)) {
          editSubItemCall(gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli'), id, lfs);
        } else {
          editSubItemCall(gridName, id, lfs);
        }
      }

      function editSubItemCall(gridName, id, lfs) {
        $state.go('Property.' + gridName + 'EditImmovable', {
          id: id,
          PropertyId: lfs.targetPropertyId,
          Level: 'PPRIM',
          Security: 'Immovable',
        });
      }

      function duplicateSubItem(premiseTS = false) {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremise') {
          /* Le kell kérdezni, hogy a helyiséghez tartozik-e élő vagy láncolás alatti szerződéses bérlemény */
          $http.get('Property/PremiseRentUnitContractCheck/' + id).then(function(result) {
            if (result.data.RentUnitContract) {
              toastr.warning(
                'Nem másolható / módosítható olyan helyiség, melyhez élő vagy láncolás alatti szerződéses bérlemény tartozik!',
                vm.messages.Warning
              );
            } else {
              duplicateSubItemCall(gridName, id, lfs, premiseTS);
            }
          });
        } else if (cadastralGrids.includes(gridName)) {
          duplicateSubItemCall(gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli'), id, lfs, premiseTS);
        } else {
          duplicateSubItemCall(gridName, id, lfs, premiseTS);
        }

        function duplicateSubItemCall(gridName, id, lfs, premiseTS) {
          $state.go('Property.' + gridName + 'DuplicateImmovable', {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRIM',
            PremiseTS: premiseTS,
            Security: 'Immovable',
          });
        }
      }

      function deleteSubItem() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                var url = 'Property/' + urlPrefix + 'DeleteImmovable/' + id;
                if (gridName == 'GridPropertyTask') {
                  url = 'Task/PropertyTaskDelete/' + id;
                }

                $http.get(url).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  var gridRef = $(`#${gridName}`).data('kendoGrid');
                  gridRef.dataSource.read();
                });
              },
            },
          },
        });
      }

      function attachDocument() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedSubGridItemId();
        dasService.NavigateToDas(vm.messages, 'Property.PropImmovableNavDasDocumentsNav', 'Flg' + urlPrefix, id);
      }

      vm.toggleTMFilterState = async function() {
        let gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.sbGrids[gridName];
        let selectedId;
        let idField = vm.pageModel.Grids[gridName].IdColumn;
        if (GetSelectedGridItems(gridRef)[0]) {
          selectedId = GetSelectedGridItems(gridRef)[0][idField];
        }
        await gridRef?.dataSource?.read();
        if (selectedId) {
          let i = 0;
          let selectedrow = 0;
          await gridRef.dataItems().forEach(element => {
            i++;
            if (element[idField] == selectedId) {
              selectedrow = i;
              return false;
            }
          });
          if (selectedrow > 0) {
            selectedrow--;
            gridRef.select('tr:eq(' + selectedrow + ')');
          } else {
            selectedId = 0;
          }
        }
        changePremiseMainGridFilter(selectedId);
      };

      function WAL(isHeader) {
        if (!isHeader) {
          var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
          switch (gridName) {
            case 'GridRoomSurface':
              walService.NavigateToWal('Property', 'PropImmovableRoomSurfaceNavWal', 'FlgRoomSurface');
              break;
            case 'GridRoomInventory':
              walService.NavigateToWal('Property', 'PropImmovableRoomInventoryNavWal', 'FlgRoomInventory');
              break;
            case 'GridPremiseTask':
              walService.NavigateToWal('Property', 'PropImmovablePremiseTaskNavWal', 'FlgPremiseTask');
              break;
            case 'GridContrUsers':
              walService.NavigateToWal('Property', 'PropImmovableContrUsersNavWal', 'FlgContrUser');
              break;
            default:
              break;
          }
        } else {
          switch (vm.activeSubItemTab) {
            case 0:
              walService.NavigateToWal('Property', 'PropImmovablePremiseViewWal', 'FlgPremiseView');
              break;
            case 1:
              walService.NavigateToWal('Property', 'PropImmovableResponsibleViewWal', 'FlgResponsibleView');
              break;
            case 2:
              walService.NavigateToWal('Property', 'PropImmovablePropertyDiscViewWal', 'FlgPropertyDiscountView');
              break;
            case 3:
              walService.NavigateToWal('Property', 'PropImmovablePropertyDimWal', 'FlgPropertyDim');
              break;
            case 4:
              walService.NavigateToWal('Property', 'PropImmovableProprietorsViewWal', 'FlgProprietorsView');
              break;
            case 5:
              walService.NavigateToWal('Property', 'PropImmovableRealtiesValueWal', 'FlgRealtiesValue');
              break;
            case 6:
              walService.NavigateToWal('Property', 'PropImmovablePropertyTaskWal', 'FlgPropertyTask');
              break;
            case 7:
              let _view = 'FlgBuildingCadastralView';
              if (vm.formModel.Level === 'PPRED') _view = 'FlgEdificeCadastralView';
              else if (vm.formModel.Level === 'PPRLA') _view = 'FlgLandCadastralView';
              walService.NavigateToWal('Property', 'PropImmovableBuildingCadastralViewWal', _view);
              break;
            case 8:
              walService.NavigateToWal('Property', 'PropImmovableAnnexeViewWal', 'FlgAnnexeView');
              break;
            case 9:
              walService.NavigateToWal('Property', 'PropImmovablePropertyBlockWal', 'FlgBlock');
              break;
            case 10:
              walService.NavigateToWal('Property', 'PropImmovableCertificateViewWal', 'FlgCertificateView');
              break;
            default:
              break;
          }
        }
      }

      function attachTask() {
        var lfs = vm.getSelectedPropertyId();
        var url = 'Task/PremiseTaskEdit?id=' + 0 + '&premiseId=' + 0 + '&propertyId=' + lfs.targetPropertyId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PremiseTaskEdit.html',
          controller: 'PremiseTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          $('#GridPremiseTask')
            .data('kendoGrid')
            .dataSource.read();
        });
      }

      function getSelectedSubGridItem() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var gridRef = $(`#${gridName}`).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      ////////////////////////////////////////////////////////////////
      /////////// Premise Area ///////////////////////////////////////
      ////////////////////////////////////////////////////////////////
      vm.premisePageModel = options.tenementPageModel;
      vm.createPremiseSubItem = createPremiseSubItem;
      vm.editPremiseSubItem = editPremiseSubItem;
      vm.deletePremiseSubItem = deletePremiseSubItem;
      vm.viewPremiseSubItem = viewPremiseSubItem;
      vm.duplicatePremiseSubItem = duplicatePremiseSubItem;
      vm.selectedSubGridItemId = 0;

      vm.getSelectedPremiseId = function() {
        return {
          targetPremiseId: vm.selectedSubGridItemId,
          filterTM: !vm.TMfilterState,
        };
      };

      vm.sbPremiseTabs = gridService.buildTabModelsWithGrids(
        vm.premisePageModel.Tabs,
        vm.premisePageModel.Panels,
        vm.premisePageModel.Grids,
        ['PanelRoomInventory', 'PanelRoomSurface', 'PanelPremiseTask', 'PanelContrUsers'],
        function(gridModel) {
          switch (gridModel.Name) {
            case 'GridRoomSurface':
              gridModel.ControllerMethod = 'Property/RoomSurfaceList/';
              return {
                gridModel,
                transportData: vm.getSelectedPremiseId,
              };
            case 'GridRoomInventory':
              gridModel.ControllerMethod = 'Property/RoomInventoryList/';
              return {
                gridModel,
                transportData: vm.getSelectedPremiseId,
              };
            case 'GridPremiseTask':
              gridModel.ControllerMethod = 'Property/PremiseTaskList/';
              return {
                gridModel,
                transportData: vm.getSelectedPremiseId,
              };
            case 'GridContrUsers':
              gridModel.ControllerMethod = 'Property/ContrUserList/';
              return {
                gridModel,
                transportData: vm.getSelectedPremiseId,
              };

            default:
              break;
          }
        }
      );

      setTimeout(function() {
        $scope.activeSubItemTab =
          Number(
            localStorage.getItem($state.current.name + '_' + escape(vm.formModel.LevelName) + '_' + 'activeTab')
          ) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;
        $scope.activePremiseSubItemTab =
          Number(
            localStorage.getItem($state.current.name + '_' + escape(vm.formModel.LevelName) + '_' + 'activePremiseTab')
          ) || 0;
        vm.activePremiseSubItemTab = $scope.activePremiseSubItemTab;
      }, 100);

      vm.functionDisabled = function(index) {
        if (index !== undefined) {
          const gridName = vm.sbTabs[index].gridId;
          var selectedItems = GetSelectedGridItems($(`#${gridName}`).data('kendoGrid'));
          if (selectedItems.length === 1) {
            var item = selectedItems[0];
            if (item.ValidTo !== undefined && item.ValidTo !== null) {
              return true;
            }
          }
        }
        return false;
      };

      function createPremiseSubItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        if (lfs.targetPremiseId === 0) {
          toastr.warning('Nem jelölt ki helyiséget', vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremiseTask') {
          var url = 'Task/PremiseTaskCreate?id=' + 0 + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'CreateImmovable', {
            id: 0,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Security: 'Immovable',
          });
        }
      }

      function editPremiseSubItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        var item = getSelectedPremiseSubGridItem();
        if (item) {
          var id = item[vm.premisePageModel.Grids[gridName].IdColumn];
        }

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremiseTask') {
          if (!!item.PropertyId) {
            toastr.error(
              'Kiválasztott adatsorra az Ingatlan tevékenységei fülön érhető el a funkció!',
              vm.messages.Warning
            );
            return false;
          }

          var url = 'Task/PremiseTaskEdit?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'EditImmovable', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Security: 'Immovable',
          });
        }
      }

      function viewPremiseSubItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        var id = getSelectedPremiseSubGridItemId();

        var item = getSelectedPremiseSubGridItem();
        if (item) {
          var id = item[vm.premisePageModel.Grids[gridName].IdColumn];
        }

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPremiseTask') {
          if (!!item.PropertyId) {
            toastr.error(
              'Kiválasztott adatsorra az Ingatlan tevékenységei fülön érhető el a funkció!',
              vm.messages.Warning
            );
            return false;
          }

          var url = 'Task/PremiseTaskView?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'ViewImmovable', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
          });
        }
      }
      function duplicatePremiseSubItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();

        var item = getSelectedPremiseSubGridItem();
        if (item) {
          var id = item[vm.premisePageModel.Grids[gridName].IdColumn];
        }

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPremiseTask') {
          if (!!item.PropertyId) {
            toastr.error(
              'Kiválasztott adatsorra az Ingatlan tevékenységei fülön érhető el a funkció!',
              vm.messages.Warning
            );
            return false;
          }

          var url = 'Task/PremiseTaskDuplicate?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'DuplicateImmovable', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Security: 'Immovable',
          });
        }
      }

      function deletePremiseSubItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var item = getSelectedPremiseSubGridItem();
        if (item) {
          var id = item[vm.premisePageModel.Grids[gridName].IdColumn];
        }

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremiseTask') {
          if (!!item.PropertyId) {
            toastr.error(
              'Kiválasztott adatsorra az Ingatlan tevékenységei fülön érhető el a funkció!',
              vm.messages.Warning
            );
            return false;
          }
        }

        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                var url = 'Property/' + urlPrefix + 'DeleteImmovable/' + id;
                if (gridName == 'GridPremiseTask') {
                  url = 'Task/PremiseTaskDelete/' + id;
                }

                $http.get(url).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  var gridRef = $(`#${gridName}`).data('kendoGrid');
                  gridRef.dataSource.read();
                });
              },
            },
          },
        });
      }

      function getSelectedPremiseSubGridItem() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var gridRef = $(`#${gridName}`).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.premisePageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedPremiseSubGridItemId() {
        var gridName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName;
        var item = getSelectedPremiseSubGridItem();
        if (item) {
          return item[vm.premisePageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function attachDocumentPremiseSubItem() {
        var id = getSelectedPremiseSubGridItemId();
        var tableName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName.substring(4);
        dasService.NavigateToDas(vm.messages, 'Property.DasDocumentsNav', 'Flg' + tableName, id);
      }

      function WALPremiseSubItem() {
        var tableName = vm.sbPremiseTabs[vm.activePremiseSubItemTab].gridName.substring(4);
        walService.NavigateToWal('Property', tableName + 'navWal', 'Flg' + tableName);
      }

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changePremiseMainGridFilter(id) {
        var gridName = vm.sbTabs[vm.activeSubItemTab].gridName;
        var targetGrid = $(`#${gridName}`).data('kendoGrid');
        if (id >= 0) {
          vm.selectedSubGridItemId = id;
        } else {
          var selectedItems = GetSelectedGridItems(targetGrid);
          if (selectedItems.length === 0) return;
          $scope.$applyAsync();
          vm.subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
          vm.selectedSubGridItemId = selectedItems[0][vm.subGridIdField];
        }
        //az összes hozzá tartozó tabot betöltse
        ['GridRoomInventory', 'GridRoomSurface', 'GridPremiseTask', 'GridContrUsers'].forEach(function(gridName) {
          const kendoGrid = $(`#${gridName}`).data('kendoGrid');
          kendoGrid && kendoGrid.dataSource.read();
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RentableUnitNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'DasService',
    'gridService',
    'HistoryService',
    'LanguageService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      walService,
      dasService,
      gridService,
      HistoryService,
      LanguageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentableUnitNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.headerPageModel = options.headerPageModel;
      vm.formModel = options.dto;
      vm.reportList = options.reportList;
      vm.formModelTenancy = options.dto2;
      vm.budgetItemPropCalcTypePageModel = options.budgetItemPropCalcTypePageModel;
      vm.budgetItemPropCalcTypeFormModel = options.budgetItemPropCalcTypeDto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.labels = Object.assign(vm.labels, LanguageService.getDictionary().property);
      vm.actions = options.pageModel.Actions;
      vm.docList = options.docList;
      vm.deleteDisabled = deleteDisabled;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.attachDocument = attachDocument;
      vm.viewMainItem = viewMainItem;
      vm.WAL = WAL;
      vm.TMfilterState = false;

      //CadastralGrids
      var cadastralGrids = [
        'GridEdificeCadastral',
        'GridBuildingCadastral',
        'GridLandCadastral',
        'GridRentUnitCadastral',
        'GridObjactCadastral',
      ];

      vm.usedRentableUnitGridEnum = Object.freeze({
        TOVABBI_ADATOK: 1,
        HELYISEG_ADATOK: 2,
      });

      vm.loadGridsOnTab = function(gridName) {
        gridService.loadGrid(gridName);
      };

      var propertyId = options.dto.PropertyId;

      vm.getSelectedPropertyId = function() {
        return {
          targetPropertyId: propertyId,
          filterTM: !vm.TMfilterState,
        };
      };

      //History adatok
      var historyBinding = {
        GridResponsible: { fieldid: 'ResponsibleId', tableid: 'FlgResponsible' },
        GridPropertyDim: { fieldid: 'DimId', tableid: 'FlgPropertyDim' },
        GridPropertyDiscount: { fieldid: 'PropDiscId', tableid: 'FlgPropertyDiscount' },
        GridObjAddress: { fieldid: 'ObjAdrId', tableid: 'FlgObjAddress' },
        GridCadastral: { fieldid: 'CadastralId', tableid: 'FlgObjectCadastral' },
        GridProprietors: { fieldid: 'ProprietorId', tableid: 'FlgProprietors' },
        GridPremise: { fieldid: 'PremiseId', tableid: 'FlgPremise' },
        GridRealtiesValue: { fieldid: 'ValueId', tableid: 'FlgRealtiesValue' },
        GridPropertyTask: { fieldid: 'PropertyTaskId', tableid: 'FlgPropertyTask' },
        GridBuildingCadastral: { fieldid: 'BuildingCadId', tableid: 'FlgBuildingCadastral' },
        GridEdificeCadastral: { fieldid: 'CadastralId', tableid: 'FlgEdificeCadastral' },
        GridLandCadastral: { fieldid: 'CadastralId', tableid: 'FlgLandCadastral' },
        GridRentUnitCadastral: { fieldid: 'CadastralId', tableid: 'FlgRentUnitCadastral' },
        GridAnnexe: { fieldid: 'AnnexeId', tableid: 'FlgAnnexe' },
        GridBlock: { fieldid: 'BlockId', tableid: 'FlgBlock' },
        GridCertificate: { fieldid: 'CertificateId', tableid: 'FlgCertificate' },
        GridRoomInventory: { fieldid: 'InventoryId', tableid: 'FlgRoomInventory' },
        GridRoomSurface: { fieldid: 'RoomSId', tableid: 'FlgRoomSurface' },
        GridPremiseTask: { fieldid: 'PremiseTaskId', tableid: 'FlgPremiseTask' },
        //GridContrUser: { fieldid: 'ContrUserId', tableid: 'FlgContrUser' },
        GridTenancyUtilisation: { fieldid: 'TenUtilId', tableid: 'FlgTenancyUtilisation' },
        GridTenancyService: { fieldid: 'TenServId', tableid: 'FlgTenancyService' },
        GridTenancyCheque: { fieldid: 'TenChequeId', tableid: 'FlgTenancyCheque' },
        GridChequeContract: { fieldid: 'ChequeContractId', tableid: 'FlgChequeContract' },
        GridChequePublicUtilities: { fieldid: 'ChequePubUtilId', tableid: 'FlgChequePublicUtilities' },
        GridChequeSurface: { fieldid: 'ChequeSurfaceId', tableid: 'FlgChequeSurface' },
        GridChequeEquipment: { fieldid: 'ChequeEquipmentId', tableid: 'FlgChequeEquipment' },
        GridChequeNotif: { fieldid: 'ChequeNotifId', tableid: 'FlgChequeNotifView' },
        GridChequeTenantAndUser: { fieldid: 'ChequeTenantAndUserId', tableid: 'FlgChequeTenantAndUserView' },
        GridChequePremise: { fieldid: 'ChequePremiseId', tableid: 'FlgChequePremiseView' },
      };
      vm.hasHistoryOnSelectedGrid = function hasHistoryOnSelectedGrid(targetGrid) {
        let gridName = undefined;
        if (targetGrid == 'PremiseGrid') {
          gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        } else if (targetGrid == 'TenanyChequeGrid') {
          gridName = vm.tenanyChequeTabs[vm.activeTenanyChequeSubItemTab].gridName;
        } else {
          gridName = vm.tabs[vm.activeSubItemTab].gridName;
        }
        return !historyBinding[gridName];
      };
      vm.History = function History(targetGrid) {
        let id = undefined;
        let selectedItems = undefined;
        let gridName = undefined;

        if (targetGrid == 'PremiseGrid') {
          gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
          let gridRef = vm.premiseGrids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        } else if (targetGrid == 'TenanyChequeGrid') {
          gridName = vm.tenanyChequeTabs[vm.activeTenanyChequeSubItemTab].gridName;
          let gridRef = vm.tenanyChequeGrids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        } else {
          gridName = vm.tabs[vm.activeSubItemTab].gridName;
          let gridRef = vm.grids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        }

        if (!!selectedItems) {
          id = selectedItems[vm.pageModel.Grids[gridName].IdColumn];
        } else {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem);
          return;
        }

        HistoryService.NavigateToHistory(
          historyBinding[gridName].tableid,
          id,
          { messages: vm.pageModel.Messages },
          $state,
          true,
          historyBinding[gridName].fieldid,
          'RentableUnit'
        );
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activePremiseSubItemTab);
      });

      $scope.$watch('vm.activeSubItemTab', function(newItem, oldItem) {
        vm.selectedSubGridItemId = 0;
      });

      vm.back = function() {
        $state.go('Property.PyramidNav');
      };

      function setDasSubModel() {
        var dasDescriptor = vm.pageModel.Grids[vm.grids[vm.activeSubItemTab]].DasDescriptor;
        var selectedGrid = vm.grids[vm.grids[vm.activeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (!selectedItems || !selectedItems[0]) return;
        vm.dasSubModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      function setDasSubPremiseModel() {
        if (!vm.premiseGrids) return;
        var dasDescriptor = vm.premisePageModel.Grids[vm.premiseGrids[vm.activePremiseSubItemTab]].DasDescriptor;
        var selectedGrid = vm.premiseGrids[vm.premiseGrids[vm.activePremiseSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (!selectedItems || !selectedItems[0]) return;

        vm.dasSubPremiseModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      function setDasSubTenancyChequeModel() {
        if (!vm.tenanyChequeGrids) return;
        var selectedGrid = vm.tenanyChequeGrids[vm.tenanyChequeGrids[vm.activeTenanyChequeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasSubTenancyChequeModel = {
          routeId: 'Document.DocumentCreate',
          tableId: objectTobase64(
            {
              FlgTenancyCheque: vm.selectedSubGridItemId,
              FlgChequeSurface: selectedItems[0]?.ChequeSurfaceId,
              idTables: { FlgChequeSurface: 'ChequeSurfaceId' },
            },
            true
          ),
          ownerId: selectedItems[0]?.ChequeSurfaceId,
        };
        $scope.$applyAsync();
      }
      function deleteDisabled() {
        vm.mainGrid = $('#GridRentUnitCadastral').data('kendoGrid');
        if (vm.mainGrid) {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (!!selectedItems && selectedItems.length > 0 && selectedItems[0].ValidTo !== null) {
            return true;
          }
        }
        return false;
      }

      //felső fejadatok
      var formlyHeaderFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.headerPageModel);
      vm.formFields = formlyHeaderFormPanelDescriptors.PanelNavHeader.FormlyDescriptor;

      //kihasználtság tab header mezők
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.tenancyHeaderInformation =
        formlyFormPanelDescriptors.PanelTenancyUtilisationHeaderInformation.FormlyDescriptor;

      var budgetItemPropCalcTypeFormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(
        vm.budgetItemPropCalcTypePageModel
      );
      vm.budgetItemPropCalcTypeFormFields =
        budgetItemPropCalcTypeFormlyFormPanelDescriptors.PanelFilterPeriod.FormlyDescriptor;

      vm.budgetItemPropCalcTypePageModel.Fields.PeriodId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        propertyId: propertyId,
      };

      var onChangeFunctionsBudgetItemPropCalcType = {
        PeriodId: function() {
          loadGrid('GridBudgetItemPropCalcType');
        },
      };

      InsertOnChangeFunctions(vm.budgetItemPropCalcTypePageModel, onChangeFunctionsBudgetItemPropCalcType);

      vm.activeSubItemTab = 0;

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        [
          'PanelPremise',
          'PanelPropertyDim',
          'PanelPropertyDiscount',
          'PanelTenancyUtilisation',
          'PanelTenancyUtilisationHeaderInformation',
          'PanelPropertyUsage',
          'PanelTenancyService',
          'PanelProprietors',
          'PanelRealtiesValue',
          'PanelRentUnitCadastral',
          'PanelTenancyCheque',
          'PanelPropertyTask',
          'PanelCertificate',
          'PanelBudgetItemPropCalcType',
          'PanelTenantsAndUsersOfRentUnit',
        ],
        function(gridModel) {
          if (gridModel.Name === 'GridPremise') {
            gridModel.ControllerMethod = 'Property/PremiseList/';

            return {
              gridModel,
              selectFunction: function() {
                changeMainGridFilter();
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridPropertyDim') {
            gridModel.ControllerMethod = 'Property/PropertyDimList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridPropertyDiscount') {
            gridModel.ControllerMethod = 'Property/PropertyDiscountList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridTenancyUtilisation') {
            gridModel.ControllerMethod = 'Property/TenancyUtilisationList/';
            vm.pageModel.Fields.SumArea.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
              'A mai dátumon érvényes adatokat jelenítjük meg a mezőkben.<br>Az értékek mértékegysége négyzetméter.';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridTenancyService') {
            gridModel.ControllerMethod = 'Property/TenancyServiceList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridProprietors') {
            gridModel.ControllerMethod = 'Property/ProprietorsList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridRealtiesValue') {
            gridModel.ControllerMethod = 'Property/RealtiesValueList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridRentUnitCadastral') {
            gridModel.ControllerMethod = 'Property/RentUnitCadastralList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridTenancyCheque') {
            gridModel.ControllerMethod = 'Property/TenancyChequeList/';

            return {
              gridModel,
              selectFunction: function() {
                changeMainGridFilter();
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridPropertyTask') {
            gridModel.ControllerMethod = 'Property/RentUnitTaskList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridCertificate') {
            gridModel.ControllerMethod = 'Property/CertificateList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: vm.getSelectedPropertyId,
            };
          }
          if (gridModel.Name === 'GridBudgetItemPropCalcType') {
            gridModel.ControllerMethod = 'Property/BudgetItemPropCalcTypeList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: function() {
                return {
                  targetPropertyId: propertyId,
                  periodId: vm.budgetItemPropCalcTypeFormModel?.PeriodId,
                };
              },
            };
          }
          if (gridModel.Name === 'GridTenantsAndUsersOfRentUnit') {
            gridModel.ControllerMethod = 'Property/TenantsAndUsersList/';
            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: function() {
                return {
                  targetPremiseOrPropertyId: propertyId,
                  filterTM: !vm.TMfilterState,
                };
              },
            };
          }

          if (gridModel.Name === 'GridPropertyUsage') {
            gridModel.ControllerMethod = 'Property/PropertyUsageList/';
            return {
              gridModel,
              selectFunction: function() {
                setDasSubModel();
              },
              transportData: function() {
                return {
                  targetPropertyId: propertyId,
                  filterTM: !vm.TMfilterState,
                };
              },
            };
          }

          return null;
        }
      );

      vm.tabs = generatedGridTabs.tabs;
      vm.gridOptions = generatedGridTabs.gridOptions;
      vm.grids = generatedGridTabs.grids;

      if (!!vm.gridOptions['GridBudgetItemPropCalcType']) {
        vm.gridOptions['GridBudgetItemPropCalcType'].detailInit = function(e) {
          var detailRow = e.detailRow;
          if (!!e.masterRow) {
            e.sender.select(e.masterRow);
          }

          var calcType = getSelectedSubGridItemId();
          var detailGridOptions = getGridOptions(
            options.pageModel.Grids.GridBudgetItemProperty,
            'Property/BudgetItemPropertyList/',
            function() {},
            function() {
              return {
                targetPropertyId: propertyId,
                periodId: vm.budgetItemPropCalcTypeFormModel?.PeriodId,
                calcType: calcType,
              };
            }
          );
          detailGridOptions.autoBind = true;

          $(detailRow)
            .find('.k-detail-cell')
            .html('<div ng-if="$index === 11"><div class="budgetItemPropertyOptionsDetailGrid"></div></div>');

          var gridDiv = detailRow.find('.budgetItemPropertyOptionsDetailGrid');
          gridDiv.kendoGrid(detailGridOptions);
          gridDiv.attr('id', 'GridBudgetItemProperty_' + calcType);
        };
      }

      function loadGrid(gridName) {
        var grid = $('#' + gridName).data('kendoGrid');
        if (grid) {
          grid.dataSource.read();
        }
      }

      vm.tabSelected = loadGrid;

      function viewMainItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPropertyTask') {
          var url = 'Task/PropertyTaskView?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PropertyTaskEdit.html',
            controller: 'PropertyTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grids['GridPropertyTask'].dataSource.read();
          });
        } else if (
          gridName === 'GridProprietors' ||
          gridName === 'GridPremise' ||
          gridName === 'GridRealtiesValue' ||
          gridName === 'GridPropertyDiscount'
        ) {
          $state.go('Property.' + gridName + 'ViewRentableUnit', {
            id: id,
            Level: 'PPRRU',
          });
        } else {
          $state.go('Property.' + gridName + 'ViewRentableUnit', {
            id: id,
          });
        }
      }

      function createSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        if (typeof lfs.targetPropertyId === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridTenancyUtilisation') {
          $http.get('Property/TenancyUtilisationCheckContract/' + lfs.targetPropertyId).then(function() {
            $state.go('Property.' + gridName + 'CreateRentableUnit', {
              id: 0,
              PropertyId: lfs.targetPropertyId,
              Level: 'PPRRU',
              Security: 'RentableUnit',
            });
          });
        } else if (gridName === 'GridPremise') {
          $state.go('Property.' + gridName + 'CreateRentableUnit', {
            id: 0,
            RentUnitId: lfs.targetPropertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else if (cadastralGrids.includes(gridName)) {
          $state.go('Property.' + gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli') + 'CreateRentableUnit', {
            id: 0,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'CreateRentableUnit', {
            id: 0,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        }
      }

      function editSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridTenancyUtilisation') {
          $http.get('Property/TenancyUtilisationCheckContract/' + lfs.targetPropertyId).then(function() {
            $state.go('Property.' + gridName + 'EditRentableUnit', {
              id: id,
              PropertyId: lfs.targetPropertyId,
              Level: 'PPRRU',
              Security: 'RentableUnit',
            });
          });
        } else if (gridName === 'GridBudgetItemPropCalcType') {
          var calcType = getSelectedSubGridItemId();
          if (calcType === 'BCTPM') {
            toastr.warning('IK kalkulálási típus nem szerkeszthető.', vm.messages.Warning);
            return false;
          }

          var detailGrid = $('#GridBudgetItemProperty_' + calcType).data('kendoGrid');
          if (detailGrid) {
            var selectedItems = GetSelectedGridItems(detailGrid);
            if (!!selectedItems[0] && !!detailGrid) {
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Property/BudgetItemPropertyEdit.html',
                controller: 'BudgetItemPropertyEditCtrl as vm',
                backdrop: 'static',
                resolve: {
                  model: RouteResolveFunc(
                    'Property/BudgetItemPropertyEditRentableUnit/?budgetItemPropertyId=' +
                      selectedItems[0].BudgetItemPropertyId
                  ),
                },
              });

              modalInstance.result.then(function() {
                detailGrid.dataSource.read();
              });
            } else {
              toastr.warning('Nincs kijelölt díjtétel sor.', vm.messages.Warning);
              return false;
            }
          }
        } else if (cadastralGrids.includes(gridName)) {
          $state.go('Property.' + gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli') + 'EditRentableUnit', {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        } else {
          $state.go('Property.' + gridName + 'EditRentableUnit', {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        }
      }
      function duplicateSubItem(premiseTS = false) {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremise') {
          /* Le kell kérdezni, hogy a helyiséghez tartozik-e élő vagy láncolás alatti szerződéses bérlemény */
          $http.get('Property/PremiseRentUnitContractCheck/' + id).then(function(result) {
            if (result.data.RentUnitContract) {
              toastr.warning(
                'Nem másolható / módosítható olyan helyiség, melyhez élő vagy láncolás alatti szerződéses bérlemény tartozik!',
                vm.messages.Warning
              );
            } else {
              duplicateSubItemCall(gridName, id, lfs, premiseTS);
            }
          });
        } else if (cadastralGrids.includes(gridName)) {
          duplicateSubItemCall(gridName + (vm.formModel.ReportMandatory ? '' : 'Simpli'), id, lfs, premiseTS);
        } else {
          duplicateSubItemCall(gridName, id, lfs, premiseTS);
        }

        function duplicateSubItemCall(gridName, id, lfs, premiseTS) {
          $state.go('Property.' + gridName + 'DuplicateRentableUnit', {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            PremiseTS: premiseTS,
            Security: 'RentableUnit',
          });
        }
      }

      function deleteSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedPropertyId();
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                if (gridName === 'GridTenancyUtilisation') {
                  $http.get('Property/TenancyUtilisationCheckContract/' + lfs.targetPropertyId).then(function() {
                    $http.get('Property/' + urlPrefix + 'DeleteRentableUnit/' + id).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      var gridRef = vm.grids[gridName];
                      gridRef.dataSource.read();
                    });
                  });
                } else {
                  $http.get('Property/' + urlPrefix + 'DeleteRentableUnit/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    var gridRef = vm.grids[gridName];
                    gridRef.dataSource.read();
                  });
                }
              },
            },
          },
        });
      }

      function attachDocument(usedGrid) {
        var gridName;
        switch (usedGrid) {
          case vm.usedRentableUnitGridEnum.TOVABBI_ADATOK:
            gridName = vm.tabs[vm.activeSubItemTab].gridName;
            var id = getSelectedSubGridItemId();
            break;
          case vm.usedRentableUnitGridEnum.HELYISEG_ADATOK:
            gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
            var id = getSelectedPremiseSubGridItemId();
            break;
          default:
            return;
        }
        if (gridName.substring(0, 4) === 'Grid') {
          var urlPrefix = gridName.substring(4);
        }
        //var tableName = vm.tabs[vm.activeSubItemTab].gridName.substring(4);
        dasService.NavigateToDas(vm.messages, 'Property.RentableUnitNavDasDocumentsNav', 'Flg' + urlPrefix, id);
      }

      function WAL(usedGrid) {
        var name;
        switch (usedGrid) {
          case vm.usedRentableUnitGridEnum.TOVABBI_ADATOK:
            var gridName = vm.tabs[vm.activeSubItemTab].gridName;
            if (gridName.substring(0, 4) === 'Grid') {
              name = gridName.substring(4);
            }
            break;
          case vm.usedRentableUnitGridEnum.HELYISEG_ADATOK:
            var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
            if (gridName.substring(0, 4) === 'Grid') {
              name = gridName.substring(4);
            }
            break;
          default:
            return; // Mivel más grid nincs az oldalon (jelenleg).
            break;
        }
        walService.NavigateToWal('Property', 'RentableUnit' + name + 'NavWal', 'Flg' + name);
      }

      function getSelectedSubGridItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.grids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      ////////////////////////////////////////////////////////////////
      /////////// Premise Area ///////////////////////////////////////
      ////////////////////////////////////////////////////////////////

      vm.premisePageModel = options.tenementPageModel;
      vm.budgetItemPropCalcTypePageModel = options.budgetItemPropCalcTypePageModel;
      vm.createPremiseSubItem = createPremiseSubItem;
      vm.editPremiseSubItem = editPremiseSubItem;
      vm.deletePremiseSubItem = deletePremiseSubItem;
      vm.duplicatePremiseSubItem = duplicatePremiseSubItem;
      vm.viewPremiseSubItem = viewPremiseSubItem;
      vm.activePremiseSubItemTab = 0;
      vm.selectedSubGridItemId = 0;

      vm.getSelectedPremiseId = function() {
        return {
          targetPremiseId: vm.selectedSubGridItemId,
          filterTM: !vm.TMfilterState,
        };
      };

      var generatedPremiseGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.premisePageModel.Tabs,
        vm.premisePageModel.Panels,
        vm.premisePageModel.Grids,
        ['PanelRoomInventory', 'PanelRoomSurface', 'PanelPremiseTask', 'PanelTenantsAndUsersOfPremise'], //, "PanelContrUsers"], nincs meg kesz, addig nem kell --> helyette TenantsAndUsers
        function(gridModel) {
          if (gridModel.Name === 'GridRoomSurface') {
            gridModel.ControllerMethod = 'Property/RoomSurfaceList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubPremiseModel();
              },
              transportData: vm.getSelectedPremiseId,
            };
          }
          if (gridModel.Name === 'GridRoomInventory') {
            gridModel.ControllerMethod = 'Property/RoomInventoryList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubPremiseModel();
              },
              transportData: vm.getSelectedPremiseId,
            };
          }
          if (gridModel.Name === 'GridPremiseTask') {
            gridModel.ControllerMethod = 'Property/PremiseTaskList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubPremiseModel();
              },
              transportData: vm.getSelectedPremiseId,
            };
          }
          if (gridModel.Name === 'GridTenantsAndUsersOfPremise') {
            gridModel.ControllerMethod = 'Property/TenantsAndUsersList/';
            return {
              gridModel,
              selectFunction: function() {
                setDasSubPremiseModel();
              },
              transportData: function() {
                return {
                  targetPremiseOrPropertyId: vm.getSelectedPremiseId()?.targetPremiseId,
                  isProperty: false,
                  filterTM: !vm.TMfilterState,
                };
              },
            };
          }

          return null;
        }
      );
      vm.premiseTabs = generatedPremiseGridTabs.tabs;
      vm.premiseGridOptions = generatedPremiseGridTabs.gridOptions;
      vm.premiseGrids = generatedPremiseGridTabs.grids;

      setTimeout(function() {
        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;
        $scope.activePremiseSubItemTab =
          Number(localStorage.getItem($state.current.name + '_' + 'activePremiseSubTab')) || 0;
        vm.activePremiseSubItemTab = $scope.activePremiseSubItemTab;
      }, 100);
      function createPremiseSubItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        if (lfs.targetPremiseId === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        if (gridName === 'GridPremiseTask') {
          var url = 'Task/PremiseTaskCreate?id=' + 0 + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'EditRentableUnit', {
            id: 0,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        }
      }

      function editPremiseSubItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        var id = getSelectedPremiseSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPremiseTask') {
          var url = 'Task/PremiseTaskEdit?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'EditRentableUnit', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        }
      }

      function duplicatePremiseSubItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        var id = getSelectedPremiseSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPremiseTask') {
          var url = 'Task/PremiseTaskDuplicate?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'DuplicateRentableUnit', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        }
      }

      function deletePremiseSubItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedPremiseSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Property/' + urlPrefix + 'DeleteRentableUnit/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  var gridRef = vm.premiseGrids[gridName];
                  gridRef.dataSource.read();
                });
              },
            },
          },
        });
      }

      function viewPremiseSubItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var lfs = vm.getSelectedPremiseId();
        var id = getSelectedPremiseSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridPremiseTask') {
          var url = 'Task/PremiseTaskView?id=' + id + '&premiseId=' + lfs.targetPremiseId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PremiseTaskEdit.html',
            controller: 'PremiseTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
              propertyId: propertyId,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            $('#GridPremiseTask')
              .data('kendoGrid')
              .dataSource.read();
          });
        } else {
          $state.go('Property.' + gridName + 'ViewImmovable', {
            id: id,
            PremiseId: lfs.targetPremiseId,
            PropertyId: propertyId,
          });
        }
      }

      function getSelectedPremiseSubGridItem() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var gridRef = vm.premiseGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.premisePageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedPremiseSubGridItemId() {
        var gridName = vm.premiseTabs[vm.activePremiseSubItemTab].gridName;
        var item = getSelectedPremiseSubGridItem();
        if (!!item) {
          return item[vm.premisePageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }
      vm.toggleTMFilterState = async function() {
        let gridName = vm.tabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.grids[gridName];
        let idField = vm.pageModel.Grids[gridName].IdColumn;
        let selectedId;
        if (GetSelectedGridItems(gridRef)[0]) {
          selectedId = GetSelectedGridItems(gridRef)[0][idField];
        }
        await gridRef?.dataSource?.read();
        if (selectedId) {
          let i = 0;
          let selectedrow = 0;
          await gridRef.dataItems().forEach(element => {
            i++;
            if (element[idField] == selectedId) {
              selectedrow = i;
              return false;
            }
          });
          if (selectedrow > 0) {
            selectedrow--;
            gridRef.select('tr:eq(' + selectedrow + ')');
          } else {
            selectedId = 0;
          }
        }
        changeMainGridFilter(selectedId);
      };
      ////////////////////////////////////////////////////////////////
      /////////// TenancyCheque Area /////////////////////////////////
      ////////////////////////////////////////////////////////////////

      vm.tenanyChequePageModel = options.pageModel;
      //vm.createTenanyChequeSubItem = createTenanyChequeSubItem;
      //vm.editTenanyChequeSubItem = editTenanyChequeSubItem;
      //vm.deleteTenanyChequeSubItem = deleteTenanyChequeSubItem;
      //vm.duplicateTenanyChequeSubItem = duplicateTenanyChequeSubItem;
      vm.activeTenanyChequeSubItemTab = 0;
      vm.selectedSubGridItemId = 0;

      vm.getSelectedTenanyChequeId = function() {
        return {
          targetTenancyChequeId: vm.selectedSubGridItemId,
        };
      };

      var generatedTenanyChequeGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.tenanyChequePageModel.Tabs,
        vm.tenanyChequePageModel.Panels,
        vm.tenanyChequePageModel.Grids,
        [
          'PanelChequeContract',
          'PanelChequeTenantAndUser',
          'PanelChequePremise',
          'PanelChequePublicUtilities',
          'PanelChequeSurface',
          'PanelChequeEquipment',
          'PanelChequeNotif',
          'PanelChequeGenDoc',
        ],
        function(gridModel) {
          if (gridModel.Name === 'GridChequeContract') {
            gridModel.ControllerMethod = 'Property/ChequeContractList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequePublicUtilities') {
            gridModel.ControllerMethod = 'Property/ChequePublicUtilitiesList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeSurface') {
            gridModel.ControllerMethod = 'Property/ChequeSurfaceList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubTenancyChequeModel();
              },

              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeEquipment') {
            gridModel.ControllerMethod = 'Property/ChequeEquipmentList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeNotif') {
            gridModel.ControllerMethod = 'Property/ChequeNotifList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeGenDoc') {
            gridModel.ControllerMethod = 'Property/TenChequeGenDocList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeTenantAndUser') {
            gridModel.ControllerMethod = 'Property/ChequeTenantAndUserList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequePremise') {
            gridModel.ControllerMethod = 'Property/ChequePremiseList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          return null;
        }
      );
      vm.tenanyChequeTabs = generatedTenanyChequeGridTabs.tabs;
      vm.tenanyChequeGridOptions = generatedTenanyChequeGridTabs.gridOptions;
      vm.tenanyChequeGrids = generatedTenanyChequeGridTabs.grids;

      setTimeout(function() {
        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;
        $scope.activeTenanyChequeSubItemTab =
          Number(localStorage.getItem($state.current.name + '_' + 'activeTenanyChequeSubTab')) || 0;
        vm.activeTenanyChequeSubItemTab = $scope.activeTenanyChequeSubItemTab;
      }, 100);

      vm.openTenancyChequeReport = function(type) {
        if (['TabTenancyCheque'].includes(vm.tabs[vm.activeSubItemTab].name)) {
          var tenCheque = vm.getSelectedTenanyChequeId();
          $http
            .post('Property/GenerateTenancyChequeReport', { tenChequeId: tenCheque.targetTenancyChequeId, type: type })
            .then(
              function(result) {
                var file = JSON.parse(result.data);
                var raw = atob(file.Report);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
                }
                var fs = new Blob([array], { type: file.MimeType });
                saveAs(fs, decodeURIComponent(file.FileName));
                toastr.success('Sikeres generálás!');
              },
              function(err) {
                console.err(err);
                // TODO error: toastr
              }
            );
        } else {
          toastr.warning('Nem generálható riport!');
        }
      };
      vm.showChequePremiseSurface = function(gridname) {
        return gridname === 'GridChequePremise';
      };
      vm.onChangesChequePremiseSurface = function(ctrl) {
        ctrl.activeTab = 0;
        ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
          ctrl.tabs,
          ctrl.panels,
          ctrl.grids,
          ['PanelChequePremiseSurface'],
          function(gridModel) {
            if (gridModel.Name === 'GridChequePremiseSurface') {
              gridModel.ControllerMethod = 'Property/ChequePremiseSurfaceList/';

              return {
                gridModel,
                transportData: function() {
                  return {
                    targetPremiseId: ctrl.row.PremiseId,
                    targetTenancyChequeId: ctrl.row.TenChequeId,
                  };
                },
                selectFunction: function() {},
              };
            }

            return null;
          }
        );
      };
      vm.generateTemplate = function(templateId) {
        if (['TabTenancyCheque'].includes(vm.tabs[vm.activeSubItemTab].name)) {
          var tenCheque = vm.getSelectedTenanyChequeId();
          $http
            .post('Template/GetTemplateData', {
              templateId: templateId,
              id: { TenChequeId: tenCheque.targetTenancyChequeId },
            })
            .then(
              function(result) {
                var file = JSON.parse(result.data);
                var raw = atob(file.Report);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
                }
                var fs = new Blob([array], { type: file.MimeType });
                saveAs(fs, decodeURIComponent(file.FileName));
              },
              function(result) {
                toastr.error('Nem generálható riport!');
              }
            );
        } else {
          toastr.warning('Nem generálható riport!');
        }
      };
      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(id) {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var targetGrid = vm.grids[gridName];
        if (id >= 0) {
          vm.selectedSubGridItemId = id;
        } else {
          var selectedItems = GetSelectedGridItems(targetGrid);
          if (selectedItems.length === 0) return;
          vm.subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
          vm.selectedSubGridItemId = selectedItems[0][vm.subGridIdField];
        }
        //az összes hozzá tartozó tabot betöltse
        if (gridName == 'GridPremise') {
          vm.premiseGrids['GridRoomInventory'] && vm.premiseGrids['GridRoomInventory'].dataSource.read();
          vm.premiseGrids['GridRoomSurface'] && vm.premiseGrids['GridRoomSurface'].dataSource.read();
          vm.premiseGrids['GridPremiseTask'] && vm.premiseGrids['GridPremiseTask'].dataSource.read();
          vm.premiseGrids['GridTenantsAndUsersOfPremise'] &&
            vm.premiseGrids['GridTenantsAndUsersOfPremise'].dataSource.read();
        } else {
          vm.tenanyChequeGrids['GridChequeContract'] && vm.tenanyChequeGrids['GridChequeContract'].dataSource.read();
          vm.tenanyChequeGrids['GridChequePublicUtilities'] &&
            vm.tenanyChequeGrids['GridChequePublicUtilities'].dataSource.read();
          vm.tenanyChequeGrids['GridChequeSurface'] && vm.tenanyChequeGrids['GridChequeSurface'].dataSource.read();
          vm.tenanyChequeGrids['GridChequeEquipment'] && vm.tenanyChequeGrids['GridChequeEquipment'].dataSource.read();
          vm.tenanyChequeGrids['GridChequeNotif'] && vm.tenanyChequeGrids['GridChequeNotif'].dataSource.read();
          vm.tenanyChequeGrids['GridChequeGenDoc'] && vm.tenanyChequeGrids['GridChequeGenDoc'].dataSource.read();
          vm.tenanyChequeGrids['GridChequeTenantAndUser'] &&
            vm.tenanyChequeGrids['GridChequeTenantAndUser'].dataSource.read();
          vm.tenanyChequeGrids['GridChequePremise'] && vm.tenanyChequeGrids['GridChequePremise'].dataSource.read();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('TenancyChequeNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'DasService',
    'gridService',
    'HistoryService',
    'LanguageService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      walService,
      dasService,
      gridService,
      HistoryService,
      LanguageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenancyChequeNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.reportList = options.reportList;
      vm.formModelTenancy = options.dto2;
      vm.budgetItemPropCalcTypePageModel = options.budgetItemPropCalcTypePageModel;
      vm.budgetItemPropCalcTypeFormModel = options.budgetItemPropCalcTypeDto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.labels = Object.assign(vm.labels, LanguageService.getDictionary().property);
      vm.actions = options.pageModel.Actions;
      vm.docList = options.docList;
      vm.deleteDisabled = deleteDisabled;

      vm.createMainItem = createMainItem;
      vm.editMainItem = editMainItem;
      vm.duplicateMainItem = duplicateMainItem;
      vm.deleteMainItem = deleteMainItem;
      vm.attachDocument = attachDocument;
      vm.viewMainItem = viewMainItem;
      vm.WAL = WAL;
      vm.TMfilterState = false;
      vm.onTenanyChequeSubItemTabSelect = onTenanyChequeSubItemTabSelect;
      vm.loadGridsOnTab = function(gridName) {
        gridService.loadGrid(gridName);
      };

      //History adatok
      var historyBinding = {
        GridTenancyCheque: { fieldid: 'TenChequeId', tableid: 'FlgTenancyCheque' },
        GridChequeContract: { fieldid: 'ChequeContractId', tableid: 'FlgChequeContract' },
        GridChequePublicUtilities: { fieldid: 'ChequePubUtilId', tableid: 'FlgChequePublicUtilities' },
        GridChequeSurface: { fieldid: 'ChequeSurfaceId', tableid: 'FlgChequeSurface' },
        GridChequeEquipment: { fieldid: 'ChequeEquipmentId', tableid: 'FlgChequeEquipment' },
        GridChequeNotif: { fieldid: 'ChequeNotifId', tableid: 'FlgChequeNotifView' },
        GridChequeTenantAndUser: { fieldid: 'ChequeTenantAndUserId', tableid: 'FlgChequeTenantAndUserView' },
        GridChequePremise: { fieldid: 'ChequePremiseId', tableid: 'FlgChequePremiseView' },
      };

      vm.History = function History(targetGrid) {
        let id = undefined;
        let selectedItems = undefined;
        let gridName = undefined;

        if (targetGrid == 'TenanyChequeGrid') {
          gridName = vm.tenanyChequeTabs[vm.activeTenanyChequeSubItemTab].gridName;
          let gridRef = vm.tenanyChequeGrids[gridName];
          selectedItems = GetSelectedGridItems(gridRef)[0];
        } else {
          gridName = 'GridTenancyCheque';
          selectedItems = GetSelectedGridItems(vm.mainGrid)[0];
        }

        if (!!selectedItems) {
          id = selectedItems[vm.pageModel.Grids[gridName].IdColumn];
        } else {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem);
          return;
        }

        HistoryService.NavigateToHistory(
          historyBinding[gridName].tableid,
          id,
          { messages: vm.pageModel.Messages },
          $state,
          true,
          historyBinding[gridName].fieldid,
          'RentableUnit'
        );
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });

      $scope.$watch('vm.activeSubItemTab', function(newItem, oldItem) {
        vm.selectedSubGridItemId = 0;
      });

      vm.back = function() {
        $state.go('main');
      };

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridTenancyCheque'].DasDescriptor;
        var selectedItems = GetSelectedGridItems($('#mainGrid')?.data('kendoGrid'));
        vm.dasSubModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      function setDasSubTenancyChequeModel() {
        if (!vm.tenanyChequeGrids) return;
        var selectedGrid = vm.tenanyChequeGrids[vm.tenanyChequeGrids[vm.activeTenanyChequeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasSubTenancyChequeModel = {
          routeId: 'Document.DocumentCreate',
          tableId: objectTobase64(
            {
              FlgTenancyCheque: vm.selectedSubGridItemId,
              FlgChequeSurface: selectedItems[0]?.ChequeSurfaceId,
              idTables: { FlgChequeSurface: 'ChequeSurfaceId' },
            },
            true
          ),
          ownerId: selectedItems[0]?.ChequeSurfaceId,
        };
        $scope.$applyAsync();
      }
      function deleteDisabled() {
        return false;
      }

      //felső fejadatok
      var formlyFilterFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFilterFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Level~eq~'PPRRU'";
      };

      var onBlurFunctions = {
        Address: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var onChangeFunctions = {
        PropertyId: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        ReasonId: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        PartnerId: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        NotifStatusId: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.pageModel.Fields.FilterClearBtn.FormlyFieldDescriptor.templateOptions.click = function() {
        vm.formModel = {};
        vm.mainGrid.dataSource.read();
      };
      vm.activeSubItemTab = 0;

      initMainGrid(
        vm,
        'GridTenancyCheque',
        'Property/TenancyChequeList/',
        function() {
          changeMainGridFilter();
          setDasModel();
        },
        function() {
          return vm.getSelectedPropertyId(false);
        }
      );

      function loadGrid(gridName) {
        var grid = $('#' + gridName).data('kendoGrid');
        if (grid) {
          grid.dataSource.read();
        }
      }

      vm.tabSelected = loadGrid;

      vm.getSelectedPropertyId = function(withTargetPropertyId = true) {
        var item = getSelectedMainGridItem();
        let propertyId = !!item ? item?.PropertyId ?? null : null;

        return {
          targetPropertyId: withTargetPropertyId ? propertyId : null,
          address: vm.formModel?.Address ?? '',
          reasonId: vm.formModel?.ReasonId,
          partnerId: vm.formModel?.PartnerId,
          propertyId: vm.formModel?.PropertyId?.Value,
          filterTM: !vm.TMfilterState,
          notifStatusId: vm.formModel?.NotifStatusId,
        };
      };

      function viewMainItem() {
        var id = getSelectedMainGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        $state.go('Property.TenancyChequeView', {
          id: id,
        });
      }

      vm.createModel = JSON.parse(JSON.stringify(vm.pageModel));

      vm.createModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Level~eq~'PPRRU'";
      };

      Object.keys(vm.createModel.Fields).forEach(x => {
        if (x != 'PropertyId') {
          vm.createModel.Fields[x].ContainerPanelId = null;
        } else {
          vm.createModel.Fields[x].FormlyFieldDescriptor.className = 'col-md-12 col-md-offset-0';
          vm.createModel.Fields[x].FormlyFieldDescriptor.templateOptions.required = true;
        }
      });

      function createMainItem() {
        var lfs = vm.getSelectedPropertyId();
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
          controller: 'SbCardListEditModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: {
              pageModel: vm.createModel,
              dto: {
                PropertyId: { Text: null, Value: lfs.targetPropertyId ?? vm.formModel?.PropertyId?.Value ?? null },
              },
              id: 0,
              state: 'new',
              panelName: 'PanelFilter',
              btnSave: { text: vm.pageModel.Actions.btnOk.Title },
              title: 'Új bérleményellenőrzés létrehozása',
            },
            params: {},
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function(result) {
          $state.go('Property.TenancyChequeCreate', {
            id: 0,
            PropertyId: result.dto.PropertyId?.Value,
            Level: 'PPRRU',
            Security: 'RentableUnit',
          });
        });
      }
      function editMainItem() {
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedMainGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        $state.go('Property.TenancyChequeEdit', {
          id: id,
          PropertyId: lfs.targetPropertyId,
          Level: 'PPRRU',
          Security: 'RentableUnit',
        });
      }
      function duplicateMainItem(premiseTS = false) {
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedMainGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        duplicateMainItemCall(id, lfs, premiseTS);

        function duplicateMainItemCall(id, lfs, premiseTS) {
          $state.go('Property.TenancyChequeDuplicate', {
            id: id,
            PropertyId: lfs.targetPropertyId,
            Level: 'PPRRU',
            PremiseTS: premiseTS,
            Security: 'RentableUnit',
          });
        }
      }

      function deleteMainItem() {
        var lfs = vm.getSelectedPropertyId();
        var id = getSelectedMainGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Property/TenancyChequeDeleteRentableUnit/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  vm.mainGrid.dataSource.read();
                });
              },
            },
          },
        });
      }

      function attachDocument(usedGrid) {
        dasService.NavigateToDas(vm.messages, 'Property.RentableUnitNavDasDocumentsNav', 'FlgTenancyCheque', id);
      }

      function WAL(usedGrid) {
        walService.NavigateToWal('Property', 'RentableUnitTenancyChequeNavWal', 'FlgTenancyCheque');
      }

      function getSelectedMainGridItem() {
        var gridRef = vm.mainGrid;
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedMainGridItemId() {
        var item = getSelectedMainGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids['GridTenancyCheque'].IdColumn];
        }
        return undefined;
      }

      vm.toggleTMFilterState = async function() {
        let gridName = vm.tabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.grids[gridName];
        let idField = vm.pageModel.Grids[gridName].IdColumn;
        let selectedId;
        if (GetSelectedGridItems(gridRef)[0]) {
          selectedId = GetSelectedGridItems(gridRef)[0][idField];
        }
        await gridRef?.dataSource?.read();
        if (selectedId) {
          let i = 0;
          let selectedrow = 0;
          await gridRef.dataItems().forEach(element => {
            i++;
            if (element[idField] == selectedId) {
              selectedrow = i;
              return false;
            }
          });
          if (selectedrow > 0) {
            selectedrow--;
            gridRef.select('tr:eq(' + selectedrow + ')');
          } else {
            selectedId = 0;
          }
        }
        changeMainGridFilter(selectedId);
      };
      ////////////////////////////////////////////////////////////////
      /////////// TenancyCheque Area /////////////////////////////////
      ////////////////////////////////////////////////////////////////

      vm.tenanyChequePageModel = options.pageModel;
      vm.activeTenanyChequeSubItemTab = 0;
      vm.selectedSubGridItemId = 0;

      vm.getSelectedTenanyChequeId = function() {
        return {
          targetTenancyChequeId: vm.selectedSubGridItemId,
        };
      };

      var generatedTenanyChequeGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.tenanyChequePageModel.Tabs,
        vm.tenanyChequePageModel.Panels,
        vm.tenanyChequePageModel.Grids,
        [
          'PanelChequeContract',
          'PanelChequeTenantAndUser',
          'PanelChequePremise',
          'PanelChequePublicUtilities',
          'PanelChequeSurface',
          'PanelChequeEquipment',
          'PanelChequeNotif',
          'PanelChequeGenDoc',
        ],
        function(gridModel) {
          if (gridModel.Name === 'GridChequeContract') {
            gridModel.ControllerMethod = 'Property/ChequeContractList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequePublicUtilities') {
            gridModel.ControllerMethod = 'Property/ChequePublicUtilitiesList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeSurface') {
            gridModel.ControllerMethod = 'Property/ChequeSurfaceList/';

            return {
              gridModel,
              selectFunction: function() {
                setDasSubTenancyChequeModel();
              },

              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeEquipment') {
            gridModel.ControllerMethod = 'Property/ChequeEquipmentList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeNotif') {
            gridModel.ControllerMethod = 'Property/ChequeNotifList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeGenDoc') {
            gridModel.ControllerMethod = 'Property/TenChequeGenDocList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequeTenantAndUser') {
            gridModel.ControllerMethod = 'Property/ChequeTenantAndUserList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          if (gridModel.Name === 'GridChequePremise') {
            gridModel.ControllerMethod = 'Property/ChequePremiseList/';

            return {
              gridModel,
              transportData: vm.getSelectedTenanyChequeId,
            };
          }
          return null;
        }
      );
      vm.tenanyChequeTabs = generatedTenanyChequeGridTabs.tabs;
      vm.tenanyChequeGridOptions = generatedTenanyChequeGridTabs.gridOptions;
      vm.tenanyChequeGrids = generatedTenanyChequeGridTabs.grids;

      setTimeout(function() {
        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;
        $scope.activeTenanyChequeSubItemTab =
          Number(localStorage.getItem($state.current.name + '_' + 'activeTenanyChequeSubTab')) || 0;
        vm.activeTenanyChequeSubItemTab = $scope.activeTenanyChequeSubItemTab;
      }, 100);

      vm.openTenancyChequeReport = function(type) {
        var tenCheque = vm.getSelectedTenanyChequeId();
        $http
          .post('Property/GenerateTenancyChequeReport', { tenChequeId: tenCheque.targetTenancyChequeId, type: type })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
              toastr.success('Sikeres generálás!');
            },
            function(err) {
              console.err(err);
              // TODO error: toastr
            }
          );
      };
      vm.showChequePremiseSurface = function(gridname) {
        return gridname === 'GridChequePremise';
      };
      vm.onChangesChequePremiseSurface = function(ctrl) {
        ctrl.activeTab = 0;
        ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
          ctrl.tabs,
          ctrl.panels,
          ctrl.grids,
          ['PanelChequePremiseSurface'],
          function(gridModel) {
            if (gridModel.Name === 'GridChequePremiseSurface') {
              gridModel.ControllerMethod = 'Property/ChequePremiseSurfaceList/';

              return {
                gridModel,
                transportData: function() {
                  return {
                    targetPremiseId: ctrl.row.PremiseId,
                    targetTenancyChequeId: ctrl.row.TenChequeId,
                  };
                },
                selectFunction: function() {},
              };
            }

            return null;
          }
        );
      };
      vm.generateTemplate = function(templateId) {
        var tenCheque = vm.getSelectedTenanyChequeId();
        $http
          .post('Property/TenChequeGenDoc', {
            templateId: templateId,
            id: { TenChequeId: tenCheque.targetTenancyChequeId },
          })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
            },
            function(result) {
              toastr.error('Nem generálható riport!');
            }
          );
      };
      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(id) {
        var targetGrid = $('#mainGrid').data('kendoGrid');
        if (id >= 0) {
          vm.selectedSubGridItemId = id;
        } else {
          var selectedItems = GetSelectedGridItems(targetGrid);
          if (selectedItems.length === 0) return;
          vm.disableEdit = selectedItems[0]['ChequeStatus'] === 'TCSCL';
          vm.subGridIdField = vm.pageModel.Grids['GridTenancyCheque'].IdColumn;
          vm.selectedSubGridItemId = selectedItems[0][vm.subGridIdField];
        }
        //az összes hozzá tartozó tabot betöltse
        let gridName = vm.tenanyChequeTabs[vm.activeTenanyChequeSubItemTab].gridName;
        vm.tenanyChequeGrids[gridName] && vm.tenanyChequeGrids[gridName].dataSource.read();
      }
      function onTenanyChequeSubItemTabSelect(index) {
        let gridName = vm.tenanyChequeTabs[index].gridName;
        vm.tenanyChequeGrids[gridName] && vm.tenanyChequeGrids[gridName].dataSource.read();
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('AnnexeEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AnnexeEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.collapseBooleans = { detailsIsCollapsed: false, annexeIsCollapsed: true };
      vm.activeBooleans = { detailsIsActive: true, annexeIsActive: false };

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      vm.UIHelperService.setDefaultSidebarStatus();
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      var level = 'PropImmovable';

      vm.save = function() {
        $http
          .post('Property/Annexe' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.attachDocument = function() {
        var id = vm.formModel.AnnexeId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgAnnexe', id);
      };
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'detailsIsCollapsed':
            vm.activeBooleans['detailsIsActive'] = true;
            break;
          case 'annexeIsCollapsed':
            vm.activeBooleans['annexeIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('BlockEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BlockEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      var level = 'PropImmovable';

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.save = function() {
        $http
          .post('Property/Block' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
      };
      vm.attachDocument = function() {
        var id = vm.formModel.BlockId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgBlock', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ResponsibleEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, lockService, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ResponsibleEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.BackTo = $stateParams.BackTo;

      vm.save = saveItem;
      vm.cancel = cancelItem;

      vm.formModel.wrk_IsPartnerTribe = false;
      vm.formModel.wrk_LatestFlgResponsible = null;

      vm.security = $stateParams.Security;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.UIHelperService = UIHelperService;
      vm.saveButtonHandling = saveButtonHandling;

      vm.UIHelperService.setDefaultSidebarStatus();

      var level = '';

      if (options.dto.Level === 'PPROB') {
        level = 'Object';
      } else {
        level = 'PropImmovable';
      }
      //visszatöltésnél megnézi hogy meg kell-e jeleníteni a PartnerId F2-t
      if (!!vm.formModel.ResponsibleTypeId) {
        $http({
          method: 'GET',
          url: 'Property/GetResponsibleType',
          params: { ResponsibleTypeId: vm.formModel.ResponsibleTypeId },
        }).then(function successCallback(response) {
          var FlgResponsibleType = response.data;
          if (FlgResponsibleType !== null) {
            vm.formModel.wrk_IsPartnerTribe = FlgResponsibleType.IsPartnerTribe;
          }
        });
      }

      function saveItem() {
        $http
          .post('Property/Responsible' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);

            if (response.data.NeedAccount === true) {
              bootbox.dialog({
                message: vm.messages.PR728,
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: vm.messages.No,
                    className: 'btn-default',
                    callback: function() {
                      $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
                    },
                  },
                  confirm: {
                    label: vm.messages.Yes,
                    className: 'btn-primary',
                    callback: function() {
                      $state.go('Partner.GridPartBankCreate', { id: 0, PartnerId: response.data.PartnerId });
                    },
                  },
                },
              });
            } else {
              $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PyramidNav');
      }

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ResponsibleId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgResponsible', id);
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      // Usage: "fieldName": "typeName"
      var customTypes = {
        CommonCostsAccountSeparator1: 'separatorDash',
        CommonCostsAccountSeparator2: 'separatorDash',
        RenovationFundAccountSeparator1: 'separatorDash',
        RenovationFundAccountSeparator2: 'separatorDash',
        CommonCostsAccount2: 'maskedInput',
        CommonCostsAccount3: 'maskedInput',
        RenovationFundAccount2: 'maskedInput',
        RenovationFundAccount3: 'maskedInput',
      };

      // Usage: "fieldName": "className"
      var customClasses = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        DateOfCommission: {
          /**
           * @return {boolean}
           */
          DateOfCommissionValidator: function(modelValue, viewValue) {
            if (vm.formModel.wrk_LatestFlgResponsible !== null) {
              var latestValue = new moment(
                vm.formModel.wrk_LatestFlgResponsible.ValidTo !== null
                  ? vm.formModel.wrk_LatestFlgResponsible.ValidTo
                  : vm.formModel.wrk_LatestFlgResponsible.DateOfCommission,
                kendo.culture().calendar.patterns.d.toUpperCase()
              );
              var currValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

              return currValue.isAfter(latestValue);
            }
            return true;
          },
        },
        StreetNumber: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          StreetNumberValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return false;
            }
            return vm.formModel.StreetChar === null || vm.formModel.StreetChar.text === '' || modelValue !== '';
          },
        },

        ValidTo: {
          /**
           * @return {boolean}
           */
          ResponsibleValidToValidator: function(modelValue, viewValue) {
            if (modelValue === null) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var dateOfCommissionValue = new moment(
              vm.formModel.DateOfCommission,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            return validToValue.isSameOrAfter(dateOfCommissionValue);
          },
        },
        Mail: {
          /**
           * @return {boolean}
           */
          email: function(modelValue, viewValue) {
            if (modelValue == '' || !modelValue) return true;
            return sysEmailValidate(modelValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ResponsibleTypeId: function(selectedItem) {
          $http({
            method: 'GET',
            url: 'Property/GetResponsibleType',
            params: { ResponsibleTypeId: selectedItem.key },
          }).then(function successCallback(response) {
            var FlgResponsibleType = response.data;
            if (FlgResponsibleType !== null) {
              vm.formModel.wrk_IsPartnerTribe = FlgResponsibleType.IsPartnerTribe;
              vm.formModel.ResponsibleTypeIsHandler = FlgResponsibleType.IsHandler;
              if (!FlgResponsibleType.IsHandler) vm.formModel.BankTransfer = false;
              vm.formModel.PartnerId = { Value: null, Text: null };
              //partner miatt ezeket is nullozza
              vm.formModel.PostCode = { Text: null, Value: null };
              vm.formModel.Locality = { Text: null, Value: null };
              vm.formModel.Street = '';
              vm.formModel.StreetChar = '';
              vm.formModel.StreetNumber = '';
              vm.formModel.Quarter = '';
              vm.formModel.Building = '';
              vm.formModel.Stairway = '';
              vm.formModel.Floor = '';
              vm.formModel.Door = '';
            }
          });

          $http({
            method: 'GET',
            url: 'Property/ResponsibleGetLatestResponsible',
            params: { PropertyId: vm.formModel.PropertyId, ResponsibleTypeId: selectedItem.key },
          }).then(function successCallback(response) {
            if (response.data === null || response.data === '') {
              vm.formModel.wrk_LatestFlgResponsible = null;
            } else {
              vm.formModel.wrk_LatestFlgResponsible = response.data;
            }
          });
        },
        CommonCostsAccount1: function(selectedItem) {
          if (!selectedItem.Value) {
            vm.formModel.CommonCostsAccount2 = '';
            vm.formModel.CommonCostsAccount3 = '';
          }
        },
        RenovationFundAccount1: function(selectedItem) {
          if (!selectedItem.Value) {
            vm.formModel.RenovationFundAccount2 = '';
            vm.formModel.RenovationFundAccount3 = '';
          }
        },
      };

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};
      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};
      // Usage: "fieldName": "inputMask"
      var inputMasks = {
        CommonCostsAccount1: '99999999',
        CommonCostsAccount2: '99999999',
        CommonCostsAccount3: '99999999',
        RenovationFundAccount1: '99999999',
        RenovationFundAccount2: '99999999',
        RenovationFundAccount3: '99999999',
      };

      var onBlurFunctions = {
        PostCode: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Value).then(
                function(result) {
                  var locality = result.data.result.Value;
                  if (locality) {
                    vm.formModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                  }
                },
                function(error) {}
              );
            }
          }
        },
        Locality: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
                function(result) {
                  var postcode = result.data.result.Value;
                  if (postcode) {
                    if (
                      !vm.formModel.PostCode ||
                      !vm.formModel.PostCode.Value ||
                      postcode === vm.formModel.PostCode.Value
                    ) {
                      vm.formModel.PostCode = {
                        Text: postcode,
                        Value: postcode,
                      };
                    } else {
                      $http.get('Partner/GetAllLocalities?postcode=' + vm.formModel.PostCode.Value).then(
                        function(result) {
                          var localities = result.data.result.Localities;
                          if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                            vm.formModel.PostCode = {
                              Text: postcode,
                              Value: postcode,
                            };
                          }
                        },
                        function(error) {}
                      );
                    }
                  }
                },
                function(error) {}
              );
            }
          }
        },
        PartnerId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.GridItem && !!vm.formModel.PartnerId) {
            vm.formModel.RespName = selectedItem.GridItem.Name;
            $http({
              method: 'GET',
              url: 'Property/ResponsibleGetPartAddress',
              params: { PartnerId: selectedItem.GridItem.PartnerId },
            }).then(function successCallback(response) {
              if (!!response.data.PartAddress) {
                vm.formModel.PostCode = response.data.PartAddress.PostCode;
                vm.formModel.PostCode.Text = response.data.PartAddress.PostCode?.Value; //TODO
                vm.formModel.Locality = response.data.PartAddress.Locality;
                vm.formModel.Locality.Text = response.data.PartAddress.PostCode?.Value; //F22 nem tolti be Key alapjan a Textet, itt ugyanaz a ketto azert a hackeles
                vm.formModel.Country = response.data.PartAddress.Country;
                vm.formModel.Street = response.data.PartAddress.Street;
                vm.formModel.StreetChar = response.data.PartAddress.StreetChar;
                vm.formModel.StreetNumber = response.data.PartAddress.StreetNumber;
                vm.formModel.Quarter = response.data.PartAddress.Quarter;
                vm.formModel.Building = response.data.PartAddress.Building;
                vm.formModel.Stairway = response.data.PartAddress.Stairway;
                vm.formModel.Floor = response.data.PartAddress.Floor;
                vm.formModel.Door = response.data.PartAddress.Door;
              }
              if (!!response.data.CommonCostsAccount.Account1) {
                vm.formModel.CommonCostsAccount1 = response.data.CommonCostsAccount.Account1;
                vm.formModel.CommonCostsAccount1.Text = response.data.CommonCostsAccount.Account1?.Value;
                vm.formModel.CommonCostsAccount2 = response.data.CommonCostsAccount.Account2;
                vm.formModel.CommonCostsAccount3 = response.data.CommonCostsAccount.Account3;
              }
              if (!!response.data.RenovationFundAccount.Account1) {
                vm.formModel.RenovationFundAccount1 = response.data.RenovationFundAccount.Account1;
                vm.formModel.RenovationFundAccount1.Text = response.data.RenovationFundAccount.Account1?.Value;
                vm.formModel.RenovationFundAccount2 = response.data.RenovationFundAccount.Account2;
                vm.formModel.RenovationFundAccount3 = response.data.RenovationFundAccount.Account3;
              }
            });
          }
          if (!selectedItem && !vm.formModel.PartnerId.Value && vm.formModel.wrk_IsPartnerTribe) {
            ////ha ki X-eljuk uriti a tobbi mezot is
            vm.formModel.PostCode = { Text: null, Value: null };
            vm.formModel.Locality = { Text: null, Value: null };
            //vm.formModel.Country = ""; Default parameterbol, ezt ne uritse
            vm.formModel.Street = '';
            vm.formModel.StreetChar = '';
            vm.formModel.StreetNumber = '';
            vm.formModel.Quarter = '';
            vm.formModel.Building = '';
            vm.formModel.Stairway = '';
            vm.formModel.Floor = '';
            vm.formModel.Door = '';
          }
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        /**
         * @return {boolean}
         */
        PartnerId: function($viewValue, $modelValue, scope) {
          return !vm.formModel.wrk_IsPartnerTribe;
        },
      };

      var customExpressionProperties = {
        PartnerId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.wrk_IsPartnerTribe;
          },
          'templateOptions.required': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        BankTransfer: {
          'templateOptions.disabled': function() {
            return !vm.formModel.ResponsibleTypeIsHandler;
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return vm.formModel.validToIsDisabled;
          },
        },
        StreetNumber: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
          'templateOptions.required': function() {
            return !(vm.formModel.StreetChar === null || vm.formModel.StreetChar === '');
          },
        },
        Street: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        StreetChar: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        PostCode: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Locality: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Country: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Quarter: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Building: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Stairway: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Floor: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        Door: {
          'templateOptions.disabled': function() {
            return vm.formModel.wrk_IsPartnerTribe;
          },
        },
        CommonCostsAccountSeparator1: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        CommonCostsAccountSeparator2: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        // CommonCostsAccount1: {
        // 'templateOptions.required': function() {
        // return vm.formModel.BankTransfer === true;
        // },
        // },
        CommonCostsAccount2: {
          'templateOptions.label': function() {
            return '\u00A0';
          },

          'templateOptions.required': function() {
            if (!!vm.formModel.CommonCostsAccount1) {
              return vm.formModel.CommonCostsAccount1.Value !== null;
            }
            return vm.formModel.CommonCostsAccount1 !== null && vm.formModel.CommonCostsAccount1 !== '';
          },
        },
        CommonCostsAccount3: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        RenovationFundAccountSeparator1: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        RenovationFundAccountSeparator2: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        // RenovationFundAccount1: {
        // 'templateOptions.required': function() {
        // return vm.formModel.BankTransfer === true;
        // },
        // },
        RenovationFundAccount2: {
          'templateOptions.label': function() {
            return '\u00A0';
          },

          'templateOptions.required': function() {
            if (!!vm.formModel.RenovationFundAccount1) {
              return vm.formModel.RenovationFundAccount1.Value !== null;
            }
            return vm.formModel.RenovationFundAccount1 !== null && vm.formModel.RenovationFundAccount1 !== '';
          },
        },
        RenovationFundAccount3: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      ////////////////////////////////////////////////////////////////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelResponsible.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ObjectCadastralEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ObjectCadastralEditCtrl', stateParams);
      }
      var vm = this;

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isCreate = $stateParams.isCreate;
      vm.isView = false;

      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      vm.pageModel.Separator = '/';
      var lastRow = vm.formModel.LastRow;
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

      vm.security = $stateParams.Security;

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        CadastralType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Character: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Asset: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Ownership: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            return !vm.formModel.isConPropEmpty && !vm.isCreate;
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfBuildings: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Negotiability: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NatConservation: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MunicipalLaw: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Locality: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var onBlurFunctions = {};

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        Owner: function(selectedItem) {
          var asd = selectedItem;
          vm.formModel.Owner.Value = selectedItem.Owner;
          vm.formModel.Owner.Text = selectedItem.Owner;
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        NumOfBuildings: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        PossessionDate: {
          /**
           * @return {boolean}
           */
          PossessionDateValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            var OutOfPossessionValue = new moment(
              vm.formModel.OutOfPossession,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            var PossessionDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(OutOfPossessionValue)) {
              return true;
            }

            return OutOfPossessionValue.isSameOrAfter(PossessionDateValue);
          },
        },
        OutOfPossession: {
          /**
           * @return {boolean}
           */
          OutOfPossessionDateValidator: function(modelValue) {
            var OutOfPossessionValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var PossessionDateValue = new moment(
              vm.formModel.PossessionDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            if (isNaN(OutOfPossessionValue)) {
              return true;
            }

            return OutOfPossessionValue.isSameOrAfter(PossessionDateValue);
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var numericOptions = {
        NumOfBuildings: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelObjectC.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/Cadastral' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
      };
      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgObjectCadastral', id);
      };

      var possessionDateValidator = function() {
        return vm.formModel.OutOfPossession === null || typeof vm.formModel.OutOfPossession === undefined;
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('BuildingCadastralEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, lockService, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingCadastralEditCtrl', stateParams);
      }
      var vm = this;

      vm.UIHelperService = UIHelperService;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabInfo',
        disableRunExpression: false,
      };

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;
      vm.isView = false;
      var lastRow = vm.formModel.LastRow;
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

      vm.security = $stateParams.Security;

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      vm.pageModel.Separator = '/';
      vm.pageModel.Separator2 = '/';

      var customTypes = {
        Separator: 'separatorSlash',
        Separator2: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        Separator2: {
          'templateOptions.disabled': 'true',
        },
        SpaceOfPublic: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfPublic === null || vm.formModel.NumOfPublic === 0 || !isNaN(validTo);
          },
        },
        SpaceOfFlat: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfFlat === null || vm.formModel.NumOfFlat === 0 || !isNaN(validTo);
          },
        },
        SpaceOfGovFlat: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfGovFlat === null || vm.formModel.NumOfGovFlat === 0 || !isNaN(validTo);
          },
        },
        SpaceOfNoFlat: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfNoFlat === null || vm.formModel.NumOfNoFlat === 0 || !isNaN(validTo);
          },
        },
        SpaceOfGovNoFlat: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfGovNoFlat === null || vm.formModel.NumOfGovNoFlat === 0 || !isNaN(validTo);
          },
        },
        SpaceOfCivDef: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfCivDef === null || vm.formModel.NumOfCivDef === 0 || !isNaN(validTo);
          },
        },
        Negotiability: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        CadastralType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        DiffUsage: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ConstructDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        RenovationDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        InBuiltFloorSpace: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumberOfLevels: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NetAreaOfLevel: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        CellarLevel: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AtticInbuiltId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        State: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HeatingCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HotWSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OtherSupply: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        GarbageCan: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfElevators: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfPublic: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfFlat: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfGovFlat: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfNoFlat: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfGovNoFlat: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfCivDef: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AssetManagedRatioDenom: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        PercentOfQuality: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        AssetManagedRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AssetManagedRatioDenom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioValue = modelValue;

            return ownRatioValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioDenominatorValue = modelValue;

            return ownRatioDenominatorValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        AssetManagedRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioValue = modelValue;

            return ownRatioValue >= 0;
          },
        },
        AssetManagedRatioDenom: {
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioDenomValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownAssetManagedRatioDenomValue = modelValue;

            return ownAssetManagedRatioDenomValue >= 1;
          },
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioValidator: function(modelValue) {
            return vm.formModel.AssetManagedRatio / modelValue <= 1;
          },
        },
        NumOfElevators: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumberOfLevels: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        CellarLevel: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NetAreaOfLevel: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfPublic: {
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfGovFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfNoFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfGovNoFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumOfCivDef: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfPublic: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfGovFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfNoFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfGovNoFlat: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        SpaceOfCivDef: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        PercentOfQuality: {
          /**
           * @return {boolean}
           */
          PercentValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0 && modelValue <= 100;
          },
        },
        InBuiltFloorSpace: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onChangeFunctions = {
        NumOfPublic: function(selectedItem) {
          if (vm.formModel.NumOfPublic === null || vm.formModel.NumOfPublic === 0) {
            vm.formModel.SpaceOfPublic = 0;
          }
        },
        NumOfFlat: function(selectedItem) {
          if (vm.formModel.NumOfFlat === null || vm.formModel.NumOfFlat === 0) {
            vm.formModel.SpaceOfFlat = 0;
          }
        },
        NumOfGovFlat: function(selectedItem) {
          if (vm.formModel.NumOfGovFlat === null || vm.formModel.NumOfGovFlat === 0) {
            vm.formModel.SpaceOfGovFlat = 0;
          }
        },
        NumOfNoFlat: function(selectedItem) {
          if (vm.formModel.NumOfNoFlat === null || vm.formModel.NumOfNoFlat === 0) {
            vm.formModel.SpaceOfNoFlat = 0;
          }
        },
        NumOfGovNoFlat: function(selectedItem) {
          if (vm.formModel.NumOfGovNoFlat === null || vm.formModel.NumOfGovNoFlat === 0) {
            vm.formModel.SpaceOfGovNoFlat = 0;
          }
        },
        NumOfCivDef: function(selectedItem) {
          if (vm.formModel.NumOfCivDef === null || vm.formModel.NumOfCivDef === 0) {
            vm.formModel.SpaceOfCivDef = 0;
          }
        },
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatio: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatioDenom: function(selectedItem) {
          reValidate();
        },
      };

      var onBlurFunctions = {
        //"NumOfPublic": function (selectedItem) {
        //   if (vm.formModel.NumOfPublic === null || vm.formModel.NumOfPublic === 0) {
        //      vm.formModel.SpaceOfPublic = 0;
        //   }
        //},
        //"NumOfFlat": function (selectedItem) {
        //   if (vm.formModel.NumOfFlat === null || vm.formModel.NumOfFlat === 0) {
        //      vm.formModel.SpaceOfFlat = 0;
        //   }
        //},
        //"NumOfGovFlat": function (selectedItem) {
        //   if (vm.formModel.NumOfGovFlat === null || vm.formModel.NumOfGovFlat === 0) {
        //      vm.formModel.SpaceOfGovFlat = 0;
        //   }
        //},
        //"NumOfNoFlat": function (selectedItem) {
        //   if (vm.formModel.NumOfNoFlat === null || vm.formModel.NumOfNoFlat === 0) {
        //      vm.formModel.SpaceOfNoFlat = 0;
        //   }
        //},
        //"NumOfGovNoFlat": function (selectedItem) {
        //   if (vm.formModel.NumOfGovNoFlat === null || vm.formModel.NumOfGovNoFlat === 0) {
        //      vm.formModel.SpaceOfGovNoFlat = 0;
        //   }
        //},
        //"NumOfCivDef": function (selectedItem) {
        //   if (vm.formModel.NumOfCivDef === null || vm.formModel.NumOfCivDef === 0) {
        //      vm.formModel.SpaceOfCivDef = 0;
        //   }
        //},
        //"OwnRatio": function (selectedItem) {
        //   reValidate();
        //},
        //"OwnRatioDenominator": function (selectedItem) {
        //   reValidate();
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var numericOptions = {
        InBuiltFloorSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        NetAreaOfLevel: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        CellarLevel: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfPublic: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfFlat: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfGovFlat: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfNoFlat: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfGovNoFlat: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfCivDef: {
          decimals: 2,
          format: 'n2',
          max: 999,
          min: 0,
        },
        PercentOfQuality: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 0,
        },
        NumOfElevators: {
          decimals: 0,
          format: 'n0',
          max: 99,
          min: 0,
        },
        NumOfPublic: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumOfFlat: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumOfGovFlat: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumOfNoFlat: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumOfGovNoFlat: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumOfCivDef: {
          decimals: 0,
          format: 'n0',
          max: 99999,
          min: 0,
        },
        NumberOfLevels: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatioDenom: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelBuildingCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/BuildingCadastral' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.BuildingCadId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgBuildingCadastral', id);
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('EdificeCadastralEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EdificeCadastralEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isView = false;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.security = $stateParams.Security;

      vm.pageModel.Separator = '/';
      vm.pageModel.Separator2 = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
        Separator2: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        Separator2: {
          'templateOptions.disabled': 'true',
        },
        CadastralType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AssetManagedRatioDenom: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        FunctionOfEdifice: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ConstructDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        RenovationDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AllNetArea: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PercentOfQuality: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) && !lastRow;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        DeviceInvested: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        AllNetArea: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        PercentOfQuality: {
          /**
           * @return {boolean}
           */
          PercentValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0 && modelValue <= 100;
          },
        },
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        AssetManagedRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioValue = modelValue;

            return ownRatioValue >= 0;
          },
        },
        AssetManagedRatioDenom: {
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioDenomValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownAssetManagedRatioDenomValue = modelValue;

            return ownAssetManagedRatioDenomValue >= 1;
          },
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioValidator: function(modelValue) {
            return vm.formModel.AssetManagedRatio / modelValue <= 1;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {
        //"OwnRatio": function (selectedItem) {
        //   reValidate();
        //},
        //"OwnRatioDenominator": function (selectedItem) {
        //   reValidate();
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatio: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatioDenom: function(selectedItem) {
          reValidate();
        },
      };

      var numericOptions = {
        AllNetArea: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        PercentOfQuality: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatioDenom: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertNumericOptions(vm.pageModel, numericOptions);

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelEdificeCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/EdificeCadastral' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgEdificeCadastral', id);
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RentUnitCadastralEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentUnitCadastralEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      vm.RentUnitType = options.dto.TenType;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      var isWaterMeter = vm.formModel.IsWaterMeter;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.saveButtonHandling = saveButtonHandling;

      vm.security = $stateParams.Security;

      vm.UIHelperService = UIHelperService;

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.pageModel.Separator = '/';
      vm.pageModel.Separator1 = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      var enableRatio = vm.formModel.EnableRatio;

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
        Separator1: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        Separator1: {
          'templateOptions.disabled': 'true',
        },
        SpaceOfRooms: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfRooms === 0 || vm.formModel.NumOfRooms === null || !isNaN(validTo);
          },
        },
        SpaceOfBedchamber: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfBedchamber === 0 || vm.formModel.NumOfBedchamber === null || !isNaN(validTo);
          },
        },
        SpaceOfDiningRecess: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfDiningRecess === 0 || vm.formModel.NumOfDiningRecess === null || !isNaN(validTo);
          },
        },
        SpaceOfSmallRooms: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfSmallRooms === 0 || vm.formModel.NumOfSmallRooms === null || !isNaN(validTo);
          },
        },
        SpaceOfHalls: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfHalls === 0 || vm.formModel.NumOfHalls === null || !isNaN(validTo);
          },
        },
        SpaceOfLobby: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfLobby === 0 || vm.formModel.NumOfLobby === null || !isNaN(validTo);
          },
        },
        SpaceOfToilet: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfToilet === 0 || vm.formModel.NumOfToilet === null || !isNaN(validTo);
          },
        },
        SpaceOfOther: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfOther === 0 || vm.formModel.NumOfOther === null || !isNaN(validTo);
          },
        },
        IsWaterMeter: {
          'templateOptions.disabled': function() {
            //return isWaterMeter || !isNaN(validTo);
            return !isNaN(validTo);
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        TenType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        CadastralType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Negotiability: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        LegalOrder: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PercentOfQuality: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PUSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HeatingCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HotWSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AnalyticCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        PropertyOwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
        },
        PropertyOwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        CapitalFunctionRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        CookingRoomKind: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ComfortLevel: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfCookingRoom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfCapitalFunctionRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfWaiterRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfBedchamber: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfDiningRecess: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfSmallRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfHalls: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfLobby: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfToilet: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfOther: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfWaiterRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Count: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var hideExpressions = {
        Count: function() {
          return true;
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralOwnRatioValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        PropertyOwnRatio: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralPropertyOwnRatioValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue > 0;
          },
        },
        PropertyOwnRatioDenominator: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralPropertyOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralPropertyOwnRatioValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return vm.formModel.PropertyOwnRatio / modelValue <= 1;
          },
          PropertyOwnRatioAndPropertyOwnRatioDenominatorValidator: function(modelValue) {
            return (vm.formModel.PropertyOwnRatio && modelValue) || (!vm.formModel.PropertyOwnRatio && !modelValue);
          },
        },
        NumOfRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfBedchamber: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfBedchamber: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfDiningRecess: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfDiningRecess: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfSmallRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfSmallRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfHalls: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfHalls: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfLobby: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfLobby: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfCookingRoom: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfToilet: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfToilet: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfOther: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfOther: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {
        Name: function(selectedItem) {
          if (
            (selectedItem === null || !selectedItem.Name || selectedItem.Name === '') &&
            (vm.formModel.Name === '' || vm.formModel.Name === null)
          ) {
            vm.formModel.Name = vm.formModel.Address;
          }
        },
      };

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        PropertyOwnRatio: function(selectedItem) {
          reValidate();
        },
        PropertyOwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        NumOfRooms: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfRooms = null;
          }
        },
        NumOfBedchamber: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfBedchamber = null;
          }
        },
        NumOfDiningRecess: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfDiningRecess = null;
          }
        },
        NumOfSmallRooms: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfSmallRooms = null;
          }
        },
        NumOfHalls: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfHalls = null;
          }
        },
        NumOfLobby: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfLobby = null;
          }
        },
        NumOfToilet: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfToilet = null;
          }
        },
        NumOfOther: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfOther = null;
          }
        },
      };

      var numericOptions = {
        NumOfRooms: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfBedchamber: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfDiningRecess: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfSmallRooms: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfHalls: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfLobby: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfToilet: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfOther: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        CapitalFunctionRooms: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfWaiterRooms: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        SpaceOfRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfBedchamber: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfDiningRecess: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfSmallRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfHalls: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfLobby: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfCookingRoom: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfToilet: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfOther: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfCapitalFunctionRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfWaiterRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        PercentOfQuality: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 1000000000,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 1000000000,
          min: 0,
        },
        PropertyOwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 1000000000,
          min: 0,
        },
        PropertyOwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 1000000000,
          min: 0,
        },
      };

      var customCallbackFunctions = {
        IsWaterMeter: function(selectedItem) {
          if (!selectedItem && vm.formModel.IsWaterMeterOnMeterView) {
            toastr.error('A bérleményhez élő vízóra van rendelve!');
            vm.formModel.IsWaterMeter = true;
          }
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertNumericOptions(vm.pageModel, numericOptions);

      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelRentUnit.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.save = function() {
        $http
          .post('Property/RentUnitCadastral' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgRentUnitCadastral', id);
      };

      vm.count = function() {
        $http
          .post('Property/OwnRatioCounter', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.PropertyOwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.PropertyOwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.PropertyOwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.PropertyOwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('LandCadastralEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'LandCadastralEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.security = $stateParams.Security;

      vm.UIHelperService = UIHelperService;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabLandCadastral',
        disableRunExpression: false,
      };

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.pageModel.Separator = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
        Separator2: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        CadastralType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AssetManagedRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        AssetManagedRatioDenom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        FunctionOfLand: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        LandUse: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        GoldCrown: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfCultivation: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        BuildingPlotKind: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MannerOfBuildIn: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        InbuiltPlot: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        IntactRate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        GasSupply: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Electricity: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        DrinkingWater: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SewageDisposal: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        RainDrainage: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        FireWaterNav: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OtekZone: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) && !lastRow;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        AssetManagedRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioValue = modelValue;

            return ownRatioValue >= 0;
          },
        },
        AssetManagedRatioDenom: {
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioDenomValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownAssetManagedRatioDenomValue = modelValue;

            return ownAssetManagedRatioDenomValue >= 1;
          },
          /**
           * @return {boolean}
           */
          ObjectCadastralAssetManagedRatioValidator: function(modelValue) {
            return vm.formModel.AssetManagedRatio / modelValue <= 1;
          },
        },
        IntactRate: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        GoldCrown: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0; // && validateGoldCrown(modelValue);
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {
        //"OwnRatio": function (selectedItem) {
        //   reValidate();
        //},
        //"OwnRatioDenominator": function (selectedItem) {
        //   reValidate();
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      var numericOptions = {
        GoldCrown: {
          decimals: 3,
          format: 'n3',
          max: 1000,
          min: 0,
        },
        IntactRate: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        AssetManagedRatioDenom: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatio: function(selectedItem) {
          reValidate();
        },
        AssetManagedRatioDenom: function(selectedItem) {
          reValidate();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelLandCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelLandCadastralOtherData.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/LandCadastral' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgLandCadastral', id);
      };

      function validateIntactRate(intactRate) {
        return /^[0-9]{1,3}(,[0-9]{1,2})?$/.test(intactRate);
      }

      function validateGoldCrown(goldCrown) {
        return /^[0-9]+(,[0-9]{1,3})?$/.test(goldCrown);
      }

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.AssetManagedRatioDenom.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ObjectCadastralSimpliEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ObjectCadastralSimpliEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseBooleans = { objectDetailsIsCollapsed: false, otherDetailsIsCollapsed: true };
      vm.activeBooleans = { objectDetailsIsActive: true, otherDetailsIsActive: false };

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isCreate = $stateParams.isCreate;
      vm.isView = false;

      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.security = $stateParams.Security;

      vm.pageModel.Separator = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1900-01-01');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        Character: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Ownership: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            return !vm.formModel.isConPropEmpty && !vm.isCreate;
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var onBlurFunctions = {};

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        Owner: function(selectedItem) {
          var asd = selectedItem;
          vm.formModel.Owner.Value = selectedItem.Owner;
          vm.formModel.Owner.Text = selectedItem.Owner;
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        PossessionDate: {
          /**
           * @return {boolean}
           */
          PossessionDateValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            var OutOfPossessionValue = new moment(
              vm.formModel.OutOfPossession,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            var PossessionDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(OutOfPossessionValue)) {
              return true;
            }

            return OutOfPossessionValue.isSameOrAfter(PossessionDateValue);
          },
        },
        OutOfPossession: {
          /**
           * @return {boolean}
           */
          OutOfPossessionDateValidator: function(modelValue) {
            var OutOfPossessionValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var PossessionDateValue = new moment(
              vm.formModel.PossessionDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            if (isNaN(OutOfPossessionValue)) {
              return true;
            }

            return OutOfPossessionValue.isSameOrAfter(PossessionDateValue);
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var numericOptions = {
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelObjectC.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/CadastralSimpli' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
      };
      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgObjectCadastral', id);
      };

      var possessionDateValidator = function() {
        return vm.formModel.OutOfPossession === null || typeof vm.formModel.OutOfPossession === undefined;
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'objectDetailsIsCollapsed':
            vm.activeBooleans['objectDetailsIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('BuildingCadastralSimpliEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, lockService, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingCadastralSimpliEditCtrl', stateParams);
      }
      var vm = this;

      vm.UIHelperService = UIHelperService;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;
      vm.isView = false;
      var lastRow = vm.formModel.LastRow;
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

      vm.security = $stateParams.Security;

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      vm.pageModel.Separator = '/';

      var customTypes = {
        Separator: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        NumberOfLevels: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HeatingCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HotWSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OtherSupply: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfElevators: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioValue = modelValue;

            return ownRatioValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }

            var ownRatioDenominatorValue = modelValue;

            return ownRatioDenominatorValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        NumOfElevators: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        NumberOfLevels: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }

            return modelValue >= 0;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {};

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var numericOptions = {
        NumOfElevators: {
          decimals: 0,
          format: 'n0',
          max: 99,
          min: 0,
        },
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelBuildingCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/BuildingCadastralSimpli' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.BuildingCadId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgBuildingCadastral', id);
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('EdificeCadastralSimpliEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EdificeCadastralSimpliEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isView = false;

      vm.security = $stateParams.Security;

      vm.pageModel.Separator = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        FunctionOfEdifice: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) && !lastRow;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {};

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
      };

      var numericOptions = {
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelEdificeCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/EdificeCadastralSimpli' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgEdificeCadastral', id);
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RentUnitCadastralSimpliEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentUnitCadastralSimpliEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      vm.RentUnitType = options.dto.TenType;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      var isWaterMeter = vm.formModel.IsWaterMeter;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.saveButtonHandling = saveButtonHandling;

      vm.security = $stateParams.Security;

      vm.pageModel.Separator = '/';
      vm.pageModel.Separator1 = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      var enableRatio = vm.formModel.EnableRatio;

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
        Separator1: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        Separator1: {
          'templateOptions.disabled': 'true',
        },
        IsWaterMeter: {
          'templateOptions.disabled': function() {
            //return isWaterMeter || !isNaN(validTo);
            return !isNaN(validTo);
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        TenType: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PUSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HeatingCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HotWSCode: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
        },
        OwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        PropertyOwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
        },
        PropertyOwnRatioDenominator: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) || !enableRatio;
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ComfortLevel: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfRooms: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfRooms === 0 || vm.formModel.NumOfRooms === null || !isNaN(validTo);
          },
        },
        SpaceOfDiningRecess: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfDiningRecess === 0 || vm.formModel.NumOfDiningRecess === null || !isNaN(validTo);
          },
        },
        SpaceOfBedchamber: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfBedchamber === 0 || vm.formModel.NumOfBedchamber === null || !isNaN(validTo);
          },
        },
        SpaceOfSmallRooms: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfSmallRooms === 0 || vm.formModel.NumOfSmallRooms === null || !isNaN(validTo);
          },
        },
        NumOfHalls: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfHalls: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfHalls === 0 || vm.formModel.NumOfHalls === null || !isNaN(validTo);
          },
        },
        SpaceOfLobby: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfLobby === 0 || vm.formModel.NumOfLobby === null || !isNaN(validTo);
          },
        },
        SpaceOfToilet: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfToilet === 0 || vm.formModel.NumOfToilet === null || !isNaN(validTo);
          },
        },
        SpaceOfOther: {
          'templateOptions.disabled': function() {
            return vm.formModel.NumOfOther === 0 || vm.formModel.NumOfOther === null || !isNaN(validTo);
          },
        },
        NumOfDiningRecess: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        CookingRoomKind: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfOther: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        SpaceOfCookingRoom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfBedchamber: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfSmallRooms: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfLobby: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        NumOfToilet: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var hideExpressions = {
        Count: function() {
          return true;
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralOwnRatioValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        PropertyOwnRatio: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralPropertyOwnRatioValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        PropertyOwnRatioDenominator: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ObjectCadastralPropertyOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralPropertyOwnRatioValidator: function(modelValue) {
            return vm.formModel.PropertyOwnRatio / modelValue <= 1;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
        SpaceOfBedchamber: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfLobby: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfToilet: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfDiningRecess: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfHalls: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfOther: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfDiningRecess: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfHalls: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfCookingRoom: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        SpaceOfOther: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfBedchamber: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfSmallRooms: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfLobby: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
        NumOfToilet: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue >= 0;
          },
        },
      };

      var onBlurFunctions = {
        Name: function(selectedItem) {
          if (
            (selectedItem === null || !selectedItem.Name || selectedItem.Name === '') &&
            (vm.formModel.Name === '' || vm.formModel.Name === null)
          ) {
            vm.formModel.Name = vm.formModel.Address;
          }
        },
      };

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
        NumOfRooms: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfRooms = null;
          }
        },
        NumOfDiningRecess: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfDiningRecess = null;
          }
        },
        NumOfHalls: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfHalls = null;
          }
        },
        NumOfOther: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfOther = null;
          }
        },
        NumOfBedchamber: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfBedchamber = null;
          }
        },
        NumOfSmallRooms: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfSmallRooms = null;
          }
        },
        NumOfLobby: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfLobby = null;
          }
        },
        NumOfToilet: function(selectedItem) {
          if (selectedItem === 0 || selectedItem === null) {
            vm.formModel.SpaceOfToilet = null;
          }
        },
      };

      var numericOptions = {
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        PropertyOwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        PropertyOwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        SpaceOfBedchamber: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfSmallRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfLobby: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfToilet: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        NumOfDiningRecess: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfHalls: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfOther: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        SpaceOfRooms: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfDiningRecess: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfHalls: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfCookingRoom: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SpaceOfOther: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        NumOfBedchamber: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfSmallRooms: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfLobby: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
        NumOfToilet: {
          decimals: 0,
          format: 'n0',
          max: 9999,
          min: 0,
        },
      };

      var customCallbackFunctions = {
        IsWaterMeter: function(selectedItem) {
          if (!selectedItem && vm.formModel.IsWaterMeterOnMeterView) {
            toastr.error('A bérleményhez élő vízóra van rendelve!');
            vm.formModel.IsWaterMeter = true;
          }
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertNumericOptions(vm.pageModel, numericOptions);

      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelRentUnit.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.save = function() {
        $http
          .post('Property/RentUnitCadastralSimpli' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgRentUnitCadastral', id);
      };

      //sidemenu collapse
      vm.collapsePanel = function(indexName) {
        //46255: Egyéb panel nincs, mivel egy panel van, nincs értelme a collapse funkciónak, így futás előtt visszatérünk, de logika itt marad, ha változna a panelek száma
        return true;

        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'tenementDetailsIsCollapsed':
            vm.activeBooleans['partnerDetailsIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
        }
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.PropertyOwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.PropertyOwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.PropertyOwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.PropertyOwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('LandCadastralSimpliEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'LandCadastralSimpliEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.security = $stateParams.Security;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.pageModel.Separator = '/';
      var lastRow = vm.formModel.LastRow;
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      var customTypes = {
        Separator: 'separatorSlash',
      };

      var customExpressionProperties = {
        Separator: {
          'templateOptions.disabled': 'true',
        },
        OwnRatio: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OwnRatioDenominator: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        MannerOfProperty: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        PossessionDate: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        OutOfPossession: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        FunctionOfLand: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        InbuiltPlot: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        GasSupply: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        Electricity: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        DrinkingWater: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo) && !lastRow;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return !isNaN(validTo);
          },
        },
      };

      var syncValidators = {
        OwnRatio: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 0;
          },
        },
        OwnRatioDenominator: {
          /**
           * @return {boolean}
           */
          ObjectCadastralOwnRatioDenominatorValidator: function(modelValue) {
            if (!modelValue) {
              return false;
            }
            return modelValue >= 1;
          },
          /**
           * @return {boolean}
           */
          CadastralOwnRatioValidator: function(modelValue) {
            return vm.formModel.OwnRatio / modelValue <= 1;
          },
        },
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ObjectValidFromValidator: function(modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }
            return ValidFromValue.isAfter(prevValidFrom);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var onBlurFunctions = {};

      var numericOptions = {
        OwnRatio: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
        OwnRatioDenominator: {
          decimals: 0,
          format: 'n0',
          max: 32767,
          min: 0,
        },
      };

      var onChangeFunctions = {
        OwnRatio: function(selectedItem) {
          reValidate();
        },
        OwnRatioDenominator: function(selectedItem) {
          reValidate();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertNumericOptions(vm.pageModel, numericOptions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelLandCadastral.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Property/LandCadastralSimpli' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.CadastralId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgLandCadastral', id);
      };

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PremiseEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, authService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PremiseEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabPremise',
        disableRunExpression: false,
      };
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.pageModelM = options.pageModelM;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;
      vm.result = 0;
      vm.set = false;
      vm.num = 1;
      addGetterToRouteState(
        vm.pageModel,
        'RentUnitId',
        vm.formModel,
        [{ ValidFrom: 'ValidFrom' }, 'Floor', 'Stairway'],
        {
          id: vm.formModel.PropertyId,
        }
      );

      vm.generateEqSpace = generateEqSpace;
      vm.newPremiseCode = newPremiseCode;
      vm.woRentUnitId = !vm.formModel.RentUnitId || vm.formModel.RentUnitId.Value === 0;
      vm.gridLevel = $stateParams.Level;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.UIHelperService = UIHelperService;

      vm.saveButtonHandling = saveButtonHandling;

      vm.UIHelperService.setDefaultSidebarStatus();
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //PremiseCode generálás
      vm.newPremiseCode = newPremiseCode;

      //ha megvan a PremiseCode, akkor tudom ellenőrizni az előző tétel ValidFrom-ját
      vm.prevValidFrom = prevValidFrom;

      //meghatározom a FlgBudget.CommonAreas
      vm.getCommonAreas = getCommonAreas;
      //ha elő van töltve a BudgetId futtatjuk is, hogy a ktsz checkbox szinkronba kerüljön:
      vm.getCommonAreas();
      //közös terület meghatározása
      vm.comAreaMultiplier = comAreaMultiplier;

      if (vm.formModel.RentUnitContract === true) {
        toastr.warning(
          'A módosítani kívánt helység szerződéses bérleményhez tartozik!',
          'Nem minden mező módosítható!'
        );
      }

      //debugger;
      vm.isView = false;
      var lastRow = vm.formModel.LastRow;
      var prevValidFrom = new moment(vm.formModel.PrevValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      var validTo = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

      var enableRatio = vm.formModel.EnableRatio;

      if (isNaN(prevValidFrom)) {
        prevValidFrom = new moment('1899-12-31');
      }

      if (!isNaN(validTo) && !lastRow) {
        vm.isView = true;
      }

      //ha nem tölthető a Floor, akkor egyből lehet hívni az automatikus PremiseCode generálást
      if (vm.formModel.Level !== 'PPRBU' && vm.formModel.PREMGE) {
        vm.newPremiseCode();
      }

      //alapértelmezett értékek
      if (vm.formModel.level === 'PPRRU') {
        vm.formModel.PremiseType = 'PRERE';
      } else if (['PPRBU', 'PPRED', 'PPRLA'].indexOf(vm.formModel.level) !== -1) {
        vm.formModel.PremiseType = 'PRETE';
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
        angular.forEach(vm.pageModelM.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var customExpressionProperties = {
        PremiseCode: {
          'templateOptions.required': function() {
            return !vm.formModel.PREMGE;
          },
          'templateOptions.disabled': function() {
            return (
              vm.formModel.PREMGE ||
              (vm.EditOrDuplicate === 'Duplicate' && vm.formModel.PremiseTS && vm.formModel.PremiseCode !== null) ||
              (vm.formModel.ModelState === 3 && vm.EditOrDuplicate === 'Edit')
            );
          },
        },
        PremiseType: {
          'templateOptions.disabled': function() {
            return (
              (vm.formModel.ModelState === 3 && vm.EditOrDuplicate === 'Edit') ||
              (vm.gridLevel === 'PPRRU' && vm.formModel.ModelState === 2)
            );
          },
        },
        RentUnitId: {
          'templateOptions.required': function() {
            return vm.formModel.PremiseType === 'PRERE';
          },
          'templateOptions.disabled': function() {
            return (
              (vm.formModel.ModelState === 3 && vm.EditOrDuplicate === 'Edit') ||
              (vm.gridLevel === 'PPRRU' && vm.formModel.ModelState === 2) ||
              vm.formModel.PremiseType != 'PRERE'
            );
          },
        },
        BudgetId: {
          'templateOptions.required': function() {
            return (
              !authService?.parameters?.SBBox &&
              (!!vm.formModel.RentUnitId?.Value || vm.formModel.PremiseType === 'PREOP')
            );
          },
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType === 'PRETE';
          },
        },
        ComAreaInv: {
          'templateOptions.disabled': function() {
            return (
              !(vm.formModel.PremiseType === 'PRECO' || vm.formModel.PremiseType === 'PRERE') ||
              (vm.formModel.BudgetId > 0 && vm.formModel.CommonAreas !== true)
            );
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 && vm.EditOrDuplicate === 'Edit';
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return false;
          },
        },
        RentableSpace: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 && vm.formModel.PremiseTS !== true;
          },
        },
        AnnexeId: {
          'templateOptions.disabled': function() {
            return vm.formModel.Level !== 'PPRBU' && vm.formModel.Level !== 'PPRRU';
          },
        },
        BlockId: {
          'templateOptions.disabled': function() {
            return vm.formModel.Level !== 'PPRBU' && vm.formModel.Level !== 'PPRRU';
          },
        },
        StairWay: {
          'templateOptions.disabled': function() {
            return vm.formModel.Level !== 'PPRBU' && vm.formModel.Level !== 'PPRRU';
          },
        },
        Floor: {
          'templateOptions.disabled': function() {
            return vm.formModel.Level !== 'PPRBU' && vm.formModel.Level !== 'PPRRU';
          },
          'templateOptions.required': function() {
            return vm.formModel.Level === 'PPRBU' || vm.formModel.Level === 'PPRRU';
          },
        },
        SurveyedArea: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 && vm.formModel.PremiseTS !== true;
          },
        },
        PremiseSubFunction: {
          'templateOptions.disabled': function() {
            return !vm.formModel.PremiseFunction;
          },
        },
      };

      var onChangeFunctions = {
        Floor: function(selectedItem) {
          if (selectedItem) {
            vm.newPremiseCode();
          }
        },
        RentUnitId: function(selectedItem) {
          if (selectedItem && vm.formModel.PremiseType === 'PRERE') {
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
        BudgetId: function(selectedItem) {
          if (selectedItem) {
            vm.getCommonAreas();
          }
        },
        PremiseFunction: function(selectedItem) {
          if (!!selectedItem && !!vm.formModel.PremiseFunction && !vm.formModel.Name) {
            vm.formModel.Name = selectedItem.text;
          }
          !!selectedItem
            ? (vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.disabled = false)
            : (vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.disabled = true);
          vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
            return {
              premiseFunc: selectedItem.key,
            };
          };
          vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        PremiseType: function(selectedItem) {
          if (selectedItem.key !== 'PRERE') {
            vm.woRentUnitId = true;
            vm.formModel.RentUnitId.Value = 0;
            vm.formModel.RentUnitId.Text = '';
            vm.formModel.BudgetId = 0;
          }
          if (vm.formModel.PremiseType !== 'PRECO' && vm.formModel.PremiseType !== 'PRERE') {
            vm.formModel.ComAreaInv = false;
          }
          if (selectedItem.key === 'PRERE') {
            vm.pageModel.Fields.RentUnitId.FormlyFieldDescriptor.templateOptions.required = true;
          } else {
            vm.pageModel.Fields.RentUnitId.FormlyFieldDescriptor.templateOptions.required = false;
          }
          vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        ComAreaInv: function() {
          vm.comAreaMultiplier();
        },
        PremiseCode: function(selectedItem) {
          if (selectedItem && selectedItem.key) {
            vm.prevValidFrom();
          }
        },
        FloorSpace: function(selectedItem) {},
        HeadRoom: function(selectedItem) {
          generateCubicMeter();
        },
        EffHeadRoom: function(selectedItem) {
          generateCubicMeter();
        },
        RentableSpace: function(selectedItem) {
          generateEqSpace();
          generateCubicMeter();
        },
      };

      var dynamicQueryParameters = {
        BlockId: function() {
          return [
            {
              key: vm.formModel.PropertyId,
              text: 'propertyId',
            },
          ];
        },
        AnnexeId: function() {
          return [
            {
              key: vm.formModel.PropertyId,
              text: 'propertyId',
            },
          ];
        },
        RentUnitId: function() {
          return [
            {
              key: vm.formModel.PropertyId,
              text: 'propertyId',
            },
          ];
        },
      };

      var onBlurFunctions = {
        Rows: function(selectedItem) {
          generateEqSpace();
        },
      };

      var syncValidators = {
        RentableSpace: {
          PositiveNumberValidator: function(viewValue, modelValue) {
            if (modelValue >= 0) {
              return true;
            }
            return false;
          },
        },
        SurveyedArea: {
          DecimalValidator: function(viewValue, modelValue) {
            if (modelValue >= 0) {
              return true;
            }
            return false;
          },
        },
        FloorSpace: {
          PositiveNumberValidator: function(viewValue, modelValue) {
            if (modelValue >= 0) {
              return true;
            }
            return false;
          },
        },
        FullArea: {
          FloorSpaceFullAreaValidator: function(viewValue, modelValue) {
            if (modelValue > 0) {
              if (modelValue >= vm.formModel.RentableSpace) {
                return true;
              } else {
                return false;
              }
            }
            return true;
          },
        },
        HeadRoom: {
          DecimalValidator: function(viewValue, modelValue) {
            if (modelValue >= 0) {
              return true;
            }
            return false;
          },
        },
        EffHeadRoom: {
          DecimalValidator: function(viewValue, modelValue) {
            if (modelValue >= 0) {
              return true;
            }
            return false;
          },
        },
        ValidFrom: {
          ObjectValidFromValidator: function(viewValue, modelValue) {
            var ValidFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidFromValue)) {
              return false;
            }

            return ValidFromValue.isAfter(prevValidFrom);
          },
          //kikerült, hogy előre is lehessen rögzíteni helyiséget
          // RentableUnitValidFromNowValidator: function (modelValue) {
          // var ValidFromValue = new moment(modelValue, kendo.culture()
          // .calendar.patterns.d.toUpperCase());

          // var d = new Date();
          // if (ValidFromValue._d >= d) {
          // return false;
          // }
          // return true;
          // }
        },
        ValidTo: {
          ValidToValidator: function(viewValue, modelValue) {
            var ValidToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var ValidFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(ValidToValue)) {
              return true;
            }
            return ValidToValue.isSameOrAfter(ValidFromValue);
          },
        },
      };

      var numericOptions = {
        RentableSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        SurveyedArea: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        FloorSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        FullArea: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        HeadRoom: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        EffHeadRoom: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        CubicMeter: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        EqSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        ComAreaMultiplier: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      var customCallbackFunctions = {
        AccToHead1: function(selectedItem) {
          vm.formModel.AccToHead2 = !vm.formModel.AccToHead1;
          generateCubicMeter();
        },
        ComAreaInv: function() {
          vm.comAreaMultiplier();
        },
      };
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertNumericOptions(vm.pageModel, numericOptions);

      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.leftFields = vm.FormlyFormPanelDescriptors.PanelLeft.FormlyDescriptor;
      vm.rightFields = vm.FormlyFormPanelDescriptors.PanelRight.FormlyDescriptor;
      //vm.MainItemTabs = ExtractFormlyPanelsInTabs(vm.pageModel.Panels, vm.pageModel.Tabs, vm.FormlyFormPanelDescriptors);
      vm.FormlyFormPanelDescriptors.PanelLeft.FormlyDescriptor[0].className = 'col-md-12';
      vm.FormlyFormPanelDescriptors.PanelRight.FormlyDescriptor[0].className = 'col-md-12';

      vm.FormlyFormPanelDescriptorsM = GenerateFormlyFormPanelsFromPageModel(vm.pageModelM);
      vm.premiseMultiplierFields =
        vm.FormlyFormPanelDescriptorsM.PanelPremiseMultiplier.FormlyDescriptor[0].fieldGroup[0].fieldGroup;

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          propertyId: vm.formModel.PropertyId,
          premiseType: vm.formModel.PremiseType,
          budgetId: vm.formModel.ExistsBudgetId,
        };
      };

      vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          premiseFunc: vm.formModel.PremiseFunction,
        };
      };

      if (vm.formModel.ModelState === 2 && !vm.set) {
        vm.num = 1;
        angular.forEach(vm.formModel.Rows, function(row) {
          if (vm.num === 1) {
            row.Checkbox = true;
          } else {
            row.Checkbox = false;
          }
          vm.num++;
        });
        vm.set = true;
      }

      vm.save = function() {
        if (vm.formModel.RentableSpace == 0 || !vm.formModel.RentableSpace) {
          bootbox.dialog({
            message: 'Biztosan 0 m2 alapterülettel szeretné elmenteni a helyiséget?',
            title: 'Figyelmeztetés!',
            buttons: {
              cancel: {
                label: 'Mégsem',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Igen',
                className: 'btn-primary',
                callback: function() {
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  generateEqSpace();
                  $http
                    .post('Property/Premise' + vm.EditOrDuplicate + 'Immovable', vm.formModel)
                    .then(function(response) {
                      toastr.success(vm.pageModel.Messages.SaveSuccessful);

                      if (vm.EditOrDuplicate === 'Edit' && vm.formModel.PremiseId > 0) {
                        return;
                      }
                      lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                      if (
                        !!response.data.PremiseId &&
                        (vm.EditOrDuplicate === 'Duplicate' ||
                          (vm.EditOrDuplicate === 'Edit' && !vm.formModel.PremiseId))
                      ) {
                        $state.go(
                          'Property.GridPremiseEdit' + (vm.gridLevel === 'PPRRU' ? 'RentableUnit' : 'Immovable'),
                          {
                            id: response.data.PremiseId,
                            PropertyId: $stateParams.PropertyId,
                            Level: vm.gridLevel,
                          }
                        );
                      } else if (vm.gridLevel === 'PPRRU') {
                        $state.go('Property.RentableUnitNav', { id: vm.formModel.RentUnitId.Value });
                      } else {
                        $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
                      }
                    })
                    .catch(function(response) {
                      toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
                },
              },
            },
          });
        } else {
          generateEqSpace();
          $http
            .post('Property/Premise' + vm.EditOrDuplicate + 'Immovable', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);

              if (vm.EditOrDuplicate === 'Edit' && vm.formModel.PremiseId > 0) {
                return;
              }
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              if (
                !!response.data.PremiseId &&
                (vm.EditOrDuplicate === 'Duplicate' || (vm.EditOrDuplicate === 'Edit' && !vm.formModel.PremiseId))
              ) {
                $state.go('Property.GridPremiseEdit' + (vm.gridLevel === 'PPRRU' ? 'RentableUnit' : 'Immovable'), {
                  id: response.data.PremiseId,
                  PropertyId: $stateParams.PropertyId,
                  Level: vm.gridLevel,
                });
              } else if (vm.gridLevel === 'PPRRU') {
                $state.go('Property.RentableUnitNav', { id: vm.formModel.RentUnitId.Value });
              } else {
                $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
              }
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        }
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if ($state.previous.name == 'Property.PyramidNav') {
          $state.go($state.previous.name);
        } else if (vm.gridLevel === 'PPRRU') {
          $state.go('Property.RentableUnitNav', { id: vm.formModel.RentUnitId.Value });
        } else {
          $state.go('Property.PropImmovableNav', { id: vm.formModel.PropertyId });
        }
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PremiseId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgPremise', id);
      };

      function generateCubicMeter() {
        if (vm.formModel.HeadRoom === 0) {
          vm.formModel.HeadRoom = vm.formModel.EffHeadRoom;
        }
        if (vm.formModel.AccToHead1) {
          vm.formModel.CubicMeter = vm.formModel.RentableSpace * vm.formModel.HeadRoom;
        } else {
          vm.formModel.CubicMeter = vm.formModel.RentableSpace * vm.formModel.EffHeadRoom;
        }
      }

      function generateEqSpace() {
        vm.multiplier = 1.0;
        angular.forEach(vm.formModel.Rows, function(row) {
          if (row.Checkbox) {
            vm.multiplier = vm.multiplier * row.Multiplier;
          }
        });
        vm.formModel.EqSpace = vm.formModel.RentableSpace * vm.multiplier;
      }

      function comAreaMultiplier() {
        $http({
          method: 'GET',
          url: 'Property/GetComAreaMultiplier/',
          params: { propertyId: vm.formModel.PropertyId },
        }).then(function successCallback(response) {
          vm.formModel.ComAreaMultiplier = response.data.ComAreaMultiplier;
        });
      }

      //PremiseCode generálás
      function newPremiseCode() {
        if (vm.formModel.PREMGE) {
          $http({
            method: 'GET',
            url: 'Property/GetNewPremiseCode/',
            params: { propertyId: vm.formModel.PropertyId, floor: vm.formModel.Floor },
          }).then(function successCallback(response) {
            vm.formModel.PremiseCode = response.data.PremiseCode;
          });
        }
      }

      function prevValidFrom() {
        if (vm.formModel.PREMGE) {
          $http({
            method: 'GET',
            url: 'Property/GetPrevValidFrom/',
            params: { propertyId: vm.formModel.PropertyId, premiseCode: vm.formModel.PremiseCode },
          }).then(function successCallback(response) {
            vm.formModel.PrevValidFrom = response.data.PrevValidFrom;
            prevValidFrom = vm.formModel.PrevValidFrom;
          });
        }
      }

      function getCommonAreas() {
        $http({
          method: 'GET',
          url: 'Property/GetBudgetCommonAreas/',
          params: { budgetId: vm.formModel.BudgetId },
        }).then(function successCallback(response) {
          vm.formModel.CommonAreas = response.data.CommonAreas;
        });
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
        angular.forEach(vm.pageModelM.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('PropertyDiscountEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, lockService, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyDiscountEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.IsEdit = $stateParams.IsEdit;

      vm.security = $stateParams.Security;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelPropertyD.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      var level = '';
      if (options.dto.Level === 'PPROB') {
        level = 'Object';
      } else if (options.dto.Level === 'PPRIM') {
        level = 'PropImmovable';
      } else {
        level = 'RentableUnit';
      }

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.EditOrDuplicate === 'Edit';
          },
        },
        DiscountId: {
          'templateOptions.disabled': function() {
            return vm.EditOrDuplicate === 'Edit';
          },
        },
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ValidFrom: function() {
          if (vm.EditOrDuplicate !== 'Edit') {
            vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
      };

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      var onBlurFunctions = {
        ValidFrom: function() {
          vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        //"ValidTo": function () {
        //   vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        //}
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      // InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      /////////////////////////////// [ ComboList Filters ] ///////////////////////////////////
      vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          ValidFrom: vm.formModel.ValidFrom,
          ValidTo: vm.formModel.ValidTo,
          ConPropertyId: vm.formModel.ConPropertyId,
          PropertyId: vm.formModel.PropertyId,
          TenType: vm.formModel.TenType,
          DiscountId: vm.formModel.DiscountId,
          Level: vm.formModel.Level,
          PropDiscId: vm.formModel.PropDiscId,
          IsEdit: vm.IsEdit,
        };
      };

      vm.save = function() {
        var editUrl = vm.EditOrDuplicate;
        if (vm.EditOrDuplicate === 'Create') {
          editUrl = 'Edit';
        }
        $http
          .post('Property/PropertyDiscount' + editUrl + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PropDiscId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgPropertyDiscount', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ObjAddressEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$timeout',
    '$state',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      $timeout,
      $state,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ObjAddressEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.selectedPostCode = null;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.security = $stateParams.Security;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelAddress.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var customExpressionProperties = {};

      var onChangeFunctions = {};

      var onBlurFunctions = {
        PostCode: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Value).then(
                function(result) {
                  var locality = result.data.result.Value;
                  if (locality) {
                    vm.formModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                  }
                },
                function(error) {}
              );
            }
          }
        },
        Locality: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
                function(result) {
                  var postcode = result.data.result.Value;
                  if (postcode) {
                    if (
                      !vm.formModel.PostCode ||
                      !vm.formModel.PostCode.Value ||
                      postcode === vm.formModel.PostCode.Value
                    ) {
                      vm.formModel.PostCode = {
                        Text: postcode,
                        Value: postcode,
                      };
                    } else {
                      $http.get('Partner/GetAllLocalities?postcode=' + vm.formModel.PostCode.Value).then(
                        function(result) {
                          var localities = result.data.result.Localities;
                          if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                            vm.formModel.PostCode = {
                              Text: postcode,
                              Value: postcode,
                            };
                          }
                        },
                        function(error) {}
                      );
                    }
                  }
                },
                function(error) {}
              );
            }
          }
        },
      };
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      vm.save = function() {
        $http
          .post('Property/ObjAddress' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.ObjectNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ObjAddrId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgObjAddress', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ProprietorsEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProprietorsEditCtrl', stateParams);
      }
      var vm = this;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;

      vm.UIHelperService = UIHelperService;

      vm.saveButtonHandling = saveButtonHandling;

      vm.UIHelperService.setDefaultSidebarStatus();
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options);
        initViewModel($http, $state, $stateParams, vm, options);
        initFormModel($http, $state, $stateParams, vm, options);

        setFields(vm, options);
        generateForm(vm);
        vm.formFields = vm.FormlyFormPanelDescriptors.PanelProprietors.FormlyDescriptor;
        vm.headerFields = vm.FormlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
      }

      function setFields(vm, opt) {
        var fs = fieldSetter;
        fs.vm = vm;

        if (opt.dto.Level === 'PPRRU') {
          //Bérlemény
          fs.setLabel('OwnRatio', 'Tulajdoni hányad');
        } else {
          //Ingatlan és Objektum
          fs.setLabel('OwnRatio', 'Eszmei tulajdoni hányad');
        }

        fs.setLabel('OwnRatioDenominator', '\u00A0');
        fs.setLabel('Separator', '\u00A0');

        setCustomType(vm, 'Separator', 'separatorSlash');

        fs.setDisabled('Name', function() {
          return !(vm.dataModel.PartnerId === null || vm.dataModel.PartnerId.Value === null) || vm.isFormReadOnly;
        });

        fs.setSyncValidator('OwnRatio', 'ObjectCadastralOwnRatioValidator', function(modelValue) {
          if (!modelValue) {
            return true;
          }
          return modelValue >= 1;
        });

        fs.setSyncValidator(
          'OwnRatioDenominator',
          'ObjectCadastralOwnRatioDenominatorValidator',
          function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 1;
          },
          'CadastralOwnRatioValidator',
          function() {
            return vm.dataModel.OwnRatio / vm.dataModel.OwnRatioDenominator <= 1;
          }
        );

        fs.setOnChangeFunction('PartnerId', function(selectedItem) {
          if (!!selectedItem && !!vm.dataModel.PartnerId) {
            vm.dataModel.Name = selectedItem.Name;
          }
        });

        fs.setOnChangeFunction('OwnRatio', function() {
          reValidate();
        });

        fs.setOnChangeFunction('OwnRatioDenominator', function() {
          reValidate();
        });

        fs.setRequired('OwnRatio', function() {
          return true;
        });

        var numericOptions = {
          OwnRatio: {
            decimals: 0,
            format: 'n0',
            max: 32767,
            min: 0,
          },
          OwnRatioDenominator: {
            decimals: 0,
            format: 'n0',
            max: 32767,
            min: 0,
          },
        };

        InsertNumericOptions(vm.pageModel, numericOptions);
      }

      var level = '';
      if (options.dto.Level === 'PPRRU') {
        level = 'RentableUnit';
      } else if (options.dto.Level === 'PPROB') {
        level = 'Object';
      } else {
        level = 'PropImmovable';
      }

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      vm.save = function() {
        if (vm.dataModel.OwnRatio / vm.dataModel.OwnRatioDenominator > 1) {
          toastr.error('A tulajdoni hányad nem lehet nagyobb 1 egésznél!');
          return;
        }
        $http
          .post('Property/Proprietors' + vm.EditOrDuplicate + vm.security, vm.dataModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.' + level + 'Nav', { id: vm.dataModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.dataModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PropriertorsId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgPropriertors', id);
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      function reValidate() {
        if (vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatio.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.OwnRatioDenominator.FormlyFieldDescriptor.formControl.$validate();
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RealtiesValueEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RealtiesValueEditCtrl', stateParams);
      }
      var vm = this;

      vm.UIHelperService = UIHelperService;

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;
      vm.saveButtonHandling = saveButtonHandling;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelRealties.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      var level = '';
      if (options.dto.Level === 'PPRRU') {
        level = 'RentableUnit';
      } else {
        level = 'PropImmovable';
      }

      var syncValidators = {
        SaleValue: {
          /**
           * @return {boolean}
           */
          RealtiesValueSaleValueValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue > 0;
          },
        },
        NetRegValue: {
          /**
           * @return {boolean}
           */
          RealtiesValueNetRegValueValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        BrutRegValue: {
          /**
           * @return {boolean}
           */
          RealtiesValueBrutRegValueValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
      };

      var numericOptions = {
        SaleValue: {
          decimals: 0,
          format: 'n0',
          max: 99999999999999,
          min: 0,
        },
        NetRegValue: {
          decimals: 0,
          format: 'n0',
          max: 99999999999999,
          min: 0,
        },
        BrutRegValue: {
          decimals: 0,
          format: 'n0',
          max: 99999999999999,
          min: 0,
        },
      };
      InsertNumericOptions(vm.pageModel, numericOptions);

      InsertSyncValidators(vm.pageModel, syncValidators);

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.save = function() {
        $http
          .post('Property/RealtiesValue' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PyramidNav');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ValueId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgRealtiesValue', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RoomInventoryEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    '$uibModalInstance',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      lockService,
      $state,
      UIHelperService,
      uibModalInstance
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RoomInventoryEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      vm.saveButtonHandling = saveButtonHandling;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      vm.PremiseListMaxItemError = 'Egyedi azonosítás miatt csak egy helyiség lehet kiválasztva!';

      kendoMSInit(vm.pageModel, ['Month']);
      vm.PremiseListF4MaxItemCount =
        vm.pageModel.Fields.PremiseList.FormlyFieldDescriptor.templateOptions.options.maxItemCount;

      vm.setPremiseListF22MaxItems = function() {
        vm.pageModel.Fields.PremiseList.FormlyFieldDescriptor.templateOptions.options.maxItemCount =
          vm.formModel.UniqIdent === true ? 1 : vm.PremiseListF4MaxItemCount;
        vm.pageModel.Fields.PremiseList.FormlyFieldDescriptor.templateOptions.options.f4scope.ErrorStrings.maxItemCount =
          vm.PremiseListMaxItemError;
      };

      vm.UIHelperService.setDefaultSidebarStatus();
      var level = '';
      if (options.dto.Level === '' || $stateParams.Security === 'Premise') {
        level = 'Pyramid';
      } else if (options.dto.Level === 'PPRRU') {
        level = 'RentableUnit';
      } else {
        level = 'PropImmovable';
      }
      vm.security = $stateParams.Security;
      vm.pageModel.Separator = '/';

      var customExpressionProperties = {
        PartnerName: {
          'templateOptions.disabled': function() {
            return (
              !(vm.formModel.ServicePartner === null || vm.formModel.ServicePartner.Value === null) || vm.isFormReadOnly
            );
          },
        },
        Quantity: {
          'templateOptions.disabled': function() {
            return vm.formModel.UniqIdent === true || vm.isFormReadOnly;
          },
        },
        FactNumber: {
          'templateOptions.required': function() {
            return (
              vm.formModel.UniqIdent === true && (!isEmpty(vm.formModel.FactNumber) || isEmpty(vm.formModel.InvNumber))
            );
          },
        },
        InvNumber: {
          'templateOptions.required': function() {
            return (
              vm.formModel.UniqIdent === true && (!isEmpty(vm.formModel.InvNumber) || isEmpty(vm.formModel.FactNumber))
            );
          },
        },
        PremiseCodeAndName: {
          'templateOptions.required': function() {
            return ['EquipmentAndPremise', 'RentableUnit', 'Immovable'].includes(vm.security);
          },
        },
        PremiseList: {
          'templateOptions.required': function() {
            return ['Equipment', 'Premise'].includes(vm.security);
          },
        },
        EqId: {
          'templateOptions.disabled': function() {
            return vm.isFormReadOnly || ['Equipment', 'EquipmentAndPremise'].includes(vm.security);
          },
        },
      };

      var hideExpressions = {
        PremiseCodeAndName: function($viewValue, $modelValue, scope) {
          return ['Equipment', 'Premise'].includes(vm.security);
        },
        PremiseList: function($viewValue, $modelValue, scope) {
          return ['EquipmentAndPremise', 'RentableUnit', 'Immovable'].includes(vm.security);
        },
      };

      var onChangeFunctions = {
        ServicePartner: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.Value) {
            if (!!selectedItem.GridItem) {
              vm.formModel.PartnerName = selectedItem.GridItem.Name;
            }
          } else {
            vm.formModel.PartnerName = '';
          }
        },

        EqId: function(selectedItem) {
          if (!!selectedItem?.EqId) {
            vm.formModel.HelpDeskPriorityId = selectedItem.HelpDeskPriorityId;
            vm.formModel.UniqIdent = selectedItem.UniqIdent;
            vm.eqQroupId = selectedItem.EqGroupId;
            if (vm.formModel.UniqIdent === true) {
              vm.formModel.Quantity = 1;
              if (!!vm.formModel.PremiseList && vm.formModel.PremiseList.length > 1) {
                toastr.error(vm.PremiseListMaxItemError);
              }
            }
          } else {
            vm.formModel.HelpDeskPriorityId = null;
            vm.formModel.UniqIdent = false;
          }
          vm.setPremiseListF22MaxItems();
        },
      };

      function saveButtonHandling() {
        // return !(
        // (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
        // (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
        // vm.EditOrDuplicate === 'View'
        // );
        return !(vm.isFormReadOnly || vm.formModel.IsReadOnly || vm.EditOrDuplicate === 'View');
      }

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      //InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      //InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelRoomInventory.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.pageModel.Fields.EqId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        eqGroupId: function() {
          return vm.eqQroupId ?? 0;
        },
      };

      vm.PremiseListF4MaxItemCount =
        vm.pageModel.Fields.PremiseList.FormlyFieldDescriptor.templateOptions.options.maxItemCount;
      vm.pageModel.Fields.PremiseList.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseListWhereCondition;

      vm.save = function() {
        $http
          .post('Property/RoomInventory' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function() {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            if (['Equipment', 'EquipmentAndPremise'].includes(vm.security)) {
              vm.cancel();
            } else {
              $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
            }
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if ($state.previous.name === 'Property.PyramidNav') {
          $state.go('Property.PyramidNav');
        } else {
          $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
        }
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.InventoryId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgRoomInventory', id);
      };

      function premiseListWhereCondition() {
        var condition =
          "ValidFrom~lte~'" + moment(new Date(vm.formModel.ValidFrom)).format('YYYY-MM-DDTHH:mm:ss') + "'";
        if (!!vm.formModel.ValidTo) {
          condition +=
            "~and~(ValidTo~isnull~or~ValidTo~gte~'" +
            moment(new Date(vm.formModel.ValidTo)).format('YYYY-MM-DDTHH:mm:ss') +
            "')";
        } else {
          condition +=
            "~and~(ValidTo~isnull~or~ValidTo~gte~'" +
            moment(new Date(vm.formModel.ValidFrom)).format('YYYY-MM-DDTHH:mm:ss') +
            "')";
        }

        if (vm.security !== 'Equipment') {
          condition +=
            '~and~' +
            (vm.formModel.Level !== 'PPRRU' ? 'PropertyId~eq~' : 'RentUnitId~eq~') +
            vm.formModel.PropertyId +
            '';
        }
        return condition;
      }

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      function isEmpty(str) {
        return !str || str.trim().length === 0;
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('RoomSurfaceEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    '$state',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, lockService, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RoomSurfaceEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      var level = '';
      if (options.dto.Level === 'PPRRU') {
        level = 'RentableUnit';
      } else {
        level = 'PropImmovable';
      }
      vm.security = $stateParams.Security;

      if (vm.formModel.IsReducedSurface) {
        vm.formModel.SurfaceMinus = false;
      }

      vm.pageModel.Separator = '/';
      var customExpressionProperties = {
        RoomSurfaceId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.SurfaceMinus;
          },
          'templateOptions.required': function() {
            return vm.formModel.SurfaceMinus;
          },
        },
        SurfaceMinus: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsReducedSurface;
          },
        },
        SurfaceConditionId: {
          'templateOptions.disabled': function() {
            return vm.formModel.SurfaceMinus === true;
          },
        },
      };
      var onChangeFunctions = {
        SurfaceKindId: function(selectedItem) {
          if (vm.formModel.SurfaceKindId !== null && typeof vm.formModel.SurfaceKindId !== 'undefined') {
            //add parameter
            vm.pageModel.Fields.SurfaceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              surfaceKindId: vm.formModel.SurfaceKindId,
            };
          }
          //reload
          vm.pageModel.Fields.SurfaceId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        Quadratmeter: function() {
          vm.formModel.CalcQuadratMeter =
            (vm.formModel.Quadratmeter ?? 0) * (vm.formModel.Quantity ?? 0) * (vm.formModel.SurfaceFactor ?? 0);
        },
        Quantity: function() {
          vm.formModel.CalcQuadratMeter =
            (vm.formModel.Quadratmeter ?? 0) * (vm.formModel.Quantity ?? 0) * (vm.formModel.SurfaceFactor ?? 0);
        },
        SurfaceFactor: function(selectedItem) {
          vm.formModel.CalcQuadratMeter =
            (vm.formModel.Quadratmeter ?? 0) * (vm.formModel.Quantity ?? 0) * (vm.formModel.SurfaceFactor ?? 0);
        },
        SurfaceId: function(selectedItem) {
          vm.pageModel.Fields.RoomSurfaceId.FormlyFieldDescriptor.templateOptions.setFunctions.dataSourceRead();
          if (!!selectedItem?.key && selectedItem?.key == vm.RSFSurfaceId) {
            vm.pageModel.Fields.RoomSurfaceId.FormlyFieldDescriptor.value({ Value: null, Text: null });
          }
        },
        RoomSurfaceId: function(selectedItem) {
          vm.RSFSurfaceId = selectedItem?.GridItem?.SurfaceId;
        },
      };

      var syncValidators = {
        Quadratmeter: {
          /**
           * @return {boolean}
           */
          NumValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
        },
        Quantity: {
          /**
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            return modelValue > 0;
          },
        },
      };

      var numericOptions = {
        Quadratmeter: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        Quantity: {
          decimals: 2,
          format: 'n0',
          max: 99999999999999,
          min: 0,
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }
      var customCallbackFunctions = {
        SurfaceMinus: function(selectedItem) {
          if (!selectedItem) {
            vm.pageModel.Fields.RoomSurfaceId.FormlyFieldDescriptor.value({ Value: null, Text: null });
          } else {
            vm.formModel.SurfaceConditionId = null;
          }
        },
      };
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.pageModel.Fields.RoomSurfaceId.FormlyFieldDescriptor.templateOptions.selectFirst = false;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelRoomSurface.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.pageModel.Fields.RoomSurfaceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        let whereCondition =
          "SurfaceMinus~eq~'false'~and~PremiseId~eq~" +
          vm.formModel.PremiseId +
          '~and~SurfaceId~neq~' +
          (vm.formModel.SurfaceId ?? 0);
        if (vm.formModel.RoomSId > 0) {
          whereCondition = 'RoomSId~neq~' + vm.formModel.RoomSId + '~and~' + whereCondition;
        }
        return whereCondition;
      };
      vm.save = function() {
        $http
          .post('Property/RoomSurface' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('property.PropertyList');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if ($state.previous.name === 'Property.PyramidNav') {
          $state.go('Property.PyramidNav');
        } else {
          $state.go('Property.' + level + 'Nav', { id: vm.formModel.PropertyId });
        }
      };
      vm.attachDocument = function() {
        var id = vm.formModel.RoomSId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgRoomSurface', id);
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('TenancyServiceEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      $state,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenancyServiceEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabTop',
        disableRunExpression: false,
      };

      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();
      vm.pageModel = options.pageModel;
      vm.pageModelAdditional = options.pageModelAdditional;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.pageModel.PanelGroups['PGTabBottom'].Disabled = !vm.formModel.ServiceBuiltUpId;

      vm.saveButtonHandling = saveButtonHandling;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;

      if (vm.formModel.ModelState === 3) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'ServiceBuiltUpId' && key !== 'ValidTo') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
          vm.pageModelAdditional.Fields.Assign.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.FormlyFormPanelDescriptorsAdditional = GenerateFormlyFormPanelsFromPageModel(vm.pageModelAdditional);
      vm.additionalFields =
        vm.FormlyFormPanelDescriptorsAdditional.PanelTenancyS2.FormlyDescriptor[0].fieldGroup[0].fieldGroup;

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Property/${gridModel.ControllerMethod}`;

          return {
            gridModel,
            transportData: function() {
              return {
                targetPropertyId: vm.formModel.PropertyId,
              };
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      InsertSyncValidators(vm.pageModel, syncValidators);

      var onChangeFunctions = {
        ServiceBuiltUpId: function(selectedItem) {
          if (selectedItem !== null && selectedItem.key !== null) {
            var params = { propertyId: vm.formModel.PropertyId, serviceBuiltUpId: selectedItem.key };
            $http({
              method: 'GET',
              url: 'Property/GetRows',
              params: params,
            }).then(function(response) {
              vm.formModel.Rows = response.data.rows;
            });
          }
          vm.pageModel.PanelGroups['PGTabBottom'].Disabled = !vm.formModel.ServiceBuiltUpId;
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.save = function() {
        $http
          .post('Property/TenancyService' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.PyramidNav');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.TenServId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgTenancyService', id);
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      function createMultiFormPanels(vm, descriptions, panels) {
        if (!vm.multiFormPanels) {
          vm.multiFormPanels = [];
        }
        angular.forEach(panels, function(panel) {
          var headers = [];
          angular.forEach(vm.pageModelAdditional.Fields, function(item) {
            if (item.ContainerPanelId === panel) {
              item.FormlyFieldDescriptor.id = item.FormlyFieldDescriptor.templateOptions.DOMId;
              var _e = {
                class: item.FormlyFieldDescriptor.className,
                label: item.FormlyFieldDescriptor.templateOptions.label,
                required: item.FormlyFieldDescriptor.templateOptions.required,
              };
              headers.push(_e);
              item.FormlyFieldDescriptor.templateOptions.label = '';
            }
          });
          vm.multiFormPanels.push({
            panel: { panel, title: vm.pageModelAdditional.Panels[panel].Title },
            headers,
            fields: descriptions[panel].FormlyDescriptor,
          });
        });
      }

      createMultiFormPanels(vm, vm.FormlyFormPanelDescriptorsAdditional, ['PanelTenancyS2']);

      vm.bindName = function(fields, index) {
        //Ha a formly-form repeat-ban van, a fileds leírót másolni kell és egyedi id-t adni:
        var _field = angular.copy(fields);
        angular.forEach(_field[0].fieldGroup[0].fieldGroup, function(field) {
          field.id = field.id + '_' + index;
        });
        return _field;
      };

      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'detailsIsCollapsed':
            vm.activeBooleans['detailsIsActive'] = true;
            break;
          case 'serviceDetailsIsCollapsed':
            vm.activeBooleans['annexeIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['annexeIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('TenancyUtilisationEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenancyUtilisationEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.save = saveItem;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.security = $stateParams.Security;

      function saveItem() {
        $http
          .post('Property/TenancyUtilisation' + vm.EditOrDuplicate + vm.security, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.UtilisationId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgTenancyUtilisation', id);
      };

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        NotRentableId: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.IsRentable ||
              (vm.EditOrDuplicate === 'Edit' && vm.formModel.TenUtilId !== 0 && vm.formModel.Contract)
            );
          },
          'templateOptions.required': function() {
            return !vm.formModel.IsRentable;
          },
        },
        Note: {
          'templateOptions.required': function() {
            return vm.commentIsRequied;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {
        /*
                                "DateOfCommission": {
                                    DateOfCommissionValidator: function (modelValue, viewValue) {
                
                                        if (!modelValue || !viewValue) {
                                            return Promise.reject();
                                        }
                
                                        $http({
                                            method: 'GET',
                                            url: 'Property/ResponsibleGetLatestResponsible',
                                            params: { PropertyId: vm.formModel.PropertyId, ResponsibleTypeId: vm.formModel.ResponsibleTypeId }              // PropertyId-t is bevenni !!!
                                        }).then(function successCallback(response) {
                
                                            var FlgResponsible = response.data;
                                            if (FlgResponsible != null) {
                                                var currValue = new moment(modelValue, kendo.culture()
                                                        .calendar.patterns.d.toUpperCase());
                
                                                var latestValue = new moment(FlgResponsible.DateOfCommission, kendo.culture()
                                                        .calendar.patterns.d.toUpperCase());
                
                                                return currValue.isAfter(latestValue) ? true : Promise.reject();
                
                                            }
                                            return true;
                                        });
                                    }
                                }
                                */
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        NotRentableId: function(selectedItem) {
          vm.commentIsRequied =
            !!selectedItem.extraProperties && !!selectedItem.extraProperties[0]
              ? selectedItem.extraProperties[0].value === 'True'
              : false;
        },
      };

      var customCallbackFunctions = {
        IsRentable: function(selectedItem) {
          if (vm.formModel.LastIsRentableState === selectedItem) {
            toastr.warning(
              'Bérelhető jelölőnégyzet értéke az utoljára felvitt kihasználtságtól eltérő kell, hogy legyen!'
            );
            vm.formModel.IsRentable = !vm.formModel.LastIsRentableState;
          } else if (selectedItem) {
            vm.formModel.NotRentableId = '';
          }
        },
      };
      var onBlurFunctions = {};
      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};
      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};
      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      InsertCustomClasses(vm.pageModel, customClasses);
      if (!vm.isFormReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////

      //szerkesztesnel nem karbantarthato (mezok letiltasa)
      if (vm.EditOrDuplicate === 'Edit' && vm.formModel.TenUtilId !== 0 && vm.formModel.Contract) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelTenancy.FormlyDescriptor;
      vm.headerFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('TenancyChequeEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    '$window',
    '$scope',
    '$uibModal',
    function(
      $http,
      options,
      $stateParams,
      dasService,
      $state,
      lockService,
      UIHelperService,
      $window,
      $scope,
      $uibModal
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenancyChequeEditCtrl', stateParams);
      }
      var vm = this;
      vm.securedId = options.id;
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabTenc',
        disableRunExpression: false,
        comboMenu: true,
      };
      vm.formly = {};
      Object.defineProperty(vm, 'formlyValid', {
        get: function() {
          vm.formly.$valid = !Object.values(vm.forms).some(x => !x.$valid);
          return vm.formly.$valid;
        },
      });
      vm.forms = {};
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly || vm.formModel.ChequeStatus === 'TCSCL';
      vm.disableCardListNew = $stateParams.controllerOptions.isFormReadOnly;
      vm.multidata = [];

      vm.UIHelperService = UIHelperService;

      vm.sendForm = sendForm;
      vm.saveButtonHandling = saveButtonHandling;

      vm.pageModel.Fields.DateOfChequeFrom.FormlyFieldDescriptor.templateOptions.placeholder = 'Kezdete';
      vm.pageModel.Fields.PlannedChequeFrom.FormlyFieldDescriptor.templateOptions.placeholder = 'Kezdete';
      vm.pageModel.Fields.DateOfChequeTo.FormlyFieldDescriptor.templateOptions.placeholder = 'Vége';
      vm.pageModel.Fields.PlannedChequeTo.FormlyFieldDescriptor.templateOptions.placeholder = 'Vége';

      vm.UIHelperService.setDefaultSidebarStatus();
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.security = $stateParams.Security;
      // #region Functions
      vm.save = function() {
        vm.formModel.SendingMail = false;
        vm.sendForm();
      };
      vm.emailButtonVisibility = function() {
        return vm.formModel.TenChequeId > 0;
      };
      vm.emailButtonActivity = function() {
        return vm.formModel.ChequeStatus !== 'TCSOP' || vm.isFormReadOnly;
      };
      vm.createButtonVisibility = function() {
        return vm.formModel.TenChequeId > 0;
      };
      vm.createButtonActivity = function() {
        return (
          vm.formModel.ChequeStatus !== 'TCSOP' ||
          vm.isFormReadOnly ||
          (!!vm.collapseHelper?.openedPanels &&
            !['PGTabContract', 'PGTabEqu', 'PGTabPremise', 'PGTabPublicUtil', 'PGTabTenantsAndUsers'].includes(
              vm.collapseHelper?.openedPanels[0]
            ))
        );
      };
      vm.createSubItem = function() {
        let url;
        switch (vm.collapseHelper?.openedPanels[0]) {
          case 'PGTabContract':
            url = $state.href('Contract.ContractEdit', {
              id: 0,
            });
            $window.open(url, '_blank');
            break;
          case 'PGTabEqu':
            url = $state.href('Equipment.EquipmentNav', {
              id: 0,
              Security: 'RentableUnit',
            });
            $window.open(url, '_blank');
            break;
          case 'PGTabPremise':
            url = $state.href('Property.GridPremiseCreateRentableUnit', {
              id: 0,
              RentUnitId: vm.formModel.PropertyId,
              Level: 'PPRRU',
              Security: 'RentableUnit',
            });
            $window.open(url, '_blank');
            break;
          case 'PGTabPublicUtil':
            url = $state.href('Utility.MeterCreate', {
              id: 0,
            });
            $window.open(url, '_blank');
            break;
          case 'PGTabTenantsAndUsers':
            url = $state.href('Partner.Create', {
              id: 0,
            });
            $window.open(url, '_blank');
            break;
        }
      };

      vm.sendMail = function() {
        $http
          .get('Property/GetChequeMail', {
            params: {
              propertyId: vm.formModel.PropertyId,
            },
          })
          .then(function(data) {
            var missingEmail = !!data.data?.Value?.MissingEmail;
            //csak akkor jöjjön a kérdés, ha van bérlő!
            if (!!data.data?.Value?.TenantPartId) {
              bootbox.dialog({
                message:
                  '<p style="text-align:center;">' +
                  data.data?.Value[missingEmail ? 'MissingEmail' : 'SendSelect'] +
                  '</p>',
                closeButton: false,
                buttons: {
                  // cancel: {
                  //   label: vm.pageModel.Messages.Cancel,
                  //   className: 'btn-default pull-left',
                  //   callback: function() {},
                  // },
                  no: {
                    label: missingEmail ? vm.pageModel.Actions.ActionSaveOnly.Title : vm.pageModel.Messages.No,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: missingEmail ? vm.pageModel.Actions.ActionCreateEmail.Title : vm.pageModel.Messages.Yes,
                    className: 'btn-primary',
                    callback: function() {
                      if (missingEmail) {
                        const url = $state.href('Partner.GridPartLinkCreate', {
                          id: 0,
                          PartnerId: data.data?.Value?.TenantPartId,
                        });
                        $window.open(url, '_blank');
                      } else {
                        $http
                          .post('Property/TenancyChequeEmailNotification', {
                            model: vm.formModel,
                            rowsModel: vm.multidata,
                          })
                          .then(function(response) {
                            if (!!response.data?.Warning) {
                              toastr.warning(response.data.Warning);
                            }
                            if (!!response.data?.Message) {
                              toastr.success(response.data.Message);
                            } else {
                              toastr.success(vm.pageModel.Actions.ActionEmailSent.Title);
                            }
                          })
                          .catch(function(response) {
                            toastr.error(vm.pageModel.Actions.ActionEmailFailed.Title);
                          });
                      }
                    },
                  },
                },
              });
            } else {
              bootbox.dialog({
                message: vm.pageModel.Actions.ActionMissingTenant.Title,
                title: vm.pageModel.Messages.Warning,
                buttons: {
                  confirm: {
                    label: vm.pageModel.Messages.Ok,
                    className: 'btn-primary',
                    callback: function() {},
                  },
                },
              });
            }
          });
      };
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($stateParams.backState ?? 'Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.TenChequeId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgTenancyCheque', id);
      };

      vm.getChequeData = function() {
        $http
          .get('Property/GetChequeData', {
            params: {
              propertyId: vm.formModel.PropertyId,
              tenChequeId: vm.formModel.TenChequeId,
              chequeDate: vm.formModel.PlannedCheque,
            },
          })
          .then(function(data) {
            vm.multidata = data.data.result.Dto;
            vm.multidataPanelTenant = _.uniqBy(vm.multidata.PanelTenant, 'PartnerId');
            vm.multidataPanelUser = _.uniqBy(vm.multidata.PanelUser, 'PartnerId');
            vm.multidata[vm.multiFormPanels[7].panel.panel]?.forEach((model, key) => {
              if (!!model.DocDate) {
                model.DocDate = new moment(model.DocDate.replace(/T.*/, '')).format('l').replaceAll(/\./g, '. ');
              }
              if (!!model.DocPrintDate) {
                model.DocPrintDate = new moment(model.DocPrintDate.replace(/T.*/, ''))
                  .format('l')
                  .replaceAll(/\./g, '. ');
              }
            });
            vm.subCardPremiseSurface = {
              pageModel: vm.pageModelCard,
              model: vm.multidata[vm.multiFormPanels[6].panel.panel],
              dasModel: vm.multiFormPanels[6].dasModel,
              docShow: vm.securedId > 0 && vm.formModel.HasDms,
              preGenerateCallback: vm.addingFieldProperties,
              afterGenerateGallback: vm.afterFormGenerate,
              panelName: vm.multiFormPanels[6].panel.panel,
              preGenerateCallback: vm.addingFieldProperties,
              parentId: 'PremiseId',
            };
          });
      };

      function sendForm() {
        let url = 'Property/TenancyCheque' + vm.EditOrDuplicate + vm.security;
        $http
          .post(url, {
            model: vm.formModel,
            rowsModel: vm.multidata,
          })
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (!!response.data?.Warning) {
              toastr.warning(response.data.Warning);
            }
            if (!!response.data?.Message) {
              toastr.success(response.data.Message);
            }
            if (!!response.data.TenChequeId) {
              $state.go(
                $stateParams.saveState ?? 'Property.GridTenancyChequeEditRentableUnit',
                {
                  id: response.data.TenChequeId,
                  PropertyId: vm.formModel.PropertyId,
                  Level: 'PPRRU',
                  Security: 'RentableUnit',
                },
                { reload: true }
              );
            } else {
              //updatekor nem töltjük újra a teljes formot, csak a paneleket
              vm.getChequeData();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createMultiFormPanels(vm, descriptions, panels) {
        if (!vm.multiFormPanels) {
          vm.multiFormPanels = [];
        }
        angular.forEach(panels, function(panel) {
          var headers = [];
          angular.forEach(vm.pageModel.Fields, function(item, key) {
            if (item.ContainerPanelId === panel) {
              item.FormlyFieldDescriptor.id = item.FormlyFieldDescriptor.templateOptions.DOMId;
              var _e = {
                class: item.FormlyFieldDescriptor.className,
                label: item.FormlyFieldDescriptor.templateOptions.label,
                required: item.FormlyFieldDescriptor.templateOptions.required,
              };
              headers.push(_e);
            }
          });
          vm.multiFormPanels.push({
            panel: { panel, title: vm.pageModel.Panels[panel].Title },
            headers,
            fields: descriptions[panel].FormlyDescriptor,
            dasModel: {
              //routeId: 'Property.DasDocumentsNav',
              routeId: 'Document.DocumentCreate',
            },
          });
        });
        vm.multiFormPanels[0].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgContract: '1',
          idTables: { FlgContract: 'ContractId' },
        };
        vm.multiFormPanels[1].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgMeter: '1',
          idTables: { FlgMeter: 'MeterId' },
        };
        vm.multiFormPanels[2].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgRoomInventory: '1',
          idTables: { FlgRoomInventory: 'InventoryId' },
        };
        vm.multiFormPanels[3].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgChequeSurface: '1',
          idTables: { FlgChequeSurface: 'ChequeSurfaceId' },
        };
        vm.multiFormPanels[5].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgPremise: '1',
          idTables: { FlgPremise: 'PremiseId' },
        };
        vm.multiFormPanels[6].dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgRoomSurface: '1',
          idTables: { FlgRoomSurface: 'RoomSId' },
        };
        vm.dasModelTenant = { routeId: 'Document.DocumentCreate' };
        vm.dasModelTenant.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgPartner: '1',
          idTables: { FlgPartner: 'PartnerId' },
        };
        vm.dasModelUser = { routeId: 'Document.DocumentCreate' };
        vm.dasModelUser.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
          FlgPartner: '1',
          idTables: { FlgPartner: 'PartnerId' },
        };
      }

      function getDigitSignData(pageModel, field) {
        var signElement = pageModel.Fields[field]?.FormlyFieldDescriptor?.templateOptions;
        if (signElement) {
          return signElement.getData();
        }
        return;
      }

      vm.viewLabel = function(ctrl, data, key) {
        let count =
          vm.multidata['PanelPremiseSurface'].filter(x => x[ctrl.subCard.parentId] === ctrl.model[key]?.PremiseId)
            ?.length ?? 0;
        return { Title: 'Helyiség felületei (' + count + ')', Disable: !count };
      };
      vm.modalExtraUser = function(pageModel, model, ctrl) {
        if (!vm.formModel.TenChequeId) {
          toastr.warning('Új lakó felvételéhez előbb nyomjon a fenti mentés ikonra.');
          return false;
        }
        vm.addingFieldProperties(pageModel, model);
        if (ctrl.state === 'new') {
          ctrl.title = 'Lakó hozzáadása';
        } else {
          ctrl.title = 'Lakó szerkesztése';
        }
        var dynamicQueryParameters = {
          TemplateId: function() {
            var result = [
              {
                key: 'DocType',
                value: model.DocTypeId,
              },
              {
                key: 'DocTypeCode',
                value: 'TenCheckReport',
              },
            ];
            if (ctrl.state === 'new') {
              result.push({
                key: 'TemplateId',
                value: model.TemplateId,
              });
            }
            return result;
          },
        };

        var customExpressionProperties = {
          PartnerName: {
            'templateOptions.required': function() {
              return true;
            },
          },
          RelationshipId: {
            'templateOptions.required': function() {
              return true;
            },
          },
        };

        var onChangeFunctions = {
          RelationshipId: function($viewValue, $modelValue, scope) {
            model.RelationshipName = $viewValue.text;
          },
        };
        var hideExpressions = {
          RelationshipName: function($viewValue, $modelValue, scope) {
            return true;
          },
          HabituallyInhabit: function($viewValue, $modelValue, scope) {
            return true;
          },
          SubTenant: function($viewValue, $modelValue, scope) {
            return true;
          },
          CoTenant: function($viewValue, $modelValue, scope) {
            return true;
          },
          DateOfBirth: function($viewValue, $modelValue, scope) {
            return true;
          },
        };
        InsertCustomExpressionProperties(pageModel, customExpressionProperties);
        InsertHideExpressions(pageModel, hideExpressions);
        InsertOnChangeFunctions(pageModel, onChangeFunctions);
        InsertDynamicQueryParameters(pageModel, dynamicQueryParameters);
        ctrl.preSave = function(ctrl) {
          ctrl.formModel.TenChequeId = vm.formModel.TenChequeId;
          ctrl.formModel.PropertyId = vm.formModel.PropertyId;
          ctrl.formModel.IsManuallyAdded = true;
          var params = { model: ctrl.formModel };
          var state = ctrl.state === 'new' ? 'Create' : 'Edit';
          $http
            .post('Property/TenChequeExtraUser' + state, params)
            .then(function(response) {
              if (response?.data?.insertedId) {
                ctrl.formModel.ChequeExtraUserId = response.data.insertedId;
              }
              if (response?.data?.modUserName) {
                ctrl.formModel.ModUserName = response.data.modUserName;
              }
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              ctrl.save();
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        };
      };

      vm.modalGenDoc = function(pageModel, model, ctrl) {
        if (!vm.formModel.TenChequeId) {
          toastr.warning('Új dokumentum generáláshoz előbb nyomjon a fenti mentés ikonra.');
          return false;
        }
        vm.addingFieldProperties(pageModel, model);
        if (ctrl.state === 'new') {
          ctrl.title = 'Dokumentum generálás';
          ctrl.btnSave = { text: 'Generálás' };
          model.Type = 'DOC';
        } else {
          ctrl.title = 'Generált dokumentum szerkesztése';
        }
        var dynamicQueryParameters = {
          TemplateId: function() {
            var result = [
              {
                key: 'DocType',
                value: model.DocTypeId,
              },
              {
                key: 'DocTypeCode',
                value: 'TenCheckReport',
              },
            ];
            if (ctrl.state === 'new') {
              result.push({
                key: 'TemplateId',
                value: model.TemplateId,
              });
            }
            return result;
          },
        };

        var customExpressionProperties = {
          TemplateId: {
            'templateOptions.disabled': function() {
              return typeof model.DocTypeId === 'undefined' || ctrl.state !== 'new';
            },
            'templateOptions.required': function() {
              return model.Type === 'DOC' || ctrl.state === 'new';
            },
          },
          DocTypeId: {
            'templateOptions.disabled': function() {
              return ctrl.state !== 'new';
            },
            'templateOptions.required': function() {
              return model.Type === 'DOC' || ctrl.state === 'new';
            },
          },
          DocDate: {
            'templateOptions.disabled': function() {
              return ctrl.state !== 'new' || model.DisableDocdate === true;
            },
            'templateOptions.required': function() {
              return true;
            },
          },
        };

        var onChangeFunctions = {
          DocTypeId: function($viewValue, $modelValue, scope) {
            model.DocType = $viewValue.text;
            pageModel.Fields.TemplateId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          },
          TemplateId: function($viewValue, $modelValue, scope) {
            model.DocName = $viewValue.text;
          },
        };
        var hideExpressions = {
          DocType: function($viewValue, $modelValue, scope) {
            return model.Type === 'DOC' || ctrl.state === 'new';
          },
          DocName: function($viewValue, $modelValue, scope) {
            return model.Type === 'DOC' || ctrl.state === 'new';
          },
          DocTypeId: function($viewValue, $modelValue, scope) {
            return model.Type !== 'DOC' && !!model.Type;
          },
          TemplateId: function($viewValue, $modelValue, scope) {
            return model.Type !== 'DOC' && !!model.Type;
          },
          ModUserName: function($viewValue, $modelValue, scope) {
            return true;
          },
        };
        InsertCustomExpressionProperties(pageModel, customExpressionProperties);
        InsertHideExpressions(pageModel, hideExpressions);
        InsertOnChangeFunctions(pageModel, onChangeFunctions);
        InsertDynamicQueryParameters(pageModel, dynamicQueryParameters);
        ctrl.preSave = function(ctrl) {
          if (!isNaN(ctrl.formModel.TemplateId)) {
            saveAndGenerateReport(ctrl);
          } else {
            $http
              .post('Contract/GetDocumentTemplateParamCount', {
                templateId: ctrl.formModel.TemplateId,
              })
              .then(
                function(res) {
                  var result = res.data;
                  res.data;
                  saveAndGenerateReport(ctrl);
                },
                function(err) {
                  ctrl.saveInProgress = false;
                }
              );
          }
        };
      };

      function saveAndGenerateReport(ctrl) {
        let url = 'Property/TenancyCheque' + vm.EditOrDuplicate + vm.security;
        $http
          .post(url, {
            model: vm.formModel,
            rowsModel: vm.multidata,
          })
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            if (!!response.data?.Warning) {
              toastr.warning(response.data.Warning);
            } else {
              if (!!response.data?.Message) {
                toastr.success(response.data.Message);
              }

              ctrl.formModel.TenChequeId = vm.formModel.TenChequeId;
              var params = { model: ctrl.formModel };
              var state = ctrl.state === 'new' ? 'Create' : 'Edit';
              let ssrs = ctrl.formModel.Type !== 'DOC' ? 'SSRS' : '';
              $http
                .post('Property/TenChequeDoc' + ssrs + state + (vm.closeInProgress === true ? 'AndClose' : ''), params)
                .then(function(response) {
                  if (response?.data?.Dto.InsertedId) {
                    ctrl.formModel.ID = response.data.Dto.InsertedId;
                  }
                  if (response?.data?.modUserName) {
                    ctrl.formModel.ModUserName = response.data.modUserName;
                  }
                  toastr.success(vm.pageModel.Messages.SaveSuccessful);
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  generateReport(ctrl, response);
                  vm.closeInProgress = false;
                  ctrl.closeWithData();
                })
                .catch(function(response) {
                  ctrl.saveInProgress = false;
                  toastr.error(vm.pageModel.Messages.SaveFailed);
                });
            }
            function generateReport(ctrl, fileResult) {
              if (ctrl.state !== 'new') {
                return;
              }
              var file = fileResult.data.Dto;
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
              if (vm.closeInProgress === true) {
                $state.go(
                  $stateParams.saveState ?? 'Property.GridTenancyChequeEditRentableUnit',
                  {
                    id: response.data.TenChequeId,
                    PropertyId: vm.formModel.PropertyId,
                    Level: 'PPRRU',
                    Security: 'RentableUnit',
                  },
                  { reload: true }
                );
              } else {
                vm.getChequeData();
              }
            }
          });
      }
      vm.addingFieldProperties = function(pageModel, model) {
        var formModel = model;
        // Usage: "fieldName": "typeName"
        var customTypes = {
          Separator1: 'separatorDash',
          Separator2: 'separatorDash',
        };
        var customExpressionProperties = {};
        var customExpressionProperties2 = {
          GroupId: {
            'templateOptions.required': function(a, b, c) {
              return (!!c.model.ElementId && !!c.model.ElementId.Value) || c.model.Quantity > 0;
            },
          },
          ElementId: {
            'templateOptions.required': function(a, b, c) {
              return (!!c.model.GroupId && !!c.model.GroupId.Value) || c.model.Quantity > 0;
            },
          },
          Quantity: {
            'templateOptions.required': function(a, b, c) {
              return (
                (!!c.model.ElementId && !!c.model.ElementId.Value) || (!!c.model.GroupId && !!c.model.GroupId.Value)
              );
            },
          },
        };

        // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
        var syncValidators = {
          PlannedCheque: {
            PlannedChequeValidator: function(modelValue, viewValue) {
              var currValidFrom = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
              var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

              return currValidFrom.isSameOrAfter(minValues);
            },
          },

          PlannedChequeTo: {
            PlannedChequeToValidator: function(modelValue, viewValue) {
              var dateTo = moment(modelValue, [moment.ISO_8601, 'HH:mm']);
              var dateFrom = moment(formModel.PlannedChequeFrom, [moment.ISO_8601, 'HH:mm']);

              return !dateFrom.isValid() || !dateTo.isValid() || dateTo.isAfter(dateFrom);
            },
          },

          DateOfCheque: {
            /**
             * @return {boolean}
             */
            DateOfChequeValidator: function(modelValue, viewValue) {
              if (!modelValue || !viewValue) {
                return true;
              }

              var dateOfChequeValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
              var plannedChequeValues = new moment(
                formModel.PlannedCheque,
                kendo.culture().calendar.patterns.d.toUpperCase()
              );

              return dateOfChequeValue.isSameOrAfter(plannedChequeValues);
            },
          },
          DateOfChequeTo: {
            DateOfChequeToValidator: function(modelValue, viewValue) {
              var dateTo = moment(modelValue, [moment.ISO_8601, 'HH:mm']);
              var dateFrom = moment(formModel.DateOfChequeFrom, [moment.ISO_8601, 'HH:mm']);

              return !dateFrom.isValid() || !dateTo.isValid() || dateTo.isAfter(dateFrom);
            },
          },
          AdultInhabitant: {
            /**
             * @return {boolean}
             * @return {boolean}
             */
            AdultInhabitantValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 1 && modelValue <= 99;
            },
          },
          ChildInhabitant: {
            /**
             * @return {boolean}
             * @return {boolean}
             */
            ChildInhabitantValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 0 && modelValue <= 99;
            },
          },
          TechnicalIndicator: {
            /**
             * @return {boolean}
             * @return {boolean}
             */
            OnetoFiveValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 1 && modelValue <= 5;
            },
          },
          CleannessIndicator: {
            /**
             * @return {boolean}
             * @return {boolean}
             */
            OnetoFiveValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 1 && modelValue <= 5;
            },
          },
          AttitudeIndicator: {
            /**
             * @return {boolean}
             * @return {boolean}
             */
            OnetoFiveValidator: function(modelValue) {
              if (!modelValue) {
                return true;
              }
              return modelValue >= 1 && modelValue <= 5;
            },
          },
        };

        var onChangeFunctions = {
          PlannedCheque: function(selectedItem) {
            if (!!formModel.PlannedCheque) {
              vm.getChequeData();
            } else {
              vm.multidata = [];
              vm.formlyPanels = [];
            }
          },
          PlannedChequeFrom: function(selectedItem) {
            pageModel.Fields.PlannedChequeTo.FormlyFieldDescriptor.formControl.$validate();
          },
          DateOfChequeFrom: function(selectedItem) {
            pageModel.Fields.DateOfChequeTo.FormlyFieldDescriptor.formControl.$validate();
          },
          GroupId: function(selectedItem, selectedRow) {
            pageModel.Fields.ElementId.FormlyFieldDescriptor.formControl.$$element
              .data('kendoMultiColumnComboBox')
              .value('');
            pageModel.Fields.ElementId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            pageModel.Fields.ElementId.FormlyFieldDescriptor.formControl.$validate();
          },
          ElementId: function(selectedItem, selectedRow) {
            pageModel.Fields.Quantity.FormlyFieldDescriptor.formControl.$$element.data(
              'kendoNumericTextBox'
            ).options.format = '##############.##' + (selectedRow?.UnitName ? ' \\' + selectedRow.UnitName : '');
            model.UnitName = selectedRow?.UnitName;
            pageModel.Fields.Quantity.FormlyFieldDescriptor.formControl.$$element.trigger('blur');
            if (!!formModel.GroupId) {
              return;
            }
            if (!!selectedRow) {
              pageModel.Fields.GroupId.FormlyFieldDescriptor.formControl.$$element
                .data('kendoMultiColumnComboBox')
                .value(selectedRow.GroupId);
            } else {
              pageModel.Fields.GroupId.FormlyFieldDescriptor.formControl.$$element
                .data('kendoMultiColumnComboBox')
                .value('');
            }
            pageModel.Fields.GroupId.FormlyFieldDescriptor.formControl.$validate();
          },
        };
        var numericOptions = {
          Quantity: {
            format: '###############.##' + (model.UnitName ? ' \\' + model.UnitName : ''),
            max: 999999999999999,
            min: 0,
          },
          ReadState: {
            format: '###############.####',
            max: 999999999999999,
            min: 0,
          },
        };
        var customExpressionPropertiesMainForm = {
          Signer1: {
            'templateOptions.required': function() {
              return !!vm.formModel.CertSigner1;
            },
          },
          Signer2: {
            'templateOptions.required': function() {
              return !!vm.formModel.CertSigner2;
            },
          },
          Checker2: {
            'templateOptions.required': function() {
              return !!vm.formModel.CertChecker2;
            },
          },
        };

        InsertNumericOptions(pageModel, numericOptions);
        InsertSyncValidators(pageModel, syncValidators);
        InsertOnChangeFunctions(pageModel, onChangeFunctions);
        InsertCustomTypes(pageModel, customTypes);
        if (!vm.isFormReadOnly) {
          InsertCustomExpressionProperties(pageModel, customExpressionPropertiesMainForm);
        }
        function groupIdCondition() {
          return { filter: formModel?.GroupId > 0 ? 'GroupId~eq~' + formModel.GroupId : '' };
        }

        function premiseIdCondition() {
          return { RentUnitId: vm.formModel?.PropertyId };
        }
        pageModel.Fields.ElementId.FormlyFieldDescriptor.templateOptions.QueryParameters = groupIdCondition;
        pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.QueryParameters = premiseIdCondition;
        pageModel.Fields.Quantity.FormlyFieldDescriptor.templateOptions.FieldView = function(inModel) {
          return inModel.Quantity + (inModel.UnitName ? ' ' + inModel.UnitName : '');
        };
      };
      vm.pageModel.Panels.PanelTenantsAndUsers.EditShow = vm.pageModel.Panels.PanelTenantsAndUsers.DelShow = function(
        model
      ) {
        return model.IsManuallyAdded;
      };
      vm.pageModel.Fields.RelationshipId.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.CommentUser.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.DateOfBirthUser.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.PlaceOfBirth.FormlyFieldDescriptor.templateOptions.FieldHide = function(
        model
      ) {
        return !model.IsManuallyAdded;
      };
      vm.pageModel.Fields.RelationshipId.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.HabituallyInhabit.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.SubTenant.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.CoTenant.FormlyFieldDescriptor.templateOptions.FieldHide = vm.pageModel.Fields.DateOfBirth.FormlyFieldDescriptor.templateOptions.FieldHide = function(
        model
      ) {
        return model.IsManuallyAdded;
      };

      vm.addingFieldProperties(vm.pageModel, vm.formModel);
      vm.pageModelCard = _.cloneDeep(vm.pageModel);
      vm.pageModelTenant = _.cloneDeep(vm.pageModel);

      vm.pageModelTenant.Fields.RelationshipName.FormlyFieldDescriptor.hide = true;
      vm.pageModelTenant.Fields.WithTitle.FormlyFieldDescriptor.hide = true;
      vm.pageModelTenant.Fields.HabituallyInhabit.FormlyFieldDescriptor.hide = true;
      vm.pageModelTenant.Fields.CoTenant.FormlyFieldDescriptor.hide = true;
      vm.pageModelTenant.Fields.SubTenant.FormlyFieldDescriptor.hide = true;

      vm.pageModel.Fields.TemplateId.FormlyFieldDescriptor.hide = true;
      vm.pageModel.Fields.DocTypeId.FormlyFieldDescriptor.hide = true;
      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }
      vm.surfacePreDocCallback = function(model, pageModel) {
        if (!model?.ChequeSurfaceId) {
          toastr.warning('Új tételhez való csatoláshoz először nyomjon a fenti mentés ikonra.');
          return false;
        }
      };
      vm.genDocPreDocCallback = function(model, pageModel, ctrl) {
        if (!vm.formModel.TenChequeId) {
          toastr.warning('Új tételhez való csatoláshoz először nyomjon a fenti mentés ikonra.');
          return false;
        }
        ctrl.dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
        };
        if (model.Type === 'DOC') {
          ctrl.dasModel.tables.FlgTenChequeDocument = '1';
          ctrl.dasModel.tables.idTables = { FlgTenChequeDocument: 'ID' };
        } else {
          ctrl.dasModel.tables.FlgTenChequeSSRSDocument = '1';
          ctrl.dasModel.tables.idTables = { FlgTenChequeSSRSDocument: 'ID' };
        }
      };
      vm.genUserPreDocCallback = function(model, pageModel, ctrl) {
        if (!vm.formModel.TenChequeId) {
          toastr.warning('Új tételhez való csatoláshoz először nyomjon a fenti mentés ikonra.');
          return false;
        }
        ctrl.dasModel.tables = {
          FlgTenancyCheque: vm.formModel.TenChequeId,
        };
        if (model.IsManuallyAdded) {
          ctrl.dasModel.tables.FlgChequeExtraUser = '1';
          ctrl.dasModel.tables.idTables = { FlgChequeExtraUser: 'ChequeExtraUserId' };
        } else {
          ctrl.dasModel.tables.FlgPartner = '1';
          ctrl.dasModel.tables.idTables = { FlgPartner: 'PartnerId' };
        }
      };
      vm.genUserPreDelCallback = function(model, pageModel, ctrl, e) {
        $http.get('Property/TenChequeExtraUserDelete/' + model.ChequeExtraUserId).then(
          function() {
            toastr.success(vm.pageModel?.Messages?.DeleteSuccessful);
            ctrl.model.splice(e.model.key, 1);
            e.sender.dataSource.remove(e.sender.dataItem(e.item));
          },
          function() {
            toastr.error(vm.pageModel?.Messages?.DeleteFailed);
            return false;
          }
        );
        return false;
      };
      vm.afterFormGenerate = function(pageModel, formModel) {};

      vm.closeChequeVisibility = function() {
        return vm.formModel.TenChequeId > 0;
      };
      vm.closeChequeActivity = function() {
        return vm.formModel.ChequeStatus !== 'TCSOP' || (!vm.formModel.CertChecker1 && !vm.formModel.CertChecker2);
      };
      vm.closeChequeDialog = function() {
        bootbox.dialog({
          title: vm.pageModel.Messages.Warning,
          message:
            'Biztosan le szeretné zárni a jegyzőkönyvet? Az esetleges módosítások mentésre kerülnek és további módosításra nincs lehetősége! A zárási folyamat részeként az Igen gombra kattintás után generálásra kerül a jegyzőkönyv a rögzített adatokkal!',
          closeButton: false,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Yes,
              className: 'btn-primary',
              callback: function() {
                vm.closeCheque();
              },
            },
          },
        });
      };
      vm.closeCheque = function() {
        vm.closeInProgress = true;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
          controller: 'SbCardListEditModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: {
              pageModel: vm.pageModel,
              dto: { DocDate: new moment(Date.now()).format('YYYY-MM-DD'), DisableDocdate: true },
              id: 0,
              state: 'new',
              panelName: vm.multiFormPanels[7].panel.panel,
              dasModel: vm.multiFormPanels[7].dasModel,
              preGenerateCallback: vm.modalGenDoc,
              afterGenerateCallback: vm.afterFormGenerate,
            },
            params: {},
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function(result) {
          if (result?.dto) {
          }
        });
      };

      ////////////////////////////////////////////////////////////////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.formHeaderFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;
      vm.formHeaderFields2 = formlyFormPanelDescriptors.PanelInfo2.FormlyDescriptor;
      vm.formContract = formlyFormPanelDescriptors.PanelContract.FormlyDescriptor;
      vm.formFields2 = formlyFormPanelDescriptors.PanelTenC2.FormlyDescriptor;
      vm.formFields3 = formlyFormPanelDescriptors.PanelTenC3.FormlyDescriptor;
      vm.formFields4 = formlyFormPanelDescriptors.PanelTenC4.FormlyDescriptor;
      vm.formFields5 = formlyFormPanelDescriptors.PanelTenC5.FormlyDescriptor;
      vm.formFields6 = formlyFormPanelDescriptors.PanelTenC6.FormlyDescriptor;
      vm.formFields7 = formlyFormPanelDescriptors.PanelTenC7.FormlyDescriptor;
      vm.formFields8 = formlyFormPanelDescriptors.PanelTenC8.FormlyDescriptor;
      vm.formFields9 = formlyFormPanelDescriptors.PanelTenC9.FormlyDescriptor;
      vm.formFields10 = formlyFormPanelDescriptors.PanelTenC10.FormlyDescriptor;
      vm.formFields11 = formlyFormPanelDescriptors.PanelTenC11.FormlyDescriptor;
      vm.formFieldsAdd = formlyFormPanelDescriptors.PanelTenCAdd.FormlyDescriptor;
      vm.formFieldsAddS1 = formlyFormPanelDescriptors.PanelTenCAddS1.FormlyDescriptor;
      vm.formFieldsAddS2 = formlyFormPanelDescriptors.PanelTenCAddS2.FormlyDescriptor;
      vm.formFieldsAddC1 = formlyFormPanelDescriptors.PanelTenCAddC1.FormlyDescriptor;
      vm.formFieldsAddC2 = formlyFormPanelDescriptors.PanelTenCAddC2.FormlyDescriptor;
      vm.formFieldsAddM = formlyFormPanelDescriptors.PanelTenCAddM.FormlyDescriptor;

      createMultiFormPanels(vm, formlyFormPanelDescriptors, [
        'PanelContract',
        'PanelPublicUtil',
        'PanelEqu',
        'PanelSurface',
        'PanelTenantsAndUsers',
        'PanelPremise',
        'PanelPremiseSurface',
        'PanelGenDoc',
      ]);

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      if (!!vm.formModel.PlannedCheque) {
        vm.getChequeData();
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('CreditContractNavCtrl', [
    '$scope',
    '$timeout',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    function($scope, $timeout, options, $http, $state, walService, $uibModal, HistoryService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CreditContractNavCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createItem = createItem;
      vm.editItem = editItem;
      vm.deleteItem = deleteItem;
      vm.duplicateItem = duplicateItem;
      vm.lockItem = lockItem;
      vm.mapItem = mapItem;
      vm.documentsItem = documentsItem;
      vm.WAL = WAL;
      vm.attachDocument = attachDocument;
      vm.viewItem = viewItem;
      vm.History = history;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.viewSubItem = viewSubItem;
      vm.stornoSubItem = stornoSubItem;
      vm.generate = generate;
      vm.newFrameworkGen = newFrameworkGen;
      vm.nextYearGen = nextYearGen;
      vm.tabChange = tabChange;

      vm.IsLockEnabledOnTheSelectedMainGridItem = false;
      vm.IsEditEnabledOnTheSelectedMainGridItem = false;
      vm.IsEditOrDeleteEnabledOnSubGridItem = false;
      vm.IsGenerateEnabledOnSubGridItem = false;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      //ezeket le kell küldeni a karbantartóknak
      var creditContractId = options.dto.CreditContractId;
      vm.currencyCode = '';
      vm.credContOwner = '';
      vm.credContTenType = '';
      vm.credContrStatus = '';
      vm.credContrTypeOfInterest = '';
      vm.selectedItemDiscountInvoiceId = '';

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridCreditC'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.selectedSubGridItems;
      vm.selectedMainGridItemId = 0;
      vm.selectedSubGridItemId = 0;

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridCreditC,
        'Property/CreditContractList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      vm.getSelectedMainGridItemId = function() {
        return {
          credContrId: vm.selectedMainGridItemId,
        };
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      //vm.activeSubItemTab = 0;

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelExtraInpayment', 'PanelFinalPayoff', 'PanelFrame', 'PanelInvoice'],
        function(gridModel) {
          if (gridModel.Name === 'GridFrame') {
            gridModel.ControllerMethod = 'Property/FrameList/';

            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoice') {
            gridModel.ControllerMethod = 'Property/InvoiceList/';

            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridExtraInpayment') {
            gridModel.ControllerMethod = 'Property/ExtraInpaymentList/';

            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridFinalPayoff') {
            gridModel.ControllerMethod = 'Property/FinalPayoffList/';

            return {
              gridModel,
              selectFunction: function() {
                changeSubGridFilter();
              },
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          return null;
        }
      );
      vm.detailItemGrids = generatedGridTabs.grids;
      vm.detailItemTabs = generatedGridTabs.tabs;
      vm.detailItemGridOptions = generatedGridTabs.gridOptions;

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          //ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedMainGridItemId = 0;
          vm.currencyCode = '';
          vm.credContOwner = '';
          vm.credContTenType = '';
          vm.credContrStatus = '';
          vm.credContrTypeOfInterest = '';
          $scope.$applyAsync();
          return;
        }

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.currencyCode = selectedItems[0].Currency;
        vm.credContOwner = selectedItems[0].Owner;
        vm.credContTenType = selectedItems[0].TenType;
        vm.credContrStatus = selectedItems[0].Status;
        vm.credContrTypeOfInterest = selectedItems[0].TypeOfInterest;

        $scope.$applyAsync();

        vm.subGridRefs = {};
        angular.forEach(vm.detailItemGrids, function(value) {
          vm.subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        //subGridek frissítése
        angular.forEach(vm.subGridRefs, function(value, key) {
          if (!!value) {
            value.dataSource.read().then(function() {
              // Ha a szerződés státusza élő, és a hátralévő hónapok száma 0 az utolsó éves hitelszerkezet tételen,
              // akkor aktív a funkció
              var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]]._data;

              vm.IsLockEnabledOnTheSelectedMainGridItem =
                frameGridItems.length !== 0 &&
                (frameGridItems[frameGridItems.length - 1].RemainingMonths === 0 ||
                  frameGridItems[frameGridItems.length - 1].RemainingMonths <= 12);

              // edit tiltása: " és nincs hozzá FlgCreditFramework tábla tétel"
              vm.IsEditEnabledOnTheSelectedMainGridItem = frameGridItems.length === 0;

              $scope.$applyAsync();
            });
          }
        });
      }

      function changeSubGridFilter() {
        var targetGrid = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]];
        vm.selectedSubGridItems = GetSelectedGridItems(targetGrid);
        if (vm.selectedSubGridItems.length === 0) {
          //ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedSubGridItemId = 0;
          vm.selectedItemDiscountInvoiceId = '';
          $timeout(function() {
            $scope.$applyAsync();
          });
          return;
        }

        vm.selectedSubGridItemId =
          vm.selectedSubGridItems[0][vm.pageModel.Grids[vm.detailItemGrids[vm.activeSubItemTab]].IdColumn];
        vm.selectedItemDiscountInvoiceId = vm.selectedSubGridItems[0].DiscountInvoiceId;

        // subgrid műveletek tiltása
        updateButtonActivity();
        $timeout(function() {
          $scope.$applyAsync();
        });
      }

      function updateButtonActivity() {
        switch (vm.activeSubItemTab) {
          case 0: // Framework
            vm.IsEditOrDeleteEnabledOnSubGridItem = !vm.selectedSubGridItems[0]?.Generate;
            vm.IsGenerateEnabledOnSubGridItem = !vm.selectedSubGridItems[0]?.Generate;
            break;
          case 2: // ExtraInpayment
          case 3: // FinalPayoff
            vm.IsEditOrDeleteEnabledOnSubGridItem = !!vm.selectedItemDiscountInvoiceId;
            vm.IsGenerateEnabledOnSubGridItem = true;
          default:
            break;
        }
      }

      function tabChange(index) {
        vm.activeSubItemTab = index;
        changeSubGridFilter();
        updateButtonActivity();
      }

      function createItem() {
        $state.go('Property.CreditContractCreate', { id: 0 });
      }

      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Property.CreditContractEdit', { id: id });
        }
      }

      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Property/CreditContractDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function duplicateItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Property.CreditContractDuplicate', { id: id });
        }
      }

      function lockItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }
        bootbox.dialog({
          message: 'Biztosan le kívánja zárni a szerződést?',
          title: 'Megerősítés',
          buttons: {
            cancel: {
              label: 'Mégsem',
              className: 'btn-default',
              callback: () => {},
            },
            confirm: {
              label: 'Igen',
              className: 'btn-primary',
              callback: () => {
                $http
                  .post('Property/CreditContractLockItem/', { creditContractId: vm.selectedMainGridItemId })
                  .then(function(response) {
                    selectedItems[0]['Status'] = 'PCSCL';
                    vm.mainGrid.dataSource.read();
                  })
                  .catch(function(response) {
                    toastr.warning('Nem sikerült lezárni a hitelszerződést!', vm.messages.Warning);
                  });
              },
            },
          },
        });
      }

      function viewItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Property.CreditContractView', { id: id });
        }
      }

      function mapItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          var ids = [];
          vm.mainGrid.dataSource._data.forEach(function(element) {
            if (element.Level === 'PPROB') ids.push(element.PropertyId);
          });
          if (ids.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            $state.go('Property.Map', {
              ids: ids,
            });
          }
        } else {
          $state.go('Property.Map', { propertyId: selectedItems[0].PropertyId });
        }
      }

      function documentsItem() {}

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Property.DasDocumentsNav', 'FlgCreditContract', id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal('Property', 'CreditContractNavWal', 'FlgCreditContractView');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            // Melyik tab az aktív? (Switch-Case 2)
            switch (vm.activeSubItemTab) {
              case 0: {
                walService.NavigateToWal('Property', 'FlgCreditFrameworkNavWal', 'FlgCreditFramework');
                break;
              }
              case 1: {
                walService.NavigateToWal('Property', 'FlgInvoiceViewNavWal', 'FlgInvoiceView');
                break;
              }
              case 2: {
                walService.NavigateToWal('Property', 'FlgExtraInpaymentViewNavWal', 'FlgExtraInpaymentView');
                break;
              }
              case 3: {
                walService.NavigateToWal('Property', 'FlgFinalPayoffNavWal', 'FlgFinalPayoff');
                break;
              }
              default: {
                break;
              }
            }
            // Belső switch-case vége.
            break;
          }

          default: {
            break;
          }
        }
      }

      vm.gridFrameId = vm.detailItemTabs.findIndex(function(x) {
        return x.gridName == 'GridFrame';
      });

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgCreditContract', id, vm, $state, true);
        }
      }

      function createSubItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }
        switch (vm.activeSubItemTab) {
          case 0:
            if (!isNewFrameworkEnabled()) {
              toastr.warning(
                'Nincs minden hitelszerkezetre generálás vagy nincs már hátra hónap!',
                vm.messages.Warning
              );
              return;
            }
            $http
              .post('Property/IsNewFrameworkButtonIsAllowed/', { creditContractId: vm.selectedMainGridItemId })
              .then(function(response) {
                if (!response.data.IsNewFrameworkIsAllowed) {
                  toastr.warning('Nincs aktív pénzügyi év!');
                } else {
                  $state.go('Property.CreditFrameworkCreate', {
                    id: 0,
                    creditContractId: vm.selectedMainGridItemId,
                  });
                }
              })
              .catch(function(response) {
                toastr.error('Hiba!');
              });
            break;
          case 2:
            var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[0]]._data;
            if (frameGridItems.length === 0 || frameGridItems[frameGridItems.length - 1].ClosingLoan <= 0) {
              toastr.warning('Nincs hitelszerkezet vagy a tőkehátralék kiegyenlített!', vm.messages.Warning);
              return;
            }
            $state.go('Property.ExtraInpaymentCreate', { id: 0, creditContractId: vm.selectedMainGridItemId });
            break;
          case 3:
            var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[0]]._data;
            if (frameGridItems.length === 0 || frameGridItems[frameGridItems.length - 1].ClosingLoan <= 0) {
              toastr.warning('Nincs hitelszerkezet vagy a tőkehátralék kiegyenlített!', vm.messages.Warning);
              return;
            }
            $state.go('Property.FinalPayOffCreate', { id: 0, creditContractId: vm.selectedMainGridItemId });
            break;
          default:
            break;
        }
      }

      function editSubItem() {
        var id = vm.selectedSubGridItemId;
        if (!id || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }
        switch (vm.activeSubItemTab) {
          case 0:
            $state.go('Property.CreditFrameworkEdit', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          case 2:
            $state.go('Property.ExtraInpaymentEdit', { id: id, creditContractId: vm.selectedMainGridItemId });
            break;
          case 3:
            $state.go('Property.FinalPayOffEdit', { id: id, creditContractId: vm.selectedMainGridItemId });
            break;
          default:
            break;
        }
      }

      function deleteSubItem() {
        var tabName;
        switch (vm.activeSubItemTab) {
          case 0:
            tabName = 'CreditFramework';
            break;
          case 2:
            tabName = 'ExtraInpayment';
            break;
          case 3:
            tabName = 'FinalPayOff';
            break;
          default:
            break;
        }
        var id = vm.selectedSubGridItemId;
        if (!id || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Property/' + tabName + 'Delete/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  if ((tabName = 'CreditFramework')) {
                    tabName = 'Frame';
                  }
                  vm.detailItemGrids['Grid' + tabName].dataSource.read();
                });
              },
            },
          },
        });
      }

      function duplicateSubItem() {
        var id = vm.selectedSubGridItemId;
        switch (vm.activeSubItemTab) {
          case 0:
            $state.go('Property.CreditFrameworkDuplicate', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          case 2:
            $state.go('Property.ExtraInpaymentDuplicate', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          case 3:
            $state.go('Property.FinalPayOffDuplicate', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          default:
            break;
        }
      }

      function viewSubItem() {
        var id = vm.selectedSubGridItemId;
        if (!id || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }
        console.log('selectes sub item tab id: ' + vm.activeSubItemTab);

        switch (vm.activeSubItemTab) {
          case 0:
            $state.go('Property.CreditFrameworkView', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          case 2:
            $state.go('Property.ExtraInpaymentView', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          case 3:
            $state.go('Property.FinalPayOffView', {
              id: id,
              creditContractId: vm.selectedMainGridItemId,
            });
            break;
          default:
            break;
        }
      }
      /////////////////////////////////////////////////////////////////////////////////////////////////
      /// Generálások /////////////////////////////////////////////////////////////////////////////////

      // Sztornó számla generálás (utolsó 2 subgrid)
      function stornoSubItem() {
        var id = vm.selectedSubGridItemId;
        if (!id || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          if (vm.activeSubItemTab === 2 || vm.activeSubItemTab === 3) {
            // tabok amin lehet stonro funkciot inditani (elovigyazatossag)
            $http
              .post('Property/CreditFrameworkStorno/', { discountInvoiceId: vm.selectedItemDiscountInvoiceId })
              .then(function(response) {
                toastr.success(vm.pageModel.Messages.SaveSuccessful); // TODO: storno uzenet
              })
              .catch(function(response) {
                toastr.error(vm.pageModel.Messages.SaveFailed); // TODO: storno uzenet
              });
          }
        }
      }

      // Számla generálása 4.4.4.2.5
      function generate() {
        var id = vm.selectedSubGridItemId;
        if (id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          bootbox.dialog({
            message: vm.labels.BeforeGenerateModalLabelMessage.Title,
            title: vm.labels.BeforeGenerateModalLabelTitle.Title,
            buttons: {
              cancel: {
                label: vm.labels.BeforeGenerateModalLabelNo.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.labels.BeforeGenerateModalLabelYes.Title,
                className: 'btn-primary',
                callback: function() {
                  switch (vm.activeSubItemTab) {
                    case 0:
                      if (!isFirstYearGenEnabled()) {
                        toastr.warning('Nem az első elem vagy már lett generálva számla!', vm.messages.Warning);
                        return;
                      }
                      $state.go('Property.FirstYearGenParam', { id: vm.selectedMainGridItemId });
                      break;
                    case 2:
                      $http
                        .post('Property/ExtraInpaymentGenerate', { id: id })
                        .then(function(response) {
                          toastr.success(vm.pageModel.Messages.GenerateSuccessful);
                        })
                        .catch(function(response) {
                          toastr.error(vm.pageModel.Messages.GenerateFailed);
                        });
                      break;
                    case 3:
                      $http
                        .post('Property/FinalPayoffGenerate', { id: id })
                        .then(function(response) {
                          toastr.success(vm.pageModel.Messages.GenerateSuccessful);
                        })
                        .catch(function(response) {
                          toastr.error(vm.pageModel.Messages.GenerateFailed);
                        });
                      break;
                  }
                },
              },
            },
          });
        }
      }

      // Követő évi számlák generálása (csak az első subgrid-ben) 4.4.4.2.6
      function nextYearGen() {
        if (vm.selectedMainGridItemId === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        } else if (!isNextYearGenEnabled()) {
          toastr.warning('Nem engedéjezett! Első elem vagy már generált!', vm.messages.Warning);
          return;
        }
        $state.go('Property.NextYearGenParam', { id: vm.selectedMainGridItemId });
      }

      // Új éves hitelszerkezet generálása (csak az első subgrid-ben) 4.4.4.2.4
      function newFrameworkGen() {
        $http.get('Property/GetNumberOfNoneGeneratedCreditFrameworkItems/').then(function(response) {
          if (
            response.data.NumberOfNoneGeneratedCreditFrameworkItems !== undefined &&
            response.data.NumberOfNoneGeneratedCreditFrameworkItems !== 0
          ) {
            $state.go('Property.NewFrameworkMod');
          } else {
            toastr.warning('Nem tartozik minden elemhez generálás!', vm.messages.Warning);
          }
        });
      }

      /////////////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////////////////////////////////////////////////////////////////////////
      function isNewFrameworkEnabled() {
        var selectedMainGridItems = GetSelectedGridItems(vm.mainGrid);
        var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]]._data;
        if (frameGridItems.length === 0) return true;
        if (
          frameGridItems[frameGridItems.length - 1].Generate !== true // ||
          // nem a reimainingMonts-ot kene kivonni, hanem az nHelpert
          //(selectedMainGridItems[0].Duration - (frameGridItems[0].RemainingMonths + frameGridItems[0].PassedMonths)) <= 0 // nincs már hátra hónap
        )
          return false;
        return true;
      }

      function isFirstYearGenEnabled() {
        var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]]._data;
        var result = frameGridItems[0].FrameworkId === vm.selectedSubGridItemId && frameGridItems[0].Generate === false;
        return result;
      }

      function isNextYearGenEnabled() {
        // akkor aktív, ha van olyan flgCreditFrameWork tétel, amelyen a Genarate=0 és ez a tétel a hozzá tartozó szerződésre nézve nem első
        var isEnabled = false;
        var frameGridItems = vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]]._data;
        if (frameGridItems.length === 0 || frameGridItems.length === 1) return false;

        angular.forEach(frameGridItems, function(value, key) {
          if (!value.Generate && value.FrameworkId !== frameGridItems[0].FrameworkId) isEnabled = true;
        });
        return isEnabled;
      }

      function getClosingLoan(selectedItemId) {
        var closingLoan = false;
        $http.get('Property/LastFrameworkClosingLoan/' + selectedItemId).then(function() {
          closingLoan = true;
        });
        return closingLoan;
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('CreditContractEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CreditContractEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.save = save;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id; // Így kell, mivel a duplikálás is ezt az id-t használja. "options.dto.ContractId;" mindig 0
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.CreditContractNav');
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelCreditC.FormlyDescriptor;

      vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        creditContractId: vm.formModel.CreditContractId,
      };

      var onChangeFunctions = {
        /*"Advance": function () {
                        if (vm.formModel.Advance !== null && typeof vm.formModel.Advance !== "undefined"
                                && vm.formModel.Loan !== null && typeof vm.formModel.Loan !== "undefined") {
                            vm.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
                        };
                        vm.pageModel.Fields.Principal1.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
                    },*/
        PropertyId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem._events && vm.formModel.CreditContractId === 0) {
            $http
              .post('Property/CreditContractGetDateOfContract', { propertyId: selectedItem.PropertyId })
              .then(function(response) {
                if (!!response.data.DateOfContract) {
                  vm.formModel.DateOfContract = response.data.DateOfContract;
                } else {
                  vm.formModel.DateOfContract = new moment().format(kendo.culture().calendar.patterns.d.toUpperCase());
                }
              });
          }
        },
        FirstDetail: function() {
          // utolsó részlet dátumának frissítése
          var firstDetail = new moment(vm.formModel.FirstDetail, kendo.culture().calendar.patterns.d.toUpperCase());
          vm.formModel.LastDetail = firstDetail
            .add(vm.formModel.Duration - 1, 'month')
            .format(kendo.culture().calendar.patterns.d.toUpperCase());
        },
        Advance: function() {
          if (!!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
            vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
          }
        },
        Loan: function() {
          if (!!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
            vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
          }
        },
        FixPercentage: function() {
          if (!!vm.formModel.FixPercentage && vm.formModel.FixPercentage > 100) {
            vm.formModel.FixPercentage = 99.99;
          }
        },
        Duration: function() {
          if (!!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
            vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
          }

          if (vm.formModel.Duration > 480) vm.formModel.Duration = 480;
          // utolsó részlet dátumának frissítése
          var firstDetail = new moment(vm.formModel.FirstDetail, kendo.culture().calendar.patterns.d.toUpperCase());
          vm.formModel.LastDetail = firstDetail
            .add(vm.formModel.Duration, 'month')
            .format(kendo.culture().calendar.patterns.d.toUpperCase());
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      /*var hideExpressions = {
                "FixPercentage": function () {
                    return vm.formModel.TypeOfInterest == "PINFX";
                }
            };
            InsertHideExpressions(vm.pageModel, hideExpressions);*/

      var customExpressionProperties = {
        FixPercentage: {
          'templateOptions.disabled': function(modelValue, o2, o3) {
            return vm.formModel.TypeOfInterest !== 'PINFX';
          },
        },
      };

      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      var onBlurFunctions = {
        //"Advance": function (selectedItem) {
        //    if (!!selectedItem && !!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
        //        vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;                        }
        //},
        //"Loan": function (selectedItem) {
        //    if (!!selectedItem && !!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
        //        vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
        //    }
        //},
        //"FixPercentage": function (selectedItem) {
        //    if (!!selectedItem && !!vm.formModel.FixPercentage && selectedItem > 100) {
        //        vm.formModel.FixPercentage = 99.99;
        //    }
        //},
        //"Duration": function (selectedItem) {
        //    if (!!selectedItem && !!vm.formModel.Advance && !!vm.formModel.Loan && !!vm.formModel.Duration && vm.formModel.Duration !== 0) {
        //        vm.formModel.Principal1 = (vm.formModel.Loan - vm.formModel.Advance) / vm.formModel.Duration;
        //    }
        //    if (selectedItem > 480) vm.formModel.Duration = 480;
        //// utolsó részlet dátumának frissítése
        //var firstDetail = new moment(vm.formModel.FirstDetail, kendo.culture().calendar.patterns.d.toUpperCase());
        //vm.formModel.LastDetail = firstDetail.add(vm.formModel.Duration, 'month').format(kendo.culture().calendar.patterns.d.toUpperCase());
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      /*var numericOptions = {
                "FixPercentage":
                {
                    decimals: 2,
                    format: "n2",
                    max: 99,
                    min: 0
                }
            };
            InsertNumericOptions(vm.pageModel, numericOptions);*/

      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var syncValidators = {
        Loan: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue, viewValue) {
            return modelValue > 0;
          },
        },
        Advance: {
          /**
           * @return {boolean}
           */
          AdvanceHigherThanLoanValidator: function(modelValue, viewValue) {
            return modelValue <= vm.formModel.Loan;
          },
        },
        FirstDetail: {
          /**
           * @return {boolean}
           */
          FirstDetailHigherThanDateOfContract: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var firstDetail = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var dateOfContract = new moment(
              vm.formModel.DateOfContract,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            if (isNaN(dateOfContract)) {
              return true;
            }

            return firstDetail.isSameOrAfter(dateOfContract);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      function save() {
        $http
          .post('Property/CreditContract' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      vm.attachDocument = function() {
        var id = vm.formModel.CreditContractId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgCreditContract', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('NewFrameworkModCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    function($http, options, $state, $stateParams, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'NewFrameworkModCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.generateNewFramework = generateNewFramework;

      vm.back = function() {
        $state.go('Property.CreditContractNav');
      };

      var dynamicQueryParameters = {
        PrincipalServiceIdP: function() {
          return [
            {
              key: vm.formModel.CreditContractId,
              text: 'creditContractId',
            },
          ];
        },
        InterestServiceIdP: function() {
          return [
            {
              key: vm.formModel.CreditContractId,
              text: 'creditContractId',
            },
          ];
        },
        InvoicePadP: function() {
          return [
            {
              key: 'INTCA',
              text: 'invoiceType',
            },
            {
              key: vm.formModel.FinancialYearP,
              text: 'financialYear',
            },
          ];
        },
        InvoicePadIntP: function() {
          return [
            {
              key: 'INTCI',
              text: 'invoiceType',
            },
            {
              key: vm.formModel.FinancialYearP,
              text: 'financialYear',
            },
          ];
        },
      };

      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      var onChangeFunctions = {
        OwnerP: function(selectedItem) {
          if (!!selectedItem) {
            $http
              .post('Property/CredFrameworkGetFinancialYear', { ownerId: selectedItem.key })
              .then(function(response) {
                if (!!response.data.FinancialYear) {
                  vm.formModel.FinancialYearP = response.data.FinancialYear;
                }
              });
          }
        },
        InvoicePadP: function(view, model) {
          vm.formModel.InvoicePadP = model.InvoicePad;
        },
        InvoicePadIntP: function(view, model) {
          vm.formModel.InvoicePadIntP = model.InvoicePad;
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.Panelframework.FormlyDescriptor;

      function generateNewFramework() {
        $http
          .post('Property/NewFrameworkGen', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('NextYearGenParamCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    function($http, options, $state, $stateParams, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'NextYearGenParamCtrl', stateParams);
      }
      var vm = this;

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.generateNextYear = generateNextYear;

      vm.back = function() {
        $state.go('Property.CreditContractNav');
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.Panelyeargen.FormlyDescriptor;

      function generateNextYear() {
        $http
          .post('Property/NewYearGen', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('FirstYearGenParamCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    function($http, options, $state, $stateParams, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FirstYearGenParamCtrl', stateParams);
      }
      var vm = this;

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.generateFirstYear = generateFirstYear;

      vm.back = function() {
        $state.go('Property.CreditContractNav');
      };

      var dynamicQueryParameters = {
        PrincipalServiceIdP: function() {
          return [
            {
              key: vm.formModel.CreditContractId,
              text: 'creditContractId',
            },
          ];
        },
      };

      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.Panelyeargen.FormlyDescriptor;

      function generateFirstYear() {
        $http
          .post('Property/FirstYearGen', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('CertificateEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CertificateEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.UIHelperService = UIHelperService;

      init();

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveButtonHandling = saveButtonHandling;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.isFormReadOnly = $stateParams.controllerOptions.isFormReadOnly;

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, options);
        initViewModel($http, $state, $stateParams, vm, options);
        initFormModel($http, $state, $stateParams, vm, options);

        vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

        var fs = fieldSetter;
        fs.vm = vm;
        fs.setMask('CertificateCode', 'HET-99999999');

        generateForm(vm);
      }

      var level = '';
      if (vm.dataModel.Level === 'PPRRU') {
        level = 'RentableUnit';
      } else {
        level = 'PropImmovable';
      }

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View'
        );
      }

      vm.save = function() {
        $http
          .post('Property/Certificate' + vm.EditOrDuplicate, vm.dataModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.' + level + 'Nav', { id: vm.dataModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.' + level + 'Nav', { id: vm.dataModel.PropertyId });
      };

      vm.attachDocument = function() {
        var id = vm.dataModel.CertificateId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgCertificate', id);
      };

      if (vm.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('EmptyFlatTransmissionFeeReportCtrl', [
    '$uibModalInstance',
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$window',
    function(mi, $scope, options, $http, $state, $stateParams, $window) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EmptyFlatTransmissionFeeReportCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.EFTModel = options.dto;
      vm.EFTPageModel = options.pageModel;

      vm.messages = options.pageModel.Messages;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.EFTPageModel);
      vm.EFTMFormFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        if (!!vm.EFTModel.AreaRentalId && vm.EFTModel.AreaRentalId.Value > 0) {
          mi.close(vm.EFTModel.AreaRentalId.Value);
        }
      };

      vm.cancel = function() {
        mi.dismiss();
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('CreditFrameworkEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CreditFrameworkEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.mainGridItemId = vm.formModel.CredContId;
      vm.typeOfInterest = vm.formModel.CredContTypeOfInterest;
      vm.owner = vm.formModel.CredContOwner;
      vm.tenType = vm.formModel.CredContTenType;
      vm.isFirst = vm.formModel.IsFirst;
      vm.duration = vm.formModel.CredContDuration;
      vm.periodsNum = vm.formModel.PeriodsNum;
      vm.nHelper = vm.formModel.NHelper;
      vm.loan = vm.formModel.CredContLoan;
      vm.advance = vm.formModel.CredContAdvance;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id; // Így kell, mivel a duplikálás is ezt az id-t használja. "options.dto.ContractId;" mindig 0
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.CreditContractNav');
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};
      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        Percentage: {
          'templateOptions.disabled': function(modelValue, o2, o3) {
            return vm.typeOfInterest === 'PINFX';
          },
        },
        Principal1: {
          'templateOptions.disabled': function(modelValue, o2, o3) {
            return !vm.isFirst;
          },
          'templateOptions.required': function(modelValue, o2, o3) {
            return vm.isFirst;
          },
        },
        Interest1: {
          'templateOptions.disabled': function(modelValue, o2, o3) {
            return !vm.isFirst;
          },
          'templateOptions.required': function(modelValue, o2, o3) {
            return vm.isFirst;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        /**
         * @return {boolean}
         */
        Principal1: function() {
          return !vm.isFirst;
        },
        /**
         * @return {boolean}
         */
        Interest1: function() {
          return !vm.isFirst;
        },
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        FinancialYear: function() {
          vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          vm.pageModel.Fields.InvoicePadInt.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        InvoicePadInt: function(view, model) {
          vm.formModel.InvoicePadInt = model.InvoicePad;
        },
        Percentage: function() {
          $http
            .post('Property/CreditFrameworkCalculateAnnuity', vm.formModel)
            .then(function(response) {
              vm.formModel.MonthlyInterest = response.data.Dto.MonthlyInterest;
              vm.formModel.Interest1 = vm.formModel.MonthlyInterest;
            })
            .catch(function(response) {
              toastr.error('Hiba a havi kamattörlesztés számítása során!');
            });

          if (vm.isFirst) {
            vm.formModel.ClosingInterest = vm.formModel.Interest1 + (vm.nHelper - 1) * vm.formModel.MonthlyInterest;
            vm.formModel.ClosingLoan =
              vm.loan - vm.advance - vm.formModel.Principal1 - (vm.nHelper - 1) * vm.formModel.MonthlyPrincipal;
          } else {
            vm.formModel.ClosingInterest = vm.formModel.OpenerInterest + vm.nHelper * vm.formModel.MonthlyInterest;
            vm.formModel.ClosingLoan = vm.formModel.OpenerLoan - vm.nHelper * vm.formModel.MonthlyPrincipal;
          }
        },
        Principal1: function() {
          // TODO: kerekitest back-end felhivassal kene
          vm.formModel.MonthlyPrincipal = Math.round(
            (vm.formModel.OpenerLoan - vm.formModel.Principal1) / (vm.duration - 1)
          );

          if (vm.isFirst) {
            vm.formModel.ClosingInterest = vm.formModel.Interest1 + (vm.nHelper - 1) * vm.formModel.MonthlyInterest;
            vm.formModel.ClosingLoan =
              vm.loan - vm.advance - vm.formModel.Principal1 - (vm.nHelper - 1) * vm.formModel.MonthlyPrincipal;
          } else {
            vm.formModel.ClosingInterest = vm.formModel.OpenerInterest + vm.nHelper * vm.formModel.MonthlyInterest;
            vm.formModel.ClosingLoan = vm.formModel.OpenerLoan - vm.nHelper * vm.formModel.MonthlyPrincipal;
          }
        },
        Interest1: function() {
          $http
            .post('Property/CreditFrameworkCalculateAnnuity', vm.formModel)
            .then(function(response) {
              // TODO: kerekitest back-end felhivassal kene
              vm.formModel.MonthlyInterest = Math.round(
                (vm.nHelper * response.data.Dto.MonthlyInterest - vm.formModel.Interest1) / (vm.nHelper - 1)
              );

              if (vm.isFirst) {
                vm.formModel.ClosingInterest = vm.formModel.Interest1 + (vm.nHelper - 1) * vm.formModel.MonthlyInterest;
                vm.formModel.ClosingLoan =
                  vm.loan - vm.advance - vm.formModel.Principal1 - (vm.nHelper - 1) * vm.formModel.MonthlyPrincipal;
              } else {
                vm.formModel.ClosingInterest = vm.formModel.OpenerInterest + vm.nHelper * vm.formModel.MonthlyInterest;
                vm.formModel.ClosingLoan = vm.formModel.OpenerLoan - vm.nHelper * vm.formModel.MonthlyPrincipal;
              }
            })
            .catch(function(response) {
              //toastr.error(vm.pageModel.Messages.SaveFailed);
              toastr.error('Hiba a havi kamattörlesztés számítása során!');
            });
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        //"Percentage": function(selectedItem, o2, o3){
        //    //calculateOnPercentageChange(selectedItem, o3.model);
        //    $http.post("Property/CreditFrameworkCalculateAnnuity", vm.formModel)
        //                .then(function (response) {
        //                    o3.model.MonthlyInterest = response.data.Dto.MonthlyInterest;
        //                })
        //                .catch(function (response) {
        //                    toastr.error("Hiba a havi kamattörlesztés számítása során!");
        //                });
        //    vm.formModel.Interest1 = vm.formModel.MonthlyInterest;
        //    if (vm.isFirst) {
        //        vm.formModel.ClosingInterest = vm.formModel.Interest1 + (vm.nHelper - 1) * vm.formModel.MonthlyInterest;
        //    } else {
        //        vm.formModel.ClosingInterest = vm.formModel.OpenerInterest + vm.nHelper * vm.formModel.MonthlyInterest;
        //    }
        //},
        //"Principal1": function (selectedItem, o2, o3) {
        //    o3.model.MonthlyPrincipal = (o3.model.OpenerLoan - selectedItem) / (vm.duration - 1);
        //    if (vm.isFirst) {
        //        o3.model.ClosingLoan = vm.loan - vm.advance - o3.model.Principal1 - ((vm.nHelper - 1) * o3.model.MonthlyPrincipal);
        //    } else {
        //        o3.model.ClosingLoan = o3.model.OpenerLoan - vm.nHelper * o3.model.MonthlyPrincipal;
        //    }
        //},
        //"Interest1": function (selectedItem, o2, o3) {
        //    $http.post("Property/CreditFrameworkCalculateAnnuity", vm.formModel)
        //                .then(function (response) {
        //                    o3.model.MonthlyInterest = response.data.Dto.MonthlyInterest;
        //                })
        //                .catch(function (response) {
        //                    //toastr.error(vm.pageModel.Messages.SaveFailed);
        //                    toastr.error("Hiba a havi kamattörlesztés számítása során!");
        //                });
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        MonthlyPrincipal: {
          /**
           * @return {boolean}
           */
          ExtraInpaymentInpaymentValidator: function(modelValue) {
            return modelValue > 0;
          },
        },
        MonthlyInterest: {
          /**
           * @return {boolean}
           */
          ExtraInpaymentInpaymentValidator: function(modelValue) {
            return modelValue > 0;
          },
        },
        Interest1: {
          /**
           * @return {boolean}
           */
          ExtraInpaymentInpaymentValidator: function(modelValue) {
            return modelValue > 0;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      var dynamicQueryParameters = {
        FinancialYear: function() {
          return [
            {
              key: vm.mainGridItemId,
              value: 'creditContractId',
            },
            {
              key: vm.formModel.FrameworkId,
              value: 'CredFrameId',
            },
          ];
        },
        PrincipalServiceId: function() {
          return [
            {
              key: vm.mainGridItemId,
              text: 'creditContractId',
            },
          ];
        },
        InterestServiceId: function() {
          return [
            {
              key: vm.mainGridItemId,
              text: 'creditContractId',
            },
          ];
        },
        InvoicePad: function() {
          var financYear;
          if (!!vm.formModel.FinancialYear && vm.formModel.FinancialYear !== '') {
            financYear = vm.formModel.FinancialYear;
          } else {
            financYear = '';
          }
          return [
            {
              key: 'INTCA',
              text: 'invoiceType',
            },
            {
              key: financYear,
              text: 'financialYear',
            },
          ];
        },
        InvoicePadInt: function() {
          var financYear;
          if (!!vm.formModel.FinancialYear && vm.formModel.FinancialYear !== '') {
            financYear = vm.formModel.FinancialYear;
          } else {
            financYear = '';
          }
          return [
            {
              key: 'INTCI',
              text: 'invoiceType',
            },
            {
              key: financYear,
              text: 'financialYear',
            },
          ];
        },
      };
      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomClasses(vm.pageModel, customClasses);
      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertParsers(vm.pageModel, parsers);
      InsertFormatters(vm.pageModel, formatters);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelFrame.FormlyDescriptor;

      function saveItem() {
        $http
          .post('Property/CreditFrameworkEdit', vm.formModel, vm.mainGridItemId)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.attachDocument = function() {
        var id = vm.formModel.FrameworkId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgCreditFramework', id);
      };

      function calculateOnPercentageChange(selectedItem, fields) {
        if (fields.CredContTypeOfInterest === 'PINCB') {
          fields.MonthlyInterest = (((fields.OpenerLoan * selectedItem) / 100) * (vm.periodsNum / 12)) / 12;
          fields.Interest1 = fields.MonthlyInterest;
          if (vm.isFirst) {
            fields.ClosingInterest = fields.Interest1 + (vm.nHelper - 1) * fields.MonthlyInterest;
          } else {
            fields.ClosingInterest = fields.OpenerInterest + vm.nHelper * fields.MonthlyInterest;
          }
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('ExtraInpaymentEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ExtraInpaymentEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.mainGridItemId = vm.formModel.CredContId;
      vm.currencyRounding = vm.formModel.CurrencyRounding;
      vm.owner = vm.formModel.CredContOwner;
      vm.tenType = vm.formModel.CredContTenType;

      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.CreditContractNav');
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};
      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        Benefit: function() {
          calculateCapitalDiscount(vm.formModel.Inpayment, vm.formModel.Benefit);
        },
        Inpayment: function() {
          calculateCapitalDiscount(vm.formModel.Inpayment, vm.formModel.Benefit);
        },
        InpaymentDate: function() {
          $http
            .post('Property/GetFinancialYearForDate', {
              inpaymentDate: vm.formModel.InpaymentDate,
              credContrId: vm.formModel.CredContId,
            })
            .then(function(response) {
              if (vm.formModel.InpaymentDate.substring(0, 4) === response.data.FinancialYear) {
                vm.formModel.FinancialYear = response.data.FinancialYear;
              } else {
                vm.formModel.FinancialYear = '';
              }
            });
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        //"FinancialYear": function () {
        //    vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        //    //vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.formControl.$validate();
        //}
        //"Benefit": function (selectedItem, o2, o3) {
        //    calculateCapitalDiscount(o3.model.Inpayment, selectedItem);
        //},
        //"Inpayment": function(selectedItem, o2, o3){
        //    calculateCapitalDiscount(selectedItem, o3.model.Benefit);
        //},
        //"InpaymentDate": function (selectedItem, o2, o3) {
        //    if (!!vm.formModel.InpaymentDate) {
        //        vm.formModel.FinancialYear = vm.formModel.InpaymentDate.substring(0, 4);
        //    }
        //    else {
        //        vm.formModel.FinancialYear = "";
        //    }*/
        //    //vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        //    vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.formControl.$validate();
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        /*"InpaymentDate": {
                    ExtraInpaymentDateValidator: function (modelValue) {
                        if (!modelValue) {
                            return true;
                        }
                        var dat = modelValue.substring(0, 4);

                        //return dat === vm.formModel.FinancialYear;
                        $http.post("Property/GetFinancialYearForDate", { inpaymentDate: modelValue })
                                .then(function (response) {
                                    if (dat === response.data.FinancialYear) {
                                        vm.formModel.FinancialYear = response.data.FinancialYear;
                                        return true;
                                    } else {
                                        vm.formModel.FinancialYear = "";
                                        return false;
                                    }
                                })
                                .catch(function (response) {
                                    return false;
                                });
                        //vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
                        //vm.pageModel.Fields.InpaymentDate.FormlyFieldDescriptor.formControl.$validate();
                    }
                },*/
        FinancialYear: {
          /**
           * @return {boolean}
           */
          ExtraInpaymentFYearValidator: function(modelValue) {
            if (!modelValue || !vm.formModel.YearlyCreditFrame) {
              return true;
            }
            return vm.formModel.YearlyCreditFrame.indexOf(modelValue) > -1;
          },
        },
        Benefit: {
          /**
           * @return {boolean}
           */
          FinalPayOffBenefitValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0 && modelValue <= 100;
          },
        },
        Inpayment: {
          /**
           * @return {boolean}
           */
          ExtraInpaymentInpaymentValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            // kendo.parseInt(modelValue)
            return (
              modelValue > 0 &&
              modelValue > vm.formModel.MonthlyPrincipal &&
              modelValue < vm.formModel.ClosingLoan - 12 * vm.formModel.MonthlyPrincipal
            );
          },
        },
      };

      /*
            // SampleFormly.js -bol szedve --> nem mukodik
            function setTestFields(vm) {
                var fs = fieldSetter;
                fs.vm = vm;
                fs.setSyncValidator(
                    "Inpayment",
                    "ExtraInpaymentInpaymentValidator",
                    function (a, b, c) {
                        return kendo.parseInt(a) > 0;
                    }
                );
            }*/

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      var dynamicQueryParameters = {
        DiscountServiceId: function() {
          return [
            {
              key: vm.mainGridItemId,
              text: 'creditContractId',
            },
          ];
        },
      };
      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomClasses(vm.pageModel, customClasses);
      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertParsers(vm.pageModel, parsers);
      InsertFormatters(vm.pageModel, formatters);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelExtraInpayment.FormlyDescriptor;

      function saveItem() {
        $http
          .post('Property/ExtraInpaymentEdit', vm.formModel, vm.mainGridItemId)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ExtraInpaymentId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgExtraInpayment', id);
      };

      function calculateCapitalDiscount(inpayment, benefit) {
        //a round-ot csak backenden adom hozzá mentéskor
        vm.formModel.CapitalDiscount = (inpayment * benefit) / 100;
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('FinalPayOffEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FinalPayOffEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.mainGridItemId = vm.formModel.CredContId;
      vm.typeOfInterest = vm.formModel.CredContTypeOfInterest;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id; // Így kell, mivel a duplikálás is ezt az id-t használja. "options.dto.ContractId;" mindig 0
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //TODO átírni a navigáció nevére
      var level = 'FinalPayOff';

      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.CreditContractNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.FinalPayOffId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgFinalPayOff', id);
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};
      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        InterestServiceId: {
          'templateOptions.required': function() {
            return vm.typeOfInterest === 'PINFX';
          },
        },
        PayablePrincipal: {
          'templateOptions.required': function() {
            return vm.typeOfInterest === 'PINFX';
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        //Ezek csak 'PINCB' esetén kellenek
        /**
         * @return {boolean}
         */
        BackInterest: function() {
          return vm.typeOfInterest !== 'PINCB';
        },
        /**
         * @return {boolean}
         */
        ActualPrincipal: function() {
          return vm.typeOfInterest !== 'PINCB';
        },
        /**
         * @return {boolean}
         */
        BackPrincipal: function() {
          return vm.typeOfInterest !== 'PINCB';
        },
        //ezek csak 'PINFX' esetén kellenek
        /**
         * @return {boolean}
         */
        InterestServiceId: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        OptPayInterest: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        OptPayPrincipal: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        PayableInterest: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        PayablePrincipal: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        RevolvingInterest: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
        /**
         * @return {boolean}
         */
        ActualBalance: function() {
          return vm.typeOfInterest !== 'PINFX';
        },
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        InpaymentDate: function() {
          //Pénzügy év töltése
          $http
            .post('Property/GetLastFinancialYearForDate', {
              inpaymentDate: vm.formModel.InpaymentDate,
              credContrId: vm.formModel.CredContId,
            })
            .then(function(response) {
              if (vm.formModel.InpaymentDate.substring(0, 4) === response.data.FinancialYear) {
                vm.formModel.FinancialYear = response.data.FinancialYear;
              } else {
                vm.formModel.FinancialYear = '';
                toastr.warning('Nem tartozik hitelszerkezet a kiválasztott dátumhoz!');
              }

              //Korrekciós tényező töltése
              if (vm.formModel.InpaymentDate || vm.formModel.InpaymentDate !== '') {
                vm.formModel.CorrectionalFactor = new Date(vm.formModel.InpaymentDate).getDate() <= 10 ? -1 : 0;

                //szerződés kezdete óta eltelt hónapok száma
                var dateOfContract = new Date(vm.formModel.DateOfContract);
                var inpaymentDate = new Date(vm.formModel.InpaymentDate);

                var diffMonths = (inpaymentDate.getFullYear() - dateOfContract.getFullYear() - 1) * 12;
                // JS-nek januar:0, ..., december: 11
                diffMonths -= 11 - dateOfContract.getMonth();
                diffMonths += inpaymentDate.getMonth();

                vm.formModel.PassedMonths = diffMonths + vm.formModel.CorrectionalFactor;

                //kalkulált mezők újraszámolása
                calculateOnInpaymentDateChange(vm.formModel.InpaymentDate, vm.formModel);
              }
            });
        },
        Benefit: function() {
          //kalkulált mezők újraszámolása
          calculateOnBenefitChange(vm.formModel.Benefit, vm.formModel);
        },
        //},
        //"OptBalancePrincipal": function (selectedItem, p2, p3) {
        //    p3.model.CapitalDiscount = calculateCapitalDiscount(selectedItem, p3.model.Benefit);
        //},
        //"AccPrincipal": function (selectedItem, p2, p3) {
        //    if (p3.model.ExtraInpayment) {
        //        p3.model.OptPayPrincipal = calculateOptPayPrincipal(selectedItem, p3.model.Advance, p3.model.MonthlyPrincipal, p3.model.CorrectionalFactor);
        //    }
        //},
        //"MonthlyPrincipal": function (selectedItem, p2, p3) {
        //    if (p3.model.ExtraInpayment) {
        //        p3.model.OptPayPrincipal = calculateOptPayPrincipal(p3.model.AccPrincipal, p3.model.Advance, selectedItem, p3.model.CorrectionalFactor);
        //    }
        //},
        //"AccInterest": function (selectedItem, p2, p3) {
        //    if (p3.model.ExtraInpayment) {
        //        p3.model.OptPayInterest = calculateOptPayInterest(selectedItem, p3.model.MonthlyInterest, p3.model.CorrectionalFactor);
        //    }
        //},
        //"MonthlyInterest": function (selectedItem, p2, p3) {
        //    if (p3.model.ExtraInpayment) {
        //        p3.model.OptPayInterest = calculateOptPayInterest(p3.model.AccInterest, selectedItem, p3.model.CorrectionalFactor);
        //    }
        //},
        //"CorrectionalFactor": function (selectedItem, p2, p3) {
        //    if (p3.model.ExtraInpayment) {
        //        p3.model.OptPayPrincipal = calculateOptPayPrincipal(p3.model.AccPrincipal, p3.model.Advance, p3.model.MonthlyPrincipal, selectedItem);
        //        p3.model.OptPayInterest = calculateOptPayInterest(p3.model.AccInterest, p3.model.MonthlyInterest, selectedItem);
        //    }
        //}
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        //"InpaymentDate": function (selectedItem, p2, p3) {
        //    //Pénzügy év töltése
        //    if (selectedItem && selectedItem.length > 0) {
        //        p3.model.FinancialYear = selectedItem.substring(0, 4);
        //    }
        //    //Korrekciós tényező töltése
        //    if (selectedItem) {
        //        if (selectedItem.substring(5, 7) <= 10) {
        //            p3.model.CorrectionalFactor = -1;
        //        }
        //        else {
        //            p3.model.CorrectionalFactor = 0;
        //        }
        //        //szerződés kezdete óta eltelt hónapok száma
        //        p3.model.PassedMonths = parseInt(p3.model.ModDate.substring(5, 7)) - parseInt(p3.model.DateOfContract.substring(5, 7)) + p3.model.CorrectionalFactor;
        //        //kalkulált mezők újraszámolása
        //        calculateOnInpaymentDateChange(selectedItem, p3.model);
        //    }
        //},
        //"Benefit": function (selectedItem, p2, p3) {
        //    //kalkulált mezők újraszámolása
        //    calculateOnBenefitChange(selectedItem, p3.model);
        //}
        ////},
        ////"OptBalancePrincipal": function (selectedItem, p2, p3) {
        ////    p3.model.CapitalDiscount = calculateCapitalDiscount(selectedItem, p3.model.Benefit);
        ////},
        ////"AccPrincipal": function (selectedItem, p2, p3) {
        ////    if (p3.model.ExtraInpayment) {
        ////        p3.model.OptPayPrincipal = calculateOptPayPrincipal(selectedItem, p3.model.Advance, p3.model.MonthlyPrincipal, p3.model.CorrectionalFactor);
        ////    }
        ////},
        ////"MonthlyPrincipal": function (selectedItem, p2, p3) {
        ////    if (p3.model.ExtraInpayment) {
        ////        p3.model.OptPayPrincipal = calculateOptPayPrincipal(p3.model.AccPrincipal, p3.model.Advance, selectedItem, p3.model.CorrectionalFactor);
        ////    }
        ////},
        ////"AccInterest": function (selectedItem, p2, p3) {
        ////    if (p3.model.ExtraInpayment) {
        ////        p3.model.OptPayInterest = calculateOptPayInterest(selectedItem, p3.model.MonthlyInterest, p3.model.CorrectionalFactor);
        ////    }
        ////},
        ////"MonthlyInterest": function (selectedItem, p2, p3) {
        ////    if (p3.model.ExtraInpayment) {
        ////        p3.model.OptPayInterest = calculateOptPayInterest(p3.model.AccInterest, selectedItem, p3.model.CorrectionalFactor);
        ////    }
        ////},
        ////"CorrectionalFactor": function (selectedItem, p2, p3) {
        ////    if (p3.model.ExtraInpayment) {
        ////        p3.model.OptPayPrincipal = calculateOptPayPrincipal(p3.model.AccPrincipal, p3.model.Advance, p3.model.MonthlyPrincipal, selectedItem);
        ////        p3.model.OptPayInterest = calculateOptPayInterest(p3.model.AccInterest, p3.model.MonthlyInterest, selectedItem);
        ////    }
        ////}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        Benefit: {
          /**
           * @return {boolean}
           */
          FinalPayOffBenefitValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0 && modelValue <= 100;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      var dynamicQueryParameters = {
        DiscountServiceId: function() {
          return [
            {
              key: vm.mainGridItemId,
              text: 'creditContractId',
            },
          ];
        },
        InterestServiceId: function() {
          return [
            {
              key: vm.mainGridItemId,
              text: 'creditContractId',
            },
          ];
        },
      };
      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomClasses(vm.pageModel, customClasses);
      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertParsers(vm.pageModel, parsers);
      InsertFormatters(vm.pageModel, formatters);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFieldsCredit = formlyFormPanelDescriptors.PanelCreditC.FormlyDescriptor;
      vm.formFieldsFinal = formlyFormPanelDescriptors.PanelFinal.FormlyDescriptor;

      function saveItem() {
        $http
          .post('Property/FinalPayOff' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.CreditContractNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      //function calculateCapitalDiscount(optBalancePrincipal, benefit) {
      //    //TODO WMM Rounding hiányzik
      //    return optBalancePrincipal * benefit / 100;
      //};

      ////dto.OptPayPrincipal = (dto.AccPrincipal - dto.Advance + (dto.MonthlyPrincipal * dto.CorrectionalFactor)) ?? 0;
      //function calculateOptPayPrincipal(accPrincipal, advance, monthlyPrincipal, correctionalFactor) {
      //    //TODO WMM Rounding hiányzik
      //    return accPrincipal - advance + (monthlyPrincipal * correctionalFactor);
      //}

      ////dto.OptPayInterest = (dto.AccInterest + (dto.MonthlyInterest * dto.CorrectionalFactor)) ?? 0;
      //function calculateOptPayInterest(accInterest, monthlyInterest, correctionalFactor) {
      //    //TODO WMM Rounding hiányzik
      //    return accInterest + (monthlyInterest * correctionalFactor);
      //}

      //kalkulált értékek frissítése szerkeszthető mezők változása esetén - Benefit, InpaymentDate
      function calculateOnBenefitChange(selectedItem, fields) {
        //TODO WMM hiányzik a round
        fields.CapitalDiscount = (fields.OptBalancePrincipal * selectedItem) / 100;
        if (fields.TypeOfInterest === 'PINFX') {
          fields.PayablePrincipal = fields.OptBalancePrincipal - fields.CapitalDiscount;
          fields.Inpayment = fields.PayablePrincipal + fields.PayableInterest + fields.ActualBalance;
        } else if (fields.TypeOfInterest === 'PINCB') {
          fields.Inpayment = fields.ActualPrincipal - fields.CapitalDiscount + fields.BackInterest;
        }
      }

      function calculateOnInpaymentDateChange(selectedItem, fields) {
        var YM = 12 - parseInt(selectedItem.substring(5, 7)) + fields.CorrectionalFactor;
        fields.ActualPrincipal = fields.CredFwClosingLoan - fields.MonthlyPrincipal * YM;
        // dto.AccPrincipal = (creditContractEntity.Principal1 + dto.PassedMonths * dto.MonthlyPrincipal + dto.Advance)
        fields.AccPrincipal = fields.Principal1 + fields.PassedMonths * fields.MonthlyPrincipal + fields.Advance;
        if (fields.TypeOfInterest === 'PINFX') {
          fields.OptBalancePrincipal = fields.Loan - fields.Advance - fields.OptPayPrincipal;
          fields.CapitalDiscount = (fields.OptBalancePrincipal * fields.Benefit) / 100;
          fields.PayablePrincipal = fields.OptBalancePrincipal - fields.CapitalDiscount;
          fields.Inpayment = fields.PayablePrincipal + fields.PayableInterest + fields.ActualBalance;
          fields.AccInterest = fields.Interest1 + fields.PassedMonths * fields.MonthlyInterest;
        } else if (fields.TypeOfInterest === 'PINCB') {
          fields.OptBalancePrincipal = fields.ActualPrincipal - (fields.AccPrincipal - fields.PaidInPrincipal);
          fields.CapitalDiscount = (fields.OptBalancePrincipal * fields.Benefit) / 100;
          fields.Inpayment = fields.ActualPrincipal - fields.CapitalDiscount + fields.BackInterest;
        }
      }
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('FacilityEditCtrl', [
    '$http',
    '$state',
    '$stateParams',
    'options',
    'AuthService',
    '$scope',
    'UIHelperService',
    function($http, $state, $stateParams, options, authService, $scope, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FacilityEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabFacility',
        disableRunExpression: false,
      };

      vm.UIHelperService = UIHelperService;

      vm.UIHelperService.setDefaultSidebarStatus();
      vm.options = options;
      vm.pageModel = options.pageModel;
      vm.pageModel.Fields.PremiseType.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        '<b>Bérlemény</b> csak abban az esetben jön létre, ha a Helyiség típusa: <b>Bérelhető</b><br>Egyéb esetben a kapcsolódó mezők inaktívak.';
      vm.pageModel.Fields.ObjectName.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Amennyiben nem ír bele egyedi értéket, úgy az objektum címével fog megegyezni:<br><i>(Irányítószám, Település, Kerület, Közterület neve, Közterület jellege, Házszám)</i>';
      vm.pageModel.Fields.PropImmovableName.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Amennyiben nem ír bele egyedi értéket, úgy az ingatlan címével fog megegyezni:<br><i>(Irányítószám, Település, Kerület, Közterület neve, Közterület jellege, Házszám, Lépcsőház)</i>';
      vm.pageModel.Fields.RentableUnitName.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Amennyiben nem ír bele egyedi értéket, úgy a bérlemény címével fog megegyezni:<br><i>(Ország, Irányítószám, Település, Kerület, Közterület neve, Közterület jellege, Házszám, Épület Lépcsőház, Emelet, Ajtó)';
      vm.pageModel.Fields.EffHeadRoom.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Méterben kell megadni. 0-nál nagyobb érték esetén a <i>Légköbméter</i> adatok <br>ebből a mezőből számolódnak. Egyéb esetben a <i>Belmagasságból</i>.';

      vm.isFormReadOnly = $stateParams.isFormReadOnly;
      vm.ObjectType = $stateParams.ObjectType;
      vm.TypeName = $stateParams.Name;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isCreate = $stateParams.isCreate;
      vm.dynamicTabName = 'PGTab' + $stateParams.ObjectType;
      vm.newPremiseCode = newPremiseCode;

      var customExpressionProperties = {
        RentableUnitName: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
        },
        TenType: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
          'templateOptions.required': function() {
            return vm.formModel.PremiseType === 'PRERE';
          },
        },
        BudgetId: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType === 'PRETE';
          },
          'templateOptions.required': function() {
            return (
              !authService?.parameters?.SBBox &&
              (vm.formModel.PremiseType === 'PRERE' || vm.formModel.PremiseType === 'PREOP')
            );
          },
        },
        RentableUnitTopogrNumber: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
        },
        RentableUnitExSystemId: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
        },
        RentableUnitComment: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
        },
        Door: {
          'templateOptions.disabled': function() {
            return vm.formModel.PremiseType !== 'PRERE';
          },
        },
        Floor: {
          'templateOptions.required': function() {
            return vm.formModel.Level === 'PPRBU';
          },
        },
        PremiseCode: {
          'templateOptions.required': function() {
            return !vm.formModel.PREMGE;
          },
          'templateOptions.disabled': function() {
            return vm.formModel.PREMGE;
          },
        },
      };
      var onChangeFunctions = {
        ZoneId: function() {
          SetZoneIdViewComboListFilter();
        },
        Floor: function(selectedItem) {
          if (selectedItem) {
            vm.newPremiseCode();
          }
        },
        PremiseType: function(selectedItem) {
          if (selectedItem?.key === 'PRETE') {
            vm.formModel.BudgetId = null;
          } else if (selectedItem?.key !== 'PRERE') {
            vm.formModel.RentableUnitName = null;
            vm.formModel.TenType = null;
            vm.formModel.RentableUnitTopogrNumber = null;
            vm.formModel.RentableUnitExSystemId = null;
            vm.formModel.RentableUnitComment = null;
            vm.formModel.Door = null;
          }
        },
        RegionCode: function(selectedItem) {
          if (!!selectedItem?.key) {
            vm.formModel.PostCode = vm.formModel.Locality = {
              Text: null,
              Value: null,
            };
          }
        },
      };

      function addressPlaceholder() {
        vm.objectAddress = (
          (!vm.formModel.PostCode.Text?.trim() ? '' : vm.formModel.PostCode.Text?.trim()) +
          (!vm.formModel.Locality.Text?.trim() ? '' : ' ' + vm.formModel.Locality.Text?.trim()) +
          (!vm.formModel.Quarter?.trim() ? '' : ' ' + vm.formModel.Quarter?.trim()) +
          (!vm.formModel.Street?.trim() ? '' : ' ' + vm.formModel.Street?.trim()) +
          (!vm.formModel.StreetChar?.trim() ? '' : ' ' + vm.formModel.StreetChar?.trim()) +
          (!vm.formModel.StreetNumber?.trim() ? '' : ' ' + vm.formModel.StreetNumber?.trim())
        ).trim();
        vm.propImmovableAddress = (
          vm.objectAddress + (!vm.formModel.Stairway?.trim() ? ' ' : ' ' + vm.formModel.Stairway?.trim())
        ).trim();
        vm.rentableUnitAddress = (
          (!vm.formModel.Country?.trim() ? '' : ' ' + vm.formModel.Country?.trim()) +
          ' ' +
          vm.objectAddress +
          (!vm.formModel.Building?.trim() ? '' : ' ' + vm.formModel.Building?.trim()) +
          (!vm.formModel.Stairway?.trim() ? '' : ' ' + vm.formModel.Stairway?.trim()) +
          (!vm.formModel.Floor?.trim() ? '' : ' ' + vm.formModel.Floor?.trim()) +
          (!vm.formModel.Door?.trim() ? '' : ' ' + vm.formModel.Door?.trim())
        ).trim();
        $('[dom-id="' + vm.pageModel.Fields.ObjectName.FormlyFieldDescriptor.templateOptions.DOMId + '"]').attr(
          'placeholder',
          vm.objectAddress
        );
        $('[dom-id="' + vm.pageModel.Fields.PropImmovableName.FormlyFieldDescriptor.templateOptions.DOMId + '"]').attr(
          'placeholder',
          vm.propImmovableAddress
        );
        $('[dom-id="' + vm.pageModel.Fields.RentableUnitName.FormlyFieldDescriptor.templateOptions.DOMId + '"]').attr(
          'placeholder',
          vm.rentableUnitAddress
        );
      }

      var onBlurFunctions = {
        PostCode: function(selectedItem) {
          if (((!!selectedItem && selectedItem.Value) || selectedItem.Text) && vm.postCodeValue !== selectedItem.Value)
            if (selectedItem.GridItem) {
              vm.formModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };
              vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
                selectedItem.GridItem.Locality
              );
              vm.formModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.RegionCode = selectedItem.GridItem.RegionCode;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
              addressPlaceholder();
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Text).then(
                function(result) {
                  var address = result.data.result.Dto;
                  var locality = address.Locality.Value;
                  if (locality) {
                    vm.formModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                    vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
                      locality
                    );
                    vm.formModel.Country = address.Country ? address.Country : '';
                    vm.formModel.Quarter = address.Quarter;
                    vm.formModel.RegionCode = address.RegionCode;
                    vm.formModel.Street = address.Street;
                    vm.formModel.StreetChar = address.StreetChar;
                    addressPlaceholder();
                  }
                },
                function(error) {}
              );
            }
          vm.postCodeValue = vm.formModel.PostCode.Value;
        },
        Door: function(selectedItem) {
          addressPlaceholder();
        },
        Street: function(selectedItem) {
          addressPlaceholder();
        },
        StreetChar: function(selectedItem) {
          addressPlaceholder();
        },
        StreetNumber: function(selectedItem) {
          addressPlaceholder();
        },
        Stairway: function(selectedItem) {
          addressPlaceholder();
        },
        Country: function(selectedItem) {
          addressPlaceholder();
        },
        Building: function(selectedItem) {
          addressPlaceholder();
        },
        Floor: function(selectedItem) {
          addressPlaceholder();
        },
        Country: function(selectedItem) {
          addressPlaceholder();
        },
        Quarter: function(selectedItem) {
          addressPlaceholder();
        },
        Locality: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.formModel.Quarter = selectedItem.GridItem.Quarter;
              vm.formModel.RegionCode = selectedItem.GridItem.RegionCode;
              vm.formModel.Street = selectedItem.GridItem.Street;
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar;
              addressPlaceholder();
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Value).then(
                function(result) {
                  var postcode = result.data.result.Value;
                  if (postcode) {
                    if (
                      !vm.formModel.PostCode ||
                      !vm.formModel.PostCode.Value ||
                      postcode === vm.formModel.PostCode.Value
                    ) {
                      vm.formModel.PostCode = {
                        Text: postcode,
                        Value: postcode,
                      };
                      addressPlaceholder();
                    } else {
                      $http.get('Partner/GetAllLocalities?postcode=' + vm.formModel.PostCode.Value).then(
                        function(result) {
                          var localities = result.data.result.Localities;
                          if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                            vm.formModel.PostCode = {
                              Text: postcode,
                              Value: postcode,
                            };
                            addressPlaceholder();
                          }
                        },
                        function(error) {}
                      );
                    }
                  }
                },
                function(error) {}
              );
            }
          }
        },
      };
      var numericOptions = {
        Northern: {
          decimals: 11,
          format: 'n9',
          max: 90,
          min: -90,
        },
        Eastern: {
          decimals: 11,
          format: 'n9',
          max: 180,
          min: -180,
        },
        RentableSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        FloorSpace: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
        CubicMetre: {
          decimals: 2,
          format: 'n2',
          max: 99999999999999,
          min: 0,
        },
      };
      vm.pageModel = vm.options.pageModel;
      vm.formModel = vm.options.dto;

      vm.zoneId = !!vm.formModel.ZoneId ? vm.formModel.ZoneId : null;
      vm.opUnitId = !!vm.formModel.OpUnitId ? vm.formModel.OpUnitId : null;
      vm.validFrom = !!vm.formModel.ValidFrom
        ? new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase())
        : null;

      if (vm.formModel.Level !== 'PPRBU' && vm.formModel.PREMGE) {
        vm.newPremiseCode();
      }

      vm.formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      SetZoneIdViewComboListFilter();

      vm.RegionCodeWhereCondition = function() {
        return !vm.formModel.RegionCode ? '' : "RegionCode~eq~'" + vm.formModel.RegionCode + "'";
      };

      vm.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.RegionCodeWhereCondition;
      vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.RegionCodeWhereCondition;
      vm.formFields = vm.formlyFormPanelDescriptors.PanelFacility.FormlyDescriptor;

      if (!vm.isView) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      // InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertNumericOptions(vm.pageModel, numericOptions);

      function newPremiseCode() {
        if (vm.formModel.PREMGE) {
          $http({
            method: 'GET',
            url: 'Property/GetNewPremiseCode/',
            params: { propertyId: vm.formModel.PropertyId, floor: vm.formModel.Floor },
          }).then(function successCallback(response) {
            vm.formModel.PremiseCode = response.data.PremiseCode;
          });
        }
      }

      function SetZoneIdViewComboListFilter() {
        if (vm.formModel.ZoneId !== null && typeof vm.formModel.ZoneId !== 'undefined') {
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            zoneId: vm.formModel.ZoneId,
          };
        }
        vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      vm.back = function back() {
        $state.go('Property.PyramidNav');
      };

      vm.save = function save() {
        if (!vm.formModel.ObjectName?.trim()) {
          vm.formModel.ObjectName = vm.objectAddress;
        }
        if (!vm.formModel.PropImmovableName?.trim()) {
          vm.formModel.PropImmovableName = vm.propImmovableAddress;
        }
        if (!vm.formModel.RentableUnitName?.trim()) {
          vm.formModel.RentableUnitName = vm.rentableUnitAddress;
        }
        $http
          .post(`Property/FacilityCreate`, vm.formModel)
          .then(function(postResult) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.PyramidNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';
  module.controller('PropertyUsageEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyUsageEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.save = save;

      //dátum hack, hogy validáció működjön:

      vm.formModel.ValidFrom = moment(vm.formModel.ValidFrom).format(kendo.culture().calendar.patterns.d.toUpperCase());

      if (!!vm.formModel.ValidTo) {
        vm.formModel.ValidTo = moment(vm.formModel.ValidTo).format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.securedProgramId = options.programId;
      vm.securedId = options.id; // Így kell, mivel a duplikálás is ezt az id-t használja. "options.dto.ContractId;" mindig 0
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.getRentableSpace = function() {
        if (moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid()) {
          $http
            .get('Property/PropertyUsageGetRentableSpace', {
              params: {
                validFrom: vm.formModel.ValidFrom,
                validTo: vm.formModel.ValidTo,
                propertyId: vm.formModel.PropertyId,
                propertyUsageId: vm.formModel.PropertyUsageId,
              },
            })
            .then(function(result) {
              vm.formModel.RentableSpace = result.data.dto.RentableSpace;
              vm.formModel.UsableSpace = result.data.dto.UsableSpace;
            });
        } else {
          vm.formModel.RentableSpace = null;
          vm.formModel.UsableSpace = null;
        }
      };

      vm.getPremisesSpace = function() {
        if (
          vm.formModel.Premises?.length > 0 &&
          moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid()
        ) {
          $http
            .get('Property/PropertyUsageGetPremisesSpace', {
              params: {
                validFrom: vm.formModel.ValidFrom,
                validTo: vm.formModel.ValidTo,
                premises: vm.formModel.Premises,
              },
            })
            .then(function(result) {
              vm.formModel.UsedSpace = result.data.dto.UsedSpace;
              recalculatePercent();
            });
        } else {
          //F4 hiba miatt ki kellett kommentelni
          //vm.formModel.UsedSpace = null;
        }
      };

      vm.validConditionFunction = function() {
        let filter = [];
        if (moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid())
          filter.push(
            "ValidFrom~lte~datetime'" + moment(new Date(vm.formModel.ValidFrom)).format('YYYY-MM-DDTHH:mm:ss') + "'"
          );
        filter.push(
          "(ValidTo~isnull~or~ValidTo~gte~'" +
            moment(new Date(vm.formModel.ValidFrom)).format('YYYY-MM-DDTHH:mm:ss') +
            "')"
        );
        return filter.join('~and~');
      };

      function recalculateSpace() {
        vm.formModel.UsedSpace = vm.formModel.RentableSpace * (vm.formModel.UsedPercent / 100);
      }

      function recalculatePercent() {
        vm.formModel.UsedPercent = (vm.formModel.UsedSpace / vm.formModel.RentableSpace) * 100;
      }

      vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Nem kötelező kitölteni.<br/>Üres érték esetén határozatlan idejű a használatba adás.<br/>Ez később módosítható.';

      vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Amennyiben választ ki Helyiség(ek)et,<br/> akkor a <b>Használt terület m2, Használt % </b><br/>mezők töltődnek az alapterületük összegével, és inaktívvá válnak.';

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFieldsPropertyData = formlyFormPanelDescriptors.PanelPropertyData.FormlyDescriptor;
      vm.formFieldsTop = formlyFormPanelDescriptors.PanelPropertyUsageTop.FormlyDescriptor;
      vm.formFieldsLeft = formlyFormPanelDescriptors.PanelPropertyUsageLeft.FormlyDescriptor;
      vm.formFieldsRight = formlyFormPanelDescriptors.PanelPropertyUsageRight.FormlyDescriptor;
      vm.formFieldsBottom = formlyFormPanelDescriptors.PanelPropertyUsageBottom.FormlyDescriptor;

      vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
        'Property/UsablePremiseList';
      vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.options.gridOptions.addtitonalParams = function() {
        return {
          propertyUsageId: vm.EditOrDuplicate == 'Duplicate' ? 0 : vm.formModel.PropertyUsageId,
          rentUnitId: vm.formModel.PropertyId,
          validFrom: vm.formModel.ValidFrom,
          validTo: vm.formModel.ValidTo,
        };
      };

      vm.pageModel.Fields.PartnerTMId.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.validConditionFunction;
      vm.pageModel.Fields.UsagePartners.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.validConditionFunction;

      var onChangeFunctions = {
        ValidFrom: function() {
          if (vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl.$validate();
          }
          vm.getRentableSpace();
        },
        ValidTo: function() {
          if (vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl.$validate();
          }
        },
        PartnerTMId: function(selectedItem, a, b) {
          if (selectedItem && selectedItem.GridItem) {
            vm.formModel.PartnerName = selectedItem.GridItem.Name;
          }
        },
        Premises: function(selectedItem, a, b) {
          console.log(vm.formModel.Premises, selectedItem);
          vm.getPremisesSpace();
        },
        Premises: function(selectedItem, a, b) {
          console.log(vm.formModel.Premises, selectedItem);
          vm.getPremisesSpace();
        },
        UsedSpace: function() {
          recalculatePercent();
        },
        UsedPercent: function() {
          recalculateSpace();
        },
        UsableSpace: function() {
          recalculatePercent();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        PartnerName: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.PartnerTMId?.Value;
          },
        },
        UsedSpace: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.Premises && vm.formModel.Premises.length > 0;
          },
        },
        UsedPercent: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.Premises && vm.formModel.Premises.length > 0;
          },
        },
      };

      if (!(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      var syncValidators = {
        ValidFrom: {
          PartLinkValidFromValidator: function(viewValue, modelValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          PartLinkValidToValidator: function(viewValue, modelValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        UsedSpace: {
          PropertyUsageUsedValidator: function(viewValue, modelValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            return modelValue <= vm.formModel.UsableSpace;
          },
          PropertyUsageDecimalValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var customClasses = {
        InfoText: 'infoText',
      };
      InsertCustomClasses(vm.pageModel, customClasses);

      function save() {
        let url =
          vm.formModel.PropertyUsageId > 0
            ? vm.EditOrDuplicate == 'Edit'
              ? 'Property/PropertyUsageEditRentableUnit'
              : 'Property/PropertyUsageDuplicateRentableUnit'
            : 'Property/PropertyUsageCreateRentableUnit';
        $http
          .post(url, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Property.RentableUnitNav', { id: vm.formModel.PropertyId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      vm.attachDocument = function() {
        var id = vm.formModel.PropertyUsageId;
        dasService.NavigateToDas(vm.pageModel.Messages, 'Property.DasDocumentsNav', 'FlgPropertyUsage', id);
      };
    },
  ]);
})(angular.module('sbProperty'));

(function(module) {
  'use strict';

  module.controller('EquipmentMoveModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'LockService',
    function(mi, $http, fModel, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentMoveModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.messages = fModel.pageModel.Messages;
      vm.labels = fModel.pageModel.Labels;
      vm.actions = fModel.pageModel.Actions;
      vm.premiseId = fModel.premiseId;

      vm.disabled = true;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.inventoryId;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        premiseId: vm.premiseId,
      };

      var onChangeFunctions = {
        MovingDate: function(selectedItem) {
          vm.disabled = vm.formModel.MovingDate && vm.formModel.PremiseId ? false : true;
        },
        PremiseId: function(selectedItem) {
          vm.disabled = selectedItem && vm.formModel.MovingDate ? false : true;
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.save = function() {
        vm.formModel.InventoryId = fModel.inventoryId;
        $http
          .post('Property/UpdateMovedEqData', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

'use strict';

const ParameterNavStateSessionKey = 'SB_PARAMETERNAV_STATE_SESSION_KEY';

function ParameterNavComponent($http, $state, $scope, $uibModal, DasService, WalService, gridService, UIHelperService) {
  var ctrl = this;

  ctrl.UIHelperService = UIHelperService;

  // @Input
  ctrl.options = undefined;

  ctrl.filterOnChangeFunctions = {
    Modul: function() {
      ctrl.parameterGrid.dataSource.read();
    },
  };

  ctrl.$onInit = function $onInit() {
    ctrl.actions = ctrl.options.pageModel.Actions;
    ctrl.headerModel = ctrl.options.dto;
    ctrl.headerFields = GenerateFormlyFormPanelsFromPageModel(ctrl.options.pageModel).PanelParameter.FormlyDescriptor;
    ctrl.parameterGridOptions = gridService.buildKendoConfigForGridModel({
      gridModel: Object.assign(_.cloneDeep(ctrl.options.pageModel.Grids.GridParameter), {
        ControllerMethod: 'Service/ParameterList/',
      }),
      transportData: function() {
        return ctrl.headerModel;
      },
      dataBound: function(event) {
        const grid = event.sender;
        //Ha multiple = 0 elrejtjük a hierarchy ikont
        const items = grid.items();
        items.each(function() {
          var dataItem = grid.dataItem(this);
          if (!dataItem.Multiple) {
            this.cells[0].innerHTML = '';
          }
        });
      },
      selectFunction: function onGridSelectChanged(rowData) {
        ctrl.selectedItem = rowData;
        $scope.$applyAsync();
      },
    });

    InsertOnChangeFunctions(ctrl.options.pageModel, ctrl.filterOnChangeFunctions);
  };

  ctrl.back = function back() {
    $state.go('main');
  };

  ctrl.editItem = function editItem() {
    var modalInstance = $uibModal.open({
      templateUrl: 'App/Service/ParameterEdit.html',
      controller: 'ParameterEditCtrl',
      controllerAs: 'vm',
      size: 'lg',
      backdrop: 'static',
      resolve: {
        options: RouteResolveFunc(
          'Service/ParameterEdit/' + ctrl.selectedItem[ctrl.options.pageModel.Grids['GridParameter'].IdColumn]
        ),
      },
    });

    modalInstance.result.then(function() {
      ctrl.parameterGrid.dataSource.read();
    });
  };

  ctrl.deleteItem = function deleteItem() {
    if (!ctrl.selectedItem) {
      toastr.warning(ctrl.options.pageModel.Messages.NotSelectedItem);
      return;
    }

    let id = ctrl.selectedItem[ctrl.options.pageModel.Grids['GridParameter'].IdColumn];

    bootbox.dialog({
      message: ctrl.options.pageModel.Messages.DeleteDialogConfirmMessage,
      title: ctrl.options.pageModel.Messages.Confirm,
      buttons: {
        cancel: {
          label: ctrl.options.pageModel.Messages.Cancel,
          className: 'btn-default',
          callback: function() {},
        },
        confirm: {
          label: ctrl.options.pageModel.Messages.Ok,
          className: 'btn-primary',
          callback: function() {
            $http.get('Service/ParameterDelete/' + id).then(function() {
              toastr.success(ctrl.options.pageModel.Messages.DeleteSuccessful);
              ctrl.parameterGrid.dataSource.read();
            });
          },
        },
      },
    });
  };

  ctrl.attachDocument = function attachDocument() {
    let id = ctrl.selectedItem && ctrl.selectedItem[ctrl.options.pageModel.Grids['GridParameter'].IdColumn];
    DasService.NavigateToDas(
      ctrl.options.pageModel.Messages,
      'Service.Parameter.ParameterDasDocumentsNav',
      'FlgParameter',
      id
    );
  };
  ctrl.WAL = function WAL() {
    WalService.NavigateToWal('Service', 'ParameterNavWal', 'FlgParameterView');
  };
}

var parameterNavComponentOptions = {
  bindings: {
    options: '<',
  },
  controller: ParameterNavComponent,
  templateUrl: 'App/Service/parameter-nav/parameter-nav/parameternav.component.html',
};

var parameterNavComponentTag = 'sbParameterNav';

'use strict';

var _nextParameterDetailGridId = 0;

function ParameterGridDetailComponent($timeout, gridService) {
  var ctrl = this;
  ctrl.gridId = `sb-parameter-detail-grid-${_nextParameterDetailGridId}`;
  _nextParameterDetailGridId++;

  ctrl.$onChanges = function $onChanges(changes) {
    if (ctrl.parameterId && ctrl.valueGridModel) {
      ctrl.valueGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign(_.cloneDeep(ctrl.valueGridModel), {
          ControllerMethod: `Service/${ctrl.valueGridModel.ControllerMethod}`,
        }),
        transportData: function transportData() {
          return {
            parameterId: ctrl.parameterId,
          };
        },
      });
    }
  };
}

var parameterGridDetailTag = 'sbParameterGridDetail';

var parameterGridDetailOptions = {
  bindings: {
    parameterId: '<',
    valueGridModel: '<',
  },
  templateUrl: 'App/Service/parameter-nav/parameter-detail/parameter-grid-detail.component.html',
  controller: ParameterGridDetailComponent,
};

function serviceRouting() {
  return {
    Service: {
      url: '/service',
      templateUrl: 'App/Service/ServiceLayout.html',
      controller: 'ServiceLayoutCtrl as vm',
      redirectTo: 'Service.Parameter.ParameterNav',
      ncyBreadcrumb: {
        label: 'Szerviz modul',
        parent: 'main',
      },
    },
    'Service.Parameter': {
      url: '/parameter',
      redirectTo: 'Service.Parameter.ParameterNav',
      views: {
        content: {
          templateUrl: 'App/Service/ParameterLayout.html',
          controller: 'ParameterLayoutCtrl as vm',
        },
      },
      ncyBreadcrumb: {
        label: 'Paraméterek',
      },
    },
    'Service.Event': {
      url: '/event',
      redirectTo: 'Service.Event.EventNav',
      views: {
        content: {
          templateUrl: 'App/Service/EventLayout.html',
          controller: 'EventLayoutCtrl as vm',
        },
      },
      ncyBreadcrumb: {
        label: 'Eseménykezelő',
      },
    },
    'Service.Message': {
      url: '/message',
      redirectTo: 'Service.Message.MessageNav',
      views: {
        content: {
          templateUrl: 'App/Service/MessageLayout.html',
          controller: 'MessageLayoutCtrl as vm',
        },
      },
    },
    'Service.User': {
      url: '/user',
      redirectTo: 'Service.User.UserNav',
      views: {
        content: {
          templateUrl: 'App/Service/UserLayout.html',
          controller: 'UserLayoutCtrl as vm',
        },
      },
      ncyBreadcrumb: {
        label: 'Felhasználók',
      },
    },
    'Service.InvCompetence': {
      url: '/invcompetence',
      redirectTo: 'Service.InvCompetence.InvCompetenceNav',
      views: {
        content: {
          templateUrl: 'App/Service/InvCompetenceLayout.html',
          controller: 'InvCompetenceLayoutCtrl as vm',
        },
      },
      ncyBreadcrumb: {
        label: 'Döntési hatáskörök',
      },
    },
    'Service.Parameter.ParameterDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceParameterMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Service.User.UserDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Service.Event.EventNav': {
      url: '/nav',
      params: { module: 'Event', documentEntity: 'event_eventnav' },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'EventMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Event/EventNav.html',
          controller: 'EventNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Event/ListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Emlékeztető navigáció',
      },
    },
    'Service.Event.View': {
      url: '/view/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'EventMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Event/EventEdit.html',
          controller: 'EventEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Event/EventView/', undefined, ['id']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: true,
        },
        backTo: 'Nav',
        documentEntity: 'event_eventnav',
      },
      ncyBreadcrumb: {
        label: 'Emlékeztető megtekintése',
      },
    },
    'Service.Event.EventDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'EventMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Service.Parameter.ParameterNav': {
      url: '/parameter',
      params: {
        module: 'service',
        formMode: 'Nav',
        backState: 'main',
        editState: 'Service.ParameterEdit',
        deleteState: 'Service/ParameterDelete/',
        documentEntity: 'service_parameternav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceParameterMenuCtrl as vm',
        },
        content: {
          template: '<sb-parameter-nav options="wrapper.options"></sb-parameter-nav>',
          controller: 'parameterNavWrapperCtrl as wrapper',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/ParameterListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Paraméterek Navigáció',
      },
    },
    'Service.Parameter.ParameterEdit': {
      url: '/edit/{id:string}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceParameterMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/ParameterEdit.html',
          controller: 'ParameterEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/ParameterEdit/', undefined, ['id']),
      },
      params: {
        formMode: 'Edit',
        subState: 'Service.',
        mainGridIdName: 'ParameterId',
        postUrl: 'Parameter/ParameterEdit',
        backStateAfterSave: 'Service.Parameter.ParameterNav',
        backState: 'Service.Parameter.ParameterNav',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
        documentEntity: 'service_parameteredit',
      },
      ncyBreadcrumb: {
        label: 'Paraméter szerkesztése',
      },
    },
    'Service.User.UserNav': {
      url: '/user',
      params: { module: 'service', documentEntity: 'service_usernav' },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserNav.html',
          controller: 'UserNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Felhasználók Navigáció',
      },
    },
    'Service.User.UserEdit': {
      url: '/useredit/:id/:backstate/',
      params: {
        module: 'service',
        formMode: 'Edit',
        backState: 'Service.User.UserNav',
        backStateGroupNav: 'Service.User.UserGroupNav',
        documentEntity: 'service_useredit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserEdit.html',
          controller: 'UserEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserEdit/', undefined, ['id', 'backstate']),
      },
      ncyBreadcrumb: {
        label: 'Felhasználói adatok módosítása',
      },
    },
    'Service.User.UserGroupNav': {
      url: '/usergroupnav',
      params: { module: 'service', documentEntity: 'service_usergroupnav' },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserGroupNav.html',
          controller: 'UserGroupNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserGroupListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Felhasználói csoportok',
      },
    },
    'Service.User.UserGroupMenuPermissionEdit': {
      url: '/usergroupmenupermissionedit/?{id}',
      params: {
        module: 'service',
        formMode: 'Edit',
        backState: 'Service.User.UserGroupNav',
        documentEntity: 'service_usergroupmenupermissionedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserGroupMenuPermissionEdit.html',
          controller: 'UserGroupMenuPermissionEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserGroupMenuPermissionEdit/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        label: 'Menüjogosultság beállítása',
      },
    },
    'Service.User.UserGroupActionPermissionEdit': {
      url: '/usergroupactionpermissionedit/?{id}',
      params: {
        module: 'service',
        formMode: 'Edit',
        backState: 'Service.User.UserGroupNav',
        documentEntity: 'service_usergroupactionpermissionedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserGroupActionPermissionEdit.html',
          controller: 'UserGroupActionPermissionEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserGroupActionPermissionEdit/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        label: 'Tevékenység-jogosultság beállítása',
      },
    },
    'Service.User.UserMenuPermissionEdit': {
      url: '/usermenupermissionedit/:id/:backstate/:subbackstate/',
      params: {
        module: 'service',
        formMode: 'Edit',
        backState: 'Service.User.UserNav',
        backStateUserMod: 'Service.User.UserEdit',
        documentEntity: 'service_usermenupermissionedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserMenuPermissionEdit.html',
          controller: 'UserMenuPermissionEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserMenuPermissionEdit/', undefined, ['id', 'backstate', 'subbackstate']),
      },
      ncyBreadcrumb: {
        label: 'Menüjogosultság beállítása',
      },
    },
    'Service.User.UserActionPermissionEdit': {
      url: '/useractionpermissionedit/:id/:backstate/:subbackstate/',
      params: {
        module: 'service',
        formMode: 'Edit',
        backState: 'Service.User.UserNav',
        backStateUserMod: 'Service.User.UserEdit',
        documentEntity: 'service_useractionpermissionedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceUserMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/UserActionPermissionEdit.html',
          controller: 'UserActionPermissionEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/UserActionPermissionEdit/', undefined, ['id', 'backstate', 'subbackstate']),
      },
      ncyBreadcrumb: {
        label: 'Tevékenység-jogosultság beállítása',
      },
    },
    'Service.Message.MessagesNav': {
      url: '/messagesnav',
      params: {
        module: 'service',
        formMode: 'Nav',
        backState: 'main',
        editState: 'Messages.MessageEdit',
        showFavouriteMarker: false,
        documentEntity: 'messages_messageedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceMessagesMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/MessagesNav.html',
          controller: 'MessagesNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/MessagesNav/'),
      },
      ncyBreadcrumb: {
        label: 'Üzenőfal',
      },
    },
    'Service.MessageEdit': {
      url: '/messageEdit/?{id}',
      params: {
        formMode: 'Edit',
        backStateAfterSave: 'Messages.MessagesNav',
        backState: 'Messages.MessagesNav',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
        documentEntity: 'messages_messageedit',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceMessagesMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/MessageEdit.html',
          controller: 'MessageEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/EditMessage/', undefined, ['id']),
      },
      ncyBreadcrumb: {
        label: 'Üzenet',
      },
    },
    'Service.User.HistoryNav': {
      url: '/history/:tableId/:idColumn/:ownerId',
      params: {
        module: 'history',
        formMode: 'Nav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceParameterMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/History/HistoryNav.html',
          controller: 'HistoryNavCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveParamFunc('Service/{tableId}ListHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
      },
      ncyBreadcrumb: {
        label: 'Történetiségi adatok',
      },
    },
    'Service.InvCompetence.InvCompetenceNav': {
      url: '/invcompetence',
      params: { module: 'service', documentEntity: 'service_invcompetencenav' },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceInvCompetenceMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/InvCompetenceNav.html',
          controller: 'InvCompetenceNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/InvCompetenceListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Döntési Hatáskörök Navigáció',
      },
    },
    'Service.InvCompetence.InvCompetenceDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceInvCompetenceMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Service.InvCompetence.HistoryNav': {
      url: '/history/:tableId/:idColumn/:ownerId',
      params: {
        module: 'history',
        formMode: 'Nav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ServiceInvCompetenceMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/History/HistoryNav.html',
          controller: 'HistoryNavCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveParamFunc('Service/{tableId}ListHistory/', undefined, ['tableId', 'idColumn', 'ownerId']),
      },
      ncyBreadcrumb: {
        label: 'Történetiségi adatok',
      },
    },
    'Service.Interface': {
      url: '/interface',
      redirectTo: 'Service.Interface.InterfaceNav',
      views: {
        content: {
          templateUrl: 'App/Service/ParameterLayout.html',
          controller: 'ParameterLayoutCtrl as vm',
        },
      },
      ncyBreadcrumb: {
        label: 'Interface',
      },
    },
    'Service.Interface.InterfaceNav': {
      url: '/interfaceNav',
      params: {
        module: 'service',
        formMode: 'Nav',
        documentEntity: 'service_interfacenav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'InterfaceNavMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Service/InterfaceNav.html',
          controller: 'InterfaceNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Service/InterfaceListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Interface kezelői felület',
      },
    },
  };
}

var serviceModule = angular
  .module('sbService', [])
  .component(parameterNavComponentTag, parameterNavComponentOptions)
  .component(parameterGridDetailTag, parameterGridDetailOptions)
  .config([
    '$stateProvider',
    function($stateProvider) {
      let serviceRoutingStates = serviceRouting();

      angular.forEach(serviceRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });
    },
  ]).name;

'use strict';

(function(module) {
  module.controller('parameterNavWrapperCtrl', [
    'options',
    function(options, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'parameterNavWrapperCtrl', stateParams);
      }
      var vm = this;

      vm.options = options;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ServiceParameterMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceParameterMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Service_Parameter_ParameterNav: { icon: 'fa fa-exchange' },
      };

      buildMenu($state, authService, 'Service_Parameter', 'service', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ParameterLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ParameterLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ServiceLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ParameterEditCtrl', [
    '$uibModalInstance',
    '$scope',
    'DasService',
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$window',
    'LockService',
    function(mi, $scope, dasService, options, $http, $state, $stateParams, $window, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ParameterEditCtrl', stateParams);
      }
      var vm = this;

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;

        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.securedProgramId = options.programId;
        vm.securedId = options.id;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        lockService.initiateLock(vm.securedProgramId, vm.securedId);

        vm.cancel = function() {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          mi.dismiss();
        };
        vm.save = function() {
          $http
            .post('Service/ParameterEdit', vm.dataModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' ' + vm.pageModel.Messages.SaveSuccessful);
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              mi.close();
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' ' + vm.pageModel.Messages.SaveFailed);
            });
        };

        vm.getFilter = function() {
          return {
            parameterId: vm.dataModel.ParameterId,
          };
        };

        if (!!vm.pageModel.Grids['GridValueGrid'])
          initMainGrid(vm, 'GridValueGrid', 'Service/ParameterValueList/', function() {}, vm.getFilter);

        //F22 whereCondition:
        if (!!vm.pageModel.Fields.ValueF22) {
          vm.pageModel.Fields.ValueF22.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
            return vm.dataModel.Filter.trim();
          };
          var fs = fieldSetter;
          fs.vm = vm;
          fs.setOnChangeFunction('ValueF22', function(selectedItem) {
            if (vm.dataModel.Type === 1) {
              vm.dataModel.ValueString = selectedItem.Value;
            } else if (vm.dataModel.Type === 2) {
              vm.dataModel.ValueNumber = selectedItem.Value;
            } else if (vm.dataModel.Type === 3) {
              vm.dataModel.ValueDateTime = selectedItem.Value;
            } else if (vm.dataModel.Type === 4) {
              vm.dataModel.ValueBool = selectedItem.Value;
            }
          });
        }
        generateForm(vm);
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.ParameterId;
        dasService.NavigateToDas(vm.messages, 'Service.Parameter.ParameterDasDocumentsNav', 'FlgParameter', id);
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('UserNavCtrl', [
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'DasService',
    function(options, $http, $state, $uibModal, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.module = $state.current.params.module;

      vm.selectedMainGridItemId = 0;
      vm.mainGridIdField = vm.pageModel.Grids['GridUserGrid'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.editUser = editUser;
      vm.createUser = createUser;

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridUserGrid, 'Service/UserList/', function() {
        changeMainGridFilter();
      });
      vm.getSelectedMainGridItemId = function() {
        return {
          UserId: vm.selectedMainGridItemId,
        };
      };

      vm.back = function() {
        $state.go('main');
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the detailGrid //////////////////////////////////
      function changeMainGridFilter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          return;
        }

        console.log('selectedItems[0]: ', selectedItems);
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        //ha nem undefined csak akkor hívja meg
        if (!!vm.detailGrid) {
          vm.detailGrid.dataSource.read();
        }
      }
      function createUser() {
        // open modal
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Service/UserAddModal.html',
          controller: 'UserAddModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Service/UserCreate'),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }
      function editUser() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          console.log('selectedItems: ', selectedItems);
          var gridId = selectedItems[0][vm.mainGridIdField];
          $http({
            method: 'GET',
            url: 'Service/GetUserCheck',
            params: { Userid: gridId },
          }).then(function successCallback(response) {
            if (response !== null) {
              if (response.data['Value']) {
                bootbox.dialog({
                  message: response.data['Value'],
                  title: '',
                  buttons: {
                    confirm: {
                      label: 'Rendben',
                      className: 'btn-primary',
                      callback: function() {},
                    },
                  },
                });
              }
            } else {
            }
            $state.go('Service.User.UserEdit', { id: gridId, backstate: '' });
          });
        }
      }

      vm.SetMenuPermissions = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          $state.go('Service.User.UserMenuPermissionEdit', { id: id, backstate: 'UserNav', subbackstate: 'UserNav' });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      };

      vm.SetActionPermissions = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          $state.go('Service.User.UserActionPermissionEdit', { id: id, backstate: 'UserNav', subbackstate: 'UserNav' });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      };

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        console.log('selectedItems: ', selectedItems);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Service.User.UserDasDocumentsNav', 'FlgUser', id);
      }

      function WAL() {
        walService.NavigateToWal('Service', 'UserNavWal', 'FlgUserView');
      }
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserAddModalCtrl', [
    '$http',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'model',
    function($http, $uibModal, $scope, uibModalInstance, model) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserAddModalCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////

      vm.addUserModel = model.dto;
      vm.pageModel = model.pageModel;
      // vm.messages = model.pageModel.Messages;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        userid: function(selectedItem) {
          vm.addUserModel.userid = vm.addUserModel.userid.toUpperCase();
        },
        password: function(selectedItem) {
          vm.pageModel.Fields.passwordAgain.FormlyFieldDescriptor.formControl.$validate();
        },
        passwordAgain: function(selectedItem) {
          vm.pageModel.Fields.password.FormlyFieldDescriptor.formControl.$validate();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        password: {
          nospecialchar: function(modelValue, viewValue) {
            return modelValue && modelValue.trim() === modelValue;
          },
        },
        passwordAgain: {
          PasswordEqualValidator: function(modelValue, viewValue) {
            return modelValue === vm.addUserModel.password;
          },
        },
        email: {
          email: function(modelValue, viewValue) {
            return sysEmailValidate(modelValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      // vm.pageModel.Fields.Periods.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
      // budgetModifyId: vm.budgetApplyTaskModel.BudgetModifyId,
      // };

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Service/UserCreate', vm.addUserModel)
          .then(function(response) {
            uibModalInstance.close();
          })
          .catch(function() {});
      }

      function cancelItem() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'WalService',
    'DasService',
    'LockService',
    'gridService',
    'HistoryService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      walService,
      dasService,
      lockService,
      gridService,
      HistoryService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.actions = options.pageModel.Actions;
      vm.userHelpDeskRolePageModel = options.userHelpDeskRolePageModel;
      vm.userHelpDeskRoleFormModel = options.userHelpDeskRoleModDto;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.userHelpDeskRoleCheckedIdList = options.userHelpDeskRoleCheckedIdList;
      vm.backstate = options.backstate;

      vm.UIHelperService = UIHelperService;
      vm.activeSubItemTab = 4;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.TMfilterState = true;
      vm.collapseBooleans = {
        partnerDetailsIsCollapsed: false,
        activityIsCollapsed: true,
        permissionIsCollapsed: true,
      };
      vm.activeBooleans = {
        partnerDetailsIsActive: true,
        activityIsActive: false,
        permissionIsActive: false,
      };

      vm.isDmsEnabled =
        AuthService?.getForrasParameterValue('fordas') == '0' && AuthService?.getForrasParameterValue('fordms') == '1';

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      // lockService.initiateLock(vm.securedProgramId, vm.securedId);

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      kendoMSInit('OpUnits');
      kendoMSInit('TreatedOrg');

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelUserMod.FormlyDescriptor;

      var userHelpDeskRoleFormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(
        vm.userHelpDeskRolePageModel
      );
      vm.userHelpDeskRoleFormFields =
        userHelpDeskRoleFormlyFormPanelDescriptors.PanelUserHelpDeskRoleMod.FormlyDescriptor;

      var onChangeFunctions = {
        InvCompId: function(selectedItem) {
          if (!!selectedItem && selectedItem.key !== '') {
            var maxApprovalIndex = selectedItem.extraProperties?.findIndex(function(item) {
              return item.key == 'MaxApproval';
            });
            if ((maxApprovalIndex ?? -1) >= 0) {
              vm.formModel.ApprovalAmount = parseFloat(
                selectedItem.extraProperties[maxApprovalIndex].value.replace(',', '.')
              );
            }
            if (!vm.formModel.ApprovalAmountCurrency || vm.formModel.ApprovalAmountCurrency === '') {
              vm.formModel.ApprovalAmountCurrency = vm.formModel.DefaultCurrencyId;
            }
          } else {
            vm.formModel.ApprovalAmount = null;
          }
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        ApprovalAmountCurrency: {
          'templateOptions.required': function() {
            return !!vm.formModel.InvCompId && vm.formModel.InvCompId.key !== '';
          },
        },
        ApprovalAmount: {
          'templateOptions.required': function() {
            return !!vm.formModel.InvCompId && vm.formModel.InvCompId.key !== '';
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var customExpressionPropertiesHelpDeskRole = {
        UserType: {
          'templateOptions.required': function() {
            return !!vm.checkedGridIds['GridUserHelpDeskRole'] && vm.checkedGridIds['GridUserHelpDeskRole'].length > 0;
          },
        },
        CurrencyId: {
          'templateOptions.required': function() {
            return !!vm.checkedGridIds['GridUserHelpDeskRole'] && vm.checkedGridIds['GridUserHelpDeskRole'].length > 0;
          },
        },
      };
      InsertCustomExpressionProperties(vm.userHelpDeskRolePageModel, customExpressionPropertiesHelpDeskRole);

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Service/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              let result = {
                userid: vm.formModel.userid,
              };
              if (gridModel.Name === 'GridUserSubstitution') {
                result.filterTM = !vm.TMfilterState;
              }
              return result;
            },
          };
        }
      );

      vm.treeTabs = [];

      angular.forEach(vm.pageModel.Tabs, function(value) {
        if (value.Name.indexOf('TreeView') !== -1) {
          vm.treeTabs.push({
            key: value.Name,
            title: value.Title,
            active: false,
            disable: false,
            gridName: value.Name.replace('Tab', ''),
            visible: false,
          });
        }
      });

      vm.subItemTabs = vm.treeTabs.concat(generatedGridTabs.tabs);
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      /*
            if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
                angular.forEach(vm.pageModel.Fields, function (value, key) {
                    value.FormlyFieldDescriptor.templateOptions.disabled = true;
                });
            }*/

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = [];
      vm.firstRunGrid = [];
      vm.checkedGridIds = [];
      vm.allCheck = [];

      angular.forEach(vm.subGrids, function(value, key) {
        if (value !== 'GridUserSubstitution') {
          initGridMultiselect(value);
        }
      });

      function initGridMultiselect(gridName) {
        vm.firstRunGrid[gridName] = true;
        vm.checkedGridIds[gridName] = [];
        vm.selectAllTip[gridName] = 'Összes';
        vm.allCheck[gridName] = false;
        var checkboxColumn = {
          headerTemplate:
            "<input type='checkbox' ng-model='vm.allCheck[\"" +
            gridName +
            "\"]' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip[\"" +
            gridName +
            '"]}}\' />',
          template:
            "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
          width: '24px',
          lockable: false,
        };

        var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
        vm.subGridOptions[gridName].columns.push(checkboxColumn);
        vm.subGridOptions[gridName].dataBound = function() {
          refreshCheckbox(this, gridName, subGridIdField);
        };
        //vm.subGridOptions[gridName].dataSource.schema.model.Id = subGridIdField;

        vm.subGridOptions[gridName].dataBound = function(e) {
          var grid = this;
          //Checked selected row;
          var items = e.sender.items();
          var gridPage = e.sender;
          if (!!items) {
            items.each(function(index) {
              var dataItem = gridPage.dataItem(this);
              if (vm.firstRunGrid[gridName]) {
                dataItem.checked =
                  vm.checkedGridIds[gridName].indexOf(dataItem[subGridIdField]) !== -1 && dataItem.isChecked;
                if (dataItem.isChecked) vm.checkedGridIds[gridName].push(dataItem[subGridIdField]);
              } else {
                dataItem.checked = vm.checkedGridIds[gridName].indexOf(dataItem[subGridIdField]) !== -1;
              }
            });
            if (vm.firstRunGrid[gridName]) {
              getAllCheckedIdFromDB(gridName);
            }
            vm.firstRunGrid[gridName] = false;
          }
          $scope.$applyAsync();
        };
      }

      function manageSelectedIdArray(id, add) {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        if (add) vm.checkedGridIds[gridName].push(id);
        else
          vm.checkedGridIds[gridName] = vm.checkedGridIds[gridName].filter(function(e) {
            return e !== id;
          });
      }

      function getAllIdFromFIC(gridName) {
        var filterString = '';
        if (vm.subGrids[gridName].dataSource.filter() !== undefined) {
          // GRID szűrés
          var filters = vm.subGrids[gridName].dataSource.filter().filters;
          if (!!filters[0].field) {
            for (var i = 0; i < filters.length; i++) {
              filterString += filters[i].field;
              filterString += '~';
              filterString += filters[i].operator;
              filterString += '~';
              filterString += "'" + filters[i].value + "'";
              if (i != filters.length - 1) {
                filterString += '~and~';
              }
            }
          }
        }

        $http
          .get('Service/' + gridName + 'IdsList/', {
            params: { userid: vm.formModel.userid, filter: filterString },
          })
          .then(function(response) {
            vm.checkedGridIds[gridName] = response.data;
            var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
            refreshCheckbox(vm.subGrids[gridName], gridName, subGridIdField);
          });
      }

      function setRequiredHelpDeskRole(gridName) {
        if (gridName === 'GridUserHelpDeskRole') {
          var required =
            !!vm.checkedGridIds['GridUserHelpDeskRole'] && vm.checkedGridIds['GridUserHelpDeskRole'].length > 0;
          vm.userHelpDeskRolePageModel.Fields.UserType.FormlyFieldDescriptor.templateOptions.required = required;
          vm.userHelpDeskRolePageModel.Fields.CurrencyId.FormlyFieldDescriptor.templateOptions.required = required;
        }
      }

      function toggleSelect(event) {
        var checked = event.target.checked;
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
        vm.checkedGridIds[gridName] = [];
        if (!checked) {
          vm.selectAllTip[gridName] = 'Összes';
          refreshCheckbox(vm.subGrids[gridName], gridName, subGridIdField);
        } else {
          vm.selectAllTip[gridName] = 'Egy sem';
          getAllIdFromFIC(gridName);
        }
        setRequiredHelpDeskRole(gridName);
      }

      function selectRow(event, item) {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        if (vm.allCheck[gridName] && !checked) {
          vm.selectAllTip[gridName] = 'Összes';
          vm.allCheck[gridName] = false;
        }
        manageSelectedIdArray(dataItem[subGridIdField], checked);
        setRequiredHelpDeskRole(gridName);
      }

      function refreshCheckbox(grid, gridName, subGridIdField) {
        var view = vm.subGrids[gridName].dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked =
            vm.checkedGridIds[gridName]
              .map(function(id) {
                return `${id}`;
              })
              .indexOf(String(value[subGridIdField])) !== -1;
          if (vm.allCheck[gridName] && !value.checked) {
            vm.selectAllTip[gridName] = 'Összes';
            vm.allCheck[gridName] = false;
          }
        });
        setRequiredHelpDeskRole(gridName);
      }

      function getSelectedIDs() {
        var row = vm.selectedItems;
        if (!row || row.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var ids = [];
        angular.forEach(vm.selectedItems, function(value, key) {
          ids.push(value[vm.subGridIdField]);
        });
        return ids;
      }

      function getAllCheckedIdFromDB(gridName) {
        $http
          .get('Service/GetUserCheckedPermissionsIdList/', {
            params: { userid: vm.formModel.userid, gridName: gridName },
          })
          .then(function(response) {
            vm.checkedGridIds[gridName] = response.data;
            var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
            refreshCheckbox(vm.subGrids[gridName], gridName, subGridIdField);
          });
      }

      vm.getS = function() {
        vm.x = getSelectedIDs();
      };
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      ///////////////////////////////////////////////////////////////////////////////////////
      // TreeView start
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.treeDataSource = [];
      vm.treeOptions = [];
      vm.checkedtreeNodes = [];

      angular.forEach(vm.subItemTabs, function(value, key) {
        if (value.gridName.indexOf('TreeView') !== -1) {
          initTreeView(value.gridName);
        }
      });

      async function initTreeView(gridName) {
        vm.treeDataSource[gridName] = new kendo.data.HierarchicalDataSource({
          sort: [
            { field: 'text', dir: 'asc' },
            { field: 'pos', dir: 'asc' },
          ],
          transport: {
            read: function(options) {
              $.ajax({
                type: 'POST',
                url: 'Service/' + gridName.replace('TreeView', '') + 'List',
                params: { Userid: vm.formModel.userid },
                dataType: 'json',
                cache: false,
                data: { Userid: vm.formModel.userid },
                success: function(result) {
                  options.success(result);
                },
              });
            },
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'hasChildren',
              parentId: 'parentId',
              children: 'items',
              isChecked: 'isChecked',
              isChecked2: 'isChecked2',
              fields: {
                ModelState: { type: 'number' },
                expanded: { type: 'boolean' },
                hasChildren: { type: 'boolean' },
                id: { type: 'number' },
                parentId: { type: 'number' },
                text: { type: 'string' },
                isChecked: { type: 'boolean' },
                isChecked2: { type: 'boolean' },
              },
            },
          },
        });

        vm.treeOptions[gridName] = {
          loadOnDemand: false,
          select: preventSelection,
          check: onCheck,
          checkboxes: {
            checkChildren: false,
            template:
              "# { #<input id='ch_#:item.uid#' ng-model='dataItem.isChecked'  type='checkbox' class='k-checkbox ch'/><label  for='ch_#:item.uid#' class='k-checkbox-label'></label># } #",
          },
          dataBound: function(e) {
            this.updateIndeterminate();
          },
          template:
            "# if(item.hasChildren == true && item.id > 0 && item.id < 1000000) { #<input id='2ch_#:item.uid#'  ng-model='dataItem.isChecked2' type='checkbox' class='k-checkbox ch'><label  for='2ch_#:item.uid#' class='k-checkbox-label'></label># }  # #:item.text || '' # ",

          dataSource: vm.treeDataSource[gridName],
        };
      }

      function preventSelection(e) {
        e.preventDefault();
        setTimeout(function() {
          $(e.node)
            .find('.k-state-focused')
            .removeClass('k-state-focused');
          $(e.node)
            .find('.k-state-selected')
            .removeClass('k-state-selected');
        });
      }
      jQuery.expr[':'].icontains = function(a, i, m) {
        return (
          jQuery(a)
            .text()
            .toLowerCase()
            .indexOf(m[3].toLowerCase()) >= 0
        );
      };

      function getNodeIds(nodes, nodeIdList) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            getNodeIds(nodes[i].children.data(), nodeIdList);
          }
          if (nodes[i].id > 0 && nodes[i].id < 1000000) {
            if (nodes[i].id >= 500000) {
              if (!nodes[i].isChecked2) {
                nodeIdList.push(nodes[i].id);
              }
            } else if (!nodes[i].isChecked) {
              nodeIdList.push(nodes[i].id);
            }
          }
        }
      }

      vm.searchKeyUp = async function() {
        var activeTreeView = vm.subItemTabs[vm.activeSubItemTab].gridName,
          treeView = $('#' + activeTreeView).data('kendoTreeView');
        treeView.dataSource
          .filter({ field: 'text', operator: 'contains', value: vm.searchValue[activeTreeView] })
          .then(function() {
            treeView.updateIndeterminate();
          });
      };

      function checkAllNodeIds(nodes, checkState, treeView, checkedNodes, find = true) {
        if (nodes[0].id >= 500000) {
          nodes[0].isChecked2 = checkState;
        } else if (find) {
          checkedNodes.push(nodes[0].id);
        }
        $('[data-uid="' + nodes[0].uid + '"] :checkbox').each(function() {
          var node = treeView.dataItem($(this));
          if (find || (!!node.id && node.id < 500000 && checkedNodes.indexOf(node.id) > -1)) {
            node.set('checked', checkState);
            node.checked = node.isChecked = node.isChecked2 = checkState;
          }
          if (!!node.id && node.id < 500000 && find) {
            checkedNodes.push(node.id);
          }
        });
      }

      function onCheck(e, tree = null, checked = null) {
        var treeView = this,
          node = e ? [treeView.dataItem(e.node)] : treeView.dataSource.data(),
          checkedNodes = [];
        checked = e ? node[0].checked : checked;
        checkAllNodeIds(node, checked, treeView, checkedNodes);
        checkAllNodeIds(treeView.dataSource.data(), checked, treeView, checkedNodes, false);
        treeView.updateIndeterminate();
        unSelectNodes(treeView);
        $scope.$applyAsync();
      }

      vm.isCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').filter(':checked').length > 0;
      };
      vm.isUnCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').not(':checked').length > 0;
      };

      function unSelectNodes(treeView) {
        $(treeView)
          .find('.k-state-focused')
          .removeClass('k-state-focused');
        $(treeView)
          .find('.k-state-selected')
          .removeClass('k-state-selected');
      }

      ///////////////////////////////////////////////////////////////////////////////////////
      // TreeView end
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.save = function() {
        vm.formModel.userHelpDeskRoleModDto = vm.userHelpDeskRoleFormModel;
        var params = { model: vm.formModel };
        $http
          .post('Service/UserEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);

            if (response) {
              if (response.projectId && response.projectId > 0) {
                $state.go('Service.User.UserEdit', { id: response.projectId });
              } else {
                lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                $state.go('Service.User.UserNav');
              }
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.saveSubItem = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName,
          urlPrefix = gridName,
          checkedIdList;
        if (gridName.indexOf('Grid') === -1) {
          var treeView = $('#' + gridName).data('kendoTreeView');
          checkedIdList = [];
          getNodeIds(treeView.dataSource.data(), checkedIdList);
        } else {
          checkedIdList = vm.checkedGridIds[gridName];
        }

        var params = { model: vm.userHelpDeskRoleFormModel, userid: vm.formModel.userid, checkedIdList: checkedIdList };
        $http
          .post('Service/' + urlPrefix + 'Save', params)
          .then(function(response) {
            if (gridName.indexOf('Grid') === -1) {
              angular.forEach(vm.subItemTabs, function(value, key) {
                if (value.gridName.indexOf('TreeView') !== -1) {
                  var activeTreeView = $('#' + gridName).data('kendoTreeView');
                  if (!!activeTreeView) {
                    activeTreeView.dataSource.read();
                  }
                }
              });
            } else {
              vm.subGrids[gridName].dataSource.read();
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          })

          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.toggleTMFilterState = function() {
        let gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.subGrids[gridName];
        gridRef.dataSource.read();
      };

      vm.createSubItem = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        if (gridName === 'GridUserSubstitution') {
          vm.openSubstitutionModal('Create?userId=' + vm.formModel.userid);
        }
      };

      vm.editSubItem = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.subGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          if (gridName === 'GridUserSubstitution') {
            vm.openSubstitutionModal('Edit?id=' + selectedItems[0].UserSubstitutionId);
          }
        }
      };

      vm.duplicateSubItem = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.subGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          if (gridName === 'GridUserSubstitution') {
            vm.openSubstitutionModal('Duplicate?id=' + selectedItems[0].UserSubstitutionId);
          }
        }
      };

      vm.deleteSubItem = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        let gridRef = vm.subGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }
        var dialogMessage = vm.messages.ConfirmDelete;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.messages.Warning,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Service/UserSubstitutionDelete/?id=' + selectedItems[0].UserSubstitutionId).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  gridRef.dataSource.read();
                });
              },
            },
          },
        });
      };
      vm.openSubstitutionModal = function(url) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Service/UserSubstitutionModal.html',
          controller: 'UserSubstitutionModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Service/UserSubstitution' + url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          let gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
          let gridRef = vm.subGrids[gridName];
          gridRef.dataSource.read();
        });
      };

      vm.SetMenuPermissions = function() {
        $state.go('Service.User.UserMenuPermissionEdit', {
          id: vm.formModel.userid,
          backstate: !!vm.backstate ? vm.backstate : '',
          subbackstate: 'UserMod',
        });
      };

      vm.SetActionPermissions = function() {
        $state.go('Service.User.UserActionPermissionEdit', {
          id: vm.formModel.userid,
          backstate: !!vm.backstate ? vm.backstate : '',
          subbackstate: 'UserMod',
        });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if (vm.backstate === 'GroupNav') {
          $state.go($state.params.backStateGroupNav);
        } else {
          $state.go($state.params.backState);
        }
      };

      vm.attachDocument = function() {
        var id = vm.formModel.userid;
        dasService.NavigateToDas(vm.messages, 'Service.Parameter.ParameterDasDocumentsNav', 'FlgUser', id);
      };
      vm.history = function() {
        var id = vm.formModel.userid;
        HistoryService.NavigateToHistory('FlgUser', id, vm, $state, true);
      };
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'partnerDetailsIsCollapsed':
            vm.activeBooleans['partnerDetailsIsActive'] = true;
            break;
          case 'activityIsCollapsed':
            vm.activeBooleans['activityIsActive'] = true;
            break;
          case 'permissionIsCollapsed':
            vm.activeBooleans['permissionIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserMenuPermissionEditCtrl', [
    '$http',
    'options',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserMenuPermissionEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.backstate = options.backstate;
      vm.subbackstate = options.subbackstate;
      vm.UIHelperService = UIHelperService;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelUserMenuPermissionMod.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // #region TreeView

      // #region TreeView Init
      vm.treeDataSource = [];
      vm.treeOptions = [];
      vm.checkedtreeNodes = [];
      vm.treeViewName = 'TreeView';
      initTreeView(vm.treeViewName);

      function initTreeView(treeName) {
        vm.treeDataSource[treeName] = new kendo.data.HierarchicalDataSource({
          sort: [
            { field: 'text', dir: 'asc' },
            { field: 'pos', dir: 'asc' },
          ],
          transport: {
            read: function(options) {
              $.ajax({
                type: 'POST',
                url: 'Service/UserMenuPremissionTreeList',
                params: { userid: vm.formModel.userid },
                dataType: 'json',
                cache: false,
                data: { userid: vm.formModel.userid },
                success: function(result) {
                  options.success(result);
                },
              });
            },
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'hasChildren',
              parentId: 'parentId',
              children: 'items',
              text: 'text',
              checked: 'checked',
              isDisabled: 'isDisabled',
              isChecked: 'checked',
              fields: {
                expanded: { type: 'boolean' },
                hasChildren: { type: 'boolean' },
                id: { type: 'string' },
                parentId: { type: 'string' },
                text: { type: 'string' },
                pos: { type: 'int' },
                checked: { type: 'boolean' },
                type: { type: 'string' },
                property: { type: 'string' },
                isDisabled: { type: 'boolean' },
              },
            },
          },
        });

        vm.treeOptions[treeName] = {
          loadOnDemand: false,
          select: preventSelection,
          check: onCheck,
          checkboxes: {
            checkChildren: false,
            template:
              "# {  #<input id='checkbox_#:item.uid#' ng-model='dataItem.isChecked' type='checkbox' class='k-checkbox ' nodeType='#:item.type#'/><label  for='checkbox_#:item.uid#' class='k-checkbox-label'></label># } #",
          },
          template: ' #:item.text# <span ng-show="dataItem.isDisabled" class="glyphicon glyphicon-ban-circle"></span> ',

          dataSource: vm.treeDataSource[treeName],
          dragAndDrop: false,
        };
      }
      //#endregion TreeView

      // #region TreeView
      function preventSelection(e) {
        e.preventDefault();
        setTimeout(function() {
          $(e.node)
            .find('.k-state-focused')
            .removeClass('k-state-focused');
          $(e.node)
            .find('.k-state-selected')
            .removeClass('k-state-selected');
        });
      }

      jQuery.expr[':'].icontains = function(a, i, m) {
        return (
          jQuery(a)
            .text()
            .toLowerCase()
            .indexOf(m[3].toLowerCase()) >= 0
        );
      };

      function getNodeIds(nodes, nodeIdList) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            getNodeIds(nodes[i].children.data(), nodeIdList);
          }
          if (nodes[i].isDisabled) nodeIdList.push(nodes[i]);
        }
      }
      vm.searchKeyUp = async function(treeName, event = null) {
        if (!event || event.keyCode === 13) {
          kendo.ui.progress($('#' + treeName + ' .k-group:first'), true);
          setTimeout(function() {
            try {
              var treeView = $('#' + treeName).data('kendoTreeView'),
                searchFilter = [{ field: 'hasChildren', operator: 'eq', value: false }];
              searchFilter.push({ field: 'text', operator: 'contains', value: vm.searchValue[treeName].toLowerCase() });
              var filter = {
                logic: 'and',
                filters: searchFilter,
              };
              treeView.dataSource.filter(filter).then(function() {
                treeView.updateIndeterminate();
              });
            } catch (error) {
              kendo.ui.progress($('#' + treeName + ' .k-group:first'), false);
            }
            kendo.ui.progress($('#' + treeName + ' .k-group:first'), false);
          }, 100);
        }
      };
      function checkAllNodeIds(nodes, checkState, treeView) {
        $('[data-uid="' + nodes[0].uid + '"] :checkbox').each(function() {
          var node = treeView.dataItem($(this));
          node.set('checked', checkState);
          node.checked = checkState;
          node.isChecked = checkState;
        });
      }

      function onCheck(e, tree = null, checked = null) {
        var treeView = this,
          node = e ? [treeView.dataItem(e.node)] : treeView.dataSource.data();
        checked = e ? node[0].checked : checked;
        checkAllNodeIds(node, checked, treeView);
        treeView.updateIndeterminate();
        unSelectNodes(treeView);
      }

      vm.isCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').filter(':checked').length > 0;
      };
      vm.isUnCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').not(':checked').length > 0;
      };
      vm.treeViewNodeDisableChecked = function(treeName, disable) {
        var treeView = $('#' + treeName).data('kendoTreeView'),
          nodes = treeView.dataSource.data();
        vm.treeViewNodeSetisDisable(nodes, disable);
        treeView.updateIndeterminate();
      };
      vm.treeViewNodeSetisDisable = function(nodes, disable) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            vm.treeViewNodeSetisDisable(nodes[i].children.data(), disable);
          }
          if (nodes[i].isChecked && nodes[i].id !== '0' && !nodes[i].id.includes('FmF')) {
            nodes[i].isDisabled = disable;
            nodes[i].set('checked', false);
            nodes[i].checked = false;
            nodes[i].isChecked = false;
          }
        }
      };

      function unSelectNodes(treeView) {
        $(treeView)
          .find('.k-state-focused')
          .removeClass('k-state-focused');
        $(treeView)
          .find('.k-state-selected')
          .removeClass('k-state-selected');
      }
      // #endregion

      vm.save = function() {
        var treeView = $('#TreeView').data('kendoTreeView'),
          nodeIdList = [];
        getNodeIds(treeView.dataSource.data(), nodeIdList);
        var params = { userid: vm.formModel.userid, nodeIdList: nodeIdList };

        $http
          .post('Service/UserMenuPremissionSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            vm.grid.dataSource.read();
          });
      };

      vm.back = function() {
        //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if (vm.subbackstate === 'UserNav') {
          $state.go($state.params.backState);
        } else {
          $state.go($state.params.backStateUserMod, { id: vm.formModel.userid, backstate: vm.backstate });
        }
      };

      vm.attachDocument = function() {
        var id = vm.formModel.userid;
        //dasService.NavigateToDas(vm.messages, 'Service.Parameter.ParameterDasDocumentsNav', 'FlgUser', id);
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserActionPermissionEditCtrl', [
    '$http',
    'options',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserActionPermissionEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.backstate = options.backstate;
      vm.subbackstate = options.subbackstate;
      vm.UIHelperService = UIHelperService;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelUserActionPermissionMod.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // #region TreeView

      // #region TreeView Init
      vm.treeDataSource = [];
      vm.treeOptions = [];
      vm.checkedtreeNodes = [];
      vm.treeViewName = 'TreeView';
      initTreeView(vm.treeViewName);

      function initTreeView(treeName) {
        vm.treeDataSource[treeName] = new kendo.data.HierarchicalDataSource({
          sort: [
            { field: 'text', dir: 'asc' },
            { field: 'pos', dir: 'asc' },
          ],
          transport: {
            read: function(options) {
              $.ajax({
                type: 'POST',
                url: 'Service/UserActionPremissionTreeList',
                params: { userid: vm.formModel.userid },
                dataType: 'json',
                cache: false,
                data: { userid: vm.formModel.userid },
                success: function(result) {
                  options.success(result);
                },
              });
            },
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'hasChildren',
              parentId: 'parentId',
              children: 'items',
              text: 'text',
              checked: 'checked',
              isDisabled: 'isDisabled',
              isChecked: 'checked',
              fields: {
                expanded: { type: 'boolean' },
                hasChildren: { type: 'boolean' },
                id: { type: 'string' },
                parentId: { type: 'string' },
                text: { type: 'string' },
                pos: { type: 'int' },
                checked: { type: 'boolean' },
                type: { type: 'string' },
                property: { type: 'string' },
                isDisabled: { type: 'boolean' },
              },
            },
          },
        });

        vm.treeOptions[treeName] = {
          loadOnDemand: false,
          select: preventSelection,
          check: onCheck,
          checkboxes: {
            checkChildren: false,
            template:
              "# {  #<input id='checkbox_#:item.uid#' ng-model='dataItem.isChecked' type='checkbox' class='k-checkbox ' nodeType='#:item.type#'/><label  for='checkbox_#:item.uid#' class='k-checkbox-label'></label># } #",
          },
          template:
            ' #:item.text# <span ng-show="dataItem.isDisabled && !!dataItem.type " class="glyphicon glyphicon-ban-circle"></span> ',

          dataSource: vm.treeDataSource[treeName],
          dragAndDrop: false,
        };
      }
      //#endregion TreeView

      // #region TreeView
      function preventSelection(e) {
        e.preventDefault();
        setTimeout(function() {
          $(e.node)
            .find('.k-state-focused')
            .removeClass('k-state-focused');
          $(e.node)
            .find('.k-state-selected')
            .removeClass('k-state-selected');
        });
      }

      jQuery.expr[':'].icontains = function(a, i, m) {
        return (
          jQuery(a)
            .text()
            .toLowerCase()
            .indexOf(m[3].toLowerCase()) >= 0
        );
      };

      function getNodeIds(nodes, nodeIdList) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            getNodeIds(nodes[i].children.data(), nodeIdList);
          }
          if (nodes[i].isDisabled && !!nodes[i].type) nodeIdList.push(nodes[i]);
        }
      }
      vm.searchKeyUp = async function(treeName, event = null) {
        if (!event || event.keyCode === 13) {
          kendo.ui.progress($('#' + treeName + ' .k-group:first'), true);
          setTimeout(function() {
            try {
              var treeView = $('#' + treeName).data('kendoTreeView'),
                searchFilter = [{ field: 'hasChildren', operator: 'eq', value: false }];
              searchFilter.push({ field: 'text', operator: 'contains', value: vm.searchValue[treeName].toLowerCase() });
              var filter = {
                logic: 'and',
                filters: searchFilter,
              };
              treeView.dataSource.filter(filter).then(function() {
                treeView.updateIndeterminate();
              });
            } catch (error) {
              kendo.ui.progress($('#' + treeName + ' .k-group:first'), false);
            }
            kendo.ui.progress($('#' + treeName + ' .k-group:first'), false);
          }, 100);
        }
      };

      function checkAllNodeIds(nodes, checkState, treeView) {
        $('[data-uid="' + nodes[0].uid + '"] :checkbox').each(function() {
          var node = treeView.dataItem($(this));
          node.set('checked', checkState);
          node.checked = checkState;
          node.isChecked = checkState;
        });
      }

      function onCheck(e, tree = null, checked = null) {
        var treeView = this,
          node = e ? [treeView.dataItem(e.node)] : treeView.dataSource.data();
        checked = e ? node[0].checked : checked;
        checkAllNodeIds(node, checked, treeView);
        treeView.updateIndeterminate();
        unSelectNodes(treeView);
      }

      vm.isCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').filter(':checked').length > 0;
      };
      vm.isUnCheckedChildrenNode = function(node) {
        return $('[data-uid="' + node.uid + '"] .k-group input[type="checkbox"]').not(':checked').length > 0;
      };
      vm.treeViewNodeDisableChecked = function(treeName, disable) {
        var treeView = $('#' + treeName).data('kendoTreeView'),
          nodes = treeView.dataSource.data();
        vm.treeViewNodeSetisDisable(nodes, disable);
        treeView.updateIndeterminate();
      };
      vm.treeViewNodeSetisDisable = function(nodes, disable) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            vm.treeViewNodeSetisDisable(nodes[i].children.data(), disable);
          }
          if (nodes[i].isChecked && nodes[i].id !== '0' && !nodes[i].id.includes('FmF')) {
            if (!!nodes[i].type) {
              nodes[i].isDisabled = disable;
            }
            nodes[i].set('checked', false);
            nodes[i].checked = false;
            nodes[i].isChecked = false;
          }
        }
      };

      function unSelectNodes(treeView) {
        $(treeView)
          .find('.k-state-focused')
          .removeClass('k-state-focused');
        $(treeView)
          .find('.k-state-selected')
          .removeClass('k-state-selected');
      }
      // #endregion

      vm.save = function() {
        var treeView = $('#TreeView').data('kendoTreeView'),
          nodeIdList = [];
        getNodeIds(treeView.dataSource.data(), nodeIdList);
        var params = { userid: vm.formModel.userid, nodeIdList: nodeIdList };

        $http
          .post('Service/UserActionPremissionSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            vm.grid.dataSource.read();
          });
      };

      vm.back = function() {
        //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if (vm.subbackstate === 'UserNav') {
          $state.go($state.params.backState);
        } else {
          $state.go($state.params.backStateUserMod, { id: vm.formModel.userid, backstate: vm.backstate });
        }
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('UserGroupNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'DasService',
    'UIHelperService',
    function($scope, options, $http, $state, $uibModal, walService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserGroupNavCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.mainGridIdField = vm.pageModel.Grids['GridUserGroup'].IdColumn;
      vm.subGridIdField = vm.pageModel.Grids['GridUserGroupUser'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.selectedMainGridItemId = 0;
      vm.userAddSubItem = userAddSubItem;
      vm.UIHelperService = UIHelperService;

      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridUserGroup, 'Service/UserGroupList/', function() {
        changeMainGridFilter(vm.mainGrid);
      });
      vm.mainGridOptions.autoBind = true;

      vm.subGrid = $('#subGrid').data('kendoGrid');
      vm.getSelectedMainGridItemId = function() {
        return {
          groupid: vm.selectedMainGridItemId,
        };
      };

      // Kendo-grid reference for sub GRID
      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridUserGroupUser,
        'Service/UserGroupUserList/',
        function() {},
        vm.getSelectedMainGridItemId
      );

      // Menu ////////////////////////////////////////////////////////////////////////////////
      vm.back = function() {
        $state.go('main');
      };

      vm.SetMenuPermissions = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          $state.go('Service.User.UserGroupMenuPermissionEdit', { id: id });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      };
      vm.SetActionPermissions = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          $state.go('Service.User.UserGroupActionPermissionEdit', { id: id });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      };
      vm.editSubItem = function() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.subGridIdField] : null;
        if (!!id) {
          $state.go('Service.User.UserEdit', { id: id, backstate: 'GroupNav' });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      };

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Service.User.UserDasDocumentsNav', 'FlgForrasGroups', id);
      }

      function WAL() {
        walService.NavigateToWal('Service', 'UserGroupNavWal', 'FlgForrasGroups');
      }

      function userAddSubItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Service/UserAddToGroupModal.html',
            controller: 'UserAddToGroupModalCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: RouteResolveFunc('Service/UserAddToGroupList/'),
              groupid: function() {
                return vm.selectedMainGridItemId;
              },
            },
            backdrop: 'static',
          });
          modalInstance.result.then(function() {
            vm.subGrid.dataSource.read();
          });
        }
      }

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subgrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        //console.log("selectedMainGridItemId: " + vm.selectedMainGridItemId);
        vm.subGrid.dataSource.read();
      }
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserGroupActionPermissionEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'WalService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      walService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserGroupActionPermissionEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.UIHelperService = UIHelperService;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelUserGroupActionPermissionMod.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // #region TreeView

      // #region TreeView Init

      vm.callProgress = function(
        item,
        callback,
        param1 = null,
        param2 = null,
        param3 = null,
        param4 = null,
        param5 = null
      ) {
        kendo.ui.progress($('#' + item), true);
        setTimeout(function() {
          try {
            callback(param1, param2, param3, param4, param5);
          } catch (error) {
            kendo.ui.progress($('#' + item), false);
          }
          kendo.ui.progress($('#' + item), false);
        }, 100);
      };

      init();

      function init() {
        vm.treeDataSource = [];
        vm.treeOptions = [];
        vm.checkedtreeNodes = [];
        vm.leftTree = 'LeftTree';
        vm.rightTree = 'RightTree';
        initTreeView(vm.leftTree);
        initTreeView(vm.rightTree);
      }
      function initTreeView(treeName) {
        vm.treeDataSource[treeName] = new kendo.data.HierarchicalDataSource({
          sort: [
            { field: 'text', dir: 'asc' },
            { field: 'pos', dir: 'asc' },
          ],
          transport: {
            read: function(options) {
              $.ajax({
                type: 'POST',
                url: 'Service/UserGroupActionPremission' + treeName + 'List',
                params: { groupid: vm.formModel.groupid },
                dataType: 'json',
                cache: false,
                data: { groupid: vm.formModel.groupid },
                success: function(result) {
                  options.success(result);
                },
              }).then(function() {
                if (treeName === vm.rightTree) {
                  vm.searchTextInTreeview('', vm.rightTree, false);
                }
              });
            },
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'hasChildren',
              parentId: 'parentId',
              children: 'items',
              text: 'text',
              checked: 'checked',
              fields: {
                expanded: { type: 'boolean' },
                hasChildren: { type: 'boolean' },
                id: { type: 'string' },
                parentId: { type: 'string' },
                text: { type: 'string' },
                pos: { type: 'int' },
                checked: { type: 'boolean' },
                type: { type: 'string' },
                property: { type: 'string' },
                isDisabled: { type: 'boolean' },
              },
            },
          },
        });

        vm.treeOptions[treeName] = {
          autoBind: true,
          loadOnDemand: false,
          select: preventSelection,
          check: onCheck,
          checkboxes: {
            checkChildren: false,
            template:
              "# {  #<input id='checkbox_#:item.uid#' ng-model='dataItem.isChecked' type='checkbox' class='k-checkbox' nodeType='#:item.type#' nodeType='#:item.type#'/><label  for='checkbox_#:item.uid#' class='k-checkbox-label'></label># } #",
          },
          template: ' #:item.text # ',

          dataSource: vm.treeDataSource[treeName],
          dragAndDrop: true,
          drop: onDrop,
          treeName: treeName,
        };
      }
      //#endregion TreeView

      // #region TreeView
      function preventSelection(e) {
        e.preventDefault();
        setTimeout(function() {
          $(e.node)
            .find('.k-state-focused')
            .removeClass('k-state-focused');
          $(e.node)
            .find('.k-state-selected')
            .removeClass('k-state-selected');
        });
        e.node.checked = !$(e.node)
          .find(':checkbox')
          .prop('checked');
        $(e.node)
          .find(':checkbox')
          .prop('checked', e.node.checked);
        vm.updateIndeterminate(e.sender.options.treeName);
      }

      jQuery.expr[':'].icontains = function(a, i, m) {
        return (
          jQuery(a)
            .text()
            .toLowerCase()
            .indexOf(m[3].toLowerCase()) >= 0
        );
      };

      function onDrop(e) {
        var sourceTreeName = e.sender.element[0].id,
          destinationTreeName;
        if ($(e.destinationNode).closest('div.k-treeview')[0]) {
          destinationTreeName = $(e.destinationNode).closest('div.k-treeview')[0].id;
        }
        var node = $('#' + sourceTreeName)
          .data('kendoTreeView')
          .dataItem(e.sourceNode);
        if (sourceTreeName === vm.rightTree && destinationTreeName !== vm.rightTree) {
          //vm.rightTreeRemoveNodes(node);
          vm.rightTreeRemoveNodes();
        } else if (destinationTreeName === vm.rightTree && sourceTreeName === vm.leftTree) {
          //vm.rightTreeAddNodes(node);
          vm.rightTreeAddNodes();
        }
        e.setValid(false);
      }

      function getNodeIds(nodes, nodeIdList) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            getNodeIds(nodes[i].children.data(), nodeIdList);
          }
          if (!!nodes[i].type && !nodes[i].isDisabled) {
            var savedNode = angular.copy(nodes[i]);
            savedNode.items = null;
            nodeIdList.push(savedNode);
          }
        }
      }

      vm.searchKeyUp = async function(treeName, event = null) {
        if (!event || event.keyCode === 13) {
          var tree = treeName,
            searchText = vm.searchValue[treeName].toLowerCase();
          vm.callProgress(treeName, vm.searchTextInTreeview, searchText, tree);
        }
      };

      vm.searchTextInTreeview = function(searchText, treeName) {
        var treeView = $('#' + treeName).data('kendoTreeView');

        $('#' + treeName + ' .k-group .k-group .k-in')
          .closest('li')
          .css('display', 'none');
        $('#' + treeName + ' .k-group')
          .closest('li')
          .css('display', 'none');
        if (searchText !== '') {
          searchText = ':not(:has(.k-item)) :icontains(' + searchText + ')';
          $('#' + treeName + ' .k-item' + searchText).each(function() {
            var node = treeView.dataItem($(this));
            if (!node.isDisabled) {
              $(this)
                .parents('ul, li')
                .each(function() {
                  $(this).show();
                });
            }
          });
        } else {
          $('#' + treeName + ' .k-item ').each(function() {
            var node = treeView.dataItem($(this));
            if (!node.isDisabled) {
              $(this).show();
            }
          });
        }
      };

      vm.rightTreeRemoveNodes = async function(node = null) {
        vm.callProgress(vm.rightTree, vm.rightTreeRemoveNodesRunning, node, $scope);
      };

      vm.rightTreeRemoveNodesRunning = function(node = null) {
        var treeName = '',
          dropped = node,
          treeView = $('#' + vm.rightTree).data('kendoTreeView');
        if (dropped) {
          node = [node];
        } else {
          treeName = vm.rightTree;
        }
        removeAllNodeIds(node, treeName, dropped);
        $scope.$digest();
        vm.searchValue[vm.rightTree] = '';
        vm.searchTextInTreeview(vm.searchValue[vm.rightTree], vm.rightTree, false);
        vm.updateIndeterminate(vm.rightTree);
      };

      vm.rightTreeAddNodes = function(node = null) {
        vm.callProgress(vm.rightTree, vm.rightTreeAddNodesRunning, node);
      };

      vm.rightTreeAddNodesRunning = function(node = null) {
        var treeView = $('#' + vm.leftTree).data('kendoTreeView'),
          dropped = node,
          rightTreeView = $('#' + vm.rightTree).data('kendoTreeView'),
          allChecked = [];
        node = dropped ? [node] : treeView.dataSource.view();
        allChecked = $('#' + vm.leftTree + ' :checkbox')
          .filter(function() {
            return this.indeterminate || this.checked;
          })
          .map(function() {
            var node = treeView.dataItem($(this));
            return node.id + '|' + node.parentId + '|' + node.property;
          });

        $('#' + vm.rightTree + ' :checkbox').each(function() {
          var rightNode = rightTreeView.dataItem($(this));
          if (
            !!rightNode.id &&
            jQuery.inArray(rightNode.id + '|' + rightNode.parentId + '|' + rightNode.property, allChecked) > -1
          ) {
            rightNode.isDisabled = false;
            $(this).css('display', '');
          }
        });
        $scope.$digest();
        vm.searchTextInTreeview('', vm.rightTree, false);
        checkAllNodeIds(treeView.dataSource.view(), false, treeView);
        vm.updateIndeterminate(vm.leftTree);
      };

      function checkAllNodeIds(nodes, checkState, treeView) {
        $('[data-uid="' + nodes[0].uid + '"]  .k-item:not(:has(".k-item"))').each(function() {
          var existsNone = false;
          $(this)
            .parents('.k-item')
            .each(function() {
              if (!existsNone) {
                if ($(this).css('display') === 'none') {
                  existsNone = true;
                  return false;
                }
              }
            });
          if (!existsNone && $(this).css('display') !== '' && $(this).css('display') !== 'none') {
            $(this)
              .find(':checkbox')
              .prop('checked', checkState);
            $(this)
              .find(':checkbox')
              .prop('indeterminate', false);
          }
        });
      }

      function removeAllNodeIds(nodes, treeName = '', dropped = false) {
        var findId = treeName == '' ? '[data-uid="' + nodes[0].uid + '"] ' : '#' + treeName + ' ',
          treeView = $('#' + treeName).data('kendoTreeView');

        $(findId + ' :checkbox')
          .filter(':checked')
          .closest('.k-item')
          .each(function() {
            var node = treeView.dataItem($(this));
            if (node.id !== '0') {
              node.isDisabled = true;
              $(this).css('display', 'none');
            }
          });
      }

      vm.updateIndeterminate = function(treeName) {
        var check = [],
          uncheck = [];
        $('#' + treeName + ' .k-item:not([style*="display: none;"]):not(:has(".k-item"))').each(function() {
          if (
            $(this)
              .find('input:checkbox:first')
              .prop('checked')
          ) {
            var parentNode = $(this).parents('.k-item:first');
            while (jQuery.inArray(parentNode.attr('data-uid'), check) < 0) {
              check.push(parentNode.attr('data-uid'));
              parentNode = $(parentNode).parents('.k-item:first');
            }
          } else {
            var parentNode = $(this).parents('.k-item:first');
            while (jQuery.inArray(parentNode.attr('data-uid'), uncheck) < 0) {
              uncheck.push(parentNode.attr('data-uid'));
              parentNode = parentNode.parents('.k-item:first');
            }
          }
        });
        $('#' + treeName + ' .k-item:not([style*="display: none;"]):has(".k-item")')
          .find('input:checkbox:first')
          .each(function() {
            var nodeuid = $(this)
              .attr('id')
              .replace('checkbox_', '');
            var isChecked = jQuery.inArray(nodeuid, check) > -1;
            var isUnChecked = jQuery.inArray(nodeuid, uncheck) > -1;
            if (isChecked && isUnChecked) {
              $(this).prop('indeterminate', true);
              $(this).prop('checked', false);
            } else if (isChecked) {
              $(this).prop('indeterminate', false);
              $(this).prop('checked', true);
            } else {
              $(this).prop('indeterminate', false);
              $(this).prop('checked', false);
            }
          });
      };
      function onCheck(e, tree = null, checked = null) {
        e.preventDefault();
        var treeView = e.sender,
          node = e ? [treeView.dataItem(e.node)] : treeView.dataSource.data();
        checked = e ? node[0].checked : checked;
        checkAllNodeIds(node, checked, treeView);
        vm.updateIndeterminate(treeView.options.treeName);
        unSelectNodes(treeView);
      }

      function unSelectNodes(treeView) {
        $(treeView)
          .find('.k-state-focused')
          .removeClass('k-state-focused');
        $(treeView)
          .find('.k-state-selected')
          .removeClass('k-state-selected');
      }
      // #endregion

      vm.save = function() {
        var treeView = $('#RightTree').data('kendoTreeView'),
          nodeIdList = [];
        getNodeIds(treeView.dataSource.data(), nodeIdList);
        var params = { groupid: vm.formModel.groupid, nodeIdList: nodeIdList };

        $http
          .post('Service/UserGroupActionPremissionSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.treeDataSource[vm.rightTree].read();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($state.params.backState);
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserGroupMenuPermissionEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'WalService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      walService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserGroupMenuPermissionEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.UIHelperService = UIHelperService;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelUserGroupMenuPermissionMod.FormlyDescriptor;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      ///////////////////////////////////////////////////////////////////////////////////////
      // TreeView start
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.treeDataSource = [];
      vm.treeOptions = [];
      vm.checkedtreeNodes = [];

      vm.leftTree = 'LeftTree';
      vm.rightTree = 'RightTree';
      initTreeView(vm.leftTree);
      initTreeView(vm.rightTree);

      function initTreeView(treeName) {
        vm.treeDataSource[treeName] = new kendo.data.HierarchicalDataSource({
          sort: [
            { field: 'text', dir: 'asc' },
            { field: 'pos', dir: 'asc' },
          ],
          transport: {
            read: function(options) {
              $.ajax({
                type: 'POST',
                url: 'Service/UserGroupMenuPremission' + treeName + 'List',
                params: { groupid: vm.formModel.groupid },
                dataType: 'json',
                cache: false,
                data: { groupid: vm.formModel.groupid },
                success: function(result) {
                  options.success(result);
                },
              })
                .then(function() {
                  vm.searchTextInTreeview('', treeName);
                })
                .then(function() {
                  if (treeName === vm.rightTree) {
                    enableLoadedNodes(vm.rightTree);
                  }
                });
            },
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'hasChildren',
              parentId: 'parentId',
              children: 'items',
              text: 'text',
              pos: 'pos',
              expanded: 'expanded',
              checked: 'isChecked',
              fields: {
                expanded: { type: 'boolean' },
                hasChildren: { type: 'boolean' },
                id: { type: 'string' },
                parentId: { type: 'string' },
                text: { type: 'string' },
                pos: { type: 'int' },
                checked: { type: 'boolean' },
                isChecked: { type: 'boolean' },
                isDisabled: { type: 'boolean' },
              },
            },
          },
        });

        vm.treeOptions[treeName] = {
          autoBind: true,
          loadOnDemand: false,
          select: preventSelection,
          check: onCheck,
          checkboxes: {
            checkChildren: false,
            template:
              "# {  #<input id='checkbox_#:item.uid#' ng-model='dataItem.isChecked'  type='checkbox' class='k-checkbox' nodeType='#:item.type#'/><label  for='checkbox_#:item.uid#' class='k-checkbox-label'></label># } #",
          },
          template: ' #:item.text # ',

          dataSource: vm.treeDataSource[treeName],
          dragAndDrop: true,
          drop: onDrop,
        };
      }

      function preventSelection(e) {
        e.preventDefault();
        setTimeout(function() {
          $(e.node)
            .find('.k-state-focused')
            .removeClass('k-state-focused');
          $(e.node)
            .find('.k-state-selected')
            .removeClass('k-state-selected');
        });
      }
      jQuery.expr[':'].icontains = function(a, i, m) {
        return (
          jQuery(a)
            .text()
            .toLowerCase()
            .indexOf(m[3].toLowerCase()) >= 0
        );
      };

      function onDrop(e) {
        var sourceTreeName = e.sender.element[0].id,
          destinationTreeName;
        if ($(e.destinationNode).closest('div.k-treeview')[0]) {
          destinationTreeName = $(e.destinationNode).closest('div.k-treeview')[0].id;
        }
        /*
        var node = $('#' + sourceTreeName)
          .data('kendoTreeView')
          .dataItem(e.sourceNode);
          */
        if (sourceTreeName === vm.rightTree && destinationTreeName !== vm.rightTree) {
          //vm.rightTreeRemoveNodes(node);
          vm.rightTreeRemoveNodes();
        } else if (destinationTreeName === vm.rightTree && sourceTreeName === vm.leftTree) {
          //vm.rightTreeAddNodes(node);
          vm.rightTreeAddNodes();
        }
        e.setValid(false);
      }

      function getNodeIds(nodes, nodeIdList) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            getNodeIds(nodes[i].children.data(), nodeIdList);
          }
          if (!!nodes[i].id && nodes[i].id !== '0' && !nodes[i].id.includes('FmF') && !nodes[i].isDisabled) {
            var savedNode = angular.copy(nodes[i]);
            savedNode.items = null;
            nodeIdList.push(savedNode);
          }
        }
      }

      vm.searchKeyUp = async function(treeName, event = null) {
        if (!event || event.keyCode === 13) {
          var tree = treeName,
            searchText = vm.searchValue[treeName].toLowerCase();
          vm.callProgress(treeName, vm.searchTextInTreeview, searchText, tree);
        }
      };

      vm.searchTextInTreeview = async function(searchText, treeName) {
        var treeView = $('#' + treeName).data('kendoTreeView'),
          searchFilter = [{ field: 'isDisabled', operator: 'neq', value: true }];
        if (searchText) {
          searchFilter.push({ field: 'text', operator: 'contains', value: searchText });
        }

        var filter = {
          logic: 'and',
          filters: searchFilter,
        };
        await treeView.dataSource.filter(filter);
        treeView.updateIndeterminate();
      };

      vm.rightTreeRemoveNodes = function(node = null) {
        vm.callProgress(vm.rightTree, vm.rightTreeRemoveNodesRunning, node);
      };

      vm.rightTreeRemoveNodesRunning = function(node = null) {
        var treeView = $('#' + vm.rightTree).data('kendoTreeView'),
          dropped = node;
        if (dropped) {
          node = [node];
        } else {
          node = treeView.dataSource.view();
        }
        removeAllNodeIds(node, treeView, dropped);
        vm.searchTextInTreeview('', vm.rightTree);
      };

      vm.callProgress = async function(item, callback) {
        kendo.ui.progress($('#' + item), true);
        await callback(arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
        $scope.$digest();
        setTimeout(function() {
          kendo.ui.progress($('#' + item), false);
        }, 0);
      };

      vm.rightTreeAddNodes = function(node = null) {
        vm.callProgress(vm.rightTree, vm.rightTreeAddNodesRunning, node);
      };

      vm.rightTreeAddNodesRunning = function(node = null) {
        var treeView = $('#' + vm.leftTree).data('kendoTreeView'),
          dropped = node,
          rightTreeView = $('#' + vm.rightTree).data('kendoTreeView');
        node = dropped ? [node] : treeView.dataSource.view();
        $('#' + vm.leftTree + ' :checkbox')
          .filter(':checked')
          .closest('.k-item')
          .each(function() {
            var node = treeView.dataItem($(this));
            if (!!node && !!node.id) {
              var rightNode = rightTreeView.dataSource.get(node.id);
              if (!!rightNode) {
                rightNode.isDisabled = false;
              }
            }
          });
        vm.searchTextInTreeview('', vm.rightTree);
        checkAllNodeIds(treeView.dataSource.view(), false, treeView);
        treeView.updateIndeterminate();
      };

      function checkAllNodeIds(nodes, checkState, treeView) {
        $('[data-uid="' + nodes[0].uid + '"] :checkbox').each(function() {
          var node = treeView.dataItem($(this));
          node.set('checked', checkState);
          node.checked = checkState;
          node.isChecked = checkState;
        });
      }

      vm.enableLoadedNodes = function(treeName) {
        $('#' + treeName + ' .k-item').each(function() {
          var node = $('#' + treeName)
            .data('kendoTreeView')
            .dataItem($(this));
          if (node.loaded) {
            node.isDisabled = false;
          }
        });
      };

      function removeAllNodeIds(nodes, treeview, dropped = false) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasChildren) {
            removeAllNodeIds(nodes[i].children.view(), treeview, dropped);
          }
          if ((nodes[i].checked || nodes[i].isChecked || dropped) && nodes[i].id !== '0') {
            nodes[i].isDisabled = true;
          }
        }
      }

      function onCheck(e, tree = null, checked = null) {
        var treeView = this,
          node = e ? [treeView.dataItem(e.node)] : treeView.dataSource.data();
        checked = e ? node[0].checked : checked;
        checkAllNodeIds(node, checked, treeView);
        $scope.$applyAsync();
        {
          treeView.updateIndeterminate();
        }
        unSelectNodes(treeView);
      }

      function unSelectNodes(treeView) {
        $(treeView)
          .find('.k-state-focused')
          .removeClass('k-state-focused');
        $(treeView)
          .find('.k-state-selected')
          .removeClass('k-state-selected');
      }

      ///////////////////////////////////////////////////////////////////////////////////////
      // TreeView end
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.save = function() {
        var treeView = $('#' + vm.rightTree).data('kendoTreeView'),
          nodeIdList = [];
        getNodeIds(treeView.dataSource.data(), nodeIdList);
        var params = { groupid: vm.formModel.groupid, nodeIdList: nodeIdList };

        $http
          .post('Service/UserGroupMenuPremissionSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.treeDataSource[vm.rightTree].read().then(function() {});
            //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($state.params.backState);
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserAddToGroupModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'groupid',
    function(uibModalInstance, $http, fModel, $state, $stateParams, AuthService, $scope, groupid) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserAddToGroupModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.groupid = groupid;
      vm.messages = fModel.pageModel.Messages;

      vm.gridIdField = vm.pageModel.Grids['GridUserAddToGroup'].IdColumn;
      var resultGridOptions = getGridOptions(
        vm.pageModel.Grids.GridUserAddToGroup,
        'Service/UserWithoutGroupList/',
        function() {},
        function() {
          return {
            groupid: vm.groupid,
          };
        }
      );
      resultGridOptions.autoBind = true;

      vm.gridOptions = angular.copy(resultGridOptions);

      vm.grid = $('#GridUserAddToGroup').data('kendoGrid');

      vm.gridOptions.autoBind = true;

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////

      //vm.toggleSelect = toggleSelect;
      //vm.selectRow = selectRow;

      vm.selectAllTip = [];
      vm.firstRunGrid = [];
      vm.checkedGridIds = [];
      vm.allCheck = [];

      vm.getGridOptions = function() {
        return vm.gridOptions;
      };
      vm.getGridName = function() {
        return 'GridUserAddToGroup';
      };
      vm.getGridIdField = function() {
        return vm.gridIdField;
      };
      vm.getGrid = function() {
        return vm.grid;
      };

      initGridMultiselect(vm.getGridName());

      function initGridMultiselect(gridName) {
        vm.firstRunGrid[gridName] = true;
        vm.checkedGridIds[gridName] = [];
        vm.selectAllTip[gridName] = 'Összes';
        vm.allCheck[gridName] = false;
        var checkboxColumn = {
          headerTemplate: 'Hozzáadás',
          template:
            "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
          width: '60px',
          lockable: false,
        };

        var gridIdField = vm.getGridIdField();
        var gridOptions = vm.getGridOptions();
        gridOptions.columns.push(checkboxColumn);
        gridOptions.dataBound = function() {
          refreshCheckbox(this, gridName, gridIdField);
        };

        gridOptions.dataBound = function(e) {
          var grid = this;
          //Checked selected row;
          var items = e.sender.items();
          var gridPage = e.sender;
          if (!!items) {
            items.each(function(index) {
              var dataItem = gridPage.dataItem(this);
              if (vm.firstRunGrid[gridName]) {
                dataItem.checked =
                  vm.checkedGridIds[gridName].indexOf(dataItem[gridIdField]) !== -1 && dataItem.isChecked;
                if (dataItem.isChecked) vm.checkedGridIds[gridName].push(dataItem[gridIdField]);
              } else {
                dataItem.checked = vm.checkedGridIds[gridName].indexOf(dataItem[gridIdField]) !== -1;
              }
            });
            vm.firstRunGrid[gridName] = false;
          }
          $scope.$applyAsync();
        };
      }

      function manageSelectedIdArray(id, add) {
        var gridName = vm.getGridName();
        if (add) vm.checkedGridIds[gridName].push(id);
        else
          vm.checkedGridIds[gridName] = vm.checkedGridIds[gridName].filter(function(e) {
            return e !== id;
          });
      }

      vm.toggleSelect = function(event) {
        var checked = event.target.checked;
        var gridName = vm.getGridName();
        var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
        vm.checkedGridIds[gridName] = [];
        if (!checked) {
          vm.selectAllTip[gridName] = 'Összes';
          refreshCheckbox(vm.subGrids[gridName], gridName, subGridIdField);
        } else {
          vm.selectAllTip[gridName] = 'Egy sem';
          getAllIdFromFIC(gridName);
        }
      };

      vm.selectRow = function(event, item) {
        var gridName = vm.getGridName();
        var subGridIdField = vm.pageModel.Grids[gridName].IdColumn;
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        if (vm.allCheck[gridName] && !checked) {
          vm.selectAllTip[gridName] = 'Összes';
          vm.allCheck[gridName] = false;
        }
        manageSelectedIdArray(dataItem[subGridIdField], checked);
      };

      function refreshCheckbox(grid, gridName, gridIdField) {
        var view = grid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked =
            vm.checkedGridIds[gridName]
              .map(function(id) {
                return `${id}`;
              })
              .indexOf(String(value[gridIdField])) !== -1;
          if (vm.allCheck[gridName] && !value.checked) {
            vm.selectAllTip[gridName] = 'Összes';
            vm.allCheck[gridName] = false;
          }
        });
      }
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      vm.saveDisabled = function() {
        var gridName = vm.getGridName();
        var checkedIdList = vm.checkedGridIds[gridName];
        return !checkedIdList || checkedIdList.length < 1;
      };

      vm.save = function() {
        var gridName = vm.getGridName();
        var urlPrefix = gridName;

        var checkedIdList = vm.checkedGridIds[gridName];

        if (vm.saveDisabled()) {
          return toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }

        var params = { groupid: groupid, checkedIdList: checkedIdList };
        $http
          .post('Service/UserAddToGroupSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            vm.grid.dataSource.read();
          });
      };

      vm.cancel = function() {
        uibModalInstance.dismiss();
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';
  module.controller('UserSubstitutionModalCtrl', [
    '$http',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'model',
    function($http, $uibModal, $scope, uibModalInstance, model) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserSubstitutionModalCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////

      vm.formModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.actions = model.pageModel.Actions;
      vm.type = 'Create';
      if (vm.formModel.ModelState === 3) {
        vm.pageModel.Labels.LabelTitle.Title = vm.pageModel.Labels.LabelTitleMod.Title;
        vm.type = 'Edit';
      } else if (vm.formModel.ModelState === 4) {
        vm.pageModel.Labels.LabelTitle.Title = vm.pageModel.Labels.LabelTitleDuplicate.Title;
        vm.type = 'Duplicate';
      }

      vm.save = saveItem;
      vm.cancel = cancelItem;

      var onChangeFunctions = {
        userid: function(selectedItem) {
          vm.formModel.userid = vm.formModel.userid.toUpperCase();
        },
        password: function(selectedItem) {
          vm.pageModel.Fields.passwordAgain.FormlyFieldDescriptor.formControl.$validate();
        },
        passwordAgain: function(selectedItem) {
          vm.pageModel.Fields.password.FormlyFieldDescriptor.formControl.$validate();
        },
      };

      var syncValidators = {
        password: {
          nospecialchar: function(modelValue, viewValue) {
            return modelValue && modelValue.trim() === modelValue;
          },
        },
        passwordAgain: {
          PasswordEqualValidator: function(modelValue, viewValue) {
            return modelValue === vm.formModel.password;
          },
        },
        email: {
          email: function(modelValue, viewValue) {
            return sysEmailValidate(modelValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      function saveItem() {
        $http
          .post('Service/UserSubstitution' + vm.type, vm.formModel)
          .then(function(response) {
            uibModalInstance.close();
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ServiceUserMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceUserMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Service_User_UserNav: { icon: 'fa fa-exchange' },
        Service_User_UserGroupNav: { icon: 'fa fa-exchange' },
      };

      buildMenu($state, authService, 'Service_User', 'service', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('MessagesNavCtrl', [
    '$scope',
    'options',
    '$state',
    'MessagesService',
    '$http',
    function($scope, options, $state, MessagesService, $http) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MessagesNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messagesService = MessagesService;

      vm.messagesService.messagesRead();

      vm.back = function() {
        $state.go('main');
      };
      vm.add = function() {
        $state.go('Service.MessageEdit', { id: null });
      };
      vm.edit = function(id) {
        $state.go('Service.MessageEdit', { id: id });
      };
      vm.remove = function(id) {
        var dialogMessage = vm.pageModel.Labels.LabelDelConfirmMessage.Title;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Labels.LabelDelConfirmTitle.Title,
          buttons: {
            cancel: {
              label: vm.pageModel.Labels.LabelCancel.Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Labels.LabelDelOk.Title,
              className: 'btn-primary',
              callback: function() {
                vm.messagesService.remove(id);
              },
            },
          },
        });
      };

      vm.download = function(file) {
        $http
          .post('Document/DocumentDownload', file, {
            responseType: 'arraybuffer',
            transformResponse: function(data) {
              var pdf;
              if (data) {
                pdf = new Blob([data], {
                  type: 'application/pdf',
                });
              }
              return {
                response: pdf,
              };
            },
          })
          .then(function(data, status, headers, config) {
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(data.response, file.DocName);
            } else {
              var fileURL = URL.createObjectURL(data.response);
              var a = document.createElement('a');
              a.href = fileURL;
              a.target = '_blank';
              a.download = file.DocName;
              document.body.appendChild(a);
              a.click();
            }
          })
          .catch(function(data, status, headers, config) {
            //TODO when WS error
          });
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('MessageEditCtrl', [
    '$scope',
    'DasService',
    'options',
    '$http',
    '$state',
    'MessagesService',
    '$uibModal',
    'lodash',
    'LockService',
    function($scope, dasService, options, $http, $state, MessagesService, $uibModal, lodash, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MessageEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.emailModel = options.dto;
      vm.messagesService = MessagesService;

      vm.pageModel.Fields.MessageOpUnitId.FormlyFieldDescriptor.type = 'kendoMS';

      var eventHandlers = {
        Files: {
          onComplete: function(e) {},
          onError: function(e) {},
          onSuccess: function(e) {
            if (e.response) {
              if (e.response.ResultStatus) {
                if (e.operation === 'upload') {
                  if (!vm.emailModel.DocumentDto.UploadedFiles) {
                    vm.emailModel.DocumentDto.UploadedFiles = e.response.FileIdentifiers;
                  } else {
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      vm.emailModel.DocumentDto.UploadedFiles.push({
                        StoredName: value.StoredName,
                        OriginalName: value.OriginalName,
                      });
                    });
                  }
                } else if (e.operation === 'remove') {
                  if (vm.emailModel.DocumentDto.UploadedFiles) {
                    lodash.forEach(e.response.FileIdentifiers, function(fd) {
                      lodash.remove(vm.emailModel.DocumentDto.UploadedFiles, function(uf) {
                        return uf.StoredName === fd.StoredName;
                      });
                    });
                  }
                }
              }
            }
          },
          onRemoveFileFromDb: function(file) {
            if (file) {
              var sf = lodash.findLast(vm.emailModel.DocumentDto.StoredFiles, function(sf) {
                return sf.DocFilesId === file.storedDoc.DocFilesId;
              });
              sf.ToRemove = true;
            }
          },
        },
      };
      var formlyOptions = {
        Files: {
          DocumentDto: 'DocumentDto',
        },
      };

      InsertEventHandlers(vm.pageModel, eventHandlers);
      InsertOptions(vm.pageModel, formlyOptions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.uploadFile = function() {
        var id = 0;
        var entityId = 0;
        var url = 'Document/DocumentEdit';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Document/DocumentEdit.html',
          controller: 'DocumentEditCtrl',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function(data) {
          console.log(data);
        });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Service.MessagesNav');
      };
      vm.save = function() {
        if ($state.params && $state.params.backStateAfterSave) {
          vm.messagesService.save(vm.emailModel, function() {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go($state.params.backStateAfterSave);
          });
        } else {
          vm.messagesService.save(vm.emailModel);
        }
      };

      vm.attachDocument = function() {
        var id = vm.emailModel.MessageId;
        dasService.NavigateToDas(vm.messages, 'Service.ParameterDasDocumentsNav', 'FlgMessage', id);
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ServiceMessagesMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceMessagesMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      buildMenu($state, authService, 'Service_Message', 'service', backMenu).then(function(m) {
        vm.menus = m;
        console.log('vm.menus: ', vm.menus);
      });
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('FavouriteItemsOrderCtrl', [
    '$uibModalInstance',
    '$http',
    '$state',
    '$stateParams',
    'lodash',
    '$scope',
    'FavouriteService',
    function(mi, $http, $state, $stateParams, lodash, $scope, FavouriteService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FavouriteItemsOrderCtrl', stateParams);
      }
      var vm = this;
      vm.saveData = [];
      vm.optionsKey = [];
      vm.favouriteService = FavouriteService;
      var ordered = lodash.orderBy(vm.favouriteService.favourites, ['Number']);
      vm.data = lodash.map(ordered, function(f) {
        return {
          //TODO jelenleg nincs FavouriteId, majd ha lesz, akkor át kell térni annak a használatára
          key: f.Number,
          text: f.ModuleText + ' > ' + f.MenuText,
          extraProperties: f,
        };
      });
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoLB',
          templateOptions: {
            required: true,
            label: '',
            options: FormlyCreateLBOption({
              data: vm.data,
              textField: 'text',
              valueField: 'key',
            }),
            reorder: function(e) {
              var items = e.items[0].parentNode.children;
              var temprows = [];
              for (var i = 0; i < items.length; i++) {
                if (items[i].id === '') {
                  continue;
                }
                if (e.dataItems[0].uid === items[i].id)
                  if (e.offset > 0) temprows[(i + e.offset) * 10 + 2] = items[i];
                  else temprows[(i + e.offset) * 10] = items[i];
                else temprows[i * 10 + 1] = items[i];
              }
              vm.saveData = [];
              if (vm.optionsKey.length < 1) {
                e.sender.dataSource._data.forEach(function(element) {
                  vm.optionsKey[element.uid] = element.key;
                });
              }
              var row = 1;
              temprows.forEach(function(element) {
                items[element.id].innerHTML = items[element.id].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, '');
                vm.saveData[row - 1] = {
                  extraProperties: null,
                  key: vm.optionsKey[items[element.id].id],
                  text: items[element.id].innerHTML,
                  ModelState: 0,
                };
                var number = (row + '.').padEnd(4);
                items[element.id].innerHTML = number + items[element.id].innerHTML;
                row++;
              });
            },
          },
        },
      ];

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.MDSelectorModel = {
        selectedData: '',
      };
      vm.save = function() {
        var newNumber = 1;
        var states = lodash.map(vm.saveData, function(d) {
          var item = lodash.find(vm.favouriteService.favourites, function(f) {
            //TODO jelenleg nincs FavouriteId, majd ha lesz, akkor át kell térni annak a használatára
            return f.Number === d.key;
          });
          item.Number = newNumber++;
          return item;
        });
        vm.favouriteService.updateOrder(states);
        mi.close();
      };
      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('InvCompetenceLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvCompetenceLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('InvCompetenceNavCtrl', [
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'DasService',
    function(options, $http, $state, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvCompetenceNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.attachDocument = attachDocument;
      vm.deleteMainItem = deleteMainItem;
      vm.createMainItem = createMainItem;
      vm.history = history;
      //vm.WAL = WAL;
      vm.module = $state.current.params.module;

      vm.selectedMainGridItemId = 0;
      vm.mainGridIdField = vm.pageModel.Grids['GridInvCompetenceGrid'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.editInvCompetence = editInvCompetence;

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridInvCompetenceGrid,
        'Service/InvCompetenceList/',
        function() {
          changeMainGridFilter();
        }
      );

      vm.back = function() {
        $state.go('main');
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      function changeMainGridFilter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          return;
        }

        console.log('selectedItems[0]: ', selectedItems);
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
      }

      function createMainItem() {
        var url = 'Service/InvCompetenceCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Service/InvCompetenceEdit.html',
          controller: 'InvCompetenceEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function deleteMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem);
          return;
        }
        var id = selectedItems[0][vm.mainGridIdField];

        bootbox.dialog({
          message: vm.pageModel.Messages.DeleteDialogConfirmMessage,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Service/InvCompetenceDelete/' + id).then(function() {
                  toastr.success(vm.pageModel.Messages.DeleteSuccessful);
                  vm.mainGrid.dataSource.read();
                });
              },
            },
          },
        });
      }

      function editInvCompetence() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Service/InvCompetenceEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Service/InvCompetenceEdit.html',
            controller: 'InvCompetenceEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        console.log('selectedItems: ', selectedItems);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(
          vm.messages,
          'Service.InvCompetence.InvCompetenceDasDocumentsNav',
          'FlgInvCompetence',
          id
        );
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgInvCompetence', id, vm, $state, true);
        }
        //HistoryService.NavigateToHistory('FlgInvCompetence', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('InvCompetenceEditCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvCompetenceEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      vm.pageModel.Fields.Level.FormlyFieldDescriptor.templateOptions.disabled = true;

      if (vm.formModel.Level > 9) {
        toastr.error(vm.messages.Level);
      }

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////

      var customClasses = {};
      var formatters = {};
      var parsers = {};
      var numericOptions = {};
      var inputMasks = {};
      var customTypes = {};
      var hideExpressions = {};
      var onChangeFunctions = {};
      var syncValidators = {
        Level: {
          LevelValidator: function(modelValue, viewValue) {
            return modelValue <= 9;
          },
        },
      };

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be run before generating formly descriptors from general field descriptors

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Service/InvCompetenceEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('ServiceInvCompetenceMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceInvCompetenceMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Service_InvCompetence_InvCompetenceNav: { icon: 'fa fa-exchange' },
      };

      buildMenu($state, authService, 'Service_InvCompetence', 'service', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('InterfaceNavCtrl', [
    'options',
    '$http',
    '$state',
    'UIHelperService',
    function(options, $http, $state, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InterfaceNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.interfaceGrid = $('#interfaceGrid').data('kendoGrid');

      vm.filterTable = filterTable;

      vm.back = function() {
        $state.go('main');
      };

      function filterTable() {
        if (!!vm.interfaceGrid) {
          vm.interfaceGrid.dataSource.read();
        } else {
          vm.interfaceGridOptions = getGridOptions(
            options.pageModel.Grids.InterfaceGrid,
            'Service/GetFilteredInterfaceRows/',
            null,
            function() {
              if (
                (!!vm.formModel.TableNameFilter && !!vm.formModel.TableMeta4Filter) ||
                (!vm.formModel.TableNameFilter && !vm.formModel.TableMeta4Filter)
              ) {
                return {
                  tableName: vm.formModel.TableNameFilter,
                  meta4: vm.formModel.TableMeta4Filter,
                };
              }
            }
          );
          vm.interfaceGridOptions.columns.push({
            field: '',
            width: '50px',
            title: 'Funkció',
            template:
              '<button type="button" class="btn btn-default" title="Módosítás" ng-click="vm.getRowId(this)"><i class="glyphicon glyphicon-pencil"></i></button>',
          });
        }
      }

      vm.getRowId = function(selectedRow) {
        var row = selectedRow.dataItem.PackageId;
        $http({
          method: 'GET',
          url: 'Service/ModifySelectedInterfaceRow/',
          params: {
            packageId: row,
          },
        })
          .then(function(response) {
            if (response.data.ResultStatus == true) {
              toastr.success('Sikeresen mentette a módosításokat!');
              vm.interfaceGrid.dataSource.read();
            } else {
              toastr.error(response.data.Errors[0].Message, 'Sikertelen módosítás!');
            }
          })
          .catch(function(response) {
            toastr.error('Hiba történt a mentés során!');
          });
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      var onChangeFunctions = {
        TableNameFilter: function(selectedItem) {
          vm.pageModel.Fields.TableMeta4Filter.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function() {
            return {
              tableName: selectedItem.key,
            };
          };
          vm.pageModel.Fields.TableMeta4Filter.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
    },
  ]);
})(angular.module('sbService'));

(function(module) {
  'use strict';

  module.controller('InterfaceNavMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InterfaceNavMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      buildMenu($state, authService, 'Service_InterfaceNav', 'service', null, null).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbService'));

'use strict';

function sbPartnerDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.partner = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      [
        'PanelPartBank',
        'PanelPartAddress',
        'PanelPartLink',
        'PanelPartClassification',
        'PanelPartContract',
        'PanelPartHierarchy',
      ],
      function(gridModel) {
        if (gridModel.Id === 'GridPartContract') {
          gridModel.ControllerMethod = gridModel.ControllerMethod;
          return {
            gridModel,
            transportData: function() {
              return {
                targetPartnerId: ctrl.partner.PartnerId,
                adopter: gridModel.Adopter,
                InstallAdopter: gridModel.InstallAdopter,
                tableName: gridModel.Table,
                idColumn: gridModel.IdColumn,
                columnCsv: gridModel.Columns.map(x => x.field).join(),
                whereCondition: `PartnerId~eq~${ctrl.partner.PartnerId}`,
                sort: ctrl.generatedTabs.find(x => x.name == 'TabPartContract')?.grid?.dataSource?.sort() ?? [
                  { field: 'DateFrom', dir: 'desc' },
                ],
              };
            },
          };
        }
        if (gridModel.Id === 'GridPartHierarchy') {
          gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              return {
                targetPartnerId: ctrl.partner.PartnerId,
              };
            },
            dataBound: function(e) {
              let rows = e.sender.tbody.children();
              for (var j = 0; j < rows.length; j++) {
                let row = $(rows[j]);
                let dataItem = e.sender.dataItem(row);
                if (dataItem['PartnerId'] == ctrl.partner.PartnerId) {
                  row.addClass('grid-bold-row');
                }
              }
            },
          };
        } else {
          gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              return {
                targetPartnerId: ctrl.partner.PartnerId,
              };
            },
          };
        }
      }
    );
    let _kendoConfig = ctrl.generatedTabs.find(x => x.name == 'TabPartHierarchy')?.kendoConfig;
    if (!!_kendoConfig) {
      //_kendoConfig['disableOptions'] = { GridStateSave: true, GridStateRestore: true };
      _kendoConfig['selectable'] = false;
    }
  };
  //#endregion
}

const sbPartnerDetailComponentOptions = {
  templateUrl: 'App/Partner/partner-detail/partner-detail.component.html',
  controller: sbPartnerDetailComponent,
  bindings: {
    partner: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbPartnerDetail: sbPartnerDetailComponentOptions,
  };

  const sbPartnerDetailModule = angular.module('sbPartnerDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbPartnerDetailModule.component(componentTag, componentOptions);
  });
})();

function partnerRouting() {
  return {
    Partner: {
      url: '/partner',
      templateUrl: 'App/AllLayout.html',
      controller: 'AllLayoutCtrl as vm',
      redirectTo: 'Partner.PartnerNav',
      ncyBreadcrumb: {
        label: 'Partner modul',
        parent: 'main',
      },
    },
    'Partner.PartnerNav': {
      url: '/nav',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerNav.html',
          controller: 'PartnerNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/ListOptions/'),
      },
      params: {
        module: 'partner',
        formMode: 'Nav',
        backState: 'main',
        createState: 'Partner.Create',
        editState: 'Partner.Edit',
        duplicateState: 'Partner.Duplicate',
        deleteState: 'Partner/PartnerDelete/',
        viewState: 'Partner.View',
        bstates: ['Partner.Create', 'Partner.Edit', 'Partner.Duplicate', 'Partner/PartnerDelete', 'Partner.View'],
        documentEntity: 'partner_partnernav',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
        helpAndManualPageId: 'partner',
      },
      ncyBreadcrumb: {
        label: 'Partner navigáció',
      },
    },
    'Partner.AidDecisionNav': {
      url: 'aid/aid-nav',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerAid.html',
          controller: 'PartnerAidCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/ListAidDecisions/'),
      },
      params: {
        isShown: false,
        formMode: 'Nav',
        backState: 'main',
        bstates: ['Partner.AidDecisionEdit', 'Partner.AidDecisionDuplicate'],
        documentEntity: 'Partner',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
      },
      ncyBreadcrumb: {
        label: 'Támogatási határozatok',
      },
    },
    'Partner.AidDecisionNavDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Partner.AidDecisionEdit': {
      url: 'aid/edit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerAidEdit.html',
          controller: 'PartnerAidEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/AidDecisionEdit/', undefined, ['id']),
      },
      params: {
        isShownC: true,
        documentEntity: 'partner_aiddecisionedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Támogatási határozat',
      },
    },
    'Partner.AidDecisionCreate': {
      url: 'aid/edit/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerAidEdit.html',
          controller: 'PartnerAidEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/AidDecisionCreate/', undefined, ['id']),
      },
      params: {
        isShownC: true,
        documentEntity: 'partner_aiddecisionedit',
        EditOrDuplicate: 'Edit',
      },
      ncyBreadcrumb: {
        label: 'Támogatási határozat',
      },
    },
    'Partner.AidDecisionDuplicate': {
      url: 'aid/duplicate/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerAidEdit.html',
          controller: 'PartnerAidEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/AidDecisionDuplicate/', undefined, ['id']),
      },
      params: {
        isShownC: true,
        documentEntity: 'partner_aiddecisionedit',
        EditOrDuplicate: 'Duplicate',
      },
      ncyBreadcrumb: {
        label: 'Támogatási határozat másolás',
      },
    },
    'Partner.AidType': {
      url: 'aid/aidtype',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/AidType.html',
          controller: 'AidTypeCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/ListAidTypes/'),
      },
      params: {
        formMode: 'Nav',
        documentEntity: 'partner_aidtype_edit',
      },
      ncyBreadcrumb: {
        label: 'Támogatási típusok',
      },
    },
    'Partner.AidType.Edit': {
      url: 'aid/aidtype/edit',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/AidTypeEdit.html',
          controller: 'AidTypeEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/AidTypeEdit/'),
      },
      ncyBreadcrumb: {
        label: 'Támogatási típus szerkeztés',
      },
    },
    'Partner.AidType.Duplicate': {
      url: 'aid/aidtype/duplicate',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/AidTypeDuplicate.html',
          controller: 'AidTypeDuplicateCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/AidTypeDuplicate/'),
      },
      ncyBreadcrumb: {
        label: 'Támogatási típus másolás',
      },
    },
    'Partner.Create': {
      url: '/create/{id:int}?valid',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerCreate/', undefined, ['id', 'valid']),
      },
      params: {
        formMode: 'Create',
        subState: 'Partner.',
        mainGridIdName: 'PartnerId',
        postUrl: 'Partner/PartnerEdit',
        backStateAfterSave: 'Partner.Edit',
        backStateAfterSaveParams: [{ name: 'id', modelName: 'PartnerId' }],
        backState: 'Partner.PartnerNav',
        documentEntity: 'partner_create',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
        helpAndManualPageId: 'partner_edit',
      },
      ncyBreadcrumb: {
        label: 'Partner hozzáadása',
      },
    },
    'Partner.Edit': {
      url: '/edit/{id:int}?valid',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerEdit/', undefined, ['id', 'valid']),
      },
      params: {
        formMode: 'Edit',
        subState: 'Partner.',
        subDeleteState: 'Partner/',
        mainGridIdName: 'PartnerId',
        postUrl: 'Partner/PartnerEdit',
        backStateAfterSave: 'Partner.Edit',
        documentEntity: 'partner_edit',
        backStateAfterSaveParams: [
          { name: 'id', modelName: 'PartnerId' },
          { name: 'valid', modelName: 'ValidFrom' },
        ],
        backState: 'Partner.PartnerNav',
        createState: 'Partner.Create',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
        bstates: [
          'Partner.Create',
          'Partner.Duplicate',
          'Partner.GridPartBankEdit',
          'Partner.GridPartBankDuplicate',
          'Partner.GridPartAddressEdit',
          'Partner.GridPartAddressDuplicate',
          'Partner.GridPartLinkEdit',
          'Partner.GridPartLinkDuplicate',
          'Partner.GridPartClassificationEdit',
          'Partner.GridPartClassificationDuplicate',
        ],
        documentEntity: 'Partner_create',
        stateTransitionInfo: {
          // TODO to be filled by OEM
        },
        openedPanelGroup: null,
      },
      ncyBreadcrumb: {
        label: 'Partner szerkesztése',
      },
    },
    'Partner.Edit.TenantPerson': {
      url: '/edit/tenantperson/{id:int}?valid',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerEditTenantPerson/', undefined, ['id', 'valid']),
      },
      params: {
        formMode: 'Edit',
        subState: 'Partner.',
        subDeleteState: 'Partner/',
        mainGridIdName: 'PartnerId',
        postUrl: 'Partner/PartnerEdit',
        backStateAfterSave: 'Partner.Edit',
        backStateAfterSaveParams: [
          { name: 'id', modelName: 'PartnerId' },
          { name: 'valid', modelName: 'ValidFrom' },
        ],
        backState: 'Partner.PartnerNav',
        createState: 'Partner.Create',
        documentEntity: 'partner_edit',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
      },
      ncyBreadcrumb: {
        label: 'Partner szerkesztése',
      },
    },
    'Partner.Edit.TenantCompany': {
      url: '/edit/tenantcompany/{id:int}?valid',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerEditTenantCompany/', undefined, ['id', 'valid']),
      },
      params: {
        formMode: 'Edit',
        subState: 'Partner.',
        subDeleteState: 'Partner/',
        mainGridIdName: 'PartnerId',
        postUrl: 'Partner/PartnerEdit',
        backStateAfterSave: 'Partner.Edit',
        backStateAfterSaveParams: [
          { name: 'id', modelName: 'PartnerId' },
          { name: 'valid', modelName: 'ValidFrom' },
        ],
        backState: 'Partner.PartnerNav',
        createState: 'Partner.Create',
        documentEntity: 'partner_edit',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backTo: 'Nav',
      },
      ncyBreadcrumb: {
        label: 'Partner szerkesztése',
      },
    },
    'Partner.View': {
      url: '/view/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerView/', undefined, ['id']),
      },
      params: {
        formMode: 'View',
        backState: 'Partner.PartnerNav',
        documentEntity: 'partner_edit',
        controllerOptions: {
          isFormReadOnly: true,
        },
        backTo: 'Nav',
      },
      ncyBreadcrumb: {
        label: 'Partner megtekintése',
      },
    },
    'Partner.Duplicate': {
      url: '/duplicate/{id:int}',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/PartnerEdit.html',
          controller: 'PartnerEditCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveFunc('Partner/PartnerDuplicate/', undefined, ['id']),
      },
      params: {
        formMode: 'Create',
        subState: 'Partner.',
        subDeleteState: 'Partner/',
        mainGridIdName: 'PartnerId',
        postUrl: 'Partner/PartnerEdit',
        backStateAfterSave: 'Partner.Edit',
        documentEntity: 'partner_edit',
        backStateAfterSaveParams: [{ name: 'id', modelName: 'PartnerId' }],
        backState: 'Partner.PartnerNav',
        controllerOptions: {
          isFormReadOnly: false,
        },
        CreateOrEdit: 'Create',
        backTo: 'Nav',
      },
      ncyBreadcrumb: {
        label: 'Partner másolása',
      },
    },
    'Partner.GridPartBankCreate': {
      url: 'partbank/create/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartBankEdit.html',
          controller: 'PartnerPartBankEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartBankCreate/', undefined, ['id', 'PartnerId']),
      },
      params: {
        formMode: 'Create',
        mainGridIdName: 'PartBankId',
        postUrl: 'Partner/GridPartBankCreate',
        backStateAfterSave: 'Partner.Edit',
        EditOrDuplicate: 'Edit',
        documentEntity: 'partner_gridpartbankedit',
        backStateAfterSaveParams: [{ name: 'id', modelName: 'PartnerId' }],
        backStateParams: [{ name: 'id', modelName: 'PartnerId' }],
        backState: 'Partner.Edit',
        controllerOptions: {
          isFormReadOnly: false,
        },
        PartnerId: 'PartnerId',
      },
      ncyBreadcrumb: {
        label: 'Bankszámlaszám létrehozása',
      },
    },
    'Partner.GridPartBankEdit': {
      url: 'partbank/edit/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartBankEdit.html',
          controller: 'PartnerPartBankEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartBankEdit/', undefined, ['id', 'PartnerId']),
      },
      params: {
        formMode: 'Edit',
        mainGridIdName: 'PartBankId',
        postUrl: 'Partner/GridPartBankEdit',
        backStateAfterSave: 'Partner.Edit',
        backStateAfterSaveParams: [{ name: 'id', modelName: 'PartnerId' }],
        backState: 'Partner.Edit',
        documentEntity: 'partner_gridpartbankedit',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backStateParams: [{ name: 'id', modelName: 'PartnerId' }],
        PartnerId: 'PartnerId',
      },
      ncyBreadcrumb: {
        label: 'Bankszámlaszám szerkesztés',
      },
    },
    'Partner.GridPartBankDuplicate': {
      url: 'partbank/duplicate/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartBankEdit.html',
          controller: 'PartnerPartBankEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartBankDuplicate/', undefined, ['id', 'PartnerId']),
      },
      params: {
        formMode: 'Duplicate',
        mainGridIdName: 'PartBankId',
        postUrl: 'Partner/GridPartBankDuplicate',
        backStateAfterSave: 'Partner.Edit',
        backStateAfterSaveParams: [{ name: 'id', modelName: 'PartnerId' }],
        backState: 'Partner.Edit',
        documentEntity: 'partner_gridpartbankedit',
        controllerOptions: {
          isFormReadOnly: false,
        },
        backStateParams: [{ name: 'id', modelName: 'PartnerId' }],
        PartnerId: 'PartnerId',
      },
      ncyBreadcrumb: {
        label: 'Bankszámlaszám másolás',
      },
    },
    'Partner.GridPartAddressCreate': {
      url: 'partaddress/create/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartAddressEdit.html',
          controller: 'PartnerPartAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartAddressCreate/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Cím hozzáadása',
      },
    },
    'Partner.GridPartAddressEdit': {
      url: 'partaddress/edit/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartAddressEdit.html',
          controller: 'PartnerPartAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartAddressEdit/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Cím szerkesztés',
      },
    },
    'Partner.GridPartAddressDuplicate': {
      url: 'partaddress/duplicate/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartAddressEdit.html',
          controller: 'PartnerPartAddressEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartAddressDuplicate/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartaddressedit',
      },
      ncyBreadcrumb: {
        label: 'Cím másolás',
      },
    },
    'Partner.GridPartLinkCreate': {
      url: 'partlink/create/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartLinkEdit.html',
          controller: 'PartnerPartLinkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartLinkCreate/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Create',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartlinkedit',
      },
      ncyBreadcrumb: {
        label: 'Elérhetőség hozzáadása',
      },
    },
    'Partner.GridPartLinkEdit': {
      url: 'partlink/edit/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartLinkEdit.html',
          controller: 'PartnerPartLinkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartLinkEdit/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartlinkedit',
      },
      ncyBreadcrumb: {
        label: 'Elérhetőség szerkesztés',
      },
    },
    'Partner.GridPartLinkDuplicate': {
      url: 'partlink/duplicate/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartLinkEdit.html',
          controller: 'PartnerPartLinkEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartLinkDuplicate/', undefined, ['id', 'PartnerId']),
        //https://stackoverflow.com/questions/34326178/reuse-angular-controller-for-modal-and-non-modal
        $uibModalInstance: function() {
          return null;
        },
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartlinkedit',
      },
      ncyBreadcrumb: {
        label: 'Elérhetőség másolás',
      },
    },
    'Partner.GridPartClassificationCreate': {
      url: 'partclassification/create/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartClassificationEdit.html',
          controller: 'PartnerPartClassificationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartClassificationCreate/', undefined, ['id', 'PartnerId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartclassificationedit',
      },
      ncyBreadcrumb: {
        label: 'Minősítés hozzáadása',
      },
    },
    'Partner.GridPartClassificationEdit': {
      url: 'partclassification/edit/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartClassificationEdit.html',
          controller: 'PartnerPartClassificationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartClassificationEdit/', undefined, ['id', 'PartnerId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Edit',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartclassificationedit',
      },
      ncyBreadcrumb: {
        label: 'Minősítés szerkesztés',
      },
    },
    'Partner.GridPartClassificationDuplicate': {
      url: 'partclassification/duplicate/{id:int}?PartnerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/PartnerPartClassificationEdit.html',
          controller: 'PartnerPartClassificationEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartClassificationDuplicate/', undefined, ['id', 'PartnerId']),
      },
      params: {
        controllerOptions: {
          isFormReadOnly: false,
        },
        EditOrDuplicate: 'Duplicate',
        PartnerId: 'PartnerId',
        documentEntity: 'partner_gridpartclassificationedit',
      },
      ncyBreadcrumb: {
        label: 'Minősítés másolás',
      },
    },
    'Partner.AddressMap': {
      url: '/partaddress/map/',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PropertyMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/SubItems/Map.html',
          controller: 'MapCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/GridPartAddressMap/', undefined, ['id']),
      },
      params: {
        id: -1,
      },
      ncyBreadcrumb: {
        label: 'Térkép',
      },
    },
    'Partner.AidDecisionNavDasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'AidDecisionMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Partner.DasDocumentsNav': {
      url: '/list/:tableId/:ownerId',
      params: {
        module: 'documents',
        formMode: 'Nav',
        backTo: 'Nav',
        lockPreviousState: true,
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Das/Documents/DocumentsNav.html',
          controller: 'DocumentsNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Das/Documents/DocumentsListOptions/', undefined, ['tableId', 'ownerId']),
      },
      ncyBreadcrumb: {
        label: 'Dokumentum csatolás',
      },
    },
    'Partner.MovingProjectNav': {
      url: '/movingprojectnav',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/MovingProjectNav.html',
          controller: 'MovingProjectNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/MovingProjectListOptions/'),
      },
      ncyBreadcrumb: {
        label: 'Költöztetési események',
        parent: 'Partner.PartnerNav',
      },
    },
    'Partner.MovingPlanEdit': {
      url: '/movingplanedit/{movingProjectId:int}?',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/Partner/MovingPlanEdit.html',
          controller: 'MovingPlanEditCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('Partner/MovingPlanEdit', undefined, ['movingProjectId']),
      },
      ncyBreadcrumb: {
        label: 'Költöztetési események',
        parent: 'Partner.MovingProjectNav',
      },
    },
    'Partner.HistoryNav': {
      url: '/history/:tableId/:idColumn/:ownerId',
      params: {
        module: 'history',
        formMode: 'Nav',
      },
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'PartnerMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/History/HistoryNav.html',
          controller: 'HistoryNavCtrl as vm',
        },
      },
      resolve: {
        model: RouteResolveParamFunc('Partner/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
      },
      ncyBreadcrumb: {
        label: 'Történetiségi adatok',
      },
    },
  };
}

'use strict';

(function() {
  const modules = ['sbPartnerDetail'];

  const sbPartnerModule = angular.module('sbPartner', modules).config([
    '$stateProvider',
    function($stateProvider) {
      let partnerRoutingStates = partnerRouting();

      angular.forEach(partnerRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });
    },
  ]);
})();

(function(module) {
  'use strict';

  module.controller('AidTypeCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    'HistoryService',
    'DasService',
    'WalService',
    function(options, $http, $state, $stateParams, $uibModal, AuthService, HistoryService, dasService, walService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AidTypeCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;

      vm.create = createItem;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.back = function() {
        $state.go('Partner.AidDecisionNav');
      };

      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(vm.pageModel.Grids.GridAidType, 'Partner/AidTypeList/', function() {});
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids.GridAidType.IdColumn;
      // Kendo-grid reference
      vm.grid = $('#aidTypeGrid').data('kendoGrid');
      ////////////////////////////////////////////////////////////////////////////////////////

      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        var url = 'Partner/AidTypeEdit/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Partner/AidTypeEdit.html',
          controller: 'AidTypeEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        //console.log(JSON.stringify(selectedItems));
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Partner/AidTypeEdit/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Partner/AidTypeEdit.html',
            controller: 'AidTypeEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.gridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Partner/AidTypeDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Partner/AidTypeDuplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Partner/AidTypeDuplicate.html',
            controller: 'AidTypeDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.gridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Partner.AidDecisionNavDasDocumentsNav', 'FlgAidType', id);
      }

      function History() {
        if (GetSelectedGridItems(vm.grid) == 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          HistoryService.NavigateToHistory('FlgAidType', GetSelectedGridItems(vm.grid), vm, $state);
        }
      }

      function WAL() {
        walService.NavigateToWal('Partner', 'PartnerAidTypeNavWal', 'FlgAidType');
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('AidTypeDuplicateCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'LockService',
    function(mi, $http, fModel, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AidTypeDuplicateCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelAidType.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Partner/AidTypeDuplicate', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikertelen!'); // TODO általános label
            mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('AidTypeEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, fModel, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AidTypeEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation] ///////////////////////////////
      // Generate Formly form descriptors from pageModel
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelAidType.FormlyDescriptor;
      ////////////////////////////////////////////////////////////////////////////////////////

      var aidType = vm.formModel.AidType;

      var customExpressionProperties = {
        AidType: {
          'templateOptions.disabled': function() {
            return !(aidType === null || aidType === '');
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.save = function() {
        $http
          .post('Partner/AidTypeEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikertelen!'); // TODO általános label
            mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.AidTypeId;
        dasService.NavigateToDas(vm.messages, 'Partner.AidDecisionNavDasDocumentsNav', 'FlgAidType', id);
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerAidCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'FileSaver',
    'HistoryService',
    'DasService',
    'WalService',
    function(
      options,
      $http,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      FileSaver,
      HistoryService,
      dasService,
      walService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerAidCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.stateParams = $stateParams;
      vm.labels = vm.pageModel.Labels;
      // MenuItems
      vm.create = createItem;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;
      vm.import = importAidDecision;
      vm.excelExport = excelExport;
      vm.activeSubItemTab = 0;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.back = function() {
        $state.go('Partner.PartnerNav');
      };

      // Tabs
      var tabs = ['Élő határozatok', 'Összes határozat'];
      vm.tabs = tabs;
      vm.validAid = 'Élő határozatok';
      vm.allAid = 'Összes határozat';

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeDetailTab', vm.activeDetailItemTab);
      });

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;
      $scope.activeDetailItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeDetailTab')) || 0;
      vm.activeDetailItemTab = $scope.activeDetailItemTab;

      // Dynamic grid configuration
      vm.validGridOptions = getGridOptions(
        Object.assign({}, vm.pageModel.Grids.GridAidDecision, { Id: 'ValidGridAidDecision' }),
        'Partner/AidDecisionValidList/',
        function() {
          //console.log('cica1')
        }
      );
      vm.gridOptions = getGridOptions(
        Object.assign({}, vm.pageModel.Grids.GridAidDecision, { Id: 'AllGridAidDecision' }),
        'Partner/AidDecisionList/',
        function() {
          //console.log('cica2')
        }
      );

      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids.GridAidDecision.IdColumn;
      // Kendo-grid reference
      vm.grid = $('#validAidGrid').data('kendoGrid');
      //
      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////////////// Grid collapse /////////////////////////////////////
      //console.log("Aid/isCollapsed: " + JSON.stringify($stateParams));
      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        var id = 0;
        $scope.isCollapsed = true;
        $state.go('Partner.AidDecisionCreate', { id: id });
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        if (vm.activeSubItemTab === 0) {
          vm.grid = $('#validAidGrid').data('kendoGrid');
        } else {
          vm.grid = $('#allAidGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        //console.log(JSON.stringify(selectedItems));
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          $state.go('Partner.AidDecisionEdit', { id: id, EditOrDuplicate: 'Edit' });
        }
      }

      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        if (vm.activeSubItemTab === 0) {
          vm.grid = $('#validAidGrid').data('kendoGrid');
        } else {
          vm.grid = $('#allAidGrid').data('kendoGrid');
        }

        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NoSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.gridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Partner/AidDecisionDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        if (vm.activeSubItemTab === 0) {
          vm.grid = $('#validAidGrid').data('kendoGrid');
        } else {
          vm.grid = $('#allAidGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          $state.go('Partner.AidDecisionDuplicate', { id: id, EditOrDuplicate: 'Duplicate' });
        }
      }

      ///// Import ////////////////
      function importAidDecision() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Partner/PartnerAidImport.html',
          controller: 'PartnerAidImportCtrl',
          controllerAs: 'vm',
          resolve: {
            pageModel: vm.pageModel,
            grid: vm.grid,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      function excelExport() {
        $http.post('Partner/AidDecisionExport').then(function(data) {
          var raw = window.atob(data.data.File);
          var rawLength = raw.length;
          var array = new Uint8Array(new ArrayBuffer(rawLength));

          for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }
          var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(fs, 'export.xlsx');
        });
      }
      function attachDocument() {
        if (vm.activeSubItemTab === 0) {
          vm.grid = $('#validAidGrid').data('kendoGrid');
        } else {
          vm.grid = $('#allAidGrid').data('kendoGrid');
        }

        var selectedItems = GetSelectedGridItems(vm.grid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.gridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Partner.AidDecisionNavDasDocumentsNav', 'FlgAidType', id);
      }

      function History() {
        console.log(vm);
        console.log($state);

        if (vm.activeSubItemTab === 0) {
          vm.grid = $('#validAidGrid').data('kendoGrid');
        } else {
          vm.grid = $('#allAidGrid').data('kendoGrid');
        }

        if (GetSelectedGridItems(vm.grid) == 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          HistoryService.NavigateToHistory('FlgAidDecision', GetSelectedGridItems(vm.grid), vm, $state);
        }
      }

      function WAL() {
        walService.NavigateToWal('Partner', 'PartnerAidDecisionNavWal', 'FlgAidDecisionView');
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerAidImportCtrl', [
    '$http',
    '$scope',
    '$uibModalInstance',
    'FileUploadService',
    'FileSaver',
    'pageModel',
    'grid',
    function($http, $scope, mi, fus, FileSaver, pageModel, grid) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerAidImportCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = pageModel;
      vm.formFields = [
        {
          key: 'importFile',
          type: 'kendoFU',
          templateOptions: {
            maxFileSize: 1024 * 1024,
            label: 'Excel',
            required: true,
            options: {
              showFileList: true,
              autoUpload: false,
              multipleFileUpload: false,
              saveUrl: null,
              removeUrl: null,
            },
            eventHandlers: {
              onError: function() {},
              onSuccess: function() {},
              onComplete: function() {},
            },
          },
        },
      ];
      vm.save = function() {
        if (!vm.formModel.importFile) return;
        var model = angular.copy(vm.formModel);
        var msg = toastr.warning(vm.pageModel.Actions.ActionWaiting.Title);
        model.importFile = vm.formModel.importFile.getFile();
        fus
          .postWithFile('Partner/AidDecisionImport', model)
          .then(function(response) {
            msg.remove();
            mi.close();
            saveToDb(response.data.ImportList);
          })
          .catch(function() {
            msg.remove();
            toastr.error(vm.pageModel.Actions.ActionImportError.Title);
          });
      };

      vm.cancel = function() {
        mi.close();
      };

      function saveToDb(importList) {
        vm.importList = JSON.stringify(importList);
        var dialogMessage = vm.pageModel.Actions.ActionImportSuccess.Title;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Actions.ActionImportTitle.Title,
          buttons: {
            cancel: {
              label: 'Mégse',
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Mentés',
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('Partner/AidDecisionImportDb', { importList: vm.importList })
                  .then(function(response) {
                    toastr.success(vm.pageModel.Actions.ActionSaveSuccess.Title);
                    var raw = window.atob(response.data.File);
                    var rawLength = raw.length;
                    var array = new Uint8Array(new ArrayBuffer(rawLength));

                    for (var i = 0; i < rawLength; i++) {
                      array[i] = raw.charCodeAt(i);
                    }
                    var fs = new Blob([array], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    FileSaver.saveAs(fs, 'hibalista.xlsx');
                  })
                  .catch(function(response) {
                    toastr.error(vm.pageModel.Actions.ActionSaveError.Title);
                  });
              },
            },
          },
        });
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerAidEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerAidEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      var EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        $state.go('Partner.AidDecisionNav');
      };

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var onChangeFunctions = {
        HAmount: function(selectedItem) {
          CalculatePAmount();
        },
        ValidFrom: function(selectedItem) {
          CalculatePAmount();
        },
        SAmount: function(selectedItem) {
          CalculatePAmount();
        },
      };

      function CalculatePAmount() {
        var validFromDate = new Date(vm.formModel.ValidFrom);
        var modDate = new Date(vm.formModel.ModDate);
        var today = new Date();
        var months = (modDate.getFullYear() - validFromDate.getFullYear()) * 12;
        months += modDate.getMonth() - validFromDate.getMonth();
        if (validFromDate > today) {
          vm.formModel.PAmount = vm.formModel.SAmount;
        } else {
          vm.formModel.PAmount = vm.formModel.HAmount * months;
        }
      }

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.save = function() {
        $http
          .post('Partner/AidDecision' + EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Támogatási határozat mentése sikeresen megtörtént!'); // TODO általános label
            $state.go('Partner.AidDecisionNav');
          })
          .catch(function(response) {
            toastr.error('Támogatási határozat mentése sikertelen!'); // TODO általános label
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.AidDecisionNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.AidDecisionId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgAidDecision', id);
      };

      function validateDate(date) {
        if (vm.formModel.ValidTo !== null) {
          return vm.formModel.ValidFrom <= vm.formModel.ValidTo;
        } else {
          return true;
        }
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';
  module.controller('PartnerEditCtrl', [
    '$scope',
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    'HistoryService',
    'WalService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      $http,
      model,
      fus,
      $state,
      $stateParams,
      HistoryService,
      walService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerEditCtrl', stateParams);
      }
      var vm = this;

      model.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.hideInput = true;
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      vm.UIHelperService = UIHelperService;
      vm.hasDifferentInvoiceName = false;
      vm.hasDifferentAccountName = false;
      vm.structCompIsSet = 0;
      // init();

      function stateIsCreate() {
        return !vm.dataModel.PartnerId;
      }

      //megtekintesnel ne lockoljunk
      if (vm.formMode != 'View') {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });
      vm.getPExtraProperty = function(key) {
        return vm.dataModel.extraProperties.find(x => x.key === key)?.value;
      };
      vm.saveFn = function() {
        //Adószám kötőjelekkel együtt történő mentése:
        vm.dataModel.TaxNumber = vm.pageModel.Fields.TaxNumber.FormlyFieldDescriptor.formControl.$viewValue;
        if (vm.formMode === 'Create') {
          //új tétel mentés utáni navigáció paraméter hack: paramétert nem lehet átadni, csak vm.dataModel-en keresztül (getSaveAction)
          vm.dataModel.openedPanelGroup = 'PGHeader';
          $stateParams.backStateAfterSaveParams.push({ name: 'openedPanelGroup', modelName: 'openedPanelGroup' });
        }
        vm.save();
      };
      vm.backWithUnlock = function() {
        if (vm.formMode != 'View') {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        vm.back();
      };

      model.pageModel.Fields['AddressType'].FormlyFieldDescriptor.type = 'kendoMS';
      init();
      function whereConditionForPostCode() {
        if (!!vm.dataModel.Locality.Value) return "Locality~eq~'" + vm.dataModel.Locality + "'";
        if (!!vm.dataModel.Country) return "Country~eq~'" + vm.dataModel.Country + "'";
        return '';
      }
      vm.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionForPostCode;
      vm.mapAddress = function() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        if (gridName !== 'GridPartAddress') {
          return;
        }
        var gridIdName = vm.pageModel.Grids[gridName].IdColumn;
        var id = getSelectedRowIdFromSubGrid(vm, gridName, gridIdName);
        if (id === -1 || !id) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var obj = { id: id };
          if (vm.formMode != 'View') {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          }
          $state.go('Partner.AddressMap', obj);
        }
      };

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.origIsPartner = angular.copy(vm.dataModel.Partner);

        vm.UIHelperService.setDefaultSidebarStatus();
        vm.UIHelperService = UIHelperService;
        vm.collapseHelper = {
          startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
          disableRunExpression: false,
        };
        vm.getCatType = function() {
          return vm.dataModel.extraProperties?.find(x => x.key == 'PartnerCatType')?.value;
        };
        //Eltérő számlanév
        vm.hasDifferentInvoiceName = vm.dataModel.Name !== vm.dataModel.InvoiceName;
        // MenuItems
        if (vm.formMode === 'Create') {
          $scope.activeSubItemTab = 0;
          vm.activeSubItemTab = 0;
        } else {
          vm.edit = editItem;
          vm.delete = deleteItem;
          vm.duplicate = duplicateItem;
          vm.view = viewItem;
          vm.history = history;
          vm.attachDocument = attachDocument;

          // SubItemMenuItems
          //vm.createSubItem = createSubItem;
          //vm.editSubItem = editSubItem;
          //vm.deleteSubItem = deleteSubItem;
          //vm.duplicateSubItem = duplicateSubItem;
          initGrid(vm);
        }
        partnerEditSetFields(vm);
        generateForm(vm);
      }

      function initGrid(vm) {
        ////////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////// [ Dynamic SubItem Grid generation] ///////////////////////////
        var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
          vm.pageModel.Tabs,
          vm.pageModel.Panels,
          vm.pageModel.Grids,
          null,
          function(gridModel) {
            if (gridModel.Id === 'GridPartContract') {
              gridModel.ControllerMethod = gridModel.ControllerMethod;
              return {
                gridModel,
                transportData: function() {
                  return {
                    targetPartnerId: vm.dataModel.PartnerId,
                    adopter: gridModel.Adopter,
                    InstallAdopter: gridModel.InstallAdopter,
                    tableName: gridModel.Table,
                    idColumn: gridModel.IdColumn,
                    columnCsv: gridModel.Columns.map(x => x.field).join(),
                    whereCondition: `PartnerId~eq~${vm.dataModel.PartnerId}`,
                    sort: vm.subGrids[gridModel.Name]?.dataSource?.sort() ?? [{ field: 'DateFrom', dir: 'desc' }],
                  };
                },
              };
            }
            if (gridModel.Id === 'GridPartHierarchy') {
              gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
              return {
                gridModel,
                transportData: function() {
                  return {
                    targetPartnerId: vm.dataModel.PartnerId,
                  };
                },
                dataBound: function(e) {
                  let rows = e.sender.tbody.children();
                  for (var j = 0; j < rows.length; j++) {
                    let row = $(rows[j]);
                    let dataItem = e.sender.dataItem(row);
                    if (dataItem['PartnerId'] == vm.dataModel.PartnerId) {
                      row.addClass('grid-bold-row');
                    }
                  }
                },
              };
            } else {
              gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
              return {
                gridModel,
                transportData: function() {
                  return {
                    targetPartnerId: vm.dataModel.PartnerId,
                  };
                },
              };
            }
          }
        );

        vm.subItemTabs = generatedGridTabs.tabs;
        vm.subGridOptions = generatedGridTabs.gridOptions;
        vm.subGrids = generatedGridTabs.grids;
        //vm.subGridOptions.GridPartHierarchy.disableOptions = { GridStateSave: true, GridStateRestore: true };
        vm.subGridOptions.GridPartHierarchy.selectable = false;

        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;
      }

      // Switches state to (nonReadOnly) edit mode
      function editItem() {
        if (vm.formMode != 'View') {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Partner.Edit', { id: vm.dataModel.PartnerId });
      }

      /// Deletes the currently open TimeMachine entry of partner
      function deleteItem() {
        var id = vm.dataModel.PartnerId;
        if (!!id) {
          $http({
            method: 'GET',
            url: 'Partner/PartnerValidComboList',
            params: { id: vm.dataModel.PartnerId },
          }).then(function successCallback(response) {
            if (response !== null) {
              var dialogMessage;
              var validFrom = new moment(vm.dataModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
              var veryFirstDate = moment(response.data.data[0].key, kendo.culture().calendar.patterns.d.toUpperCase());

              if (validFrom.isSame(veryFirstDate)) {
                dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage2;
              } else {
                dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage1.replace(
                  '{0}',
                  validFrom.format(kendo.culture().calendar.patterns.d.toUpperCase())
                );
              }

              bootbox.dialog({
                message: dialogMessage,
                title: vm.messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      $http.get('Partner/PartnerDelete/' + id + '?shouldLock=false').then(function() {
                        toastr.success(vm.messages.DeleteSuccessful);
                        if (vm.formMode != 'View') {
                          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                        }
                        $state.go('Partner.PartnerNav');
                      });
                    },
                  },
                },
              });
            }
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      /// Duplicates the active partner entry
      function duplicateItem() {
        if (vm.formMode != 'View') {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Partner.Duplicate', { id: vm.dataModel.PartnerId });
      }

      // Switches the state to (readOnly) view mode
      function viewItem() {
        if (vm.formMode != 'View') {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Partner.View', { id: vm.dataModel.PartnerId });
      }
      function attachDocument() {
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgPartner', vm.dataModel.PartnerId);
      }

      vm.dasModel = { routeId: 'Partner.DasDocumentsNav', tableId: 'FlgPartner', ownerId: vm.dataModel.PartnerId };

      function history() {
        HistoryService.NavigateToHistory('FlgPartner', vm.dataModel.PartnerId, vm, $state);
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////
      vm.subDisabled = true;

      function getSelectedSubGridItem() {
        var gridName = vm.subItemTabs[$scope.activeSubItemTab].gridName;
        var gridRef = $('#subGrid' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          vm.subDisabled = false;
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.subItemTabs[$scope.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function partnerEditSetFields(vm) {
        vm.pageModel.AccountSeparator1 = '-';
        vm.pageModel.AccountSeparator2 = '-';
        var fs = fieldSetter;
        fs.vm = vm;
        fs.setMask('Iban', '**99 **** **** **** ***?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*');
        fs.setMask('Account', '99999999-99999999-?9?9?9?9?9?9?9?9'); //not working on F2
        //fs.setMask('Account2', '99999999');
        //fs.setMask('Account3', '99999999');
        fs.setMask('Swift', 'AAAA AA ** ?*?*?*');
        fs.setMask('TaxId', '9999999999');
        fs.setMask('TaxNumber', '99999999-9-99');
        fs.setMask('IdNumber', '9999999-9999');

        // fs.setAsSeparatorDash('AccountSeparator1');
        // fs.setAsSeparatorDash('AccountSeparator2');

        fs.setFocus('PartnerCode', function() {
          return vm.dataModel.PartnerId === 0;
        });
        fs.setDisabled('PartnerCode', function() {
          return (
            vm.controllerOptions.isFormReadOnly ||
            vm.dataModel.IsReadOnly ||
            vm.dataModel.ERPCON ||
            (!vm.dataModel.ERPCON && !vm.dataModel.Partner) ||
            !stateIsCreate()
          );
        });

        fs.setDisabled('Account', function() {
          return !stateIsCreate();
        });
        fs.setDisabled('AccountName', function() {
          return !stateIsCreate();
        });
        fs.setDisabled('Bank', function() {
          return !stateIsCreate();
        });
        fs.setDisabled('Iban', function() {
          return !stateIsCreate();
        });
        fs.setDisabled('Swift', function() {
          return !stateIsCreate();
        });

        //fs.setReadOnly('ValidFrom', 'false');

        fs.setDisabled('MainTenant', function() {
          return (
            vm.controllerOptions.isFormReadOnly ||
            vm.dataModel.IsReadOnly ||
            !(
              vm.dataModel.MainTenantPartId === null ||
              vm.dataModel.MainTenantPartId === '' ||
              vm.dataModel.MainTenantPartId.key === null ||
              vm.dataModel.MainTenantPartId.key === ''
            )
          );
        });
        fs.setDisabled('DefaultInterestRate', function() {
          return (
            vm.controllerOptions.isFormReadOnly ||
            vm.dataModel.IsReadOnly ||
            vm.dataModel.DefaultInterest === 'PDECE' ||
            vm.dataModel.DefaultInterest === 'PDECI' ||
            vm.dataModel.DefaultInterest === 'PDEOB' ||
            vm.dataModel.DefaultInterest === 'PDERA'
          );
        });
        fs.setDisabled('CompUnitId', function() {
          vm.structCompIsSet = vm.dataModel.StructCompId;
          return vm.controllerOptions.isFormReadOnly || vm.dataModel.IsReadOnly || !vm.structCompIsSet;
        });
        fs.setDisabled('OwnerCompPartId', function() {
          return (
            vm.controllerOptions.isFormReadOnly ||
            vm.dataModel.IsReadOnly ||
            !vm.dataModel.StructCompId ||
            !vm.dataModel.CompUnitId
          );
        });
        fs.setDisabled('Partner', function() {
          return (
            vm.controllerOptions.isFormReadOnly ||
            vm.dataModel.IsReadOnly ||
            (vm.dataModel.ERPCON && vm.origIsPartner === true)
          );
        });

        //fs.hideLabel('Account2');
        //fs.hideLabel('Account3');

        //PTCCP - Társaság
        //PTCID - Magánszemély
        //PTCSE - Egyéni vállalkozó
        fs.hideField('Valid', function() {
          return !vm.dataModel.PartnerId || vm.dataModel.PartnerId === 0;
        });
        hideFieldByPartnerCatType(fs, vm, 'MainTenant', []);
        hideFieldByPartnerCatType(fs, vm, 'RegNumber', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'RegCourtId', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'StatNumber', ['PTCCP']);
        //hideFieldByPartnerCatType(fs, vm, 'StructCompId', ['PTCCP']);
        // hideFieldByPartnerCatType(
        //   fs,
        //   vm,
        //   'CompUnitId',
        //   ['PTCCP'],
        //   vm.dataModel.StructCompId === null || vm.dataModel.StructCompId === ''
        // );
        // hideFieldByPartnerCatType(
        //   fs,
        //   vm,
        //   'OwnerCompPartId',
        //   ['PTCCP'],
        //   vm.dataModel.StructCompId === null || vm.dataModel.StructCompId === ''
        // );
        //hideFieldByPartnerCatType(fs, vm, 'InvRecipient', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'Assign', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'MainTenantPartId', []);
        hideFieldByPartnerCatType(fs, vm, 'SECardNumber', ['PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'SERegNumber', ['PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'TaxId', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'IdNumber', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'IdCard', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'PlaceOfBirth', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'DateOfBirth', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'BirthName', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'MotherName', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'Nationality', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'BSName', ['PTCID']);
        hideFieldByPartnerCatType(fs, vm, 'BSStart', ['PTCID']);
        hideFieldByPartnerCatType(fs, vm, 'BSEnd', ['PTCID']);
        hideFieldByPartnerCatType(fs, vm, 'BSValue', ['PTCID']);
        hideFieldByPartnerCatType(fs, vm, 'TaxNumber', ['PTCSE', 'PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'InstituteId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'PostId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'PhoneBookId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'EuPartner', ['PTCSE', 'PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'EuTaxNumber', ['PTCSE', 'PTCCP']);
        // hideFieldByPartnerCatType(fs, vm, 'CashAccounting', ['PTCSE', 'PTCCP']);
        // hideFieldByPartnerCatType(fs, vm, 'Kata', ['PTCSE', 'PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'GroupTaxNumber', ['PTCSE', 'PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'SSNumber', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'ForeignName', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'InstituteId', ['PTCCP']);
        setRequiredByPartnerCatType(fs, vm, 'Nationality', ['PTCID', 'PTCSE']);

        fs.setRequired('CompUnitId', function() {
          return vm.structCompIsSet > 0;
        });
        fs.setRequired('Valid', function() {
          //Create es Duplicate-nel nem kotelezo a Valid combo
          return !(vm.dataModel.ModelState === 2 || vm.dataModel.ModelState === 4);
        });
        fs.setRequired('TaxNumber', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (
            (typeValue == 'PTCSE' || typeValue == 'PTCCP') &&
            vm.dataModel.EuPartner == true &&
            !vm.dataModel.EuTaxNumber
            //&& (!vm.dataModel.OwnerCompPartId || !vm.dataModel.OwnerCompPartId.Value)
          );
        });
        fs.setRequired('EuTaxNumber', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (
            (typeValue == 'PTCSE' || typeValue == 'PTCCP') &&
            pagdprValue == 'PAGDPR_YES' &&
            vm.dataModel.EuPartner == true &&
            (!vm.dataModel.TaxNumber || !!vm.dataModel.EuTaxNumber)
          );
        });
        fs.setRequired('BirthName', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (typeValue == 'PTCSE' || typeValue == 'PTCID') && pagdprValue == 'PAGDPR_YES';
        });
        fs.setRequired('MotherName', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (typeValue == 'PTCSE' || typeValue == 'PTCID') && pagdprValue == 'PAGDPR_YES';
        });
        fs.setRequired('PlaceOfBirth', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (typeValue == 'PTCSE' || typeValue == 'PTCID') && pagdprValue == 'PAGDPR_YES';
        });
        fs.setRequired('DateOfBirth', function() {
          var typeValue = vm.getPExtraProperty('PartnerCatType');
          var pagdprValue = vm.getPExtraProperty('PAGDPR');
          return (typeValue == 'PTCSE' || typeValue == 'PTCID') && pagdprValue == 'PAGDPR_YES';
        });
        fs.setRequired('AddressType', function() {
          return addressRequired();
        });
        fs.setRequired('PostCode', function() {
          return addressRequired();
        });
        fs.setRequired('Locality', function() {
          return addressRequired();
        });
        fs.setRequired('Country', function() {
          return addressRequired();
        });
        fs.setRequired('TopogrNumber', function() {
          return (
            addressRequired() &&
            (!vm.dataModel.Street?.trim() || !vm.dataModel.StreetChar?.trim() || !vm.dataModel.StreetNumber?.trim())
          );
        });
        fs.setRequired('Street', function() {
          return addressRequired() && !vm.dataModel.TopogrNumber?.trim();
        });
        fs.setRequired('StreetChar', function() {
          return addressRequired() && !vm.dataModel.TopogrNumber?.trim();
        });
        fs.setRequired('StreetNumber', function() {
          return addressRequired() && !vm.dataModel.TopogrNumber?.trim();
        });
        fs.setRequired('Valid', function() {
          //Create es Duplicate-nel nem kotelezo a Valid combo
          return !(vm.dataModel.ModelState === 2 || vm.dataModel.ModelState === 4);
        });
        fs.setRequired('Bank', function() {
          return (
            (!vm.dataModel.PartnerId || vm.dataModel.PartnerId === 0) &&
            vm.dataModel.Partner &&
            vm.dataModel.Payment === 'S'
          );
        });
        fs.setRequired('AccountName', function() {
          return (
            (!vm.dataModel.PartnerId || vm.dataModel.PartnerId === 0) &&
            vm.dataModel.Partner &&
            vm.dataModel.Payment === 'S'
          );
        });
        fs.setRequired('Account', function() {
          return (
            (!vm.dataModel.PartnerId || vm.dataModel.PartnerId === 0) &&
            vm.dataModel.Partner &&
            vm.dataModel.Payment === 'S'
          );
        });

        fs.setOnChangeFunction('PartnerCatId', function(selectedItem) {
          SetModelExtraPropBasedOnSelectedItem(vm.dataModel.extraProperties, 'PartnerCatType', selectedItem);
          $http({
            method: 'GET',
            url: 'Partner/GetPartnerDefaultFieldsQuery',
          }).then(function successCallback(response) {
            if (response !== null && response.data) {
              vm.dataModel.Currency = response.data.Dto.Currency;
              vm.dataModel.DueDateType = response.data.Dto.DueDateType;
              vm.dataModel.DefaultInterest = response.data.Dto.DefaultInterest;
            }
          });
          let partnerCatType = vm.getPExtraProperty('PartnerCatType');
          //PTCCP - Társaság
          //PTCID - Magánszemély
          //PTCSE - Egyéni vállalkozó
          switch (partnerCatType) {
            case 'PTCSE':
              setFieldPosition(vm.pageModel, vm.FormlyFormPanelDescriptors, 'PostId', 7, 3);
              setFieldPosition(vm.pageModel, vm.FormlyFormPanelDescriptors, 'EuPartner', 9, 1);
              break;
            case 'PTCCP':
              setFieldPosition(vm.pageModel, vm.FormlyFormPanelDescriptors, 'PostId', 6, 3);
              setFieldPosition(vm.pageModel, vm.FormlyFormPanelDescriptors, 'EuPartner', 8, 3);
              break;
            case 'PTCID':
            default:
              setFieldPosition(vm.pageModel, vm.FormlyFormPanelDescriptors, 'PostId', 9, 1);
              break;
          }
          //   clearFields(model.dto);
        });
        fs.setOnChangeFunction('Valid', function(selectedItem) {
          if (!!selectedItem.key && selectedItem.key !== '') {
            if (vm.formMode != 'View') {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            $state.go('Partner.Edit', {
              id: vm.dataModel.PartnerId,
              valid: vm.dataModel.Valid,
            });
          }
        });
        // fs.setOnChangeFunction('Payment', function(selectedItem) {
        // vm.paymentHasCash = selectedItem.extraProperties?.find(x => x.key == 'Cash')?.value == 'True';
        // });
        fs.setOnChangeFunction('DefaultInterest', function() {
          if (vm.dataModel.DefaultInterest === 'PDEBU') {
            vm.dataModel.DefaultInterestRate = 8;
          } else {
            vm.dataModel.DefaultInterestRate = 0;
          }
        });
        fs.setOnChangeFunction('DefaultInterestRate', function() {
          if (
            !!vm.dataModel.DefaultInterestRate &&
            vm.dataModel.DefaultInterestRate > 1000 &&
            (vm.dataModel.DefaultInterest === 'PDEFI' ||
              vm.dataModel.DefaultInterest === 'PDEPU' ||
              vm.dataModel.DefaultInterest === 'PDEPE')
          ) {
            vm.dataModel.DefaultInterestRate = 999.99;
          }
        });
        fs.setOnChangeFunction('Country', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('PostCode', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Locality', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Quarter', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Street', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('StreetChar', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('StreetNumber', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Building', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Stairway', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Floor', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('Door', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('TopogrNumber', function() {
          FNSetFullAddr();
        });
        fs.setOnChangeFunction('BSStart', function() {
          reValidate();
        });
        fs.setOnChangeFunction('BSEnd', function() {
          reValidate();
        });
        fs.setOnChangeFunction('AddressType', function(selectedItems) {
          if (selectedItems.length > 0 && !selectedItems.includes('PATIN')) {
            selectedItems.push('PATIN');
            vm.pageModel.Fields.AddressType.FormlyFieldDescriptor.value(selectedItems.join(','));
          }
        });
        fs.setOnChangeFunction('PropertyF2', function(selectedItem) {
          if (selectedItem?.GridItem) {
            vm.dataModel.PostCode = selectedItem.GridItem.PostCode ? selectedItem.GridItem.PostCode : '';
            vm.dataModel.Locality = {
              Text: selectedItem.GridItem.Locality,
              Value: selectedItem.GridItem.Locality,
            };
            vm.dataModel.PostCode = {
              Text: selectedItem.GridItem.PostCode,
              Value: selectedItem.GridItem.PostCode,
            };
            vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
              selectedItem.GridItem.Locality
            );
            vm.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
              selectedItem.GridItem.PostCode
            );
            vm.dataModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
            vm.dataModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
            vm.dataModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
            vm.dataModel.StreetNumber = selectedItem.GridItem.StreetNumber ? selectedItem.GridItem.StreetNumber : '';
            vm.dataModel.Stairway = selectedItem.GridItem.Stairway ? selectedItem.GridItem.Stairway : '';
            vm.dataModel.Building = selectedItem.GridItem.Building ? selectedItem.GridItem.Building : '';
            vm.dataModel.Floor = selectedItem.GridItem.Floor ? selectedItem.GridItem.Door : '';
            vm.dataModel.Door = selectedItem.GridItem.Door ? selectedItem.GridItem.Door : '';
            vm.dataModel.TopogrNumber = selectedItem.GridItem.TopogrNumber ? selectedItem.GridItem.TopogrNumber : '';
          }
        });
        fs.setOnBlurFunction('Name', function() {
          if (!vm.hasDifferentInvoiceName || (!!vm.dataModel.Name && !vm.dataModel.InvoiceName)) {
            vm.dataModel.InvoiceName = vm.dataModel.Name;
          }
        });
        fs.setOnBlurFunction('InvoiceName', function() {
          vm.hasDifferentInvoiceName = vm.dataModel.Name !== vm.dataModel.InvoiceName;
        });
        fs.setOnBlurFunction('PostCode', function(selectedItem) {
          if (
            ((!!selectedItem && selectedItem.Value) || selectedItem.Text) &&
            vm.postCodeValue !== selectedItem.Value
          ) {
            if (selectedItem.GridItem) {
              vm.dataModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };

              vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
                selectedItem.GridItem.Locality
              );

              vm.dataModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
              vm.dataModel.Quarter = selectedItem.GridItem.Quarter ? selectedItem.GridItem.Quarter : '';
              vm.dataModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
              vm.dataModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
              FNSetFullAddr();
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Text).then(
                function(result) {
                  var partAddress = result.data.result.Dto;
                  var locality = partAddress.Locality.Value;
                  if (locality) {
                    vm.dataModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                    vm.dataModel.Country = partAddress.Country ? partAddress.Country : '';
                    vm.dataModel.Quarter = partAddress.Quarter ? partAddress.Quarter : '';
                    vm.dataModel.Street = partAddress.Street ? partAddress.Street : '';
                    vm.dataModel.StreetChar = partAddress.StreetChar ? partAddress.StreetChar : '';
                    FNSetFullAddr();
                  }
                },
                function(error) {}
              );
            }
            vm.postCodeValue = vm.dataModel.PostCode.Value;
            vm.localityValue = vm.dataModel.Locality.Value;
          }
        });
        fs.setOnBlurFunction('Locality', function(selectedItem) {
          if (!!selectedItem && selectedItem.Value && vm.localityValue !== selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.dataModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.dataModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
              vm.dataModel.Quarter = selectedItem.GridItem.Quarter ? selectedItem.GridItem.Quarter : '';
              vm.dataModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
              vm.dataModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
              FNSetFullAddr();
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Text).then(
                function(result) {
                  var partAddress = result.data.result.Dto;
                  if (partAddress) {
                    var postcode = partAddress.PostCode.Value;
                    if (postcode) {
                      if (
                        !vm.dataModel.PostCode ||
                        !vm.dataModel.PostCode.Value ||
                        postcode == vm.dataModel.PostCode.Value
                      ) {
                        vm.dataModel.PostCode = {
                          Text: postcode,
                          Value: postcode,
                        };
                        vm.dataModel.Country = partAddress.Country ? partAddress.Country : '';
                        vm.dataModel.Quarter = partAddress.Quarter ? partAddress.Quarter : '';
                        vm.dataModel.Street = partAddress.Street ? partAddress.Street : '';
                        vm.dataModel.StreetChar = partAddress.StreetChar ? partAddress.StreetChar : '';
                        FNSetFullAddr();
                      } else {
                        $http.get('Partner/GetAllLocalities?postcode=' + vm.dataModel.PostCode.Value).then(
                          function(result) {
                            var localities = result.data.result.Localities;
                            if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                              vm.dataModel.PostCode = {
                                Text: postcode,
                                Value: postcode,
                              };
                              FNSetFullAddr();
                            }
                          },
                          function(error) {}
                        );
                      }
                    }
                  }
                },
                function(error) {}
              );
            }
            vm.localityValue = vm.dataModel.Locality.Value;
          }
        });
        fs.setOnBlurFunction('Account', function() {
          if (vm.dataModel.Account?.length > 7) {
            $http
              .post('Grid/Data', {
                tableName: 'FlgBank',
                whereCondition: "Bank~eq~'" + vm.dataModel.Account?.substring(0, 8) + "'",
                columnCsv: 'Bank,Name',
                idColumn: 'BankId',
                adopter: model.pageModel.Grids.GridPartContract.Adopter,
                installAdopter: model.pageModel.Grids.GridPartContract.InstallAdopter,
                pageSize: 0,
                page: 1,
              })
              .then(function(response) {
                if (!!response.data?.Data[0]?.Name?.trim()) {
                  vm.dataModel.Bank = response.data?.Data[0]?.Name.trim();
                }
              });
          }
        });

        fs.setSyncValidator('PartnerCode', 'nospecialchar', function(modelValue, viewValue) {
          if (modelValue !== null && modelValue !== '') {
            return partnerCodeRegexValidate(modelValue);
          }
          return true;
        });
        fs.setSyncValidator('ValidFrom', 'PartnerValidFromValidator', function(modelValue, viewValue) {
          if (vm.dataModel.ValidTo === null) {
            return true;
          }
          if (!modelValue || !viewValue) {
            return false;
          }

          var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
          var validToValue = new moment(vm.dataModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

          return validFromValue.isBefore(validToValue);
        });

        fs.setSyncValidator('BSStart', 'PartnerBSValidator', function(modelValue, viewValue) {
          if (!modelValue) {
            return true;
          }
          var BSStartValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
          var BSEndValue = new moment(vm.dataModel.BSEnd, kendo.culture().calendar.patterns.d.toUpperCase());
          if (!vm.dataModel.BSEnd) {
            return true;
          }
          return BSStartValue.isSameOrBefore(BSEndValue);
        });

        fs.setSyncValidator('BSEnd', 'PartnerBSValidator', function(modelValue, viewValue) {
          if (!modelValue) {
            return true;
          }
          var BSStartValue = new moment(vm.dataModel.BSStart, kendo.culture().calendar.patterns.d.toUpperCase());
          var BSEndValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
          return BSStartValue.isSameOrBefore(BSEndValue);
        });

        var customCallbackFunctions = {
          Partner: function(selectedItem) {
            if (
              vm.dataModel.Partner === false &&
              (vm.dataModel.PartnerCode !== null || vm.dataModel.PartnerCode !== '')
            ) {
              vm.dataModel.PartnerCode = '';
            }
          },
        };

        InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
        var onClickFunctions = {
          PropertyF2Btn: function(selectedItem) {
            vm.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.options.openF2Modal();
          },
        };
        InsertOnClickFunctions(vm.pageModel, onClickFunctions);

        fs.setSyncValidator('DueDateDays', 'Validator', function(modelValue, viewValue) {
          return modelValue >= -2;
        });
        fs.setSyncValidator('ValidTo', 'PartAddressValidToValidator', function(modelValue, viewValue) {
          if (!modelValue || !viewValue) {
            return true;
          }

          var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
          var validFromValue = new moment(vm.dataModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

          return validToValue.isSameOrAfter(validFromValue);
        });
        fs.setSyncValidator('PostCode', 'PartAddressPostCodeValidator', function(modelValue, viewValue) {
          if (vm.dataModel.Country == 'HU') {
            if (/^[1-9]\d{3}$/g.test(modelValue.Text)) {
              return true;
            } else {
              return false;
            }
          } else {
            var postCode = parseFloat(modelValue.Text);
            if (!isNaN(postCode) && postCode < 0) {
              return false;
            } else {
              return true;
            }
          }
        });
        fs.setSyncValidator('StreetNumber', 'PartAddressStreetNumberValidator', function(modelValue, viewValue) {
          if (!!modelValue?.trim()) {
            return /^[1-9].*/g.test(modelValue);
          }
          return true;
        });
        fs.setSyncValidator('Email', 'PartLinkEmailValidator', function(modelValue, viewValue) {
          if (modelValue != null && modelValue != '') {
            return sysEmailValidate(modelValue);
          }
          return true;
        });

        fs.setFormatters('Iban', [FF_ToUpperCase]);

        fs.setDynamicQueryParameters('OwnerCompPartId', function() {
          return [
            {
              key: vm.dataModel.PartnerId,
              text: 'partnerId',
            },
            {
              key: vm.dataModel.StructCompId,
              text: 'structCompId',
            },
          ];
        });

        fs.hideField('RepPartId', function() {
          return (
            !!vm.dataModel.Representative ||
            !ShowFieldBasedOnExtraProp(vm.dataModel.extraProperties, 'PartnerCatType', ['PTCCP'])
          );
        });

        fs.hideField('CompRepPartId', function() {
          return (
            !!vm.dataModel.Representative ||
            !ShowFieldBasedOnExtraProp(vm.dataModel.extraProperties, 'PartnerCatType', ['PTCCP'])
          );
        });

        var whereConditionPropertyF2Function = function() {
          return "Level~eq~'PPRRU'";
        };

        vm.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = whereConditionPropertyF2Function;
        vm.pageModel.Fields.Valid.transData = function() {
          return {
            id: vm.dataModel.PartnerId,
          };
        };

        vm.pageModel.Fields.OwnerCompPartId.transData = function() {
          return {
            id: vm.dataModel.PartnerId,
          };
        };
        // Set editability of fields based on controllerOptions
        if (vm.controllerOptions.isFormReadOnly || vm.dataModel.IsReadOnly) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            if (key !== 'Valid') {
              value.FormlyFieldDescriptor.templateOptions.disabled = true;
            }
          });
        }
      }

      function hideFieldByPartnerCatType(fs, vm, fieldName, types, orFilter) {
        if (orFilter === null) {
          orFilter = false;
        }
        fs.hideField(fieldName, function() {
          return !ShowFieldBasedOnExtraProp(vm.dataModel.extraProperties, 'PartnerCatType', types);
        });
      }

      function setRequiredByPartnerCatType(fs, vm, fieldName, types) {
        fs.setRequired(fieldName, function() {
          return ShowFieldBasedOnExtraProp(vm.dataModel.extraProperties, 'PartnerCatType', types);
        });
      }

      var clearFields = function(fields) {
        angular.forEach(fields, function(value, key) {
          if (fieldToClearList.indexOf(key) !== -1) {
            model.dto[key] = null;
          }
        });
      };

      function print(formElement) {
        if (!!formElement && formElement == vm.dataModel.Country) {
          return formElement + ' ';
        }
        if (!!formElement) {
          return ' ' + formElement;
        } else {
          return '';
        }
      }
      function FNSetFullAddr() {
        if (
          !!vm.dataModel.Locality &&
          !!vm.dataModel.PostCode &&
          vm.dataModel.Locality.Text != null &&
          vm.dataModel.PostCode.Text != null
        ) {
          vm.dataModel.Address =
            print(vm.dataModel.Country) +
            vm.dataModel.PostCode.Text +
            ' ' +
            vm.dataModel.Locality.Text +
            print(vm.dataModel.Quarter) +
            print(vm.dataModel.Street) +
            print(vm.dataModel.StreetChar) +
            print(vm.dataModel.StreetNumber) +
            print(vm.dataModel.Building) +
            print(vm.dataModel.Stairway) +
            print(vm.dataModel.Floor) +
            print(vm.dataModel.Door) +
            print(vm.dataModel.TpogrNumber);
        }
      }

      function getActualPartBankInfo(tmId) {
        $http({
          method: 'GET',
          url: 'Partner/GetActualPartBankInfo',
          params: { partnerTmId: vm.dataModel.PartnerTmId },
        }).then(function successCallback(response) {
          if (response !== null) {
            vm.dataModel.Account = response.data.Dto.Account1.Value;
            //  vm.dataModel.Account2 = response.data.Dto.Account2;
            //  vm.dataModel.Account3 = response.data.Dto.Account3;
            vm.dataModel.AccountName = response.data.Dto.AccountName;
            vm.dataModel.Bank = response.data.Dto.Bank;
          }
        });
      }

      vm.deleteCallbackFunction = function deleteCallbckFunction(result) {
        if (result.gridName === 'GridPartBank') {
          getActualPartBankInfo();
        }
      };

      var fieldToClearList = [
        'MainTenantPartId',
        'TaxNumber',
        'RegNumber',
        'RegCourtId',
        'StatNumber',
        'StructCompId',
        'CompUnitId',
        'OwnerCompPartId',
        'PhoneBookId',
        'InstituteId',
        'PostId',
        'BSName',
        'BSStart',
        'BSEnd',
        'BSValue',
        'Payment',
        'InvPayPartId',
        'AvalPartId',
        'DueDateDays',
        'DefaultInterestRate',
        'TaxId',
        'IdNumber',
        'IdCard',
        'DateOfBirth',
        'PlaceOfBirth',
        'BirthName',
        'MotherName',
        'SECardNumber',
        'SERegNumber',
      ];

      function reValidate() {
        vm.pageModel.Fields.BSStart.FormlyFieldDescriptor.formControl.$validate();
        vm.pageModel.Fields.BSEnd.FormlyFieldDescriptor.formControl.$validate();
      }

      function partnerCodeRegexValidate(partnerCode) {
        var regexp = /^[a-zA-Z0-9áéíóöőúüűÁÉÍÓÖŐÚÜŰ-]*$/;
        return regexp.test(partnerCode);
      }

      function addressRequired() {
        return (
          (vm.dataModel.Partner === true ||
            !!vm.dataModel.AddressType?.trim() ||
            !!vm.postCodeValue?.trim() ||
            !!vm.localityValue?.trim() ||
            !!vm.dataModel.Country?.trim() ||
            !!vm.dataModel.TopogrNumber?.trim() ||
            !!vm.dataModel.Street?.trim() ||
            !!vm.dataModel.StreetChar?.trim() ||
            !!vm.dataModel.StreetNumber?.trim()) &&
          (!vm.dataModel.PartnerId || vm.dataModel.PartnerId === 0)
        );
      }

      vm.WAL = WAL;

      function WAL() {
        walService.NavigateToWal('Partner', 'ParnerNavWal', 'FlgPartnerView');
      }

      vm.WAL2 = function WAL2() {
        switch (vm.activeSubItemTab) {
          case 0: // Bankszámlaszámok
            walService.NavigateToWal('Partner', 'PartnerMODPartBankNavWal', 'FlgPartBank');
            break;
          case 1: // Címek
            walService.NavigateToWal('Partner', 'PartnerMODPartAddressNavWal', 'FlgPartAddressView');
            break;
          case 2: // Elérhetőségek
            walService.NavigateToWal('Partner', 'PartnerMODPartLinkNavWal', 'FlgPartLinkView');
            break;
          case 3: // Minősítések
            walService.NavigateToWal('Partner', 'PartnerMODPartClassificationNavWal', 'FlgPartClassificationView');
            break;
          default:
            break;
        }
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('MovingProjectNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, $uibModal, $filter, authService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MovingProjectNavCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createMovingProject = createMovingProject;
      vm.editMovingProject = editMovingProject;
      vm.deleteMovingProject = deleteMovingProject;
      vm.duplicateMovingProject = duplicateMovingProject;

      vm.createMovingPlan = createMovingPlan;
      vm.executeMovingPlan = executeMovingPlan;
      vm.attachDocument = attachDocument;

      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.back = function() {
        $state.go('main');
      };

      function attachDocument() {
        var id = getSelectedGridItemId('GridMovingProject');
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgMovingProject', id);
      }

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
          return {
            gridModel,
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      vm.subGridOptions.GridMovingProjectRow.autoBind = false;

      vm.subGridOptions.GridMovingProject['detailInit'] = function(e) {
        if (vm.subGrids.GridMovingProjectRow.dataSource)
          vm.subGrids.GridMovingProjectRow.dataSource.read({ parentMovingProjectId: e.data.MovingProjectId });
      };

      function createMovingProject() {
        var itemId = 0;
        var url = 'Partner/MovingProjectEdit?id=' + itemId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Partner/MovingProjectEdit.html',
          controller: 'MovingProjectEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.subGrids['GridMovingProject'].dataSource.read();
        });
      }

      function editMovingProject() {
        var itemId = getSelectedGridItemId('GridMovingProject');
        if (!!itemId) {
          var url = 'Partner/MovingProjectEdit?id=' + itemId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Partner/MovingProjectEdit.html',
            controller: 'MovingProjectEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrids['GridMovingProject'].dataSource.read();
          });
        }
      }

      function duplicateMovingProject() {
        var itemId = getSelectedGridItemId('GridMovingProject');
        if (!!itemId) {
          var url = 'Partner/MovingProjectDuplicate?id=' + itemId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Partner/MovingProjectEdit.html',
            controller: 'MovingProjectEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrids['GridMovingProject'].dataSource.read();
          });
        }
      }

      function deleteMovingProject() {
        var itemId = getSelectedGridItemId('GridMovingProject');
        if (!!itemId) {
          var url = 'Partner/MovingProjectDelete?id=' + itemId;
          var dialogMessage = vm.messages.DialogConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .success(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.subGrids['GridMovingProject'].dataSource.read();
                    })
                    .error(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function createMovingPlan() {
        var selectedItem = getSelectedGridItem('GridMovingProject');
        if (selectedItem !== null) {
          $state.go('Partner.MovingPlanEdit', { movingProjectId: selectedItem.MovingProjectId });
        }
      }

      function executeMovingPlan() {
        var selectedItem = getSelectedGridItem('GridMovingProject');
        if (selectedItem !== null) {
          if (selectedItem.Status === true) {
            toastr.warning('Az esemény státusza már végrahajtva!');
          } else {
            var id = selectedItem.MovingProjectId;
            var url = 'Partner/MovingPlanExecute?movingProjectId=' + id;

            var dialogMessage = vm.messages.DialogConfirmDelete;
            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Warning,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http
                      .get(url)
                      .success(function() {
                        toastr.success(vm.messages.DeleteSuccessful);
                        vm.subGrids['GridMovingProject'].dataSource.read();
                      })
                      .error(function(response) {
                        toastr.error(vm.pageModel.Messages.DeleteFailed);
                      });
                  },
                },
              },
            });
          }
        }
      }

      function getSelectedGridItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('MovingProjectEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MovingProjectEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.formModifiers = {};

      var onChangeFunctions = {
        ValidFrom: function(selectedItem) {
          vm.formModel.TenantPartId = null;
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.MovingProjectId.FormlyFieldDescriptor.className += ' movingProjectId';
      vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.templateOptions.required = false;
      vm.pageModel.Fields.ForTenantPart.FormlyFieldDescriptor.hide = true;
      vm.pageModel.Fields.Optimization.FormlyFieldDescriptor.hide = true;

      delete vm.pageModel.Fields.ReasonOfMoving.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.ReasonOfMoving.FormlyFieldDescriptor.templateOptions['changed'] = function(e) {
        vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.hide = vm.formModel.ReasonOfMoving !== 1;
      };

      vm.pageModel.Fields.ReasonOfMoving.FormlyFieldDescriptor.template =
        '<label style="width:50%;"><input type="radio" ng-value="1" ng-model="model[options.key]" name="RadioGroup1" class="radio formly-field-radio" ng-change="to.changed(model[options.key])">' +
        vm.pageModel.Fields.ForTenantPart.FormlyFieldDescriptor.templateOptions.label +
        '</label>' +
        '<label style="width:50%;"><input type="radio" ng-value="2" ng-model="model[options.key]" name="RadioGroup1" class="radio formly-field-radio" ng-change="to.changed(model[options.key])">' +
        vm.pageModel.Fields.Optimization.FormlyFieldDescriptor.templateOptions.label +
        '</label>';

      vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.hide = vm.formModel.ReasonOfMoving !== 1;
      vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        validFrom: vm.formModel.ValidFrom,
      };

      // Actions
      function save() {
        $http
          .post('Partner/MovingProjectSave', vm.formModel)
          .success(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .error(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('MovingPlanEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MovingPlanEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      vm.ContainerPartnerDS = [];
      vm.PremiseListDS = [];
      vm.UserPartnerDS = [];
      vm.PropertyListDS = [];

      vm.selectedContractIds = [];

      vm.ContainerUserTemplate = $('#ContainerUserTemplate').html();
      vm.PremiseListTemplate = $('#PremiseListTemplate').html();
      vm.PropertyListTemplate = $('#PropertyListTemplate').html();

      vm.getRentSpace = getRentSpace;
      vm.getStuffNumber = getStuffNumber;

      vm.rentPBChanged = rentPBChanged;
      vm.stuffPBChanged = stuffPBChanged;

      vm.movingSchemaSaved = false;
      vm.movingSchemaDefaulted = false;

      vm.back = function() {
        console.log(vm);
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.MovingProjectNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.MovingSchemaId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgMovingSchema', id);
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        PropertyId: function(selectedItems) {
          if (!!selectedItems) {
            if (typeof selectedItems.length == 'undefined') {
              selectedItems = [selectedItems];
            }

            vm.formModel.PropertyIds = selectedItems.map(function(a) {
              return a.PropertyId;
            });
            vm.formModel.PropertyId.Text = selectedItems
              .map(function(a) {
                return a.PropertyName;
              })
              .toString();
            vm.formModel.PropertyId.Value = vm.formModel.PropertyIds.toString();

            vm.formModel.PremiseIds = [];
            vm.formModel.PremiseId.Text = '';
            vm.formModel.PremiseId.Value = '';

            vm.selectedContractIds = selectedItems.map(function(a) {
              return a.ContractId;
            });

            getContainerUsers(vm.selectedContractIds);
          } else {
            if (vm.formModel.PropertyId != null && vm.formModel.PremiseId != null) {
              if (
                vm.formModel.PropertyId.Text === 'null' ||
                vm.formModel.PropertyId.Text == null ||
                vm.formModel.PropertyId.Value === 'null' ||
                vm.formModel.PropertyId.Value == null
              ) {
                vm.formModel.PropertyIds = [];
                vm.formModel.PropertyId.Text = '';
                vm.formModel.PropertyId.Value = '';
              }
              if (
                vm.formModel.PremiseId.Text === 'null' ||
                vm.formModel.PremiseId.Text == null ||
                vm.formModel.PremiseId.Value === 'null' ||
                vm.formModel.PremiseId.Value == null
              ) {
                vm.formModel.PremiseIds = [];
                vm.formModel.PremiseId.Text = '';
                vm.formModel.PremiseId.Value = '';
              }
            }
          }

          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            movingProjectTenantPartId: vm.formModel.MovingProjectId,
            movingProjectValidFrom: vm.formModel.MovingProjectValidFrom,
          };

          vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            propertyIds: vm.formModel.PropertyIds,
          };
        },
        PremiseId: function(selectedItems) {
          if (vm.formModel.PremiseId.Value == 0 || vm.formModel.PremiseId.Text == 0) {
            vm.formModel.PremiseId.Text = '';
            vm.formModel.PremiseId.Value = '';
          }

          if (!!selectedItems) {
            vm.formModel.PremiseIds = selectedItems.map(function(a) {
              return a.PremiseId;
            });
            vm.formModel.PremiseId.Text = selectedItems
              .map(function(a) {
                return a.PremiseId;
              })
              .toString();
            vm.formModel.PremiseId.Value = vm.formModel.PremiseIds.toString();
          } else {
            if (vm.formModel.PropertyId != null && vm.formModel.PremiseId != null) {
              if (
                vm.formModel.PremiseId.Text === 'null' ||
                vm.formModel.PremiseId.Text == null ||
                vm.formModel.PremiseId.Value === 'null' ||
                vm.formModel.PremiseId.Value == null
              ) {
                vm.formModel.PremiseIds = [];
                vm.formModel.PremiseId.Text = '';
                vm.formModel.PremiseId.Value = '';
              }
            }
          }
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      delete vm.pageModel.Fields.DefaultBtn.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.DefaultBtn.FormlyFieldDescriptor.template =
        '<a class="btn btn-default" id="setDefaultBtn" title="Alaphelyzet" style="border-radius: 0px !important; margin-top: 10px; padding-top: 4px; padding-bottom: 2px;">Alaphelyzet</a>';

      delete vm.pageModel.Fields.SaveBtn.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.SaveBtn.FormlyFieldDescriptor.template =
        '<a class="btn btn-default" id="saveMovingSchemaBtn" title="Mentés" style="border-radius: 0px !important; margin-top: 10px; padding-top: 4px; padding-bottom: 2px;">Mentés</a>';

      vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        validFrom: vm.formModel.MovingProjectValidFrom,
      };

      function setDefault() {
        if (vm.movingSchemaDefaulted) {
          vm.movingSchemaDefaulted = false;
          return;
        }

        var url = 'Partner/SetMovingPlanDefault?movingProjectId=' + vm.formModel.MovingProjectId;
        var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http
                  .get(url)
                  .success(function() {
                    toastr.success('Sikeres visszaállítás');
                    getContainerUsers(vm.selectedContractIds);
                  })
                  .error(function(response) {
                    toastr.error('Sikertelen visszaállítás');
                  });
              },
            },
          },
        });

        vm.movingSchemaDefaulted = true;
      }

      function saveMovingSchema() {
        if (!vm.movingSchemaSaved) {
          vm.movingSchemaSaved = true;
          updateFormModelMovingSchemaItems();

          $http
            .post('Partner/MovingSchemaEdit', vm.formModel)
            .success(function(response) {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              $state.go('Partner.MovingProjectNav');
            })
            .error(function(response) {
              vm.movingSchemaSaved = false;
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        }
      }

      function updateFormModelMovingSchemaItems() {
        var currentList = [];
        vm.formModel.MovingSchemaList = [];

        currentList = vm.ContainerPartnerDS.filter(function(ms) {
          return ms.PremiseToId != -1 && ms.PremiseFromId != -1;
        });

        for (var i = 0; i < currentList.length; i++) {
          vm.formModel.MovingSchemaList.push(currentList[i]);
        }

        angular.forEach(vm.UserPartnerDS, function(value, key) {
          currentList = value.filter(function(ms) {
            return ms.PremiseToId != -1 && ms.PremiseFromId != -1;
          });
          for (var i = 0; i < currentList.length; i++) {
            vm.formModel.MovingSchemaList.push(currentList[i]);
          }
        });
      }

      function getContainerUsers(contractIds) {
        $('#setDefaultBtn').on('click', function() {
          setDefault();
        });

        $('#saveMovingSchemaBtn').on('click', function() {
          saveMovingSchema();
        });

        vm.movingSchemaSaved = false;
        vm.movingSchemaDefaulted = false;

        var params = { model: vm.formModel, contractIds: contractIds };

        $http
          .post('Partner/GetContainerUsers', params)
          .success(function(response) {
            if (!!response) {
              vm.formModel = response;

              vm.ContainerPartnerDS = vm.formModel.MovingSchemaList.filter(function(ms) {
                return ms.PremiseFromId == 0 && ms.PremiseToId == -1;
              });

              vm.PropertyListDS = vm.formModel.Properties;

              for (var j = 0; j < vm.PropertyListDS.length; j++) {
                var propertyId = vm.PropertyListDS[j].PropertyId;

                vm.PremiseListDS[propertyId] = vm.PropertyListDS[j].Premises;

                for (var i = 0; i < vm.PremiseListDS[propertyId].length; i++) {
                  var premise = vm.PremiseListDS[propertyId][i];
                  vm.UserPartnerDS[premise.PremiseId] = vm.formModel.MovingSchemaList.filter(function(ms) {
                    return (
                      (ms.PremiseFromId == premise.PremiseId && ms.PremiseToId == -1) ||
                      ms.PremiseToId == premise.PremiseId
                    );
                  });
                }
              }

              var oldUserPartnerTMIds = vm.formModel.MovingSchemaList.filter(function(ms) {
                return ms.PremiseToId != -1;
              }).map(function(x) {
                return x.PartnerTMId;
              });

              for (var i = 0; i < vm.ContainerPartnerDS.length; i++) {
                if (
                  jQuery.inArray(vm.ContainerPartnerDS[i].PartnerTMId, oldUserPartnerTMIds) > -1 &&
                  vm.ContainerPartnerDS[i].PremiseToId == -1
                ) {
                  vm.ContainerPartnerDS[i].PremiseFromId = -1;
                }
              }

              angular.forEach(vm.UserPartnerDS, function(value, key) {
                for (var i = 0; i < value.length - 1; i++) {
                  if (jQuery.inArray(value[i].PartnerTMId, oldUserPartnerTMIds) > -1 && value[i].PremiseToId == -1) {
                    value[i].PremiseFromId = -1;
                  }
                }
              });

              setDraggable();
            }
          })
          .error(function(response) {
            // TODO: ErrorMessage!
          });
      }

      function setDraggable() {
        setTimeout(function(e) {
          $('.userListContainer').kendoDraggable({
            filter: '.userContainer',
            hint: function(element) {
              return draggableHint(element);
            },
            dragstart: function(e) {
              var currentPartnerTMId = parseInt(e.currentTarget[0].id.replace('partner_', ''));
              var currentPremiseId = parseInt(e.currentTarget[0].offsetParent.id.replace('listView_', ''));
              var currentDs = currentPremiseId == 0 ? vm.ContainerPartnerDS : vm.UserPartnerDS[currentPremiseId];

              if (
                currentDs.find(function(x) {
                  return x.PartnerTMId == currentPartnerTMId;
                }).PremiseFromId == -1
              ) {
                e.preventDefault();
              }
            },
            dragend: draggableOnDragEnd,
          });

          $('.userListContainer').kendoDropTarget({
            drop: dropTargetOnDrop,
          });
        }, 3000);
      }

      function draggableHint(element) {
        var w = element.width();

        return element.clone().css({
          'background-color': 'white',
          width: w + 'px',
        });
      }

      function draggableOnDragEnd(e) {}

      function dropTargetOnDrop(e) {
        var currentDs = e.draggable.element.data('kendoListView').dataSource.transport.data;
        var targetDs = e.dropTarget.data('kendoListView').dataSource.transport.data;

        if (targetDs != currentDs) {
          var currentPartnerTMId = parseInt(e.draggable.currentTarget[0].id.replace('partner_', ''));

          var currentPremiseId = parseInt(e.draggable.element[0].id.replace('listView_', ''));
          var targetPremiseId = parseInt(e.dropTarget[0].id.replace('listView_', ''));

          var targetPropertyId = parseInt(e.dropTarget[0].offsetParent.id.replace('listViewPremiseList_', ''));
          //var targetContractId = ?????

          var currentUser = currentDs.find(function(x) {
            return x.PartnerTMId == currentPartnerTMId;
          });

          if (!!currentUser) {
            var draggedUser = {
              PartnerTMId: currentUser.PartnerTMId,
              PartnerName: currentUser.PartnerName,
              PostId: currentUser.PostId,
              Square: currentUser.Square,
              PremiseFromId: currentUser.PremiseFromId,
              PremiseToId: targetPremiseId,
              PropertyFromId: currentUser.PropertyFromId,
              PropertyToId: targetPropertyId,
              ContractFromId: currentUser.ContractFromId,
              ContractToId: 0,
              ContrUserId: currentUser.ContrUserId,
              MovingProjectId: currentUser.MovingProjectId,
            };

            // TODO: Vizsgálni, hogy targetDs-be befér-e a személy foglalt terület alapján
            if (!isEnoughSpaceInTargetDs(currentPremiseId, targetPremiseId, currentUser.Square)) {
              toastr.warning('Nincs elég szabad hely a költöztetéshez.');
              e.preventDefault();
              return;
            }

            if (currentUser.PremiseToId == -1) {
              currentUser.PremiseFromId = -1;
              targetDs.push(draggedUser);
            } else if (currentUser.PremiseFromId == targetPremiseId) {
              currentDs.remove(currentUser);
              targetDs.find(function(x) {
                return x.PartnerTMId == draggedUser.PartnerTMId;
              }).PremiseToId = -1;
              targetDs.find(function(x) {
                return x.PartnerTMId == draggedUser.PartnerTMId;
              }).PremiseFromId = targetPremiseId;
            } else {
              var fromDs =
                currentUser.PremiseFromId > 0 ? vm.UserPartnerDS[currentUser.PremiseFromId] : vm.ContainerPartnerDS;
              fromDs.find(function(x) {
                return x.PartnerTMId == draggedUser.PartnerTMId;
              }).PremiseToId = targetPremiseId;
              currentDs.remove(currentUser);
              targetDs.push(draggedUser);
            }

            e.draggable.element.data('kendoListView').dataSource.read();
            e.dropTarget.data('kendoListView').dataSource.read();
          }
        }
      }

      function isEnoughSpaceInTargetDs(currentPremiseId, targetPremiseId, square) {
        if (targetPremiseId > 0) {
          var targetRentProgressBar = $('#rentspace_progressbar_' + targetPremiseId).data('kendoProgressBar');
          var targetStuffProgressBar = $('#stuff_progressbar_' + targetPremiseId).data('kendoProgressBar');
          var targetRentPBValue = targetRentProgressBar.options.value;
          var targetRentPBMax = targetRentProgressBar.options.max;
          var targetStuffPBValue = targetStuffProgressBar.options.value;
          var targetStuffPBMax = targetStuffProgressBar.options.max;

          if (targetRentPBMax - targetRentPBValue < square && targetStuffPBMax >= targetStuffPBValue) {
            return false;
          }

          targetRentProgressBar.value((targetRentPBValue += square));
          targetStuffProgressBar.value((targetStuffPBValue += 1));
        }

        if (currentPremiseId > 0) {
          var currentRentProgressBar = $('#rentspace_progressbar_' + currentPremiseId).data('kendoProgressBar');
          var currentStuffProgressBar = $('#stuff_progressbar_' + currentPremiseId).data('kendoProgressBar');
          var currentRentPBValue = currentRentProgressBar.options.value;
          var currentRentPBMax = currentRentProgressBar.options.max;
          var currentStuffPBValue = currentStuffProgressBar.options.value;
          var currentStuffPBMax = currentStuffProgressBar.options.max;
          currentRentProgressBar.value((currentRentPBValue -= square));
          currentStuffProgressBar.value((currentStuffPBValue -= 1));
        }

        return true;
      }

      function rentPBChanged(premiseId) {
        var targetProgressBar = $('#rentspace_progressbar_' + premiseId).data('kendoProgressBar');

        if (!!targetProgressBar) {
          var status = targetProgressBar.options.value + '/' + targetProgressBar.options.max;
          targetProgressBar.progressStatus.text(status);
        }
      }

      function stuffPBChanged(premiseId) {
        var targetProgressBar = $('#stuff_progressbar_' + premiseId).data('kendoProgressBar');

        if (!!targetProgressBar) {
          var status = targetProgressBar.options.value + '/' + targetProgressBar.options.max;
          targetProgressBar.progressStatus.text(status);
        }
      }

      function getRentSpace(currentDs) {
        var space = 0;
        for (var i = 0; i < currentDs.length; i++) {
          if (currentDs[i].PremiseFromId != -1) {
            space += currentDs[i].Square;
          }
        }

        return space;
      }

      function getStuffNumber(currentDs) {
        var sum = 0;
        for (var i = 0; i < currentDs.length; i++) {
          if (currentDs[i].PremiseFromId != -1) {
            sum += 1;
          }
        }

        return sum;
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerNavCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'AuthService',
    '$httpParamSerializer',
    'WalService',
    'options',
    'HistoryService',
    'DasService',
    '$timeout',
    'gridService',
    'LanguageService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      authService,
      $httpParamSerializer,
      walService,
      options,
      HistoryService,
      dasService,
      $timeout,
      gridService,
      LanguageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerNavCtrl', stateParams);
      }
      var vm = this;

      init();

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);
        vm.originalPartnerCode = angular.copy(vm.dataModel.PartnerCode);
        vm.deleteMainItem = deleteMainItem;
        vm.filter = filter;
        vm.propLabels = LanguageService.getDictionary().property;
        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;

        //EditItem override

        vm.edit = function() {
          if (
            vm.dataModel.HasErpCon === true &&
            !!vm.selectedMainGridItem &&
            !!vm.selectedMainGridItem.Partner === true &&
            !vm.selectedMainGridItem.PartnerCode
          ) {
            toastr.error('A kiválasztott tétel még nem kapott Partnerkódot az ERP rendszertől!', 'Kérem várjon...');
            return;
          }
          vm.editItem();
        };

        // return dto for controller method
        vm.getFilter = function() {
          return {
            dto: vm.dataModel,
            disableTMFilter: vm.TMfilterState,
          };
        };
        vm.isCollapsed1 = true;

        initMainGrid(
          vm,
          'GridPartner',
          'Partner/ListWithFilters/',
          function() {
            changeSubItemGridFilter(vm.mainGrid);
            setDasModel();
          },
          vm.getFilter
        );
        // vm.superDetailInit = vm.mainGridOptions.detailInit;
        // vm.mainGridOptions.detailInit = function(detailInitEvent) {
        //   typeof vm.superDetailInit === 'function' && vm.superDetailInit.call(this, detailInitEvent);
        //   vm.selectedMainGridItemId = detailInitEvent.data.PartnerId;
        //   $(detailInitEvent.detailCell)
        //     .find('[kendo-grid]')
        //     .first()
        //     .data('kendoGrid')
        //     .dataSource.read();
        // };

        vm.TMfilterState = false;
        vm.toggleTMFilterState = function() {
          if (!vm.mainGridOptions.dataSource.transport.read.data) {
            vm.mainGridOptions.dataSource.transport.read.data = {};
          }
          vm.mainGrid.dataSource.read();
        };
        vm.mainGridOptions.toolbar = kendo.template($('#template').html());

        generateForm(vm);
        vm.filterFields = vm.FormlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;
      }

      // Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        vm.selectedMainGridItem = getSelectedRowFromMainGrid(vm);
        vm.selectedMainGridItemId = vm.selectedMainGridItem[vm.mainGridIdField];
      }

      function filter() {
        vm.mainGrid.dataSource.read();
      }

      function deleteMainItem() {
        var id = getSelectedRowIdFromMainGrid(vm);
        if (id === -1) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var dialogMessage;
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (selectedItems[0]['CountTM'] === 1) {
            dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage2;
          } else {
            var validFrom = new moment(
              selectedItems[0]['ValidFrom'],
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage1.replace(
              '{0}',
              validFrom.format(kendo.culture().calendar.patterns.d.toUpperCase())
            );
          }

          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Partner/PartnerDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridPartner'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      vm.history = history;
      function history() {
        HistoryService.NavigateToHistory('FlgPartner', getSelectedRowIdFromMainGrid(vm), vm, $state, true);
      }

      vm.WAL = WAL;
      function WAL() {
        walService.NavigateToWal('Partner', 'ParnerNavWal', 'FlgPartnerView');
      }
      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerNavMenuCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'gridService',
    function($scope, options, $http, $state, $uibModal, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerNavMenuCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      // MenuItems
      vm.createMainItem = createMainItem;
      vm.editMainItem = editMainItem;
      vm.deleteMainItem = deleteMainItem;
      vm.duplicateMainItem = duplicateMainItem;
      vm.viewMainItem = viewMainItem;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      // Grid configuration
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.mainGridIdField = vm.pageModel.Grids['GridPartner'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridPartner, 'Partner/List/', function() {
        changeSubItemGridFilter(vm.mainGrid);
      });
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////// [ Dynamic SubItem Form generation] ///////////////////////////
      vm.activeSubItemTab = 0;
      vm.getSelectedMainGridItemId = function() {
        return {
          targetPartnerId: vm.slectedMainGridItemId,
        };
      };

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;

          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      // Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.slectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          value.dataSource.read();
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new main item
      function createMainItem() {
        $state.go('Partner.Create', { id: 0 });
      }

      /// Edits the selected main item
      function editMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Partner.Edit', { id: id });
        }
      }

      function deleteMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = selectedItems[0][vm.mainGridIdField];
        if (!!id) {
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var dialogMessage;

            if (selectedItems[0]['CountTM'] === 1) {
              dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage2;
            } else {
              var validFrom = new moment(
                selectedItems[0]['ValidFrom'],
                kendo.culture().calendar.patterns.d.toUpperCase()
              );
              dialogMessage = vm.messages.PartnerDeleteDialogConfirmMessage1.replace(
                '{0}',
                validFrom.format(kendo.culture().calendar.patterns.d.toUpperCase())
              );
            }

            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http.get('Partner/PartnerDelete/' + id).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.mainGrid.dataSource.read();
                    });
                  },
                },
              },
            });
          }
        }
      }

      /// Duplicates the selected main item
      function duplicateMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Partner.Duplicate', { id: id }); // TODO
        }
      }

      /// Opens a non-modifyable view for the selected item
      function viewMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Partner.View', { id: id });
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      function attachDocument() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }

      function WAL() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('AidDecisionMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AidDecisionMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'Partner.PartnerNav' };
      var desc = {
        Partner_AidDecisionNav_AidDecisionNav: { icon: 'fa fa-book' },
        Partner_AidDecisionNav_AidType: { icon: 'fa fa-signal' },
      };

      buildMenu($state, authService, 'Partner_AidDecisionNav', 'partner', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerEditMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerEditMenuCtrl', stateParams);
      }
      var vm = this;

      vm.partnerList = function() {
        $state.go('Partner.PartnerNav');
      };

      vm.back = function() {
        $state.go('Partner.PartnerNav');
      };

      vm.partnerCat = function() {
        $state.go('Masterdata.Partner');
      };

      vm.financialCat = function() {
        $state.go('Masterdata.Financial');
      };

      vm.aidDecision = function() {
        $state.go('Partner.AidDecisionNav');
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerSubItemEditMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerSubItemEditMenuCtrl', stateParams);
      }
      var vm = this;

      var partnerId = $state.params.PartnerId;

      vm.partnerList = function() {
        $state.go('Partner.PartnerNav');
      };

      vm.back = function() {
        $state.go('Partner.Edit', { id: partnerId });
      };

      vm.partnerCat = function() {
        $state.go('Masterdata.Partner');
      };

      vm.financialCat = function() {
        $state.go('Masterdata.Financial');
      };

      vm.aidDecision = function() {
        $state.go('Partner.AidDecisionNav');
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var partnerId = $state.params.PartnerId;
      var backTo = $state.params.backTo;
      //
      if (backTo == 'Nav') {
        backMenu.event = function() {
          $state.go('Partner.PartnerNav');
        };
      }
      if (partnerId) {
        backMenu.event = function() {
          $state.go('Partner.Edit', { id: partnerId });
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Partner_PartnerNav: { icon: 'fa fa-users' },
        Masterdata_Partner: { icon: 'fa fa-file' },
        Masterdata_Financial: { icon: 'fa fa-dollar' },
        Partner_AidDecisionNav: { icon: 'fa fa-book' },
      };

      buildMenu($state, authService, 'Partner', 'partner', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerPartBankEditCtrl', [
    '$http',
    '$state',
    '$stateParams',
    'options',
    'AuthService',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, $state, $stateParams, options, AuthService, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerPartBankEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseBooleans = { partnerDetailsIsCollapsed: false, bankAccountNumberIsCollapsed: false };
      vm.activeBooleans = { partnerDetailsIsActive: true, bankAccountNumberIsActive: true };

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.backWithUnlock = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.Edit', { id: vm.dataModel.PartnerId });
      };

      vm.loadBank = function(bank) {
        if (bank == null) {
          return;
        }
        $http
          .get('Partner/FindBankName?bank=' + bank)
          .then(function(response) {
            vm.dataModel.Bank = response.data.bankName;
          })
          .catch(function(response) {});
      };

      // Init ////////////////////////////////////////////////////////////////////////////////
      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, options);
        initViewModel($http, $state, $stateParams, vm, options);
        initFormModel($http, $state, $stateParams, vm, options);

        partBankEditSetFields(vm);
        generateForm(vm);

        if (vm.dataModel.Account1) {
          var bank = vm.dataModel.Account1.Value;
          vm.loadBank(bank);
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////
      function partBankEditSetFields(vm) {
        vm.pageModel.AccountSeparator1 = '-';
        vm.pageModel.AccountSeparator2 = '-';

        var fs = fieldSetter;
        fs.vm = vm;
        fs.setMask('Iban', '**99 **** **** **** ***?* ?*?*?*?* ?*?*?*?* ?*?*?*?* ?*?*');
        fs.setF2Mask('Account1', '99999999');
        fs.setMask('Account2', '99999999');
        fs.setMask('Account3', '99999999');
        fs.setMask('Swift', 'AAAA ** ** ?*?*?*');

        fs.setAsSeparatorDash('AccountSeparator1');
        fs.setAsSeparatorDash('AccountSeparator2');

        fs.setRequired('Account1', function() {
          return (
            vm.dataModel.Iban == null ||
            vm.dataModel.Iban == '' ||
            vm.dataModel.Swift == null ||
            vm.dataModel.Swift == ''
          );
        });

        fs.setRequired('Account2', function() {
          if (!!vm.dataModel.Account1) {
            return vm.dataModel.Account1.Value !== null;
          }
          return vm.dataModel.Account1 !== null && vm.dataModel.Account1 !== '';
        });
        fs.hideLabel('Account2');
        fs.hideLabel('Account3');

        fs.setOnBlurFunction('Account1', function(selectedItem) {
          if (!!selectedItem && selectedItem.GridItem) {
            vm.dataModel.Bank = selectedItem.GridItem.Name;
          } else {
            var bank = selectedItem.Text;
            vm.loadBank(bank);
          }
        });

        fs.setOnChangeFunction('Account1', function() {
          vm.pageModel.Fields.Iban.FormlyFieldDescriptor.formControl.$validate();
        });
        fs.setOnChangeFunction('Account2', function() {
          vm.pageModel.Fields.Iban.FormlyFieldDescriptor.formControl.$validate();
        });
        fs.setOnChangeFunction('Account3', function() {
          vm.pageModel.Fields.Iban.FormlyFieldDescriptor.formControl.$validate();
        });

        fs.setSyncValidator('Iban', 'IbanValidator', function(modelValue, viewValue) {
          if (!!viewValue && !!vm.dataModel.Account1 && vm.dataModel.Account1.Value && vm.dataModel.Account2) {
            let regex = 'HU[0-9]{2}';
            regex += vm.dataModel.Account1.Value;
            regex += vm.dataModel.Account2;
            regex += !!vm.dataModel.Account3 ? vm.dataModel.Account3 : '00000000';
            return !!viewValue.match('^' + regex + '$');
          }
          return true;
        });
      }

      vm.save = function() {
        if (vm.dataModel.Active === true && !!vm.dataModel.AccountType) {
          $http
            .post('Partner/GetPartBankTypeIsExist', {
              partnerId: vm.dataModel.PartnerId,
              partBankId: vm.dataModel.PartBankId,
              accountType: vm.dataModel.AccountType,
            })
            .then(function(response) {
              if (response.data.ResultStatus) {
                vm.saveFn();
              } else {
                bootbox.dialog({
                  message: response.data.Errors[0].Message,
                  title: vm.pageModel.Messages.Confirm,
                  buttons: {
                    cancel: {
                      label: vm.pageModel.Messages.Cancel,
                      className: 'btn-default',
                      callback: function() {},
                    },
                    confirm: {
                      label: vm.pageModel.Messages.Ok,
                      className: 'btn-primary',
                      callback: function() {
                        vm.saveFn();
                      },
                    },
                  },
                });
              }
            });
        } else {
          vm.saveFn();
        }
      };

      //response miatt nem a base-t hasznalja
      vm.saveFn = function() {
        if ($stateParams.formMode === 'Edit') {
          $http
            .post('Partner/GridPartBankEdit', vm.dataModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.backWithUnlock,
              }); // TODO általános label
              if (response.data.DefaultIsUnknown) {
                toastr.warning('Jelölje ki az aktuális alapértelmezett bankszámlát!'); //TODO általános label
              }
            })
            .catch(function(response) {});
        } else if ($stateParams.formMode === 'Create') {
          $http
            .post('Partner/GridPartBankCreate', vm.dataModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.backWithUnlock,
              }); // TODO általános label
              if (response.data.DefaultIsUnknown) {
                toastr.warning('Jelölje ki az aktuális alapértelmezett bankszámlát!'); //TODO általános label
              }
            })
            .catch(function(response) {});
        } else {
          $http
            .post('Partner/GridPartBankDuplicate', vm.dataModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.backWithUnlock,
              }); // TODO általános label
            })
            .catch(function(response) {});
        }
      };

      vm.duplicate = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.GridPartBankDuplicate', { id: vm.dataModel.PartBankId, PartnerId: vm.dataModel.PartnerId });
      };

      vm.delete = function() {
        bootbox.dialog({
          message: vm.pageModel.Messages.ConfirmDelete,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Partner/GridPartBankDelete/' + vm.dataModel.PartBankId).then(function() {
                  toastr.success(vm.pageModel.Messages.DeleteSuccessful, null, { callBack: vm.backWithUnlock });
                });
              },
            },
          },
        });
      };

      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'partnerDetailsIsCollapsed':
            vm.activeBooleans['partnerDetailsIsActive'] = true;
            break;
          case 'bankAccountNumberIsCollapsed':
            vm.activeBooleans['bankAccountNumberIsActive'] = true;
            break;
        }
      };

      vm.attachDocument = function() {
        var id = vm.dataModel.PartBankId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgPartBank', id);
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerPartAddressEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    'AuthService',
    '$timeout',
    'LockService',
    'DasService',
    'UIHelperService',
    '$uibModalInstance',
    function(
      $http,
      options,
      $state,
      $stateParams,
      AuthService,
      $timeout,
      lockService,
      dasService,
      UIHelperService,
      uibModalInstance
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerPartAddressEditCtrl', stateParams);
      }
      var vm = this;
      options.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.hideInput = true;
      vm.collapseBooleans = { partnerDetailsIsCollapsed: false, partnerAddressIsCollapsed: false };
      vm.activeBooleans = { partnerDetailsIsActive: true, partnerAddressIsActive: true };
      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.postCodeValue = vm.formModel.PostCode ? vm.formModel.PostCode.Value : '';
      vm.localityValue = vm.formModel.Locality ? vm.formModel.Locality.Value : '';

      vm.UIHelperService.setDefaultSidebarStatus();
      var partnerId = $stateParams.PartnerId;
      // Identify which MainItem we are adding/editing this SubItem to/for
      var EditOrDuplicate = $stateParams.EditOrDuplicate;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelPartA.FormlyDescriptor;
      vm.partnerFormFields = formlyFormPanelDescriptors.PanelPartnerData.FormlyDescriptor;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if (uibModalInstance) {
          uibModalInstance.close();
        } else {
          $state.go('Partner.Edit', { id: partnerId });
        }
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PartAddressId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgPartAddress', id);
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var customExpressionPropertiesB = {
        TopogrNumber: {
          'templateOptions.required': function() {
            return vm.formModel.StreetNumber == 0 || vm.formModel.StreetNumber == null;
          },
        },
        StreetNumber: {
          'templateOptions.required': function() {
            return vm.formModel.TopogrNumber == 0 || vm.formModel.TopogrNumber == null;
          },
        },
        Street: {
          'templateOptions.required': function() {
            return vm.formModel.TopogrNumber == 0 || vm.formModel.TopogrNumber == null;
          },
        },
        StreetChar: {
          'templateOptions.required': function() {
            return vm.formModel.TopogrNumber == 0 || vm.formModel.TopogrNumber == null;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionPropertiesB);

      var customExpressionPropertiesPATIN = {
        ValidTo: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var syncValidators = {
        ValidTo: {
          PartAddressValidToValidator: function(modelValue, viewValue) {
            //
            if (!modelValue || !viewValue) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        PostCode: {
          PartAddressPostCodeValidator: function(modelValue, viewValue) {
            if (vm.formModel.Country == 'HU') {
              if (/^[1-9]\d{3}$/g.test(modelValue.Text)) {
                return true;
              } else {
                return false;
              }
            } else {
              var postCode = parseFloat(modelValue.Text);
              if (!isNaN(postCode) && postCode < 0) {
                return false;
              } else {
                return true;
              }
            }
          },
        },
        StreetNumber: {
          PartAddressStreetNumberValidator: function(modelValue, viewValue) {
            if (!!vm.formModel.TopogrNumber || /^[1-9].*/g.test(modelValue)) {
              return true;
            } else {
              return false;
            }
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      if (vm.formModel.PostCode != null && EditOrDuplicate != 'Duplicate') {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        if (vm.formModel.AddressType == 'PATIN') {
          InsertCustomExpressionProperties(vm.pageModel, customExpressionPropertiesPATIN);
        }
      }

      vm.save = function() {
        //debugger;
        if (EditOrDuplicate == 'Create') {
          $http
            .post('Partner/GridPartAddressCreate', vm.formModel)
            .then(function(response) {
              //console.log(response);
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {});
        } else if (EditOrDuplicate == 'Edit') {
          $http
            .post('Partner/GridPartAddressEdit', vm.formModel)
            .then(function(response) {
              //console.log(response);
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {});
        } else {
          $http
            .post('Partner/GridPartAddressDuplicate', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {});
        }
      };
      vm.duplicate = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.GridPartAddressDuplicate', {
          id: vm.formModel.PartAddressId,
          PartnerId: vm.formModel.PartnerId,
        });
      };

      vm.delete = function() {
        bootbox.dialog({
          message: vm.pageModel.Messages.ConfirmDelete,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Partner/GridPartAddressDelete/' + vm.formModel.PartAddressId).then(function() {
                  toastr.success(vm.pageModel.Messages.DeleteSuccessful, null, { callBack: vm.back });
                });
              },
            },
          },
        });
      };

      var onBlurFunctions = {
        PostCode: function(selectedItem) {
          if (
            ((!!selectedItem && selectedItem.Value) || selectedItem.Text) &&
            vm.postCodeValue !== selectedItem.Value
          ) {
            if (selectedItem.GridItem) {
              vm.formModel.Locality = {
                Text: selectedItem.GridItem.Locality,
                Value: selectedItem.GridItem.Locality,
              };

              vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
                selectedItem.GridItem.Locality
              );

              vm.formModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
              vm.formModel.Quarter = selectedItem.GridItem.Quarter ? selectedItem.GridItem.Quarter : '';
              vm.formModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
              FNSetFullAddr();
            } else {
              $http.get('Partner/GetSingleLocality?postcode=' + selectedItem.Text).then(
                function(result) {
                  var partAddress = result.data.result.Dto;
                  var locality = partAddress.Locality.Value;
                  if (locality) {
                    vm.formModel.Locality = {
                      Text: locality,
                      Value: locality,
                    };
                    vm.formModel.Country = partAddress.Country ? partAddress.Country : '';
                    vm.formModel.Quarter = partAddress.Quarter ? partAddress.Quarter : '';
                    vm.formModel.Street = partAddress.Street ? partAddress.Street : '';
                    vm.formModel.StreetChar = partAddress.StreetChar ? partAddress.StreetChar : '';
                    FNSetFullAddr();
                  }
                },
                function(error) {}
              );
            }
            vm.postCodeValue = vm.formModel.PostCode.Value;
            vm.localityValue = vm.formModel.Locality.Value;
          }
        },
        Locality: function(selectedItem) {
          if (!!selectedItem && selectedItem.Value && vm.localityValue !== selectedItem.Value) {
            if (selectedItem.GridItem) {
              vm.formModel.PostCode = {
                Text: selectedItem.GridItem.PostCode,
                Value: selectedItem.GridItem.PostCode,
              };
              vm.formModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
              vm.formModel.Quarter = selectedItem.GridItem.Quarter ? selectedItem.GridItem.Quarter : '';
              vm.formModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
              vm.formModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
              FNSetFullAddr();
            } else {
              $http.get('Partner/GetFirstPostcode?locality=' + selectedItem.Text).then(
                function(result) {
                  var partAddress = result.data.result.Dto;
                  if (partAddress) {
                    var postcode = partAddress.PostCode.Value;
                    if (postcode) {
                      if (
                        !vm.formModel.PostCode ||
                        !vm.formModel.PostCode.Value ||
                        postcode == vm.formModel.PostCode.Value
                      ) {
                        vm.formModel.PostCode = {
                          Text: postcode,
                          Value: postcode,
                        };
                        vm.formModel.Country = partAddress.Country ? partAddress.Country : '';
                        vm.formModel.Quarter = partAddress.Quarter ? partAddress.Quarter : '';
                        vm.formModel.Street = partAddress.Street ? partAddress.Street : '';
                        vm.formModel.StreetChar = partAddress.StreetChar ? partAddress.StreetChar : '';
                        FNSetFullAddr();
                      } else {
                        $http.get('Partner/GetAllLocalities?postcode=' + vm.formModel.PostCode.Value).then(
                          function(result) {
                            var localities = result.data.result.Localities;
                            if (localities && localities.length > 0 && localities.indexOf(selectedItem.Value) < 0) {
                              vm.formModel.PostCode = {
                                Text: postcode,
                                Value: postcode,
                              };
                              FNSetFullAddr();
                            }
                          },
                          function(error) {}
                        );
                      }
                    }
                  }
                },
                function(error) {}
              );
            }
            vm.localityValue = vm.formModel.Locality.Value;
          }
        },
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        Country: function(selectedItem) {
          FNSetFullAddr();
        },
        PostCode: function(selectedItem) {
          ////debugger;
          //if (!!selectedItem && !!vm.formModel.Locality) {
          //    vm.formModel.Locality = { Text: selectedItem.Locality, Value: selectedItem.Locality };
          //    vm.formModel.PostCode = { Text: selectedItem.PostCode, Value: selectedItem.PostCode };
          //}
          FNSetFullAddr();
        },
        Locality: function(selectedItem) {
          //if (!!selectedItem && !!vm.formModel.PostCode) {
          //    vm.formModel.Locality = { Text: selectedItem.Locality, Value: selectedItem.Locality };
          //    vm.formModel.PostCode = { Text: selectedItem.PostCode, Value: selectedItem.PostCode };
          //}
          FNSetFullAddr();
        },
        Quarter: function(selectedItem) {
          FNSetFullAddr();
        },
        Street: function(selectedItem) {
          FNSetFullAddr();
        },
        StreetChar: function(selectedItem) {
          FNSetFullAddr();
        },
        StreetNumber: function(selectedItem) {
          FNSetFullAddr();
        },
        Building: function(selectedItem) {
          FNSetFullAddr();
        },
        Stairway: function(selectedItem) {
          FNSetFullAddr();
        },
        Floor: function(selectedItem) {
          FNSetFullAddr();
        },
        Door: function(selectedItem) {
          FNSetFullAddr();
        },
        TopogrNumber: function(selectedItem) {
          FNSetFullAddr();
        },
        PropertyF2: function(selectedItem) {
          if (selectedItem?.GridItem) {
            vm.formModel.PostCode = selectedItem.GridItem.PostCode ? selectedItem.GridItem.PostCode : '';
            vm.formModel.Locality = {
              Text: selectedItem.GridItem.Locality,
              Value: selectedItem.GridItem.Locality,
            };
            vm.formModel.PostCode = {
              Text: selectedItem.GridItem.PostCode,
              Value: selectedItem.GridItem.PostCode,
            };
            vm.pageModel.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
              selectedItem.GridItem.Locality
            );
            vm.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.setFunctions.setText(
              selectedItem.GridItem.PostCode
            );
            vm.formModel.Country = selectedItem.GridItem.Country ? selectedItem.GridItem.Country : '';
            vm.formModel.Street = selectedItem.GridItem.Street ? selectedItem.GridItem.Street : '';
            vm.formModel.StreetChar = selectedItem.GridItem.StreetChar ? selectedItem.GridItem.StreetChar : '';
            vm.formModel.StreetNumber = selectedItem.GridItem.StreetNumber ? selectedItem.GridItem.StreetNumber : '';
            vm.formModel.Stairway = selectedItem.GridItem.Stairway ? selectedItem.GridItem.Stairway : '';
            vm.formModel.Building = selectedItem.GridItem.Building ? selectedItem.GridItem.Building : '';
            vm.formModel.Floor = selectedItem.GridItem.Floor ? selectedItem.GridItem.Door : '';
            vm.formModel.Door = selectedItem.GridItem.Door ? selectedItem.GridItem.Door : '';
            vm.formModel.TopogrNumber = selectedItem.GridItem.TopogrNumber ? selectedItem.GridItem.TopogrNumber : '';
          }
          FNSetFullAddr();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      var onClickFunctions = {
        PropertyF2Btn: function(selectedItem) {
          vm.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.options.openF2Modal();
        },
      };
      InsertOnClickFunctions(vm.pageModel, onClickFunctions);

      function whereConditionForPostCode() {
        if (!!vm.formModel.Location) return "PostCode~eq~'" + vm.formModel.Locality + "'";
        if (!!vm.formModel.Country) return "Country~eq~'" + vm.formModel.Country + "'";
        return '';
      }
      vm.pageModel.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionForPostCode;
      var whereConditionPropertyF2Function = function() {
        return "Level~eq~'PPRRU'";
      };
      vm.pageModel.Fields.PropertyF2.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionPropertyF2Function;

      function print(formElement) {
        if (!!formElement && formElement == vm.formModel.Country) {
          return formElement + ' ';
        }
        if (!!formElement) {
          return ' ' + formElement;
        } else {
          return '';
        }
      }

      function FNSetFullAddr() {
        if (
          !!vm.formModel.Locality &&
          !!vm.formModel.PostCode &&
          vm.formModel.Locality.Text != null &&
          vm.formModel.PostCode.Text != null
        ) {
          vm.formModel.Address =
            print(vm.formModel.Country) +
            vm.formModel.PostCode.Text +
            ' ' +
            vm.formModel.Locality.Text +
            print(vm.formModel.Quarter) +
            print(vm.formModel.Street) +
            print(vm.formModel.StreetChar) +
            print(vm.formModel.StreetNumber) +
            print(vm.formModel.Building) +
            print(vm.formModel.Stairway) +
            print(vm.formModel.Floor) +
            print(vm.formModel.Door) +
            print(vm.formModel.TpogrNumber);
        }
      }
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'partnerDetailsIsCollapsed':
            vm.activeBooleans['partnerDetailsIsActive'] = true;
            break;
          case 'partnerAddressIsCollapsed':
            vm.activeBooleans['partnerAddressIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerPartClassificationEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    'AuthService',
    'HistoryService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      AuthService,
      HistoryService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerPartClassificationEditCtrl', stateParams);
      }
      var vm = this;
      vm.collapseBooleans = { partnerDetailsIsCollapsed: false };
      vm.activeBooleans = { partnerDetailsIsActive: true };

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      // Identify which MainItem we are adding/editing this SubItem to/for
      var partnerId = $stateParams.PartnerId;
      var EditOrDuplicate = $stateParams.EditOrDuplicate;
      var validTo = vm.formModel.ValidTo;
      //console.log(EditOrDuplicate);
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelPartC.FormlyDescriptor;
      vm.partnerFormFields = formlyFormPanelDescriptors.PanelPartnerData.FormlyDescriptor;
      //console.log("vm.formFields: " + JSON.stringify(vm.formFields));

      //console.log("$stateParams");
      //console.log($stateParams);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.Edit', { id: partnerId });
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return EditOrDuplicate == 'Edit' && validTo != null;
          },
        },
      };

      var syncValidators = {
        ValidTo: {
          PartClassificationValidToValidator: function(modelValue, viewValue) {
            //
            if (!modelValue || !viewValue) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      if (vm.formModel.Classification != null && EditOrDuplicate != 'Duplicate') {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      vm.save = function() {
        if (EditOrDuplicate == 'Create') {
          $http
            .post('Partner/GridPartClassificationCreate', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        } else if (EditOrDuplicate == 'Edit') {
          $http
            .post('Partner/GridPartClassificationEdit', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        } else {
          $http
            .post('Partner/GridPartClassificationDuplicate', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        }
      };

      vm.duplicate = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.GridPartClassificationDuplicate', {
          id: vm.formModel.PartClassificationId,
          PartnerId: vm.formModel.PartnerId,
        });
      };

      vm.delete = function() {
        bootbox.dialog({
          message: vm.pageModel.Messages.ConfirmDelete,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Partner/GridPartClassificationDelete/' + vm.formModel.PartClassificationId).then(function() {
                  toastr.success(vm.pageModel.Messages.DeleteSuccessful, null, { callBack: vm.back });
                });
              },
            },
          },
        });
      };

      vm.cancel = function() {
        mi.close();
      };
      vm.History = History;
      vm.attachDocument = attachDocument;
      function attachDocument() {
        var id = vm.formModel.PartClassificationId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgPartClassification', id);
      }

      function History() {
        HistoryService.NavigateToHistory('FlgPartClassificationView', $state.params.id, vm, $state);
      }
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';

  module.controller('PartnerPartLinkEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    'AuthService',
    'HistoryService',
    'DasService',
    'LockService',
    'UIHelperService',
    '$uibModalInstance',
    function(
      $http,
      options,
      $state,
      $stateParams,
      AuthService,
      HistoryService,
      dasService,
      lockService,
      UIHelperService,
      uibModalInstance
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerPartLinkEditCtrl', stateParams);
      }
      var vm = this;

      vm.collapseBooleans = { partnerDetailsIsCollapsed: false };
      vm.activeBooleans = { partnerDetailsIsActive: true };

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      // Identify which MainItem we are adding/editing this SubItem to/for
      var partnerId = $stateParams.PartnerId;
      var EditOrDuplicate = $stateParams.EditOrDuplicate;
      var email = options.dto.DataEm;
      var linkType = options.dto.LinkType;
      vm.messages = options.pageModel.Messages;

      /* saját model változók */
      vm.formModel.wrk_IsPartnerTribe = false;
      vm.formModel.wrk_LatestFlgPartLink = null;
      vm.PrimaryLinkIsDisabled = vm.formModel.PrimaryLink;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        if (uibModalInstance) {
          uibModalInstance.close();
        } else {
          $state.go('Partner.Edit', { id: partnerId });
        }
      };

      vm.formlyInvalid = function() {
        const invalid = vm.formly.$invalid;
        return invalid;
      };

      if (EditOrDuplicate === 'Edit') {
        if (vm.formModel.LinkType === 'PLTPH') {
          vm.formModel.DataMo = vm.formModel.DataPh;
          vm.formModel.DataFa = vm.formModel.DataPh;
        } else if (vm.formModel.LinkType === 'PLTMO') {
          vm.formModel.DataPh = vm.formModel.DataMo;
          vm.formModel.DataFa = vm.formModel.DataMo;
        } else if (vm.formModel.LinkType === 'PLTFA') {
          vm.formModel.DataPh = vm.formModel.DataFa;
          vm.formModel.DataMo = vm.formModel.DataFa;
        }
      }

      var onChangeFunctions = {
        LinkType: function(selectedItem) {
          $http({
            method: 'GET',
            url: 'Partner/PartLinkGetLatestLink',
            params: { PartnerId: vm.formModel.PartnerId, LinkType: selectedItem.key },
          }).then(function successCallback(response) {
            if (response.data == null || response.data == '') {
              vm.formModel.wrk_LatestFlgPartLink = null;
              vm.formModel.PrimaryLink = true;
              vm.PrimaryLinkIsDisabled = true;
            } else {
              vm.formModel.wrk_LatestFlgPartLink = response.data;
              vm.formModel.PrimaryLink = false;
              vm.PrimaryLinkIsDisabled = false; //!vm.formModel.wrk_LatestFlgPartLink.PrimaryLink;
            }
          });
        },
        DataPh: function(selectedItem) {
          vm.formModel.DataMo = vm.formModel.DataPh;
          vm.formModel.DataFa = vm.formModel.DataPh;
        },
        DataMo: function(selectedItem) {
          vm.formModel.DataPh = vm.formModel.DataMo;
          vm.formModel.DataFa = vm.formModel.DataMo;
        },
        DataFa: function(selectedItem) {
          vm.formModel.DataPh = vm.formModel.DataFa;
          vm.formModel.DataMo = vm.formModel.DataFa;
        },
        ValidFrom: function() {
          if (vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl.$validate();
          }
        },
        ValidTo: function() {
          if (vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl.$validate();
          }
        },
      };
      var EditOrDuplicate = $stateParams.EditOrDuplicate;
      var hideExpressions = {
        DataPh: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTPH';
        },
        DataMo: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTMO';
        },
        DataFa: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTFA';
        },
        DataEm: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTEM';
        },
        DataWe: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTWE';
        },
        DataOt: function($viewValue, $modelValue, scope) {
          return vm.formModel.LinkType != 'PLTOT';
        },
      };

      var syncValidators = {
        DataEm: {
          PartLinkEmailValidator: function(modelValue, viewValue) {
            //
            if (vm.formModel.LinkType == 'PLTEM' && modelValue != null && modelValue != '') {
              return sysEmailValidate(modelValue);
              //console.log(selectedItem.key);
            }
            return true;
          },
        },
        ValidFrom: {
          PartLinkValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          PartLinkValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      var customExpressionProperties = {
        PrimaryLink: {
          'templateOptions.disabled': function() {
            return vm.PrimaryLinkIsDisabled;
          },
        },
        DataPh: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTPH';
          },
        },
        DataMo: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTMO';
          },
        },
        DataFa: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTFA';
          },
        },
        DataEm: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTEM';
          },
        },
        DataWe: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTWE';
          },
        },
        DataOt: {
          'templateOptions.required': function() {
            return vm.formModel.LinkType == 'PLTOT';
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelPartL.FormlyDescriptor;
      vm.partnerFormFields = formlyFormPanelDescriptors.PanelPartnerData.FormlyDescriptor;
      InsertSyncValidators(vm.pageModel, syncValidators);
      vm.save = function() {
        if (EditOrDuplicate === 'Create') {
          $http
            .post('Partner/GridPartLinkCreate', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        } else if (EditOrDuplicate === 'Edit') {
          $http
            .post('Partner/GridPartLinkEdit', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        } else {
          $http
            .post('Partner/GridPartLinkDuplicate', vm.formModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!', null, {
                callBack: vm.back,
              }); // TODO általános label
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen!'); // TODO általános label
            });
        }
      };

      vm.duplicate = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Partner.GridPartLinkDuplicate', { id: vm.formModel.PartLinkId, PartnerId: vm.formModel.PartnerId });
      };

      vm.delete = function() {
        bootbox.dialog({
          message: vm.pageModel.Messages.ConfirmDelete,
          title: vm.pageModel.Messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Partner/GridPartLinkDelete/' + vm.formModel.PartLinkId).then(function() {
                  toastr.success(vm.pageModel.Messages.DeleteSuccessful, null, { callBack: vm.back });
                });
              },
            },
          },
        });
      };

      vm.cancel = function() {
        mi.close();
      };
      vm.History = History;
      vm.attachDocument = attachDocument;
      function attachDocument() {
        var id = vm.formModel.PartLinkId;
        dasService.NavigateToDas(vm.messages, 'Partner.DasDocumentsNav', 'FlgPartLink', id);
      }

      function History() {
        HistoryService.NavigateToHistory('FlgPartLink', $state.params.id, vm, $state);
      }

      function validatePhone(phone) {
        var PHONE_REGEXP = /^(\+?\d{2}\s?)\(?\d{2,3}\)?[\s]?\d{3}[\s]?\d{3,}$/;
        if (PHONE_REGEXP.test(phone)) {
          return true;
        }
        return false;
      }
    },
  ]);
})(angular.module('sbPartner'));

'use strict';

function sbDivideMeterQuantityModalComponent($http, $uibModal) {
  const ctrl = this;

  ctrl.formly = undefined;

  ctrl.$onInit = function $onInit() {
    ctrl.pageModel = ctrl.resolve.fModel.pageModel;

    ctrl.formModel = ctrl.resolve.fModel.dto;

    const formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(ctrl.pageModel);
    ctrl.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
    ctrl.pageModel.Fields.MeterId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;

    var onChangeFunctions = {
      UtilityType: function() {
        ctrl.pageModel.Fields.MeterId.FormlyFieldDescriptor.templateOptions.options.f4scope.resetModel();
      },
    };

    var customExpressionProperties = {
      MeterId: {
        'templateOptions.disabled': function() {
          return !ctrl.formModel.UtilityType;
        },
      },
    };
    InsertCustomExpressionProperties(ctrl.pageModel, customExpressionProperties);
    InsertOnChangeFunctions(ctrl.pageModel, onChangeFunctions);
  };

  ctrl.cancel = function cancel() {
    ctrl.modalInstance.close();
  };

  ctrl.save = function save() {
    if (!ctrl.formly.$invalid) {
      $http.post('Utility/DivideMeterQuantity', ctrl.formModel).then(result => {
        ctrl.modalInstance.close();
        $uibModal.open({
          component: 'sbDivideMeterQuantityResultModal',
          resolve: {
            resultGridOptions: ctrl.pageModel.Grids.DivideMeterQuantityResultGrid,
            dataModel: result.data,
          },
          size: 'lg',
          backdrop: 'static',
        });
      });
    }
  };

  var whereConditionFunction = function() {
    if (!!ctrl.formModel.UtilityType) {
      return 'UtilityTypeId~eq~' + ctrl.formModel.UtilityType + '';
    }
    return '';
  };
}

const sbDivideMeterQuantityModalComponentOptions = {
  templateUrl: 'App/Utility/divide-meter-quantity-modal/divide-meter-quantity-modal.component.html',
  controller: sbDivideMeterQuantityModalComponent,
  bindings: {
    modalInstance: '<',
    resolve: '<',
  },
};

const sbDivideMeterQuantityModalComponentTag = 'sb-divide-meterquantity-modal';

'use strict';

function sbDivideMeterQuantityResultModalComponent($http, $uibModal) {
  const ctrl = this;

  ctrl.formly = undefined;

  ctrl.$onInit = function $onInit() {
    ctrl.row = ctrl.resolve.dataModel.ErrorList;

    //let errorList = !!ctrl.resolve.dataModel.ErrorList ? ctrl.resolve.dataModel.ErrorList : '{}';
    //ctrl.row = errorList !== '[{}]' ? JSON.parse(errorList) : JSON.parse('[]');
    ctrl.message = ctrl.resolve.dataModel.Message;

    var resultGridOptions = getGridOptions(ctrl.resolve.resultGridOptions, '', function() {}, ctrl.dump);
    resultGridOptions.dataSource = new kendo.data.DataSource({ data: ctrl.row, pageSize: 20, page: 1 });
    resultGridOptions.gridstates = { all: false, filter: false };
    ctrl.resultGridOptions = angular.copy(resultGridOptions);

    ctrl.cancel = function cancel() {
      ctrl.modalInstance.close();
    };

    ctrl.exportExcel = exportExcel;
  };
}

const sbDivideMeterQuantityResultModalComponentOptions = {
  templateUrl: 'App/Utility/divide-meter-quantity-result-modal/divide-meter-quantity-result-modal.component.html',
  controller: sbDivideMeterQuantityResultModalComponent,
  bindings: {
    modalInstance: '<',
    resolve: '<',
  },
};

const sbDivideMeterQuantityResultModalComponentTag = 'sb-divide-meterquantity-result-modal';

'use strict';

function sbMeterInvoiceDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.activeTab = 0;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelMeterInvoiceRowDetail'],
      function(gridModel) {
        gridModel.ControllerMethod = `Utility/${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: function() {
            return {
              targetInvoiceId: ctrl.meterInvoice.InvoiceId,
            };
          },
        };
      }
    );

    let gridOptions = ctrl.generatedTabs.find(obj => {
      return obj.name === 'TabMeterInvoiceRowDetail';
    });

    gridService.addAggregateToFooter(
      gridOptions.kendoConfig,
      'sum',
      'Gross',
      '',
      "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
    );
  };

  //#endregion
}

const sbMeterInvoiceDetailComponentOptions = {
  templateUrl: 'App/Utility/meter-invoice-detail/meter-invoice-detail.component.html',
  controller: sbMeterInvoiceDetailComponent,
  bindings: {
    meterInvoice: '=',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbMeterInvoiceDetail: sbMeterInvoiceDetailComponentOptions,
  };

  const sbMeterInvoiceDetailModule = angular.module('sbMeterInvoiceDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbMeterInvoiceDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbMeterChartComponent($http, $scope, $element) {
  const ctrl = this;
  const element = $element;
  $element.ready(function() {
    ctrl.chart = element.find('#chart').data('kendoChart');
    ctrl.chart.read = ctrl.read;
  });

  ctrl.$onChanges = function $onChanges(changes) {
    if (!!changes.type) {
      ctrl.model.options.seriesDefaults.type = changes.type.currentValue;
    }
    ctrl.read();
  };

  ctrl.$onInit = function $onInit() {
    ctrl.model.options.dataBound = ctrl.dataBound;
    element.find('#chart').kendoChart(ctrl.model.options);
  };

  ctrl.read = function(callback = null) {
    if (!!ctrl.chart) {
      $http
        .post('Utility/GetDataForChart/', {
          meterId: ctrl.model.MeterId,
          year: !ctrl.model.FilterChartByYearCombo?.length ? null : ctrl.model.FilterChartByYearCombo.split(','),
          month: !ctrl.model.FilterChartByMonthCombo?.length ? null : ctrl.model.FilterChartByMonthCombo.split(','),
          day: !ctrl.model.FilterChartByDayCombo?.length ? null : ctrl.model.FilterChartByDayCombo,
          chartType: ctrl.model.ChartTypeCombo,
        })
        .then(function(response) {
          let data = response.data.chartData.Value;
          if (!!callback) {
            callback(data);
          }
          if (typeof ctrl.model.chartDataTransport === 'function') {
            ctrl.model.options.series = ctrl.model.chartDataTransport(response.data.chartData.Value);
            element.find('#chart').kendoChart(ctrl.model.options);
          } else {
            element
              .find('#chart')
              .data('kendoChart')
              .dataSource.data(data);
          }
        })
        .catch(function(e) {
          toastr.error(e.statusText);
          return [];
        });
    }
  };
}

const sbMeterChartComponentOptions = {
  templateUrl: 'App/Utility/meter-chart/meter-chart.component.html',
  controller: sbMeterChartComponent,
  bindings: {
    openOrClose: '<',
    type: '<',
    chart: '=',
    model: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbMeterChartComponent: sbMeterChartComponentOptions,
  };

  const sbMeterChartComponentModule = angular.module('sbMeterChartComponent', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbMeterChartComponentModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = ['sbMeterInvoiceDetail'];

  const sbMeterInvoiceModule = angular.module('sbUtility', modules);
})();

'use strict';

(function() {
  const components = {
    sbDivideMeterQuantityModal: sbDivideMeterQuantityModalComponentOptions,
    sbDivideMeterQuantityResultModal: sbDivideMeterQuantityResultModalComponentOptions,
  };

  const modules = ['sbMeterInvoiceDetail', 'sbMeterChartComponent'];
  const sbUtilityModule = angular.module('sbUtility', modules);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbUtilityModule.component(componentTag, componentOptions);
  });
})();

(function(module) {
  'use strict';

  module.controller('UtilityLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilityLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('UtilityMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilityMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Utility_UtilityTypeNav: { icon: 'fa fa-book' },
        Utility_MeterNav: { icon: 'fa fa-book' },
        Utility_MeterRIDNav: { icon: 'fa fa-book' },
      };

      buildMenu($state, authService, 'Utility', 'utility', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('sbUtility'));

angular.module('sbUtility').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Utility: {
        url: '/utility',
        templateUrl: 'App/Utility/UtilityLayout.html',
        controller: 'UtilityLayoutCtrl as vm',
        redirectTo: 'Utility.MeterNav',
        ncyBreadcrumb: {
          // skip: true,
          label: 'Közművek modul',
          parent: 'main',
        },
      },

      'Utility.UtilityTypeNav': {
        url: '/utilitytypenav',
        params: {
          module: 'utility',
          formMode: 'Nav',
          documentEntity: 'utility_utilitytypenav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/UtilityTypeNav.html',
            controller: 'UtilityTypeNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utility/UtilityTypeListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Közmű típusok',
        },
      },

      'Utility.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Utility.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },

      'Utility.MeterNav': {
        url: '/meternav',
        params: {
          module: 'Utility',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utility.MeterEdit'],
          documentEntity: 'Utility_meternav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterNav.html',
            controller: 'MeterNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utility/MeterListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Mérőórák',
        },
      },
      'Utility.MeterHierarchy': {
        url: '/meterhierarchy/{meterId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterHierarchy.html',
            controller: 'MeterHierarchyCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GetMeterHierarchy/', undefined, ['meterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
        },
        ncyBreadcrumb: {
          label: 'Mérőóra hierarchia',
        },
      },
      'Utility.MeterCreate': {
        url: '/create/{id:int}',
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          utilityType: {
            value: null,
          },
          CreateOrEdit: 'Create',
          documentEntity: 'utility_metercreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterEdit.html',
            controller: 'MeterEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterCreate/', undefined, ['utilityType']),
        },
        ncyBreadcrumb: {
          label: 'Mérőóra hozzáadása',
        },
      },
      'Utility.MeterDuplicate': {
        url: '/duplicate/{id:int}?valid',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterEdit.html',
            controller: 'MeterEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterDuplicate/', undefined, ['id', 'valid']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          EditOrDuplicate: 'Duplicate',
          module: 'Utility',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utility.GridMeterReadingEdit'],
          documentEntity: 'utility_metercreate',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Mérőóra szerkesztése',
        },
      },

      'Utility.MeterEdit': {
        url: '/edit/{id:int}?valid',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterEdit.html',
            controller: 'MeterEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterEdit/', undefined, ['id', 'valid']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          module: 'Utility',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utility.GridMeterReadingEdit'],
          documentEntity: 'utility_metercreate',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Mérőóra szerkesztése',
        },
      },
      'Utility.MeterView': {
        url: '/view/{id:int}?valid',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterEdit.html',
            controller: 'MeterEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterView/', undefined, ['id', 'valid']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          CreateOrEdit: 'View',
          module: 'Utility',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utility.GridMeterReadingEdit'],
          documentEntity: 'utility_meterview',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Mérőóra megtekintése',
        },
      },
      'Utility.MeterEdit.CustomerService': {
        url: '/edit/customerservice/{id:int}?valid',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterEdit.html',
            controller: 'MeterEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterEditCustomerService/', undefined, ['id', 'valid']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          documentEntity: 'utility_metercreate',
        },
        ncyBreadcrumb: {
          label: 'Mérőóra szerkesztése',
        },
      },
      'Utility.MeterCharts': {
        url: '/charts/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterCharts.html',
            controller: 'MeterChartsCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utility/MeterCharts/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'View',
          module: 'Utility',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'utility_metercharts',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Diagramok',
        },
      },
      /*
            "Utility.UtilityTypeComboList": {
                url: "/phone-book",
                params: { MDType: "PhoneBook", ModulType: "Partner" },
                views: {
                    "masterData": {
                        templateUrl: "App/MasterData/MasterDataView.html",
                        controller: "MasterDataViewCtrl as vm",
                        resolve: {
                            options: RouteResolveFunc("PartnerMasterData/ListOptions/")
                        }
                    }
                },
                ncyBreadcrumb: {
                    label: "Telefonkönyv"
                }
            },
            */

      'Utility.MeterRIDNav': {
        url: '/meterridnav',
        params: {
          module: 'utility',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utility.GridMeterReadingImportEdit'],
          documentEntity: 'utility_meterridnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterRIDNav.html',
            controller: 'MeterRIDNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utility/MeterReadingImportListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Óraállások tömeges kezelése',
        },
      },

      //"Utility.GridMeterReadingCreate": {
      //    url: "/RIDcreate/{id:int}?",
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "UtilityMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/Utility/SubItems/MeterReadingEdit.html",
      //            controller: "MeterReadingEditCtrl as vm",
      //            resolve: {
      //                model: RouteResolveFunc("Utility/GridMeterReadingEdit/", undefined, [])
      //            }
      //        }
      //    },
      //    params: {
      //        controllerOptions: {
      //            isFormReadOnly: false
      //        },
      //        CreateOrEdit: "Create"
      //    },
      //    ncyBreadcrumb: {
      //        label: "Mérőóra hozzáadása"
      //    }
      //},

      'Utility.GridMeterReadingCreate': {
        url: '/RIDcreate/{id:int}?MeterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterReadingEdit.html',
            controller: 'MeterReadingEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GridMeterReadingCreate/', undefined, ['id', 'MeterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Create',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterreadingedit',
        },
        ncyBreadcrumb: {
          label: 'Mérőóra állás szerkesztése',
          parent: 'Utility.MeterEdit',
        },
      },

      'Utility.GridMeterReadingEdit': {
        url: '/RIDcreate/{id:int}?MeterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterReadingEdit.html',
            controller: 'MeterReadingEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GridMeterReadingEdit/', undefined, ['id', 'MeterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterreadingedit',
        },
        ncyBreadcrumb: {
          label: 'Mérőóra állás szerkesztése',
        },
      },
      'Utility.GridPremiseGaugeCreate': {
        url: '/premisegaugecreate/:meterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/PremiseGauge.html',
            controller: 'PremiseGaugeCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/PremiseGaugeCreate/', undefined, ['meterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
        },
        ncyBreadcrumb: {
          label: 'Helyiségek hozzárendelése',
          parent: 'Utility.MeterEdit',
        },
      },
      'Utility.GridEquipmentGaugeCreate': {
        url: '/equipmentgaugecreate/:meterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/EquipmentGauge.html',
            controller: 'EquipmentGaugeCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/EquipmentGaugeCreate/', undefined, ['meterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
        },
        ncyBreadcrumb: {
          label: 'Berendezések hozzárendelése',
          parent: 'Utility.MeterEdit',
        },
      },
      'Utility.GridDailyReadingCreate': {
        url: '/meterdailyreadingcreate/:meterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterDailyReadingEdit.html',
            controller: 'MeterDailyReadingCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GridMeterDailyReadingCreate/', undefined, ['meterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Create',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterdailyreadingcreate',
        },
        ncyBreadcrumb: {
          label: 'Napi óraállások',
          parent: 'Utility.MeterEdit',
        },
      },
      'Utility.GridDailyReadingEdit': {
        url: '/meterdailyreadingedit/{id:int}?MeterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterDailyReadingEdit.html',
            controller: 'MeterDailyReadingCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GridMeterDailyReadingEdit/', undefined, ['id', 'MeterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterdailyreadingedit',
        },
        ncyBreadcrumb: {
          label: 'Napi óraállás szerkesztése',
        },
      },
      'Utility.GridRentUnitCreate': {
        url: '/rentunitcreate/:meterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/MeterRentUnitEdit.html',
            controller: 'MeterRentUnitCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/RentUnitCreate/', undefined, ['meterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
        },
        ncyBreadcrumb: {
          label: 'Bérlemények hozzárendelése',
          parent: 'Utility.MeterEdit',
        },
      },
      'Utility.GridMeterChangeCreate': {
        url: '/meterchange/{id:int}?MeterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterChangeEdit.html',
            controller: 'MeterChangeEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterChangeCreate/', undefined, ['id', 'MeterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterchangeedit',
        },
        ncyBreadcrumb: {
          label: 'Mérőóra cseréje',
          parent: 'Utility.MeterEdit',
        },
      },
      'Utility.GridMeterChangeEdit': {
        url: '/meterchange/{id:int}?MeterId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterChangeEdit.html',
            controller: 'MeterChangeEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/MeterChangeEdit/', undefined, ['id', 'MeterId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          MeterId: 'MeterId',
          documentEntity: 'utility_gridmeterchangeedit',
        },
        ncyBreadcrumb: {
          label: 'Mérőóra cseréje',
        },
      },
      'Utility.GridMeterReadingImportEdit': {
        url: '/RIDedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/SubItems/MeterReadingImportEdit.html',
            controller: 'MeterReadingImportEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Utility/GridMeterReadingImportEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          documentEntity: 'utility_gridmeterreadingedit',
        },
        ncyBreadcrumb: {
          label: 'Importált mérőóra állás szerkesztése',
        },
      },
      'Utility.Map': {
        url: '/map/?propertyId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utility/Map.html',
            controller: 'MapCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utility/Map/', null, ['propertyId']),
        },
        params: {
          PropertyId: null,
        },
        ncyBreadcrumb: {
          label: 'Térkép',
          parent: 'Utility.MeterNav',
        },
      },
      'Utility.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilityMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Utility/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Utility");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('UtilityTypeEditCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilityTypeEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      vm.save = saveItem;

      vm.formModifiers = {
        numericOptions: {
          MainMeterAuthYears: {
            decimals: 5,
            format: 'n0',
            max: 20,
            min: 0,
          },
          SubMeterAuthYears: {
            decimals: 5,
            format: 'n0',
            max: 20,
            min: 0,
          },
        },
      };

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = model.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      function saveItem() {
        $http
          .post('Utility/UtilityTypeEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.UtilityTypeId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgUtilityType', id);
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('UtilityTypeNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'UIHelperService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilityTypeNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createUtilityType = createUtilityType;
      vm.editUtilityType = editUtilityType;
      vm.deleteUtilityType = deleteUtilityType;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.mainGridIdField = vm.pageModel.Grids['GridUtilityType'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridUtilityType,
        'Utility/UtilityTypeList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      ////////// setting UtilityTypeId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          UtilityTypeId: vm.selectedMainGridItemId,
        };
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
      }

      //////////////////////////////////////////
      ////////////// UtilityType operations ///////////
      //////////////////////////////////////////

      function createUtilityType() {
        var url = 'Utility/UtilityTypeCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utility/UtilityTypeEdit.html',
          controller: 'UtilityTypeEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editUtilityType() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Utility/UtilityTypeEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Utility/UtilityTypeEdit.html',
            controller: 'UtilityTypeEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteUtilityType() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = vm.messages.DialogConfirmMessage;
          dialogMessage = dialogMessage.replace(
            '{0}',
            ': ' + selectedItem['Name'] + ' (ID:' + selectedItem['UtilityTypeId'] + ') ' + '?'
          );
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Utility/UtilityTypeDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgUtilityType', id);
      }

      function WAL() {
        walService.NavigateToWal('Utility', 'UtilityTypeNavWal', 'FlgUtilityTypeView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          HistoryService.NavigateToHistory('FlgUtilityType', selectedItems, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterDailyReadingCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterDailyReadingCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;

      vm.meterDailyReadingModel = model.dto; //formModel

      if (!vm.meterDailyReadingModel.PreviusState || vm.meterDailyReadingModel.PreviusState < 0) {
        vm.meterDailyReadingModel.PreviusState = 0;
      }

      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrEdit = $stateParams.CreateOrEdit;

      vm.pageModel.Fields.ReadingDate.FormlyFieldDescriptor.templateOptions.DateTimeOptions.customEdit = true;

      //set minimum date:
      /*if (vm.meterDailyReadingModel.PreviousReadingDate) {
        vm.pageModel.Fields.ReadingDate.FormlyFieldDescriptor.templateOptions.options = {
          min: vm.meterDailyReadingModel.PreviousReadingDate,
        };
      }*/

      // MenuItems
      vm.save = saveItem;
      //vm.delete = deleteItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterEdit', { id: vm.meterDailyReadingModel.MeterId });
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        State: function() {
          if (
            !vm.meterDailyReadingModel.State ||
            vm.meterDailyReadingModel.State < vm.meterDailyReadingModel.PreviusState
          ) {
            vm.meterDailyReadingModel.State = vm.meterDailyReadingModel.PreviusState;
          }
          vm.meterDailyReadingModel.Consumption =
            vm.meterDailyReadingModel.State - vm.meterDailyReadingModel.PreviusState;
        },
      };

      var numericOptions = {
        State: {
          decimals: 3,
          format: 'n3',
        },
      };

      var customExpressionProperties = {
        ReadingDate: {
          'templateOptions.disabled': function() {
            return createOrEdit === 'Edit';
          },
        },
        PreviusState: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Consumption: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ModUser: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ModDate: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
      };

      var syncValidators = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertNumericOptions(vm.pageModel, numericOptions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.meterDailyReadingModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Generate Formly form descriptors from pageModel

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        //if (formly.$valid) {
        $http
          .post('Utility/GridMeterDailyReadingEdit', vm.meterDailyReadingModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Utility.MeterEdit', {
              id: vm.meterDailyReadingModel.MeterId,
            });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.cancel = function() {
        mi.close();
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterReadingEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterReadingEditCtrl', stateParams);
      }
      var vm = this;

      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.meterReadingModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.isMainMeter = model.isMainMeter;
      vm.messages = model.pageModel.Messages;
      vm.actions = vm.pageModel.Actions;
      var createOrEdit = $stateParams.CreateOrEdit;
      vm.createOrEdit = $stateParams.CreateOrEdit;
      // MenuItems
      vm.save = saveItem;
      //vm.delete = deleteItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterEdit', { id: vm.meterReadingModel.MeterId });
      };

      vm.attachDocument = function() {
        var id = vm.meterReadingModel.MeterReadingId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterReading', id);
      };

      vm.readMeterDailyReading = function() {
        $http
          .post('Utility/ReadMeterDailyReading', {
            meterId: vm.meterReadingModel.MeterId,
            state: vm.meterReadingModel.State,
          })
          .then(function(response) {
            vm.meterReadingModel.ReadingDate = response.data.ReadingDate;
            vm.meterReadingModel.State = response.data.State;
          })
          .catch(function(response) {});
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        NotConsPrice: function($viewValue, $modelValue, scope) {
          return !vm.isMainMeter;
        },
        NotConsQuantity: function($viewValue, $modelValue, scope) {
          return !vm.isMainMeter;
        },
        ConsPrice: function($viewValue, $modelValue, scope) {
          return !vm.isMainMeter;
        },
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        State: function() {
          $http
            .post(
              'Utility/GridMeterReadingCalculateState',
              {
                readingDate: vm.meterReadingModel.ReadingDate,
                readingState: vm.meterReadingModel.State,
                correctionState: vm.meterReadingModel.Correction,
                meterReadingId: vm.meterReadingModel.MeterReadingId,
                meterId: vm.meterReadingModel.MeterId,
              },
              { ignoreLoadingBar: true }
            )
            .then(function successcallback(response) {
              if (!!response.data) {
                vm.meterReadingModel.PreState = response.data.PreState;
                vm.meterReadingModel.DeductedCons = response.data.DeductedCons;
                vm.meterReadingModel.Consumption = response.data.Consumption;
              }
            });
        },
        Correction: function() {
          $http
            .post(
              'Utility/GridMeterReadingCalculateState',
              {
                readingDate: vm.meterReadingModel.ReadingDate,
                readingState: vm.meterReadingModel.State,
                correctionState: vm.meterReadingModel.Correction,
                meterReadingId: vm.meterReadingModel.MeterReadingId,
                meterId: vm.meterReadingModel.MeterId,
              },
              { ignoreLoadingBar: true }
            )
            .then(function successcallback(response) {
              if (!!response.data) {
                vm.meterReadingModel.PreState = response.data.PreState;
                vm.meterReadingModel.DeductedCons = response.data.DeductedCons;
                vm.meterReadingModel.Consumption = response.data.Consumption;
              }
            });
        },
        ReadingDate: function() {
          if (vm.meterReadingModel.ReadingDate !== null) {
            vm.pageModel.Fields.Period.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              readingDate: vm.meterReadingModel.ReadingDate,
            };
            vm.meterReadingModel.Period = null;
          }
        },
        ConsPrice: function(selectedItem) {
          if (vm.isMainMeter) {
            if (vm.meterReadingModel.Consumption !== 0) {
              vm.meterReadingModel.UnitPrice =
                (vm.meterReadingModel.ConsPrice + vm.meterReadingModel.NotConsPrice) / vm.meterReadingModel.Consumption;
            }
          }
        },
        NotConsPrice: function(selectedItem) {
          if (vm.isMainMeter) {
            if (vm.meterReadingModel.Consumption !== 0) {
              vm.meterReadingModel.UnitPrice =
                (vm.meterReadingModel.ConsPrice + vm.meterReadingModel.NotConsPrice) / vm.meterReadingModel.Consumption;
            }
          }
        },
        Consumption: function(selectedItem) {
          if (vm.isMainMeter) {
            if (vm.meterReadingModel.Consumption !== 0) {
              vm.meterReadingModel.UnitPrice =
                (vm.meterReadingModel.ConsPrice + vm.meterReadingModel.NotConsPrice) / vm.meterReadingModel.Consumption;
            }
          }
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        ReadingDate: function(selectedItem, element, scope) {
          $http
            .post(
              'Utility/GridMeterReadingCalculateState',
              {
                readingDate: selectedItem,
                readingState: vm.meterReadingModel.State,
                correctionState: vm.meterReadingModel.Correction,
                meterReadingId: vm.meterReadingModel.MeterReadingId,
                meterId: vm.meterReadingModel.MeterId,
              },
              { ignoreLoadingBar: true }
            )
            .then(function successcallback(response) {
              if (!!response.data) {
                vm.meterReadingModel.PreState = response.data.PreState;
                vm.meterReadingModel.DeductedCons = response.data.DeductedCons;
                vm.meterReadingModel.Consumption = response.data.Consumption;
              }
            });
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {
        State: {
          decimals: 3,
          format: 'n3',
          max: 9999999999,
          min: 0,
        },
        Correction: {
          decimals: 3,
          format: 'n3',
          max: 9999999999,
          min: 0,
        },
        DeductedCons: {
          decimals: 3,
          format: 'n3',
        },
        Consumption: {
          decimals: 3,
          format: 'n3',
        },
        NotConsPrice: {
          decimals: 2,
          format: 'n2',
        },
        NotConsQuantity: {
          decimals: 3,
          format: 'n3',
        },
        PreState: {
          decimals: 3,
          format: 'n3',
        },
      };

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.meterReadingModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        //if (formly.$valid) {
        $http
          .post('Utility/GridMeterReadingEdit', vm.meterReadingModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Utility.MeterEdit', {
              id: vm.meterReadingModel.MeterId,
            });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;

      vm.cancel = function() {
        mi.close();
      };

      if (vm.meterReadingModel.ReadingDate !== null) {
        vm.pageModel.Fields.Period.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          readingDate: vm.meterReadingModel.ReadingDate,
        };
      }
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterReadingImportEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'LockService',
    'UIHelperService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterReadingImportEditCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      var createOrEdit = $stateParams.CreateOrEdit;

      // MenuItems
      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterRIDNav');
      };

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        //if (formly.$valid) {
        $http
          .post('Utility/GridMeterReadingImportEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.back();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterChangeEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    'LockService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterChangeEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;

      vm.meterChangeModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      // MenuItems
      vm.create = createItem;
      vm.save = saveItem;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterEdit', { id: $stateParams.MeterId });
      };

      vm.attachDocument = function() {
        var id = vm.meterModel.MeterId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeter', id);
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ ComboList Filters ] //////////////////////////////////

      // Valid/Érvényesség kiválasztása
      //vm.pageModel.Fields.Valid.transData = function () {
      //    return {
      //        id: vm.meterModel.MeterId
      //    }
      //};

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};
      var firstLoadDMDate = true;
      var origDMstateExpression = vm.meterChangeModel.DisMountState !== 0;
      var origDMDateExpression = new Date(vm.meterChangeModel.DisMountDate).getFullYear !== 1;
      var customExpressionProperties = {
        DisMountState: {
          'templateOptions.disabled': function() {
            return origDMstateExpression;
          },
        },
        DisMountDate: {
          'templateOptions.disabled': function() {
            if (!origDMstateExpression && firstLoadDMDate) {
              firstLoadDMDate = false;
              var dt = new moment(new Date());
              vm.meterChangeModel.DisMountDate = dt.format();
            }
            return origDMstateExpression;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        CertificationDate: function(selectedItem) {
          var certificationDateValue = new moment(
            vm.meterChangeModel.CertificationDate,
            kendo.culture().calendar.patterns.d.toUpperCase(),
            true
          );
          if (certificationDateValue.isValid()) {
            $http({
              method: 'get',
              url: 'utility/GetCertificationDate',
              params: {
                serialNumber: vm.meterChangeModel.SerialNumber,
                certificationDate: vm.meterChangeModel.CertificationDate,
              },
            }).then(function successcallback(response) {
              var certDateValue = new moment(
                response.data.dto.CertificationEndDate,
                kendo.culture().calendar.patterns.d.toUpperCase()
              );
              vm.meterChangeModel.CertificationEndDate = certDateValue.format();
            });
          }
        },
        DisMountDate: function(selectedItem) {
          vm.pageModel.Fields.MountDate.FormlyFieldDescriptor.formControl.$validate();
        },
      };
      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        MountDate: {
          MountLTDisMountDate: function(modelValue, viewValue) {
            var mountDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var dismountDateValue = new moment(
              vm.meterChangeModel.DisMountDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return !vm.meterChangeModel.DisMountDate || mountDateValue.isSameOrAfter(dismountDateValue);
          },
        },
        DisMountDate: {
          DisMountDateLTOriginal: function(modelValue, viewValue) {
            var dismountDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var minDisountDateValue = new moment(
              vm.meterChangeModel.MinDismountDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return dismountDateValue.isSameOrAfter(minDisountDateValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.meterChangeModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner
      function createItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.meterChangeEdit', { id: vm.meterChangeModel.MeterId });
      }

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Utility/MeterChangeEdit', vm.meterChangeModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Utility.MeterNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('MeterContractCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterContractCtrl', stateParams);
      }
      var vm = this;

      vm.feeGenListGridOptions = model.feeGenList;
      vm.feeNotGenListGridOptions = model.feeNotGenList;
      vm.messages = model.messages;

      vm.save = function save() {
        uibModalInstance.close();
      };

      vm.cancel = function cancel() {
        uibModalInstance.dismiss();
      };

      vm.exportExcel = function exportExcel() {
        var grid1 = $('#feeNotGenList').getKendoGrid();
        var rows1 = [
          {
            cells: grid1.columns
              .filter(x => {
                return !x.hidden;
              })
              .map(x => {
                return { value: x.title };
              }),
          },
        ];
        angular.forEach(grid1.dataSource.data(), function(value) {
          rows1.push({
            cells: grid1.columns
              .filter(x => {
                return !x.hidden;
              })
              .map(x => {
                return { value: value[x.field] };
              }),
          });
        });

        var grid2 = $('#feeGenList').getKendoGrid();
        var rows2 = [
          {
            cells: grid2.columns
              .filter(x => {
                return !x.hidden;
              })
              .map(x => {
                return { value: x.title };
              }),
          },
        ];
        angular.forEach(grid2.dataSource.data(), function(value) {
          rows2.push({
            cells: grid2.columns
              .filter(x => {
                return !x.hidden;
              })
              .map(x => {
                return { value: value[x.field] };
              }),
          });
        });

        var workbook = new kendo.ooxml.Workbook({
          sheets: [
            {
              columns: [{ autoWidth: true }, { autoWidth: true }],
              title: 'Díjgenerálás nélkül',
              rows: rows1,
            },
            {
              columns: [{ autoWidth: true }, { autoWidth: true }],
              title: 'Díjgenerálással érintett',
              rows: rows2,
            },
          ],
        });

        workbook.toDataURLAsync().then(function(dataURL) {
          kendo.saveAs({
            dataURI: dataURL,
            fileName: 'Összerendeléskor érintett szerződések.xlsx',
          });
        });
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterHierarchyCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    'LockService',
    '$uibModalInstance',
    function($scope, model, $http, $state, $stateParams, lockService, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterHierarchyCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = cancel;
      var treeDataSource = new kendo.data.HierarchicalDataSource({
        data: [model.Dto],
      });

      vm.treeOptions = {
        loadOnDemand: false,
        // checkboxes: {
        // checkChildren: false,
        // },
        dataSource: treeDataSource,
      };

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('MeterEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    'WalService',
    '$stateParams',
    '$uibModal',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      model,
      fus,
      $state,
      walService,
      $stateParams,
      $uibModal,
      $scope,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterEditCtrl', stateParams);
      }
      var vm = this;
      vm.scope = $scope;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
        disableRunExpression: false,
      };

      vm.UIHelperService = UIHelperService;

      vm.UIHelperService.setDefaultSidebarStatus();
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.meterModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrEdit = $stateParams.CreateOrEdit;
      vm.editOrDuplicate = $stateParams.EditOrDuplicate;
      vm.isSaveDisabled = isSaveDisabled;
      vm.viewPercentage = viewPercentage;
      // MenuItems
      vm.save = checkBeforeSave;
      // SubItemMenuItems
      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.deleteMeter = deleteMeter;
      vm.divideMeterQuantity = divideMeterQuantity;
      vm.disableEdit = false;
      if (vm.meterModel.isUnitPrice) {
        vm.disableEdit = true;
      }
      vm.origAccountContact = angular.copy(vm.meterModel.AccountContact);

      vm.activeSubItemTab;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      var localValidFrom = new moment(vm.meterModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.getMeterValidFrom = function() {
        return vm.meterModel.ValidFrom || vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl.$viewValue;
      };

      getLastDividedPeriod();

      //a különböző szerkesztési állapotok meghatározása:
      vm.isNewTimeStamp = function() {
        let validFrom = new moment(vm.getMeterValidFrom(), kendo.culture().calendar.patterns.d.toUpperCase());
        return validFrom.isAfter(localValidFrom);
      };

      vm.isModState = function() {
        return $stateParams.CreateOrEdit === 'Edit' && $stateParams.EditOrDuplicate !== 'Duplicate';
      };

      vm.hasDividedPeriod = function() {
        return !!vm.lastDividedPeriodEnding && vm.lastDividedPeriodEnding.isValid();
      };

      vm.dateIsFirtDay = function(date) {
        let dateObject = new moment(date, kendo.culture().calendar.patterns.d.toUpperCase());
        return dateObject.date() == 1;
      };

      vm.hasRentUnit = false;

      vm.revalidateField = function(fieldList) {
        if (!angular.isArray()) {
          fieldList = ['IsUnitPrice', 'UnitPriceCalcMode', 'BaseFeeSplitMode', 'Status', 'AccountContact', 'ValidFrom'];
        }
        fieldList.forEach(function(key, index) {
          if (!!vm.pageModel.Fields[key]) vm.pageModel.Fields[key].FormlyFieldDescriptor.formControl.$validate();
        });
      };

      vm.dataIsChanged = function(fields) {
        //összehasonlítja az betöltéskori (eredeti) modelt a jelenlegivel, ha meg van adva a mező tömb, akkor csak azokat vizsgálja...
        let changed = false;
        let object = Object.keys(vm.originalData);
        if (angular.isArray(fields)) {
          object = object.filter(function(key) {
            return fields.includes(key);
          });
        }
        object.forEach(function(key, index) {
          if (vm.originalData[key] !== vm.meterModel[key]) {
            changed = true;
            return true;
          }
        });
        return changed;
      };

      vm.originalData = {};
      Object.keys(vm.meterModel).forEach(function(key, index) {
        let necessaryFields = [
          'IsUnitPrice',
          'UnitPriceCalcMode',
          'BaseFeeSplitMode',
          'Status',
          'AccountContact',
          'ServicePrice',
        ];
        if (necessaryFields.includes(key)) {
          vm.originalData[key] = angular.copy(vm.meterModel[key]);
        }
      });

      //Setting required dates to null, the initial values caused problems with formly.$invalid
      if ($stateParams.CreateOrEdit === 'Create') {
        vm.meterModel.CertificationDate = null;
        vm.meterModel.CertificationEndDate = null;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ ComboList Filters ] //////////////////////////////////

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.WAL = WAL;
      vm.History = history;
      vm.usedMeterGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterNav');
      };

      vm.attachDocumentMain = function() {
        if (!vm.meterModel.MeterId) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeter', vm.meterModel.MeterId);
        }
      };

      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridDailyReading'], ['ModDate', 'ReadingDate']);

      vm.attachDocument = function() {
        var id = getSelectedSubGridItemId();

        if (!id) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          switch (vm.activeSubItemTab) {
            case 0:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterReadingView', id);
              break;
            case 1:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterChangeView', id);
              break;
            case 2:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterRentUnitView', id);
              break;
            case 3:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgPremiseOfGaugeView', id);
              break;
            case 4:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgEquipmentOfGaugeView', id);
              break;
            case 5:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgConsDividedView', id);
              break;
            case 6:
              dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterDailyReadingView', id);
              break;
            default:
              break;
          }
        }
      };

      vm.pageModel.Fields.Valid.transData = function() {
        return {
          id: vm.meterModel.MeterId,
        };
      };

      if (vm.meterModel.ParentalMeterAreaId === null || vm.meterModel.ParentalMeterAreaId.Value === null) {
        // TODO ?
      }

      var customTypes = {
        Comment: 'textarea',
      };

      // Usage: "fieldName": "className"
      var customClasses = {};
      vm.selectedTenement = null;

      var isPropertyOrLocationIdSelected = function() {
        return vm.meterModel.ImmovableId !== null && vm.meterModel.ImmovableId.Value !== null;
      };

      var isServiceIdRequired = function() {
        return vm.meterModel.Status === 'USTFI' && !vm.controllerOptions.isFormReadOnly;
      };
      //ServiceId F22 hack:
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.required = isServiceIdRequired();

      var customExpressionProperties = {
        AccountContact: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              (vm.meterModel.ParentalMeterAreaId !== null && vm.meterModel.ParentalMeterAreaId.Value !== null) ||
              (vm.isModState() &&
                !vm.isNewTimeStamp() &&
                (vm.hasDividedPeriod() || !vm.dateIsFirtDay(vm.meterModel.ValidFrom)))
            );
          },
        },
        ModDate: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ModUser: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ServicePrice: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly || (vm.isModState() && !vm.isNewTimeStamp() && vm.hasDividedPeriod())
            );
          },
        },
        UnitPriceCalcMode: {
          'templateOptions.required': function() {
            return (
              vm.meterModel.IsUnitPrice === true &&
              (vm.meterModel.ParentalMeterAreaId === null || vm.meterModel.ParentalMeterAreaId.Value === null)
            );
          },
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              vm.meterModel.IsUnitPrice !== true ||
              (vm.isModState() &&
                !vm.isNewTimeStamp() &&
                (vm.hasDividedPeriod() || !vm.dateIsFirtDay(vm.meterModel.ValidFrom)))
            );
          },
        },
        IsUnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              (vm.isModState() &&
                !vm.isNewTimeStamp() &&
                (vm.hasDividedPeriod() || !vm.dateIsFirtDay(vm.meterModel.ValidFrom)))
            );
          },
        },
        BaseFeeSplitMode: {
          'templateOptions.required': function() {
            if (vm.meterModel.Status === 'USTFI') {
              return (
                vm.meterModel.ParentalMeterAreaId === null ||
                vm.meterModel.ParentalMeterAreaId.Value === null ||
                (vm.isModState() &&
                  !vm.isNewTimeStamp() &&
                  (vm.hasDividedPeriod() || !vm.dateIsFirtDay(vm.meterModel.ValidFrom)))
              );
            } else {
              return false;
            }
          },
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              (vm.isModState() &&
                !vm.isNewTimeStamp() &&
                (vm.hasDividedPeriod() || !vm.dateIsFirtDay(vm.meterModel.ValidFrom)))
            );
          },
        },
        DisMountDate: {
          'templateOptions.required': function() {
            return vm.meterModel.Status === 'USTIN';
          },
        },
        DisMountState: {
          'templateOptions.required': function() {
            return vm.meterModel.Status === 'USTIN';
          },
        },
        PremiseId: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              vm.meterModel.PropertyLocationId === null ||
              vm.meterModel.PropertyLocationId.Value === null
            );
          },
        },
        ServiceId: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              vm.meterModel.PropertyLocationId === null ||
              (vm.isModState() && vm.hasRentUnit)
            );
          },
          'templateOptions.required': isServiceIdRequired,
        },
        CertificationDate: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly; //|| vm.isModState() || vm.isNewTimeStamp();
          },
        },
        Valid: {
          'templateOptions.required': function() {
            return !(vm.meterModel.ModelState === 2 || vm.meterModel.ModelState === 4);
          },
        },
        UtilityTypeId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || createOrEdit !== 'Create';
          },
        },
        ImmovableId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || vm.isModState() || vm.isNewTimeStamp();
          },
        },
        PropertyLocationId: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              vm.isModState() ||
              vm.isNewTimeStamp() ||
              (vm.meterModel.ImmovableId !== null &&
                (vm.meterModel.ImmovableId.Value === null || vm.meterModel.ImmovableId.Value === ''))
            );
          },
        },
        ParentalMeterAreaId: {
          'templateOptions.disabled': function() {
            return (
              vm.controllerOptions.isFormReadOnly ||
              (vm.meterModel.ImmovableId !== null &&
                (vm.meterModel.ImmovableId.Value === null || vm.meterModel.ImmovableId.Value === ''))
            );
          },
        },
        Status: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || (vm.isModState() && !vm.isNewTimeStamp());
          },
        },
      };

      var hideExpressions = {
        /**
         * @return {boolean}
         */
        Valid: function($viewValue, $modelValue, scope) {
          return !vm.meterModel.MeterId || vm.meterModel.MeterId === 0;
        },
        /**
         * @return {boolean}
         */
        UnitPriceCalcMode: function($viewValue, $modelValue, scope) {
          return vm.meterModel.ParentalMeterAreaId !== null && vm.meterModel.ParentalMeterAreaId.Value !== null;
        },
      };

      var onChangeFunctions = {
        ParentalMeterAreaId: function(selectedItem) {
          if (
            !!selectedItem &&
            !!selectedItem.MeterAreaId &&
            selectedItem.MeterAreaId !== '' &&
            selectedItem.MeterAreaId !== null
          ) {
            vm.meterModel.AccountContact = false;
            $http({
              method: 'GET',
              url: 'Utility/GetPremiseByParental',
              params: { id: selectedItem.MeterId },
            }).then(function successCallback(response) {
              if (
                //createOrEdit === 'Create' &&
                (response !== null && response.data !== null && vm.meterModel.PremiseId.Value === null) ||
                vm.meterModel.PremiseId.Value === ''
              ) {
                var premiseResp = response.data.split(':');
                vm.meterModel.PremiseId.Text = premiseResp[0];
                vm.meterModel.PremiseId.Value = parseInt(premiseResp[1]);
              } /*else {
                vm.meterModel.PremiseId.Text = null;
                vm.meterModel.PremiseId.Value = null;
              }*/
            });
          }
        },
        Valid: function(selectedItem) {
          if (!!selectedItem.key && selectedItem.key !== '') {
            vm.formly.$setPristine();
            $state.go('Utility.MeterEdit', {
              id: vm.meterModel.MeterId,
              valid: vm.meterModel.Valid,
            });
          }
        },
        ValidFrom: function() {
          if (createOrEdit === 'Edit') {
            if (vm.isNewTimeStamp()) {
              vm.disableEdit = false;
            } else {
              vm.disableEdit = true;
            }
          }

          getLastDividedPeriod();

          vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            propertyLocationId: vm.meterModel.PropertyLocationId.Value ? vm.meterModel.PropertyLocationId.Value : 0,
            validFrom: vm.getMeterValidFrom(),
          };
          vm.meterModel.PremiseId = { Text: null, Value: null };
          vm.revalidateField();
        },
        IsUnitPrice: function() {
          vm.revalidateField();
        },
        ServicePrice: function() {
          vm.revalidateField();
        },
        UnitPriceCalcMode: function() {
          vm.revalidateField();
        },
        BaseFeeSplitMode: function() {
          vm.revalidateField();
        },
        Status: function() {
          vm.revalidateField();
        },
        AccountContact: function() {
          vm.revalidateField();
        },

        PremiseId: function(selectedItem) {},
        PropertyLocationId: function(selectedItem) {
          if (selectedItem === null || selectedItem.PropertyId !== vm.meterModel.PropertyLocationId.Value) {
            vm.meterModel.PremiseId = null;
          }
          vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            propertyLocationId: selectedItem ? selectedItem.PropertyId : 0,
            validFrom: vm.getMeterValidFrom(),
          };
        },
        ImmovableId: function(selectedItem, model) {
          if (!selectedItem || vm.meterModel.ImmovableId.Value !== selectedItem.PropertyId) {
            vm.meterModel.ParentalMeterAreaId = null;
            vm.meterModel.PremiseId = null;
            vm.meterModel.PropertyLocationId = null;
            vm.meterModel.ServiceId = null;
            vm.meterModel.MeterAreaId = null;
          }

          vm.pageModel.Fields.PropertyLocationId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            PropId: selectedItem ? selectedItem.PropertyId : null,
          };

          vm.pageModel.Fields.ParentalMeterAreaId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            utilityTypeId: vm.meterModel.UtilityTypeId,
            currenMeterId: vm.meterModel.MeterId,
            immovableId: selectedItem ? selectedItem.PropertyId : null,
            meterAreaid: vm.meterModel.MeterAreaId,
          };

          if (!selectedItem) return;

          if (vm.meterModel.ImmovableId.Value !== null) {
            var certificationDate = new Date(vm.meterModel.CertificationDate);

            $http({
              method: 'GET',
              url: 'Utility/GetMeterNamesByTenement',
              params: { tenement: selectedItem.PropertyId },
            }).then(function successCallback(response) {
              if (response !== null) {
                vm.meterModel.Name = response.data.Value;
              } else {
                vm.meterModel.Name = null;
              }
            });
          }
        },

        UtilityTypeId: function(selectedItem) {
          if (vm.meterModel.UtilityTypeId === null) {
            vm.meterModel.CertificationDate = null;
            vm.meterModel.CertificationEndDate = null;
          }

          vm.meterModel.ParentalMeterAreaId = null;

          vm.pageModel.Fields.ParentalMeterAreaId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            utilityTypeId: vm.meterModel.UtilityTypeId,
            currenMeterId: vm.meterModel.MeterId,
            immovableId: vm.meterModel.ImmovableId,
            meterAreaid: vm.meterModel.MeterAreaId,
          };
        },

        CertificationDate: function(selectedItem) {
          if (vm.meterModel.UtilityTypeId && vm.meterModel.UtilityTypeId !== null) {
            var certificationDate = new moment(
              vm.meterModel.CertificationDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            $http({
              method: 'GET',
              url: 'Utility/UtilityTypesList',
              params: { id: vm.meterModel.UtilityTypeId },
            }).then(function successCallback(response) {
              if (response !== null) {
                if (vm.meterModel.ParentalMeterAreaId === null) {
                  certificationDate = new moment(
                    new Date(
                      certificationDate.year() + response.data.dto.MainMeterAuthYears,
                      certificationDate.month(),
                      certificationDate.date()
                    )
                  ).format(kendo.culture().calendar.patterns.d.toUpperCase());
                  vm.meterModel.CertificationEndDate = certificationDate;
                } else {
                  certificationDate = new moment(
                    new Date(
                      certificationDate.year() + response.data.dto.SubMeterAuthYears,
                      certificationDate.month(),
                      certificationDate.date()
                    )
                  ).format(kendo.culture().calendar.patterns.d.toUpperCase());
                  vm.meterModel.CertificationEndDate = certificationDate;
                }
              } else {
                vm.meterModel.CertificationEndDate = certificationDate;
              }
            });
          }
        },
        MountDate: function() {
          var validFrom = new moment(vm.getMeterValidFrom(), kendo.culture().calendar.patterns.d.toUpperCase());
          var mountDate = new moment(vm.meterModel.MountDate, kendo.culture().calendar.patterns.d.toUpperCase());

          if (!vm.getMeterValidFrom() || mountDate.isAfter(validFrom)) {
            vm.meterModel.ValidFrom = vm.meterModel.MountDate;
            vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              propertyLocationId: vm.meterModel.PropertyLocationId.Value ? vm.meterModel.PropertyLocationId.Value : 0,
              validFrom: vm.getMeterValidFrom(),
            };
            vm.meterModel.PremiseId = { Text: null, Value: null };
          } else {
            vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl.$validate();
          }
        },
      };

      var onBlurFunctions = {};

      var customCallbackFunctions = {
        IsUnitPrice: function(value) {
          if (!value) {
            vm.meterModel.UnitPriceCalcMode = null;
            vm.disableEdit = false;
          } else {
            vm.disableEdit = true;
          }
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        UnitPriceCalcMode: {
          required: function(modelValue, viewValue) {
            return !(
              (vm.meterModel.ParentalMeterAreaId === null || vm.meterModel.ParentalMeterAreaId.Value === null) &&
              vm.meterModel.IsUnitPrice === true &&
              modelValue === null
            );
          },
        },
        DisMountDate: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          MeterValidDisMountDate: function(modelValue, viewValue) {
            if (vm.getMeterValidFrom() === null || !modelValue || !viewValue) {
              return true;
            }

            var disMountDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            if (disMountDateValue === null) {
              return true;
            }

            var validFromValue = new moment(vm.getMeterValidFrom(), kendo.culture().calendar.patterns.d.toUpperCase());
            var mountDateValue = new moment(vm.meterModel.MountDate, kendo.culture().calendar.patterns.d.toUpperCase());

            return disMountDateValue.isSameOrAfter(validFromValue) && disMountDateValue.isSameOrAfter(mountDateValue);
          },
          required: function(modelValue, viewValue) {
            return !(vm.meterModel.Status === 'USTIN' && (modelValue === null || modelValue === ''));
          },
        },

        DisMountState: {
          required: function(modelValue, viewValue) {
            return !(vm.meterModel.Status === 'USTIN' && (modelValue === null || modelValue === ''));
          },
        },

        ValidFrom: {
          ValidFromLTMountDate: function(modelValue, viewValue) {
            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var mountDateValue = new moment(vm.meterModel.MountDate, kendo.culture().calendar.patterns.d.toUpperCase());
            return validFromValue.isSameOrAfter(mountDateValue);
          },
          ValidFromDateAfterDividedPeriod: function(modelValue, viewValue) {
            let validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            let dataIsChanged = vm.dataIsChanged();
            return (
              !vm.isNewTimeStamp() ||
              !dataIsChanged ||
              (dataIsChanged && (validFromValue.isAfter(vm.lastDividedPeriodEnding) || !vm.lastDividedPeriodEnding))
            );
          },
          ValidFromDateFirstDayIfDividedPeriod: function(modelValue, viewValue) {
            let validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase(), true);
            let dataIsChanged = vm.dataIsChanged([
              'IsUnitPrice',
              'UnitPriceCalcMode',
              'BaseFeeSplitMode',
              'AccountContact',
            ]);
            return (
              !vm.isNewTimeStamp() ||
              !dataIsChanged ||
              (dataIsChanged &&
                (validFromValue.isAfter(vm.lastDividedPeriodEnding) || !vm.lastDividedPeriodEnding) &&
                validFromValue.date() == 1)
            );
          },
        },
        Status: {
          StatusChangeOnlyOnePerMonth: function(modelValue, viewValue) {
            let validFromValue = new moment(
              vm.meterModel.ValidFrom,
              kendo.culture().calendar.patterns.d.toUpperCase(),
              true
            );
            return (
              modelValue === 'USTIN' ||
              validFromValue.date() === 1 ||
              !vm.acceptableStatusInPeriod ||
              vm.acceptableStatusInPeriod === modelValue
            );
          },
        },
      };

      var asyncValidators = {};

      var parsers = {};

      vm.pageModel.Grids.GridMeterReadingAggrDaily.Columns.forEach(x => {
        if (x.field === 'DailyAvg' || x.field === 'DailyMax' || x.field === 'DailyMin' || x.field === 'DailySum') {
          x.format = '{0:n3}';
        }
      });
      vm.pageModel.Grids.GridMeterReadingAggrHourly.Columns.forEach(x => {
        if (x.field === 'HourlyAvg' || x.field === 'HourlyMax' || x.field === 'HourlyMin' || x.field === 'HourlySum') {
          x.format = '{0:n3}';
        }
      });

      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      function deleteMeter() {
        var id = vm.meterModel.MeterId;
        var tmId = vm.meterModel.MeterTMId;

        var dialogMessage = vm.messages.DeleteDialogConfirmMessage;
        dialogMessage = dialogMessage.replace('{0}', '(' + vm.pageModel.SerialNumber + ')');
        if (vm.meterModel.LastTmId == tmId) {
          dialogMessage = 'Az utolsó időpecséttel a mérőóra is törlődni fog! \n<br/>' + dialogMessage;
        }
        bootbox.dialog({
          message: dialogMessage,
          title: vm.messages.Warning,
          buttons: {
            cancel: {
              label: kendo.ui.Confirm.prototype.options.messages.cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: kendo.ui.Confirm.prototype.options.messages.okText,
              className: 'btn-primary',
              callback: function() {
                $http.get('Utility/MeterDelete/' + id + '?tmId=' + tmId).then(function(result) {
                  toastr.success(vm.messages.DeleteSuccessful);
                  if (result.data.LastTmId > 0) {
                    $state.go('Utility.MeterEdit', { id: id }, { reload: true });
                  } else {
                    $state.go('Utility.MeterNav', {}, { reload: true });
                  }
                });
              },
            },
          },
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      //InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////// [ Dynamic SubItem Grid generation] ///////////////////////////
      //vm.activeSubItemTab = 0;
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        [
          'PanelAlapa',
          'PanelTovA',
          'PanelMeterReading',
          'PanelMeterChange',
          'PanelEgyebA',
          'PanelRentUnit',
          'PanelPremiseGauge',
          'PanelEquipmentGauge',
          'PanelConsDivided',
          'PanelDailyReading',
          'PanelInvoice',
        ],
        function(gridModel) {
          gridModel.ControllerMethod = `Utility/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              return {
                targetMeterId: vm.meterModel.MeterId,
                targetMeterAreaId: vm.meterModel.MeterAreaId,
                meterId: vm.meterModel.MeterId,
                consDividedId: vm.meterModel.MeterId,
                dailyReadingMeterId: vm.selectedMainGridItemId,
              };
            },
          };
        }
      );
      vm.subItemTabs = generatedGridTabs.tabs;

      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      var generatedSubDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelMeterInvoiceRowDetail'],
        function(gridModel) {
          gridModel.ControllerMethod = `Utility/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              var selectedItems = GetSelectedItems(vm.subGrids['GridInvoice']);
              return {
                targetInvoiceId: selectedItems.InvoiceId,
              };
            },
          };
        }
      );

      var generatedDailyGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelHourlyAggrGrid', 'PanelDailyAggrGrid'],
        function(gridModel) {
          gridModel.Table;
          return {
            gridModel,
            transportData: {
              tableName: gridModel.Table,
              targetMeterId: vm.meterModel.MeterId,
              whereCondition: function() {
                return 'MeterId~eq~' + vm.meterModel.MeterId;
              },
              adopter: gridModel.Adopter,
              installAdopter: gridModel.InstallAdopter,
              idColumn: gridModel.IdColumn,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.generatedDailyReadGrids = generatedDailyGridTabs.grids;
      vm.generatedDailyReadTabs = generatedDailyGridTabs.tabs;
      vm.generatedDailyReadTabs.push(vm.subItemTabs.find(x => x.name == 'TabDailyReading'));
      vm.generatedDailyReadGrids.push('GridDailyReading');

      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      vm.subDetailItemTabs = generatedSubDetailGridTabs.tabs;
      vm.subDetailGrids = generatedSubDetailGridTabs.grids;

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      // Valid/Érvényesség kiválasztása
      vm.pageModel.Fields.Valid.transData = function() {
        return {
          id: vm.meterModel.MeterId,
        };
      };
      //collapse menu
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'dataIsCollapsed':
            vm.activeBooleans['dataIsActive'] = true;
            break;
          case 'moreDetailsIsCollapsed':
            vm.activeBooleans['moreDetailsIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
        }
      };
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly || vm.meterModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      function checkBeforeSave() {
        saveItem();
      }

      function warnings() {
        if (
          !vm.meterModel.ServicePrice &&
          (!vm.meterModel.IsUnitPrice || (vm.meterModel.IsUnitPrice && vm.meterModel.UnitPriceCalcMode == 'UPCFX'))
        ) {
          let message =
            'Szolgáltatás díja mező értékének hiánya miatt a közmű díj nem fog kiszámlázásra kerülni! Kérem töltse ki a mezőt, amennyiben szeretne számlázni a mérőórához kapcsolódóan!';
          toastr.warning(message);
        }
      }
      /// Saves the current main item
      function saveItem() {
        vm.meterModel.ServiceId = vm.meterModel.ServiceId ?? 0;
        if (vm.editOrDuplicate === 'Duplicate') {
          $http
            .post('Utility/MeterDuplicate', vm.meterModel)
            .then(function(response) {
              warnings();
              vm.formly.$setPristine();
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              if (response.data.Messages && response.data.Messages.length > 0) {
                toastr.warning(response.data.Messages[0].Message);
              }
              $state.go('Utility.MeterEdit', {
                id: response.data.MeterId,
              });
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        } else {
          $http
            .post('Utility/MeterEdit', vm.meterModel)
            .then(function(response) {
              warnings();
              vm.formly.$setPristine();
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              if (response.data.Messages && response.data.Messages.length > 0) {
                toastr.warning(response.data.Messages[0].Message);
              }
              if (createOrEdit === 'Create') {
                $state.go('Utility.MeterEdit', {
                  id: response.data.MeterId,
                });
              } else {
                $state.go('Utility.MeterEdit', {}, { reload: true });
              }
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Initialisation of Dynamic F2 filters ] /////////////////////

      // ParentalMeterAreaId/Főmérő azonosító
      if (vm.meterModel.MeterId !== null && vm.meterModel.MeterId > 0) {
        vm.pageModel.Fields.ParentalMeterAreaId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          utilityTypeId: vm.meterModel.UtilityTypeId,
          currenMeterId: vm.meterModel.MeterId,
          meterAreaid: vm.meterModel.MeterAreaId,
        };
      }
      //###
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "ServiceType~in~'CSEPU'";
      };

      if (vm.meterModel.PropertyLocationId !== null && vm.meterModel.PropertyLocationId.Value > 0) {
        // PremiseId/Helyiség
        vm.selectedTenement = vm.meterModel.ImmovableId.Value;
      }

      //formly.$invalid was false when required f2 grids were empty.
      function isSaveDisabled() {
        if (vm.formly) {
          var isInvalid = vm.formly.$invalid;
          var hasPLI = vm.meterModel.PropertyLocationId && vm.meterModel.PropertyLocationId.Value !== null;
          var hasServiceId = vm.meterModel.ServiceId && vm.meterModel.ServiceId.Value !== null;

          if (isInvalid === false && hasPLI && (!isServiceIdRequired() || hasServiceId)) {
            return false;
          }
          return true;
        }
      }

      function viewPercentage() {
        editPercentage(vm.meterModel.MeterId, true);
        // var id = getSelectedSubGridItemId();
        // if (!!id) {
        // editPercentage(vm.meterModel.MeterId, true);
        // } else {
        // toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        // }
      }

      ///////////////////// [ Dynamic executor functions for sub items ] //////////////////////
      function createSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var MeterId = vm.meterModel.MeterId;
        if (urlPrefix === 'GridMeterReading' || urlPrefix === 'GridMeterChange') {
          $state.go('Utility.' + urlPrefix + 'Create', { id: id, MeterId: MeterId });
        } else if (urlPrefix === 'GridDailyReading') {
          $state.go('Utility.' + urlPrefix + 'Create', { meterId: MeterId });
        } else if (
          urlPrefix === 'GridPremiseGauge' ||
          urlPrefix === 'GridRentUnit' ||
          urlPrefix === 'GridEquipmentGauge'
        ) {
          $state.go('Utility.' + urlPrefix + 'Create', {
            meterId: MeterId,
          });
        }
      }
      function editPercentage(id, readOnly) {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utility/MeterRentUnitModal.html',
          controller: 'MeterRentUnitModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Utility/DividedPercent' + (readOnly ? 'View' : 'Edit') + '/?meterId=' + id),
            formModifiers: readOnly,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function(result) {
          console.log(result);
          $('#subGrid' + gridName)
            .data('kendoGrid')
            .dataSource.read();
        });
      }

      /// Saves the current main item
      function editSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var MeterId = vm.meterModel.MeterId;

        if (!!id) {
          if (gridName === 'GridMeterReading') {
            $http
              .get('Utility/GetMeterConsDivided', { params: { meterReadingId: id } })
              .then(function(result) {
                $state.go('Utility.' + urlPrefix + 'Edit', { id: id, MeterId: MeterId });
              })
              .catch(function(response) {
                //toastr.error(vm.pageModel.Messages.SaveFailed);
              });
            return;
          }
          if (gridName === 'GridRentUnit') {
            editPercentage(MeterId, false);
            return;
          }
          $state.go('Utility.' + urlPrefix + 'Edit', { id: id, MeterId: MeterId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      /// Deletes the selected item(s) of the active subItem grid
      function deleteSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var item = getSelectedSubGridItem();
        var id = getSelectedSubGridItemId();

        if (gridName === 'GridPremiseGauge' || gridName === 'GridEquipmentGauge') {
          id = vm.meterModel.MeterId;
          $http.get('Utility/Check' + gridName + 'ValidTo', { params: { id: id } }).then(function(result) {
            if (!result.data.Value) {
              bootbox
                .dialog({
                  message: 'Minden tétel törlésre fog kerülni, biztos folytatja?',
                  title: vm.messages.Warning,
                  buttons: {
                    cancel: {
                      label: vm.pageModel.Messages.Cancel,
                      className: 'btn-default',
                      callback: function() {},
                    },
                    confirm: {
                      label: vm.pageModel.Messages.Confirm,
                      className: 'btn-primary',
                      callback: function() {
                        $http
                          .get('Utility/' + urlPrefix + 'Delete/', { params: { id: id, validToFilter: false } })
                          .then(function() {
                            toastr.success(vm.messages.DeleteSuccessful);
                            $(getSubGridId(gridName))
                              .data('kendoGrid')
                              .dataSource.read();
                          });
                      },
                    },
                  },
                })
                .catch(function(response) {
                  //toastr.error(vm.pageModel.Messages.SaveFailed);
                });
            } else {
              bootbox
                .dialog({
                  message: 'Biztos, hogy törli az összes érvényes tételt?',
                  title: vm.messages.Warning,
                  buttons: {
                    cancel: {
                      label: vm.pageModel.Messages.Cancel,
                      className: 'btn-default',
                      callback: function() {},
                    },
                    confirm: {
                      label: vm.pageModel.Messages.Confirm,
                      className: 'btn-primary',
                      callback: function() {
                        $http
                          .get('Utility/' + urlPrefix + 'Delete/', { params: { id: id, validToFilter: true } })
                          .then(function() {
                            toastr.success(vm.messages.DeleteSuccessful);
                            $(getSubGridId(gridName))
                              .data('kendoGrid')
                              .dataSource.read();
                          });
                      },
                    },
                  },
                })
                .catch(function(response) {
                  //toastr.error(vm.pageModel.Messages.SaveFailed);
                });
            }
          });
          return;
        }
        if (!!id) {
          if (gridName === 'GridRentUnit') {
            id = vm.meterModel.MeterId;
          } else if (gridName === 'GridMeterReading') {
            $http
              .get('Utility/GetMeterConsDivided', { params: { meterReadingId: id } })
              .then(function(result) {
                bootbox.dialog({
                  message: 'Biztos benne, hogy törölni kívánja a kiválasztott óraállást?',
                  title: vm.messages.Warning,
                  buttons: {
                    cancel: {
                      label: vm.pageModel.Messages.Cancel,
                      className: 'btn-default',
                      callback: function() {},
                    },
                    confirm: {
                      label: vm.pageModel.Messages.Confirm,
                      className: 'btn-primary',
                      callback: function() {
                        $http.get('Utility/' + urlPrefix + 'Delete/' + id).then(function() {
                          toastr.success(vm.messages.DeleteSuccessful);
                          $('#subGrid' + gridName)
                            .data('kendoGrid')
                            .dataSource.read();
                        });
                      },
                    },
                  },
                });
              })
              .catch(function(response) {
                //toastr.error(vm.pageModel.Messages.SaveFailed);
              });
            return;
          } else if (gridName === 'GridConsDivided') {
            $http
              .get('Utility/GetErasableStateOnConsDivided', { params: { consDividedId: id } })
              .then(function(result) {
                bootbox.dialog({
                  message:
                    'Biztos benne, hogy a ' +
                    item.Period0 +
                    ' fogyasztási hónapra vonatkozó felosztást törölni kívánja ennél a mérőóránál minden bérleményre?',
                  title: vm.messages.Warning,
                  buttons: {
                    cancel: {
                      label: vm.pageModel.Messages.Cancel,
                      className: 'btn-default',
                      callback: function() {},
                    },
                    confirm: {
                      label: vm.pageModel.Messages.Confirm,
                      className: 'btn-primary',
                      callback: function() {
                        $http.get('Utility/' + urlPrefix + 'Delete/' + id).then(function() {
                          toastr.success(vm.messages.DeleteSuccessful);
                          $('#subGrid' + gridName)
                            .data('kendoGrid')
                            .dataSource.read();
                        });
                      },
                    },
                  },
                });
              })
              .catch(function(response) {
                /*if (response.status != 403) {
                        toastr.error(vm.pageModel.Messages.DeleteFailed);
                    }*/
              });
            return;
          }

          var validFromValue = new moment(item.ValidFrom).format(kendo.culture().calendar.patterns.d.toUpperCase());
          var dialogMessage = vm.messages.SubItemDialogConfirmMessage;
          switch (gridName) {
            case 'GridMeterReading':
              dialogMessage = dialogMessage.replace('{0}', ': ' + item.State + ' - ' + item.Address + '?');
              break;
            case 'GridRentUnit':
              dialogMessage = item.IsWaterMeter
                ? 'A ' + validFromValue + ' dátumú érvényesség törlése több bérleményt is érinthet!'
                : dialogMessage.replace('{0}', '?');
              break;
            default:
              dialogMessage = dialogMessage.replace('{0}', '?');
              break;
          }
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Utility/' + urlPrefix + 'Delete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    if (gridName == 'GridRentUnit' && item.IsWaterMeter) {
                      toastr.warning(
                        'Kérem az érvényességhez tartozó valamennyi bérleménynél ellenőrizze a közmű típusú beállításokat!'
                      );
                    }

                    $(getSubGridId(gridName))
                      .data('kendoGrid')
                      .dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function divideMeterQuantity() {
        $uibModal.open({
          component: 'sbDivideMeterQuantityModal',
          resolve: {
            fModel: RouteResolveFunc('Utility/GetDivideMeterQuantity/'),
          },
          backdrop: 'static',
        });
      }

      function WAL(whichGrid) {
        switch (vm.activeSubItemTab) {
          case 0:
            walService.NavigateToWal('Utility', 'MeterReadingNavWal', 'FlgMeterReadingView');
            break;
          case 1:
            walService.NavigateToWal('Utility', 'MeterChangeNavWal', 'FlgMeterChangeView');
            break;
          case 2:
            walService.NavigateToWal('Utility', 'MeterRentUnitNavWal', 'FlgMeterRentUnitView');
            break;
          case 3:
            walService.NavigateToWal('Utility', 'MeterPremiseGaugeNavWal', 'FlgPremiseOfGaugeView');
            break;
          case 4:
            walService.NavigateToWal('Utility', 'MeterEquipmentGaugeNavWal', 'FlgEquipmentOfGaugeView');
            break;
          case 5:
            walService.NavigateToWal('Utility', 'ConsDividedNavWal', 'FlgConsDividedView');
            break;
          case 6:
            walService.NavigateToWal('Utility', 'DailyReadingNavWal', 'FlgMeterDailyReading');
            break;
          default:
            break;
        }
      }

      function history() {
        var id = getSelectedSubGridItemId();

        if (!id) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          switch (vm.activeSubItemTab) {
            case 0:
              HistoryService.NavigateToHistory('FlgMeterReadingView', id, vm, $state, true);
              break;
            case 1:
              HistoryService.NavigateToHistory('FlgMeterChangeView', id, vm, $state, true);
              break;
            case 2:
              HistoryService.NavigateToHistory('FlgMeterRentUnitView', id, vm, $state, true);
              break;
            case 3:
              HistoryService.NavigateToHistory('FlgPremiseOfGaugeView', id, vm, $state, true);
              break;
            case 4:
              HistoryService.NavigateToHistory('FlgEquipmentOfGaugeView', id, vm, $state, true);
              break;
            case 5:
              HistoryService.NavigateToHistory('FlgConsDividedView', id, vm, $state, true);
              break;
            case 6:
              HistoryService.NavigateToHistory('FlgMeterDailyReadingView', id, vm, $state, true);
              break;
            default:
              break;
          }
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      function isDisabled() {
        var item = getSelectedSubGridItem();

        if (item.InvoiceId > 0) {
          return true;
        }

        var lastDate;
        angular.forEach(vm.subGrids.GridMeterReading.dataSource._data, function(value, key) {
          if (!lastDate) {
            lastDate = value.ReadingDate;
          } else {
            if (value.ReadingDate > lastDate) {
              lastDate = value.ReadingDate;
            }
          }
        });

        if (item.ReadingDate !== lastDate) {
          return true;
        }

        return false;
      }

      vm.changedTabIndex = function(index, scope) {
        vm.activeSubItemTab = index;
      };

      function getSelectedSubGridItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $(getSubGridId(gridName)).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);

        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function hasSubGridValidRows() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $('#subGrid' + gridName).data('kendoGrid');
        if (!gridRef || !gridRef.dataSource || !gridRef.dataSource._data[0]) {
          return false;
        }
        return gridRef.dataSource._data.some(x => !x.ValidTo);
      }

      function getSubGridId(gridName) {
        let gridId;
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        if (!!vm.generatedDailyReadTabs[vm.meterModel.GridTypeCombo]?.gridName && gridName === 'GridDailyReading') {
          gridId = '#dailyGrid' + vm.generatedDailyReadTabs[vm.meterModel.GridTypeCombo].gridName;
        } else {
          gridId = '#subGrid' + gridName;
        }
        return gridId;
      }

      function hasSubGridRows() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $(getSubGridId(gridName)).data('kendoGrid');
        if (!gridRef || !gridRef.dataSource || !gridRef.dataSource._data[0]) {
          return false;
        }
        return true;
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;

      vm.createSubItemShow = showCreateButton;
      vm.editSubItemShow = showEditButton;
      vm.percentSubItemShow = showPercentageButton;
      vm.deleteSubItemShow = showDeleteButton;
      vm.meterEditWalShow = showMeterEditWal;
      vm.meterAttachDocShow = showMeterAttachDoc;
      vm.meterHistoryShow = showMeterHistory;
      vm.walSubItemShow = showStandardButtons;
      vm.attachDocumentSubItemShow = showStandardButtons;
      vm.historySubItemShow = showStandardButtons;
      vm.closeValidRowsShow = showCloseButton;
      vm.disableSubItemCreate = disableSubButtons;
      vm.hasSubGridValidRows = hasSubGridValidRows;
      vm.hasSubGridRows = hasSubGridRows;
      vm.closeValidRows = closeValidRows;

      function closeValidRows() {
        const gridName = vm.subItemTabs[vm.activeSubItemTab].gridName.substr(4);
        const modalInstance = $uibModal.open({
          templateUrl: 'App/Utility/CloseOpenSubGridRowsModal.html',
          controller: 'CloseOpenSubGridRowsModalCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc('Utility/' + gridName + 'CloseValidRows/', { meterId: vm.meterModel.MeterId }),
            parameter: {
              gridName: gridName,
            },
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function() {
          var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
          $('#subGrid' + gridName)
            .data('kendoGrid')
            .dataSource.read();
        });
      }

      function disableSubButtons() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        if (name === 'GridRentUnit' && !vm.meterModel.IsRentUnitActive) {
          return true;
        }
        if (name === 'GridPremiseGauge' && !vm.meterModel.IsPremiseGaugeActive) {
          return true;
        }
        if (name === 'GridEquipmentGauge' && !vm.meterModel.IsEquipmentGaugeActive) {
          return true;
        }
        if (name === 'GridDailyReading') {
          return false;
        }
        return false;
      }

      function showCreateButton() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return name === 'GridConsDivided' || name === 'GridInvoice' || gridComboValue;
      }

      function showMeterEditWal() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return name === 'GridInvoice' || gridComboValue;
      }

      function showMeterAttachDoc() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return name === 'GridInvoice' || gridComboValue;
      }

      function showMeterHistory() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return name === 'GridInvoice' || gridComboValue;
      }

      function showEditButton() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return (
          name === 'GridConsDivided' ||
          name === 'GridMeterChange' ||
          name === 'GridPremiseGauge' ||
          name === 'GridEquipmentGauge' ||
          name === 'GridRentUnit' ||
          name === 'GridInvoice' ||
          gridComboValue
        );
      }

      function showPercentageButton() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        return name === 'GridRentUnit';
      }
      function showDeleteButton() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridComboValue = vm.activeSubItemTab == 6 && vm.meterModel.GridTypeCombo != 2;
        return name === 'GridMeterChange' || name === 'GridInvoice' || gridComboValue;
      }

      function showStandardButtons() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        return name === 'GridConsDivided' || name === 'GridInvoice';
      }

      function showCloseButton() {
        var name = vm.subItemTabs[vm.activeSubItemTab].gridName;
        return name === 'GridPremiseGauge' || name === 'GridEquipmentGauge';
      }

      function getLastDividedPeriod() {
        let validFromObj = new moment(vm.getMeterValidFrom(), kendo.culture().calendar.patterns.d.toUpperCase(), true);
        if (validFromObj.isValid()) {
          $http({
            method: 'GET',
            url: 'Utility/GetLastDividedPeriod',
            params: {
              meterId: vm.meterModel.MeterId,
              validFrom: vm.getMeterValidFrom(),
              validTo: vm.meterModel.ValidTo,
            },
          }).then(function successCallback(response) {
            vm.lastDividedPeriodEnding = !!response.data.PeriodEndDate
              ? new moment(response.data.PeriodEndDate, kendo.culture().calendar.patterns.d.toUpperCase())
              : null;
            vm.acceptableStatusInPeriod = response.data.AcceptableStatusInPeriod;
            vm.hasRentUnit = response.data.HasRentUnit;
            vm.lastValidFrom = response.data.LastValidFrom;
          });
        }
      }

      if (
        createOrEdit === 'Create' &&
        vm.meterModel &&
        (vm.meterModel.UtilityTypeId !== null || vm.meterModel.UtilityTypeId !== -1)
      ) {
        vm.meterModel.ParentalMeterAreaId = null;

        vm.pageModel.Fields.ParentalMeterAreaId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          utilityTypeId: vm.meterModel.UtilityTypeId,
          currenMeterId: vm.meterModel.MeterId,
        };
      }
      //
      vm.pageModel.Fields.ProviderId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "PartnerCatType~neq~'PTCID'";
      };

      //PremiseId whereCondition:
      vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        propertyLocationId:
          vm.meterModel.PropertyLocationId && vm.meterModel.PropertyLocationId.Value
            ? vm.meterModel.PropertyLocationId.Value
            : 0,
        validFrom: vm.getMeterValidFrom(),
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'FileSaver',
    'Blob',
    'LanguageService',
    '$timeout',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      FileSaver,
      Blob,
      LangService,
      $timeout,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.filterModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      // MenuItems
      vm.createMeter = createMeter;
      vm.duplicateMeter = duplicateMeter;
      vm.editMeter = editMeter;
      vm.deleteMeter = deleteMeter;
      vm.viewMeter = viewMeter;
      vm.meterHierarchy = meterHierarchy;
      vm.showMap = showMap;
      vm.exportList = exportList;
      vm.filter = filter;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.divideMeterQuantity = divideMeterQuantity;
      vm.meterCharts = meterCharts;

      vm.usedMeterGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
        localStorage.setItem($state.previous.name + '_' + 'filter', vm.filterModel.UtilityTypeId);
      });

      vm.back = function() {
        $state.go('main');
      };

      vm.IsActiveOnly = false;
      vm.TimeMachineFilter = false;
      //     return dto for controller method
      vm.getFilter = function() {
        return {
          utilityTypeId: vm.filterModel.UtilityTypeId,
          isActive: vm.IsActiveOnly,
          tmFilter: vm.TimeMachineFilter,
          rentUnitId: vm.filterModel.RentUnitId.Value,
        };
      };
      vm.mainGridIdField = vm.pageModel.Grids['GridMeter'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      function filter() {
        vm.mainGrid.dataSource.read();
        clearSubItemGrid();
      }

      // Set combo default
      vm.filterModel.UtilityTypeId = localStorage.getItem($state.current.name + '_' + 'filter') || null;
      vm.filterModel.RentUnitId = JSON.parse(localStorage.getItem($state.current.name + '_' + 'filter_rentunit')) || {
        Value: null,
        Text: null,
      };

      LangService.updateLang();

      vm.toggleTMFilterState = function() {
        vm.filter();
      };

      var onChangeFunctions = {
        UtilityTypeId: function(selectedItem) {
          vm.filterModel.UtilityTypeId = selectedItem.key;
          localStorage.setItem($state.current.name + '_' + 'filter', vm.filterModel.UtilityTypeId);
          vm.filter();
        },
        RentUnitId: function(selectedItem) {
          if (!!selectedItem.Value) {
            localStorage.setItem(
              $state.current.name + '_' + 'filter_rentunit',
              JSON.stringify(vm.filterModel.RentUnitId)
            );
          } else {
            localStorage.removeItem($state.current.name + '_' + 'filter_rentunit');
          }

          setTimeout(function() {
            vm.filter();
          });
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridMeter,
        'Utility/ListWithFilters/',
        function() {
          changeSubItemGridFilter(vm.mainGrid);
        },
        vm.getFilter
      );

      vm.mainGridOptions.autoBind = true;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Filter fields ] //////////////////////////////////////////
      //
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.filterFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      vm.pageModel.Fields.RentUnitId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Level~eq~'PPRRU'";
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////// [ Dynamic SubItem Form generation] ///////////////////////////
      // TODO LT a saját modellt nem kellene mutatnia itt!
      vm.getSelectedMainGridItemId = function() {
        return {
          targetMeterId: vm.selectedMainGridItemId,
          targetMeterAreaId: vm.selectedMeterAreaId,
          meterId: vm.selectedMainGridItemId,
          consDividedId: vm.selectedMainGridItemId,
          dailyReadingMeterId: vm.selectedMainGridItemId,
        };
      };
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Utility/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      vm.indexOfTabMeterInvoiceRowDetail = null;
      vm.subItemTabs.forEach(function(item, index) {
        if (item.name == 'TabMeterInvoiceRowDetail') {
          vm.indexOfTabMeterInvoiceRowDetail = index;
        }
      });
      vm.subItemTabs.splice(vm.indexOfTabMeterInvoiceRowDetail, 1);

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      function GetSelectedItems(selectedGrid) {
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems[0];
        }
      }

      var generatedSubDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelMeterInvoiceRowDetail'],
        function(gridModel) {
          gridModel.ControllerMethod = `Utility/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              var selectedItems = GetSelectedItems(vm.subGrids['GridInvoice']);
              return {
                targetInvoiceId: selectedItems.InvoiceId,
              };
            },
          };
        }
      );
      vm.subDetailItemTabs = generatedSubDetailGridTabs.tabs;
      vm.subDetailGrids = generatedSubDetailGridTabs.grids;

      // Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.selectedMeterAreaId = selectedItems[0].MeterAreaId;

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          !!value && value.dataSource.read();
        });
      }

      function clearSubItemGrid() {
        vm.selectedMainGridItemId = -1;
        vm.selectedMeterAreaId = -1;

        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          !!value && value.dataSource.data([]);
        });
      }

      //////////////////////////////////////////
      ////////////// Meter operations ///////////
      //////////////////////////////////////////

      function createMeter() {
        if (vm.filterModel.UtilityTypeId && vm.filterModel.UtilityTypeId !== '-1') {
          $state.go('Utility.MeterCreate', { id: 0, utilityType: vm.filterModel.UtilityTypeId });
        } else {
          $state.go('Utility.MeterCreate', { id: 0 });
        }
      }

      function duplicateMeter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Utility.MeterDuplicate', { id: id });
        }
      }

      /// Edits the selected main item
      function editMeter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Utility.MeterEdit', { id: id });
        }
      }
      function viewMeter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Utility.MeterView', { id: id });
        }
      }

      function meterHierarchy() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var modalInstanceTreeView = $uibModal.open({
            templateUrl: 'App/Utility/MeterHierarchy.html',
            controller: 'MeterHierarchyCtrl as vm',
            resolve: {
              model: RouteResolveFunc('Utility/GetMeterHierarchy?meterId=' + id),
            },
            backdrop: 'static',
          });
        }
      }

      function deleteMeter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = vm.messages.DeleteConfirmation;
          dialogMessage = dialogMessage.replace('{0}', '(' + selectedItem.SerialNumber + ')');
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: kendo.ui.Confirm.prototype.options.messages.cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: kendo.ui.Confirm.prototype.options.messages.okText,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Utility/MeterDelete/' + id + '?isEdit=false').then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function showMap() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          $state.go('Utility.Map');
        } else {
          var id = selectedItems[0].PropertyLocationId;
          $state.go('Utility.Map', { propertyId: id });
        }
      }

      function meterCharts() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Utility.MeterCharts', { id: id });
        }
      }

      function exportList() {
        var f = vm.mainGrid.dataSource;
        var filter = f.transport.parameterMap({
          filter: f.filter(),
          group: f.group(),
          page: 0,
          pageSize: 0,
          sort: f.sort(),
          utilityTypeId: vm.filterModel.UtilityTypeId,
          isActive: vm.IsActiveOnly,
          tmFilter: vm.TimeMachineFilter,
          rentUnitId: vm.filterModel.RentUnitId.Value,
        });

        $http.post('Utility/MeterListExport', filter).then(function(data) {
          var raw = window.atob(data.data.File);
          var rawLength = raw.length;
          var array = new Uint8Array(new ArrayBuffer(rawLength));

          for (var i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
          }
          var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(fs, 'export.xlsx');
        });
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeter', id);
      }

      function divideMeterQuantity() {
        $uibModal.open({
          component: 'sbDivideMeterQuantityModal',
          resolve: {
            fModel: RouteResolveFunc('Utility/GetDivideMeterQuantity/'),
          },
          backdrop: 'static',
        });
      }

      function WAL(whichGrid) {
        switch (whichGrid) {
          case vm.usedMeterGridEnum.MAIN:
            walService.NavigateToWal('Utility', 'MeterNavWal', 'FlgMeterView');
            break;
          case vm.usedMeterGridEnum.SUB:
            switch (vm.activeSubItemTab) {
              case 0:
                walService.NavigateToWal('Utility', 'MeterReadingNavWal', 'FlgMeterReadingView');
                break;
              case 1:
                walService.NavigateToWal('Utility', 'MeterChangeNavWal', 'FlgMeterChangeView');
                break;
              case 2:
                walService.NavigateToWal('Utility', 'MeterRentUnitNavWal', 'FlgMeterRentUnitView');
                break;
              case 3:
                walService.NavigateToWal('Utility', 'MeterPremiseGaugeNavWal', 'FlgPremiseOfGaugeView');
                break;
              case 4:
                walService.NavigateToWal('Utility', 'MeterEquipmentGaugeNavWal', 'FlgEquipmentOfGaugeView');
                break;
              case 5:
                walService.NavigateToWal('Utility', 'ConsDividedNavWal', 'FlgConsDividedView');
                break;
              case 6:
                walService.NavigateToWal('Utility', 'DailyReadingNavWal', 'FlgMeterDailyReading');
                break;
              default:
                break;
            }
            break;
          default:
            break;
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          HistoryService.NavigateToHistory('FlgMeter', selectedItems, vm, $state, true);
        }
      }
      /*
      vm.mainGridOptions.dataBound = function(e) {
        var mId = readCookie('mId');
        if (mId !== null) {
          var grid = e.sender;
          $.each(grid.tbody.find('tr'), function() {
            var model = grid.dataItem(this);
            if (model.MeterId === mId) {
              $('[data-uid=' + model.uid + ']').addClass('k-state-selected');
              grid.select(model);
              changeSubItemGridFilter(vm.mainGrid);
            }
          });
          document.cookie = 'mId=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
      };
*/
      function readCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterChartsCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'gridService',
    'UIHelperService',
    function($scope, options, $http, $state, gridService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterChartsCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.changedType = true;

      vm.formModel.options = {
        theme: $(document).data('kendoSkin') || 'default',
        title: {
          text: vm.formModel.MeterLabelName.toString(),
        },
        legend: {
          position: 'bottom',
        },
        seriesDefaults: {
          type: 'column',
        },
        series: [
          {
            field: 'Consumption',
            name: 'Fogyasztás',
          },
        ],
        valueAxis: {
          labels: {
            format: '{0}',
          },
          field: 'Consumption',
        },
        zoomable: true,
        categoryAxis: {
          field: 'Year',
        },
        tooltip: {
          visible: true,
          format: '{0}',
          template: '#= data.value #',
        },
        dataBound: vm.dataBound,
      };

      vm.back = function() {
        $state.go('Utility.MeterNav');
      };

      vm.changeChart = function(chartType) {
        vm.chartType = chartType;
      };

      vm.toggleMeterInfoPanel = function() {
        vm.isCollapsed1 = !vm.isCollapsed1;
      };

      vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.type = 'kendoMS';
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelChartInfo.FormlyDescriptor;
      vm.conboFields = formlyFormPanelDescriptors.PanelChartComboFilters.FormlyDescriptor;
      vm.diagramFields = formlyFormPanelDescriptors.PanelChartDiagram.FormlyDescriptor;
      vm.meterInfosFields = formlyFormPanelDescriptors.PanelChartMeterInfos.FormlyDescriptor;

      vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          id: vm.formModel.MeterId,
        };
      };

      vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {};

      var customExpressionProperties = {
        FilterChartByYearCombo: {
          hide: function() {
            let disabled =
              (vm.formModel.ChartTypeCombo != 'SCTYY' &&
                vm.formModel.ChartTypeCombo != 'SCTMM' &&
                vm.formModel.ChartTypeCombo != 'SCTDD') ||
              !vm.formModel.ChartTypeCombo;
            if (disabled) {
              vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
            }
            return disabled;
          },
        },
        FilterChartByMonthCombo: {
          hide: function() {
            let disabled =
              (vm.formModel.ChartTypeCombo != 'SCTMM' && vm.formModel.ChartTypeCombo != 'SCTDD') ||
              !vm.formModel.ChartTypeCombo;
            if (disabled) {
              vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
            }
            return disabled;
          },
        },
        FilterChartByDayCombo: {
          hide: function() {
            let disabled = vm.formModel.ChartTypeCombo != 'SCTHH' || !vm.formModel.ChartTypeCombo;
            return disabled;
          },
        },
      };

      var onChangeFunctions = {
        FilterChartByYearCombo: function(e) {
          if (vm.formModel.FilterChartByYearCombo) {
            vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
              return {
                id: vm.formModel.MeterId,
                year: vm.formModel.FilterChartByYearCombo,
              };
            };
          } else {
            vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
            vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
          }
          vm.reloadChart();
        },
        FilterChartByMonthCombo: function(e) {
          vm.reloadChart();
        },
        FilterChartByDayCombo: function() {
          vm.reloadChart();
        },
        ChartTypeCombo: function() {
          if (vm.formModel.ChartTypeCombo == 'SCTYY') {
            $(
              '[dom-id="' +
                vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.DOMId +
                '"]'
            ).data('kendoMultiSelect').options.maxSelectedItems = 3;
          } else if (vm.formModel.ChartTypeCombo == 'SCTMM') {
            $(
              '[dom-id="' +
                vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.DOMId +
                '"]'
            ).data('kendoMultiSelect').options.maxSelectedItems = 3;
            $(
              '[dom-id="' +
                vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.DOMId +
                '"]'
            ).data('kendoMultiSelect').options.maxSelectedItems = 12;
          } else if (vm.formModel.ChartTypeCombo == 'SCTDD') {
            $(
              '[dom-id="' +
                vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.DOMId +
                '"]'
            ).data('kendoMultiSelect').options.maxSelectedItems = 1;
            $(
              '[dom-id="' +
                vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.DOMId +
                '"]'
            ).data('kendoMultiSelect').options.maxSelectedItems = 1;
          }
          vm.changedType = true;
          vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
          vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [];
          vm.formModel.FilterChartByYearCombo = null;
          vm.formModel.FilterChartByMonthCombo = null;
          vm.formModel.FilterChartByDayCombo = null;
          vm.reloadChart();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      //collect and filter data for chart

      vm.unique = array => [...new Set(array)];

      vm.chartCallback = function(data) {
        if (!vm.changedType) {
          return;
        }
        vm.changedType = false;
        let maxYear = 0;
        let maxMonth = 0;
        let maxDay = 0;
        let max = 0;
        angular.forEach(data, function(x) {
          var tmpDate = x.Year + (x.Month ?? 0).toString().padStart(2, '0') + (x.Day ?? 0).toString().padStart(2, '0');
          if (tmpDate > max) {
            max = tmpDate;
            maxYear = x.Year;
            maxMonth = x.Month;
            maxDay = x.Day;
          }
        });
        if (vm.formModel.ChartTypeCombo == 'SCTYY') {
          if (maxYear > 0) {
            vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [maxYear];
          }
        } else if (vm.formModel.ChartTypeCombo == 'SCTMM') {
          var months = [];
          for (var i = 1; i < 13; i++) {
            months.push(i);
          }
          if (maxYear > 0) {
            vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [maxYear];
          }
          vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [...months];
        } else if (vm.formModel.ChartTypeCombo == 'SCTDD') {
          if (maxYear > 0) {
            vm.pageModel.Fields.FilterChartByYearCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [maxYear];
          }
          if (maxMonth > 0) {
            vm.pageModel.Fields.FilterChartByMonthCombo.FormlyFieldDescriptor.templateOptions.selectedItems = [
              maxMonth,
            ];
          }
        } else if (vm.formModel.ChartTypeCombo == 'SCTHH') {
          vm.formModel.FilterChartByDayCombo =
            maxYear +
            '. ' +
            (maxMonth ?? 0).toString().padStart(2, '0') +
            '. ' +
            (maxDay ?? 0).toString().padStart(2, '0') +
            '. ';
        }
      };

      vm.reloadChart = function() {
        if (vm.formModel.ChartTypeCombo == 'SCTYY') {
          vm.formModel.options.categoryAxis.field = '';
          var res = [];
          var years = [];
          vm.formModel.chartDataTransport = function(data) {
            const tmpData = data;
            years = [];
            res = [];
            var yearsTMP = [];
            tmpData.forEach(elem => {
              yearsTMP.push(elem.Year);
            });
            vm.unique(tmpData.map(x => x.Year))
              .sort()
              .forEach(function(year) {
                let tmpObj = {};
                tmpObj.name = year.toString();
                tmpObj.data = [];
                tmpObj.data.push(tmpData.find(o => o.Year == year)?.Consumption ?? 0);
                if (vm.chartType === 'area') {
                  tmpObj.data.unshift(0);
                  tmpObj.data.push(0);
                }
                res.push(tmpObj);
              });
            years = yearsTMP;
            return res;
          };
          vm.formModel.options.categoryAxis.categories = years;
          vm.chart.read(vm.chartCallback);
        } else if (vm.formModel.ChartTypeCombo == 'SCTMM') {
          vm.formModel.options.categoryAxis.field = '';
          var tmpMonths = [];
          var months = [];
          for (var i = 1; i < 13; i++) {
            if (
              !!vm.formModel.FilterChartByMonthCombo &&
              !vm.formModel.FilterChartByMonthCombo.split(',').find(x => x == i)
            ) {
              continue;
            }
            tmpMonths.push(moment('2011' + i.toString().padStart(2, '0') + '01', 'YYYYMMDD').format('MMMM'));
            months.push(i);
          }
          vm.formModel.chartDataTransport = function(data) {
            const tmpData = data;
            let years = [];
            vm.unique(data.map(x => x.Year))
              .sort()
              .forEach(function(x) {
                let tmpObj = {};
                tmpObj.name = x.toString();
                tmpObj.data = [];
                months.forEach(function(month) {
                  tmpObj.data.push(tmpData.find(y => y.Year == x && y.Month == month)?.Consumption ?? 0);
                });
                years.push(tmpObj);
              });
            return years;
          };
          vm.formModel.options.categoryAxis.categories = tmpMonths;
          vm.chart.read(vm.chartCallback);
        } else if (vm.formModel.ChartTypeCombo == 'SCTDD') {
          vm.formModel.options.categoryAxis.field = '';
          var tmpDais = [];
          var dais = [];
          let months = [];
          let years = [];
          vm.formModel.chartDataTransport = function(data) {
            months = [];
            const dataTMP = data;
            if (dataTMP[0]?.Month) {
              var numberOfDais = new Date(dataTMP[0].Year, dataTMP[0].Month, 0).getDate();
              for (var i = 1; i <= numberOfDais; i++) {
                let moment2 = moment(
                  '2011.' + dataTMP[0].Month + '.' + i.toString().padStart(2, '0'),
                  'YYYYMMDD'
                ).format('MM.DD');
                if (!tmpDais.includes(moment2)) {
                  tmpDais.push(moment2);
                }
                dais.push(i);
              }
            }
            vm.unique(data.map(x => x.Year))
              .sort()
              .forEach(function(x) {
                let tmpObj = {};
                tmpObj.name = x.toString();
                tmpObj.data = [];
                tmpDais.forEach(function(day) {
                  tmpObj.data.push(
                    dataTMP.find(y => y.Year == x && y.Month == day.split('.')[0] && y.Day == day.split('.')[1])
                      ?.Consumption ?? 0
                  );
                });
                months.push(tmpObj);
              });
            return months;
          };
          vm.formModel.options.categoryAxis.categories = tmpDais;
          vm.chart.read(vm.chartCallback);
        } else if (vm.formModel.ChartTypeCombo == 'SCTHH') {
          vm.formModel.options.categoryAxis.field = '';
          var tmpHours = [];
          for (var i = 0; i < 24; i++) {
            tmpHours.push(i);
          }
          vm.formModel.chartDataTransport = function(data) {
            const tmpData = data;
            let hours = [];
            vm.unique(data.map(x => x.Year + '.' + x.Month + '.' + x.Day))
              .sort()
              .forEach(function(x) {
                let tmpObj = {};
                tmpObj.name =
                  x.split('.')[0].toString() +
                  '.' +
                  x
                    .split('.')[1]
                    .toString()
                    .padStart(2, '0') +
                  '.' +
                  x
                    .split('.')[2]
                    .toString()
                    .padStart(2, '0');
                tmpObj.data = [];
                tmpHours.forEach(function(hour) {
                  tmpObj.data.push(
                    tmpData.find(
                      y =>
                        y.Year == x.split('.')[0] &&
                        y.Month == x.split('.')[1] &&
                        y.Day == x.split('.')[2] &&
                        y.Hour == hour
                    )?.Consumption ?? 0
                  );
                });
                hours.push(tmpObj);
              });
            return hours;
          };
          vm.formModel.options.categoryAxis.categories = tmpHours;
          vm.chart.read(vm.chartCallback);
        }
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('PremiseGaugeCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    'LockService',
    'gridService',
    'UIHelperService',
    function($scope, model, $http, $state, $stateParams, lockService, gridService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PremiseGaugeCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.labels = model.pageModel.Labels;
      vm.actions = model.pageModel.Actions;
      vm.formModel.isNotAllChecked = true;
      vm.disableSaveButton = true;
      vm.formModel.ValidFrom = ConvertDate(vm.formModel.ValidFrom);

      if (vm.formModel.MinPossibleValidFrom !== null) {
        vm.formModel.MinPossibleValidFrom = ConvertDate(vm.formModel.MinPossibleValidFrom);
      }

      function ConvertDate(convertableDate) {
        const date = moment(convertableDate);
        return date.format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.back = function() {
        $state.go('Utility.MeterEdit', { id: vm.formModel.MeterId });
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridPremiseGauge'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridPremiseGauge'];

      vm.mainGridOptions = getGridOptions(
        model.pageModel.Grids.GridPremiseGauge,
        'Utility/PremiseGaugeList/',
        function(row) {},
        { propertyLocationId: vm.formModel.PropertyLocationId }
      );
      vm.mainGridOptions.dataSource.serverPaging = false;
      vm.mainGridOptions.dataSource.serverSorting = false;
      vm.mainGridOptions.dataSource.serverFiltering = false;
      vm.mainGridOptions.dataSource.serverAggregates = false;
      vm.mainGridOptions.dataSource.serverGroupping = false;
      vm.mainGridOptions.toolbar = ['cancel'];
      (vm.mainGridOptions.selectable = 'multiple cell'), (vm.mainGridOptions.batch = true);
      vm.mainGridOptions.editable = true;

      function numericEditor(container, options) {
        $('<input data-bind="value:' + options.field + '"/>')
          ?.appendTo(container)
          ?.kendoNumericTextBox({
            decimals: '2',
            format: options.format ?? '',
          });
      }

      angular.forEach(vm.mainGridOptions.columns, function(value, key) {
        if (['Percents'].indexOf(value.field) !== -1) {
          value.editor = numericEditor;
          value.format = '{0:n2}';
        }
      });

      vm.mainGridOptions.dataBound = function(e) {
        var rows = e.sender.tbody.children();
        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.dirty === true) row[0].classList.add('row-corrected');
          else row[0].classList.remove('row-corrected');
        }
      };

      angular.forEach(vm.mainGridOptions.dataSource.schema.model.fields, function(value, key) {
        if (key === 'Percents') {
          value.editable = true;
        } else {
          value.editable = false;
        }
      });

      vm.mainGridOptions.columns.forEach(function(col) {
        if (col.field === 'Percents') {
          col.editable = function(d) {
            if (!vm.dataItem.find(x => x[vm.mainGridIdField] == d[vm.mainGridIdField])) {
              return false;
            }
            return true;
          };
        }
      });

      vm.mainGridOptions.save = function(event) {
        if (event.values.Percents < 0) {
          event.preventDefault();
          toastr.warning('Negatív érték nem adható meg!');
          return;
        }
        if (event.values.Percents > 100) {
          event.preventDefault();
          toastr.warning('A fogyasztási %-ok összege túllépi a 100%-ot! Kérem folytassa a karbantartást!');
          return;
        }
        vm;
        event.sender.refresh(event);
      };

      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];
      vm.dataItem = [];
      vm.checkedPercents = [];
      var checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        editable: function(dataItem) {
          return false;
        },
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '40px',
        lockable: false,
      };

      vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);

      function toggleSelect(event) {
        var checked = event.target.checked;
        vm.checkedIds = [];
        if (vm.mainGrid.dataSource.total() > 0) {
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.mainGrid, checked);
          } else {
            vm.selectAllTip = 'Egy sem';
            setAllNotChecked(checked);
          }
        }
      }

      function selectRow(event, item) {
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        manageSelectedIdArray(dataItem, checked);
      }

      function refreshCheckbox(grid, checked) {
        var view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = checked;
          manageSelectedIdArray(value, checked);
        });
      }

      function manageSelectedIdArray(dataItem, add) {
        if (add) {
          vm.dataItem.push(dataItem);
        } else {
          vm.dataItem = vm.dataItem.filter(function(e) {
            return e !== dataItem;
          });
        }
      }

      function setAllNotChecked(checked) {
        if (checked) {
          vm.formModel.isAllNotChecked = false;
        } else {
          vm.formModel.isAllNotChecked = true;
        }
        refreshCheckbox(vm.mainGrid, checked);
      }

      const syncValidators = {
        ValidFrom: {
          GaugeValidator: function(modelValue) {
            if (!modelValue || modelValue === null || modelValue === '') {
              return false;
            }
            return true;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      function checkBeforeSave() {
        const view = vm.mainGrid.dataSource.view();
        for (const element of view) {
          if (element.checked) {
            vm.formModel.isAllNotChecked = false;
            return;
          }
        }
      }

      vm.save = function() {
        bootbox.dialog({
          message: 'Sikerült minden szükséges tételt korrigálni?',
          title: 'Csak a módosított sorokra készül korrekció!',
          buttons: {
            cancel: {
              label: 'Nem',
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Igen',
              className: 'btn-primary',
              callback: function() {
                vm.formModel.NewValidityRows = [];
                checkBeforeSave();
                if (vm.formModel.isAllNotChecked === true) {
                  var list = vm.mainGrid.dataSource.view();
                  angular.forEach(list, function(value, key) {
                    manageSelectedIdArray(value, vm.formModel.isAllNotChecked);
                  });
                }

                var sumPercentage = 0;
                for (var i = 0; i < vm.dataItem.length; i++) {
                  if (vm.dataItem[i] && vm.dataItem[i].Percents) {
                    vm.formModel.NewValidityRows.push(vm.dataItem[i]);
                    sumPercentage += vm.dataItem[i].Percents;
                  }
                }

                if (vm.formModel.isAllNotChecked === true) {
                  vm.dataItem = [];
                }

                if (sumPercentage < 100) {
                  toastr.warning('A fogyasztási %-ok összege nem adják ki a 100%-ot! Kérem folytassa a karbantartást!');
                } else if (sumPercentage > 100) {
                  toastr.warning('A fogyasztási %-ok összege túllépi a 100%-ot! Kérem folytassa a karbantartást!');
                } else {
                  $http
                    .post('Utility/PremiseGaugeInsert', vm.formModel)
                    .then(function() {
                      toastr.success(vm.pageModel.Messages.SaveSuccessful);
                      $state.go('Utility.MeterEdit', {
                        id: vm.formModel.MeterId,
                      });
                    })
                    .catch(function() {
                      toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
                }
              },
            },
          },
        });
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('EquipmentGaugeCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    'LockService',
    'UIHelperService',
    function($scope, model, $http, $state, $stateParams, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentGaugeCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.labels = model.pageModel.Labels;
      vm.actions = model.pageModel.Actions;
      vm.formModel.isAllNotChecked = true;
      vm.formModel.ValidFrom = ConvertDate(vm.formModel.ValidFrom);

      if (vm.formModel.MinPossibleValidFrom !== null) {
        vm.formModel.MinPossibleValidFrom = ConvertDate(vm.formModel.MinPossibleValidFrom);
      }

      function ConvertDate(convertableDate) {
        var date = moment(convertableDate);
        return date.format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.back = function() {
        $state.go('Utility.MeterEdit', { id: vm.formModel.MeterId });
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridRoomInvForUtility'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridRoomInvForUtility'];

      vm.mainGridOptions = getGridOptions(
        model.pageModel.Grids.GridRoomInvForUtility,
        'Utility/RoomInvForUtilityList/',
        function(row) {},
        {
          propertyLocationId: vm.formModel.PropertyLocationId,
          validFrom: vm.formModel.ValidFrom,
        }
      );

      vm.mainGridOptions.dataSource.serverPaging = false;
      vm.mainGridOptions.dataSource.serverSorting = false;
      vm.mainGridOptions.dataSource.serverFiltering = false;
      vm.mainGridOptions.dataSource.serverAggregates = false;
      vm.mainGridOptions.dataSource.serverGroupping = false;
      vm.mainGridOptions.toolbar = ['cancel'];
      (vm.mainGridOptions.selectable = 'multiple cell'), (vm.mainGridOptions.batch = true);
      vm.mainGridOptions.editable = true;

      function numericEditor(container, options) {
        $('<input data-bind="value:' + options.field + '"/>')
          ?.appendTo(container)
          ?.kendoNumericTextBox({
            decimals: '2',
            format: options.format,
          });
      }

      angular.forEach(vm.mainGridOptions.columns, function(value, key) {
        if (['Percents'].indexOf(value.field) !== -1) {
          value.editor = numericEditor;
          value.format = '{0:n2}';
        }
      });

      vm.mainGridOptions.dataBound = function(e) {
        var rows = e.sender.tbody.children();
        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.dirty === true) row[0].classList.add('row-corrected');
          else row[0].classList.remove('row-corrected');
        }
      };

      angular.forEach(vm.mainGridOptions.dataSource.schema.model.fields, function(value, key) {
        if (key === 'Percents') {
          value.editable = true;
        } else {
          value.editable = false;
        }
      });

      vm.mainGridOptions.columns.forEach(function(c) {
        if (c.field === 'Percents') {
          c.editable = function(d) {
            if (!vm.dataItem.find(x => x[vm.mainGridIdField] == d[vm.mainGridIdField])) {
              return false;
            } else if (d.Percents > 100) {
              toastr.warning('Nem adható meg fogyasztási %, ha a fogyasztás nagyobb, mint 100%.');
              return false;
            }
            return true;
          };
        }
      });

      vm.mainGridOptions.save = function(e) {
        if (e.values.Percents < 0) {
          e.preventDefault();
          toastr.warning('Negatív érték nem adható meg!');
          return;
        }
        if (e.values.Percents > 100) {
          e.preventDefault();
          toastr.warning('A fogyasztási % összege túllépi a 100%-ot! Kérem folytassa a karbantartást!');
          return;
        }
        vm;
        e.sender.refresh(e);
      };

      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];
      vm.dataItem = [];
      vm.checkedPercents = [];
      const checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        editable: function(e) {
          return false;
        },
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '40px',
        lockable: false,
      };

      vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);

      function toggleSelect(event) {
        const checked = event.target.checked;
        vm.checkedIds = [];
        if (vm.mainGrid.dataSource.total() > 0) {
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.mainGrid, checked);
          } else {
            vm.selectAllTip = 'Egy sem';
            setAllNotChecked(checked);
          }
        }
      }
      function setAllCheck() {
        const view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value) {
          if (value.checked === true) vm.formModel.isAllNotChecked = true;
        });
      }
      function selectRow(event, item) {
        const checked = event.target.checked;
        const dataItem = item.dataItem;
        setAllCheck();
        manageSelectedIdArray(dataItem, checked);
      }

      function refreshCheckbox(grid, checked) {
        const view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = checked;
          manageSelectedIdArray(value, checked);
        });
      }

      function manageSelectedIdArray(dataItem, add) {
        if (add) {
          vm.dataItem.push(dataItem);
        } else {
          vm.dataItem = vm.dataItem.filter(function(e) {
            return e !== dataItem;
          });
        }
      }

      function setAllNotChecked(checked) {
        if (checked) {
          vm.formModel.isAllNotChecked = false;
        } else {
          vm.formModel.isAllNotChecked = true;
        }
        refreshCheckbox(vm.mainGrid, checked);
      }

      function checkBeforeSave() {
        const view = vm.mainGrid.dataSource.view();
        for (const element of view) {
          if (element.checked) {
            vm.formModel.isAllNotChecked = false;
            return;
          }
        }
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // vm.formFields = formlyFormPanelDescriptors.PanelApportion.FormlyDescriptor;

      const syncValidators = {
        ValidFrom: {
          GaugeValidator: function(modelValue) {
            if (!modelValue || modelValue === null || modelValue === '') {
              return false;
            }
            return true;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.save = function() {
        bootbox.dialog({
          message: 'Sikerült minden szükséges tételt korrigálni?',
          title: 'Csak a módosított sorokra készül korrekció!',
          buttons: {
            cancel: {
              label: 'Nem',
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Igen',
              className: 'btn-primary',
              callback: function() {
                vm.formModel.NewValidityRows = [];
                checkBeforeSave();
                if (vm.formModel.isAllNotChecked === true) {
                  var list = vm.mainGrid.dataSource.view();
                  angular.forEach(list, function(value, key) {
                    manageSelectedIdArray(value, vm.formModel.isAllNotChecked);
                  });
                }

                var sumPercentage = 0;
                for (var i = 0; i < vm.dataItem.length; i++) {
                  if (vm.dataItem[i] && vm.dataItem[i].Percents) {
                    vm.formModel.NewValidityRows.push(vm.dataItem[i]);
                    sumPercentage += vm.dataItem[i].Percents;
                  }
                }

                if (vm.formModel.isAllNotChecked === true) {
                  vm.dataItem = [];
                }

                if (sumPercentage < 100) {
                  toastr.warning('A fogyasztási %-ok összege nem adják ki a 100%-ot! Kérem folytassa a karbantartást!');
                } else if (sumPercentage > 100) {
                  toastr.warning('A fogyasztási %-ok összege túllépi a 100%-ot! Kérem folytassa a karbantartást!');
                } else {
                  $http
                    .post('Utility/EquipmentGaugeInsert', vm.formModel)
                    .then(function() {
                      toastr.success(vm.pageModel.Messages.SaveSuccessful);
                      $state.go('Utility.MeterEdit', {
                        id: vm.formModel.MeterId,
                      });
                    })
                    .catch(function() {
                      toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
                }
              },
            },
          },
        });
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterRentUnitCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'LockService',
    'gridService',
    'UIHelperService',
    function($scope, model, $http, $state, $stateParams, $uibModal, lockService, gridService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterRentUnitCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.labels = model.pageModel.Labels;
      vm.actions = model.pageModel.Actions;
      vm.formModel.isAllChecked = false;
      vm.isSaveDisabled = isSaveDisabled;
      vm.disableSaveButton = true;
      vm.mainGridIdField = vm.pageModel.Grids['GridProperty'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridProperty'];
      vm.originalValidFrom = ConvertDate(vm.formModel.ValidFrom);
      vm.formModel.ValidFrom = vm.originalValidFrom;

      function ConvertDate(convertableDate) {
        var date = moment(convertableDate);
        return date.format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign(model.pageModel.Grids.GridProperty, {
          ControllerMethod: 'Utility/MeterRentPropertyList/',
        }),
        transportData: function() {
          return { immovableId: vm.formModel.ImmovableId };
        },
        groupable: false,
      });
      vm.pageModel.Fields.Valid.transData = function() {
        return {
          id: vm.formModel.MeterId,
        };
      };
      gridService.setupMultiSelect(vm.mainGridOptions, {
        idField: vm.pageModel.Grids['GridProperty'].IdColumn,
        disableCheckbox: false,
        selectHandler: selectHandlerCore,
        selectAllHandler: selectHandlerCore,
      });
      var getPropertyFilter = function() {
        return '';
      };

      vm.validRentUnitList = [];

      function selectHandlerCore(e) {
        $scope.$applyAsync();
      }
      $scope.$applyAsync();

      vm.back = function() {
        //  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Utility.MeterEdit', { id: vm.formModel.MeterId });
      };

      vm.checkSave = function() {
        vm.formModel.PropertyList = angular.copy(gridService.getSelectedItems(vm.mainGrid));

        var gridName = 'ModalContractGrid';
        var transportData = {
          meterId: vm.formModel.MeterId,
          propertyIdList: vm.formModel.PropertyList,
          validFrom: vm.formModel.ValidFrom,
        };
        $http.post('Utility/CheckGrid', transportData).then(function(response) {
          if (
            response.data &&
            ((response.data.FeeGenList && response.data.FeeGenList.length > 0) ||
              (response.data.FeeNotGenList && response.data.FeeNotGenList.length > 0))
          ) {
            var feeGenListGridOptions = gridService.buildKendoConfigForGridModel({
              gridModel: vm.pageModel.Grids['ModalContractGrid'],
              transportData: {
                tableName: vm.pageModel.Grids['ModalContractGrid'].Table,
                whereCondition: "ContractId~in~'" + response.data.FeeGenList.join(',') + "'",
                adopter: vm.pageModel.Grids['ModalContractGrid'].Adopter,
                installAdopter: vm.pageModel.Grids['ModalContractGrid'].InstallAdopter,
                columnCsv: _.map(vm.pageModel.Grids['ModalContractGrid'].Columns, 'field').join(),
                idColumn: vm.pageModel.Grids['ModalContractGrid'].IdColumn,
              },
            });
            var feeNotGenListGridOptions = gridService.buildKendoConfigForGridModel({
              gridModel: vm.pageModel.Grids['ModalContractGrid'],
              transportData: {
                tableName: vm.pageModel.Grids['ModalContractGrid'].Table,
                whereCondition: "ContractId~in~'" + response.data.FeeNotGenList.join(',') + "'",
                adopter: vm.pageModel.Grids['ModalContractGrid'].Adopter,
                installAdopter: vm.pageModel.Grids['ModalContractGrid'].InstallAdopter,
                columnCsv: _.map(vm.pageModel.Grids['ModalContractGrid'].Columns, 'field').join(),
                idColumn: vm.pageModel.Grids['ModalContractGrid'].IdColumn,
              },
            });
            feeGenListGridOptions.autoBind = true;
            feeNotGenListGridOptions.autoBind = true;

            var modalInstance = $uibModal.open({
              templateUrl: 'App/Utility/SubItems/MeterContract.html',
              controller: 'MeterContractCtrl as vm',
              size: 'lg',
              backdrop: 'static',
              resolve: {
                model: {
                  feeGenList: feeGenListGridOptions,
                  feeNotGenList: feeNotGenListGridOptions,
                  messages: vm.messages,
                },
              },
            });

            modalInstance.result
              .then(function() {
                vm.save();
              })
              .catch(function() {
                //mégsemmel ne a karbantartóra térjünk vissza, hanem a navira
                //vm.back();
                //most megint nem
              });
          } else {
            vm.save();
          }
        });
      };

      vm.save = function() {
        $http
          .post('Utility/PropertyRentUnitInsert', vm.formModel)
          .then(function() {
            if (vm.formModel.IsWaterMeter) {
              toastr.warning(
                'Kérem az érvényességhez tartozó valamennyi bérleménynél ellenőrizze a közmű típusú beállításokat!'
              );
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Utility.MeterEdit', {
              id: vm.formModel.MeterId,
            });
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      function isSaveDisabled() {
        return vm.disableSaveButton;
      }

      var syncValidators = {
        ValidFrom: {
          RentUnitGaugeValidator: function(modelValue) {
            if (!modelValue || modelValue === null || modelValue === '') {
              return false;
            }
            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var lastFromValue = new moment(
              vm.formModel.MaxValidFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return !lastFromValue.isValid() || validFromValue.isAfter(lastFromValue);
          },
        },
      };
      var onChangeFunctions = {
        Valid: function(selectedItem) {
          vm.formModel.ValidFrom = !!selectedItem.key ? selectedItem.key : vm.originalValidFrom;
          var asd = vm.pageModel.Fields.Valid.FormlyFieldDescriptor.templateOptions.options.dataSource.data();
          if (vm.formModel.Valid !== '' && vm.formModel.Valid !== null) {
            var params = {
              id: vm.formModel.MeterId,
              validFrom: vm.formModel.Valid,
            };
            $http
              .post('Utility/GetValidRentUnitList', params)
              .then(function(result) {
                vm.validRentUnitList = result.data.RentUnitList;
                vm.rentUnitIndex = [];

                vm.mainGrid.fw_selectedIds = {};
                angular.forEach(vm.validRentUnitList, function(value, key) {
                  vm.mainGrid.fw_selectedIds[value] = true;
                });
                gridService.setSelectedIds(vm.mainGrid);
                vm.mainGrid.dataSource.read();
              })
              .catch(function() {
                toastr.error(vm.pageModel.Messages.SaveFailed);
              });
          }
        },
        ValidFrom: function(selectedItem) {
          console.log(selectedItem);
        },
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            var top = vm.pageModel.Fields.Valid.FormlyFieldDescriptor.templateOptions.options.dataSource.data();

            if (top.length > 0) {
              if (top[top.length - 1] && top[top.length - 1].key === vm.formModel.Valid) {
                return false;
              }
            }
            if (top[0] === undefined) {
              return false;
            }
            return true;
          },
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('MeterRentUnitModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    'formModifiers',
    '$uibModalInstance',
    function($scope, $http, $state, $stateParams, model, formModifiers, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterRentUnitModalCtrl', stateParams);
      }
      var vm = this;
      vm.isFormReadOnly = formModifiers;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.save = function() {
        $http
          .post('Utility/DividedPercentEdit', { DividedPercentRentUnitList: vm.multidata.Paneldata })
          .then(function(data) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //ellenőrzés:
            calcSumPercent();
            if (vm.dataModel.Remains !== 0) {
              toastr.warning('Hibás felosztás');
            }

            mi.close();
          });
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
      }

      vm.hasErroronMultiForm = function() {
        var invalid = false;
        angular.forEach(vm.formlyPanels.Paneldata, function(value, key) {
          if (value.$invalid === true) invalid = true;
        });
        return invalid;
      };

      var syncValidators = {
        Percents: {
          GaugeValidator: function(modelValue) {
            if (modelValue > 100 || modelValue < 0) {
              return false;
            } else {
              return true;
            }
          },
        },
      };
      var calcSumPercent = function() {
        vm.dataModel.Remains =
          100 - vm.multidata.Paneldata.reduce((sum, item) => sum + (!!item.Percents ? item.Percents : 0), 0);
      };
      var onChangeFunctions = {
        Percents: function(selectedItem) {
          calcSumPercent();
        },
      };

      var customExpressionProperties = {
        Tenement: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Remains: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        Percents: {
          'templateOptions.disabled': function() {
            return vm.isFormReadOnly;
          },
        },
      };

      vm.bindName = function(fields, index) {
        //Ha a formly-form repeat-ban van, a fileds leírót másolni kell és egyedi id-t adni:
        var _field = angular.copy(fields);
        angular.forEach(_field[0].fieldGroup[0].fieldGroup, function(field) {
          field.id = field.id + '_' + index;
        });
        return _field;
      };

      function createMultiFormPanels(vm, descriptions, panels) {
        if (!vm.multiFormPanels) {
          vm.multiFormPanels = [];
        }
        angular.forEach(panels, function(panel) {
          var headers = [];
          angular.forEach(vm.pageModel.Fields, function(item) {
            if (item.ContainerPanelId === panel) {
              item.FormlyFieldDescriptor.id = item.FormlyFieldDescriptor.templateOptions.DOMId;
              var _e = {
                class: item.FormlyFieldDescriptor.className,
                label: item.FormlyFieldDescriptor.templateOptions.label,
                required: item.FormlyFieldDescriptor.templateOptions.required,
              };
              headers.push(_e);
              item.FormlyFieldDescriptor.templateOptions.label = '';
            }
          });
          vm.multiFormPanels.push({
            panel: { panel, title: vm.pageModel.Panels[panel].Title },
            headers,
            fields: descriptions[panel].FormlyDescriptor,
          });
        });
      }

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      //   InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.multidata = { Paneldata: vm.dataModel.DividedPercentRentUnitList };
      calcSumPercent();
      createMultiFormPanels(vm, vm.FormlyFormPanelDescriptors, ['Paneldata']);
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('DividedPercentModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    function($scope, $http, $state, $stateParams, model, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DividedPercentModalCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.save = function() {
        $http.post('Utility/DividedPercentEdit', { dto: vm.dataModel }).then(function(data) {
          toastr.success(vm.pageModel.Messages.SaveSuccessful);

          mi.close();
        });
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
      }

      var syncValidators = {};

      var onBlurFunctions = {};

      var onChangeFunctions = {};

      var customExpressionProperties = {};
      //  InsertSyncValidators(vm.pageModel, syncValidators);
      //  InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      //   InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      // InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('CloseOpenSubGridRowsModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    'fModel',
    'parameter',
    function($scope, $http, $state, $stateParams, $uibModalInstance, fModel, parameter) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CloseOpenSubGridRowsModalCtrl', stateParams);
      }
      const vm = this;
      vm.dataModel = fModel.dto;
      vm.pageModel = fModel.pageModel;
      vm.gridName = parameter.gridName;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.modal = $uibModalInstance;
      vm.validtoValid = false;
      if (vm.dataModel.MaxValidFrom !== null) {
        vm.dataModel.MaxValidFrom = ConvertDate(vm.dataModel.MaxValidFrom);
      }

      function ConvertDate(convertableDate) {
        const date = moment(convertableDate);
        return date.format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.cancel = function() {
        $uibModalInstance.close();
      };

      vm.closeRows = function() {
        $http.post('Utility/' + vm.gridName + 'CloseOpenRows', vm.dataModel).then(function() {
          toastr.success(vm.pageModel.Messages.SaveSuccessful);
          vm.modal.close(vm.dataModel);
        });
      };

      switch (vm.gridName) {
        case 'EquipmentGauge':
          vm.titleHUN = 'Berendezés(ek) lezárása';
          break;
        case 'PremiseGauge':
          vm.titleHUN = 'Helyiség(ek) lezárása';
          break;
      }

      vm.validToCheck = function() {
        return vm.dataModel.ValidTo !== null && vm.dataModel.ValidTo !== '' && vm.validtoValid;
      };

      const syncValidators = {
        ValidTo: {
          ValidToValidator: function(modelValue) {
            if (modelValue < vm.dataModel.MaxValidFrom) {
              vm.validtoValid = false;
              return false;
            }
            vm.validtoValid = true;
            return true;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MeterRIDNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$timeout',
    'HistoryService',
    'DasService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $timeout,
      HistoryService,
      dasService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MeterRIDNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      //// MenuItems
      vm.importMeterReading = importMeterReading;
      vm.checkMeterReading = checkMeterReading;
      vm.revertMeterReading = revertMeterReading;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      //Kerekítések beállítása

      angular.forEach(
        vm.pageModel.Grids.GridMeterRID.Columns.filter(x => ['State', 'Correction'].indexOf(x.field) !== -1),
        function(value, key) {
          value.format = '{0:n3}';
        }
      );

      vm.editSubItem = editSubItem;

      vm.registerMeter = registerMeter;
      vm.enableToRegister = false;
      vm.enableToCheck = false;

      vm.back = function() {
        $state.go('main');
      };
      vm.mainGridIdField = vm.pageModel.Grids['GridMeterRIM'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridMeterRIM, 'Utility/MeterRIMList/', function() {
        changeSubItemGridFilter(vm.mainGrid);
      });

      //vm.subGrid = $("#subGrid").data("kendoGrid");
      vm.getSelectedMainGridItemId = function() {
        return {
          targetRIDId: vm.selectedMainGridItemId,
        };
      };
      vm.subGrid = options.pageModel.Grids['GridMeterRID'];
      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridMeterRID,
        'Utility/MeterRIDList/',
        function() {},
        vm.getSelectedMainGridItemId
      );

      //// Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          return;
        }

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        //check the selectedItem's status, if UIMIM(Beolvasott) -> enabled to register
        vm.selectedMainGridItemStatus = selectedItems[0].Status;
        if (vm.selectedMainGridItemStatus === 'UIMIM') {
          vm.enableToRegister = true;
          vm.enableToCheck = true;
        } else {
          vm.enableToRegister = false;
          vm.enableToCheck = false;
          $scope.$applyAsync();
        }

        if (!!vm.subGrid) {
          vm.subGrid.dataSource.read();
        }
      }

      function importMeterReading() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utility/MeterRIDImport.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            'FileUploadService',
            'pageModel',
            'grid',
            function($scope, mi, fus, pageModel, grid) {
              var vm = this;
              vm.formFields = [
                {
                  key: 'importFile',
                  type: 'kendoFU',
                  templateOptions: {
                    maxFileSize: 1024 * 1024,
                    label: 'Excel',
                    required: true,
                    options: {
                      showFileList: true,
                      autoUpload: false,
                      multipleFileUpload: false,
                      saveUrl: null,
                      removeUrl: null,
                    },
                    eventHandlers: {
                      onError: function() {},
                      onSuccess: function() {},
                      onComplete: function() {},
                    },
                  },
                },
              ];
              vm.ok = function() {
                if (!vm.model.importFile) return;
                var model = angular.copy(vm.model);
                var msg = toastr.warning(pageModel.Actions.ActionImportWait.Title, null, {
                  timeOut: '0',
                  extendedTimeOut: '0',
                });
                model.importFile = vm.model.importFile.getFile();
                model.fileName = vm.model.importFile.name;
                fus
                  .postWithFile('Utility/MeterRIDImport', model)
                  .then(function(response) {
                    //TODO: SUCCESS message
                    msg.remove();
                    grid.dataSource.read();
                    mi.close();
                  })
                  .catch(function() {
                    msg.remove();
                  });
              };

              vm.cancel = function() {
                mi.close();
              };
            },
          ],
          controllerAs: 'vm',
          resolve: {
            pageModel: vm.pageModel,
            grid: vm.mainGrid,
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function() {});
      }

      function checkMeterReading() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          $http
            .post('Utility/MeterRIDCheck', { id: id })
            .then(function(response) {
              vm.subGrid.dataSource.read();
            })
            .catch(function() {
              vm.subGrid.dataSource.read();
            });
        }
      }

      function revertMeterReading() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: 'Biztosan visszavonja a kiválasztott beolvasást?',
            title: 'Megerősítés',
            buttons: {
              cancel: {
                label: 'Mégsem',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Rendben',
                className: 'btn-primary',
                callback: function() {
                  $http
                    .post('Utility/MeterRIDRevert', { id: id })
                    .then(function(response) {
                      vm.mainGrid.dataSource.read();
                    })
                    .catch(function() {
                      vm.mainGrid.dataSource.read();
                    });
                },
              },
            },
          });
        }
      }

      //////////// Register the detailItems to MeterReading /////////////////
      ///////////////////////////////////////////////////////////////////////
      function registerMeter() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var msg = toastr.warning(vm.pageModel.Actions.ActionRegisterWait.Title);
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          $http
            .get('Utility/MeterReadingRegister/' + id)
            .then(function(response) {
              msg.remove();
              $timeout(function() {
                toastr.success(vm.pageModel.Actions.ActionRegisterSuccessful.Title);
              }, 0);
              vm.mainGrid.dataSource.read();
            })
            .catch(function() {
              msg.remove();
              vm.mainGrid.dataSource.read();
            });
        }
      }

      function editSubItem() {
        var id = getSelectedSubGridItemId();
        if (!!id) {
          $state.go('Utility.GridMeterReadingImportEdit', { id: id });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterReading', id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            // walService.NavigateToWal("Utility", "MeterRIMNavWal", "FlgMeterReadingView");
            walService.NavigateToWal('Utility', 'MeterRIMNavWal', 'FlgMeterReadingImportMainView');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            walService.NavigateToWal('Utility', 'MeterRIDNavWal', 'FlgMeterReadingImportDetailView');
            break;
          }

          default: {
            break;
          }
        }
      }

      function history() {
        var selectedItems = getSelectedSubGridItemId();
        if (selectedItems) {
          HistoryService.NavigateToHistory('FlgMeterReading', selectedItems, vm, $state, true);
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function getSelectedSubGridItem() {
        var gridName = 'GridMeterRID';
        var gridRef = $('#' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);

        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = 'GridMeterRID';
        var item = getSelectedSubGridItem();

        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';

  module.controller('MapMeterCtrl', [
    '$uibModalInstance',
    '$http',
    'types',
    'tenement',
    'propertyid',
    'fModel',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    function(mi, $http, types, tenement, propertyid, fModel, $stateParams, AuthService, $scope, $state) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MapMeterCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = fModel.pageModel;
      vm.mainGridIdField = vm.pageModel.Grids['GridMeter'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      var uids = types.join('&uIds=');
      var url = 'Utility/GetMeters/?tenement=' + tenement + '&propertyid=' + propertyid + '&uIds=' + uids;

      vm.mainGridOptions = getGridOptions(vm.pageModel.Grids.GridMeter, url, selectFunction);
      vm.mainGridOptions.autoBind = true;

      function selectFunction(rowData) {
        var mId = rowData.MeterId;

        document.cookie = 'mId=' + mId;
        mi.close();

        $state.go('Utility.MeterEdit', { id: mId });
      }

      vm.cancel = function() {
        mi.close();
      };

      vm.reset = function() {
        vm.mainGridOptions.dataSource.filter([]);
      };
    },
  ]);
})(angular.module('sbUtility'));

(function(module) {
  'use strict';
  module.controller('MainIndexCtrl', [
    '$rootScope',
    '$scope',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    '$interval',
    'AuthService',
    'FavouriteService',
    '$stateParams',
    function(
      $rootScope,
      $scope,
      $http,
      $state,
      $uibModal,
      $filter,
      $interval,
      AuthService,
      FavouriteService,
      $stateParams
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MainIndexCtrl', stateParams);
      }
      var vm = this;
      AuthService.getUserContextReloadMenus();
      vm.showInfo = $state.current.name == 'Dashboard.Dashboard';
      vm.mainMenuItems = AuthService.mainMenu;
      vm.setLabel = setLabel;
      vm.isHide = isHide;
      vm.favouriteService = FavouriteService;
      vm.authService = AuthService;

      vm.currentStateName = $state.current.name;

      $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        vm.currentStateName = toState.name;
      });

      $rootScope.$on('cfpLoadingBar:started', function() {
        vm.cfpLoadingBox = false;
        vm.cfpLoadingBoxTimer = setTimeout(function() {
          vm.cfpLoadingBox = true;
        }, 2000);
      });
      $rootScope.$on('cfpLoadingBar:completed', function() {
        clearTimeout(vm.cfpLoadingBoxTimer);
        vm.cfpLoadingBox = false;
      });

      vm.menuExtraData = {
        Partner: { icon: 'sb-icons sb-partner' },
        Property: { icon: 'fa fa-building' },
        Contract: { icon: 'sb-icons sb-contract-rent' },
        Budget: { icon: 'sb-icons sb-house-dollar' },
        Project: { icon: 'griff griff-project' },
        HelpDesk: { icon: 'sb-icons sb-toolbox' },
        Utility: { icon: 'sb-icons sb-meter ' },
        Task: { icon: 'sb-icons sb-tools' },
        Equipment: { icon: 'sb-icons sb-exting', subHide: ['Equipment_EquipmentSystemNav'] },
        Invoice: { icon: 'sb-icons sb-invoice', subHide: ['Invoice_Rent'] },
        SupplyContract: { icon: 'sb-icons sb-contract' },
        BuildingConstruction: { icon: 'griff griff-buildingconstruction' },
        Dms: { icon: 'sb-icons sb-books', subHide: ['Dms_DocumentAttachmentService'] },
        ForrasDoclib: { icon: 'sb-icons sb-books' },
        Template: { icon: 'fa fa-file-text' },
        Utilization: { icon: 'griff griff-utilization' },
        Mrs: { icon: 'sb-icons sb-post-check' },
        Service: {
          icon: 'fa fa-gears',
          subHide: ['Service_Message'],
          //, subSort: {'Service_User' : 1 , 'Service_Parameter' : 2 }
        },
        MasterDataModule: { icon: 'sb-icons sb-gear-circ' },
        CustomerService: { icon: 'griff griff-customerservice' },
        ReportModul: { icon: 'fa fa-file', subHide: ['ReportModul_Report'] },
      };
      vm.menuKey = Object.keys(vm.menuExtraData);

      vm.goToFavourite = function(state) {
        vm.favouriteService.goToFavourite(state);
      };

      vm.favouriteItemsOrderEdit = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Service/FavouriteItemsOrderEditor.html',
          controller: 'FavouriteItemsOrderCtrl',
          controllerAs: 'vm',
        });
      };

      function setLabel(key) {
        for (var i in vm.mainMenuItems) {
          if (key === vm.mainMenuItems[i].Id) {
            return vm.mainMenuItems[i].Text;
          }
        }
      }

      function isHide(key) {
        for (var i in vm.mainMenuItems) {
          if (key === vm.mainMenuItems[i].Id) {
            return true;
          }
        }
        return false;
      }

      vm.link_module = function() {
        if (!!this.sub && this.sub.length > 0) {
          let closed = !this.opened;
          this.opened = closed;
          let elem = $('.' + this.StateC)?.first();
          let elemRect = elem[0]?.getBoundingClientRect();
          if (closed && elemRect) {
            if ((window.innerHeight || document.documentElement.clientHeight) - elemRect.bottom < 0) {
              window.scroll({ top: elem.offset().top - elemRect.top + elemRect.height });
            }
          }
        } else {
          vm.link_open(this.State);
        }
      };

      vm.link_open = function(link = this.State) {
        if (!link) return;

        if (link === 'dmsMasterdata.Nav' && AuthService.getForrasParameterValue('fordms') != '1') {
          toastr.warning('Ez a funkció nincs használatban!', 'Figyelmeztetés');
          return false;
        }

        if (link === 'ForrasDoclib.DocumentNav' && AuthService.getForrasParameterValue('fordas') == '1') {
          link = 'ForrasDoclib.AllDocumentNav';
        }
        const linkRegex = /^[^(]+/;
        const paramRegex = /\([^\)]+\)/;
        const removeRegex = /[\(\)]/g;
        let realLink = link.match(linkRegex)?.length > 0 ? link.match(linkRegex)[0] : '';

        let params = link.match(paramRegex)?.length > 0 ? link.match(paramRegex)[0]?.replace(removeRegex, '') : '';
        var paramsObj = !!params ? JSON.parse(params) : {};
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href(realLink, paramsObj);
          window.open(url, '_blank');
        } else {
          $state.go(realLink, paramsObj);
        }
      };

      vm.subMenuTree = function subMenuTree(menu) {
        let showedmenu = menu.filter(function(menuItem) {
          return !!menuItem.Text && !(vm.menuExtraData[menuItem.ParentId]?.subHide?.indexOf(menuItem.Id) >= 0);
        });
        let sortedMenu = showedmenu.sort(function(aMenuItem, bMenuItem) {
          let aPos =
            !!vm.menuExtraData[aMenuItem.ParentId]?.subSort &&
            !!vm.menuExtraData[aMenuItem.ParentId]?.subSort[aMenuItem.Id]
              ? vm.menuExtraData[aMenuItem.ParentId]?.subSort[aMenuItem.Id]
              : aMenuItem.Pos + 0.5;
          let bPos =
            !!vm.menuExtraData[bMenuItem.ParentId]?.subSort &&
            !!vm.menuExtraData[bMenuItem.ParentId]?.subSort[bMenuItem.Id]
              ? vm.menuExtraData[bMenuItem.ParentId]?.subSort[bMenuItem.Id]
              : bMenuItem.Pos + 0.5;
          return aPos < bPos ? -1 : 1;
        });

        let arr = angular.copy(sortedMenu);
        let arrMap = new Map(arr.map(item => [item.Id, item]));

        let tree = [];

        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];

          //Törzsadatok state hack:
          item.State =
            item.State.startsWith('Masterdata') && !item.State.startsWith('Masterdatamodule.AllMasterData')
              ? item.State + 'List'
              : item.State;
          item.StateC = item.State.replace(/[:\ \(\)]/g, '_');
          if (item.ParentId) {
            let parentItem = arrMap.get(item.ParentId);

            if (parentItem) {
              let { sub } = parentItem;

              if (sub) {
                parentItem.sub.push(item);
              } else {
                parentItem.sub = [item];
              }
            }
          } else {
            tree.push(item);
          }
        }

        return tree.reduce(function(p, menuItem) {
          p[menuItem.Id] = menuItem;
          return p;
        }, {});
      };

      vm.filter = function filter() {
        let text = vm.filterText;
        if (text && text.length >= 3) {
          let array = angular.copy($scope.data);

          const getNodes = (result, object) => {
            object.opened = true;
            if (object.title.toUpperCase().indexOf(text.toUpperCase()) !== -1) {
              result.push(object);
              return result;
            }
            if (Array.isArray(object.sub)) {
              object.opened = true;
              const sub = object.sub.reduce(getNodes, []);
              if (sub.length) result.push({ ...object, sub });
            }
            return result;
          };
          vm.filteredMenu = array.reduce(getNodes, []);
        } else {
          vm.filteredMenu = $scope.data;
        }
      };

      vm.findAndOpenState = function findAndOpenState(menu, id, type = 'state') {
        //Törzsadatok state hack:
        id = type == 'state' && id.match('^Masterdata(.*?)List') ? id.replace(/List$/, '') : id;
        let finded = menu.find(function(menuItem) {
          return type == 'state' ? menuItem.State == vm.addParametersToState(id) : menuItem.Id == id;
        });
        if (finded) {
          finded.opened = true;
          if (finded.ParentId) {
            return vm.findAndOpenState(menu, finded.ParentId, 'id');
          } else {
            return finded.Id;
          }
        }
      };

      vm.isOpening = function(menuState, currentState) {
        return menuState === vm.getRootState(currentState);
      };

      vm.removeParametersFromState = function(state) {
        return state.replace(/\([^()]*\)/g, '');
      };

      vm.addParametersToState = function(state) {
        if (!!$state.current.params) {
          if ($state.current.params.module === 'Invoice' && !!$stateParams.InvoiceTypeFilter) {
            return state + '({"InvoiceTypeFilter": "' + $stateParams.InvoiceTypeFilter + '"})';
          }
        }
        return state;
      };

      vm.getRootState = function(state, level = 1) {
        let stateArray = state.split('.');

        if (stateArray[0].substring(0, 3).toUpperCase() === 'MRS') stateArray[0] = 'Mrs';
        if (stateArray[0].substring(0, 3).toUpperCase() === 'DMS') stateArray[0] = 'Dms';
        if (stateArray[0] == 'Document') stateArray[0] = 'Dms';
        if (stateArray[0] == 'Masterdata' && level === 1) stateArray.shift();

        return stateArray.slice(0, level).join('.');
      };
      var menuLoaded = false;
      $rootScope.$on('AuthService:setMenu', function() {
        if (!AuthService.menu || menuLoaded) return;
        let _menus = {
          menu: AuthService.menu,
          mainMenu: AuthService.mainMenu,
          unpermittedMenu: AuthService.unpermittedMenu,
        };
        menuLoaded = true;
        let menus = angular.copy(_menus);
        var openedMainMenu = vm.findAndOpenState(menus.menu, $state.current.name);

        menus.menu.forEach(function(menuItem) {
          menuItem.title = menuItem.Text;
          menuItem.pos = menuItem.Pos;
          menuItem.link = vm.link_module;
          menuItem.description = menuItem.Description;
        });

        var menuData = [],
          subMenus = vm.subMenuTree(menus.menu);
        if (menus && menus.mainMenu) {
          menus.mainMenu.forEach(function(menuItem) {
            //if (menuItem.Id == 'Partner') debugger;
            if (menuItem.ModuleId === 'a_flgr' && !!menuItem.Text && !!menuItem.Id && !!vm.menuExtraData[menuItem.Id]) {
              menuData.push({
                toRender: true,
                title: menuItem.Text,
                link: vm.link_module,
                description: menuItem.Description,
                sub: subMenus[menuItem.Id].sub ?? [],
                icon: vm.menuExtraData[menuItem.Id].icon,
                //pos: menuItem.Pos,
                pos: vm.menuKey.indexOf(menuItem.Id),
                State: menuItem.Id,
                StateC: menuItem.Id.replace(/[:\ \(\)]/g, '_'),
                opened: openedMainMenu == menuItem.Id,
              });
            }
          });
          menuData.sort(function(aMenuItem, bMenuItem) {
            return aMenuItem.pos < bMenuItem.pos ? -1 : 1;
          });
        }
        $scope.data = angular.copy(menuData);
        vm.filter();
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('DashboardCtrl', [
    'AuthService',
    'LanguageService',
    function(AuthService, LanguageService) {
      $('[ui-view] #wrapper:first')
        .css('position', 'relative')
        .css('top', '-40px');
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DashboardCtrl', stateParams);
      }
      var vm = this;
      vm.labels = LanguageService.getDictionary().dashboard;
      vm.chartOptions = {};
      vm.chart = {};
      vm.charts = ['barchart', 'spacePie', 'numberPie', 'barchart2', 'rentedDonut', 'emptyDonut'];

      vm.showMenu = function(menus) {
        let menuItems = menus.split(',').map(item => item.trim());
        return vm.mainMenu?.some(x => menuItems.includes(x.Id));
      };
      vm.getUserContext = function() {
        vm.mainMenu = AuthService.mainMenu;
      };
      AuthService.getUserContext(false, vm.getUserContext, false);
      vm.chartOptions[vm.charts[0]] = {
        type: 'column',
        controller: 'Dashboard/GetServiceIncomeBarChart/',
        titleText: vm.labels.ServiceIncome,
        legend: {
          position: 'top',
          visible: true,
        },
        seriesDefaults: {
          type: 'column',
        },
        series: [
          {
            type: 'column',
            field: 'value',
            categoryField: 'category',
            name: '#= group.value #',
          },
        ],
        valueAxis: {
          labels: {
            format: '{0:n0} Ft',
          },
          line: {
            visible: false,
          },
          axisCrossingValue: 0,
          min: 0,
        },
        categoryAxis: {
          line: {
            visible: false,
          },
          labels: {
            position: 'start',
          },
        },
        tooltip: {
          visible: true,
          format: '{0:n0}',
          template: "#= series.name #: #= kendo.toString(value, 'n0') # Ft",
        },
      };
      vm.chartOptions[vm.charts[3]] = {
        type: 'column',
        controller: 'Dashboard/GetPropertyTypeIncomeBarChart/',
        titleText: vm.labels.PropertyTypeIncome,
        legend: {
          position: 'top',
          visible: true,
        },
        seriesDefaults: {
          type: 'column',
        },
        series: [
          {
            type: 'column',
            field: 'value',
            categoryField: 'category',
            name: '#= group.value #',
          },
        ],
        valueAxis: {
          labels: {
            format: '{0:n0} Ft',
          },
          line: {
            visible: false,
          },
          axisCrossingValue: 0,
          min: 0,
        },
        categoryAxis: {
          line: {
            visible: false,
          },
          labels: {
            position: 'start',
          },
        },
        tooltip: {
          visible: true,
          format: '{0:n0}',
          template: "#= series.name #: #= kendo.toString(value, 'n0') # Ft",
        },
      };
      vm.chartOptions[vm.charts[1]] = {
        type: 'pie',
        seriesColors: ['#4e67c8', '#a7ea52', '#ff8021'],
        controller: 'Dashboard/GetPropertyUtilizationSpacePieChart/',
        titleText: vm.labels.PropertyUtilizationSpace,
        legend: {
          visible: false,
        },
        autoFit: true,
        seriesDefaults: {
          labels: {
            visible: true,
            background: 'transparent',
            template: '#= category #: \n #= value#%',
          },
          stack: true,
        },
        series: [
          {
            type: 'pie',
            startAngle: 90,
            autoFit: true,
          },
        ],
        tooltip: {
          visible: true,
          format: '{0} m2',
        },
      };
      vm.chartOptions[vm.charts[2]] = {
        type: 'pie',
        seriesColors: ['#a7ea52', '#ff8021', '#4e67c8'],
        controller: 'Dashboard/GetPropertyUtilizationNumberPieChart/',
        titleText: vm.labels.PropertyUtilizationNumber,
        legend: {
          visible: false,
        },
        autoFit: true,
        seriesDefaults: {
          labels: {
            visible: true,
            //background: 'transparent',
            template: '#= category #: \n #= value#%',
          },
          stack: true,
        },
        series: [
          {
            type: 'pie',
            startAngle: 90,
            autoFit: true,
          },
        ],
        tooltip: {
          visible: true,
          format: '{0} db',
        },
      };
      vm.chartOptions[vm.charts[4]] = {
        type: 'donut',
        titleText: vm.labels.PropertyUtilizationRentedRatio,
        controller: 'Dashboard/GetPropertyUtilizationRentedRatioPieChar/',
        centerText: function(e) {
          return e.sender.dataSource.data().find(x => x.id == 'reserved')?.value + '%';
        },
        params: {},
        series: [
          {
            type: 'donut',
            field: 'value',
            startAngle: 90,
            categoryField: 'category',
            autoFit: true,
            labels: {
              color: '#000',
              position: 'outsideEnd',
              template: '#: category #',
              visible: true,
            },
          },
        ],
        legend: {
          visible: false,
        },
      };
      vm.chartOptions[vm.charts[5]] = {
        type: 'donut',
        titleText: vm.labels.PropertyUtilizationEmptyRatio,
        controller: 'Dashboard/GetPropertyUtilizationEmptyRatioPieChar/',
        params: {},
        centerText: function(e) {
          return e.sender.dataSource.data().find(x => x.id == 'empty')?.value + ' %';
        },
        series: [
          {
            type: 'donut',
            field: 'value',
            startAngle: 90,
            categoryField: 'category',
            autoFit: true,
            labels: {
              color: '#000',
              position: 'outsideEnd',
              template: '#: category #',
              visible: true,
            },
          },
        ],
        legend: {
          visible: false,
        },
        seriesClick: function(e) {
          //alert(e.category);
        },
        plotAreaClick: function(e) {
          //console.log(e.value);
        },
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('EventCardCtrl', [
    '$rootScope',
    '$scope',
    '$http',
    '$uibModal',
    'AuthService',
    function($rootScope, $scope, $http, $uibModal, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventCardCtrl', stateParams);
      }
      var vm = this;
      vm.ReminderCount = null;
      $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
        vm.LoginTimer.tickTime = (AuthService?.parameters?.ReminderList ?? 300) * 1000;
      });
      $rootScope.$on('AuthService:loggedIn', function() {
        if (!vm.LoginTimer) {
          vm.startEvent();
        }
      });
      vm.startGetReminderCount = function() {
        if (AuthService.isLoggedIn) {
          // try {
          //   $http
          //     .post('Event/GetReminderListCount', {})
          //     .then(
          //       function(response) {
          //         vm.ReminderCount = response?.data?.Value;
          //       },
          //       function(error) {}
          //     )
          //     .catch();
          // } catch (e) {}
        }
      };
      $('.refreshReminderList.dropdown').on('shown.bs.dropdown', function(event) {
        // Csak akkor frissítsen a listview, ha megnyitom:
        event.stopImmediatePropagation();
        vm.refreshReminderList();
      });

      vm.refreshReminderList = function(force = false) {
        if (AuthService.isLoggedIn) {
          const d = new Date();
          let actTime = d.getTime();
          if (!vm.loadTime || actTime - vm.loadTime > vm.eventListCache || force) {
            $('.reminderDiv .k-listview-content').html('');
            kendo.ui.progress($('[kendo-list-view]'), true);
            vm.startGetReminderCount();
            vm.ReminderDataSource.read();
          }
        }
      };

      vm.startReminder = function() {
        console.log('Start reminder function');
        vm.ReminderDataSource = new kendo.data.DataSource({
          autoBind: false,
          transport: {
            read: {
              url: 'Event/ReminderListForView',
              dataType: 'json',
            },
          },
          pageSize: 0,
          schema: {
            data: 'Data',
            total: 'Total',
          },
          change: function(e) {
            $scope.$applyAsync();
          },
        });
      };
      vm.databound = function(e) {
        kendo.ui.progress($('[kendo-list-view]'), false);
        const d = new Date();
        vm.loadTime = d.getTime();
      };
      vm.startEvent = function() {
        // if (!AuthService.parameters?.FWCOID) {
        //vm.startReminderRefresher();
        vm.startGetReminderCount();
        vm.startReminder();
        vm.LoginTimer = SBTimer.getInstance('reminderCount');
        vm.LoginTimer.tickTime = (AuthService?.parameters?.ReminderList ?? 300) * 1000;
        vm.LoginTimer.subscribe('tick', d => {
          vm.startGetReminderCount();
          //  console.log(`event at ${d.toFixed(2)}s.`);
        });
        vm.LoginTimer.start();
      };

      vm.goToLinkFromReminder = function(reminder, event) {
        if (!!reminder.LinkToTable) window.location = '#!' + reminder.LinkToTable;
      };

      vm.pageRemiderCard = function(event, dataItem, mode) {
        event.preventDefault();

        if (mode === 'UP') dataItem.ModelState++;
        if (mode === 'DOWN') dataItem.ModelState--;
        if (mode === 'LAST') dataItem.ModelState = dataItem.ReminderLists.length - 1;
        if (mode === 'FIRST') dataItem.ModelState = 0;

        if (dataItem.ModelState < 0) dataItem.ModelState = dataItem.ReminderLists.length - 1;
        if (dataItem.ModelState >= dataItem.ReminderLists.length) dataItem.ModelState = 0;
        return dataItem;
      };

      vm.getReminderClass = function(dataItem) {
        let reminderCss = '';
        if (!dataItem || !dataItem.ReminderLists || !dataItem.ReminderLists[0]) return reminderCss;

        let eventDate = new moment(dataItem.ReminderLists[0].EventDate);
        let alertDate = new moment(dataItem.ReminderLists[0].AlertDate);
        let nowDate = new moment();

        if (alertDate.isBefore(nowDate)) reminderCss = 'alert-warning';
        if (eventDate.isBefore(nowDate)) reminderCss = 'alert-danger';

        return reminderCss;
      };

      vm.setReminderToAC = function(reminderObject, event) {
        bootbox.dialog({
          message: 'Biztos, hogy kezeltre állítja az eseményt?', //vm.messages.ConfirmDelete,
          title: 'Kezeltre állítás',
          buttons: {
            cancel: {
              label: 'Mégsem', //vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Rendben', //vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                if (!!reminderObject.ReminderLists) {
                  let reminder = reminderObject.ReminderLists[0];
                  $http
                    .post('Event/EventStatusToAC', {
                      f_esemenyid: reminder.f_esemenyid,
                      type: reminder.Type,
                      jobCount: reminder.JobCount,
                      alertId: reminder.EMSAlertId,
                      eventId: reminder.EMSEventId,
                    })
                    .then(function() {
                      toastr.success('Az esemény kezeltre állítva!');
                      vm.refreshReminderList(true);
                    });
                }
              },
            },
          },
        });
      };

      vm.createEvent = function() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Event/EventEdit.html',
          controller: 'EventEditCtrl',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('Event/EventEdit/0'),
            parameter: {
              CreateOrEdit: 'Create',
            },
          },
        });
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EmptyMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EmptyMenuCtrl', stateParams);
      }
      // this is intentionally empty
      // it does NOT build the menu!
      var vm = this;
      vm.currentState = $state.current.name;
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  '$urlRouterProvider',
  function($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/workspace');
    var states = {
      main: {
        url: '/',
        redirectTo: function() {
          return 'Dashboard';
        },
        ncyBreadcrumb: {
          label: 'Főoldal',
        },
      },
      Dashboard: {
        url: '/dash',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'main.Workspace',
        ncyBreadcrumb: {
          skip: true,
          parent: 'main',
        },
      },
      'Dashboard.Dashboard': {
        url: 'board',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DashboardCtrl as vm',
          },
          content: {
            templateUrl: 'App/Index/Dashboard.html',
            controller: 'DashboardCtrl as vm',
          },
        },
        params: {
          openMenu: true,
        },
        ncyBreadcrumb: {
          label: 'Dashboard',
          parent: 'main',
        },
      },
      'main.Workspace': {
        url: 'workspace',
        templateUrl: 'App/Index/Main.html',
        controller: 'MainIndexCtrl as vm',
        ncyBreadcrumb: {
          label: 'Főoldal',
        },
        ncyBreadcrumb: {
          skip: true,
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    /*
    var states = {
        "main.DmsDocumentNav": {
            url: "document/nav/:dasTableId/:dasOwnerId",
            params: {
                module: "document",
                formMode: "Nav"
            },
            views: {
                "menu": {
                    templateUrl: "App/TileMenu.html",
                    controller: "EmptyMenuCtrl as vm"
                },
                "content": {
                    templateUrl: "App/Dms/Document/DocumentNav.html",
                    controller: "DocumentNavCtrl_dms as vm",
                    resolve: {
                        options: RouteResolveFunc("Document/DocumentNavOptions/")
                    }
                }
            }
        },
        "main.DmsDocumentMasterData": {
            url: "master-data/nav",
            params: {
                module: "masterdata"
            },
            views: {
                "menu": {
                    templateUrl: "App/TileMenu.html",
                    controller: "EmptyMenuCtrl as vm"
                },
                "content": {
                    templateUrl: "App/Dms/MasterData/MasterDataDocument.html",
                    controller: "DocumentMasterDataCtrl_dms as vm",
                    resolve: {
                        options: RouteResolveFunc("Dms/MasterData/ListOptions/")
                    }
                }
            }
        },
        "main.DasDocumentsNav": {
            url: "das/documents/list/:tableId/:ownerId",
            params: {
                module: "documents",
                formMode: "Nav"
            },
            views: {
                "menu": {
                    templateUrl: "App/TileMenu.html",
                    controller: "EmptyMenuCtrl as vm"
                },
                "content": {
                    templateUrl: "App/Das/Documents/DocumentsNav.html",
                    controller: "DocumentsNavCtrl as vm",
                    resolve: {
                        options: RouteResolveFunc("Das/Documents/DocumentsListOptions/")
                    }
                }
            }
        },
        "main.MrsDocumentNav": {
            url: "mrs/document-module/document",
            params: {
                module: "document",
                formMode: "Nav"
            },
            views: {
                "menu": {
                    templateUrl: "App/TileMenu.html",
                    controller: "EmptyMenuCtrl as vm"
                },
                "content": {
                    templateUrl: "App/Mrs/Document/DocumentNav.html",
                    controller: "DocumentNavCtrl_mrs as vm",
                    resolve: {
                        options: RouteResolveFunc("Mrs/Document/DocumentListOptions/")
                    }
                }
            }
        }
    };
    */
    var states = {};

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('ServiceModalCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    '$uibModalInstance',
    function($http, $state, $uibModal, $filter, AuthService, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceModalCtrl', stateParams);
      }
      var vm = this;

      vm.parameter_module = function() {
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Service.Parameter.ParameterNav');
          window.open(url, '_blank');
        } else {
          $state.go('Service.Parameter.ParameterNav');
        }
      };

      vm.user_module = function() {
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Service.User.UserNav');
          window.open(url, '_blank');
        } else {
          $state.go('Service.User.UserNav');
        }
      };

      vm.event_module = function() {
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Service.Event.EventNav');
          window.open(url, '_blank');
        } else {
          $state.go('Service.Event.EventNav');
        }
      };

      vm.message_module = function() {
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Service.Message.MessagesNav');
          window.open(url, '_blank');
        } else {
          $state.go('Service.Message.MessagesNav');
        }
      };

      vm.serviceMenuFunc = function(index) {
        if (index === 0) {
          vm.parameter_module();
        } else if (index === 1) {
          vm.event_module();
        } else if (index === 2) {
          vm.user_module();
        } else if (index === 3) {
          vm.message_module();
        }
      };

      vm.menu = [];
      AuthService.getMenu('Service').then(function(result) {
        var authmenu = result;
        for (var i = 0; i < authmenu.length; i++) {
          vm.menu.push({
            Text: authmenu[i].Text,
          });
        }
      });

      //vm.history_module = function () {
      //    mi.close();
      //    if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
      //        var url = $state.href("History.HistoryNav");
      //        window.open(url, '_blank');
      //    }
      //    else {
      //        $state.go("History.HistoryNav");
      //    }
      //}
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceModalCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    '$uibModalInstance',
    function($http, $state, $uibModal, $filter, AuthService, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceModalCtrl', stateParams);
      }
      var vm = this;
      vm.invoice_module = function(InvoiceTypeFilter) {
        mi.close();
        $state.go('Invoice.InvoiceNav', { InvoiceTypeFilter: InvoiceTypeFilter });
      };

      vm.invoice_module_approval = function() {
        mi.close();
        $state.go('Invoice.SuppInvoiceApp');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ConstructionModalCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    '$uibModalInstance',
    function($http, $state, $uibModal, $filter, AuthService, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ConstructionModalCtrl', stateParams);
      }
      var vm = this;

      vm.construction_masterdata = function() {
        mi.close();
        $state.go('Masterdata.Construction');
      };

      vm.construction_module = function() {
        mi.close();
        $state.go('Construction.BuildingConstructionNav');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetModalCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    '$uibModalInstance',
    function($http, $state, $uibModal, $filter, AuthService, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetModalCtrl', stateParams);
      }
      var vm = this;
      vm.budget_module = function() {
        console.log('YMCA');
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Budget.Budget.BudgetNav');
          window.open(url, '_blank');
        } else {
          $state.go('Budget.Budget.BudgetNav');
        }
      };

      vm.apportion_module = function() {
        mi.close();
        if (event.which === 2 || (event.which === 1 && (event.metaKey || event.ctrlKey))) {
          var url = $state.href('Budget.Apportion.ApportionNav', { ApportionType: 'BATAP' });
          window.open(url, '_blank');
        } else {
          $state.go('Budget.Apportion.ApportionNav', { ApportionType: 'BATAP' });
        }
      };
      vm.budgetMenu = function(index) {
        if (index === 0) {
          vm.budget_module();
        } else if (index === 1) {
          vm.apportion_module();
        }
      };

      var desc = {
        Budget_Budget: { icon: 'fa fa-file-text' },
        Budget_Apportion: { icon: 'fa fa-file-text' },
      };

      vm.menu = [];
      AuthService.getMenu('Budget').then(function(result) {
        var authmenu = result;
        for (var i = 0; i < authmenu.length; i++) {
          for (var key in desc) {
            if (!desc.hasOwnProperty(key)) {
              continue;
            }

            if (key.toLowerCase() === authmenu[i].Id.toLowerCase()) {
              vm.menu.push({
                Text: authmenu[i].Text,
              });
            }
          }
        }
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('LoginCtrl', [
    '$scope',
    'AuthService',
    'LanguageService',
    '$state',
    '$http',
    '$uibModal',
    'options',
    '$stateParams',
    '$window',
    function($scope, authService, languageService, $state, $http, $uibModal, options, $stateParams, $window) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'LoginCtrl', stateParams);
      }
      var vm = this;
      if (authService.isLoggedIn) {
        authService.redirectTo();
      }
      vm.sbType = localStorage.getItem('SBType');
      vm.sbLang = localStorage.getItem('SBLang');
      vm.changePassword = changePassword;
      authService.getSBType().then(function(resp) {
        localStorage.setItem('SBType', resp);
        vm.sbType = resp;
      });
      authService.getSBFormInit().then(function(resp) {
        localStorage.setItem('SBFormInitOff', resp);
      });
      authService.getSBMainState().then(function(resp) {
        if (!!resp) {
          $state.get('main').redirectTo = resp;
        }
      });
      vm.user = {
        companyId: vm.sbType == 'box' ? localStorage.getItem('SBCompanyId') : '',
        userId: '',
        userName: '',
        password: '',
        lang: !vm.sbLang ? 'hu' : vm.sbLang,
        adopter: '',
        group: '',
        guid: '',
      };
      vm.labels = languageService.getDictionary().login;
      vm.labelsIndex = languageService.getDictionary().index;
      vm.login = login;
      vm.jelszoEmlekezteto = jelszoEmlekezteto;
      vm.userCheck = userCheck;
      vm.selectAdopter = selectAdopter;
      vm.selectGroup = selectGroup;
      vm.changeUserId = changeUserId;
      vm.langOptions = options?.lang;
      vm.keycloak = options?.keycloak;
      vm.isAuthenticated = options?.isAuthenticated;
      vm.pwdChangeShow = options?.pwdChange;
      vm.expiredKeycloak = options?.expiredKeycloak;
      if (typeof vm.keycloak !== 'undefined') {
        localStorage.setItem('sb-keycloak', vm.keycloak ? '1' : '0');
      }
      vm.userIdLength = 4;
      vm.capsLock = false;
      vm.validUser = false;
      if (vm.keycloak) {
        if (vm.expiredKeycloak) {
          window.location.href = 'auth/kclogout';
        } else {
          kclogin();
        }
      }
      vm.loginShow = function() {
        return authService && !authService.isLoggedIn;
      };
      // watch capslock

      document.querySelector('input[type=password]')?.addEventListener('keyup', function(keyboardEvent) {
        if (keyboardEvent instanceof KeyboardEvent) {
          vm.capsLock = keyboardEvent.getModifierState('CapsLock') === true;
          $scope.$applyAsync();
        }
      });

      document.querySelector('input[type=password]')?.addEventListener('mousedown', function(keyboardEvent) {
        if (keyboardEvent instanceof MouseEvent) {
          vm.capsLock = keyboardEvent.getModifierState('CapsLock') === true;
          $scope.$applyAsync();
        }
      });

      //Ha a felhasználó bejelentkezve van, akkor átirányítjuk
      function kclogin() {
        if (vm.isAuthenticated) {
          login();
          return;
        } else {
          // $window.location.href = '/auth/kclogin';
          return;
        }
      }
      async function login() {
        if (vm.keycloak && !vm.isAuthenticated) {
          $window.location.href = 'auth/kclogin';
          return;
        }
        return $http.post('Auth/Login', vm.user).then(
          function(result) {
            if (checkResponse(result.data) && !result.data?.ExpiredDialog) {
              vm.sbType == 'box' && localStorage.setItem('SBCompanyId', vm.user.companyId);
              vm.user.userName = result.data.userName;
              vm.user.userId = result.data.userId;
              vm.adopterVisible = true;
              vm.user.guid = result.data.guid;
              vm.adopters = result.data.adopterList;
              if (vm.adopters.length === 1) {
                vm.user.adopter = vm.adopters[0].Id;
                selectAdopter();
                vm.adopterVisible = false;
              }
            } else {
              if (!!result.data?.ExpiredDialog) {
                toastr.warning(result.data?.Message);
                changePassword();
              }
              vm.adopterVisible = false;
              vm.groupVisible = false;
              vm.user.userName = '';
              vm.user.userId = '';
              vm.user.password = '';
              vm.isAuthenticated = false;
            }
          },
          function(error) {
            vm.isAuthenticated = false;
          }
        );
      }

      function jelszoEmlekezteto() {
        var modalInstance = $uibModal.open({
          size: 'sm',
          templateUrl: 'App/Login/JelszoEmlekezteto.html',
          controller: [
            '$scope',
            '$uibModalInstance',
            function($scope, mi) {
              $scope.user = { nickName: vm.user.nickName };

              $scope.ok = function() {
                mi.close($scope.user);
              };
              $scope.cancel = function() {
                mi.close();
              };
            },
          ],
          backdrop: 'static',
        });

        modalInstance.result.then(function(user) {
          $http.post('Auth/ForgotPassword/', user).then(function() {
            toastr.success('Új jelszó sikeresen elküldve!');
          });
        });
      }

      function checkResponse(response) {
        var isSuccess = angular.isDefined(response.IsSuccess) ? response.IsSuccess : true;
        if (!isSuccess) toastr.error(response.Message);
        return isSuccess;
      }

      function userCheck() {
        var params = {
          userName: vm.user.nickName,
          password: vm.user.password,
          lang: vm.user.lang,
        };
        $http.post('Auth/UserCheck/', params).then(function(result) {
          vm.adopterVisible = true;
          vm.adopters = result.data;
          if (vm.adopters.length === 1) {
            vm.user.adopter = vm.adopters[0].Id;
            selectAdopter();
            vm.adopterVisible = false;
          }
        });
      }

      function selectAdopter() {
        if (vm.user.adopter !== '') {
          var params = { userId: vm.user.userId, adopter: vm.user.adopter, guid: vm.user.guid };
          $http.post('Auth/SelectAdopter/', params).then(function(result) {
            vm.groupVisible = true;
            vm.groups = result.data;
            if (vm.groups.length === 1) {
              vm.user.group = vm.groups[0].Id;
              vm.groupVisible = false;
              if (vm.adopters.length === 1) {
                selectGroup();
              }
            }
          });
        }
      }
      function changeUserId(scope) {
        let valid = false,
          userid = vm.user.userId;
        if (userid) {
          userid = userid.toUpperCase();
          vm.user.userId = userid;
          let re = new RegExp(`^[a-zA-Z0-9._-]{${vm.userIdLength}}$`, 'gi');
          if (userid.match(re)) {
            valid = true;
          }
        }
        scope.$setValidity('pattern', valid);
        vm.validUser = valid;
      }
      function selectGroup() {
        if (vm.user.group === '') {
          location.reload(true);
          return;
        }
        if (vm.user.group !== '') {
          $http.post('Auth/SelectGroup/', vm.user).then(
            function(success) {
              var response = success.data;
              if (checkResponse(response)) {
                authService.loggedIn();
                authService.setUserContext(response, { clearControllerPermissions: true });
                languageService.updateLang();

                languageService.updateLang();
                localStorage.setItem('SBLang', vm.user.lang);
                localStorage.setItem(
                  'SBLangCode',
                  vm.langOptions.find(x => x.Value === vm.user.lang)?.Key ??
                    `${vm.user.lang}-${vm.user.lang.toUpperCase()}`
                );

                var eventCardCtrl = angular.element($('.refreshReminderList')).scope()?.eventCardCtrl;
                eventCardCtrl?.ReminderDataSource?.data([]);
                if (!!eventCardCtrl?.loadTime) {
                  eventCardCtrl.loadTime = 0;
                }
                if (!!eventCardCtrl?.ReminderCount) {
                  eventCardCtrl.ReminderCount = null;
                }
                authService.redirectTo();
              }
            },
            function(error) {
              // TODO error
            }
          );
        }
      }
      function changePassword() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/User/ChangePasswordNoLogin.html',
          controller: 'ChangePasswordNoLoginCtrl',
          controllerAs: 'vm',
          resolve: {
            model: function() {
              return { userId: vm.user.userId, password: vm.user.password };
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TokenCtrl', [
    '$scope',
    'AuthService',
    'LanguageService',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    'options',
    '$stateParams',
    function($scope, authService, languageService, $state, $location, $http, $uibModal, options, $stateParams) {
      var vm = this;
      vm.langOptions = options?.lang;
      vm.user = {
        companyId: vm.sbType == 'box' ? localStorage.getItem('SBCompanyId') : '',
        userId: '',
        userName: '',
        password: '',
        lang: !vm.sbLang ? 'hu' : vm.sbLang,
        adopter: '',
        group: '',
        guid: '',
      };
      if (authService?.isLoggedIn) {
        authService.logout('tokenLogin', { token: $stateParams?.token });
        return;
      }
      $('.navbar:first').remove();
      $http.post('Auth/LoginWithHash/', { token: $stateParams?.token }).then(
        function(success) {
          let result = success.data.loginResult;
          if (result) {
            vm.sbType == 'box' && localStorage.setItem('SBCompanyId', vm.user.companyId);
            vm.user.userName = result.userName;
            vm.user.userId = result.userId;
            vm.user.guid = result.guid;
            vm.adopters = result.adopterList;
          }

          $http.post('Auth/SelectGroupWithHash/').then(
            function(success) {
              var response = success?.data;
              if (response) {
                authService.isLoggedIn = true;
                authService.setUserContext(response, { clearControllerPermissions: true });
                languageService.updateLang();

                languageService.updateLang();
                localStorage.setItem('SBLang', vm.user.lang);
                localStorage.setItem(
                  'SBLangCode',
                  vm.langOptions.find(x => x.Value === vm.user.lang)?.Key ??
                    `${vm.user.lang}-${vm.user.lang.toUpperCase()}`
                );
                $state.go(authService.user?.tokenLogin?.stateName, authService.user?.tokenLogin?.stateParam);
              }
            },
            function(error) {
              // TODO error
            }
          );
        },
        function(error) {
          // TODO error
        }
      );
      //sbType cache:
      vm.sbType = localStorage.getItem('SBType');
      vm.sbLang = localStorage.getItem('SBLang');
      authService.getSBType().then(function(resp) {
        localStorage.setItem('SBType', resp);
        vm.sbType = resp;
      });
      authService.getSBFormInit().then(function(resp) {
        localStorage.setItem('SBFormInitOff', resp);
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  '$urlRouterProvider',
  function($stateProvider, urlRouter) {
    urlRouter.otherwise('/login');

    var states = {
      login: {
        url: '/login?redirectTo',
        templateUrl: 'App/Login/Login.html',
        controller: 'LoginCtrl as vm',
        resolve: {
          options: RouteResolveFunc('Auth/LanguageOptions'),
        },
        needAuth: false,
        ncyBreadcrumb: {
          label: '',
        },
      },
      tokenLogin: {
        url: '/token/:token',
        templateUrl: 'App/Login/Token.html',
        controller: 'TokenCtrl as vm',
        resolve: {
          options: RouteResolveFunc('Auth/LanguageOptions'),
        },
        needAuth: false,
        ncyBreadcrumb: {
          label: '',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('NavbarCtrl', [
    'AuthService',
    '$uibModal',
    '$http',
    '$state',
    '$window',
    'FavouriteService',
    'gridService',
    'HelpAndManualService',
    'UIHelperService',
    'LanguageService',
    function(
      authService,
      $uibModal,
      $http,
      $state,
      $window,
      FavouriteService,
      gridService,
      hmService,
      UIHelperService,
      languageService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'NavbarCtrl', stateParams);
      }
      var vm = this;

      vm.authService = authService;
      vm.logout = authService.logout;
      vm.changePassword = changePassword;
      vm.details = details;
      vm.toggleContentMenu = toggleContentMenu;
      vm.isLangVisible = isLangVisible;
      vm.sugo = sugo;
      vm.goToMessages = goToMessages;
      vm.events = events;
      vm.favouriteService = FavouriteService;
      vm.UIHelperService = UIHelperService;
      Object.defineProperty(vm, 'labels', {
        get: function() {
          return languageService.getDictionary()?.index;
        },
      });

      $(document).on('click', '.notHideOnClick.dropdown-menu', function(e) {
        //ne záródjon be a dropdown kattintásra:
        e.stopPropagation();
      });

      function events() {
        alert('events');
      }

      function changePassword() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/User/ChangePassword.html',
          controller: 'ChangePasswordCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Auth/ChangePasswordOptions/'),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function details() {
        //$state.go("user.details");
      }

      function toggleContentMenu() {
        $('#wrapper').toggleClass('toggled');
      }

      function isLangVisible() {
        return $state.current.name.toLowerCase() === 'main';
      }

      function sugo() {
        var isPageExist = hmService.getActiveHMPageUrl();
        if (isPageExist !== undefined) {
          $window.open(hmService.getActiveHMPageUrl(), '_blank');
        }
      }

      function goToMessages() {
        $state.go('Messages.MessagesNav');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('AllLayoutCtrl', [
    'UIHelperService',
    '$stateParams',
    function(UIHelperService, $stateParams) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AllLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      if (!!$stateParams.openMenu) {
        vm.UIHelperService.sidebar$.next(true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('AllMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AllMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.selectedModule = {
        selectedData: $stateParams.selectedModule == '{selectedModule}' ? null : $stateParams.selectedModule,
      };

      vm.ModuleDDL = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: false,
            label: 'Modul',
            options: FormlyCreateDDLOption({
              url: 'AllMasterData/ListModuleOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.MasterDataDDL[0].templateOptions.options.dataSource.read();
            },
          },
        },
      ];

      vm.MasterDataDDL = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'AllMasterData/ListMasterDataOptions',
              transData: function() {
                return {
                  module: !!vm.selectedModule && !!vm.selectedModule.selectedData ? vm.selectedModule.selectedData : '',
                };
              },
              textField: 'text',
              valueField: 'key',
              autoBind: true,
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};
      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          //console.log("going to state with: " + JSON.stringify(vm.formModifiers));
          $state.go(vm.type + 'List', {
            selectedModule:
              !!vm.selectedModule && !!vm.selectedModule.selectedData ? vm.selectedModule.selectedData : '',
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      'Masterdatamodule.AllMasterData': {
        url: '/all',
        params: {
          module: 'masterdataPartner',
          selectedModule: '{selectedModule}',
          documentEntity: 'masterdata_partner',
        },
        views: {
          content: {
            templateUrl: 'App/MasterData/All/AllMasterData.html',
            controller: 'AllMasterDataCtrl as vm',
          },
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Összes törzs',
          parent: 'Masterdatamodule',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';
  module.controller('AllMasterDataOuterLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AllMasterDataOuterLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataDuplicateCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'LockService',
    'parameters',
    function(mi, $http, fModel, $stateParams, AuthService, lockService, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataDuplicateCtrl', stateParams);
      }
      var vm = this;
      vm.securedProgramId = fModel.programId;
      vm.securedId = parameters.id;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      if (!!fModel.isSecondMDType) {
        vm.MDType = $stateParams.secondMDType;
      } else {
        vm.MDType = $stateParams.MDType;
      }

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      if (vm.MDType === 'Period') {
        var onChangeFunctions = {
          FinancialYear: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'PartnerMasterData/PeriodLastMonth',
              params: { financialYear: vm.formModel.FinancialYear },
            }).then(function successCallback(response) {
              if (response.data !== null && response.data !== '') {
                vm.formModel.Period = response.data.Period;
                vm.formModel.Name = response.data.Name;
              } else {
              }
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }
      if (vm.MDType === 'Service') {
        if (vm.formModel.ModelState !== 3) {
          vm.pageModel.Fields.ServiceCode.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
            'A mező tartalma automatikusan kitöltésre kerül az eddig kiosztott maximális sorszám + 1 értékkel.<br>Ez az érték módosítható bármely, még nem kiosztott sorszámra.<br>Amennyiben a kiosztható maximális érték (99) már kiosztásra került, <br>akkor nincsen automatikus  kitöltés, de rögzíthető bármely nem kiosztott szabad sorszám.';
        }
        var customExpressionProperties = {
          Active: {
            'templateOptions.disabled': function() {
              //Módosításkor a mező tiltott
              return vm.formModel.ModelState === 3;
            },
          },
          ServiceCode: {
            'templateOptions.disabled': function() {
              //Módosításkor a mező tiltott
              return vm.formModel.ModelState === 3;
            },
          },
        };
        var customTypes = {
          ServiceCode: 'maskedInput',
        };
        vm.ServiceGroupCode = vm.formModel.ServiceCode.substring(0, 2);
        var inputMasks = {
          ServiceCode: vm.ServiceGroupCode.replaceAll(/(\d)/g, '\\$1') + '.99',
        };
        InsertInputMasks(vm.pageModel, inputMasks);
        InsertCustomTypes(vm.pageModel, customTypes);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      if (vm.MDType === 'Floor') {
        var floor = vm.formModel.Floor;
        var customExpressionProperties = {
          Floor: {
            'templateOptions.disabled': function() {
              return floor !== '' && floor !== null;
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType === 'RentStatus') {
        var numericOptions = {
          RentStatusId: {
            decimals: 0,
            format: 'n0',
            max: 999999,
            min: 0,
          },
          Ranking: {
            decimals: 0,
            format: 'n0',
            max: 999999,
            min: 0,
          },
        };
        InsertNumericOptions(vm.pageModel, numericOptions);
      }
      if (vm.MDType === 'RentLocation') {
        var numericOptions = {
          RentLocationId: {
            decimals: 0,
            format: 'n0',
            max: 999999,
            min: 0,
          },
        };
        InsertNumericOptions(vm.pageModel, numericOptions);
      }
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      if (vm.MDType == 'ProjectStatusMain') {
        vm.formFields = formlyFormPanelDescriptors.PanelProjectStatus.FormlyDescriptor;
      } else {
        vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      }

      if (vm.MDType === 'ServiceGroup') {
        var customTypes = {
          ServiceGroupCode: 'maskedInput',
        };
        var inputMasks = {
          ServiceGroupCode: '99',
        };
        InsertInputMasks(vm.pageModel, inputMasks);
        InsertCustomTypes(vm.pageModel, customTypes);
      }

      vm.save = function() {
        if (vm.MDType === 'Service') {
          if (vm.formModel.ServiceCode.length < 3) {
            vm.formModel.ServiceCode = vm.ServiceGroupCode + '.' + vm.formModel.ServiceCode;
          }
        }
        $http.post(vm.ModulType + 'MasterData/' + vm.MDType + 'Duplicate', vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikeresen megtörtént!');
            mi.close();
          },
          function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' duplikálása sikertelen!');
            //mi.close();
          }
        );
      };

      if (vm.MDType === 'RentLocation') {
        var onChangeFunctions = {
          PropertyId: function(selectedItem) {
            if (!!selectedItem.GridItem) {
              vm.formModel.Level = selectedItem.GridItem.Level;
              vm.formModel.Tenement = selectedItem.GridItem.Tenement;
            }
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

        var whereConditionFunctionService = function() {
          return "ServiceType~eq~'CSEUT'";
        };
        vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionService;
        vm.pageModel.Fields.OtherService.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionService;
        var whereConditionFunctionProperty = function() {
          return "Level~eq~'PPRBU'~or~Level~eq~'PPRED'~or~Level~eq~'PPRLA'~or~Level~eq~'PPROB'";
        };
        vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionProperty;
        var whereConditionFunctionPemise = function() {
          if (vm.formModel.PropertyId.Value > 0 && !!vm.formModel.Level) {
            if (vm.formModel.Level === 'PPROB') {
              return "Tenement~startswith~'" + vm.formModel.Tenement.substring(0, 4) + "'";
            } else {
              return "PropertyId~eq~'" + vm.formModel.PropertyId.Value + "'";
            }
          }
        };
        vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionPemise;
      }

      if (vm.MDType === 'PriceListRow') {
        var whereConditionFunction = function() {
          return "ServiceType~eq~'CSEUT'";
        };
        vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
        vm.pageModel.Fields.PriceTypeId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
      }

      vm.cancel = function() {
        // Unlock
        // This will spawn a modal what cannot be closed until the unlock is done
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataEditCtrl', [
    '$uibModal',
    '$uibModalInstance',
    '$http',
    '$state',
    'fModel',
    'formModifiers',
    '$stateParams',
    'AuthService',
    '$scope',
    'HistoryService',
    'LockService',
    'parameters',
    function(
      $uibModal,
      mi,
      $http,
      $state,
      fModel,
      formModifiers,
      $stateParams,
      AuthService,
      $scope,
      HistoryService,
      lockService,
      parameters
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataEditCtrl', stateParams);
      }
      var vm = this;
      vm.securedProgramId = fModel.programId;
      vm.securedId = parameters.id;
      vm.operation = !parameters.Operation ? 'Edit' : parameters.Operation;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init(vm, mi, $http, fModel, formModifiers, $stateParams, AuthService, $scope);

      function init(vm, mi, $http, fModel, formModifiers, $stateParams, AuthService, $scope) {
        vm.pageModel = fModel.pageModel;
        vm.pageModelR = fModel.pageModelR;
        vm.messages = fModel.pageModel.Messages;
        vm.formModifiers = formModifiers;
        vm.History = history;
        vm.attachDocument = attachDocument;
        //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
        // These must be ran before generating formly descriptors from general field descriptors
        if (!!vm.formModifiers) {
          InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
          InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
          InsertParsers(vm.pageModel, vm.formModifiers.parsers);
          InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
          InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
          InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
          InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
        }
        ////////////////////////////////////////////////////////////////////////////////////////
        vm.formModel = fModel.dto;
        if (!!fModel.isSecondMDType) {
          vm.MDType = $stateParams.secondMDType;
        } else {
          vm.MDType = $stateParams.MDType;
        }
        vm.saveDisabled = function() {
          return false;
        };
        vm.ModulType = $stateParams.ModulType;
        vm.getModulType = function() {
          return vm.ModulType;
        };

        if (vm.MDType === 'PremiseFunction') {
          vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.type = 'kendoMS';
        }

        var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

        // ez azért van, hogy a mentés elott ha valaki akar még tudjon ellenőrzéseket vlégrehajtani, és az
        // általairt fuggveny vegen meghivni a save metodust
        if (vm.save === undefined) {
          vm.save = save;
        }

        if (vm.MDType === 'UsageFee') {
          if (vm.securedId !== 0) {
            vm.UsageFeeHasContractReferences = true;

            var getContractQueryUrl = 'ContractMasterData/GetUsageFeeContracts/' + vm.securedId;
            $http.get(getContractQueryUrl).then(function(result) {
              var contractList = result.data.ContractList;
              if (contractList.length == 0) {
                vm.UsageFeeHasContractReferences = false;
              } else {
                vm.UsageFeeHasContractReferences = true;
              }
              // update formly
              vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.runExpressions();
            });

            var customExpressionProperties = {
              ValidFrom: {
                'templateOptions.disabled': function() {
                  return vm.UsageFeeHasContractReferences;
                },
              },
            };
            InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
          }

          // set save
          vm.save = function() {
            var getValidUsageFeesByAreaRentalIdUrl =
              'ContractMasterData/GetValidUsageFeesByAreaRentalId/' + vm.formModel.AreaRentalId;

            $http.get(getValidUsageFeesByAreaRentalIdUrl).then(function(result) {
              var usageFeeList = result.data.UsageFeeList;
              if (!usageFeeList || usageFeeList.length === 0) {
                save();
              } else {
                // open warning modal
                var modalInstance = $uibModal.open({
                  templateUrl: 'App/MasterData/Contract/UsageFeeSaveWarningOnAreaRental.html',
                  controller: 'UsageFeeSaveWarningOnAreaRentalCtrl',
                  controllerAs: 'vm',
                  resolve: {
                    parameters: {
                      usageFeeList: usageFeeList,
                    },
                  },
                  backdrop: 'static',
                });

                modalInstance.result.then(function(result) {
                  if (result.isCancelled) {
                    return;
                  }
                  if (!result.hasResult) {
                    return;
                  }

                  var usageFee = result.usageFee;
                  if (usageFee.UsageFeeId < 0) {
                    // Egyiket sem, ilyenkor csak az új tételt kell rögzíteni
                    save();
                    return;
                  } else {
                    // close the selected usageFee
                    var closeSelectedUsageFeeUrl = 'ContractMasterData/CloseSelectedUsageFee';

                    $http
                      .post(closeSelectedUsageFeeUrl, { usageFeeIdToClose: usageFee.UsageFeeId, model: vm.formModel })
                      .then(function(response) {
                        save();
                      })
                      .catch(function(response) {
                        toastr.error(
                          vm.pageModel.Labels['LabelTitle'].Title + ' mentése nem sikerült!',
                          'Hiba történt!'
                        ); // TODO általános label
                        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                        mi.close();
                      });

                    // end
                  }

                  // end
                });
                // end
              }
            });

            //save();
          };
        }

        if (vm.MDType === 'ResponsibleType') {
          var customExpressionProperties = {
            IsHandler: {
              'templateOptions.disabled': function() {
                if (vm.formModel.IsPartnerTribe === false) {
                  vm.formModel.IsHandler = false;
                  return true;
                }
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType == 'PartnerCat') {
          var hideExpressions = {
            PartGroupId: function($viewValue, $modelValue, scope) {
              return !vm.formModel.showPartGroup;
            },
          };
          InsertHideExpressions(vm.pageModel, hideExpressions);

          var customExpressionProperties = {
            Type: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
          };

          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Period') {
          var numericOptions = {
            RatioNumber: {
              decimals: 0,
              format: 'n0',
              max: 99999999999999,
              min: 0,
            },
          };
          InsertNumericOptions(vm.pageModel, numericOptions);

          var onChangeFunctions = {
            FinancialYear: function(selectedItem) {
              $http({
                method: 'GET',
                url: 'PartnerMasterData/PeriodLastMonth',
                params: { financialYear: vm.formModel.FinancialYear },
              }).then(function successCallback(response) {
                if (response.data !== null && response.data !== '') {
                  vm.formModel.Period = response.data.Period;
                  vm.formModel.Name = response.data.Name;
                }
              });
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

          var customExpressionProperties = {
            FinancialYear: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'InvoicePad') {
          var customExpressionProperties = {
            InvoiceType: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
          };

          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'EqualMultiplier') {
          var syncValidators = {
            Multiplier: {
              /**
               * @return {boolean}
               */
              MultiplierValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return /^[0-9]*(,[0-9]{1,2})?$/.test(modelValue);
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'VatCode') {
          var syncValidators = {
            Vat: {
              /**
               * @return {boolean}
               */
              NumValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return /^[0-9]*(,[0-9]{1,2})?$/.test(modelValue);
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);

          var vatcode = vm.formModel.VatCode;
          var customExpressionProperties = {
            VatCode: {
              'templateOptions.disabled': function() {
                return vatcode !== '' && vatcode !== null;
              },
            },
            Name: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Repeat') {
          var syncValidators = {
            UnitNum: {
              /**
               * @return {boolean}
               */
              NumValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }

                return modelValue > 0;
              },
            },
          };
          InsertSyncValidators(vm.pageModel, syncValidators);

          var numericOptions = {
            UnitNum: {
              decimals: 0,
              format: 'n0',
              max: 99999999999999,
              min: 0,
            },
          };
          InsertNumericOptions(vm.pageModel, numericOptions);
        }

        if (vm.MDType === 'Post') {
          var numericOptions = {
            Square: {
              decimals: 0,
              format: 'n0',
              max: '9?9?9?9?9?9?9',
              min: 0,
            },
          };

          InsertNumericOptions(vm.pageModel, numericOptions);
          var customTypes = {
            Square: 'maskedInput',
          };
          InsertCustomTypes(vm.pageModel, customTypes);

          var inputMasks = {
            Square: '9?9?9?9?9?9?9',
          };
          InsertInputMasks(vm.pageModel, inputMasks);

          var syncValidators = {
            Square: {
              /**
               * @return {boolean}
               */
              NoMessageValidator: function(modelValue) {
                var str = String(modelValue);
                if (modelValue && str.includes('_')) {
                  modelValue = str.substring(0, str.indexOf('_'));
                }
                if (!modelValue) {
                  return true;
                }
                return modelValue >= 0 && modelValue <= 9999999;
              },
            },
          };
          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'Currency') {
          var syncValidators = {
            SmallestUnit: {
              /**
               * @return {boolean}
               */
              NumValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }

                return modelValue >= 0;
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'CurrencyExchange') {
          var syncValidators = {
            RateDate: {
              /**
               * @return {boolean}
               */
              RateDateValidator: function(modelValue) {
                var today = new Date();
                var date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
                var todayDateValue = new moment(date, kendo.culture().calendar.patterns.d.toUpperCase());
                var rateDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

                return !rateDateValue.isAfter(todayDateValue);
              },
            },
            BuyingRate: {
              /**
               * @return {boolean}
               */
              VatValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return true;
              },
            },
            CentralRate: {
              /**
               * @return {boolean}
               */
              VatValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return true;
              },
            },
            SellingRate: {
              /**
               * @return {boolean}
               */
              VatValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return true;
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'PostCode') {
          var syncValidators = {
            PostCode: {
              PartAddressPostCodeValidator: function(modelValue, viewValue) {
                if (vm.formModel.Country == 'HU') {
                  if (/^[1-9]\d{3}$/g.test(modelValue)) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  var postCode = parseFloat(modelValue);
                  if (!isNaN(postCode) && postCode < 0) {
                    return false;
                  } else {
                    return true;
                  }
                }
              },
            },
            NumberFrom: {
              NumberFromValidator: function(modelValue) {
                return !isNaN(modelValue) && !!vm.formModel.NumberTo ? modelValue <= vm.formModel.NumberTo : true;
              },
              NumberFromMinimumValidator: function(modelValue) {
                return !modelValue || modelValue >= -3;
              },
            },
            NumberTo: {
              NumberToValidator: function(modelValue) {
                return !isNaN(modelValue) && !!vm.formModel.NumberFrom ? modelValue >= vm.formModel.NumberFrom : true;
              },
              NumberToMinimumValidator: function(modelValue) {
                return !modelValue || modelValue >= 0;
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);

          var onChangeFunctions = {
            NumberFrom: function() {
              vm.pageModel.Fields.NumberTo.FormlyFieldDescriptor.formControl.$validate();
            },
            NumberTo: function() {
              vm.pageModel.Fields.NumberFrom.FormlyFieldDescriptor.formControl.$validate();
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        }

        if (vm.MDType === 'Deposit') {
          if (!vm.formModel.DepositId) {
            vm.formModel.Vat = 0;
            vm.formModel.MoRental = 0;
            vm.formModel.MoPropServ = 0;
            vm.formModel.OtPercent = 0;
          }

          var syncValidators = {
            Vat: {
              /**
               * @return {boolean}
               */
              VatValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return true;
              },
            },
            MoRental: {
              /**
               * @return {boolean}
               */
              MoRentalValidator: function(modelValue) {
                if (modelValue >= 0) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            MoPropServ: {
              /**
               * @return {boolean}
               */
              MoRentalValidator: function(modelValue) {
                //debugger;
                if (modelValue >= 0) {
                  return true;
                } else {
                  return false;
                }
              },
            },
            OtPercent: {
              /**
               * @return {boolean}
               */
              MoRentalValidator: function(modelValue) {
                if (modelValue >= 0) {
                  return true;
                } else {
                  return false;
                }
              },
            },
          };
          var customExpressionProperties = {
            Vat: {
              'templateOptions.disabled': function() {
                if (vm.formModel.Fixed) {
                  vm.formModel.Vat = 0;
                }
                return vm.formModel.Fixed;
              },
            },
            MoRental: {
              'templateOptions.disabled': function() {
                if (vm.formModel.Fixed) {
                  vm.formModel.MoRental = 0;
                }
                return vm.formModel.Fixed;
              },
            },
            MoPropServ: {
              'templateOptions.disabled': function() {
                if (vm.formModel.Fixed) {
                  vm.formModel.MoPropServ = 0;
                }
                return vm.formModel.Fixed;
              },
            },
            OtPercent: {
              'templateOptions.disabled': function() {
                if (vm.formModel.Fixed) {
                  vm.formModel.OtPercent = 0;
                }
                return vm.formModel.Fixed;
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

          //override save button

          vm.save = function() {
            if (
              vm.formModel.MoPropServ < 0 ||
              vm.formModel.MoRental < 0 ||
              vm.formModel.OtPercent < 0 ||
              vm.formModel.Vat.Value < 0
            ) {
              toastr.error('A mezők értéke nem lehet negatív!');
            } else {
              save();
            }
          };
        }

        if (vm.MDType === 'ContractType') {
          var syncValidators = {
            Prefix: {
              /**
               * @return {boolean}
               */
              PrefixValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return /[a-zA-Z]/.test(modelValue);
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'RentIndexation') {
          var customExpressionProperties = {
            ValidFrom: {
              'templateOptions.disabled': function() {
                return (
                  vm.formModel.RentIndexationId !== 0 &&
                  vm.formModel.RentIndexationTMId !== vm.formModel.MaxRentIndexationTMId
                );
              },
            },
            ValidTo: {
              'templateOptions.disabled': function() {
                return (
                  vm.formModel.RentIndexationId !== 0 &&
                  vm.formModel.RentIndexationTMId !== vm.formModel.MaxRentIndexationTMId
                );
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'SupplyContrStatusType') {
          var syncValidators = {
            RanKing: {
              /**
               * @return {boolean}
               */
              MoRentalValidator: function(modelValue) {
                if (modelValue >= 0) {
                  return true;
                } else {
                  return false;
                }
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'UsageFeeMultiplier') {
          var syncValidators = {
            WithoutTitelMonth: {
              /**
               * @return {boolean}
               */
              WithoutTitelMonthValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return kendo.parseFloat(modelValue) >= 0;
              },
            },
            WithoutTitelMultiplier: {
              /**
               * @return {boolean}
               */
              WithoutTitelMultiplierValidator: function(modelValue) {
                if (!modelValue) {
                  return true;
                }
                return kendo.parseFloat(modelValue) > 0;
              },
            },
          };
          InsertSyncValidators(vm.pageModel, syncValidators);
        }

        if (vm.MDType === 'FinancialYear') {
          var financialYear = vm.formModel.FinancialYear;
          var customExpressionProperties = {
            DateFrom: {
              'templateOptions.disabled': function() {
                return financialYear !== '' && financialYear !== null;
              },
            },
            DateTo: {
              'templateOptions.disabled': function() {
                return financialYear !== '' && financialYear !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        //beírható azonosítóknál módosításnál ne legyen módosítható az azonosító
        if (vm.MDType === 'Nationality') {
          var nationality = vm.formModel.Nationality;
          var customExpressionProperties = {
            Nationality: {
              'templateOptions.disabled': function() {
                return nationality !== '' && nationality !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Floor') {
          var floor = vm.formModel.Floor;
          var customExpressionProperties = {
            Floor: {
              'templateOptions.disabled': function() {
                return floor !== '' && floor !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'FinancialItem') {
          var financialItem = vm.formModel.FinancialItem;
          var customExpressionProperties = {
            FinancialItem: {
              'templateOptions.disabled': function() {
                return financialItem !== '' && financialItem !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Classification') {
          var classification = vm.formModel.Classification;
          var customExpressionProperties = {
            Classification: {
              'templateOptions.disabled': function() {
                return classification !== '' && classification !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Language') {
          var language = vm.formModel.Language;
          var customExpressionProperties = {
            Language: {
              'templateOptions.disabled': function() {
                return language !== '' && language !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Country') {
          var country = vm.formModel.Country;
          var customExpressionProperties = {
            Country: {
              'templateOptions.disabled': function() {
                return country !== '' && country !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Payment') {
          var payment = vm.formModel.Payment;
          var customExpressionProperties = {
            Payment: {
              'templateOptions.disabled': function() {
                return payment !== '' && payment !== null;
              },
            },
            Cash: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
            Cheque: {
              'templateOptions.disabled': function() {
                return vm.formModel.HasRelation;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'Currency') {
          var currency = vm.formModel.Currency;
          var customExpressionProperties = {
            Currency: {
              'templateOptions.disabled': function() {
                return currency !== '' && currency !== null;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'ConstructionElement') {
          var onChangeFunctions = {
            GroupId: function(selectedItem) {
              $http({
                method: 'GET',
                url: 'ConstructionMasterData/GetClassifyName',
                params: { groupId: vm.formModel.GroupId },
              }).then(function successCallback(response) {
                if (response.data !== null && response.data !== '') {
                  vm.formModel.ConstructionClassify = response.data.Dto.ClassifyName;
                }
              });
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        }
        if (vm.MDType === 'ConstructionGroup') {
          var onChangeFunctions = {
            ConstructionClassify: function(selectedItem) {
              $http({
                method: 'GET',
                url: 'ConstructionMasterData/GetGroupRanking',
                params: { ConstructionClassify: vm.formModel.ConstructionClassify },
              }).then(function successCallback(response) {
                if (response.data !== null && response.data !== '') {
                  vm.formModel.Ranking = response.data.Dto.Ranking;
                }
              });
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        }

        if (vm.MDType === 'PremiseFunction') {
          vm.pageModel.Fields.PremiseSubFunction.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
            return {
              functionId: vm.formModel.PremiseFunctionId,
            };
          };
        }

        if (vm.MDType === 'BudSubGroup') {
          var customExpressionProperties = {
            BudSubGroupCode: {
              'templateOptions.disabled': function() {
                //Módosításkor a mező tiltott
                return vm.formModel.ModelState === 3;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }
        if (vm.MDType === 'BudgetPlanServiceMod') {
          var syncValidators = {
            AppliedPercent: {
              /**
               * @return {boolean}
               */
              PercentValidator: function(modelValue, viewValue) {
                return viewValue >= 0 && viewValue <= 100;
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);
        }
        if (vm.MDType === 'BudgetDate') {
          //Létrehozáskor alapértelmezetten aktív
          if (vm.formModel.BudgetDateId == 0) vm.formModel.Active = true;

          var onChangeFunctions = {
            FinancialYear: function(selectedItem) {
              if (!!selectedItem && !!selectedItem.extraProperties) {
                vm.formModel.DateFrom = selectedItem.extraProperties[0].value;
                vm.formModel.DateTo = selectedItem.extraProperties[1].value;
              }
              vm.formModel.BudgetDate = null;
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

          var syncValidators = {
            BudgetDate: {
              /**
               * @return {boolean}
               */
              BudgetDateValidator: function(modelValue) {
                var dateBudget = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
                //var dateFrom = new moment(vm.formModel.DateFrom, kendo.culture().calendar.patterns.d.toUpperCase());
                //var dateTo = new moment(vm.formModel.DateTo, kendo.culture().calendar.patterns.d.toUpperCase());
                var dateFrom = new moment(vm.formModel.DateFrom);
                var dateTo = new moment(vm.formModel.DateTo);
                return (
                  dateBudget.isBetween(dateFrom, dateTo) || dateBudget.isSame(dateFrom) || dateBudget.isSame(dateTo)
                );
              },
            },
          };

          InsertSyncValidators(vm.pageModel, syncValidators);

          function warning(messages, txt) {
            var dialogMessage = vm.messages.ConfirmDelete;
            bootbox.dialog({
              message: txt,
              title: messages.Warning,
              buttons: {
                cancel: {
                  label: messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    save();
                  },
                },
              },
            });
          }

          // override save button action
          vm.save = function() {
            if (vm.formModel.BudgetDateId > 0) {
              $http({
                method: 'GET',
                url: 'BudgetMasterData/BudgetDateModifiable',
                params: { budgetDateId: vm.formModel.BudgetDateId, newbudgetDate: vm.formModel.BudgetDate },
              })
                .then(function(response) {
                  if (!!response && response.data.warning) {
                    warning(vm.messages, response.data.warning);
                  } else {
                    save();
                  }
                })
                .catch(function(response) {});
            } else {
              save();
            }
          };
        }

        if (vm.MDType === 'CityCode') {
          var customExpressionProperties = {
            CityCode: {
              'templateOptions.disabled': function() {
                //Módosításkor a mező tiltott
                return vm.formModel.ModelState === 3;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        if (vm.MDType === 'BudJobNumber') {
          var customExpressionProperties = {
            BudJobNumber: {
              'templateOptions.disabled': function() {
                //Módosításkor a mező tiltott
                return vm.formModel.ModelState === 3;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        // Project section - why tho
        if (vm.MDType === 'Financing') {
          vm.formFields = formlyFormPanelDescriptors.Panelfinancing.FormlyDescriptor;
        }
        if (vm.MDType === 'InvoiceType') {
          vm.formFields = formlyFormPanelDescriptors.Panelinvoicetype.FormlyDescriptor;
        }
        if (vm.MDType === 'Priority') {
          vm.formFields = formlyFormPanelDescriptors.Panelpriority.FormlyDescriptor;
        }
        if (vm.MDType === 'Specialization') {
          // Ez nem lesz, mert nem modal ablak az Edit window-ja, hanem egy külön felület
        }
        if (vm.MDType === 'ProjectStatusMain') {
          vm.formFields = formlyFormPanelDescriptors.PanelProjectStatus.FormlyDescriptor;
        }
        if (vm.MDType === 'ProjectType') {
          vm.formFields = formlyFormPanelDescriptors.Paneltype.FormlyDescriptor;

          // override save button action
          vm.save = function() {
            // legalabb egy checkboxnak be kell lennie pipalva
            if (
              !(
                vm.formModel.IsInvestment === true ||
                vm.formModel.IsMaintenance === true ||
                vm.formModel.IsRestoration === true
              )
            ) {
              toastr.warning('Kérem, az alábbiak közül legalább egy bejelölését: beruházás, karbantartás, felújítás!');
            } else if (vm.formModel.ProjectTypeId !== 0) {
              save();
            } else {
              // nézzük meg, hogy van-e már ilyen néven lementve tipus
              $http
                .get('ProjectMasterData/IsExistingTypeName/?Name=' + vm.formModel.Name)
                .then(function(response) {
                  if (!!response && response.data.ResultStatus && !response.data.IsExistingTypeName) {
                    // call save method
                    save();
                  } else {
                    toastr.warning('Már létezik azonos megnevezésű törzs.');
                  }
                })
                .catch(function(response) {
                  toastr.error('Hiba a Projekttípus mentése közben!');
                });
            }
          };
        }
        if (vm.MDType === 'Period') {
          vm.save = function() {
            if (vm.formModel.RatioNumber === 0) {
              toastr.warning('Az arányosítási szám nem lehet 0!');
            } else {
              save();
            }
          };
        }
        if (vm.MDType === 'CurrencyExchange') {
          vm.save = function() {
            if (vm.formModel.BuyingRate < 0 || vm.formModel.CentralRate < 0 || vm.formModel.SellingRate < 0) {
              toastr.warning('Az árfolyam nem lehet negatív!');
            } else {
              save();
            }
          };
        }
        if (vm.MDType === 'RentLocation') {
          vm.save = function() {
            if (
              vm.origFormModel.ValidFrom === vm.formModel.ValidFrom &&
              vm.formModel.MaxDateRentLocationTMId &&
              (vm.origFormModel.PropertyId?.Value !== vm.formModel.PropertyId?.Value ||
                vm.origFormModel.ServiceId?.Value !== vm.formModel.ServiceId?.Value ||
                vm.origFormModel.ReservationNumberCode?.Value !== vm.formModel.ReservationNumberCode?.Value ||
                vm.origFormModel.PriceListRowId?.Value !== vm.formModel.PriceListRowId?.Value ||
                vm.origFormModel.BudgetId?.Value !== vm.formModel.BudgetId?.Value ||
                uniqueJson(vm.formModel.OtherService) !== uniqueJson(vm.origFormModel.OtherService) ||
                uniqueJson(vm.formModel.PremiseId) !== uniqueJson(vm.origFormModel.PremiseId))
            ) {
              bootbox.dialog({
                message: vm.pageModel.Labels.ActualValidConfirmation.Title,
                title: vm.pageModel.Labels.Warning.Title,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      vm.saveFinal();
                    },
                  },
                },
              });
            } else {
              vm.saveFinal();
            }
          };
          vm.saveFinal = function() {
            if (!vm.formModel.PremiseId?.length) {
              bootbox.dialog({
                message: vm.pageModel.Labels.EmptyPremiseConfirmation.Title,
                title: vm.messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      save();
                    },
                  },
                },
              });
            } else {
              save();
            }
          };
          function uniqueJson(element) {
            return JSON.stringify(element?.filter((item, index) => element?.indexOf(item) === index).sort());
          }
        }

        if (!vm.formFields) {
          vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
        }

        if (vm.MDType === 'RentLocation') {
          vm.pageModel.Fields.RentLocationTMId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
            return {
              rentLocationId: vm.formModel.RentLocationId,
            };
          };
          vm.fieldDisabled = vm.saveDisabled = function() {
            return (
              vm.formModel.RentLocationTMId != vm.formModel.MaxDateRentLocationTMId && vm.formModel.ModelState === 3
            );
          };
          vm.firstRunProperty = true;
          vm.firstRunService = true;
          var onChangeFunctions = {
            PropertyId: function(selectedItem) {
              if (vm.firstRunProperty && vm.origFormModel.PropertyId?.Value === selectedItem?.Value) {
                return;
              }
              vm.firstRunProperty = false;

              if (!!selectedItem.GridItem) {
                vm.formModel.Level = selectedItem.GridItem.Level;
                vm.formModel.Tenement = selectedItem.GridItem.Tenement;
              }
              F4Helpers.SelectRows(vm, 'formModel', 'PremiseId', []);
              vm.formModel.PremiseId = [];
            },
            PremiseId: function(selectedItem) {
              $http
                .get('UtilizationMasterData/GetRentLocationCapacity/', {
                  params: { premiseid: vm.formModel.PremiseId },
                })
                .then(function(response) {
                  vm.formModel.CalcCapacity = response?.data?.Dto?.CalcCapacity ?? 0;
                  return response;
                });
            },
            ServiceId: function(selectedItem) {
              if (vm.firstRunService && vm.origFormModel.ServiceId?.Value === selectedItem?.Value) {
                return;
              }
              vm.firstRunService = false;
              F4Helpers.SelectRows(vm, 'formModel', 'OtherService', []);
              vm.formModel.OtherService = [];
              vm.formModel.PriceListRowId.Value = null;
              vm.formModel.PriceListRowId.Text = null;
            },
            RentLocationTMId: function(selectedItem) {
              vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems.length = 0;
              vm.pageModel.Fields.OtherService.FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems.length = 0;
              vm.formModel.Name = '';
              vm.formModel.ReservationNumberCode.Text = '';
              vm.formModel.PropertyId.Text = '';
              vm.formModel.ServiceId.Text = '';
              vm.formModel.Capacity = 0;
              vm.formModel.CalcCapacity = 0;
              vm.formModel.BudgetId.Text = '';
              vm.formModel.Comment = '';
              vm.formModel.ValidFrom = '';
              vm.formModel.ValidTo = '';
              vm.formModel.PriceListRowId.Text = '';
              vm.formModel.Email = '';
              $http({
                method: 'GET',
                url: 'UtilizationMasterData/RentLocationEdit?id=' + selectedItem.key,
              }).then(function successCallback(response) {
                if (response !== null && response.data) {
                  vm.formModel.PremiseId = response.data.dto.PremiseId;
                  F4Helpers.GetRows(
                    $http,
                    vm,
                    'PremiseId',
                    function(item) {
                      F4Helpers.SelectRows(
                        vm,
                        'formModel',
                        'PremiseId',
                        item.filter(x => response.data.dto.PremiseId.includes(x.PremiseId))
                      );
                    },
                    whereConditionFunctionPemise()
                  );

                  vm.formModel.OtherService = response.data.dto.OtherService;
                  F4Helpers.GetRows(
                    $http,
                    vm,
                    'OtherService',
                    function(item) {
                      F4Helpers.SelectRows(
                        vm,
                        'formModel',
                        'OtherService',
                        item.filter(x => response.data.dto.OtherService.includes(x.ServiceId))
                      );
                    },
                    whereConditionFunctionOtherService()
                  );
                  vm.formModel.Name = response.data.dto.Name;
                  vm.formModel.ReservationNumberCode.Value = response.data.dto.ReservationNumberCode.Value;
                  vm.formModel.ReservationNumberCode.Text = response.data.dto.ReservationNumberCode.Text;
                  vm.formModel.PropertyId.Value = response.data.dto.PropertyId.Value;
                  vm.formModel.PropertyId.Text = response.data.dto.PropertyId.Text;
                  vm.formModel.ServiceId.Value = response.data.dto.ServiceId.Value;
                  vm.formModel.ServiceId.Text = response.data.dto.ServiceId.Text;
                  vm.formModel.Capacity = response.data.dto.Capacity;
                  vm.formModel.CalcCapacity = response.data.dto.CalcCapacity;
                  vm.formModel.BudgetId = response.data.dto.BudgetId;
                  vm.formModel.BudgetId.Value = response.data.dto.BudgetId.Value;
                  vm.formModel.BudgetId.Text = response.data.dto.BudgetId.Text;
                  vm.formModel.Comment = response.data.dto.Comment;
                  vm.formModel.ValidFrom = response.data.dto.ValidFrom;
                  vm.formModel.ValidTo = response.data.dto.ValidTo;
                  vm.formModel.PriceListRowId.Value = response.data.dto.PriceListRowId.Value;
                  vm.formModel.PriceListRowId.Text = response.data.dto.PriceListRowId.Text;
                  vm.formModel.Email = response.data.dto.Email;
                }
              });
            },
          };
          InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
          var numericOptions = {
            Capacity: {
              decimals: 0,
              format: 'n0',
              max: 9999999,
              min: 0,
            },
          };
          InsertNumericOptions(vm.pageModel, numericOptions);
          var customExpressionProperties = {
            Name: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            ReservationNumberCode: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            PropertyId: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            ServiceId: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            PremiseId: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            OtherService: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            Capacity: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            PriceListRowId: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            BudgetId: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            Comment: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            ValidFrom: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
            Email: {
              'templateOptions.disabled': function() {
                return vm.fieldDisabled();
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

          var syncValidators = {
            Email: {
              email: function(modelValue) {
                return !modelValue || sysEmailValidate(modelValue);
              },
            },
          };
          InsertSyncValidators(vm.pageModel, syncValidators);

          var whereConditionFunctionService = function() {
            return "ServiceType~eq~'CSEUT'";
          };
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionService;
          var whereConditionFunctionOtherService = function() {
            return (
              "ServiceType~eq~'CSEUT'" +
              (vm.formModel.ServiceId?.Value ? "~and~ServiceId~neq~'" + vm.formModel.ServiceId?.Value + "'" : '')
            );
          };
          vm.pageModel.Fields.OtherService.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionOtherService;
          var whereConditionFunctionProperty = function() {
            return "Level~eq~'PPRBU'~or~Level~eq~'PPRED'~or~Level~eq~'PPRLA'~or~Level~eq~'PPROB'";
          };
          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionProperty;
          var whereConditionFunctionPemise = function() {
            if (vm.formModel.PropertyId.Value > 0 && !!vm.formModel.Level) {
              if (vm.formModel.Level === 'PPROB') {
                return "Tenement~startswith~'" + vm.formModel.Tenement.substring(0, 4) + "'";
              } else {
                return "PropertyId~eq~'" + (vm.formModel.PropertyId?.Value ?? 0) + "'";
              }
            }
          };
          vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionPemise;
          var whereConditionFunctionPriceListRowId = function() {
            return "ServiceId~eq~'" + (vm.formModel.ServiceId?.Value ?? 0) + "'";
          };
          vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionPriceListRowId;
        }
        if (vm.MDType === 'ServiceGroup') {
          var customTypes = {
            ServiceGroupCode: 'maskedInput',
          };
          var inputMasks = {
            ServiceGroupCode: '99',
          };
          InsertInputMasks(vm.pageModel, inputMasks);
          InsertCustomTypes(vm.pageModel, customTypes);
        }
        if (vm.MDType === 'Service') {
          if (vm.formModel.ModelState !== 3) {
            vm.pageModel.Fields.ServiceCode.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
              'A mező tartalma automatikusan kitöltésre kerül az eddig kiosztott maximális sorszám + 1 értékkel.<br>Ez az érték módosítható bármely, még nem kiosztott sorszámra.<br>Amennyiben a kiosztható maximális érték (99) már kiosztásra került, <br>akkor nincsen automatikus  kitöltés, de rögzíthető bármely nem kiosztott szabad sorszám.';
          }
          var customExpressionProperties = {
            Active: {
              'templateOptions.disabled': function() {
                //Módosításkor a mező tiltott
                return vm.formModel.ModelState === 3;
              },
            },
            ServiceCode: {
              'templateOptions.disabled': function() {
                //Módosításkor a mező tiltott
                return vm.formModel.ModelState === 3;
              },
            },
          };
          var customTypes = {
            ServiceCode: 'maskedInput',
          };
          vm.ServiceGroupCode = vm.formModel.ServiceCode.substring(0, 2);
          var inputMasks = {
            ServiceCode: vm.ServiceGroupCode.replaceAll(/(\d)/g, '\\$1') + '.99',
          };
          InsertInputMasks(vm.pageModel, inputMasks);
          InsertCustomTypes(vm.pageModel, customTypes);
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }
        if (vm.MDType === 'RentStatus') {
          var numericOptions = {
            RentStatusId: {
              decimals: 0,
              format: 'n0',
              max: 999999,
              min: 0,
            },
            Ranking: {
              decimals: 0,
              format: 'n0',
              max: 999999,
              min: 0,
            },
          };
          InsertNumericOptions(vm.pageModel, numericOptions);
          vm.isActive = null;
          vm.isVisible = null;
          var customCallbackFunctions = {
            IsApproved: function(selectedItem) {
              if (!!selectedItem) {
                vm.isActive = angular.copy(vm.formModel.IsActive);
                vm.formModel.IsActive = true;
                vm.isVisible = angular.copy(vm.formModel.IsActive);
                vm.formModel.IsVisible = true;
              }
            },
          };
          InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

          var customExpressionProperties = {
            IsVisible: {
              'templateOptions.disabled': function() {
                return vm.formModel.IsApproved === true;
              },
            },
            IsActive: {
              'templateOptions.disabled': function() {
                return vm.formModel.IsApproved === true;
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }
        if (vm.MDType === 'RentLocation') {
          vm.origFormModel = angular.copy(vm.formModel);
          var numericOptions = {
            RentLocationId: {
              decimals: 0,
              format: 'n0',
              max: 999999,
              min: 0,
            },
          };
          InsertNumericOptions(vm.pageModel, numericOptions);
        }

        if (vm.MDType === 'Owner') {
          var whereConditionFunction = function() {
            return "Worker~eq~'false'~and~ContrUser~eq~'false'~and~Partner~eq~'true'";
          };
          vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
          var customExpressionProperties = {
            PartnerId: {
              'templateOptions.required': function() {
                return AuthService.parameters?.ERPCON !== 'ERPCON_NO';
              },
            },
          };
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }

        function attachDocument() {
          toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
        }

        function history() {
          HistoryService.NavigateToHistory('Flg' + vm.MDType, eval('vm.formModel.' + vm.MDType + 'Id'), vm, $state);
          mi.close();
        }
        vm.cancel = function() {
          // Unlock
          // This will spawn a modal what cannot be closed until the unlock is done
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          mi.close();
        };
      }

      if (vm.MDType === 'PriceListRow') {
        var whereConditionFunction = function() {
          return "ServiceType~eq~'CSEUT'";
        };
        vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
        vm.pageModel.Fields.PriceTypeId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
      }

      if (vm.MDType === 'RatePlan') {
        //-------------a filterezéshez, hogy ne lehessen ugyan azt kiválasztani a kettőben
        var onChangeFunctions = {
          CurrencyFrom: function(selectedItem) {
            vm.pageModel.Fields.CurrencyTo.FormlyFieldDescriptor.templateOptions.options.dataSource.filter({
              field: 'key',
              operator: 'neq',
              value: selectedItem.key,
            });
          },
          CurrencyTo: function(selectedItem) {
            vm.pageModel.Fields.CurrencyFrom.FormlyFieldDescriptor.templateOptions.options.dataSource.filter({
              field: 'key',
              operator: 'neq',
              value: selectedItem.key,
            });
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      if (vm.MDType === 'Allocation') {
        var customExpressionProperties = {
          UnitsType: {
            'templateOptions.disabled': function() {
              return vm.formModel.ChangeNameOnly;
            },
          },
          RentalStatus: {
            'templateOptions.disabled': function() {
              return vm.formModel.ChangeNameOnly;
            },
          },
          WaterClock: {
            'templateOptions.disabled': function() {
              return vm.formModel.ChangeNameOnly;
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType === 'Information') {
        vm.disableForContractStatusField = vm.formModel.ForContractStatus == true;
        var customExpressionProperties = {
          ForContractStatus: {
            'templateOptions.disabled': function() {
              return vm.disableForContractStatusField;
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType === 'ServiceAssignment') {
        // function setServiceAssignmentFieldFilter(field, serviceType, tentype) {
        // vm.pageModel.Fields[field].FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = { serviceType: serviceType, tenType: tenType };
        // }

        // setServiceAssignmentFieldFilter('RentalServiceId', 'CSERE', vm.formModel.RentalTenType);
        // setServiceAssignmentFieldFilter('RentalServiceId', 'CSERE', vm.formModel.RentalTenType);

        vm.pageModel.Fields.RentalServiceId.FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns[0].width =
          'auto';
        vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns[0].width =
          'auto';

        vm.pageModel.Fields.RentalServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          return { serviceType: 'CSERE', tenType: vm.formModel.SelectedTenType };
        };
        vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          return { serviceType: 'CSEUS', tenType: vm.formModel.SelectedTenType };
        };

        var onChangeFunctions = {
          RentalServiceId: function(key, selectedItem) {
            //vm.formModel.RentalTenType = selectedItem?.TenType;
            vm.formModel.SelectedTenType = selectedItem?.TenType;
            // if (!!vm.formModel.RentalTenType && !!vm.formModel.UsageTenType && selectedItem?.TenType !== vm.formModel.UsageTenType)
            // {
            // vm.formModel.UsageServiceId = null;
            // }
            vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.templateOptions.refresh();
          },
          UsageServiceId: function(key, selectedItem) {
            //vm.formModel.UsageTenType = selectedItem?.TenType;
            vm.formModel.SelectedTenType = selectedItem?.TenType;
            // if (!!vm.formModel.RentalTenType &&  !!vm.formModel.UsageTenType && selectedItem?.TenType !== vm.formModel.RentalTenType)
            // {
            // vm.formModel.RentalServiceId = null;
            // }
            vm.pageModel.Fields.RentalServiceId.FormlyFieldDescriptor.templateOptions.refresh();
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      if (vm.MDType === 'UtilizationPriceType') {
        var onChangeFunctions = {
          ServiceId: function(selectedItem) {
            if (vm.formModel.ServiceId !== null && typeof vm.formModel.ServiceId !== 'undefined') {
              //add parameter
              //vm.pageModel.Fields.ServiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              //    serviceId: vm.formModel.ServiceId,
              //};
              //reload
              if (!!selectedItem.extraProperties[2].value) {
                vm.formModel.TenType = selectedItem.extraProperties[2].value;
                vm.pageModel.Fields.TenType.FormlyFieldDescriptor.templateOptions.disabled = true;
              } else {
                vm.pageModel.Fields.TenType.FormlyFieldDescriptor.templateOptions.disabled = false;
              }
            }
          },
          Owner: function(selectedItem) {
            vm.setTenTypeFilter();
          },
          TenType: function(selectedItem) {
            vm.setTenTypeFilter();
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }
      if (vm.MDType === 'ReservationReason') {
        vm.pageModel.Fields.ReservationReasonTMId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          return {
            reservationReasonId: vm.formModel.ReservationReasonId,
          };
        };
        vm.fieldDisabled = vm.saveDisabled = function() {
          return (
            vm.formModel.ReservationReasonTMId != vm.formModel.MaxDateReservationReasonTMId &&
            vm.formModel.ModelState === 3
          );
        };

        var onChangeFunctions = {
          ReservationReasonTMId: function(selectedItem) {
            $http({
              method: 'GET',
              url: 'UtilizationMasterData/ReservationReasonEdit?id=' + selectedItem.key,
            }).then(function successCallback(response) {
              if (response !== null && response.data) {
                // vm.formModel.Name = response.data.dto.Name;
                // vm.formModel.IsInvoicing = response.data.dto.IsInvoicing;
                // vm.formModel.IsActive = response.data.dto.IsActive;
                // vm.formModel.Comment = response.data.dto.Comment;
                // vm.formModel.ValidFrom = response.data.dto.ValidFrom;
                // vm.formModel.ValidTo = response.data.dto.ValidTo;
              }
            });
            console.log(selectedItem);
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        var customExpressionProperties = {
          Name: {
            'templateOptions.disabled': function() {
              return vm.fieldDisabled();
            },
          },
          IsInvoicing: {
            'templateOptions.disabled': function() {
              return vm.fieldDisabled();
            },
          },
          IsActive: {
            'templateOptions.disabled': function() {
              return vm.fieldDisabled();
            },
          },
          Comment: {
            'templateOptions.disabled': function() {
              return vm.fieldDisabled();
            },
          },
          ValidFrom: {
            'templateOptions.disabled': function() {
              return vm.fieldDisabled();
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      if (vm.MDType === 'CPV') {
        var customTypes = {
          CPVCode: 'maskedInput',
        };
        InsertCustomTypes(vm.pageModel, customTypes);

        var inputMasks = {
          CPVCode: '99999999-9',
        };
        InsertInputMasks(vm.pageModel, inputMasks);
      }

      vm.setTenTypeFilter = function() {
        vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          Owner: vm.formModel.Owner,
          TenType: vm.formModel.TenType,
        };
        vm.formModel.Tenement = { Text: null, Value: null };
      };

      function save() {
        var messageSuccess =
          vm.operation == 'Duplicate' ? ' duplikálása sikeresen megtörtént!' : ' mentése sikeresen megtörtént!';
        var messageFailed = vm.operation == 'Duplicate' ? ' duplikálása sikertelen!' : ' mentése nem sikerült!';
        if (vm.MDType === 'Service') {
          if (vm.formModel.ServiceCode.length < 3) {
            vm.formModel.ServiceCode = vm.ServiceGroupCode + '.' + vm.formModel.ServiceCode;
          }
        }
        $http
          .post(vm.ModulType + 'MasterData/' + vm.MDType + vm.operation, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + messageSuccess); // TODO általános label

            // Unlock
            // This will spawn a modal what cannot be closed until the unlock is done
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          })
          .then(function(response) {
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + messageFailed, 'Hiba történt!'); // TODO általános label
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('MasterDataLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Masterdata: {
        url: '/master-data',
        templateUrl: 'App/MasterData/MasterDataLayout.html',
        controller: 'MasterDataLayoutCtrl as vm',
        redirectTo: 'MasterData.partner',
        ncyBreadcrumb: {
          skip: true,
          label: 'Törzsadatok',
        },
      },
      'Masterdata.Partner': {
        url: '/partner',
        params: {
          module: 'partner',
          documentEntity: 'masterdata_partner',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PartnerMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Partner/PartnerMasterData.html',
            controller: 'PartnerMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Partner törzsek',
          parent: 'Partner.PartnerNav',
        },
      },
      'Masterdata.Partner.PartnerCatList': {
        url: '/category-list',
        params: { MDType: 'PartnerCat', documentEntity: 'masterdata_partner_partnercatlist', ModulType: 'Partner' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Partner kategóriák',
        },
      },
      'Masterdata.Partner.NationalityList': {
        url: '/nationality',
        params: { MDType: 'Nationality', ModulType: 'Partner', documentEntity: 'masterdata_partner_NationalityList' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Állampolgárság',
        },
      },
      'Masterdata.Partner.CompUnitList': {
        url: '/comp-unit',
        params: { MDType: 'CompUnit', ModulType: 'Partner', documentEntity: 'masterdata_partner_compunitlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szervezeti egység',
        },
      },
      'Masterdata.Partner.RegCourtList': {
        url: '/reg-court',
        params: { MDType: 'RegCourt', ModulType: 'Partner', documentEntity: 'masterdata_partner_regcourtlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Cégbíróság',
        },
      },
      'Masterdata.Partner.ClassificationList': {
        url: '/classification',
        params: {
          MDType: 'Classification',
          ModulType: 'Partner',
          documentEntity: 'masterdata_partner_classificationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Minősítő kód',
        },
      },
      'Masterdata.Partner.StructCompList': {
        url: '/struct-comp',
        params: { MDType: 'StructComp', ModulType: 'Partner', documentEntity: 'masterdata_partner_structcomplist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Strukturált szervezet',
        },
      },
      'Masterdata.PartnerDasDocumentsNav': {
        url: '/partner/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PartnerMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.FinancialDasDocumentsNav': {
        url: '/partner/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PartnerMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.PropertyDasDocumentsNav': {
        url: '/property/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.BuildingDasDocumentsNav': {
        url: '/property/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.TenementDasDocumentsNav': {
        url: '/property/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.PremisesDasDocumentsNav': {
        url: '/property/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.EquipmentDasDocumentsNav': {
        url: '/equipment/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.SupplyContractDasDocumentsNav': {
        url: '/supplycontr/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.ContractDasDocumentsNav': {
        url: '/contract/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.BudgetDasDocumentsNav': {
        url: '/budget/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.InvoiceDasDocumentsNav': {
        url: '/invoice/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.ConstructionDasDocumentsNav': {
        url: '/construction/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.HelpDeskDasDocumentsNav': {
        url: '/helpdesk/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.UtilizationDasDocumentsNav': {
        url: '/utilization/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.ProjectDasDocumentsNav': {
        url: '/project/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdata.Partner.PostList': {
        url: '/post',
        params: { MDType: 'Post', ModulType: 'Partner', documentEntity: 'masterdata_partner_postlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beosztás',
        },
      },
      'Masterdata.Partner.LanguageList': {
        url: '/language',
        params: { MDType: 'Language', ModulType: 'Partner', documentEntity: 'masterdata_partner_languagelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Nyelv',
        },
      },
      'Masterdata.Partner.PhoneBookList': {
        url: '/phone-book',
        params: { MDType: 'PhoneBook', ModulType: 'Partner', documentEntity: 'masterdata_partner_phonebooklist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Telefonkönyv',
        },
      },
      'Masterdata.Financial': {
        url: '/financial',
        params: {
          module: 'financial',
          documentEntity: 'masterdata_financial',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PartnerMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Financial/FinancialMasterData.html',
            controller: 'FinancialMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi törzsek',
          parent: 'Partner.PartnerNav',
        },
      },
      'Masterdata.PartnerHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PartnerMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PartnerMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.PropertyHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PropertyMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.TenementHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('TenementMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.PremisesHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PremisesMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.SupplyContractHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('SupplyContractMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.ContractHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('ContractMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.ConstructionHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('ConstructionMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.ProjectHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('ProjectMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDeskHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Financial.BankList': {
        url: '/bank',
        params: { MDType: 'Bank', ModulType: 'Partner', documentEntity: 'masterdata_financial_banklist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzintézet',
        },
      },
      'Masterdata.Financial.CurrencyList': {
        url: '/currency',
        params: { MDType: 'Currency', ModulType: 'Partner', documentEntity: 'masterdata_financial_currencylist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Devizanem',
        },
      },
      'Masterdata.Financial.FinancialItemList': {
        url: '/financialItem',
        params: {
          MDType: 'FinancialItem',
          ModulType: 'Partner',
          documentEntity: 'masterdata_financial_financialitemlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi jogcímek',
        },
      },
      'Masterdata.Financial.PaymentList': {
        url: '/payment',
        params: { MDType: 'Payment', ModulType: 'Partner', documentEntity: 'masterdata_financial_paymentlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Fizetési mód',
        },
      },
      'Masterdata.Financial.VatCodeList': {
        url: '/vatCode',
        params: { MDType: 'VatCode', ModulType: 'Partner', documentEntity: 'masterdata_financial_vatcodelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'ÁFA kódok',
        },
      },
      'Masterdata.Financial.RepeatList': {
        url: '/repeat',
        params: { MDType: 'Repeat', ModulType: 'Partner', documentEntity: 'masterdata_financial_repeatlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlázási ciklus',
        },
      },
      'Masterdata.Financial.CurrencyExchangeList': {
        url: '/currencyExchange',
        params: {
          MDType: 'CurrencyExchange',
          ModulType: 'Partner',
          documentEntity: 'masterdata_financial_exchangelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Devizanem árfolyam',
        },
      },
      'Masterdata.Financial.FinancialYearList': {
        url: '/financialYear',
        params: {
          MDType: 'FinancialYear',
          ModulType: 'Partner',
          documentEntity: 'masterdata_financial_financialyearlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi évek',
        },
      },
      'Masterdata.Financial.PeriodList': {
        url: '/period',
        params: { MDType: 'Period', ModulType: 'Partner', documentEntity: 'masterdata_financial_periodlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlázási hónapok',
        },
      },
      'Masterdata.Financial.AnalyticCodeList': {
        url: '/analyticCode',
        params: {
          MDType: 'AnalyticCode',
          ModulType: 'Partner',
          documentEntity: 'masterdata_financial_analyticcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Analitikus kódok',
        },
      },
      'Masterdata.Financial.ProjectList': {
        url: '/project',
        params: { MDType: 'Project', ModulType: 'Partner', documentEntity: 'masterdata_financial_projectlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ügylet kódok',
        },
      },
      'Masterdata.HelpDesk.TicketTemplateList': {
        url: '/tickettemplate',
        params: { MDType: 'TicketTemplate', ModulType: 'HelpDesk' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Munkalap sablonok',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.Utilization': {
        url: '/utilization',
        params: { module: 'utilization', documentEntity: 'utilization_masterdatanav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterData.html',
            controller: 'UtilizationMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Törzsek',
          parent: 'Utilization',
        },
      },
      'Masterdata.Financial.InvoicePadList': {
        url: '/invoicepad',
        params: { MDType: 'InvoicePad', ModulType: 'Partner', documentEntity: 'masterdata_financial_invoicepadlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlatömbök',
        },
      },
      'Masterdata.Property': {
        url: '/property',
        params: {
          module: 'property',
          documentEntity: 'masterdatamodule_property',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Property/PropertyMasterData.html',
            controller: 'PropertyMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Objektum és ingatlan törzsek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.AreaMultiplierList': {
        url: '/areaMultiplier',
        params: { MDType: 'AreaMultiplier', ModulType: 'Property' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Területi szorzó',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.AssetList': {
        url: '/asset',
        params: { MDType: 'Asset', ModulType: 'Property', documentEntity: 'masterdatamodule_property_assetlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Vagyonjellegek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.CadastralTypeList': {
        url: '/cadastralType',
        params: {
          MDType: 'CadastralType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_cadastraltypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kataszteri típusok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.ImmovableList': {
        url: '/immovable',
        params: {
          MDType: 'Immovable',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_immovablelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Objektum jellege',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.LocalityList': {
        url: '/locality',
        params: { MDType: 'Locality', ModulType: 'Property', documentEntity: 'masterdatamodule_property_localitylist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan fekvése',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.MannerOfPropertyList': {
        url: '/mannerOfProperty',
        params: {
          MDType: 'MannerOfProperty',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_mannerofpropertylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdonba kerülés módja',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.NatConservationList': {
        url: '/natConservation',
        params: {
          MDType: 'NatConservation',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_natconservationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Védettség',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.NegotiabilityList': {
        url: '/negotiability',
        params: {
          MDType: 'Negotiability',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_negotiabilitylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Forgalomképesség',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.OpUnitList': {
        url: '/opUnit',
        params: { MDType: 'OpUnit', ModulType: 'Property', documentEntity: 'masterdatamodule_property_opunitlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Üzemeltetési egység',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.OwnerList': {
        url: '/owner',
        params: { MDType: 'Owner', ModulType: 'Property', documentEntity: 'masterdatamodule_property_ownerlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdon típusok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.OwnershipList': {
        url: '/ownership',
        params: {
          MDType: 'Ownership',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_ownershiplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdonjogok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.ResponsibleTypeList': {
        url: '/responsibleType',
        params: {
          MDType: 'ResponsibleType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_responsibletypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felelős típusok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.ZoneList': {
        url: '/zone',
        params: { MDType: 'Zone', ModulType: 'Property', documentEntity: 'masterdatamodule_property_zonelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Területi egység',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.FunctionOfLandList': {
        url: '/functionOfLand',
        params: {
          MDType: 'FunctionOfLand',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_functionoflandlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Földrészlet rendeltetése',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.LandUseList': {
        url: '/landUse',
        params: { MDType: 'LandUse', ModulType: 'Property', documentEntity: 'masterdatamodule_property_landuselist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Művelési ág',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.OutOfCultivationList': {
        url: '/outOfCultivation',
        params: {
          MDType: 'OutOfCultivation',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_outofcultivationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Művelés alól kivett terület jellege',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.BuildingPlotKindList': {
        url: '/buildingPlotKind',
        params: {
          MDType: 'BuildingPlotKind',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_buildingplotkindlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Földrészlet jellege',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.InbuiltPlotList': {
        url: '/inbuiltPlot',
        params: {
          MDType: 'InbuiltPlot',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_inbuiltplotlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beépítettség',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.MannerOfBuildInList': {
        url: '/mannerOfBuildIn',
        params: {
          MDType: 'MannerOfBuildIn',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_mannerofbuildinlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beépítési mód',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.ElectricityList': {
        url: '/electricity',
        params: {
          MDType: 'Electricity',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_electricitylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Villany ellátás',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.DrinkingWaterList': {
        url: '/drinkingWater',
        params: {
          MDType: 'DrinkingWater',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_drinkingwaterlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ivóvíz ellátás',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.SewageDisposalList': {
        url: '/sewageDisposal',
        params: {
          MDType: 'SewageDisposal',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_sewagedisposallist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szennyvíz elvezetés',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.RainDrainageList': {
        url: '/rainDrainage',
        params: {
          MDType: 'RainDrainage',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_raindrainagelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Csapadékvíz elvezetés',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.FireWaterNavList': {
        url: '/fireWaterNav',
        params: {
          MDType: 'FireWaterNav',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_firewaternavlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tűzivíz elvezetés',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.GasSupplyList': {
        url: '/gasSupply',
        params: {
          MDType: 'GasSupply',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_gassupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Gáz ellátás',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.FunctionOfEdificeList': {
        url: '/functionOfEdifice',
        params: {
          MDType: 'FunctionOfEdifice',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_functionofedificelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Építmény rendeltetése',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.EnergeticsList': {
        url: '/energetics',
        params: {
          MDType: 'Energetics',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_energeticslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Energetikai besorolások',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.TypeList': {
        url: '/type',
        params: {
          MDType: 'PropertyType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_typelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan főtípus',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.SubTypeList': {
        url: '/subtype',
        params: {
          MDType: 'PropertySubType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_subtypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan altípus',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.CountryList': {
        url: '/country',
        params: { MDType: 'Country', ModulType: 'Property', documentEntity: 'masterdata_property_countrylist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ország',
        },
      },
      'Masterdata.Property.StreetCharList': {
        url: '/streetchar',
        params: { MDType: 'StreetChar', ModulType: 'Property', documentEntity: 'masterdata_property_streetcharlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Közterület jellege',
        },
      },
      'Masterdata.Property.RegionList': {
        url: '/region',
        params: { MDType: 'Region', ModulType: 'Property', documentEntity: 'masterdata_property_regionlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Megye',
        },
      },
      'Masterdata.Property.FloorList': {
        url: '/floor',
        params: { MDType: 'Floor', ModulType: 'Property', documentEntity: 'masterdata_property_floorlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Emelet',
        },
      },
      'Masterdata.Property.PostCodeList': {
        url: '/post-code',
        params: { MDType: 'PostCode', ModulType: 'Property', documentEntity: 'masterdata_property_postcodelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Irányítószám',
        },
      },
      'Masterdata.Building': {
        url: '/building',
        params: {
          module: 'building',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Property/PropertyMasterData.html',
            controller: 'BuildingMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Épület törzsek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.DiffUsageList': {
        url: '/diffusage',
        params: {
          MDType: 'DiffUsage',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_diffusagelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Rendeltetéstől eltérő használat',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.StateList': {
        url: '/state',
        params: { MDType: 'State', ModulType: 'Property', documentEntity: 'masterdatamodule_property_statelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Állapot',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.AtticInbuiltList': {
        url: '/atticinbuilt',
        params: {
          MDType: 'AtticInbuilt',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_atticinbuiltlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tetőtéri beépítettség',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.OtherSupplyList': {
        url: '/othersupply',
        params: {
          MDType: 'OtherSupply',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_othersupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Egyéb ellátottság',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Property.GarbageCanList': {
        url: '/garbagecan',
        params: {
          MDType: 'GarbageCan',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_garbagecanlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Hulladéktárolás',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement': {
        url: '/tenement',
        params: {
          module: 'tenement',
          documentEntity: 'masterdatamodule_tenement',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Tenement/TenementMasterData.html',
            controller: 'TenementMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérlemény törzsek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.NotRentableList': {
        url: '/notRentable',
        params: {
          MDType: 'NotRentable',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_notrentablelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérelhetetlenség okok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.ServiceBuiltUpList': {
        url: '/serviceBuiltUp',
        params: {
          MDType: 'ServiceBuiltUp',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_servicebuiltuplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kiépített szolgáltatások',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.PublicUtilitySupplyList': {
        url: '/publicUtilitySupply',
        params: {
          MDType: 'PublicUtilitySupply',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_publicutilitysupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Közmű ellátás',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.HeatingMannerList': {
        url: '/heatingManner',
        params: {
          MDType: 'HeatingManner',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_heatingmannerlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Fűtési módok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.SurfaceKindList': {
        url: '/surfaceKind',
        params: {
          MDType: 'SurfaceKind',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_surfacekindlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felületfajták',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.SurfaceConditionList': {
        url: '/surfacecondition',
        params: {
          MDType: 'SurfaceCondition',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_surfaceconditionlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felület állapota',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.SurfaceList': {
        url: '/surface',
        params: { MDType: 'Surface', ModulType: 'Premises', documentEntity: 'masterdatamodule_premises_surfacelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felületek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.CookingRoomList': {
        url: '/cookingRoom',
        params: {
          MDType: 'CookingRoom',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_cookingroomlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Főzőhelyiség fajták',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.LegalOrderList': {
        url: '/legalOrder',
        params: {
          MDType: 'LegalOrder',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_legalorderlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Jogi rendezettségek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.ComfortLevelList': {
        url: '/comfortLevel',
        params: {
          MDType: 'ComfortLevel',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_comfortlevellist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Lakás komfortfokozatok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.ReasonOfChequeList': {
        url: '/reasonofcheque',
        params: {
          MDType: 'ReasonOfCheque',
          ModulType: 'Tenement',
          documentEntity: 'masterdatamodule_tenement_reasonofchequelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ellenőrzés oka',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Tenement.WaterChargePayList': {
        url: '/waterChargePay',
        params: {
          MDType: 'WaterChargePay',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_waterchargepaylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Vízdíj fizetés módja',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises': {
        url: '/premises',
        params: {
          module: 'premises',
          documentEntity: 'masterdatamodule_premises',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Premises/PremisesMasterData.html',
            controller: 'PremisesMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiség törzsek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.PremiseFunctionList': {
        url: '/premiseFunction',
        params: {
          MDType: 'PremiseFunction',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_premisefunctionlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiség funkciók',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.PremiseNameList': {
        url: '/premiseFunction',
        params: {
          MDType: 'PremiseName',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_premisenamelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiségnevek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.HotWaterSupplyList': {
        url: '/hotWaterSupply',
        params: {
          MDType: 'HotWaterSupply',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_hotwatersupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Melegvízellátás módja',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.EqualMultiplierList': {
        url: '/equalmultiplier',
        params: {
          MDType: 'EqualMultiplier',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_equalmultiplierlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiség egyenértékű szorzók',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Premises.InvTypeList': {
        url: '/invtype',
        params: { MDType: 'InvType', ModulType: 'Premises', documentEntity: 'masterdatamodule_premises_invtypelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiségleltár típusok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Equipment': {
        url: '/equipment',
        params: {
          module: 'equipment',
          documentEntity: 'equipment_equipmentnav',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PropertyMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Equipment/EquipmentMasterData.html',
            controller: 'EquipmentMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezések',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Equipment.EquipmentList': {
        url: '/equipment',
        params: { MDType: 'Equipment', ModulType: 'Equipment', documentEntity: 'equipment_equipmentnav' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezések',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Equipment.EquipmentGroupList': {
        url: '/equipmentgroup',
        params: { MDType: 'EquipmentGroup', ModulType: 'Equipment', documentEntity: 'equipment_equipmentgroupnav' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés csoportok',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Equipment.EquipmentQualityList': {
        url: '/equipmentquality',
        params: { MDType: 'EquipmentQuality', ModulType: 'Equipment', documentEntity: 'equipment_equipmentqualitynav' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés minősítések',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.Equipment.EquipmentSystemList': {
        url: '/equipmentsystem',
        params: { MDType: 'EquipmentSystem', ModulType: 'Equipment', documentEntity: 'equipment_equipmentsystemnav' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés rendszerek',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdata.SupplyContract': {
        url: '/supplycontract',
        params: {
          module: 'supplycontract',
          documentEntity: 'masterdatamodule_supplycontract',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/SupplyContract/SupplyContractMasterData.html',
            controller: 'SupplyContractMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés törzsek',
          parent: 'SupplyContract.SupplyContractNav',
        },
      },
      'Masterdata.SupplyContract.ContractTypeList': {
        url: '/contracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'SupplyContract',
          documentEntity: 'masterdatamodule_supplycontract_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
          parent: 'SupplyContract.SupplyContractNav',
        },
      },
      'Masterdata.SupplyContract.CPVList': {
        url: '/cpv',
        params: {
          MDType: 'CPV',
          ModulType: 'SupplyContract',
          documentEntity: 'masterdatamodule_supplycontract_cpvlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'CPV kódok',
          parent: 'SupplyContract.SupplyContractNav',
        },
      },
      'Masterdata.SupplyContract.SupplyContrStatusTypeList': {
        url: '/supplycontrstatustype',
        params: {
          MDType: 'SupplyContrStatusType',
          ModulType: 'SupplyContract',
          documentEntity: 'masterdatamodule_supplycontract_supplycontrstatustypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés státusz típusok',
          parent: 'SupplyContract.SupplyContractNav',
        },
      },
      'Masterdata.SupplyContract.SpecializationList': {
        url: '/specialization',
        params: {
          MDType: 'SCSpecialization',
          ModulType: 'SupplyContract',
          documentEntity: 'masterdatamodule_supplycontract_specializationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterület',
          parent: 'SupplyContract.SupplyContractNav',
        },
      },
      'Masterdata.Contract': {
        url: '/contract',
        params: {
          module: 'contract',
          documentEntity: 'masterdata_contract',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Contract/ContractMasterData.html',
            controller: 'ContractMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti szerződés törzsek',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.ContractTypeList': {
        url: '/contracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'Contract',
          documentEntity: 'masterdata_contract_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.ContractCodeList': {
        url: '/contractcode',
        params: {
          MDType: 'ContractCode',
          ModulType: 'Contract',
          documentEntity: 'masterdatamodule_contract_contractcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés kódok',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.InformationList': {
        url: '/information',
        params: { MDType: 'Information', ModulType: 'Contract', documentEntity: 'contract_gridcontrinformationedit' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ügyviteli információk',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.ServiceAssignmentList': {
        url: '/serviceassignment',
        params: {
          MDType: 'ServiceAssignment',
          ModulType: 'Contract',
          documentEntity: 'contract_serviceassignmentedit',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti és használati díjak összerendelése',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.AreaRentalList': {
        url: '/arearental',
        params: { MDType: 'AreaRental', ModulType: 'Contract', documentEntity: 'masterdata_contract_arearentallist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helybérlés típusok',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.ConditionalList': {
        url: '/conditional',
        params: { MDType: 'Conditional', ModulType: 'Contract', documentEntity: 'masterdata_contract_conditionallist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződést megszüntető feltételek',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.DepositList': {
        url: '/deposit',
        params: { MDType: 'Deposit', ModulType: 'Contract', documentEntity: 'masterdata_contract_depositlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Óvadék típusok',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.RelationshipList': {
        url: '/relationship',
        params: {
          MDType: 'Relationship',
          ModulType: 'Contract',
          documentEntity: 'masterdata_contract_relationshiplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Családi viszonyok',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.RentIndexationList': {
        url: '/rentindexation',
        params: {
          MDType: 'RentIndexation',
          ModulType: 'Contract',
          documentEntity: 'masterdata_contract_rentindexationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj indexálás módja',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.TerminateReasonList': {
        url: '/terminatereason',
        params: {
          MDType: 'TerminateReason',
          ModulType: 'Contract',
          documentEntity: 'masterdata_contract_terminatereasonlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Megszűnés okai',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.TitleTypeList': {
        url: '/titletype',
        params: { MDType: 'TitleType', ModulType: 'Contract', documentEntity: 'masterdata_contract_titletypelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Jogcím típusa',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Contract.UsageFeeList': {
        url: '/usagefee',
        params: {
          MDType: 'UsageFee',
          ModulType: 'Contract',
          secondMDType: 'UsageFeeMultiplier',
          documentEntity: 'masterdata_contract_usagefeelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Contract/ContractMasterDataView.html',
            controller: 'ContractMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Használati díjak számításának módja',
          parent: 'Contract.ContractNav',
        },
      },
      'Masterdata.Budget': {
        url: '/budget',
        params: {
          module: 'budget',
          documentEntity: 'masterdata_budget',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterData.html',
            controller: 'BudgetMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetList': {
        url: '/budget',
        params: { MDType: 'Budget', ModulType: 'Budget', documentEntity: 'masterdata_budget' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetItemList': {
        url: '/budgetitem',
        params: { MDType: 'BudgetItem', ModulType: 'Budget' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés tételek',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetTypeList': {
        url: '/budgettype',
        params: { MDType: 'BudgetType', ModulType: 'Budget' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés típusok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.AllocationList': {
        url: '/allocation',
        params: { MDType: 'Allocation', ModulType: 'Budget', documentEntity: 'masterdata_budget_allocationlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felosztás alapjai',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.CalcTypeServiceList': {
        url: '/calctypeservice',
        params: {
          MDType: 'CalcTypeService',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_calctypeservicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kalkulációs módok díjtételei',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudJobNumberList': {
        url: '/budjobnumber',
        params: { MDType: 'BudJobNumber', ModulType: 'Budget', documentEntity: 'masterdata_budget_budjobnumberlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Munkaszámok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetDateList': {
        url: '/budgetdate',
        params: { MDType: 'BudgetDate', ModulType: 'Budget', documentEntity: 'masterdata_budget_budgetdatelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés dátumok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudSubGroupList': {
        url: '/budsubgroup',
        params: { MDType: 'BudSubGroup', ModulType: 'Budget', documentEntity: 'masterdata_budget_budsubgrouplist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Alcsoportok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.CityCodeList': {
        url: '/citycode',
        params: { MDType: 'CityCode', ModulType: 'Budget', documentEntity: 'masterdata_budget_citycodelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Város közigazgatási kódok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.RatePlanList': {
        url: '/rateplan',
        params: { MDType: 'RatePlan', ModulType: 'Budget', documentEntity: 'masterdata_budget_rateplanlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Éves tervárfolyamok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.CostCenterList': {
        url: '/costcenter',
        params: { MDType: 'CostCenter', ModulType: 'Budget', documentEntity: 'masterdata_budget_costcenterlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költséghely kódok',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.CondominiumUnitList': {
        url: '/CondominiumUnit',
        params: {
          MDType: 'CondominiumUnit',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_condominiumunitlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Társasházi mennyiségi egységek',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetCorrectiveServiceList': {
        url: '/BudgetCorrectiveService',
        params: {
          MDType: 'BudgetCorrectiveService',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_BudgetCorrectiveServicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Díjgenerálás korrekciós díjtételei',
        },
      },
      'Masterdata.Budget.BudgetPlanServiceModList': {
        url: '/BudgetPlanServiceMod',
        params: {
          MDType: 'BudgetPlanServiceMod',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_BudgetPlanServiceModlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Díjgenerálás korrekciós díjtételei',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.Budget.BudgetPlanServiceModList': {
        url: '/BudgetPlanServiceMod',
        params: {
          MDType: 'BudgetPlanServiceMod',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_BudgetPlanServiceModList',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleményre osztott díjak módosítása',
          parent: 'Budget.Budget.BudgetNav',
        },
      },
      'Masterdata.BudgetHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('BudgetMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Invoice': {
        url: '/invoice',
        params: {
          module: 'invoice',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Invoice/InvoiceMasterData.html',
            controller: 'InvoiceMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('InvoiceMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlaiktatás törzsadatok',
          parent: 'Invoice.InvoiceNav',
        },
      },
      'Masterdata.Construction': {
        url: '/construction',
        params: {
          module: 'construction',
          documentEntity: 'masterdatamodule_construction',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Construction/ConstructionMasterData.html',
            controller: 'ConstructionMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezet törzsadatok',
          parent: 'main',
        },
      },
      'Masterdata.Construction.ConstructionClassifyList': {
        url: '/constructionclassify',
        params: {
          MDType: 'ConstructionClassify',
          ModulType: 'Construction',
          documentEntity: 'masterdatamodule_construction_constructionclassifylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti besorolások',
          parent: 'Masterdata.Construction',
        },
      },
      'Masterdata.Construction.ConstructionElementList': {
        url: '/constructionelement',
        params: {
          MDType: 'ConstructionElement',
          ModulType: 'Construction',
          documentEntity: 'masterdatamodule_construction_constructionelementlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti Elemek',
          parent: 'Masterdata.Construction',
        },
      },
      'Masterdata.Construction.ConstructionGroupList': {
        url: '/constructiongroup',
        params: {
          MDType: 'ConstructionGroup',
          ModulType: 'Construction',
          documentEntity: 'masterdatamodule_construction_constructiongrouplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti Elemcsoportok',
          parent: 'Masterdata.Construction',
        },
      },
      'Masterdata.HelpDesk': {
        url: '/helpdesk',
        params: {
          module: 'helpdesk',
          documentEntity: 'masterdatamodule_helpdesk',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/HelpDesk/HelpDeskMasterData.html',
            controller: 'HelpDeskMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helpdesk törzsadatok',
          parent: 'main',
        },
      },
      'Masterdata.HelpDesk.HelpDeskPriorityList': {
        url: '/helpdeskpriority',
        params: {
          MDType: 'HelpDeskPriority',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdata_helpdesk_helpdeskprioritylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Prioritások',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.HelpDeskPriorityHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.ServiceLevelList': {
        url: '/helpdeskservicelevel',
        params: {
          MDType: 'ServiceLevel',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdata_helpdesk_servicelevellist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szolgáltatási szintek',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.ServiceLevelHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.HelpDeskStatusList': {
        url: '/helpdeskstatus',
        params: {
          MDType: 'HelpDeskStatus',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdata_helpdesk_helpdeskstatuslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Státuszok',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.HelpDeskStatusHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.TicketTypeList': {
        url: '/helpdesktickettype',
        params: {
          MDType: 'TicketType',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdata_helpdesk_tickettypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bejelentés típusok',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.TicketTypeHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.SpecializationList': {
        url: '/helpdeskspecialization',
        params: {
          MDType: 'HDSpecialization',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdata_helpdesk_specializationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterületek',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.SpecializationHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.Specialization': {
        url: '/helpdeskspecialization',
        params: {
          MDType: 'HDSpecialization',
          ModulType: 'HelpDesk',
          documentEntity: 'masterdatamodule_helpdesk_specializationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakértelmek',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.HelpDesk.RoleList': {
        url: '/helpdeskrole',
        params: { MDType: 'HelpDeskRole', ModulType: 'HelpDesk' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerepkörök',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.HelpDeskRoleHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.LedgerCodeList': {
        url: '/helpdeskledgercode',
        params: { MDType: 'LedgerCode', ModulType: 'HelpDesk' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Általános pénzügyi dimenziók',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdata.LedgerCodeHistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Utilization': {
        url: '/utilization',
        params: { module: 'utilization', documentEntity: 'utilization_masterdatanav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterData.html',
            controller: 'UtilizationMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Törzsek',
          parent: 'Utilization',
        },
      },

      'Masterdata.Utilization.RentStatusList': {
        url: '/rentstatus',
        params: {
          MDType: 'RentStatus',
          ModulType: 'Utilization',
          documentEntity: 'masterdata_utilization_rentstatuslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Státuszok',
        },
      },
      'Masterdata.Utilization.RateServiceList': {
        url: '/rateservice',
        params: {
          MDType: 'ServiceGroup',
          ModulType: 'Utilization',
          secondMDType: 'Service',
          documentEntity: 'masterdata_utilization_rateservicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szolgáltatások',
        },
      },
      'Masterdata.Utilization.RateServiceUnitPriceList': {
        url: '/pricelist',
        params: {
          MDType: 'PriceList',
          ModulType: 'Utilization',
          secondMDType: 'PriceListRow',
          documentEntity: 'masterdata_utilization_rateserviceunitpricelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Árlisták',
        },
      },
      'Masterdata.Utilization.PriceTypeList': {
        url: '/pricetype',
        params: {
          MDType: 'UtilizationPriceType',
          ModulType: 'Utilization',
          documentEntity: 'masterdata_utilization_pricetypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ártípusok',
        },
      },
      'Masterdata.Utilization.RentLocationList': {
        url: '/rentlocation',
        params: {
          MDType: 'RentLocation',
          ModulType: 'Utilization',
          documentEntity: 'masterdata_utilization_rentlocationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyszínek',
        },
      },
      'Masterdata.Utilization.ContractTypeList': {
        url: '/rentcontracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'Utilization',
          documentEntity: 'masterdata_utilization_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
        },
      },
      'Masterdata.Utilization.ReservationReasonList': {
        url: '/reservationreason',
        params: {
          MDType: 'ReservationReason',
          ModulType: 'Utilization',
          documentEntity: 'masterdata_utilization_reservationreasonlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Igénylés oka',
        },
      },
      'Masterdata.Project': {
        url: '/project',
        params: {
          module: 'project',
          documentEntity: 'masterdata_project',
          formMode: 'Torzs',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectMasterData.html',
            controller: 'ProjectMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekt törzsek',
          parent: 'Project.ProjectNav',
        },
      },
      'Masterdata.Project.ProjectFinancingList': {
        url: '/projectfinancing',
        params: { MDType: 'Financing', ModulType: 'Project', documentEntity: 'masterdata_project_financing' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekt finanszírozás',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Project.ProjectInvoiceTypeList': {
        url: '/projectinvoice',
        params: { MDType: 'InvoiceType', ModulType: 'Project', documentEntity: 'masterdata_project_invoicetype' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlafajták',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Project.ProjectPriorityList': {
        url: '/projectpriority',
        params: { MDType: 'Priority', ModulType: 'Project', documentEntity: 'masterdata_project_priority' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Prioritás',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Project.SpecializationList': {
        url: '/projectspecialization',
        params: { MDType: 'Specialization', ModulType: 'Project', documentEntity: 'masterdata_project_specialization' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterületek',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Project.ProjectStatusList': {
        url: '/projectstatus',
        params: {
          MDType: 'ProjectStatusMain',
          ModulType: 'Project',
          documentEntity: 'masterdata_project_projectstatusmain',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projektstátuszok',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Project.ProjectTypeList': {
        url: '/projecttype',
        params: { MDType: 'ProjectType', ModulType: 'Project' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ProjectMasterDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekttípusok',
          parent: 'Masterdata.Project',
        },
      },
      'Masterdata.Partner.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PartnerMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Financial.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PartnerMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Property.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PropertyMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Tenement.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('TenementMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Premises.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('PremisesMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.SupplyContract.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('SupplyContractMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Contract.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('ContractMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.Construction.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('ConstructionMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Masterdata.HelpDesk.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          masterData: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('HelpDeskMasterData/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Masterdatamodule: {
        url: '/master-data-module',
        templateUrl: 'App/MasterData/MasterDataLayout.html',
        controller: 'MasterDataModuleMenuCtrl as vm',
        redirectTo: 'Masterdatamodule.AllMasterData',
        ncyBreadcrumb: {
          label: 'Törzsek modul',
          parent: 'main',
        },
      },
      'Masterdatamodule.PartnerDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.FinancialDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.PropertyDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.BuildingDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.TenementDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.PremisesDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.EquipmentDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.SupplyContractDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.ContractDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.BudgetDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.InvoiceDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.ConstructionDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.HelpDeskDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.UtilizationDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.Utilization': {
        url: '/utilization',
        params: { module: 'masterdataUtilization', documentEntity: 'utilization_masterdatanav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterData.html',
            controller: 'UtilizationMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Hasznosítás Törzsek',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Utilization.RentStatusList': {
        url: '/rentstatus',
        params: {
          MDType: 'RentStatus',
          ModulType: 'Utilization',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_rentstatuslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Státuszok',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.RateServiceList': {
        url: '/rateservice',
        params: {
          MDType: 'ServiceGroup',
          ModulType: 'Utilization',
          secondMDType: 'Service',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_rateservicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szolgáltatások',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.RateServiceUnitPriceList': {
        url: '/pricelist',
        params: {
          MDType: 'PriceList',
          ModulType: 'Utilization',
          secondMDType: 'PriceListRow',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_rateserviceunitpricelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Árlisták',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.PriceTypeList': {
        url: '/pricetype',
        params: {
          MDType: 'UtilizationPriceType',
          ModulType: 'Utilization',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_pricetypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ártípusok',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.RentLocationList': {
        url: '/rentlocation',
        params: {
          MDType: 'RentLocation',
          ModulType: 'Utilization',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_rentlocationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyszínek',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.ContractTypeList': {
        url: '/rentcontracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'Utilization',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Utilization.ReservationReasonList': {
        url: '/reservationreason',
        params: {
          MDType: 'ReservationReason',
          ModulType: 'Utilization',
          backTo: 'main',
          documentEntity: 'masterdata_utilization_reservationreasonlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Igénylés oka',
          parent: 'Masterdatamodule.Utilization',
        },
      },
      'Masterdatamodule.Project': {
        url: '/project',
        params: { module: 'masterdataProject', documentEntity: 'masterdata_project' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectMasterData.html',
            controller: 'ProjectMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekt törzsek',
          parent: 'Masterdatamodule',
        },
      },

      'Masterdatamodule.Project.ProjectPriorityList': {
        url: '/projectpriority',
        params: {
          MDType: 'Priority',
          ModulType: 'Project',
          backTo: 'main',
          documentEntity: 'masterdata_project_priority',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Prioritás',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.Project.ProjectFinancingList': {
        url: '/projectfinancing',
        params: {
          MDType: 'Financing',
          ModulType: 'Project',
          backTo: 'main',
          documentEntity: 'masterdata_project_financing',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekt finanszírozás',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.Project.ProjectInvoiceTypeList': {
        url: '/projectinvoice',
        params: {
          MDType: 'InvoiceType',
          ModulType: 'Project',
          backTo: 'main',
          documentEntity: 'masterdata_project_invoicetype',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlafajták',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.Project.SpecializationList': {
        url: '/projectspecialization',
        params: {
          MDType: 'Specialization',
          ModulType: 'Project',
          backTo: 'main',
          documentEntity: 'masterdata_project_specialization',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterületek',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.Project.ProjectStatusList': {
        url: '/projectstatus',
        params: {
          MDType: 'ProjectStatusMain',
          ModulType: 'Project',
          backTo: 'main',
          documentEntity: 'masterdata_project_projectstatusmain',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projektstátuszok',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.Project.ProjectTypeList': {
        url: '/projecttype',
        params: { MDType: 'ProjectType', ModulType: 'Project', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ProjectMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Projekttípusok',
          parent: 'Masterdatamodule.Project',
        },
      },
      'Masterdatamodule.ProjectDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Masterdatamodule.Partner': {
        url: '/partner',
        params: { module: 'masterdataPartner', documentEntity: 'masterdata_partner' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Partner/PartnerMasterData.html',
            controller: 'PartnerMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Partner törzsek',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Partner.PartnerCatList': {
        url: '/category-list',
        params: {
          MDType: 'PartnerCat',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_partnercatlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Partner kategóriák',
        },
      },
      'Masterdatamodule.Partner.NationalityList': {
        url: '/nationality',
        params: {
          MDType: 'Nationality',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_NationalityList',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Állampolgárság',
        },
      },
      'Masterdatamodule.Partner.CompUnitList': {
        url: '/comp-unit',
        params: {
          MDType: 'CompUnit',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_compunitlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szervezeti egység',
        },
      },
      'Masterdatamodule.Partner.RegCourtList': {
        url: '/reg-court',
        params: {
          MDType: 'RegCourt',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_regcourtlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Cégbíróság',
        },
      },
      'Masterdatamodule.Partner.ClassificationList': {
        url: '/classification',
        params: {
          MDType: 'Classification',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_classificationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Minősítő kód',
        },
      },
      'Masterdatamodule.Partner.StructCompList': {
        url: '/struct-comp',
        params: {
          MDType: 'StructComp',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_structcomplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Strukturált szervezet',
        },
      },
      'Masterdatamodule.Partner.PostList': {
        url: '/post',
        params: { MDType: 'Post', ModulType: 'Partner', backTo: 'main', documentEntity: 'masterdata_partner_postlist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beosztás',
        },
      },
      'Masterdatamodule.Partner.LanguageList': {
        url: '/language',
        params: {
          MDType: 'Language',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_languagelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Nyelv',
        },
      },
      'Masterdatamodule.Partner.PhoneBookList': {
        url: '/phone-book',
        params: {
          MDType: 'PhoneBook',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_partner_phonebooklist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Telefonkönyv',
        },
      },
      'Masterdatamodule.Financial': {
        url: '/financial',
        params: { module: 'masterdataFinancial', documentEntity: 'masterdata_financial' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Financial/FinancialMasterData.html',
            controller: 'FinancialMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi törzsek',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Financial.BankList': {
        url: '/bank',
        params: {
          MDType: 'Bank',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_banklist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzintézet',
        },
      },
      'Masterdatamodule.Financial.CurrencyList': {
        url: '/currency',
        params: {
          MDType: 'Currency',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_currencylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Devizanem',
        },
      },
      'Masterdatamodule.Financial.FinancialItemList': {
        url: '/financialItem',
        params: {
          MDType: 'FinancialItem',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_financialitemlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi jogcímek',
        },
      },
      'Masterdatamodule.Financial.PaymentList': {
        url: '/payment',
        params: {
          MDType: 'Payment',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_paymentlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Fizetési mód',
        },
      },
      'Masterdatamodule.Financial.VatCodeList': {
        url: '/vatCode',
        params: {
          MDType: 'VatCode',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_vatcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'ÁFA kódok',
        },
      },
      'Masterdatamodule.Financial.RepeatList': {
        url: '/repeat',
        params: {
          MDType: 'Repeat',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_repeatlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlázási ciklus',
        },
      },
      'Masterdatamodule.Financial.CurrencyExchangeList': {
        url: '/currencyExchange',
        params: {
          MDType: 'CurrencyExchange',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_exchangelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Devizanem árfolyam',
        },
      },
      'Masterdatamodule.Financial.FinancialYearList': {
        url: '/financialYear',
        params: {
          MDType: 'FinancialYear',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_financialyearlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Pénzügyi évek',
        },
      },
      'Masterdatamodule.Financial.PeriodList': {
        url: '/period',
        params: {
          MDType: 'Period',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_periodlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlázási hónapok',
        },
      },
      'Masterdatamodule.Financial.AnalyticCodeList': {
        url: '/analyticCode',
        params: {
          MDType: 'AnalyticCode',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_analyticcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Analitikus kódok',
        },
      },
      'Masterdatamodule.Financial.ProjectList': {
        url: '/project',
        params: {
          MDType: 'Project',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_projectlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ügylet kódok',
        },
      },
      'Masterdatamodule.Financial.InvoicePadList': {
        url: '/invoicepad',
        params: {
          MDType: 'InvoicePad',
          ModulType: 'Partner',
          backTo: 'main',
          documentEntity: 'masterdata_financial_invoicepadlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PartnerMasterData/FinancialListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlatömbök',
        },
      },
      'Masterdatamodule.Property': {
        url: '/property',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_property' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Property/PropertyMasterData.html',
            controller: 'PropertyMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan törzsadatok',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Property.AreaMultiplierList': {
        url: '/areaMultiplier',
        params: { MDType: 'AreaMultiplier', ModulType: 'Property', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Területi szorzó',
        },
      },
      'Masterdatamodule.Property.AssetList': {
        url: '/asset',
        params: {
          MDType: 'Asset',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_assetlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Vagyonjellegek',
        },
      },
      'Masterdatamodule.Property.CadastralTypeList': {
        url: '/cadastralType',
        params: {
          MDType: 'CadastralType',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_cadastraltypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kataszteri típusok',
        },
      },
      'Masterdatamodule.Property.ImmovableList': {
        url: '/immovable',
        params: {
          MDType: 'Immovable',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_immovablelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Objektum jellege',
        },
      },
      'Masterdatamodule.Property.LocalityList': {
        url: '/locality',
        params: {
          MDType: 'Locality',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_localitylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan fekvése',
        },
      },
      'Masterdatamodule.Property.MannerOfPropertyList': {
        url: '/mannerOfProperty',
        params: {
          MDType: 'MannerOfProperty',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_mannerofpropertylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdonba kerülés módja',
        },
      },
      'Masterdatamodule.Property.NatConservationList': {
        url: '/natConservation',
        params: {
          MDType: 'NatConservation',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_natconservationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Védettség',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Property.NegotiabilityList': {
        url: '/negotiability',
        params: {
          MDType: 'Negotiability',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_negotiabilitylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Forgalomképesség',
        },
      },
      'Masterdatamodule.Property.OpUnitList': {
        url: '/opUnit',
        params: {
          MDType: 'OpUnit',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_opunitlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Üzemeltetési egység',
        },
      },
      'Masterdatamodule.Property.OwnerList': {
        url: '/owner',
        params: {
          MDType: 'Owner',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_ownerlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdon típusok',
        },
      },
      'Masterdatamodule.Property.OwnershipList': {
        url: '/ownership',
        params: {
          MDType: 'Ownership',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_ownershiplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tulajdonjogok',
        },
      },
      'Masterdatamodule.Property.ResponsibleTypeList': {
        url: '/responsibleType',
        params: {
          MDType: 'ResponsibleType',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_responsibletypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felelős típuskódok',
        },
      },
      'Masterdatamodule.Property.ZoneList': {
        url: '/zone',
        params: {
          MDType: 'Zone',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_zonelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Övezetek',
        },
      },
      'Masterdatamodule.Property.FunctionOfLandList': {
        url: '/functionOfLand',
        params: {
          MDType: 'FunctionOfLand',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_functionoflandlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Földrészlet rendeltetése',
        },
      },
      'Masterdatamodule.Property.LandUseList': {
        url: '/landUse',
        params: {
          MDType: 'LandUse',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_landuselist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Művelési ág',
        },
      },
      'Masterdatamodule.Property.OutOfCultivationList': {
        url: '/outOfCultivation',
        params: {
          MDType: 'OutOfCultivation',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_outofcultivationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Művelés alól kivett terület jellege',
        },
      },
      'Masterdatamodule.Property.BuildingPlotKindList': {
        url: '/buildingPlotKind',
        params: {
          MDType: 'BuildingPlotKind',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_buildingplotkindlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Telek jellege',
        },
      },
      'Masterdatamodule.Property.InbuiltPlotList': {
        url: '/inbuiltPlot',
        params: {
          MDType: 'InbuiltPlot',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_inbuiltplotlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beépítettség',
        },
      },
      'Masterdatamodule.Property.MannerOfBuildInList': {
        url: '/mannerOfBuildIn',
        params: {
          MDType: 'MannerOfBuildIn',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_mannerofbuildinlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Beépítési mód',
        },
      },
      'Masterdatamodule.Property.ElectricityList': {
        url: '/electricity',
        params: {
          MDType: 'Electricity',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_electricitylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Villany ellátás',
        },
      },
      'Masterdatamodule.Property.DrinkingWaterList': {
        url: '/drinkingWater',
        params: {
          MDType: 'DrinkingWater',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_drinkingwaterlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ivóvíz ellátás',
        },
      },
      'Masterdatamodule.Property.SewageDisposalList': {
        url: '/sewageDisposal',
        params: {
          MDType: 'SewageDisposal',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_sewagedisposallist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szennyvíz elvezetés',
        },
      },
      'Masterdatamodule.Property.RainDrainageList': {
        url: '/rainDrainage',
        params: {
          MDType: 'RainDrainage',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_raindrainagelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Csapadékvíz elvezetés',
        },
      },
      'Masterdatamodule.Property.FireWaterNavList': {
        url: '/fireWaterNav',
        params: {
          MDType: 'FireWaterNav',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_firewaternavlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tűzivíz elvezetés',
        },
      },
      'Masterdatamodule.Property.GasSupplyList': {
        url: '/gasSupply',
        params: {
          MDType: 'GasSupply',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_gassupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Gáz ellátás',
        },
      },
      'Masterdatamodule.Property.FunctionOfEdificeList': {
        url: '/functionOfEdifice',
        params: {
          MDType: 'FunctionOfEdifice',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_functionofedificelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Építmény rendeltetése',
        },
      },
      'Masterdatamodule.Property.EnergeticsList': {
        url: '/energetics',
        params: {
          MDType: 'Energetics',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_energeticslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Energetikai besorolások',
        },
      },
      'Masterdatamodule.Property.TypeList': {
        url: '/type',
        params: {
          MDType: 'PropertyType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_typelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan főtípus',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdatamodule.Property.SubTypeList': {
        url: '/subtype',
        params: {
          MDType: 'PropertySubType',
          ModulType: 'Property',
          documentEntity: 'masterdatamodule_property_subtypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ingatlan altípus',
          parent: 'Property.PyramidNav',
        },
      },
      'Masterdatamodule.Building': {
        url: '/building',
        params: { module: 'building' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Property/PropertyMasterData.html',
            controller: 'BuildingMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Épület törzsek',
        },
      },
      'Masterdatamodule.Property.DiffUsageList': {
        url: '/diffusage',
        params: {
          MDType: 'DiffUsage',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_diffusagelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Eltérő használat',
        },
      },
      'Masterdatamodule.Property.StateList': {
        url: '/state',
        params: {
          MDType: 'State',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_statelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Állapot',
        },
      },
      'Masterdatamodule.Property.AtticInbuiltList': {
        url: '/atticinbuilt',
        params: {
          MDType: 'AtticInbuilt',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_atticinbuiltlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tetőtéri beépítettség',
        },
      },
      'Masterdatamodule.Property.OtherSupplyList': {
        url: '/othersupply',
        params: {
          MDType: 'OtherSupply',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_othersupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Egyéb ellátottság',
        },
      },
      'Masterdatamodule.Property.GarbageCanList': {
        url: '/garbagecan',
        params: {
          MDType: 'GarbageCan',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdatamodule_property_garbagecanlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BuildingMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Hulladéktárolás',
        },
      },
      'Masterdatamodule.Tenement': {
        url: '/tenement',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_tenement' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Tenement/TenementMasterData.html',
            controller: 'TenementMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérlemény törzsek',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Tenement.NotRentableList': {
        url: '/notRentable',
        params: {
          MDType: 'NotRentable',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_notrentablelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérelhetetlenség okok',
        },
      },
      'Masterdatamodule.Tenement.ReasonOfChequeList': {
        url: '/reasonofcheque',
        params: {
          MDType: 'ReasonOfCheque',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_reasonofchequelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ellenőrzés oka',
        },
      },
      'Masterdatamodule.Tenement.ServiceBuiltUpList': {
        url: '/serviceBuiltUp',
        params: {
          MDType: 'ServiceBuiltUp',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_servicebuiltuplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kiépített szolgáltatások',
        },
      },
      'Masterdatamodule.Tenement.PublicUtilitySupplyList': {
        url: '/publicUtilitySupply',
        params: {
          MDType: 'PublicUtilitySupply',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_publicutilitysupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Közmű ellátás',
        },
      },
      'Masterdatamodule.Tenement.HeatingMannerList': {
        url: '/heatingManner',
        params: {
          MDType: 'HeatingManner',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_heatingmannerlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Fűtési módok',
        },
      },
      'Masterdatamodule.Premises.SurfaceKindList': {
        url: '/surfaceKind',
        params: {
          MDType: 'SurfaceKind',
          ModulType: 'Premises',
          documentEntity: 'masterdatamodule_premises_surfacekindlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felületfajták',
        },
      },
      'Masterdatamodule.Premises.SurfaceList': {
        url: '/surface',
        params: { MDType: 'Surface', ModulType: 'Premises', documentEntity: 'masterdatamodule_premises_surfacelist' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felületek',
        },
      },
      'Masterdatamodule.Tenement.CookingRoomList': {
        url: '/cookingRoom',
        params: {
          MDType: 'CookingRoom',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_cookingroomlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Főzőhelyiség fajták',
        },
      },
      'Masterdatamodule.Tenement.LegalOrderList': {
        url: '/legalOrder',
        params: {
          MDType: 'LegalOrder',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_legalorderlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Jogi rendezettség',
        },
      },
      'Masterdatamodule.Tenement.ComfortLevelList': {
        url: '/comfortLevel',
        params: {
          MDType: 'ComfortLevel',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_comfortlevellist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Komfortfokozatok',
        },
      },
      'Masterdatamodule.Tenement.WaterChargePayList': {
        url: '/waterChargePay',
        params: {
          MDType: 'WaterChargePay',
          ModulType: 'Tenement',
          backTo: 'main',
          documentEntity: 'masterdatamodule_tenement_waterchargepaylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('TenementMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Vízdíj fizetés módja',
        },
      },
      'Masterdatamodule.Premises': {
        url: '/premises',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_premises' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Premises/PremisesMasterData.html',
            controller: 'PremisesMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiség',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Premises.PremiseFunctionList': {
        url: '/premiseFunction',
        params: {
          MDType: 'PremiseFunction',
          ModulType: 'Premises',
          backTo: 'main',
          documentEntity: 'masterdatamodule_premises_premisefunctionlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiség funkciók',
        },
      },
      'Masterdatamodule.Premises.PremiseNameList': {
        url: '/premiseName',
        params: {
          MDType: 'PremiseName',
          ModulType: 'Premises',
          backTo: 'main',
          documentEntity: 'masterdatamodule_premises_premisenamelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiségnevek',
        },
      },
      'Masterdatamodule.Premises.HotWaterSupplyList': {
        url: '/hotWaterSupply',
        params: {
          MDType: 'HotWaterSupply',
          ModulType: 'Premises',
          backTo: 'main',
          documentEntity: 'masterdatamodule_premises_hotwatersupplylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Melegvíz ellátás',
        },
      },
      'Masterdatamodule.Premises.EqualMultiplierList': {
        url: '/equalmultiplier',
        params: {
          MDType: 'EqualMultiplier',
          ModulType: 'Premises',
          backTo: 'main',
          documentEntity: 'masterdatamodule_premises_equalmultiplierlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Egyenértékű szorzók',
        },
      },
      'Masterdatamodule.Premises.InvTypeList': {
        url: '/invtype',
        params: {
          MDType: 'InvType',
          ModulType: 'Premises',
          backTo: 'main',
          documentEntity: 'masterdatamodule_premises_invtypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PremisesMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helyiségleltár típus',
        },
      },
      'Masterdatamodule.Equipment': {
        url: '/equipment',
        params: { module: 'equipment', documentEntity: 'equipment_equipmentnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Equipment/EquipmentMasterData.html',
            controller: 'EquipmentMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezések',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Equipment.EquipmentList': {
        url: '/equipment',
        params: {
          MDType: 'Equipment',
          ModulType: 'Equipment',
          backTo: 'main',
          documentEntity: 'equipment_equipmentnav',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezések',
        },
      },
      'Masterdatamodule.Equipment.EquipmentGroupList': {
        url: '/equipmentgroup',
        params: {
          MDType: 'EquipmentGroup',
          ModulType: 'Equipment',
          backTo: 'main',
          documentEntity: 'equipment_equipmentgroupnav',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés csoportok',
        },
      },
      'Masterdatamodule.Equipment.EquipmentQualityList': {
        url: '/equipmentquality',
        params: {
          MDType: 'EquipmentQuality',
          ModulType: 'Equipment',
          backTo: 'main',
          documentEntity: 'equipment_equipmentqualitynav',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés minősítések',
        },
      },
      'Masterdatamodule.Equipment.EquipmentSystemList': {
        url: '/equipmentsystem',
        params: {
          MDType: 'EquipmentSystem',
          ModulType: 'Equipment',
          backTo: 'main',
          documentEntity: 'equipment_equipmentsystemnav',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('EquipmentMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Berendezés rendszerek',
        },
      },
      'Masterdatamodule.SupplyContract': {
        url: '/supplycontract',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_supplycontract' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/SupplyContract/SupplyContractMasterData.html',
            controller: 'SupplyContractMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés törzsek',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.SupplyContract.ContractTypeList': {
        url: '/contracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'SupplyContract',
          backTo: 'main',
          documentEntity: 'masterdatamodule_supplycontract_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
        },
      },
      'Masterdatamodule.SupplyContract.CPVList': {
        url: '/cpv',
        params: {
          MDType: 'CPV',
          ModulType: 'SupplyContract',
          backTo: 'main',
          documentEntity: 'masterdatamodule_supplycontract_cpvlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'CPV kódok',
        },
      },
      'Masterdatamodule.SupplyContract.SupplyContrStatusTypeList': {
        url: '/supplycontrstatustype',
        params: {
          MDType: 'SupplyContrStatusType',
          ModulType: 'SupplyContract',
          backTo: 'main',
          documentEntity: 'masterdatamodule_supplycontract_supplycontrstatustypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés státusz típusok',
        },
      },
      'Masterdatamodule.SupplyContract.SpecializationList': {
        url: '/specialization',
        params: {
          MDType: 'SCSpecialization',
          ModulType: 'SupplyContract',
          backTo: 'main',
          documentEntity: 'masterdatamodule_supplycontract_specializationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterület',
        },
      },
      'Masterdatamodule.Contract': {
        url: '/contract',
        params: { module: 'masterdata', documentEntity: 'masterdata_contract' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Contract/ContractMasterData.html',
            controller: 'ContractMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti szerződések',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Contract.ContractTypeList': {
        url: '/contracttype',
        params: {
          MDType: 'ContractType',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_contracttypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsContractType/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés típusok',
        },
      },
      'Masterdatamodule.Contract.ContractCodeList': {
        url: '/contractcode',
        params: {
          MDType: 'ContractCode',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdatamodule_contract_contractcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződés kódok',
        },
      },
      'Masterdatamodule.Contract.AreaRentalList': {
        url: '/arearental',
        params: {
          MDType: 'AreaRental',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_arearentallist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsAreaRental/'),
        },
        ncyBreadcrumb: {
          label: 'Helybérlés típusok',
        },
      },
      'Masterdatamodule.Contract.ConditionalList': {
        url: '/conditional',
        params: {
          MDType: 'Conditional',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_conditionallist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsConditional/'),
        },
        ncyBreadcrumb: {
          label: 'Szerződést megszüntető feltételek',
        },
      },
      'Masterdatamodule.Contract.DepositList': {
        url: '/deposit',
        params: {
          MDType: 'Deposit',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_depositlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsDeposit/'),
        },
        ncyBreadcrumb: {
          label: 'Óvadék típusok',
        },
      },
      'Masterdatamodule.Contract.InformationList': {
        url: '/information',
        params: { MDType: 'Information', ModulType: 'Contract', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsInformation/'),
        },
        ncyBreadcrumb: {
          label: 'Ügyviteli információk',
        },
      },
      'Masterdatamodule.Contract.ServiceAssignmentList': {
        url: '/serviceassignment',
        params: { MDType: 'ServiceAssignment', ModulType: 'Contract', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsServiceAssignment/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti és használati díjak összerendelése',
        },
      },
      'Masterdatamodule.Contract.RelationshipList': {
        url: '/relationship',
        params: {
          MDType: 'Relationship',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_relationshiplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsRelationShip/'),
        },
        ncyBreadcrumb: {
          label: 'Családi viszonyok',
        },
      },
      'Masterdatamodule.Contract.RentIndexationList': {
        url: '/rentindexation',
        params: {
          MDType: 'RentIndexation',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_rentindexationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsRentIndexation/'),
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj indexálás módja',
        },
      },
      'Masterdatamodule.Contract.TerminateReasonList': {
        url: '/terminatereason',
        params: {
          MDType: 'TerminateReason',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_terminatereasonlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsTerminateReason/'),
        },
        ncyBreadcrumb: {
          label: 'Megszűnés okai',
        },
      },
      'Masterdatamodule.Contract.TitleTypeList': {
        url: '/titletype',
        params: {
          MDType: 'TitleType',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_titletypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsTitleType/'),
        },
        ncyBreadcrumb: {
          label: 'Jogcím típusa',
        },
      },
      'Masterdatamodule.Contract.UsageFeeList': {
        url: '/usagefee',
        params: {
          MDType: 'UsageFee',
          ModulType: 'Contract',
          backTo: 'main',
          documentEntity: 'masterdata_contract_usagefeelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ContractMasterData/ListOptionsUsageFee/'),
        },
        ncyBreadcrumb: {
          label: 'Használati díjak számításának módja',
        },
      },
      'Masterdatamodule.Budget': {
        url: '/budget',
        params: { module: 'budget', documentEntity: 'masterdata_budget' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterData.html',
            controller: 'BudgetMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Budget.BudgetList': {
        url: '/budget',
        params: { MDType: 'Budget', ModulType: 'Budget', backTo: 'main', documentEntity: 'masterdata_budget' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés',
        },
      },
      'Masterdatamodule.Budget.BudgetItemList': {
        url: '/budgetitem',
        params: { MDType: 'BudgetItem', ModulType: 'Budget', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés tételek',
        },
      },
      'Masterdatamodule.Budget.BudgetTypeList': {
        url: '/budgettype',
        params: { MDType: 'BudgetType', ModulType: 'Budget', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés típusok',
        },
      },
      'Masterdatamodule.Budget.AllocationList': {
        url: '/allocation',
        params: {
          MDType: 'Allocation',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_allocationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Felosztás alapjai',
        },
      },
      'Masterdatamodule.Budget.CalcTypeServiceList': {
        url: '/calctypeservice',
        params: {
          MDType: 'CalcTypeService',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_calctypeservicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Kalkulációs módok díjtételei',
        },
      },
      'Masterdatamodule.Budget.BudJobNumberList': {
        url: '/budjobnumber',
        params: {
          MDType: 'BudJobNumber',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_budjobnumberlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Munkaszámok',
        },
      },
      'Masterdatamodule.Budget.BudgetDateList': {
        url: '/budgetdate',
        params: {
          MDType: 'BudgetDate',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_budgetdatelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetés dátumok',
        },
      },
      'Masterdatamodule.Budget.BudSubGroupList': {
        url: '/budsubgroup',
        params: {
          MDType: 'BudSubGroup',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_budsubgrouplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Alcsoportok',
        },
      },
      'Masterdatamodule.Budget.CityCodeList': {
        url: '/citycode',
        params: {
          MDType: 'CityCode',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_citycodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Város közigazgatási kódok',
        },
      },
      'Masterdatamodule.Budget.RatePlanList': {
        url: '/rateplan',
        params: {
          MDType: 'RatePlan',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_rateplanlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Éves tervárfolyamok',
        },
      },
      'Masterdatamodule.Budget.CostCenterList': {
        url: '/costcenter',
        params: {
          MDType: 'CostCenter',
          ModulType: 'Budget',
          backTo: 'main',
          documentEntity: 'masterdata_budget_costcenterlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költséghely kódok',
        },
      },
      'Masterdatamodule.Budget.CondominiumUnitList': {
        url: '/CondominiumUnit',
        params: {
          MDType: 'CondominiumUnit',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_condominiumunitlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Társasházi mennyiségi egységek',
        },
      },
      'Masterdatamodule.Budget.BudgetCorrectiveServiceList': {
        url: '/BudgetCorrectiveService',
        params: {
          MDType: 'BudgetCorrectiveService',
          ModulType: 'Budget',
          documentEntity: 'masterdata_budget_BudgetCorrectiveServicelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/Budget/BudgetMasterDataView.html',
            controller: 'BudgetMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('BudgetMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Díjgenerálás korrekciós díjtételei',
        },
      },

      'Masterdatamodule.Invoice': {
        url: '/invoice',
        params: { module: 'invoice' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Invoice/InvoiceMasterData.html',
            controller: 'InvoiceMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('InvoiceMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Számlaiktatás törzsadatok',
          parent: 'Masterdatamodule',
        },
      },
      'Masterdatamodule.Construction': {
        url: '/construction',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_construction' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Construction/ConstructionMasterData.html',
            controller: 'ConstructionMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListDDLOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezet törzsadatok',
          parent: 'main',
        },
      },
      'Masterdatamodule.Construction.ConstructionClassifyList': {
        url: '/constructionclassify',
        params: {
          MDType: 'ConstructionClassify',
          ModulType: 'Construction',
          backTo: 'main',
          documentEntity: 'masterdatamodule_construction_constructionclassifylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti besorolások',
        },
      },
      'Masterdatamodule.Construction.ConstructionElementList': {
        url: '/constructionelement',
        params: {
          MDType: 'ConstructionElement',
          ModulType: 'Construction',
          backTo: 'main',
          documentEntity: 'masterdatamodule_construction_constructionelementlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti Elemek',
        },
      },
      'Masterdatamodule.Construction.ConstructionGroupList': {
        url: '/constructiongroup',
        params: {
          MDType: 'ConstructionGroup',
          ModulType: 'Construction',
          backTo: 'main',
          documentEntity: 'masterdatamodule_construction_constructiongrouplist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ConstructionMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerkezeti Elemcsoportok',
        },
      },
      'Masterdatamodule.HelpDesk': {
        url: '/helpdesk',
        params: { module: 'masterdata', documentEntity: 'masterdatamodule_helpdesk' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'MasterDataModuleMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/HelpDesk/HelpDeskMasterData.html',
            controller: 'HelpDeskMasterDataCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Helpdesk törzsadatok',
          parent: 'main',
        },
      },
      'Masterdatamodule.HelpDesk.HelpDeskPriorityList': {
        url: '/helpdeskpriority',
        params: {
          MDType: 'HelpDeskPriority',
          ModulType: 'HelpDesk',
          backTo: 'main',
          documentEntity: 'masterdatamodule_helpdesk_helpdeskprioritylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Prioritások',
        },
      },
      'Masterdatamodule.HelpDesk.ServiceLevelList': {
        url: '/helpdeskservicelevel',
        params: {
          MDType: 'ServiceLevel',
          ModulType: 'HelpDesk',
          backTo: 'main',
          documentEntity: 'masterdatamodule_helpdesk_servicelevellist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szolgáltatási szintek',
        },
      },
      'Masterdatamodule.HelpDesk.HelpDeskStatusList': {
        url: '/helpdeskstatus',
        params: {
          MDType: 'HelpDeskStatus',
          ModulType: 'HelpDesk',
          backTo: 'main',
          documentEntity: 'masterdatamodule_helpdesk_helpdeskstatuslist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Státuszok',
        },
      },
      'Masterdatamodule.HelpDesk.TicketTemplateList': {
        url: '/tickettemplate',
        params: { MDType: 'TicketTemplate', ModulType: 'HelpDesk' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Munkalap sablonok',
          parent: 'Masterdata.HelpDesk',
        },
      },
      'Masterdatamodule.HelpDesk.TicketTypeList': {
        url: '/helpdesktickettype',
        params: {
          MDType: 'TicketType',
          ModulType: 'HelpDesk',
          backTo: 'main',
          documentEntity: 'masterdatamodule_helpdesk_tickettypelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Bejelentés típusok',
        },
      },
      'Masterdatamodule.HelpDesk.SpecializationList': {
        url: '/helpdeskspecialization',
        params: {
          MDType: 'HDSpecialization',
          ModulType: 'HelpDesk',
          backTo: 'main',
          documentEntity: 'masterdatamodule_helpdesk_specializationlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szakterületek',
        },
      },
      'Masterdatamodule.HelpDesk.LedgerCodeList': {
        url: '/helpdeskledgercode',
        params: { MDType: 'LedgerCode', ModulType: 'HelpDesk', backTo: 'main' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Általános pénzügyi dimenziók',
        },
      },
      'Masterdatamodule.HelpDesk.RoleList': {
        url: '/helpdeskrole',
        params: { MDType: 'HelpDeskRole', ModulType: 'HelpDesk' },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDeskMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Szerepkörök',
        },
      },
      'Masterdatamodule.Property.CountryList': {
        url: '/country',
        params: {
          MDType: 'Country',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdata_Property_countrylist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ország',
        },
      },
      'Masterdatamodule.Property.StreetCharList': {
        url: '/streetchar',
        params: {
          MDType: 'StreetChar',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdata_Property_streetcharlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Közterület',
        },
      },
      'Masterdatamodule.Property.RegionList': {
        url: '/region',
        params: {
          MDType: 'Region',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdata_Property_regionlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Megye',
        },
      },
      'Masterdatamodule.Property.FloorList': {
        url: '/floor',
        params: {
          MDType: 'Floor',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdata_Property_floorlist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Emelet',
        },
      },
      'Masterdatamodule.Property.PostCodeList': {
        url: '/post-code',
        params: {
          MDType: 'PostCode',
          ModulType: 'Property',
          backTo: 'main',
          documentEntity: 'masterdata_Property_postcodelist',
        },
        views: {
          masterData: {
            templateUrl: 'App/MasterData/MasterDataView.html',
            controller: 'MasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('PropertyMasterData/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Irányítószám',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';
  module.controller('MasterDataModuleMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataModuleMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo == 'Nav') {
        backMenu.event = function() {
          $state.go('Invoice.InvoiceNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Masterdatamodule_AllMasterData: { icon: 'fa fa-file-text' },
        Masterdatamodule_Project: { icon: 'fa fa-file-text' },
        Masterdatamodule_Partner: { icon: 'fa fa-file-text' },
        Masterdatamodule_Utilization: { icon: 'fa fa-file-text' },
        Masterdatamodule_Financial: { icon: 'fa fa-file-text' },
        Masterdatamodule_Property: { icon: 'fa fa-file-text' },
        Masterdatamodule_Tenement: { icon: 'fa fa-file-text' },
        Masterdatamodule_Premises: { icon: 'fa fa-file-text' },
        Masterdatamodule_SupplyContract: { icon: 'fa fa-file-text' },
        Masterdatamodule_Contract: { icon: 'fa fa-file-text' },
        Masterdatamodule_Construction: { icon: 'fa fa-file-text' },
        Masterdatamodule_HelpDesk: { icon: 'fa fa-file-text' },
      };

      buildMenu($state, authService, 'MasterDataModule', 'masterdatamodule', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('MasterDataViewCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'HistoryService',
    'WalService',
    'DasService',
    'LockService',
    function(
      options,
      $http,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      HistoryService,
      walService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataViewCtrl', stateParams);
      }
      console.log('MasterDataViewCtrl');
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;

      vm.securedProgramId = options.programId;

      vm.MDType = $stateParams.MDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };
      vm.back = function() {
        switch (vm.ModulType) {
          case 'Property':
          case 'Building':
          case 'Tenement':
          case 'Premises': {
            $state.go('Property.PyramidNav');
            break;
          }
          case 'SupplyContract': {
            $state.go('SupplyContract.SupplyContractNav');
            break;
          }
          case 'Contract': {
            $state.go('Contract.ContractNav');
            break;
          }
          case 'Budget': {
            $state.go('main');
            break;
          }
          case 'Invoice': {
            $state.go('Invoice.InvoiceNav');
            break;
          }
          case 'Construction': {
            $state.go('Construction.BuildingConstructionNav');
            break;
          }
          case 'Project': {
            $state.go('Project.ProjectNav');
            break;
          }
          case 'HelpDesk': {
            $state.go('HelpDesk');
            break;
          }
          default: {
            $state.go('Partner.PartnerNav');
            break;
          }
        }
      };

      //override from stateParams
      if (!!$stateParams.backTo) {
        vm.back = function() {
          $state.go($stateParams.backTo);
        };
      }

      vm.selectedgridItemId = 0;
      vm.hdHideDuplicate = false;

      // MenuItems
      vm.create = createItem;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;
      vm.WAL = WAL;
      vm.attachDocument = attachDocument;
      vm.clickisValidDate = function() {
        vm.isValidDate = !vm.isValidDate;
        $('#MDVGrid')
          .data('kendoGrid')
          .dataSource.read();
      };
      if (vm.MDType == 'RentIndexation') {
        vm.isValidDate = true;
      }

      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');
      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        vm.getModulType() + 'MasterData/' + vm.getMDType() + 'List/',
        function() {
          if (
            vm.MDType === 'EquipmentGroup' ||
            vm.MDType === 'LedgerCode' ||
            vm.MDType === 'HelpDeskRole' ||
            vm.MDType === 'TicketTemplate' ||
            vm.MDType === 'SurfaceCondition' ||
            vm.MDType === 'Surface'
          ) {
            selectGridItem();
          }
          changeGridFilter(vm, $scope, vm.grid, vm.gridIdField);
        },
        function(e) {
          if (vm.MDType == 'RentIndexation') {
            return {
              isValidDate: vm.isValidDate,
            };
          }
        }
      );
      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {
        Floor: {
          customTypes: {
            Ranking: 'maskedInput',
          },
          inputMasks: {
            Ranking: '9?9?9',
          },
        },
        Bank: {
          customTypes: {
            Bank: 'maskedInput',
          },
          inputMasks: {
            Bank: '99999999',
          },
        },
        Annexe: {
          customTypes: {
            Ordering: 'maskedInput',
          },
          inputMasks: {
            Ordering: '9?9?9?9?9?9?9?9?9?9',
          },
        },
        VatCode: {
          customTypes: {
            // "Vat": "kendoNTB"
          },
          inputMasks: {
            Vat: '9?9?9?,?9?9?9?9?9?9?',
          },
        },
        AreaMultiplier: {
          customTypes: {
            // "Multiplier": "kendoNTB"
          },
        },
      };

      function selectGridItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);

        if (selectedItems.length === 0) {
          return;
        }

        vm.selectedgridItemId = selectedItems[0][vm.gridIdField];

        switch (vm.MDType) {
          case 'EquipmentGroup':
            vm.equipmentRecipientGrid.dataSource.read();
            break;
          case 'LedgerCode':
            vm.dimensionsValueGrid.dataSource.read();
            break;
          case 'TicketTemplate':
            vm.ticketTemplateTaskDataGrid.dataSource.read();
            break;
          case 'HelpDeskRole':
            //vm.dimensionsValueGrid.dataSource.read();
            break;
          case 'Surface':
            vm.surfacePremiseGrid.dataSource.read();
            break;
        }
      }

      if (vm.MDType === 'EquipmentGroup') {
        vm.pageModelR = options.pageModelR;

        vm.getSelectedGridItemId = function() {
          return {
            EqGroupId: vm.selectedgridItemId,
          };
        };

        vm.equipmentRecipientGrid = options.pageModel.Grids.GridEquipmentRecipient;
        vm.equipmentRecipientGridOptions = getGridOptions(
          options.pageModel.Grids.GridEquipmentRecipient,
          'EquipmentMasterData/EquipmentRecipientList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      if (vm.MDType === 'LedgerCode') {
        vm.getSelectedGridItemId = function() {
          return {
            LedgerCodeId: vm.selectedgridItemId,
          };
        };

        vm.dimensionsValueGrid = options.pageModel.Grids.GridDimensionsValue;
        vm.dimensionsValueGridOptions = getGridOptions(
          options.pageModel.Grids.GridDimensionsValue,
          'HelpDeskMasterData/LedgerCodeValueList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      if (vm.MDType === 'HelpDeskRole') {
        vm.getSelectedGridItemId = function() {
          return {
            HelpDeskRoleId: vm.selectedgridItemId,
          };
        };

        vm.helpDeskRoleDataGrid = options.pageModel.Grids.GridHelpDeskRoleData;
        vm.helpDeskRoleDataGridOptions = getGridOptions(
          options.pageModel.Grids.GridHelpDeskRoleData,
          'HelpDeskMasterData/HelpDeskRoleDataList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }
      if (vm.MDType === 'TicketTemplate') {
        vm.getSelectedGridItemId = function() {
          return {
            ticketTemplateId: vm.selectedgridItemId,
          };
        };

        vm.ticketTemplateTaskDataGrid = options.pageModel.Grids.GridTicketTemplateTask;
        vm.ticketTemplateTaskGridOptions = getGridOptions(
          options.pageModel.Grids.GridTicketTemplateTask,
          'HelpDeskMasterData/TicketTemplateTaskList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }
      if (vm.MDType === 'ProjectStatusMain') {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        vm.subGridIdField = vm.pageModel.Grids['Grid' + vm.getMDType().replace('Main', 'Sub')].IdColumn;
        // Kendo-grid reference
        vm.subGrid = $('#MDVSubGrid').data('kendoGrid');
        // Dynamic grid configuration
        vm.subGridOptions = getGridOptions(
          vm.pageModel.Grids['Grid' + vm.getMDType().replace('Main', 'Sub')],
          vm.getModulType() + 'MasterData/' + vm.getMDType().replace('Main', 'Sub') + 'List/',
          function() {
            changeGridFilter(vm, $scope, vm.subGrid, vm.subGridIdField);
          }
        );

        vm.gridOptions.dataSource.schema['model']['fields']['IsActive']['type'] = 'boolean';
        vm.subGridOptions.dataSource.schema['model']['fields']['IsActive']['type'] = 'boolean';

        angular.forEach(vm.gridOptions.columns, function(val, key) {
          if (val.field === 'IsActive') {
            val.template = '<input type="checkbox" #: IsActive == 1 ? "checked" : "" # disabled/>';
          }
          if (val.field === 'Color') {
            val.template =
              '<span class="statusColor" style="background-color: #: Color #; display: block">&nbsp;</span>';
            val['filterable'] = false;
          }
        });
        angular.forEach(vm.subGridOptions.columns, function(val, key) {
          if (val.field === 'IsActive') {
            val.template = '<input type="checkbox" #: IsActive == 1 ? "checked" : "" # disabled/>';
          }
          if (val.field === 'Color') {
            val.template =
              '<span class="statusColor" style="background-color: #: Color #; display: block">&nbsp;</span>';
            val['filterable'] = false;
          }
        });
      }
      if (vm.MDType === 'ProjectType') {
        vm.gridOptions.dataSource.schema['model']['fields']['IsInvestment']['type'] = 'boolean';
        vm.gridOptions.dataSource.schema['model']['fields']['IsMaintenance']['type'] = 'boolean';
        vm.gridOptions.dataSource.schema['model']['fields']['IsRestoration']['type'] = 'boolean';

        angular.forEach(vm.gridOptions.columns, function(val, key) {
          if (val.field === 'IsInvestment') {
            val.template = '<input type="checkbox" #: IsInvestment == 1 ? "checked" : "" # disabled/>';
          }
          if (val.field === 'IsMaintenance') {
            val.template = '<input type="checkbox" #: IsMaintenance == 1 ? "checked" : "" # disabled/>';
          }
          if (val.field === 'IsRestoration') {
            val.template = '<input type="checkbox" #: IsRestoration == 1 ? "checked" : "" # disabled/>';
          }
        });
      }
      if (vm.MDType === 'Specialization' || vm.MDType === 'HDSpecialization') {
        vm.gridOptions.dataSource.schema['model']['fields']['HelpDeskModule']['type'] = 'boolean';
        vm.gridOptions.dataSource.schema['model']['fields']['ProjectModule']['type'] = 'boolean';

        angular.forEach(vm.gridOptions.columns, function(val, key) {
          if (val.field === 'HelpDeskModule') {
            val.template = '<input type="checkbox" #: HelpDeskModule == 1 ? "checked" : "" # disabled/>';
          }
          if (val.field === 'ProjectModule') {
            val.template = '<input type="checkbox" #: ProjectModule == 1 ? "checked" : "" # disabled/>';
          }
        });
      }

      if (vm.MDType === 'SurfaceCondition') {
        vm.formModel = { FilterTM: true };

        var customCallbackFunctions = {
          FilterTM: function(state, x) {
            vm.surfacePremiseGrid.dataSource.read();
          },
        };

        InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

        vm.getSelectedGridItemId = function() {
          return {
            surfaceId: vm.selectedgridItemId,
            filterTM: vm.formModel.FilterTM,
          };
        };
        vm.surfacePremiseFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.surfacePremiseGrid = options.pageModel.Grids.GridSurfacePremise;
        vm.surfacePremiseGridOptions = getGridOptions(
          options.pageModel.Grids.GridSurfacePremise,
          'Premises	MasterData/SurfaceConditionPremiseList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      if (vm.MDType === 'Surface') {
        vm.formModel = { FilterTM: true };

        var customCallbackFunctions = {
          FilterTM: function(state, x) {
            vm.surfacePremiseGrid.dataSource.read();
          },
        };

        InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

        vm.getSelectedGridItemId = function() {
          return {
            surfaceId: vm.selectedgridItemId,
            filterTM: vm.formModel.FilterTM,
          };
        };
        vm.surfacePremiseFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.surfacePremiseGrid = options.pageModel.Grids.GridSurfacePremise;
        vm.surfacePremiseGridOptions = getGridOptions(
          options.pageModel.Grids.GridSurfacePremise,
          'Premises	MasterData/SurfacePremiseList/',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      if (
        vm.MDType === 'HelpDeskPriority' ||
        vm.MDType === 'HelpDeskStatus' ||
        vm.MDType === 'ServiceLevel' ||
        vm.MDType === 'TicketType' ||
        vm.MDType === 'LedgerCode' ||
        vm.MDType === 'ProjectType' ||
        vm.MDType === 'Priority' ||
        vm.MDType === 'InvoiceType' ||
        vm.MDType === 'Financing' ||
        vm.MDType === 'ServiceAssignment'
      ) {
        vm.hdHideDuplicate = true;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        if (vm.MDType === 'Specialization') {
          $state.go('Project.ProjectSpecializationCreate', { id: 0 });
        } else if (vm.MDType === 'HDSpecialization') {
          $state.go('HelpDesk.HelpDeskSpecializationCreate', { id: 0 });
        } else if (vm.MDType === 'SCSpecialization') {
          $state.go('SupplyContract.HelpDeskSpecializationCreate', { id: 0 });
        } else if (vm.MDType === 'TicketTemplate') {
          $state.go('HelpDesk.TicketTemplateCreate', { id: 0 });
        } else if (vm.MDType === 'HelpDeskRole') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/HelpDesk/HelpDeskRoleEdit.html',
            controller: 'HelpDeskRoleEditCtrl',
            controllerAs: 'vm',
            size: 'xl',
            resolve: {
              fModel: RouteResolveFunc(vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Create/'),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: 0,
                Operation: 'Create',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        } else {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Create/'),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: 0,
                Operation: 'Create',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          if (vm.MDType === 'Specialization') {
            $state.go('Project.ProjectSpecializationEdit', { id: id });
          } else if (vm.MDType === 'HDSpecialization') {
            $state.go('HelpDesk.HelpDeskSpecializationEdit', { id: id });
          } else if (vm.MDType === 'SCSpecialization') {
            $state.go('SupplyContract.HelpDeskSpecializationEdit', { id: id });
          } else if (vm.MDType === 'TicketTemplate') {
            $state.go('HelpDesk.TicketTemplateEdit', { id: id });
          } else if (vm.MDType === 'HelpDeskRole') {
            var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Edit/' + encodeURIComponent(id);
            var modalInstance = $uibModal.open({
              templateUrl: 'App/MasterData/HelpDesk/HelpDeskRoleEdit.html',
              controller: 'HelpDeskRoleEditCtrl',
              controllerAs: 'vm',
              size: 'xl',
              resolve: {
                fModel: RouteResolveFunc(url),
                formModifiers: vm.formModifiers[vm.getMDType()],
                parameters: {
                  id: id,
                },
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.grid.dataSource.read();
            });
          } else {
            var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Edit/' + encodeURIComponent(id);
            var modalInstance = $uibModal.open({
              templateUrl: 'App/MasterData/MasterDataEdit.html',
              controller: 'MasterDataEditCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: RouteResolveFunc(url),
                formModifiers: vm.formModifiers[vm.getMDType()],
                parameters: {
                  id: id,
                  Operation: 'Edit',
                },
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.grid.dataSource.read();
              if (vm.subGrid != null) {
                vm.subGrid.dataSource.read();
              }
            });
          }
        }
      }

      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.gridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Delete/' + id;
                  $http.get(url).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        var id = getSelectedId();

        if (id > 0) {
          if (vm.MDType === 'Specialization') {
            $state.go('Project.ProjectSpecializationDuplicate', { id: id });
          } else if (vm.MDType === 'HDSpecialization') {
            $state.go('HelpDesk.HelpDeskSpecializationDuplicate', { id: id });
          } else if (vm.MDType === 'SCSpecialization') {
            $state.go('SupplyContract.HelpDeskSpecializationDuplicate', { id: id });
          } else if (vm.MDType === 'TicketTemplate') {
            $state.go('HelpDesk.TicketTemplateDuplicate', { id: id });
          } else if (vm.MDType === 'HelpDeskRole') {
            var url =
              vm.getModulType() +
              'MasterData/' +
              vm.getMDType() +
              'Duplicate?id=' +
              encodeURIComponent(id) +
              '&isDuplicate=' +
              encodeURIComponent(true);
            var modalInstance = $uibModal.open({
              templateUrl: 'App/MasterData/HelpDesk/HelpDeskRoleEdit.html',
              controller: 'HelpDeskRoleEditCtrl',
              controllerAs: 'vm',
              size: 'xl',
              resolve: {
                fModel: RouteResolveFunc(url),
                formModifiers: vm.formModifiers[vm.getMDType()],
                parameters: {
                  id: id,
                  isDuplicate: true,
                },
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.grid.dataSource.read();
            });
          } else {
            var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Duplicate/' + id;
            var modalInstance = $uibModal.open({
              templateUrl: 'App/MasterData/MasterDataEdit.html',
              controller: 'MasterDataEditCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: RouteResolveFunc(url),
                formModifiers: vm.formModifiers[vm.getMDType()],
                parameters: {
                  id: id,
                  Operation: 'Duplicate',
                },
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.grid.dataSource.read();
              if (vm.subGrid != null) {
                vm.subGrid.dataSource.read();
              }
            });
          }
        }
      }

      function getSelectedId() {
        var id = 0;

        if (vm.MDType === 'ProjectStatusMain') {
          id = typeof vm.selectedMainGridItemId === 'undefined' ? 0 : vm.selectedMainGridItemId;
        } else {
          var selectedItems = GetSelectedGridItems(vm.grid);
          if (selectedItems.length == 0) {
            id = 0;
          } else {
            id = selectedItems[0][vm.gridIdField];
          }
        }

        if (id == 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        }

        vm.selectedMainGridItemId = 0; // Különben a következő action gomb lenyomáskor rosszul veheti (a korábbi értéket)
        return id;
      }

      ///
      function attachDocument() {
        var id = getSelectedId();
        var _state =
          $state.$current.name.search('Masterdatamodule') === -1
            ? 'Masterdata.' + vm.ModulType + 'DasDocumentsNav'
            : 'Masterdatamodule.' + vm.ModulType + 'DasDocumentsNav';
        if (vm.MDType === 'HDSpecialization') {
          dasService.NavigateToDas(vm.messages, _state, 'FlgSpecialization', id);
        } else {
          dasService.NavigateToDas(vm.messages, _state, 'Flg' + vm.MDType, id);
        }
      }

      function WAL() {
        if (vm.MDType === 'HDSpecialization' || vm.MDType === 'SCSpecialization') {
          walService.NavigateToWal(vm.ModulType + 'MasterData', 'SpecializationNavWal', 'FlgSpecialization');
        } else if (vm.MDType === 'HelpDeskRole') {
          walService.NavigateToWal(vm.ModulType + 'MasterData', 'HelpDeskRoleNavWal', 'FlgUserHelpDeskRoleView');
        } else {
          walService.NavigateToWal(vm.ModulType + 'MasterData', vm.MDType + 'NavWal', 'Flg' + vm.MDType); // vm.ModulType + "MasterData"; "MasterData" szükséges, különben nem működik
        }
      }

      vm.History = function history() {
        if (vm.selectedMainGridItemId == 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          if (vm.MDType === 'HDSpecialization' || vm.MDType === 'SCSpecialization') {
            HistoryService.NavigateToHistory('FlgSpecialization', vm.selectedMainGridItemId, vm, $state, true);
          } else {
            HistoryService.NavigateToHistory('Flg' + vm.MDType, vm.selectedMainGridItemId, vm, $state, true);
          }
        }
      };
      ///////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PartnerMasterDataMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerMasterDataMenuCtrl', stateParams);
      }
      var vm = this;

      vm.partnerNav = function() {
        $state.go('partner.nav');
      };

      vm.main = function() {
        $state.go('main');
      };

      vm.partnerCat = function() {
        $state.go('masterdata.partner');
      };

      vm.financialCat = function() {
        $state.go('masterdata.financial');
      };

      vm.aidDecision = function() {
        $state.go('partner.aid');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PropertyMasterDataMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyMasterDataMenuCtrl', stateParams);
      }
      var vm = this;

      vm.main = function() {
        $state.go('main');
      };

      vm.partnerCat = function() {
        $state.go('masterdata.property');
      };
      vm.equipment = function() {
        $state.go('property.EquipmentList');
      };
      vm.pyramid = function() {
        $state.go('property.PropertyList');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BuildingMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    function(options, $http, $state, $stateParams, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingMasterDataCtrl', stateParams);
      }
      var vm = this;

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'BuildingMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractMasterDataCtrl', stateParams);
      }
      var vm = this;

      vm.grid = null;
      vm.UIHelperService = UIHelperService;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'ContractMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractMasterDataViewCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    'WalService',
    'DasService',
    function($scope, options, $http, $state, $stateParams, $uibModal, AuthService, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractMasterDataViewCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.pageModel.usageFeeMultiplier = 'Szorzók';
      vm.messages = options.pageModel.Messages;
      vm.MDType = $stateParams.MDType;
      vm.secondMDType = $stateParams.secondMDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.getSecondMDType = function() {
        return vm.secondMDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      vm.back = function() {
        $state.go('Masterdata.Contract');
      };

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      vm.serviceCallerFunc = '';

      vm.isServiceEdit = false;
      vm.selectedgridItemId = 0;
      // MenuItems
      vm.create = createItem;
      vm.createSecondItem = createSecondItem;
      vm.edit = editItem;
      vm.editSecondItem = editSecondItem;
      vm.delete = deleteItem;
      vm.deleteSecondItem = deleteSecondItem;
      vm.duplicate = duplicateItem;
      vm.duplicateSecondItem = duplicateSecondItem;
      vm.isDuplicateable = isItemDuplicateable;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      console.log(vm);
      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        vm.getModulType() + 'MasterData/' + vm.getMDType() + 'List/',
        function() {}
      );
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      if (vm.getSecondMDType()) {
        vm.secondGridIdField = vm.pageModel.Grids['Grid' + vm.getSecondMDType()].IdColumn;
      }

      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');

      //Szolgáltatások esetén a második grid inicializálása
      vm.secondGrid = $('MDVSecondGrid').data('kendoGrid');

      if (vm.MDType == 'UsageFee') {
        vm.secondGridOptions = getGridOptions(
          vm.pageModel.Grids['GridUsageFeeMultiplier'],
          vm.getModulType() + 'MasterData/UsageFeeMultiplierList',
          function() {}
        );
      }

      // Grid elem kiválasztás eseménykezelőjének definiálása
      $scope.gridOnSelection = function(kendoEvent) {
        if (vm.MDType == 'UsageFee') {
          // kiválasztott grid elem elővétele
          var selectedItem = kendoEvent.sender.select();
          var item = kendoEvent.sender.dataItem(selectedItem);
          // szervernek post-olandó adat eltárolása
          vm.selectedgridItemId = item.UsageFeeId;
          // grid feltöltése paraméter értéke alapján a szerverről
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        }
      };

      function isItemDuplicateable() {
        // Feltétel, ha az adott MDType-ra ez nem igaz, return false;
        return true;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};

      if (vm.MDType == 'EquipmentGroup') {
        vm.pageModelR = options.pageModelR;

        function selectGridItem() {
          var selectedItems = GetSelectedGridItems(vm.grid);

          if (selectedItems.length === 0) return;

          vm.selectedgridItemId = selectedItems[0][vm.gridIdField];
          vm.equipmentRecipientGrid.dataSource.read();
        }

        vm.getSelectedGridItemId = function() {
          return {
            EqGroupId: vm.selectedgridItemId,
          };
        };

        vm.equipmentRecipientGrid = options.pageModel.Grids.GridEquipmentRecipient;
        vm.equipmentRecipientGridOptions = getGridOptions(
          options.pageModel.Grids.GridEquipmentRecipient,
          'EquipmentMasterData/EquipmentRecipientList/',
          function() {},
          vm.getSelectedGridItemId
        );
      } else if (vm.MDType == 'ServiceGroup') {
        for (var i = 0; i < vm.gridOptions.columns.length; i++) {
          if (vm.gridOptions.columns[i].field == 'ServiceGroupTypeName') {
            vm.gridOptions.columns[i].hidden = true;
          }
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Create/';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getMDType()],
            parameters: {
              id: 0,
              Operation: 'Create',
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      //Második grid esetén ez a create metódus fog futni
      function createSecondItem() {
        if (vm.getMDType() == 'UsageFee') {
          vm.serviceCallerFunc = 'UsageFeeMultiplier';
          if (
            typeof vm.selectedgridItemId == 'undefined' ||
            vm.selectedgridItemId == null ||
            vm.selectedgridItemId == 0
          ) {
            toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            return;
          }
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        var url =
          vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Create?Id=' + vm.selectedgridItemId + '&subId=0';
        var id = selectedItems[0][vm.gridIdField];
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getSecondMDType()],
            parameters: {
              id: id,
              Operation: 'Create',
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        });
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        if (vm.getMDType() == 'UsageFee') {
          vm.serviceCallerFunc = 'UsageFee';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Edit/' + encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
                Operation: 'Edit',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function editSecondItem() {
        if (vm.getMDType() == 'UsageFee') {
          vm.serviceCallerFunc = 'UsageFeeMultiplier';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url =
            vm.getModulType() +
            'MasterData/' +
            vm.getSecondMDType() +
            'Edit?id=' +
            encodeURIComponent(vm.selectedgridItemId) +
            '&subId=' +
            encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: vm.selectedgridItemId,
                subId: id,
                Operation: 'Edit',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }

      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.gridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  // UsageFee special case
                  if (vm.getMDType() == 'UsageFee') {
                    var contractQueryUrl = 'ContractMasterData/GetUsageFeeContracts/' + id;

                    $http.get(contractQueryUrl).then(function(result) {
                      var contractList = result.data.ContractList;
                      if (contractList.length == 0) {
                        // not referenced anywhere, can be deleted
                        var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Delete/' + id;
                        $http.get(url).then(function() {
                          toastr.success(vm.messages.DeleteSuccessful);
                          vm.grid.dataSource.read();
                        });
                      } else {
                        // referenced by some contracts, cannot delete

                        // open warning modal
                        var modalInstance = $uibModal.open({
                          templateUrl: 'App/MasterData/Contract/ExistingContractReferenceModal.html',
                          controller: 'ExistingContractReferenceModalCtrl',
                          controllerAs: 'vm',
                          resolve: {
                            parameters: {
                              contractList: contractList,
                            },
                          },
                          backdrop: 'static',
                        });

                        modalInstance.result.then(function() {});
                        // end
                      }
                    });
                  } else {
                    var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Delete/' + id;
                    $http.get(url).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.grid.dataSource.read();
                    });
                  }

                  // end
                },
              },
            },
          });
        }
      }

      function deleteSecondItem() {
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.secondGridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Delete/' + id).then(function() {
                    toastr.success('Sikeres törlés!'); // TODO ezt valami Labelből hozni
                    vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        if (vm.getMDType() == 'UsageFee') {
          vm.serviceCallerFunc = 'UsageFee';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function duplicateSecondItem() {
        if (vm.getMDType() == 'UsageFee') {
          vm.serviceCallerFunc = 'UsageFeeMultiplier';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: id,
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }
      function attachDocument() {
        var id = getSelectedId();
        var _state =
          $state.$current.name.search('Masterdatamodule') === -1
            ? 'Masterdata.' + vm.ModulType + 'DasDocumentsNav'
            : 'Masterdatamodule.' + vm.ModulType + 'DasDocumentsNav';
        dasService.NavigateToDas(vm.messages, _state, 'Flg' + vm.MDType, id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal(vm.ModulType + 'MasterData', vm.MDType + 'NavWal', 'Flg' + vm.MDType); // vm.ModulType + "MasterData"; "MasterData" szükséges, különben nem működik
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            // Ebben a két törzsben van subgrid is:
            if (vm.MDType == 'UsageFee') {
              walService.NavigateToWal(
                vm.ModulType + 'MasterData',
                'UsageFeeMultiplierNavWal',
                'FlgUsageFeeMultiplier'
              );
            }
            break;
          }

          default: {
            break;
          }
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ExistingContractReferenceModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'parameters',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ExistingContractReferenceModalCtrl', stateParams);
      }
      var vm = this;
      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters);

      function init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
        vm.contractList = parameters.contractList;
        vm.modalInstance = $uibModalInstance;
      }

      vm.cancel = function() {
        vm.modalInstance.close();
      };

      // end
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('UsageFeeSaveWarningOnAreaRentalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'parameters',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UsageFeeSaveWarningOnAreaRentalCtrl', stateParams);
      }
      var vm = this;

      vm.toggleCheckbox = function(usageFeeId) {
        vm.usageFeeList.forEach(usageFee => {
          if (usageFee.UsageFeeId == usageFeeId) {
            usageFee.Checked = true;
          } else {
            usageFee.Checked = false;
          }
        });
      };

      vm.getSelectedUsageFee = function() {
        let usageFee = null;
        let i;
        for (i = 0; i < vm.usageFeeList.length; i++) {
          let current = vm.usageFeeList[i];
          if (current.Checked) {
            usageFee = current;
            break;
          }
        }
        return usageFee;
      };

      vm.createResultSet = function(usageFee, isCancelled) {
        let hasResult = false;
        if (usageFee) {
          hasResult = true;
        }

        let result = {
          usageFee: usageFee,
          hasResult: hasResult,
          isCancelled: isCancelled,
        };

        return result;
      };

      vm.cancel = function() {
        let resultSet = vm.createResultSet(null, true);
        vm.modalInstance.close(resultSet);
      };

      vm.save = function() {
        let selectedUsageFee = vm.getSelectedUsageFee();
        let resultSet = vm.createResultSet(selectedUsageFee, false);
        vm.modalInstance.close(resultSet);
      };

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters);
      function init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
        let usageFeeList = parameters.usageFeeList;
        appendUsageFeeListWithChecked(usageFeeList);

        vm.modalInstance = $uibModalInstance;
      }

      // This function uses ES6 features, leave it at the end of the file, as VS cannot understand it...
      function appendUsageFeeListWithChecked(usageFeeList) {
        vm.usageFeeList = usageFeeList.map(obj => {
          return { ...obj, Checked: false };
        });

        vm.usageFeeList.push({
          Name: 'Egyik sem',
          UsageFeeId: -1,
          Checked: true,
        });
      }

      // end
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PremisesMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PremisesMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'PremisesMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FinancialMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FinancialMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      // Login form mezők
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'PartnerMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PartnerMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'PartnerMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};
      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          //console.log("going to state with: " + JSON.stringify(vm.formModifiers));
          $state.go(vm.type + 'List', {
            formModifiers: vm.formModifiers[vm.type],
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PropertyMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'PropertyMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TenementMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenementMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'TenementMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SupplyContractMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'SupplyContractMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'BudgetMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};
      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          //console.log("going to state with: " + JSON.stringify(vm.formModifiers));
          $state.go(vm.type + 'List', {
            formModifiers: vm.formModifiers[vm.type],
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetMasterDataViewCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    'WalService',
    function($scope, options, $http, $state, $stateParams, $uibModal, AuthService, walService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetMasterDataViewCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;

      vm.MDType = $stateParams.MDType;
      vm.secondMDType = $stateParams.secondMDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.getSecondMDType = function() {
        return vm.secondMDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      vm.back = function() {
        $state.go('Masterdata.Budget');
      };

      vm.serviceCallerFunc = '';

      vm.isServiceEdit = false;
      vm.selectedgridItemId = 0;
      // MenuItems
      vm.create = createItem;
      vm.createSecondItem = createSecondItem;
      vm.edit = editItem;
      vm.editSecondItem = editSecondItem;
      vm.delete = deleteItem;
      vm.deleteSecondItem = deleteSecondItem;
      vm.duplicate = duplicateItem;
      vm.duplicateSecondItem = duplicateSecondItem;
      // vm.sort = sortItem;
      vm.sort = priorityCondominiumUnit;
      vm.isDuplicateable = isItemDuplicateable;
      vm.isSortable = isItemSortable;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        vm.getModulType() + 'MasterData/' + vm.getMDType() + 'List/',
        function() {
          if (vm.MDType == 'EquipmentGroup') {
            selectGridItem();
          }
        }
      );
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      if (vm.getSecondMDType()) {
        vm.secondGridIdField = vm.pageModel.Grids['Grid' + vm.getSecondMDType()].IdColumn;
      }
      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};

      function isItemDuplicateable() {
        // Feltétel, ha az adott MDType-ra ez nem igaz, return false;
        return true;
      }

      function isItemSortable() {
        if (vm.MDType == 'CondominiumUnit') return true;
        return false;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Create/';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getMDType()],
            parameters: {
              id: 0,
              Operation: 'Create',
            },
          },
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      //Második grid esetén ez a create metódus fog futni
      function createSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
          if (
            typeof vm.selectedgridItemId == 'undefined' ||
            vm.selectedgridItemId == null ||
            vm.selectedgridItemId == 0
          ) {
            toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            return;
          }
        } else if (vm.getMDType() == 'PriceList') {
          vm.serviceCallerFunc = 'PriceListRow';
          if (
            typeof vm.selectedgridItemId == 'undefined' ||
            vm.selectedgridItemId == null ||
            vm.selectedgridItemId == 0
          ) {
            toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            return;
          }
        }
        var url =
          vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Edit?Id=' + vm.selectedgridItemId + '&subId=0';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getSecondMDType()],
            parameters: {
              id: vm.selectedgridItemId,
              Operation: 'Create',
            },
          },
        });

        modalInstance.result.then(function() {
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        });
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Edit/' + encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
                Operation: 'Edit',
              },
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function editSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
        } else if (vm.getMDType() == 'PriceList') {
          vm.serviceCallerFunc = 'PriceListRow';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url =
            vm.getModulType() +
            'MasterData/' +
            vm.getSecondMDType() +
            'Edit?id=' +
            encodeURIComponent(vm.selectedgridItemId) +
            '&subId=' +
            encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: id,
                Operation: 'Edit',
              },
            },
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }

      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.gridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Delete/' + id).then(function() {
                    toastr.success('Sikeres törlés!'); // TODO ezt valami Labelből hozni
                    vm.grid.dataSource.read();
                  });
                  //.error(function () {
                  //    toastr.warning("sikertelen törlés", vm.pageModel.Messages.Warning);
                  //})
                },
              },
            },
          });
        }
      }

      function deleteSecondItem() {
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.secondGridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Delete/' + id).then(function() {
                    toastr.success('Sikeres törlés!'); // TODO ezt valami Labelből hozni
                    vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
              },
            },
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function duplicateSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: id,
              },
            },
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }
      function priorityCondominiumUnit() {
        var url = vm.ModulType + 'MasterData/' + vm.MDType + 'PriorityList';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/Budget/CondominiumUnitPriorityEdit.html',
          controller: 'CondominiumUnitPriorityCtrl',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc(url),
            fModel: vm.pageModel,
            formModifiers: vm.formModifiers[vm.getMDType()],
          },
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          if (id != 0) {
            debugger;
            console.log($state.$current.name);
            if ($state.$current.name.search('Masterdatamodule') === -1) {
              $state.go('Masterdata.' + vm.ModulType + 'DasDocumentsNav', { tableId: 'Flg' + vm.MDType, ownerId: id });
            } else {
              $state.go('Masterdatamodule.' + vm.ModulType + 'DasDocumentsNav', {
                tableId: 'Flg' + vm.MDType,
                ownerId: id,
              });
            }
          }
        }
      }

      function WAL() {
        walService.NavigateToWal(vm.ModulType + 'MasterData', vm.MDType + 'NavWal', 'Flg' + vm.MDType); // vm.ModulType + "MasterData"; "MasterData" szükséges, különben nem működik
      }
      ////////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('CondominiumUnitPriorityCtrl', [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    function($scope, $rootScope, mi, options, $http, $state, $stateParams, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CondominiumUnitPriorityCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if (!vm.close) {
          event.preventDefault();
        }
      });
      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!vm.close && reason !== 'escape key press') {
          event.preventDefault();
        }
      });
      vm.close = false;
      vm.options = options;
      vm.saveData = [];
      vm.optionsKey = [];
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoLB',
          templateOptions: {
            required: true,
            label: '',
            options: FormlyCreateLBOption({
              url: 'BudgetMasterdata/CondominiumUnitPriorityList',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            reorder: function(e) {
              var items = e.items[0].parentNode.children;
              var temprows = [];
              for (var i = 0; i < items.length; i++) {
                if (items[i].id === '') {
                  continue;
                }
                if (e.dataItems[0].uid === items[i].id)
                  if (e.offset > 0) temprows[(i + e.offset) * 10 + 2] = items[i];
                  else temprows[(i + e.offset) * 10] = items[i];
                else temprows[i * 10 + 1] = items[i];
              }
              vm.saveData = [];
              if (vm.optionsKey.length < 1) {
                e.sender.dataSource._data.forEach(function(element) {
                  vm.optionsKey[element.uid] = element.key;
                });
              }
              var row = 1;
              temprows.forEach(function(element) {
                items[element.id].innerHTML = items[element.id].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, '');
                vm.saveData[row - 1] = {
                  extraProperties: null,
                  key: vm.optionsKey[items[element.id].id],
                  text: items[element.id].innerHTML,
                  ModelState: 0,
                };
                var number = (row + '.').padEnd(4);
                items[element.id].innerHTML = number + items[element.id].innerHTML;
                row++;
              });
              vm.options = vm.saveData;
              console.log(vm.options);
            },
          },
        },
      ];
      vm.grid = null;
      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }
      vm.save = function() {
        $http.post('BudgetMasterData/CondominiumUnitPrioritySave', vm.options).then(
          function(response) {
            toastr.success('Társasházi mennyiségi egységek sorrendjének mentése sikeresen megtörtént!'); // TODO általános label
            vm.close = true;
            mi.close();
          },
          function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          }
        );
      };

      vm.cancel = function() {
        vm.close = true;
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ConstructionMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ConstructionMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.grid = null;
      vm.UIHelperService = UIHelperService;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'ConstructionMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};

      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          $state.go(vm.type + 'List', {
            formModifiers: vm.formModifiers[vm.type],
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskRoleEditCtrl', [
    '$uibModal',
    '$uibModalInstance',
    '$http',
    '$state',
    'fModel',
    'formModifiers',
    '$stateParams',
    'AuthService',
    '$scope',
    'HistoryService',
    'LockService',
    'parameters',
    function(
      $uibModal,
      mi,
      $http,
      $state,
      fModel,
      formModifiers,
      $stateParams,
      AuthService,
      $scope,
      HistoryService,
      lockService,
      parameters
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskRoleEditCtrl', stateParams);
      }
      var vm = this;
      fModel.pageModel.Fields.TicketTypeId.FormlyFieldDescriptor.type = 'kendoMS';
      fModel.pageModel.Fields.SpecializationId.FormlyFieldDescriptor.type = 'kendoMS';
      vm.existHDSCHU = fModel.existHDSCHU;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, fModel);
        initViewModel($http, $state, $stateParams, vm, fModel);
        initFormModel($http, $state, $stateParams, vm, fModel);

        //				helpDeskRoleSetFields(vm);
        generateForm(vm);

        vm.cancel = cancel;
        vm.send = send;

        vm.panelB = [];
        vm.panelC = [];
        vm.panelTME = [];
        vm.panelR = [];
        vm.panelSC = [];

        vm.adminF4IsEnabled = function(key) {
          return (
            ['DataRespUser02', 'DataRespUser03', 'DataRespUser04', 'DataRespUser05', 'DataRespUser06'].indexOf(key) !==
            -1
          );
        };

        vm.pageModel.Fields.DataRespUser03.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~contains~'HDAPPR'";
        };

        vm.pageModel.Fields.DataRespUser04.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~contains~'HDEXEC'";
        };
        vm.pageModel.Fields.DataRespUser05.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~contains~'HDACER'";
        };
        vm.pageModel.Fields.DataRespUser06.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~contains~'HDACHE'";
        };

        vm.panelSCRow = 1;
        vm.roleSC_options = [];
        vm.roleSC_filters = [];
        vm.changedSC = [];
        vm.changedR = [];
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key.endsWith('06') && !vm.existHDSCHU) {
            return;
          }
          if (value.ContainerPanelId == 'PanelRoleB') vm.panelB.push(value);
          if (value.ContainerPanelId == 'PanelRoleC') vm.panelC.push(value);
          if (value.ContainerPanelId == 'PanelRoleTME') vm.panelTME.push(value);
          if (value.ContainerPanelId == 'PanelRoleSC') {
            vm.roleSC_options[key] = {
              dataTextField: 'text',
              dataValueField: 'key',
              dataSource: {
                data: angular.copy(
                  fModel.dto.OptionsForSourceCodeCombo.filter(x =>
                    ['', 'HDSCR', 'HDSPL', 'HDSVA', 'HDSTD', 'HDSER'].slice(0, vm.panelSCRow + 1).includes(x.key)
                  )
                ),
              },
            };
            vm.panelSC.push(value);
            vm.changedSC[key] = function(key) {
              if (!!vm.dataModel[key]) {
                let dataRespUser = 'DataRespUser' + key.replace(/SourceCode/, '');
                if (!!vm.dataModel[dataRespUser]) {
                  vm.dataModel[dataRespUser] = [];
                  vm.pageModel.Fields[
                    dataRespUser
                  ].FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems.length = 0;
                }
              }
            };
            vm.panelSCRow++;
          }
          if (value.ContainerPanelId == 'PanelRoleR') {
            value.FormlyFieldDescriptor.templateOptions.options.singleTagNumber = 0;
            value.FormlyFieldDescriptor.templateOptions.options.singleTagText = 'elem';
            vm.panelR.push(value);
            vm.changedR[key] = function(key) {
              if (!!vm.dataModel[key]) {
                let sourceCode = 'SourceCode' + key.replace(/DataRespUser/, '');
                if (!!vm.dataModel[key] && !!vm.dataModel[key].length) {
                  vm.dataModel[sourceCode] = '';
                }
              }
            };
          }
        });

        vm.roleB_option = {
          dataTextField: 'text',
          dataValueField: 'key',
          dataSource: {
            data: angular.copy(fModel.dto.OptionsForCombo1),
          },
        };

        vm.roleC_option = {
          dataTextField: 'text',
          dataValueField: 'key',
          dataSource: {
            data: angular.copy(fModel.dto.OptionsForCombo2),
          },
        };

        vm.roleTME_option = {
          dataTextField: 'text',
          dataValueField: 'key',
          dataSource: {
            data: angular.copy(fModel.dto.OptionsForCombo2),
          },
        };
        delete fModel.dto.OptionsForCombo1;
        delete fModel.dto.OptionsForCombo2;
        delete fModel.dto.OptionsForSourceCodeCombo;
      }

      //nem működik kendoMS-re!!!
      /*
			  function helpDeskRoleSetFields(vm) {
                var fs = fieldSetter;
                fs.vm = vm;

                fs.setSyncValidator(
                    "TicketTypeId",    
					"TicketTypeIdValidator",					
                    function (modelValue, viewValue) {                        
                        return true;
                    });
            }
			*/

      function send() {
        let controllerType;
        switch (fModel.dto.ModelState) {
          case 4:
            controllerType = 'Duplicate';
            break;
          case 2:
            controllerType = 'Create';
            break;
          default:
            controllerType = 'Edit';
        }

        $http.post('HelpDeskMasterData/HelpDeskRole' + controllerType, vm.dataModel).then(
          function() {
            toastr.success('Sikeres mentés!');
            mi.close();
            $state.go('Masterdata.HelpDesk.RoleList');
          },
          function() {
            toastr.error('Sikertelen mentés!');
          }
        );
      }

      function cancel() {
        mi.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('Equipment.EquipmentSystemNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        //Equipment_EquipmentSystemNav: { icon: 'fa fa-bars' },
        Equipment_EquipmentGroupNav: { icon: 'fa fa-list' },
        Equipment_EquipmentQualityNav: { icon: 'fa fa-briefcase' },
        Equipment_Equipment: { icon: 'fa fa-bed' },
      };

      buildMenu($state, authService, 'Equipment', 'equipment', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Equipment: {
        url: '/equipment',
        templateUrl: 'App/Equipment/EquipmentLayout.html',
        controller: 'EquipmentLayoutCtrl as vm',
        redirectTo: 'Equipment.EquipmentNav',
        ncyBreadcrumb: {
          label: 'Berendezések',
          parent: 'main',
        },
      },
      /*
        'Equipment.EquipmentSystemNav': {
        url: '/equipmentsystem',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Equipment/EquipmentSystemNav.html',
            controller: 'EquipmentSystemNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Equipment/ListOptions/'),
        },
        params: {
          module: 'equipment',
          formMode: 'Nav',
          documentEntity: 'equipment_equipmentsystemnav',
        },
        ncyBreadcrumb: {
          //skip: true,
          parent: 'Equipment.EquipmentNav',
          label: 'Berendezés rendszerek',
        },
      },
      */
      'Equipment.EquipmentDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Equipment.EquipmentGroupNav': {
        url: '/equipmentgroup',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Equipment/EquipmentGroupNav.html',
            controller: 'EquipmentGroupNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Equipment/EquipmentGroupListOptions/'),
        },
        params: {
          module: 'equipment',
          formMode: 'Nav',
          documentEntity: 'equipment_equipmentgroupnav',
        },
        ncyBreadcrumb: {
          //skip: true,
          label: 'Berendezés csoportok',
          parent: 'Equipment',
        },
      },
      'Equipment.EquipmentGroupNav.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Equipment.EquipmentQualityNav': {
        url: '/equipmentquality',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Equipment/EquipmentQualityNav.html',
            controller: 'EquipmentQualityNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Equipment/EquipmentQualityListOptions/'),
        },
        params: {
          module: 'equipment',
          formMode: 'Nav',
          documentEntity: 'equipment_equipmentqualitynav',
        },
        ncyBreadcrumb: {
          //skip: true,
          label: 'Berendezés minősítők',
          parent: 'Equipment',
        },
      },
      'Equipment.EqOtherData': {
        url: '/equipmentotherdata',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Equipment/EquipmentOtherDataNav.html',
            controller: 'EquipmentOtherDataNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Equipment/EquipmentOtherDataListOptions/'),
        },
        params: {
          module: 'equipment',
          formMode: 'Nav',
          documentEntity: 'equipment_eqotherdata',
        },
        ncyBreadcrumb: {
          //skip: true,
          label: 'Berendezés egyéb adatok',
          parent: 'Equipment',
        },
      },
      'Equipment.EquipmentQualityNav.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Equipment.EquipmentNav': {
        url: '/equipment',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Equipment/EquipmentNav.html',
            controller: 'EquipmentNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Equipment/EquipmentListOptions/'),
        },
        params: {
          module: 'equipment',
          formMode: 'Nav',
          documentEntity: 'equipment_equipmentnav',
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Navigáció',
          parent: 'Equipment',
        },
      },
      'Equipment.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Equipment/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Equipment.EquipmentNav.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EquipmentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('EquipmentSystemNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentSystemNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createEquipmentSystem = createEquipmentSystem;
      vm.editEquipmentSystem = editEquipmentSystem;
      vm.duplicateEquipmentSystem = duplicateEquipmentSystem;
      vm.deleteEquipmentSystem = deleteEquipmentSystem;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.mainGridIdField = 'EqSystemId';
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridEqSystem,
        'Equipment/EquipmentSystemList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          EqSystemId: vm.selectedMainGridItemId,
        };
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          return;
        }
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
      }

      //////////////////////////////////////////
      ////////////// EquipmentSystem operations ///////////
      //////////////////////////////////////////
      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      function createEquipmentSystem() {
        var url = 'Equipment/EquipmentSystemCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Equipment/EquipmentSystemEdit.html',
          controller: 'EquipmentSystemEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editEquipmentSystem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentSystemEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentSystemEdit.html',
            controller: 'EquipmentSystemEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function duplicateEquipmentSystem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentSystemDuplicate/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentSystemEdit.html',
            controller: 'EquipmentSystemEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteEquipmentSystem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: 'Biztosan törölni szeretné a kiválasztott elemet?', // message: vm.messages.DeleteDialogConfirmMessage // Ez undefined.
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Equipment/EquipmentSystemDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentSystem', id);
      }

      function WAL() {
        walService.NavigateToWal('Equipment', 'EquipmentSystemNavWal', 'FlgEquipmentSystem');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgEquipmentSystem', id, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentSystemEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'EditOrDuplicate',
    'AuthService',
    'LockService',
    function(mi, $http, fModel, $stateParams, EditOrDuplicate, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentSystemEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.EditOrDuplicate = EditOrDuplicate;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Equipment/EquipmentSystem' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikertelen'); // TODO általános label
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.EqSystemId;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentSystem', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentGroupNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentGroupNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createEquipmentGroup = createEquipmentGroup;
      vm.editEquipmentGroup = editEquipmentGroup;
      vm.duplicateEquipmentGroup = duplicateEquipmentGroup;
      vm.deleteEquipmentGroup = deleteEquipmentGroup;

      vm.mainGridIdField = 'EqGroupId';
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.usedEquipmentGroupGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridEqGroup,
        'Equipment/EquipmentGroupList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          EqGroupId: vm.selectedMainGridItemId,
        };
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        //console.log("selectedMainGridItemId: " + vm.selectedMainGridItemId);

        //vm.subGrid.dataSource.read();
      }

      //////////////////////////////////////////
      ////////////// EquipmentGroup operations ///////////
      //////////////////////////////////////////

      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      function createEquipmentGroup() {
        var url = 'Equipment/EquipmentGroupCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Equipment/EquipmentGroupEdit.html',
          controller: 'EquipmentGroupEditCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
          vm.subGrid.dataSource.read();
        });
      }

      function editEquipmentGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentGroupEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentGroupEdit.html',
            controller: 'EquipmentGroupEditCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
            vm.subGrid.dataSource.read();
          });
        }
      }

      function duplicateEquipmentGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentGroupDuplicate/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentGroupEdit.html',
            controller: 'EquipmentGroupEditCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
            vm.subGrid.dataSource.read();
          });
        }
      }

      function deleteEquipmentGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          //console.log(vm.pageModel);
          //console.log(vm.messages);
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = 'Biztosan törölni szeretné a kiválasztott elemet?';
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: 'Mégse',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Törlés',
                className: 'btn-primary',
                callback: function() {
                  $http.get('Equipment/EquipmentGroupDelete/' + id).then(function() {
                    toastr.success('Berendezés rendszer sikeresen törölve!');
                    vm.mainGrid.dataSource.read();
                    vm.subGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentGroup', id);
      }

      function WAL(whichGrid) {
        switch (whichGrid) {
          case vm.usedEquipmentGroupGridEnum.MAIN:
            walService.NavigateToWal('Equipment', 'EquipmentGroupNavWal', 'FlgEquipmentGroup');
            break;
          default:
            break;
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgEquipmentGroup', id, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentGroupEditCtrl', [
    '$scope',
    'DasService',
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'EditOrDuplicate',
    'AuthService',
    'LockService',
    'gridService',
    function(
      $scope,
      DasService,
      mi,
      $http,
      fModel,
      $stateParams,
      EditOrDuplicate,
      AuthService,
      lockService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentGroupEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.EditOrDuplicate = EditOrDuplicate;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      vm.updateSelectedItems = updateSelectedItems;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      kendoMSInit(vm.pageModel, ['OtherDataName']);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      //define the grid
      $('#grid').kendoGrid({});
      vm.grid = $('#tesztGrid').data('kendoGrid');

      vm.defaultId = 0;
      vm.selectedIds = [];
      vm.selectedItems = {};

      function getDefaultGridOptions(
        gridModel,
        readUrl,
        transportData,
        defaultSort,
        selectHandler,
        pageChangeHandler,
        detailInitHandler
      ) {
        function setFieldAttributes(gridOptions) {
          function determineFieldAttributes(gridOptions, fieldName) {
            switch (gridOptions.dataSource.schema['model']['fields'][fieldName]['type']) {
              case 'number':
                return { style: 'text-align:right;' };
              case 'string':
                break;
              case 'bool':
                break;
            }
          }

          gridOptions.disableOptions = { GridStateSave: true, GridStateRestore: true };
          angular.forEach(gridOptions.columns, function(v) {
            v['attributes'] = determineFieldAttributes(gridOptions, v['field']);
          });
        }
        var gridOptions = {
          excel: {
            allPages: true,
            filterable: true,
          },
          dataSource: {
            //type: 'aspnetmvc-ajax',
            transport: {
              read: {
                url: readUrl,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                data: transportData,
                type: 'POST',
                cache: false,
              },
            },
            error: KendoDataSourceErrorFunc,
            schema: {
              data: 'Data',
              total: 'Total',
              model: {
                id: gridModel.IdColumn,
                fields: JSON.parse(gridModel.Fields),
              },
            },
            filter: [
              {
                filters: [],
              },
            ],
            pageSize: 25,
            serverPaging: true,
            serverSorting: true,
            serverFiltering: true,
            sort: defaultSort,
          },
          sortable: {
            mode: 'multiple',
            allowUnsort: true,
          },
          selectable: 'row',
          reorderable: true,
          resizable: true,
          pageable: {
            refresh: true,
            pageSizes: [5, 10, 25, 50, 100],
            buttonCount: 5,
          },
          filterable: {
            mode: 'row',
            operators: {
              string: {
                contains: kendo.ui.FilterMenu.prototype.options.operators.string.contains,
                startswith: kendo.ui.FilterMenu.prototype.options.operators.string.startswith,
                eq: kendo.ui.FilterMenu.prototype.options.operators.string.eq,
                neq: kendo.ui.FilterMenu.prototype.options.operators.string.neq,
                doesnotcontain: kendo.ui.FilterMenu.prototype.options.operators.string.doesnotcontain,
                endswith: kendo.ui.FilterMenu.prototype.options.operators.string.endswith,
                isnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnull,
                isnotnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnotnull,
                isempty: kendo.ui.FilterMenu.prototype.options.operators.string.isempty,
                isnotempty: kendo.ui.FilterMenu.prototype.options.operators.string.isnotempty,
              },
            },
          },
          columns: gridModel.Columns.slice(),
          columnMenu: true,
        };

        if (selectHandler) {
          gridOptions.change = selectHandler;
        }

        if (detailInitHandler) {
          gridOptions.detailInit = detailInitHandler;
        }

        if (pageChangeHandler) {
          gridOptions.pageable.change = pageChangeHandler;
        }

        setFieldAttributes(gridOptions);

        return gridOptions;
      }

      function getMultiselectGridOptions(
        gridModel,
        readUrl,
        transportData,
        defaultSort,
        selectHandler,
        pageChangeHandler,
        detailInitHandler,
        autoselectOnInit,
        preSelectedIds,
        preSelectDefault
      ) {
        var gridOptions = getDefaultGridOptions(
          gridModel,
          readUrl,
          transportData,
          defaultSort,
          null,
          pageChangeHandler,
          detailInitHandler
        );
        gridOptions.selectable = false;

        var checkboxColumn = {
          headerTemplate: 'Befogadó',
          template: "<input type='checkbox' class='fw-select-checkbox'/>",
          width: '60px',
          lockable: false,
        };
        gridOptions.columns.splice(0, 0, checkboxColumn);

        var radioBtnColumn = {
          headerTemplate: 'Alapértelmezett',
          template: "<input type='radio' name='eqdefaultbtn' class='fw-select-radiobtn'/>",
          width: '70px',
          lockable: false,
        };

        vm.radioBtnColumn = radioBtnColumn;

        gridOptions.dataBound = function(e) {
          var grid = this;
          $(this.tbody)
            .find('.fw-select-radiobtn')
            .bind('click', function(e) {
              var row = $(e.target).closest('tr');
              var rowId = grid.dataItem(row).id;
              if (row.find('.fw-select-checkbox').prop('checked')) {
                grid.fw_defaultId = rowId;
                vm.updateDefaultItem(rowId);
                return true;
              } else return false;
            });

          $(this.tbody)
            .find('.fw-select-checkbox')
            .bind('change', function(e) {
              var row = $(e.target).closest('tr');
              var rowId = grid.dataItem(row).id;
              if (this.checked) {
                row.addClass('k-state-selected');
                //ha nincs még alapértelmezett, legyen a most kijelölt sor
                if ($('.fw-select-radiobtn:checked').length === 0) {
                  row.find('.fw-select-radiobtn').prop('checked', true);
                  grid.fw_defaultId = rowId;
                }
                grid.fw_selectedIds[rowId] = true;
              } else {
                row.removeClass('k-state-selected');
                //ha ez volt az alapértelmezett, ki kell venni
                if (row.find('.fw-select-radiobtn').prop('checked')) {
                  row.find('.fw-select-radiobtn').prop('checked', false);
                  grid.fw_defaultId = 0;
                }
                delete grid.fw_selectedIds[rowId];
              }
            });
        };

        return gridOptions;
      }

      vm.mainGridOptions = getMultiselectGridOptions(
        fModel.pageModel.Grids.GridEqRecipient,
        'Equipment/EquipmentSystemList/',
        undefined,
        { field: 'EqSystemId', dir: 'ASC' },
        vm.updateSelectedItems,
        null,
        null,
        true,
        vm.formModel.EqSystemIds,
        vm.formModel.EqSystemDefault
      );

      vm.gridDataBound = function() {
        var grid = this;
        $(this.tbody)
          .find('.fw-select-radiobtn')
          .bind('click', function(e) {
            var row = $(e.target).closest('tr');
            var rowId = grid.dataItem(row).id;
            if (row.find('.fw-select-checkbox').prop('checked')) {
              grid.fw_defaultId = rowId;
              vm.updateDefaultItem(rowId);
              return true;
            } else return false;
          });

        $(this.tbody)
          .find('.fw-select-checkbox')
          .bind('click', function(e) {
            var row = $(e.target).closest('tr');
            var rowId = grid.dataItem(row).EqSystemId;
            if (this.checked) {
              row.addClass('k-state-selected');
              //ha nincs még alapértelmezett, legyen a most kijelölt sor
              if ($('.fw-select-radiobtn:checked').length === 0) {
                row.find('.fw-select-radiobtn').prop('checked', true);
                grid.fw_defaultId = rowId;
              }
              grid.fw_selectedIds[rowId] = true;
            } else {
              row.removeClass('k-state-selected');
              //ha ez volt az alapértelmezett, ki kell venni
              if (row.find('.fw-select-radiobtn').prop('checked')) {
                row.find('.fw-select-radiobtn').prop('checked', false);
                grid.fw_defaultId = 0;
              }
              delete grid.fw_selectedIds[rowId];
            }

            vm.updateDefaultItem(grid.fw_defaultId);
            if (vm.updateSelectedItems) {
              vm.updateSelectedItems(Object.keys(grid.fw_selectedIds));
            }
          });
        if (grid.fw_selectedIds === undefined) {
          grid.fw_selectedIds = {};
          if (this.dataSource._data.length > 0) {
            if (!!vm.formModel.EqSystemIds)
              grid.fw_selectedIds = vm.formModel.EqSystemIds.reduce(function(json, value) {
                json[value] = true;
                return json;
              }, {});

            grid.fw_defaultId = vm.formModel.EqSystemDefault;
            vm.updateDefaultItem(grid.fw_defaultId);

            if (vm.updateSelectedItems) {
              vm.updateSelectedItems(Object.keys(grid.fw_selectedIds));
            }
          }
        }
        var pageData = this.dataSource._data;
        for (var i = 0; i < pageData.length; i++) {
          if (grid.fw_selectedIds[pageData[i].id]) {
            var row = grid.table.find("tr[data-uid='" + pageData[i].uid + "']");
            row.find('.fw-select-checkbox').prop('checked', 'true');
            row.addClass('k-state-selected');
          }
          if (grid.fw_defaultId === pageData[i].id) {
            var row = grid.table.find("tr[data-uid='" + pageData[i].uid + "']");
            row.find('.fw-select-radiobtn').prop('checked', 'true');
          }
        }

        var defaultItem = grid.dataSource.data().find(x => x.EqSystemId == vm.formModel.EqSystemDefault);

        if (defaultItem) {
          var defaultRow = grid.tbody.find("tr[data-uid='" + defaultItem.uid + "']");
          if (defaultRow) {
            defaultRow.find('.fw-select-radiobtn').prop('checked', true);
          }
        }
      };

      vm.gridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign({}, vm.pageModel.Grids['GridEqRecipient'], {
          ControllerMethod: 'Equipment/EquipmentSystemList/',
        }),
        undefined,
        function() {},
        dataBound: vm.gridDataBound,
        function() {},
        multiselect: {
          idField: vm.pageModel.Grids['GridEqRecipient'].IdColumn,
          selectHandler: function(id, checked) {
            console.log(id, checked);
            $scope.$applyAsync();
          },
        },
      });
      vm.gridOptions.columns.splice(1, 0, vm.radioBtnColumn);

      function updateSelectedItems(selectedIds) {
        console.log(selectedIds);
        var items = {};
        for (var i = 0; i < selectedIds.length; i++) {
          var id = selectedIds[i];
          if (!vm.selectedItems[id]) {
            //new selection - should be in the current datasource of the grid
            items[id] = vm.grid.dataSource.get(id);
          } else {
            //old selection - it's possible, that data is not available int the current datasource of the grid due
            //to paging sorting, etc. use the stored record.
            items[id] = vm.selectedItems[id];
          }
        }
        // force a new turn to update the view
        $scope.$apply(function() {
          vm.selectedItems = items;
          vm.selectedIds = selectedIds;
          vm.formModel.EqSystemIds = selectedIds;
        });
      }
      vm.updateDefaultItem = function(selectedIds) {
        $scope.$apply(function() {
          vm.formModel.EqSystemDefault = selectedIds;
        });
      };

      vm.save = function() {
        $http
          .post('Equipment/EquipmentGroup' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikeresen megtörtént!');
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikertelen');
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.EqGroupId;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentGroup', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentQualityNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentQualityNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createEquipmentQuality = createEquipmentQuality;
      vm.editEquipmentQuality = editEquipmentQuality;
      vm.duplicateEquipmentQuality = duplicateEquipmentQuality;
      vm.deleteEquipmentQuality = deleteEquipmentQuality;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.mainGridIdField = 'QualityId';
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridEqQuality,
        'Equipment/EquipmentQualityList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          QualityId: vm.selectedMainGridItemId,
        };
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
      }

      //////////////////////////////////////////
      ////////////// EquipmentQuality operations ///////////
      //////////////////////////////////////////

      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      function createEquipmentQuality() {
        var url = 'Equipment/EquipmentQualityCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Equipment/EquipmentQualityEdit.html',
          controller: 'EquipmentQualityEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editEquipmentQuality() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentQualityEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentQualityEdit.html',
            controller: 'EquipmentQualityEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function duplicateEquipmentQuality() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentQualityDuplicate/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentQualityEdit.html',
            controller: 'EquipmentQualityEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteEquipmentQuality() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = 'Biztosan törölni szeretné a kiválasztott elemet?'; // vm.messages.DeleteDialogConfirmMessage; // Ez undefined.
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Equipment/EquipmentQualityDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentQuality', id);
      }

      function WAL() {
        walService.NavigateToWal('Equipment', 'EquipmentQualityNavWal', 'FlgEquipmentQuality');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgEquipmentQuality', id, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentQualityEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'EditOrDuplicate',
    'AuthService',
    'LockService',
    function(mi, $http, fModel, $stateParams, EditOrDuplicate, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentQualityEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.EditOrDuplicate = EditOrDuplicate;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Equipment/EquipmentQuality' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + 'mentése sikertelen'); // TODO általános label
          });
      };
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.QualityId;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipmentQuality', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentOtherDataNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentOtherDataNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createEquipmentOtherData = createEquipmentOtherData;
      vm.editEquipmentOtherData = editEquipmentOtherData;
      vm.deleteEquipmentOtherData = deleteEquipmentOtherData;
      vm.duplicateEquipmentOtherData = duplicateEquipmentOtherData;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.mainGridIdField = 'EqOtherDataId';

      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      vm.back = function() {
        $state.go('main');
      };

      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridEquipmentOtherData,
        'Equipment/EquipmentOtherDataList/'
      );

      function createEquipmentOtherData() {
        var url = 'Equipment/EquipmentOtherDataCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Equipment/EquipmentOtherDataEdit.html',
          controller: 'EquipmentOtherDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editEquipmentOtherData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentOtherDataEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentOtherDataEdit.html',
            controller: 'EquipmentOtherDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteEquipmentOtherData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Equipment/EquipmentOtherDataDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function duplicateEquipmentOtherData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentOtherDataDuplicate/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentOtherDataEdit.html',
            controller: 'EquipmentOtherDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEqOtherData', id);
      }

      function WAL() {
        walService.NavigateToWal('Equipment', 'EquipmentOtherDataNavWal', 'FlgEqOtherData');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgEqOtherData', id, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentOtherDataEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'EditOrDuplicate',
    'LockService',
    function(mi, $http, fModel, EditOrDuplicate, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentOtherDataEditCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = fModel.dto;
      vm.pageModel = fModel.pageModel;
      vm.messages = fModel.pageModel.Messages;
      vm.labels = fModel.pageModel.Labels;
      vm.actions = fModel.pageModel.Actions;
      vm.EditOrDuplicate = EditOrDuplicate;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelEquipmentOtherDataMod.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Equipment/EquipmentOtherData' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createEquipment = createEquipment;
      vm.editEquipment = editEquipment;
      vm.duplicateEquipment = duplicateEquipment;
      vm.moveEquipment = moveEquipment;
      vm.deleteEquipment = deleteEquipment;

      vm.createSubItem = createSubItem;
      vm.modifySubItem = modifySubItem;
      vm.deleteSubItem = deleteSubItem;

      vm.WAL = WAL;
      vm.WALOnSubGrid = WALOnSubGrid;
      vm.WALOnOtherDataGrid = WALOnOtherDataGrid;

      vm.History = history;
      vm.HistoryOnSubgrid = historyOnSubgrid;
      vm.HistoryOnOtherDataGrid = historyOnOtherDataGrid;

      vm.mainGridIdField = 'EqId';
      vm.mainGrid = null;

      function mainGridRead() {
        if (vm.mainGrid && vm.mainGrid.dataSource) {
          vm.mainGrid.dataSource.read();
        }
      }

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridEquipment,
        'Equipment/EquipmentOtherList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
          setDasModel();
        }
      );

      var generatedSubGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelEqOtherDataLinkSubgrid', 'PanelEquipmentPremiseViewSubgrid'],
        function(gridModel) {
          gridModel.Table;
          return {
            gridModel,
            transportData: {
              tableName: gridModel.Table,
              whereCondition: function() {
                return 'EqId~eq~' + (vm.selectedMainGridItemId || 0);
              },
              adopter: gridModel.Adopter,
              installAdopter: gridModel.InstallAdopter,
              idColumn: gridModel.IdColumn,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
            },
            selectFunction: function onGridSelectChanged(rowData) {
              setDasSubModel();
              $scope.$applyAsync();
            },
          };
        }
      );

      vm.subItemTabs = generatedSubGridTabs.tabs;
      vm.subGrids = generatedSubGridTabs.grids;
      vm.activeSubItemTab = 0;
      var _pendingSubGridRead = false;

      function getActiveSubGrid() {
        var gridKey = vm.subGrids[vm.activeSubItemTab];
        return gridKey !== undefined ? vm.subGrids[gridKey] : undefined;
      }

      function activeSubGridRead() {
        var activeSubGrid = getActiveSubGrid();
        if (activeSubGrid && activeSubGrid.dataSource) {
          _pendingSubGridRead = false;
          activeSubGrid.dataSource.read();
        } else {
          _pendingSubGridRead = true;
        }
      }

      $scope.$watch(
        function() {
          return vm.activeSubItemTab;
        },
        function(newVal, oldVal) {
          if (_pendingSubGridRead) {
            activeSubGridRead();
          }
        }
      );

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          EqId: vm.selectedMainGridItemId,
        };
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          setDasModel();
          return;
        }
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        activeSubGridRead();
      }

      //////////////////////////////////////////
      ////////////// Equipment operations ///////////
      //////////////////////////////////////////

      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      function createEquipment() {
        var url = 'Equipment/EquipmentCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Equipment/EquipmentEdIt.html',
          controller: 'EquipmentEditCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          mainGridRead();
        });
      }

      function editEquipment() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentEdit.html',
            controller: 'EquipmentEditCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            mainGridRead();
          });
        }
      }

      function duplicateEquipment() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Equipment/EquipmentDuplicate/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Equipment/EquipmentEdit.html',
            controller: 'EquipmentEditCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: RouteResolveFunc(url),
              EditOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            mainGridRead();
          });
        }
      }

      function deleteEquipment() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = 'Biztosan törölni szeretné a kiválasztott elemet?'; // vm.messages.DeleteDialogConfirmMessage; // Ez undefined.
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Equipment/EquipmentDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    mainGridRead();
                  });
                },
              },
            },
          });
        }
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridEquipment'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (!selectedItems || selectedItems.length === 0) {
          return;
        }
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        //$scope.$apply();
      }

      function setDasSubModel() {
        var activeSubGrid = getActiveSubGrid();
        if (!activeSubGrid) {
          return;
        }
        var dasDescriptor = vm.pageModel.Grids[vm.subGrids[vm.activeSubItemTab]].DasDescriptor;
        var selectedItems = GetSelectedGridItems(activeSubGrid);
        vm.dasSubModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        //$scope.$apply();
      }

      function WAL() {
        walService.NavigateToWal('Equipment', 'EquipmentNavWal', 'FlgEquipmentView');
      }

      function WALOnSubGrid() {
        walService.NavigateToWal('Equipment', 'EquipmentPremiseNavWal', 'FlgEquipmentPremiseView');
      }

      function WALOnOtherDataGrid() {
        walService.NavigateToWal('Equipment', 'EqOtherDataLinkNavWal', 'FlgEqOtherDataLinkView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgEquipment', id, vm, $state, true);
        }
      }

      function historyOnSubgrid() {
        var selectedItems = GetSelectedGridItems(getActiveSubGrid());
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0]['InventoryId'];
          HistoryService.NavigateToHistory('FlgRoomInventory', id, vm, $state, true);
        }
      }

      function historyOnOtherDataGrid() {
        var selectedItems = GetSelectedGridItems(getActiveSubGrid());
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0]['EqOtherDataLinkId'];
          HistoryService.NavigateToHistory('FlgEqOtherDataLink', id, vm, $state, true);
        }
      }

      function createSubItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Property/RoomInventoryCreateEquipment/';
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Property/RoomInventoryEditModal.html',
            controller: 'RoomInventoryEditCtrl',
            controllerAs: 'vm',
            size: 'xl',
            resolve: {
              options: RouteResolveFunc(url, {
                EquipmentId: id,
              }),
              $stateParams: {
                controllerOptions: { isFormReadOnly: false },
                EditOrDuplicate: 'Edit',
                Security: 'Equipment',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            var activeSubGrid = getActiveSubGrid();
            if (activeSubGrid && activeSubGrid.dataSource) {
              activeSubGrid.dataSource.read();
            }
          });
        }
      }

      function modifySubItem(isReadOnly, isDuplicate) {
        var selectedSubItems = GetSelectedGridItems(getActiveSubGrid());
        if (selectedSubItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var url = 'Property/RoomInventoryEditEquipment/';
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Property/RoomInventoryEditModal.html',
            controller: 'RoomInventoryEditCtrl',
            controllerAs: 'vm',
            size: 'xl',
            resolve: {
              options: RouteResolveFunc(url, {
                id: selectedSubItems[0]['InventoryId'],
              }),
              $stateParams: {
                controllerOptions: { isFormReadOnly: isReadOnly },
                EditOrDuplicate: isDuplicate === true ? 'Duplicate' : 'Edit',
                Security: 'EquipmentAndPremise',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            var activeSubGrid = getActiveSubGrid();
            if (activeSubGrid && activeSubGrid.dataSource) {
              activeSubGrid.dataSource.read();
            }
          });
        }
      }

      vm.hasValidTo = function() {
        var selectedItems = GetSelectedGridItems(getActiveSubGrid());
        return selectedItems[0]?.ValidTo != null ? true : false;
      };

      function moveEquipment() {
        var selectedItems = GetSelectedGridItems(getActiveSubGrid());
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var url =
            'Property/EquipmentMove?InventoryId=' +
            selectedItems[0].InventoryId +
            '&PremiseId=' +
            selectedItems[0].PremiseId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Property/EquipmentMoveModal.html',
            controller: 'EquipmentMoveModalCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            var activeSubGrid = getActiveSubGrid();
            if (activeSubGrid && activeSubGrid.dataSource) {
              activeSubGrid.dataSource.read();
            }
          });
        }
      }

      function deleteSubItem() {
        var selectedSubItems = GetSelectedGridItems(getActiveSubGrid());
        if (selectedSubItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get('Property/RoomInventoryDeleteEquipment/' + selectedSubItems[0]['InventoryId'])
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      var activeSubGrid = getActiveSubGrid();
                      if (activeSubGrid && activeSubGrid.dataSource) {
                        activeSubGrid.dataSource.read();
                      }
                    });
                },
              },
            },
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EquipmentEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'EditOrDuplicate',
    'AuthService',
    'LockService',
    function(mi, $http, fModel, $stateParams, EditOrDuplicate, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EquipmentEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.pageModelODL = fModel.pageModelODL;
      vm.EditOrDuplicate = EditOrDuplicate;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //Multiformon ne jelenjen meg a fejléc:
      vm.pageModelODL.Fields.EqOtherDataLinkId.FormlyFieldDescriptor.templateOptions.options[
        'hideLabelFromHEader'
      ] = true;

      vm.formModel = fModel.dto;

      var onChangeFunctions = {
        EqOtherDataId: function(value, model) {
          model['EqOtherDataType'] = this.sObject.extraProperties.filter(x => x.key == 'OtherDataType')[0].value;
          console.log(
            'EqOtherDataId',
            value,
            this.sObject.extraProperties.filter(x => x.key == 'OtherDataType')[0].value,
            model
          );
        },
        EqGroupId: function(selectedItem) {
          if (selectedItem) {
            setOtherDataGrid(selectedItem.key);
            vm.formModel.HelpDeskPriorityId = selectedItem.extraProperties.getField('HelpDeskPriorityId').value;
          }
        },
      };
      var syncValidators = {
        Price: {
          PriceValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return /^[0-9]*(,[0-9]{1,2})?$/.test(modelValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var onChangeFunctionsODL = {
        EqOtherDataId: function(value, model) {
          model['EqOtherDataType'] = this.sObject.extraProperties.filter(x => x.key == 'OtherDataType')[0].value;
          console.log(
            'EqOtherDataId',
            value,
            this.sObject.extraProperties.filter(x => x.key == 'OtherDataType')[0].value,
            model
          );
        },
      };
      var hideExpressionsODL = {
        ValueBool: function($viewValue, $modelValue, scope) {
          return !(scope.model.EqOtherDataType == 'FTYBO');
        },
        ValueString: function($viewValue, $modelValue, scope) {
          return !(scope.model.EqOtherDataType == 'FTYTE') && !!scope.model.EqOtherDataType;
        },
        ValueDate: function($viewValue, $modelValue, scope) {
          return !(scope.model.EqOtherDataType == 'FTYDA');
        },
        ValueNumber: function($viewValue, $modelValue, scope) {
          return !(scope.model.EqOtherDataType == 'FTYNU');
        },
      };

      var onClickFunctionsODL = {
        EqOtherDataLinkId: function(value, model, event) {
          vm.formModel.EquipmentOtherDataLink = vm.formModel.EquipmentOtherDataLink.filter(
            item => item.$$hashKey !== model.$$hashKey
          );
        },
      };

      InsertOnChangeFunctions(vm.pageModelODL, onChangeFunctionsODL);
      InsertHideExpressions(vm.pageModelODL, hideExpressionsODL);
      InsertOnClickFunctions(vm.pageModelODL, onClickFunctionsODL);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Equipment/Equipment' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikertelen'); // TODO általános label
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.EqId;
        dasService.NavigateToDas(vm.messages, 'Equipment.EquipmentDasDocumentsNav', 'FlgEquipment', id);
      };

      function setOtherDataGrid(eqId) {
        if (!!vm.formModel.EquipmentOtherDataLink && vm.formModel.EquipmentOtherDataLink.length > 0) {
          bootbox.dialog({
            message: vm.pageModel.Labels.LabelODLoadQuestion.Title,
            title: vm.pageModel.Messages.Warning,
            closeButton: false,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  getOtherData(eqId);
                },
              },
            },
          });
        } else {
          getOtherData(eqId);
        }
      }

      function getOtherData(eqId) {
        $http.get('Equipment/GetEquipmentOtherDataList/' + eqId).then(function(result) {
          vm.formModel.EquipmentOtherDataLink = result.data.Value;
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EventLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EventNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$window',
    '$uibModal',
    'WalService',
    'DasService',
    'UIHelperService',
    function($scope, options, $http, $state, $window, $uibModal, walService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.filterModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.UIHelperService = UIHelperService;
      // MenuItems
      vm.createMainItem = createMainItem;
      vm.editMainItem = editMainItem;
      vm.deleteMainItem = deleteMainItem;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      //vm.filter = filter;
      vm.back = function() {
        $state.go('main');
      };

      vm.getFilter = function() {
        return {
          dto: vm.filterModel,
        };
      };

      // Set combo default
      vm.filterModel.EventTypeId = localStorage.getItem('EventType');
      if (vm.filterModel.EventTypeId === null || vm.filterModel.EventTypeId === '') {
        vm.filterModel.EventTypeId = 'EVTCC';
        localStorage.setItem('EventType', vm.filterModel.EventTypeId);
      }
      // Grid configuration
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.mainGridIdField = vm.pageModel.Grids['GridEventCC'].IdColumn;

      vm.gridCc = $('#gridCc').data('kendoGrid');
      vm.gridDm = $('#gridDm').data('kendoGrid');
      vm.gridVc = $('#gridVc').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.gridCcOptions = getGridOptions(
        options.pageModel.Grids.GridEventCC,
        'Event/ListCc/',
        function() {},
        vm.getFilter
      );

      vm.gridCcOptions.columns.filter(function(item) {
        if (item.field === 'Alert') item.format = '{0} nap';
      });

      vm.gridDmOptions = getGridOptions(
        options.pageModel.Grids.GridEventDM,
        'Event/ListDm/',
        function() {},
        vm.getFilter
      );

      vm.gridVcOptions = getGridOptions(
        options.pageModel.Grids.GridEventVC,
        'Event/ListVc/',
        function() {},
        vm.getFilter
      );

      vm.gridDmOptions.columns.filter(function(item) {
        if (item.field === 'Alert') item.format = '{0} nap';
      });

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////// [ Dynamic SubItem Form generation] ///////////////////////////
      vm.activeSubItemTab = 0;
      vm.getSelectedMainGridItemId = function() {
        return {
          targetEventId: vm.slectedMainGridItemId,
        };
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Filter fields ] //////////////////////////////////////////
      //
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.filterFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new main item
      function createMainItem() {
        //localStorage.setItem('EventType', vm.filterModel.EventTypeId);
        if (vm.filterModel.EventTypeId === 'EVTCC') {
          var refreshGrid = vm.gridCc;
        } else if (vm.filterModel.EventTypeId === 'EVTVC') {
          var refreshGrid = vm.gridVc;
        } else {
          var refreshGrid = vm.gridDm;
        }
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Event/EventEdit.html',
          controller: 'EventEditCtrl',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('Event/EventCreate/0'),
            parameter: {
              CreateOrEdit: 'Create',
              EventTypeId: vm.filterModel.EventTypeId,
            },
          },
        });

        modalInstance.result.then(function() {
          refreshGrid.dataSource.read();
        });
      }

      /// Edits the selected main item
      function editMainItem() {
        if (vm.filterModel.EventTypeId === 'EVTCC') {
          var selectedItems = GetSelectedGridItems(vm.gridCc);
          var refreshGrid = vm.gridCc;
        } else if (vm.filterModel.EventTypeId === 'EVTVC') {
          var selectedItems = GetSelectedGridItems(vm.gridVc);
          var refreshGrid = vm.gridVc;
        } else {
          var selectedItems = GetSelectedGridItems(vm.gridDm);
          var refreshGrid = vm.gridDm;
        }
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Event/EventEdit.html',
            controller: 'EventEditCtrl',
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              options: RouteResolveFunc('Event/EventEdit/' + id),
              parameter: {
                CreateOrEdit: 'Edit',
                EventTypeId: vm.filterModel.EventTypeId,
              },
            },
          });

          modalInstance.result.then(function() {
            refreshGrid.dataSource.read();
          });
        }
      }

      var onChangeFunctions = {
        EventTypeId: function(selectedItem) {
          vm.filterModel.EventTypeId = selectedItem.key;
          localStorage.setItem('EventType', vm.filterModel.EventTypeId);
          //refresh grid by EventType
          if (vm.filterModel.EventTypeId === 'EVTDM') vm.gridDm?.dataSource.read();
          if (vm.filterModel.EventTypeId === 'EVTVC') vm.gridVc?.dataSource.read();
          else vm.gridCc?.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      function deleteMainItem() {
        if (vm.filterModel.EventTypeId === 'EVTCC') {
          var selectedItems = GetSelectedGridItems(vm.gridCc);
          var refreshGrid = vm.gridCc;
        } else if (vm.filterModel.EventTypeId === 'EVTVC') {
          var selectedItems = GetSelectedGridItems(vm.gridVc);
          var refreshGrid = vm.gridVc;
        } else {
          var selectedItems = GetSelectedGridItems(vm.gridDm);
          var refreshGrid = vm.gridDm;
        }

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.EventDeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Event/EventDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    refreshGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        if (vm.filterModel.EventTypeId === 'EVTCC') {
          var selectedItems = GetSelectedGridItems(vm.gridCc);
          var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
          dasService.NavigateToDas(vm.messages, 'Service.Event.EventDasDocumentsNav', 'FlgReminderCCView', id);
        } else if (vm.filterModel.EventTypeId === 'EVTVC') {
          var selectedItems = GetSelectedGridItems(vm.gridVc);
          var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
          dasService.NavigateToDas(vm.messages, 'Service.Event.EventDasDocumentsNav', 'FlgReminderVCView', id);
        } else {
          var selectedItems = GetSelectedGridItems(vm.gridDm);
          var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
          dasService.NavigateToDas(vm.messages, 'Service.Event.EventDasDocumentsNav', 'FlgReminderDMView', id);
        }
      }

      function WAL() {
        if (vm.filterModel.EventTypeId === 'EVTCC') {
          walService.NavigateToWal('Event', 'EventCCNavWal', 'FlgReminderCCView');
        } else if (vm.filterModel.EventTypeId === 'EVTVC') {
          walService.NavigateToWal('Event', 'EventCCNavWal', 'FlgReminderVCView');
        } else {
          walService.NavigateToWal('Event', 'EventDMNavWal', 'FlgReminderDMView');
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EventNavMenuCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'gridService',
    function($scope, options, $http, $state, $uibModal, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventNavMenuCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      // MenuItems
      vm.createMainItem = createMainItem;
      vm.editMainItem = editMainItem;
      vm.deleteMainItem = deleteMainItem;
      vm.duplicateMainItem = duplicateMainItem;
      vm.viewMainItem = viewMainItem;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      // Grid configuration
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.mainGridIdField = vm.pageModel.Grids['GridEvent'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridEvent, 'Event/List/', function() {
        changeSubItemGridFilter(vm.mainGrid);
      });

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////// [ Dynamic SubItem Form generation] ///////////////////////////
      vm.activeSubItemTab = 0;
      vm.getSelectedMainGridItemId = function() {
        return {
          targetEventId: vm.slectedMainGridItemId,
        };
      };
      //console.log(vm.pageModel);
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Event/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      // Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          return;
        }

        vm.slectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          value.dataSource.read();
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new main item
      function createMainItem() {
        $state.go('Service.Event.Create', { id: 0 });
      }

      /// Edits the selected main item
      function editMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Service.Event.Edit', { id: id });
        }
      }

      function deleteMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = selectedItems[0][vm.mainGridIdField];
        if (!!id) {
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var dialogMessage;

            if (selectedItems[0]['CountTM'] === 1) {
              dialogMessage = vm.messages.EventDeleteDialogConfirmMessage2;
            } else {
              var validFrom = new moment(
                selectedItems[0]['ValidFrom'],
                kendo.culture().calendar.patterns.d.toUpperCase()
              );
              dialogMessage = vm.messages.EventDeleteDialogConfirmMessage1.replace(
                '{0}',
                validFrom.format(kendo.culture().calendar.patterns.d.toUpperCase())
              );
            }

            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http.get('Event/EventDelete/' + id).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.mainGrid.dataSource.read();
                    });
                  },
                },
              },
            });
          }
        }
      }

      /// Duplicates the selected main item
      function duplicateMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Service.Event.Duplicate', { id: id }); // TODO
        }
      }

      /// Opens a non-modifyable view for the selected item
      function viewMainItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Service.Event.View', { id: id });
        }
      }
      function attachDocument() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }

      function WAL() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('EventEditCtrl', [
    '$uibModalInstance',
    '$scope',
    'DasService',
    'options',
    'parameter',
    '$http',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    'LockService',
    function(mi, $scope, dasService, options, parameter, $http, $state, $stateParams, $window, $q, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventEditCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.eventModel = options.dto;
      vm.pageModel = options.pageModel;

      vm.messages = options.pageModel.Messages;
      vm.CreateOrEdit = parameter.CreateOrEdit;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      if (!vm.eventModel.Type) {
        vm.eventModel.Type = !!parameter.EventTypeId ? parameter.EventTypeId : 'EVTDM'; //CC!!!
      }

      //Ha konkrét típussal jött, akkor a Type-t el kell rejteni (ha nincs paraméter, akkor nem navigációból jött)
      vm.hideTypeSelector = !!parameter.EventTypeId;

      vm.Selection = vm.eventModel.Selection;
      vm.selectionGrid = $('#selectionGrid').data('kendoGrid');

      //mező áthelyezés típustól függően:---------------
      // if (vm.eventModel.Type === 'EVTDM') {
      // vm.pageModel.Fields.Alert.FieldOrder = 2;
      // vm.pageModel.Fields.Comment.FieldOrder = 2;
      // vm.pageModel.Fields.Comment.FieldGroup = 5;
      // vm.pageModel.Fields.Comment.FormlyFieldDescriptor.className = vm.pageModel.Fields.Comment.FormlyFieldDescriptor.className.replace(
      // 'col-md-12',
      // 'col-md-6'
      // );
      // }
      //------------------------------------------------

      // MenuItems
      vm.save = saveItem;
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
      vm.attachDocument = function() {
        var id = vm.eventModel.ReminderId;
        dasService.NavigateToDas(
          vm.messages,
          'Service.Event.EventDasDocumentsNav',
          vm.eventModel.Type === 'EVTCC' ? 'FlgReminderCCView' : 'FlgReminderDMView',
          id
        );
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};
      // Usage: "fieldName": "className"
      var customClasses = {};
      var customExpressionProperties = {
        StatusBool: {
          'templateOptions.disabled': function() {
            return /*vm.eventModel.Type === "EVSAC" ||*/ vm.CreateOrEdit === 'Create';
          },
        },
        tableid: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTDM' || vm.eventModel.Type === 'EVTVC';
          },
          'templateOptions.tooltipToLabel': function() {
            return vm.eventModel.Type === 'EVTVC'
              ? 'Azon táblák közül választhat,<br>amelyekre a Történetiség<br>funkció be van kapcsolva.'
              : 'Azon táblák közül választhat,<br>amelyekben van dátum mező.';
          },
        },
        columnid: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTDM';
          },
        },
        EventDate: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTCC';
          },
        },
        StartDate: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTVC';
          },
        },
        NoticeDataColumnId: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTDM' || vm.eventModel.Type === 'EVTVC';
          },
        },
        DataChangeType: {
          'templateOptions.required': function() {
            return vm.eventModel.Type === 'EVTVC';
          },
        },
      };
      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        tableid: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type === 'EVTCC';
        },
        columnid: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type !== 'EVTDM';
        },
        Query: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type === 'EVTCC';
        },
        EventDate: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type !== 'EVTCC';
        },
        Type: function($viewValue, $modelValue, scope) {
          return vm.hideTypeSelector;
        },
        NoticeDataColumnId: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type === 'EVTCC';
        },
        DataChangeType: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type !== 'EVTVC';
        },
        StartDate: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type !== 'EVTVC';
        },
        Alert: function($viewValue, $modelValue, scope) {
          return vm.eventModel.Type === 'EVTVC';
        },
      };
      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        Type: function(selectedItem) {
          vm.rowCnt = 0;
          vm.row.empty();
          vm.eventModel.tableid = null;
          vm.eventModel.columnid = null;
          vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            tableid: '',
            filtered: true,
          };

          vm.pageModel.Fields.tableid.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            eventType: vm.eventModel.Type,
          };

          vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          vm.pageModel.Fields.tableid.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },

        tableid: function(selectedItem) {
          if (typeof vm.eventModel.tableid !== 'undefined' && vm.eventModel.tableid !== null) {
            //add parameter
            vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              tableid: vm.eventModel.tableid,
              filtered: true,
            };
            vm.pageModel.Fields.NoticeDataColumnId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              tableid: vm.eventModel.tableid,
            };
            vm.pageModel.Fields.NoticeDataColumnId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();

            vm.rowCnt = 0;
            vm.clearGrid();
            vm.valueFieldDataSource.read();
            vm.leftSideDataSource.read();
            //tábla idmezője:
            vm.eventModel.idcolumn = selectedItem.extraProperties[0].value;
          }
          //vm.row = new kendo.data.ObservableArray([]);
          //reload
          vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        groupid: function(selectedItem) {
          vm.pageModel.Fields.Users.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            adopter: 'a_flgr',
            groupid: selectedItem.key.trim(),
          };
          vm.pageModel.Fields.Users.FormlyFieldDescriptor.templateOptions.selectedItems = [];
          vm.pageModel.Fields.Users.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          setDataModelFromMultiSelect('Users');
        },
        Users: function(selectedItem) {
          // TODO ?
        },
      };
      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};
      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};
      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};
      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};
      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};
      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      var dynamicQueryParameters = {
        columnid: function() {
          var tableId = !!vm.formModel && !!vm.formModel.tableid ? vm.formModel.tableid.Value : 0;
          return [
            {
              key: tableId,
              text: 'tableid',
            },
            {
              key: false,
              text: 'filtered',
            },
          ];
        },
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.pageModel.Fields.Users.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.Users.FormlyFieldDescriptor.templateOptions.options.placeHolder = 'Összes';

      vm.pageModel.Fields.NoticeDataColumnId.FormlyFieldDescriptor.type = 'kendoMS';

      vm.pageModel.Fields.EventDate.FormlyFieldDescriptor.templateOptions.DateTimeOptions.customEdit = true;
      vm.pageModel.Fields.Alert.FormlyFieldDescriptor.templateOptions.options.format = '0 nap';
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      //Set editability of fields based on controllerOptions
      // Ha kezelt vagy readonly:
      // if (vm.eventModel.IsReadOnly) {
      // //vm.eventModel.IsReadOnly = true;
      // angular.forEach(vm.pageModel.Fields, function(value, key) {
      // value.FormlyFieldDescriptor.templateOptions.disabled = true;
      // });
      // }

      // Ha módosítás és DM:
      // if (
      // !vm.eventModel.IsReadOnly &&
      // vm.eventModel.Status === 'EVSIN' &&
      // vm.CreateOrEdit !== 'Create' &&
      // vm.eventModel.Type === 'EVTDM'
      // ) {
      // // nem letiltandó mezők:
      // var notReadOnlyFields = ['Name', 'Comment', 'StatusBool'];
      // angular.forEach(vm.pageModel.Fields, function(value, key) {
      // value.FormlyFieldDescriptor.templateOptions.disabled = notReadOnlyFields.indexOf(key) === -1;
      // });
      // }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      //Fire tableid onchangefunc...
      if (
        vm.eventModel.tableid !== undefined &&
        vm.eventModel.tableid !== null &&
        vm.eventModel.tableid.trim() !== ''
      ) {
        vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          tableid: vm.eventModel.tableid,
        };
        vm.pageModel.Fields.columnid.FormlyFieldDescriptor.templateOptions.options.dataSource.read();

        vm.pageModel.Fields.NoticeDataColumnId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          tableid: vm.eventModel.tableid,
        };
        vm.pageModel.Fields.NoticeDataColumnId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      ////Init Users Parameters...
      if (
        vm.eventModel.groupid !== undefined &&
        vm.eventModel.groupid !== null &&
        vm.eventModel.groupid.trim() !== ''
      ) {
        vm.pageModel.Fields.Users.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          adopter: 'FLGR',
          groupid: vm.eventModel.groupid.trim(),
        };
      }

      vm.pageModel.Fields.tableid.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        eventType: vm.eventModel.Type,
      };

      function setDataModelFromMultiSelect(field) {
        vm.eventModel[field] = vm.pageModel.Fields[field].FormlyFieldDescriptor.templateOptions.selectedItems.join();
      }

      function selectionGridAsSendableObject() {
        var selectionGridObjectArray = [];
        var selectionGrid = vm.selectionGrid.dataSource.data();

        if (selectionGrid.some(x => !x.LeftSide.key)) {
          toastr.error('A szelekcióban érték nélküli sor szerepel.', 'Hiba a szelekcióban!');
          return false;
        }

        angular.forEach(selectionGrid, function(row, key) {
          selectionGridObjectArray.push({
            id: row.RowId,
            LeftSideKey: row.LeftSide.key,
            LeftSideText: row.LeftSide.text,
            Negation: row.Negotation,
            Relation: row.Relation.id,
            RightSideType: row.Type,
            RightSideKey: !!row.ValueField.Value
              ? row.ValueField.Value
              : !!row.ValueField.key
              ? row.ValueField.key
              : typeof row.ValueField === 'object'
              ? row.ValueField.join(',')
              : row.ValueField,
            RightSideText: row.ValueField.text,
          });
        });
        return selectionGridObjectArray;
      }

      /// Saves the current main item
      function saveItem() {
        setDataModelFromMultiSelect('Users');

        if (vm.selectionGrid) {
          if (!vm.updateQueryFromSelections()) {
            return false;
          }
          vm.eventModel.Selection = selectionGridAsSendableObject();
          vm.eventModel.FilterCnt = vm.rowCnt;
        }

        if (vm.eventModel.Selection !== false) {
          $http
            .post('Event/EventEdit', vm.eventModel)
            .then(function(response) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              mi.close();
            })
            .catch(function onError(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        }
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
      vm.isCollapsed3 = false;

      // #region ValueField DataSource and combobox --------------------------------------------------------------------------------

      vm.valueFieldDataSource = new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Event/ForrasTablestrComboList',
            dataType: 'json',
            data: {
              tableid: function() {
                return vm.eventModel.tableid;
              },
              filtered: false, // minden mező látszódik
            },
          },
        },
        schema: {
          data: 'data',
        },
      });

      vm.getRightSideDDlOptions = function(clone) {
        return {
          //autoBind: false,
          optionLabel: 'Kérem, válasszon...',
          dataTextField: 'text',
          dataValueField: 'key',
          dataSource: clone ? angular.copy(vm.valueFieldDataSource) : vm.valueFieldDataSource,
        };
      };

      // #endregion ValueField DataSource and combobox -----------------------------------------------------------------------------
      // #region LeftSideField DataSource and combobox --------------------------------------------------------------------------------
      vm.leftSideDataSource = new kendo.data.DataSource({
        transport: {
          read: {
            url: 'Event/ForrasTablestrComboList',
            dataType: 'json',
            data: {
              tableid: function() {
                return vm.eventModel.tableid;
              },
              filtered: false, // minden mező látszódik
            },
          },
        },
        schema: {
          data: 'data',
        },
      });
      vm.leftFieldOption = {
        autoWidth: true,
        optionLabel: 'Kérem, válasszon...',
        dataTextField: 'text',
        dataValueField: 'key',
        change: function(e) {
          var grid = $('#selectionGrid').data('kendoGrid');
          var rowUniqId = $(e.sender.element)
            .closest('tr')
            .index();
          vm.row[rowUniqId].ngIf = false;
          //Ha bit típusú lesz, akkor false-val kell feltölteni, egyébként null
          if (!!vm.row[rowUniqId].LeftSide.extraProperties) {
            vm.row[rowUniqId].ValueField =
              !!vm.row[rowUniqId].LeftSide.extraProperties[2] &&
              !!vm.row[rowUniqId].LeftSide.extraProperties[2].value &&
              vm.row[rowUniqId].LeftSide.extraProperties[2].value == 'bit'
                ? false
                : null;
            //Ha változik a bal oldal fel kell szűrni a jobb oldali combot
            if (vm.row[rowUniqId].LeftSide.extraProperties[0].value != '') {
              //beállítom az options egy részét:
              vm.row[rowUniqId].ValueField = {
                value: null,
                options: {
                  name: vm.row[rowUniqId].LeftSide.key,
                  modalTitle: vm.row[rowUniqId].LeftSide.text,
                  filteringMode: 0,
                  gridOptions: {},
                },
              };
              vm.row[rowUniqId].f2options = {
                name: vm.row[rowUniqId].LeftSide.key,
                modalTitle: vm.row[rowUniqId].LeftSide.text,
                filteringMode: 0,
                gridOptions: {},
              };

              var tableName = vm.row[rowUniqId].LeftSide.extraProperties[0].value;
              $http
                .post('F22/GetDynamicF22FieldModel', {
                  installAdopter:
                    vm.pageModel.Fields.F22ForAdopterData.FormlyFieldDescriptor.templateOptions.DynamicOptions
                      .InstallAdopter,
                  adopter:
                    vm.pageModel.Fields.F22ForAdopterData.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter,
                  table: tableName.includes(':') ? tableName.split(':')[1] : tableName,
                  key: vm.row[rowUniqId].LeftSide.extraProperties[1].value,
                  value: '',
                  freeText: false,
                  writable: false,
                  filteringMode: 0,
                  patternMatchMode: 0,
                })
                .then(function(result) {
                  // Set it on the appropriate f22 value input
                  var f22_fieldModel = result.data;
                  // generate options by field model
                  f22_fieldModel.templateOptions.DynamicOptions.ModalTitle = vm.row[rowUniqId].LeftSide?.text;
                  F22Helpers.setF22Options(f22_fieldModel);
                  vm.row[rowUniqId].f2options = f22_fieldModel.templateOptions.options;
                  vm.row[rowUniqId].f2options.singleTagType = true;
                  vm.row[rowUniqId].f2options.singleTagNumber = 0;
                  // re-init f22 with bound ngif
                  vm.row[rowUniqId].ngIf = true;
                });
            }

            var _type = vm.row[rowUniqId].LeftSide.extraProperties[2].value;
            //Mezőtípus beírása változóba, hogy a dateTime mezőket ISO dátumra tudjuk konvertálni
            vm.row[rowUniqId].FieldType = _type;
            //Értékmező filterezése:
            if (!!vm.row[rowUniqId].ValueFieldOption) {
              if (!!_type && !!vm.row[rowUniqId].LeftSide.extraProperties[0].value) {
                vm.row[rowUniqId].ValueFieldOption.dataSource.filter([
                  { field: 'extraProperties[2].value', operator: 'equal', value: _type },
                ]);
              } else {
                vm.row[rowUniqId].ValueFieldOption.dataSource.filter([]);
              }
            }
          }
          $scope.$applyAsync();
        },
        dataSource: vm.leftSideDataSource,
        dataBound: function(e) {
          // //Felül kell írni az értéket, mert betöltésnél nincs extraProperties...
          if (vm.eventModel.IsReadOnly || vm.eventModel.ModelState === 3) {
            var rowUniqId = $(e.sender.element)
              .closest('tr')
              .index();
            var dataItem = e.sender.dataItem(e.item);
            if (dataItem.ModelState !== undefined) {
              vm.row[rowUniqId].LeftSide = e.sender.dataItem(e.item);
              vm.row[rowUniqId].FieldType = vm.row[rowUniqId].LeftSide.extraProperties[2].value;

              if (!vm.row[rowUniqId].ValueField.Text && vm.row[rowUniqId].LeftSide.extraProperties[0].value !== '') {
                vm.row[rowUniqId].ValueField =
                  vm.row[rowUniqId].Relation.id === 5
                    ? vm.row[rowUniqId].ValueField.split(',')
                    : {
                        Text: vm.row[rowUniqId].ValueField,
                        Value: vm.row[rowUniqId].ValueField,
                        //options: {},
                      };
                vm.row[rowUniqId].f2options = {};

                var tableName = vm.row[rowUniqId].LeftSide.extraProperties[0].value;
                $http
                  .post('F22/GetDynamicF22FieldModel', {
                    installAdopter:
                      vm.pageModel.Fields.F22ForAdopterData.FormlyFieldDescriptor.templateOptions.DynamicOptions
                        .InstallAdopter,
                    adopter:
                      vm.pageModel.Fields.F22ForAdopterData.FormlyFieldDescriptor.templateOptions.DynamicOptions
                        .Adopter,
                    table: tableName.includes(':') ? tableName.split(':')[1] : tableName,
                    key: vm.row[rowUniqId].LeftSide.extraProperties[1].value,
                    value: '',
                    freeText: false,
                    writable: false,
                    filteringMode: 0,
                    patternMatchMode: 0,
                  })
                  .then(function(result) {
                    // Set it on the appropriate f22 value input
                    var f22_fieldModel = result.data;
                    // generate options by field model
                    f22_fieldModel.templateOptions.DynamicOptions.ModalTitle = vm.row[rowUniqId].LeftSide?.text;
                    F22Helpers.setF22Options(f22_fieldModel);
                    vm.row[rowUniqId].f2options = f22_fieldModel.templateOptions.options;
                    vm.row[rowUniqId].f2options.singleTagType = true;
                    vm.row[rowUniqId].f2options.singleTagNumber = 0;
                    // re-init f22 with bound ngif
                    vm.row[rowUniqId].ngIf = true;
                  });
                //$scope.$apply();
              }
            }
            //$scope.$apply();
          }
        },
      };
      // #endregion valueField DataSource and combobox

      // #region relation DataSource and combobox --------------------------------------------------------------------------------
      vm.relationDDV_option = {
        dataTextField: 'name',
        dataValueField: 'id',
        dataSource: {
          data: [
            { operation: '=', name: '= egyenlő', id: 0 },
            { operation: '<', name: '< kisebb', id: 1 },
            { operation: '>', name: '> nagyobb', id: 2 },
            { operation: '$', name: '$ tartalmazza', id: 3 },
            { operation: '@', name: '@ kezdete', id: 4 },
            { operation: ':', name: ': felsorolás', id: 5 },
            { operation: '%', name: '% minta', id: 6 },
            { operation: '^', name: '^ mintalista', id: 7 },
          ],
        },
      };
      vm.relationDDVf_option = {
        dataTextField: 'name',
        dataValueField: 'id',
        dataSource: {
          data: [
            { operation: '=', name: '= egyenlő', id: 0 },
            { operation: '<', name: '< kissebb', id: 1 },
            { operation: '>', name: '> nagyobb', id: 2 },
          ],
        },
      };
      // #endregion Relation DataSource and combobox --------------------------------------------------------------------------------
      // #region type DataSource and combobox --------------------------------------------------------------------------------
      vm.typeDDE_option = {
        dataTextField: 'name',
        dataValueField: 'id',
        dataSource: {
          data: [
            { name: 'Érték', id: 0 },
            { name: 'Értékmező', id: 1 },
          ],
        },
        change: function(e) {
          //Ha változik a jobb oldal mező típusa, töröljük az értéket
          var grid = $('#selectionGrid').data('kendoGrid');
          var rowUniqId = $(e.sender.element)
            .closest('tr')
            .index();
          delete vm.row[rowUniqId].ValueField;
          $scope.$applyAsync();
        },
      };
      // #endregion type DataSource and combobox -----------------------------------------------------------------------------

      vm.rowCnt = 0;
      vm.row = new kendo.data.ObservableArray([]);

      vm.selectionGridOpt = {
        dataBound: function(options) {
          //
        },
        dataSource: {
          transport: {
            read: function(options) {
              //Ha create, akkor az üres vm.rowt, hozzácsatolom.
              vm.rowCnt = vm.eventModel.FilterCnt;
              angular.forEach(vm.Selection, function(item, key) {
                //add extraproperties to dataModel:
                var extraProperties = [];
                if (!!item.LeftSideExtraproperties) {
                  extraProperties.push({ key: 'jointable', value: item.LeftSideExtraproperties.JoinTable });
                  extraProperties.push({ key: 'joinfield', value: item.LeftSideExtraproperties.JoinField });
                  extraProperties.push({ key: 'datatype', value: item.LeftSideExtraproperties.DataType });
                }

                vm.row.push({
                  rowNum: 0,
                  RowId: item.Id,
                  Type: item.RightSideType,
                  LeftSide: { key: item.LeftSideKey, extraProperties: extraProperties },
                  Negotation: item.Negation,
                  ValueField:
                    item.RightSideType == 1
                      ? { key: item.RightSideKey }
                      : item.RightSideKey === 'true' && item.RightSideText == ''
                      ? true
                      : item.RightSideKey, //transform "TRUE" > true
                  Relation: { id: item.Relation, name: 'testr' },
                });
              });
              options.success(vm.row);
            },
          },
          change: function(options) {
            if (!!options.action && options.action === 'add') {
              options.items[0].rowNum = ++vm.rowCnt;
              options.items[0].RowId = '#' + padLeft(vm.rowCnt, 3);
              vm.initSelections();
            }

            if (!!options.action && options.action === 'remove') {
              vm.initSelections();
            }

            //afer Transport-Read
            if (!options.action) {
              angular.forEach(options.items, function(value, key) {
                if (value.Type == 1) value.ValueFieldOption = vm.getRightSideDDlOptions(false);
              });
            }
          },
          batch: false,
          schema: {
            model: {
              id: 'RowId',
              fields: {
                rowNum: { defaultValue: 0 },
                ngIf: { defaultValue: false },
                Del: { editable: false, filterable: false },
                RowId: { defaultValue: '_' },
                Type: { defaultValue: 0 },
                LeftSide: { defaultValue: { key: '', text: '' }, validation: { required: true } },
                Negotation: { defaultValue: false },
                ValueField: { defaultValue: { value: null, options: {} } },
                Relation: { defaultValue: { id: 0, name: '= egyenlő', type: '', operation: '=' } },
                Add: { editable: false },
              },
            },
          },
        },
        editable: false,
        filterable: true,
        sortable: false,
        resizable: false,
        reorderable: false,
        pageable: false,

        columns: [
          {
            field: 'Del',
            filterable: false,
            title: ' ',
            template:
              '<button type="button" class="" title="" ng-disabled="vm.eventModel.IsReadOnly" ng-click="vm.deleteRow($event)"><i class="fa fa-trash"></i></button>',
            footerTemplate:
              '<div class="selectionGridSkeleton"><button type="button" ng-disabled="vm.eventModel.IsReadOnly" title="{{vm.actions.ActionDelete.Title}}" ng-disabled="vm.disabled" ng-click="vm.addRow()"><i class="griff-add"></i></button></div>',
            width: '35px',
            attributes: {
              style: 'text-align: center;',
            },
          },
          {
            field: 'RowId',
            title: 'ID',
            template: '#=RowId#',
            footerTemplate: '<div class="selectionGridSkeleton"><div class="skeletonField"></div></div>',
            width: '50px',
            attributes: {
              style: 'text-align: center;',
            },
            headerAttributes: {
              style: 'text-align: center;',
            },
          },
          {
            field: 'LeftSide',
            title: 'Bal oldal',
            template:
              '<input kendo-drop-down-list style="width: 100%" ng-disabled="vm.eventModel.IsReadOnly"  k-options="vm.leftFieldOption" k-ng-model="dataItem.LeftSide" ng-class="(!dataItem.LeftSide.key) ? \'fieldInvalid\' : \'fieldValid\'"/>',
            footerTemplate: '<div class="selectionGridSkeleton"><div class="skeletonField"></div></div>',
            width: '120px',
            headerAttributes: {
              style: 'text-align: center;',
            },
          },
          {
            field: 'Negotation',
            title: 'Nem',
            template:
              '<input ng-disabled="vm.eventModel.IsReadOnly"  type="checkbox" #= Negotation ? \'checked="checked"\' : "" # ng-model="dataItem.Negotation"/>',
            footerTemplate:
              '<div class="selectionGridSkeleton"><div style="width: 25px;display: inline-block;" class="skeletonField"></div></div>',
            width: '45px',
            attributes: {
              style: 'text-align: center;',
            },
            headerAttributes: {
              style: 'text-align: center;',
            },
          },
          {
            field: 'Relation',
            title: 'Reláció',
            template:
              '<select ng-hide="dataItem.Type == 1" style="width: 100%" ng-disabled="vm.eventModel.IsReadOnly" kendo-drop-down-list  k-options="vm.relationDDV_option" k-ng-model="dataItem.Relation"></select>' +
              '<select ng-hide="dataItem.Type == 0"  style="width: 100%" ng-disabled="vm.eventModel.IsReadOnly" kendo-drop-down-list  k-options="vm.relationDDVf_option" k-ng-model="dataItem.Relation"></select>',
            footerTemplate: '<div class="selectionGridSkeleton"><div class="skeletonField"></div></div>',
            width: '115px',
            headerAttributes: {
              style: 'text-align: center;',
            },
          },
          {
            title: 'Jobb oldal',
            headerAttributes: {
              style: 'text-align: center; border-bottom: 1px solid #ccc;',
            },
            columns: [
              {
                field: 'Type',
                title: 'Típus',
                template:
                  '<input ng-disabled="vm.eventModel.IsReadOnly" style="width: 100%" kendo-drop-down-list k-options="vm.typeDDE_option" ng-model="dataItem.Type" />',
                footerTemplate: '<div class="selectionGridSkeleton"><div class="skeletonField"></div></div>',
                width: '80px',
                headerAttributes: {
                  style: 'text-align: center;',
                },
              },
              {
                field: 'ValueField',
                title: 'Érték',
                template:
                  '<input ng-disabled="vm.eventModel.IsReadOnly" class="rightSide" kendo-drop-down-list ng-show="vm.hideField(dataItem)==\'ddl\'" k-options="dataItem.ValueFieldOption" k-ng-model="dataItem.ValueField" />' +
                  '<div style="padding: 0 3px 0px 0;"><input ng-disabled="vm.eventModel.IsReadOnly" class="rightSide form-control" type="text" style="padding: 0;width: 100%;" ng-show="vm.hideField(dataItem)==\'textbox\'" ng-model="dataItem.ValueField"  /></div>' +
                  '<div ng-if="dataItem.ngIf && dataItem.Relation.id !== 5" ng-show="vm.hideField(dataItem)==\'F2\'"><f22-input class="EventSelectionF22Bugfix" ng-disabled="vm.eventModel.IsReadOnly" ng-model="dataItem.ValueField" f2-options="dataItem.f2options" ></f22-input></div>' +
                  '<div ng-if="dataItem.ngIf && dataItem.Relation.id === 5" ng-show="vm.hideField(dataItem)==\'F2\'"><f4-input class="EventSelectionF4Bugfix" ng-disabled="vm.eventModel.IsReadOnly" ng-model="dataItem.ValueField" f4-options="dataItem.f2options" ></f4-input></div>' +
                  '<table style="width: 100%" ng-show="vm.hideField(dataItem)==\'datetime\'" class="rightSide"><tr><td><input kendo-date-picker style="width: 100%;" ng-disabled="vm.eventModel.IsReadOnly" ng-model="dataItem.ValueField" kdpcidv parsedate format="yyyy-MM-dd" parseFormats="yyyy.MM.dd" customedit="true"/></td><td><button type="button" tabindex="-1" class="close" aria-label="Close" ng-click="clear()" ng-hide="to.disabled"><span aria-hidden="true">&times;</span></button></td></tr></table>' +
                  '<div ng-show="vm.hideField(dataItem)==\'numeric\'"><input ng-disabled="vm.eventModel.IsReadOnly" class="rightSide" kendo-numeric-text-box style="width: 100%" style="width: 100%;"  ng-model="dataItem.ValueField" /></div>' +
                  '<div ng-show="vm.hideField(dataItem)==\'int\'"><input ng-disabled="vm.eventModel.IsReadOnly" class="rightSide" kendo-numeric-text-box style="width: 100%" style="width: 100%;" ng-model="dataItem.ValueField" /></div>' +
                  '<div class="text-center"><input ng-disabled="vm.eventModel.IsReadOnly" class="rightSide formly-field-checkbox" type="checkbox"  ng-show="vm.hideField(dataItem)==\'checkbox\'" ng-model="dataItem.ValueField" /></div>',
                footerTemplate: '<div class="selectionGridSkeleton"><div class="skeletonField"></div></div>',
                width: '160px',
                headerAttributes: {
                  style: 'text-align: center;',
                },
              },
            ],
          },
        ],
      };

      vm.isLastRow = function(dataItem) {
        return vm.row.length === 1 || vm.row[vm.row.length - 1].rowNum === dataItem.rowNum;
      };

      //az sql típusok meghatározzuk a megjelenítendő mező típusát:
      vm.getFieldTypeForNgHide = function(type) {
        if (['bit'].indexOf(type) >= 0) return 'checkbox';
        if (['char', 'text', 'varchar'].indexOf(type) >= 0) return 'textbox';
        if (['float', 'numeric'].indexOf(type) >= 0) return 'numeric';
        if (['int'].indexOf(type) >= 0) return 'int';
        if (['datetime', 'smalldatetime'].indexOf(type) >= 0) return 'datetime';
      };
      //az sql típusból meghatározzuk, hogy mi legyen az IsNull
      vm.getFieldTypeForIsNull = function(leftSide, type) {
        //ha extraPropertiesből megállapítható a típus, akkor a típusnak megfelelően ISNULL-al adom vissza:
        if (type === 0 && !!leftSide.extraProperties && !!leftSide.extraProperties[2]) {
          if (['bit', 'float', 'numeric', 'int'].indexOf(leftSide.extraProperties[2].value) >= 0)
            return 'ISNULL(' + leftSide.key + ',0)';
          if (['char', 'text', 'varchar'].indexOf(leftSide.extraProperties[2].value) >= 0)
            return 'ISNULL(' + leftSide.key + ",'')";
          if (['datetime', 'smalldatetime'].indexOf(leftSide.extraProperties[2].value) >= 0) return leftSide.key; //return "ISNULL("+leftSide.key+",'0000-00-00 00:00:00')";
        }
        //ha nem, akkor csak a mezőt:
        else return leftSide.key;
      };
      vm.getQuoteForField = function(leftSide) {
        //ha extraPropertiesből megállapítható a típus, akkor a típusnak megfelelően quote-al adom vissza:
        if (!!leftSide.extraProperties && !!leftSide.extraProperties[2]) {
          return ['float', 'numeric', 'int'].indexOf(leftSide.extraProperties[2].value) >= 0 ? '' : "'";
        }
        //ha nem, akkor csak a mezőt:
        else return "'";
      };

      vm.hideField = function(dataItem) {
        //Melyik típusú mező jelenjen meg?
        if (parseInt(dataItem.Type) === 1) return 'ddl';
        if (
          parseInt(dataItem.Type) === 0 &&
          !!dataItem.LeftSide.extraProperties &&
          dataItem.LeftSide.extraProperties.length > 0 &&
          dataItem.LeftSide.extraProperties[1].value !== ''
        )
          return 'F2';
        if (
          parseInt(dataItem.Type) === 0 &&
          !!dataItem.LeftSide.extraProperties &&
          dataItem.LeftSide.extraProperties.length > 0 &&
          dataItem.LeftSide.extraProperties[2].value !== ''
        )
          return vm.getFieldTypeForNgHide(dataItem.LeftSide.extraProperties[2].value);
        if (typeof dataItem.ValueField === 'boolean') return vm.getFieldTypeForNgHide('bit');
        return '';
      };

      ///----------------------------------------------------------------------------------
      vm.reNumberRowId = function() {
        var items = vm.row;
        var no = 0;
        angular.forEach(items, function(value, key) {
          value.RowId = '#' + padLeft(no++ + 1, 3);
        });
        $('#selectionGrid')
          .data('kendoGrid')
          .dataSource.read();
        vm.initSelections();
      };

      vm.updateQueryFromSelections = function() {
        var isValid = true;
        var queryStr = vm.eventModel.OpOrder;
        //itt készül a query, végigmegyek a grid sorain soronként összeállítom a feltételt és a zárójelezés stringben az adott id-t kicserélem erre
        var items = vm.selectionGrid.dataSource.data();
        angular.forEach(items, function(value, key) {
          if (value.RowId !== '' && !!value.LeftSide.key) {
            //Kell-e ' vagy nem
            var quote = vm.getQuoteForField(value.LeftSide);
            //F2/Combo érték vagy sima

            var rsValue = value.ValueField;

            if (value.FieldType == 'smalldatetime' || value.FieldType == 'datetime') {
              let _dateObject = new moment(value.ValueField, kendo.culture().calendar.patterns.d.toUpperCase(), true);
              if (!_dateObject._isValid) {
                toastr.error('Dátum hiba a szelekcióban!');
                isValid = false;
              }
              rsValue = _dateObject.format('YYYY-MM-DDTHH:mm:ss.SSS');
            } else if (!!value.ValueField && (!!value.ValueField.key || !!value.ValueField.Value))
              rsValue = !!value.ValueField.key ? value.ValueField.key : value.ValueField.Value;

            if (value.Relation.id === 0) {
              //egyenlő
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' <> ' : ' = ') +
                (value.Type == 0 ? quote + rsValue + quote : rsValue);
            }
            if (value.Relation.id === 1) {
              //kisebb
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' >= ' : ' < ') +
                (value.Type == 0 ? quote + rsValue + quote : rsValue);
            }
            if (value.Relation.id === 2) {
              //nagyobb
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' <= ' : ' > ') +
                (value.Type == 0 ? quote + rsValue + quote : rsValue);
            }
            if (value.Relation.id === 3) {
              //tartalmazza
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' NOT LIKE ' : ' LIKE ') +
                "'%" +
                rsValue +
                "%'";
            }
            if (value.Relation.id === 4) {
              //kezdete
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' NOT LIKE ' : ' LIKE ') +
                "'" +
                rsValue +
                "%'";
            }
            if (value.Relation.id === 5) {
              //felsorolás
              var _vA = typeof value.ValueField === 'string' ? value.ValueField.split(',') : value.ValueField;
              //.filter(function(n){ return n != undefined &&  n != ""  });
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' NOT IN ' : ' IN ') +
                '(' +
                quote +
                _vA.join(quote + ',' + quote) +
                quote +
                ')';
            }
            if (value.Relation.id === 6) {
              //minta
              var _row =
                vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                (value.Negotation ? ' NOT LIKE ' : ' LIKE ') +
                "'" +
                rsValue +
                "'";
            }
            if (value.Relation.id === 7) {
              //mintalista
              var _vA = rsValue.split(',');
              var _vS = [];
              angular.forEach(_vA, function(_value, _key) {
                _vS.push(
                  vm.getFieldTypeForIsNull(value.LeftSide, value.Type) +
                    (value.Negotation ? ' NOT LIKE ' : ' LIKE ') +
                    "'" +
                    _value +
                    "'"
                );
              });
              var _row = value.Negotation ? '' + _vS.join("' AND '") + '' : '(' + _vS.join("' OR '") + ')';
            }
            queryStr = queryStr.replace(value.RowId, _row);
          } else {
            queryStr = queryStr.replace(value.RowId, '');
          }
        });
        vm.eventModel.Query = queryStr;
        return isValid;
      };

      vm.initSelections = function() {
        if (vm.eventModel.Type != 'EVTCC') {
          var items = $('#selectionGrid')
            .data('kendoGrid')
            .dataSource.data();
          var ids = [];
          angular.forEach(items, function(value, key) {
            if (value.RowId !== '') ids.push(value.RowId);
          });
          vm.eventModel.OpOrder = ids.join(' AND ');
        }
      };

      vm.addRow = function() {
        var grid = $('#selectionGrid').data('kendoGrid');
        var index = grid.dataSource.view().length;
        var newItem = grid.dataSource.insert(index, {});
        newItem.ValueFieldOption = vm.getRightSideDDlOptions(true);
      };

      vm.deleteRow = function(e) {
        e.preventDefault();
        var grid = $('#selectionGrid').data('kendoGrid');
        var dataItem = grid.dataItem($(e.currentTarget).closest('tr'));
        grid.dataSource.remove(dataItem);
        //ha nincs több sor, beszúr egyet:
        if (vm.eventModel.Type === 'EVTVC' && vm.row.length === 0) vm.addRow();
      };

      vm.clearGrid = function() {
        var grid = $('#selectionGrid').data('kendoGrid');
        vm.row.empty();
        if (vm.eventModel.Type === 'EVTVC' && vm.row.length === 0) vm.addRow();
      };

      ///----------------------------------------------------------------------------------

      function padLeft(nr, n, str) {
        return Array(n - String(nr).length + 1).join(str || '0') + nr;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('EventMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'EventMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Service_Event_EventNav: { icon: 'fa fa-users' },
      };

      buildMenu($state, authService, 'Service_Event', 'Service', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

var myApp = angular.module('myApp');

myApp.config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Event: {
        url: '/Event',
        templateUrl: 'App/Event/EventLayout.html',
        controller: 'EventLayoutCtrl as vm',
        redirectTo: 'Event.EventNav',
        ncyBreadcrumb: {
          label: 'Emlékeztető modul',
          parent: 'main',
        },
      },

      'Event.EventNav': {
        url: '/nav',
        params: { module: 'Event' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EventMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Event/EventNav.html',
            controller: 'EventNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Event/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Emlékeztető navigáció',
        },
      },
      'Event.EventDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EventMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },

      //"Event.CreateCC": {
      //    url: "/createcc/{id:int}?valid",
      //    params: { module: "Event" },
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "EventMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/Event/EventEdit.html",
      //            controller: "EventEditCtrl as vm",
      //            resolve: {
      //                model: RouteResolveFunc("Event/EventEdit/", undefined, ["id"])
      //            }
      //        }
      //    },
      //    params: {
      //        controllerOptions: {
      //            isFormReadOnly: false
      //        },
      //        CreateOrEdit: "Create",
      //        EventTypeId: "EVTCC",
      //        backTo: "Nav"
      //    },
      //    ncyBreadcrumb: {
      //        label: "Emlékeztető hozzáadása"
      //    }
      //},

      //"Event.CreateDM": {
      //    url: "/createdm/{id:int}?valid",
      //    params: { module: "Event" },
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "EventMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/Event/EventEdit.html",
      //            controller: "EventEditCtrl as vm",
      //            resolve: {
      //                model: RouteResolveFunc("Event/EventEdit/", undefined, ["id"])
      //            }
      //        }
      //    },
      //    params: {
      //        controllerOptions: {
      //            isFormReadOnly: false
      //        },
      //        CreateOrEdit: "Create",
      //        EventTypeId: "EVTDM",
      //        backTo: "Nav"
      //    },
      //    ncyBreadcrumb: {
      //        label: "Emlékeztető hozzáadása"
      //    }
      //},

      //"Event.Edit": {
      //    url: "/edit/{id:int}?valid",
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "EventMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/Event/EventEdit.html",
      //            controller: "EventEditCtrl as vm",
      //            resolve: {
      //                model: RouteResolveFunc("Event/EventEdit/", undefined, ["id"])
      //            }
      //        }
      //    },
      //    params: {
      //        controllerOptions: {
      //            isFormReadOnly: false
      //        },
      //        CreateOrEdit: "Edit",
      //        backTo: "Nav"
      //    },
      //    ncyBreadcrumb: {
      //        label: "Emlékeztető szerkesztése"
      //    }
      //},

      'Event.View': {
        url: '/view/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'EventMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Event/EventEdit.html',
            controller: 'EventEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Event/EventView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          backTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Emlékeztető megtekintése',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

'use strict';

function sbSupplyContractDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.activeTab = 0;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelSupplyContractInvoiceRowDetail'],
      function(gridModel) {
        gridModel.ControllerMethod = `SupplyContract/${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: function() {
            return {
              targetInvoiceId: ctrl.supplyContr.InvoiceId,
            };
          },
        };
      }
    );

    let gridOptions = ctrl.generatedTabs.find(obj => {
      return obj.name === 'TabSupplyContractInvoiceRowDetail';
    });

    gridService.addAggregateToFooter(
      gridOptions.kendoConfig,
      'sum',
      'Gross',
      '',
      "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
    );
  };

  //#endregion
}

const sbSupplyContractDetailComponentOptions = {
  templateUrl: 'App/SupplyContract/supply-contract-detail/supply-contract-detail.component.html',
  controller: sbSupplyContractDetailComponent,
  bindings: {
    supplyContr: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbSupplyContractDetail: sbSupplyContractDetailComponentOptions,
  };

  const sbSupplyContractDetailModule = angular.module('sbSupplyContractDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbSupplyContractDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = ['sbSupplyContractDetail'];

  const sbSupplyContractModule = angular.module('sbSupplyContract', modules);
})();

(function(module) {
  'use strict';
  module.controller('SupplyContractEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    'WalService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      HistoryService,
      dasService,
      lockService,
      walService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.function = $stateParams.Operation;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.lastSupplierPartId = angular.copy(vm.formModel.SupplierPartId);

      vm.create = createItem;
      vm.save = saveWithCheck;
      vm.edit = editItem;
      vm.delete = deleteItem;
      vm.duplicate = duplicateItem;
      vm.view = viewItem;
      vm.link = linkItem;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.UIHelperService = UIHelperService;

      vm.UIHelperService.setDefaultSidebarStatus();
      //active
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabGeneralData',
        disableRunExpression: false,
      };

      vm.setcolumtodatetime = SetGridColumnToDateTime(
        vm.pageModel.Grids,
        ['GridSupplyContractStatus'],
        ['ValidFrom', 'ValidTo']
      );

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.SupplyContractNav');
      };

      var customExpressionProperties = {
        SupplyContrStatusTypeId: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.SupplyContrId === 0 || vm.EditOrDuplicate === 'Duplicate');
          },
        },
        InstallmentNum: {
          'templateOptions.disabled': function() {
            return vm.formModel.PaymentPlan !== 'SPPIN';
          },
        },
        CPVId: {
          'templateOptions.required': function() {
            return vm.formModel.Procurement === true;
          },
        },
        ContractTypeId: {
          'templateOptions.disabled': function() {
            return (
              (vm.formModel.SupplyContrId !== 0 && vm.EditOrDuplicate !== 'Duplicate') || vm.formModel.TypeId == null
            );
          },
        },
        TypeId: {
          'templateOptions.disabled': function() {
            return (
              vm.EditOrDuplicate === 'LinkEdit' ||
              (vm.formModel.SupplyContrId !== 0 && vm.EditOrDuplicate !== 'Duplicate')
            );
          },
        },
        SupplierPartId: {
          'templateOptions.disabled': function() {
            return !dateIsValid(vm.formModel.DateFrom);
          },
        },
        DateTo: {
          'templateOptions.required': function() {
            return vm.formModel.Extent === 'CEXDE';
          },
        },
      };

      var syncValidators = {
        InstallmentNum: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          NumValidator: function(modelValue) {
            if (!modelValue || vm.formModel.PaymentPlan !== 'SPPIN') {
              return true;
            }
            return modelValue > 0;
          },
        },
        Net: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          VatValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
          /**
           * @return {boolean}
           * @return {boolean}
           * @return {boolean}
           */
          NetGrossValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var grossValue = vm.formModel.Gross;
            if (!grossValue) {
              return true;
            }
            return parseInt(grossValue) >= parseInt(modelValue);
          },
        },
        Gross: {
          /**
           * @return {boolean}
           * @return {boolean}
           */
          VatValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
          /**
           * @return {boolean}
           * @return {boolean}
           * @return {boolean}
           */
          NetGrossValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var netValue = vm.formModel.Net;
            if (!netValue) {
              return true;
            }
            return parseInt(netValue) <= parseInt(modelValue);
          },
        },
      };

      var onChangeFunctions = {
        PaymentPlan: function(selectedItem) {
          if (selectedItem.key === 'SPPLS') {
            vm.formModel.InstallmentNum = 1;
          } else if (selectedItem.key === 'SPPIN') {
            vm.formModel.InstallmentNum = 1;
          } else if (selectedItem.key === 'SPPNO') {
            vm.formModel.InstallmentNum = 0;
          } else {
            vm.formModel.InstallmentNum = 0;
          }
        },
        SupplierPartId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem._events && !!vm.formModel.SupplierPartId) {
            vm.formModel.Currency = selectedItem.Currency;
            vm.formModel.Payment = selectedItem.Payment;
            vm.lastSupplierPartId = selectedItem.PartnerId;
          } else {
            delete vm.lastSupplierPartId;
          }

          if (!vm.formModel.Currency) {
            vm.formModel.Currency = 'HUF';
          }
        },
        Net: function(selectedItem) {
          reValidate();
        },
        Gross: function(selectedItem) {
          reValidate();
        },
        TypeId: function(selectedItem) {
          vm.pageModel.Fields.ContractTypeId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        DateFrom: function() {
          if (dateIsValid(vm.formModel.DateFrom)) {
            setSupplierPartIdF2Parameters(vm.formModel.DateFrom);
            vm.pageModel.Fields.SupplierPartId.FormlyFieldDescriptor.value(vm.lastSupplierPartId);
          } else {
            vm.formModel.SupplierPartId = { Value: null, Text: null };
          }
        },
      };

      var dynamicQueryParameters = {
        ContractTypeId: function() {
          return [
            {
              key: vm.formModel.TypeId,
              text: 'TypeId',
            },
          ];
        },
      };

      var onBlurFunctions = {
        //"Net": function (selectedItem) {
        //    reValidate();
        //},
        //"Gross": function (selectedItem) {
        //    reValidate();
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.getSelectedSubGridInvoiceId = function() {
        return {
          targetInvoiceId: getSelectedSubGridItemId(),
        };
      };

      vm.activeSubItemTab = 0;
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelSupplyContractStatus', 'PanelSupplyContractPartition', 'PanelSupplyContractInvoice'],
        function(gridModel) {
          gridModel.ControllerMethod = `SupplyContract/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              return {
                targetSupplyContrId: vm.formModel.SupplyContrId,
              };
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      var generatedSubDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelSupplyContractInvoiceRowDetail'],
        function(gridModel) {
          gridModel.ControllerMethod = `SupplyContract/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedSubGridInvoiceId,
          };
        }
      );
      vm.subDetailItemTabs = generatedSubDetailGridTabs.tabs;
      vm.subDetailGrids = generatedSubDetailGridTabs.grids;

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      if (dateIsValid(vm.formModel.DateFrom)) {
        setSupplierPartIdF2Parameters(vm.formModel.DateFrom);
      }

      function saveItem() {
        $http
          .post('SupplyContract/SupplyContract' + vm.function, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('SupplyContract.SupplyContractEdit', { id: response.data.SupplyContrId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function saveWithCheck() {
        if (vm.function == 'LinkEdit') {
          $http
            .get('SupplyContract/GetSupplyContractDateTo', {
              params: { OwnerSupplyContrId: vm.formModel.OwnerSupplyContrId },
            })
            .then(function(response) {
              if (!!response.data.DateToB) {
                let dateActiveDate = new Date(vm.formModel.ActiveDate.replaceAll('. ', '-').replace('.', ''));
                let dateActiveDateC = new Date(
                  dateActiveDate.setDate(dateActiveDate.getDate() - 1)
                ).toLocaleDateString();

                bootbox.dialog({
                  message:
                    vm.formModel.OwnerSupplyContr +
                    ' sz. szerződésnek meg van adva szerződés vége dátuma: ' +
                    new Date(response.data.DateTo).toLocaleDateString() +
                    '. Kívánja módosítani ' +
                    dateActiveDateC +
                    ' - ra?',
                  title: vm.messages.Confirm,
                  buttons: {
                    cancel: {
                      label: vm.messages.Ok,
                      className: 'btn-primary',
                      callback: function() {
                        vm.formModel.DateToUpdate = true;
                        saveItem();
                      },
                    },
                    confirm: {
                      label: vm.messages.Cancel,
                      className: 'btn-default',
                      callback: function() {
                        vm.formModel.DateToUpdate = false;
                        saveItem();
                      },
                    },
                  },
                });
              } else {
                vm.formModel.DateToUpdate = true;
                saveItem();
              }
            });
        } else {
          saveItem();
        }
      }

      function createItem() {
        $state.go('SupplyContract.SupplyContractCreate', { id: 0 });
      }

      function editItem() {
        $state.go('SupplyContract.SupplyContractEdit', { id: vm.formModel.SupplyContrId });
      }

      function duplicateItem() {
        $state.go('SupplyContract.SupplyContractDuplicate', { id: vm.formModel.SupplyContrId });
      }

      function deleteItem() {
        var id = vm.formModel.SupplyContrId;
        bootbox.dialog({
          message: vm.messages.DeleteDialogConfirmMessage,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('SupplyContract/SupplyContractDelete/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  $state.go('SupplyContract.SupplyContractNav');
                });
              },
            },
          },
        });
      }

      function viewItem() {
        $state.go('SupplyContract.View', { id: vm.formModel.SupplyContrId });
      }

      function linkItem() {
        var id = vm.formModel.SupplyContrId;
        if (!!id) {
          $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: true });
          //bootbox.dialog({
          //  message: 'Válasszon egy opciót!',
          //  title: 'Láncolás',
          //  buttons: {
          //    add: {
          //      label: 'Új szerződés',
          //      className: 'btn-primary',
          //      callback: function() {
          //        $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: false });
          //      },
          //    },
          //    modify: {
          //      label: 'Szerződés módosítás',
          //      className: 'btn-primary',
          //      callback: function() {
          //        $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: true });
          //      },
          //    },
          //    cancel: {
          //      label: 'Mégse',
          //      className: 'btn-default',
          //      callback: function() {},
          //    },
          //  },
          //});
        }
      }

      function createSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var SupplyContrId = vm.formModel.SupplyContrId;
        if (urlPrefix === 'GridSupplyContractPartition') {
          $http.get('SupplyContract/PartitionCount/' + SupplyContrId).then(function() {
            $state.go('SupplyContract.' + urlPrefix + 'Create', {
              id: id,
              SupplyContrId: SupplyContrId,
            });
          });
        } else {
          $state.go('SupplyContract.' + urlPrefix + 'Create', { id: id, SupplyContrId: SupplyContrId });
        }
      }

      function editSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var SupplyContrId = vm.formModel.SupplyContrId;
        if (!!id) {
          $state.go('SupplyContract.' + urlPrefix + 'Edit', { id: id, SupplyContrId: SupplyContrId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function duplicateSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var SupplyContrId = vm.formModel.SupplyContrId;
        if (!!id) {
          $state.go('SupplyContract.' + urlPrefix + 'Duplicate', { id: id, SupplyContrId: SupplyContrId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function deleteSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var item = getSelectedSubGridItem();
        var id = getSelectedSubGridItemId();
        if (!!id) {
          var dialogMessage = vm.messages.SubItemDialogConfirmMessage;
          switch (gridName) {
            case 'GridSupplyContrStatus':
              //console.log("item: " + JSON.stringify(item));
              dialogMessage = dialogMessage.replace('{0}', ': ' + item.SuppContrStatusTypeId + '?');
              break;
            case 'GridSupplyContrPartition':
              //console.log("item: " + JSON.stringify(item));
              dialogMessage = dialogMessage.replace('{0}', ': ' + item.OpUnitId + '?');
              break;
          }
          bootbox.dialog({
            message: 'Biztosan törölni szeretné a kijelölt elemet?',
            //message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: 'Mégse',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Törlés',
                className: 'btn-primary',
                callback: function() {
                  $http.get('SupplyContract/' + urlPrefix + 'Delete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    $('#subGrid' + gridName)
                      .data('kendoGrid')
                      .dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }
      function attachDocument() {
        var id = vm.formModel.SupplyContrId;
        dasService.NavigateToDas(vm.messages, 'SupplyContract.DasDocumentsNav', 'FlgSupplyContr', id);
      }

      function History() {
        HistoryService.NavigateToHistory('FlgSupplyContract', $state.params.id, vm, $state);
      }

      function getSelectedSubGridItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $('#subGrid' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
      vm.isCollapsed3 = false;

      function reValidate() {}

      function setSupplierPartIdF2Parameters(date) {
        vm.pageModel.Fields.SupplierPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          validFrom: date,
        };
      }

      function dateIsValid(date) {
        return moment(
          date,
          kendo.culture().calendar.patterns.d.toUpperCase(),
          !date || !date.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2})/)
        ).isValid();
      }

      function WAL() {
        switch (vm.activeSubItemTab) {
          case 0:
            walService.NavigateToWal('SupplyContract', 'SupplyContrStatusWal', 'FlgSupplyContrStatusView');
            break;
          case 1:
            walService.NavigateToWal('SupplyContract', 'SupplyContrPartitionWal', 'FlgSupplyContrPartitionView');
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SupplyContractStatusEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, HistoryService, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractStatusEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      vm.UIHelperService = UIHelperService;
      vm.collapseBooleans = {
        contractDetailsIsCollapsed: false,
        statusDetailsIsCollapsed: true,
      };
      vm.activeBooleans = {
        contractDetailsIsActive: true,
        statusDetailsIsActive: false,
      };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.function = $stateParams.Operation;

      vm.create = createSubItem;
      vm.save = saveSubItem;
      vm.edit = editSubItem;
      vm.delete = deleteSubItem;
      vm.duplicate = duplicateSubItem;
      vm.History = History;
      vm.attachDocument = attachDocument;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.SupplyContractEdit', { id: vm.formModel.SupplyContrId });
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelStatus.FormlyDescriptor;
      vm.supplyContractFormFields = formlyFormPanelDescriptors.PanelSupplyContractData.FormlyDescriptor;

      function saveSubItem() {
        $http
          .post('SupplyContract/SupplyContractStatus' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('SupplyContract.SupplyContractEdit', { id: vm.formModel.SupplyContrId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var SupplyContrId = vm.formModel.SupplyContrId;
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.' + urlPrefix + 'Edit', { id: id, Id: SupplyContrId });
      }

      function editSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Edit', { id: vm.formModel.SupplyContrStatusId });
      }

      function duplicateSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Duplicate', { id: vm.formModel.SupplyContrStatusId });
      }

      function deleteSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Delete', { id: vm.formModel.SupplyContrStatusId });
      }
      function attachDocument() {
        var id = vm.formModel.SupplyContrId;
        dasService.NavigateToDas(vm.messages, 'SupplyContract.DasDocumentsNav', 'FlgSupplyContr', id);
      }

      function History() {
        // TODO
        HistoryService.NavigateToHistory('FlgSupplyContrStatus', $state.params.id, vm, $state);
      }

      vm.collapsePanel = function(indexName) {
        vm.UIHelperService.activeSubMenuId = indexName;
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];

        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'contractDetailsIsCollapsed':
            vm.activeBooleans['contractDetailsIsActive'] = true;
            break;
          case 'statusDetailsIsCollapsed':
            vm.activeBooleans['statusDetailsIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SupplyContractPartitionEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, HistoryService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractPartitionEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.function = $stateParams.Operation;

      vm.create = createSubItem;
      vm.save = saveSubItem;
      vm.edit = editSubItem;
      vm.delete = deleteSubItem;
      vm.duplicate = duplicateSubItem;
      vm.History = History;
      vm.attachDocument = attachDocument;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.SupplyContractEdit', { id: vm.formModel.SupplyContrId });
      };

      var onChangeFunctions = {
        VatCode: function(selectedItem) {
          if (vm.formModel.NetAmount !== null && vm.formModel.NetAmount !== 0 && !!selectedItem) {
            vm.formModel.GrossAmount = vm.formModel.NetAmount * (1 + selectedItem.extraProperties[0].value / 100);
          } else if (vm.formModel.GrossAmount !== null && vm.formModel.GrossAmount !== 0 && !!selectedItem) {
            vm.formModel.NetAmount = vm.formModel.GrossAmount / (1 + selectedItem.extraProperties[0].value / 100);
          }
        },
        NetAmount: function(selectedItem) {
          if (vm.formModel.VatCode !== null) {
            vm.formModel.GrossAmount = selectedItem * (1 + vm.formModel.VatCode / 100);
          }
        },
        GrossAmount: function(selectedItem) {
          if (vm.formModel.VatCode !== null) {
            vm.formModel.NetAmount = selectedItem / (1 + vm.formModel.VatCode / 100);
          }
        },
        Zone: function(selectedItem) {
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            zoneId: selectedItem.Zone,
          };
        },
        OpUnitId: function(selectedItem) {
          vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            opUnitId: selectedItem.OpUnitId,
          };
        },
      };

      var onBlurFunctions = {
        //"NetAmount": function (selectedItem) {
        //    if (vm.formModel.VatCode != null) {
        //        vm.formModel.GrossAmount = selectedItem * (1 + vm.formModel.VatCode/100);
        //    }
        //},
        //"GrossAmount": function (selectedItem) {
        //    if (vm.formModel.VatCode != null) {
        //        vm.formModel.NetAmount = selectedItem / (1 + vm.formModel.VatCode / 100);
        //    }
        //}
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      var customExpressionProperties = {
        NetAmount: {
          'templateOptions.disabled': function() {
            return vm.formModel.GrossAmount !== null && vm.formModel.GrossAmount !== 0;
          },
        },
        GrossAmount: {
          'templateOptions.disabled': function() {
            return vm.formModel.NetAmount !== null && vm.formModel.NetAmount !== 0;
          },
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelPartition.FormlyDescriptor;
      vm.supplyContractFormFields = formlyFormPanelDescriptors.PanelSupplyContractData.FormlyDescriptor;

      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        supplyContractId: vm.formModel.SupplyContrId,
      };

      function saveSubItem() {
        $http
          .post('SupplyContract/SupplyContractPartition' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('SupplyContract.SupplyContractEdit', { id: vm.formModel.SupplyContrId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createSubItem() {
        var gridName = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var SupplyContrId = vm.formModel.SupplyContrId;
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.' + urlPrefix + 'Edit', { id: id, Id: SupplyContrId });
      }

      function editSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Edit', { id: vm.formModel.SupplyContrPartitionId });
      }

      function duplicateSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Duplicate', { id: vm.formModel.SupplyContrPartitionId });
      }

      function deleteSubItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('SupplyContract.Delete', { id: vm.formModel.SupplyContrPartitionId });
      }
      function attachDocument() {
        var id = vm.formModel.SupplyContrPartitionId;
        dasService.NavigateToDas(vm.messages, 'SupplyContract.DasDocumentsNav', 'FlgSupplyContrPartition', id);
      }

      function History() {
        HistoryService.NavigateToHistory('FlgSuppContrPartition', $state.params.id, vm, $state);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SupplyContractLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SupplyContractNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'WalService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, $uibModal, HistoryService, walService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createSupplyContract = createSupplyContract;
      vm.editSupplyContract = editSupplyContract;
      vm.duplicateSupplyContract = duplicateSupplyContract;
      vm.deleteSupplyContract = deleteSupplyContract;
      vm.viewSupplyContract = viewSupplyContract;
      vm.linkSupplyContract = linkSupplyContract;
      vm.grids = options.pageModel.Grids;

      vm.activeMainItemTab = 0;

      vm.WAL = WAL;
      vm.History = history;

      vm.supplyContract = 'Élő szerződések';
      vm.allSupplyContract = 'Minden szerződés';

      vm.mainGridIdField = vm.pageModel.Grids['GridSupplyContract'].IdColumn;
      vm.mainGridSupplyContrField = 'SupplyContr';
      vm.mainGrid = $('#GridSupplyContract').data('kendoGrid');

      vm.invoiceSubGridIdField = vm.pageModel.Grids['GridSupplyContractInvoice'].IdColumn;
      vm.subDetailGridIdField = vm.pageModel.Grids['GridSupplyContract'].IdColumn;
      vm.detailGridIdField = vm.pageModel.Grids['GridSupplyContractDetail'].IdColumn;
      vm.usedSupplyContractGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      function changeMainGridFilter() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        changeGridFilter(vm, $scope, selectedGrid, selectedGrid.options.idColumn);
      }

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.grids,
        ['PanelSupplyContract', 'PanelAllSupplyContract'],
        function(gridModel) {
          if (gridModel.Name === 'GridSupplyContract') {
            gridModel.ControllerMethod = 'SupplyContract/SupplyContractValidList/';
            return {
              gridModel,
              selectFunction: function() {
                changeMainGridFilter();
                changeSubItemGridFilter();
                setDasModel();
              },
              dataBound: function() {
                setDasModel();
              },
            };
          }
          if (gridModel.Name === 'GridAllSupplyContract') {
            gridModel.ControllerMethod = 'SupplyContract/SupplyContractList/';
            return {
              gridModel,
              selectFunction: function() {
                changeMainGridFilter();
                changeSubItemGridFilter();
                setDasModel();
              },
              dataBound: function() {
                setDasModel();
              },
            };
          }

          return null;
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      vm.mainGrids = generatedMainGridTabs.grids;

      //vm.activeSubItemTab = 0;
      vm.getSelectedMainGridItemId = function() {
        return {
          targetSupplyContrId: vm.selectedMainGridItemId,
        };
      };

      vm.getSelectedSubGridInvoiceId = function() {
        return {
          targetInvoiceId: vm.selectedSubGridItemId,
        };
      };

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.grids,
        ['PanelSupplyContractStatus', 'PanelSupplyContractPartition', 'PanelSupplyContractInvoice'],
        function(gridModel) {
          gridModel.ControllerMethod = `SupplyContract/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });

      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;
      vm.initSupplyContractDetail = function(ctrl) {
        ctrl.activeTab = 0;
        const ctrlDetail = ctrl;
        ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
          ctrl.tabs,
          ctrl.panels,
          ctrl.grids,
          ['PanelSupplyContractDetail'],
          function(gridModel) {
            gridModel.ControllerMethod = `SupplyContract/SupplyContractChainedList`;
            return {
              gridModel,
              transportData: function() {
                return {
                  targetSupplyContrId: ctrlDetail.row[vm.detailGridIdField],
                };
              },
              selectFunction: function() {},
            };
            return null;
          }
        );
      };

      var generatedSubDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.grids,
        ['PanelSupplyContractInvoiceRowDetail'],
        function(gridModel) {
          gridModel.ControllerMethod = `SupplyContract/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: vm.getSelectedSubGridInvoiceId,
          };
        }
      );
      vm.subDetailItemTabs = generatedSubDetailGridTabs.tabs;
      vm.subDetailGrids = generatedSubDetailGridTabs.grids;

      vm.changeTabs = function(index) {
        vm.activeMainItemTab = index;
        changeSubItemGridFilter();
      };

      function changeSubItemGridFilter() {
        //
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || (!!selectedItems && selectedItems.length === 0)) return;

        vm.selectedMainGridItemId = selectedItems[vm.mainGridIdField];

        vm.selectedSubGridItemId = selectedItems[vm.invoiceSubGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          !!value && value.dataSource.read();
        });
      }

      function createSupplyContract() {
        $state.go('SupplyContract.SupplyContractCreate', { id: 0 });
      }

      function editSupplyContract() {
        var selectedItems = GetSelectedItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[vm.mainGridIdField];
          $state.go('SupplyContract.SupplyContractEdit', { id: id });
        }
      }

      function duplicateSupplyContract() {
        var selectedItems = GetSelectedItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[vm.mainGridIdField];
          $state.go('SupplyContract.SupplyContractDuplicate', { id: id });
        }
      }

      function deleteSupplyContract() {
        let mainGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('SupplyContract/SupplyContractDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrids.forEach(function(element, index, grid) {
                      grid[element].dataSource?.read();
                    });
                  });
                },
              },
            },
          });
        }
      }

      function viewSupplyContract() {
        var selectedItems = GetSelectedItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[vm.mainGridIdField];
          $state.go('SupplyContract.View', { id: id });
        }
      }

      function linkSupplyContract() {
        var selectedItems = GetSelectedItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[vm.mainGridIdField];
          if (!!id) {
            $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: true });
            // 52679 SB SZÁLLÍTÓI/VEVŐI - Láncolás módosítása-val kikerült
            // bootbox.dialog({
            // message: 'Válasszon egy opciót!',
            // title: 'Láncolás',
            // buttons: {
            // add: {
            // label: 'Új szerződés',
            // className: 'btn-primary',
            // callback: function() {
            // $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: false });
            // },
            // },
            // modify: {
            // label: 'Szerződés módosítás',
            // className: 'btn-primary',
            // callback: function() {
            // $state.go('SupplyContract.SupplyContractLinkEdit', { id: id, edit: true });
            // },
            // },
            // cancel: {
            // label: 'Mégse',
            // className: 'btn-default',
            // callback: function() {},
            // },
            // },
            // });
          }
        }
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids[vm.mainGrids[vm.activeMainItemTab]].DasDescriptor;
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId:
            !selectedItems?.length || !dasDescriptor.ownerColumn ? null : selectedItems[0][dasDescriptor.ownerColumn],
        };

        $scope.$applyAsync();
      }

      function WAL(whichGrid) {
        switch (whichGrid) {
          case vm.usedSupplyContractGridEnum.MAIN:
            walService.NavigateToWal('SupplyContract', 'SupplyContractWal', 'FlgSupplyContrView');
            break;
          case vm.usedSupplyContractGridEnum.SUB:
            switch (vm.activeSubItemTab) {
              case 0:
                walService.NavigateToWal('SupplyContract', 'SupplyContrStatusWal', 'FlgSupplyContrStatusView');
                break;
              case 1:
                walService.NavigateToWal('SupplyContract', 'SupplyContrPartitionWal', 'FlgSupplyContrPartitionView');
                break;
              case 2:
                walService.NavigateToWal('SupplyContract', 'SupplyContractInvoiceViewWal', 'FlgInvoiceView');
                break;
              default:
                break;
            }
            break;
          default:
            break;
        }
      }

      function history() {
        // Kiválasztott subgrid elem lekérése:
        var selectedItems = GetSelectedItems(vm.subGrids[vm.subGrids[vm.activeSubItemTab]]); // vm.subGrids[vm.activeSubItemTab] csak a választott tab nevét adja stringként
        switch (vm.activeSubItemTab) {
          // Az id változó neve nem generikus, hanem táblafüggő, ezért külön kell kezelni.
          case 0: // GridSupplyContractStatus,  SupplyContrStatusId
            if (selectedItems && selectedItems.SupplyContrStatusId) {
              HistoryService.NavigateToHistory(
                'FlgSupplyContract',
                selectedItems.SupplyContrStatusId,
                vm,
                $state,
                true
              );
            } else {
              toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            }
            break;
          case 1: // GridSupplyContractPartition,  SupplyContrPartitionId
            if (selectedItems && selectedItems.SupplyContrPartitionId) {
              HistoryService.NavigateToHistory(
                'FlgSupplyContract',
                selectedItems.SupplyContrPartitionId,
                vm,
                $state,
                true
              );
            } else {
              toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            }
            break;
        }
      }

      function GetSelectedItems(selectedGrid) {
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems[0];
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SupplyContractMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplyContractMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var supplyContractId = $state.params.SupplyContrId;
      // Routesban kap értéket: {Nav, Edit}
      var backTo = $state.params.BackTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('SupplyContract.SupplyContractNav');
        };
      } else if (backTo === 'Edit') {
        backMenu.event = function() {
          $state.go('SupplyContract.SupplyContractEdit', { id: supplyContractId });
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        SupplyContract_SupplyContractNav: { icon: 'fa fa-file-text' },
        Masterdata_SupplyContract: { icon: 'fa fa-file-text-o' },
      };

      buildMenu($state, authService, 'SupplyContract', 'supplycontract', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      SupplyContract: {
        url: '/supplycontract',
        templateUrl: 'App/SupplyContract/SupplyContractLayout.html',
        controller: 'SupplyContractLayoutCtrl as vm',
        redirectTo: 'SupplyContract.SupplyContractNav',
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződések',
          parent: 'main',
        },
      },
      'SupplyContract.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'SupplyContract.SupplyContractNav': {
        url: '/supplycontract',
        params: {
          module: 'supplycontract',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'SupplyContract.SupplyContractEdit',
            'SupplyContract.SupplyContractDuplicate',
            'SupplyContract.View',
            'SupplyContract.SupplyContractLinkEdit',
            'SupplyContract.DasDocumentsNav',
          ],
          documentEntity: 'supplycontract',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractNav.html',
            controller: 'SupplyContractNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/ListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Navigáció',
        },
      },
      'SupplyContract.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'SupplyContract.SupplyContractEdit': {
        url: '/supplycontractedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          BackTo: 'Nav',
          backState: 'main',
          bstates: ['SupplyContract.SupplyContractStatusEdit', 'SupplyContract.SupplyContractStatusDuplicate'],
          documentEntity: 'supplycontract_supplycontractedit',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés szerkesztés',
        },
      },
      'SupplyContract.SupplyContractCreate': {
        url: '/supplycontractedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          BackTo: 'Nav',
          backState: 'main',
          bstates: ['SupplyContract.SupplyContractStatusEdit', 'SupplyContract.SupplyContractStatusDuplicate'],
          documentEntity: 'supplycontract_supplycontractedit',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés szerkesztés',
        },
      },
      'SupplyContract.SupplyContractDuplicate': {
        url: '/supplycontractduplicate/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          documentEntity: 'supplycontract_supplycontractedit',
          BackTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés másolás',
        },
      },
      'SupplyContract.View': {
        url: '/view/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          documentEntity: 'supplycontract_supplycontractedit',
          BackTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés megtekintés',
        },
      },
      'SupplyContract.SupplyContractLinkEdit': {
        url: '/supplycontractlinkedit/{id:int}?edit',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractLinkEdit/', undefined, ['id', 'edit']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'LinkEdit',
          Operation: 'LinkEdit',
          BackTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés láncolás',
        },
      },
      'SupplyContract.SupplyContractLinkCreate': {
        url: '/supplycontractlinkedit/{id:int}?edit',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractEdit.html',
            controller: 'SupplyContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractLinkCreate/', undefined, ['id', 'edit']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          BackTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Szállítói/vevői szerződés láncolás',
        },
      },
      'SupplyContract.GridSupplyContractStatusEdit': {
        url: '/supplycontractstatusedit/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractStatusEdit.html',
            controller: 'SupplyContractStatusEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractStatusEdit/', undefined, ['id', 'SupplyContrId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          documentEntity: 'supplycontract_GridSupplyContractStatusEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'SupplyContract.GridSupplyContractStatusCreate': {
        url: '/supplycontractstatusedit/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractStatusEdit.html',
            controller: 'SupplyContractStatusEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractStatusCreate/', undefined, ['id', 'SupplyContrId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          documentEntity: 'supplycontract_GridSupplyContractStatusEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'SupplyContract.GridSupplyContractStatusDuplicate': {
        url: '/supplycontractstatusduplicate/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractStatusEdit.html',
            controller: 'SupplyContractStatusEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractStatusDuplicate/', undefined, [
            'id',
            'SupplyContrId',
          ]),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          documentEntity: 'supplycontract_GridSupplyContractStatusEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Másolás',
        },
      },
      'SupplyContract.GridSupplyContractPartitionEdit': {
        url: '/supplycontractpartitionedit/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractPartitionEdit.html',
            controller: 'SupplyContractPartitionEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractPartitionEdit/', undefined, ['id', 'SupplyContrId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          documentEntity: 'supplycontract_GridSupplyContractpartitionEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'SupplyContract.GridSupplyContractPartitionCreate': {
        url: '/supplycontractpartitionedit/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractPartitionEdit.html',
            controller: 'SupplyContractPartitionEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractPartitionCreate/', undefined, [
            'id',
            'SupplyContrId',
          ]),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          documentEntity: 'supplycontract_GridSupplyContractpartitionEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'SupplyContract.GridSupplyContractPartitionDuplicate': {
        url: '/supplycontractpartitionduplicate/{id:int}?SupplyContrId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/SupplyContract/SupplyContractPartitionEdit.html',
            controller: 'SupplyContractPartitionEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('SupplyContract/SupplyContractPartitionDuplicate/', undefined, [
            'id',
            'SupplyContrId',
          ]),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          documentEntity: 'supplycontract_GridSupplyContractpartitionEdit',
          BackTo: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Másolás',
        },
      },
      'SupplyContract.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('SupplyContract/{tableId}History/', undefined, [
            'tableId',
            'idColumn',
            'ownerId',
          ]),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'SupplyContract.HelpDeskSpecializationEdit': {
        url: '/helpdeskSpecializationEdit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('SupplyContractMasterData/SpecializationEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          backTo: 'Masterdata.SupplyContract.SpecializationList',
          documentEntity: 'masterdata_supplycontract_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület szerkesztése',
        },
      },
      'SupplyContract.HelpDeskSpecializationCreate': {
        url: '/helpdeskSpecializationEdit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('SupplyContractMasterData/SpecializationCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          backTo: 'Masterdata.SupplyContract.SpecializationList',
          documentEntity: 'masterdata_supplycontract_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület hozzáadása',
        },
      },
      'SupplyContract.HelpDeskSpecializationDuplicate': {
        url: '/helpdeskSpecializationDuplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'SupplyContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('SupplyContractMasterData/SpecializationDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          backTo: 'Masterdata.SupplyContract.SpecializationList',
          documentEntity: 'masterdata_supplycontract_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület másolása',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "SupplyContract");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

'use strict';

function sbContractDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.activeTab = !ctrl.contrFee.MeterId ? 0 : 1;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelContrDiscount', 'PanelContrMeterConsDivided'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: function() {
            return {
              contrFeeId: ctrl.contrFee.ContrFeeId,
            };
          },
        };
      }
    );
  };

  ctrl.showTabs = function(tab) {
    if (
      tab.gridName === 'GridContrDiscount' &&
      (ctrl.contrFee.ServiceType == 'CSERE' || ctrl.contrFee.ServiceType == 'CSEUS')
    )
      return true;
    if (tab.gridName === 'GridContrMeterConsDivided' && !!ctrl.contrFee.MeterId) return true;
    return false;
  };

  //#endregion
}

const sbContractDetailComponentOptions = {
  templateUrl: 'App/Contract/contract-detail/contract-detail.component.html',
  controller: sbContractDetailComponent,
  bindings: {
    contrFee: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbContractDetail: sbContractDetailComponentOptions,
  };

  const sbContractDetailModule = angular.module('sbContractDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbContractDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbContractInvoiceDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.activeTab = 0;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelInvoiceRow'],
      function(gridModel) {
        if (gridModel.Name === 'GridInvoiceRow') {
          gridModel.ControllerMethod = 'Contract/InvoiceRowList/';

          return {
            gridModel,
            transportData: function() {
              return {
                invoiceId: ctrl.invoice.InvoiceId,
              };
            },
            selectFunction: function() {},
          };
        }

        return null;
      }
    );
  };

  ctrl.showTabs = function(tab) {
    return true;
  };

  //#endregion
}

const sbContractInvoiceDetailComponentOptions = {
  templateUrl: 'App/Contract/contract-invoice-detail/contract-invoice-detail.component.html',
  controller: sbContractInvoiceDetailComponent,
  bindings: {
    invoice: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbContractInvoiceDetail: sbContractInvoiceDetailComponentOptions,
  };

  const sbContractInvoiceDetailModule = angular.module('sbContractInvoiceDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbContractInvoiceDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbContractNavDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contract = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    //ctrl.activeTab = !ctrl.contract.MeterId ? 0 : 1;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelChaining'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: function() {
            return {
              contractId: ctrl.contract.ContractId,
            };
          },
        };
      }
    );
  };

  ctrl.showTabs = function(tab) {
    return true;
  };

  //#endregion
}

const sbContractNavDetailComponentOptions = {
  templateUrl: 'App/Contract/contract-nav-detail/contract-nav-detail.component.html',
  controller: sbContractNavDetailComponent,
  bindings: {
    contract: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbContractNavDetail: sbContractNavDetailComponentOptions,
  };

  const sbContractNavDetailModule = angular.module('sbContractNavDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbContractNavDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = ['sbContractDetail', 'sbContractInvoiceDetail', 'sbContractNavDetail'];

  const sbContractModule = angular.module('sbContract', modules);
})();

(function(module) {
  'use strict';

  module.controller('ServiceMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };

      //Routesban kap értéket: ServiceGroupNav
      var backTo = $state.params.BackTo;
      if (backTo === 'ServiceGroupNav') {
        backMenu.event = function() {
          $state.go('Contract.ServiceGroupNav');
        };
      } else if (backTo === 'ServiceFinancialDataNav') {
        backMenu.event = function() {
          $state.go('Contract.ServiceFinancialDataNav');
        };
      } else {
        backMenu.event = function() {
          $state.go('Contract.ContractNav');
        };
      }

      var desc = {
        Contract_ServiceNav_ServiceGroupNav: { icon: 'fa fa-book' },
        Contract_ServiceNav_ServiceFinancialDataNav: { icon: 'fa fa-signal' },
        Contract_ServiceNav_ServiceReportNav: { icon: 'fa fa-area-chart' },
      };

      buildMenu($state, authService, 'Contract_ServiceNav', 'contract', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('AlreadyAssignedPartnerWarningModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'parameters',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AlreadyAssignedPartnerWarningModalCtrl', stateParams);
      }
      var vm = this;
      vm.contractsWherePartnerIsTenant = parameters.contractsWherePartnerIsTenant;
      vm.contractsWherePartnerIsUser = parameters.contractsWherePartnerIsUser;

      vm.cancel = function() {
        $uibModalInstance.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContractIncomeReportModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$window',
    '$uibModal',
    '$uibModalInstance',
    'FileSaver',
    'model',
    'parameters',
    function($scope, $http, $state, $stateParams, $window, $uibModal, $uibModalInstance, FileSaver, model, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractIncomeReportModalCtrl', stateParams);
      }
      var vm = this;

      vm.cancel = cancel;
      vm.generate = generate;

      init(vm, $scope, $http, $state, $stateParams, $window, $uibModal, $uibModalInstance, model, parameters);

      function init(vm, $scope, $http, $state, $stateParams, $window, $uibModal, $uibModalInstance, model, parameters) {
        vm.pageModel = model.pageModel;
        vm.dto = model.dto;
        vm.firstPeriod;
        vm.lastPeriod;

        vm.dto.ContractId = parameters.contractId;

        initModel($http, $state, $stateParams, vm, model, $window);
        initViewModel($http, $state, $stateParams, vm, model, $window);
        initFormModel($http, $state, $stateParams, vm, model, $window);

        vm.FormlyDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.FormlyDescriptors.PanelForm.Model = {};

        vm.pageModel.Fields.FinancialYearId.ControllerMethod = 'Contract/FinancialYearComboList';

        var onBlurFunctions = {
          FinancialYearId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.FinancialYearId = selectedItem;
            }
          },
          FirstPeriodId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.FirstPeriodId = selectedItem;
            }
          },
          LastPeriodId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.LastPeriodId = selectedItem;
            }
          },
          ShowContractsWithOpenStatus: function(selectedItem) {
            if (selectedItem) {
              vm.dto.ShowContractsWithOpenStatus = selectedItem;
            }
          },
        };
        InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

        var onChangeFunctions = {
          FinancialYearId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.FinancialYearId = selectedItem.key;
              reloadPeriodCombos(selectedItem.key);
              reValidate();
            }
          },
          FirstPeriodId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.FirstPeriodId = selectedItem.key;
              vm.firstPeriod = selectedItem.extraProperties[0].value;
              reValidate();
            }
          },
          LastPeriodId: function(selectedItem) {
            if (selectedItem) {
              vm.dto.LastPeriodId = selectedItem.key;
              vm.lastPeriod = selectedItem.extraProperties[0].value;
              reValidate();
            }
          },
          ShowContractsWithOpenStatus: function(selectedItem) {
            if (selectedItem) {
              vm.dto.ShowContractsWithOpenStatus = selectedItem.key;
            }
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      var syncValidators = {
        FirstPeriodId: {
          FirstPeriodValidator: function(modelValue, viewValue) {
            if (!vm.firstPeriod || !vm.lastPeriod || !vm.dataModel.FinancialYearId) {
              return true;
            }

            return parseInt(vm.firstPeriod.substring(4, 5)) < parseInt(vm.lastPeriod.substring(4, 5));
          },
        },
        LastPeriodId: {
          LastPeriodValidator: function(modelValue, viewValue) {
            if (!vm.firstPeriod || !vm.lastPeriod || !vm.dataModel.FinancialYearId) {
              return true;
            }

            return parseInt(vm.firstPeriod.substring(4, 5)) < parseInt(vm.lastPeriod.substring(4, 5));
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      function reloadPeriodCombos(financialYearId) {
        resetCombo(
          'FirstPeriodId',
          'Contract/FirstPeriodComboListByFinancialYearId?financialYearId=' + financialYearId
        );
        resetCombo('LastPeriodId', 'Contract/LastPeriodComboListByFinancialYearId?financialYearId=' + financialYearId);
      }

      function resetCombo(comboName, url) {
        var field = vm.pageModel.Fields[comboName];
        field.ControllerMethod = url;

        var comboId = vm.FormlyDescriptors.PanelForm.FormlyDescriptor.getField(comboName).id;
        var comboDataSource = $('#' + comboId).data('kendoDropDownList').dataSource;
        comboDataSource.transport.options.read.url = url;
        comboDataSource.read();
      }

      function reValidate() {
        if (vm.pageModel.Fields.FirstPeriodId.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.FirstPeriodId.FormlyFieldDescriptor.formControl.$validate();
        }
        if (vm.pageModel.Fields.LastPeriodId.FormlyFieldDescriptor.formControl) {
          vm.pageModel.Fields.LastPeriodId.FormlyFieldDescriptor.formControl.$validate();
        }
      }

      function cancel() {
        $uibModalInstance.close();
      }

      function generate() {
        // generate
        $http
          .post('Contract/GenerateIncomeReport', vm.dto)
          .then(function(response) {
            var data = response.data.Report;
            saveFileAs(data, 'report.xls');
            toastr.success('Sikeres generálás!');
          })
          .catch(function(response) {
            toastr.error('Sikertelen generálás');
          });
      }

      function saveFileAs(data, fileName) {
        var raw = window.atob(data);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(fs, fileName);
      }
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Contract: {
        url: '/contract',
        templateUrl: 'App/Contract/ContractLayout.html',
        controller: 'ContractLayoutCtrl as vm',
        redirectTo: 'Contract.ContractNav',
        ncyBreadcrumb: {
          label: 'Bérleti szerződések',
          parent: 'main',
        },
      },
      'Contract.ContractNav': {
        url: '/contract',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Contract.ContractEdit',
            'Contract.ContractLinkEdit',
            'Contract.ContractDuplicate',
            'Contract.ContractView',
          ],
          documentEntity: 'contract',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractNav.html',
            controller: 'ContractNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ListOptions/'),
        },
        options: {
          mvcController: 'Contract/ListOptions/',
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Bérleti szerződések',
        },
      },
      'Contract.ContractNavDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        options: {
          mvcController: 'Das/Documents/DocumentsListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Contract.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        options: {
          mvcController: 'Das/Documents/DocumentsListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Contract.ContractEdit': {
        url: '/contractedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractEdit.html',
            controller: 'ContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractNav',
          module: 'Contract',
          documentEntity: 'contract_contractedit',
          openedPanelGroup: null,
          focusToField: null,
        },
        ncyBreadcrumb: {
          label: 'Szerződés szerkesztés',
        },
      },
      'Contract.ContractEdit.CustomerService': {
        url: '/contractedit/customerservice/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractEdit.html',
            controller: 'ContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractEditCustomerService/{id}'),
        },
        options: {
          mvcController: 'Contract/ContractEditCustomerService/{id}',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractNav',
          module: 'Contract',
          documentEntity: 'contract_contractedit',
        },
        ncyBreadcrumb: {
          label: 'Szerződés szerkesztés',
        },
      },
      'Contract.ContractDuplicate': {
        url: '/contractduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractEdit.html',
            controller: 'ContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractNav',
          module: 'Contract',
          documentEntity: 'contract_contractedit',
        },
        ncyBreadcrumb: {
          label: 'Szerződés másolás',
        },
      },

      // Bérleti díj indexálás

      'Contract.RentIndexationGen': {
        url: '/rentindexationgen/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/RentIndexationGen.html',
            controller: 'RentIndexationGenCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/RentIndexationGen/'),
        },
        options: {
          mvcController: 'Contract/RentIndexationGen/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          BackTo: 'ContractNav',
          module: 'Contract',
          documentEntity: 'masterdata_contract_rentindexationlist',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj indexálás',
        },
      },

      // Bérleti díj indexálás vége

      // Díjak grid

      'Contract.GridFeeEdit': {
        url: '/contrfeeedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrFeeEdit.html',
            controller: 'ContrFeeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrFeeEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrFeeEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridfeeedit',
        },
        ncyBreadcrumb: {
          label: 'Díj hozzáadása',
        },
      },
      'Contract.GridFeeCreate': {
        url: '/contrfeecreate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrFeeEdit.html',
            controller: 'ContrFeeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrFeeCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrFeeCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridfeeedit',
        },
        ncyBreadcrumb: {
          label: 'Díj hozzáadása',
        },
      },
      'Contract.GridFeeDuplicate': {
        url: '/contrfeeduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrFeeEdit.html',
            controller: 'ContrFeeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrFeeDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrFeeDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridfeeedit',
        },
        ncyBreadcrumb: {
          label: 'Díj másolása',
        },
      },

      // Díjak grid vége
      // Dokumentum grid

      'Contract.GridContrLetterEdit': {
        url: '/contrletteredit/{id:int}?{ContractId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrLetterEdit.html',
            controller: 'ContrLetterEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrLetterEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrLetterEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_contrletteredit',
        },
        ncyBreadcrumb: {
          label: 'Generált dokumentum hozzáadása',
        },
      },
      'Contract.GridContrLetterCreate': {
        url: '/contrlettercreate/{id:int}?{ContractId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrLetterEdit.html',
            controller: 'ContrLetterEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrLetterCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrLetterCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_contrletteredit',
        },
        ncyBreadcrumb: {
          label: 'Generált dokumentum hozzáadása',
        },
      },

      'Contract.GridContrLetterDuplicate': {
        url: '/contrletterduplicate/{id:int}?{ContractId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrLetterEdit.html',
            controller: 'ContrLetterEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrLetterDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrLetterDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'Contract/ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_contrletteredit',
        },
        ncyBreadcrumb: {
          label: 'Generált dokumentum hozzáadása',
        },
      },

      // Dokumentum grid vége

      'Contract.ContractView': {
        url: '/contractview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractEdit.html',
            controller: 'ContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractView/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractView/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'ContractNav',
          module: 'Contract',
          documentEntity: 'contract_contractedit',
        },
        ncyBreadcrumb: {
          label: 'Szerződés megtekintés',
        },
      },
      // óvadék grid
      'Contract.GridDepositEdit': {
        url: '/contrdepositedit/{id:int}?{ContractId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrDepositEdit.html',
            controller: 'ContrDepositEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrDepositEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrDepositEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griddepositedit',
        },
        ncyBreadcrumb: {
          label: 'Óvadék szerkesztés',
        },
      },
      'Contract.GridDepositCreate': {
        url: '/contrdepositedit/{id:int}?{ContractId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrDepositEdit.html',
            controller: 'ContrDepositEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrDepositCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrDepositCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griddepositedit',
        },
        ncyBreadcrumb: {
          label: 'Óvadék szerkesztés',
        },
      },
      'Contract.GridDepositDuplicate': {
        url: '/contrdepositduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrDepositEdit.html',
            controller: 'ContrDepositEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrDepositDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContrDepositDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griddepositedit',
        },
        ncyBreadcrumb: {
          label: 'Óvadék másolás',
        },
      },
      // óvadék grid vége

      // fizetési megállapodások
      'Contract.GridPaymentEdit': {
        url: '/contrpaymentedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrPaymentEdit.html',
            controller: 'ContrPaymentEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrPaymentEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrPaymentEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridpaymentedit',
        },
        ncyBreadcrumb: {
          label: 'Fizetési megállapodás szerkesztés',
        },
      },
      'Contract.GridPaymentCreate': {
        url: '/contrpaymentcreate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrPaymentEdit.html',
            controller: 'ContrPaymentEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrPaymentCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrPaymentCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridpaymentedit',
        },
        ncyBreadcrumb: {
          label: 'Fizetési megállapodás szerkesztés',
        },
      },
      'Contract.GridPaymentDuplicate': {
        url: '/contrpaymentduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrPaymentEdit.html',
            controller: 'ContrPaymentEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrPaymentDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrPaymentDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridpaymentedit',
        },
        ncyBreadcrumb: {
          label: 'Fizetési megállapodás másolás',
        },
      },
      // fizetési megállapodások vége

      // használók grid
      'Contract.GridUsersEdit': {
        url: '/contrusersedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrUsersEdit.html',
            controller: 'ContrUsersEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrUsersEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrUsersEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griduseredit',
        },
        ncyBreadcrumb: {
          label: 'Használó',
        },
      },
      'Contract.GridUsersCreate': {
        url: '/contruserscreate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrUsersEdit.html',
            controller: 'ContrUsersEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrUsersCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrUsersCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griduseredit',
        },
        ncyBreadcrumb: {
          label: 'Használó',
        },
      },

      // Ügyviteli információk grid
      'Contract.GridContrInformationDuplicate': {
        url: '/contrinformationduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrInformationEdit.html',
            controller: 'ContrInformationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrInformationDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrInformationDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrinformationedit',
        },
        ncyBreadcrumb: {
          label: 'Ügyviteli információ szerkesztése',
        },
      },
      'Contract.GridContrInformationEdit': {
        url: '/contrinformationedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrInformationEdit.html',
            controller: 'ContrInformationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrInformationEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrInformationEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrinformationedit',
        },
        ncyBreadcrumb: {
          label: 'Ügyviteli információ szerkesztése',
        },
      },
      'Contract.GridUsersEdit.CustomerService': {
        url: '/contrusersedit/customerservice/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrUsersEdit.html',
            controller: 'ContrUsersEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrUsersEditCustomerService/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrUsersEditCustomerService/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griduseredit',
        },
        ncyBreadcrumb: {
          label: 'Használó',
        },
      },
      'Contract.GridContrInformationCreate': {
        url: '/contrinformationcreate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrInformationEdit.html',
            controller: 'ContrInformationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrInformationCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrInformationCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrinformationedit',
        },
        ncyBreadcrumb: {
          label: 'Ügyviteli információ szerkesztése',
        },
      },
      'Contract.GridUsersDuplicate': {
        url: '/contrusersduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrUsersEdit.html',
            controller: 'ContrUsersEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrUsersDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrUsersDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_griduseredit',
        },
        ncyBreadcrumb: {
          label: 'Használó másolás',
        },
      }, // használók grid vége

      // Bérbeszámítás grid
      'Contract.GridContrCostEdit': {
        url: '/contrcostedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrCostEdit.html',
            controller: 'ContrCostEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrCostEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrCostEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrcostedit',
        },
        ncyBreadcrumb: {
          label: 'Bérbeszámítás',
        },
      },
      'Contract.GridContrCostCreate': {
        url: '/contrcostcreate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrCostEdit.html',
            controller: 'ContrCostEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrCostCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/ContrCostCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrcostedit',
        },
        ncyBreadcrumb: {
          label: 'Bérbeszámítás',
        },
      },
      'Contract.GridContrCostDuplicate': {
        url: '/contrcostduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrCostEdit.html',
            controller: 'ContrCostEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrCostDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContrCostDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridcontrcostedit',
        },
        ncyBreadcrumb: {
          label: 'Bérbeszámítás',
        },
      },
      // Bérbeszámítás vége

      // előlegszámla karbantartó
      'Contract.GridAdvanceAccountEdit': {
        url: '/advanceaccountedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/AdvanceAccountEdit.html',
            controller: 'AdvanceAccountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/AdvanceAccountEdit/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/AdvanceAccountEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridadvanceaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Előlegszámla szerkesztés',
        },
      },
      'Contract.GridAdvanceAccountCreate': {
        url: '/advanceaccountedit/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/AdvanceAccountEdit.html',
            controller: 'AdvanceAccountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/AdvanceAccountCreate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/AdvanceAccountCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridadvanceaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Előlegszámla szerkesztés',
        },
      },
      'Contract.GridAdvanceAccountDuplicate': {
        url: '/advanceaccountduplicate/{id:int}?ContractId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/ContractAdvanceAccountEdit.html',
            controller: 'AdvanceAccountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/AdvanceAccountDuplicate/', undefined, ['id', 'ContractId']),
        },
        options: {
          mvcController: 'Contract/AdvanceAccountDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'ContractEdit',
          module: 'Contract',
          documentEntity: 'contract_gridadvanceaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Előlegszámla karbantartó másolás',
        },
      },
      // Előlegszámla karbantartó

      'Contract.ContractLinkEdit': {
        url: '/contractlinkedit/{id:int}?edit',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContractEdit.html',
            controller: 'ContractEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractLinkEdit/', undefined, ['id', 'edit']),
        },
        options: {
          mvcController: 'Contract/ContractLinkEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'LinkEdit',
          BackTo: 'Nav',
          module: 'Contract',
          documentEntity: 'contract_contractedit',
        },
        ncyBreadcrumb: {
          label: 'Szerződés láncolás',
        },
      },
      'Contract.ServiceDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        options: {
          mvcController: 'Das/Documents/DocumentsListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Contract.ServiceGroupNav': {
        url: '/service/serviceNav',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'Contract.ContractNav',
          createGroupState: 'Contract.ServiceGroupCreate',
          editGroupState: 'Contract.ServiceGroupEdit',
          duplicateGroupState: 'Contract.ServiceGroupDuplicate',
          createState: 'Contract.ServiceCreate',
          editState: 'Contract.ServiceEdit',
          duplicateState: 'Contract.ServiceDuplicate',
          bstates: [
            'Contract.ServiceGroupEdit',
            '"Contract.ServiceGroupDuplicate',
            'Contract.ServiceEdit',
            'Contract.ServiceDuplicate',
          ],
          documentEntity: 'contract_servicegroupnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupNav.html',
            controller: 'ServiceGroupNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ServiceGroupListOptions/'),
        },
        options: {
          mvcController: 'Contract/ServiceGroupListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Contract.ServiceGroupEdit': {
        url: '/servicegroupedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceGroupEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceGroupEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_servicegroupedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Contract.ServiceGroupCreate': {
        url: '/servicegroupcreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceGroupCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceGroupCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          formMode: 'Create',
          EditOrDuplicate: 'Edit',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_servicegroupedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Contract.ServiceGroupDuplicate': {
        url: '/servicegroupduplicate/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceGroupDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceGroupDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_servicegroupedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoport másolás',
        },
      },
      'Contract.ServiceEdit': {
        url: '/serviceedit/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceEdit/', undefined, ['id', 'ServiceGroupId']),
        },
        options: {
          mvcController: 'Contract/ContractServiceEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_serviceedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel',
        },
      },
      'Contract.ServiceCreate': {
        url: '/servicecreate/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceCreate/', undefined, ['id', 'ServiceGroupId']),
        },
        options: {
          mvcController: 'Contract/ContractServiceCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_serviceedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel',
        },
      },
      'Contract.ServiceDuplicate': {
        url: '/serviceduplicate/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceDuplicate/', undefined, ['id', 'ServiceGroupId']),
        },
        options: {
          mvcController: 'Contract/ContractServiceDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'Contract.ServiceGroupNav',
          module: 'Contract',
          documentEntity: 'contract_serviceedit',
        },
        ncyBreadcrumb: {
          label: 'Másolás',
        },
      },
      'Contract.DiscountNav': {
        url: '/discount',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Contract.DiscountCreate', 'Contract.DiscountEdit', 'Contract.DiscountDuplicate'],
          documentEntity: 'contract_discountnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountNav.html',
            controller: 'DiscountNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountListOptions/'),
        },
        options: {
          mvcController: 'Contract/DiscountListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmények',
        },
      },
      'Contract.DiscountCreate': {
        url: '/discountcreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountEdit.html',
            controller: 'DiscountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'DiscountNav',
          module: 'Contract',
          documentEntity: 'contract_discountcreate',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény hozzáadás',
        },
      },
      'Contract.DiscountEdit': {
        url: '/discountedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountEdit.html',
            controller: 'DiscountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'DiscountNav',
          module: 'Contract',
          documentEntity: 'contract_discountcreate',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény szerkesztés',
        },
      },
      'Contract.DiscountDuplicate': {
        url: '/discountduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountEdit.html',
            controller: 'DiscountEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'DiscountNav',
          module: 'Contract',
          documentEntity: 'contract_discountcreate',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény másolás',
        },
      },
      'Contract.DiscountGroupNav': {
        url: '/discountgroup',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Contract.DiscountGroupEdit', 'Contract.DiscountGroupDuplicate'],
          documentEntity: 'contract_discountgroupnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountGroupNav.html',
            controller: 'DiscountGroupNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountGroupListOptions/'),
        },
        options: {
          mvcController: 'Contract/DiscountGroupListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény csoportok',
        },
      },
      'Contract.DiscountGroupEdit': {
        url: '/discountgroupedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountGroupEdit.html',
            controller: 'DiscountGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountGroupEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountGroupEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'DiscountGroupNav',
          module: 'Contract',
          documentEntity: 'contract_discountgroupedit',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény csoportok',
        },
      },
      'Contract.DiscountGroupCreate': {
        url: '/discountgroupedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountGroupEdit.html',
            controller: 'DiscountGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountGroupCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountGroupCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          formMode: 'Create',
          EditOrDuplicate: 'Edit',
          BackTo: 'DiscountGroupNav',
          module: 'Contract',
          documentEntity: 'contract_discountgroupedit',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény csoportok',
        },
      },
      'Contract.DiscountGroupDuplicate': {
        url: '/discountgroupduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'DiscountMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/DiscountGroupEdit.html',
            controller: 'DiscountGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/DiscountGroupDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/DiscountGroupDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'DiscountGroupNav',
          module: 'Contract',
          documentEntity: 'contract_discountgroupedit',
        },
        ncyBreadcrumb: {
          label: 'Kedvezmény csoport másolás',
        },
      },

      'Contract.ServiceFinancialDataNav': {
        url: '/service/ServiceFinancialDataNav',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          createState: 'Contract.ServiceFinancialDataCreate',
          editState: 'Contract.ServiceFinancialDataEdit',
          duplicateState: 'Contract.ServiceFinancialDataDuplicate',
          bstates: ['Contract.ServiceFinancialDataEdit', 'Contract.ServiceFinancialDataDuplicate'],
          documentEntity: 'contract_servicefinancialdatanav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataNav.html',
            controller: 'ServiceFinancialDataNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ServiceFinancialDataListOptions/'),
        },
        options: {
          mvcController: 'Contract/ServiceFinancialDataListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
          parent: 'Contract.ServiceGroupNav',
        },
      },

      'Contract.ServiceFinancialDataEdit': {
        url: '/servicefinancialdataedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceFinancialDataEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceFinancialDataEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backState: 'Contract.ServiceFinancialDataNav',
          module: 'Contract',
          documentEntity: 'contract_servicefinancialdataedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
        },
      },
      'Contract.ServiceFinancialDataCreate': {
        url: '/servicefinancialdataedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceFinancialDataCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceFinancialDataCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          formMode: 'Create',
          EditOrDuplicate: 'Edit',
          backState: 'Contract.ServiceFinancialDataNav',
          module: 'Contract',
          documentEntity: 'contract_servicefinancialdataedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
        },
      },
      'Contract.ServiceFinancialDataDuplicate': {
        url: '/servicefinancialdataduplicate/{id:int}?ServiceFinancialDataId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContractServiceFinancialDataDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/ContractServiceFinancialDataDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          backState: 'Contract.ServiceFinancialDataNav',
          module: 'Contract',
          documentEntity: 'contract_servicefinancialdataedit',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai másolás',
        },
      },

      'Contract.PriceListNav': {
        url: 'service/PriceListNav',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Contract.PriceListEdit',
            'Contract.PriceListDuplicate',
            'Contract.PriceListRowEdit',
            'Contract.PriceListRowDuplicate',
          ],
          documentEntity: 'contract_pricelistnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListNav.html',
            controller: 'PriceListNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListListOptions/'),
        },
        options: {
          mvcController: 'Contract/PriceListListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Árlisták',
          parent: 'Contract.ContractNav',
        },
      },

      'Contract.PriceListEdit': {
        url: '/PriceListedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListEdit.html',
            controller: 'PriceListEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceListEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistedit',
        },
        ncyBreadcrumb: {
          label: 'Árlista',
        },
      },
      'Contract.PriceListCreate': {
        url: '/PriceListedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListEdit.html',
            controller: 'PriceListEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceListCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistedit',
        },
        ncyBreadcrumb: {
          label: 'Árlista',
        },
      },
      'Contract.PriceListDuplicate': {
        url: '/PriceListduplicate/{id:int}?PriceListId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListEdit.html',
            controller: 'PriceListEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceListDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistedit',
        },
        ncyBreadcrumb: {
          label: 'Árlista másolás',
        },
      },

      'Contract.PriceListRowEdit': {
        url: '/PriceListrowedit/{id:int}?PriceListId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListRowEdit.html',
            controller: 'PriceListRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListRowEdit/', undefined, ['id', 'PriceListId']),
        },
        options: {
          mvcController: 'Contract/PriceListRowEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistrowedit',
        },
        ncyBreadcrumb: {
          label: 'Egységárak',
        },
      },
      'Contract.PriceListRowCreate': {
        url: '/PriceListrowcreate/{id:int}?PriceListId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListRowEdit.html',
            controller: 'PriceListRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListRowCreate/', undefined, ['id', 'PriceListId']),
        },
        options: {
          mvcController: 'Contract/PriceListRowCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistrowedit',
        },
        ncyBreadcrumb: {
          label: 'Egységárak',
        },
      },
      'Contract.PriceListRowDuplicate': {
        url: '/PriceListrowduplicate/{id:int}?PriceListRowId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceListRowEdit.html',
            controller: 'PriceListRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceListRowDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceListRowDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'PriceListNav',
          module: 'Contract',
          documentEntity: 'contract_pricelistrowedit',
        },
        ncyBreadcrumb: {
          label: 'Egységár másolás',
        },
      },
      'Contract.PriceTypeNav': {
        url: 'service/PriceTypeNav',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Contract.PriceTypeEdit', 'Contract.PriceTypeDuplicate'],
          documentEntity: 'contract_pricetypenav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceTypeNav.html',
            controller: 'PriceTypeNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceTypeListOptions/'),
        },
        options: {
          mvcController: 'Contract/PriceTypeListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Ártípusok',
          parent: 'Contract.ContractNav',
        },
      },
      'Contract.PriceTypeEdit': {
        url: '/PriceTypeedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceTypeEdit.html',
            controller: 'PriceTypeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceTypeEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceTypeEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceTypeNav',
          module: 'Contract',
          documentEntity: 'contract_pricetypeedit',
        },
        ncyBreadcrumb: {
          label: 'Ártípusok',
        },
      },
      'Contract.PriceTypeCreate': {
        url: '/PriceTypeedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceTypeEdit.html',
            controller: 'PriceTypeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceTypeCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceTypeCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceTypeNav',
          module: 'Contract',
          documentEntity: 'contract_pricetypeedit',
        },
        ncyBreadcrumb: {
          label: 'Ártípusok',
        },
      },
      'Contract.PriceTypeDuplicate': {
        url: '/PriceTypeduplicate/{id:int}?PriceTypeId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceTypeEdit.html',
            controller: 'PriceTypeEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceTypeDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceTypeDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'PriceTypeNav',
          module: 'Contract',
          documentEntity: 'contract_pricetypeedit',
        },
        ncyBreadcrumb: {
          label: 'Ártípus másolás',
        },
      },

      'Contract.PriceTypeRowEdit': {
        url: '/PriceTyperowedit/{id:int}?PriceTypeId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'PriceListMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/PriceTypeRowEdit.html',
            controller: 'PriceTypeRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/PriceTypeRowEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Contract/PriceTypeRowEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'PriceTypeNav',
          module: 'Contract',
          documentEntity: 'contract_pricetypeedit',
        },
        ncyBreadcrumb: {
          label: 'Ártípus szerkesztés',
        },
      },
      'Contract.InvoiceNav': {
        url: '/invoicenav/{InvoiceTypeFilter:string}/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceNav.html',
            controller: 'InvoiceNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/ListInvoiceOptions/', undefined, ['InvoiceTypeFilter']),
        },
        options: {
          mvcController: 'Invoice/ListInvoiceOptions/',
        },
        params: {
          module: 'Contract',
          InvoiceTypeFilter: 'INTRM',
          BackTo: 'Contract',
          lockTypeFilterCombo: true,
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Contract.RentAccountAdd',
            'Contract.RentAccountEdit',
            'Contract.RentAccountDuplicate',
            'Contract.RentAccountView',
            'Contract.RentCorrection',
          ],
          documentEntity: 'contract_invoicenav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számlák',
        },
      },
      'Contract.RentAccountAdd': {
        url: '/rentaccountadd/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla felvétele',
        },
      },
      'Contract.RentInvoiceEdit': {
        url: '/rentaccountedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla szerkesztése',
        },
      },
      'Contract.RentAccountDuplicate': {
        url: '/rentaccountduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla másolás',
        },
      },
      'Contract.RentInvoiceView': {
        url: '/rentaccountview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceView/', undefined, ['id']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceView/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla megtekintés',
        },
      },
      'Contract.RentInvoiceStorno': {
        url: '/rentstorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceStorno/', undefined, ['invoiceId']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceStorno/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számlák stornózása',
        },
      },
      'Contract.RentInvoiceCorrection': {
        url: '/rentcorrection/{invoiceId:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceCorrection/', undefined, ['invoiceId']),
        },
        options: {
          mvcController: 'Invoice/RentInvoiceCorrection/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Contract',
          documentEntity: 'contract_rentaccountadd',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj helyesbítő számla',
        },
      },
      'Contract.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Contract/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Contract.ContrFeeImport': {
        url: '/contrfeeimport',
        params: {
          module: 'Contract',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Contract.ContractEdit',
            'Contract.ContractLinkEdit',
            'Contract.ContractDuplicate',
            'Contract.ContractView',
          ],
          documentEntity: 'contrfeeimport',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ContractMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ContrFeeImportNav.html',
            controller: 'ContrFeeImportNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ContrFeeImportListOptions/'),
        },
        options: {
          mvcController: 'Contract/ContrFeeImportListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Díjak tömeges kezelése',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Contract");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('ContractNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    'AuthService',
    'FileSaver',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      gridService,
      authService,
      FileSaver
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.reportList = options.reportList;
      vm.reportList.forEach(x => {
        switch (x.ReportId) {
          case 'EloSzerzodesek':
            x.ReportName = vm.actions['ActiveContracts']?.Title ?? x.ReportName;
            break;
          case 'SzerzodesTorzs':
            x.ReportName = vm.actions['ContractMasterData']?.Title ?? x.ReportName;
            break;
          case 'BerlemenyTorzs':
            x.ReportName = vm.actions['PropertyMasterData']?.Title ?? x.ReportName;
            break;
          case 'BerlemenyTorzs_ures_helyiseg':
            x.ReportName = vm.actions['EmptyPremises']?.Title ?? x.ReportName;
            break;
          case 'BerlemenyTorzs_ures_lakas':
            x.ReportName = vm.actions['ActionFixReportsEmptyFlats']?.Title ?? x.ReportName;
            break;
          case 'PartnerIdogep':
            x.ReportName = vm.actions['ActionFixPartnerTimeMachine']?.Title ?? x.ReportName;
            break;
        }
        return x;
      });

      vm.createContract = createContract;
      vm.editContract = editContract;
      vm.duplicateContract = duplicateContract;
      vm.deleteContract = deleteContract;
      vm.viewContract = viewContract;
      vm.linkContract = linkContract;
      vm.changeTitleAndUsageFee = changeTitleAndUsageFee;
      vm.changeTitleAndUsageFeeState = changeTitleAndUsageFeeState;
      vm.generateContrInvoice = generateContrInvoice;
      vm.generateFixReports = generateFixReports;
      vm.rentIndexationGen = rentIndexationGen;
      vm.findRentableUnit = findRentableUnit;
      vm.addEventHandlerForMigratedContracts = addEventHandlerForMigratedContracts;
      vm.WAL = WAL;
      vm.History = History;
      vm.disabled = true;

      vm.filter = filter;

      vm.activeMainItemTab = 0;
      vm.activeDetailItemTab = 0;

      vm.isFilterCollapsed = true;

      vm.back = function() {
        $state.go('main');
      };
      authService.executeActionWithPermission(vm, 'changeTitleAndUsageFee', 'Contract/GetContrTitleChange');
      authService.executeActionWithPermission(
        vm,
        'addEventHandlerForMigratedContracts',
        'Contract/AddEventHandlerForMigratedContracts'
      );
      // ContractIncomeReport
      vm.incomeReport = function() {
        var contractIdNeeded = false;
        if (contractIdNeeded) {
          var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
          var selectedItems = GetSelectedItems(selectedGrid);
          if (!selectedItems || selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var contractId = selectedItems[selectedGrid.options.idColumn];
            openIncomeReportModal(contractId);
          }
        } else {
          openIncomeReportModal(0);
        }
      };

      vm.editDisabled = function() {
        var selectedItems = GetSelectedItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItems && selectedItems.length > 0 && selectedItems['ContractStatus'] === 'CCSCL') {
          return true;
        }
        return false;
      };

      function openIncomeReportModal(contractId) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContractIncomeReportModal.html',
          controller: 'ContractIncomeReportModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Contract/ContractIncomeReport'),
            parameters: {
              contractId: contractId,
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          // nothing to do...
        });
      }

      // ContractTransmissionFeeReport
      vm.transFeeReport = function() {
        var modalInstanceTreeView = $uibModal.open({
          templateUrl: 'App/Contract/ContractTransFeeReportModal.html',
          controller: 'ContractTransFeeReportModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Contract/ContractTransFeeReport'),
          },
          backdrop: 'static',
        });

        modalInstanceTreeView.result.then(function(resultPropertyIds) {
          $http.post('Contract/GetGeneratedTransFeeCount', { ids: resultPropertyIds }).then(function(resultCount) {
            bootbox.dialog({
              message:
                'A kiválasztott létesítmények alapján ' +
                resultCount.data.Value +
                ' darab díjközlő kimutatás kerül generálásra.<br /><br />Folytatja?',
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http
                      .post('Contract/GetTransFeeReportsByPropertyId', {
                        ids: resultPropertyIds,
                      })
                      .then(function(result) {
                        if (result.data.Value > 0) {
                          openContractsModal(resultPropertyIds);
                        } else {
                          generateAllTransFeeReports(resultPropertyIds, []);
                        }
                      });
                  },
                },
              },
            });
          });
        });
      };

      function openContractsModal(propertyIds) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContractTransFeeConfirmModal.html',
          controller: 'ContractTransFeeConfirmModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Contract/ContractTransFeeConfirmReport', { ids: propertyIds }),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function(excludedReportIds) {
          generateAllTransFeeReports(propertyIds, excludedReportIds);
        });
      }

      function generateAllTransFeeReports(propertyIds, excludedReportIds) {
        $http
          .post('Contract/GenerateAllTransFeeReports', {
            ids: propertyIds,
            excludedReportIds: excludedReportIds,
          })
          .then(function(result) {
            var data = result.data;
            if (data.ResultStatus) {
              var raw = atob(data.File);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }

              var fs = new Blob([array], { type: data.MimeType });
              saveAs(fs, decodeURIComponent(data.FileName));

              toastr.success('Sikeres generálás!');
            }
          });
      }

      vm.getFilter = function() {
        return {
          dto: vm.formModel,
          valid: false,
        };
      };

      vm.getFilterValid = function() {
        return {
          dto: vm.formModel,
          valid: true,
        };
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeDetailTab', vm.activeDetailItemTab);
      });
      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;
      $scope.activeDetailItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeDetailTab')) || 0;
      vm.activeDetailItemTab = $scope.activeDetailItemTab;

      vm.subGrid = vm.pageModel.Grids['GridChainingContract'];

      vm.getSelectedMainGridItemId = function() {
        return {
          ContractId: vm.selectedMainGridItemId,
        };
      };

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelContract', 'PanelAllContract', 'PanelAffectedContract'],
        function(gridDescriptor) {
          if (gridDescriptor.Name === 'GridContract') {
            return {
              gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Contract/ContractListWithFilters/' }),
              transportData: vm.getFilterValid,
              selectFunction: function() {
                changeMainGridFilter();
                setDasModel();
              },
            };
          }

          if (gridDescriptor.Name === 'GridAllContract') {
            return {
              gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Contract/ContractListWithFilters/' }),
              transportData: vm.getFilter,
              selectFunction: function() {
                changeMainGridFilter();
                setDasModel();
              },
            };
          }

          if (gridDescriptor.Name === 'GridAffectedContract') {
            return {
              gridModel: Object.assign({}, gridDescriptor, {
                ControllerMethod: 'Contract/ContractAffectedListWithFilters/',
              }),
              transportData: vm.getFilter,
              selectFunction: function() {
                changeMainGridFilter();
                setDasModel();
              },
            };
          }

          return null;
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      vm.mainGrids = generatedMainGridTabs.grids;

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelChaining'],
        function(gridModel) {
          return {
            gridModel,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailGrid = generatedDetailGridTabs.grids;

      function changeMainGridFilter() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        changeGridFilter(vm, $scope, selectedGrid, selectedGrid.options.idColumn);
      }

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      function createContract() {
        $state.go('Contract.ContractEdit', { id: 0 });
      }

      function editContract() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          $state.go('Contract.ContractEdit', { id: id });
        }
      }

      function duplicateContract() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          $state.go('Contract.ContractDuplicate', { id: id });
        }
      }

      function deleteContract() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/ContractDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function viewContract() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          $state.go('Contract.ContractView', { id: id });
        }
      }

      function linkContract() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          var contract = selectedItems;

          if (contract.ContractStatus !== 'CCSAC') {
            //TODO
            toastr.warning('Csak élő szerződést lehet láncolni!', vm.messages.Warning);
          } else {
            if (!!id) {
              $state.go('Contract.ContractLinkEdit', { id: id, edit: true });
              //    bootbox.dialog({
              //        message: "Válasszon egy opciót!",
              //        title: "Láncolás",
              //        buttons: {
              //            add: {
              //                label: "Új szerződés",
              //                className: "btn-primary",
              //                callback: function () {
              //                    $state.go("Contract.ContractLinkEdit", { "id": id, "edit": false });
              //                }
              //            },
              //            modify: {
              //                label: "Szerződés módosítás",
              //                className: "btn-primary",
              //                callback: function () {
              //                    $state.go("Contract.ContractLinkEdit", { "id": id, "edit": true });
              //                }
              //            },
              //            cancel: {
              //                label: "Mégse",
              //                className: "btn-default",
              //                callback: function () {
              //                }
              //            }
              //        }
              //    });
            }
          }
        }
      }
      function generateFixReports(type) {
        if (type === 'EloSzerzodesek') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ReportActiveContract.html',
            controller: 'ReportActiveContractCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/ReportActiveContract/'),
            },
            backdrop: 'static',
          });
        } else if (type === 'SzerzodesTorzs') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ReportContractMasterData.html',
            controller: 'ReportContractMasterDataCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/ReportContractMasterData/'),
            },
            backdrop: 'static',
          });
        } else if (type === 'BerlemenyTorzs') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ReportPropertyMasterData.html',
            controller: 'ReportPropertyMasterDataCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/ReportPropertyMasterData/'),
            },
            backdrop: 'static',
          });
        } else if (type === 'BerlemenyTorzs_ures_helyiseg') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ReportEmptyPremises.html',
            controller: 'ReportEmptyPremisesCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/ReportEmptyPremises/'),
            },
            backdrop: 'static',
          });
        } else if (type === 'BerlemenyTorzs_ures_lakas') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ReportEmptyFlats.html',
            controller: 'ReportEmptyFlatsCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/ReportEmptyFlats/'),
            },
            backdrop: 'static',
          });
        } else if (type === 'Partner_idogep') {
          $GenerateRiport($http, $uibModal, FileSaver, {
            uibParams: {
              title: vm.actions.ActionFixPartnerTimeMachine?.Title,
            },
            report: type,
            generateController: 'Contract/GenerateReportPartnerTimeMachine',
            getController: 'Contract/ReportPartnerTimeMachine/',
          });
        } else if (type.startsWith('BerlemenyAdatlap')) {
          $GenerateRiport($http, $uibModal, FileSaver, {
            uibParams: {
              title: vm.actions.ActionFixReportsRUData.Title,
            },
            report: type,
            generateController: 'Contract/GenerateReportRentUnitData',
            getController: 'Contract/ReportRentUnitData/',
          });
        } else if (type.startsWith('LakasokAdatai')) {
          $GenerateRiport($http, $uibModal, FileSaver, {
            uibParams: {
              title: vm.actions.ActionFixReportsFlatsData.Title,
              preGenerateCallback: vm.addingFlatsDataFieldProperties,
              afterGenerateCallback: vm.afterFlatsDataFormGenerate,
            },
            report: type,
            generateController: 'Contract/GenerateReportFlatsData',
            getController: 'Contract/ReportFlatsData/',
          });
        } else {
          $http
            .post('Contract/GenerateReportDataWithoutParameters', { report: type })
            .then(function(result) {
              $FileSaveAs(FileSaver, result.data.Report, result.data.FileNameExt, result.data.MimeType);
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.GenerateFailed);
            });
        }
      }
      vm.addingFlatsDataFieldProperties = function(pageModel, model) {};
      vm.afterFlatsDataFormGenerate = function(pageModel, model) {
        var syncValidators = {
          Rooms: {
            NumValidator: function(modelValue) {
              return !modelValue || modelValue >= 0;
            },
          },
          SmallRooms: {
            NumValidator: function(modelValue) {
              return !modelValue || modelValue >= 0;
            },
          },
        };

        InsertSyncValidators(pageModel, syncValidators);
        var whereConditionTenant = function() {
          return 'Tenant~eq~1';
        };
        pageModel.Fields.Tenant.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionTenant;
        var whereConditionCoTenant = function() {
          return 'CoTenant~eq~1';
        };
        pageModel.Fields.CoTenant.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionCoTenant;
        var whereConditionObPropertyId = function() {
          return "Level~eq~'PPROB'";
        };
        pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionObPropertyId;
        var whereConditionPropertyId = function() {
          return "Level~eq~'PPRRU'";
        };
        pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionPropertyId;
      };
      function changeTitleAndUsageFee() {
        var url = 'Contract/GetContrTitleChange/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrTitleChange.html',
          controller: 'ContrTitleChangeCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }
      function changeTitleAndUsageFeeState() {
        return authService?.parameters?.COATCR != 'COATCR_YES';
      }

      function generateContrInvoice() {
        var url = 'Contract/ContrInvoiceGen/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrInvoiceGen.html',
          controller: 'ContrInvoiceGenCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      function rentIndexationGen() {
        $state.go('Contract.RentIndexationGen');
      }

      function findRentableUnit() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/RentableUnitsFindModal.html',
          controller: 'RentableUnitsFindModalCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            fModel: RouteResolveFunc('Contract/RentableUnitsFindListOptions/'),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function(excludedReportIds) {
          //generateAllTransFeeReports(propertyIds, excludedReportIds);
        });
      }

      function addEventHandlerForMigratedContracts() {
        $http
          .post('Contract/AddEventHandlerForMigratedContracts/')
          .then(function(response) {
            if (response.data.RestartNeed) {
              toastr.warning('A funkció újrafuttatása szükséges!', 'Még nem végeztünk minden rekorddal!');
            } else {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function WAL() {
        walService.NavigateToWal('Contract', 'ContractNavWal', 'FlgContractView');
      }

      function History() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[selectedGrid.options.idColumn];
          HistoryService.NavigateToHistory('FlgContract', id, vm, $state, true);
        }
      }

      function GetSelectedItems(selectedGrid) {
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (!selectedItems || selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function filter() {
        if (!!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]].dataSource.read();
        }
      }

      $(window).resize(function() {
        $('#propertyTreeView').height($(window).height() * 0.7);
      });

      function setFilterCellIds() {
        $.each($('#contractGrid').find('.k-filter-row')[0].children, (index, item) => {
          $(item).attr('id', index + '-filtercell');
        });
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids[vm.mainGrids[vm.activeMainItemTab]].DasDescriptor;
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContractEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$uibModal',
    'HistoryService',
    'DasService',
    'LockService',
    'WalService',
    'gridService',
    'UIHelperService',
    'AuthService',
    '$q',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      WalService,
      gridService,
      UIHelperService,
      authService,
      $q
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.isEditedStatus =
        vm.formModel.ContractStatus === 'CCSOP' ||
        vm.formModel.ContractStatus === 'CCSAC' ||
        vm.formModel.ContractStatus === 'CCSDT';
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
        disableRunExpression: false,
        tabOnlyFunction: vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly || !vm.isEditedStatus,
      };
      function headerIsDisabled() {
        return vm.collapseHelper?.disabledPanels?.indexOf('PGHeader') !== -1;
      }
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.originalAvailableSpace = angular.copy(vm.formModel.AvailableSpace);
      vm.originalRentedSpace = angular.copy(vm.formModel.RentedSpace);
      vm.originalInvoicingTo = angular.copy(vm.formModel.InvoicingTo);
      vm.originalContractStatus = angular.copy(vm.formModel.ContractStatus);
      vm.WAL = WAL;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      //Init
      vm.pageModel.PanelGroups.PGOvadek.Disabled = !vm.formModel.HasDepositPanel;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.controllerOptions.isFormReadOnly) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.createContract = createContract;
      vm.lockContract = lockContract;
      vm.duplicateContract = duplicateContract;
      vm.deleteContract = deleteContract;
      vm.saveButtonHandling = saveButtonHandling;
      vm.invoice = invoice;

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.generateSubItem = generateSubItem;
      vm.depositIndicesGen = depositIndicesGen;
      vm.depositStornoGen = depositStornoGen;

      vm.attachDocument = attachDocument;
      vm.history = history;
      vm.isFixed = false;

      //authService.executeActionWithPermission(vm, 'lockContract', 'Contract/ContractLock');
      //authService.executeActionWithPermission(vm, 'generateSubItemFee', 'Contract/ContrFeeGen');
      //authService.executeActionWithPermission(vm, 'depositIndicesGen', 'Contract/ContrDepositIndicesGen');
      //authService.executeActionWithPermission(vm, 'depositStornoGen', 'Contract/ContrDepositStornoGen');
      //authService.executeActionWithPermission(vm, 'generateSubItemDeposit', 'Contract/ContrDepositGen');
      vm.UIHelperService.setDefaultSidebarStatus();

      //ActiveDate iso to pattern:
      if (!!vm.formModel.ActiveDate) {
        var date = moment(vm.formModel.ActiveDate);
        vm.formModel.ActiveDate = date.format(kendo.culture().calendar.patterns.d.toUpperCase());
      }

      vm.loadGridsOnTab = function(gridName) {
        gridService.loadGrid(gridName);
      };

      var open = false;
      if (vm.formModel.ContractStatus === 'CCSOP') {
        open = true;
      }
      //visszatoltesnel vizsgalja es beallitja
      if (!!vm.formModel.extraProperties[1].value) {
        vm.isFixed = vm.formModel.extraProperties[1].value;
      }

      //if(!!vm.formModel.extraProperties[2].value && vm.formModel.extraProperties[2].value === "true") {
      //    vm.isEdit = vm.formModel.extraProperties[2].value;
      //}
      vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.templateOptions.selectFirst = false;
      vm.isSelectedSubItem = false;

      vm.contractId = options.dto.ContractId;

      var propertyId = !!options.dto.PropertyId ? options.dto.PropertyId.Value : 0; //hozzáadásnál ne szálljon el

      vm.contrFeeGridIdField = 'ContrFeeId';
      vm.contrDiscountDetailGrid = $('#GridContrDiscount').data('kendoGrid');
      vm.contrMeterConsDividedDetailGrid = $('#GridContrMeterConsDivided').data('kendoGrid');

      vm.invoiceGridIdField = 'InvoiceId';
      vm.invoiceRowDetailGrid = $('#GridInvoiceRow').data('kendoGrid');

      vm.advanceAccountGridIdField = 'AdvanceAccountId';
      vm.deductibleServiceDetailGrid = $('#GridDeductibleService').data('kendoGrid');
      vm.recognisedServiceDetailGrid = $('#GridRecognisedService').data('kendoGrid');

      vm.activeSubItemTab = 0;
      vm.activeDetailItemTab = 0;
      vm.activeFlowmeterTab = 0;
      vm.activeInvoiceItemTab = 0;

      //lapfül visszatérés
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeInvoiceTab', vm.activeInvoiceItemTab);
      });

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;
      $scope.activeInvoiceItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeInvoiceTab')) || 0;
      vm.activeInvoiceItemTab = $scope.activeInvoiceItemTab;

      //ha megtekintésen vagyunk az összes mező letiltása
      if (vm.EditOrDuplicate === 'View') {
        vm.formModel.IsReadOnly = true;
      }

      vm.getSelectedContractId = function() {
        return {
          targetContractId: vm.contractId,
          targetYear: vm.formModel.Year,
        };
      };

      vm.allTimestamp = false;

      vm.getContrFeeTransportData = function() {
        return {
          targetContractId: vm.contractId,
          targetYear: vm.formModel.Year,
          validOnly: vm.allTimestamp !== true,
        };
      };

      vm.refreshFeeGrid = function() {
        if (vm.grids && vm.grids['GridFee']) {
          vm.grids['GridFee'].dataSource.read();
        }
      };

      vm.getOrigContractId = function() {
        return {
          origContractId: vm.formModel.OrigContractId,
        };
      };

      vm.getSelectedPropertyId = function() {
        return {
          targetPropertyId: propertyId,
        };
      };

      vm.getSelectedContrFeeId = function() {
        return {
          contrFeeId: vm.selectedContrFeeId,
        };
      };

      vm.getSelectedInvoiceId = function() {
        return {
          invoiceId: vm.selectedInvoiceId,
        };
      };

      vm.getSelectedAdvanceAccountId = function() {
        return {
          advanceAccountId: vm.selectedAdvanceAccountId,
        };
      };
      vm.unlock = function() {
        if (!vm.controllerOptions.isFormReadOnly) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
      };
      vm.save = save;
      vm.back = function() {
        $state.go('Contract.ContractNav').then(vm.unlock);
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly || !vm.isEditedStatus) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
        vm.pageModel.Fields.Year.FormlyFieldDescriptor.templateOptions.disabled = false;
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.activeMainItemTab = 0;

      var customTypes = {
        AccountSeparator1: 'separatorDash',
        AccountSeparator2: 'separatorDash',
        DepAccount2: 'maskedInput',
        DepAccount3: 'maskedInput',
      };

      var customExpressionProperties = {
        ActiveDate: {
          'templateOptions.disabled': function() {
            return (
              (vm.originalContractStatus == 'CCSAC' || vm.originalContractStatus == 'CCSCH') &&
              vm.EditOrDuplicate !== 'LinkEdit'
            );
          },
        },
        UsageFeeId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.DateFrom;
          },
        },
        ContractTypeId: {
          'templateOptions.disabled': function() {
            return (
              !(
                vm.formModel.ContractId === 0 ||
                vm.formModel.ContractId === null ||
                vm.EditOrDuplicate === 'Duplicate'
              ) || headerIsDisabled()
            );
          },
        },
        OrigRefNumber: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        ContractCodeId: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },

        DateTo: {
          'templateOptions.required': function() {
            return vm.formModel.Extent === 'CEXDE';
          },
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ExternalNumber: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced || headerIsDisabled();
          },
        },
        Extent: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ConditionalId: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        DateFrom: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        OccupationFrom: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        InvoicingTo: {
          'templateOptions.disabled': function() {
            return !(
              vm.formModel.ContractStatus === 'CCSOP' ||
              vm.formModel.ContractStatus === 'CCSAC' ||
              vm.formModel.ContractStatus === 'CCSDT'
            );
          },
        },
        InvoicingFrom: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        TitleTypeId: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
          'templateOptions.required': function() {
            return !!vm.formModel.WithTitle;
          },
        },
        TerminateDays: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        LandlordTermDays: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        TenantTermDays: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ExtLandlordTermDays: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ExtTenantTermDays: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        DepositId: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        Deposit: {
          'templateOptions.disabled': function() {
            return !vm.isFixed;
          },
        },
        IsRentable: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null && vm.formModel.OccupationTo == null;
          },
        },
        TerminateReasonId: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        TerminateRegNumber: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        TerminateRollback: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        NotRentableId: {
          'templateOptions.disabled': function() {
            if (vm.formModel.IsRentable === true) {
              vm.formModel.NotRentableId = null;
            }
            return !(
              (vm.formModel.TerminateDate !== null || vm.formModel.OccupationTo != null) &&
              vm.formModel.IsRentable === false
            );
          },
        },
        TerminateDate: {
          'templateOptions.disabled': function() {
            const disabled = !(vm.formModel.ContractStatus === 'CCSAC');
            return disabled;
          },
        },
        TerminateType: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        RentIndexationDate: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.RentIndexationId !== null && vm.formModel.RentIndexationId !== '');
          },
        },
        RentIndexationMonth: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.RentIndexationId !== null && vm.formModel.RentIndexationId !== '');
          },
          'templateOptions.required': function() {
            return vm.formModel.RentIndexationId !== null && vm.formModel.RentIndexationId !== '';
          },
        },
        RentIndexationDay: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.RentIndexationId !== null && vm.formModel.RentIndexationId !== '');
          },
          'templateOptions.required': function() {
            return vm.formModel.RentIndexationId !== null && vm.formModel.RentIndexationId !== '';
          },
        },
        PMAdvance: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        PMLabel: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
          'templateOptions.required': function() {
            return vm.formModel.PMAdvance === true;
          },
        },
        PMCurrency: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
          'templateOptions.required': function() {
            return vm.formModel.PMAdvance === true;
          },
        },
        Extended: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ExtendedPartId: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.Extended !== true);
          },
        },
        OptionDuty: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        OptionLease: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        OptionLeaseMonth: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.OptionLease !== true);
          },
        },
        OptionLeaseLaw: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        OtherLaw: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        DepCurrency: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return (
              vm.formModel.DepositId !== null && vm.formModel.DepositId !== '' && vm.formModel.BankGuarantees !== true
            );
          },
        },
        DepPayment: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return (
              vm.formModel.DepositId !== null && vm.formModel.DepositId !== '' && vm.formModel.BankGuarantees !== true
            );
          },
        },
        InstallmentFrom: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return (
              vm.formModel.DepositId !== null && vm.formModel.DepositId !== '' && vm.formModel.BankGuarantees !== true
            );
          },
        },
        BankGuaranteesEnd: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return vm.formModel.BankGuarantees === true;
          },
        },
        InstallmentNum: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
        },
        FirstInstallment: {
          'templateOptions.disabled': function() {
            if (
              vm.formModel.isInvoiced ||
              vm.formModel.DepositId === null ||
              vm.formModel.DepositId === '' ||
              vm.formModel.InstallmentNum === 1
            ) {
              vm.formModel.FirstInstallment = null;
              return true;
            } else {
              return false;
            }
          },
        },
        DepIndexation: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
        },
        DepInterestCalc: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
        },
        BankGuarantees: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
        },
        DepAccount1: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return vm.formModel.BankGuarantees;
          },
        },
        DepAccount2: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.required': function() {
            return (
              vm.formModel.DepAccount1 !== null &&
              vm.formModel.DepAccount1.Text !== null &&
              vm.formModel.DepAccount1.Text !== ''
            );
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        DepAccount3: {
          'templateOptions.disabled': function() {
            return !!(vm.formModel.isInvoiced || vm.formModel.DepositId === null || vm.formModel.DepositId === '');
          },
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        AccountSeparator1: {
          'templateOptions.disabled': 'true',
        },
        AccountSeparator2: {
          'templateOptions.disabled': 'true',
        },
        AssignNumber: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        CommentContract: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        CommentTechnical: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.isInvoiced;
          },
        },
        ComfortLevel: {
          'templateOptions.required': function() {
            return vm.formModel.TenType === 'PTEFL';
          },
        },
        Persons: {
          'templateOptions.disabled': function() {
            //36381: jelen állapot szerint az összefüggés megszüntetve
            //return vm.formModel.HasContrUser;
            return false;
          },
        },
        ContractStatus: {
          'templateOptions.disabled': function() {
            return (
              vm.EditOrDuplicate === 'LinkEdit' ||
              vm.formModel.ContractId === 0 ||
              (vm.formModel.ContractStatus !== 'CCSOP' && open !== true)
            );
          },
          'templateOptions.required': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        TenantPartId: {
          'templateOptions.disabled': function() {
            return !(vm.formModel.ContractStatus === 'CCSOP') || headerIsDisabled();
          },
        },
        PropertyId: {
          'templateOptions.disabled': function() {
            var dateIsValid = moment(
              vm.formModel.ActiveDate,
              kendo.culture().calendar.patterns.d.toUpperCase(),
              true
            ).isValid();
            return !dateIsValid || vm.formModel.ContractStatus !== 'CCSOP' || vm.formModel.isLinked;
          },
        },
        RentedSpace: {
          'templateOptions.required': function() {
            return !vm.formModel.RentedPercent && !vm.formModel.RentedSpace;
          },
        },
        RentedPercent: {
          'templateOptions.required': function() {
            return !vm.formModel.RentedPercent && !vm.formModel.RentedSpace;
          },
        },
        RentalServiceId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.PropertyId || !vm.formModel.PropertyId.Value || !vm.formModel.TenType;
          },
        },
        // UsageServiceId: {
        // 'templateOptions.disabled': function() {
        // return !vm.formModel.PropertyId || !vm.formModel.PropertyId.Value || !vm.formModel.TenType;
        // },
        // },
      };

      var customExpressionPropertiesCCSDT = {
        TerminateReasonId: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        TerminateRegNumber: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        TerminateRollback: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        TerminateDate: {
          'templateOptions.disabled': function() {
            const disabled = !(vm.formModel.ContractStatus === 'CCSDT');
            return disabled;
          },
        },
        TerminateType: {
          'templateOptions.disabled': function() {
            return vm.formModel.TerminateDate === null;
          },
        },
        RentalServiceId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.PropertyId.Value || !vm.formModel.TenType;
          },
        },
        UsageServiceId: {
          'templateOptions.disabled': function() {
            return !vm.formModel.PropertyId.Value || !vm.formModel.TenType;
          },
        },
      };

      var syncValidators = {
        ContractStatus: {
          /**
           * @return {boolean}
           */
          ContractStatusValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            //csak nyitottat es elot lehet szerkeszteni + felmondás alattit
            return modelValue === 'CCSOP' || modelValue === 'CCSAC' || modelValue === 'CCSDT';
          },
        },
        TerminateDays: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        TenantTermDays: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        LandlordTermDays: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        ExtTenantTermDays: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        ExtLandlordTermDays: {
          /**
           * @return {boolean}
           */
          PositiveNumberValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 0;
          },
        },
        InvoicingFrom: {
          /**
           * @return {boolean}
           */
          InvoicingFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var invoicingFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoicingToValue = new moment(
              vm.formModel.InvoicingTo,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            if (isNaN(invoicingToValue)) {
              return true;
            }

            return invoicingToValue.isSameOrAfter(invoicingFromValue);
          },
        },
        RentedSpace: {
          /**
           * @return {boolean}
           */
          RentedSpaceValidator: function(viewValue, modelValue, scope) {
            return modelValue <= vm.formModel.RentableSpace;
          },
        },
        RentedPercent: {
          /**
           * @return {boolean}
           */
          PercentValidator: function(viewValue, modelValue, scope) {
            return modelValue >= 0 && modelValue <= 100;
          },
        },
        InvoicingTo: {
          /**
           * @return {boolean}
           */
          InvoicingFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var invoicingFromValue = new moment(
              vm.formModel.InvoicingFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            var invoicingToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return invoicingToValue.isSameOrAfter(invoicingFromValue);
          },
        },
        OccupationFrom: {
          /**
           * @return {boolean}
           */
          OccupationFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var occupationFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var occupationToValue = new moment(
              vm.formModel.OccupationTo,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            if (isNaN(occupationToValue)) {
              return true;
            }
            return occupationToValue.isSameOrAfter(occupationFromValue);
          },
        },
        OccupationTo: {
          /**
           * @return {boolean}
           */
          OccupationFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var occupationFromValue = new moment(
              vm.formModel.OccupationFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            var occupationToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return occupationToValue.isSameOrAfter(occupationFromValue);
          },
        },
        DateFrom: {
          /**
           * @return {boolean}
           */
          DateFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var dateFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var dateToValue = new moment(vm.formModel.dateTo, kendo.culture().calendar.patterns.d.toUpperCase());
            if (isNaN(dateToValue)) {
              return true;
            }
            return dateToValue.isSameOrAfter(dateFromValue);
          },
        },
        DateTo: {
          /**
           * @return {boolean}
           */
          DateFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var dateFromValue = new moment(vm.formModel.DateFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var dateToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return dateToValue.isSameOrAfter(dateFromValue);
          },
        },
        TerminateDate: {
          /**
           * @return {boolean}
           */
          TerminateDateValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            if (!vm.formModel.InvoicingFrom) {
              return true;
            }
            var invoicingFromValue = new moment(
              vm.formModel.InvoicingFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            var terminateDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return terminateDateValue.isSameOrAfter(invoicingFromValue);
          },
        },
        RentIndexationDate: {
          /**
           * @return {boolean}
           */
          RentIndexationDateValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var DateFromValue = new moment(vm.formModel.DateFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var RentIndexationDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var DateToValue = new moment(vm.formModel.DateTo, kendo.culture().calendar.patterns.d.toUpperCase());

            var x =
              RentIndexationDateValue.isSameOrAfter(DateFromValue) &&
              (vm.formModel.Extent === 'CEXIN' || DateToValue.isSameOrAfter(RentIndexationDateValue));

            return x;
          },
        },
      };

      var hideExpressions = {
        /**
         * @return {boolean}
         */
        DateTo: function($viewValue, $modelValue, scope) {
          return !ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Extent', ['CEXDE']);
        },
      };

      function checkAvailableSpace() {
        if (
          vm.originalAvailableSpace === vm.formModel.AvailableSpace &&
          vm.originalRentedSpace === vm.formModel.RentedSpace
        ) {
          // Skip the check when there is no change
          return true;
        }

        if (vm.formModel.AvailableSpace === null) {
          toastr.warning('Bérelhető m2 nincs megadva.');
          return true;
        }
        if (
          vm.formModel.OwnerContractId === vm.formModel.ContractId &&
          vm.formModel.AvailableSpace < vm.formModel.RentedSpace &&
          vm.formModel.ContractStatus !== 'CCSOP'
        ) {
          toastr.error(
            'A Bérelt m2 nem lehet több, mint a Bérelhető m2. A maximális Bérelhető m2: ' + vm.formModel.AvailableSpace
          );
          return false;
        }

        return true;
      }

      vm.checkAvailableSpace = checkAvailableSpace;

      var onChangeFunctions = {
        ContractTypeId: function(value, selectedItem) {
          console.log('ContractTypeId', value, selectedItem);
        },
        DateFrom: function(selectedItem) {
          if (vm.pageModel.Fields.RentIndexationDate.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.RentIndexationDate.FormlyFieldDescriptor.formControl.$validate();
          }
        },
        DateTo: function(selectedItem) {
          if (vm.pageModel.Fields.RentIndexationDate.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.RentIndexationDate.FormlyFieldDescriptor.formControl.$validate();
          }
        },
        Extent: function(selectedItem) {
          if (vm.formModel.Extent === 'CEXIN') {
            vm.formModel.DateTo = null;
          }
          SetModelExtraPropBasedOnSelectedItem(vm.formModel.extraProperties, 'Extent', selectedItem);
        },
        TerminateDate: function(selectedItem) {
          if (vm.formModel.TerminateDate !== null) {
            vm.formModel.IsRentable = false;
          }
          endingDateCalculator();
        },
        TerminateType: function(selectedItem) {
          endingDateCalculator();
        },
        Year: function(selectedItem) {
          vm.formModel.Year = selectedItem.key;
          vm.grids['GridInvoice'].dataSource.read();
        },
        TenType: function() {
          setOtherParamsToServiceIds(vm.formModel.PropertyId.Value, vm.formModel.TenType);
        },
        PropertyId: function(selectedItem) {
          if (
            !selectedItem ||
            !vm.formModel.PropertyId.Value ||
            selectedItem.PropertyId !== vm.formModel.PropertyId.Value
          ) {
            vm.formModel.RentalServiceId = null;
            vm.formModel.UsageServiceId = null;
          }
          if (!!selectedItem && !!selectedItem._events && !!vm.formModel.PropertyId) {
            vm.formModel.OpUnitId = selectedItem.OpUnitId;
            vm.formModel.OwnerName = selectedItem.OwnerName;
            $http
              .post('Contract/GetContractTimeLineData', {
                propertyId: selectedItem.PropertyId,
                activeDate: vm.formModel.ActiveDate,
              })
              .then(function(response) {
                vm.formModel.AvailableSpace = 0;
                if (response.data.AvailableSpace) {
                  vm.formModel.AvailableSpace = response.data.AvailableSpace;
                }

                vm.formModel.RentableSpace = 0;
                if (response.data.RentableSpace) {
                  vm.formModel.RentableSpace = response.data.RentableSpace;
                }

                vm.formModel.ComAreaMultiplier = response.data.ComAreaMultiplier;
                vm.formModel.UniqueComAreaMultiplier = response.data.ComAreaMultiplier;
                vm.formModel.RentedSpace = response.data.AvailableSpace;
                vm.formModel.DimId = response.data.DimId;
                vm.formModel.TenType = response.data.TenType;
                vm.formModel.ComfortLevel = response.data.ComfortLevel;
                vm.formModel.AreaRentalId = response.data.AreaRentalId;
                vm.formModel.RentedPercent = '';
                if (
                  vm.formModel.AvailableSpace !== 0 &&
                  vm.formModel.AvailableSpace !== null &&
                  vm.formModel.RentedSpace !== null
                ) {
                  vm.formModel.RentedPercent = (vm.formModel.RentedSpace / vm.formModel.RentableSpace) * 100;
                }
                if (!response.data.TenType) {
                  vm.formModel.RentalServiceId = null;
                  vm.formModel.UsageServiceId = null;
                } else {
                  setOtherParamsToServiceIds(selectedItem.PropertyId, response.data.TenType);
                }
                //kijelölő adatok
                if (!vm.formModel.AssignPartId?.Value && !vm.formModel.AssignNumber && !vm.formModel.AssignDate) {
                  $http
                    .post('Contract/GetRentUnitCadastralData', {
                      propertyId: selectedItem.PropertyId,
                    })
                    .then(function(response) {
                      vm.formModel.AssignPartId.Value = response.data.Dto.TenantDesignation?.Value;
                      vm.formModel.AssignNumber = response.data.Dto.DesignationNumber;
                      vm.formModel.AssignDate = response.data.Dto.ValidFrom;
                    })
                    .catch(function(response) {});
                }
              })
              .catch(function(response) {});
          }

          if (!selectedItem || !selectedItem.PropertyId) {
            vm.formModel.OpUnitId = null;
            vm.formModel.OwnerName = null;
            vm.formModel.TenType = null;
            vm.formModel.RentableSpace = null;
            vm.formModel.ComAreaMultiplier = null;
            vm.formModel.ComfortLevel = null;
            vm.formModel.AvailableSpace = 0;
            vm.formModel.RentedPercent = 0;
            vm.formModel.RentedSpace = 0;
            vm.formModel.DimId = 0;
          }
        },
        DepositId: function(selectedItem) {
          SetModelExtraPropBasedOnSelectedItem(vm.formModel.extraProperties, 'Fixed', selectedItem);
          if (!!selectedItem.extraProperties) {
            vm.isFixed = selectedItem.extraProperties[0].value === 'True' ? true : false;
          }
          if (!!selectedItem && !!selectedItem.key && !vm.isFixed) {
            $http
              .post('Contract/DepositCalculator', {
                depositId: selectedItem.key,
                contractId: vm.formModel.ContractId,
              })
              .then(function(response) {
                vm.formModel.Deposit = response.data.Dto.Deposit;
              })
              .catch(function(response) {});
          }
        },
        RentedSpace: function(selectedItem) {
          vm.checkAvailableSpace();
          if (
            vm.formModel.RentedSpace !== null &&
            vm.formModel.AvailableSpace !== null &&
            vm.formModel.AvailableSpace !== 0
          ) {
            vm.formModel.RentedPercent = (vm.formModel.RentedSpace / vm.formModel.RentableSpace) * 100;
          }
        },
        RentedPercent: function(selectedItem) {
          if (vm.formModel.RentedPercent !== null && vm.formModel.AvailableSpace !== null) {
            vm.formModel.RentedSpace = (vm.formModel.RentableSpace * vm.formModel.RentedPercent) / 100;
          }
        },
        TenantPartId: function(selectedItem) {
          if (!!selectedItem) {
            vm.pageModel.Fields.DepAccount1.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              targetPartnerId: selectedItem.PartnerId,
            };
            if (
              (vm.formModel.OwnerContractId !== vm.formModel.ContractId &&
                vm.formModel.ContractId !== 0 &&
                vm.formModel.ContractId !== null) ||
              vm.formModel.isLinked
            ) {
              vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                ownerContractId: vm.formModel.OwnerContractId,
              };
            }
            if (!!selectedItem._events) {
              // Check if the chosen TenantPartId is already in use on a live contract
              $http
                .post('Contract/CheckIfPartnerIsAlreadyInUseOnALiveContract', {
                  partnerId: selectedItem.PartnerId,
                })
                .then(function(response) {
                  if (!response.data.partnerAlreadyInUse) {
                    return;
                  }

                  // open modal
                  var modalInstance = $uibModal.open({
                    templateUrl: 'App/Contract/AlreadyAssignedPartnerWarningModal.html',
                    controller: 'AlreadyAssignedPartnerWarningModalCtrl',
                    controllerAs: 'vm',
                    resolve: {
                      parameters: {
                        contractsWherePartnerIsTenant: response.data.contractsWherePartnerIsTenant,
                        contractsWherePartnerIsUser: response.data.contractsWherePartnerIsUser,
                      },
                    },
                    backdrop: 'static',
                  });

                  modalInstance.result.then(function() {
                    // nothing to do...
                  });
                })
                .catch(function(response) {});
            }
          }
        },
        DepAccount1: function(selectedItem) {
          if (!!selectedItem) {
            vm.formModel.DepAccount2 = selectedItem.Account2;
            vm.formModel.DepAccount3 = selectedItem.Account3;
          }
        },
        ActiveDate: function(value) {
          //clear PropertyId and dependency
          if (!vm.formModel.isLinked) {
            vm.formModel.PropertyId = null;
            vm.formModel.OpUnitId = null;
            vm.formModel.TenType = null;
            vm.formModel.RentableSpace = null;
            vm.formModel.ComAreaMultiplier = null;
            vm.formModel.ComfortLevel = null;
            vm.formModel.AvailableSpace = 0;
            vm.formModel.RentedPercent = 0;
            vm.formModel.RentedSpace = 0;
            vm.formModel.DimId = 0;
          }
          setOtherParamsOnActiveDateChange();
          var dateIsValid = moment(
            vm.formModel.ActiveDate,
            kendo.culture().calendar.patterns.d.toUpperCase(),
            true
          ).isValid();

          if (dateIsValid && vm.formModel.TenantPartId.Value !== null) {
            $http
              .post('Contract/GetContractActiveDateCheck', {
                tenantpartId: vm.formModel.TenantPartId.Value,
                activeDate: vm.formModel.ActiveDate,
              })
              .then(function(result) {
                if (!result.data.Valid) {
                  toastr.warning(vm.pageModel.Messages.ActiveDateCheck);
                }
              });
          }
          //

          if (vm.formModel.isLinked === true && dateIsValid) {
            $http
              .post('Contract/GetContractTimeLineData', {
                propertyId: vm.formModel.PropertyId.Value,
                contractId: vm.formModel.ContractId,
                activeDate: vm.formModel.ActiveDate,
              })
              .then(function(response) {
                var data = response.data;
                var messages = [];
                if (vm.formModel.AreaRentalId !== data.AreaRentalId) {
                  var beforeText = $("input[dom-id='Contract_AreaRentalId']")
                    .data()
                    .kendoDropDownList.text();
                  messages.push({
                    id: 1,
                    checkbox: true,
                    message:
                      'A bérlemény helybérlés típusa <b><i>' +
                      beforeText +
                      '</i></b> helyett <b><i>' +
                      data.AreaRentalName +
                      '</i></b>.',
                  });
                }
                if (vm.formModel.ComfortLevel !== data.ComfortLevel) {
                  var beforeText = $("input[dom-id='Contract_ComfortLevel']")
                    .data()
                    .kendoDropDownList.text();
                  messages.push({
                    id: 2,
                    checkbox: true,
                    message:
                      'A bérlemény lakás komfortfokozata <b><i>' +
                      beforeText +
                      '</i></b> helyett <b><i>' +
                      data.ComfortLevelName +
                      '</i></b>.',
                  });
                }
                if (vm.formModel.TenType !== data.TenType) {
                  var beforeText = $("input[dom-id='Contract_TenType']")
                    .data()
                    .kendoDropDownList.text();
                  messages.push({
                    id: 3,
                    checkbox: true,
                    message:
                      'A bérlemény bérlemény típusa <b><i>' +
                      beforeText +
                      '</i></b> helyett <b><i>' +
                      data.TenTypeName +
                      '</i></b>.',
                  });
                }

                if (!data.RentableSpace) {
                  messages.push({
                    id: 6,
                    checkbox: false,
                    message: 'A bérleményhez nem található kihasználtsági, összterület m<sup>2</sup> adat.',
                  });
                } else if (vm.formModel.RentableSpace !== data.RentableSpace && data.IsRentable == true) {
                  messages.push({
                    id: 4,
                    checkbox: false,
                    message:
                      'A bérlemény összterület m<sup>2</sup>-e <b><i>' +
                      vm.formModel.RentableSpace +
                      '</i></b> helyett <b><i>' +
                      data.RentableSpace +
                      '</i></b>.',
                  });
                } else if (vm.formModel.RentableSpace !== data.RentableSpace && data.IsRentable == false) {
                  messages.push({
                    id: 5,
                    checkbox: false,
                    message: 'A bérlemény a szerződés életbelépés dátumán nem bérelhető.',
                  });
                }

                if (vm.formModel.CompAreaMultiplier !== data.CompAreaMultiplier) {
                  messages.push({
                    id: 7,
                    checkbox: true,
                    message:
                      'A közös területi szorzó <b><i>' +
                      vm.formModel.CompAreaMultiplier +
                      '</i></b> helyett <b><i>' +
                      data.CompAreaMultiplier +
                      '</i></b>. Módosluljon ennek megfelelően a közös területi szorzó?',
                  });
                }

                if (messages.length > 0) {
                  var modalInstance = $uibModal.open({
                    templateUrl: 'App/Contract/ContractDataDifferenceWarningModal.html',
                    controller: 'ContractDataDifferenceWarningModalCtrl',
                    controllerAs: 'vm',
                    resolve: {
                      parameters: {
                        messages: messages,
                      },
                    },
                    backdrop: 'static',
                  });

                  modalInstance.result.then(function(result) {
                    if (result[1] === true) {
                      vm.formModel.AreaRentalId = data.AreaRentalId;
                    }
                    if (result[2] === true) {
                      vm.formModel.ComfortLevel = data.ComfortLevel;
                    }
                    if (result[3] === true) {
                      vm.formModel.TenType = data.TenType;
                    }
                    if (vm.formModel.RentableSpace !== data.RentableSpace) {
                      vm.formModel.RentableSpace = data.RentableSpace;
                    }
                    if (vm.formModel.AvailableSpace !== data.AvailableSpace) {
                      vm.formModel.AvailableSpace = data.AvailableSpace;
                    }

                    if (result[7] === true) {
                      vm.formModel.CompAreaMultiplier = data.CompAreaMultiplier;
                    }
                  });
                }
              });
          }
        },
        RentalServiceId: function(selectedItem) {
          vm.formModel.UsageServiceId = { Value: selectedItem?.AssignmentServiceId, Text: null };
          //vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.resetModel();
        },
      };
      var onBlurFunctions = {
        ActiveDate: function(value) {
          if (!value) {
            toastr.warning('Az életbelépés dátuma mező kitöltése kötelező!', vm.messages.Warning);
          }
        },
      };

      var inputMasks = {
        DepAccount1: '99999999',
        DepAccount2: '99999999',
        DepAccount3: '99999999',
      };

      var whereConditionFunctionUsageFee = function() {
        let whereCondition =
          '(AreaRentalId~eq~0' +
          (!!vm.formModel.AreaRentalId ? '~or~AreaRentalId~eq~' + vm.formModel.AreaRentalId : '') +
          ')';
        if (vm.formModel.DateFrom) {
          var dateString = moment(new Date(vm.formModel.DateFrom)).format('YYYY-MM-DDTHH:mm:ssZ');
          whereCondition +=
            "~and~ValidFrom~lte~datetime'" +
            dateString +
            "~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
            dateString +
            ')';
        }
        return whereCondition;
      };
      vm.pageModel.Fields.UsageFeeId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionUsageFee;

      InsertCustomTypes(vm.pageModel, customTypes);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertInputMasks(vm.pageModel, inputMasks);

      if (
        !vm.controllerOptions.isFormReadOnly &&
        !vm.formModel.IsReadOnly &&
        vm.isEditedStatus &&
        vm.formModel.ContractStatus !== 'CCSDT'
      ) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      } else if (
        !vm.controllerOptions.isFormReadOnly &&
        vm.formModel.IsReadOnly &&
        vm.isEditedStatus &&
        vm.formModel.ContractStatus === 'CCSDT'
      ) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionPropertiesCCSDT);
      }

      function setOtherParamsOnActiveDateChange() {
        var TenantPartIdParams = vm.formModel.isLinked
          ? { ownerContractId: vm.formModel.OwnerContractId, activeDate: vm.formModel.ActiveDate }
          : { activeDate: vm.formModel.ActiveDate };
        vm.pageModel.Fields.TenantPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = TenantPartIdParams;

        vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          activeDate: vm.formModel.ActiveDate,
          contractStatus: vm.formModel.ContractStatus,
          //isEdit: vm.isEdit
        };
      }
      setOtherParamsOnActiveDateChange();

      function setOtherParamsToServiceIds(propertyId, tenType) {
        vm.pageModel.Fields.RentalServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          TenType: tenType,
          PropertyId: propertyId,
        };
        vm.pageModel.Fields.UsageServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          TenType: tenType,
          PropertyId: propertyId,
        };
      }
      setOtherParamsToServiceIds(
        !!vm.formModel.PropertyId ? vm.formModel.PropertyId.Value : null,
        vm.formModel.TenType
      );
      function save() {
        var defer = $q.defer();
        var AvailableSpaceCheckSucceeded = vm.checkAvailableSpace();
        if (!AvailableSpaceCheckSucceeded) {
          return defer.promise;
        }
        saveUpdateQuestion(defer, vm.formModel.ContractId);
        return defer.promise;
      }
      function saveIfOccupationToIsNull(defer, hasContractFee) {
        $http
          .post('Contract/Contract' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            var redirectToNewState = function() {
              if (vm.formModel.ContractId === 0 || vm.formModel.ContractId === null) {
                $state.go('Contract.ContractEdit', { id: response.data.ContractId, openedPanelGroup: 'PGGridek' });
              } else {
                if (response.data.Link) {
                  $state.go('Contract.ContractEdit', { id: response.data.ContractId, openedPanelGroup: 'PGHeader' });
                } else {
                  $state.reload();
                }
              }
            };

            var isPropertyIdChanged = propertyId && propertyId !== vm.formModel.PropertyId.Value;
            if (hasContractFee && isPropertyIdChanged) {
              bootbox.dialog({
                message: vm.pageModel.Messages.FeeNotification,
                title: vm.pageModel.Messages.Warning,
                closeButton: false,
                buttons: {
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: redirectToNewState,
                  },
                },
              });
            } else {
              redirectToNewState();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            defer.reject();
          });
      }

      function saveUpdateQuestion(defer, id) {
        vm.formModel.ForceSave = false;
        if (vm.originalContractStatus === 'CCSOP' && vm.formModel.ContractStatus === 'CCSAC') {
          //kell e díjakat frissíteni?
          $http.get('Contract/FeeUpdateNeed/' + id).then(function(result) {
            if (result.data.FeeUpdateNeed === true) {
              bootbox.dialog({
                message: 'A díjak változtak! Élővé tétel előtt frissíti a díjakat?',
                title: vm.pageModel.Messages.Warning,
                closeButton: true,
                buttons: {
                  cancel: {
                    label: 'Élővé tétel a díjak frissítése nélkül',
                    className: 'btn-default',
                    callback: function() {
                      vm.formModel.ForceSave = true;
                      saveImpl(defer);
                    },
                  },
                  confirm: {
                    label: 'Díjak frissítése',
                    className: 'btn-primary',
                    callback: function() {
                      $scope.$applyAsync(function() {
                        vm.collapseHelper.showPanel('PanelFee');
                        vm.activeSubItemTab = 4;
                        generateSubItemFee(id);
                      });
                    },
                  },
                },
              });
            } else {
              saveImpl(defer);
            }
          });
        } else {
          saveImpl(defer);
        }
      }

      function saveImpl(defer) {
        if (vm.formModel.OccupationTo === null) {
          //LazyLoad-os gridek miatt ez a funkció nem használható, ha szükséges figyelni akkor kell GET backendre.
          //var hasContractFee = vm.grids['GridFee'].dataSource && vm.grids['GridFee'].dataSource.total();
          var hasContractFee = true;
          if (vm.formModel.InvoicingTo !== null && hasContractFee) {
            bootbox.dialog({
              message: 'A számlázás vége mező kitöltésre került, így mentéskor a még nyitott díjsorok lezáródnak!',
              title: vm.pageModel.Messages.Warning,
              closeButton: false,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    saveIfOccupationToIsNull(defer, hasContractFee);
                  },
                },
              },
            });
          } else {
            saveIfOccupationToIsNull(defer, hasContractFee);
          }
        } else {
          if (vm.formModel.IsRentable == null) {
            alert(
              'A Bérelhető mező nincs kitöltve! (töltési feltétel: Birtokba visszavétel dátuma vagy Felmondás dátuma)'
            );
            return;
          }

          if (vm.formModel.IsRentable === false) {
            if (vm.formModel.NotRentableId == null) {
              alert(
                'A Bérelhetetlenség oka mező nincs kitöltve! (töltési feltétel: Birtokba visszavétel dátuma vagy Felmondás dátuma)'
              );
              return;
            }
          }

          bootbox.dialog({
            message: 'Ebben az esetben lezárja a szerződést, biztos benne?',
            title: 'Mentés',
            buttons: {
              add: {
                label: 'Igen',
                className: 'btn-primary',
                callback: function() {
                  $http
                    .post('Contract/Contract' + vm.EditOrDuplicate, vm.formModel)
                    .then(function(response) {
                      defer.resolve();
                      vm.formly.$setPristine();
                      if (!vm.controllerOptions.isFormReadOnly) {
                        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                      }
                      //toastr.success(vm.pageModel.Messages.SaveSuccessful);
                      //$state.go("Contract.ContractNav");
                      toastr.success('Szerződés zárása sikeresen megtörtént!');

                      if (response.data.ContrFeeCloseIsNeed === true) {
                        vm.getContrFeeForClose(vm.formModel.ContractId);
                      } else {
                        $state.reload();
                      }
                    })
                    .catch(function(response) {
                      defer.reject();
                      toastr.error(vm.pageModel.Messages.SaveFailed);
                    });
                },
              },
              cancel: {
                label: 'Nem',
                className: 'btn-default',
                callback: function() {},
              },
            },
          });
        }
      }

      function createContract() {
        $state.go('Contract.ContractEdit', { id: 0 });
      }

      function duplicateContract() {
        var id = vm.formModel.ContractId;
        $state.go('Contract.ContractDuplicate', { id: id });
      }

      function deleteContract() {
        var id = vm.formModel.ContractId;
        bootbox.dialog({
          message: vm.messages.DeleteDialogConfirmMessage,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Contract/ContractDelete/' + id + '?shouldLock=false').then(function() {
                  vm.formly.$setPristine();
                  toastr.success(vm.messages.DeleteSuccessful);
                  $state.go('Contract.ContractNav').then(vm.unlock);
                });
              },
            },
          },
        });
      }

      function lockContract() {
        if (vm.formModel.OccupationTo == null) {
          toastr.error('Birtokba visszavétel kötelezően kitöltendő!');
          return;
        }
        bootbox.dialog({
          message: 'Ebben az esetben lezárja a szerződést, biztos benne?',
          title: 'Mentés',
          buttons: {
            add: {
              label: 'Igen',
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('Contract/ContractLock', vm.formModel)
                  .then(function(response) {
                    vm.formly.$setPristine();
                    if (!vm.controllerOptions.isFormReadOnly) {
                      lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                    }
                    toastr.success('Szerződés zárása sikeresen megtörtént!');
                    vm.getContrFeeForClose(vm.formModel.ContractId);
                  })
                  .catch(function(response) {
                    toastr.error(vm.pageModel.Messages.SaveFailed);
                  });
              },
            },
            cancel: {
              label: 'Nem',
              className: 'btn-default',
              callback: function() {},
            },
          },
        });
      }

      vm.getContrFeeForClose = function(id) {
        var url = 'Contract/GetContrFeeForClose/?contractId=' + id;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrFeeForCloseResultModal.html',
          controller: 'ContrFeeForCloseResultModalCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: { fModel: RouteResolveFunc(url) },
          backdrop: 'static',
        });

        modalInstance.result.then(
          function() {
            $state.reload();
          },
          function() {
            toastr.warning('A szerződés díjai nem lettek lezárva, továbbiakban csak kézzel zárhatóak!');
            $state.reload();
          }
        );
      };

      function linkContract() {
        var id = vm.formModel.ContractId;
        if (vm.formModel.ContractStatus !== 'CCSAC' || open) {
          //TODO
          toastr.warning('Csak élő szerződést lehet láncolni!', vm.messages.Warning);
        } else {
          if (!!id) {
            $state.go('Contract.ContractLinkEdit', { id: id, edit: true });
            //bootbox.dialog({
            //    message: "Válasszon egy opciót!",
            //    title: "Láncolás",
            //    buttons: {
            //        add: {
            //            label: "Új szerződés",
            //            className: "btn-primary",
            //            callback: function () {
            //                $state.go("Contract.ContractLinkEdit", { "id": id, "edit": false });
            //            }
            //        },
            //        modify: {
            //            label: "Szerződés módosítás",
            //            className: "btn-primary",
            //            callback: function () {
            //                $state.go("Contract.ContractLinkEdit", { "id": id, "edit": true });
            //            }
            //        },
            //        cancel: {
            //            label: "Mégse",
            //            className: "btn-default",
            //            callback: function () {
            //            }
            //        }
            //    }
            //});
          }
        }
      }

      vm.linkContract = linkContract;

      vm.dasMainModel = {
        routeId: 'Contract.ServiceDasDocumentsNav',
        tableId: 'FlgContract',
        ownerId: vm.formModel.ContractId,
      };
      function setDasSubModel() {
        var dasDescriptor = vm.pageModel.Grids[vm.grids[vm.activeSubItemTab]].DasDescriptor;
        var selectedGrid = vm.grids[vm.grids[vm.activeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasSubModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      function attachDocument(grid) {
        if (!!grid) {
          var gridName = vm.tabs[vm.activeSubItemTab].gridName;
          var lfs = vm.getSelectedContractId();
          var id = getSelectedSubGridItemId();
          dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgDiscountLinkage', id);
        } else {
          var id = vm.formModel.ContractId;
          dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgContract', id);
        }
      }

      function history() {
        HistoryService.NavigateToHistory('FlgContract', vm.formModel.ContractId, vm, $state);
      }

      function endingDateCalculator() {
        var terminateDateValue = new moment(
          vm.formModel.TerminateDate,
          kendo.culture().calendar.patterns.d.toUpperCase()
        );
        var days = 0;

        if (vm.formModel.TerminateType === 'CTTNO') {
          days = vm.formModel.TerminateDays;
        }

        if (vm.formModel.TerminateType === 'CTTLA') {
          days = vm.formModel.LandlordTermDays;
        }
        if (vm.formModel.TerminateType === 'CTTTE') {
          days = vm.formModel.TenantTermDays;
        }
        if (vm.formModel.TerminateType === 'CTTEL') {
          days = vm.formModel.ExtLandlordTermDays;
        }
        if (vm.formModel.TerminateType === 'CTTET') {
          days = vm.formModel.ExtTenantTermDays;
        }

        vm.formModel.EndingDate = terminateDateValue.add(days, 'days').format();
      }

      function invoice() {
        $state.go('Contract.InvoiceNav', { InvoiceTypeFilter: 'INTRM', contractId: vm.contractId });
      }

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        [
          'PanelPremise',
          'PanelContrFlowmeter',
          'PanelUsers',
          'PanelPayment',
          'PanelFee',
          'PanelDeposit',
          'PanelContrCost',
          'PanelDocument',
          'PanelInvoice',
          'PanelContrInformation',
          'PanelAdvanceAccount',
          'PanelContractMessages',
        ],
        function(gridModel) {
          if (gridModel.Name === 'GridPremise') {
            gridModel.ControllerMethod = 'Contract/ContrPremiseList/';
            return {
              gridModel,
              transportData: vm.getSelectedPropertyId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridContrFlowmeter') {
            gridModel.ControllerMethod = 'Contract/ContrFlowmeterList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridUsers') {
            gridModel.ControllerMethod = 'Contract/ContrUsersList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridPayment') {
            gridModel.ControllerMethod = 'Contract/PaymentList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridFee') {
            gridModel.ControllerMethod = 'Contract/ContrFeeList/';
            return {
              gridModel,
              transportData: vm.getContrFeeTransportData,
              selectFunction: function() {
                changeContrFeeGridFilter();
                getSelectedSubGridItem();
                setDasSubModel();
                vm.setButtonActivity();
              },
            };
          }
          if (gridModel.Name === 'GridDeposit') {
            gridModel.ControllerMethod = 'Contract/ContrDepositList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
                vm.setButtonActivity();
              },
            };
          }
          if (gridModel.Name === 'GridContrCost') {
            gridModel.ControllerMethod = 'Contract/ContrCostList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
                vm.setButtonActivity();
              },
            };
          }
          if (gridModel.Name === 'GridContrLetter') {
            gridModel.ControllerMethod = 'Contract/ContrLetterList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridInvoice') {
            gridModel.ControllerMethod = 'Contract/InvoiceList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                changeInvoiceGridFilter();
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridContrInformation') {
            gridModel.ControllerMethod = 'Contract/ContrInformationList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
                vm.setButtonActivity();
              },
            };
          }
          if (gridModel.Name === 'GridAdvanceAccount') {
            gridModel.ControllerMethod = 'Contract/AdvanceAccountList/';
            return {
              gridModel,
              transportData: vm.getSelectedContractId,
              selectFunction: function() {
                changeAdvanceAccountGridFilter();
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridContractMessages') {
            gridModel.ControllerMethod = 'Contract/GetContractMessages/';
            return {
              gridModel,
              transportData: vm.getOrigContractId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          return null;
        }
      );
      vm.tabs = generatedGridTabs.tabs;
      vm.gridOptions = generatedGridTabs.gridOptions;
      vm.grids = generatedGridTabs.grids;

      var generatedContrFeeGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelContrDiscount', 'PanelContrMeterConsDivided'],
        function(gridModel) {
          if (gridModel.Name === 'GridContrDiscount') {
            gridModel.ControllerMethod = 'Contract/ContrDiscountDetailList/';

            return {
              gridModel,
              groupable: true,
              transportData: vm.getSelectedContrFeeId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridContrMeterConsDivided') {
            gridModel.ControllerMethod = 'Contract/ContrMeterConsDividedDetailList/';

            return {
              gridModel,
              groupable: true,
              transportData: vm.getSelectedContrFeeId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }

          return null;
        }
      );
      vm.contrDiscountTabs = generatedContrFeeGridTabs.tabs;
      vm.contrFeeDetailGridOptions = generatedContrFeeGridTabs.gridOptions;

      var generatedAdvanceAccountGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelDeductibleService', 'PanelRecognisedService'],
        function(gridModel) {
          if (gridModel.Name === 'GridDeductibleService') {
            gridModel.ControllerMethod = 'Contract/DeductibleServiceDetailList/';

            return {
              gridModel,
              transportData: vm.getSelectedAdvanceAccountId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }
          if (gridModel.Name === 'GridRecognisedService') {
            gridModel.ControllerMethod = 'Contract/RecognisedServiceDetailList/';

            return {
              gridModel,
              transportData: vm.getSelectedAdvanceAccountId,
              selectFunction: function() {
                getSelectedSubGridItem();
                setDasSubModel();
              },
            };
          }

          return null;
        }
      );
      vm.advanceAccountTabs = generatedAdvanceAccountGridTabs.tabs;
      vm.advanceAccountDetailGridOptions = generatedAdvanceAccountGridTabs.gridOptions;

      function changeContrFeeGridFilter() {
        // var targetGrid = $('#GridFee').data('kendoGrid');
        // var selectedItems = GetSelectedGridItems(targetGrid);
        // if (selectedItems.length === 0) {
        // vm.selectedContrFeeId = 0;
        // return;
        // }
        // vm.selectedContrFeeId = selectedItems[0][vm.contrFeeGridIdField];
        // vm.contrDiscountGrid = $('#GridContrDiscount').data('kendoGrid');
        // if (vm.contrDiscountGrid && selectedItems[0].ServiceId == 2) {
        // vm.contrDiscountGrid.dataSource.read();
        // }
        // vm.contrMeterConsDividedGrid = $('#GridContrMeterConsDivided').data('kendoGrid');
        // if (vm.contrMeterConsDividedGrid && selectedItems[0].MeterId != 0) {
        // vm.contrMeterConsDividedGrid.dataSource.read();
        // }
      }

      function changeInvoiceGridFilter() {
        var targetGrid = $('#GridInvoice').data('kendoGrid');
        var selectedItems = GetSelectedGridItems(targetGrid);

        if (selectedItems.length === 0) {
          vm.selectedInvoiceId = 0;
          return;
        }

        vm.selectedInvoiceId = selectedItems[0][vm.invoiceGridIdField];
        //ha nem undefined csak akkor hívja meg
        if (!!vm.invoiceRowDetailGrid) {
          vm.invoiceRowDetailGrid.dataSource.read();
        }
      }

      function changeAdvanceAccountGridFilter() {
        var targetGrid = $('#GridAdvanceAccount').data('kendoGrid');
        var selectedItems = GetSelectedGridItems(targetGrid);

        if (selectedItems.length === 0) {
          vm.selectedAdvanceAccountId = 0;
          return;
        }
        vm.selectedAdvanceAccountId = selectedItems[0][vm.advanceAccountGridIdField];
        vm.deductibleServiceDetailGrid = $('#GridDeductibleService').data('kendoGrid');
        vm.recognisedServiceDetailGrid = $('#GridRecognisedService').data('kendoGrid');
        if (vm.deductibleServiceDetailGrid) {
          vm.deductibleServiceDetailGrid.dataSource.read();
        }
        if (vm.recognisedServiceDetailGrid) {
          vm.recognisedServiceDetailGrid.dataSource.read();
        }
      }

      function createSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedContractId();
        if (typeof lfs.targetContractId === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        if (gridName === 'GridFee') {
          $http
            .get('Contract/HasPayment', { params: { targetContractId: vm.contractId } })
            .then(function(response) {
              if (response.data.Value === true) {
                $state.go('Contract.' + gridName + 'Create', { id: 0, ContractId: vm.formModel.ContractId });
              } else {
                toastr.error('A szerződésen nincs rögzítve fizetési megállapodás!', 'Díj rögzítése nem lehetséges!');
              }
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.GenerateFailed);
            });
        } else if (gridName === 'GridContractMessages') {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ContractMessageModal.html',
            controller: 'ContractMessageModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(
                'Contract/AddContractMessage/?contractId=' + vm.getSelectedContractId().targetContractId
              ),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grids['GridContractMessages'].dataSource.read();
          });
        } else {
          $state.go('Contract.' + gridName + 'Create', { id: 0, ContractId: vm.formModel.ContractId });
        }
      }

      function editSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedContractId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go('Contract.' + gridName + 'Edit', { id: id, ContractId: lfs.targetContractId });
      }

      function duplicateSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var lfs = vm.getSelectedContractId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go('Contract.' + gridName + 'Duplicate', { id: id, ContractId: lfs.targetContractId });
      }

      function deleteSubItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var lfs = vm.getSelectedContractId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        var dialog = function(message, title) {
          bootbox.dialog({
            message: message,
            title: title || vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/' + urlPrefix + 'Delete/' + id).then(function(data) {
                    toastr.success(vm.messages.DeleteSuccessful);
                    var gridRef = vm.grids[gridName];
                    //36381: jelen állapot szerint az összefüggés megszüntetve
                    // if (gridName === 'GridUsers') {
                    // if (data.data.Persons !== 0) {
                    // vm.formModel.HasContrUser = true;
                    // vm.formModel.Persons = data.data.Persons;
                    // } else {
                    // vm.formModel.HasContrUser = false;
                    // vm.formModel.Persons = null;
                    // }
                    // }
                    gridRef.dataSource.read();
                  });
                },
              },
            },
          });
        };

        if (urlPrefix == 'Fee') {
          $http.get('Contract/AffectedByDepositOnDelQuery/' + id).then(function(result) {
            if (result.data.AffectedByDeposit == true) {
              dialog(result.data.Message, 'Figyelmeztetés!');
              return;
            } else {
              dialog(vm.messages.ConfirmDelete);
            }
          });
        } else {
          dialog(vm.messages.ConfirmDelete);
        }
      }

      function generateSubItemFee(id) {
        checkUnitPriceBeforeContrFeeGen(id);
      }

      function checkUnitPriceBeforeContrFeeGen(id) {
        $http
          .get('Contract/CheckUnitPriceBeforeContrFeeGen/' + id)
          .then(function(response) {
            if (!response.data.result.HasUnitPrice) {
              bootbox.dialog({
                message:
                  'A bérleti szerződésben megadott bérleti díj típusú díjhoz nem található érvényes egységár egyetlen árlistában sem. Amennyiben folytatja a folyamatot, akkor a genreálás nem hoz létre bérleti díj típusú díjat. Kívánja mégis elindítani?',
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      // nothing to do...},
                    },
                  },
                  confirm: {
                    label: 'Generálás',
                    className: 'btn-primary',
                    callback: function() {
                      checkBudgetBeforeContrFeeGen(id, true);
                    },
                  },
                },
              });
            } else {
              checkBudgetBeforeContrFeeGen(id, false);
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }

      function checkBudgetBeforeContrFeeGen(id, withoutRentalServiceId) {
        $http
          .get('Contract/CheckBudgetBeforeContrFeeGen/' + id)
          .then(function(response) {
            if (angular.isArray(response.data.grid) && !!response.data.grid.length) {
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Contract/ContrFeeSetPeriodBeforeGenModal.html',
                controller: 'ContrFeeSetPeriodBeforeGenModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  fModel: response.data,
                },
              });
              modalInstance.result.then(function(closedServiceIds) {
                startGenerateFunction(id, withoutRentalServiceId, closedServiceIds);
              });
            } else {
              startGenerateFunction(id, withoutRentalServiceId, []);
            }
          })
          .catch(function(error) {});
      }

      function startGenerateFunction(id, withoutRentalServiceId, closedServiceIds) {
        $http
          .post('Contract/ContrFeeGen/', {
            contractId: id,
            withoutRentalServiceId: withoutRentalServiceId,
            closedServiceIds: closedServiceIds,
          })
          .then(function(response) {
            if (!!response.data.message) {
              toastr.success(response.data.message);

              if (!!response.data.warnings) {
                angular.forEach(response.data.warnings, function(value, key) {
                  toastr.warning(value);
                });
              }

              var gridRef = vm.grids['GridFee'];
              gridRef.dataSource.read();
            } else {
              toastr.success(vm.pageModel.Messages.GenerateSuccessful);
              var gridRef = vm.grids['GridFee'];
              gridRef.dataSource.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }

      function generateSubItemDeposit(id) {
        var id = vm.formModel.ContractId;
        $http
          .get('Contract/ContrDepositGen/' + id)
          .then(function(response) {
            if (!!response.statusText) {
              toastr.success(response.statusText);
              var gridRef = vm.grids['GridDeposit'];
              gridRef.dataSource.read();
            } else {
              toastr.success(vm.pageModel.Messages.GenerateSuccessful);
              var gridRef = vm.grids['GridDeposit'];
              gridRef.dataSource.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }
      function generateSubItem() {
        var id = vm.formModel.ContractId;
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          generateSubItemFee(id);
        } else {
          generateSubItemDeposit(id);
        }
      }

      function depositStornoGenFn() {
        var depositItem = getSelectedSubGridItem();
        $http
          .get('Contract/ContrDepositStornoGen/' + depositItem.ContrDepositId)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            var gridRef = vm.grids['GridDeposit'];
            gridRef.dataSource.read();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }

      function depositStornoGen() {
        bootbox.dialog({
          message: vm.pageModel.Labels.LabelDepositStrono.Title,
          title: vm.pageModel.Messages.Warning,
          closeButton: false,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-primary',
            },
            confirm: {
              label: vm.messages.Yes,
              className: 'btn-primary',
              callback: depositStornoGenFn,
            },
          },
        });
      }

      function depositIndicesGen() {
        $http
          .get('Contract/ContrDepositIndicesGen/' + vm.formModel.ContractId)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            var gridRef = vm.grids['GridDeposit'];
            gridRef.dataSource.read();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }

      function getSelectedSubGridItem() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.grids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          vm.isSelectedSubItem = true;
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      vm.setAddButtonActivity = function() {
        // helyiségek
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridPremise') {
          return true;
        }
        //befizetések
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridInvoice') {
          return true;
        }
        // üzenőfal
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridContractMessages') {
          return false;
        }
        //Fogyasztásmérők
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridContrFlowmeter') {
          return true;
        }
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          return vm.formModel.ContractStatus === 'CCSCL' && vm.formModel.HasLinkedContract === true;
        }

        //zárt státusz
        if (vm.formModel.ContractStatus === 'CCSCL') {
          return true;
        }

        //// használók
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridUsers" && vm.formModel.ContractStatus != "CCSCL") {
        //    return false;
        //}
        //// fizetési megállapodások
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridPayment" && vm.formModel.ContractStatus != "CCSCL") {
        //    return false;
        //}
        //// bérbeszámítás
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridContrCost" && vm.formModel.ContractStatus != "CCSCL") {
        //    return false;
        //}
        //// óvadék
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridDeposit' && vm.formModel.ContractStatus != 'CCSCL') {
        //    return false;
        //}
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridFee') {
        //    return false;
        //}
        //// Generált dokumentumok
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrLetter' && vm.formModel.ContractStatus != 'CCSCL') {
        //    return false;
        //}
        //return true; // disabled by default

        //átmenetileg elérhetőre állítjuk, tab-os bug miatt
        return false;
      };

      vm.setEditButtonActivity = function() {
        // helyiségek
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridPremise') {
          return true;
        }
        //befizetések
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridInvoice') {
          return true;
        }
        //Fogyasztásmérők
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridContrFlowmeter') {
          return true;
        }
        //Ügyviteli informnációk
        if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrInformation') {
          var item = getSelectedSubGridItem();
          return !!item && item.ForContractStatus;
        }
        //Díjak
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          return vm.formModel.ContractStatus === 'CCSCL' && vm.formModel.HasLinkedContract === true;
        }
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridDeposit') {
          var depositItem = getSelectedSubGridItem();
          return !!depositItem && (depositItem.DepStatus === 'CDSCH' || depositItem.DepStatus === 'CDSDI');
        }
        //zárt státusz
        if (vm.formModel.ContractStatus === 'CCSCL') {
          return true;
        }
        //if (vm.isSelectedSubItem == false) {
        //    return true;
        //}
        return false; // enabled by default
      };

      vm.setRemoveButtonActivity = function() {
        // helyiségek
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridPremise') {
          return true;
        }
        //befizetések
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridInvoice') {
          return true;
        }
        //Fogyasztásmérők
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridContrFlowmeter') {
          return true;
        }
        //Ügyviteli informnációk
        if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrInformation') {
          var item = getSelectedSubGridItem();
          return !!item && item.ForContractStatus;
        }
        //Óvadék
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridDeposit') {
          var depositItem = getSelectedSubGridItem();
          return !!depositItem && (depositItem.DepStatus === 'CDSCH' || depositItem.DepStatus === 'CDSDI');
        }

        //Díjak
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          var item = getSelectedSubGridItem();
          return (
            (vm.formModel.ContractStatus === 'CCSCL' && vm.formModel.HasLinkedContract === true) ||
            (!!item && (item.MeterId > 0 || item.MeterTmId)) ||
            (!!item && item.ServiceType == 'CSERC')
          );
        }

        //// használók
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridUsers" && vm.formModel.ContractStatus == "CCSOP" && vm.isSelectedSubItem) { // "Ha nincs rá hivatkozás!" feltétel még hozzá kell írni
        //    return false;
        //}
        //// fizetési megállapodások
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridPayment" && vm.isSelectedSubItem) {
        //    return false;
        //}
        //// bérbeszámítás
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridContrCost" && vm.isSelectedSubItem) { // "Ha nincs rá hivatkozás!" feltétel még hozzá kell írni
        //    return false;
        //}

        //// Generált dokumentumok
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrLetter' && vm.formModel.ContractStatus != 'CCSCL' && vm.isSelectedSubItem) { // "Ha nincs rá hivatkozás!" feltétel még hozzá kell írni
        //    return false;
        //}

        //zárt státusz
        if (vm.formModel.ContractStatus === 'CCSCL') {
          return true;
        }
        //átmenetileg elérhetőre állítjuk, tab-os bug miatt
        return false;
      };

      vm.setCopyButtonActivity = function() {
        // helyiségek
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridPremise') {
          return true;
        }
        //befizetések
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridInvoice') {
          return true;
        }
        //Fogyasztásmérők
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridContrFlowmeter') {
          return true;
        }
        //Ügyviteli informnációk
        if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrInformation') {
          var item = getSelectedSubGridItem();
          return !!item && item.ForContractStatus;
        }
        //Díjak
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          var item = getSelectedSubGridItem();
          return (
            (vm.formModel.ContractStatus === 'CCSCL' && vm.formModel.HasLinkedContract === true) ||
            (!!item && item.ServiceType === 'CSEPU')
          );
        }
        //zárt státusz
        if (vm.formModel.ContractStatus === 'CCSCL') {
          return true;
        }
        //// használók
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridUsers" && vm.isSelectedSubItem) { // "Ha nem készült számla az adott szerződéshez!" feltétel még hozzá kell írni
        //    return false;
        //}
        //// fizetési megállapodások
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridPayment" && vm.formModel.ContractStatus != "CCSCL" && vm.isSelectedSubItem) {
        //    return false;
        //}
        //// bérbeszámítás
        //if (vm.tabs[vm.activeSubItemTab].gridName == "GridContrCost" && vm.formModel.ContractStatus != "CCSCL" && vm.isSelectedSubItem) {
        //    return false;
        //}
        //// óvadék
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridDeposit' && vm.formModel.ContractStatus != 'CCSCL' && vm.isSelectedSubItem) {
        //    return false;
        //}
        //// Generált dokumentumok
        //if (vm.tabs[vm.activeSubItemTab].gridName == 'GridContrLetter' && vm.formModel.ContractStatus != 'CCSCL' && vm.isSelectedSubItem) {
        //    return false;
        //}

        //return true; // disabled by default

        //átmenetileg elérhetőre állítjuk, tab-os bug miatt
        return false;
      };

      vm.ContrFeeValidation = function() {
        var id = vm.formModel.ContractId;
        $http
          .get('Contract/ContrFeeGenValidation/' + id)
          .then(function(response) {
            var isValid = response.data.IsValid;
            vm.ContrFeeIsValid = isValid;
          })
          .catch(function(response) {});
      };

      vm.setGenerateButtonActivity = function() {
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridDeposit') {
          if (
            vm.formModel.ContractStatus !== 'CCSCL' &&
            vm.formModel.DepositId !== 0 &&
            vm.formModel.DepositId !== null &&
            vm.formModel.BankGuarantees !== true &&
            vm.formModel.InstallmentFrom !== null
          ) {
            return false;
          }
        } else if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          return (
            vm.ContrFeeIsValid ||
            !vm.formModel.InvoicingFrom ||
            !vm.formModel.HasPayment /*|| vm.formModel.HasFeeWoMeter*/
          );
          //return false;
        }
        return true;
      };

      vm.setStornoButtonActivity = function() {
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridDeposit') {
          var depositItem = getSelectedSubGridItem();
          return !(
            !!depositItem &&
            depositItem.DepStatus === 'CDSCH' &&
            (depositItem.StornoContrDeposit === null || depositItem.stornoContrDeposit === '')
          );
        } else {
          return true;
        }
      };

      vm.depositIndicesGenButtonActivity = function() {
        return !(
          vm.formModel.ContractStatus !== 'CCSCL' &&
          vm.formModel.DepositId !== 0 &&
          vm.formModel.BankGuarantees !== true
        );
      };

      vm.setButtonActivity = function() {
        vm.setEditButtonActivity();
        vm.setRemoveButtonActivity();
        vm.setCopyButtonActivity();
        vm.setGenerateButtonActivity();
        vm.setStornoButtonActivity();
        $scope.$applyAsync();
      };

      function isSaveDisabled() {
        var logFormlyDisabledErrorsToConsole = false;

        var disabled = vm.formly.$invalid;
        if (disabled && logFormlyDisabledErrorsToConsole && vm.formly.$error) {
          if (vm.formly.$error.required) {
            console.log('--- BEGIN FORMLY ERRORS ---');
            vm.formly.$error.required.forEach(function(currentValue, index, arr) {
              console.log(currentValue.$$attr.id);
            });
            console.log('--- END FORMLY ERRORS ---');
          }
        }

        return disabled;
      }

      function saveButtonHandling() {
        return !(
          (vm.formModel.IsClosed && vm.controllerOptions.isFormReadOnly) ||
          (vm.formModel.IsClosed && vm.formModel.IsReadOnly) ||
          vm.EditOrDuplicate === 'View' ||
          !vm.isEditedStatus
        );
      }

      vm.contrFeeInactivateActivity = function() {
        if (vm.tabs[vm.activeSubItemTab].gridName === 'GridFee') {
          if (vm.formModel.HasLinkedContract === true) {
            return true;
          }
          var feeItem = getSelectedSubGridItem();
          if (!feeItem || feeItem.FeeStatus === 'CFSIN') {
            return true;
          }
          // A státuszváltás csak érvényes (időbélyeg szerint aktuális) díjsoron engedélyezett.
          var now = new Date();
          var from = feeItem.InvoicingFrom ? new Date(feeItem.InvoicingFrom) : null;
          var to = feeItem.InvoicingTo ? new Date(feeItem.InvoicingTo) : null;
          var isValid = !!from && from <= now && (to === null || to >= now);
          return !isValid;
        } else {
          return true;
        }
      };

      vm.contrMessageInactivateActivity = function() {
        var selectedItem = getSelectedSubGridItem();
        return selectedItem;
      };

      vm.contrFeeInactivate = function contrFeeInactivate() {
        var gridName = vm.tabs[vm.activeSubItemTab].gridName;
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $http.post('Contract/ContrFeeInactivate', { contrFeeId: id }).then(function(result) {
          if (result.data.IsSuccess === true) {
            vm.grids['GridFee'].dataSource.read();
            toastr.success('Sikeres Inaktiválás!');
          }
        });
      };
      vm.subWalControllers = [];
      vm.subWalControllers.push(['Contract', 'ContractPremisesWal', 'FlgPremisesView']);
      vm.subWalControllers.push(['Contract', 'ContractMeterWal', 'FlgMeterView']);
      vm.subWalControllers.push(['Contract', 'ContractUserWal', 'FlgContrUserView']);
      vm.subWalControllers.push(['Contract', 'ContractPaymentWal', 'FlgContrPaymentView']);
      vm.subWalControllers.push(['Contract', 'ContractFeeWal', 'FlgContrFeeView']);
      vm.subWalControllers.push(['Contract', 'ContractDepositWal', 'FlgContrDepositView']);
      vm.subWalControllers.push(['Contract', 'ContractCostSetOffWal', 'FlgContrCostSetOff']);
      vm.subWalControllers.push(['Contract', 'ContractLetterWal', 'FlgContrLetterView']);
      vm.subWalControllers.push(['Contract', 'ContractInvoiceWal', 'FlgInvoiceView']);
      vm.subWalControllers.push(['Contract', 'ContractInformationWal', 'FlgContrInformationView']);
      vm.subWalControllers.push(['Contract', 'ContractAdvanceAccountWal', 'FlgAdvanceAccountView']);

      function WAL(isHead) {
        if (!isHead) {
          var walElement = vm.subWalControllers[vm.activeSubItemTab];
          if (!!walElement) {
            WalService.NavigateToWal(walElement[0], walElement[1], walElement[2]);
          }
        } else {
          WalService.NavigateToWal('Contract', 'ContractViewWal', 'FlgContractView');
        }
      }

      vm.viewMessage = function viewMessage() {
        var selectedItem = getSelectedSubGridItem();
        if (!selectedItem) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var contractMessageId = selectedItem.ContrMessageId;
          $uibModal.open({
            templateUrl: 'App/Contract/ContractMessageModal.html',
            controller: 'ContractMessageModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc('Contract/ViewContractMessage/?contractMessageId=' + contractMessageId),
            },
          });
        }
      };

      vm.isSaveDisabled = isSaveDisabled;
      vm.ContrFeeValidation();
      // ContractTransmissionFeeReport
      vm.transFeeReport = function() {
        $http.post('Contract/GenerateTransFeeReport', { contractId: vm.formModel.ContractId }).then(function(result) {
          var data = result.data;
          if (data.ResultStatus) {
            var raw = atob(data.File);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }

            var fs = new Blob([array], { type: data.MimeType });
            saveAs(fs, decodeURIComponent(data.FileName));

            toastr.success('Sikeres generálás!');
          }
        });
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrDiscountEditCtrl', [
    '$uibModalInstance',
    '$http',
    '$state',
    'fModel',
    'EditOrDuplicate',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, $state, fModel, EditOrDuplicate, $stateParams, authService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrDiscountEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      if (vm.formModel.ContrDiscountId !== 0 && vm.formModel.ContrDiscountId !== null) {
        $http({
          method: 'GET',
          url: 'Contract/GetDiscountById',
          params: {
            discountId: vm.formModel.DiscountId.Value,
            contrFeeId: vm.formModel.ContrFeeId,
            contrDiscountId: vm.formModel.ContrDiscountId,
          },
        }).then(function successCallback(response) {
          var FlgDiscount = response.data.Dto;
          if (FlgDiscount !== null) {
            vm.pageModel.Fields['DiscountId'].FormlyFieldDescriptor.templateOptions.disabled = !FlgDiscount.Modifiable;
            vm.pageModel.Fields[
              'RealDiscount'
            ].FormlyFieldDescriptor.templateOptions.disabled = !FlgDiscount.Modifiable;
            vm.pageModel.Fields[
              'RealDiscountPercent'
            ].FormlyFieldDescriptor.templateOptions.disabled = !FlgDiscount.Modifiable;
            vm.formModel.RealNetAmount = FlgDiscount.RealNetAmount;
            vm.formModel.Currency = FlgDiscount.Currency;
            vm.MaxDiscount = {
              Discount: !FlgDiscount.MaxDiscount ? null : roundByDefParam(FlgDiscount.MaxDiscount),
              DiscountPercent: FlgDiscount.MaxDiscountPercent,
            };
          }
        });
      }
      vm.controllerOptions = $stateParams.controllerOptions;
      //Ha generált kedvezmény, akkor minden csak megtekinthető!
      vm.formModel.IsReadOnly = vm.formModel.Generated;

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      //hack, hogy ne törölje az f2 a már beírt összeget, mivel form inicializáláskor is lefut az onchange!
      //ha nem új tétellel jön, hanem módosítás/duplukálással, akkor az első F2 onchange-re ne történjen semmi
      vm.firstLoad = vm.formModel.ModelState != 2;

      var convertNullTo0 = function(value) {
        if (value === null) return 0;
        else return value;
      };

      var onChangeFunctions = {
        DiscountId: function(selectedItem) {
          if (!!selectedItem) {
            if (!vm.firstLoad) {
              //hack, hogy ne törölje az f2 a már beírt összeget, mivel form inicializáláskor is lefut az onchange!
              $http({
                method: 'GET',
                url: 'Contract/GetDiscountById',
                params: {
                  discountId: selectedItem.DiscountId,
                  contrFeeId: vm.formModel.ContrFeeId,
                  contrDiscountId: vm.formModel.ContrDiscountId,
                },
              }).then(function successCallback(response) {
                var FlgDiscount = response.data.Dto;
                if (FlgDiscount !== null) {
                  vm.CurrencyRound = FlgDiscount.CurrencyRound;
                  vm.pageModel.Fields[
                    'RealDiscount'
                  ].FormlyFieldDescriptor.templateOptions.disabled = !FlgDiscount.Modifiable;
                  vm.pageModel.Fields[
                    'RealDiscountPercent'
                  ].FormlyFieldDescriptor.templateOptions.disabled = !FlgDiscount.Modifiable;
                  vm.formModel.RanKing = FlgDiscount.RanKing;
                  vm.formModel.Currency = FlgDiscount.Currency;
                  vm.formModel.RealNetAmount = FlgDiscount.RealNetAmount;
                  vm.MaxDiscount = {
                    Discount: !FlgDiscount.MaxDiscount ? null : roundByDefParam(FlgDiscount.MaxDiscount),
                    DiscountPercent: FlgDiscount.MaxDiscountPercent,
                  };

                  if (
                    convertNullTo0(FlgDiscount.Discount) !== 0 &&
                    convertNullTo0(FlgDiscount.DiscountPercent) === 0 &&
                    !!FlgDiscount.RealNetAmount &&
                    convertNullTo0(FlgDiscount.RealNetAmount) != 0
                  ) {
                    //kedvezmény van megadva, százelékot számoljuk utána
                    vm.formModel.Discount = roundByDefParam(FlgDiscount.Discount);
                    vm.formModel.DiscountPercent = (FlgDiscount.Discount / FlgDiscount.RealNetAmount) * 100;
                    vm.formModel.RealDiscount = roundByDefParam(
                      !vm.MaxDiscount.Discount || vm.MaxDiscount.Discount > FlgDiscount.Discount
                        ? FlgDiscount.Discount
                        : vm.MaxDiscount.Discount
                    );
                    vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / FlgDiscount.RealNetAmount) * 100;
                  }
                  if (
                    convertNullTo0(FlgDiscount.Discount) === 0 &&
                    convertNullTo0(FlgDiscount.DiscountPercent) !== 0 &&
                    !!FlgDiscount.RealNetAmount &&
                    convertNullTo0(FlgDiscount.RealNetAmount) != 0
                  ) {
                    //százalék van megadva, összeget számoljuk hozzá

                    vm.formModel.DiscountPercent = FlgDiscount.DiscountPercent;
                    vm.formModel.Discount = roundByDefParam(
                      (FlgDiscount.DiscountPercent * FlgDiscount.RealNetAmount) / 100
                    );
                    vm.formModel.RealDiscountPercent =
                      !vm.MaxDiscount.DiscountPercent || vm.MaxDiscount.DiscountPercent > FlgDiscount.DiscountPercent
                        ? FlgDiscount.DiscountPercent
                        : vm.MaxDiscount.DiscountPercent;
                    vm.formModel.RealDiscount = roundByDefParam(
                      (vm.formModel.RealDiscountPercent * FlgDiscount.RealNetAmount) / 100
                    );
                  }
                }
              });
            }
          } else {
            vm.formModel.Discount = null;
            vm.formModel.DiscountPercent = null;
            vm.formModel.RealDiscount = null;
            vm.formModel.RealDiscountPercent = null;
            vm.formModel.RanKing = null;
            vm.formModel.Currency = null;
            vm.formModel.RealNetAmount = null;
          }
          //hack, hogy ne törölje az f2 a már beírt összeget, mivel form inicializáláskor is lefut az onchange!
          vm.firstLoad = false;
        },
        DiscountPercent: function(selectedItem) {
          if (!!vm.formModel.RealNetAmount && vm.formModel.RealNetAmount !== 0) {
            vm.formModel.Discount = roundByDefParam((vm.formModel.RealNetAmount * vm.formModel.DiscountPercent) / 100);

            if (vm.MaxDiscount.Discount != null && vm.MaxDiscount.DiscountPercent == null) {
              vm.formModel.RealDiscount = roundByDefParam(Math.min(vm.formModel.Discount, vm.MaxDiscount.Discount));
              vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / vm.formModel.RealNetAmount) * 100;
            }
            if (vm.MaxDiscount.Discount == null && vm.MaxDiscount.DiscountPercent != null) {
              vm.formModel.RealDiscount = roundByDefParam(
                Math.min(vm.formModel.Discount, (vm.formModel.RealNetAmount * vm.MaxDiscount.DiscountPercent) / 100)
              );
              vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / vm.formModel.RealNetAmount) * 100;
            }
            if (vm.MaxDiscount.Discount == null && vm.MaxDiscount.DiscountPercent == null) {
              vm.formModel.RealDiscount = roundByDefParam(vm.formModel.Discount);
              vm.formModel.RealDiscountPercent = vm.formModel.DiscountPercent;
            }
          }
        },
        Discount: function(selectedItem) {
          vm.formModel.Discount = roundByDefParam(vm.formModel.Discount);
          if (!!vm.formModel.RealNetAmount && vm.formModel.RealNetAmount !== 0) {
            vm.formModel.DiscountPercent = (vm.formModel.Discount / vm.formModel.RealNetAmount) * 100;
            if (vm.MaxDiscount.Discount != null && vm.MaxDiscount.DiscountPercent == null) {
              vm.formModel.RealDiscount = roundByDefParam(Math.min(vm.formModel.Discount, vm.MaxDiscount.Discount));
              vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / vm.formModel.RealNetAmount) * 100;
            }
            if (vm.MaxDiscount.Discount == null && vm.MaxDiscount.DiscountPercent != null) {
              vm.formModel.RealDiscount = roundByDefParam(
                Math.min(vm.formModel.Discount, (vm.formModel.RealNetAmount * vm.MaxDiscount.DiscountPercent) / 100)
              );
              vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / vm.formModel.RealNetAmount) * 100;
            }
            if (vm.MaxDiscount.Discount == null && vm.MaxDiscount.DiscountPercent == null) {
              vm.formModel.RealDiscount = roundByDefParam(vm.formModel.Discount);
              vm.formModel.RealDiscountPercent = vm.formModel.DiscountPercent;
            }
          }
        },
        RealDiscountPercent: function(selectedItem) {
          vm.formModel.RealDiscount = roundByDefParam(
            (vm.formModel.RealNetAmount * vm.formModel.RealDiscountPercent) / 100
          );
        },
        RealDiscount: function(selectedItem) {
          vm.formModel.RealDiscountPercent = (vm.formModel.RealDiscount / vm.formModel.RealNetAmount) * 100;
        },
      };
      function calculate() {}
      var syncValidators = {
        Discount: {
          /**
           * @return {boolean}
           */
          RealDiscountValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            return modelValue >= vm.formModel.RealDiscount;
          },
        },
        DiscountPercent: {
          /**
           * @return {boolean}
           */
          RealDiscountPercentValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            return modelValue >= vm.formModel.RealDiscountPercent;
          },
        },
      };

      var hideExpressions = {
        RanKing: function($viewValue, $modelValue, scope) {
          return vm.formModel.IsPriorityHandle == false;
        },
      };

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelDiscount.FormlyDescriptor;

      vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        contrFeeId: vm.formModel.ContrFeeId,
        contrDiscountId: vm.formModel.ContrDiscountId,
      };

      vm.save = function() {
        $http.post('Contract/ContrDiscount' + EditOrDuplicate, vm.formModel).then(
          function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
            $state.reload();
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
      vm.attachDocument = attachDocument;
      vm.history = history;

      function attachDocument() {
        var id = vm.formModel.ContrDiscountId;
        dasService.NavigateToDas(vm.messages, 'Contract.ContractNavDasDocumentsNav', 'FlgContrDiscount', id);
      }

      function history() {
        // TODO?
        HistoryService.NavigateToHistory('FlgContrDiscount', vm.dataModel.ContrDiscountId, vm, $state);
      }

      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.CurrencyRound || 0));
      }

      function roundByDefParam(value) {
        return parseFloat(parseFloat(value).toFixed(authService.parameters.DEFFPR || 2));
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrFeeEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$uibModal',
    'AuthService',
    'HistoryService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      authService,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.InvoiceingToIsModifiable =
        vm.formModel.ModifyLimitation == 3 ||
        (vm.formModel.ModifyLimitation == 0 &&
          (vm.formModel.MeterId > 0 || vm.formModel.MeterTmId > 0 || vm.formModel.ServiceType == 'CSERC'));

      vm.createContract = createContract;
      vm.lockContract = lockContract;
      vm.attachDocument = attachDocument;
      vm.history = history;

      var contractId = options.dto.ContractId;
      var contrFeeId = options.dto.ContrFeeId;
      vm.ServiceType = options.dto.ServiceType;

      if (!vm.formModel.HasValidVat) {
        toastr.warning('Az összeg mezők letiltásra kerültek.', 'Áfa nem található a díjtételek pénzügyi adataiban!');
      }

      vm.activeMainItemTab = 0;

      vm.startedAmount = {
        UnitPrice: angular.copy(vm.formModel.UnitPrice),
        CorrectedNetAmount: angular.copy(vm.formModel.CorrectedNetAmount),
        RealNetAmount: angular.copy(vm.formModel.RealNetAmount),
      };
      vm.amountIsChanged = function() {
        return (
          (vm.startedAmount.UnitPrice != null && vm.startedAmount.UnitPrice != vm.formModel.UnitPrice) ||
          (vm.startedAmount.CorrectedNetAmount &&
            vm.startedAmount.CorrectedNetAmount != vm.formModel.CorrectedNetAmount) ||
          (vm.startedAmount.RealNetAmount != null && vm.startedAmount.RealNetAmount != vm.formModel.RealNetAmount)
        );
      };

      vm.startedModel = angular.copy(vm.formModel);
      vm.modelIsChanged = function() {
        //32641: Ha a formon csak az InvoicingTo változott az zárásnak minősül és nem szabad újrakalkulálni a díjakat.
        //Ehhez betöltéskor letároljuk a modelt, majd azt hasonlítjuk az aktuálishoz
        //Problémát okoz, hogy míg a kezdetekkor az F2-es mezőkben egyes állpapotokban a ModelState hiányzik.
        //Megoldásként mindkét modellben az F2 objektumot megszüntetjük, csak az értéküket hasonlítjuk össze
        var tempStartedModel = angular.copy(vm.startedModel);
        var tempFormModel = angular.copy(vm.formModel);

        angular.forEach(Object.getOwnPropertyNames(tempStartedModel), function(value, key) {
          if (!!tempStartedModel[value] && tempStartedModel[value].hasOwnProperty('Value'))
            tempStartedModel[value] = tempStartedModel[value]['Value'];
        });

        angular.forEach(Object.getOwnPropertyNames(tempFormModel), function(value, key) {
          if (!!tempFormModel[value] && tempFormModel[value].hasOwnProperty('Value'))
            tempFormModel[value] = tempFormModel[value]['Value'];
        });

        //InvoicingTo-t nem vizsgáljuk
        delete tempFormModel.InvoicingTo;
        delete tempStartedModel.InvoicingTo;

        return !angular.equals(tempFormModel, tempStartedModel);
      };

      var customExpressionProperties = {
        DiscountId: {
          'templateOptions.required': function() {
            return vm.ServiceType === 'CSECO';
          },
        },
        Contract: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        OrigContractId: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        OwnerContractId: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ContractTypeId: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        TenantPartId: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ContractStatus: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ModUser: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        ModDate: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        DuplicationFee: {
          'templateOptions.disabled': function() {
            return true;
          },
        },
        UnitId: {
          'templateOptions.disabled': function() {
            return vm.formModel.ContrFeeId != 0 || vm.formModel.ModifyLimitation > 0;
          },
        },
        Quantity: {
          'templateOptions.disabled': function() {
            return !vm.formModel.HasValidVat || vm.formModel.ModifyLimitation > 1;
          },
        },
        UnitPrice: {
          // 'templateOptions.required': function() {
          // return true;
          // },
          'templateOptions.disabled': function() {
            return !vm.formModel.HasValidVat || vm.formModel.ModifyLimitation > 1;
          },
        },
        RealNetAmount: {
          'templateOptions.disabled': function() {
            return !vm.formModel.HasValidVat || vm.formModel.ModifyLimitation > 1;
          },
        },
        RealUsageFee: {
          'templateOptions.disabled': function() {
            return !vm.formModel.HasValidVat || vm.formModel.ModifyLimitation > 1;
          },
        },
        InvoicingTo: {
          'templateOptions.required': function() {
            return vm.formModel.DailyAccount === true;
          },
        },
        PauseFromMonth: {
          'templateOptions.required': function() {
            return (
              vm.formModel.DailyAccount !== true &&
              (!!vm.formModel.PauseFromDay || !!vm.formModel.PauseToMonth || !!vm.formModel.PauseToDay)
            );
          },
        },
        PauseFromDay: {
          'templateOptions.required': function() {
            return (
              vm.formModel.DailyAccount !== true &&
              (!!vm.formModel.PauseFromMonth || !!vm.formModel.PauseToMonth || !!vm.formModel.PauseToDay)
            );
          },
        },
        PauseToMonth: {
          'templateOptions.required': function() {
            return (
              vm.formModel.DailyAccount !== true &&
              (!!vm.formModel.PauseFromDay || !!vm.formModel.PauseFromMonth || !!vm.formModel.PauseToDay)
            );
          },
        },
        PauseToDay: {
          'templateOptions.required': function() {
            return (
              vm.formModel.DailyAccount !== true &&
              (!!vm.formModel.PauseFromMonth || !!vm.formModel.PauseFromDay || !!vm.formModel.PauseToMonth)
            );
          },
        },
        DailyAccount: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModifyLimitation > 1 || vm.formModel.Invoiced === true;
          },
        },
      };

      var dynamicQueryParameters = {
        DiscountId: function() {
          //haxx: ha nincs kivalasztva kivalasztva csoport ne szalljon el a kontroller
          var serviceId = vm.formModel.ServiceId.Value === null ? 0 : vm.formModel.ServiceId.Value;
          return [
            {
              key: serviceId,
              text: 'serviceId',
            },
          ];
        },
      };

      var hideExpressions = {
        DiscountId: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSECO';
        },
        CalcUsageFee: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS';
        },
        RealUsageFee: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS';
        },

        CalcNetAmount: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS';
        },
        CalcUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS';
        },
        CorrectedNetAmount: function($viewValue, $modelValue, scope) {
          return vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS';
        },
        PauseFromMonth: function($viewValue, $modelValue, scope) {
          return true; //vm.formModel.DailyAccount === true;
        },
        PauseFromDay: function($viewValue, $modelValue, scope) {
          return true; //vm.formModel.DailyAccount === true;
        },
        PauseToMonth: function($viewValue, $modelValue, scope) {
          return true; //vm.formModel.DailyAccount === true;
        },
        PauseToDay: function($viewValue, $modelValue, scope) {
          return true; //vm.formModel.DailyAccount === true;
        },
      };

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.getSelectedContractId = function() {
        return {
          targetContractId: contractId,
        };
      };

      vm.getSelectedContrFeeId = function() {
        return {
          contrFeeId: vm.selectedContrFeeId,
        };
      };

      vm.save = save;

      vm.back = function() {
        console.log(JSON.stringify(vm.gridOptions));
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      if (vm.EditOrDuplicate === 'View') {
        vm.formModel.ModifyLimitation = 2;
      } else if (
        vm.EditOrDuplicate === 'Edit' &&
        (vm.formModel.MeterId > 0 || vm.formModel.MeterTmId > 0 || vm.formModel.ServiceType == 'CSERC')
      ) {
        vm.formModel.ModifyLimitation = 2;
      }

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.ModifyLimitation > 0) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled =
            (vm.formModel.ModifyLimitation == 1 &&
              ['Quantity', 'UnitPrice', 'RealNetAmount', 'RealUsageFee'].indexOf(key) < 0) ||
            vm.formModel.ModifyLimitation >= 2;
        });
        //Ha van meter/TmId, vagy CSERC típus: biztosítani kell a díjtétel lezárását
        if (vm.formModel.ModifyLimitation > 0 || vm.formModel.ServiceType == 'CSERC') {
          vm.pageModel.Fields.InvoicingTo.FormlyFieldDescriptor.templateOptions.disabled = !vm.InvoiceingToIsModifiable;
        }
      }

      var onChangeFunctions = {
        ServiceId: function(selectedItem) {
          //betolteskor is lefut (ha van kivalasztva ServiceId)
          //DiscountId csak CSECO eseten latszik
          if (!!selectedItem) {
            var discountIdHideExpression = {
              DiscountId: function($viewValue, $modelValue, scope) {
                return selectedItem.ServiceType !== 'CSECO';
              },
            };
            InsertHideExpressions(vm.pageModel, discountIdHideExpression);

            var duplicationFeeCustomExpression = {
              DuplicationFee: {
                'templateOptions.disabled': function() {
                  return (
                    !vm.formModel.HasValidVat ||
                    vm.formModel.ModifyLimitation > 0 ||
                    selectedItem.ServiceType !== 'CSERE'
                  );
                },
              },
            };
            InsertCustomExpressionProperties(vm.pageModel, duplicationFeeCustomExpression);

            //csak berleti dijnal mukodjon a duplazas
            if (selectedItem.ServiceType == 'CSERE') {
              var customCallbackFunctions = {
                DuplicationFee: function(selectedItem) {
                  if (selectedItem === true) {
                    vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.CorrectedNetAmount * 2);
                  } else {
                    vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.CorrectedNetAmount / 2);
                  }
                  vm.formModel.RealNetAmount = roundByDefParam(vm.formModel.CorrectedNetAmount);
                  vm.formModel.CalcUsageFee = roundByDefParam(
                    vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier
                  );
                  vm.formModel.RealUsageFee = vm.formModel.CalcUsageFee;
                  vm.formModel.RealGrossAmount = roundByDefParam(countRealGrossAmount(vm.formModel.RealNetAmount));
                  vm.formModel.UnitPrice = roundByDefParam(vm.formModel.RealNetAmount / vm.formModel.Quantity);
                },
              };
              InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
            }

            //berleti dij kedvezmenyek ful
            if (vm.gridTabs != undefined && vm.gridTabs != null) {
              vm.gridTabs[0].visible = selectedItem.ServiceType === 'CSERE' || selectedItem.ServiceType === 'CSEUS';
            }

            //onBlur-hoz is kell a ServiceType
            vm.ServiceType = selectedItem.ServiceType;
          } else {
            vm.ServiceType = null;
          }

          //betolteskor nem fut le
          vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.disabled = vm.formModel.IsReadOnly; //false
          vm.pageModel.Fields.RealNetAmount.FormlyFieldDescriptor.templateOptions.disabled = vm.formModel.IsReadOnly; //false
          if (!!selectedItem && !!selectedItem._events) {
            if (!!vm.formModel.DiscountId) {
              vm.formModel.DiscountId.Value = null;
              vm.formModel.DiscountId.Text = null;
            }
            if (!!selectedItem) {
              //dátumok beállítása
              vm.formModel.PauseFromMonth = selectedItem.PauseFromMonth;
              vm.formModel.PauseFromDay = selectedItem.PauseFromDay;
              vm.formModel.PauseToMonth = selectedItem.PauseToMonth;
              vm.formModel.PauseToDay = selectedItem.PauseToDay;

              //kedvezményhez kapcsolódó mezők tiltása
              var customExpressionPropertiesDiscount = {
                Quantity: {
                  'templateOptions.disabled': function() {
                    return (
                      !vm.formModel.HasValidVat ||
                      !(
                        selectedItem.ServiceQuantity === 'CSQSM' ||
                        selectedItem.ServiceQuantity === 'CSQCM' ||
                        selectedItem.ServiceType != 'CSECO'
                      )
                    );
                  },
                },
                UnitPrice: {
                  'templateOptions.disabled': function() {
                    return !vm.formModel.HasValidVat || selectedItem.ServiceType === 'CSECO';
                  },
                },
                //43965-értelmében mindig tiltott!
                // CorrectedNetAmount: {
                // 'templateOptions.disabled': function() {
                // return selectedItem.ServiceType === 'CSECO';
                // },
                // },
              };
              InsertCustomExpressionProperties(vm.pageModel, customExpressionPropertiesDiscount);

              $http({
                method: 'GET',
                url: 'Contract/GetContrFeeInvoicingDates',
                params: {
                  ContractId: contractId,
                  ServiceId: selectedItem.ServiceId,
                },
              }).then(function successCallback(response) {
                vm.formModel.InvoicingFrom = response.data.InvoicingFrom;
                getCalculatedFields(
                  vm.formModel.ContractId,
                  selectedItem.ServiceId,
                  selectedItem.ServiceType,
                  vm.formModel.InvoicingFrom,
                  vm.formModel.InvoicingTo
                );
              });
              //kedvezmények panel lerejtése
              //vm.panelDiscountIsHided = selectedItem.ServiceType !== "CSERE";
            }
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              contractId: contractId,
            };
          }
        },
        RealNetAmount: function() {
          vm.formModel.RealNetAmount = roundByDefParam(vm.formModel.RealNetAmount);
          //egysegar
          vm.formModel.UnitPrice = roundByDefParam(vm.formModel.RealNetAmount / vm.formModel.Quantity);
          //brutto osszeg
          vm.formModel.RealGrossAmount = countRealGrossAmount(vm.formModel.RealNetAmount);
          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSEUS') {
            //kalkulalt hasznalati dij
            vm.formModel.CalcUsageFee = vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier;
            //tenyleges hasznlati dij
            vm.formModel.RealUsageFee = vm.formModel.CalcUsageFee;
          }

          if (vm.ServiceType == 'CSERE') {
            //fizetendo netto osszeg
            vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.RealNetAmount);
          }
        },
        CorrectedNetAmount: function() {
          vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.CorrectedNetAmount);
          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSECO') {
            //egysegar
            vm.formModel.UnitPrice = roundByDefParam(vm.formModel.CorrectedNetAmount / vm.formModel.Quantity);
          }
          if (vm.ServiceType == 'CSERE') {
            //brutto osszeg
            vm.formModel.RealGrossAmount = countRealGrossAmount(vm.formModel.CorrectedNetAmount);
            //tenlyeges netto
            vm.formModel.RealNetAmount = vm.formModel.CorrectedNetAmount;
          }

          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSEUS') {
            //kalkulalt hasznalati dij
            vm.formModel.CalcUsageFee = vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier;
            //tenyleges hasznlati dij
            vm.formModel.RealUsageFee = vm.formModel.CalcUsageFee;
          }
        },
        RealUsageFee: function() {
          vm.formModel.RealUsageFee = roundByDefParam(vm.formModel.RealUsageFee);
        },
        Quantity: function() {
          //tenyleges netto osszeg
          vm.formModel.RealNetAmount = roundByDefParam(vm.formModel.Quantity * vm.formModel.UnitPrice);
          //tenyleges brutto osszeg
          vm.formModel.RealGrossAmount = countRealGrossAmount(vm.formModel.RealNetAmount);

          //speciális esetek:
          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSECO') {
            //kalkulalt netto osszeg
            vm.formModel.CalcNetAmount = roundByDefParam(
              vm.formModel.Quantity *
                (!!vm.formModel.CalcUnitPrice ? vm.formModel.CalcUnitPrice : vm.formModel.UnitPrice)
            );
            //fizetendo netto osszeg

            vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.CalcNetAmount - vm.formModel.RealDiscount);
            //tenyleges netto osszeg
            vm.formModel.RealNetAmount = vm.formModel.CorrectedNetAmount;
            //tenyleges brutto osszeg
            vm.formModel.RealGrossAmount = countRealGrossAmount(vm.formModel.RealNetAmount);
            //egységár
            vm.formModel.UnitPrice = roundByDefParam(vm.formModel.RealNetAmount / vm.formModel.Quantity);
          }

          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSEUS') {
            //kalkulalt hasznalati dij
            vm.formModel.CalcUsageFee = vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier;
            //tenyleges hasznlati dij
            vm.formModel.RealUsageFee = vm.formModel.CalcUsageFee;
          }

          if (vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS' && vm.ServiceType != 'CSECO') {
            //Kalkulalt osszegek uritese
            vm.formModel.CalcNetAmount = null;
            vm.formModel.CalcUnitPrice = null;
            vm.formModel.CorrectedNetAmount = null;
          }

          vm.formModel.InvoiceQuantity =
            Math.sign(vm.formModel.Quantity) == -1
              ? -Math.abs(vm.formModel.InvoiceQuantity)
              : Math.abs(vm.formModel.InvoiceQuantity);
        },
        UnitPrice: function() {
          vm.formModel.UnitPrice = roundByDefParam(vm.formModel.UnitPrice);
          //tenyleges netto osszeg
          vm.formModel.RealNetAmount = roundByDefParam(vm.formModel.UnitPrice * vm.formModel.Quantity);
          //tenyleges brutto osszeg
          vm.formModel.RealGrossAmount = roundByDefParam(countRealGrossAmount(vm.formModel.RealNetAmount));

          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSEUS') {
            //kalkulalt hasznalati dij
            vm.formModel.CalcUsageFee = roundByDefParam(
              vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier
            );
            //tenyleges hasznlati dij
            vm.formModel.RealUsageFee = roundByDefParam(vm.formModel.CalcUsageFee);
          }
          if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSECO') {
            //fizetendo netto osszeg
            vm.formModel.CorrectedNetAmount = roundByDefParam(vm.formModel.RealNetAmount);
          }

          if (vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS' && vm.ServiceType != 'CSECO') {
            //Kalkulalt osszegek uritese
            vm.formModel.CalcNetAmount = null;
            vm.formModel.CalcUnitPrice = null;
            vm.formModel.CorrectedNetAmount = null;
          }
        },
        InvoicingFrom: function() {
          var dateIsValid = moment(
            vm.formModel.InvoicingFrom,
            kendo.culture().calendar.patterns.d.toUpperCase(),
            true
          ).isValid();
          if (
            dateIsValid &&
            !!vm.formModel.ServiceId &&
            !!vm.formModel.ServiceId.Value &&
            vm.formModel.ServiceId.Value > 0
          ) {
            getCalculatedFields(
              vm.formModel.ContractId,
              vm.formModel.ServiceId.Value,
              vm.ServiceType,
              vm.formModel.InvoicingFrom,
              vm.formModel.InvoicingTo
            );
          }
        },
        InvoicingTo: function() {
          var dateIsValid =
            !vm.formModel.InvoicingTo ||
            moment(vm.formModel.InvoicingTo, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid();
          if (
            vm.modelIsChanged() &&
            dateIsValid &&
            !!vm.formModel.ServiceId &&
            !!vm.formModel.ServiceId.Value &&
            vm.formModel.ServiceId.Value > 0
          ) {
            getCalculatedFields(
              vm.formModel.ContractId,
              vm.formModel.ServiceId.Value,
              vm.ServiceType,
              vm.formModel.InvoicingFrom,
              vm.formModel.InvoicingTo
            );
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      var syncValidators = {
        ServiceId: {
          NonSelectableService: function(viewValue, modelValue) {
            return vm.ServiceType !== 'CSEPU' && vm.ServiceType !== 'CSERC';
          },
        },

        UnitPrice: {
          NotZeroValidator: function(viewValue, modelValue) {
            return vm.formModel.GetPriceCanBeZero || !!modelValue;
          },
        },

        Quantity: {
          NotZeroValidator: function(viewValue, modelValue) {
            return !!modelValue;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);

      //ServiceId F2 QueryParameters
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        contractId: contractId,
      };
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.columns[12].hidden = true; //ServiceId
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.columns[13].hidden = true; //ServiceGroupId
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.columns[14].hidden = true; //UnitId

      /////////////////////////////////////////////////////////////////////////////////////////
      // Bérleti díjhoz kedvezményekhez kell
      /////////////////////////////////////////////////////////////////////////////////////////
      //Bérleti díj kedvezmény grid/tab generálása
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelContrDiscount'],
        function(gridModel) {
          if (gridModel.Name === 'GridContrDiscount') {
            gridModel.ControllerMethod = 'Contract/ContrDiscountDetailList/';

            return {
              gridModel,
              transportData: { contrFeeId: contrFeeId },
              selectFunction: function() {
                getSelectedSubGridItem();
              },
              groupable: true,
            };
          }

          return null;
        }
      );

      if (vm.formModel.ContrFeeId !== 0) {
        vm.grids = generatedGridTabs.grids;
        vm.gridTabs = generatedGridTabs.tabs;
        vm.gridOptions = generatedGridTabs.gridOptions;
      }

      var getUrlPrefix = function() {
        var urlPrefix = vm.gridTabs[vm.activeSubItemTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      };
      var refreshActiveGrid = function() {
        vm.grids[vm.grids[vm.activeSubItemTab]].dataSource.read();
      };
      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });
      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      vm.editSubItem = function() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var url = 'Contract/' + getUrlPrefix() + 'Edit/?id=' + id + '&ContrFeeId=' + contrFeeId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrDiscountEdit.html',
          controller: 'ContrDiscountEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          refreshActiveGrid();
        });
      };

      vm.duplicateSubItem = function() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var url = 'Contract/' + getUrlPrefix() + 'Duplicate/?id=' + id + '&ContrFeeId=' + contrFeeId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrDiscountEdit.html',
          controller: 'ContrDiscountEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: duplicatePromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          refreshActiveGrid();
        });
      };

      vm.createSubItem = function() {
        var id = 0;
        var url = 'Contract/' + getUrlPrefix() + 'Edit/?id=' + id + '&ContrFeeId=' + contrFeeId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrDiscountEdit.html',
          controller: 'ContrDiscountEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            EditOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          refreshActiveGrid();
        });
      };

      vm.deleteSubItem = function() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        bootbox.dialog({
          message: 'Biztosan törölni szeretné a kiválasztott elemet?', // TODO
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Contract/' + getUrlPrefix() + 'Delete/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  refreshActiveGrid();
                  $state.reload();
                });
              },
            },
          },
        });
      };

      function getSelectedSubGridItem() {
        var gridName = vm.gridTabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.grids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        //
        var gridName = vm.gridTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }
      function getCalculatedFields(contractId, serviceId, serviceType, invoicingFrom, invoicingTo) {
        $http({
          method: 'GET',
          url: 'Contract/ContrFeeGetCalculatedFields',
          params: {
            ContractId: contractId,
            ServiceId: serviceId,
            invoicingFrom: invoicingFrom,
            invoicingTo: invoicingTo,
          },
        })
          .then(function successCallback(response) {
            //Van érvényes pénzügyi adat?
            vm.formModel.HasValidVat = !!response.data;
            //InvoicingFrom
            if (!!response.data && !vm.formModel.InvoicingFrom) {
              vm.formModel.InvoicingFrom = response.data.InvoicingFrom;
            }
            //DiscountId
            if (!!response.data && !!response.data.DiscountId && !!response.data.DiscountId.Value) {
              if (!!vm.formModel.DiscountId) {
                vm.formModel.DiscountId.Value = response.data.DiscountId.Value;
                vm.formModel.DiscountId.Text = response.data.DiscountId.Text;
                //Disable F2
                vm.pageModel.Fields.DiscountId.FormlyFieldDescriptor.templateOptions.disabled = true;
                //Disable NetAmount
                if (response.data.Modifiable) {
                  vm.pageModel.Fields.RealNetAmount.FormlyFieldDescriptor.templateOptions.disabled = true;
                }
              }
            }
            ////////////
            //Quantity
            //InvoiceQuantity
            //UnitId
            if (!!response.data) {
              vm.formModel.Quantity = response.data.Quantity;
              //46851 - Kézi díjrögzítéskor negatív díjak kezelése (számlázási mennyiségben átvezetés)
              vm.formModel.InvoiceQuantity =
                Math.abs(response.data.InvoiceQuantity) * Math.sign(response.data.Quantity);
              vm.formModel.UnitId = response.data.UnitId;
              vm.formModel.HasValidVat = true;
            }
            ////////////////

            if (!!response.data) {
              //CalcUnitPrice
              if (serviceType == 'CSECO') {
                //TODO CalcUnitPrice = GetDiscount() - RealDiscount
                vm.formModel.CalcUnitPrice = response.data.CalcUnitPrice - vm.formModel.RealDiscount;
              } else {
                //backenden kezelve van a tobbi tipus szerint
                vm.formModel.CalcUnitPrice = response.data.CalcUnitPrice;
              }
              //PriceListRowId (why?)
              vm.formModel.PriceListRowId = response.data.PriceListRowId;
              //Vat
              vm.formModel.Vat = response.data.Vat;
              //CalcNetAmount
              vm.formModel.CalcNetAmount = roundByDefParam(vm.formModel.Quantity * vm.formModel.CalcUnitPrice);
              //CorrectedNetAmount
              if (serviceType == 'CSERE' || serviceType == 'CSECO' || serviceType == 'CSEAI') {
                vm.formModel.CorrectedNetAmount = roundByDefParam(
                  vm.formModel.CalcNetAmount - vm.formModel.RealDiscount
                );
              } else {
                vm.formModel.CorrectedNetAmount = roundByDefParam(
                  vm.formModel.CalcNetAmount - vm.formModel.SumDiscount
                );
              }
              //RealNetAmount
              vm.formModel.RealNetAmount = vm.formModel.CorrectedNetAmount;
              //RealGrossAmount
              vm.formModel.RealGrossAmount =
                vm.formModel.RealNetAmount + (vm.formModel.RealNetAmount * vm.formModel.Vat) / 100;

              if (vm.ServiceType == 'CSERE' || vm.ServiceType == 'CSEUS') {
                if (vm.ServiceType == 'CSERE') {
                  vm.formModel.CalcUsageFee = vm.formModel.RealNetAmount * vm.formModel.WithoutTitelMultiplier;
                  vm.formModel.RealUsageFee = vm.formModel.CalcUsageFee;
                } else {
                  vm.formModel.CalcUsageFee = response.data.CalcUsageFee;
                  vm.formModel.RealUsageFee = response.data.RealUsageFee;
                  vm.formModel.UsageFeeMultiplierId = response.data.UsageFeeMultiplierId;
                }
              }

              //RealNetAmount
              vm.formModel.RealNetAmount = vm.formModel.CorrectedNetAmount;
              //RealGrossAmount
              vm.formModel.RealGrossAmount = countRealGrossAmount(vm.formModel.RealNetAmount);
              //UnitPrice
              if (serviceType == 'CSERE' || serviceType == 'CSECO') {
                vm.formModel.UnitPrice = roundByDefParam(vm.formModel.RealNetAmount / vm.formModel.Quantity);
              } else {
                vm.formModel.UnitPrice = roundByDefParam(vm.formModel.CalcUnitPrice);
              }

              if (vm.ServiceType !== 'CSERE' && vm.ServiceType !== 'CSEUS' && vm.ServiceType != 'CSECO') {
                //Kalkulalt osszegek uritese
                vm.formModel.CalcNetAmount = null;
                vm.formModel.CalcUnitPrice = null;
                vm.formModel.CorrectedNetAmount = null;
              }
            }
          })
          .catch(function() {
            clearValueOnAmountFields();
            //nincs érvényes pénzügyi adat!
            vm.formModel.HasValidVat = false;
          });
      }

      /////////////////////////////////////////////////////////////////////////////////////////
      // Bérleti díjhoz kedvezményekhez kellett
      /////////////////////////////////////////////////////////////////////////////////////////
      vm.activeMainItemTab = 0;

      function save() {
        var dialog = function(message, title) {
          bootbox.dialog({
            message:
              '<b>A díj értékek megváltoztak!</b><br/><br/>Az ingatlanhoz rendelt kevezmények újra kiszámításra kerülnek!<br/>Mentés esetén a <b>manuálisan rögzített kedvezmények törlődnek</b>, az aktuális kedvezményeket újra kell rögzíteni!' +
              (!!message ? '<br/><br/>' + message : ''),
            title: title || vm.pageModel.Messages.Confirm,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Actions['ActionSave'].Title, //vm.pageModel.Messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  saveFunctWarning();
                },
              },
            },
          });
        };

        if (vm.amountIsChanged()) {
          $http.get('Contract/AffectedByDepositOnEditQuery/' + vm.formModel.ContrFeeId).then(function(result) {
            if (result.data.AffectedByDeposit == true) {
              dialog(result.data.Message, 'Figyelmeztetés!');
              return;
            } else {
              dialog();
            }
          });
        } else {
          saveFunctWarning();
        }
      }

      function saveFunctWarning() {
        $http
          .post('Contract/GetContrFeeHasClosedWarning', vm.formModel)
          .then(function(response) {
            if (!!response.data.HasWarning) {
              bootbox.dialog({
                message: response.data.HasWarning,
                title: vm.pageModel.Messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.pageModel.Messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: vm.pageModel.Messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      saveFunct();
                    },
                  },
                },
              });
            } else {
              saveFunct();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function saveFunct() {
        if (vm.startedAmount.UnitPrice == null || vm.amountIsChanged()) {
          vm.formModel.BaseUnitPrice = vm.formModel.UnitPrice;
        }
        $http
          .post('Contract/ContrFee' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            if (vm.formModel.ContrFeeId > 0)
              $state.go('Contract.GridFeeEdit', { id: vm.formModel.ContrFeeId }, { reload: true });
            else $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createContract() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContrFeeEdit', { id: 0 });
      }

      function lockContract() {
        var url = 'Contract/ContractLock/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContractLock.html',
          controller: 'ContractLockCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      function attachDocument() {
        var id = vm.formModel.ContrFeeId;
        dasService.NavigateToDas(vm.messages, 'Contract.ContractNavDasDocumentsNav', 'FlgContrFee', id);
      }

      function history() {
        HistoryService.NavigateToHistory('FlgContrFee', contrFeeId, vm, $state);
      }

      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.Rounding || 0));
      }

      function roundByDefParam(value) {
        return parseFloat(parseFloat(value).toFixed(authService.parameters.DEFFPR || 2));
      }

      function countRealGrossAmount(netAmount) {
        var vatAmount = (netAmount * vm.formModel.Vat) / 100;
        return netAmount + roundByDefParam(vatAmount);
      }

      function clearValueOnAmountFields() {
        vm.formModel.RealNetAmount = null;
        vm.formModel.CalcUsageFee = null;
        vm.formModel.RealUsageFee = null;
        vm.formModel.RealGrossAmount = null;
        vm.formModel.UnitPrice = null;
        vm.CorrectedNetAmount = null;
        vm.formModel.DiscountId = null;
        vm.formModel.CalcUnitPrice = null;
        vm.formModel.PriceListRowId = null;
        vm.formModel.Vat = null;
        vm.formModel.CalcNetAmount = null;
        vm.formModel.CorrectedNetAmount = null;
      }
      /////////////////////////////////////////////////////////////////////////////
      // buttons
      /////////////////////////////////////////////////////////////////////////////

      vm.setAddButtonActivity = function() {
        return vm.formModel.IsReadOnly === true || !vm.formModel.EnabledDiscountByAreaRental;
      };

      vm.setEditButtonActivity = function() {
        return vm.formModel.IsReadOnly === true;
      };

      vm.setRemoveButtonActivity = function() {
        return vm.formModel.IsReadOnly === true;
      };

      vm.setCopyButtonActivity = function() {
        return vm.formModel.IsReadOnly === true || !vm.formModel.EnabledDiscountByAreaRental;
      };

      vm.activeSubItemTab = 0;
      vm.activeDetailItemTab = 0;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrLetterEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    '$uibModal',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, $uibModal, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrLetterEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGContrLetter',
        disableRunExpression: false,
      };
      function headerIsDisabled() {
        return vm.collapseHelper?.disabledPanels?.indexOf('PGHeader') !== -1;
      }
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.UIHelperService.setDefaultSidebarStatus();

      var dynamicQueryParameters = {
        TemplateId: function() {
          return [
            {
              key: 'DocType',
              value: vm.formModel.DocType,
            },
            {
              key: 'TemplateId',
              value: vm.formModel.TemplateId,
            },
          ];
        },
      };

      var customExpressionProperties = {
        TemplateId: {
          'templateOptions.disabled': function() {
            if (typeof vm.formModel.DocType === 'undefined') {
              return true;
            }
            return false;
          },
        },
      };

      var onChangeFunctions = {
        DocType: function() {
          vm.pageModel.Fields.TemplateId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.headerFields = vm.FormlyFormPanelDescriptors.PanelHeader.FormlyDescriptor;
      vm.leftPanelFields = vm.FormlyFormPanelDescriptors.PanelLeft.FormlyDescriptor;
      vm.rightPanelFields = vm.FormlyFormPanelDescriptors.PanelRight.FormlyDescriptor;

      //Ha a számlázhatóság vége nem üres, akkor minden csak megtekinthető!
      vm.formModel.IsReadOnly = vm.formModel.InvoicingTo !== null || vm.EditOrDuplicate === 'View';

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.createContrLetter = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.GridContrLetterEdit', { id: 0, ContractId: vm.formModel.ContractId.Value });
      };

      vm.save = function() {
        if (!isNaN(vm.formModel.TemplateId)) {
          saveAndGenerateReport();
        } else {
          $http
            .post('Contract/GetDocumentTemplateParamCount', {
              templateId: vm.formModel.TemplateId,
            })
            .then(
              function(res) {
                var result = res.data;
                //jelenleg nem ismert olyan paraméter, amire ennek a modalnak fel kellene jönnie
                //ha mégis újra bekerül, csak ide kell felvenni a apraméter nevét:
                if (result.ParamNameList.includes('FAKEPARAM')) {
                  var modalInstance = $uibModal.open({
                    templateUrl: 'App/Contract/ContrTemplateGenParamReqModal.html',
                    controller: 'ContrTemplateGenParamReqModalEditCtrl',
                    controllerAs: 'vm',
                    resolve: {
                      fModel: RouteResolveFunc('Contract/DocumentTemplateGenParamModal'),
                      reportParams: {},
                    },
                    backdrop: 'static',
                  });

                  modalInstance.result.then(function(res) {
                    if (res.reportType) {
                      saveAndGenerateReport(res.reportType);
                    }
                  });
                } else {
                  saveAndGenerateReport();
                }
              },
              function(err) {
                // TODO err
              }
            );
        }
      };

      function saveAndGenerateReport(reportType) {
        $http.post('Contract/ContrLetter' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            console.log('response: ' + response);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            generateReport(reportType);
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }
      function generateReport(reportType) {
        $http
          .post('Contract/GenerateDocumentTemplate', {
            templateId: vm.formModel.TemplateId,
            contractId: vm.formModel.ContractId,
            reportType: reportType,
          })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
              ////////////////////////////////////////////////////////////////////////////////////
              // sikeres letoltes, mehet a mentes
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
              ////////////////////////////////////////////////////////////////////////////////////
            },
            function(result) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            }
          );
      }

      vm.deleteContrLetter = function() {
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Contract/ContrLetterDelete/' + vm.formModel.ContrLetterId).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  $state.go('Contract.ContractEdit', {
                    id: vm.formModel.ContractId.Value,
                    openedPanelGroup: 'PGGridek',
                  });
                });
              },
            },
          },
        });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ContrLetterId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgContrLetter', id);
      };
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'contractDetailsIsCollapsed':
            vm.activeBooleans['contractDetailsIsActive'] = true;
            break;
          case 'generatedDocumentumIsCollapsed':
            vm.activeBooleans['generatedDocumentumIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrPaymentEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrPaymentEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGTabContract',
        disableRunExpression: false,
      };

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.formModel.AccountSeparator1 = '-';
      vm.formModel.AccountSeparator2 = '-';

      vm.UIHelperService.setDefaultSidebarStatus();

      var contractId = options.dto.ContractId;

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ContrPaymentId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgContrPayment', id);
      };

      var syncValidators = {
        FulfilmentDay: {
          /**
           * @return {boolean}
           */
          FulfilmentDayValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 1 && modelValue <= 31;
          },
        },
        DueDateDays: {
          /**
           * @return {boolean}
           */
          DueDateDaysValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= -2 && modelValue <= 31;
          },
        },
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            if (vm.formModel.HasInvoice) {
              return true;
            }
            return (
              (vm.formModel.First === true && vm.formModel.ContractStatusCode !== 'CCSOP') ||
              (vm.formModel.ContrPaymentId !== 0 && vm.EditOrDuplicate == 'Edit')
            );
          },
        },
        DefaultInterestRate: {
          'templateOptions.disabled': function() {
            if (vm.formModel.HasInvoice) {
              return true;
            }
            return vm.formModel.Modifiable === false;
          },
        },
        Account1: {
          'templateOptions.required': function() {
            return vm.formModel.Payment === 'S'; // Csoportos beszedés
          },
        },
        Account2: {
          'templateOptions.required': function() {
            return vm.formModel.Account1 != null &&
              vm.formModel.Account1.Text != null &&
              vm.formModel.Account1.Text != ''
              ? true
              : false;
          },
        },
      };

      var onChangeFunctions = {
        Account1: function(selectedItem) {
          if (!!selectedItem) {
            vm.formModel.Account2 = selectedItem.Account2;
            vm.formModel.Account3 = selectedItem.Account3;
          }
        },
      };

      var customTypes = {
        AccountSeparator1: 'separatorDash',
        AccountSeparator2: 'separatorDash',
      };

      var inputMasks = {
        //"Account1": "99999999",
        //"Account2": "99999999",
        //"Account3": "99999999",
        FulfilmentDay: '99',
        DueDateDays: '99',
      };

      InsertCustomTypes(vm.pageModel, customTypes);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertInputMasks(inputMasks);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.pageModel.Fields.Payment.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { filters: { IsCash: '0' } };
      };
      vm.headerFields = vm.FormlyFormPanelDescriptors.PanelHeader.FormlyDescriptor;
      vm.leftPanelFields = vm.FormlyFormPanelDescriptors.PanelLeft.FormlyDescriptor;
      vm.rightPanelFields = vm.FormlyFormPanelDescriptors.PanelRight.FormlyDescriptor;
      vm.pageModel.Fields.Account1.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        targetPartnerId: vm.formModel.PartnerId,
      };

      if (vm.EditOrDuplicate == 'Edit' && vm.formModel.ContrPaymentId !== 0) {
        if (vm.formModel.HasInvoice) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }
      }

      function save() {
        $http
          .post('Contract/ContrPayment' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            vm.formly.$setPristine();
            $state.go('Contract.ContractEdit', { id: contractId, openedPanelGroup: 'PGGridek' });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractLockCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    function(mi, $http, fModel, $stateParams, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractLockCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http.post('Contract/ContractLock', vm.formModel).then(
          function(response) {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!'); // TODO általános label
            mi.close();
            $state.go('Contract.ContractNav');
          },
          function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen'); // TODO általános label
            //mi.close();
          }
        );
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrUsersEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    '$state',
    'HistoryService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      $uibModal,
      $state,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrUsersEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.collapseBooleans = {
        contractDetailsIsCollapsed: false,
        otherDetailsIsCollapsed: true,
        partAddressIsCollapsed: true,
        partLinkIsCollapsed: true,
      };
      vm.activeBooleans = {
        contractDetailsIsActive: true,
        otherDetailsIsActive: false,
        partAddressIsActive: false,
        partLinkIsActive: false,
      };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.UIHelperService.setDefaultSidebarStatus();

      init();
      initGrid(vm);

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

        initModel($http, $state, $stateParams, vm, options);
        initViewModel($http, $state, $stateParams, vm, options);
        initFormModel($http, $state, $stateParams, vm, options);

        vm.pageModel.Fields.UserPartId.FormlyFieldDescriptor.templateOptions.onClick = function() {
          if (!vm.dataModel.UseFrom)
            toastr.warning('Használó csak az érvényesség kezdete dátum megadása után választható!', 'Figyelmeztetés!');
        };

        //alformok generálása
        vm.dataModelForAddress = options.dataModelForAddress;
        vm.pageModelForAddress = options.pageModelForAddress;
        vm.FormlyFormAddressDescriptors = GenerateFormlyFormPanelsFromPageModel(options.pageModelForAddress);

        vm.dataModelForLink = options.dataModelForLink;
        vm.pageModelForLink = options.pageModelForLink;
        vm.FormlyFormLinkDescriptors = GenerateFormlyFormPanelsFromPageModel(options.pageModelForLink);

        //Alformok beállításai
        partnerAddressSetFields(vm);
        partnerLinkSetFields(vm);
        //fő form generálása
        partnerEditSetFields(vm);
        generateForm(vm);
        //F2 szűrések
        vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          tenement: vm.dataModel.ContrTenementId.Value,
        };

        vm.pageModel.Fields.UserPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          useFrom: vm.dataModel.UseFrom,
        };

        // TenantPartId F22 onChange
        vm.fillPartnerData = fillPartnerData;
        var onChangeFunctions = {
          UseFrom: function(model, view) {
            vm.pageModel.Fields.UserPartId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              useFrom: vm.dataModel.UseFrom,
            };
          },
          UserPartId: function(selectedItem) {
            if (selectedItem === null) {
              return;
            }
            vm.dataModel.UseTo = null;

            // Check if the chosen TenantPartId is already in use on a live contract
            $http
              .post('Contract/CheckIfPartnerIsAlreadyInUseOnALiveContract', {
                partnerId: selectedItem.PartnerId,
              })
              .then(function(response) {
                if (response?.data?.ValidTo) {
                  let validToObject = new moment(response.data.ValidTo);

                  if (validToObject.isValid()) {
                    let useToObject = new moment(vm.dataModel.UseTo, kendo.culture().calendar.patterns.d.toUpperCase());

                    if (!vm.dataModel.UseTo || (useToObject.isValid() && validToObject.isBefore(useToObject)))
                      vm.dataModel.UseTo = validToObject.format(kendo.culture().calendar.patterns.d.toUpperCase());
                  }
                }
                if (!response.data.partnerAlreadyInUse) {
                  return;
                }

                // open modal
                var modalInstance = $uibModal.open({
                  templateUrl: 'App/Contract/AlreadyAssignedPartnerWarningModal.html',
                  controller: 'AlreadyAssignedPartnerWarningModalCtrl',
                  controllerAs: 'vm',
                  resolve: {
                    parameters: {
                      contractsWherePartnerIsTenant: response.data.contractsWherePartnerIsTenant,
                      contractsWherePartnerIsUser: response.data.contractsWherePartnerIsUser,
                    },
                  },
                  backdrop: 'static',
                });

                modalInstance.result.then(function() {
                  // nothing to do...
                });
              })
              .catch(function(response) {});

            var partnerId = selectedItem.PartnerId;
            vm.fillPartnerData(partnerId);
          },
        };

        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

        //readonly
        if (vm.controllerOptions.isFormReadOnly || !!vm.dataModel.UseTo) {
          vm.isReadOnly = true;
          setReadOnlyOnPageModels([vm.pageModel, vm.pageModelForAddress, vm.pageModelForLink]);
        }
      }

      function initGrid(vm) {
        ////////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////// [ Dynamic SubItem Grid generation] ///////////////////////////
        var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
          vm.pageModel.Tabs,
          vm.pageModel.Panels,
          vm.pageModel.Grids,
          null,
          function(gridModel) {
            gridModel.ControllerMethod = `Partner/${gridModel.ControllerMethod}`;
            return {
              gridModel,
              transportData: function() {
                return {
                  targetPartnerId: vm.dataModel.UserPartId?.Value,
                };
              },
              selectFunction: function onGridSelectChanged(rowData) {
                vm.subGrids[vm.subGrids[vm.activeSubItemTab]].SelectedItemId =
                  rowData[vm.subGridOptions[vm.subGrids[vm.activeSubItemTab]].idColumn];
                $scope.$applyAsync();
              },
            };
          }
        );

        vm.subItemTabs = generatedGridTabs.tabs;
        vm.subGridOptions = generatedGridTabs.gridOptions;
        vm.subGrids = generatedGridTabs.grids;
        $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
        vm.activeSubItemTab = $scope.activeSubItemTab;

        vm.editSubItemActive = function() {
          return vm.subGrids[vm.subGrids[vm.activeSubItemTab]]?.SelectedItemId === undefined;
        };

        vm.hasUserPart = function() {
          return vm.dataModel.UserPartId?.Value > 0;
        };

        vm.editSubItem = function(funct) {
          let controllerPreStr = vm.subGrids[vm.activeSubItemTab];
          let modalPreStr = controllerPreStr.replace('Grid', 'Partner');
          // open modal
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Partner/SubItems/' + modalPreStr + 'Modal.html',
            controller: modalPreStr + 'EditCtrl',
            controllerAs: 'vm',
            resolve: {
              options: RouteResolveFunc('Partner/' + controllerPreStr + funct + '/', {
                id: funct == 'Edit' ? vm.subGrids[vm.subGrids[vm.activeSubItemTab]].SelectedItemId : 0,
                PartnerId: vm.dataModel.UserPartId?.Value,
              }),
            },
            backdrop: 'static',
            size: 'lg',
          });

          modalInstance.result.then(function() {
            vm.subGrids[vm.subGrids[vm.activeSubItemTab]].dataSource.read();
          });
        };
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
      vm.isCollapsed3 = false;

      function hideFieldByPartnerCatType(fs, vm, fieldName, types, orFilter) {
        if (orFilter === null) {
          orFilter = false;
        }
        fs.hideField(fieldName, function() {
          return !ShowFieldBasedOnExtraProp(vm.dataModel.extraProperties, 'PartnerCatType', types);
        });
      }

      // -------------------------------------------PartnerAddress--------------------------------------------------------------------------------
      function partnerAddressSetFields(vm) {
        var onChangeFunctions = {
          Country: function(selectedItem) {
            if (!!selectedItem) {
              //vm.pageModelForAddress.Fields.PostCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = { Country: selectedItem.key};
            }

            //Ahhoz, hogy a címet frissíteni tudjam, tudni kell, hogy melyik listaelemek látszódnak, és azokra futtatom a címözzefűzést
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          //"PostCode": function (selectedItem) {
          //    if (!!selectedItem) {
          //        vm.setFieldOnEditedPage("listViewAddress", "Locality", selectedItem.Locality);
          //    }
          //        //vm.pageModelForAddress.Fields.Locality.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = { PostCode: selectedItem.key };
          //    if (vm.PartAddressSource._view.length > 0)
          //        FNSetFullAddrOnItems(vm.PartAddressSource._view);
          //},
          //"Locality": function (selectedItem) {
          //    if (!!selectedItem) {
          //        vm.setFieldOnEditedPage("listViewAddress", "PostCode", selectedItem.PostCode);
          //    }
          //    if (vm.PartAddressSource._view.length > 0)
          //        FNSetFullAddrOnItems(vm.PartAddressSource._view);
          //},
          //"PostCode": function (selectedItem) {
          //    if (!!selectedItem) {
          //        vm.dataModelForAddress.Locality = { Text: selectedItem.Locality, Value: selectedItem.Locality };
          //        vm.dataModelForAddress.PostCode = { Text: selectedItem.PostCode, Value: selectedItem.PostCode };
          //    }
          //    //FNSetFullAddr();
          //},
          //"Locality": function (selectedItem) {
          //    if (!!selectedItem) {
          //        vm.dataModelForAddress.Locality = { Text: selectedItem.Locality, Value: selectedItem.Locality };
          //        vm.dataModelForAddress.PostCode = { Text: selectedItem.PostCode, Value: selectedItem.PostCode };
          //    }
          //    //FNSetFullAddr();
          //},
          PostCode: function(selectedItem) {
            //if (!!selectedItem && !!vm.dataModelForAddress.PostCode) {
            if (!!selectedItem) {
              vm.PartAddressSource._view[0].Locality.Value = selectedItem.Locality;
              //vm.dataModelForAddress.Locality = { Text: selectedItem.Locality, Value: selectedItem.Locality };
              vm.selectedPostCode = selectedItem.Locality;
            }
          },
          Locality: function(selectedItem) {
            //if ((vm.PartAddressSource._view[0].Locality.Value == null || vm.PartAddressSource._view[0].Locality.Text == null) && vm.selectedPostCode != null) {
            //    vm.PartAddressSource._view[0].Locality = {
            //        Text: vm.selectedPostCode,
            //        Value: vm.selectedPostCode
            //    };
            //}
            if (!!selectedItem && !!vm.PartAddressSource._view[0].Locality) {
              vm.PartAddressSource._view[0].PostCode = {
                Text: selectedItem.PostCode,
                Value: selectedItem.PostCode,
              };
            }
          },
          Quarter: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          Street: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          StreetChar: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          StreetNumber: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          Building: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          Stairway: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          Floor: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          Door: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
          TopogrNumber: function(selectedItem) {
            if (vm.PartAddressSource._view.length > 0) FNSetFullAddrOnItems(vm.PartAddressSource._view);
          },
        };
        InsertOnChangeFunctions(vm.pageModelForAddress, onChangeFunctions);

        var customExpressionProperties = {
          ValidTo: {
            'templateOptions.disabled': function($viewValue, $modelValue, scope) {
              return vm.disableFields || scope.model.AddressType === 'PATIN';
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModelForAddress, customExpressionProperties);

        var onBlurFunctions = {
          PostCode: function(selectedItem) {
            if (!!selectedItem && !!vm.dataModelForAddress.Locality) {
              vm.dataModelForAddress.Locality = {
                Text: selectedItem.Locality,
                Value: selectedItem.Locality,
              };
            }
          },
          Locality: function(selectedItem) {
            if (!!selectedItem && !!vm.dataModelForAddress.PostCode) {
              vm.dataModelForAddress.PostCode = {
                Text: selectedItem.PostCode,
                Value: selectedItem.PostCode,
              };
            }
          },
        };
        InsertOnBlurFunctions(vm.pageModelForAddress, onBlurFunctions);
      }

      // -------------------------------------------PartnerLink--------------------------------------------------------------------------------
      function partnerLinkSetFields(vm) {
        var hideExpressions = {
          /**
           * @return {boolean}
           */
          DataPh: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTPH';
            }
            return true;
          },
          /**
           * @return {boolean}
           */
          DataMo: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTMO';
            }
            return true;
          },
          /**
           * @return {boolean}
           */
          DataFa: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTFA';
            }
            return true;
          },
          /**
           * @return {boolean}
           */
          DataEm: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTEM';
            }
            return true;
          },
          /**
           * @return {boolean}
           */
          DataWe: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTWE';
            }
            return true;
          },
          /**
           * @return {boolean}
           */
          DataOt: function($viewValue, $modelValue, scope) {
            if (!!scope.model.LinkType) {
              return scope.model.LinkType.Value !== 'PLTOT';
            }
            return true;
          },
        };

        InsertHideExpressions(vm.pageModelForLink, hideExpressions);

        var customExpressionProperties = {
          // ??
          //ki volt kommentezve InsertCustomExpressionProperties, gondolom emiatt hogy ez nem kell
          //"Name": {
          //    "templateOptions.disabled": false
          //},
          DataPh: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTPH';
              } else {
                return false;
              }
            },
          },
          DataMo: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTMO';
              } else {
                return false;
              }
            },
          },
          DataFa: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTFA';
              } else {
                return false;
              }
            },
          },
          DataEm: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTEM';
              } else {
                return false;
              }
            },
          },
          DataWe: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTWE';
              } else {
                return false;
              }
            },
          },
          DataOt: {
            'templateOptions.required': function() {
              if (!!vm.PartLinkSource._view[0] && !!vm.PartLinkSource._view[0].LinkType) {
                return vm.PartLinkSource._view[0].LinkType.Value === 'PLTOT';
              } else {
                return false;
              }
            },
          },
        };
        InsertCustomExpressionProperties(vm.pageModelForLink, customExpressionProperties);
      }

      // -------------------------------------------PartnerEdit--------------------------------------------------------------------------------
      function partnerEditSetFields(vm) {
        var fs = fieldSetter;
        fs.vm = vm;

        fs.setMask('TaxId', '9999999999');
        fs.setMask('TaxNumber', '99999999-9-99');
        fs.setMask('IdNumber', '9999999-9999');

        hideFieldByPartnerCatType(fs, vm, 'RegNumber', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'RegCourtId', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'StatNumber', ['PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'SECardNumber', ['PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'SERegNumber', ['PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'TaxId', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'IdNumber', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'IdCard', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'PlaceOfBirth', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'DateOfBirth', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'BirthName', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'MotherName', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'Nationality', ['PTCID', 'PTCSE']);
        hideFieldByPartnerCatType(fs, vm, 'TaxNumber', ['PTCID', 'PTCSE', 'PTCCP']);
        hideFieldByPartnerCatType(fs, vm, 'InstituteId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'PostId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'PhoneBookId', ['PTCID', 'PTCSE', 'PTCCP'], !vm.dataModel.Worker);
        hideFieldByPartnerCatType(fs, vm, 'RelationshipId', ['PTCID', 'PTCSE']);

        fs.setOnBlurFunction('UserPartId', function(selectedItem) {
          if (!!selectedItem && !!vm.dataModel.UserPartId)
            vm.dataModel.UserPartId = { Text: selectedItem.Name, Value: selectedItem.PartnerId };
        });

        fs.setOnChangeFunction('UserPartId', function(selectedItem) {
          if (!selectedItem) {
            resetPanels(vm, ['PanelPartnerRight'], ['PartnerCode']);
            vm.PartAddressSource.data([]);
            vm.PartLinkSource.data([]);
          }
          //Ha kiválaszt egy partnert ki kell tölteni az adatokat
          else {
            getDataFromSelectedUserPart(selectedItem);
            vm.dataModel.PartnerCode = selectedItem.PartnerCode;
          }
        });

        fs.setOnChangeFunction('PartnerCatId', function(selectedItem) {
          SetModelExtraPropBasedOnSelectedItem(vm.dataModel.extraProperties, 'PartnerCatType', selectedItem);
        });
        fs.setDisabled('SubTenantSpace', function() {
          return !vm.dataModel.SubTenant;
        });
      }

      // Reset fields function-------------------------------------------------------------------------------------------------------------------------
      function resetPanels(_vm, panels, fields) {
        angular.forEach(_vm.pageModel.Fields, function(value, key) {
          //minden mezőn végigmegy, ha a mező a megadott panelen van, törli az értékét
          if (panels.indexOf(value.ContainerPanelId) > -1) {
            _vm.dataModel[key] = null;
          }
        });

        //külön megadott mezők feltöltése
        angular.forEach(fields, function(value, key) {
          _vm.dataModel[value] = null;
        });
      }

      // Fill fields function-------------------------------------------------------------------------------------------------------------------------
      function fillPanelsFromResponse(_vm, dto, panels, fields) {
        angular.forEach(_vm.pageModel.Fields, function(value, key) {
          //minden mezőn végigmegy, ha a mező a megadott panelen van, akkor feltölti az új dto-bol
          var panelIndex = panels.indexOf(value.ContainerPanelId);
          if (panelIndex > -1) {
            _vm.dataModel[key] = dto[key];
          }
        });
        //minden dto.ban visszakapott extrapropertiest felülír
        angular.forEach(dto.extraProperties, function(value, key) {
          SetModelExtraPropBasedOnSelectedItem(_vm.dataModel.extraProperties, value.key, dto);
        });
        //külön megadott mezők feltöltése
        angular.forEach(fields, function(value, key) {
          _vm.dataModel[value] = dto[value];
        });
      }

      function getDataFromSelectedUserPart(selectedItem) {
        if (!!selectedItem) {
          $http.get('Contract/GetPartnerDataForContrUser/' + selectedItem.PartnerId).then(function(response) {
            fillPanelsFromResponse(
              vm,
              response.data.dto,
              ['PanelPartnerRight', 'PanelPartLink'],
              ['PartAddresses', 'PartLinks']
            );
            vm.dataModel.PartnerTmId = response.data.dto.PartnerTmId;
            if (!!response.data.dto.PostId) {
              vm.dataModel.PostId = response.data.dto.PostId;
            }
            vm.dataModel.PartnerCode = response.data.dto.PartnerCode;
            vm.PartAddressSource.data(vm.dataModel.PartAddresses);
            vm.PartLinkSource.data(vm.dataModel.PartLinks);
          });
        }
      }

      // ----------------------------------------------------------------------------------------------------------------------------------------------
      function InsertCustomExpressionPropertiesToPageModels(pageModels, customFunction) {
        angular.forEach(pageModels, function(pmValue, pmKey) {
          angular.forEach(pmValue.Fields, function(fValue, fKey) {
            if (!fValue.FormlyFieldDescriptor['expressionProperties'])
              fValue.FormlyFieldDescriptor['expressionProperties'] = customFunction;
          });
        });
      }

      var disableFieldsOption = {
        'templateOptions.disabled': function() {
          return vm.disableFields;
        },
      };
      InsertCustomExpressionPropertiesToPageModels([vm.pageModelForLink, vm.pageModelForAddress], disableFieldsOption);

      // ----------------------------------------------------------------------------------------------------------------------------------------------
      function FNSetFullAddrOnItems(items) {
        angular.forEach(items, function(item, key) {
          //minden megjelenített itemen végigmegy és beállítja a fullAddress-t
          if (!!item.Locality && !!item.PostCode && item.Locality.Value !== null && item.PostCode.Value !== null) {
            item.Address =
              (!!item.Country.Text ? item.Country.Text + ' ' : '') +
              (!!item.PostCode.Value ? item.PostCode.Value + ' ' : '') +
              (!!item.Locality.Value ? item.Locality.Value + ' ' : ' ') +
              (!!item.Quarter ? item.Quarter + ', ' : ', ') +
              (!!item.Street ? item.Street + ' ' : '') +
              (!!item.StreetChar.Text ? item.StreetChar.Text + ' ' : '') +
              (!!item.StreetNumber ? item.StreetNumber + ' ' : '') +
              (!!item.Building ? item.Building + ' ' : '') +
              (!!item.Stairway ? item.Stairway + ' ' : '') +
              (!!item.Floor.Text ? item.Floor.Text + ' ' : '') +
              (!!item.Door ? item.Door + ' ' : '') +
              (!!item.TpogrNumber ? item.TpogrNumber + ' ' : '');

            //    print(item.Country) + item.PostCode.Value + " " + item.Locality.Value + print(item.Quarter) + print(item.Street) +
            //print(item.StreetChar) + print(item.StreetNumber) + print(item.Building) + print(item.Stairway) +
            //print(item.Floor) + print(item.Door) + print(item.TpogrNumber);
          }
        });
      }

      vm.updateAddress = updateAddress;
      function updateAddress() {
        angular.forEach(vm.PartAddressSource._view, function(item, key) {
          if (vm.dataModel.PartAddresses !== null) {
            for (var i = 0; i < vm.dataModel.PartAddresses.length; i++) {
              if (vm.dataModel.PartAddresses[i].PartAddressId === item.PartAddressId) {
                vm.dataModel.PartAddresses[i].PostCode.Value = item.PostCode.Value;
                vm.dataModel.PartAddresses[i].Locality.Value = item.Locality.Value;
                vm.dataModel.PartAddresses[i].Country.Text = item.Country.Text;
                vm.dataModel.PartAddresses[i].Quarter = item.Quarter;
                vm.dataModel.PartAddresses[i].Street = item.Street;
                vm.dataModel.PartAddresses[i].StreetChar.Text = item.StreetChar.Text;
                vm.dataModel.PartAddresses[i].StreetNumber = item.StreetNumber;
                vm.dataModel.PartAddresses[i].Building = item.Building;
                vm.dataModel.PartAddresses[i].Stairway = item.Stairway;
                vm.dataModel.PartAddresses[i].Floor.Text = item.Floor.Text;
                vm.dataModel.PartAddresses[i].Door = item.Door;
                vm.dataModel.PartAddresses[i].TpogrNumber = item.TpogrNumber;
              }
            }
          }
        });
      }

      // ----------------------------------------------------------------------------------------------------------------------------------------------

      vm.disableFields = true;

      function createSourceForListView(listView, dataItem, idField) {
        return new kendo.data.DataSource({
          transport: {
            read: function(options) {
              listView.removeClass('k-widget');
              if (!!vm.dataModel[dataItem]) options.success(vm.dataModel[dataItem]);
            },
            create: function(options) {
              var item = options.data.models[0];
              item[idField] = 'new_' + kendo.guid();
              item.ModelState = 'new';
              if (vm.dataModel[dataItem] === null) {
                vm.dataModel[dataItem] = [];
              }
              vm.dataModel[dataItem].push(item);
              options.success(item);
            },
            update: function(options) {
              var item = options.data.models[0];
              item.ModelState = 'mod';
              options.success(options.data.models[0]);
            },
            destroy: function(options) {},
          },
          schema: {
            model: {
              id: idField,
            },
          },
          batch: true,
          pageSize: 1,
          error: function(x) {},
          change: function(x) {
            if (x.action === 'add') {
              vm.disableFields = false;
              vm.editedItem = x.items;
            }
            if (x.action === 'sync' || x.action === 'remove') {
              vm.disableFields = true;
              vm.editedItem = null;
            }
            if (x.items.length > 0) {
              FNSetFullAddrOnItems(x.items);
            }
          },
        });
      }

      //Így lehet kikeresni a dataSource-sben az adott listview itemet:
      vm.setFieldOnEditedPage = function(listViewId, field, value) {
        var selListView = $('#' + listViewId).data('kendoListView');
        var editedRow = $('#' + listViewId)
          .find('.k-edit-item')
          .first();
        if (editedRow.length > 0) selListView.dataItem(editedRow)[field] = value;
      };

      //PartAddress ListView declaration
      vm.PartAddressSource = createSourceForListView($('#listViewAddress'), 'PartAddresses', 'PartAddressId');
      vm.PartAddressTemplate = $('#PartAddressTemplate').html();
      vm.PartAddressEditTemplate = $('#PartAddressEditTemplate').html();
      vm.addNewAddress = function(e) {
        //új Cím hozzáadása
        vm.listViewAddress = $('#listViewAddress').data('kendoListView');
        vm.listViewAddress.add();
        e.preventDefault();
      };

      vm.onPartAddressListViewChange = function() {
        console.log('ListView page change...');
      };

      //PartLink ListView declaration
      vm.PartLinkSource = createSourceForListView($('#listViewLink'), 'PartLinks', 'PartLinkId');
      vm.PartLinkTemplate = $('#PartLinkTemplate').html();
      vm.PartLinkEditTemplate = $('#PartLinkEditTemplate').html();
      vm.addNewLink = function(e) {
        //új elérhetőség hozzáadása
        vm.listViewLink = $('#listViewLink').data('kendoListView');
        vm.listViewLink.add();
        e.preventDefault();
      };

      function setReadOnlyOnPageModels(pageModels) {
        // Set editability of fields based on controllerOptions
        angular.forEach(pageModels, function(pmValue, pmKey) {
          angular.forEach(pmValue.Fields, function(fValue, fKey) {
            fValue.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        });
      }

      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      vm.create = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.GridUsersEdit', { id: 0, ContractId: vm.dataModel.ContractId });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.delete = function() {
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Contract/ContrUsersDelete/' + vm.dataModel.ContrUserId).then(function() {
                  toastr.success('Használó sikeresen törölve!');
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
                });
              },
            },
          },
        });
      };
      //vm.duplicate = function () {
      //    $state.go("Contract.GridUsersDuplicate", {
      //        id: vm.dataModel.ContractId.Value,
      //        "ContractId": vm.dataModel.ContractId.Value
      //    });
      //};
      vm.save = function() {
        $http.post('Contract/ContrUsers' + vm.EditOrDuplicate, vm.dataModel).then(
          function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            vm.formly.$setPristine();
            $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      };
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = attachDocument;
      vm.history = history;

      function attachDocument() {
        var id = vm.dataModel.ContrUsersId;
        dasService.NavigateToDas(vm.messages, 'Contract.ContractNavDasDocumentsNav', 'FlgContrUsers', id);
      }

      function history() {
        HistoryService.NavigateToHistory('FlgContrUser', vm.dataModel.ContrUserId, vm, $state);
      }

      function fillPartnerData(partnerId) {
        console.log('PartnerId ' + partnerId + ' was loaded.');

        $http.get('Contract/GetPartnerDataForContrUser/' + partnerId).then(function(response) {
          fillPanelsFromResponse(
            vm,
            response.data.dto,
            ['PanelPartnerRight', 'PanelPartLink'],
            ['PartAddresses', 'PartLinks']
          );
          vm.dataModel.PartnerTmId = response.data.dto.PartnerTmId;
          if (!!response.data.dto.PostId) {
            vm.dataModel.PostId = response.data.dto.PostId;
          }
          vm.dataModel.PartnerCode = response.data.dto.PartnerCode;
          vm.PartAddressSource.data(vm.dataModel.PartAddresses);
          vm.PartLinkSource.data(vm.dataModel.PartLinks);
        });
      }

      function isFormlyInvalid() {
        var logFormlyDisabledErrorsToConsole = false;

        var disabled = vm.formly.$invalid;
        if (disabled && logFormlyDisabledErrorsToConsole && vm.formly.$error) {
          if (vm.formly.$error.required) {
            console.log('--- BEGIN FORMLY ERRORS ---');
            vm.formly.$error.required.forEach(function(currentValue, index, arr) {
              console.log(currentValue.$$attr.id);
            });
            console.log('--- END FORMLY ERRORS ---');
          }
        }

        return disabled;
      }
      vm.isFormlyInvalid = isFormlyInvalid;
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'contractDetailsIsCollapsed':
            vm.activeBooleans['contarctDetailsIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
          case 'partAddressIsCollapsed':
            vm.activeBooleans['partAddressIsActive'] = true;
            break;
          case 'partLinkIsCollapsed':
            vm.activeBooleans['partLinkIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrCostEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrCostEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.collapseBooleans = { contractDetailsIsCollapsed: false, offsetIsCollapsed: true };
      vm.activeBooleans = { contractDetailsIsActive: true, offsetIsActive: false };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.UIHelperService.setDefaultSidebarStatus();

      //Ha van már futó bérbeszámítás, figyelmeztetünk
      if (vm.formModel.HasValidCsercRowInContrFee) {
        toastr.warning('A szerződéshez már tartozik egy aktív bérbeszámítás!', 'Figyelem!');
      }

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.pageModel.Fields.Amount.FormlyFieldDescriptor.templateOptions.disabled =
        vm.formModel.ContrCostSetOffId > 0 && vm.formModel.Amount == vm.formModel.PaidAmount;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.headerFields = formlyFormPanelDescriptors.Paneldata.FormlyDescriptor;
      vm.formFields = formlyFormPanelDescriptors.PanelSetOff.FormlyDescriptor;

      var customExpressionProperties = {
        ServiceId: {
          'templateOptions.disabled': function() {
            return vm.formModel.ContrCostSetOffId > 0;
          },
        },
        Amount: {
          'templateOptions.disabled': function() {
            return vm.formModel.ContrCostSetOffId > 0 && vm.formModel.PaidAmount == vm.formModel.Amount;
          },
        },
        StartingDate: {
          'templateOptions.disabled': function() {
            return vm.formModel.ContrCostSetOffId > 0;
          },
        },
      };

      var onChangeFunctions = {
        //ServiceId: function(selectedItem) {console.log(selectedItem)};
      };

      var syncValidators = {
        RentPercent: {
          PercentNotAllowZeroValidator: function(viewValue, modelValue) {
            return modelValue > 0 && modelValue <= 100;
          },
        },
        Amount: {
          DecimalValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
          CostOffAmountValidator: function(viewValue, modelValue) {
            return modelValue > vm.formModel.PaidAmount;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.save = function() {
        $http.post('Contract/ContrCost' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ContrCostSetOffId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgContrCostSetOff', id);
      };
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }

        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'contractDetailsIsCollapsed':
            vm.activeBooleans['contractDetailsIsActive'] = true;
            break;
          case 'offsetIsCollapsed':
            vm.activeBooleans['offsetIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrDepositEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'UIHelperService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrDepositEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.collapseBooleans = { contractDetailsIsCollapsed: false, depositIsCollapsed: true };
      vm.activeBooleans = { contractDetailsIsActive: true, depositIsActive: false };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.formModel.IsReadOnly = vm.formModel.DepStatus === 'CDSCH';
      vm.UIHelperService.setDefaultSidebarStatus();

      if (vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      if (vm.formModel.DepStatus !== 'CDSCH') {
        var comboFilter = {
          logic: 'or',
          filters: [
            {
              field: 'key',
              operator: 'eq',
              value: 'CDSDI',
            },
            {
              field: 'key',
              operator: 'eq',
              value: 'CDSNE',
            },
          ],
        };
        vm.pageModel.Fields.DepStatus.FormlyFieldDescriptor.templateOptions.options.dataSource.filter(comboFilter);
      }

      vm.headerFields = formlyFormPanelDescriptors.PanelHeader.FormlyDescriptor;
      vm.formFields = formlyFormPanelDescriptors.PanelDeposit.FormlyDescriptor;

      vm.save = function() {
        $http.post('Contract/ContrDeposit' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            //console.log("response: " + response);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.formly.$setPristine();
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit');
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ContrDepositId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgContrDeposit', id);
      };
      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'contractDetailsIsCollapsed':
            vm.activeBooleans['contractDetailsIsActive'] = true;
            break;
          case 'depositIsCollapsed':
            vm.activeBooleans['depositIsActive'] = true;
            break;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrInformationEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    'HistoryService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      $state,
      HistoryService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrInformationEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.collapseBooleans = { contractDetailsIsCollapsed: false, businessInformationIsCollapsed: true };
      vm.activeBooleans = { contractDetailsIsActive: true, businessInformationIsActive: false };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.UIHelperService.setDefaultSidebarStatus();
      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;

        vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
        initModel($http, $state, $stateParams, vm, options);
        initViewModel($http, $state, $stateParams, vm, options);
        initFormModel($http, $state, $stateParams, vm, options);

        generateForm(vm);

        var descriptor = vm.FormlyFormPanelDescriptors.PanelInformation.FormlyDescriptor;
        descriptor[0].fieldGroup[0].fieldGroup[0].templateOptions.disabled = false;

        vm.save = function() {
          $http
            .post('Contract/ContrInformation' + vm.EditOrDuplicate, vm.dataModel)
            .then(function(response) {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        };

        vm.back = function() {
          console.log(JSON.stringify(vm.gridOptions));
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('Contract.ContractEdit', { id: vm.dataModel.ContractId, openedPanelGroup: 'PGGridek' });
        };

        vm.collapsePanel = function(indexName) {
          vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
          for (let b in vm.collapseBooleans) {
            if (b.valueOf() !== indexName) {
              vm.collapseBooleans[b] = true;
            }
          }

          for (let b in vm.activeBooleans) {
            vm.activeBooleans[b] = false;
          }

          switch (indexName) {
            case 'contractDetailsIsCollapsed':
              vm.activeBooleans['contractDetailsIsActive'] = true;
              break;
            case 'businessInformationIsCollapsed':
              vm.activeBooleans['businessInformationIsActive'] = true;
              break;
          }
        };
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ServiceGroupNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'WalService',
    'DasService',
    'UIHelperService',
    'HistoryService',
    'gridService',
    function(
      $scope,
      options,
      $http,
      $state,
      $stateParams,
      walService,
      dasService,
      UIHelperService,
      HistoryService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceGroupNavCtrl', stateParams);
      }
      var vm = this;
      vm.module = $stateParams.module;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createServiceGroup = createServiceGroup;
      vm.editServiceGroup = editServiceGroup;
      vm.duplicateServiceGroup = duplicateServiceGroup;
      vm.deleteServiceGroup = deleteServiceGroup;
      vm.disabled = true;

      vm.createService = createService;
      vm.editService = editService;
      vm.duplicateService = duplicateService;
      vm.deleteService = deleteService;
      vm.subDisabled = true;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go($state.params.backState);
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridServiceGroup'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridServiceGroup'];

      vm.subGridIdField = vm.pageModel.Grids['GridService'].IdColumn;
      vm.subGrid = $('#subGrid').data('kendoGrid');

      vm.detailGridIdField = vm.pageModel.Grids['GridServiceFinancialData'].IdColumn;

      vm.priceDetailGridIdField = vm.pageModel.Grids['GridPrice'].IdColumn;
      vm.priceDetailGrid = vm.pageModel.Grids['GridPrice'];

      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridServiceGroup,
        'Contract/ServiceGroupList/',
        function(e) {
          changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField, vm.subGrid);
          vm.selectedSubGridItemId = e.ServiceGroupId;
        }
      );

      vm.getSelectedMainGridItemId = function() {
        return {
          serviceGroupId: vm.selectedMainGridItemId,
        };
      };

      vm.getSelectedSubGridItemId = function(e) {
        return {
          serviceId: vm.selectedSubGridItemId,
        };
      };

      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridService,
        'Contract/ServiceList/',
        function() {
          changeSubGridDisable(vm, vm.subGrid, $scope, vm.detailGrid);
        },
        vm.getSelectedMainGridItemId
      );

      vm.detailGridOptions = getGridOptions(
        options.pageModel.Grids.GridServiceFinancialData,
        'Contract/ServiceFinancialDataDetailList/',
        function() {},
        vm.getSelectedSubGridItemId
      );

      vm.priceDetailGridOptions = getGridOptions(
        options.pageModel.Grids.GridPrice,
        'Contract/PriceDetailList/',
        function() {},
        vm.getSelectedSubGridItemId
      );

      vm.initServiceGroupDetail = function(ctrl) {
        ctrl.activeTab = 0;
        const ctrlDetail = ctrl;
        ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
          ctrl.tabs,
          ctrl.panels,
          ctrl.grids,
          ['PanelServiceFinancialData', 'PanelPrice'],
          function(gridModel) {
            gridModel.ControllerMethod = `Contract/${gridModel.ControllerMethod}`;
            return {
              gridModel,
              transportData: function() {
                return {
                  serviceId: ctrlDetail.row.ServiceId,
                };
              },
              selectFunction: function() {},
            };
            return null;
          }
        );
      };

      function createServiceGroup() {
        $state.go($state.params.createGroupState, { id: 0 });
      }

      function editServiceGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go($state.params.editGroupState, { id: id });
        }
      }

      function duplicateServiceGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go($state.params.duplicateGroupState, { id: id });
        }
      }

      function deleteServiceGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.module + '/' + vm.module + 'ServiceGroupDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function createService() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki díjtétel csoportot!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var ServiceGroupId = vm.selectedMainGridItemId;
          $state.go($state.params.createState, { id: 0, ServiceGroupId: ServiceGroupId });
        }
      }

      function editService() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var ServiceGroupId = vm.selectedMainGridItemId;
          $state.go($state.params.editState, { id: id, ServiceGroupId: ServiceGroupId });
        }
      }

      function duplicateService() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var ServiceGroupId = vm.selectedMainGridItemId;
          $state.go($state.params.duplicateState, { id: id, ServiceGroupId: ServiceGroupId });
        }
      }

      function deleteService() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          $http.get(vm.module + '/' + vm.module + 'ServiceDelete/' + id).then(function() {
            toastr.success('Díjtétel sikeresen törölve!');
            vm.subGrid.dataSource.read();
          });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgServiceGroup', id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal(vm.module, 'ServiceGroupNavWal', 'FlgServiceGroupView');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            walService.NavigateToWal(vm.module, 'ServiceNavWal', 'FlgServiceView');
            break;
          }

          default: {
            break;
          }
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgServiceGroup', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ServiceGroupEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceGroupEditCtrl', stateParams);
      }
      var vm = this;
      vm.module = $stateParams.module;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($stateParams.BackTo);
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ServiceGroupId;
        dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgServiceGroup', id);
      };

      var syncValidators = {
        ServiceGroupCode: {
          /**
           * @return {boolean}
           */
          ServiceGroupCodeValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            return !isNaN(modelValue);
          },
        },
      };
      var customTypes = {
        ServiceGroupCode: 'maskedInput',
      };
      var inputMasks = {
        ServiceGroupCode: '99',
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      function save() {
        $http.post(vm.module + '/' + vm.module + 'ServiceGroup' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.formly.$setPristine();
            $state.go($stateParams.BackTo);
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ServiceFinancialDataNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'WalService',
    'HistoryService',
    'DasService',
    'UIHelperService',
    function($scope, options, $http, $state, $stateParams, walService, HistoryService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceFinancialDataNavCtrl', stateParams);
      }
      var vm = this;
      vm.module = $stateParams.module;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createServiceFinancialData = createServiceFinancialData;
      vm.editServiceFinancialData = editServiceFinancialData;
      vm.duplicateServiceFinancialData = duplicateServiceFinancialData;
      vm.deleteServiceFinancialData = deleteServiceFinancialData;
      vm.selectedMainGridItemId = 0;
      vm.disabled = true;

      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go($state.params.backState);
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridServiceFinancialData'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridServiceFinancialData,
        'Contract/ServiceFinancialDataList/',
        function() {
          changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField);
        }
      );

      vm.getSelectedMainGridItemId = function() {
        return {
          serviceFinancialDataId: vm.selectedMainGridItemId,
        };
      };

      function createServiceFinancialData() {
        $state.go($state.params.createState, { id: 0 });
      }

      function editServiceFinancialData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go($state.params.editState, { id: id });
        }
      }

      function duplicateServiceFinancialData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go($state.params.duplicateState, { id: id });
        }
      }

      function deleteServiceFinancialData() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];

          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.module + '/' + vm.module + 'ServiceFinancialDataDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgServiceFinancialData', id);
      }

      function WAL() {
        walService.NavigateToWal(vm.module, 'ServiceFinancialDataNavWal', 'FlgServiceFinancialDataView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory(
          'FlgServiceFinancialDat',
          selectedItems[0][vm.mainGridIdField],
          vm,
          $state,
          true
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ServiceFinancialDataEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceFinancialDataEditCtrl', stateParams);
      }
      var vm = this;
      vm.module = $stateParams.module;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($state.params.backState);
      };
      function save() {
        $http.post(vm.module + '/' + vm.module + 'ServiceFinancialData' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.formly.$setPristine();
            $state.go($stateParams.backState);
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ServiceFinancialDataId;
        dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgServiceFinancialData', id);
      };

      // function editItem() {
      // $state.go("Contract.ServiceFinancialDataEdit", {"id": vm.formModel.ServiceFinancialDataId});
      // }

      // function cancelItem() {
      // $state.go("Contract.ServiceFinancialDataNav");
      // }

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.ServiceFinancialDataId !== 0;
          },
        },
        TenType: {
          'templateOptions.required': function() {
            return vm.formModel.ServiceGroupType === 'CSGIN';
          },
        },
        Owner: {
          'templateOptions.required': function() {
            return vm.formModel.ServiceGroupType === 'CSGIN';
          },
        },
        AreaRentalId: {
          'templateOptions.required': function() {
            return vm.formModel.ServiceGroupType === 'CSGIN';
          },
        },
      };

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          ValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            //$("#ValidTo").siblings("span.k-tooltip-validation").hide();

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      var onChangeFunctions = {
        ServiceId: function(selectedItem) {
          vm.formModel.ServiceGroupType = selectedItem?.ServiceGroupType;
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};
      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};
      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertAsyncValidators(vm.pageModel, asyncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      ////////////////////////////////////////////////////////////////////////////////////////
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createDiscount = createDiscount;
      vm.editDiscount = editDiscount;
      vm.duplicateDiscount = duplicateDiscount;
      vm.deleteDiscount = deleteDiscount;
      vm.priorityDiscount = priorityDiscount;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.disabled = true;
      vm.isPriorityHandle = options.isPriorityHandle === true;

      // Tabs
      var validTab = 'Élő kedvezmények'; //TODO resource-ból
      var allTab = 'Összes kedvezmény';
      var tabs = [validTab, allTab];
      vm.tabs = tabs;
      vm.validDiscount = validTab;
      vm.allDiscount = allTab;
      vm.activeSubItemTab = 0;
      vm.activeDetailTab = 0;

      vm.back = function() {
        $state.go('Contract.ContractNav');
      };

      vm.selectedMainGridItemId = 0;

      vm.mainGridIdField = vm.pageModel.Grids['GridDiscount'].IdColumn;
      vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
      vm.mainGrid = vm.pageModel.Grids['GridDiscount'];

      // Kendo-grid reference for main GRID
      vm.allGridOptions = getGridOptions(
        Object.assign({}, options.pageModel.Grids.GridDiscount, { Id: 'AllGridDiscount' }),
        'Contract/DiscountList/',
        function() {
          changeMainGridFilter();
        }
      );
      // valid filter on main GRID
      vm.validGridOptions = getGridOptions(
        Object.assign({}, options.pageModel.Grids.GridDiscount, { Id: 'ValidGridDiscount' }),
        'Contract/DiscountValidList/',
        function() {
          changeMainGridFilter();
        }
      );

      vm.getSelectedMainGridItemId = function() {
        return {
          DiscountId: vm.selectedMainGridItemId,
        };
      };

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelDiscountLinkage'],
        function(gridModel) {
          if (gridModel.Name === 'GridDiscountLinkage') {
            gridModel.ControllerMethod = 'Contract/DiscountLinkageList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          return null;
        }
      );

      vm.detailTabs = generatedDetailGridTabs.tabs;
      vm.detailGridOptions = generatedDetailGridTabs.gridOptions.GridDiscountLinkage;
      vm.detailGridIdField = vm.pageModel.Grids['GridDiscountLinkage'].IdColumn;
      vm.detailGrid = $('#detailGrid').data('kendoGrid');

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the detailGrid //////////////////////////////////
      function changeMainGridFilter() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }
        changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField, vm.detailGrid);
      }

      function createDiscount() {
        $state.go('Contract.DiscountCreate', { id: 0 });
      }

      function editDiscount() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.DiscountEdit', { id: id });
        }
      }

      function duplicateDiscount() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.DiscountDuplicate', { id: id });
        }
      }

      function deleteDiscount() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/DiscountDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function priorityDiscount() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Contract/DiscountPriorityEdit/?id=' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/DiscountPriorityEdit.html',
            controller: 'DiscountPriorityCtrl',
            controllerAs: 'vm',
            resolve: {
              options: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }
      function attachDocument() {
        if (vm.activeSubItemTab === 0) {
          vm.mainGrid = $('#validDiscountGrid').data('kendoGrid');
        } else {
          vm.mainGrid = $('#allDiscountGrid').data('kendoGrid');
        }

        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgDiscount', id);
      }

      function WAL() {
        walService.NavigateToWal('Contract', 'DiscountNavWal', 'FlgDiscountView');
      }

      vm.history = function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          HistoryService.NavigateToHistory('FlgDiscount', id, vm, $state, true);
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('DiscountEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.disabled = true;
      var discountId = vm.formModel.DiscountId;
      vm.discountGroupId =
        !!vm.formModel.DiscountGroupId && !!vm.formModel.DiscountGroupId.Value ? vm.formModel.DiscountGroupId.Value : 0;
      vm.ranKing = vm.formModel.RanKing;

      vm.IsEdit = false;

      if (options.id) {
        if (options.id > 0) {
          vm.IsEdit = true;
        }
      }

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.DiscountNav');
      };

      vm.WAL = WAL;

      //F2 disable
      if (vm.formModel.DiscountGroupId !== null && vm.EditOrDuplicate !== 'Duplicate') {
        vm.pageModel.Fields['DiscountGroupId'].FormlyFieldDescriptor.templateOptions.disabled = true;
      }

      var customExpressionProperties = {
        Discount: {
          'templateOptions.disabled': function() {
            return !(
              vm.formModel.DiscountPercent === null ||
              vm.formModel.DiscountPercent === '' ||
              vm.formModel.DiscountPercent === 0 ||
              vm.formModel.DiscountPercent === '0'
            );
          },
        },
        DiscountPercent: {
          'templateOptions.disabled': function() {
            return !(
              vm.formModel.Discount === null ||
              vm.formModel.Discount === '' ||
              vm.formModel.Discount === 0 ||
              vm.formModel.Discount === '0'
            );
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsExistsReference === true;
          },
        },
        DiscountGroupId: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsExistsReference === true;
          },
        },
        Currency: {
          'templateOptions.required': function() {
            return vm.formModel.Discount > 0;
          },
        },
        RepeatId: {
          'templateOptions.required': function() {
            return vm.formModel.Discount > 0;
          },
        },
        RanKing: {
          'templateOptions.required': function() {
            return vm.formModel.IsPriorityHandle !== false;
          },
          'templateOptions.disabled': function() {
            return vm.formModel.IsPriorityHandle == false;
          },
        },
        //adatbázis szinten kötelező
        //"RepeatId": {
        //    "templateOptions.required": function () {
        //        return vm.formModel.Discount == null || vm.formModel.Discount == "" || vm.formModel.Discount == 0 ? false : true
        //    }
        //}
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      var onChangeFunctions = {
        DiscountGroupId: function(selectedItem) {
          if ((!!selectedItem && !!selectedItem._events) || !selectedItem) {
            var discountGroupId = 0;
            if (selectedItem && selectedItem.DiscountGroupId > 0) {
              discountGroupId = selectedItem.DiscountGroupId;
            }
            if (vm.discountGroupId == discountGroupId) {
              vm.formModel.RanKing = vm.ranKing;
            } else {
              $http
                .post('Contract/GetDiscountRanking', {
                  id: discountGroupId,
                })
                .then(function successCallback(response) {
                  vm.formModel.RanKing = response.data.Value;
                })
                .catch(function errorCallback(response) {
                  vm.formModel.RanKing = 0;
                });
            }
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var hideExpressions = {
        RanKing: function($viewValue, $modelValue, scope) {
          return vm.formModel.IsPriorityHandle == false;
        },
      };
      InsertHideExpressions(vm.pageModel, hideExpressions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      function save() {
        vm.formModel.OverrideRanking = false;
        if (vm.formModel.IsPriorityHandle === true) {
          $http({
            method: 'POST',
            url: 'Contract/GetRankingIsExists',
            params: {
              discountId: vm.formModel.DiscountId,
              groupId: vm.formModel.DiscountGroupId,
              ranking: vm.formModel.RanKing,
            },
          }).then(function successCallback(response) {
            if (response.data.Value === true) {
              bootbox.dialog({
                message:
                  'Ezzel a prioritással már létezik kedvezmény a csoporton belül.<br/><br/>Kívánja mégis ezt beszúrni és a prioritásban utána következőeket újraszámozni?',
                title: vm.messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      vm.formModel.OverrideRanking = true;
                      saveCore();
                    },
                  },
                },
              });
            } else {
              saveCore();
            }
          });
        } else {
          saveCore();
        }
      }

      function saveCore() {
        if (vm.EditOrDuplicate !== 'Edit') {
          $http.post('Contract/DiscountEdit', vm.formModel).then(
            function(response) {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              vm.formly.$setPristine();
              $state.go('Contract.DiscountEdit', { id: response.data.DiscountId });
            },
            function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            }
          );
        } else {
          $http.post('Contract/Discount' + vm.EditOrDuplicate, vm.formModel).then(
            function(response) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              vm.formly.$setPristine();
              $state.go('Contract.DiscountNav');
            },
            function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            }
          );
        }
      }
      //////////////////////////////////////////////////////////////
      /////// DiscountLinkage ///////////////////////////
      ///////////////////////////////////////

      vm.createLinkage = createLinkage;
      vm.editLinkage = editLinkage;
      vm.duplicateLinkage = duplicateLinkage;
      vm.deleteLinkage = deleteLinkage;

      vm.getSelectedDiscountId = function() {
        return {
          discountId: discountId,
        };
      };

      vm.gridIdField = vm.pageModel.Grids['GridDiscountLinkage'].IdColumn;
      vm.grid = vm.pageModel.Grids['GridDiscountLinkage'];

      vm.gridOptions = getGridOptions(
        options.pageModel.Grids.GridDiscountLinkage,
        'Contract/DiscountLinkageList/',
        function() {
          changeGridFilter(vm, $scope, vm.grid, vm.gridIdField);
        },
        vm.getSelectedDiscountId
      );

      ///////////////////////////////
      // Resolve Edit Or Duplicate
      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });

      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });
      //////////////////////////////

      function createLinkage() {
        var id = 0;
        var url = 'Contract/DiscountLinkageCreate/?id=' + id + '&discountId=' + discountId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/DiscountLinkageEdit.html',
          controller: 'DiscountLinkageEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            editOrDuplicate: editPromise,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      function editLinkage() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Contract/DiscountLinkageEdit/?id=' + id + '&discountId=' + discountId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/DiscountLinkageEdit.html',
            controller: 'DiscountLinkageEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              editOrDuplicate: editPromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function duplicateLinkage() {
        vm.editOrDuplicate = 'Duplicate';
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Contract/DiscountLinkageDuplicate/?id=' + id + '&discountId=' + discountId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/DiscountLinkageEdit.html',
            controller: 'DiscountLinkageEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              editOrDuplicate: duplicatePromise,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function deleteLinkage() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: 'Nem', //TODO label
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Igen', //TODO label
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/DiscountLinkageDelete/' + id).then(function() {
                    toastr.success('Korlátozás sikeresen törölve!');
                    vm.grid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      vm.attachDocument = attachDocument;
      vm.history = history;

      function attachDocument(grid) {
        if (!!grid) {
          var selectedItems = GetSelectedGridItems(vm.grid);
          var id = !!selectedItems[0] ? selectedItems[0][vm.gridIdField] : null;
          dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgDiscountLinkage', id);
        } else {
          var id = vm.formModel.DiscountId;
          dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgDiscount', id);
        }
      }

      function history(grid) {
        switch (grid) {
          case 'main': {
            HistoryService.NavigateToHistory('FlgDiscount', vm.formModel.FlgDiscountId, vm, $state);
          }
          case 'sub': {
            if (GetSelectedGridItems(vm.grid) != 0) {
              HistoryService.NavigateToHistory(
                'FlgDiscountLinkage',
                GetSelectedGridItems(vm.grid)[0].DiscountLinkageId,
                vm,
                $state
              );
            } else {
              toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            }
          }
        }
      }

      function WAL() {
        walService.NavigateToWal('Contract', 'ContractDiscountLinkageNavWal', 'FlgDiscountLinkageView');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountGroupNavCtrl', [
    '$uibModal',
    '$scope',
    'options',
    '$http',
    '$state',
    'HistoryService',
    'WalService',
    'DasService',
    'UIHelperService',
    function($uibModal, $scope, options, $http, $state, HistoryService, walService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountGroupNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createDiscountGroup = createDiscountGroup;
      vm.editDiscountGroup = editDiscountGroup;
      vm.duplicateDiscountGroup = duplicateDiscountGroup;
      vm.deleteDiscountGroup = deleteDiscountGroup;
      vm.priorityDiscountGroup = priorityDiscountGroup;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.disabled = true;
      vm.isPriorityHandle = options.isPriorityHandle === true;

      vm.back = function() {
        $state.go('Contract.DiscountNav');
      };
      console.log('vm.selectedMainGridItemId');
      console.log(vm.selectedMainGridItemId);

      vm.mainGridIdField = vm.pageModel.Grids['GridDiscountGroup'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridDiscountGroup,
        'Contract/DiscountGroupList/',
        function() {
          changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField);
        }
      );

      vm.getSelectedMainGridItemId = function() {
        return {
          targetDiscountGroupId: vm.selectedMainGridItemId,
        };
      };

      function createDiscountGroup() {
        var id = 0;
        var url = 'Contract/DiscountGroupCreate/?id=' + id;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/DiscountGroupEdit.html',
          controller: 'DiscountGroupEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editDiscountGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Contract/DiscountGroupEdit/?id=' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/DiscountGroupEdit.html',
            controller: 'DiscountGroupEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function duplicateDiscountGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Contract/DiscountGroupDuplicate/?id=' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/DiscountGroupEdit.html',
            controller: 'DiscountGroupEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteDiscountGroup() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/DiscountGroupDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function priorityDiscountGroup() {
        var url = 'Contract/DiscountGroupPriorityList/';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/DiscountGroupPriorityEdit.html',
          controller: 'DiscountGroupPriorityCtrl',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      //function changeMainGridFilter(targetGrid) {
      //    var selectedItems = GetSelectedGridItems(targetGrid);
      //    if (selectedItems.length === 0) {
      //        //ha nincs kijelölt elem, akkor töröljük az Id-t
      //        vm.selectedMainGridItemId = 0;
      //        $scope.$apply();
      //        return;
      //    }
      //    vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
      //    // $scope frissítése;
      //    $scope.$apply();
      //}
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgDiscountGroup', id);
      }

      function WAL() {
        walService.NavigateToWal('Contract', 'DiscountGroupNavWal', 'FlgDiscountGroup');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgDiscountGroup', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountGroupEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, fModel, $stateParams, authService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountGroupEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.formModel = fModel.dto;
      vm.modalTitle = 'Kedvezmény csoport';

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      var customExpressionProperties = {
        DiscountLimit: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.DiscountPercentLimit || !!vm.formModel.AdditionalDiscountPercentLimit;
          },
        },
        DiscountPercentLimit: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.DiscountLimit || !!vm.formModel.AdditionalPercentLimit;
          },
        },
        Currency: {
          'templateOptions.required': function() {
            return !(vm.formModel.DiscountLimit === null || vm.formModel.DiscountLimit === '');
          },
        },
        AdditionalDiscountLimit: {
          'templateOptions.disabled': function() {
            return (
              !vm.formModel.AdditionalDiscount ||
              !!vm.formModel.DiscountPercentLimit ||
              !!vm.formModel.AdditionalDiscountPercentLimit
            );
          },
        },
        AdditionalDiscountPercentLimit: {
          'templateOptions.disabled': function() {
            return (
              !vm.formModel.AdditionalDiscount || !!vm.formModel.DiscountLimit || !!vm.formModel.AdditionalDiscountLimit
            );
          },
        },
        AdditionalDiscount: {
          'templateOptions.disabled': function() {
            return (
              (vm.formModel.DiscountLimit === null || vm.formModel.DiscountLimit === 0) &&
              (vm.formModel.DiscountPercentLimit === null || vm.formModel.DiscountPercentLimit === 0)
            );
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var hideExpressions = {
        RanKing: function($viewValue, $modelValue, scope) {
          return vm.formModel.IsPriorityHandle == false;
        },
      };
      InsertHideExpressions(vm.pageModel, hideExpressions);

      var onChangeFunctions = {
        DiscountLimit: function() {
          vm.formModel.DiscountPercentLimit = null;
          if (vm.formModel.DiscountLimit === 0) {
            vm.formModel.DiscountLimit = null;
          }
        },
        DiscountPercentLimit: function() {
          vm.formModel.DiscountLimit = null;
          if (vm.formModel.DiscountPercentLimit === 0) {
            vm.formModel.DiscountPercentLimit = null;
          }
        },
        AdditionalDiscountLimit: function() {
          vm.formModel.AdditionalDiscountPercentLimit = null;
          if (vm.formModel.AdditionalDiscountLimit === 0) {
            vm.formModel.AdditionalDiscountLimit = null;
          }
        },
        AdditionalDiscountPercentLimit: function() {
          vm.formModel.AdditionalDiscountLimit = null;
          if (vm.formModel.AdditionalDiscountPercentLimit === 0) {
            vm.formModel.AdditionalDiscountPercentLimit = null;
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customCallbackFunctions = {
        AdditionalDiscount: function(selectedItem) {
          if (!selectedItem) {
            vm.formModel.AdditionalDiscountLimit = null;
            vm.formModel.AdditionalDiscountPercentLimit = null;
          }
        },
      };

      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      vm.save = save;

      function save() {
        var url = 'Contract/DiscountGroupEdit';
        if (vm.formModel.ModelState == 4) {
          url = 'Contract/DiscountGroupDuplicate';
        }

        $http
          .post(url, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages['SaveSuccessful']);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages['SaveFailed']);
          });
      }

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.UnitId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnit', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountLinkageEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'editOrDuplicate',
    '$stateParams',
    'AuthService',
    'LockService',
    function(mi, $http, fModel, editOrDuplicate, $stateParams, AuthService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountLinkageEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var customExpressionProperties = {
        TenType: {
          'templateOptions.required': function() {
            return vm.formModel.PartnerCatId === null || vm.formModel.PartnerCatId.Value === null;
          },
        },
        PartnerCatId: {
          'templateOptions.required': function() {
            return vm.formModel.TenType === null || vm.formModel.TenType === '' || vm.formModel.TenType === 0;
          },
        },
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsExistsReference;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.save = function() {
        $http.post('Contract/DiscountLinkage' + editOrDuplicate, vm.formModel).then(
          function() {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          },
          function() {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikertelen'); // TODO általános label
          }
        );
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.DiscountLinkageId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgDiscountLinkage', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountPriorityCtrl', [
    '$uibModalInstance',
    '$rootScope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    function(mi, $rootScope, options, $http, $state, $stateParams, authService, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountPriorityCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if (!vm.close) {
          event.preventDefault();
        }
      });
      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!vm.close && reason !== 'escape key press') {
          event.preventDefault();
        }
      });
      vm.close = false;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.options = options;
      vm.saveData = [];
      vm.optionsKey = [];
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoLB',
          templateOptions: {
            required: true,
            label: '',
            options: FormlyCreateLBOption({
              url: 'Contract/DiscountPriorityList/',
              transData: function() {
                return {
                  id: vm.formModel.DiscountId,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            reorder: function(e) {
              var items = e.items[0].parentNode.children;
              var temprows = [];
              for (var i = 0; i < items.length; i++) {
                if (items[i].id === '') {
                  continue;
                }
                if (e.dataItems[0].uid === items[i].id)
                  if (e.offset > 0) temprows[(i + e.offset) * 10 + 2] = items[i];
                  else temprows[(i + e.offset) * 10] = items[i];
                else temprows[i * 10 + 1] = items[i];
              }
              vm.saveData = [];
              if (vm.optionsKey.length < 1) {
                e.sender.dataSource._data.forEach(function(element) {
                  vm.optionsKey[element.uid] = element.key;
                });
              }
              var row = 1;
              temprows.forEach(function(element) {
                items[element.id].innerHTML = items[element.id].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, '');
                vm.saveData[row - 1] = {
                  extraProperties: null,
                  key: vm.optionsKey[items[element.id].id],
                  text: items[element.id].innerHTML,
                  ModelState: 0,
                };
                var number = (row + '.').padEnd(4);
                items[element.id].innerHTML = number + items[element.id].innerHTML;
                row++;
              });
              vm.options = vm.saveData;
            },
          },
        },
      ];

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.MDSelectorModel = {
        selectedData: '',
      };
      vm.save = function() {
        $http.post('Contract/DiscountPrioritySave', vm.options).then(
          function(response) {
            toastr.success('Kedvezmény prioritásának mentése sikeresen megtörtént!'); // TODO általános label
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            vm.close = true;
            mi.close();
          },
          function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          }
        );
      };
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.close = true;
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountGroupPriorityCtrl', [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    function($scope, $rootScope, mi, options, $http, $state, $stateParams, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountGroupPriorityCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if (!vm.close) {
          event.preventDefault();
        }
      });
      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!vm.close && reason !== 'escape key press') {
          event.preventDefault();
        }
      });
      vm.close = false;
      vm.options = options;
      vm.saveData = [];
      vm.optionsKey = [];
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoLB',
          templateOptions: {
            required: true,
            label: '',
            options: FormlyCreateLBOption({
              url: 'Contract/DiscountGroupPriorityList',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            reorder: function(e) {
              var items = e.items[0].parentNode.children;
              var temprows = [];
              for (var i = 0; i < items.length; i++) {
                if (items[i].id === '') {
                  continue;
                }
                if (e.dataItems[0].uid === items[i].id)
                  if (e.offset > 0) temprows[(i + e.offset) * 10 + 2] = items[i];
                  else temprows[(i + e.offset) * 10] = items[i];
                else temprows[i * 10 + 1] = items[i];
              }
              vm.saveData = [];
              if (vm.optionsKey.length < 1) {
                e.sender.dataSource._data.forEach(function(element) {
                  vm.optionsKey[element.uid] = element.key;
                });
              }
              var row = 1;
              temprows.forEach(function(element) {
                items[element.id].innerHTML = items[element.id].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, '');
                vm.saveData[row - 1] = {
                  extraProperties: null,
                  key: vm.optionsKey[items[element.id].id],
                  text: items[element.id].innerHTML,
                  ModelState: 0,
                };
                var number = (row + '.').padEnd(4);
                items[element.id].innerHTML = number + items[element.id].innerHTML;
                row++;
              });
              vm.options = vm.saveData;
              console.log(vm.options);
            },
          },
        },
      ];
      vm.grid = null;
      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }
      vm.save = function() {
        $http.post('Contract/DiscountGroupPrioritySave', vm.options).then(
          function(response) {
            toastr.success('Kedvezmény csoportok prioritásának mentése sikeresen megtörtént!'); // TODO általános label
            vm.close = true;
            mi.close();
          },
          function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          }
        );
      };
      // nincs rá szükség

      //vm.renumber = function (id) {
      //    var listbox = $("#" + id).data("kendoListBox");
      //    var items = listbox.items();
      //    console.log(listbox);
      //    console.log(items);
      //    for (var i = 0; i < items.length; i++) {
      //        var number = ((i + 1) + ".").padEnd(4);
      //        if (/^[0-9]{1,2}\. {1,2}/.test(items[i].innerHTML)) {
      //            items[i].innerHTML = items[i].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, number);
      //        } else {
      //            items[i].innerHTML = number + items[i].innerHTML;
      //        }
      //    }
      //}
      vm.cancel = function() {
        vm.close = true;
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'WalService',
    'DasService',
    'UIHelperService',
    'AuthService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      HistoryService,
      walService,
      dasService,
      UIHelperService,
      authService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createPriceList = createPriceList;
      vm.editPriceList = editPriceList;
      vm.duplicatePriceList = duplicatePriceList;
      vm.deletePriceList = deletePriceList;
      vm.refreshFeePriceList = refreshFeePriceList;
      vm.createPriceListRow = createPriceListRow;
      vm.editPriceListRow = editPriceListRow;
      vm.duplicatePriceListRow = duplicatePriceListRow;
      vm.deletePriceListRow = deletePriceListRow;
      vm.generatePriceListRow = generatePriceListRow;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.disabled = true;
      vm.subDisabled = true;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      vm.back = function() {
        $state.go('Contract.ContractNav');
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridPriceList'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridPriceList'];

      vm.subGridIdField = vm.pageModel.Grids['GridPriceListRow'].IdColumn;
      vm.subGrid = $('#subGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridPriceList, 'Contract/PriceListList/', function() {
        changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField, vm.subGrid);
        vm.selectAllTip = 'Összes';
        vm.checkedIds = [];
        vm.allCheck = false;
      });

      vm.getSelectedMainGridItemId = function() {
        return {
          PriceListId: vm.selectedMainGridItemId,
        };
      };

      // Kendo-grid reference for sub GRID
      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridPriceListRow,
        'Contract/PriceListRowList/',
        function() {
          changeSubGridDisable(vm, vm.subGrid, $scope);
        },
        vm.getSelectedMainGridItemId
      );

      authService.executeActionWithPermission(vm, 'refreshFeePriceList', 'Contract/PriceListRefreshFeeInfo');
      authService.executeActionWithPermission(vm, 'generatePriceListRow', 'Contract/PriceListRowGen');
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////
      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];

      var checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '24px',
        lockable: false,
      };
      vm.subGridOptions.columns.splice(0, 0, checkboxColumn);
      vm.subGridOptions.dataBound = function() {
        refreshCheckbox(this);
      };
      vm.subGridOptions.dataSource.schema.model.Id = vm.subGridIdField;

      vm.subGridOptions.dataBound = function(e) {
        var grid = this;
        //Checked selected row;
        var items = e.sender.items();
        var gridPage = e.sender;
        items.each(function(index) {
          var dataItem = gridPage.dataItem(this);
          dataItem.checked = vm.checkedIds.indexOf(dataItem.PriceListRowId) !== -1;
        });

        $scope.$applyAsync();
      };

      function manageSelectedIdArray(id, add) {
        if (add) vm.checkedIds.push(id);
        else
          vm.checkedIds = vm.checkedIds.filter(function(e) {
            return e !== id;
          });
      }

      function getAllIdFromFIC() {
        var filterString = '';
        if (vm.subGrid.dataSource.filter() !== undefined) {
          // GRID szűrés

          var filters = vm.subGrid.dataSource.filter().filters;
          if (!!filters[0].field) {
            for (var i = 0; i < filters.length; i++) {
              filterString += filters[i].field;
              filterString += '~';
              filterString += filters[i].operator;
              filterString += '~';
              filterString += "'" + filters[i].value + "'";
              if (i != filters.length - 1) {
                filterString += '~and~';
              }
            }
          }
        }

        $http
          .get('Contract/PriceListRowIdsList/', {
            params: { priceListId: vm.selectedMainGridItemId, filter: filterString },
          })
          .then(function(response) {
            vm.checkedIds = response.data;
            refreshCheckbox(vm.subGrid);
          });
      }

      function toggleSelect(event) {
        var checked = event.target.checked;
        if (vm.subGrid.dataSource.total() > 0) {
          vm.checkedIds = [];
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.subGrid);
          } else {
            vm.selectAllTip = 'Egy sem';
            getAllIdFromFIC();
          }
        }
      }

      function selectRow(event, item) {
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        manageSelectedIdArray(dataItem.PriceListRowId, checked);
      }

      function refreshCheckbox(grid) {
        var view = vm.subGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = vm.checkedIds.includes(value.PriceListRowId);
        });
      }

      function getSelectedIDs() {
        var row = vm.selectedItems;
        if (!row || row.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var ids = [];
        angular.forEach(vm.selectedItems, function(value, key) {
          ids.push(value[vm.subGridIdField]);
        });
        return ids;
      }

      vm.getS = function() {
        vm.x = getSelectedIDs();
      };
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      function createPriceList() {
        $state.go('Contract.PriceListCreate', { id: 0 });
      }

      function editPriceList() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.PriceListEdit', { id: id });
        }
      }

      function duplicatePriceList() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.PriceListDuplicate', { id: id });
        }
      }

      function deletePriceList() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/PriceListDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function refreshFeePriceList() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', vm.messages.Warning);
        } else {
          var item = selectedItems[0];
          if (item.ValidTo !== null) {
            toastr.warning(
              'Csak olyan árlistához tartozó díjakat lehet generálni, amelyeknél az érvényesség vége nincs megadva.',
              'Új díjsorok generálásának várható eredménye'
            );
          } else {
            $http
              .post('Contract/PriceListRefreshFeeInfo')
              .then(function() {
                var modalInstance = $uibModal.open({
                  templateUrl: 'App/Contract/PriceListRefreshFeeModal.html',
                  controller: 'PriceListRefreshFeeModalCtrl as vm',
                  size: 'lg',
                  backdrop: 'static',
                  resolve: {
                    model: {
                      messages: vm.messages,
                      grid: vm.pageModel.Grids['ContrFeeForPriceListGrid'],
                      priceListId: selectedItems[0][vm.mainGridIdField],
                    },
                  },
                });
              })
              .catch(function() {
                return;
              });
          }
        }
      }

      function createPriceListRow() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki árlistát!', 'Figyelmeztetés!');
        } else {
          var PriceListId = vm.selectedMainGridItemId;
          $state.go('Contract.PriceListRowEdit', { id: 0, PriceListId: PriceListId });
        }
      }

      function editPriceListRow() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var PriceListId = vm.selectedMainGridItemId;
          $state.go('Contract.PriceListRowEdit', { id: id, PriceListId: PriceListId });
        }
      }

      function duplicatePriceListRow() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var PriceListId = vm.selectedMainGridItemId;
          $state.go('Contract.PriceListRowDuplicate', { id: id, PriceListId: PriceListId });
        }
      }
      function deletePriceListRow() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (vm.checkedIds.length > 0 || selectedItems.length !== 0) {
          var param,
            url = '',
            succesMessage = '',
            deleteMessage = '';
          if (vm.checkedIds.length > 0) {
            param = { ids: vm.checkedIds };
            url = 'Contract/PriceListRowsDelete/';
            succesMessage = 'Egységárak sikeresen törölve!';
            deleteMessage = 'Biztosan törölni akarja a kiválasztott elemeket?';
          } else {
            param = { id: selectedItems[0][vm.subGridIdField] };
            url = 'Contract/PriceListRowDelete/';
            succesMessage = 'Egységár sikeresen törölve!';
            deleteMessage = vm.messages.DeleteDialogConfirmMessage;
          }
          bootbox.dialog({
            message: deleteMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(url, { params: param }).then(function() {
                    toastr.success(succesMessage);
                    vm.subGrid.dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function generatePriceListRow() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else if (selectedItems[0]['ValidTo']) {
          toastr.warning(
            "Csak olyan árlistához generálható egységár, amelynél az 'Érvényeség vége' oszlop üres!",
            'Figyelmeztetés!'
          );
        } else {
          var id = selectedItems[0].PriceListId;
          var url = 'Contract/PriceListRowGen/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/PriceListRowGen.html',
            controller: 'PriceListRowGenCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });
          modalInstance.result.then(function() {
            vm.subGrid.dataSource.read();
          });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgPriceList', id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal('Contract', 'PriceListNavWal', 'FlgPriceList');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            walService.NavigateToWal('Contract', 'PriceListRowNavWal', 'FlgPriceListRowView');
            break;
          }

          default: {
            break;
          }
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgPriceList', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('PriceListEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    '$uibModal',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, $uibModal, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.origValidTo = vm.formModel.ValidTo;

      vm.securedProgramId = options.programId;
      vm.securedId = vm.formModel.PriceListId;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //TODO: resource-ból automatikosan (?)
      if (vm.EditOrDuplicate === 'Duplicate') {
        vm.title = 'Árlista másolása';
      }
      if (!vm.formModel.PriceListId) {
        vm.title = 'Árlista hozzáadása';
      }
      if (vm.formModel.PriceListId > 0 && vm.EditOrDuplicate === 'Edit') {
        vm.title = 'Árlista módosítása';
      }

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.PriceListNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PriceListId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgPriceList', id);
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.pageModel.Fields.PreviousPriceListId.FormlyFieldDescriptor.templateOptions.options.whereCondition = previousPriceListIdWhereCondition;

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsExistsReference;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        // PreviousPriceListId: {
        // /**
        // * @return {boolean}
        // */
        // PreviousPriceListCopyValidator: function(modelValue, viewValue) {
        // if (vm.EditOrDuplicate === 'Duplicate' && !!modelValue && modelValue.Value > 0) {
        // return modelValue.Value === vm.formModel.PriceListId;
        // }

        // return true;
        // },
        // },
      };

      var onChangeFunctions = {
        PreviousPriceListId: function(selectedItem) {
          vm.formModel.PreviousPriceListValidTo =
            !!selectedItem && !!selectedItem.GridItem ? selectedItem.GridItem.ValidTo : null;
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);

      function save() {
        let targetPriceListId;
        let targetValidTo;
        let msgPrefix;

        //Ha másolás vagy létrehozás és az előző árlista ki van töltve (és annak nincs vége dátuma), akkor az előző árlistát és a kapcsolódó díjsorokat le kell zárni
        if (
          (vm.EditOrDuplicate === 'Duplicate' || !vm.formModel.PriceListId) &&
          !vm.formModel.PreviousPriceListValidTo
        ) {
          targetPriceListId = vm.formModel.PreviousPriceListId.Value;
          targetValidTo = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase())
            .add(-1, 'd')
            .toDate();
          msgPrefix =
            'Az új árlisa létrehozásával egy időben a <b>' +
            vm.formModel.PreviousPriceListId.Text +
            '</b> árlista is lezárásra kerül!</br>';
        } else if (!!vm.formModel.ValidTo) {
          // Ha módosítás, és kitölti a vége dátumot, akkor a díjsorokat le kell zárni
          targetPriceListId = vm.formModel.PriceListId;
          targetValidTo = vm.formModel.ValidTo;
          msgPrefix = '';
        }

        if (!!targetPriceListId && !vm.origValidTo) {
          $http
            .post('Contract/GetCloseContrFee', {
              priceListId: targetPriceListId,
              validTo: targetValidTo,
            })
            .then(
              function(response) {
                if (response.data.Value > 0) {
                  bootbox.dialog({
                    message:
                      msgPrefix +
                      'Ebben az esetben <b>' +
                      response.data.Value +
                      ' db díjsor is lezárásra kerül </b> a zárás dátumával.<br/><br/>Biztos folytatni kívánja a műveletet?',
                    title: 'Mentés',
                    buttons: {
                      add: {
                        label: 'Igen',
                        className: 'btn-primary',
                        callback: function() {
                          postData();
                        },
                      },
                      cancel: {
                        label: 'Nem',
                        className: 'btn-default',
                        callback: function() {},
                      },
                    },
                  });
                } else {
                  postData();
                }
              },
              function(response) {
                toastr.error(vm.pageModel.Messages.SaveFailed);
              }
            );
        } else {
          postData();
        }
      }

      function postData() {
        $http.post('Contract/PriceList' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            if (!!response.data.contrFeeIds && response.data.contrFeeIds.length > 0) {
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Contract/PriceListUpdateResult.html',
                controller: 'PriceListUpdateResultCtrl',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                  model: {
                    grid: vm.pageModel.Grids['ContrFeeResultGrid'],
                    contrFeeIds: response.data.contrFeeIds,
                  },
                },
              });
              modalInstance.result.then(function() {
                saveSuccessful();
              });
            } else {
              saveSuccessful();
            }
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function saveSuccessful() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        toastr.success(vm.pageModel.Messages.SaveSuccessful);
        vm.formly.$setPristine();
        $state.go('Contract.PriceListNav');
      }

      function previousPriceListIdWhereCondition() {
        var dateString = moment(new Date(vm.formModel.ValidFrom)).format('YYYY-MM-DDT');
        var wcText = (wcText =
          vm.EditOrDuplicate != 'Duplicate'
            ? "ValidTo~lt~datetime'" + dateString + "'"
            : 'PriceListId~eq~' + vm.formModel.PriceListId);
        return wcText;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListRefreshFeeModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, $uibModal, $uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListRefreshFeeModalCtrl', stateParams);
      }
      var vm = this;

      vm.messages = model.messages;
      vm.generate = generate;
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.mainGrid = angular.copy(model.grid);
      vm.ContrFeeForPriceListGridLength = 0;

      vm.getFilter = function() {
        return "PriceListId~eq~'" + model.priceListId + "'";
      };

      initGrid(
        vm,
        'ContrFeeForPriceListGrid',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      vm.ContrFeeForPriceListGridOptions.autoBind = true;

      var calcUnitPriceColumn = {
        field: 'CalcUnitPrice',
        hidden: false,
        filterable: true,
        title: 'Új kalkulált egységár',
        attributes: {
          style: 'text-align: right;',
        },
      };
      vm.ContrFeeForPriceListGridOptions.columns.push(calcUnitPriceColumn);

      vm.ContrFeeForPriceListGridOptions.dataBound = function() {
        vm.ContrFeeForPriceListGridLength = this.dataSource.data().length ? this.dataSource.data().length : 0;
        angular.forEach(this.dataSource.data(), function(row) {
          $http
            .post('Contract/GetUnitPriceForPriceList', {
              contractId: row.ContractId,
              serviceId: row.ServiceId,
              priceListId: row.PriceListId,
            })
            .then(function(response) {
              if (response.data) {
                row.CorrectPriceListRow = response.data.CorrectPriceListRow;
                row.CalcUnitPrice = response.data.CalculatedUnitPrice
                  ? response.data.CalculatedUnitPrice.toFixed(2)
                  : '';

                if (
                  row.IsThereNewFee != 1 &&
                  row.ThisContrFeeIdIsInvoiced != 1 &&
                  row.CorrectPriceListRow &&
                  row.CalcUnitPrice
                ) {
                  row.ExpectedResult = 'Sikeres!';
                } else if (row.IsThereNewFee == 1) {
                  row.ExpectedResult =
                    'Sikertelen! Az új díjsor számlázhatósági időszakában a szerződés rendelkezik már azonos díjsorral!';
                } else if (!row.CorrectPriceListRow || !row.CalcUnitPrice) {
                  row.ExpectedResult = 'Sikertelen! Nincs érvényes egységár az új árlistában!';
                } else if (row.ThisContrFeeIdIsInvoiced == 1) {
                  row.ExpectedResult =
                    'Sikertelen! Az új díjsor számlázhatósági időszakában található Nyitott státuszú számla!';
                }
              }
            });
        });
      };

      var expectedResultColumn = {
        field: 'ExpectedResult',
        hidden: false,
        filterable: true,
        title: 'Várható eredmény',
      };
      vm.ContrFeeForPriceListGridOptions.columns.splice(2, 0, expectedResultColumn);

      function generate() {
        var contrFeeIdList = [];
        angular.forEach(
          $('#ContrFeeForPriceListGrid')
            .data('kendoGrid')
            .dataSource.data(),
          function(row) {
            if (row.ExpectedResult === 'Sikeres!') {
              contrFeeIdList.push(row.ContrFeeId);
            }
          }
        );

        $http
          .post('Contract/PriceListRefreshFee', {
            priceListId: model.priceListId,
            contrFeeIdListJSON: JSON.stringify(contrFeeIdList),
          })
          .then(function(response) {
            $uibModalInstance.close();
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Contract/PriceListRefreshFeeResultModal.html',
              controller: 'PriceListRefreshFeeResultModalCtrl as vm',
              size: 'lg',
              backdrop: 'static',
              resolve: {
                model: {
                  messages: vm.messages,
                  grid: model.grid,
                  priceListId: model.priceListId,
                  generatedContrFeeList: response.data.GeneratedContrFeeList,
                  contrFeeForPriceListGridData: $('#ContrFeeForPriceListGrid')
                    .data('kendoGrid')
                    .dataSource.data(),
                  contrFeeForPriceListGridLength: vm.ContrFeeForPriceListGridLength,
                },
              },
            });
          });
      }

      function cancel() {
        $uibModalInstance.close();
      }

      function exportExcel() {
        $http
          .post('Contract/PriceListExcelExport')
          .then(function() {
            var grid = $('#ContrFeeForPriceListGrid').getKendoGrid();

            var rows = [
              {
                cells: [
                  { value: 'Szerződésszám' },
                  { value: 'Díjtétel kód és megnevezés' },
                  { value: 'Várható eredmény' },
                  { value: 'Korábbi egységár' },
                  { value: 'Új kalkulált egységár' },
                ],
              },
            ];

            angular.forEach(grid.dataSource.data(), function(value) {
              rows.push({
                cells: [
                  { value: value.Contract },
                  { value: value.ServiceCodeName },
                  { value: value.ExpectedResult },
                  { value: value.PreviousUnitPrice },
                  { value: value.CalcUnitPrice },
                ],
              });
            });

            var workbook = new kendo.ooxml.Workbook({
              sheets: [
                {
                  columns: [
                    { autoWidth: true },
                    { autoWidth: true },
                    { autoWidth: true },
                    { autoWidth: true },
                    { autoWidth: true },
                  ],
                  title: 'Sheet1',
                  rows: rows,
                },
              ],
            });

            workbook.toDataURLAsync().then(function(dataURL) {
              kendo.saveAs({
                dataURI: dataURL,
                fileName: 'Report.xlsx',
              });
            });
          })
          .catch(function() {
            return;
          });
      }

      function initGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars === null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.mainGrid.IdColumn;

        if (vm.mainGrid.Table) {
          readUrl = vm.mainGrid.ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.mainGrid.Table,
            whereCondition: whereCondition,
            adopter: vm.mainGrid.Adopter,
            installAdopter: vm.mainGrid.InstallAdopter,
            columnCsv: _.map(vm.mainGrid.Columns, 'field').join(),
            idColumn: vm.mainGrid.IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#' + mainGrid).data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(vm.mainGrid, readUrl, selectFunction, transportData, detailInit);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListRefreshFeeResultModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListRefreshFeeResultModalCtrl', stateParams);
      }
      var vm = this;

      vm.messages = model.messages;
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.mainGrid = angular.copy(model.grid);
      vm.generatedContrFeeList = model.generatedContrFeeList;
      vm.contrFeeForPriceListGridData = model.contrFeeForPriceListGridData;
      vm.ContrFeeForPriceListGridLength = model.contrFeeForPriceListGridLength;
      vm.ContrFeeForPriceListSuccessGridLength = 0;

      vm.getFilter = function() {
        return "PriceListId~eq~'" + model.priceListId + "'";
      };

      initGrid(
        vm,
        'ContrFeeForPriceListGrid',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      vm.ContrFeeForPriceListGridOptions.autoBind = true;

      var calcUnitPriceColumn = {
        field: 'NewRealNetAmount',
        hidden: false,
        filterable: true,
        title: 'Új fizetendő nettó összeg',
        attributes: {
          style: 'text-align: right;',
        },
      };
      vm.ContrFeeForPriceListGridOptions.columns.push(calcUnitPriceColumn);

      angular.forEach(vm.ContrFeeForPriceListGridOptions.columns, function(column) {
        if (column.field === 'PreviousRealNetAmount') {
          column.hidden = false;
          column.title = 'Korábbi fizetendő nettó összeg';
        } else if (column.field === 'PreviousUnitPrice') {
          column.hidden = true;
        }
      });

      vm.ContrFeeForPriceListGridOptions.dataBound = function() {
        var data = this.dataSource.data();
        var counter = 0;
        vm.ContrFeeForPriceListSuccessGridLength = 0;

        setTimeout(function() {
          $scope.$apply(function() {
            angular.forEach(data, function(row) {
              if (vm.generatedContrFeeList && vm.generatedContrFeeList[row.ContrFeeId]) {
                var generatedContrFee = vm.generatedContrFeeList[row.ContrFeeId];
                row.NewRealNetAmount = generatedContrFee.NewRealNetAmount;
                row.Contract = generatedContrFee.Contract;
                row.ServiceCodeName = generatedContrFee.ServiceCodeName;
                if (!generatedContrFee.Message && generatedContrFee.NewRealNetAmount) {
                  row.Result = 'Sikeres!';
                } else {
                  row.Result = generatedContrFee.Message;
                }
                if (generatedContrFee.NewRealNetAmount) {
                  vm.ContrFeeForPriceListSuccessGridLength++;
                }
              } else {
                row.Result = vm.contrFeeForPriceListGridData[counter].ExpectedResult;
              }

              ++counter;
            });
          });
        });
      };

      var expectedResultColumn = {
        field: 'Result',
        hidden: false,
        filterable: true,
        title: 'Eredmény',
      };
      vm.ContrFeeForPriceListGridOptions.columns.splice(2, 0, expectedResultColumn);

      function cancel() {
        uibModalInstance.dismiss();
      }

      function exportExcel() {
        var grid = $('#ContrFeeForPriceListGrid').getKendoGrid();

        var rows = [
          {
            cells: [
              { value: 'Szerződésszám' },
              { value: 'Díjtétel kód és megnevezés' },
              { value: 'Eredmény' },
              { value: 'Korábbi fizetendő nettó összeg' },
              { value: 'Új fizetendő nettó összeg' },
            ],
          },
        ];

        angular.forEach(grid.dataSource.data(), function(value) {
          rows.push({
            cells: [
              { value: value.Contract },
              { value: value.ServiceCodeName },
              { value: value.Result },
              { value: value.PreviousRealNetAmount },
              { value: value.NewRealNetAmount },
            ],
          });
        });

        var workbook = new kendo.ooxml.Workbook({
          sheets: [
            {
              columns: [
                { autoWidth: true },
                { autoWidth: true },
                { autoWidth: true },
                { autoWidth: true },
                { autoWidth: true },
              ],
              title: 'Sheet1',
              rows: rows,
            },
          ],
        });
        workbook.toDataURLAsync().then(function(dataURL) {
          kendo.saveAs({
            dataURI: dataURL,
            fileName: 'Report.xlsx',
          });
        });
      }

      function initGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars === null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.mainGrid.IdColumn;

        if (vm.mainGrid.Table) {
          readUrl = vm.mainGrid.ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.mainGrid.Table,
            whereCondition: whereCondition,
            adopter: vm.mainGrid.Adopter,
            installAdopter: vm.mainGrid.InstallAdopter,
            columnCsv: _.map(vm.mainGrid.Columns, 'field').join(),
            idColumn: vm.mainGrid.IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#' + mainGrid).data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(vm.mainGrid, readUrl, selectFunction, transportData, detailInit);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListUpdateResultCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListUpdateResultCtrl', stateParams);
      }
      var vm = this;

      vm.messages = model.messages;
      vm.ok = ok;
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.contrFeeIds = model.contrFeeIds;
      vm.mainGrid = angular.copy(model.grid);

      vm.getFilter = function() {
        if (!vm.contrFeeIds || vm.contrFeeIds.length === 0) {
          return "ContrFeeId~eq~'-1'";
        } else if (vm.contrFeeIds.length === 1) {
          return "ContrFeeId~eq~'" + vm.contrFeeIds[0] + "'";
        } else {
          return "ContrFeeId~in~'" + vm.contrFeeIds.join(',') + "'";
        }
        return "ContrFeeId~eq~'-1'";
      };

      initGrid(
        vm,
        'ContrFeeResultGrid',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      vm.ContrFeeResultGridOptions.autoBind = true;

      function ok() {
        uibModalInstance.close();
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function exportExcel() {
        $('#ContrFeeResultGrid')
          .getKendoGrid()
          .saveAsExcel();
      }

      function initGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars === null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.mainGrid.IdColumn;

        if (vm.mainGrid.Table) {
          readUrl = vm.mainGrid.ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.mainGrid.Table,
            whereCondition: whereCondition,
            adopter: vm.mainGrid.Adopter,
            installAdopter: vm.mainGrid.InstallAdopter,
            columnCsv: _.map(vm.mainGrid.Columns, 'field').join(),
            idColumn: vm.mainGrid.IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#' + mainGrid).data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(vm.mainGrid, readUrl, selectFunction, transportData, detailInit);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };

      //Routesban kap értéket: PriceListNav
      var backTo = $state.params.BackTo;
      if (backTo === 'PriceListNav') {
        backMenu.event = function() {
          $state.go('Contract.PriceListNav');
        };
      } else {
        backMenu.event = function() {
          $state.go('Contract.ContractNav');
        };
      }

      var desc = {
        Contract_PriceListNav_PriceListNav: { icon: 'fa fa-tag' },
        Contract_PriceListNav_PriceTypeNav: { icon: 'fa fa-tags' },
        Contract_PriceListNav_PriceListReportNav: { icon: 'fa fa-area-chart' },
      };

      buildMenu($state, authService, 'Contract_PriceListNav', 'contract', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('PriceListRowEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListRowEditCtrl', stateParams);
      }
      var vm = this;

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.UIHelperService = UIHelperService;
      vm.save = save;

      vm.securedProgramId = options.programId;
      vm.securedId = vm.formModel.PriceListRowId;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.PriceListNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PriceListRowId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgPriceListRow', id);
      };

      var onChangeFunctions = {
        PriceTypeId: function(selectedItem) {
          if (!!selectedItem) {
            vm.formModel.ServiceId = selectedItem.ServiceId;
            vm.formModel.ServiceTypeName = selectedItem.ServiceTypeName;
            vm.formModel.OwnerName = selectedItem.OwnerName;
            vm.formModel.TenTypeName = selectedItem.TenTypeName;
            vm.formModel.AreaRentalName = selectedItem.AreaRentalName;
            vm.formModel.ComfortName = selectedItem.ComfortName;
            vm.formModel.ZoneName = selectedItem.ZoneName;
            vm.formModel.TenementName = selectedItem.TenementName;
            setServiceIdWhereCondition(selectedItem.ServiceType);
          } else {
            setServiceIdWhereCondition(null);
          }

          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        ServiceId: function(selectedItem) {
          if (!!selectedItem && selectedItem.key != '') {
            vm.formModel.UnitId = selectedItem.extraProperties[1].key;
          }
          setPriceTypeIdWhereCondition();
          vm.formModel.PriceTypeId = { Value: vm.formModel.PriceTypeId.Value, Text: null };
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      setPriceTypeIdWhereCondition();
      function setPriceTypeIdWhereCondition() {
        vm.pageModel.Fields.PriceTypeId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          priceListId: vm.formModel.PriceListId,
          serviceId: vm.formModel.ServiceId,
        };
      }
      function setServiceIdWhereCondition(serviceType) {
        vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          serviceType: serviceType,
        };
      }

      function save() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $http.post('Contract/PriceListRow' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Contract.PriceListNav');
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceListRowGenCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    function(mi, $http, fModel, $stateParams, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceListRowGenCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      var onChangeFunctions = {
        ServiceType: function(selectedItem) {
          if (vm.formModel.ServiceType !== null && typeof vm.formModel.ServiceType !== 'undefined') {
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              serviceType: vm.formModel.ServiceType,
            };
          }
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        ServiceId: function(selectedItem) {
          if (vm.formModel.ServiceId !== null && typeof vm.formModel.ServiceId !== 'undefined') {
            //add parameter
            vm.pageModel.Fields.ServiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              serviceId: vm.formModel.ServiceId,
            };
          }
          //reload
          if (!!selectedItem.extraProperties) {
            vm.pageModel.Fields.ServiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            vm.formModel.ServiceType = selectedItem.extraProperties[0].value;
            vm.formModel.UnitId = selectedItem.extraProperties[1].value;
            vm.formModel.TenType = selectedItem.extraProperties[2].value;
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        ServiceType: {
          'templateOptions.disabled': function() {
            return !(
              vm.formModel.ServiceId === 0 ||
              vm.formModel.ServiceId === null ||
              vm.formModel.ServiceType === '' ||
              vm.formModel.ServiceType === null
            );
          },
        },
        TenType: {
          'templateOptions.disabled': function() {
            return !(
              vm.formModel.ServiceId === 0 ||
              vm.formModel.ServiceId === null ||
              vm.formModel.TenType === '' ||
              vm.formModel.TenType === null
            );
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.save = function() {
        $http
          .post('Contract/PriceListRowGen', vm.formModel)
          .then(function(response) {
            if (!!response.statusText) {
              toastr.success(response.statusText);
            } else {
              toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            }
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PriceTypeNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'HistoryService',
    'WalService',
    'DasService',
    'UIHelperService',
    function($scope, options, $http, $state, HistoryService, walService, dasService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceTypeNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.create = createPriceType;
      vm.editPriceType = editPriceType;
      vm.duplicatePriceType = duplicatePriceType;
      vm.deletePriceType = deletePriceType;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.disabled = true;

      vm.back = function() {
        $state.go('Contract.PriceListNav');
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridPriceType'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridPriceType, 'Contract/PriceTypeList/', function() {
        changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField);
      });

      vm.getSelectedMainGridItemId = function() {
        return {
          targetPriceTypeId: vm.selectedMainGridItemId,
        };
      };

      function createPriceType() {
        $state.go('Contract.PriceTypeCreate', { id: 0 });
      }

      function editPriceType() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.PriceTypeEdit', { id: id });
        }
      }

      function duplicatePriceType() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Contract.PriceTypeDuplicate', { id: id });
        }
      }

      function deletePriceType() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          bootbox.dialog({
            message: vm.messages.DeleteDialogConfirmMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Contract/PriceTypeDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgPriceType', id);
      }

      function WAL() {
        walService.NavigateToWal('Contract', 'PriceTypeNavWal', 'FlgPriceTypeView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgPriceType', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('PriceTypeEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PriceTypeEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.save = save;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.PriceTypeNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.PriceTypeId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgPriceType', id);
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.setTenTypeFilter = function() {
        vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          Owner: vm.formModel.Owner,
          TenType: vm.formModel.TenType,
          AreaRentalId: vm.formModel.AreaRentalId,
        };
        vm.formModel.Tenement = { Text: null, Value: null };
      };
      var onChangeFunctions = {
        Owner: function(selectedItem) {
          vm.setTenTypeFilter();
        },
        TenType: function(selectedItem) {
          vm.setTenTypeFilter();
        },
        AreaRentalId: function(selectedItem) {
          vm.setTenTypeFilter();
        },
        ServiceType: function(selectedItem) {
          if (vm.formModel.ServiceType !== null && typeof vm.formModel.ServiceType !== 'undefined') {
            //add parameter
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              serviceType: vm.formModel.ServiceType,
            };
          }
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },

        ServiceId: function(selectedItem) {
          if (vm.formModel.ServiceId !== null && typeof vm.formModel.ServiceId !== 'undefined') {
            //add parameter
            vm.pageModel.Fields.ServiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              serviceId: vm.formModel.ServiceId,
            };

            //reload
            vm.pageModel.Fields.ServiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            vm.formModel.ServiceType = selectedItem.extraProperties[0].value;
            vm.formModel.UnitId = selectedItem.extraProperties[1].value;
            if (!!selectedItem.extraProperties[2].value) {
              vm.formModel.TenType = selectedItem.extraProperties[2].value;
              vm.pageModel.Fields.TenType.FormlyFieldDescriptor.templateOptions.disabled = true;
            } else {
              vm.pageModel.Fields.TenType.FormlyFieldDescriptor.templateOptions.disabled = false;
            }
          }
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsExistsReference;
          },
        },
        TenType: {
          'templateOptions.disabled': function() {
            return vm.formModel.IsDisabled;
            //vm.formModel.ServiceId === 0 ||
            //vm.formModel.ServiceId === null ||
            //vm.formModel.TenType === '' ||
            //vm.formModel.TenType === null ||
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          AidDecisionValidFromValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            if (isNaN(validToValue)) {
              return true;
            }

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          AidDecisionValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validToValue.isSameOrAfter(validFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      function save() {
        $http.post('Contract/PriceType' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Contract.PriceTypeNav');
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ServiceEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ServiceEditCtrl', stateParams);
      }
      var vm = this;
      vm.module = $stateParams.module;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.UIHelperService = UIHelperService;
      if (!vm.formModel.ServiceId) {
        vm.pageModel.Fields.ServiceCode.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
          'A mező tartalma automatikusan kitöltésre kerül az eddig kiosztott maximális sorszám + 1 értékkel.<br>Ez az érték módosítható bármely, még nem kiosztott sorszámra.<br>Amennyiben a kiosztható maximális érték (99) már kiosztásra került, <br>akkor nincsen automatikus  kitöltés, de rögzíthető bármely nem kiosztott szabad sorszám.';
      }
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go($stateParams.BackTo);
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ServiceId;
        dasService.NavigateToDas(vm.messages, 'Contract.ServiceDasDocumentsNav', 'FlgService', id);
      };

      var customExpressionProperties = {
        TenType: {
          'templateOptions.disabled': function() {
            return vm.formModel.HasFinancialData === true;
          },
        },
        ServiceType: {
          'templateOptions.disabled': function() {
            return vm.formModel.HasFinancialData === true;
          },
        },
        Collector: {
          'templateOptions.disabled': function() {
            return vm.formModel.HasFinancialData === true;
          },
        },
        ServiceCode: {
          'templateOptions.disabled': function() {
            return !!vm.formModel.ServiceId && vm.formModel.ServiceId !== 0;
          },
        },
        ServiceQuantity: {
          'templateOptions.disabled': function() {
            return vm.formModel.ServiceType === 'CSEAI';
          },
        },
        PauseFromMonth: {
          'templateOptions.required': function() {
            return (
              (vm.formModel.PauseFromDay !== null &&
                vm.formModel.PauseFromDay !== '' &&
                vm.formModel.PauseFromDay !== 0) ||
              (vm.formModel.PauseToMonth !== null &&
                vm.formModel.PauseToMonth !== '' &&
                vm.formModel.PauseToMonth !== 0) ||
              (vm.formModel.PauseToDay !== null && vm.formModel.PauseToDay !== '' && vm.formModel.PauseToDay !== 0)
            );
          },
        },
        PauseFromDay: {
          'templateOptions.required': function() {
            return (
              (vm.formModel.PauseFromMonth !== null &&
                vm.formModel.PauseFromMonth !== '' &&
                vm.formModel.PauseFromMonth !== 0) ||
              (vm.formModel.PauseToMonth !== null &&
                vm.formModel.PauseToMonth !== '' &&
                vm.formModel.PauseToMonth !== 0) ||
              (vm.formModel.PauseToDay !== null && vm.formModel.PauseToDay !== '' && vm.formModel.PauseToDay !== 0)
            );
          },
        },
        PauseToMonth: {
          'templateOptions.required': function() {
            return (
              (vm.formModel.PauseFromDay !== null &&
                vm.formModel.PauseFromDay !== '' &&
                vm.formModel.PauseFromDay !== 0) ||
              (vm.formModel.PauseFromMonth !== null &&
                vm.formModel.PauseFromMonth !== '' &&
                vm.formModel.PauseFromMonth !== 0) ||
              (vm.formModel.PauseToDay !== null && vm.formModel.PauseToDay !== '' && vm.formModel.PauseToDay !== 0)
            );
          },
        },
        PauseToDay: {
          'templateOptions.required': function() {
            return (
              (vm.formModel.PauseFromDay !== null &&
                vm.formModel.PauseFromDay !== '' &&
                vm.formModel.PauseFromDay !== 0) ||
              (vm.formModel.PauseToMonth !== null &&
                vm.formModel.PauseToMonth !== '' &&
                vm.formModel.PauseToMonth !== 0) ||
              (vm.formModel.PauseFromMonth !== null &&
                vm.formModel.PauseFromMonth !== '' &&
                vm.formModel.PauseFromMonth !== 0)
            );
          },
        },
      };

      var syncValidators = {
        RanKing: {
          /**
           * @return {boolean}
           */
          ServiceRanKingValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return modelValue >= 1;
          },
        },
        ServiceQuantity: {
          /**
           * @return {boolean}
           */
          ServiceServiceQuantityValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return validateServiceQuantity(modelValue);
          },
          /**
           * @return {boolean}
           */
          ServiceServiceQuantity2Validator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            return validateServiceQuantity2(modelValue);
          },
        },
      };

      var onChangeFunctions = {
        ServiceType: function(selectedItem) {
          if (selectedItem.key === 'CSEAI') {
            vm.formModel.ServiceQuantity = 'CSQFI';
          }
        },
        BudgetRanking: function() {
          $http
            .post('Contract/GetBudgetRankingStatus', {
              serviceGroupId: vm.formModel.ServiceGroupId,
              serviceId: vm.formModel.ServiceId,
              budgetRanking: vm.formModel.BudgetRanking,
            })
            .then(function(response) {
              if (!response.data.IsUnique) {
                toastr.error('Foglalt értékek: ' + response.data.ListOfUsedIdsAsString, 'Nem egyedi a megadott érték!');
              }
            });
        },
        RanKing: function() {
          $http
            .post('Contract/GetBudgetRankingStatus', {
              serviceGroupId: vm.formModel.ServiceGroupId,
              serviceId: vm.formModel.ServiceId,
              ranking: vm.formModel.RanKing,
            })
            .then(function(response) {
              if (!response.data.IsUnique) {
                toastr.error('Foglalt értékek: ' + response.data.ListOfUsedIdsAsString, 'Nem egyedi a megadott érték!');
              }
            });
        },
      };
      var customTypes = {
        ServiceCode: 'maskedInput',
      };
      vm.ServiceGroupCode = vm.formModel.ServiceCode.substring(0, 2);
      var inputMasks = {
        ServiceCode: vm.ServiceGroupCode.replaceAll(/(\d)/g, '\\$1') + '.99',
      };
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      function save() {
        if (vm.formModel.ServiceCode.length < 3) {
          vm.formModel.ServiceCode = vm.ServiceGroupCode + '.' + vm.formModel.ServiceCode;
        }
        $http.post(vm.module + '/' + vm.module + 'Service' + vm.EditOrDuplicate, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.formly.$setPristine();
            $state.go($stateParams.BackTo);
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function validateServiceQuantity(serviceQuantity) {
        if (
          serviceQuantity === 'CSQFM' &&
          vm.formModel.ServiceType !== 'CSEPU' &&
          vm.formModel.ServiceType !== 'CSEOT'
        ) {
          vm.formModel.ServiceQuantity = null;
          return false;
        }
        return true;
      }

      function validateServiceQuantity2(serviceQuantity) {
        if (serviceQuantity !== 'CSQFI' && vm.formModel.ServiceType === 'CSEAI') {
          vm.formModel.ServiceQuantity = 'CSQFI';
          return false;
        }
        return true;
      }

      console.log('ServiceGroupId:' + vm.formModel.ServiceGroupId);
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('AdvanceAccountEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'AdvanceAccountEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.pageModelDeductible = options.pageModelDeductible;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.deductibleFieldsIndex = 0;

      vm.pageModelDeductibleList = [];

      angular.forEach(vm.formModel.DeductibleServiceList, function(value, key) {
        vm.pageModelDeductibleList.push(angular.copy(options.pageModelDeductible));
      });

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ContrPaymentId;
        dasService.NavigateToDas(vm.messages, 'Contract.DasDocumentsNav', 'FlgAdvanceAccount', id);
      };
      vm.deductibleAssignCallBack = deductibleAssignCallBack;
      var syncValidators = {};

      var customExpressionProperties = {};

      var onChangeFunctions = {
        InvoiceId: function(selectedItem) {
          if (!!selectedItem.GridItem) {
            vm.formModel.Net = selectedItem.GridItem.Net;
            vm.formModel.BackNet = selectedItem.GridItem.Net;
            vm.formModel.Vat = selectedItem.GridItem.Vat;
            vm.formModel.BackVat = selectedItem.GridItem.Vat;
          }
        },
      };

      //vm.pageModelDeductible.Fields.Assign.FormlyFieldDescriptor.templateOptions.onClick = checkBoxClick;

      //var deductibleOnChangeFunctions = {
      //    "Assign": function (selectedItem) {
      //        if (!!selectedItem) {
      //            debugger;
      //            angular.forEach(vm.pageModelDeductible.Fields, function (value, key) {
      //                if (key === "Assign" && value === true) {
      //                    vm.pageModelDeductible.Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.required = true;
      //                }
      //            });
      //        }
      //    }
      //};

      var deductibleCallBackFunctions = {
        Assign: function(selectedItem) {
          vm.deductibleAssignCallBack();
        },
      };
      function deductibleAssignCallBack() {
        var index = 0;
        angular.forEach(vm.formModel.DeductibleServiceList, function(value, key) {
          vm.pageModelDeductibleList[
            index
          ].Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.required = value.Assign ? true : false;
          index++;
        });
      }
      //vm.deductibleAssignCallBack();

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      //InsertOnChangeFunctions(vm.pageModelDeductible, deductibleOnChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);

      //function checkBoxClick() {
      //    angular.forEach(vm.pageModelDeductible.Fields, function (value, key) {
      //        if (key === "Assign") {
      //            angular.forEach(vm.pageModelDeductible.Fields, function (value, key) {
      //                if (key === "RecognisedServiceId" && value.fieldGroup === vm.pageModelDeductible.Fields.Assign.fieldGroup) {
      //                    if (vm.pageModelDeductible.Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.required === true) {
      //                        vm.pageModelDeductible.Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.required = false;
      //                    } else {
      //                        vm.pageModelDeductible.Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.required = true;
      //                    }
      //                }
      //            });
      //        }
      //    });
      //}

      var whereConditionFunction = function() {
        return "(InvoiceType~eq~'INTCU')~and~(InvoiceStatus~eq~'INSCL'~or~InvoiceStatus~eq~'INSSO')";
      };
      vm.pageModel.Fields.InvoiceId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = whereConditionFunction;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.headerFields = vm.FormlyFormPanelDescriptors.PanelHeader.FormlyDescriptor;
      vm.deductibleFields = [];

      var index = 0;
      angular.forEach(vm.formModel.DeductibleServiceList, function(value, key) {
        var recognisedServiceIdwhereConditionFunction = function() {
          return "Active~eq~'true'~and~InvoiceItem~eq~'true'~and~FurtherBilling~neq~'true'";
        };
        vm.pageModelDeductibleList[
          index
        ].Fields.RecognisedServiceId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = recognisedServiceIdwhereConditionFunction;
        InsertCustomCallbackFunctions(vm.pageModelDeductibleList[index], deductibleCallBackFunctions);
        vm.FormlyFormDeductiblePanelDescriptors = GenerateFormlyFormPanelsFromPageModel(
          vm.pageModelDeductibleList[index]
        );
        vm.deductibleFields.push(
          vm.FormlyFormDeductiblePanelDescriptors.PanelDeductible.FormlyDescriptor[0].fieldGroup[0].fieldGroup
        );
        index++;
      });

      function save() {
        $http
          .post('Contract/AdvanceAccount' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Contract.ContractEdit', { id: vm.formModel.ContractId, openedPanelGroup: 'PGGridek' });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrInvoiceGenResultModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrInvoiceGenResultModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grid;
      vm.labels = fModel.labels;
      vm.messages = fModel.messages;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;

      vm.leadStr = !!fModel.data.Messages[0] ? fModel.data.Messages[0].Message : '';
      vm.errorStr = !!fModel.data.Messages[1] ? fModel.data.Messages[1].Message : '{}';
      vm.row = vm.errorStr !== '[{}]' ? JSON.parse(vm.errorStr) : JSON.parse('[]');
      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrFeeForCloseResultModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'gridService',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeForCloseResultModalCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = cancel;
      vm.closeSelectedFees = closeSelectedFees;

      // function onClickFn(contrFeeId, date) {
      // console.log(contrFeeId, date);
      // }
      vm.formModel = fModel.ContrFeeList;
      vm.gridModel = fModel.pageModel.Grids.ContrFeeForCloseResult;
      vm.resultGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: vm.gridModel,
        dataBound: function() {
          const grid = this;
          $(this.tbody)
            .find('.contrFeeForCloseChkBox')
            .off('change')
            .bind('change', function(e) {
              var row = $(e.target).closest('tr');
              var dataItem = grid.dataItem(row);
              dataItem.IsClose = $(e.target).prop('checked') === true;
              changeFieldValue(vm.formModel, dataItem['ContrFeeId'], dataItem.IsClose);
              grid.refresh();
            });
        },
      });
      vm.resultGridOptions.dataSource = new kendo.data.DataSource({
        data: new kendo.data.ObservableArray(vm.formModel),
        schema: { model: vm.resultGridOptions.dataSource.schema.model },
        page: vm.resultGridOptions.dataSource.page,
        pageSize: vm.resultGridOptions.dataSource.pageSize,
      });
      enableCheckboxOnColumn(vm.resultGridOptions, 'IsClose');
      //vm.resultGridOptions.pageable = false;

      vm.resultGrid = $('#resultGrid').data('kendoGrid');

      function enableCheckboxOnColumn(gridOptions, field, fn) {
        var column = vm.resultGridOptions.columns.find(function(prop) {
          return prop.field === field;
        });

        column.template =
          '<input type="checkbox" #=IsClose ? "checked=checked" : "" # class="contrFeeForCloseChkBox"></input>';
      }

      function changeFieldValue(model, rowId, value) {
        var row = model.find(function(prop) {
          return prop['ContrFeeId'] === rowId;
        });
        row.IsClose = value;
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function closeSelectedFees() {
        $http
          .post('Contract/CloseContrFee', { ContrFeeListForClose: vm.formModel })
          .then(function(response) {
            toastr.success('A kijelölt díjak zárása sikeresen megtörtént!');
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error('Hiba a kijelölt díjak zárása során!');
          });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('CheckBeforeContrInvoiceGenWarningModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'parameters',
    '$window',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters, $window) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CheckBeforeContrInvoiceGenWarningModalCtrl', stateParams);
      }
      var vm = this;
      vm.contracts = [];

      if (parameters.type == 'invoicedContracts') {
        vm.text1 =
          'A kiválasztott bérleti szerződések között szerepelnek olyanok, melyek a tárgyhóra vonatkozóan nyitott bérleti díj számlával rendelkeznek.';
        vm.text2 = 'A számlák kézi törlését követően indítható el csak a számlagenerálás.';
      } else if (parameters.type == 'diffPaymentPerPartner') {
        vm.text1 =
          'A kiválasztott bérleti szerződések között szerepelnek olyanok, melyek a tárgyhóra vonatkozóan eltérő fizetési megállapodás adatot tartalmaznak.';
        vm.text2 =
          'A fizetési megállapodás módosítását követően indítható el csak a számlagenerálás vagy pedig külön kell számlázni az eltérő fizetési megállapodást tartalmazó szerződéseket.';
      }

      const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
          const value = obj[key];
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
          return objectsByKeyValue;
        }, {});

      const groupByPartnerCode = groupBy('PartnerCode');

      vm.contracts = groupByPartnerCode(parameters.contracts);

      vm.openContract = function(contractId) {
        const url = $state.href('Contract.ContractEdit', { id: contractId });
        $window.open(url, '_blank');
      };

      vm.cancel = function() {
        $uibModalInstance.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrTitleChangeCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrTitleChangeCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid || !vm.formModel.Period || !vm.formModel.Period.Value;
      };

      //kendoMSInit("TenantPartCode");
      //kendoMSInit("ContractFrom");
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // additional F4 pre-filters
      vm.contractWhereCondition = '';
      vm.pageModel.Fields.ContractFrom.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return vm.contractWhereCondition;
      };
      //vm.pageModel.Fields.ContractFrom.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function () {
      //    return vm.contractWhereCondition;
      //};

      // Property F4 onChange
      vm.pageModel.Fields.TenantPartCode.FormlyFieldDescriptor.templateOptions.options.InputChanged = function(
        selectedScope
      ) {
        var whereCondition = '';
        if (selectedScope.f4Values) {
          for (var i = 0; i < selectedScope.f4Values.length; i++) {
            var tenantPartId = selectedScope.f4Values[i];
            whereCondition += 'TenantPartId~eq~' + tenantPartId;
            if (i < selectedScope.f4Values.length - 1) {
              whereCondition += '~or~';
            }
          }
        }

        vm.contractWhereCondition = whereCondition;
      };

      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.start = function() {
        $http
          .post('Contract/CheckBeforeContrTitleChange', vm.formModel)
          .then(function(response) {
            if (!response.data.contracts || response.data.contracts.length === 0) {
              toastr.warning('Nincs találat a megadott paraméterekkel!', 'Figyelmeztetés!');
              return;
            }
            // open modal
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Contract/ContrTitleChangeContractList.html',
              controller: 'ContrTitleChangeContractListCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: { data: response.data, grid: vm.pageModel.Grids.ContrTitleChangeResult },
              },
              backdrop: 'static',
            });

            modalInstance.result
              .then(function() {
                $http.post('Contract/ContrTitleChange', response.data.contracts).then(function(response) {
                  var modalInstanceResult = $uibModal.open({
                    templateUrl: 'App/Contract/ContrTitleChangeContractListResult.html',
                    controller: 'ContrTitleChangeContractListResultCtrl',
                    controllerAs: 'vm',
                    resolve: {
                      fModel: { data: response.data, grid: vm.pageModel.Grids.ContrTitleChangeResult },
                    },
                    backdrop: 'static',
                  });
                  mi.close();
                });
              })
              .catch(function() {});
          })
          .catch(function(response) {});
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrTitleChangeContractListCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrTitleChangeContractListCtrl', stateParams);
      }
      var vm = this;
      vm.gridModel = angular.copy(fModel.grid);
      vm.missingGridModel = angular.copy(fModel.grid);
      vm.row = fModel.data.contracts;
      vm.rowMissing = fModel.data.contractsMissing;
      vm.cancel = cancel;
      vm.close = close;
      vm.exportExcel = function() {
        exportExcel(
          [vm.resultGrid, vm.missingGrid],
          ['Módosuló szerződések', 'Tartományon kívüli szerződések'],
          'Tömeges jogcímállításban (és használati díj emelésben) érintett szerződések.xlsx'
        );
      };

      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({
        data: vm.row,
        schema: {
          model: {
            fields: {
              Contract: { type: 'string' },
              EmsContractDate: { type: 'date' },
            },
          },
        },
        pageSize: 20,
        page: 1,
      });
      vm.resultGridOptions = angular.copy(resultGridOptions);
      vm.resultGrid = $('#resultGrid').data('kendoGrid');

      var missingGridOptions = getGridOptions(vm.missingGridModel, '', function() {}, vm.dump);
      missingGridOptions.dataSource = new kendo.data.DataSource({
        data: vm.rowMissing,
        schema: {
          model: {
            fields: {
              Contract: { type: 'string' },
              EmsContractDate: { type: 'date' },
            },
          },
        },
        pageSize: 20,
        page: 1,
      });
      vm.missingGridOptions = angular.copy(missingGridOptions);
      vm.missingGrid = $('#missingGrid').data('kendoGrid');

      function cancel() {
        uibModalInstance.dismiss();
      }

      function close() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrTitleChangeContractListResultCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrTitleChangeContractListResultCtrl', stateParams);
      }
      var vm = this;
      vm.close = close;
      vm.errorGridModel = angular.copy(fModel.grid);
      vm.errorRow = fModel.data.ErrorList;
      vm.successRow = fModel.data.SuccessList;
      vm.exportExcel = function() {
        exportExcel([vm.errorGrid], ['Hibajegyzék'], 'Tömeges jogcímállítás (és használati díj emelés) hibái.xlsx');
      };

      var errorGridOptions = getGridOptions(vm.errorGridModel, '', function() {}, vm.dump);
      errorGridOptions.dataSource = new kendo.data.DataSource({
        data: vm.errorRow,
        schema: {
          model: {
            fields: {
              Contract: { type: 'string' },
              EmsContractDate: { type: 'date' },
            },
          },
        },
        pageSize: 20,
        page: 1,
      });
      vm.errorGridOptions = angular.copy(errorGridOptions);
      vm.errorGrid = $('#errorGrid').data('kendoGrid');

      function close() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrInvoiceGenCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrInvoiceGenCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      //kendoMSInit("TenantPartCode");
      //kendoMSInit("ContractFrom");
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // additional F4 pre-filters
      vm.contractWhereCondition = '';
      vm.pageModel.Fields.ContractFrom.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return vm.contractWhereCondition;
      };
      //vm.pageModel.Fields.ContractFrom.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function () {
      //    return vm.contractWhereCondition;
      //};

      // Property F4 onChange
      vm.pageModel.Fields.TenantPartCode.FormlyFieldDescriptor.templateOptions.options.InputChanged = function(
        selectedScope
      ) {
        var whereCondition = '';
        if (selectedScope.f4Values) {
          for (var i = 0; i < selectedScope.f4Values.length; i++) {
            var tenantPartId = selectedScope.f4Values[i];
            whereCondition += 'TenantPartId~eq~' + tenantPartId;
            if (i < selectedScope.f4Values.length - 1) {
              whereCondition += '~or~';
            }
          }
        }

        vm.contractWhereCondition = whereCondition;
      };

      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.preSave = function() {
        if (!vm.formModel.DueDate) {
          bootbox.dialog({
            message: 'A fizetési határidő nem került kitöltésre. Szeretné pótolni?',
            title: vm.pageModel.Messages.Warning,
            closeButton: false,
            buttons: {
              cancel: {
                label: 'Igen',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Nem',
                className: 'btn-primary',
                callback: function() {
                  vm.save();
                },
              },
            },
          });
        } else {
          vm.save();
        }
      };

      vm.save = function() {
        $http
          .post('Contract/ContrInvoiceGen', vm.formModel)
          .then(function(response) {
            if (!!response.data.invoicedContracts) {
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Contract/CheckBeforeContrInvoiceGenWarningModal.html',
                controller: 'CheckBeforeContrInvoiceGenWarningModalCtrl',
                controllerAs: 'vm',
                resolve: {
                  parameters: {
                    contracts: response.data.invoicedContracts,
                    type: 'invoicedContracts',
                  },
                },
                backdrop: 'static',
              });

              modalInstance.result.then(function() {});
            } else if (!!response.data.diffPaymentPerPartner) {
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Contract/CheckBeforeContrInvoiceGenWarningModal.html',
                controller: 'CheckBeforeContrInvoiceGenWarningModalCtrl',
                controllerAs: 'vm',
                resolve: {
                  parameters: {
                    contracts: response.data.diffPaymentPerPartner,
                    type: 'diffPaymentPerPartner',
                  },
                },
                backdrop: 'static',
              });

              modalInstance.result.then(function() {});
            } else {
              // open modal
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Contract/ContrInvoiceGenResultModal.html',
                controller: 'ContrInvoiceGenResultModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  fModel: {
                    data: response.data,
                    grid: vm.pageModel.Grids.GridContrInvoiceGenResult,
                    labels: vm.pageModel.Labels,
                    messages: vm.pageModel.Messages,
                  },
                },
                backdrop: 'static',
              });
              modalInstance.result.then(function() {});
              mi.close();
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo == 'Nav') {
        backMenu.event = function() {
          $state.go('Contract.ContractNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Contract_ContractNav: { icon: 'fa fa-file-text' },
        Contract_InvoiceNav: { icon: 'fa fa-file-text' },
        Contract_ServiceNav: { icon: 'fa fa-file-text-o' },
        Contract_PriceListNav: { icon: 'fa fa-list' },
        Contract_DiscountNav: { icon: 'fa fa-tag' },
        Contract_ContrInvoiceNav: { icon: 'fa fa-tag' },
        Masterdata_Contract: { icon: 'fa fa-home' },
        Contract_ReportNav: { icon: 'fa fa-area-chart' },
      };

      buildMenu($state, authService, 'Contract', 'contract', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DiscountMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DiscountMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };

      //Routesban kap értéket: {DiscountNav, DiscountGroupNav}
      var backTo = $state.params.BackTo;
      if (backTo === 'DiscountNav') {
        backMenu.event = function() {
          $state.go('Contract.DiscountNav');
        };
      } else if (backTo === 'DiscountGroupNav') {
        backMenu.event = function() {
          $state.go('Contract.DiscountGroupNav');
        };
      } else {
        backMenu.event = function() {
          $state.go('Contract.ContractNav');
        };
      }

      var desc = {
        Contract_DiscountNav_DiscountNav: { icon: 'fa fa-tag' },
        Contract_DiscountNav_DiscountGroupNav: { icon: 'fa fa-tags' },
        Contract_DiscountNav_DiscountReportNav: { icon: 'fa fa-area-chart' },
      };

      buildMenu($state, authService, 'Contract_DiscountNav', 'contract', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrTemplateGenParamReqModalEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'reportParams',
    '$stateParams',
    'AuthService',
    function(mi, $http, fModel, reportParams, $stateParams, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrTemplateGenParamReqModalEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.reportParams = reportParams;

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation] ///////////////////////////////
      // Generate Formly form descriptors from pageModel
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      ////////////////////////////////////////////////////////////////////////////////////////

      vm.save = function() {
        vm.reportParams['reportType'] = vm.formModel.Code.Value;
        mi.close({ reportType: vm.formModel.Code });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('RentIndexationGenCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'FileSaver',
    'HistoryService',
    'WalService',
    'DasService',
    function($scope, options, $http, $state, FileSaver, HistoryService, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentIndexationGenCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.generate = generate;
      vm.save = save;
      vm.messages = options.pageModel.Messages;
      vm.excelExport = excelExport;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.back = function() {
        $state.go('Contract.ContractNav');
      };

      function SetRentIndexationIdComboListFilter() {
        vm.pageModel.Fields.RentIndexationId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          if (moment(vm.formModel.IndexationDate, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid()) {
            return { indexationDate: vm.formModel.IndexationDate };
          }
          return null;
        };
      }
      function SetRentIndexationIdComboListBound() {
        vm.pageModel.Fields.RentIndexationId.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          var selectedItem = e.sender.dataItem(e.item);
          RentIndexationIdComboListChange(selectedItem);
        };
      }

      function RentIndexationIdComboListChange(selectedItem) {
        SetModelExtraPropBasedOnSelectedItem(vm.formModel.extraProperties, 'IndexValue', selectedItem);
        if (!!selectedItem?.extraProperties) {
          vm.formModel.IndexValue = selectedItem.extraProperties[0].value ? selectedItem.extraProperties[0].value : '';
        }
      }

      SetRentIndexationIdComboListFilter();
      SetRentIndexationIdComboListBound();

      //F4 szuresek
      var tenTypeWhereConditionFunction = function() {
        return "CodeGroup~eq~'PTE'";
      };
      vm.pageModel.Fields.TenType.FormlyFieldDescriptor.templateOptions.options.whereCondition = tenTypeWhereConditionFunction;

      var contractIdWhereConditionFunction = function() {
        return "ContractStatus~eq~'CCSOP'~or~ContractStatus~eq~'CCSAC'~or~ContractStatus~eq~'CCSCH'";
      };
      vm.pageModel.Fields.ContractId.FormlyFieldDescriptor.templateOptions.options.whereCondition = contractIdWhereConditionFunction;

      var partnerIdWhereConditionFunction = function() {
        var today = new Date();
        var date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
        return "Tenant~eq~'true'~and~ValidFrom~lte~'" + date + "'~and~(ValidTo~isnull~or~ValidTo~gte~'" + date + "')";
      };
      vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.whereCondition = partnerIdWhereConditionFunction;

      var serviceIdWhereConditionFunction = function() {
        var today = new Date();
        var date = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();
        return "ServiceType~eq~'CSERE'";
      };
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = serviceIdWhereConditionFunction;

      function save() {
        $http
          .post('Contract/RentIndexationGenSave')
          .then(function(response) {
            toastr.success(vm.messages.SaveSuccessful);
            if (!!vm.grid && !!vm.grid.dataSource) {
              vm.grid.dataSource.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.messages.SaveFailed);
          });
      }

      function generate() {
        if (!!vm.grid && !!vm.grid.dataSource && vm.grid.dataSource._data.length > 0) {
          bootbox.dialog({
            message: vm.pageModel.Actions.ActionWarningMessage.Title,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  generateRequest();
                },
              },
            },
          });
        } else {
          generateRequest();
        }
      }

      function generateRequest() {
        $http
          .post('Contract/RentIndexationGen', vm.formModel)
          .then(function(response) {
            toastr.success(vm.messages.GenerateSuccessful);
            if (!!vm.grid && !!vm.grid.dataSource) {
              vm.formModel.GeneratedRowCount = response.data.Dto.GeneratedRowCount;
              vm.formModel.SumOldPrice = response.data.Dto.SumOldPrice;
              vm.formModel.SumNewPrice = response.data.Dto.SumNewPrice;
              vm.grid.dataSource.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.messages.GenerateFailed);
          });
      }

      function excelExport() {
        var gridData = vm.grid.dataSource.data();
        $http
          .post('Contract/RentIndexationGenExcelExport', gridData)
          .then(function(data) {
            var raw = window.atob(data.data.File);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'export.xlsx');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Actions.ActionExcelFailed.Title);
          });
      }

      var onChangeFunctions = {
        RentIndexationId: function(selectedItem) {
          RentIndexationIdComboListChange(selectedItem);
        },
        IndexationDate: function() {
          if (moment(vm.formModel.IndexationDate, kendo.culture().calendar.patterns.d.toUpperCase(), true).isValid()) {
            vm.pageModel.Fields.RentIndexationId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids.GridRentIndexationGen,
        'Contract/RentIndexationGenList/',
        function() {}
      );
      vm.gridIdField = vm.pageModel.Grids.GridRentIndexationGen.IdColumn;
      vm.grid = $('#generatedContrFeeGrid').data('kendoGrid');
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractTransFeeReportModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractTransFeeReportModalCtrl', stateParams);
      }
      var vm = this;

      vm.mainGridOptions = model.mainGridOptions;
      vm.messages = model.messages;
      vm.checkedTreeNodes = null;

      vm.generate = generate;
      vm.cancel = cancel;

      var treeDataSource = new kendo.data.HierarchicalDataSource({
        data: model,
      });

      vm.treeOptions = {
        loadOnDemand: false,
        checkboxes: {
          checkChildren: true,
        },
        check: onCheck,
        dataSource: treeDataSource,
      };

      function generate() {
        uibModalInstance.close(vm.checkedTreeNodes);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function checkedNodeIds(nodes, checkedNodes) {
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].checked && !nodes[i].hasChildren) {
            checkedNodes.push(nodes[i].id);
          }

          if (nodes[i].hasChildren) {
            checkedNodeIds(nodes[i].children.view(), checkedNodes);
          }
        }
      }

      function onCheck() {
        var checkedNodes = [],
          treeView = $('#propertyTreeView').data('kendoTreeView');

        checkedNodeIds(treeView.dataSource.view(), checkedNodes);

        vm.checkedTreeNodes = checkedNodes;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContractTransFeeConfirmModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractTransFeeConfirmModalCtrl', stateParams);
      }
      var vm = this;

      vm.mainGridOptions = model.mainGridOptions;
      vm.messages = model.messages;
      vm.propertyIds = model.ids;
      vm.pageModel = model.pageModel;

      vm.generate = generate;
      vm.cancel = cancel;

      vm.getFilter = function() {
        var propertyIdQueryArray = [];

        angular.forEach(vm.propertyIds, function(propertyId) {
          propertyIdQueryArray.push("PropertyId~eq~'" + propertyId + "'");
        });

        return '(' + propertyIdQueryArray.join('~or~') + ")~and~HasReport~eq~'1'";
      };

      // GridContractReport
      initMainGrid(
        vm,
        'GridContractReport',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        false
      );

      vm.mainGridOptions.dataSource.sort = [{ field: 'ContractInfo', dir: 'asc' }];

      var checkBoxColumn = {
        selectable: true,
        width: '40px',
        attributes: {
          style: 'padding-right: 25px; text-align: right;',
        },
      };

      vm.pageModel.Grids['GridContractReport'].Columns.unshift(checkBoxColumn);

      vm.mainGridOptions.autoBind = true;
      vm.mainGridOptions.dataBound = function() {
        $('.transfee-report .k-grid .k-checkbox').prop('checked', true);
      };

      function generate() {
        var excludedIds = [];

        $('input')
          .not(':checked')
          .closest('tr')
          .each(function() {
            if (this.dataset && this.dataset.uid && vm.mainGrid.dataSource.getByUid(this.dataset.uid)) {
              excludedIds.push(vm.mainGrid.dataSource.getByUid(this.dataset.uid).ContractId);
            }
          });

        uibModalInstance.close(excludedIds);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function initMainGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars === null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

        if (vm.pageModel.Grids[gridName].Table) {
          readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.pageModel.Grids[gridName].Table,
            whereCondition: whereCondition,
            adopter: vm.pageModel.Grids[gridName].Adopter,
            installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids[gridName].IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#mainGrid').data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('RentableUnitsFindModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentableUnitsFindModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.isResult = false;
      vm.excelExport = excelExport;

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation] ///////////////////////////////
      // Generate Formly form descriptors from pageModel
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.gridIdField = vm.pageModel.Grids['GridRentableUnitFindResult'].IdColumn;
      vm.grid = vm.pageModel.Grids['GridRentableUnitFindResult'];

      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids.GridRentableUnitFindResult,
        'Contract/RentableUnitsList/',
        function() {},
        function() {
          return { Date: vm.formModel.Date };
        }
      );
      vm.gridOptions.autoBind = true;

      vm.formatDate = function(date) {
        var dateObject = new moment(vm.formModel.Date, kendo.culture().calendar.patterns.d.toUpperCase());
        return dateObject.format(dateObject._f);
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      function excelExport() {
        $http
          .post('Contract/RentableUnitsListExcelExport', { Date: vm.formModel.Date })
          .then(function(data) {
            var raw = window.atob(data.data.File);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'export.xlsx');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Actions.ActionExcelFailed.Title);
          });
      }

      vm.generate = function() {
        vm.isResult = true;
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContractDataDifferenceWarningModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'parameters',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, parameters) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractDataDifferenceWarningModalCtrl', stateParams);
      }
      var vm = this;

      vm.messages = parameters.messages;

      //set default functions
      vm.formModel = { 1: false, 2: false, 3: false, 7: false };

      vm.cancel = function() {
        $uibModalInstance.dismiss();
      };

      vm.accept = function() {
        $uibModalInstance.close(vm.formModel);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportActiveContractCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportActiveContractCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      kendoMSInit('TenTypes');

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/GenerateReportActiveContract', vm.formModel)
          .then(function(result) {
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'EloSzerzodesekRiport.xls');
          })
          .catch(function(result) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportContractMasterDataCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportContractMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      kendoMSInit('Extent');

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/GenerateReportContractMasterData', vm.formModel)
          .then(function(result) {
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'SzerzodesTorzs.xls');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportPropertyMasterDataCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportPropertyMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/GenerateReportPropertyMasterData', vm.formModel)
          .then(function(result) {
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'BerlemenyTorzs.xls');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportEmptyPremisesCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportEmptyPremisesCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      kendoMSInit('TenType');

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/GenerateReportEmptyPremises', vm.formModel)
          .then(function(result) {
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'BerlemenyTorzs_ures_helyiseg.xls');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportEmptyFlatsCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'FileSaver',
    function(mi, $http, fModel, $stateParams, AuthService, $uibModal, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportEmptyFlatsCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/GenerateReportEmptyFlats', vm.formModel)
          .then(function(result) {
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(fs, 'BerlemenyTorzs_ures_lakas.xls');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContractMessageModalCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContractMessageModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.isCreate = !vm.formModel.Subject;

      if (vm.isCreate) {
        vm.title = vm.pageModel.Labels['LabelTitle_New'].Title;
      } else {
        vm.title = vm.pageModel.Labels['LabelTitle_View'].Title;
      }

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////

      var hideExpressions = {
        ModUserName: function() {
          return vm.isCreate;
        },
        ModDate: function() {
          return vm.isCreate;
        },
      };
      var customExpressionProperties = {
        ModUserName: {
          'templateOptions.disabled': 'true',
        },
        ModDate: {
          'templateOptions.disabled': 'true',
        },
        Message: {
          'templateOptions.disabled': function() {
            return !vm.isCreate;
          },
        },
        Subject: {
          'templateOptions.disabled': function() {
            return !vm.isCreate;
          },
        },
      };

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be run before generating formly descriptors from general field descriptors

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      ////////////////////////////////////////////////////////////////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Contract/AddContractMessage', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrFeeImportNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$timeout',
    'HistoryService',
    'DasService',
    'UIHelperService',
    'FileSaver',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $timeout,
      HistoryService,
      dasService,
      UIHelperService,
      FileSaver
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeImportNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      //// MenuItems
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      //// Functions
      vm.contrFeeImport = contrFeeImport;
      vm.contrFeeImportCheck = contrFeeImportCheck;
      vm.contrFeeImportRegister = contrFeeImportRegister;
      vm.contrFeeImportRevert = contrFeeImportRevert;
      vm.editSubItem = editSubItem;
      vm.viewSubItem = viewSubItem;
      vm.downloadXls = downloadXls;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      vm.back = function() {
        $state.go('main');
      };
      vm.mainGridIdField = vm.pageModel.Grids['GridContrFeeImportMain'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridContrFeeImportMain,
        'Contract/ContrFeeImportMainList/',
        function() {
          changeSubItemGridFilter(vm.mainGrid);
        }
      );

      //vm.subGrid = $("#subGrid").data("kendoGrid");
      vm.getSelectedMainGridItemId = function() {
        return {
          targetRIDId: vm.selectedMainGridItemId,
        };
      };
      vm.subGrid = options.pageModel.Grids['GridContrFeeImportDetail'];
      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridContrFeeImportDetail,
        'Contract/ContrFeeImportDetailList/',
        function() {},
        vm.getSelectedMainGridItemId
      );

      function contrFeeImport() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrFeeImportXlsModal.html',
          controller: 'ContrFeeImportXlsModalCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc('Contract/ContrFeeImportXlsModalOptions'),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function contrFeeImportCheck() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var msg = toastr.warning(vm.pageModel.Labels.LabelCheckWait.Title, vm.pageModel.Labels.LabelWait.Title, {
            timeOut: '0',
            extendedTimeOut: '0',
          });
          $http
            .post('Contract/ContrFeeXlsImportCheck', { id: id })
            .then(function(response) {
              vm.mainGrid.dataSource.read();
              msg.remove();
            })
            .catch(function() {
              vm.mainGrid.dataSource.read();
              msg.remove();
            });
        }
      }

      function contrFeeImportRegister() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var msg = toastr.warning(vm.pageModel.Labels.LabelCheckWait.Title, vm.pageModel.Labels.LabelWait.Title, {
            timeOut: '0',
            extendedTimeOut: '0',
          });
          $http
            .post('Contract/ContrFeeImportRegister', { id: id, checkOnly: true })
            .then(function(response) {
              if (!!msg) msg.remove();
              if (!!response.data.WarningType) {
                let bootBoxButtons =
                  response.data.WarningType != 'RegisterWarning3'
                    ? {
                        confirm: {
                          label: vm.messages.Ok,
                          className: 'btn-primary',
                          callback: function() {
                            vm.mainGrid.dataSource.read();
                          },
                        },
                      }
                    : {
                        yes: {
                          label: vm.pageModel.Actions.ActionYes.Title,
                          className: 'btn-primary',
                          callback: function() {
                            var msgNoCheck = toastr.warning(
                              vm.pageModel.Labels.LabelRegisterWait.Title,
                              vm.pageModel.Labels.LabelWait.Title,
                              {
                                timeOut: '0',
                                extendedTimeOut: '0',
                              }
                            );
                            $http
                              .post('Contract/ContrFeeImportRegister', { id: id, checkOnly: false })
                              .then(function(response) {
                                if (!!msgNoCheck) msgNoCheck.remove();
                                vm.mainGrid.dataSource.read();

                                if (response.data.WarningType != '') {
                                  toastr.warning(
                                    vm.pageModel.Labels.LabelRegisterError.Title,
                                    vm.pageModel.Labels.LabelWait.Title
                                  );
                                } else {
                                  toastr.success(
                                    vm.pageModel.Labels.LabelRegisterSuccessful.Title,
                                    vm.pageModel.Labels.LabelWait.Title
                                  );
                                  vm.mainGrid.dataSource.read();
                                }
                              });
                          },
                        },
                        cancel: {
                          label: vm.pageModel.Actions.ActionNo.Title,
                          className: 'btn-default',
                          callback: function() {},
                        },
                      };

                bootbox.dialog({
                  message: vm.pageModel.Labels['Label' + response.data.WarningType].Title,
                  title:
                    response.data.WarningType != 'RegisterWarning3'
                      ? vm.pageModel.Labels.LabelInformation.Title
                      : vm.pageModel.Messages.Warning,
                  closeButton: false,
                  buttons: bootBoxButtons,
                });
                if (!!msg) msg.remove();
              } else {
                vm.mainGrid.dataSource.read();
              }
            })
            .catch(function() {
              if (!!msg) msg.remove();
              msgNoCheck = toastr.warning(
                vm.pageModel.Labels.LabelRegisterError.Title,
                vm.pageModel.Labels.LabelWait.Title
              );
            });
        }
      }

      function contrFeeImportRevert() {
        bootbox.dialog({
          message: vm.pageModel.Labels.LabelRevertConfirmation.Title,
          title: vm.pageModel.Labels.LabelConfirmationTitle.Title,
          closeButton: false,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-primary',
              callback: function() {},
            },
            ok: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                contrFeeImportRevertImpl();
              },
            },
          },
        });
      }

      function contrFeeImportRevertImpl() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var msg = toastr.warning(vm.pageModel.Labels.LabelRevertWait.Title, vm.pageModel.Labels.LabelWait.Title, {
            timeOut: '0',
            extendedTimeOut: '0',
          });
          $http
            .post('Contract/ContrFeeImportRevert', { id: id })
            .then(function(response) {
              if (!!response.data.WarningType) {
                bootbox.dialog({
                  message: vm.pageModel.Labels['Label' + response.data.WarningType].Title,
                  title: vm.pageModel.Labels.LabelInformation.Title,
                  closeButton: false,
                  buttons: {
                    confirm: {
                      label: vm.messages.Ok,
                      className: 'btn-primary',
                      callback: function() {
                        vm.mainGrid.dataSource.read();
                      },
                    },
                  },
                });
              } else {
                vm.mainGrid.dataSource.read();
              }
              msg.remove();
            })
            .catch(function() {
              vm.mainGrid.dataSource.read();
              msg.remove();
            });
        }
      }

      function editSubItem(readOnly) {
        var id = getSelectedSubGridItemId();
        if (!!id) {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Contract/ContrFeeImportEditModal.html',
            controller: 'ContrFeeImportEditModalCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc('Contract/GridContrFeeImportEdit/' + id),
              readOnly: readOnly === true,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrid.dataSource.read();
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function viewSubItem() {
        editSubItem(true);
      }

      function downloadXls(untouched) {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          $http
            .post('Contract/ContrFeeImportDownloadXls', { contrFeeImportMainId: id, untouchedXls: untouched })
            .then(function(response) {
              var raw = window.atob(response.data.File);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver.saveAs(fs, response.data.Filename + '.xlsx');
            });
        }
      }

      //// Updates subItem grid filters according to the item selection of the mainGrid
      function changeSubItemGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          return;
        }
        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.selectedMainGridItemStatus = selectedItems[0].Status;
        vm.enableToRegister = vm.selectedMainGridItemStatus === 'UIMIM';
        vm.enableToEdit = vm.selectedMainGridItemStatus === 'UIMIM';
        vm.enableToCheck = vm.selectedMainGridItemStatus === 'UIMIM';
        vm.enableToRevert = vm.selectedMainGridItemStatus === 'UIMIM' || vm.selectedMainGridItemStatus === 'UIMAC';
        vm.enableToDownload = vm.selectedMainGridItemStatus === 'UIMAC';
        $scope.$applyAsync();

        if (!!vm.subGrid) {
          vm.subGrid.dataSource.read();
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgMeterReading', id);
      }

      function WAL(whichGrid) {
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            walService.NavigateToWal('Utility', 'MeterRIMNavWal', 'FlgMeterReadingImportMainView');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            walService.NavigateToWal('Utility', 'MeterRIDNavWal', 'FlgMeterReadingImportDetailView');
            break;
          }

          default: {
            break;
          }
        }
      }

      function history() {
        var selectedItems = getSelectedSubGridItemId();
        if (selectedItems) {
          HistoryService.NavigateToHistory('xxx', selectedItems, vm, $state, true);
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function getSelectedSubGridItem() {
        var gridName = 'GridContrFeeImportDetail';
        var gridRef = $('#' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);

        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = 'GridContrFeeImportDetail';
        var item = getSelectedSubGridItem();

        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrFeeImportXlsModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'FileUploadService',
    function(mi, $http, fModel, $stateParams, AuthService, fus) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeImportXlsModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.isResult = false;

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation] ///////////////////////////////
      // Generate Formly form descriptors from pageModel
      var eventHandlers = {
        FileName: {
          onError: function() {},
          onSuccess: function() {},
          onComplete: function() {},
        },
      };
      InsertEventHandlers(vm.pageModel, eventHandlers);

      vm.pageModel.Fields.FileName.FormlyFieldDescriptor.templateOptions.accept = '.xlsx';
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        //if (!vm.formModel.FileName) return;
        var model = angular.copy(vm.formModel);
        model.FileName = vm.formModel.FileName.getFile();
        var msg = toastr.warning(vm.pageModel.Labels.LabelCheckWait.Title, vm.pageModel.Labels.LabelWait.Title, {
          timeOut: '0',
          extendedTimeOut: '0',
        });
        fus
          .postWithFile('Contract/ContrFeeXlsImport', model)
          .then(function(response) {
            msg.remove();
            mi.close();
          })
          .catch(function() {
            msg.remove();
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ContrFeeImportEditModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'readOnly',
    '$stateParams',
    'AuthService',
    'FileUploadService',
    function(mi, $http, fModel, readOnly, $stateParams, AuthService, fus) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeImportEditModalCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.formModel = fModel.dto;
      vm.isReadOnly = readOnly || fModel.dto.ModelState === 1;
      vm.isResult = false;

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation] ///////////////////////////////
      // Generate Formly form descriptors from pageModel

      if (vm.isReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.modalTitle = vm.isReadOnly ? vm.pageModel.Labels.LabelTitleView.Title : vm.pageModel.Labels.LabelTitle.Title;
      vm.closeButtonTitle = vm.isReadOnly
        ? vm.pageModel.Actions.ActionBack.Title
        : vm.pageModel.Actions.ActionCancel.Title;

      var customExpressionProperties = {
        InvoicingTo: {
          'templateOptions.disabled': function() {
            return vm.isReadOnly || vm.formModel.FileType == 'UFTBC';
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return 'Active~eq~true';
      };

      vm.save = function() {
        $http
          .post('Contract/GridMeterReadingImportEdit', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function() {});
      };

      vm.cancel = function() {
        mi.dismiss('cancel');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ContrFeeSetPeriodBeforeGenModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    'gridService',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ContrFeeSetPeriodBeforeGenModalCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = cancel;
      vm.generate = generate;

      vm.formModel = fModel.grid;
      vm.pageModel = fModel.pageModel;
      vm.pageModel.Labels.LabelText.Title = vm.pageModel.Labels.LabelText.Title.replace(
        '{{BudgetYear}}',
        new Date().getFullYear()
      );

      vm.gridModel = fModel.pageModel.Grids.ContrFeeSetPeriodBeforeGenList;
      vm.serviceIdList = [];
      vm.resultGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: vm.gridModel,
        dataBound: function() {
          const grid = this;
          $(this.tbody)
            .find('.serviceForCloseChkBox')
            .off('change')
            .bind('change', function(e) {
              var row = $(e.target).closest('tr');
              var dataItem = grid.dataItem(row);
              dataItem.IsClose = $(e.target).prop('checked') === true;
              collectServiceIds(vm.serviceIdList, dataItem['ServiceId'], dataItem.IsClose);
              grid.refresh();
            });
        },
      });
      vm.resultGridOptions.dataSource = new kendo.data.DataSource({
        data: new kendo.data.ObservableArray(vm.formModel),
        schema: { model: vm.resultGridOptions.dataSource.schema.model },
        page: vm.resultGridOptions.dataSource.page,
        pageSize: vm.resultGridOptions.dataSource.pageSize,
      });
      enableCheckboxOnColumn(vm.resultGridOptions, 'IsClose');
      //vm.resultGridOptions.pageable = false;

      vm.resultGrid = $('#resultGrid').data('kendoGrid');

      function enableCheckboxOnColumn(gridOptions, field, fn) {
        var column = vm.resultGridOptions.columns.find(function(prop) {
          return prop.field === field;
        });

        column.template =
          '<input type="checkbox" #=IsClose ? "checked=checked" : "" # class="serviceForCloseChkBox"></input>';
      }

      function changeFieldValue(model, rowId, value) {
        var row = model.find(function(prop) {
          return prop['ServiceId'] === rowId;
        });
        row.IsClose = value;
      }

      function collectServiceIds(idList, serviceId, value) {
        let index = idList.indexOf(serviceId);
        if (value === true && index === -1) {
          idList.push(serviceId);
        } else if (value === false && index !== -1) {
          idList = idList.splice(index, 1);
        }
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function generate() {
        uibModalInstance.close(vm.serviceIdList);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UnitNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnitNavCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.createUnit = createUnit;
      vm.editUnit = editUnit;
      vm.deleteUnit = deleteUnit;
      vm.createUnitConv = createUnitConv;
      vm.editUnitConv = editUnitConv;
      vm.deleteUnitConv = deleteUnitConv;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.UsedGridEnum = Object.freeze({ UNIT: 1, UNITCONVERSION: 2 });

      vm.UsedGridEnum = Object.freeze({ UNIT: 1, UNITCONVERSION: 2 });

      vm.mainGridIdField = vm.pageModel.Grids['GridUnit'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      vm.subGridIdField = vm.pageModel.Grids['GridUnitConversion'].IdColumn;
      vm.pageModel.Grids['GridUnitConversion'].Columns[2].format = '{0:n6}';
      vm.subGrid = $('#subGrid').data('kendoGrid');

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridUnit, 'Task/UnitList/', function() {
        changeMainGridFilter(vm.mainGrid);
      });

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          unitId: vm.selectedMainGridItemId,
        };
      };

      // Kendo-grid reference for sub GRID
      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridUnitConversion,
        'Task/UnitConversionList/',
        function() {},
        vm.getSelectedMainGridItemId
      );

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        //console.log("selectedMainGridItemId: " + vm.selectedMainGridItemId);
        vm.subGrid.dataSource.read();
      }

      //////////////////////////////////////////
      ////////////// Unit operations ///////////
      //////////////////////////////////////////

      function createUnit() {
        var url = 'Task/UnitCreate/';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/UnitEdit.html',
          controller: 'UnitEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editUnit() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'Task/UnitEdit/' + id;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/UnitEdit.html',
            controller: 'UnitEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteUnit() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.mainGridIdField];
          var dialogMessage = vm.messages.DialogConfirmMessage;
          dialogMessage = dialogMessage.replace('{0}', ': ' + selectedItem.UnitName + '?');
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Actions.ActionNo.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Actions.ActionYes.Title,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Task/UnitDelete/' + id).then(function() {
                    toastr.success('Mértékegység sikeresen törölve!');
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function WAL(mode) {
        switch (mode) {
          case vm.UsedGridEnum.UNIT:
            walService.NavigateToWal('Task', 'UnitNavWal', 'FlgUnitView');
            break;
          case vm.UsedGridEnum.UNITCONVERSION:
            walService.NavigateToWal('Task', 'UnitConversionNavWal', 'FlgUnitConversionView');
            break;
          default:
            break;
        }
      }

      function attachDocument(mode) {
        switch (mode) {
          case vm.UsedGridEnum.UNIT:
            var selectedItems = GetSelectedGridItems(vm.mainGrid);
            var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
            $state.go('Task.DasDocumentsNav', { tableId: 'FlgUnit', ownerId: id });
            dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnit', id);
            break;
          case vm.UsedGridEnum.UNITCONVERSION:
            var selectedItems = GetSelectedGridItems(vm.subGrid);
            var id = !!selectedItems[0] ? selectedItems[0][vm.subGridIdField] : null;
            dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitConversion', id);
            break;
          default:
            break;
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgUnit', selectedItems[0][vm.mainGridIdField], vm, $state, true);
      }

      ////////////////////////////////////////////////////
      ////////////// UnitConversion operations ///////////
      ////////////////////////////////////////////////////
      function createUnitConv() {
        var selectedUnitItem = GetSelectedGridItems(vm.mainGrid);
        if (selectedUnitItem.length === 0) {
          toastr.warning('Nem jelölt ki mértékegységet!', 'Figyelmeztetés!');
        } else {
          var id = 0;
          var UnitId = vm.selectedMainGridItemId;
          var url = 'Task/UnitConversionEdit/?id=' + id + '&unitId=' + UnitId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/UnitConversionEdit.html',
            controller: 'UnitConversionEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrid.dataSource.read();
          });
        }
      }

      function editUnitConv() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.subGridIdField];
          var UnitId = vm.selectedMainGridItemId;
          var url = 'Task/UnitConversionEdit/?id=' + id + '&unitId=' + UnitId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/UnitConversionEdit.html',
            controller: 'UnitConversionEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrid.dataSource.read();
          });
        }
      }

      function deleteUnitConv() {
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          var id = selectedItems[0][vm.subGridIdField];
          var dialogMessage = vm.messages.DialogConfirmMessage;
          dialogMessage = dialogMessage.replace('{0}', ': ' + selectedItem.UnitToName + '?');
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Actions.ActionNo.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Actions.ActionYes.Title,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Task/UnitConversionDelete/' + id).then(function() {
                    toastr.success('Átváltás sikeresen törölve!');
                    vm.subGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UnitEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, fModel, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnitEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      vm.modalTitle =
        vm.formModel.ModelState == 2
          ? vm.pageModel.Labels['LabelTitle'].Title
          : vm.pageModel.Labels['LabelEditTitle'].Title;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('Task/UnitEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages['SaveSuccessful']);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages['SaveFailed']);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.UnitId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnit', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UnitConversionEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, fModel, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnitConversionEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        //InsertStaticValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      //console.log("pageModel: ");
      //console.log(vm.pageModel);
      vm.formModel = fModel.dto;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      //console.log(vm.formFields);
      vm.pageModel.Fields.UnitToId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { unitId: vm.formModel.UnitId };
      };

      vm.save = function() {
        vm.formModel.Multiplier = parseFloat(vm.formModel.Multiplier.toString().replace(',', '.'));
        $http
          .post('Task/UnitConversionEdit', vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!'); // TODO általános label
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen'); // TODO általános label
            //mi.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      vm.attachDocument = function() {
        var id = vm.formModel.UnitConversionId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitConversion', id);
      };
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Task: {
        url: '/Task',
        templateUrl: 'App/Task/TaskLayout.html',
        controller: 'TaskLayoutCtrl as vm',
        redirectTo: 'Task.TaskNav',
        ncyBreadcrumb: {
          label: 'Tevékenységek',
          parent: 'main',
        },
      },
      'Task.TaskNav': {
        url: '/task',
        params: {
          module: 'Task',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Task.TaskCreate', 'Task.TaskEdit'],
          documentEntity: 'task_tasknav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskNav.html',
            controller: 'TaskNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/TaskListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tevékenységek',
        },
      },
      'Task.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Task.TaskCreate': {
        url: '/taskcreate/{id:int}?taskTypeId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/TaskCreate/', undefined, ['id', 'taskTypeId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          documentEntity: 'task_taskcreate',
          backTo: 'TaskNav',
        },
        ncyBreadcrumb: {
          label: 'Tevékenység létrehozása',
        },
      },
      'Task.TaskEdit': {
        url: '/taskedit/{id:int}?taskTypeId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/TaskEdit/', undefined, ['id', 'taskTypeId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          documentEntity: 'task_taskcreate',
          backTo: 'TaskNav',
        },
        ncyBreadcrumb: {
          label: 'Tevékenység szerkesztése',
        },
      },
      'Task.TaskTypeNav': {
        url: '/tasktype',
        params: { module: 'Task', documentEntity: 'task_tasktypenav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskTypeNav.html',
            controller: 'TaskTypeNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/TaskTypeListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tevékenységtípusok',
        },
      },
      'Task.PropertyTaskNav': {
        url: '/propertytask',
        params: { module: 'Task', documentEntity: 'task_propertytasknav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/PropertyTaskNav.html',
            controller: 'PropertyTaskNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/PropertyTaskListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Tevékenységek ingatlanhoz rendelése',
        },
      },
      'Task.UnitNav': {
        url: '/unit',
        params: {
          module: 'task',
          documentEntity: 'task_unitnav',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/UnitNav.html',
            controller: 'UnitNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/ListOptions/'),
        },
        ncyBreadcrumb: {
          //skip: true,
          label: 'Mértékegységek',
        },
      },
      'Task.UnitCreate': {
        url: '/unitcreate/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/UnitEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Create',
          documentEntity: 'task_unitnav',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'Task.UnitEdit': {
        url: '/unitedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/UnitEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          documentEntity: 'task_unitnav',
        },
        ncyBreadcrumb: {
          label: 'Szerkesztés',
        },
      },
      'Task.UnitDuplicate': {
        url: '/unitduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/UnitEdit.html',
            controller: 'UnitEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/UnitDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          documentEntity: 'task_unitnav',
        },
        ncyBreadcrumb: {
          label: 'Másolás',
        },
      },
      'Task.FrequencyNav': {
        url: '/frequency',
        params: { module: 'task', documentEntity: 'task_frequencynav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/FrequencyNav.html',
            controller: 'FrequencyNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/FrequencyListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Gyakoriságok',
        },
      },
      'Task.FrequencyDuplicate': {
        url: '/frequencyduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/FrequencyDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          documentEntity: 'task_frequencynav',
        },
      },
      'Task.UnitPriceCollectionNav': {
        url: '/unitpricecollection',
        params: { module: 'task', documentEntity: 'task_unitpricecollectionnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/UnitPriceCollectionNav.html',
            controller: 'UnitPriceCollectionNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/UnitPriceCollectionListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Egységárgyűjtemények',
        },
      },
      'Task.ValidDateEdit': {
        url: '/validdateedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/ValidDateEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Érvényesség szerkesztés',
        },
      },
      'Task.ValidDateCreate': {
        url: '/validdatecreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/ValidDateCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Create',
        },
        ncyBreadcrumb: {
          label: 'Érvényesség szerkesztés',
        },
      },
      'Task.TaskPriceEdit': {
        url: '/taskpriceedit',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/TaskEdit.html',
            controller: 'TaskEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/TaskPriceEdit/{dto}'),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Tevékenység árazása',
        },
      },
      'Task.BudgetUnitPriceCollectionNav': {
        url: '/budgetunitpricecollection',
        params: { module: 'task', documentEntity: 'task_BudgetUnitPriceCollectionNav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Task/BudgetUnitPriceCollectionNav.html',
            controller: 'BudgetUnitPriceCollectionNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Task/ListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Navigáció',
        },
      },
      'Task.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TaskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Task/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Task");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('TaskMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };

      var backTo = $state.params.backTo;
      if (backTo === 'TaskNav') {
        backMenu.event = function() {
          $state.go('Task.TaskNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Task_TaskNav: { icon: 'fa fa-exchange' },
        Task_TaskTypeNav: { icon: 'fa fa-exchange' },
        Task_FrequencyNav: { icon: 'fa fa-users' },
        Task_UnitPriceCollectionNav: { icon: 'fa fa-exchange' },
        Task_UnitNav: { icon: 'fa fa-exchange' },
      };

      buildMenu($state, authService, 'Task', 'task', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    'gridService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $filter,
      authService,
      HistoryService,
      dasService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskNavCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.createTask = createTask;
      vm.editTask = editTask;
      vm.deleteTask = deleteTask;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go('main');
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        TaskTypeId: function(selectedItem) {
          if (!!selectedItem) vm.subGrids['GridTask'].dataSource.read({ taskTypeId: selectedItem.key });
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        null,
        function(gridModel) {
          gridModel.ControllerMethod = `Task/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            selectFunction: function() {
              setDasModel();
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      function createTask() {
        $state.go('Task.TaskCreate', { id: 0, taskTypeId: vm.formModel.TaskTypeId });
      }

      function editTask() {
        var taskId = getSelectedGridItemId('GridTask');
        if (!!taskId) {
          $state.go('Task.TaskEdit', { id: taskId });
        }
      }

      function deleteTask() {
        var taskId = getSelectedGridItemId('GridTask');
        if (!!taskId) {
          var url = 'Task/TaskDelete?id=' + taskId;
          var dialogMessage = vm.messages.DialogConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.subGrids['GridTask'].dataSource.read();
                    })
                    .catch(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridTask'].DasDescriptor;
        var selectedItems = getSelectedGridItemId('GridTask');
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems,
        };
        $scope.$applyAsync();
      }

      function WAL() {
        walService.NavigateToWal('Task', 'TaskNavWal', 'FlgTaskView');
      }

      function history() {
        HistoryService.NavigateToHistory('FlgTask', getSelectedGridItemId('GridTask'), vm, $state, true);
      }

      function getSelectedGridItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, options, $state, $stateParams, AuthService, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = options.pageModel.Actions;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Task.TaskNav');
      };

      vm.attachDocument = function() {
        var id = vm.formModel.TaskId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgTask', id);
      };

      vm.formModifiers = {};

      var customTypes = {
        StandardTime: 'maskedInput',
      };

      var inputMasks = {
        StandardTime: '(99) óra (99) perc',
      };

      vm.pageModel.Fields.Availabilities.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.Availabilities.FormlyFieldDescriptor.templateOptions.itemType = 'Array';
      vm.pageModel.Fields.Frequencies.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.Frequencies.FormlyFieldDescriptor.templateOptions.itemType = 'Array';

      var onChangeFunctions = {
        TaskTypeId: function(selectedItem) {
          vm.pageModel.Fields.Frequencies.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            taskTypeId: function() {
              return selectedItem.key;
            },
          });
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, vm.formModifiers.syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, inputMasks);
        InsertCustomTypes(vm.pageModel, customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.Frequencies.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { taskTypeId: vm.formModel.TaskTypeId };
      };

      // Actions
      function save() {
        $http
          .post('Task/TaskSave', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Task.TaskNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskTypeNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'WalService',
    'DasService',
    function($scope, options, $http, $state, $uibModal, $filter, authService, HistoryService, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskTypeNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.createTaskType = createTaskType;
      vm.editTaskType = editTaskType;
      vm.deleteTaskType = deleteTaskType;
      vm.duplicateTaskType = duplicateTaskType;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go('main');
      };

      vm.mainGridIdField = vm.pageModel.Grids['GridTaskType'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridTaskType, 'Task/TaskTypeList/', function() {
        changeGridFilter(vm, $scope, vm.mainGrid, vm.mainGridIdField);
      });

      // vm.mainGridOptions.dataBinding = function(e) {
      //   var iconPicker = new IconPicker();
      //   angular.forEach(this.dataSource.data(), function(val, key) {
      //     val.Icon = iconPicker.replaceShortPrefix(val.Icon);
      //   });
      // };

      // angular.forEach(vm.mainGridOptions.columns, function(val, key) {
      //   if (val.field === 'Icon') {
      //     val.template = '<span class="#: Icon #"></span>';
      //     val['filterable'] = false;
      //   }
      // });

      function createTaskType() {
        var itemId = 0;
        var url = 'Task/TaskTypeCreate?id=' + itemId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/TaskTypeEdit.html',
          controller: 'TaskTypeEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editTaskType() {
        var itemId = getSelectedRowIdFromMainGrid(vm);
        if (!!itemId) {
          var url = 'Task/TaskTypeEdit?id=' + itemId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/TaskTypeEdit.html',
            controller: 'TaskTypeEditCtrl',
            controllerAs: 'vm',
            resolve: {
              id: itemId,
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteTaskType() {
        var itemId = getSelectedRowIdFromMainGrid(vm);
        if (!!itemId) {
          var url = 'Task/TaskTypeDelete?id=' + itemId;
          var dialogMessage = vm.messages.DialogConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.mainGrid.dataSource.read();
                    })
                    .catch(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function duplicateTaskType() {
        var id = getSelectedRowIdFromMainGrid(vm);
        if (!!id) {
          var url = 'Task/TaskTypeDuplicate?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/TaskTypeEdit.html',
            controller: 'TaskTypeEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function attachDocument() {
        var id = getSelectedRowIdFromMainGrid(vm);
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgTaskType', id);
      }

      function WAL() {
        walService.NavigateToWal('Task', 'TaskTypeNavWal', 'FlgTaskType');
      }

      function history() {
        var itemId = getSelectedRowIdFromMainGrid(vm);
        if (!!itemId) {
          $state.params.documentEntity = '';
          HistoryService.NavigateToHistory('FlgTaskType', itemId, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskTypeEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskTypeEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;
      vm.attachDocument = function() {
        var id = vm.formModel.TaskTypeId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgTaskType', id);
      };

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      // Actions
      function save() {
        var id = getSelectedRowIdFromMainGrid(vm);
        var url = id !== 0 ? 'Task/TaskTypeSave' : 'Task/TaskTypeDuplicate';

        $http
          .post(url, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.pageModel.Fields.Icon.FormlyFieldDescriptor.data = { IconPicker: new IconPicker() };
      delete vm.pageModel.Fields.Icon.FormlyFieldDescriptor.type;

      vm.pageModel.Fields.Icon.FormlyFieldDescriptor.template =
        '<div class="iconpicker">' +
        '<div class="form-group ng-scope row formly" ng-class="{\'has-error\': showError}">' +
        '<label class="control-label">{{to.label + (to.required === true ? "&nbsp;*" : "")}}</label>' +
        '<div class="input-wrapper">' +
        '<input class="form-control" ng-model="model[options.key]" ng-change="to.changed(model[options.key])"' +
        'ng-required="to.required" maxlength="{{::to.maxlength}}" autocomplete="off"' +
        'ng-click="options.data.IconPicker.toggleIconFontSelectorVisibility()"' +
        'formly-focus="{{options.templateOptions.focus}}" focus-wait="1000" refocus />' +
        '<span class="{{options.data.IconPicker.replaceShortPrefix(model[options.key])}} icon1" ng-click="options.data.IconPicker.toggleIconFontSelectorVisibility()"></span>' +
        '<span class="fa fa-lg fa-angle-down icon2" ng-click="options.data.IconPicker.toggleIconFontSelectorVisibility()"></span>' +
        '</div>' +
        '<div ng-include="\'App/templates/formly/formlyNgMessages.html\'"></div>' +
        '</div>' +
        '<ul ng-show="options.data.IconPicker.showIconFontSelector">' +
        '<li ng-repeat="iconFont in options.data.IconPicker.iconfonts">' +
        '<button class="btn btn-default" type="button" ng-mousedown="model[options.key] = iconFont.shortPrefix + iconFont.iconClass; options.data.IconPicker.toggleIconFontSelectorVisibility();">' +
        '<span class="{{iconFont.prefix + iconFont.iconClass}}"></span>' +
        '</button>' +
        '</li>' +
        '</ul>' +
        '</div>';
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FrequencyNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $uibModal, $filter, authService, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FrequencyNavCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createFrequency = createFrequency;
      vm.editFrequency = editFrequency;
      vm.deleteFrequency = deleteFrequency;
      vm.duplicateFrequency = duplicateFrequency;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.back = function() {
        $state.go('main');
      };

      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridFrequency, 'Task/FrequencyList/', function() {});

      function createFrequency() {
        var url = 'Task/FrequencyCreate?id=0';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/FrequencyNavEdit.html',
          controller: 'FrequencyNavEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function editFrequency() {
        var selectedItem = getSelectedGridItem();
        if (selectedItem !== null) {
          var id = selectedItem.FrequencyId;
          var url = 'Task/FrequencyEdit?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/FrequencyNavEdit.html',
            controller: 'FrequencyNavEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function duplicateFrequency() {
        var selectedItem = getSelectedGridItem();
        if (!!selectedItem) {
          var id = selectedItem.FrequencyId;
          var url = 'Task/FrequencyDuplicate?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/FrequencyNavEdit.html',
            controller: 'FrequencyNavEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteFrequency() {
        var selectedItem = getSelectedGridItem();
        if (selectedItem !== null) {
          var id = selectedItem.FrequencyId;
          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http({
                    method: 'GET',
                    url: 'Task/FrequencyDelete/',
                    params: { id: id },
                  }).then(function successCallback(response) {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function getSelectedGridItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function attachDocument() {
        var selectedItem = getSelectedGridItem();
        var id = selectedItem.FrequencyId;
        var id = !!selectedItem ? selectedItem.FrequencyId : null;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgFrequency', id);
      }

      function viewFrequency() {
        var selectedItem = getSelectedGridItem();
        if (!!selectedItem) {
          var url = 'Task/FrequencyView?id=' + selectedItem.FrequencyId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/FrequencyNavEdit.html',
            controller: 'FrequencyNavEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function WAL() {
        walService.NavigateToWal('Task', 'FrequencyNavWal', 'FlgFrequencyView');
      }

      function history() {
        var itemId = getSelectedGridItem();
        if (!!itemId && !!itemId.FrequencyId) {
          HistoryService.NavigateToHistory('FlgFrequency', itemId.FrequencyId, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('FrequencyNavEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FrequencyNavEditCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.frequencyModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      if (vm.frequencyModel.FrequencyId === 0) {
        vm.modalTitle = vm.pageModel.Labels.LabelTitle.Title;
      } else {
        vm.modalTitle = vm.pageModel.Labels.LabelEditTitle.Title;
      }

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      vm.pageModel.Fields.DayTypes.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.DayTypes.FormlyFieldDescriptor.templateOptions.itemType = 'Array';
      vm.pageModel.Fields.TaskTypes.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.TaskTypes.FormlyFieldDescriptor.templateOptions.itemType = 'Array';

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.frequencyModel };
        var url = vm.frequencyModel.FrequencyId !== 0 ? 'Task/FrequencyEdit' : 'Task/FrequencyDuplicate';

        $http
          .post(url, params)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.attachDocument = function() {
        var id = vm.frequencyModel.FrequencyId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgFrequency', id);
      };

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UnitPriceCollectionNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $filter,
      authService,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnitPriceCollectionNavCtrl', stateParams);
      }
      var vm = this;

      // $scope.states = {
      //   Icon: function(val) {
      //     return statusTxt[val];
      //   },
      // };
      $scope.$watch('vm.activeTaskTypeTab', function() {
        if (vm.taskTypeTabs) vm.loadGridsOnTab(vm.taskTypeTabs[vm.activeTaskTypeTab].key);
      });
      vm.UIHelperService = UIHelperService;

      vm.UsedGridEnum = Object.freeze({ UNITPRICECOLLECTION: 1, UNITPRICE: 2 });

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createUnitPriceCollection = createUnitPriceCollection;
      vm.editUnitPriceCollection = editUnitPriceCollection;
      vm.deleteUnitPriceCollection = deleteUnitPriceCollection;

      vm.createValidDate = createValidDate;
      vm.editValidDate = editValidDate;
      vm.deleteValidDate = deleteValidDate;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.HistorySubGrid = historySubGrid;

      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.subGrids = [];
      vm.subGridOptions = [];

      vm.selectedItem = getSelectedGridItem();
      vm.showUnitPriceBySelectedDate = showUnitPriceBySelectedDate;
      vm.UnitPriceValidDates = [];
      vm.UnitPriceValidDateValidFroms = [];

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeTaskTypeTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridUnitPriceCollection,
        'Task/UnitPriceCollectionList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        }
      );

      $scope.activeTaskTypeTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeTaskTypeTab = $scope.activeTaskTypeTab;

      $scope.gridOnSelection = function() {
        vm.selectedItem = getSelectedGridItem();
        vm.activeTaskTypeTab = 0;
        generateTabs();
      };

      function createUnitPriceCollection() {
        var url = 'Task/UnitPriceCollectionCreate';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/UnitPriceCollectionEdit.html',
          controller: 'UnitPriceCollectionEditCtrl',
          controllerAs: 'vm',
          resolve: {
            unitPriceCollectionId: 0,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      // angular.forEach(vm.mainGridOptions.columns, function(val) {
      //   if (val.field === 'Icon') {
      //     val.template = '<span class="glyphicon-stack">#= Icon #</span>';
      //     val['filterable'] = false;
      //   }
      // });

      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.mainGrid.dataSource.read();
        vm.subGrid.dataSource.read();
      }

      function editUnitPriceCollection() {
        var selectedItem = getSelectedGridItem();
        if (selectedItem !== null) {
          var id = selectedItem.UnitPriceCollectionId;
          var url = 'Task/UnitPriceCollectionEdit?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/UnitPriceCollectionEdit.html',
            controller: 'UnitPriceCollectionEditCtrl',
            controllerAs: 'vm',
            resolve: {
              unitPriceCollectionId: id,
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function deleteUnitPriceCollection() {
        var selectedItem = getSelectedGridItem();
        if (selectedItem !== null) {
          var id = selectedItem.UnitPriceCollectionId;
          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http({
                    method: 'GET',
                    url: 'Task/UnitPriceCollectionDelete/',
                    params: { id: id },
                  }).then(function successCallback() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function getSelectedGridItem() {
        if (!vm.mainGrid) {
          return null;
        }

        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedUnitPrice(gridName) {
        var gridRef = $('#unitPriceGrid-' + gridName).data('kendoGrid');

        if (!gridRef) {
          return null;
        }

        var selectedItems = GetSelectedGridItems(gridRef);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function showUnitPriceBySelectedDate(gridName) {
        if (vm.UnitPriceValidDates[gridName] && vm.activeTaskTypeTab >= 0 && vm.subGrids[gridName]) {
          vm.subGrids[gridName].dataSource.read({
            validDateId: parseInt(vm.UnitPriceValidDates[gridName].key),
            taskTypeId: parseInt(vm.taskTypeTabs[vm.activeTaskTypeTab].key),
          });
        } else if (vm.UnitPriceValidDates[gridName] === null) {
          vm.subGrids[gridName].dataSource.read({
            validDateId: 0,
            taskTypeId: parseInt(vm.taskTypeTabs[vm.activeTaskTypeTab].key),
          });
        }
      }

      function generateTabs() {
        if (!vm.selectedItem) {
          return {};
        }
        $http({
          method: 'GET',
          url: 'Task/UnitPriceCollectionTaskTypeList',
          params: { unitPriceCollectionId: vm.selectedItem.UnitPriceCollectionId },
        }).then(function successCallback(response) {
          vm.taskTypeTabs = response.data.ListOptions;
          vm.activeSubItemTab = 1;
          vm.subGrids = [];
          vm.subGridOptions = [];

          if (vm.taskTypeTabs.length > 0) {
            for (var i = 0; i < vm.taskTypeTabs.length; i++) {
              vm.subGrids[vm.taskTypeTabs[i].key] = $('#unitPriceGrid-' + vm.taskTypeTabs[i].key).data('kendoGrid');
              getValidDates(vm.taskTypeTabs[i], undefined, true);

              vm.taskTypeTabs[i].kendoConfig = gridService.buildKendoConfigForGridModel({
                gridModel: Object.assign(_.cloneDeep(options.pageModel.Grids.GridUnitPrice), {
                  ControllerMethod: 'Task/UnitPriceList',
                }),
                autoBind: false,
                transportData: function() {
                  return {
                    validDateId: vm.UnitPriceValidDates[vm.taskTypeTabs[vm.activeTaskTypeTab].key]
                      ? vm.UnitPriceValidDates[vm.taskTypeTabs[vm.activeTaskTypeTab].key].key
                      : 0,
                    taskTypeId: vm.taskTypeTabs[vm.activeTaskTypeTab].key,
                    unitPriceCollectionId: vm.selectedItem.UnitPriceCollectionId,
                  };
                },
                dataSourceOptions: {
                  sort: [
                    { field: 'TaskName', dir: 'asc' },
                    { field: 'FrequencyName', dir: 'asc' },
                  ],
                },
                dataBound: function() {
                  this.element.unbind('dblclick');
                  this.element.on('dblclick', 'tr.k-state-selected', function() {
                    vm.unitPriceGridOnSelection(vm.taskTypeTabs[vm.activeTaskTypeTab].key);
                  });
                },
              });
            }
          }
        });
      }

      vm.loadGridsOnTab = function(taskTypeId) {
        var gridRef = $('#unitPriceGrid-' + taskTypeId).data('kendoGrid');

        if (gridRef) {
          vm.subGrids[taskTypeId] = gridRef;
          gridRef.dataSource.read({
            validDateId: vm.UnitPriceValidDates[taskTypeId] ? vm.UnitPriceValidDates[taskTypeId].key : 0,
            taskTypeId: taskTypeId,
          });
        }
      };

      function getValidDates(taskType, validDateId) {
        $http({
          method: 'GET',
          url: 'Task/UnitPriceValidDateValidFromList',
          params: {
            unitPriceCollectionId: vm.selectedItem.UnitPriceCollectionId,
            taskTypeId: parseInt(taskType.key),
          },
        }).then(function successCallback(response) {
          vm.UnitPriceValidDateValidFroms[taskType.key] = response.data.ListOptions;
          var currentValidDates = vm.UnitPriceValidDateValidFroms[taskType.key];

          if (currentValidDates.length > 0) {
            if (angular.isUndefined(validDateId)) {
              validDateId = parseInt(currentValidDates[currentValidDates.length - 1].key);
            }
          }

          validDateChanged(taskType, validDateId);
        });
      }

      //################################ Create/Edit/Delete Valid Date ############################################

      function createValidDate() {
        var id = 0;
        var unitPriceCollectionId = vm.selectedItem.UnitPriceCollectionId;
        var taskType = vm.taskTypeTabs[vm.activeTaskTypeTab];

        var url =
          'Task/ValidDateCreate?id=' +
          id +
          '&unitPriceCollectionId=' +
          unitPriceCollectionId +
          '&taskTypeId=' +
          parseInt(taskType.key);

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/ValidDateEdit.html',
          controller: 'ValidDateEditCtrl',
          controllerAs: 'vm',
          resolve: {
            validDateId: id,
            unitPriceCollectionId: unitPriceCollectionId,
            taskTypeId: parseInt(taskType.key),
            model: RouteResolveFunc(url),
            isCreate: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          getValidDates(taskType);
        });
      }

      function validDateChanged(taskType, id) {
        var validDate = null;
        var curremtValidDates = vm.UnitPriceValidDateValidFroms[taskType.key];

        for (var i = 0; i < curremtValidDates.length; i++) {
          if (curremtValidDates[i].key === id) {
            validDate = curremtValidDates[i];
          }
        }

        if (validDate !== null) {
          vm.UnitPriceValidDates[taskType.key] = validDate;
          vm.subGrids[taskType.key].dataSource.read({ validDateId: validDate.key, taskTypeId: taskType.key });
        }
      }

      function editValidDate() {
        var unitPriceCollectionId = vm.selectedItem.UnitPriceCollectionId;
        var taskType = vm.taskTypeTabs[vm.activeTaskTypeTab];
        var validDate = vm.UnitPriceValidDates[taskType.key];

        if (validDate) {
          var id = parseInt(validDate.key);
          var url =
            'Task/ValidDateEdit?id=' +
            id +
            '&unitPriceCollectionId=' +
            unitPriceCollectionId +
            '&taskTypeId=' +
            parseInt(taskType.key);

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/ValidDateEdit.html',
            controller: 'ValidDateEditCtrl',
            controllerAs: 'vm',
            resolve: {
              validDateId: id,
              unitPriceCollectionId: unitPriceCollectionId,
              taskTypeId: parseInt(taskType.key),
              model: RouteResolveFunc(url),
              isCreate: false,
            },
            backdrop: 'static',
          });

          modalInstance.result.then(
            function() {
              getValidDates(taskType, parseInt(validDate.key));
            },
            function() {
              //Modal Dismissed
            }
          );
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function deleteValidDate() {
        var taskType = vm.taskTypeTabs[vm.activeTaskTypeTab];
        var validDate = vm.UnitPriceValidDates[taskType.key];
        if (validDate !== null) {
          var id = validDate.key;
          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http({
                    method: 'GET',
                    url: 'Task/ValidDateDelete/',
                    params: { id: id },
                  }).then(function successCallback() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    getValidDates(taskType);
                  });
                },
              },
            },
          });
        }
      }

      function attachDocument(mode) {
        switch (mode) {
          case vm.UsedGridEnum.UNITPRICECOLLECTION:
            var selectedItem = getSelectedGridItem();
            if (selectedItem) {
              var id = selectedItem.UnitPriceCollectionId;
              dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitPriceCollection', id);
            }
            break;
          case vm.UsedGridEnum.UNITPRICE:
            var selectedItem = getSelectedUnitPrice();
            if (selectedItem) {
              var id = selectedItem[vm.mainGridIdField];
              dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitPrice', id);
            }
            break;
          default:
            break;
        }
      }

      function WAL(mode) {
        switch (mode) {
          case vm.UsedGridEnum.UNITPRICECOLLECTION:
            walService.NavigateToWal('Task', 'UnitPriceCollectionNavWal', 'FlgUnitPriceCollectionView');
            break;
          case vm.UsedGridEnum.UNITPRICE:
            walService.NavigateToWal('Task', 'UnitPriceNavWal', 'FlgUnitPriceView');
            break;
          default:
            break;
        }
      }

      function history() {
        var itemId = getSelectedGridItem();
        if (!!itemId) {
          $state.params.documentEntity = '';
          HistoryService.NavigateToHistory('FlgUnitPriceCollection', itemId.UnitPriceCollectionId, vm, $state, true);
        }
      }

      function historySubGrid() {
        var selectedUnitPrice = getSelectedUnitPrice(vm.taskTypeTabs[vm.activeTaskTypeTab].key);
        if (selectedUnitPrice) {
          if (selectedUnitPrice.UnitPriceId) {
            $state.params.documentEntity = '';
            HistoryService.NavigateToHistory('FlgUnitPrice', selectedUnitPrice.UnitPriceId, vm, $state, true);
          } else {
            toastr.warning('Hibásan rögzített egységár!', vm.messages.Warning);
          }
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      //################################ Create/Edit/Delete Valid Date ############################################

      vm.mainGridOptions.dataBound = selectFirstUnitPriceCollection;

      function selectFirstUnitPriceCollection() {
        vm.mainGrid.select('tr:eq(0)');
        $scope.gridOnSelection();
      }

      vm.unitPriceGridOnSelection = function(taskTypeName) {
        var selectedUnitPrice = getSelectedUnitPrice(taskTypeName);
        var taskName = selectedUnitPrice.TaskName;
        var frequencyName = selectedUnitPrice.FrequencyName;
        var validDateId = vm.UnitPriceValidDates[taskTypeName] ? vm.UnitPriceValidDates[taskTypeName].key : 0;

        if (validDateId > 0) {
          var url = 'Task/TaskPriceEdit';
          var p = { taskName: taskName, frequencyName: frequencyName, validDateId: validDateId };
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/TaskPriceEdit.html',
            controller: 'TaskPriceEditCtrl',
            controllerAs: 'vm',
            resolve: {
              validDateId: parseInt(validDateId),
              model: RouteResolveFunc(url, p, ['taskName', 'frequencyName', 'validDateId']),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            var taskType = vm.taskTypeTabs[vm.activeTaskTypeTab];
            var validDate = vm.UnitPriceValidDates[taskType.key];
            vm.subGrids[taskType.key].dataSource.read({
              validDateId: validDate ? validDate.key : 0,
              taskTypeId: taskType.key,
            });
          });
        } else {
          toastr.warning('Kérem, válasszon az egységár rögzítéséhez egy érvényességet!', vm.messages.Warning);
        }
      };

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('UnitPriceCollectionEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'unitPriceCollectionId',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      dasService,
      uibModalInstance,
      unitPriceCollectionId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnitPriceCollectionEditCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = function() {
        var id = vm.unitPriceCollectionModel.UnitPriceCollectionId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitPriceCollection', id);
      };
      vm.isSaveDisabled = isSaveDisabled;

      vm.modalTitle =
        unitPriceCollectionId === 0 ? vm.pageModel.Labels.LabelTitle.Title : vm.pageModel.Labels.LabelEditTitle.Title;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        /**
         * @return {boolean}
         */
        /*"Status": function () {
                    //return vm.unitPriceCollectionModel.ModelState === 3;
                    return false;
                }*/
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {
        /**
         * @return {boolean}
         */
        /*"Status": function () {
                    return vm.unitPriceCollectionModel.ModelState !== 3;
                }*/
      };

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        //"CycleId": function () {
        //    SetCycleLengthComboListFilter();
        //}
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      vm.pageModel.Fields.TaskTypes.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.TaskTypes.FormlyFieldDescriptor.templateOptions.itemType = 'Array';

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner
      /// Saves the current main item

      function isSaveDisabled() {
        return vm.formly.$invalid || !vm.formModel.TaskTypes || vm.formModel.TaskTypes.length < 1;
      }

      function saveItem() {
        var params = { model: vm.formModel, id: unitPriceCollectionId };
        $http
          .post('Task/UnitPriceCollectionEdit', params)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ValidDateEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'validDateId',
    'unitPriceCollectionId',
    'taskTypeId',
    'isCreate',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      validDateId,
      unitPriceCollectionId,
      taskTypeId,
      isCreate,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ValidDateEditCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.validDateModel = model.dto;
      vm.validDateModel.ValidDateId = validDateId;
      vm.validDateModel.UnitPriceCollectionId = unitPriceCollectionId;
      vm.validDateModel.TaskTypeId = taskTypeId;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.isCreate = isCreate;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.validDateModel };
        var saveType = vm.isCreate ? 'Create' : 'Edit';
        $http
          .post('Task/ValidDate' + saveType, params)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TaskPriceEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'validDateId',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      dasService,
      uibModalInstance,
      validDateId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TaskPriceEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.taskPriceModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      vm.cronModel = {
        monthlyCronDtoList: model.monthExpressions,
        weeklyCronDtoList: model.weekExpressions,
        dailyCronDtoList: model.dayExpressions,
      };

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = function() {
        var id = vm.taskPriceModel.UnitPriceId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitPrice', id);
      };

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      /// Saves the current main item
      function saveItem() {
        var params = {
          model: vm.taskPriceModel,
          validDateId: validDateId,
          monthCronExpressions: vm.cronModel['monthlyCronDtoList'],
          weekCronExpressions: vm.cronModel['weeklyCronDtoList'],
          dayCronExpressions: vm.cronModel['dailyCronDtoList'],
        };

        $http
          .post('Task/TaskPriceEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetUnitPriceCollectionNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'WalService',
    'DasService',
    function($scope, options, $http, $state, $uibModal, $filter, authService, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetUnitPriceCollectionNavCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createBudgetUnitPriceCollection = createBudgetUnitPriceCollection;
      vm.editBudgetUnitPriceCollection = editBudgetUnitPriceCollection;
      vm.deleteBudgetUnitPriceCollection = deleteBudgetUnitPriceCollection;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.selectedItem = getSelectedGridItem();

      vm.back = function() {
        $state.go('main');
      };

      function createBudgetUnitPriceCollection() {
        var id = 0;
        var url = 'Task/BudgetUnitPriceCollectionEdit?id=' + id;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/BudgetUnitPriceCollectionEdit.html',
          controller: 'BudgetUnitPriceCollectionEditCtrl',
          controllerAs: 'vm',
          resolve: {
            budgetUnitPriceCollectionId: id,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          // TODO
        });
      }

      function editBudgetUnitPriceCollection() {
        var id = selectedItem.UnitPriceCollectionId;
        var url = 'Task/BudgetUnitPriceCollectionEdit?id=' + id;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/BudgetUnitPriceCollectionEdit.html',
          controller: 'BudgetUnitPriceCollectionEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function deleteBudgetUnitPriceCollection() {
        var selectedItem = getSelectedGridItem();
        if (selectedItem !== null) {
          var id = selectedItem.UnitPriceCollectionId;
          bootbox.dialog({
            message: vm.messages.ConfirmDelete,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http({
                    method: 'GET',
                    url: 'Task/BudgetUnitPriceCollectionDelete/',
                    params: { id: id },
                  }).then(function successCallback(response) {
                    toastr.success(vm.messages.DeleteSuccessful);
                  });
                },
              },
            },
          });
        }
      }

      function getSelectedGridItem() {
        if (!vm.mainGrid) {
          return null;
        }

        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgUnitPriceCollection', id);
      }

      function WAL() {
        walService.NavigateToWal('Task', 'BudgetUnitPriceCollectionNavWal', 'FlgBudgetUnitPriceCollectionView');
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetUnitPriceCollectionEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'budgetUnitPriceCollectionId',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      dasService,
      uibModalInstance,
      budgetUnitPriceCollectionId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetUnitPriceCollectionEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetUnitPriceCollectionModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.required': function() {
            return vm.budgetUnitPriceCollectionModel.ModelState !== 3;
          },
          'templateOptions.disabled': function() {
            return vm.budgetUnitPriceCollectionModel.ModelState === 3;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        TaskTypeId: function() {
          SetUnitPriceComboListFilter();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      SetUnitPriceComboListFilter();

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.budgetUnitPriceCollectionModel, id: budgetUnitPriceCollectionId };

        $http
          .post('Task/BudgetUnitPriceCollectionEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.attachDocument = function() {
        var id = vm.budgetUnitPriceCollectionModel.BudgetUnitPriceCollectionId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgBudgetUnitPriceCollection', id);
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ ComboList Filters ] ///////////////////////////////////

      function SetUnitPriceComboListFilter() {
        vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          taskTypeId: vm.budgetUnitPriceCollectionModel.TaskTypeId,
        };

        vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PropertyTaskNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($scope, options, $http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyTaskNavCtrl', stateParams);
      }
      var vm = this;

      vm.propertyId = 34;
      vm.propertyTaskId = 1005;

      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createPropertyTask = createPropertyTask;
      vm.editPropertyTask = editPropertyTask;
      vm.deletePropertyTask = deletePropertyTask;

      function createPropertyTask() {
        var propertyTaskId = 0;
        var propertyId = vm.propertyId;

        var url = 'Task/PropertyTaskEdit?id=' + propertyTaskId + '&propertyId=' + propertyId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Task/PropertyTaskEdit.html',
          controller: 'PropertyTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
        });

        modalInstance.result.then(function() {
          // TODO
        });
      }

      function editPropertyTask() {
        var propertyId = vm.propertyId;
        var propertyTaskId = vm.propertyTaskId;

        if (!!propertyTaskId) {
          var url = 'Task/PropertyTaskEdit?id=' + propertyTaskId + '&propertyId=' + propertyId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Task/PropertyTaskEdit.html',
            controller: 'PropertyTaskEditCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
          });

          modalInstance.result.then(function() {
            // TODO
          });
        }
      }

      function deletePropertyTask() {
        var propertyTaskId = vm.propertyTaskId;

        if (!!propertyTaskId) {
          var url = 'Task/PropertyTaskDelete?id=' + propertyTaskId;
          var dialogMessage = vm.messages.DialogConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                    })
                    .catch(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function getSelectedGridItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PropertyTaskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PropertyTaskEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;
      vm.isReadOnly = model.isReadOnly ? model.isReadOnly : false;
      vm.isAddCronExpressionDisabled = true;
      isAddCronExpressionDisabled();

      vm.cronModel = {};

      vm.save = save;
      vm.cancel = cancel;
      vm.attachDocument = function() {
        var id = vm.formModel.PropertyTaskId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgPropertyTask', id);
      };

      vm.itemIsRemovable = function(options) {
        $http
          .post('Task/HasHDReference', { type: 'Property', id: options.data.CronExpressionId })
          .then(function(response) {
            if (response.data.removable === true) {
              options.success();
            } else {
              options.error('XHR response', 'status code', 'error message');
            }
          })
          .catch(function(response) {
            console.log(response);
            options.error('XHR response', 'status code', 'error message');
          });
      };

      vm.formModifiers = {};

      if (vm.isReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var onChangeFunctions = {
        ValidFrom: function() {
          if (vm.formModel.ModelState === 2) {
            vm.formly[vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.name].$setViewValue(
              vm.formModel.FirstPropertyBudgetId
            );

            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
              vm.formModel.FirstPropertyBudgetId
            );
          }
        },
        BudgetId: function(selectedItem, x) {
          if (vm.formModel.ModelState === 2) {
            if (!selectedItem.Value) {
              vm.formModel.TaskType = '';
              vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
                budgetId: null,
                validFrom: vm.formModel.null,
              });
              vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
                taskTypeId: null,
                propertyId: null,
                validFrom: null,
              });
              vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
                taskId: null,
              });
            } else {
              vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            }
          }
        },
        TaskType: function(selectedItem) {
          if (selectedItem && vm.formModel.ModelState === 2) {
            vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
              taskTypeId: vm.formModel.TaskType,
              propertyId: vm.formModel.PropertyId,
              validFrom: vm.formModel.ValidFrom,
            });
            vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
              taskId: null,
            });
          }
        },
        Task: function(selectedItem) {
          if (selectedItem && vm.formModel.ModelState === 2) {
            vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
              taskId: vm.formModel.Task,
            });

            if (selectedItem && selectedItem.extraProperties && selectedItem.extraProperties.length > 0) {
              var floorSpace = $.grep(selectedItem.extraProperties, function(e, i) {
                return e.key === 'FloorSpace';
              });
              if (floorSpace.length > 0) {
                vm.formModel.Quantity = floorSpace[0].value;
              }

              var autoHDGen = $.grep(selectedItem.extraProperties, function(e, i) {
                return e.key === 'AutoHDGen';
              });
            }
          }

          if (
            typeof (vm.formModel.TaskFrequencyId !== 'undefined') &&
            vm.formModel.TaskFrequencyId !== null &&
            vm.formModel.TaskFrequencyId !== 0
          ) {
            reloadMaturities('clear');
          }
        },
        TaskFrequencyId: function(selectedItem) {
          isAddCronExpressionDisabled();
          if (!vm.isAddCronExpressionDisabled) {
            reloadMaturities('byFrequency');
          }
        },
      };

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          MinDateValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validFromValue.isSameOrAfter(minValues);
          },
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidFromValidator: function(modelValue, viewValue) {
            if (vm.formModel.ValidTo === null) {
              return true;
            }

            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          MinDateValidator: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validToValue.isSameOrAfter(minValues);
          },
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            if (vm.formModel.ValidFrom === null) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        BudgetId: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        TaskType: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        Task: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3;
          },
        },
        TaskFrequencyId: {
          'templateOptions.disabled': function() {
            return vm.formModel.ValidTo >= Date.now();
          },
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        if (!vm.isReadOnly) {
          InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        }
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract formly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      var budgetIdWhereCondition = function() {
        return 'Active~eq~true~and~OpUnitId~eq~' + vm.formModel.OpUnitId;
      };

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.whereCondition = budgetIdWhereCondition;

      vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { budgetId: vm.formModel.BudgetId.Value, validFrom: vm.formModel.ValidFrom };
      };

      vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          taskTypeId: vm.formModel.TaskType,
          propertyId: vm.formModel.PropertyId,
          validFrom: vm.formModel.ValidFrom,
        };
      };

      vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { taskId: vm.formModel.Task };
      };

      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.type = 'textarea';
      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions['rows'] = 4;

      var whereConditionFunctionForPremise = function() {
        var dateString = moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ');
        return (
          "PropertyId~eq~'" +
          vm.formModel.PropertyId +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          dateString +
          "')"
        );
      };

      vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunctionForPremise;

      // Actions
      function save() {
        var params = {
          model: vm.formModel,
          monthCronExpressions: vm.cronModel['monthlyCronDtoList'],
          weekCronExpressions: vm.cronModel['weeklyCronDtoList'],
          dayCronExpressions: vm.cronModel['dailyCronDtoList'],
        };

        $http
          .post('Task/PropertyTaskSave', params)
          .then(function(response) {
            if (response.data.message) {
              toastr.warning(response.data.message);
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }

      function isAddCronExpressionDisabled() {
        vm.isAddCronExpressionDisabled = !(
          vm.formModel.Task &&
          vm.formModel.Task > 0 &&
          vm.formModel.TaskFrequencyId &&
          vm.formModel.TaskFrequencyId > 0
        );
        return vm.isAddCronExpressionDisabled;
      }

      function reloadMaturities(reloadType) {
        $http
          .get(
            'Task/PropertyCronExpressionList/?taskFrequencyId=' +
              vm.formModel.TaskFrequencyId +
              '&propertyTaskId=' +
              (reloadType === 'full' ? vm.formModel.PropertyTaskId : 0)
          )
          .then(function(response) {
            vm.cronModel = {
              monthlyCronDtoList: response.data.monthExpressions,
              weeklyCronDtoList: response.data.weekExpressions,
              dailyCronDtoList: response.data.dayExpressions,
            };
          });
      }

      reloadMaturities('full');
      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PremiseTaskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'propertyId',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      propertyId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PremiseTaskEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.formIsView = false;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      vm.cronModel = {};

      if (propertyId) {
        vm.formModel.PropertyId = propertyId;
      }

      vm.isReadOnly = model.isReadOnly ? model.isReadOnly : false;
      vm.isAddCronExpressionDisabled = true;
      isAddCronExpressionDisabled();

      if (!vm.isAddCronExpressionDisabled) {
        reloadMaturities();
      }

      vm.monthCronModel = null;
      vm.weekCronModel = null;
      vm.dayCronModel = null;

      vm.monthCronDtos = null;
      vm.weekCronDtos = null;
      vm.dayCronDtos = null;
      vm.disableF2 = true;

      // MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.attachDocument = function() {
        var id = vm.formModel.PremiseTaskId;
        dasService.NavigateToDas(vm.messages, 'Task.DasDocumentsNav', 'FlgPremiseTask', id);
      };

      vm.itemIsRemovable = function(options) {
        $http
          .post('Task/HasHDReference', { type: 'Premise', id: options.data.CronExpressionId })
          .then(function(response) {
            if (response.data.removable === true) {
              options.success();
            } else {
              options.error('XHR response', 'status code', 'error message');
            }
          })
          .catch(function(response) {
            console.log(response);
            options.error('XHR response', 'status code', 'error message');
          });
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        ValidFrom: function() {
          if (vm.formModel.ModelState === 2) {
            vm.formly[vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.name].$setViewValue(
              vm.formModel.FirstPremiseBudgetId
            );
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource
              .read()
              .then(function() {
                var ddl = $('#' + vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.name).data('kendoDropDownList');
                ddl.value(vm.formModel.FirstPremiseBudgetId);
                vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              });
          }
        },
        BudgetId: function(selectedItem) {
          if (selectedItem && vm.formModel.ModelState === 2) {
            vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            vm.formModel.Task = '';
            vm.formModel.TaskFrequencyId = '';
          }
        },
        TaskType: function(selectedItem) {
          if (selectedItem && vm.formModel.ModelState === 2) {
            vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            vm.formModel.TaskFrequencyId = '';
          }
        },
        Task: function(selectedItem) {
          if (selectedItem && vm.formModel.ModelState === 2) {
            vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();

            if (selectedItem && selectedItem.extraProperties && selectedItem.extraProperties.length > 0) {
              vm.pageModel.Fields.RoomSId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                premiseId: vm.formModel.PremiseId,
                propertyId: vm.formModel.PropertyId,
              };
              vm.pageModel.Fields.InventoryId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                premiseId: vm.formModel.PremiseId,
                propertyId: vm.formModel.PropertyId,
              };

              var floorSpace = $.grep(selectedItem.extraProperties, function(e, i) {
                return e.key === 'FloorSpace';
              });
              if (floorSpace.length > 0) {
                vm.disableF2 = false;
                //vm.formModel.Quantity = floorSpace[0].value;
              } else {
                vm.disableF2 = true;
              }

              var autoHDGen = $.grep(selectedItem.extraProperties, function(e, i) {
                return e.key === 'AutoHDGen';
              });
              //if (autoHDGen.length > 0 && autoHDGen[0].value === 'True') {
              //    // Az esedékességek beállítása az egységárak esedékességeinél leírt módon történik.
              //    // Megadásuk kötelező, ha a kiválasztott tevékenységhez tartozóan az FlgTask.AutoHDGen mező értéke 1,
              //    // azaz automatikusan generálunk majd hozzájuk munkalapot.

              //    // Nem csak ebben az esetben kell betölteni őket, mert ettől csak kötelező a megadása, de ezen kívül is meg lehet őket adni!
              //}
            } else {
              vm.disableF2 = true;
            }
          }

          if (
            typeof (vm.formModel.TaskFrequencyId !== 'undefined') &&
            vm.formModel.TaskFrequencyId !== null &&
            vm.formModel.TaskFrequencyId !== 0
          ) {
            reloadMaturities('clear');
          }
        },
        TaskFrequencyId: function(selectedItem) {
          isAddCronExpressionDisabled();
          if (!vm.isAddCronExpressionDisabled) {
            reloadMaturities('byFrequency');
          }
        },
      };

      var syncValidators = {
        ValidFrom: {
          /**
           * @return {boolean}
           */
          MinDateValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validFromValue.isSameOrAfter(minValues);
          },
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidFromValidator: function(modelValue, viewValue) {
            if (vm.formModel.ValidTo === null) {
              return true;
            }

            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
        ValidTo: {
          /**
           * @return {boolean}
           */
          MinDateValidator: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validToValue.isSameOrAfter(minValues);
          },
          /**
           * @return {boolean}
           * @return {boolean}
           */
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            if (vm.formModel.ValidFrom === null) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
      };

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 || vm.formModel.isView;
          },
        },
        ValidTo: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 || vm.formModel.isView;
          },
        },
        BudgetId: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 || vm.formModel.isView;
          },
        },
        TaskType: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 || vm.formModel.isView;
          },
        },
        Task: {
          'templateOptions.disabled': function() {
            return vm.formModel.ModelState === 3 || vm.formModel.isView;
          },
        },
        InventoryId: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ModelState === 3 || vm.formModel.isView) {
              return true;
            }

            return false;
          },
        },
        RoomSId: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ModelState === 3 || vm.formModel.isView) {
              return true;
            }

            return vm.disableF2;
          },
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract formly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          premiseId: vm.formModel.PremiseId,
          validFrom: vm.formModel.ValidFrom,
          propertyId: vm.formModel.PropertyId,
        };
      };

      vm.pageModel.Fields.TaskType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { budgetId: vm.formModel.BudgetId || 0, validFrom: vm.formModel.ValidFrom };
      };

      vm.pageModel.Fields.Task.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          budgetId: vm.formModel.BudgetId || 0,
          taskTypeId: vm.formModel.TaskType,
          premiseId: vm.formModel.PremiseId,
          validFrom: vm.formModel.ValidFrom,
          propertyId: vm.formModel.PropertyId,
        };
      };

      vm.pageModel.Fields.TaskFrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          budgetId: vm.formModel.BudgetId || 0,
          taskId: vm.formModel.Task,
          validFrom: vm.formModel.ValidFrom,
          taskTypeId: vm.formModel.TaskType,
          propertyId: vm.formModel.PropertyId,
          premiseId: vm.formModel.PremiseId,
        };
      };

      function reloadMaturities(withReload) {
        $http
          .get(
            'Task/PremiseCronExpressionList/?taskFrequencyId=' +
              vm.formModel.TaskFrequencyId +
              '&premiseTaskId=' +
              vm.formModel.PremiseTaskId
          )
          .then(function(response) {
            vm.monthCronModel = response.data.monthCronModel;
            vm.weekCronModel = response.data.weekCronModel;
            vm.dayCronModel = response.data.dayCronModel;

            vm.monthCronDtos = response.data.monthExpressions;
            vm.weekCronDtos = response.data.weekExpressions;
            vm.dayCronDtos = response.data.dayExpressions;
          });
      }

      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.type = 'textarea';
      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions['rows'] = 4;

      // Actions
      function save() {
        var params = {
          model: vm.formModel,
          monthCronExpressions: vm.cronModel['monthlyCronDtoList'],
          weekCronExpressions: vm.cronModel['weeklyCronDtoList'],
          dayCronExpressions: vm.cronModel['dailyCronDtoList'],
        };

        $http
          .post('Task/PremiseTaskSave', params)
          .then(function(response) {
            if (response.data.message) {
              toastr.warning(response.data.message);
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }

      // Crontab (kek)
      function isAddCronExpressionDisabled() {
        vm.isAddCronExpressionDisabled = !(
          vm.formModel.Task &&
          vm.formModel.Task > 0 &&
          vm.formModel.TaskFrequencyId &&
          vm.formModel.TaskFrequencyId > 0
        );
        return vm.isAddCronExpressionDisabled;
      }

      function reloadMaturities(reloadType) {
        $http
          .get(
            'Task/PremiseCronExpressionList/?taskFrequencyId=' +
              vm.formModel.TaskFrequencyId +
              '&premiseTaskId=' +
              (reloadType === 'full' ? vm.formModel.PremiseTaskId : 0)
          )
          .then(function(response) {
            vm.cronModel = {
              monthlyCronDtoList: response.data.monthExpressions,
              weeklyCronDtoList: response.data.weekExpressions,
              dailyCronDtoList: response.data.dayExpressions,
            };
          });
      }

      reloadMaturities('full');
      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;

      if (vm.formModel.isView) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
        vm.formIsView = true;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ChangePasswordCtrl', [
    '$state',
    '$stateParams',
    '$http',
    'model',
    'AuthService',
    '$uibModalInstance',
    function($state, $stateParams, $http, model, authService, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ChangePasswordCtrl', stateParams);
      }
      var vm = this;

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setSyncValidator('VerifyPassword', 'VerifyPasswordNotEqual', function(modelValue, viewValue) {
          return modelValue === vm.dataModel.NewPassword;
        });
        fs.setOnChangeFunction('NewPassword', function(selectedItem) {
          vm.pageModel.Fields.VerifyPassword.FormlyFieldDescriptor.formControl.$validate();
        });
        generateForm(vm);
      }

      init();
      //Nick használata jelszó mentésnél
      vm.dataModel.NickName = authService.user.id;
      // Jelszóváltoztatás
      vm.changePassword = function() {
        $http
          .post('Auth/ChangePassword', vm.dataModel)
          .then(function(data) {
            toastr.success('Sikeres jelszóváltoztatás!');
            uibModalInstance.close();
          })
          .catch(function(e) {});
      };
      vm.cancel = function() {
        uibModalInstance.dismiss();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ChangePasswordNoLoginCtrl', [
    '$http',
    'model',
    'LanguageService',
    '$uibModalInstance',
    function($http, model, languageService, uibModalInstance) {
      var vm = this;
      vm.labels = languageService.getDictionary().changePassword;
      vm.dataModel = {};
      vm.dataModel.userId = model.userId;
      vm.dataModel.Password = model.password;

      vm.formFields = [
        {
          key: 'userId',
          type: 'input',
          templateOptions: {
            type: 'input',
            label: vm.labels?.user,
            disabled: true,
            required: true,
          },
        },
        {
          key: 'Password',
          type: 'input',
          templateOptions: {
            type: 'password',
            label: vm.labels?.currentPassword,
            required: true,
            disabled: !!model.password,
          },
        },
        {
          key: 'newPassword',
          type: 'input',
          templateOptions: {
            type: 'password',
            label: vm.labels?.newPassword,
            required: true,
            onBlur: function(modelValue, field, scope, e) {
              vm.formFields[3].formControl?.$validate();
            },
          },
        },
        {
          key: 'verifyPassword',
          type: 'input',
          templateOptions: {
            required: true,
            type: 'password',
            label: vm.labels?.verifyPassword,
          },
          validators: {
            VerifyPasswordNotEqual: {
              expression: function(viewValue, modelValue, scope) {
                var value = modelValue || viewValue;
                return modelValue === vm.dataModel?.newPassword;
              },
            },
          },
        },
      ];

      vm.changePassword = function() {
        $http
          .post('Auth/ChangePasswordNoLogin', vm.dataModel)
          .then(function(data) {
            if (!!data?.data?.message) {
              toastr.error(data.data.message);
            } else {
              toastr.success(vm.labels?.passwordChangeSuccessful ?? 'Sikeres jelszóváltoztatás!');
              uibModalInstance.close();
            }
          })
          .catch(function(e) {
            toastr.error(vm.labels?.errorChangingPassword ?? 'Hiba a jelszóváltoztatás során!');
          });
      };
      vm.cancel = function() {
        uibModalInstance.dismiss();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UserDetailsCtrl', [
    '$state',
    '$http',
    'AuthService',
    function($state, $http, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserDetailsCtrl', stateParams);
      }
      var vm = this;

      // TODO
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UserLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UserMenuCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UserMenuCtrl', stateParams);
      }
      var vm = this;

      vm.logout = authService.logout;

      vm.changePassword = function() {
        $state.go('user.changepassword');
      };

      vm.userDetails = function() {
        //$state.go("user.details");
      };

      vm.main = function() {
        $state.go('main');
      };
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      user: {
        url: '/user',
        templateUrl: 'App/User/UserLayout.html',
        controller: 'UserLayoutCtrl as vm',
        deepStateRedirect: { default: { state: 'user.details' } },
        ncyBreadcrumb: {
          label: 'Felhasználó',
        },
      },
      //"user.details": {
      //    url: "/details",
      //    views: {
      //        "menu": {
      //            templateUrl: "App/User/UserMenu.html",
      //            controller: "UserMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/User/UserDetails.html",
      //            controller: "UserDetailsCtrl as vm"
      //        }
      //    },
      //    ncyBreadcrumb: {
      //        label: "Adataim"
      //    }
      //},
      'user.changepassword': {
        url: '/change-password',
        views: {
          menu: {
            templateUrl: 'App/User/UserMenu.html',
            controller: 'UserMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/User/ChangePassword.html',
            controller: 'ChangePasswordCtrl as vm',
          },
        },
        ncyBreadcrumb: {
          label: 'Jelszóváltoztatás',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "User");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

'use strict';

function sbBudgetitemComponent(gridService, $scope, $http, $state, $stateParams, WalService, $uibModal, $filter) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeSubItemTab = 0;
  ctrl.activeTab = 0;
  ctrl.DetailGridKeys = {};
  ctrl.selectedPeriod = {};
  ctrl.expandedBudgetItemRow;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  ctrl.$onInit = function $onInit() {
    ctrl.filterTab = function(item) {
      var retVal = item.key !== 'TabItemProperty';
      return retVal;
    };

    ctrl.pageModel.Grids.GridBudgetItem.Columns['8'].hidden = false;
    ctrl.pageModel.Grids.GridBudgetItem.Columns['9'].hidden = false;
    setColumnName(ctrl.formModel.SelectedFinancialYear);
    toggleFinancialHistoryColumn(ctrl.formModel.FinancialHistory);

    var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
      ctrl.pageModel.Tabs,
      ctrl.pageModel.Panels,
      ctrl.pageModel.Grids,
      ['PanelBudgetItem', 'PanelCondominium', 'PanelPMFee', 'PanelPremise', 'PanelUnitPrice', 'PanelItemPropertySum'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: GridDataHandler,
          selectFunction: changeSubGridFilter,
        };
      }
    );

    generatedGridTabs.gridOptions['GridBudgetItem'].disableOptions = { GridStateSave: true, GridStateRestore: true };

    var generatedSubGridTabs = gridService.CreateGridContainerTabsWithGrids(
      ctrl.pageModel.Tabs,
      ctrl.pageModel.Panels,
      ctrl.pageModel.Grids,
      ['PanelItemPeriod', 'PanelItemJobNum'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: SubGridDataHandler,
          selectFunction: changeSubGridFilter,
        };
      }
    );

    generatedGridTabs.gridOptions.GridItemPropertySum.dataSource.transport.read.data = PropGridDataHandler;

    function PropGridDataHandler(e) {
      return {
        budgetModifyId: ctrl.budgetModifyId,
        periodid: ctrl.formModel.PeriodId,
        propertyId: ctrl.selectedPropertyId,
      };
    }

    ///////////////////////////////////////////////////////////////////////////////////////////
    ///////////////////////////////[GridCondominium Tab Functions]/////////////////////////////

    ctrl.privatePropertyGridIdField = ctrl.pageModel.Grids['GridCondominiumPrivateProperty'].IdColumn;
    ctrl.privatePropertyGrid = ctrl.pageModel.Grids['GridCondominiumPrivateProperty'];

    ctrl.privatePropertyGridOptions = getGridOptions(
      ctrl.privatePropertyGrid,
      'Budget/BudgetCondominiumPrivatePropertyList/',
      selectRow,
      function() {
        return { budgetId: ctrl.budgetId, condominiumValidFrom: ctrl.formModelCondominiumValidFrom };
      }
    );

    ctrl.pageModel.Grids.GridCondominium.Columns['1'].title = 'TH. összes';
    ctrl.pageModel.Grids.GridCondominiumPrivateProperty.Columns['1'].title = 'ST. összes';

    ctrl.pageModel.Grids.GridCondominium.Columns['2'].title = 'TH. vízórás';
    ctrl.pageModel.Grids.GridCondominiumPrivateProperty.Columns['2'].title = 'ST. vízórás';

    ctrl.pageModel.Grids.GridCondominium.Columns['3'].title = 'TH. vízóra nélküli';
    ctrl.pageModel.Grids.GridCondominiumPrivateProperty.Columns['3'].title = 'ST. vízóra nélküli';

    $http({
      method: 'GET',
      url: 'Budget/BudgetCondominiumValidFromComboList',
      params: { budgetId: ctrl.budgetId },
    }).then(function successCallback(response) {
      ctrl.BudgetCondominiumValidFrom = response.data;
    });

    var selectRow = function(ActualElement) {
      if (!ActualElement) {
        return false;
      }
      //clear Selection on other grid
      if (ctrl.CondominiumGridSelected) {
        var gridRef = $('#GridCondominium').data('kendoGrid');
        gridRef.clearSelection();
      }
      //----------------------------
      ctrl.CondominiumGridSelected = false;
      $scope.$applyAsync();
    };

    ctrl.showBudgetCondominiumDDL = function showBudgetCondominiumDDL() {
      var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
      if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
        var name = activeTab.gridName;
        if (name === 'GridCondominium' && ctrl.active == true) {
          return true;
        } else {
          return false;
        }
      }
    };

    ctrl.showBudgetCondominiumDDLOnChange = function showCondominiumDDLOnChange() {
      var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
      ctrl.CondominiumValidFromValue = ctrl.BudgetCondiminiumPeriods.ValidFrom;

      //Store data to the global formModel
      ctrl.formModelCondominiumValidFrom = ctrl.CondominiumValidFromValue;

      selectedGrid.dataSource.read({
        budgetId: ctrl.budgetId,
        condominiumValidFrom: ctrl.CondominiumValidFromValue,
      });

      ctrl.privatePropertyGrid.dataSource.read();
    };

    var customCallbackFunctions = {
      FinancialHistory: function(state) {
        toggleFinancialHistoryColumn(state);
        if (ctrl.isReadOnly !== true) {
          $http({
            method: 'GET',
            url: 'Budget/SetFinancialHistoryBit',
            params: { budgetId: ctrl.budgetId, state: state },
          })
            .then(function(response) {})
            .catch(function(e) {});
        }
      },
    };

    var onChangeFunctions = {
      ServiceGroupType: function(selectedItem) {
        if (selectedItem && ctrl.budgetDate) {
          ReadItemGrid();
        }
      },
      ServiceGroup: function(selectedItem) {
        if (selectedItem && ctrl.budgetDate) {
          ReadItemGrid();
        }
      },
      BudSubGroup: function(selectedItem) {
        if (selectedItem && ctrl.budgetDate) {
          ReadItemGrid();
        }
      },
      PeriodId: function(selectedItem) {
        ctrl.showBudgetItemsDDLOnChange();
      },
      ItemView: function(selectedItem) {
        if (!!selectedItem.key) {
          ReadItemGrid();
          if (ctrl.isReadOnly !== true) {
            $http({
              method: 'GET',
              url: 'Budget/SetItemView',
              params: { budgetId: ctrl.budgetId, itemView: selectedItem.key },
            })
              .then(function(response) {})
              .catch(function(e) {});
          }
        }
      },
    };

    InsertOnChangeFunctions(ctrl.pageModel, onChangeFunctions);
    InsertCustomCallbackFunctions(ctrl.pageModel, customCallbackFunctions);

    generatedGridTabs.gridOptions['GridBudgetItem'].disableOptions = { GridStateSave: true, GridStateRestore: true };

    ctrl.subItemTabs = generatedGridTabs.tabs;
    ctrl.subGridOptions = generatedGridTabs.gridOptions;
    ctrl.subGrids = generatedGridTabs.grids;

    ctrl.detailTabs = generatedSubGridTabs.tabs;
    ctrl.detailGridOptions = generatedSubGridTabs.gridOptions;
    ctrl.detailGrids = generatedSubGridTabs.grids;

    //oldal lapozás eltávolítása
    ctrl.subGridOptions.GridBudgetItem.pageable = false;
    ctrl.subGridOptions.GridBudgetItem.filterable = false;
    ctrl.subGridOptions.GridBudgetItem.columnMenu = false;

    angular.forEach(ctrl.detailGridOptions, function(value, key) {
      value.pageable = false;
      value.filterable = false;
      value.columnMenu = false;
    });

    //Költségvetés tételek manipuláció (színezés, detail elrejtés, checkbox javítás, dátum javítás)
    ctrl.subGridOptions.GridBudgetItem.dataBound = function(e) {
      //sticky header beállítása
      e.sender.content
        .parent()
        .find('.k-grid-header')
        .addClass('sticky');

      var rows = e.sender.tbody.children();

      for (var j = 0; j < rows.length; j++) {
        var row = $(rows[j]);
        var dataItem = e.sender.dataItem(row);

        if (!!ctrl.expandedBudgetItemRow && dataItem.BudgetItemId == ctrl.expandedBudgetItemRow) {
          e.sender.expandRow(row);
        }

        var level = 2;
        if (!dataItem.get('ServiceId')) level = 1;
        if (!dataItem.get('ServiceGroupId')) level = 0;

        row[0].classList.add('row-level-' + level);

        var column1 =
          $(e.sender.thead.children()[0])
            .find('[data-field="SumFinancialYear"]')
            .attr('data-index') *
            1 +
          1;
        var column2 =
          $(e.sender.thead.children()[0])
            .find('[data-field="SumFinancialYearMinus1"]')
            .attr('data-index') *
            1 +
          1;
        var column3 =
          $(e.sender.thead.children()[0])
            .find('[data-field="SumFinancialYearMinus2"]')
            .attr('data-index') *
            1 +
          1;

        [row.children().eq(column1), row.children().eq(column2), row.children().eq(column3)].forEach(function(el) {
          el[0].classList.add('cell-level-' + level);
        });

        //Detail elrejtése
        row.find('.k-hierarchy-cell a').css('visibility', level == 2 ? 'visible' : 'hidden');
      }
    };

    ctrl.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(ctrl.pageModel);

    ctrl.SelectedServicesReset = true;

    ctrl.pageModel.Fields.SelectedServices.FormlyFieldDescriptor.templateOptions.options.whereCondition = selectedServiceWhereCondition;

    ///////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////[GridItemPropertySum Tab Grid Functions]///////////////////////

    if (!!ctrl.pageModel.Fields.PeriodId.FormlyFieldDescriptor.templateOptions.options.dataSource) {
      ctrl.pageModel.Fields.PeriodId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        budgetId: ctrl.budgetId,
        budgetModifyId: ctrl.budgetModifyId,
      };
    }
  };

  function GridDataHandler(e) {
    return {
      budgetId: ctrl.budgetId,
      budgetDate: ctrl.budgetDate,

      serviceGroupType: ctrl.formModel.ServiceGroupType,
      serviceGroup: ctrl.formModel.ServiceGroup,
      budSubGroup: ctrl.formModel.BudSubGroup,

      itemView: ctrl.formModel.ItemView,
      condominiumValidFrom: ctrl.formModel.CondominiumValidFrom,

      //BudgetItemPropertySumGrid-hez tartozó változó
      BudgetItemPeriodId: ctrl.BudgetItemPeriodId,

      //BudgetITemPropertyGrid-hez tartozó változók
      budgetModifyId: ctrl.budgetModifyId,
      period: ctrl.DetailGridKeys.PeriodId,
      propertyId: ctrl.DetailGridKeys.PropertyId,
      tenement: ctrl.DetailGridKeys.Tenement,
      tenementName: ctrl.DetailGridKeys.TenementName,
    };
  }

  function SubGridDataHandler(e) {
    return {
      budgetItemId: !!ctrl.selectedBudgetItemRow ? ctrl.selectedBudgetItemRow.BudgetItemId : 0,
    };
  }

  function changeSubGridFilter(ActualElement) {
    if (!ActualElement) {
      return false;
    }

    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var gridRef = $('#' + gridName).data('kendoGrid');

    if (gridName == 'GridCondominium') {
      //clear Selection on other grid
      if (!ctrl.CondominiumGridSelected) {
        var gridRef = $('#privatePropertyGrid').data('kendoGrid');
        gridRef.clearSelection();
      }
      //----------------------------
      ctrl.CondominiumGridSelected = true;
    }

    if (gridName == 'GridBudgetItem') {
      ctrl.selectedBudgetItemRow = ActualElement;

      ActualElement.Level = 2;
      if (!ActualElement.ServiceId) ActualElement.Level = 1;
      if (!ActualElement.ServiceGroupId) ActualElement.Level = 0;

      if (ActualElement.Level == 2 && ActualElement.BudgetItemId !== undefined) {
        if (!!ctrl.detailGrids['GridItemPeriod']) ctrl.detailGrids['GridItemPeriod'].dataSource.read();
        if (!!ctrl.detailGrids['GridItemJobNum']) ctrl.detailGrids['GridItemJobNum'].dataSource.read();
      }
    }

    if (gridName == 'GridPMFee') {
      ctrl.selectedPMFeeRow = ActualElement;
    }

    $scope.$applyAsync();
  }
  //#region Button visibility
  ctrl.showSubItemCreateButton = function showSubItemCreateButton() {
    if (ctrl.isReadOnly === true) return false;

    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem') {
        return false;
      }
      if (name === 'GridItemPropertySum' && ctrl.active == true) {
        return false;
      } else {
        return true;
      }
    }
  };

  ctrl.showSubItemEditButton = function showSubItemEditButton() {
    if (ctrl.isReadOnly === true) return false;

    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem') {
        return false;
      } else if (name === 'GridPMFee' && ctrl.active == true) {
        return true;
      } else if (name === 'GridUnitPrice' && ctrl.active == true) {
        return true;
      } else if (name === 'GridCondominium' && ctrl.active == true) {
        return true;
      } else if (name === 'GridBudgetItem' && ctrl.active == true) {
        return true;
      } else {
        return false;
      }
    }
  };

  ctrl.showSubItemDuplicateButton = function showSubItemDuplicateButton() {
    if (ctrl.isReadOnly === true) return false;
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridUnitPrice' && ctrl.active == true) {
        return true;
      } else {
        return false;
      }
    }
  };

  ctrl.showSubItemDeleteButton = function showSubItemDeleteButton() {
    if (ctrl.isReadOnly === true) return false;
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem') {
        return false;
      } else if (name === 'GridItemPropertySum' && ctrl.active == true) {
        return false;
      } else {
        return true;
      }
    }
  };

  ctrl.showSubItemGenerateNewFeeButton = function showSubItemGenerateNewFeeButton() {
    if (ctrl.isReadOnly === true) return false;
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridPMFee' && ctrl.active == true) {
        return true;
      } else {
        return false;
      }
    }
  };

  ctrl.showSubItemItemViewButton = function showSubItemItemViewButton() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem' && ctrl.active == true) {
        return true;
      } else {
        return false;
      }
    }
  };

  //Rejtett f4

  ctrl.isSubGridItemViewDisabled = function() {
    return false;
  };

  function selectedServiceWhereCondition() {
    return "BudgetModifyId~eq~'" + ctrl.budgetModifyId + "'";
  }

  ctrl.openItemViewF4 = function openItemViewF4() {
    ctrl.pageModel.Fields.SelectedServices.FormlyFieldDescriptor.templateOptions.options.whereCondition = selectedServiceWhereCondition;
    ctrl.pageModel.Fields.SelectedServices.FormlyFieldDescriptor.templateOptions.options.f4scope.openF4Modal();
  };
  //#endregion

  ////////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////[Subgrid Actions]//////////////////////////////////

  // Create sub item
  ctrl.createSubItem = function createSubItem() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var urlPrefix = gridName;
    var id = 0;
    var BudgetId = ctrl.budgetId;
    var gridRef = $('#' + gridName).data('kendoGrid');
    var selectedGridItems = GetSelectedGridItems(gridRef);
    if (urlPrefix === 'GridBudgetItem') {
      if (selectedGridItems.length === 0) {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return null;
      } else {
        $state.go('Budget.Budget.BudgetItemPeriodCreate', { id: selectedGridItems[0].BudgetItemId });
      }
    } else if (urlPrefix === 'GridPMFee') {
      var BudgetDateId = ctrl.budgetDate;

      var controllername = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Create';
      var modalname = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
      var url = 'Budget/' + controllername + '?id=' + id + '&BudgetId=' + BudgetId + '&BudgetDateId=' + BudgetDateId;

      var modalInstance = $uibModal.open({
        templateUrl: 'App/Budget/SubItems/' + modalname + '.html',
        controller: modalname + 'Ctrl',
        controllerAs: 'vm',
        resolve: {
          model: RouteResolveFunc(url),
        },
        backdrop: 'static',
      });

      modalInstance.result.then(function() {
        var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
        selectedGrid.dataSource.read();
      });
    } else if (urlPrefix === 'GridPremise') {
      var controllername = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Create';
      var modalname = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
      var url =
        'Budget/' +
        controllername +
        '?id=' +
        id +
        '&obPropertyId=' +
        ctrl.obPropertyId.Value +
        '&PropertyId=' +
        ctrl.propertyId.Value;

      var modalInstance = $uibModal.open({
        templateUrl: 'App/Budget/SubItems/' + modalname + '.html',
        controller: modalname + 'Ctrl',
        controllerAs: 'vm',
        resolve: {
          model: RouteResolveFunc(url),
        },
        backdrop: 'static',
      });

      modalInstance.result.then(function() {
        var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
        selectedGrid.dataSource.read();
      });
    } else if (urlPrefix === 'GridUnitPrice') {
      var controllername = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Create';
      var modalname = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
      var url = 'Budget/' + controllername + '?id=' + id + '&BudgetId=' + BudgetId + '&isDuplicate=' + false;

      var modalInstance = $uibModal.open({
        templateUrl: 'App/Budget/SubItems/' + modalname + '.html',
        controller: modalname + 'Ctrl',
        controllerAs: 'vm',
        resolve: {
          budgetUnitPriceId: id,
          model: RouteResolveFunc(url),
        },
        backdrop: 'static',
      });

      modalInstance.result.then(function() {
        var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
        selectedGrid.dataSource.read();
      });
    } else if (urlPrefix === 'GridCondominium') {
      var contollername = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Create';
      var modalname = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
      var url =
        'Budget/BudgetCondominiumCreate?id=' +
        id +
        '&BudgetId=' +
        BudgetId +
        '&condominiumUnitId=' +
        (!!selectedGridItems[0] ? selectedGridItems[0].CondominiumUnitId : 0) +
        '&validFrom=null';

      var modalInstance = $uibModal.open({
        templateUrl: 'App/Budget/SubItems/' + modalname + '.html',
        controller: modalname + 'Ctrl',
        controllerAs: 'vm',
        resolve: {
          budgetCondominiumId: id,
          model: RouteResolveFunc(url),
        },
        backdrop: 'static',
      });

      modalInstance.result.then(function() {
        var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];

        //Refresh the DDL
        $http({
          method: 'GET',
          url: 'Budget/BudgetCondominiumValidFromComboList',
          params: { budgetId: ctrl.budgetId },
        }).then(function successCallback(response) {
          ctrl.BudgetCondominiumValidFrom = response.data;
        });

        //Refresh the Grid
        selectedGrid.dataSource.read({
          budgetId: ctrl.budgetId,
          condominiumValidFrom: ctrl.CondominiumValidFromValue,
        });
      });
    } else {
      lockService.initiateUnlock(ctrl.securedProgramId, ctrl.securedId);
      $state.go('Budget.Budget.' + urlPrefix + 'Edit', { id: id, BudgetId: BudgetId });
    }
  };

  // Save the current sub item
  ctrl.editSubItem = function editSubItem() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var urlPrefix = gridName;

    var id = getSelectedSubGridItemId();

    //BudgetCondominium esetén csak módosítás van, így a 0-ás id esetén meg kell hívni a CreateSubItem részt paraméterezve
    if (urlPrefix === 'GridCondominium' && id == 0) {
      var gridRef = $('#' + gridName).data('kendoGrid');
      var selectedGridItems = GetSelectedGridItems(gridRef);
      var name = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
      var url =
        'Budget/BudgetCondominiumCreate?BudgetId=' +
        ctrl.budgetId +
        '&condominiumUnitId=' +
        (!!selectedGridItems && !!selectedGridItems[0] ? selectedGridItems[0].CondominiumUnitId : 0) +
        '&validFrom=' +
        ctrl.formModelCondominiumValidFrom;

      var modalInstance = $uibModal.open({
        templateUrl: 'App/Budget/SubItems/' + name + '.html',
        controller: name + 'Ctrl',
        controllerAs: 'vm',
        resolve: {
          budgetCondominiumId: id,
          model: RouteResolveFunc(url),
        },
        backdrop: 'static',
      });

      modalInstance.result.then(function() {
        var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];

        //Refresh the DDL
        $http({
          method: 'GET',
          url: 'Budget/BudgetCondominiumValidFromComboList',
          params: { budgetId: ctrl.budgetId },
        }).then(function successCallback(response) {
          ctrl.BudgetCondominiumValidFrom = response.data;
        });

        //Refresh the Grid
        selectedGrid.dataSource.read({
          budgetId: ctrl.budgetId,
          condominiumValidFrom: ctrl.CondominiumValidFromValue,
        });
      });
      return false;
    }

    if (!!id) {
      var BudgetId = ctrl.budgetId;

      if (urlPrefix === 'GridBudgetItem') {
        var gridRef = $('#GridItemPeriod').data('kendoGrid');
        var selectedGridItems = GetSelectedGridItems(gridRef);
        if (selectedGridItems.length === 0) {
          toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
          return null;
        } else {
          $state.go('Budget.Budget.BudgetItemPeriodEdit', { id: selectedGridItems[0].BudgetItemPeriodId });
        }
      } else if (urlPrefix === 'GridPMFee') {
        var BudgetDateId = ctrl.budgetDate;

        var name = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
        var url = 'Budget/' + name + '?id=' + id + '&BudgetId=' + BudgetId + '&BudgetDateId=' + BudgetDateId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/' + name + '.html',
          controller: name + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
          selectedGrid.dataSource.read();
        });
      } else if (urlPrefix === 'GridUnitPrice') {
        var name = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
        var url = 'Budget/' + name + '?id=' + id + '&BudgetId=' + BudgetId + '&isDuplicate=' + false;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/' + name + '.html',
          controller: name + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            budgetUnitPriceId: id,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
          selectedGrid.dataSource.read();
        });
      } else if (urlPrefix === 'GridCondominium') {
        var name = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
        var url = 'Budget/' + name + '?id=' + id;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/' + name + '.html',
          controller: name + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            budgetCondominiumId: id,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        //Refresh the DDL
        $http({
          method: 'GET',
          url: 'Budget/BudgetCondominiumValidFromComboList',
          params: { budgetId: ctrl.budgetId },
        }).then(function successCallback(response) {
          ctrl.BudgetCondominiumValidFrom = response.data;
        });

        //Refresh the Grid
        modalInstance.result.then(function() {
          var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
          selectedGrid.dataSource.read({
            budgetId: ctrl.budgetId,
            condominiumValidFrom: ctrl.CondominiumValidFromValue,
          });
        });
      } else {
        lockService.initiateUnlock(ctrl.securedProgramId, ctrl.securedId);
        $state.go('Budget.Budget.' + urlPrefix + 'Edit', { id: id, BudgetId: BudgetId });
      }
    } else toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
  };

  // Deletes the selected item(s) of the active subItem grid
  ctrl.deleteSubItem = function deleteSubItem() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var urlPrefix = gridName;
    var item = getSelectedSubGridItem();
    var id = getSelectedSubGridItemId();

    if (!!id) {
      if (urlPrefix === 'GridBudgetItem') {
        var gridRef = $('#GridItemPeriod').data('kendoGrid');
        var selectedGridItems = [];
        ctrl.expandedBudgetItemRow = Object.keys(ctrl.selectedPeriod)[0];

        Object.keys(ctrl.selectedPeriod).forEach(function(key) {
          ctrl.selectedPeriod[key].forEach(function(value) {
            selectedGridItems.push(value);
          });
        });

        if (selectedGridItems.length === 0) {
          toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
          return null;
        } else {
          bootbox.dialog({
            message: ctrl.pageModel.Messages.ConfirmDelete,
            title: ctrl.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: ctrl.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: ctrl.pageModel.Messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .post('Budget/' + urlPrefix.replace(/grid/gi, '') + 'Delete', {
                      selectedPeriodIds: selectedGridItems,
                    })
                    .then(function(result) {
                      toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                      ctrl.selectedPeriod = {};
                      var gridItemRef = $('#GridBudgetItem').data('kendoGrid');
                      if (result.data.RefreshBudgetItemGrid === true) {
                        delete ctrl.expandedBudgetItemRow;
                      }
                      gridItemRef.dataSource.read();
                    });
                },
              },
            },
          });
        }
      } else if (urlPrefix === 'GridPremise') {
        var name = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Del';
        var url = 'Budget/' + name + '?id=' + id;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/' + name + '.html',
          controller: name + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
          selectedGrid.dataSource.read();
        });
      } else if (urlPrefix === 'GridCondominium') {
        bootbox.dialog({
          message: ctrl.pageModel.Messages.ConfirmDelete,
          title: ctrl.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: ctrl.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: ctrl.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Budget/' + urlPrefix + 'Delete/' + id).then(function() {
                  toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                  var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
                  selectedGrid.dataSource.read({
                    budgetId: ctrl.budgetId,
                    condominiumValidFrom: ctrl.CondominiumValidFromValue,
                  });
                });
              },
            },
          },
        });
      } else if (urlPrefix === 'GridUnitPrice') {
        bootbox.dialog({
          message: ctrl.pageModel.Messages.ConfirmDelete,
          title: ctrl.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: ctrl.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: ctrl.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http({
                  method: 'GET',
                  url: 'Budget/' + urlPrefix + 'Delete/',
                  params: { id: id, budgetId: ctrl.budgetId },
                }).then(function successCallback(response) {
                  toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                  var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
                  selectedGrid.dataSource.read();
                });
              },
            },
          },
        });
      } else {
        bootbox.dialog({
          message: ctrl.pageModel.Messages.ConfirmDelete,
          title: ctrl.pageModel.Messages.Warning,
          buttons: {
            cancel: {
              label: ctrl.pageModel.Messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: ctrl.pageModel.Messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Budget/' + urlPrefix + 'Delete/' + id).then(function() {
                  toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                  var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
                  selectedGrid.dataSource.read();
                });
              },
            },
          },
        });
      }
    } else {
      toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
    }
  };

  ctrl.duplicateSubItem = function duplicateSubItem() {
    // ToDo: Másolás megvalósítása
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var urlPrefix = gridName;
    var id = getSelectedSubGridItemId();
    var BudgetId = ctrl.budgetId;

    if (!!id) {
      if (urlPrefix === 'GridUnitPrice') {
        var controllername = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Duplicate';
        var modalname = 'Budget' + urlPrefix.replace(/grid/gi, '') + 'Edit';
        var url = 'Budget/' + controllername + '?id=' + id + '&BudgetId=' + BudgetId + '&isDuplicate=' + true;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/' + modalname + '.html',
          controller: modalname + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            budgetUnitPriceId: id,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function() {
          var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
          selectedGrid.dataSource.read();
        });
      }
    } else {
      toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
    }
  };

  ctrl.generateNewFeeSubItem = function generateNewFeeSubItem() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var urlPrefix = gridName;
    var id = getSelectedSubGridItemId();
    var BudgetId = ctrl.budgetId;

    if (!!id) {
      if (urlPrefix === 'GridPMFee') {
        if (!!ctrl.selectedPMFeeRow.ValidTo) {
          toastr.warning(
            'Csak olyan rögzített IK díj alapján lehet díjakat generálni, amelynél az érvényesség vége nincs megadva.',
            ctrl.pageModel.Messages.Warning
          );
          return false;
        }

        $http
          .post('Budget/BudgetClosableFee', { id: id })
          .then(function(response) {
            if (response.data.Dto.ContrFeeId.length > 0) {
              bootbox.dialog({
                message:
                  'A díjfrissítés során ' +
                  response.data.Dto.ContrFeeId.length +
                  ' db szerződés díjsor lezárásra kerül. Biztosan kívánja folytatni a műveletet?',
                title: ctrl.pageModel.Messages.Warning,
                buttons: {
                  cancel: {
                    label: ctrl.pageModel.Messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: ctrl.pageModel.Messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      generateNewFeeCore(id);
                    },
                  },
                },
              });
            } else {
              generateNewFeeCore(id);
            }
          })
          .catch(function(response) {
            toastr.error(ctrl.pageModel.Messages.SaveFailed);
          });
      }
    } else {
      toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
    }
  };

  function generateNewFeeCore(id) {
    $http
      .post('Budget/BudgetGenerateNewFee', { id: id })
      .then(function(response) {
        console.log('BudgetGenerateNewFee', response);
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/GenerateContrFeeResultModal.html',
          controller: 'GenerateContrFeeResultModalCtrl as vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            model: {
              messages: ctrl.pageModel.Messages,
              grid: ctrl.pageModel.Grids['GenerateContrFeeResult'],
              dto: {
                RowAll: response.data.Dto.RowAll,
                RowSuccess: response.data.Dto.RowSuccess,
                ResultList: response.data.Dto.ResultList,
              },
            },
          },
        });
      })
      .catch(function(response) {
        toastr.error(ctrl.pageModel.Messages.SaveFailed);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////[Common Helper Functions]/////////////////////////////////

  ctrl.isSubGridCreateDisabled = function() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem' && ctrl.active == true) {
        return !(
          !!ctrl.selectedBudgetItemRow &&
          !!ctrl.selectedBudgetItemRow.BudgetItemId &&
          ctrl.selectedBudgetItemRow.Level == 2 &&
          ctrl.selectedBudgetItemRow.PeriodCount < 12
        );
      } else if (name === 'GridPremise' && ctrl.active == true) {
        return false;
      } else if (name === 'GridPMFee' && ctrl.active == true) {
        return false;
      } else if (name === 'GridUnitPrice' && ctrl.active == true) {
        return false;
      } else if (name === 'GridCondominium' && ctrl.active == true) {
        return !ctrl.CondominiumGridSelected;
      } else {
        return true;
      }
    }
  };

  ctrl.isSubGridEditDisabled = function() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem' && ctrl.active == true) {
        return !(
          !!ctrl.selectedBudgetItemRow &&
          !!ctrl.selectedBudgetItemRow.SelectedBudgetItemPeriod &&
          !!ctrl.selectedBudgetItemRow.SelectedBudgetItemPeriod.BudgetItemPeriodId
        );
      } else if (name === 'GridPremise' && ctrl.active == true) {
        return false;
      } else if (name === 'GridPMFee' && ctrl.active == true) {
        return false;
      } else if (name === 'GridUnitPrice' && ctrl.active == true) {
        return false;
      } else if (
        name === 'GridCondominium' &&
        ctrl.active == true &&
        !!ctrl.CondominiumValidFromValue &&
        ctrl.CondominiumGridSelected
      ) {
        return getSelectedSubGridItemId() === undefined;
      } else {
        return true;
      }
    }
  };

  ctrl.isSubGridDeleteDisabled = function() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridBudgetItem' && ctrl.active == true) {
        return Object.values(ctrl.selectedPeriod).length == 0;
      } else if (name === 'GridPremise' && ctrl.active == true) {
        return false;
      } else if (name === 'GridPMFee' && ctrl.active == true) {
        return false;
      } else if (name === 'GridUnitPrice' && ctrl.active == true) {
        return false;
      } else if (
        name === 'GridCondominium' &&
        ctrl.active === true &&
        !!ctrl.CondominiumValidFromValue &&
        ctrl.CondominiumGridSelected
      ) {
        return !getSelectedSubGridItemId();
      } else {
        return true;
      }
    }
    return true;
  };

  ctrl.isSubGridGenerateNewFeeDisabled = function() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridPMFee' && ctrl.active == true) {
        return !ctrl.selectedPMFeeRow;
      } else {
        return true;
      }
    }
  };

  ctrl.WAL = function WAL() {
    switch (ctrl.activeSubItemTab) {
      case 0:
        WalService.NavigateToWal('Budget', 'BudgetCustomItemWal', 'FlgBudgetItemView');
        break;
      case 1:
        WalService.NavigateToWal('Budget', 'BudgetCondominiumWal', 'FlgBudgetCondominiumView');
        break;
      case 2:
        WalService.NavigateToWal('Budget', 'BudgetPMFeeWal', 'FlgBudgetPMFeeView');
        break;
      case 3:
        WalService.NavigateToWal('Budget', 'BudgetItemPropertySumWal', 'FlgBudgetItemPropertySumView');
        break;
      case 4:
        WalService.NavigateToWal('Budget', 'BudPremiseWal', 'FlgBudPremiseView');
        break;
      case 5:
        WalService.NavigateToWal('Budget', 'BudgetUnitPriceCollectionWal', 'FlgBudgetUnitPriceCollectionView');
        break;
      default:
        break;
    }
  };

  ctrl.showBudgetItemsDDL = function showBudgetItemsDDL() {
    var activeTab = ctrl.subItemTabs[ctrl.activeSubItemTab];
    if ('undefined' !== typeof activeTab && 'gridName' in activeTab) {
      var name = activeTab.gridName;
      if (name === 'GridItemPropertySum' && ctrl.active == true) {
        return true;
      } else {
        return false;
      }
    }
  };

  ctrl.showBudgetItemsDDLOnChange = function showBudgetItemsDDLOnChange() {
    var selectedGrid = ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]];
    selectedGrid.dataSource.read();
  };

  //Rejtett F4 változik:
  $scope.$watch('$ctrl.formModel.SelectedServices', function(newItem, oldItem) {
    newItem = Array.isArray(newItem) ? newItem : [];
    oldItem = Array.isArray(oldItem) ? oldItem : [];
    if (newItem.length === oldItem.length && newItem.every((el, ix) => el === oldItem[ix])) {
      //nem változott
    } else {
      $http({
        method: 'POST',
        url: 'Budget/SetToBePlanedBit',
        data: { budgetModifyId: ctrl.budgetModifyId, serviceId: newItem },
      })
        .then(function(response) {
          ReadItemGrid();
        })
        .catch(function(e) {});
    }
  });

  //BudgetModifyId  változik:
  $scope.$watch('$ctrl.budgetModifyId', function(newItem, oldItem) {
    //Tesztelés minden változás figyelésével:
    if (1 === 1 || newItem !== oldItem) {
      ctrl.SelectedServicesReset = false;
      $http({
        method: 'GET',
        url: 'Budget/GetBudgetItemFilters',
        params: { budgetId: ctrl.budgetId, budgetModifyId: ctrl.budgetModifyId },
      }).then(function successCallback(response) {
        if (response) {
          setColumnName(response.data.Dto.SelectedFinancialYear);
          toggleFinancialHistoryColumn(response.data.Dto.FinancialHistory);
          ctrl.formModel.SelectedServices = response.data.Dto.SelectedServices;
          ctrl.formModel.FinancialHistory = response.data.Dto.FinancialHistory;
          ctrl.formModel.ItemView = ctrl.budgetItemView || response.data.Dto.ItemView;
          ctrl.SelectedServicesReset = true;
          ReadItemGrid();
        }
      });
    }
  });

  ctrl.resetBudgetItemsFilters = function() {
    ctrl.formModel.ServiceGroupType = null;
    ctrl.formModel.ServiceGroup = null;
    ctrl.formModel.BudSubGroup = null;
    ReadItemGrid();
  };

  function ReadItemGrid() {
    //ctrl.subGrids['GridBudgetItem']?.dataSource.read();
    ctrl.subGrids[ctrl.subGrids[ctrl.activeSubItemTab]]?.dataSource.read();
    if (ctrl.activeSubItemTab == 2) {
      ctrl.pageModel.Fields.PeriodId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
        budgetId: ctrl.budgetId,
        budgetModifyId: ctrl.budgetModifyId,
      });
    }
  }

  function toggleFinancialHistoryColumn(state) {
    ctrl.pageModel.Grids.GridBudgetItem.Columns['8'].hidden = !state;
    ctrl.pageModel.Grids.GridBudgetItem.Columns['9'].hidden = !state;

    if (!ctrl.subItemTabs || ctrl.subItemTabs[ctrl.activeSubItemTab].gridName !== 'GridBudgetItem') return false;

    if (state === true) {
      !!ctrl.subGrids && !!ctrl?.subGrids['GridBudgetItem'] && ctrl.subGrids['GridBudgetItem'].showColumn(9);
      !!ctrl.subGrids && !!ctrl?.subGrids['GridBudgetItem'] && ctrl.subGrids['GridBudgetItem'].showColumn(8);
    } else {
      !!ctrl.subGrids && !!ctrl?.subGrids['GridBudgetItem'] && ctrl.subGrids['GridBudgetItem'].hideColumn(8);
      !!ctrl.subGrids && !!ctrl?.subGrids['GridBudgetItem'] && ctrl.subGrids['GridBudgetItem'].hideColumn(9);
    }

    if (!!ctrl.subGrids && !!ctrl?.subGrids['GridBudgetItem']) {
      let columns = ctrl.subGrids['GridBudgetItem'].columns.filter(function(column) {
        return !column.hidden;
      });

      let width = ctrl.subGrids['GridBudgetItem'].wrapper.width();
      columns.map(column => {
        ctrl.subGrids['GridBudgetItem'].resizeColumn(column, (width - 28) / columns.length);
      });
    }
  }

  function getSelectedSubGridItem() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var gridRef = $('#' + gridName).data('kendoGrid');
    var selectedItems = GetSelectedGridItems(gridRef);

    if (!!selectedItems[0] && !!ctrl.pageModel.Grids[gridName]) {
      return selectedItems[0];
    }
    return undefined;
  }

  function getSelectedSubGridItemId() {
    var gridName = ctrl.subItemTabs[ctrl.activeSubItemTab].gridName;
    var item = getSelectedSubGridItem();

    if (!!item) {
      return item[ctrl.pageModel.Grids[gridName].IdColumn];
    }
    return undefined;
  }

  //Oszlop nevek beállítása
  function setColumnName(year) {
    let selectedFinancialYear = new moment(year, kendo.culture().calendar.patterns.d.toUpperCase()).year();

    ctrl.pageModel.Grids.GridBudgetItem.Columns['7'].title = 'Tény érték ' + selectedFinancialYear;
    ctrl.pageModel.Grids.GridBudgetItem.Columns['8'].title = 'Tény érték ' + (selectedFinancialYear - 1);
    ctrl.pageModel.Grids.GridBudgetItem.Columns['9'].title = 'Tény érték ' + (selectedFinancialYear - 2);

    if (ctrl.subGrids && ctrl.subGrids['GridBudgetItem']) {
      let thead = ctrl.subGrids['GridBudgetItem'].thead;
      if (!!thead) {
        let sfy0 = thead.find("[data-field~='SumFinancialYear']").html();
        thead
          .find("[data-field~='SumFinancialYear']")
          .html(
            sfy0.replaceAll(
              /(<span class="k-column-title">)(.*?)(<\/span>)/gi,
              '<span class="k-column-title">Tény érték ' + selectedFinancialYear + '</span>'
            )
          );
        let sfy1 = thead.find("[data-field~='SumFinancialYearMinus1']").html();
        thead
          .find("[data-field~='SumFinancialYearMinus1']")
          .html(
            sfy1.replaceAll(
              /(<span class="k-column-title">)(.*?)(<\/span>)/gi,
              '<span class="k-column-title">Tény érték ' + (selectedFinancialYear - 1) + '</span>'
            )
          );
        let sfy2 = thead.find("[data-field~='SumFinancialYearMinus2']").html();
        thead
          .find("[data-field~='SumFinancialYearMinus2']")
          .html(
            sfy2.replaceAll(
              /(<span class="k-column-title">)(.*?)(<\/span>)/gi,
              '<span class="k-column-title">Tény érték ' + (selectedFinancialYear - 2) + '</span>'
            )
          );
      }
    }
  }
}

const sbBudgetitemComponentOptions = {
  templateUrl: 'App/Budget/budgetitem/budgetitem.component.html',
  controller: sbBudgetitemComponent,
  transclude: true,
  bindings: {
    budgetId: '<',
    budgetModifyId: '<',
    budgetDate: '<',
    obPropertyId: '<',
    propertyId: '<',
    budgetItemView: '<',
    active: '<',
    isReadOnly: '<',
    formModel: '<',
    pageModel: '<',
    propertydetailFormModel: '<',
    propertydetailPageModel: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbBudgetitem: sbBudgetitemComponentOptions,
  };

  const sbBudgetitemModule = angular.module('sbBudgetitem', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbBudgetitemModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbBudgetitemDetailComponent(gridService, $scope, $http, $state, stateServiceForBudgetDetailGrid) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  ctrl.$onInit = function $onInit() {
    ctrl.tabs = ctrl.pageModel.Tabs;
    ctrl.panels = ctrl.pageModel.Panels;
    ctrl.grids = ctrl.pageModel.Grids;
    ctrl.actions = ctrl.pageModel.Actions;

    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      angular.copy(ctrl.grids),
      ['PanelItemPeriod', 'PanelItemJobNum'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        gridModel.Id = ctrl.budgetItem.uid;
        return {
          gridModel,
          transportData: function() {
            return {
              budgetItemId: ctrl.budgetItem.BudgetItemId,
            };
          },
          selectFunction: function(actualElement) {
            ctrl.budgetItem.SelectedBudgetItemPeriod = actualElement;
            $scope.$applyAsync();
          },
        };
      }
    );

    ctrl.itemCreate = function() {
      $state.go('Budget.Budget.BudgetItemPeriodCreate', { id: ctrl.budgetItem.BudgetItemId });
    };
    ctrl.itemEdit = function() {
      $state.go('Budget.Budget.BudgetItemPeriodEdit', {
        id: ctrl.budgetItem.SelectedBudgetItemPeriod.BudgetItemPeriodId,
      });
    };
    ctrl.itemDelete = function() {
      if ((ctrl.selectedPeriod[ctrl.budgetItem.BudgetItemId]?.length || 0) === 0) {
        toastr.warning(ctrl.pageModel.Messages.NotSelectedItem, ctrl.pageModel.Messages.Warning);
        return null;
      }
      ctrl.expandedRow = ctrl.budgetItem.BudgetItemId;
      bootbox.dialog({
        message: ctrl.pageModel.Messages.ConfirmDelete,
        title: ctrl.pageModel.Messages.Warning,
        buttons: {
          cancel: {
            label: ctrl.pageModel.Messages.Cancel,
            className: 'btn-default',
            callback: function() {},
          },
          confirm: {
            label: ctrl.pageModel.Messages.Ok,
            className: 'btn-primary',
            callback: function() {
              $http
                .post('Budget/BudgetItemDelete', {
                  selectedPeriodIds: ctrl.selectedPeriod[ctrl.budgetItem.BudgetItemId],
                })
                .then(function(result) {
                  toastr.success(ctrl.pageModel.Messages.DeleteSuccessful);
                  Object.keys(ctrl.selectedPeriod || {}).forEach(function(property) {
                    delete ctrl.selectedPeriod[property];
                  });
                  stateServiceForBudgetDetailGrid.setValue([]);
                  var gridItemRef = $('#GridBudgetItem').data('kendoGrid');
                  if (result.data.RefreshBudgetItemGrid === true) {
                    delete ctrl.expandedRow;
                  }
                  gridItemRef.dataSource.read();
                });
            },
          },
        },
      });
    };

    ctrl.isCreateDisabled = function() {
      return ctrl.budgetItem.PeriodCount >= 12 || ctrl.readOnly;
    };
    ctrl.isEditDisabled = function() {
      return !ctrl.budgetItem.SelectedBudgetItemPeriod || ctrl.readOnly;
    };
    ctrl.isDeleteDisabled = function() {
      return (
        (ctrl.selectedPeriod[ctrl.budgetItem.BudgetItemId]?.length || 0) == 0 ||
        ctrl.budgetItem.PeriodCount == 0 ||
        ctrl.readOnly
      );
    };

    function selectHandlerCore() {
      ctrl.selectedPeriod['' + ctrl.budgetItem.BudgetItemId] = ctrl.generatedTabs[0].grid.selectedIds;

      if (ctrl.generatedTabs[0].grid.selectedIds.length === 0) {
        Object.keys(ctrl.selectedPeriod).forEach(function(property) {
          delete ctrl.selectedPeriod[property];
        });
      } else {
        Object.keys(ctrl.selectedPeriod).forEach(function(property) {
          if (property != '' + ctrl.budgetItem.BudgetItemId) delete ctrl.selectedPeriod[property];
        });
      }
      stateServiceForBudgetDetailGrid.setValue(Object.keys(ctrl.selectedPeriod).map(key => Number(key)));
      $scope.$applyAsync();
    }

    gridService.setupMultiSelect(ctrl.generatedTabs[0].kendoConfig, {
      idField: 'BudgetItemPeriodId',
      disableCheckbox:
        ctrl.readOnly ||
        (!_.isEmpty(ctrl.selectedPeriod) &&
          Object.keys(ctrl.selectedPeriod)
            .map(key => Number(key))
            .indexOf(ctrl.budgetItem.BudgetItemId) === -1),
      selectHandler: selectHandlerCore,
      selectAllHandler: selectHandlerCore,
    });
  };

  stateServiceForBudgetDetailGrid.subscribe($scope, function(newValue) {
    gridService.setCheckboxState(
      ctrl.generatedTabs[0].grid,
      !_.isEmpty(newValue) && newValue.indexOf(ctrl.budgetItem.BudgetItemId) === -1
    );
  });

  ctrl.showTabs = function(tab) {
    return true;
  };

  //#endregion
}

const sbBudgetitemDetailComponentOptions = {
  templateUrl: 'App/Budget/budgetitem-detail/budgetitem-detail.component.html',
  controller: sbBudgetitemDetailComponent,
  transclude: true,
  bindings: {
    pageModel: '<',
    budgetItem: '=',
    messages: '<',
    readOnly: '<',
    selectedPeriod: '<',
    disableCheckbox: '<',
    expandedRow: '=',
  },
};

'use strict';

(function() {
  const components = {
    sbBudgetitemDetail: sbBudgetitemDetailComponentOptions,
  };

  const sbBudgetitemDetailModule = angular.module('sbBudgetitemDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbBudgetitemDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

function sbPropertyDetailComponent(gridService, $http) {
  const ctrl = this;

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  //#endregion

  ctrl.$onInit = function $onInit() {
    ctrl.generatedPropSubGridTabs = gridService.CreateGridContainerTabsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelItemProperty'],
      function(gridModel) {
        gridModel.ControllerMethod = `${gridModel.ControllerMethod}`;
        return {
          gridModel,
          transportData: PropGridDataHandler,
        };
      }
    );
    ctrl.propertyDetailFormlyDescriptor = GenerateFormlyFormPanelsFromPageModel(
      ctrl.propertyDetailModel
    )?.PanelPropertyDetail.FormlyDescriptor;

    $http({
      method: 'GET',
      url: 'Budget/GetPropertyDetail',
      params: { propertyId: ctrl.propertyId, periodId: ctrl.periodId },
    })
      .then(function(result) {
        ctrl.propertyDetailDto = result.data.Dto;
      })
      .catch(function(e) {
        toastr.error(e.statusText);
      });

    function PropGridDataHandler(e) {
      return {
        periodId: ctrl.periodId,
        propertyId: ctrl.propertyId,
        budgetModifyId: ctrl.budgetModifyId,
      };
    }
  };
}

const sbPropertyDetailComponentOptions = {
  templateUrl: 'App/Budget/grid-property-detail/grid-property-detail.component.html',
  controller: sbPropertyDetailComponent,
  bindings: {
    propertyId: '=',
    periodId: '=',
    budgetModifyId: '=',
    tabs: '<',
    panels: '<',
    grids: '<',
    propertyDetailModel: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbBudgetPropertyDetail: sbPropertyDetailComponentOptions,
  };

  const sbBudgetPropertyDetailModule = angular.module('sbBudgetPropertyDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbBudgetPropertyDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = ['sbBudgetitem', 'sbBudgetitemDetail', 'sbBudgetPropertyDetail'];

  const sbBudgetModule = angular.module('sbBudget', modules);
})();

(function(module) {
  'use strict';

  module.controller('BudgetApportionCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetApportionCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetOuterLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetOuterLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var id = $state.params.BudgetId;
      //Routesban kap értéket: {Nav, Edit}
      var backTo = $state.params.backTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('Budget.Budget.BudgetNav');
        };
      } else if (backTo === 'Edit') {
        backMenu.event = function() {
          $state.go('Budget.Budget.BudgetEdit', { id: id, openedPanelGroup: 'PGBudgetItemData' });
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Budget_Budget_Budget: { icon: 'fa fa-file-text' },
        //"Budget_Groups": { icon: "fa fa-file-text" },
        Budget_Budget_ServiceNav: { icon: 'fa fa-file-text' },
        Budget_Budget_Reports: { icon: 'fa fa-file-text' },
        Masterdata_Budget: { icon: 'fa fa-file-text-o' },
      };
      buildMenu($state, authService, 'Budget_Budget', 'budget', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetServiceMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetServiceMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var id = $state.params.BudgetId;
      //Routesban kap értéket: {Nav, Edit}
      var backTo = $state.params.backTo;
      /*
			if (backTo === "Nav") {
                backMenu.event = function () {
                    $state.go("Budget.BudgetNav");
                };
            } else if (backTo === "Edit") {
                backMenu.event = function () {
                    $state.go("Budget.BudgetEdit", { "id": id });
                };
            } else {
                backMenu.state = "main";
            }
			*/
      var desc = {
        Budget_Budget_ServiceNav_ServiceFinancialDataNav: { icon: 'fa fa-file-text' },
        Budget_Budget_ServiceNav_ServiceGroupNav: { icon: 'fa fa-file-text' },
      };
      buildMenu($state, authService, 'Budget_Budget_ServiceNav', 'budget', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Budget: {
        url: '/budget',
        templateUrl: 'App/Budget/BudgetOuterLayout.html',
        controller: 'BudgetOuterLayoutCtrl as vm',
        redirectTo: 'Budget.Budget.BudgetNav',
        ncyBreadcrumb: {
          label: 'Költségvetés tervezés',
          parent: 'main',
        },
      },
      'Budget.Budget': {
        url: '/budget',
        redirectTo: 'Budget.Budget.BudgetNav',
        ncyBreadcrumb: {
          label: 'Költségvetés tervezés',
          parent: 'Budget',
        },
        views: {
          content: {
            templateUrl: 'App/Budget/BudgetLayout.html',
            controller: 'BudgetLayoutCtrl as vm',
          },
        },
      },
      'Budget.Budget.BudgetNav': {
        url: '/nav',
        params: {
          module: 'Budget',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Budget.Budget.BudgetCreate',
            'Budget.Budget.BudgetCreate',
            'Budget.Budget.BudgetEdit',
            'Budget.Budget.BudgetView',
            'Budget.Budget.DasDocumentsNav',
          ],
          documentEntity: 'budget_budgetnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetNav.html',
            controller: 'BudgetNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Költségvetések',
        },
      },
      'Budget.Budget.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Budget.Budget.BudgetCreate': {
        url: '/create',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetEdit.html',
            controller: 'BudgetEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetCreate/'),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Create',
          backTo: 'Nav',
          documentEntity: 'budget_budgetcreate',
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Költségvetés hozzáadása',
        },
      },
      'Budget.Budget.BudgetEdit': {
        url: '/edit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetEdit.html',
            controller: 'BudgetEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          backTo: 'Nav',
          module: 'Budget',
          formMode: 'Nav',
          backState: 'main',
          bstates: [
            'Budget.Budget.BudgetCreate',
            'Budget.Budget.BudgetCreate',
            'Budget.Budget.BudgetEdit',
            'Budget.Budget.BudgetView',
          ],
          documentEntity: 'budget_budgetcreate',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Költségvetés szerkesztése',
        },
      },
      'Budget.Budget.BudgetDuplicate': {
        url: '/duplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetEdit.html',
            controller: 'BudgetEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Create',
          backTo: 'Nav',
          documentEntity: 'budget_budgetcreate',
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Költségvetés másolása',
        },
      },
      'Budget.Budget.BudgetView': {
        url: '/view/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetEdit.html',
            controller: 'BudgetEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          backTo: 'Nav',
          documentEntity: 'budget_budgetcreate',
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Költségvetés megtekintése',
        },
      },
      //Költségvetés tételek:
      'Budget.Budget.BudgetItemPeriodCreate': {
        url: '/itemcreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/SubItems/BudgetItemEdit.html',
            controller: 'BudgetItemEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetItemCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          createOrEdit: 'Create',
          backTo: 'Budget.BudgetEdit',
        },
        ncyBreadcrumb: {
          label: 'Költségvetés tervezés',
        },
      },
      'Budget.Budget.BudgetItemPeriodEdit': {
        url: '/itemedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/SubItems/BudgetItemEdit.html',
            controller: 'BudgetItemEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/BudgetItemEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          createOrEdit: 'Edit',
          backTo: 'Budget.BudgetEdit',
          module: 'Budget',
          formMode: 'Nav',
          backState: 'Budget.BudgetEdit',
          bstates: ['Budget.BudgetItemCreate', 'Budget.BudgetItemEdit'],
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        ncyBreadcrumb: {
          label: 'Költségvetés tervezés',
        },
      },
      //Átterhelések:
      'Budget.Apportion': {
        url: '/apportion',
        params: {
          ApportionType: 'BATAP',
        },
        redirectTo: 'Budget.Apportion.ApportionNav',
        ncyBreadcrumb: {
          label: 'Központi átterhelések',
          parent: 'main',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/BudgetApportion.html',
            controller: 'BudgetApportionCtrl as vm',
          },
        },
      },
      'Budget.Apportion.ApportionDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Budget.Apportion.ApportionNav': {
        url: '/apportion/{ApportionType:string}',
        params: {
          module: 'Apportion',
          formMode: 'Nav',
          backState: 'main',
          createState: 'Budget.Apportion.ApportionCreate',
          editState: 'Budget.Apportion.ApportionEdit',
          duplicateState: 'Budget.Apportion.ApportionDuplicate',
          deleteState: 'Partner/PartnerDelete/',
          documentEntity: 'budget_apportionnav',
          viewState: 'Partner.View',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionNav.html',
            controller: 'ApportionNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionListOptions/', undefined, ['ApportionType']),
        },
        ncyBreadcrumb: {
          parent: 'Budget.Apportion',
          label: 'Közvetlen átterhelés',
        },
      },
      'Budget.Apportion.ApportionDasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Budget.Apportion.ApportionCreate': {
        url: '/apportioncreate/{BudgetDateId:int}?ApportionType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionEdit.html',
            controller: 'ApportionEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionCreate/', undefined, ['BudgetDateId', 'ApportionType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'ApportionNav',
          documentEntity: 'budget_apportionedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés létrehozása',
        },
      },

      'Budget.Apportion.ApportionEdit': {
        url: '/apportionedit/{id:int}?ApportionType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionEdit.html',
            controller: 'ApportionEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionEdit/', undefined, ['id', 'ApportionType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'ApportionNav',
          documentEntity: 'budget_apportionedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés szerkesztése',
        },
      },
      'Budget.Apportion.ApportionDuplicate': {
        url: '/apportionduplicate/{id:int}?ApportionType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionEdit.html',
            controller: 'ApportionEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/ApportionDuplicate/', undefined, ['id', 'ApportionType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          backTo: 'ApportionNav',
          documentEntity: 'budget_apportionedit',
        },
        ncyBreadcrumb: {
          label: 'Közvetlen átterhelés másolása',
        },
      },
      'Budget.Apportion.ApportionView': {
        url: '/apportionview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionEdit.html',
            controller: 'ApportionEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/ApportionView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          backTo: 'ApportionNav',
          documentEntity: 'budget_apportionedit',
        },
        ncyBreadcrumb: {
          label: 'Közvetlen átterhelés megtekintése',
        },
      },

      //"Budget.ApportionNav.JobNum": {
      //   url: "/apportionjobnumnav",
      //   params: { module: "Apportion" },
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionJobNumNav.html",
      //         controller: "ApportionJobNumNavCtrl as vm",
      //         resolve: {
      //            options: RouteResolveFunc("Budget/ApportionJobNumListOptions/")
      //         }
      //      }
      //   },
      //   ncyBreadcrumb: {
      //      label: "Munkaszámos átterhelés"
      //   }
      //},
      //"Budget.ApportionJobNumCreate": {
      //   url: "/apportionjobnumcreate",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionJobNumEdit.html",
      //         controller: "ApportionJobNumEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionJobNumCreate/")
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Create",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Munkaszámos átterhelés hozzáadása"
      //   }
      //},
      //"Budget.ApportionJobNumEdit": {
      //   url: "/apportionjobnumedit/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionJobNumEdit.html",
      //         controller: "ApportionJobNumEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionJobNumEdit/", undefined, ["id"])
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Edit",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Munkaszámos átterhelés szerkesztése"
      //   }
      //},
      //"Budget.ApportionJobNumDuplicate": {
      //   url: "/apportionjobnumduplicate/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionJobNumEdit.html",
      //         controller: "ApportionJobNumEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionJobNumDuplicate/", undefined, ["valid"])
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Create",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Munkaszámos átterhelés másolása"
      //   }
      //},
      //"Budget.ApportionJobNumView": {
      //   url: "/apportionjobnumview/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionJobNumEdit.html",
      //         controller: "ApportionJobNumEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionJobNumView/{id}")
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: true
      //      },
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Munkaszámos átterhelés megtekintése"
      //   }
      //},

      //"Budget.ApportionNav.Percent": {
      //   url: "/apportionpercentnav",
      //   params: { module: "Apportion" },
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionPercentNav.html",
      //         controller: "ApportionPercentNavCtrl as vm",
      //         resolve: {
      //            options: RouteResolveFunc("Budget/ApportionPercentListOptions/")
      //         }
      //      }
      //   },
      //   ncyBreadcrumb: {
      //      label: "Százalékos átterhelés"
      //   }
      //},
      //"Budget.ApportionPercentCreate": {
      //   url: "/apportionpercentcreate",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionPercentEdit.html",
      //         controller: "ApportionPercentEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionPercentCreate/")
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Create",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Százalékos átterhelés hozzáadása"
      //   }
      //},
      //"Budget.ApportionPercentEdit": {
      //   url: "/apportionpercentedit/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionPercentEdit.html",
      //         controller: "ApportionPercentEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionPercentEdit/", undefined, ["id"])
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Edit",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Százalékos átterhelés szerkesztése"
      //   }
      //},
      //"Budget.ApportionPercentDuplicate": {
      //   url: "/apportionpercentduplicate/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionPercentEdit.html",
      //         controller: "ApportionPercentEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionPercentDuplicate/", undefined, ["valid"])
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: false
      //      },
      //      CreateOrEdit: "Create",
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Százalékos átterhelés másolása"
      //   }
      //},
      //"Budget.ApportionPercentView": {
      //   url: "/apportionpercentview/{id:int}",
      //   views: {
      //      "menu": {
      //         templateUrl: "App/TileMenu.html",
      //         controller: "ApportionMenuCtrl as vm"
      //      },
      //      "content": {
      //         templateUrl: "App/Budget/ApportionPercentEdit.html",
      //         controller: "ApportionPercentEditCtrl as vm",
      //         resolve: {
      //            model: RouteResolveFunc("Budget/ApportionPercentView/{id}")
      //         }
      //      }
      //   },
      //   params: {
      //      controllerOptions: {
      //         isFormReadOnly: true
      //      },
      //      backTo: "ApportionNav"
      //   },
      //   ncyBreadcrumb: {
      //      label: "Százalékos átterhelés megtekintése"
      //   }
      //},

      'Budget.Apportion.ApportionPlan': {
        url: '/apportionplan',
        params: {
          module: 'Apportion',
          formMode: 'Nav',
          documentEntity: 'budget_apportionplan',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionPlanNav.html',
            controller: 'ApportionPlanNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionPlanListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Átterhelés terv',
        },
      },
      'Budget.Apportion.ApportionPlanEdit': {
        url: '/apportionplanedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionPlanEdit.html',
            controller: 'ApportionPlanEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionPlanEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'ApportionPlanNav',
          documentEntity: 'budget_apportionplanedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés terv',
        },
      },
      'Budget.Apportion.ApportionPlanCreate': {
        url: '/apportionplancreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionPlanEdit.html',
            controller: 'ApportionPlanEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/ApportionPlanCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'ApportionPlanNav',
          documentEntity: 'budget_apportionplanedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés terv',
        },
      },
      'Budget.Apportion.ApportionPlanDuplicate': {
        url: '/apportionplanduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionPlanEdit.html',
            controller: 'ApportionPlanEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/ApportionPlanDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          backTo: 'ApportionPlanNav',
          documentEntity: 'budget_apportionplanedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés terv másolás',
        },
      },
      'Budget.Apportion.ApportionPlanView': {
        url: '/apportionplanview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ApportionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/ApportionPlanEdit.html',
            controller: 'ApportionPlanEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/ApportionPlanView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          backTo: 'ApportionNav',
          documentEntity: 'budget_apportionplanedit',
        },
        ncyBreadcrumb: {
          label: 'Átterhelés terv megtekintése',
        },
      },

      'Budget.Budget.GridUnitPriceDelete': {
        url: '/BudgetUnitPrice/{id:int}?BudgetId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/SubItems/BudgetUnitPriceEdit.html',
            controller: 'BudgetUnitPriceEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/GridBudgetUnitPriceDelete/', undefined, ['id', 'BudgetId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          createOrDelete: 'Delete',
          BudgetId: 'BudgetId',
        },
        ncyBreadcrumb: {
          label: 'Költségvetés egységár törlése',
        },
      },

      'Budget.Budget.GridCondominiumDelete': {
        url: '/BudgetCondominium/{id:int}?BudgetId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Budget/SubItems/BudgetCondominiumEdit.html',
            controller: 'BudgetCondominiumEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Budget/GridCondominiumDelete/', undefined, ['id', 'BudgetId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          createOrDelete: 'Delete',
          BudgetId: 'BudgetId',
        },
        ncyBreadcrumb: {
          label: 'Társasházi adatok törlése',
        },
      },
      'Budget.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Budget/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      //States for contract/service
      'Budget.Budget.ServiceGroupNav': {
        url: '/service/serviceNav',
        params: {
          module: 'Budget',
          formMode: 'Nav',
          backState: 'Budget.Budget.BudgetNav',
          createGroupState: 'Budget.Budget.ServiceGroupCreate',
          editGroupState: 'Budget.Budget.ServiceGroupEdit',
          duplicateGroupState: 'Budget.Budget.ServiceGroupDuplicate',
          createState: 'Budget.Budget.ServiceCreate',
          editState: 'Budget.Budget.ServiceEdit',
          duplicateState: 'Budget.Budget.ServiceDuplicate',
          bstates: [
            'Budget.Budget.ServiceGroupEdit',
            '"Budget.Budget.ServiceGroupDuplicate',
            'Budget.Budget.ServiceEdit',
            'Budget.Budget.ServiceDuplicate',
          ],
          documentEntity: 'budget_servicegroupnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupNav.html',
            controller: 'ServiceGroupNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ServiceGroupListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Budget.Budget.ServiceGroupEdit': {
        url: '/servicegroupedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceGroupEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_servicegroupedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Budget.Budget.ServiceGroupCreate': {
        url: '/servicegroupedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceGroupCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_servicegroupedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoportok',
        },
      },
      'Budget.Budget.ServiceGroupDuplicate': {
        url: '/servicegroupduplicate/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceGroupEdit.html',
            controller: 'ServiceGroupEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceGroupDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_servicegroupedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel csoport másolás',
        },
      },

      'Budget.Budget.ServiceEdit': {
        url: '/serviceedit/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceEdit/', undefined, ['id', 'ServiceGroupId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_serviceedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel',
        },
      },
      'Budget.Budget.ServiceCreate': {
        url: '/serviceedit/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceCreate/', undefined, ['id', 'ServiceGroupId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_serviceedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel',
        },
      },
      'Budget.Budget.ServiceDuplicate': {
        url: '/serviceduplicate/{id:int}?ServiceGroupId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceEdit.html',
            controller: 'ServiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceDuplicate/', undefined, ['id', 'ServiceGroupId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'Budget.Budget.ServiceGroupNav',
          documentEntity: 'budget_serviceedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Másolás',
        },
      },
      'Budget.Budget.ServiceFinancialDataNav': {
        url: '/service/ServiceFinancialDataNav',
        params: {
          module: 'Budget',
          formMode: 'Nav',
          backState: 'main',
          createState: 'Budget.Budget.ServiceFinancialDataCreate',
          editState: 'Budget.Budget.ServiceFinancialDataEdit',
          duplicateState: 'Budget.Budget.ServiceFinancialDataDuplicate',
          bstates: ['Budget.Budget.ServiceFinancialDataEdit', 'Budget.Budget.ServiceFinancialDataDuplicate'],
          documentEntity: 'budget_servicefinancialdatanav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataNav.html',
            controller: 'ServiceFinancialDataNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Contract/ServiceFinancialDataListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
          parent: 'Budget.Budget.ServiceGroupNav',
        },
      },

      'Budget.Budget.ServiceFinancialDataEdit': {
        url: '/servicefinancialdataedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceFinancialDataEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backState: 'Budget.Budget.ServiceFinancialDataNav',
          documentEntity: 'budget_servicefinancialdataedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
        },
      },
      'Budget.Budget.ServiceFinancialDataCreate': {
        url: '/servicefinancialdataedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceFinancialDataCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backState: 'Budget.Budget.ServiceFinancialDataNav',
          documentEntity: 'budget_servicefinancialdataedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai',
        },
      },
      'Budget.Budget.ServiceFinancialDataDuplicate': {
        url: '/servicefinancialdataduplicate/{id:int}?ServiceFinancialDataId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'BudgetServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Contract/ServiceFinancialDataEdit.html',
            controller: 'ServiceFinancialDataEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Budget/BudgetServiceFinancialDataDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          backState: 'Budget.Budget.ServiceFinancialDataNav',
          documentEntity: 'budget_servicefinancialdataedit',
          module: 'Budget',
        },
        ncyBreadcrumb: {
          label: 'Díjtétel pénzügyi adatai másolás',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Budget");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('BudgetNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    'gridService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $filter,
      authService,
      HistoryService,
      dasService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetNavCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.budgetItemNavModel = options.budgetItemNavModel;
      vm.budgetItemNavDto = options.budgetItemNavDto;

      if (!!options.propertyDetailModel) {
        vm.propertyDetailDto = {};
        vm.propertyDetailModel = options.propertyDetailModel;
      }

      console.log('vm.pageModel: ', vm.pageModel);

      //MenuItems
      vm.createBudget = createBudget;
      vm.editBudget = editBudget;
      vm.deleteBudget = deleteBudget;
      vm.duplicateBudget = duplicateBudget;
      vm.viewBudget = viewBudget;
      vm.History = history;
      vm.WAL = WAL;
      vm.opSettlementReport = opSettlementReport;
      vm.deleteBudgetModifys = deleteBudgetModifys;
      vm.refreshSelectedGrid = refreshSelectedGrid;

      vm.back = function() {
        $state.go('main');
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.getSelectedItem = function() {
        var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
        return GetSelectedGridItems(selectedGrid);
      };

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        [],
        function(gridModel) {
          gridModel.ControllerMethod =
            gridModel.Name === 'GridBudget'
              ? 'Budget/BudgetListOnlyActive/'
              : `Budget/BudgetList/${gridModel.ControllerMethod}`;
          return {
            gridModel,
            transportData: function() {
              return { validOnly: vm.allTimestamp !== true };
            },
            selectFunction: function() {
              vm.selectedBudget = GetSelectedItem();
              vm.budgetItemNavDto.SelectedFinancialYear = vm.selectedBudget.BudgetDate;
              setDasModel();
            },
          };
        }
      );

      //Hide Active column on ActiveBudget grid.
      var activeColumnInBudgetGrid = generatedGridTabs.gridOptions.GridBudget.columns.find(function(element) {
        return element['field'] === 'Active';
      });
      if (!!activeColumnInBudgetGrid) activeColumnInBudgetGrid.hidden = true;

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      function refreshSelectedGrid() {
        var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
        selectedGrid.dataSource.read();
      }

      // Actions
      function createBudget() {
        $state.go('Budget.Budget.BudgetCreate');
      }

      function editBudget() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          //if (selectedItem.Active === true)
          $state.go('Budget.Budget.BudgetEdit', { id: selectedItem.BudgetId });
          //else
          //    $state.go("Budget.BudgetView", { "id": selectedItem.BudgetId });
        }
      }

      function duplicateBudget() {
        var selectedItem = GetSelectedItem();
        if (selectedItem)
          //if (selectedItem.Active === true)
          $state.go('Budget.Budget.BudgetDuplicate', { id: selectedItem.BudgetId });
        //else
        //    $state.go("Budget.BudgetView", { "id": selectedItem.BudgetId });
      }

      function viewBudget() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) $state.go('Budget.Budget.BudgetView', { id: selectedItem.BudgetId });
      }

      function deleteBudget() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Budget/BudgetDelete/' + selectedItem.BudgetId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
                    selectedGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function GetSelectedItem() {
        var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function WAL() {
        walService.NavigateToWal('Budget', 'BudgetNavWal', 'FlgBudgetView');
      }

      function history() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          HistoryService.NavigateToHistory('FlgBudget', selectedItem.BudgetId, vm, $state, true);
        }
      }

      function opSettlementReport() {
        var uibModalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/BudgetOpSettlementEdit.html',
          controller: 'BudgetOpSettlementEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('budget/BudgetOpSettlementEdit'),
          },
          backdrop: 'static',
        });

        uibModalInstance.result.then(function() {});
      }

      function deleteBudgetModifys() {
        var selectedItem = GetSelectedItem();
        if (!!selectedItem && !!selectedItem.BudgetId) {
          var uibModalInstance = $uibModal.open({
            templateUrl: 'App/Budget/SubItems/BudgetModifyDel.html',
            controller: 'BudgetModifyDelCtrl',
            controllerAs: 'vm',
            size: 'md',
            resolve: {
              model: RouteResolveFunc('budget/BudgetModifyDelete', { budgetId: selectedItem.BudgetId }),
            },
            backdrop: 'static',
          });

          uibModalInstance.result.then(function() {});
        }
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids[vm.subGrids[vm.activeSubItemTab]].DasDescriptor;
        var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
        var selectedItems = GetSelectedGridItems(selectedGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetApplyTaskModalCtrl', [
    '$http',
    'model',
    'dataSources',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'HistoryService',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      dataSources,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      HistoryService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetApplyTaskModalCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetApplyTaskModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      kendoMSInit('Periods');

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.Periods.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        budgetModifyId: vm.budgetApplyTaskModel.BudgetModifyId,
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Budget/BudgetApplyTaskPreGen', vm.budgetApplyTaskModel)
          .then(function(response) {
            if (!response.data.BudgetApplyTaskResult.length) {
              toastr.warning(
                'A megadott paraméterekkel nincs találat "Költségvetés lekérdezés tevékenység beforgatáshoz" nézetben!',
                vm.messages.Warning
              );
              return;
            }

            var modalInstance = $uibModal.open({
              templateUrl: 'App/Budget/SubItems/BudgetApplyTaskResultModal.html',
              controller: 'BudgetApplyTaskResultModalCtrl',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                fModel: {
                  pageModel: vm.pageModel,
                  dataModel: vm.budgetApplyTaskModel,
                  grids: vm.pageModel.Grids,
                  result: response.data,
                  gridRefresh: dataSources.gridRefresh,
                },
              },
              backdrop: 'static',
            });
            modalInstance.result.then(function() {});
            uibModalInstance.close();
          })
          .catch(function() {});
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      }

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetRevertTaskModalCtrl', [
    '$http',
    'model',
    'budgetId',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'HistoryService',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      budgetId,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      HistoryService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetRevertTaskModalCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetRevertTaskModel = model.dto;
      vm.budgetId = budgetId;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      SetGridModelColumnToDateTime(
        vm.pageModel.Fields.BudgetItemTaskBundleId.FormlyFieldDescriptor.templateOptions.GridOptions.gridModel,
        ['ModDateTime']
      );

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.pageModel.Fields.BudgetItemTaskBundleId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "BudgetId~eq~'" + vm.budgetId + "'";
      };

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Budget/BudgetRevertTask', { id: vm.budgetRevertTaskModel.BudgetItemTaskBundleId.Value })
          .then(function(response) {
            uibModalInstance.close();
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetApplyTaskResultModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetApplyTaskResultModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grids;
      vm.dataModel = fModel.dataModel;
      vm.actions = fModel.pageModel.Actions;
      vm.titles = fModel.pageModel.Titles;
      vm.messages = fModel.pageModel.Messages;
      vm.labels = fModel.pageModel.Labels;
      vm.fields = fModel.pageModel.Fields;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.apply = apply;

      vm.FinancialYear = fModel.result.FinancialYear;
      vm.BudgetDate = new moment(fModel.result.BudgetDate, kendo.culture().calendar.patterns.d.toUpperCase()).format(
        'L'
      );
      vm.row = fModel.result.BudgetApplyTaskResult;
      var resultGridOptions = getGridOptions(vm.gridModel.GridBudgetApplyTaskResult, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }

      function apply() {
        $http.post('Budget/BudgetApplyTaskGen', vm.dataModel).then(function(response) {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Budget/SubItems/BudgetApplyTaskGenResultModal.html',
            controller: 'BudgetApplyTaskGenResultModalCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              fModel: {
                grid: vm.gridModel.GridBudgetApplyTaskGenResult,
                result: response.data,
                pageModel: fModel.pageModel,
              },
            },
            backdrop: 'static',
          });
          modalInstance.result.then(function() {});
          uibModalInstance.close();
          fModel.gridRefresh();
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetApplyTaskGenResultModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetApplyTaskGenResultModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grid;
      vm.dataModel = fModel.dataModel;
      vm.actions = fModel.pageModel.Actions;
      vm.titles = fModel.pageModel.Titles;
      vm.messages = fModel.pageModel.Messages;
      vm.labels = fModel.pageModel.Labels;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;

      vm.row = fModel.result.BudgetApplyTaskGenResult;
      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    '$filter',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      $uibModal,
      dasService,
      lockService,
      gridService,
      UIHelperService,
      $filter
    ) {
      var vm = this;
      vm.selectedPeriod = {};
      vm.UIHelperService = UIHelperService;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
        disableRunExpression: false,
      };

      function headerIsDisabled() {
        return vm.collapseHelper?.disabledPanels?.indexOf('PGHeader') !== -1;
      }

      vm.SubPanelCollapsed = {};
      vm.SubPanelCollapsed['PanelBudgetOther'] =
        (localStorage
          .getItem($state.current.name + '_' + $state.previous.name + '_SubPanelCollapsed_PanelBudgetOther')
          ?.toLowerCase() ?? 'false') == 'true';

      vm.collapse = function(name) {
        vm.SubPanelCollapsed[name] = !vm.SubPanelCollapsed[name];
        localStorage.setItem(
          $state.current.name + '_' + $state.previous.name + '_SubPanelCollapsed_' + name,
          vm.SubPanelCollapsed[name]
        );
      };

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      var scope = $scope;
      //ha hibával jön az oldalbetöltés (nincs pageModel), akkor vissza a navra
      if (!model || !model.pageModel) {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Budget.BudgetNav');
        return false;
      }
      vm.modelFromController = angular.copy(model);
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;

      vm.budgetItemNavModel = model.budgetItemNavModel;
      vm.budgetItemNavDto = model.budgetItemNavDto;

      vm.messages = model.pageModel.Messages;
      vm.titles = model.pageModel.Titles;
      vm.actions = model.pageModel.Actions;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.activeSubItemTab = 0;
      vm.back = function() {
        $state.go('Budget.Budget.BudgetNav');
      };
      vm.CreateOrEdit = $stateParams.CreateOrEdit;

      if (vm.CreateOrEdit === 'Create') {
        vm.formModel.BudgetId = null;
        vm.formModel.ModDate = null;
        vm.formModel.ModUser = null;
      }

      if (!!model.propertyDetailModel) {
        vm.propertyDetailDto = {};
        vm.propertyDetailModel = model.propertyDetailModel;
      }

      //MenuItems
      vm.createBudget = createBudget;
      vm.editBudget = editBudget;
      vm.deleteBudget = deleteBudget;
      vm.duplicateBudget = duplicateBudget;
      vm.viewBudget = viewBudget;
      vm.save = saveItem;

      vm.attachDocument = attachDocument;
      vm.history = history;
      vm.deleteBudgetModifys = deleteBudgetModifys;
      vm.tenementPartitionDownloadXls = tenementPartitionDownloadXls;

      //store actual FlgBudgetItemProperty key value
      vm.BudgetItemPropertyKeyValue;
      //store keys os detail grid
      vm.DetailGridKeys = {};

      //Store actual FlgBugetItemPeriod key value
      vm.BudgetItemPeriodKeyValue;

      //store the budget item period
      vm.BudgetItemPeriodId;

      //Action showable setting
      vm.CondominiumGridSelected = true;

      vm.SelectedServicesReset = true;

      ////////////////////////////////////////////////////////////////////////////////////////////
      //////////////////////////[Event Handlers & Element Modifier]///////////////////////////////
      vm.formModifiers = {};

      var onChangeFunctions = {
        OpUnitId: function(selectedItem) {
          if (selectedItem === null) {
            //egyelőre nem töröljük a többi mezőt, mert ha üzemeltetési egységet töröljük, attól még az objektum és az ingatlan igaz marad
            // vm.formModel.ObPropertyId = {Value: null, Text:  null };
            //vm.formModel.Owner = {Value: null, Text:  null };
            vm.formModel.PropertyId = { Value: null, Text: null };
            vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.opUnitId = null;
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.opUnitId = null;
          } else {
            vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.opUnitId =
              selectedItem.OpUnitId;
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.opUnitId =
              selectedItem.OpUnitId;
            //vm.formModel.ObPropertyId = { Value: vm.formModel.ObPropertyId.Value, Text: null };
            //vm.formModel.PropertyId = { Value: vm.formModel.PropertyId.Value, Text: null };
          }
        },
        Owner: function(selectedItem) {
          if (selectedItem === null) {
            vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.owner = null;
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.owner = null;
          } else {
            vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.owner =
              selectedItem.Owner;
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.owner =
              selectedItem.Owner;
            //vm.formModel.ObPropertyId = { Value: vm.formModel.ObPropertyId.Value, Text: null };
            //vm.formModel.PropertyId = { Value: vm.formModel.PropertyId.Value, Text: null };
          }
        },
        ObPropertyId: function(selectedItem) {
          if (selectedItem === null) {
            vm.formModel.PropertyId = { Value: null, Text: null };
            vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.obPropertyId = null;
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.obPropertyId = null;
          } else {
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams.obPropertyId =
              selectedItem.PropertyId;
            //vm.formModel.PropertyId = {Value: vm.formModel.PropertyId.Value,  Text : null};
            vm.formModel.OpUnitId = { Value: selectedItem.OpUnitId, Text: selectedItem.OpUnitName };
            vm.formModel.Owner = { Value: selectedItem.Owner, Text: selectedItem.OwnerName };
          }
        },
        PropertyId: function(selectedItem) {
          if (!!selectedItem) {
            if (!vm.formModel.OpUnitId.Value) vm.formModel.OpUnitId = selectedItem.OpUnitId;
            if (!vm.formModel.Owner.Value) vm.formModel.Owner = selectedItem.Owner;
            if (!vm.formModel.ObPropertyId.Value) vm.formModel.ObPropertyId = selectedItem.ConPropertyId;
          }
        },
        FinancialYear: function(selectedItem) {
          //A költségvetés pánzügyi éve nem befolyásolja a form változás figyelést!
          vm.pageModel.Fields.FinancialYear.FormlyFieldDescriptor.formControl.$setPristine();
          setFormlyDirtyState();
          if (selectedItem) {
            //vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.formControl.$validate();
            vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
              financialYear: selectedItem.key,
              isFormReadOnly: vm.controllerOptions.isFormReadOnly === true,
              budgetId: vm.controllerOptions.isFormReadOnly === true ? vm.formModel.BudgetId : 0,
            };
            vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
        BudgetDate: function(selectedItem) {
          //A költségvetés dátum nem befolyásolja a form változás figyelést!
          vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.formControl.$setPristine();
          setFormlyDirtyState();
          if (selectedItem) {
            //vm.pageModel.Fields.FinancialYear.FormlyFieldDescriptor.formControl.$validate();
            var toDate = selectedItem;
            if (!!selectedItem.extraProperties && !!selectedItem.extraProperties[0]) {
              vm.formModel.FinancialYear = selectedItem.extraProperties[0].value;
            }
            // Ha módosításnál olyan költségvetés dátumot választ, amihez van már adat az FlgBudgetModify táblában, akkor be kell olvasni a hozzá tartozó tételeket is (FlgBudgetItem).
            if (vm.formModel.BudgetId > 0 && vm.formModel.BudgetDate) {
              $http({
                method: 'GET',
                url: 'Budget/GetBudgetModify',
                params: { budgetId: vm.formModel.BudgetId, budgetDateId: vm.formModel.BudgetDate },
              }).then(function successCallback(response) {
                if (response) {
                  if (!!response.data.Dto && response.data.Dto.SelectedModify.BudgetModifyId) {
                    vm.formModel.BudgetType = response.data.Dto.SelectedModify.BudgetType;
                    vm.formModel.BudgetModifyId = response.data.Dto.SelectedModify.BudgetModifyId;
                    vm.formModel.CalculatedPMFee = response.data.Dto.CalculatedPMFee;
                  } else {
                    copyItems(response.data.Dto.FromDateStr, response.data.Dto.LastModify, toDate);
                  }
                }
              });
            }
          }
        },
      };

      //A generálásnál feltett kérdés miatt le kell tárolni a combobox előző értékét:
      $scope.$watch('vm.formModel.BudgetDate', function(newItem, oldItem) {
        var ddl = $('#' + vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.name).data('kendoDropDownList');
        if (newItem != oldItem && !!ddl && ddl.dataSource) {
          vm.prevBudgetDate = ddl.dataSource.data().find(function(x) {
            return x.key == oldItem;
          });
        }
      });

      var customExpressionProperties = {
        BudgetId: {
          'templateOptions.required': function() {
            return vm.CreateOrEdit !== 'Create';
          },
        },
        ModUser: {
          'templateOptions.required': function() {
            return vm.CreateOrEdit !== 'Create';
          },
        },
        ModDate: {
          'templateOptions.required': function() {
            return vm.CreateOrEdit !== 'Create';
          },
        },
        OpUnitId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
          'templateOptions.required': function() {
            return vm.formModel.BudgetType === 'BBTPM';
          },
        },
        Owner: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
        },
        ObPropertyId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
        },
        Name: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || headerIsDisabled();
          },
        },
        BudgetType: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || headerIsDisabled();
          },
        },
        Active: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly || headerIsDisabled();
          },
        },
        FinancialYear: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        BudgetDate: {
          'templateOptions.disabled': function() {
            return headerIsDisabled();
          },
        },
        PropertyId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
        },
        CityCodeId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
        },
        OrgPartId: {
          'templateOptions.disabled': function() {
            return vm.controllerOptions.isFormReadOnly;
          },
        },
      };

      var customCallbackFunctions = {};

      var syncValidators = {
        FinancialYear: {
          BudgetFinancialYearValidator: function(modelValue, viewValue) {
            if (modelValue && vm.formModel.BudgetDate) {
              var valid = ValidateFinancialYear(modelValue);
              if (!valid) return false;
            }

            return true;
          },
        },
        BudgetDate: {
          BudgetBudgetDateValidator: function(modelValue, viewValue) {
            if (modelValue && vm.formModel.FinancialYear) {
              var valid = ValidateFinancialYear(vm.formModel.FinancialYear);
              if (!valid) return false;
            }

            return true;
          },
        },
      };

      function ValidateFinancialYear(financialYear) {
        var id = vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.id;
        var budgetDateDdl = $('#' + id).data('kendoDropDownList');
        if (budgetDateDdl) {
          var dataItem = budgetDateDdl.dataItem();
          if (dataItem.extraProperties) {
            var extraProperties = $.grep(dataItem.extraProperties, function(e, i) {
              return e.key == 'FinancialYear';
            });
            if (extraProperties.length > 0) {
              var budgetDateFinancialYear = extraProperties[0].value;
              if (financialYear != budgetDateFinancialYear) {
                return false;
              }
            }
          }
        }

        return true;
      }

      // Insert static validators / formatters / parsers. These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, syncValidators);
        //InsertAsyncValidators(vm.pageModel, asyncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, vm.formModifiers.numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      }

      // Set editability of fields based on controllerOptions
      if (vm.controllerOptions.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (value.ContainerPanelId == 'PanelBudgetHead') value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.pageModel.Fields.FinancialYear.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        showInactive: vm.controllerOptions.isFormReadOnly === true,
        budgetId: vm.controllerOptions.isFormReadOnly === true ? vm.formModel.BudgetId : 0,
      };

      //ha van adat a Pénzügyi évre vonatkozóan előszűrjük a Költségvetés dátumot
      vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        financialYear: vm.formModel.FinancialYear,
        isFormReadOnly: vm.controllerOptions.isFormReadOnly,
        budgetId: vm.controllerOptions.isFormReadOnly === true ? vm.formModel.BudgetId : 0,
      };

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      // Initialise dynamic F2 filters
      function SetF2DynamicFilters() {
        vm.pageModel.Fields.ObPropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          opUnitId:
            vm.formModel.OpUnitId != null && vm.formModel.OpUnitId.Value > 0 ? vm.formModel.OpUnitId.Value : null,
          owner: vm.formModel.Owner != null ? vm.formModel.Owner.Value : null,
          propertyId:
            vm.formModel.PropertyId != null && vm.formModel.PropertyId.Value > 0 ? vm.formModel.PropertyId.Value : null,
        };
        vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          opUnitId:
            vm.formModel.OpUnitId != null && vm.formModel.OpUnitId.Value > 0 ? vm.formModel.OpUnitId.Value : null,
          owner: vm.formModel.Owner != null ? vm.formModel.Owner.Value : null,
          obPropertyId:
            vm.formModel.ObPropertyId != null && vm.formModel.PropertyId.Value > 0
              ? vm.formModel.ObPropertyId.Value
              : null,
        };
      }

      ////////////////////////////////////////////////////////////////////////////////////////////
      ////////////////////////////////////////[MainGrid Actions]/////////////////////////////////
      function createBudget() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Budget.BudgetCreate', { id: 0 });
      }

      function editBudget(e) {
        if (vm.formModel.Active === true) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('Budget.Budget.BudgetEdit', { id: vm.formModel.BudgetId });
        } else {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('Budget.Budget.BudgetView', { id: vm.formModel.BudgetId });
        }
      }

      function duplicateBudget() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Budget.BudgetDuplicate', { id: vm.formModel.BudgetId });
      }

      function viewBudget() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Budget.BudgetView', { id: vm.formModel.BudgetId });
      }

      function attachDocument() {
        var id = vm.formModel.BudgetId;
        dasService.NavigateToDas(vm.messages, 'Budget.Budget.DasDocumentsNav', 'FlgBudget', id);
      }

      function history() {
        toastr.warning(vm.messages.FunctionNotExists, vm.messages.Warning);
      }

      function copyItems(fromDateStr, fromDate, toDate) {
        var dialogMessage = $filter('format')(
          vm.pageModel.Labels.LabelBudgetDateCopyWarning.Title,
          toDate.text,
          fromDateStr
        );
        bootbox.dialog({
          message: dialogMessage,
          title: vm.messages.Warning,
          buttons: {
            yes: {
              label: vm.pageModel.Messages.Yes,
              className: 'btn-primary',
              callback: function() {
                $http({
                  method: 'GET',
                  url: 'Budget/BudgetItemsCopy',
                  params: { budgetId: vm.formModel.BudgetId, toDateId: toDate.key, nullBase: false },
                })
                  .then(function(response) {
                    toastr.success(vm.pageModel.Messages.DuplicateSuccessful);
                    vm.formModel.BudgetModifyId = response.data.Dto.BudgetModifyId;
                    //$state.go("Budget.BudgetNav");
                  })
                  .catch(function(e) {
                    toastr.error(e.statusText);
                    vm.formModel.BudgetDate = fromDate.BudgetDateId;
                    //$scope.$apply();
                  });
              },
            },
            no: {
              label: vm.pageModel.Actions.ActionNullBasePlaning.Title,
              className: 'btn-primary',
              callback: function() {
                $http({
                  method: 'GET',
                  url: 'Budget/BudgetItemsCopy',
                  params: { budgetId: vm.formModel.BudgetId, toDateId: toDate.key, nullBase: true },
                })
                  .then(function(response) {
                    toastr.success(vm.pageModel.Messages.DuplicateSuccessful);
                    vm.formModel.BudgetModifyId = response.data.Dto.BudgetModifyId;
                    // $state.go("Budget.BudgetNav");
                  })
                  .catch(function(e) {
                    toastr.error(e.statusText);
                    vm.formModel.BudgetDate = fromDate.BudgetDateId;
                    //$scope.$apply();
                  });
              },
            },
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn btn-default',
              callback: function() {
                vm.formModel.BudgetDate = fromDate.BudgetDateId;
                $scope.$applyAsync();
              },
            },
          },
        });
      }
      function deleteBudget() {
        var dialogMessage = vm.messages.ConfirmDelete;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.messages.Warning,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Budget/BudgetDelete/' + vm.formModel.BudgetId).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  $state.go('Budget.Budget.BudgetNav');
                });
              },
            },
          },
        });
      }

      function saveItem() {
        $http
          .post('Budget/BudgetSave', vm.formModel)
          .then(function(response) {
            vm.formly.$setPristine();
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (!vm.formModel.BudgetId || vm.formModel.ModelState == 4) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              $state.go('Budget.Budget.BudgetEdit', { id: response.data.Id, openedPanelGroup: 'PGBudgetItemData' });
            } else {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
              //$state.go('Budget.Budget.BudgetNav');
              //Ha elnavigálunk (újratöltünk) mindig a legutolsó ktv dátumra állna. Nem szükséges a navigálás:
              //$state.go('Budget.Budget.BudgetEdit', { id: vm.formModel.BudgetId }, { reload: true });
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Budget.BudgetNav');
      };

      // Init
      var init = function() {
        vm.formModel.BudgetDate = vm.formModel.BudgetDate;
        SetF2DynamicFilters();
        //vm.UIHelperService.setDefaultSidebarStatus();
      };

      init();

      vm.applyTask = function(id) {
        var url = 'Budget/BudgetApplyTask?budgetModifyId=' + vm.formModel.BudgetModifyId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/BudgetApplyTaskModal.html',
          controller: 'BudgetApplyTaskModalCtrl as vm',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            dataSources: {
              gridRefresh: function() {
                var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
                selectedGrid.dataSource.read();
              },
            },
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function() {
            var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
            selectedGrid.dataSource.read();
          })
          .catch(function() {});
      };

      vm.revertTask = function(id) {
        var url = 'Budget/GetBudgetRevertTask';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Budget/SubItems/BudgetRevertTaskModal.html',
          controller: 'BudgetRevertTaskModalCtrl as vm',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
            budgetId: vm.formModel.BudgetId,
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function() {
            var selectedGrid = vm.subGrids[vm.subGrids[vm.activeSubItemTab]];
            selectedGrid.dataSource.read();
          })
          .catch(function() {});
      };

      function deleteBudgetModifys() {
        if (vm.formModel.BudgetId) {
          var uibModalInstance = $uibModal.open({
            templateUrl: 'App/Budget/SubItems/BudgetModifyDel.html',
            controller: 'BudgetModifyDelCtrl',
            controllerAs: 'vm',
            size: 'md',
            resolve: {
              model: RouteResolveFunc('budget/BudgetModifyDelete', { budgetId: vm.formModel.BudgetId }),
            },
            backdrop: 'static',
          });
          uibModalInstance.result.then(function(submitVar) {
            if (!!submitVar) {
              $state.go('Budget.Budget.BudgetEdit', { id: vm.formModel.BudgetId }, { reload: true });
            }
          });
        }
      }

      function tenementPartitionDownloadXls() {
        if (vm.formModel.BudgetId) {
          var uibModalInstance = $uibModal.open({
            templateUrl: 'App/Budget/SubItems/TenementPartitionInputModal.html',
            controller: 'TenementPartitionInputModalCtrl',
            controllerAs: 'vm',
            size: 'md',
            resolve: {
              model: RouteResolveFunc('budget/TenementPartitionInputModal', { budgetId: vm.formModel.BudgetId }),
            },
            backdrop: 'static',
          });
          uibModalInstance.result.then(function(submitVar) {
            if (!!submitVar) {
              //$state.go('Budget.Budget.BudgetEdit', { id: vm.formModel.BudgetId }, { reload: true });
            }
          });
        }
      }

      function setPanelHeaderStatus(panelName) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (value.ContainerPanelId === panelName) {
            value.FormlyFieldDescriptor.runExpressions();
          }
        });
      }

      function setFormlyDirtyState() {
        let isDirty = false;
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (value.FormlyFieldDescriptor.formControl) {
            if (value.FormlyFieldDescriptor.formControl.$dirty === true) {
              isDirty = true;
            }
          }
        });
        if (isDirty) vm.formly.$setDirty();
        else vm.formly.$setPristine();
      }

      function toggleFinancialHistoryColumn(state) {
        if (state === true) {
          vm.subGrids['GridBudgetItem'].showColumn(9);
          vm.pageModel.Grids.GridBudgetItem.Columns['9'].hidden = false;

          vm.subGrids['GridBudgetItem'].showColumn(8);
          vm.pageModel.Grids.GridBudgetItem.Columns['8'].hidden = false;
        } else {
          vm.subGrids['GridBudgetItem'].hideColumn(8);
          vm.pageModel.Grids.GridBudgetItem.Columns['8'].hidden = true;

          vm.subGrids['GridBudgetItem'].hideColumn(9);
          vm.pageModel.Grids.GridBudgetItem.Columns['9'].hidden = true;
        }

        let columns = vm.subGrids['GridBudgetItem'].columns.filter(function(column) {
          return !column.hidden;
        });

        let width = vm.subGrids['GridBudgetItem'].wrapper.width();
        columns.map(column => {
          vm.subGrids['GridBudgetItem'].resizeColumn(column, (width - 28) / columns.length);
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ApportionEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Apportion.ApportionNav', { ApportionType: vm.formModel.ApportionType });
      };

      if (vm.formModel.isView == true) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var syncValidators = {
        PercentRate: {
          PercentValidator: function(modelValue) {
            return modelValue >= 0 && modelValue <= 100;
          },
        },
      };

      var customExpressionProperties = {
        BudJobNumberId: {
          'templateOptions.required': function() {
            return vm.formModel.ApportionType === 'BATJO';
          },
        },
        PercentRate: {
          'templateOptions.required': function() {
            return vm.formModel.ApportionType === 'BATPE';
          },
        },
      };

      var onChangeFunctions = {
        BudgetIdFrom: function(selectedItem) {
          if (!!selectedItem && selectedItem.BudgetId !== null && typeof selectedItem.BudgetId !== 'undefined') {
            vm.pageModel.Fields.BudgetIdTo.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: selectedItem.BudgetId,
            };
          } else {
            vm.pageModel.Fields.BudgetIdTo.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: 0,
            };
          }
        },
        BudgetIdTo: function(selectedItem) {
          if (!!selectedItem && selectedItem.BudgetId !== null && typeof selectedItem.BudgetId !== 'undefined') {
            vm.pageModel.Fields.BudgetIdFrom.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: selectedItem.BudgetId,
            };
          } else {
            vm.pageModel.Fields.BudgetIdFrom.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: 0,
            };
          }
        },
      };

      var hideExpressions = {
        BudJobNumberId: function($viewValue, $modelValue, scope) {
          return vm.formModel.ApportionType != 'BATJO';
        },
        PercentRate: function($viewValue, $modelValue, scope) {
          return vm.formModel.ApportionType != 'BATPE';
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelApportion.FormlyDescriptor;

      function save() {
        $http
          .post('Budget/Apportion' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Budget.Apportion.ApportionNav', { ApportionType: vm.formModel.ApportionType });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ApportionId;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportion', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ApportionPlanEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    function($http, options, $state, $stateParams, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionPlanEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Budget.Apportion.ApportionPlan');
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelApportionPlan.FormlyDescriptor;

      function save() {
        $http
          .post('Budget/ApportionPlan' + vm.EditOrDuplicate, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Budget.Apportion.ApportionPlan');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ApportionPlanId;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportionPlan', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BudgetPMFeeEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    'HistoryService',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      uibModalInstance,
      HistoryService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetPMFeeEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;
      vm.attachDocument = attachDocument;
      vm.history = history;

      vm.formModifiers = {};

      var numericOptions = {
        PMFee: {
          decimals: 6,
          format: 'n6',
          max: 9999999999,
          min: 0,
        },
      };

      var onChangeFunctions = {
        ValidFrom: function(selectedItem) {
          vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl.$validate();
        },
        ValidTo: function(selectedItem) {
          vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.formControl.$validate();
        },
      };

      var syncValidators = {
        ValidFrom: {
          dateTooEarly: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validFromValue.isSameOrAfter(minValues);
          },
          ValidFromValidator: function(modelValue, viewValue) {
            if (vm.formModel.ValidTo === null) {
              return true;
            }

            if (!modelValue || !viewValue) {
              return false;
            }

            var validFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(vm.formModel.ValidTo, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
        ValidTo: {
          dateTooEarly: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            var minValues = new moment('1900-01-01', 'YYYY-MM-DD');

            return validToValue.isSameOrAfter(minValues);
          },
          ValidToValidator: function(modelValue, viewValue) {
            if (!modelValue && !viewValue) {
              return true;
            }

            if (vm.formModel.ValidFrom == null) {
              return true;
            }

            var validFromValue = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var validToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());

            return validFromValue.isBefore(validToValue);
          },
        },
      };

      // Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertSyncValidators(vm.pageModel, syncValidators);
        //InsertStaticValidators(vm.pageModel, syncValidators);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertNumericOptions(vm.pageModel, numericOptions);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, vm.formModifiers.customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      // Actions
      function save() {
        $http
          .post('Budget/BudgetPMFeeSave', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
      function attachDocument() {
        var id = vm.formModel.BudgetPMFeeId;
        dasService.NavigateToDas(vm.messages, 'Budget.DasDocumentsNav', 'FlgBudgetPMFee', id);
      }

      function history() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        HistoryService.NavigateToHistory('FlgBudgetPMFee', vm.formModel.BudgetPMFeeId, vm, $state);
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetUnitPriceEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'budgetUnitPriceId',
    'HistoryService',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      budgetUnitPriceId,
      HistoryService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetUnitPriceEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetUnitPriceModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrDelete = $stateParams.createOrDelete;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = attachDocument;
      vm.history = history;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.required': function() {
            return vm.budgetUnitPriceModel.ModelState != 3;
          },
          'templateOptions.disabled': function() {
            return vm.budgetUnitPriceModel.ModelState == 3;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        TaskTypeId: function() {
          SetUnitPriceComboListFilter();
          vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      if (vm.controllerOptions.isFormReadOnly || !!vm.budgetUnitPriceModel.ValidTo) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      SetUnitPriceComboListFilter();

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.budgetUnitPriceModel, id: budgetUnitPriceId, budgetId: $stateParams.id };

        $http
          .post('Budget/BudgetUnitPriceEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
      function attachDocument() {
        toastr.warning(vm.messages.FunctionNotExists, vm.messages.Warning);
      }

      function history() {
        // TODO
        console.log(vm);
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        HistoryService.NavigateToHistory('FlgUnitPrice', vm.formModel.UnitPriceId, vm, $state);
        uibModalInstance.close();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ ComboList Filters ] ///////////////////////////////////

      function SetUnitPriceComboListFilter() {
        vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          taskTypeId: vm.budgetUnitPriceModel.TaskTypeId,
          statusActive: true,
        };
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetCondominiumEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'budgetCondominiumId',
    'HistoryService',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      budgetCondominiumId,
      HistoryService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetCondominiumEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetCondominiumModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrDelete = $stateParams.createOrDelete;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = attachDocument;
      vm.history = history;

      var disableValidFrom = !!vm.budgetCondominiumModel.ValidFrom;

      reCalculate();
      function reCalculate() {
        vm.budgetCondominiumModel.NoWaterClockValue =
          vm.budgetCondominiumModel.SumValue - vm.budgetCondominiumModel.WaterClockValue;
      }

      vm.formIsValid = function() {
        //syncValidator numerictextboxon nem mĹ±kĂ¶dik, helyette:
        var isValid =
          vm.budgetCondominiumModel.SumValue > 0 &&
          vm.budgetCondominiumModel.WaterClockValue >= 0 &&
          vm.budgetCondominiumModel.NoWaterClockValue >= 0;
        return isValid;
      };

      //ha validTo != null, csak olvvashatĂł
      if (vm.budgetCondominiumModel.ValidTo != null) {
        vm.formIsReadonly = true;
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        ValidFrom: {
          'templateOptions.disabled': function() {
            return disableValidFrom;
          },
        },
        //"ValidTo": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},
        //"WaterClockValue": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},
        //"UnitsType": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},

        //"SumValue": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},
        //"NoWaterClockValue": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},
        //"ModelState": {
        //    "templateOptions.required": function () {
        //        return (vm.budgetCondominiumModel.ModelState != 3);
        //    }
        //},
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        SumValue: function() {
          reCalculate();
          //vm.pageModel.Fields.SumValue.FormlyFieldDescriptor.formControl.$validate();
        },
        WaterClockValue: function() {
          reCalculate();
          //vm.pageModel.Fields.WaterClockValue.FormlyFieldDescriptor.formControl.$validate();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        //"SumValue": function (selectedItem) {
        //    if (selectedItem) {
        //        reCalculate();
        //        vm.pageModel.Fields.SumValue.FormlyFieldDescriptor.formControl.$validate();
        //    }
        //},
        //"WaterClockValue": function (selectedItem) {
        //    if (selectedItem) {
        //        reCalculate();
        //    }
        //},
        // \    /\
        //  )  ( ')
        // (  /  )
        //  \(__)|
        // cica: onBlur helyett onChange fut a numeric textboxokra is
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.budgetCondominiumModel, id: budgetCondominiumId, budgetId: $stateParams.id };

        $http
          .post('Budget/BudgetCondominiumEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
      function attachDocument() {
        var id = vm.formModel.BudgetCondominiumId;
        dasService.NavigateToDas(vm.messages, 'Budget.DasDocumentsNav', 'FlgBudgetCondominium', id);
      }

      function history() {
        HistoryService.NavigateToHistory('FlgBudgetCondinium', budgetCondominiumId, vm, $state);
        uibModalInstance.close();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Initialisation of Dynamic F2 filters ] /////////////////////

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetPremiseEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'HistoryService',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      HistoryService,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetPremiseEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetPremiseModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrDelete = $stateParams.createOrDelete;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = attachDocument;
      vm.history = history;

      //F22 whereConditions
      vm.getF22ConditionForObProperty = function() {
        return "Level~eq~'PPROB'";
      };
      vm.getF22ConditionForProperty = function() {
        return (
          "Level~in~'PPRBU,PPRED,PPRLA'" +
          (!!vm.budgetPremiseModel.ObProperty && vm.budgetPremiseModel.ObProperty.Value > 0
            ? '~and~ConPropertyId~eq~' + vm.budgetPremiseModel.ObProperty.Value
            : '')
        );
      };
      vm.getF22ConditionForPremise = function() {
        var where = "(BudgetId~isnull~or~BudgetId~eq~0)~and~ValidTo~isnull~and~PremiseType~in~'PRERE,PRECO'";
        if (!!vm.budgetPremiseModel.ObProperty && vm.budgetPremiseModel.ObProperty.Value > 0)
          where += '~and~ConPropertyId~eq~' + vm.budgetPremiseModel.ObProperty.Value;
        if (!!vm.budgetPremiseModel.Property && vm.budgetPremiseModel.Property.Value > 0)
          where += '~and~PropertyId~eq~' + vm.budgetPremiseModel.Property.Value;
        return where;
      };

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      //init F22
      vm.pageModel.Fields.ObProperty.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.getF22ConditionForObProperty;
      vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.getF22ConditionForProperty;
      vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.whereCondition =
        vm.getF22ConditionForPremise;
      //Disable prefilled F22
      vm.pageModel.Fields.ObProperty.FormlyFieldDescriptor.templateOptions.disabled =
        !!vm.budgetPremiseModel.ObProperty && vm.budgetPremiseModel.ObProperty.Value > 0;
      vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.disabled =
        !!vm.budgetPremiseModel.Property && vm.budgetPremiseModel.Property.Value > 0;
      //F4 params

      vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        BudgetId: 1234,
      };

      // Saves the current main item
      function saveItem() {
        vm.budgetPremiseModel.BudgetId = parseInt($stateParams.id);
        $http
          .post('Budget/BudgetPremiseEdit', vm.budgetPremiseModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }
      function attachDocument() {
        var id = vm.budgetPremiseModel.BudgetPremiseId;
        dasService.NavigateToDas(vm.messages, 'Budget.DasDocumentsNav', 'FlgBudgetPremise', id);
      }

      function history() {
        // TODO
        console.log(vm);
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        HistoryService.NavigateToHistory('FlgPremiseCondinium', vm.formModel.BudgetPremiseCondiniumId, vm, $state);
        uibModalInstance.close();
      }

      // var onChangeFunctions = {
      // "ObProperty": function (selectedItem) {
      // //vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.formControl.$validate();
      // },
      // };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetPremiseDelCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'LockService',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetPremiseDelCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.budgetPremiseModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrDelete = $stateParams.createOrDelete;

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Budget/BudgetPremiseDel', vm.budgetPremiseModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.DeleteSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetItemEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'lodash',
    function($http, model, $state, $stateParams, $scope, dasService, lockService, lodash) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetItemEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.dataModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.createOrEdit = $stateParams.createOrEdit;
      vm.hasPartition = false;
      vm.tenTypes = vm.dataModel.BudgetItemTenTypeId;
      vm.origPlanValueCalc = vm.dataModel.PlanValueCalc;

      // MenuItems
      vm.save = saveItem;
      vm.back = back;
      vm.attachDocument = attachDocument;
      vm.history = history;

      vm.UnitsTypeForUnitPrice = ['BUTOP', 'BUTUP', 'BUTPP'];

      //Comment Textarea height:
      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions['rows'] = 4;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Set editability of fields based on controllerOptions

      if (vm.controllerOptions.isFormReadOnly || vm.dataModel.ReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      if (!!vm.dataModel.BudgetItemTenTypeId) {
        vm.hasPartition = true;
      }

      if (!!vm.dataModel.BudgetItemPeriodId) {
        var excludedField = ['CondominiumValue', 'PlanValueCalc', 'InvoicedValueCalc', 'Comment'];
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = excludedField.indexOf(key) == -1;
        });
      } else {
        kendoMSInit('PeriodId');
        vm.pageModel.Fields.BudSubGroupId.FormlyFieldDescriptor.templateOptions.disabled = !!vm.dataModel.HasPeriod;
        vm.pageModel.Fields.PerMonth.FormlyFieldDescriptor.templateOptions.disabled = !!vm.dataModel.HasPeriod;
        vm.pageModel.Fields.AllocationId.FormlyFieldDescriptor.templateOptions.disabled = !!vm.dataModel.HasPeriod;
        vm.pageModel.Fields.Commitment.FormlyFieldDescriptor.templateOptions.disabled = !!vm.dataModel.HasPeriod;
      }
      kendoMSInit('BudgetItemTenTypeId');

      vm.pageModel.Fields.CondominiumValue.FormlyFieldDescriptor.templateOptions.disabled = !vm.dataModel
        .HasCondominiumValue;
      vm.pageModel.Fields.PlanValueCalc.FormlyFieldDescriptor.templateOptions.disabled =
        vm.dataModel.HasCondominiumValue;
      vm.pageModel.Fields.BudgetItemTenTypeId.FormlyFieldDescriptor.templateOptions.disabled = vm.hasPartition;
      vm.pageModel.Fields.BudgetItemTenTypeId.FormlyFieldDescriptor.templateOptions.required = !vm.hasPartition;

      ////////////////////////////////////////////////////////////////////////////////////////

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        PlanValueCalc: {
          'templateOptions.disabled': function() {
            // az a serviceid szerepel e az flgservicetask táblában -> ha van, akkor van tevékenység rendelve tehát disabled, ha nem szerepel, akkor meg engedjük
            return (
              (!!vm.dataModel.ServiceId && !!vm.dataModel.HasServiceTask) ||
              vm.UnitsTypeForUnitPrice.indexOf(vm.dataModel.AllocationUnitsType) !== -1
            );
          },
        },
        CondominiumValue: {
          'templateOptions.disabled': function() {
            return (
              !vm.dataModel.HasCondominiumValue ||
              vm.UnitsTypeForUnitPrice.indexOf(vm.dataModel.AllocationUnitsType) !== -1
            );
          },
        },
        UnitPrice: {
          'templateOptions.disabled': function() {
            return vm.UnitsTypeForUnitPrice.indexOf(vm.dataModel.AllocationUnitsType) === -1;
          },
          'templateOptions.required': function() {
            return vm.UnitsTypeForUnitPrice.indexOf(vm.dataModel.AllocationUnitsType) !== -1;
          },
        },
        AllocationId: {
          'templateOptions.disabled': function() {
            return !!vm.dataModel.BudgetItemPeriodId || !!vm.dataModel.HasPeriod;
            // || !!vm.defaultAllocationForCalcType || vm.dataModel.CalcType === 'BCTPM'
          },
        },
        BudgetItemTenTypeId: {
          'templateOptions.disabled': function() {
            if (!vm.dataModel.TenementPartition) {
              return true;
            } else {
              return vm.hasPartition || vm.createOrEdit == 'Edit';
            }
          },
          'templateOptions.required': function() {
            if (!vm.dataModel.TenementPartition) {
              return false;
            } else {
              return !(vm.hasPartition || vm.createOrEdit == 'Edit');
            }
          },
        },
      };

      var customCallbackFunctions = {
        TenementPartition: function() {
          if (!vm.dataModel.TenementPartition) {
            vm.dataModel.BudgetItemTenTypeId = '';
          } else {
            vm.dataModel.BudgetItemTenTypeId = vm.tenTypes;
          }
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      /**
       * Ha viszont a Kalkulálás típusa-nak IK-t választunk (CalcType=’BCTPM’), akkor itt fixen és nem módosíthatóan az a felosztási alap kerül beírásra,
       * ahol a mennyiségi egység típusa „m2 egyenértékű” (UnitsType=’BUTES’), bérbeadás állapota „bérelhető” (RentalStatus=’BRSLE’),
       * vízórás-e értéke „összes” (WaterClock=’BWCAL’).
       **/
      var optionsOfAllocationId = lodash.get(
        vm.pageModel.Fields.AllocationId,
        'FormlyFieldDescriptor.templateOptions.GridOptions'
      );
      if (optionsOfAllocationId) {
        var controllerMethod = optionsOfAllocationId.gridModel.ControllerMethod;
        if (controllerMethod.indexOf('/') === -1) {
          controllerMethod = 'F2/' + controllerMethod;
        }

        var dataSourceForBCTPM = new kendo.data.DataSource({
          //type: 'aspnetmvc-ajax',
          transport: {
            read: {
              url: controllerMethod,
              contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
              type: 'POST',
              cache: false, //IE miatt kell!!
            },
          },
          filter: {
            logic: 'and',
            filters: [
              {
                field: 'UnitTypeName',
                operator: 'eq',
                value: vm.pageModel.Labels['LabelFilterForUnitTypeName'].Title,
              },
              {
                field: 'WaterClockName',
                operator: 'eq',
                value: vm.pageModel.Labels['LabelFilterForWaterClockName'].Title,
              },
              {
                field: 'RentalStatusName',
                operator: 'eq',
                value: vm.pageModel.Labels['LabelFilterForRentalStatusName'].Title,
              },
            ],
          },
          pageSize: 1,
          schema: {
            data: 'Data',
            total: 'Total',
          },
        });
      }

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        CalcType: function(selectedItem) {
          if (selectedItem.key === 'BCTPM') {
            dataSourceForBCTPM.fetch().then(function() {
              var data = dataSourceForBCTPM.view();

              if (data.length != 0) {
                vm.dataModel.AllocationId = data[0].AllocationId;
                $scope.$applyAsync();
              }
            });
          } else {
            vm.defaultAllocationForCalcType =
              !!selectedItem && !!selectedItem.extraProperties && !!selectedItem.extraProperties[0]
                ? selectedItem.extraProperties[0].value
                : null;
            if (!!vm.defaultAllocationForCalcType) {
              vm.dataModel.AllocationId = parseInt(vm.defaultAllocationForCalcType);
            }
          }
        },
        CondominiumValue: function(selectedItem) {
          vm.dataModel.PlanValueCalc = !!vm.dataModel.CondominiumValue
            ? vm.dataModel.PlanValueCalcFormula.replace('#', vm.dataModel.CondominiumValue)
            : null;
          var val = tryEval(vm.dataModel.PlanValueCalc);
          vm.dataModel.PlanValue = val === false ? null : val;
        },
        AllocationId: function(selectedItem, sel) {
          vm.dataModel.AllocationUnitsType = selectedItem?.UnitsType;
          if (!vm.dataModel.HasPeriod && vm.UnitsTypeForUnitPrice.indexOf(vm.dataModel.AllocationUnitsType) !== -1)
            vm.dataModel.PerMonth = 1;
          if (!!selectedItem) {
            if (!!selectedItem.AllocationId) {
              $http({
                method: 'GET',
                url: 'Budget/GetPlanValueCalcFormula',
                params: {
                  allocationId: selectedItem.AllocationId,
                  budgetId: vm.dataModel.BudgetId,
                  budgetDate: vm.dataModel.BudgetDate,
                },
              }).then(function(data) {
                vm.dataModel.PlanValueCalcFormula = data.data.Value;
                if (!!vm.dataModel.BudgetItemTenTypeId) GetBudgetitemQuantity();
                else reCalc();
              });
            }
          } else {
            vm.dataModel.PlanValueCalc = '';
            vm.dataModel.PlanValueCalcFormula = '';
          }
        },
        UnitPrice: function() {
          reCalc();
        },
        PlanValueCalc: function(value) {
          if (value) vm.dataModel.PlanValueCalc = value.replace(/,/g, '.');
          var val = tryEval(vm.dataModel.PlanValueCalc);
          vm.dataModel.PlanValue = val === false ? null : val;
        },
        InvoicedValueCalc: function(value) {
          if (value) vm.dataModel.InvoicedValueCalc = value.replace(/,/g, '.');
          var val = tryEval(vm.dataModel.InvoicedValueCalc);
          vm.dataModel.InvoicedValue = val === false ? null : val;
        },
        BudgetItemTenTypeId: function() {
          GetBudgetitemQuantity();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {
        PlanValueCalc: function() {
          if (!vm.dataModel.InvoicedValueCalc) {
            vm.dataModel.InvoicedValueCalc = vm.dataModel.PlanValueCalc;
            vm.dataModel.InvoicedValue = vm.dataModel.PlanValue;
          }
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        PeriodId: {
          PeriodIdValidator: function(modelValue) {
            //nem működik KendoMs-re!!!
            return true;
          },
        },
        PlanValueCalc: {
          PlanValueCalcValidator: function(modelValue) {
            if (!modelValue) return false;
            var normalized = modelValue.replace(/,/g, '.');
            return /^[0-9*/+ ().-]+$/.test(normalized) && tryEval(normalized) !== false;
          },
        },
        InvoicedValueCalc: {
          InvoicedValueCalcValidator: function(modelValue) {
            if (!modelValue) return true;
            var normalized = modelValue.replace(/,/g, '.');
            return /^[0-9*/+ ().-]+$/.test(normalized) && tryEval(normalized) !== false;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertParsers(vm.pageModel, parsers);
      vm.pageModel.Fields.PeriodId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        budgetItemId: vm.dataModel.BudgetItemId,
        showAllPeriod:
          !vm.controllerOptions.isFormReadOnly && !vm.dataModel.ReadOnly && !!vm.dataModel.BudgetItemPeriodId,
      };

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Budget/BudgetItem' + (!!vm.dataModel.BudgetItemPeriodId ? 'Edit' : 'Create'), vm.dataModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (response.data.GenSucces === false) {
              toastr.warning(response.data.GenMessage, vm.pageModel.Messages.GenerateFailed);
            }
            $state.go('Budget.Budget.BudgetEdit', { id: vm.dataModel.BudgetId, openedPanelGroup: 'PGBudgetItemData' });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function back() {
        $state.go('Budget.Budget.BudgetEdit', { id: vm.dataModel.BudgetId, openedPanelGroup: 'PGBudgetItemData' });
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      function tryEval(code) {
        var ret;
        try {
          ret = eval(code);
        } catch (e) {
          return false;
        }
        return ret === Infinity || ret === -Infinity ? false : ret;
      }

      function kendoMSInit(field) {
        vm.pageModel.Fields[field].FormlyFieldDescriptor.type = 'kendoMS';
      }

      function attachDocument() {
        var id = vm.dataModel.BudgetItemId;
        dasService.NavigateToDas(vm.messages, 'Budget.DasDocumentsNav', 'FlgBudgetItem', id);
      }

      function GetBudgetitemQuantity() {
        clearTimeout(vm.QuantityDebounceTimeOut);
        vm.QuantityDebounceTimeOut = setTimeout(() => {
          GetBudgetitemQuantity_GET();
        }, 1000);
      }

      function GetBudgetitemQuantity_GET() {
        if (!!vm.dataModel.BudgetItemTenTypeId && !!vm.dataModel.AllocationId && vm.dataModel.AllocationId.Value) {
          $http({
            method: 'GET',
            url: 'Budget/GetBudgetitemQuantity',
            params: {
              budgetItemId: vm.dataModel.BudgetItemId,
              allocationId: vm.dataModel.AllocationId.Value,
              tenTypes: vm.dataModel.BudgetItemTenTypeId,
            },
          }).then(function(result) {
            vm.dataModel.Quantity = result.data.Quantity;
            reCalc();
          });
        }
      }

      function reCalc() {
        vm.dataModel.PlanValueCalc = !!vm.dataModel.CondominiumValue
          ? vm.dataModel.PlanValueCalcFormula.replace('#', vm.dataModel.CondominiumValue)
          : vm.dataModel.AllocationUnitsType === 'BUTUP' ||
            vm.dataModel.AllocationUnitsType === 'BUTOP' ||
            vm.dataModel.AllocationUnitsType === 'BUTPP'
          ? getButupPlanValueCalc(vm.dataModel.UnitPrice * vm.dataModel.Quantity)
          : vm.dataModel.PlanValueCalc;

        var val = tryEval(vm.dataModel.PlanValueCalc);
        vm.dataModel.PlanValue = val === false ? null : val;
      }

      function getButupPlanValueCalc(newValue) {
        if (!!vm.origPlanValueCalc && vm.origPlanValueCalc.indexOf('/') !== -1) {
          return vm.origPlanValueCalc.replace(/^.*?(?=\/)/, newValue);
        } else {
          return newValue;
        }
      }

      function history() {
        // TODO
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        HistoryService.NavigateToHistory('FlgBudgetItem', vm.dataModel.BudgetItemId, vm, $state);
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetOpSettlementEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'FileSaver',
    function($http, model, $state, $stateParams, $uibModal, $scope, uibModalInstance, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetOpSettlementEditCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.dataModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      var createOrDelete = $stateParams.createOrDelete;

      //Dynamic filter
      var whereConditionFunction = function() {
        return "FinancialYear~eq~'" + vm.dataModel.FinancialYear + "'";
      };

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        BudgetId: {
          'templateOptions.disabled': function() {
            return !vm.dataModel.FinancialYear;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      //CustomControllers
      //				vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod = "Budget/BudgetListOnlyActive"; //Budget/BudgetForF4
      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        $http
          .post('Budget/BudgetOpSettlementReport', vm.dataModel)
          .then(function(response) {
            var data = response.data.Report;

            if (!response.data.ResultStatus || !data) {
              toastr.error(response.data.Errors[0].Message, vm.pageModel.Messages.GenerateFailed);
              return false;
            }

            var reportName =
              vm.pageModel.Labels['LabelReportNamePrefix'].Title +
              ' (' +
              vm.dataModel.FinancialYear +
              ' - ' +
              vm.dataModel.BudgetId.join(',') +
              ').xls';
            saveFileAs(data, reportName);
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      }

      function saveFileAs(data, fileName) {
        var raw = window.atob(data);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(fs, fileName);
      }

      function cancelItem() {
        uibModalInstance.close();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Helper functions ] ///////////////////////////////////

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetModifyDelCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'LockService',
    'gridService',
    function($http, model, $state, $stateParams, $uibModal, $scope, uibModalInstance, lockService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetModifyDelCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.dataModel.BudgetModifyId = [];
        vm.btnIsDisable = true;

        vm.mainGridIdField = vm.pageModel.Grids['GridModifyPlanning'].IdColumn;
        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: vm.pageModel.Grids['GridModifyPlanning'],
          transportData: {
            tableName: vm.pageModel.Grids['GridModifyPlanning'].Table,
            whereCondition: "TicketId~eq~'" + vm.dataModel.TicketId + "'",
            adopter: vm.pageModel.Grids['GridModifyPlanning'].Adopter,
            installAdopter: vm.pageModel.Grids['GridModifyPlanning'].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids['GridModifyPlanning'].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids['GridModifyPlanning'].IdColumn,
            whereCondition: "BudgetId~eq~'" + vm.dataModel.BudgetId + "'",
          },
        });
        vm.mainGridOptions.autoBind = true;

        vm.mainGridOptions.filterable = false;
        vm.mainGridOptions.pageable = false;

        vm.mainGridOptions.columns[0].width = '80px';
        vm.mainGridOptions.columns[1].attributes = { style: 'text-align: center;' };
        vm.mainGridOptions.columns[2].attributes = { style: 'text-align: center;' };
        vm.mainGridOptions.columns[3].attributes = { style: 'text-align: center;' };

        var checkboxColumn = {
          headerTemplate: ' ',
          template:
            "<input type='checkbox' class='fw-select-checkbox' ng-model='dataItem.checked' ng-disabled='dataItem.IsGenerated' />",
          width: '24px',
          lockable: false,
        };
        vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);
        vm.mainGridOptions.dataBound = function(e) {
          var grid = this;
          //Checked selected row;
          var items = e.sender.items();
          var gridPage = e.sender;
          items.each(function(index) {
            var dataItem = gridPage.dataItem(this);
            if (dataItem.IsGenerated) {
              dataItem.checked = false;
              manageBudgetModifyId(dataItem.BudgetModifyId, false);
            } else {
              dataItem.checked = vm.dataModel.BudgetModifyId.indexOf(dataItem.BudgetModifyId) !== -1;
            }
          });

          $scope.$applyAsync();

          $(this.tbody)
            .find('.fw-select-checkbox')
            .bind('change', function(e) {
              var row = $(e.target).closest('tr');
              var budgetModifyId = grid.dataItem(row).BudgetModifyId;
              manageBudgetModifyId(budgetModifyId, this.checked);
              vm.btnIsDisable =
                vm.dataModel.BudgetModifyId.length < 1 ||
                vm.mainGrid.dataSource.data().length <= vm.dataModel.BudgetModifyId.length;
              $scope.$applyAsync();
            });
        };

        function manageBudgetModifyId(id, add) {
          if (add) vm.dataModel.BudgetModifyId.push(id);
          else
            vm.dataModel.BudgetModifyId = vm.dataModel.BudgetModifyId.filter(function(e) {
              return e !== id;
            });
        }
      }
      init();

      vm.delete = function() {
        bootbox.dialog({
          message: vm.pageModel.Labels['LabelWarning'].Title,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.pageModel.Actions['btnCancel'].Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Actions['btnOk'].Title,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('Budget/BudgetModifyDelete', vm.dataModel)
                  .then(function(response) {
                    if (!response.data.ResultStatus) {
                      toastr.error(response.data.Errors[0].Message, vm.pageModel.Messages['DeleteFailed']);
                      return false;
                    }
                    toastr.success(vm.pageModel.Messages['DeleteSuccessful']);
                    lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                    uibModalInstance.close(true);
                  })
                  .catch(function(response) {
                    toastr.error(vm.pageModel.Messages['DeleteSuccessful']);
                  });
              },
            },
          },
        });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      };

      vm.btnIsDisable = function() {
        console.log(vm.dataModel.BudgetModifyId);
        return (
          vm.dataModel.BudgetModifyId.length < 1 ||
          vm.mainGrid.dataSource.data().length >= vm.dataModel.BudgetModifyId.length
        );
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TenementPartitionInputModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    'LockService',
    'gridService',
    'FileSaver',
    function(
      $http,
      model,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      uibModalInstance,
      lockService,
      gridService,
      FileSaver
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenementPartitionInputModalCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);

        vm.pageModel.Fields.DateFrom.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          budgetDateId: vm.dataModel.BudgetDateId,
        };
      }
      init();

      vm.save = function() {
        $http
          .post('Budget/TenementPartitionDownloadXls', {
            budgetModifyId: vm.dataModel.BudgetModifyId,
            dateFrom: vm.dataModel.DateFrom,
          })
          .then(function(data) {
            angular.forEach(data.data.Files, function(row, key) {
              var raw = window.atob(row.File);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              FileSaver.saveAs(fs, row.Filename + '.xlsx');
            });

            toastr.success(
              vm.pageModel.Messages.GeneratedFilesCount + ' ' + data.data.Files.length,
              vm.pageModel.Messages.GenerateXlsSuccessful
            );
            uibModalInstance.close();
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('BudgetGenerateModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BudgetGenerateModalCtrl', stateParams);
      }
      var vm = this;

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        var fs = fieldSetter;
        fs.vm = vm;
        fs.setOnChangeFunction('FinancialYear', function(selectedItem) {
          vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        });
        generateForm(vm);
        vm.pageModel.Fields.BudgetDate.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          return { financialYear: vm.dataModel.FinancialYear };
        };
      }
      init();

      vm.save = function() {
        $http
          .post('Budget/BudgetGenerate', vm.dataModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(response.message);
          });
      };

      vm.cancel = function() {
        uibModalInstance.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;

      if ($state.params.InvoiceTypeFilter !== null && $state.params.InvoiceTypeFilter !== '') {
        vm.currentState = $state.current.name + '({InvoiceTypeFilter: "' + $state.params.InvoiceTypeFilter + '"})';
      }

      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('Invoice.InvoiceNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Invoice_Cust: { icon: 'fa fa-file-text' },
        Invoice_Supp: { icon: 'fa fa-file-text' },
        Invoice_Diff: { icon: 'fa fa-file-text' },
        Invoice_SuppInvoiceApp: { icon: 'fa fa-file-text' },
      };
      buildMenu($state, authService, 'Invoice', 'invoice', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Invoice: {
        url: '/invoice',
        templateUrl: 'App/Invoice/InvoiceLayout.html',
        controller: 'InvoiceLayoutCtrl as vm',
        redirectTo: 'Invoice.InvoiceNav',
        ncyBreadcrumb: {
          skip: true,
          label: 'Számlaiktatás nyilvántartás',
          parent: 'main',
        },
      },
      'Invoice.InvoiceNav': {
        url: '/{InvoiceTypeFilter:string}',
        params: {
          module: 'Invoice',
          formMode: 'Nav',
          backState: 'main',
          InvoiceTypeFilter: 'INTCU',
          bstates: ['Invoice.SupplierInvoiceEdit', 'Invoice.SupplierInvoiceCreate'],
          documentEntity: 'invoice_invoicenav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceNav.html',
            controller: 'InvoiceNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/ListInvoiceOptions/', undefined, ['InvoiceTypeFilter']),
        },
        ncyBreadcrumb: {
          label: 'Számlaiktatás nyilvántartás',
          parent: 'main',
        },
      },
      'Invoice.SuppInvoiceNav': {
        url: '/INTSU',
        params: {
          module: 'Invoice',
          formMode: 'Nav',
          backState: 'main',
          InvoiceTypeFilter: 'INTSU',
          lockTypeFilterCombo: true,
          bstates: ['Invoice.SupplierInvoiceEdit', 'Invoice.SupplierInvoiceCreate'],
          documentEntity: 'invoice_invoicenav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceNav.html',
            controller: 'InvoiceNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/ListInvoiceOptions/', undefined, ['InvoiceTypeFilter']),
        },
        ncyBreadcrumb: {
          label: 'Számlaiktatás nyilvántartás',
          parent: 'main',
        },
      },
      'Invoice.CondominiumInvoiceNav': {
        url: '/condominiuminvoice',
        params: {
          module: 'Invoice',
          formMode: 'Nav',
          backState: 'main',
          InvoiceTypeFilter: 'INTTH',
          lockTypeFilterCombo: true,
          bstates: ['Invoice.SupplierInvoiceEdit', 'Invoice.SupplierInvoiceCreate'],
          documentEntity: 'invoice_condominiuminvoicenav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/CondominiumInvoiceNav.html',
            controller: 'CondominiumInvoiceNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/ListCondInvoiceOptions/', undefined, ['InvoiceTypeFilter']),
        },
        ncyBreadcrumb: {
          label: 'Társasházi utalások nyilvántartás',
          parent: 'main',
        },
      },
      'Invoice.CondominiumInvoiceView': {
        url: '/condominiuminvoiceview/{id:int}?buttons',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/CondominiumInvoiceEdit.html',
            controller: 'CondominiumInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CondominiumInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'CondominiumInvoiceNav',
          documentEntity: 'invoice_condominiuminvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Társasházi utalás megtekintés',
        },
      },
      'Invoice.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Invoice.CustomerInvoiceCreate': {
        url: '/customerinvoicecreate/{id:int}?invoiceType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceCreate/', undefined, ['id', 'invoiceType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla felvétele',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTCU"})',
        },
      },
      'Invoice.CustomerInvoiceEdit': {
        url: '/customerinvoiceedit/{id:int}?invoiceType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceEdit/', undefined, ['id', 'invoiceType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla szerkesztése',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTCU"})',
        },
      },
      'Invoice.CustomerInvoiceDuplicate': {
        url: '/customerinvoiceduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla másolása',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTCU"})',
        },
      },
      'Invoice.RentInvoiceEdit': {
        url: '/rentaccountedit/{id:int}?invoiceType',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceEdit/', undefined, ['id', 'invoiceType']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla szerkesztése',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTRM"})',
        },
      },
      'Invoice.RentInvoiceView': {
        url: '/rentaccountview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'Nav',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számla megtekintés',
        },
      },
      'Invoice.CustomerInvoiceView': {
        url: '/customerinvoiceview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'Nav',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla megtekintés',
        },
      },
      'Invoice.PropertyInvoiceView': {
        url: '/rentaccountview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceEdit.html',
            controller: 'InvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/PropertyInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'Nav',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Elidegenítés megtekintés',
        },
      },
      'Invoice.SupplierInvoiceView': {
        url: '/supplierinvoiceview/{id:int}?buttons',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SupplierInvoiceEdit.html',
            controller: 'SupplierInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'SuppInvoiceNav',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla megtekintés',
        },
      },
      'Invoice.SupplierInvoiceAppView': {
        url: '/supplierinvoicevappiew/{id:int}?buttons',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SupplierInvoiceEdit.html',
            controller: 'SupplierInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceView/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'View',
          BackTo: 'SuppInvoiceApp',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla megtekintés',
        },
      },
      'Invoice.CustomerGridInvoiceRowCreate': {
        url: '/customerinvoicerowcreate/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceRowEdit.html',
            controller: 'InvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceRowCreate/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.CustomerGridInvoiceRowEdit': {
        url: '/customerinvoicerowedit/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceRowEdit.html',
            controller: 'InvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceRowEdit/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.CustomerGridInvoiceRowDuplicate': {
        url: '/customerinvoicerowduplicate/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceRowEdit.html',
            controller: 'InvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceRowDuplicate/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.RentGridInvoiceRowCreate': {
        url: '/rentaccountrowcreate/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/RentAccountRowEdit.html',
            controller: 'RentAccountRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceRowCreate/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.RentGridInvoiceRowEdit': {
        url: '/rentaccountrowedit/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/RentAccountRowEdit.html',
            controller: 'RentAccountRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceRowEdit/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.RentGridInvoiceRowDuplicate': {
        url: '/rentaccountrowduplicate/{id:int}?invoiceId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/RentAccountRowEdit.html',
            controller: 'RentAccountRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceRowDuplicate/', undefined, ['id', 'invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Kimenő számla tételek',
        },
      },
      'Invoice.SupplierInvoiceCreate': {
        url: '/supplierinvoicecreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SupplierInvoiceEdit.html',
            controller: 'SupplierInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'SuppInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla létrehozása',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTSU"})',
        },
      },
      'Invoice.SupplierInvoiceEdit': {
        url: '/supplierinvoiceedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SupplierInvoiceEdit.html',
            controller: 'SupplierInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'SuppInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla szerkesztése',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTSU"})',
        },
      },
      'Invoice.SupplierInvoiceDuplicate': {
        url: '/supplierinvoiceduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SupplierInvoiceEdit.html',
            controller: 'SupplierInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'SuppInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTSU"})',
        },
      },
      'Invoice.TenancyDivision': {
        url: '/tenancydivision/{invoiceId:int}/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/TenancyDivision.html',
            controller: 'TenancyDivisionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/TenancyDivision/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'SupplierInvoiceEdit',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
          openedPanelGroup: null,
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTSU"})',
        },
      },
      'Invoice.SuppInvoiceRowCreate': {
        url: '/suppinvoicerowcreate/{id:int}?invoiceId?orgPartId?unitSumId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SuppInvoiceRowEdit.html',
            controller: 'SuppInvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SuppInvoiceRowCreate/', undefined, [
            'id',
            'invoiceId',
            'orgPartId',
            'unitSumId',
          ]),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla tételek',
        },
      },
      'Invoice.SuppInvoiceRowEdit': {
        url: '/suppinvoicerowedit/{id:int}?invoiceId?orgPartId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SuppInvoiceRowEdit.html',
            controller: 'SuppInvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SuppInvoiceRowEdit/', undefined, ['id', 'invoiceId', 'orgPartId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla tételek',
        },
      },
      'Invoice.SuppInvoiceRowDuplicate': {
        url: '/suppinvoicerowduplicate/{id:int}?invoiceId?orgPartId',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SuppInvoiceRowEdit.html',
            controller: 'SuppInvoiceRowEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SuppInvoiceRowDuplicate/', undefined, ['id', 'invoiceId', 'orgPartId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói számla tételek',
        },
      },
      'Invoice.CustInvoiceEdit': {
        url: '/custinvoiceedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/CustInvoiceEdit.html',
            controller: 'CustInvoiceEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustInvoiceEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccounteditedit',
        },
        ncyBreadcrumb: {
          label: 'Vevő számla',
          parent: 'Invoice.InvoiceNav({InvoiceTypeFilter: "INTCU"})',
        },
      },
      //'Invoice.SuppGridInvoiceUnitSumCreate': {
      //  url: '/supplierinvunitdev/{invoiceId:int}',
      //  views: {
      //    menu: {
      //      templateUrl: 'App/TileMenu.html',
      //      controller: 'InvoiceMenuCtrl as vm',
      //    },
      //    content: {
      //      templateUrl: 'App/Invoice/SupplierInvUnitDev.html',
      //      controller: 'SupplierInvUnitDevCtrl as vm',
      //    },
      //  },
      //  resolve: {
      //    options: RouteResolveFunc('Invoice/SupplierInvUnitDev/', undefined, ['invoiceId']),
      //  },
      //  params: {
      //    controllerOptions: {
      //      isFormReadOnly: false,
      //    },
      //    EditOrDuplicate: 'Create',
      //    BackTo: 'InvoiceNav',
      //    module: 'Invoice',
      //    documentEntity: 'invoice_supplierinvoiceedit',
      //  },
      //  ncyBreadcrumb: {
      //    label: 'Szállítói számla felosztása',
      //  },
      //},
      //'Invoice.SuppGridInvoiceUnitSumEdit': {
      //  url: '/supplierinvunitdev/{invoiceId:int}',
      //  views: {
      //    menu: {
      //      templateUrl: 'App/TileMenu.html',
      //      controller: 'InvoiceMenuCtrl as vm',
      //    },
      //    content: {
      //      templateUrl: 'App/Invoice/SupplierInvUnitDev.html',
      //      controller: 'SupplierInvUnitDevCtrl as vm',
      //    },
      //  },
      //  resolve: {
      //    options: RouteResolveFunc('Invoice/SupplierInvUnitDev/', undefined, ['invoiceId']),
      //  },
      //  params: {
      //    controllerOptions: {
      //      isFormReadOnly: false,
      //    },
      //    EditOrDuplicate: 'Edit',
      //    BackTo: 'InvoiceNav',
      //    module: 'Invoice',
      //    documentEntity: 'invoice_supplierinvoiceedit',
      //  },
      //  ncyBreadcrumb: {
      //    label: 'Szállítói számla felosztása',
      //  },
      //},
      //"Invoice.GridSuppInvoiceApprovalEdit": {
      //    url: "/suppinvoiceapp/",
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "InvoiceMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/Invoice/SuppInvoiceApp.html",
      //            controller: "SuppInvoiceAppCtrl as vm",
      //            resolve: {
      //                options: RouteResolveFunc("Invoice/SuppInvoiceApp/")
      //            }
      //        }
      //    },
      //    params: {
      //        controllerOptions: {
      //            isFormReadOnly: false
      //        },
      //        EditOrDuplicate: "Edit",
      //        BackTo: "InvoiceNav",
      //        module: "Invoice",
      //        formMode: "Nav"
      //    },
      //    ncyBreadcrumb: {
      //        label: "Szállítói számlák jóváhagyása"
      //    }
      //},
      'Invoice.CustomerInvoiceCorrection': {
        url: '/customerinvoicecorrection/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceCorrection/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Vevő helyesbítő számla',
        },
      },
      'Invoice.RentInvoiceCorrection': {
        url: '/rentinvoicecorrection/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceCorrection/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj helyesbítő számla',
        },
      },
      'Invoice.SupplierInvoiceCorrection': {
        url: '/supplierinvoicecorrection/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceCorrection/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'SuppInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Szállítói helyesbítő számla',
        },
      },
      'Invoice.PropertyInvoiceCorrection': {
        url: '/propertyinvoicecorrection/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/PropertyInvoiceCorrection/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_rentaccountedit',
        },
        ncyBreadcrumb: {
          label: 'Elidegenítés helyesbítő számla',
        },
      },
      'Invoice.CondominiumInvoiceCorrection': {
        url: '/condominiumcorrection/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceCorrection.html',
            controller: 'InvoiceCorrectionCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CondominiumInvoiceCorrection/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'CondominiumInvoiceNav',
          module: 'Invoice',
          InvoiceType: 'Condominium',
          documentEntity: 'invoice_condominiuminvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Társasházi utalás helyesbítő számla',
        },
      },
      'Invoice.CustomerInvoiceStorno': {
        url: '/customerinvoicestorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CustomerInvoiceStorno/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_invoicenav',
        },
        ncyBreadcrumb: {
          label: 'Vevő számlák stornózása',
        },
      },
      'Invoice.RentInvoiceStorno': {
        url: '/rentstorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/RentInvoiceStorno/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_invoicenav',
        },
        ncyBreadcrumb: {
          label: 'Bérleti díj számlák stornózása',
        },
      },
      'Invoice.SupplierInvoiceStorno': {
        url: '/supplierinvoicestorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SupplierInvoiceStorno/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'SuppInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Bejövő számla sztornózása',
        },
      },
      'Invoice.CondominiumInvoiceStorno': {
        url: '/condominiumstorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/CondominiumInvoiceStorno/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'CondominiumInvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_condominiuminvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Társasházi utalás számla sztornózása',
        },
      },
      'Invoice.PropertyInvoiceStorno': {
        url: '/propertyinvoicestorno/{invoiceId:int}',

        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/InvoiceStorno.html',
            controller: 'InvoiceStornoCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/PropertyInvoiceStorno/', undefined, ['invoiceId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          documentEntity: 'invoice_supplierinvoiceedit',
        },
        ncyBreadcrumb: {
          label: 'Elidegenítés számlák stornózása',
        },
      },
      'Invoice.SuppInvoiceApp': {
        url: '/suppinvoiceapp/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Invoice/SuppInvoiceApp.html',
            controller: 'SuppInvoiceAppCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Invoice/SuppInvoiceApp/'),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          BackTo: 'InvoiceNav',
          module: 'Invoice',
          formMode: 'Nav',
          documentEntity: 'invoice_suppinvoiceapp',
        },
        ncyBreadcrumb: {
          label: 'Jóváhagyandó számlák',
        },
      },
      'Invoice.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId/:prefix',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'InvoiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Invoice/{prefix}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Invoice");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('InvoiceNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $state.current.params !== 'undefined' ? $state.current.params : null;
        ctrlInit(this, 'InvoiceNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.InvoiceType = options.dto.InvoiceType;
      vm.Modifyable = false;
      vm.activeSubItemTab = 0;
      vm.allCheck = false;
      vm.isWalVisible = false;
      // Paraméter ellenőrzése!

      if (['INTRM', 'INTCU', 'INTSU', 'INTCP', 'INTCA', 'INTCI', 'INTNA'].indexOf(vm.InvoiceType) < 0) {
        toastr.error('Hibás paraméter!', vm.messages.Warning);
        $state.go('Invoice.InvoiceNav', { InvoiceTypeFilter: 'INTSU' });
        return;
      }

      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridInvoiceStatus'], ['ModDate', 'RejectDate']);

      vm.usedInvoiceGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.createInvoice = createInvoice;
      vm.editInvoice = editInvoice;
      vm.deleteInvoice = deleteInvoice;
      vm.duplicateInvoice = duplicateInvoice;
      vm.viewInvoice = viewInvoice;
      vm.lockInvoice = lockInvoice;
      vm.stornoInvoice = stornoInvoice;
      vm.reOpenInvoice = reOpenInvoice;
      vm.reOpenButtonStatus = reOpenButtonStatus;
      vm.correctInvoice = correctInvoice;
      vm.printInvoice = printInvoice;
      vm.generateContrInvoice = generateContrInvoice;
      vm.invoiceGen = invoiceGen;
      vm.getPartnerAccountBalance = getPartnerAccountBalance;
      vm.invoiceImport = InvoiceImport;
      vm.invoiceExport = InvoiceExport;
      vm.WAL = WAL;
      vm.History = History;
      vm.pageModel.Grids.GridInvoice.storageKey = vm.pageModel.Grids.GridInvoice.Id + '.' + vm.InvoiceType;
      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
          case 'INTCU':
            type = 'Customer';
            break;
          case 'INTSU':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);

      //lapfül mentés
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      var onChangeFunctions = {
        Period: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.formModel.Period.Value = selectedItem ? selectedItem.Period : null;
          vm.checkedIds = [];
          vm.checkedRows = [];
          vm.allCheck = false;
          vm.mainGrid.dataSource.read();
        },
        InvoiceType: function(selectedItem) {
          vm.checkedIds = [];
          vm.checkedRows = [];
          vm.allCheck = false;
          //vm.mainGrid.dataSource.read();
          $state.go('Invoice.InvoiceNav', { InvoiceTypeFilter: selectedItem.key });
          //A látszó tabokon ürítem a gridet:
          var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
          angular.forEach(tabs, function(value, key) {
            if (!!vm.detailItemGrids[value]) vm.detailItemGrids[value].dataSource.data([]);
          });
        },
        //"ContractId": function (selectedItem) {
        //    //Törölhető, ha az F2 időben beírja majd az értéket
        //    vm.formModel.ContractId.Value = selectedItem ? selectedItem.ContractId : 0;
        //    vm.mainGrid.dataSource.read();
        //},
        //"InvoiceId": function (selectedItem) {
        //    //Törölhető, ha az F2 időben beírja majd az értéket
        //    vm.formModel.InvoiceId.Value = selectedItem ? selectedItem.InvoiceId : 0;
        //    vm.mainGrid.dataSource.read();
        //},
        PartnerId: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.formModel.PartnerId.Value = selectedItem ? selectedItem.PartnerId : null;
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        InvoiceType: {
          'templateOptions.disabled': function() {
            //return vm.InvoiceType === 'INTRM' || vm.InvoiceType === 'INTSU';
            return $state.current.params.lockTypeFilterCombo === true;
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      var ddOptions = vm.pageModel.Fields.InvoiceType.FormlyFieldDescriptor.templateOptions.options;
      delete ddOptions.optionLabel;

      /**
       * @return {string}
       */
      vm.InvoiceTypeName = function() {
        if (vm.InvoiceType === 'INTRM') {
          return 'Bérleti díj számla';
        } else if (vm.InvoiceType === 'INTCU') {
          return 'Vevő számla';
        } else if (vm.InvoiceType === 'INTSU') {
          return 'Szállítói számla';
        } else if (vm.InvoiceType === 'INTCO') {
          return 'Óvadék/Biztosítás';
        } else if (vm.InvoiceType === 'INTCP') {
          return 'Bérbeszámítás';
        } else if (vm.InvoiceType === 'INTDI') {
          return 'Elidegenítés';
        }
        return '';
      };

      // Látható oszlopok beállítása
      function getColumnsByInvoiceType(invoiceType) {
        switch (invoiceType) {
          case 'INTCU':
          case 'INTRM':
            return {
              GridInvoice: [
                'InvoiceStatusName',
                'Period',
                'Invoice',
                'RefInvoice',
                'StornoInvoice',
                'InvoiceTypeName',
                'InvoiceDate',
                'Fulfilment',
                'PaymentDueDate',
                'Net',
                'Vat',
                'Gross',
                'PartnerCode',
                'PartnerName',
                'InvoiceAddress',
                'OriginalDoc',
                'Pay',
                'Contract',
                'RentEventNumber',
                'BundleId',
                'CashDeposit',
                'SettleAnInvoice',
                'InvoicePad',
                'PadName',
                'Payment',
                'PaymentName',
                'Account1',
                'Account2',
                'Account3',
                'DefaultInterest',
                'DefaultInterestName',
                'DefaultInterestRate',
                'SumInvoice',
                'MergedContracts',
              ],
              GridInvoiceRow: [
                'RowNum',
                'Tenement',
                'Object',
                'AccountingFrom',
                'AccountingTo',
                'Quantity',
                'UnitCode',
                'UnitPrice',
                'Discount',
                'Net',
                'Vat',
                'VatAmount',
                'Gross',
                'Period',
                'OrgPartName',
                'ServiceName',
                'ServiceCode',
                'BudgetName',
              ],
              GridInvoiceCorr: ['RowNum', 'Object', 'Gross'],
            };
          case 'INTSU':
            return {
              GridInvoice: [
                'InvoiceStatusName',
                'Period',
                'Invoice',
                'Invoice',
                'RefInvoice',
                'InvoiceDate',
                'Fulfilment',
                'PaymentDueDate',
                'PartnerCode',
                'PartnerName',
                'InvoiceAddress',
                'OriginalDoc',
                'Pay',
                'ControllSumma',
                'InvoicePad',
                'PadName',
                'InvoiceImportId',
                'ERPCONParameterValueName',
              ],
              GridInvoiceRow: [
                'RowNum',
                'Object',
                'Period',
                'AccountingFrom',
                'AccountingTo',
                'Quantity',
                'UnitCode',
                'UnitPrice',
                'Discount',
                'Net',
                'Vat',
                'VatAmount',
                'Gross',
                'OrgPartName',
                'TenementName',
                'ServiceName',
                'ServiceCode',
                'BudgetName',
              ],
              GridInvoiceUnitSum: [
                'RowNum',
                'OrgPartName',
                'Net',
                'VatCode',
                'Vat',
                'Gross',
                'ModUser',
                'ModDate',
                'TechFlag',
                'ProcUser',
              ],
              GridInvoiceApproval: ['Level', 'OrgPartName', 'AppUserName', 'AppDate', 'MaxAmount'],
            };
          default:
            return {
              GridInvoice: [
                'InvoiceStatusName',
                'Period',
                'Invoice',
                'RefInvoice',
                'StornoInvoice',
                'InvoiceTypeName',
                'InvoiceDate',
                'Fulfilment',
                'PaymentDueDate',
                'Net',
                'Vat',
                'Gross',
                'PartnerCode',
                'PartnerName',
                'InvoiceAddress',
                'OriginalDoc',
                'Pay',
                'Contract',
                'RentEventNumber',
                'BundleId',
                'CashDeposit',
                'SettleAnInvoice',
                'InvoicePad',
                'PadName',
              ],
              GridInvoiceRow: [
                'RowNum',
                'Tenement',
                'Object',
                'AccountingFrom',
                'AccountingTo',
                'Quantity',
                'UnitCode',
                'UnitPrice',
                'Discount',
                'Net',
                'Vat',
                'VatAmount',
                'Gross',
                'Period',
                'OrgPartName',
                'ServiceName',
                'ServiceCode',
                'BudgetName',
              ],
              GridInvoiceCorr: ['RowNum', 'Object', 'Gross'],
            };
        }
      }
      //Tab-Grid-Számlatípus összerendelés
      function getDetailGridAndTabByInvoiceType(invoiceType) {
        switch (invoiceType) {
          case 'INTSU':
            return {
              TabInvoiceRow: 'GridInvoiceRow',
              TabInvoiceUnitSum: 'GridInvoiceUnitSum',
              TabInvoiceApproval: 'GridInvoiceApproval',
              TabInvoiceStatus: 'GridInvoiceStatus',
            };
          default:
            return {
              TabInvoiceRow: 'GridInvoiceRow',
              TabInvoiceCorr: 'GridInvoiceCorr',
            };
        }
      }

      function setColumnVisible(invoiceType) {
        var columns = getColumnsByInvoiceType(invoiceType);
        if (invoiceType !== 'INTDI') {
          vm.isWalVisible = true;
        }
        angular.forEach(columns, function(value, key) {
          angular.forEach(vm.pageModel.Grids[key].Columns, function(valueC, keyC) {
            valueC.hidden = value.indexOf(valueC.field) === -1;
          });
          //sort:
          vm.pageModel.Grids[key].Columns.sort(function(a, b) {
            return columns[key].indexOf(a.field) - columns[key].indexOf(b.field);
          });
        });
      }

      setColumnVisible(vm.formModel.InvoiceType);
      // látható szűrő beállítása
      //vm.pageModel.Fields.InvoiceId.FormlyFieldDescriptor.hide = vm.InvoiceType !== "INTSU";
      //vm.pageModel.Fields.ContractId.FormlyFieldDescriptor.hide = vm.InvoiceType === "INTSU";

      vm.mainGridIdField = vm.pageModel.Grids['GridInvoice'].IdColumn;

      //vm.mainGrid = $("#mainGrid").data("kendoGrid");

      var getInvoiceFilter = function() {
        return (
          "InvoiceType~eq~'" +
          vm.formModel.InvoiceType +
          "'" +
          (vm.formModel.Period && vm.formModel.Period.Value !== null
            ? "~and~Period~eq~'" + vm.formModel.Period.Value + "'"
            : '') +
          (vm.formModel.PartnerId && vm.formModel.PartnerId.Value !== null
            ? "~and~PartnerId~eq~'" + vm.formModel.PartnerId.Value + "'"
            : '')
          //+(vm.formModel.InvoiceId && vm.formModel.InvoiceId.Value !== null ? "~and~InvoiceId~eq~"+vm.formModel.InvoiceId.Value+"" : "")
          //+(vm.formModel.ContractId && vm.formModel.ContractId.Value !== null ? "~and~ContractId~eq~"+vm.formModel.ContractId.Value+"" : "")
        );
      };

      initMainGrid(
        vm,
        'GridInvoice',
        'Grid/Data',
        function() {
          changeMainGridFilter(vm.mainGrid);
          setDasModel();
        },
        null,
        false,
        getInvoiceFilter,
        null
      );

      vm.selectedMainGridItemId = 0;

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////
      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];
      vm.checkedRows = [];

      var checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '40px',
        lockable: false,
      };
      vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);
      vm.mainGridOptions.dataBound = function() {
        refreshCheckbox(this);
      };
      //vm.mainGridOptions.dataSource.schema.model.Id = vm.mainGridIdField;

      vm.mainGridOptions.dataBound = function(e) {
        var needApply = false;
        var grid = this;
        //Checked selected row;
        var items = e.sender.items();
        var gridPage = e.sender;
        items.each(function(index) {
          var dataItem = gridPage.dataItem(this);
          dataItem.checked = vm.checkedIds.indexOf(dataItem.InvoiceId) !== -1;
          needApply = true;
        });

        if (needApply) {
          $scope.$applyAsync();
        }
      };

      function manageSelectedIdArray(dataItem, add) {
        if (add) vm.checkedRows.push(dataItem);
        else
          vm.checkedRows = vm.checkedRows.filter(function(e) {
            return e.InvoiceId !== dataItem.InvoiceId;
          });

        vm.checkedIds = _.map(vm.checkedRows, 'InvoiceId');
      }

      function getAllIdFromFIC() {
        if (vm.mainGrid.dataSource.filter() !== undefined) {
          var filterString = '';
          var filters = vm.mainGrid.dataSource.filter().filters;
          if (!!filters[0].field) {
            filterString = vm.mainGridOptions.dataSource.transport.parameterMap(
              { filter: vm.mainGrid.dataSource.filter() },
              'non'
            ).filter;
          }
        }

        $http
          .post('Grid/Data', {
            page: 1,
            pageSize: 0,
            sort: '',
            group: '',
            filter: filterString,
            aggregates: '',
            tableName: vm.pageModel.Grids['GridInvoice'].Table,
            adopter: vm.pageModel.Grids['GridInvoice'].Adopter,
            installAdopter: vm.pageModel.Grids['GridInvoice'].InstallAdopter,
            whereCondition: getInvoiceFilter(),
            idColumn: vm.pageModel.Grids['GridInvoice'].IdColumn,
            columnCsv: 'InvoiceId,InvoiceStatus',
          })
          .then(function(response) {
            vm.checkedIds = _.map(response.data.Data, vm.pageModel.Grids['GridInvoice'].IdColumn);
            vm.checkedRows = response.data.Data;
            refreshCheckbox(vm.mainGrid);
          });
      }

      function toggleSelect(event) {
        var checked = event.target.checked;
        vm.checkedIds = [];
        vm.checkedRows = [];
        if (vm.mainGrid.dataSource.total() > 0) {
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.mainGrid);
          } else {
            vm.selectAllTip = 'Egy sem';
            getAllIdFromFIC();
          }
        }
      }

      function selectRow(event, item) {
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        manageSelectedIdArray(dataItem, checked);
      }

      function refreshCheckbox(grid) {
        var view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = vm.checkedIds.indexOf(value.InvoiceId) !== -1;
        });
      }

      function getSelectedIDs() {
        var row = vm.selectedItems;
        if (!row || row.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var ids = [];
        angular.forEach(vm.selectedItems, function(value, key) {
          ids.push(value[vm.mainGridIdField]);
        });
        return ids;
      }

      vm.getS = function() {
        vm.x = getSelectedIDs();
      };
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          targetInvoiceId: vm.selectedMainGridItemId,
          selectFunction: function() {
            setDasModel();
          },
        };
      };

      vm.selectedContractId = 0;
      vm.getSelectedContractId = function() {
        return {
          contractId: vm.selectedContractId,
        };
      };

      vm.filterTab = function(item) {
        var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
        var retVal = tabs[item.key] !== undefined;
        return retVal;
      };

      // Kendo-grid reference for sub GRIDs

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceRow', 'PanelInvoiceCorr', 'PanelInvoiceUnitSum', 'PanelInvoiceApproval', 'PanelInvoiceStatus'],
        function(gridModel) {
          if (gridModel.Name === 'GridInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
              selectFunction: function(row) {
                vm.HasFurtherBilling = row.HasFurtherBilling;
                $scope.$applyAsync();
              },
            };
          }
          if (gridModel.Name === 'GridInvoiceCorr') {
            gridModel.ControllerMethod = 'Invoice/InvoiceCorrList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoiceUnitSum') {
            gridModel.ControllerMethod = 'Invoice/InvoiceUnitSumList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoiceApproval') {
            gridModel.ControllerMethod = 'Invoice/InvoiceApprovalList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          if (gridModel.Name === 'GridInvoiceStatus') {
            gridModel.ControllerMethod = 'Invoice/InvoiceStatusList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          return null;
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      vm.pageModel.Fields.InvoiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        invoiceType: vm.InvoiceType,
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          // ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedMainGridItemId = 0;
          $scope.$applyAsync();
          return;
        }

        vm.isCorrection = selectedItems[0].DocumentType === 'INDCO';
        vm.isClosed = selectedItems[0].InvoiceStatus === 'INSCL';
        vm.Modifyable = selectedItems[0].InvoiceStatus === 'INSOP';
        vm.InvoicePadHasErpCon =
          !!selectedItems[0].ERPCONParameterValue && selectedItems[0].ERPCONParameterValue !== 'ERPCON_NO';
        vm.disableEdit = selectedItems[0].RentEventId > 0;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.selectedContractId = selectedItems[0]['ContractId'];
        //$scope.$apply();
        setDasModel();
        //Csak a látszó tabokon frissítem a gridet:
        var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
        angular.forEach(tabs, function(value, key) {
          vm.detailItemGrids[value] && vm.detailItemGrids[value].dataSource.read();
        });
        $scope.$applyAsync();
      }

      function createInvoice() {
        $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceCreate', {
          id: 0,
          invoiceType: vm.InvoiceType,
        });
      }

      function editInvoice() {
        if (!vm.Modifyable) {
          toastr.warning('Tétel zárolva!', vm.messages.Warning);
        } else {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          var invoiceStatus = selectedItems[0]['InvoiceStatus'];
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var id = selectedItems[0][vm.mainGridIdField];
            if (vm.InvoiceType === 'INTSU' && vm.formModel.ERPCON) {
              $state.go(vm.module + '.SupplierInvoiceEdit', { id: id, invoiceType: vm.InvoiceType });
            } else {
              $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceEdit', {
                id: id,
                invoiceType: vm.InvoiceType,
              });
            }
          }
        }
      }

      function deleteInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (vm.checkedIds.length == 0 && selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          if (vm.checkedIds.length == 0) {
            acceptModalDelete(selectedItems.length, _.map(selectedItems, vm.pageModel.Grids['GridInvoice'].IdColumn));
          } else {
            acceptModalDelete(vm.checkedIds.length, vm.checkedIds);
          }
        }
      }

      //var filteredRows = [];
      //function PageTraverser(dataSource, targetPage, totalPages, filters, completionFunction) {
      //    //$('#pResults').text('Traversing page ' + targetPage);
      //    dataSource.serverPaging = true;
      //    dataSource.serverFiltering = true;
      //    dataSource.serverSorting = true
      //    dataSource.query({
      //        page: targetPage,
      //        pageSize: 20,
      //        filter: filters
      //    }).then(function () {
      //        var view = dataSource.view();
      //        for (var viewItemId = 0; viewItemId < view.length; viewItemId++) {
      //            var viewItem = view[viewItemId];
      //            filteredRows.push(viewItem);
      //        }
      //        targetPage++;
      //        if (targetPage <= totalPages) {
      //            PageTraverser(dataSource, targetPage, totalPages, filters, completionFunction);
      //        } else {
      //            completionFunction();
      //        }
      //    });
      //}

      function duplicateInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $http.get('Invoice/InvoiceDuplicateCheck/' + id).then(function() {
            //INTRM-nél sosem aktív a duplicate
            $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceDuplicate', {
              id: id,
              invoiceType: vm.InvoiceType,
            });
          });
        }
      }

      function viewInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          if (vm.InvoiceType === 'INTSU') {
            $state.go(vm.module + '.SupplierInvoiceView', { id: id, invoiceType: vm.InvoiceType });
          } else {
            $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceView', { id: id });
          }
        }
      }

      function lockInvoice() {
        if (vm.checkedIds.length == 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          acceptModalLock(vm.checkedIds.length, vm.checkedIds);
        }
      }

      function acceptModalDelete(total, selectedItems) {
        let allSelected = vm.allCheck ? total : selectedItems.length;
        let openSelected = vm.checkedRows.filter(x => x.InvoiceStatus == 'INSOP').length;

        let msg =
          vm.checkedRows.filter(x => x.InvoiceStatus != 'INSOP').length > 0
            ? `A törlés funkció csak nyitott státuszú számlákra futtatható, az ettől eltérő státuszú számlákat figyelmen kívül hagyja!<br/><br/><b>A kijelölt ${allSelected} db számlából ${openSelected} db számla törlésre fog kerülni!</b><br/><br/>Biztosan szeretné folytatni a műveletet?`
            : `<b>${openSelected} db számla törlésre fog kerülni!</b><br/><br/>Biztosan szeretné folytatni a műveletet?`;

        if (openSelected == 0) {
          msg = `A törlés funkció csak nyitott státuszú számlákra futtatható!`;
        }

        let data = $.param({
          invoiceIds: selectedItems,
        });
        bootbox.dialog({
          message: msg,
          title: vm.messages.Confirm,
          buttons:
            openSelected == 0
              ? {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      if (vm.allCheck) {
                        vm.selectedItems = [];
                      }
                    },
                  },
                }
              : {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      if (vm.allCheck) {
                        vm.selectedItems = [];
                      }
                    },
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      var url = 'Invoice/' + vm.invoiceTypeForController + 'InvoiceDelete/';
                      $http({
                        url: url,
                        method: 'POST',
                        data: data,
                        headers: {
                          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        },
                      }).then(function(response) {
                        let result = response.statusText.split(',');
                        if (result[0] > 0 && vm.InvoiceType !== 'INTSU') {
                          toastr.success(result[0] + ' db számla törlése sikeresen megtörtént!');
                        }
                        if (result[1] > 0) {
                          toastr.warning(result[1] + ' db számlát nem sikerült törölni!');
                        }
                        if (result[2] > 0) {
                          toastr.warning(result[2] + ' db számla státusza rontottra lett állítva!');
                        }
                        vm.mainGrid.dataSource.read();
                        vm.checkedIds = [];
                        vm.checkedRows = [];
                        vm.selectedItems = [];
                      });
                    },
                  },
                },
        });
      }

      function acceptModalLock(total, selectedItems) {
        var text = ' db számla zárásra fog kerülni! Biztosan szeretné folytatni a műveletet?';
        var data = $.param({
          invoiceIds: selectedItems,
        });
        bootbox.dialog({
          message: vm.allCheck ? total + text : selectedItems.length + text,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {
                if (vm.allCheck) {
                  vm.selectedItems = [];
                }
              },
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http({
                  url: 'Invoice/' + vm.invoiceTypeForController + 'InvoiceLock',
                  method: 'POST',
                  data: data,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                  },
                }).then(function(response) {
                  var result = response.statusText.split(',');
                  if (result[0] > 0) {
                    toastr.success(result[0] + ' db számla sikeresen le lett zárva!');
                  }
                  if (result[1] > 0) {
                    toastr.warning(result[1] + ' db számlát nem sikerült lezárni!');
                  }
                  vm.mainGrid.dataSource.read();
                  vm.checkedIds = [];
                  vm.checkedRows = [];
                  vm.selectedItems = [];
                });
              },
            },
          },
        });
      }

      function stornoInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }

        var invoiceStatus = selectedItems[0]['InvoiceStatus'];
        var invoiceType = selectedItems[0]['InvoiceType'];
        var stornoInvoiceId = selectedItems[0]['StornoInvoiceId'];

        if (!!stornoInvoiceId) {
          toastr.warning('Ez a számla korábban már stornózva lett!', vm.messages.Warning);
        } else if (
          invoiceStatus !== 'INSCL' &&
          invoiceStatus !== 'INSSO' &&
          !(invoiceStatus === 'INSOP' && invoiceType === 'INTSU')
        ) {
          toastr.warning('A számla státusza nem megfelelő a stornózáshoz!', vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceStorno', { invoiceId: id });
        }
      }

      function reOpenInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $http
          .post('Invoice/SupplierInvoiceReOpen', {
            id: selectedItems[0].InvoiceId,
          })
          .then(
            function(result) {
              toastr.success('A ' + selectedItems[0].Invoice + ' számú szállítói számla visszanyitása sikeres!');
              vm.mainGrid.dataSource.read();
            },
            function(err) {
              console.err(err);
            }
          );
      }

      function reOpenButtonStatus() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          return true;
        }

        if (selectedItems[0].InvoiceStatus !== 'INSCL' || selectedItems[0].DocumentType !== 'INDNO') {
          return true;
        }

        if (selectedItems[0].ERPCONParameterValue && selectedItems[0].ERPCONParameterValue !== 'ERPCON_NO') {
          return true;
        }

        if (!selectedItems[0].ERPCONParameterValue && vm.formModel.SystemERPCON) {
          return true;
        }

        return false;
      }

      function correctInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }

        var invoiceStatus = selectedItems[0]['InvoiceStatus'];
        var invoiceType = selectedItems[0]['InvoiceType'];
        var stornoInvoiceId = selectedItems[0]['StornoInvoiceId'];
        var invoiceId = selectedItems[0]['InvoiceId'];
        var refInvoiceId = selectedItems[0]['RefInvoiceId'];

        if (invoiceStatus !== 'INSCL' && invoiceStatus !== 'INSSO') {
          toastr.warning('A számla státusza nem megfelelő a helyesbítéshez! ', vm.messages.Warning);
        } else if (stornoInvoiceId > 0) {
          toastr.warning('A számlához már tartozik sztornó számla! ', vm.messages.Warning);
        } else if (invoiceId != refInvoiceId) {
          toastr.warning('A számla nem alap bzizonylat! ', vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceCorrection', { invoiceId: id });
        }
      }

      function printInvoice() {
        console.log('cicca');
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        console.log(selectedItems);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0].InvoiceId;
          console.log('id: ', id);
          $http
            .post('Invoice/Generate' + vm.invoiceTypeForController + 'InvoiceReport', {
              invoiceId: id,
            })
            .then(
              function(result) {
                var file = JSON.parse(result.data);
                var raw = atob(file.Report);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
                }
                var fs = new Blob([array], { type: file.MimeType });
                saveAs(fs, decodeURIComponent(file.FileName));
              },
              function(err) {
                console.err(err);
                // TODO error: toastr
              }
            );
        }
      }

      function generateContrInvoice() {
        var url = 'Contract/ContrInvoiceGenInvoiceNavInvoice' + invoiceStatus + '/';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Contract/ContrInvoiceGen.html',
          controller: 'ContrInvoiceGenCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      //tovabbszamlazas
      function invoiceGen() {
        vm.invoiceRowGridIdField = vm.pageModel.Grids['GridInvoiceRow'].IdColumn;
        var selectedItems = GetSelectedGridItems(vm.detailItemGrids['GridInvoiceRow']);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki számlatételt!', vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.invoiceRowGridIdField];
          var url = 'Invoice/InvoiceGen/' + id;
          var modelInstance = $uibModal.open({
            templateUrl: 'App/Invoice/InvoiceGen.html',
            controller: 'InvoiceGenCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });
        }
      }

      function getPartnerAccountBalance() {
        if (!vm.formModel.PartnerId.Value) {
          toastr.warning('Az egyenleg lekérdezéshez jelöljön ki egy partnert!', vm.messages.Warning);
          return;
        }
        var url = 'Invoice/GetPartnerAccountBalance/' + vm.formModel.PartnerId.Value;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Invoice/PartnerAccountBalance.html',
          controller: 'PartnerAccountBalanceCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      function InvoiceImport() {
        var url = 'Invoice/GetInvoiceImportModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Invoice/InvoiceImport.html',
          controller: 'InvoiceImportCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      function InvoiceExport() {
        var url = 'Invoice/GetInvoiceExportModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Invoice/InvoiceExport.html',
          controller: 'InvoiceExportCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });
      }

      //////////

      vm.back = function() {
        var backTo = $state.current.params.BackTo;
        $state.go(!backTo || backTo === '' ? 'main' : backTo);
      };

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridInvoice'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      function WAL(usedGrid) {
        switch (usedGrid) {
          case vm.usedInvoiceGridEnum.MAIN:
            walService.NavigateToWal('Invoice', vm.invoiceTypeForController + 'InvoiceWal', 'FlgInvoiceView');
            break;
          case vm.usedInvoiceGridEnum.SUB:
            switch (vm.activeSubItemTab) {
              case 0: // Számla tételek
                walService.NavigateToWal('Invoice', vm.invoiceTypeForController + 'InvoiceRowWal', 'FlgInvoiceRowView');
                break;
              case 1: // Szervezetekre jutó rész
                walService.NavigateToWal('Invoice', 'SupplierInvoiceUnitSumWal', 'FlgInvoiceUnitSumView');
                break;
              case 2: // Jóváhagyások
                walService.NavigateToWal('Invoice', 'SupplierInvoiceApprovalWal', 'FlgInvoiceApprovalView');
                break;
            }
            break;
          default:
            break;
        }
      }

      function History() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = selectedItems[0][vm.mainGridIdField];
        HistoryService.NavigateToHistory(
          'FlgInvoice',
          id,
          vm,
          $state,
          true,
          '',
          vm.invoiceTypeForController + 'Invoice'
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceCorrectionCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'LockService',
    'UIHelperService',
    function($scope, options, $http, $state, $stateParams, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceCorrectionCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.module = $state.current.params.module;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
          case 'INTCU':
            type = 'Customer';
            break;
          case 'INTSU':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController =
        $stateParams.InvoiceType || vm.getInvoiceTypeForController(vm.formModel.InvoiceType);

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.controllerOptions.isFormReadOnly) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      //Grid
      vm.mainGridIdField = vm.pageModel.Grids['GridInvoiceRow'].IdColumn;
      vm.mainGrid = vm.pageModel.Grids['GridInvoiceRow'];

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridInvoiceRow,
        'Invoice/InvoiceRowList/',
        function() {},
        { targetInvoiceId: vm.formModel.InvoiceId }
      );

      vm.mainGridOptions.toolbar = ['cancel'];
      (vm.mainGridOptions.selectable = 'multiple cell'), (vm.mainGridOptions.batch = true);
      vm.mainGridOptions.editable = true;
      vm.mainGridOptions.edit = function(e) {
        var container = e.container;
        container.find('[id]').removeAttr('id');
      };

      function numericEditor(container, options) {
        $('<input data-bind="value:' + options.field + '"/>')
          .appendTo(container)
          .kendoNumericTextBox({
            decimals: vm.formModel.Rounding,
            format: options.format ?? '',
          });
      }
      function textEditor(container, options) {
        $('<input data-bind="value:' + options.field + '"/>')
          .appendTo(container)
          .kendoTextBox();
      }
      angular.forEach(vm.mainGridOptions.columns, function(value, key) {
        if (['UnitPrice', 'Discount', 'Net', 'Gross', 'Vat', 'VatAmount'].indexOf(value.field) !== -1) {
          value.editor = numericEditor;
          value.format = '{0:n' + vm.formModel.Rounding + '}';
        } else if ('Object' === value.field) {
          value.editor = textEditor;
        }
      });

      vm.mainGridOptions.dataBound = function(e) {
        var rows = e.sender.tbody.children();
        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.dirty === true) row[0].classList.add('row-corrected');
          else row[0].classList.remove('row-corrected');
        }
      };

      angular.forEach(vm.mainGridOptions.dataSource.schema.model.fields, function(value, key) {
        if (
          key === 'Quantity' ||
          key === 'UnitPrice' ||
          key === 'Discount' ||
          key === 'DiscountPercent' ||
          key === 'Gross' ||
          key === 'Object'
        ) {
          value.editable = true;
        } else {
          value.editable = false;
        }
      });

      vm.mainGridOptions.columns.forEach(function(c) {
        if (c.field === 'DiscountPercent') {
          c.editable = function(d) {
            if (d.Discount > 0) {
              toastr.warning('Nem adható meg Kedvezmény %, ha a Kedvezmény nagyobb, mint 0.');
              return false;
            }
            return true;
          };
        }
        if (c.field === 'Discount') {
          c.editable = function(d) {
            if (d.DiscountPercent > 0) {
              toastr.warning('Nem adható meg Kedvezmény, ha a Kedvezmény % nagyobb, mint 0.');
              return false;
            }
            return true;
          };
        }
        if (c.field === 'Gross') {
          c.editable = function(d) {
            if (d.Net === 0 && d.UnitPrice === 0) {
              return true;
            }
            toastr.warning('Csak akkor adható meg Bruttó érték, ha a Nettó és Egységár mezők értéke 0.');
            return false;
          };
        }
      });

      vm.mainGridOptions.save = function(e) {
        if (e.values.UnitPrice < 0) {
          e.preventDefault();
          toastr.warning('Negatív érték nem adható meg!');
          return;
        }

        if (e.values.Object === '') {
          e.preventDefault();
          toastr.warning('A Tárgy nem lehet üres!');
          return;
        }

        if (e.values.Quantity !== undefined || e.values.UnitPrice !== undefined) {
          var quantity = e.values.Quantity !== undefined ? e.values.Quantity : e.model.Quantity;
          var unitPrice = roundByCurrency(e.values.UnitPrice !== undefined ? e.values.UnitPrice : e.model.UnitPrice);
          e.model.UnitPrice = unitPrice; //beírás után rögtön lekerekítjük a kijelzett egységárat is
          e.model.Net = roundByCurrency(quantity * unitPrice);

          if (e.model.Discount > 0) {
            e.model.Net = roundByCurrency(e.model.Net - e.model.Discount);
          } else if (e.model.DiscountPercent > 0) {
            e.model.Net = roundByCurrency(e.model.Net - (e.values.DiscountPercent / 100) * e.model.Net);
          }
        }

        if (e.values.Discount !== undefined) {
          e.values.Discount = roundByCurrency(e.values.Discount);
          e.model.Net = roundByCurrency(e.model.Quantity * e.model.UnitPrice - e.values.Discount);
        }

        if (e.values.DiscountPercent !== undefined) {
          var net = e.model.Quantity * e.model.UnitPrice;
          e.model.Net = roundByCurrency(net - (e.values.DiscountPercent / 100) * net);
        }

        if (e.values.Gross !== undefined) {
          e.values.Gross = roundByCurrency(e.values.Gross);
          e.model.Net = roundByCurrency(e.values.Gross / (1 + e.model.Vat / 100));
          var discount = 0;

          if (e.model.Discount > 0) {
            discount = roundByCurrency(e.model.Discount);
          } else if (e.model.DiscountPercent > 0) {
            discount = roundByCurrency((e.values.DiscountPercent / 100) * e.model.Net);
          }

          if (e.model.Quantity > 0) {
            e.model.UnitPrice = roundByCurrency((e.model.Net + discount) / e.model.Quantity);
          }

          e.model.Net = roundByCurrency(e.values.Gross / (1 + e.model.Vat / 100));
          e.model.VatAmount = roundByCurrency(e.values.Gross - e.model.Net);
        } else {
          //e.model.Gross = e.model.Net * (1 + e.model.Vat);
          e.model.VatAmount = roundByCurrency(e.model.Net * (e.model.Vat / 100));
          e.model.Gross = roundByCurrency(e.model.Net + e.model.VatAmount);
        }
        vm;
        e.sender.refresh(e);
      };

      var onChangeFunctions = {};
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var onBlurFunctions = {
        NewPeriod: function() {
          vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var syncValidators = {
        NewInvoiceDate: {
          NewInvoiceValidator: function(modelValue) {
            var newInvoiceDate = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var InvoiceDate = new moment(vm.formModel.InvoiceDate, kendo.culture().calendar.patterns.d.toUpperCase());
            return newInvoiceDate >= InvoiceDate;
          },
        },
        NewPeriod: {
          NewPeriodValidator: function(modelValue) {
            vm.formModel.NewPeriod = modelValue;
            return modelValue >= vm.formModel.Period;
          },
        },
        NewPaymentDueDate: {
          NewPaymentDueDateValidator: function(modelValue) {
            var newPaymentDue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var newInvoiceDate = new moment(
              vm.formModel.NewInvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return newPaymentDue >= newInvoiceDate;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      function warningPopup(title, message, callbackFn) {
        bootbox.dialog({
          message: message,
          title: title,
          buttons: {
            cancel: {
              label: 'Nem',
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Igen',
              className: 'btn-primary',
              callback: callbackFn,
            },
          },
        });
      }

      function saveImpl() {
        $http
          .post('Invoice/' + vm.invoiceTypeForController + 'InvoiceCorrection', vm.formModel)
          .then(function(result) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (!vm.controllerOptions.isFormReadOnly) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            let editOrView = 'Edit';
            if (vm.invoiceTypeForController === 'Condominium') {
              editOrView = 'View';
            }

            bootbox.dialog({
              message:
                'A helyesbítő számla mentése sikeresen megtörtént. Kíván még további díjtételt rögzíteni a számlához?',
              title: 'Megerősítés',
              buttons: {
                cancel: {
                  label: 'Nem',
                  className: 'btn-default',
                  callback: function() {
                    $state.go(vm.module + '.' + $stateParams.BackTo, { InvoiceTypeFilter: vm.formModel.InvoiceType });
                  },
                },
                confirm: {
                  label: 'Igen',
                  className: 'btn-primary',
                  callback: function() {
                    $state.go(vm.module + '.' + vm.invoiceTypeForController + 'Invoice' + editOrView, {
                      id: result.data.Value,
                      invoiceType: vm.formModel.InvoiceType,
                    });
                  },
                },
              },
            });
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      vm.save = function() {
        vm.formModel.CorrectedRow = [];
        var list = vm.mainGrid.dataSource._data;
        for (var i = 0; i < list.length; i++) {
          if (list[i].dirty === true) vm.formModel.CorrectedRow.push(list[i]);
        }
        if (vm.formModel.CorrectedRow[0] == null) {
          warningPopup(
            'Megerősítés',
            'Csak a számlafej adatokban történt módosítás! Az Igen gombra kattintva nullás végösszegű számla lesz generálva. Folytatja?',
            saveImpl
          );
        } else {
          if (vm.formModel.HasCSEPUInRows === true) {
            warningPopup(
              'Megerősítés',
              'A módosítások csak az adott számlát érintik, és a közmű modulban változást nem eredményeznek. Amennyiben újbóli felosztás szükséges, az érintett számlákat sztornózni kell. Ha a helyesbítő számla miatt nem lehetséges a sztornózás, akkor nem lehetséges az újbóli felosztás sem. Kívánja folytatni?',
              function() {
                warningPopup('Megerősítés', 'Sikerült minden szükséges tételt korrigálni?', saveImpl);
              }
            );
          } else {
            warningPopup('Megerősítés', 'Sikerült minden szükséges tételt korrigálni?', saveImpl);
          }
        }
      };

      vm.back = function() {
        if (!vm.controllerOptions.isFormReadOnly) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go(vm.module + '.' + $stateParams.BackTo, { InvoiceTypeFilter: vm.formModel.InvoiceType });
      };

      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.Rounding || 0));
      }

      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          period: vm.formModel.NewPeriod,
          invoiceType: vm.formModel.InvoiceType,
        };
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceStornoCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'LockService',
    function($scope, options, $http, $state, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceStornoCtrl', stateParams);
      }
      var vm = this;

      //vm.controllerOptions = $stateParams.controllerOptions;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.module = $state.current.params.module;
      vm.selectedInvoiceRowId = 0;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      //if (!vm.controllerOptions.isFormReadOnly) {
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      //}

      //InvoiceType
      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
          case 'INTCU':
            type = 'Customer';
            break;
          case 'INTSU':
          case 'INTTH':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go(vm.module + '.' + $state.params.BackTo, { id: vm.formModel.InvoiceId });
      };
      vm.save = function() {
        $http
          .post('Invoice/' + vm.invoiceTypeForController + 'InvoiceStorno', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go(vm.module + '.' + $state.params.BackTo, {
              id: vm.formModel.InvoiceId,
              InvoiceTypeFilter: vm.formModel.InvoiceType,
            });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      if (vm.invoiceTypeForController != 'Supplier') {
        if (vm.formModel.CashDeposit !== null && vm.formModel.CashDeposit !== 0) {
          bootbox.dialog({
            message: 'Ennek ellenére stornózni akarja?',
            title: 'A számlára már történt befizetés <CashDeposit>!',
            buttons: {
              cancel: {
                label: 'Nem',
                className: 'btn-default',
                callback: function() {
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                  $state.go(vm.module + '.InvoiceNav', { id: vm.formModel.InvoiceId });
                },
              },
              confirm: {
                label: 'Igen',
                className: 'btn-primary',
                callback: function() {},
              },
            },
          });
        }
      }

      var onBlurFunction = {
        Period: function() {
          vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };

      var customExpressionProperties = {
        NewInvoiceDate: {
          'templateOptions.required': function() {
            return vm.formModel.InvoiceType === 'INTSU' && vm.formModel.ERPCON !== true;
          },
        },
        OriginalDoc: {
          'templateOptions.required': function() {
            return vm.formModel.InvoiceType === 'INTSU' && vm.formModel.INODRQ === true;
          },
        },
      };

      var hideExpressions = {
        NewInvoiceDate: function($viewValue, $modelValue, scope) {
          return (
            vm.formModel.ERPCON === true || vm.formModel.InvoiceType !== 'INTSU' || vm.formModel.InvoiceType === 'INTTH'
          );
        },
        OriginalDoc: function($viewValue, $modelValue, scope) {
          return vm.formModel.InvoiceType !== 'INTSU' || vm.formModel.InvoiceType === 'INTTH';
        },
      };

      InsertOnBlurFunctions(vm.pageModel, onBlurFunction);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = vm.FormlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return {
          period: vm.formModel.Period,
          invoiceType: vm.formModel.InvoiceType,
        };
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('CondominiumInvoiceNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $state.current.params !== 'undefined' ? $state.current.params : null;
        ctrlInit(this, 'InvoiceNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.InvoiceType = options.dto.InvoiceType;
      vm.Modifyable = false;
      vm.activeSubItemTab = 0;
      vm.allCheck = false;
      vm.isWalVisible = false;

      vm.usedInvoiceGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.deleteInvoice = deleteInvoice;
      vm.viewInvoice = viewInvoice;
      vm.lockInvoice = lockInvoice;
      // vm.stornoInvoice = stornoInvoice;
      // vm.correctInvoice = correctInvoice;
      vm.WAL = WAL;
      vm.History = History;
      vm.pageModel.Grids.GridInvoice.storageKey = vm.pageModel.Grids.GridInvoice.Id + '.' + vm.InvoiceType;

      vm.invoiceTypeForController = 'Condominium';

      vm.generateCondominiumInvoice = generateCondominiumInvoice;

      //lapfül mentés
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      var onChangeFunctions = {
        Period: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.formModel.Period.Value = selectedItem ? selectedItem.Period : null;
          vm.checkedIds = [];
          vm.checkedRows = [];
          vm.allCheck = false;
          vm.mainGrid.dataSource.read();
        },
        PropertyId: function(selectedItem) {
          vm.checkedIds = [];
          vm.checkedRows = [];
          vm.allCheck = false;
          vm.mainGrid.dataSource.read();
        },
        PartnerId: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {};
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Level~eq~'PPRBU'";
      };

      var getInvoiceFilter = function() {
        let cond = [];
        if (vm.formModel.Period && vm.formModel.Period.Value !== null) {
          cond.push("Period~eq~'" + vm.formModel.Period.Value + "'");
        }
        if (vm.formModel.PropertyId && vm.formModel.PropertyId.Value !== null) {
          cond.push("PropertyId~eq~'" + vm.formModel.PropertyId.Value + "'");
        }
        if (vm.formModel.PartnerId && vm.formModel.PartnerId.Value !== null) {
          cond.push("PartnerId~eq~'" + vm.formModel.PartnerId.Value + "'");
        }
        return cond.join('~and~');
      };

      initMainGrid(
        vm,
        'GridInvoice',
        'Grid/Data',
        function() {
          changeMainGridFilter(vm.mainGrid);
        },
        null,
        false,
        getInvoiceFilter,
        null
      );

      vm.selectedMainGridItemId = 0;

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////
      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];
      vm.checkedRows = [];

      var checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '40px',
        lockable: false,
      };
      vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);
      vm.mainGridOptions.dataBound = function() {
        refreshCheckbox(this);
      };

      vm.mainGridOptions.dataBound = function(e) {
        var grid = this;
        //Checked selected row;
        var items = e.sender.items();
        var gridPage = e.sender;
        items.each(function(index) {
          var dataItem = gridPage.dataItem(this);
          dataItem.checked = vm.checkedIds.indexOf(dataItem.InvoiceId) !== -1;
        });

        $scope.$applyAsync();
      };

      function manageSelectedIdArray(dataItem, add) {
        if (add) vm.checkedRows.push(dataItem);
        else
          vm.checkedRows = vm.checkedRows.filter(function(e) {
            return e.InvoiceId !== dataItem.InvoiceId;
          });

        vm.checkedIds = _.map(vm.checkedRows, 'InvoiceId');
      }

      function getAllIdFromFIC() {
        if (vm.mainGrid.dataSource.filter() !== undefined) {
          var filterString = '';
          var filters = vm.mainGrid.dataSource.filter().filters;
          if (!!filters[0].field) {
            filterString = vm.mainGridOptions.dataSource.transport.parameterMap(
              { filter: vm.mainGrid.dataSource.filter() },
              'non'
            ).filter;
          }
        }

        $http
          .post('Grid/Data', {
            page: 1,
            pageSize: 0,
            sort: '',
            group: '',
            filter: filterString,
            aggregates: '',
            tableName: vm.pageModel.Grids['GridInvoice'].Table,
            adopter: vm.pageModel.Grids['GridInvoice'].Adopter,
            installAdopter: vm.pageModel.Grids['GridInvoice'].InstallAdopter,
            whereCondition: getInvoiceFilter(),
            idColumn: vm.pageModel.Grids['GridInvoice'].IdColumn,
            columnCsv: 'InvoiceId,InvoiceStatus',
          })
          .then(function(response) {
            vm.checkedIds = _.map(response.data.Data, vm.pageModel.Grids['GridInvoice'].IdColumn);
            vm.checkedRows = response.data.Data;
            refreshCheckbox(vm.mainGrid);
          });
      }

      function toggleSelect(event) {
        var checked = event.target.checked;
        vm.checkedIds = [];
        vm.checkedRows = [];
        if (vm.mainGrid.dataSource.total() > 0) {
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.mainGrid);
          } else {
            vm.selectAllTip = 'Egy sem';
            getAllIdFromFIC();
          }
        }
      }

      function selectRow(event, item) {
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        manageSelectedIdArray(dataItem, checked);
      }

      function refreshCheckbox(grid) {
        var view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = vm.checkedIds.indexOf(value.InvoiceId) !== -1;
        });
      }

      function getSelectedIDs() {
        var row = vm.selectedItems;
        if (!row || row.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var ids = [];
        angular.forEach(vm.selectedItems, function(value, key) {
          ids.push(value[vm.mainGridIdField]);
        });
        return ids;
      }

      vm.getS = function() {
        vm.x = getSelectedIDs();
      };
      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          targetInvoiceId: vm.selectedMainGridItemId,
          selectFunction: function() {},
        };
      };

      vm.selectedContractId = 0;
      vm.getSelectedContractId = function() {
        return {
          contractId: vm.selectedContractId,
        };
      };

      // Kendo-grid reference for sub GRIDs

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceRow'],
        function(gridModel) {
          if (gridModel.Name === 'GridInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowList/';
            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
              selectFunction: function(row) {
                vm.HasFurtherBilling = row.HasFurtherBilling;

                $scope.$applyAsync();
              },
            };
          }
          return null;
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      // vm.pageModel.Fields.InvoiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
      // invoiceType: vm.InvoiceType,
      // };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          // ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedMainGridItemId = 0;

          $scope.$applyAsync();
          return;
        }

        vm.Modifyable = selectedItems[0].InvoiceStatus === 'INSOP';
        vm.InvoicePadHasErpCon =
          !!selectedItems[0].ERPCONParameterValue && selectedItems[0].ERPCONParameterValue !== 'ERPCON_NO';
        vm.disableEdit = selectedItems[0].RentEventId > 0;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.selectedContractId = selectedItems[0]['ContractId'];
        //$scope.$apply();
        vm.detailItemGrids['GridInvoiceRow'].dataSource.read();

        $scope.$applyAsync();
      }

      function deleteInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (vm.checkedIds.length == 0 && selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          if (vm.checkedIds.length == 0) {
            acceptModalDelete(selectedItems.length, _.map(selectedItems, vm.pageModel.Grids['GridInvoice'].IdColumn));
          } else {
            acceptModalDelete(vm.checkedIds.length, vm.checkedIds);
          }
        }
      }

      function viewInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceView', { id: id });
        }
      }

      function lockInvoice() {
        if (vm.checkedIds.length == 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          acceptModalLock(vm.checkedIds.length, vm.checkedIds);
        }
      }

      function acceptModalDelete(total, selectedItems) {
        let allSelected = vm.allCheck ? total : selectedItems.length;
        let openSelected = vm.checkedRows.filter(x => x.InvoiceStatus == 'INSOP').length;

        let msg =
          vm.checkedRows.filter(x => x.InvoiceStatus != 'INSOP').length > 0
            ? `A törlés funkció csak nyitott státuszú számlákra futtatható, az ettől eltérő státuszú számlákat figyelmen kívül hagyja!<br/><br/><b>A kijelölt ${allSelected} db számlából ${openSelected} db számla törlésre fog kerülni!</b><br/><br/>Biztosan szeretné folytatni a műveletet?`
            : `<b>${openSelected} db számla törlésre fog kerülni!</b><br/><br/>Biztosan szeretné folytatni a műveletet?`;

        if (openSelected == 0) {
          msg = `A törlés funkció csak nyitott státuszú számlákra futtatható!`;
        }

        let data = $.param({
          invoiceIds: selectedItems,
        });
        bootbox.dialog({
          message: msg,
          title: vm.messages.Confirm,
          buttons:
            openSelected == 0
              ? {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      if (vm.allCheck) {
                        vm.selectedItems = [];
                      }
                    },
                  },
                }
              : {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      if (vm.allCheck) {
                        vm.selectedItems = [];
                      }
                    },
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      var url = 'Invoice/' + vm.invoiceTypeForController + 'InvoiceDelete/';
                      $http({
                        url: url,
                        method: 'POST',
                        data: data,
                        headers: {
                          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                        },
                      }).then(function(response) {
                        let result = response.statusText.split(',');
                        if (result[0] > 0 && vm.InvoiceType !== 'INTTH') {
                          toastr.success(result[0] + ' db számla törlése sikeresen megtörtént!');
                        }
                        if (result[1] > 0) {
                          toastr.warning(result[1] + ' db számlát nem sikerült törölni!');
                        }
                        if (result[2] > 0) {
                          toastr.warning(result[2] + ' db számla státusza rontottra lett állítva!');
                        }
                        vm.mainGrid.dataSource.read();
                        vm.checkedIds = [];
                        vm.checkedRows = [];
                        vm.selectedItems = [];
                      });
                    },
                  },
                },
        });
      }

      function acceptModalLock(total, selectedItems) {
        var text = ' db számla zárásra fog kerülni! Biztosan szeretné folytatni a műveletet?';
        var data = $.param({
          invoiceIds: selectedItems,
        });
        bootbox.dialog({
          message: vm.allCheck ? total + text : selectedItems.length + text,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {
                if (vm.allCheck) {
                  vm.selectedItems = [];
                }
              },
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http({
                  url: 'Invoice/' + vm.invoiceTypeForController + 'InvoiceLock',
                  method: 'POST',
                  data: data,
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                  },
                }).then(function(response) {
                  var result = response.statusText.split(',');
                  if (result[0] > 0) {
                    toastr.success(result[0] + ' db számla sikeresen le lett zárva!');
                  }
                  if (result[1] > 0) {
                    toastr.warning(result[1] + ' db számlát nem sikerült lezárni!');
                  }
                  vm.mainGrid.dataSource.read();
                  vm.checkedIds = [];
                  vm.checkedRows = [];
                  vm.selectedItems = [];
                });
              },
            },
          },
        });
      }

      // function stornoInvoice() {
      // var selectedItems = GetSelectedGridItems(vm.mainGrid);

      // if (selectedItems.length === 0) {
      // toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      // return false;
      // }

      // var invoiceStatus = selectedItems[0]['InvoiceStatus'];
      // var invoiceType = selectedItems[0]['InvoiceType'];
      // var stornoInvoiceId = selectedItems[0]['StornoInvoiceId'];

      // if (!!stornoInvoiceId) {
      // toastr.warning('Ez a számla korábban már stornózva lett!', vm.messages.Warning);
      // } else if (
      // invoiceStatus !== 'INSCL' &&
      // invoiceStatus !== 'INSSO' &&
      // !(invoiceStatus === 'INSOP' && invoiceType === 'INTTH')
      // ) {
      // toastr.warning('A számla státusza nem megfelelő a stornózáshoz!', vm.messages.Warning);
      // } else {
      // var id = selectedItems[0][vm.mainGridIdField];
      // $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceStorno', { invoiceId: id });
      // }
      // }

      // function correctInvoice() {
      // var selectedItems = GetSelectedGridItems(vm.mainGrid);

      // if (selectedItems.length === 0) {
      // toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
      // return;
      // }

      // var invoiceStatus = selectedItems[0]['InvoiceStatus'];
      // var invoiceType = selectedItems[0]['InvoiceType'];
      // var stornoInvoiceId = selectedItems[0]['StornoInvoiceId'];
      // var invoiceId = selectedItems[0]['InvoiceId'];
      // var refInvoiceId = selectedItems[0]['RefInvoiceId'];

      // if (invoiceStatus !== 'INSCL' && invoiceStatus !== 'INSSO') {
      // toastr.warning('A számla státusza nem megfelelő a helyesbítéshez! ', vm.messages.Warning);
      // } else if (stornoInvoiceId > 0) {
      // toastr.warning('A számlához már tartozik sztornó számla! ', vm.messages.Warning);
      // } else if (invoiceId != refInvoiceId) {
      // toastr.warning('A számla nem alap bzizonylat! ', vm.messages.Warning);
      // } else {
      // var id = selectedItems[0][vm.mainGridIdField];
      // $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceCorrection', { invoiceId: id });
      // }
      // }

      function generateCondominiumInvoice() {
        var url = 'Invoice/CondominiumInvoiceGen';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Invoice/CondominiumInvoiceGen.html',
          controller: 'CondominiumInvoiceGenCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            mainGridDataSource: vm.mainGrid.dataSource,
          },
          backdrop: 'static',
        });
      }

      //////////

      vm.back = function() {
        var backTo = $state.current.params.BackTo;
        $state.go(!backTo || backTo === '' ? 'main' : backTo);
      };

      function WAL(usedGrid) {
        switch (usedGrid) {
          case vm.usedInvoiceGridEnum.MAIN:
            walService.NavigateToWal('Invoice', vm.invoiceTypeForController + 'InvoiceWal', 'FlgInvoiceView');
            break;
          case vm.usedInvoiceGridEnum.SUB:
            switch (vm.activeSubItemTab) {
              case 0: // Számla tételek
                walService.NavigateToWal('Invoice', vm.invoiceTypeForController + 'InvoiceRowWal', 'FlgInvoiceRowView');
                break;
              case 1: // Szervezetekre jutó rész
                walService.NavigateToWal('Invoice', 'SupplierInvoiceUnitSumWal', 'FlgInvoiceUnitSumView');
                break;
              case 2: // Jóváhagyások
                walService.NavigateToWal('Invoice', 'SupplierInvoiceApprovalWal', 'FlgInvoiceApprovalView');
                break;
            }
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('CondominiumInvoiceEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    'WalService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      HistoryService,
      dasService,
      lockService,
      walService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CondominiumInvoiceEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.module = $state.current.params.module;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.InvoiceType = options.dto.InvoiceType;
      vm.formModel.extraProperties = [{ Cheque: null }];
      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;

      vm.UIHelperService.setDefaultSidebarStatus();

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
        disableRunExpression: false,
      };

      if (vm.formModel.InvoiceStatus === 'INSCL' && vm.EditOrDuplicate !== 'Duplicate') {
        vm.controllerOptions.isFormReadOnly = true;
      }

      if ((!vm.formModel.InvoiceId || vm.formModel.InvoiceId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }

      vm.WAL = WAL;
      vm.shouldLock = vm.formModel.InvoiceStatus !== 'INSCL' && !vm.controllerOptions.isFormReadOnly;

      vm.getInvoiceTypeForController = function(invoiceType) {
        return 'Condominium';
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);
      if (vm.shouldLock) {
        vm.securedProgramId = options.programId;
        vm.securedId = options.id;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.lock = lock;
      vm.back = function() {
        if (vm.shouldLock) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Invoice.CondominiumInvoiceNav');
      };

      var customTypes = {
        Account2: 'maskedInput',
        Account3: 'maskedInput',
        Account1Sep: 'separatorDash',
        Account2Sep: 'separatorDash',
      };

      var customExpressionProperties = {};

      var hideExpressions = {};

      function fillAuntCompanyData(auntCompanyId, invoiceDate) {
        $http
          .get('Invoice/GetAuntCompanyData/', { params: { auntCompanyId: auntCompanyId, invoiceDate: invoiceDate } })
          .then(function(response) {
            vm.formModel.AuntCompanyTmId = response.data.Dto.AuntCompanyTMId;
            if (!!response.data.Dto.AuntCompanyTMId) {
              vm.formModel.Account1 = response.data.Dto.AuntCompanyAccount1;
              vm.formModel.Account2 = response.data.Dto.AuntCompanyAccount2;
              vm.formModel.Account3 = response.data.Dto.AuntCompanyAccount3;
            }
          });
      }

      function invoicePadChanged(extraProperties, isDataBound) {
        if (extraProperties) {
          vm.formModel.AuntCompanyId = extraProperties.AuntCompanyId;
          vm.formModel.Notice = extraProperties.Notice;
          vm.formModel.FinancialYear = extraProperties.FinancialYear;
          if (!isDataBound) {
            fillAuntCompanyData(extraProperties.AuntCompanyId, vm.formModel.InvoiceDate);
          }
          vm.refreshTMids();
          reValidateField(['Fulfilment']);
        }
      }

      var onBlurFunctions = {};

      var onChangeFunctions = {};

      /////////////////////////////////////
      //default érték hogy tudjunk menteni
      if (!vm.formModel.Currency) {
        vm.formModel.Currency = 'HUF';
      }
      /////////////////////////////////////

      var inputMasks = {
        Account1: '99999999',
        Account2: '99999999',
        Account3: '99999999',
      };

      var syncValidators = {};

      var dynamicQueryParameters = {};

      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Force an onchange on InvoicePad when it is loaded to fill f22 with initial data
      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        InvoiceType: vm.InvoiceType,
      };

      //var invoiceId = options.dto.InvoiceId;
      vm.getInvoiceId = function() {
        return {
          targetInvoiceId: vm.formModel.InvoiceId,
        };
      };

      //var contractId = 0;
      //if (!!options.dto.ContractId) {
      //    contractId = options.dto.ContractId.Value;
      //}
      vm.getContractId = function() {
        return {
          contractId: vm.formModel.ContractId.Value,
        };
      };

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceRow', 'PanelInvoiceCorr'],
        function(gridModel) {
          if (gridModel.Name === 'GridInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
            };
          }
          if (gridModel.Name === 'GridInvoiceCorr') {
            gridModel.ControllerMethod = 'Invoice/InvoiceCorrList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
            };
          }

          return null;
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      vm.activeSubItemTab = 0;
      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.showAttachDoc = showAttachDoc;
      //
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;
      //
      function createSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var invoiceId = vm.formModel.InvoiceId;
        $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Create', { id: id, invoiceId: invoiceId });
      }

      function editSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var invoiceId = vm.formModel.InvoiceId;
        if (!!id) {
          $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Edit', { id: id, invoiceId: invoiceId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function duplicateSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var invoiceId = vm.formModel.InvoiceId;
        if (!!id) {
          $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Duplicate', {
            id: id,
            invoiceId: invoiceId,
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function deleteSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var id = getSelectedSubGridItemId();
        if (!!id) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get('Invoice/' + vm.invoiceTypeForController + getUrlPrefix() + 'Delete/' + id)
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      $('#subGrid' + gridName)
                        .data('kendoGrid')
                        .dataSource.read();
                    });
                },
              },
            },
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function getSelectedSubGridItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $('#subGrid' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function lock() {
        $http.post('Invoice/' + vm.invoiceTypeForController + 'InvoiceSaveAndLock/', vm.formModel).then(function() {
          toastr.success('Számla zárás sikeresen megtörtént!');
          $state.reload();
          //$state.go("Invoice.RentAccountEdit", { "id": vm.formModel.InvoiceId });
        });
      }

      function attachDocument() {
        var id = vm.formModel.InvoiceId;
        dasService.NavigateToDas(vm.messages, 'Invoice.DasDocumentsNav', 'FlgInvoice', id);
      }

      function showAttachDoc() {
        return $stateParams.id > 0;
      }

      function History() {
        var id = getSelectedSubGridItemId();
        HistoryService.NavigateToHistory(
          'FlgInvoiceRow',
          id,
          vm,
          $state,
          true,
          '',
          vm.invoiceTypeForController + 'InvoiceRow'
        );
      }

      var reValidateField = function(fields) {
        angular.forEach(fields, function(value, key) {
          if (!!vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl)
            vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl.$validate();
        });
      };

      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'detailsIsCollapsed':
            vm.activeBooleans['detailsIsActive'] = true;
            break;
          case 'invoiceIsCollapsed':
            vm.activeBooleans['invoiceIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
        }
      };

      var getUrlPrefix = function() {
        var urlPrefix = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      };

      function WAL() {
        var tableid = vm.activeSubItemTab === 0 ? 'FlgInvoiceRowView' : 'FlgInvoiceCorr';
        walService.NavigateToWal('Invoice', vm.invoiceTypeForController + getUrlPrefix() + 'Wal', tableid);
      }

      var clearFieldData = function() {
        vm.formModel.PartnerId = null;
        vm.formModel.CoTenantPartTm.Value = null;
        vm.formModel.CoTenantPartTm.Text = null;
        vm.formModel.CoTenantPart = null;
        vm.formModel.CoTenant2PartTm.Value = null;
        vm.formModel.CoTenant2PartTm.Text = null;
        vm.formModel.CoTenant2Part = null;
        vm.formModel.Payment = null;
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('CondominiumInvoiceGenCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'mainGridDataSource',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(mi, $http, fModel, mainGridDataSource, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CondominiumInvoiceGenCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel.pageModel;
      vm.mainGridDataSource = mainGridDataSource;

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = fModel.dto;

      vm.isFormInvalid = function() {
        return vm.formly.$invalid;
      };

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "FinancialYear~eq~'" + (vm.formModel.Period?.Value || '').substr(0, 4) + "'";
      };

      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "InvoiceType~eq~'INTTH'";
      };

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.preSave = function() {
        if (!vm.formModel.DueDate) {
          bootbox.dialog({
            message: 'A fizetési határidő nem került kitöltésre. Szeretné pótolni?',
            title: vm.pageModel.Messages.Warning,
            closeButton: false,
            buttons: {
              cancel: {
                label: 'Igen',
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: 'Nem',
                className: 'btn-primary',
                callback: function() {
                  vm.save();
                },
              },
            },
          });
        } else {
          vm.save();
        }
      };

      vm.save = function() {
        $http
          .post('Invoice/CondominiumInvoiceGen', vm.formModel)
          .then(function(response) {
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Invoice/CondominiumInvoiceGenResultModal.html',
              controller: 'CondominiumInvoiceGenResultModalCtrl',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                model: {
                  data: response.data,
                  grid: vm.pageModel.Grids.GridCondominiumInvoiceGenResult,
                  labels: vm.pageModel.Labels,
                  actions: vm.pageModel.Actions,
                  messages: vm.pageModel.Messages,
                },
              },
              backdrop: 'static',
            });
            modalInstance.result.then(function() {});
            vm.mainGridDataSource.read();
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('CondominiumInvoiceGenResultModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    'gridService',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CondominiumInvoiceGenResultModalCtrl', stateParams);
      }
      var vm = this;

      vm.messages = model.messages;
      vm.actions = model.actions;
      vm.titles = model.titles;
      vm.labels = model.labels;
      vm.formModel = model.data;
      vm.gridModel = model.grid;

      vm.ok = ok;
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;

      vm.generatedResultGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: _.cloneDeep(vm.gridModel),
      });
      vm.generatedResultGridOptions.dataSource = vm.formModel.ErrorList;
      vm.generatedResultGridOptions.pageable.pageSize = 10;

      function ok() {
        uibModalInstance.close();
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function exportExcel() {
        $('#generatedResultGrid')
          .getKendoGrid()
          .saveAsExcel();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'HistoryService',
    'DasService',
    'LockService',
    'WalService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      HistoryService,
      dasService,
      lockService,
      walService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.module = $state.current.params.module;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.InvoiceType = options.dto.InvoiceType;
      vm.formModel.extraProperties = [{ Cheque: null }];
      vm.backTo = $state.params.BackTo;
      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
      //vm.AuntCompanyId = 0;
      vm.UIHelperService.setDefaultSidebarStatus();
      vm.collapseBooleans = {
        detailsIsCollapsed: false,
        invoiceIsCollapsed: true,
        otherDetailsIsCollapsed: true,
      };
      vm.activeBooleans = {
        detailsIsActive: true,
        invoiceIsActive: false,
        otherDetailsIsActive: false,
      };

      if (vm.formModel.InvoiceStatus === 'INSCL' && vm.EditOrDuplicate !== 'Duplicate') {
        vm.controllerOptions.isFormReadOnly = true;
      }
      if (vm.formModel.IsReadOnly) {
        vm.controllerOptions.isFormReadOnly = true;
      }

      vm.function;
      if ((!vm.formModel.InvoiceId || vm.formModel.InvoiceId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }

      vm.WAL = WAL;
      vm.shouldLock = vm.formModel.InvoiceStatus !== 'INSCL' && !vm.controllerOptions.isFormReadOnly;

      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCU':
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
            type = 'Customer';
            break;
          case 'INTSU':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);
      if (vm.shouldLock) {
        vm.securedProgramId = options.programId;
        vm.securedId = options.id;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.save = save;
      vm.lock = lock;
      vm.back = function() {
        if (vm.shouldLock) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        if (!!vm.backTo && vm.backTo !== '' && vm.module === 'Contract') {
          $state.go(vm.module + '.' + vm.backTo, { InvoiceTypeFilter: vm.InvoiceType });
          return;
        }
        $state.go('Invoice.InvoiceNav', { InvoiceTypeFilter: vm.InvoiceType });
      };

      var customTypes = {
        Account2: 'maskedInput',
        Account3: 'maskedInput',
        Account1Sep: 'separatorDash',
        Account2Sep: 'separatorDash',
      };

      var customExpressionProperties = {
        PartnerTMId: {
          'templateOptions.disabled': function() {
            if (vm.controllerOptions.isFormReadOnly) {
              return true;
            } else {
              return (
                ((vm.formModel.ContractId && vm.formModel.ContractId.Value > 0) ||
                  (vm.formModel.SupplyContrId && vm.formModel.SupplyContrId.Value > 0)) &&
                vm.formModel.PartnerTMId &&
                vm.formModel.PartnerTMId.Value > 0
              );
            }
          },
        },
        PaymentNumber: {
          'templateOptions.disabled': function() {
            return vm.formModel.PaymentIsCheque;
          },
        },
        CoTenantPartTm: {
          'templateOptions.disabled': function() {
            return (
              !(vm.formModel.ContractId && vm.formModel.ContractId.Value > 0) || vm.controllerOptions.isFormReadOnly
            );
          },
        },
        CoTenant2PartTm: {
          'templateOptions.disabled': function() {
            return (
              !(vm.formModel.ContractId && vm.formModel.ContractId.Value > 0) || vm.controllerOptions.isFormReadOnly
            );
          },
        },
        Account1: {
          'templateOptions.required': function() {
            //return !vm.formModel.PaymentIsCash;
            return false;
          },
        },
        Account2: {
          'templateOptions.required': function() {
            return vm.formModel.Account1 !== null &&
              vm.formModel.Account1.Text !== null &&
              vm.formModel.Account1.Text !== ''
              ? true
              : false;
          },
          // Ez azért van itt, hogy ne csússzon fel a mező, ha nincs label
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        Account3: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
        },
        // HAXX
        Account1Sep: {
          'templateOptions.disabled': 'true',
        },
        Account2Sep: {
          'templateOptions.disabled': 'true',
        },
        ContractId: {
          'templateOptions.required': function() {
            return vm.InvoiceType === 'INTRM' || vm.controllerOptions.isFormReadOnly;
          },
          'templateOptions.disabled': function() {
            return (vm.InvoiceType !== 'INTRM' && vm.InvoiceType !== 'INTCU') || vm.controllerOptions.isFormReadOnly;
          },
        },
        Currency: {
          'templateOptions.disabled': function() {
            return (
              vm.InvoiceType !== 'INTCU' ||
              vm.formModel.InvoiceStatus === 'INSCL' ||
              vm.controllerOptions.isFormReadOnly
            );
          },
        },
        SupplyContrId: {
          'templateOptions.disabled': function() {
            return (
              vm.InvoiceType !== 'INTCU' ||
              vm.formModel.InvoiceStatus === 'INSCL' ||
              vm.controllerOptions.isFormReadOnly
            );
          },
        },
      };

      var hideExpressions = {
        AccountingFrom: function($viewValue, $modelValue, scope) {
          return vm.invoiceType !== 'INTCU';
        },
        AccountingTo: function($viewValue, $modelValue, scope) {
          return vm.invoiceType !== 'INTCU';
        },
        PaymentNumber: function($viewValue, $modelValue, scope) {
          return vm.invoiceType === 'INTRM';
        },
      };

      function fillAuntCompanyData(auntCompanyId, invoiceDate) {
        $http
          .get('Invoice/GetAuntCompanyData/', { params: { auntCompanyId: auntCompanyId, invoiceDate: invoiceDate } })
          .then(function(response) {
            vm.formModel.AuntCompanyTmId = response.data.Dto.AuntCompanyTMId;
            if (!!response.data.Dto.AuntCompanyTMId) {
              vm.formModel.Account1 = response.data.Dto.AuntCompanyAccount1;
              vm.formModel.Account2 = response.data.Dto.AuntCompanyAccount2;
              vm.formModel.Account3 = response.data.Dto.AuntCompanyAccount3;
            }
          });
      }

      function invoicePadChanged(extraProperties, isDataBound) {
        if (extraProperties) {
          vm.formModel.AuntCompanyId = extraProperties.AuntCompanyId;
          vm.formModel.Notice = extraProperties.Notice;
          vm.formModel.FinancialYear = extraProperties.FinancialYear;
          if (!isDataBound) {
            fillAuntCompanyData(extraProperties.AuntCompanyId, vm.formModel.InvoiceDate);
          }
          vm.refreshTMids();
          reValidateField(['Fulfilment']);
        }
      }

      var onBlurFunctions = {};

      var onChangeFunctions = {
        //"AuntCompanyTmId": function (selectedItem) {
        //if (!!selectedItem)
        //        vm.AuntCompanyId = selectedItem.PartnerId;
        //},
        PartnerTMId: function(selectedItem) {
          //Partnerkód jegyzése Vevői szerződésekhez
          vm.selectedPartner = selectedItem;
          if (!!selectedItem) {
            //Aktuális partnerId beírása
            $http.get('Partner/PartnerView/' + selectedItem.PartnerId).then(function(response) {
              vm.formModel.PartnerId = response.data.dto.PartnerId ? response.data.dto.PartnerId : null;
              //ha szerzodest valasztunk eloszor, szetcseszi  a ContractId value-t, ezert a plusz feltetel
              if (vm.formModel.ContractId.Value === null) {
                vm.formModel.ContractId.Value = response.data.dto.extraProperties[2]
                  ? response.data.dto.extraProperties[2].value
                  : null;
              }
              if (vm.formModel.SupplyContrId.Value === null && vm.InvoiceType === 'INTCU') {
                var supplyContractId =
                  response.data.dto.extraProperties[3].value > 0 ? response.data.dto.extraProperties[3].value : null;
                vm.pageModel.Fields.SupplyContrId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
                  supplyContractId
                );
              }
            });
          }
        },
        CoTenantPartTm: function(selectedItem) {
          if (!!selectedItem) {
            vm.formModel.CoTenantPart = selectedItem.PartnerId;
          }
        },
        CoTenant2PartTm: function(selectedItem) {
          if (!!selectedItem) {
            vm.formModel.CoTenant2Part = selectedItem.PartnerId;
          }
        },
        InvoicePad: function(selectedItem, extraProperties) {
          if (!!selectedItem && !!extraProperties) {
            invoicePadChanged(extraProperties, false);
          } else {
            reValidateField(['Fulfilment']);
          }
        },
        InvoiceDate: function(selectedItem) {
          fillAuntCompanyData(vm.formModel.AuntCompanyId, vm.formModel.InvoiceDate);
        },
        ContractId: function(selectedItem) {
          if (selectedItem === null) {
            //Törléskor ürítjük a mezőket:
            clearFieldData();
          }

          if (selectedItem && selectedItem.ContractId > 0) {
            if (!vm.formModel.PartnerTMId.Value)
              $http.get('Invoice/GetContractForInvoice/' + selectedItem.ContractId).then(function(response) {
                vm.formModel.PartnerTMId.Value = response.data.dto.extraProperties[1]
                  ? response.data.dto.extraProperties[1].value
                  : null;
                vm.formModel.PartnerId = response.data.dto.extraProperties[0]
                  ? response.data.dto.extraProperties[0].value
                  : null;
                if (response.data.dto.extraProperties[2] !== null)
                  vm.formModel.Payment = response.data.dto.extraProperties[2]
                    ? response.data.dto.extraProperties[2].value
                    : null;
              });
          }

          if (vm.invoiceType === 'INTCU') {
            if (!!selectedItem && !!vm.formModel.ContractId) {
              vm.formModel.Currency = selectedItem.Currency;
            }
            if (!vm.formModel.Currency) {
              vm.formModel.Currency = 'HUF';
            }
          }
        },
        Payment: function(selectedItem) {
          if (selectedItem !== null && selectedItem.key !== '') {
            vm.formModel.PaymentIsCash = selectedItem.extraProperties[0].value === 'True';
            vm.formModel.PaymentIsCheque = selectedItem.extraProperties[1].value === 'True';
            reValidateField(['PaymentDueDate', 'Account1', 'Account2']);
          }
        },
        Account1: function(selectedItem) {
          if (!selectedItem) {
            vm.formModel.Account2 = null;
            vm.formModel.Account3 = null;
          }
          reValidateField(['PaymentDueDate', 'Account1', 'Account2']);
        },
        Fulfilment: function(selectedItem) {
          ////Dátum változáskor egyelőre törlöm az adatokat
          vm.refreshTMids();
        },
        SupplyContrId: function(selectedItem) {
          if (!vm.formModel.PartnerTMId.Value && !!selectedItem.GridItem)
            vm.formModel.PartnerTMId.Value = selectedItem.GridItem.SupplierPartTMId;
        },
      };

      vm.refreshTMids = function() {
        $http
          .get('Partner/GetTMIdsBasedOnValidDate/', {
            params: {
              partnerIds: vm.selectPartnerIds(),
              validDate: vm.formModel.Fulfilment,
            },
          })
          .then(function(response) {
            var tmObj = JSON.parse(JSON.stringify(response.data));
            var x = vm.getTmIdByValue(tmObj, 6);
            //vm.formModel.AuntCompanyTmId = vm.getTmIdByValue(tmObj, vm.AuntCompanyId);
            vm.formModel.PartnerTMId = vm.getTmIdByValue(tmObj, vm.formModel.PartnerId);
            vm.formModel.CoTenantPartTm = vm.getTmIdByValue(tmObj, vm.formModel.CoTenantPart);
            vm.formModel.CoTenant2PartTm = vm.getTmIdByValue(tmObj, vm.formModel.CoTenant2Part);
          });
      };

      vm.getTmIdByValue = function(arr, value) {
        var result = arr.filter(function(o) {
          return o.PartnerId === value;
        });

        return result && result.length > 0 ? result[0].PartnerTmId : null; // or undefined
      };

      vm.selectPartnerIds = function() {
        var list = [];
        if (vm.AuntCompanyId > 0) list.push(vm.AuntCompanyId);
        if (vm.formModel.PartnerId > 0) list.push(vm.formModel.PartnerId);
        if (vm.formModel.CoTenantPart > 0) list.push(vm.formModel.CoTenantPart);
        if (vm.formModel.CoTenant2Part > 0) list.push(vm.formModel.CoTenant2Part);
        return list.join();
      };

      /////////////////////////////////////
      //default érték hogy tudjunk menteni
      if (!vm.formModel.Currency) {
        vm.formModel.Currency = 'HUF';
      }
      /////////////////////////////////////

      var inputMasks = {
        Account1: '99999999',
        Account2: '99999999',
        Account3: '99999999',
      };

      var syncValidators = {
        Fulfilment: {
          FulfilmentValidator: function(modelValue) {
            var fulfilment = new Date(modelValue);
            if (
              vm.formModel.FinancialYear &&
              vm.formModel.FinancialYear !== '' &&
              fulfilment.getFullYear() !== vm.formModel.FinancialYear
            ) {
              //TODO sablon szövegre cserélni.
              toastr.warning(vm.formModel.FinancialYear + ' korlátozás van a számlatömben!', vm.messages.Warning);
              return false;
            }
            return true;
          },
        },

        PaymentDueDate: {
          PaymentDueDateValidator: function(modelValue) {
            var paymentDueDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoiceDateValue = new moment(
              vm.formModel.InvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            return vm.formModel.PaymentIsCash
              ? paymentDueDateValue.isSame(invoiceDateValue)
              : paymentDueDateValue.isSameOrAfter(invoiceDateValue);
          },
        },
      };

      var dynamicQueryParameters = {
        CoTenantPartTm: function() {
          return [
            { Key: 'ContractId', Value: vm.formModel.ContractId.Value },
            { Key: 'ValidDate', Value: vm.formModel.Fulfilment },
          ];
        },
        CoTenant2PartTm: function() {
          return [
            { Key: 'ContractId', Value: vm.formModel.ContractId.Value },
            { Key: 'ValidDate', Value: vm.formModel.Fulfilment },
          ];
        },
        ContractId: function() {
          return [{ Key: 'PartnerTMId', Value: vm.formModel.PartnerTMId.Value }];
        },
        PartnerTMId: function() {
          return [{ Key: 'ValidDate', Value: vm.formModel.Fulfilment }];
        },
      };

      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      if (vm.controllerOptions.isFormReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Force an onchange on InvoicePad when it is loaded to fill f22 with initial data
      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        InvoiceType: vm.InvoiceType,
      };

      vm.pageModel.Fields.SupplyContrId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        var condition = "ContractTypeType~eq~'CCTCU'";
        if (!!vm.selectedPartner) {
          condition +=
            '~and~SupplierPartCode' +
            (vm.selectedPartner.PartnerCode === null ? '~isnull' : "~eq~'" + vm.selectedPartner.PartnerCode + "'");
        }
        return condition;
      };

      function save() {
        if (vm.EditOrDuplicate === 'Duplicate') {
          //vm.formModel.RefInvoiceId = vm.formModel.InvoiceId;
        }
        $http
          .post('Invoice/' + vm.invoiceTypeForController + 'Invoice' + vm.function, vm.formModel)
          .then(function(response) {
            if (vm.shouldLock) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (vm.formModel.InvoiceId && vm.formModel.InvoiceId > 0 && vm.EditOrDuplicate !== 'Duplicate') {
              $state.go(vm.module + '.InvoiceNav', { InvoiceTypeFilter: vm.InvoiceType });
            } else {
              $state.go(vm.module + '.' + vm.invoiceTypeForController + 'InvoiceEdit', { id: response.data.InvoiceId });
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      //var invoiceId = options.dto.InvoiceId;
      vm.getInvoiceId = function() {
        return {
          targetInvoiceId: vm.formModel.InvoiceId,
        };
      };

      //var contractId = 0;
      //if (!!options.dto.ContractId) {
      //    contractId = options.dto.ContractId.Value;
      //}
      vm.getContractId = function() {
        return {
          contractId: vm.formModel.ContractId.Value,
        };
      };

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceRow', 'PanelInvoiceCorr'],
        function(gridModel) {
          if (gridModel.Name === 'GridInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
              selectFunction: function(row) {
                vm.invoiceRowNomodify = row.Nomodify;
                $scope.$applyAsync();
              },
            };
          }
          if (gridModel.Name === 'GridInvoiceCorr') {
            gridModel.ControllerMethod = 'Invoice/InvoiceCorrList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
            };
          }

          return null;
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      vm.activeSubItemTab = 0;
      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.duplicateSubItem = duplicateSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.showAttachDoc = showAttachDoc;
      //
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;
      //
      function createSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = 0;
        var invoiceId = vm.formModel.InvoiceId;
        $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Create', { id: id, invoiceId: invoiceId });
      }

      function editSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var invoiceId = vm.formModel.InvoiceId;
        if (!!id) {
          $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Edit', { id: id, invoiceId: invoiceId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function duplicateSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var urlPrefix = gridName;
        var id = getSelectedSubGridItemId();
        var invoiceId = vm.formModel.InvoiceId;
        if (!!id) {
          $state.go('Invoice.' + vm.invoiceTypeForController + urlPrefix + 'Duplicate', {
            id: id,
            invoiceId: invoiceId,
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function deleteSubItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var id = getSelectedSubGridItemId();
        if (!!id) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get('Invoice/' + vm.invoiceTypeForController + getUrlPrefix() + 'Delete/' + id)
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      $('#subGrid' + gridName)
                        .data('kendoGrid')
                        .dataSource.read();
                    });
                },
              },
            },
          });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function getSelectedSubGridItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = $('#subGrid' + gridName).data('kendoGrid');
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function lock() {
        $http.post('Invoice/' + vm.invoiceTypeForController + 'InvoiceSaveAndLock/', vm.formModel).then(function() {
          toastr.success('Számla zárás sikeresen megtörtént!');
          $state.reload();
          //$state.go("Invoice.RentAccountEdit", { "id": vm.formModel.InvoiceId });
        });
      }

      function attachDocument() {
        var id = vm.formModel.InvoiceId;
        dasService.NavigateToDas(vm.messages, 'Invoice.DasDocumentsNav', 'FlgInvoice', id);
      }

      function showAttachDoc() {
        return $stateParams.id > 0;
      }

      function History() {
        var id = getSelectedSubGridItemId();
        HistoryService.NavigateToHistory(
          'FlgInvoiceRow',
          id,
          vm,
          $state,
          true,
          '',
          vm.invoiceTypeForController + 'InvoiceRow'
        );
      }

      var reValidateField = function(fields) {
        angular.forEach(fields, function(value, key) {
          if (!!vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl)
            vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl.$validate();
        });
      };

      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'detailsIsCollapsed':
            vm.activeBooleans['detailsIsActive'] = true;
            break;
          case 'invoiceIsCollapsed':
            vm.activeBooleans['invoiceIsActive'] = true;
            break;
          case 'otherDetailsIsCollapsed':
            vm.activeBooleans['otherDetailsIsActive'] = true;
            break;
        }
      };

      var getUrlPrefix = function() {
        var urlPrefix = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      };

      function WAL() {
        var tableid = vm.activeSubItemTab === 0 ? 'FlgInvoiceRowView' : 'FlgInvoiceCorr';
        walService.NavigateToWal('Invoice', vm.invoiceTypeForController + getUrlPrefix() + 'Wal', tableid);
      }

      var clearFieldData = function() {
        vm.formModel.CoTenantPartTm.Value = null;
        vm.formModel.CoTenantPartTm.Text = null;
        vm.formModel.CoTenantPart = null;
        vm.formModel.CoTenant2PartTm.Value = null;
        vm.formModel.CoTenant2PartTm.Text = null;
        vm.formModel.CoTenant2Part = null;
        //vm.formModel.Payment = null;
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceRowEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$window',
    'LockService',
    'UIHelperService',
    '$q',
    'InvoiceValuesCalculatorService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      $window,
      lockService,
      UIHelperService,
      $q,
      InvoiceValuesCalculatorService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceRowEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = vm.pageModel.Labels;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.lastChangedIsBUP = true;
      vm.fieldsDisabledState = [];
      vm.function;

      InvoiceValuesCalculatorService.setModel(vm.formModel);
      InvoiceValuesCalculatorService.setCurrentRound(vm.formModel.Rounding);

      if ((!vm.formModel.InvoiceRowId || vm.formModel.InvoiceRowId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }

      if (vm.formModel.HasERP) {
        vm.pageModel.Fields.Object.MaxLength = 70;
      }

      vm.pageTypeTitle =
        vm.formModel.InvoiceType === 'INTCU' ? vm.labels.LabelINTCU.Title : vm.pageModel.Panels.PanelForm.Title;

      vm.save = save;
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Invoice.' + vm.invoiceTypeForController + 'InvoiceEdit', {
          id: vm.formModel.InvoiceId,
          invoiceType: vm.formModel.InvoiceType,
        });
      };
      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCU':
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
            type = 'Customer';
            break;
          case 'INTSU':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);

      var onChangeFunctions = {
        ServiceId: function(selectedItem) {
          vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            serviceId: selectedItem ? selectedItem.ServiceId : null,
          };
          if (!!selectedItem && selectedItem !== null && vm.formModel.BudgetId.Value !== null)
            $http({
              method: 'GET',
              url: 'Invoice/GetDataForInvoiceRow',
              params: {
                invoiceId: vm.formModel.InvoiceId,
                serviceId: selectedItem.ServiceId,
                budgetId: vm.formModel.BudgetId.Value,
                propertyId: vm.formModel.PropertyId.Value,
              },
            }).then(function(response) {
              if (response !== null && response.data.Dto !== null) {
                //vm.formModel.UnitId.Value = !vm.formModel.UnitId.Value ? response.data.Dto.UnitId : vm.formModel.UnitId.Value;
                //vm.formModel.OpUnitId = !vm.formModel.OpUnitId ? response.data.Dto.OpUnitId : vm.formModel.OpUnitId;
                //vm.formModel.VatCode = !vm.formModel.VatCode ? response.data.Dto.VatCode : vm.formModel.VatCode;
                //vm.formModel.Vat = !vm.formModel.Vat ? response.data.Dto.Vat : vm.formModel.Vat;
                vm.formModel.ProjectId = !vm.formModel.ProjectId ? response.data.Dto.ProjectId : vm.formModel.ProjectId;
                vm.formModel.UnitId.Value = response.data.Dto.UnitId;
                vm.formModel.OpUnitId = response.data.Dto.OpUnitId;
                vm.formModel.VatCode = response.data.Dto.VatCode;
                vm.formModel.Vat = response.data.Dto.Vat;
                vm.formModel.ProjectId = response.data.Dto.ProjectId;
                vm.formModel.Object = !vm.formModel.Object ? response.data.Dto.Object : vm.formModel.Object;
                vm.formModel.Quantity = vm.formModel.Quantity > 0 ? vm.formModel.Quantity : response.data.Dto.Quantity;
              } else {
                if (vm.formModel.UnitId.Value === null && vm.formModel.Vat === null) {
                  toastr.error('Nem egyértelműek a pénzügyi adatok!');
                }
              }
            });
        },
        BudgetId: function(selectedItem) {
          if (!!selectedItem) {
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: selectedItem ? selectedItem.BudgetId : null,
              invoiceId: vm.formModel.InvoiceId,
            };
          }
        },
        PropertyId: function(selectedItem) {
          if (selectedItem !== null) {
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              propertyId: selectedItem ? selectedItem.PropertyId : null,
            };
            vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              invoiceId: vm.formModel.InvoiceId,
            };

            if (selectedItem.PropertyId !== vm.formModel.PropertyId.Value) {
              clearBudget();
            }
          } else {
            clearBudget();
          }
        },
        BaseUnitPrice: function() {
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.BaseUnitPrice > 0);
          toggleField('Gross', vm.formModel.BaseUnitPrice > 0);
        },
        BaseGrossUnitPrice: function() {
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.BaseGrossUnitPrice > 0);
          toggleField('Gross', vm.formModel.BaseGrossUnitPrice > 0);
        },
        Quantity: function() {
          InvoiceValuesCalculatorService.ReCalc();
        },
        Discount: function() {
          InvoiceValuesCalculatorService.ReCalc();
          vm.formModel.DiscountPercent = null;
        },
        DiscountPercent: function() {
          InvoiceValuesCalculatorService.ReCalc();
          vm.formModel.Discount = null;
        },
        Net: function() {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('BaseUnitPrice', vm.formModel.Net > 0);
          toggleField('Gross', vm.formModel.Net > 0 && vm.formModel.BaseGrossUnitPrice > 0);
        },
        Gross: function() {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('BaseGrossUnitPrice', vm.formModel.Gross > 0);
          toggleField('Net', vm.formModel.Gross > 0 && vm.formModel.BaseUnitPrice > 0);
        },
        CalcMode: function(selectedItem) {
          vm.formModel.VatAmount = null;
          vm.formModel.UnitPrice = null;
          vm.formModel.GrossUnitPrice = null;
          vm.formModel.Net = null;
          vm.formModel.Gross = null;
          vm.formModel.BaseUnitPrice = null;
          vm.formModel.BaseGrossUnitPrice = null;

          toggleField('BaseUnitPrice', false);
          toggleField('BaseGrossUnitPrice', false);
          toggleField('Net', false);
          toggleField('Gross', false);
        },
      };

      var onBlurFunctions = {};

      var customExpressionProperties = {
        AccountingTo: {
          'templateOptions.required': function() {
            return vm.formModel.AccountingFrom !== null;
          },
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        AccountingFrom: {
          'templateOptions.required': function() {
            return vm.formModel.AccountingTo !== null;
          },
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return !!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        Quantity: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return !!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        Discount: {
          'templateOptions.disabled': function() {
            if (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null) {
              return true;
            } else {
              return !!vm.formModel.DiscountPercent;
              //return false;
            }
          },
        },
        DiscountPercent: {
          'templateOptions.disabled': function() {
            if (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null) {
              return true;
            } else {
              return !!vm.formModel.Discount;
              //return false;
            }
          },
        },
        Object: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        Net: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 1 ||
              vm.fieldsDisabledState['Net'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
          'templateOptions.required': function() {
            return !vm.fieldsDisabledState['Net'];
          },
        },
        Gross: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 0 ||
              vm.fieldsDisabledState['Gross'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
          'templateOptions.required': function() {
            return !vm.fieldsDisabledState['Gross'];
          },
        },
        Comment: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        ServiceId: {
          'templateOptions.disabled': function() {
            if (vm.formModel.BudgetId) {
              return vm.formModel.BudgetId.Value === null;
            } else {
              return false;
            }
          },
        },
        BaseUnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['BaseUnitPrice'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        BaseGrossUnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['BaseGrossUnitPrice'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        PropertyId: {
          'templateOptions.required': function() {
            return (
              (!vm.formModel.HasContract && vm.formModel.SupplyContrId < 1) ||
              (vm.formModel.InvoiceType === 'INTCU' && vm.formModel.HasKKR)
            );
          },
        },
      };

      var syncValidators = {
        BaseUnitPrice: {
          /**
           * @return {boolean}
           */
          UnitPriceValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
        },
        UnitPrice: {
          /**
           * @return {boolean}
           */
          UnitPriceValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
        },
        DiscountPercent: {
          /**
           * @return {boolean}
           */
          DiscountPercentValidator: function(viewValue, modelValue) {
            return modelValue <= 100;
          },
        },
        AccountingTo: {
          AccountingToValidator: function(modelValue) {
            var AccountingToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var AccountingFromValue = new moment(
              vm.formModel.AccountingFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return modelValue === null || AccountingToValue.isSameOrAfter(AccountingFromValue);
          },
        },
      };

      var dynamicQueryParameters = {
        BudgetId: {
          propertyId: function() {
            return vm.formModel.PropertyId.Value;
          },
        },
        PropertyId: {
          invoiceId: function() {
            return vm.formModel.InvoiceId;
          },
        },
      };

      var hideExpressions = {
        BaseGrossUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 0;
        },
        BaseUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 1;
        },

        GrossUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 0;
        },
        UnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 1;
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      function save() {
        var defer = $q.defer();
        $http
          .post('Invoice/' + vm.invoiceTypeForController + 'InvoiceRow' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Invoice.' + vm.invoiceTypeForController + 'InvoiceEdit', {
              id: vm.formModel.InvoiceId,
              invoiceType: vm.formModel.InvoiceType,
            });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            defer.reject();
          });
        return defer.promise;
      }

      function clearBudget() {
        vm.formModel.BudgetId.Text = null;
        vm.formModel.BudgetId.Value = 0;

        vm.formModel.ServiceId.Text = null;
        vm.formModel.ServiceId.Value = 0;
      }

      var toggleField = function(_field, _bool) {
        vm.fieldsDisabledState[_field] = _bool;
      };

      //letiltom előtöltésnél a net, gross mezőt
      toggleField('Net', vm.formModel.BaseUnitPrice > 0);
      toggleField('Gross', vm.formModel.BaseUnitPrice > 0);

      function parseLocaleNumber(number) {
        if (!number) {
          number = 0;
        }
        var thousandSeparator = (1111).toLocaleString().replace(/1/g, '');
        var decimalSeparator = (1.1).toLocaleString().replace(/1/g, '');

        var numText = number + '';
        if (thousandSeparator !== '') {
          numText = numText.replace(new RegExp('\\' + thousandSeparator, 'g'), '');
        }
        if (decimalSeparator !== '') {
          numText = numText.replace(new RegExp('\\' + decimalSeparator), '.');
        }

        return Number(parseFloat(numText));

        //return Number(parseFloat((number + "")
        //    .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
        //    .replace(new RegExp('\\' + decimalSeparator), '.')));
      }
      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.Rounding || 0));
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('RentAccountRowEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$window',
    'LockService',
    'UIHelperService',
    '$q',
    'InvoiceValuesCalculatorService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      $window,
      lockService,
      UIHelperService,
      $q,
      InvoiceValuesCalculatorService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentAccountRowEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = vm.pageModel.Labels;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.fieldsDisabledState = [];
      vm.function;

      InvoiceValuesCalculatorService.setModel(vm.formModel);
      InvoiceValuesCalculatorService.setCurrentRound(vm.formModel.Rounding);

      if ((!vm.formModel.InvoiceRowId || vm.formModel.InvoiceRowId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }

      if (vm.formModel.HasERP) {
        vm.pageModel.Fields.Object.MaxLength = 70;
      }

      vm.pageTypeTitle =
        vm.formModel.InvoiceType === 'INTCU' ? vm.labels.LabelINTCU.Title : vm.pageModel.Panels.PanelForm.Title;

      vm.save = save;
      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Invoice.' + vm.invoiceTypeForController + 'InvoiceEdit', {
          id: vm.formModel.InvoiceId,
          invoiceType: vm.formModel.InvoiceType,
        });
      };
      vm.getInvoiceTypeForController = function(invoiceType) {
        var type = '';
        switch (invoiceType) {
          case 'INTRM':
            type = 'Rent';
            break;
          case 'INTCU':
          case 'INTCO':
          case 'INTCP':
          case 'INTDI':
            type = 'Customer';
            break;
          case 'INTSU':
            type = 'Supplier';
            break;
          case 'INTCA':
          case 'INTCI':
            type = 'Property';
            break;
            break;
          default:
        }
        return type;
      };
      vm.invoiceTypeForController = vm.getInvoiceTypeForController(vm.formModel.InvoiceType);

      var onChangeFunctions = {
        ContractId: function(selectedItem) {
          if (!!selectedItem) {
            $http({
              method: 'GET',
              url: 'Invoice/GetPropertyAndBudgetForInvoiceRow',
              params: {
                invoiceId: vm.formModel.InvoiceId,
                contractId: selectedItem.ContractId,
              },
            }).then(function(response) {
              vm.formModel.PropertyId = response.data.Dto.PropertyId;
              vm.formModel.BudgetId = response.data.Dto.BudgetId;
              vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                budgetId: vm.formModel.BudgetId,
                invoiceId: vm.formModel.InvoiceId,
              };
            });
          }
        },

        ServiceId: function(selectedItem) {
          if (!!selectedItem && selectedItem !== null && vm.formModel.BudgetId.Value !== null)
            $http({
              method: 'GET',
              url: 'Invoice/GetFinancialDataForRentAccountRow',
              params: {
                invoiceId: vm.formModel.InvoiceId,
                serviceId: selectedItem.ServiceId,
                budgetId: vm.formModel.BudgetId.Value,
                propertyId: vm.formModel.PropertyId.Value,
                accountingFrom: vm.formModel.AccountingFrom,
                accountingTo: vm.formModel.AccountingTo,
              },
            }).then(function(response) {
              if (response !== null && response.data.Dto !== null) {
                vm.formModel.ProjectId = !vm.formModel.ProjectId ? response.data.Dto.ProjectId : vm.formModel.ProjectId;
                vm.formModel.UnitId.Value = response.data.Dto.UnitId;
                vm.formModel.OpUnitId = response.data.Dto.OpUnitId;
                vm.formModel.VatCode = response.data.Dto.VatCode;
                vm.formModel.Vat = response.data.Dto.Vat;
                vm.formModel.ProjectId = response.data.Dto.ProjectId;
                vm.formModel.Object = !vm.formModel.Object ? response.data.Dto.Object : vm.formModel.Object;
                vm.formModel.Quantity = vm.formModel.Quantity > 0 ? vm.formModel.Quantity : response.data.Dto.Quantity;
              } else {
                if (vm.formModel.UnitId.Value === null && vm.formModel.Vat === null) {
                  toastr.error('Nem egyértelműek a pénzügyi adatok!');
                }
              }
            });
        },

        UnitPrice: function() {
          vm.formModel.BaseUnitPrice = vm.formModel.UnitPrice;
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.UnitPrice > 0);
          toggleField('Gross', vm.formModel.UnitPrice > 0);
        },
        GrossUnitPrice: function() {
          vm.formModel.BaseGrossUnitPrice = vm.formModel.GrossUnitPrice;
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.UnitPrice > 0);
          toggleField('Gross', vm.formModel.UnitPrice > 0);
        },
        Quantity: function() {
          InvoiceValuesCalculatorService.ReCalc();
        },
        Net: function() {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('UnitPrice', vm.formModel.Net > 0);
          toggleField('Gross', vm.formModel.Net > 0 && vm.formModel.UnitPrice > 0);
        },
        Gross: function() {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('GrossUnitPrice', vm.formModel.Gross > 0);
          toggleField('Net', vm.formModel.Gross > 0 && vm.formModel.UnitPrice > 0);
        },
        CalcMode: function(selectedItem) {
          vm.formModel.VatAmount = null;
          vm.formModel.UnitPrice = null;
          vm.formModel.GrossUnitPrice = null;
          vm.formModel.Net = null;
          vm.formModel.Gross = null;
          vm.formModel.BaseUnitPrice = null;
          vm.formModel.BaseGrossUnitPrice = null;

          toggleField('UnitPrice', false);
          toggleField('GrossUnitPrice', false);
          toggleField('Net', false);
          toggleField('Gross', false);
        },
      };

      var customCallbackFunctions = {};

      var onBlurFunctions = {};

      var customExpressionProperties = {
        AccountingTo: {
          'templateOptions.required': function() {
            return vm.formModel.AccountingFrom !== null;
          },
        },
        AccountingFrom: {
          'templateOptions.required': function() {
            return vm.formModel.AccountingTo !== null;
          },
        },
        Quantity: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return !!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        Net: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 1 ||
              vm.fieldsDisabledState['Net'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
          'templateOptions.required': function() {
            return !vm.fieldsDisabledState['Net'];
          },
        },
        Gross: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 0 ||
              vm.fieldsDisabledState['Gross'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
          'templateOptions.required': function() {
            return !vm.fieldsDisabledState['Gross'];
          },
        },
        Comment: {
          'templateOptions.disabled': function() {
            if (vm.formModel.ServiceId) {
              return vm.formModel.ServiceId.Value === null;
            } else {
              return false;
            }
          },
        },
        ServiceId: {
          'templateOptions.disabled': function() {
            if (vm.formModel.BudgetId) {
              return vm.formModel.BudgetId.Value === null;
            } else {
              return false;
            }
          },
        },
        UnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['UnitPrice'] || (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        GrossUnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['GrossUnitPrice'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
      };

      var syncValidators = {
        UnitPrice: {
          /**
           * @return {boolean}
           */
          UnitPriceValidator: function(viewValue, modelValue) {
            return modelValue > 0;
          },
        },
        AccountingTo: {
          AccountingToValidator: function(modelValue) {
            var AccountingToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var AccountingFromValue = new moment(
              vm.formModel.AccountingFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return modelValue === null || AccountingToValue.isSameOrAfter(AccountingFromValue);
          },
        },
      };

      var dynamicQueryParameters = {};

      var hideExpressions = {
        GrossUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 0;
        },
        UnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 1;
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertHideExpressions(vm.pageModel, hideExpressions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.pageModel.Fields.ContractId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        partnerId: vm.formModel.PartnerId,
      };

      function save() {
        vm.formModel.BaseUnitPrice = vm.formModel.UnitPrice;
        vm.formModel.BaseGrossUnitPrice = vm.formModel.GrossUnitPrice;
        var defer = $q.defer();
        $http
          .post('Invoice/' + vm.invoiceTypeForController + 'InvoiceRow' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Invoice.' + vm.invoiceTypeForController + 'InvoiceEdit', {
              id: vm.formModel.InvoiceId,
              invoiceType: vm.formModel.InvoiceType,
            });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            defer.reject();
          });
        return defer.promise;
      }

      function clearBudget() {
        vm.formModel.BudgetId.Text = null;
        vm.formModel.BudgetId.Value = 0;

        vm.formModel.ServiceId.Text = null;
        vm.formModel.ServiceId.Value = 0;
      }

      var toggleField = function(_field, _bool) {
        vm.fieldsDisabledState[_field] = _bool;
      };

      //letiltom előtöltésnél a net, gross mezőt
      toggleField('Net', vm.formModel.UnitPrice > 0);
      toggleField('Gross', vm.formModel.UnitPrice > 0);

      function parseLocaleNumber(number) {
        if (!number) {
          number = 0;
        }
        var thousandSeparator = (1111).toLocaleString().replace(/1/g, '');
        var decimalSeparator = (1.1).toLocaleString().replace(/1/g, '');

        var numText = number + '';
        if (thousandSeparator !== '') {
          numText = numText.replace(new RegExp('\\' + thousandSeparator, 'g'), '');
        }
        if (decimalSeparator !== '') {
          numText = numText.replace(new RegExp('\\' + decimalSeparator), '.');
        }

        return Number(parseFloat(numText));

        //return Number(parseFloat((number + "")
        //    .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
        //    .replace(new RegExp('\\' + decimalSeparator), '.')));
      }
      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.Rounding || 0));
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SupplierInvoiceEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$uibModal',
    'HistoryService',
    'DasService',
    'LockService',
    'WalService',
    'gridService',
    'UIHelperService',
    'AuthService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      walService,
      gridService,
      UIHelperService,
      authService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplierInvoiceEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();

      vm.saveIsDisabled = function() {
        const debugging = false;

        if (!debugging) {
          return vm.formModel.IsReadOnly || vm.formly.$invalid;
        }

        if (!vm.formly.$invalid) {
          return vm.formModel.IsReadOnly || vm.formly.$invalid;
        }

        // invalid
        const breakpoint_here = 1;
      };

      vm.module = $state.current.params.module || 'Invoice';
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.InvoiceType = options.dto.InvoiceType;
      // ha nincs előtöltve a kibocsájtó f2, akkor majd a combobox inicializáláskor be kell tölteni....
      vm.preLoadAuntCompany = !vm.formModel.AuntCompanyTmId?.Value;
      vm.isProcUser = false;
      vm.isProcUserOrgPart = false;
      vm.isPaymentAllocator = function() {
        return options.dto.PaymentAllocator === authService.user.id;
      };

      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridSuppInvoiceStatus'], ['ModDate']);
      //vm.UIHelperService.setDefaultSidebarStatus();

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGHeader',
        disableRunExpression: false,
      };

      function headerIsDisabled() {
        return vm.collapseHelper?.disabledPanels?.indexOf('PGHeader') !== -1;
      }

      vm.function;
      if ((!vm.formModel.InvoiceId || vm.formModel.InvoiceId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }

      vm.saveAppFunctionEnabled = saveAppFunctionEnabled();
      vm.WAL = WAL;
      vm.shouldLock = vm.formModel.InvoiceStatus !== 'INSCL' && !vm.formModel.IsReadOnly;

      if (vm.shouldLock) {
        vm.securedProgramId = options.programId;
        vm.securedId = options.id;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.QueryParameters = {
        filterByERPCONParam:
          !vm.formModel.InvoiceERPCONParameterValue && vm.formModel.SystemERPCONParameterValue !== 'ERPCON_NO',
      };

      vm.disableHeaderByERPCON =
        !!vm.formModel.InvoiceERPCONParameterValue && vm.formModel.InvoiceERPCONParameterValue !== 'ERPCON_NO';
      apply_ERPCON_state(vm.disableHeaderByERPCON);

      function apply_ERPCON_state(disable) {
        vm.pageModel.Fields.OriginalDoc.MaxLength = disable ? 20 : 50;
        if (disable === true) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            if (['PanelFormLeft', 'PanelFormRight'].indexOf(value.ContainerPanelId) !== -1)
              value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }
      }

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var customTypes = {
        Account2: 'maskedInput',
        Account3: 'maskedInput',
        Account1Sep: 'separatorDash',
        Account2Sep: 'separatorDash',
      };

      var customExpressionProperties = {
        SupplyContrId: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.IsReadOnly === true ||
              vm.formModel.PartnerId == null ||
              vm.formModel.PartnerId.Value === null ||
              vm.formModel.PartnerId.Value === 0 ||
              vm.EditOrDuplicate == 'View'
            );
          },
        },
        Account1: {
          'templateOptions.required': function() {
            return ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Cash', ['False']);
          },
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Account2: {
          'templateOptions.required': function() {
            return (
              vm.formModel.Account1 !== null && vm.formModel.Account1.Text !== null && vm.formModel.Account1.Text !== ''
            );
          },
          // Ez azért van itt, hogy ne csússzon fel a mező, ha nincs label
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Account3: {
          'templateOptions.label': function() {
            return '\u00A0';
          },
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        // HAXX
        Account1Sep: {
          'templateOptions.disabled': 'true',
        },
        Account2Sep: {
          'templateOptions.disabled': 'true',
        },
        OrgPartId: {
          'templateOptions.required': 'false',
        },
        PaymentDueDate: {
          'templateOptions.disabled': function() {
            return (
              ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Cash', ['True']) ||
              headerIsDisabled() ||
              vm.formModel.IsReadOnly ||
              vm.disableHeaderByERPCON ||
              vm.EditOrDuplicate == 'View'
            );
          },
        },
        InvoicePad: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() ||
              vm.formModel.IsReadOnly ||
              (vm.formModel.ERPCON_NO !== true && vm.formModel.InvoiceId > 0 && vm.EditOrDuplicate == 'Edit') ||
              vm.EditOrDuplicate == 'View'
            );
          },
        },
        PartnerId: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        InvoiceDate: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Fulfilment: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Arrival: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Payment: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        Currency: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        ControllSumma: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
          'templateOptions.required': function() {
            return true;
          },
        },
        PaymentAllocator: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
        OriginalDoc: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
          'templateOptions.required': function() {
            return vm.formModel.INODRQ_YES === true;
          },
        },
        Period: {
          'templateOptions.disabled': function() {
            return (
              headerIsDisabled() || vm.formModel.IsReadOnly || vm.disableHeaderByERPCON || vm.EditOrDuplicate == 'View'
            );
          },
        },
      };

      var onChangeFunctions = {
        PartnerId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.GridItem) {
            $http.get('Partner/PartnerView/' + selectedItem.Value).then(function(response) {
              //Ha már ki van töltve (módosítás) ne írja felül:
              if ((!vm.formModel.Account1 || !vm.formModel.Account1.Value) && !!response.data.dto.Account) {
                vm.formModel.Account1 = {
                  Value: response.data.dto.Account.substring(0, 8),
                  Text: response.data.dto.Account.substring(0, 8),
                };
                vm.formModel.Account2 = response.data.dto.Account.substring(8, 16);
                vm.formModel.Account3 = response.data.dto.Account.substring(16, 24);
              }
            });
          } else {
          }
        },
        InvoicePad: function(selectedItem, selectedRow) {
          if (!!selectedItem) {
            var extraProperties = selectedRow;
            invoicePadChanged(extraProperties, true);
          } else {
            reValidateField(['Fulfilment']);
          }
        },
        OrgPartId: function(selectedItem) {
          if (selectedItem) vm.isProcUserOrgPart = false;
          refreshRestFields(vm.formModel.InvoiceId, selectedItem.key);
          refreshActiveGrid();
        },
        //"ContractId": function (selectedItem) {
        //    if (!!selectedItem && !!vm.formModel.ContractId)
        //        vm.formModel.Currency = selectedItem.Currency;
        //    if (!vm.formModel.Currency)
        //        vm.formModel.Currency = "HUF";
        //},
        Payment: function(selectedItem) {
          setTimeout(function() {
            $scope.$apply(function() {
              if (ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Cash', ['True'])) {
                vm.formModel.PaymentDueDate = vm.formModel.InvoiceDate;
              }
            });
            reValidateField(['PaymentDueDate', 'Account1', 'Account2']);
          });
          SetModelExtraPropBasedOnSelectedItem(vm.formModel.extraProperties, 'Cash', selectedItem);
        },
        InvoiceDate: function(selectedItem) {
          setTimeout(function() {
            fillAuntCompanyData(vm.formModel.AuntCompanyId, vm.formModel.InvoiceDate);
            $scope.$apply(function() {
              if (ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Cash', ['True'])) {
                vm.formModel.PaymentDueDate = vm.formModel.InvoiceDate;
              }
            });
            reValidateField(['PaymentDueDate']);
          });
        },
        Account1: function(selectedItem) {
          if (!selectedItem.Value) {
            vm.formModel.Account2 = null;
            vm.formModel.Account3 = null;
          }
          reValidateField(['PaymentDueDate', 'Account1', 'Account2']);
        },
        Fulfilment: function() {
          if (!!vm.formModel.Fulfilment) {
            vm.pageModel.Fields.Period.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            var fulfilmentDate = new moment(vm.formModel.Fulfilment, kendo.culture().calendar.patterns.d.toUpperCase());
            var newPeriod = fulfilmentDate.format('YYYYMM');
            if (
              hasPeriod(
                vm.pageModel.Fields.Period.FormlyFieldDescriptor.templateOptions.options.dataSource.data(),
                newPeriod
              )
            ) {
              vm.formModel.Period = newPeriod;
            } else {
              vm.formModel.Period = null;
              toastr.warning('Nincs még ilyen időszak definiálva (' + newPeriod + ')!', vm.messages.Warning);
            }
          } else {
            vm.formModel.Period = null;
          }
        },
      };

      var inputMasks = {
        Account1: '99999999',
        Account2: '99999999',
        Account3: '99999999',
      };

      var syncValidators = {
        Fulfilment: {
          /**
           * @return {boolean}
           */
          FulfilmentValidator: function(modelValue) {
            var fulfilmentDate = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase(), true);
            if (!fulfilmentDate.isValid()) {
              return true;
            }
            var fulfilmentYear = fulfilmentDate.year();
            if (
              vm.formModel.FinancialYear &&
              vm.formModel.FinancialYear !== '' &&
              fulfilmentYear.toString() !== vm.formModel.FinancialYear
            ) {
              //TODO sablon szövegre cserélni.
              toastr.warning(vm.formModel.FinancialYear + ' korlátozás van a számlatömbben!', vm.messages.Warning);
              return false;
            }
            return true;
          },
        },

        PaymentDueDate: {
          PaymentDueDateValidator: function(modelValue) {
            var paymentDueDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoiceDateValue = new moment(
              vm.formModel.InvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return ShowFieldBasedOnExtraProp(vm.formModel.extraProperties, 'Cash', ['True'])
              ? paymentDueDateValue.isSame(invoiceDateValue)
              : true;
          },
        },
      };

      var dynamicQueryParameters = {
        SupplyContrId: function() {
          return [
            {
              value: vm.formModel.PartnerId.Value,
              key: 'PartnerId',
            },
          ];
        },
      };

      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      function invoicePadDataBound(e) {
        var selectedIndex = e.sender.selectedIndex;
        if (!!e.sender.dataSource._data[selectedIndex]) {
          var extraProperties = e.sender.dataSource._data[selectedIndex];
          invoicePadChanged(extraProperties, vm.preLoadAuntCompany);
        }
      }

      vm.pageModel.Fields.InvoicePad.FormlyFieldDescriptor.templateOptions.options.dataBound = invoicePadDataBound;

      vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.parameterMap = function(
        data,
        type
      ) {
        return {
          invoiceId: options.dto?.InvoiceId,
        };
      };

      //vm.FormlyFormPanelDescriptors.PanelFormLeft.FormlyDescriptor['0'].fieldGroup['0'].fieldGroup['0'].templateOptions.options.dataBound = invoicePadDataBound;

      var invoiceId = options.dto.InvoiceId;
      vm.getInvoiceId = function() {
        return {
          targetInvoiceId: invoiceId,
        };
      };

      vm.checkUnitSumProcUser = function(item) {
        if (!!item?.UnitSumId) {
          $http({
            method: 'GET',
            url: 'Invoice/CheckProcUser',
            params: {
              id: item.UnitSumId ?? 0,
            },
          }).then(function successCallback(response) {
            vm.isProcUser = response?.data?.result?.Valid ?? false;
            return;
          });
        }
        vm.isProcUser = false;
      };

      vm.getRowFilter = function() {
        return {
          dto: {
            orgPartId: vm.formModel.OrgPartId,
            invoiceId: vm.formModel.InvoiceId,
          },
        };
      };

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceUnitSum', 'PanelInvoiceRow', 'PanelInvoiceApproval', 'PanelInvoiceStatus'],
        function(gridModel) {
          if (gridModel.Name === 'GridSuppInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowListWithFilter/';

            return {
              gridModel,
              transportData: vm.getRowFilter,
            };
          }
          if (gridModel.Name === 'GridSuppInvoiceUnitSum') {
            gridModel.ControllerMethod = 'Invoice/InvoiceUnitSumList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
              selectFunction: function(item) {
                vm.checkUnitSumProcUser(item);
              },
            };
          }
          if (gridModel.Name === 'GridSuppInvoiceApproval') {
            gridModel.ControllerMethod = 'Invoice/InvoiceApprovalList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
            };
          }

          if (gridModel.Name === 'GridSuppInvoiceStatus') {
            gridModel.ControllerMethod = 'Invoice/InvoiceStatusList/';

            return {
              gridModel,
              transportData: vm.getInvoiceId,
            };
          }

          return null;
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.showAttachDoc = showAttachDoc;

      // MAIN BUTTONS
      vm.back = function() {
        if (vm.shouldLock) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go(vm.module + '.' + $stateParams.BackTo, { InvoiceTypeFilter: vm.InvoiceType }, true);
      };

      vm.save = function save() {
        $http
          .post('Invoice/SupplierInvoice' + vm.function, vm.formModel)
          .then(function(response) {
            if (vm.shouldLock) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);

            if (response.data.InvoiceId > 0) {
              $state.go(vm.module + '.SupplierInvoiceEdit', { id: response.data.InvoiceId });
            } else if (vm.formModel.InvoiceId > 0) {
              $state.go(vm.module + '.SupplierInvoiceEdit', { id: vm.formModel.InvoiceId }, { reload: true });
            } else {
              $state.go(vm.module + '.' + $stateParams.BackTo, { InvoiceTypeFilter: vm.InvoiceType }, true);
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            vm.formModel.InvoiceStatus = 'INSOP';
          });
      };

      vm.saveApp = function saveApp() {
        $http
          .post('Invoice/InvCompetenceCheck')
          .then(function(response) {
            vm.formModel.InvoiceStatus = 'INSCO';
            vm.save();
          })
          .catch(function(response) {
            //toastr.error(response.statusText);
          });
      };

      vm.sub = function() {
        //$http.get("Invoice/SupplierInvUnitSumCount/" + vm.formModel.InvoiceId)
        //        .then(function () {
        //            var url = "Invoice/SupplierInvUnitDev/?InvoiceId=" + vm.formModel.InvoiceId;
        //            var modalInstance = $uibModal.open({
        //                templateUrl: "App/Invoice/SupplierInvUnitDev.html",
        //                controller: "SupplierInvUnitDevCtrl",
        //                controllerAs: "vm",
        //                resolve: {
        //                    fModel: RouteResolveFunc(url),
        //                    EditOrDuplicate: editPromise
        //                },
        //                backdrop: "static"
        //            });
        //            modalInstance.result.then(function () {
        //                refreshActiveGrid();
        //            });
        //        });
        //$state.go("Invoice.SupplierInvUnitDev", {"InvoiceId": vm.formModel.Invoice});

        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        $state.go('Invoice.TenancyDivision', { invoiceId: vm.formModel.InvoiceId, id: id });
      };

      vm.addInvoiceRow = function() {
        var item = getSelectedSubGridItem();
        debugger;

        $state.go('Invoice.SuppInvoiceRowCreate', {
          id: 0,
          invoiceId: item.InvoiceId,
          orgPartId: item.OrgPartId,
          unitSumId: item.UnitSumId,
        });
      };

      // GRID BUTTONS
      vm.createSubItem = function createSubItem() {
        var lfs = vm.getInvoiceId();
        var urlPrefix = getUrlPrefix();
        var id = 0;
        var invoiceId = vm.formModel.InvoiceId;
        if (urlPrefix === 'SuppInvoiceRow') {
          $http.get('Invoice/SupplierInvUnitCount/' + invoiceId).then(function() {
            $state.go('Invoice.' + urlPrefix + 'Create', {
              id: 0,
              invoiceId: +lfs.targetInvoiceId,
              orgPartId: options.dto.OrgPartId,
            });
          });
        } else if (vm.activeSubItemTab == 0) {
          $http.get('Invoice/SupplierInvUnitSumCount/' + invoiceId).then(function() {
            var url = 'Invoice/SupplierInvUnitSumCreate/?id=' + 0 + '&invoiceId=' + vm.formModel.InvoiceId;
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Invoice/SupplierInvUnitSumEdit.html',
              controller: 'SupplierInvUnitSumEditCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: RouteResolveFunc(url),
                EditOrDuplicate: editPromise,
              },
              backdrop: 'static',
            });
            modalInstance.result.then(function() {
              vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              refreshActiveGrid();
            });
          });
        } else {
          $state.go('Invoice.' + urlPrefix + 'Edit', {
            id: 0,
            invoiceId: +lfs.targetInvoiceId,
            orgPartId: options.dto.OrgPartId,
          });
        }
      };

      vm.editSubItem = function editSubItem() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        } else if (vm.activeSubItemTab == 0) {
          $http.get('Invoice/SupplierInvUnitSumEditCheck/' + id).then(function() {
            var url = 'Invoice/SupplierInvUnitSumEdit/' + id;
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Invoice/SupplierInvUnitSumEdit.html',
              controller: 'SupplierInvUnitSumEditCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: RouteResolveFunc(url),
                EditOrDuplicate: editPromise,
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              refreshActiveGrid();
            });
          });
        } else {
          var lfs = vm.getInvoiceId();
          $state.go('Invoice.' + getUrlPrefix() + 'Edit', {
            id: id,
            invoiceId: +lfs.targetInvoiceId,
            orgPartId: options.dto.OrgPartId,
          });
        }
      };

      vm.duplicateSubItem = function duplicateSubItem() {
        var id = getSelectedSubGridItemId();
        var invoiceId = vm.formModel.InvoiceId;
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        } else if (vm.activeSubItemTab == 0) {
          $http.get('Invoice/SupplierInvUnitSumCount/' + invoiceId).then(function() {
            var url = 'Invoice/SupplierInvUnitSumDuplicate/' + id;
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Invoice/SupplierInvUnitSumEdit.html',
              controller: 'SupplierInvUnitSumEditCtrl',
              controllerAs: 'vm',
              resolve: {
                fModel: RouteResolveFunc(url),
                EditOrDuplicate: duplicatePromise,
              },
              backdrop: 'static',
            });

            modalInstance.result.then(function() {
              vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              refreshActiveGrid();
            });
          });
        } else {
          var lfs = vm.getInvoiceId();
          $state.go('Invoice.' + getUrlPrefix() + 'Duplicate', {
            id: id,
            invoiceId: +lfs.targetInvoiceId,
            orgPartId: options.dto.OrgPartId,
          });
        }
      };

      vm.isDeleteSubItemDisabled = function() {
        var disabled =
          vm.formModel.IsReadOnly === true ||
          vm.formModel.InvoiceId == 0 ||
          (vm.activeSubItemTab == 1 && !(vm.formModel.OrgPartId > 0 && vm.formModel.InvoiceId > 0));
        var enabled = !disabled || vm.formModel.InvoiceStatus == 'INSOP';
        return !enabled;
      };

      vm.deleteSubItem = function deleteSubItem() {
        var id = getSelectedSubGridItemId();

        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var item = getSelectedSubGridItem();
        var url = 'Invoice/' + getUrlPrefix() + 'Delete/' + id;
        if (vm.detailItemTabs[vm.activeSubItemTab].gridName === 'GridSuppInvoiceUnitSum') {
          $http.get('Invoice/SuppInvoiceUnitSumCheckRows/' + id).then(function(response) {
            if (!!response.data.ErrorMessages) {
              bootbox.dialog({
                message: response.data.ErrorMessages,
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      $http.get(url).then(function() {
                        toastr.success(vm.messages.DeleteSuccessful);
                        vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
                        refreshAllGrids();
                      });
                    },
                  },
                },
              });
            } else {
              $http.get(url).then(function() {
                toastr.success(vm.messages.DeleteSuccessful);
                vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
                refreshAllGrids();
              });
            }
          });
        } else {
          bootbox.dialog({
            message:
              vm.messages.ConfirmDelete +
              (item.MeterReadingId > 0 ? ' A mérőóra kapcsolat miatt a kapcsolódó tételek is törlődnek! ' : ''),
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(url).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    refreshAllGrids();
                    if (vm.detailItemTabs[vm.activeSubItemTab].gridName === 'GridSuppInvoiceRow') {
                      getHeaderdata(vm.formModel.InvoiceId);
                      refreshRestFields(vm.formModel.InvoiceId, vm.formModel.OrgPartId);
                    }
                  });
                },
              },
            },
          });
        }
      };

      function getSelectedSubGridItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.detailItemGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      function attachDocument() {
        var id = vm.formModel.InvoiceId;
        dasService.NavigateToDas(vm.messages, 'Invoice.DasDocumentsNav', 'FlgInvoice', id);
      }

      function showAttachDoc() {
        return $stateParams.id > 0;
      }

      function History() {
        var id = getSelectedSubGridItemId();
        var tableid;
        switch (vm.activeSubItemTab) {
          case 0:
            tableid = 'FlgInvoiceUnitSum';
            break;
          case 1:
            tableid = 'FlgInvoiceRow';
            break;
          default:
        }
        HistoryService.NavigateToHistory(tableid, id, vm, $state, true, '', 'Supplier' + tableid.substring(3));
      }

      var getUrlPrefix = function() {
        var urlPrefix = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      };
      var refreshActiveGrid = function() {
        vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]].dataSource.read();
      };
      var refreshAllGrids = function() {
        for (let i = 0; i < vm.detailItemGrids.length; i++) {
          var gridName = vm.detailItemGrids[i];
          var grid = vm.detailItemGrids[gridName];
          if (!!grid) {
            var dataSource = grid.dataSource;
            if (dataSource) {
              dataSource.read();
            }
          }
        }
      };
      var editPromise = new Promise(function(resolve) {
        resolve('Edit');
      });
      var duplicatePromise = new Promise(function(resolve) {
        resolve('Duplicate');
      });

      function saveAppFunctionEnabled() {
        return vm.formModel.InvoiceStatus === 'INSOP';
      }

      var reValidateField = function(fields) {
        angular.forEach(fields, function(value, key) {
          if (!!vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl)
            vm.pageModel.Fields[value].FormlyFieldDescriptor.formControl.$validate();
        });
      };

      var hasPeriod = function(object, value) {
        for (var i = 0; i < object.length; i++) {
          if (object[i].key === value) return true;
        }
        return false;
      };

      function fillAuntCompanyData(auntCompanyId, invoiceDate) {
        $http
          .get('Invoice/GetAuntCompanyData/', { params: { auntCompanyId: auntCompanyId, invoiceDate: invoiceDate } })
          .then(function(response) {
            vm.formModel.AuntCompanyTmId = response.data.Dto.AuntCompanyTMId;
          });
      }

      function invoicePadChanged(extraProperties, preLoadAuntCompany) {
        if (extraProperties) {
          vm.formModel.AuntCompanyId = extraProperties?.AuntCompanyId;
          vm.formModel.Notice = extraProperties?.Notice;
          vm.formModel.FinancialYear = extraProperties?.FinancialYear;
          if (preLoadAuntCompany) {
            fillAuntCompanyData(extraProperties?.AuntCompanyId, vm.formModel.InvoiceDate);
          }
          //nem kell apply_ERPCON_state
          reValidateField(['Fulfilment']);
        }
      }

      function getHeaderdata(invoiceId) {
        $http.get('Invoice/SupplierInvoiceEdit/' + invoiceId).then(function(result) {
          if (!!result && !!result.data) {
            vm.formModel.Net = result.data.dto.Net;
            vm.formModel.Gross = result.data.dto.Gross;
            vm.formModel.Vat = result.data.dto.Vat;
            vm.formModel.Pay = result.data.dto.Pay;
          }
        });
      }

      function refreshRestFields(invoiceId, orgPartId) {
        $http({
          method: 'GET',
          url: 'Invoice/GetDataForSuppInvoiceRowGrid',
          params: {
            invoiceId: invoiceId,
            orgPartId: orgPartId,
          },
        }).then(function successCallback(response) {
          if (response.data.Dto !== null) {
            vm.formModel.RestNet = response.data.Dto.RestNet;
            vm.formModel.RestVat = response.data.Dto.RestVat;
          } else {
            //TODO
            //console.log("Nincs visszatérő érték!");
          }
          vm.isProcUserOrgPart = !!response.data.isProcUser;
        });
      }

      function WAL() {
        switch (vm.activeSubItemTab) {
          case 0:
            walService.NavigateToWal('Invoice', 'SupplierInvoiceUnitSumWal', 'FlgInvoiceUnitSum');
            break;
          case 1:
            walService.NavigateToWal('Invoice', 'SupplierInvoiceRowWal', 'FlgInvoiceRowView');
            break;
          default:
            break;
        }
      }

      vm.saveButtonShow = saveButtonShow;
      vm.saveAppButtonShow = saveAppButtonShow;

      function saveButtonShow() {
        return vm.EditOrDuplicate == 'View';
      }

      function saveAppButtonShow() {
        return vm.EditOrDuplicate == 'View';
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SupplierInvUnitDevCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    '$uibModal',
    function($http, options, $state, $stateParams, $scope, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplierInvUnitDevCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.History = History;
      vm.attachDocument = attachDocument;
      console.log(vm.pageModel);
      console.log(vm.formModel);
      console.log(vm.controllerOptions);

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // modify pageModel to create an editable grid, it is neccesary to set the editable attribute of each column
      vm.modifiedGridFields = JSON.parse(vm.pageModel.Grids.GridInvoiceUnitSum.Fields);
      vm.modifiedGridFields.RowNum.editable = false;
      vm.modifiedGridFields.ModUser.editable = false;
      options.dto.UserName != null
        ? (vm.modifiedGridFields.ModUser.defaultValue = options.dto.UserName)
        : (vm.modifiedGridFields.ModUser.defaultValue = 'null');
      vm.modifiedGridFields.ModDate.editable = false;
      vm.modifiedGridFields = JSON.stringify(vm.modifiedGridFields);
      vm.pageModel.Grids.GridInvoiceUnitSum.Fields = vm.modifiedGridFields;

      vm.subGridIdField = vm.pageModel.Grids['GridInvoiceUnitSum'].IdColumn;
      vm.subGrid = $('#subGrid').data('kendoGrid');

      var invoiceId = options.dto.InvoiceId;
      vm.getInvoiceId = function() {
        return {
          targetInvoiceId: invoiceId,
        };
      };

      vm.subGridOptions = getGridOptions(
        options.pageModel.Grids.GridInvoiceUnitSum,
        'Invoice/InvoiceUnitSumList/',
        function() {},
        vm.getInvoiceId
      );

      // MAIN BUTTONS
      vm.back = function() {
        $state.go('Invoice.SupplierInvoiceEdit', { id: options.dto.InvoiceId });
      };

      // GRID BUTTONS
      vm.createSubItem = function createSubItem() {
        var subgrid = $('#subGrid').data('kendoGrid');
        var subgriddataSource = subgrid.dataSource;
        vm.totalUnitSumRecords = subgriddataSource.total();

        var newItem = subgriddataSource.insert(vm.totalUnitSumRecords, {});
        var newRow = subgriddataSource.data()[vm.totalUnitSumRecords];
        newRow.RowNum = vm.totalUnitSumRecords + 1;
        subgrid.editRow(newRow);
      };

      vm.editSubItem = function editSubItem() {
        var gridName = 'GridInvoiceUnitSum';
        var selectedItems = GetSelectedGridItems(vm.subGrid);
        var lfs = vm.getInvoiceId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = 'Invoice/SupplierInvUnitSumEdit/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Invoice/SupplierInvUnitSumEdit.html',
            controller: 'SupplierInvUnitSumEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      };

      vm.duplicateSubItem = function duplicateSubItem() {
        var gridName = 'GridInvoiceUnitSum';
        var lfs = vm.getInvoiceId();
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
      };

      vm.deleteSubItem = function deleteSubItem() {
        var gridName = 'GridInvoiceUnitSum';
        var urlPrefix = gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = gridName.substring(4);
        }
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                ////
                //$http.get("Contract/" + urlPrefix + "Delete/" + id)
                //    .success(function () {
                //        toastr.success(vm.messages.DeleteSuccessful);
                //        var gridRef = vm.grids[gridName];
                //        gridRef.dataSource.read();
                //    });
              },
            },
          },
        });
      };

      vm.save = function() {
        vm.formModel.Rows = [];
        var list = vm.subGrid.dataSource._data;
        for (var i = 0; i < list.length; i++) {
          vm.formModel.Rows.push(list[i]);
        }
        $http
          .post('Invoice/RentCorrectionInsert', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $state.go('Invoice.SupplierInvoiceEdit', { id: options.dto.InvoiceId });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      function getSelectedSubGridItem() {
        var gridName = 'GridInvoiceUnitSum';
        var gridRef = vm.subGrid;
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = 'GridInvoiceUnitSum';
        var item = getSelectedSubGridItem();
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }
      function attachDocument() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }

      function history() {
        // TODO -
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }
      //var x = document.getElementById('addgrid');
      //if (x.style.display === 'none') {
      //    x.style.display = 'block';
      //} else {
      //    x.style.display = 'none';
      //}
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SupplierInvUnitSumEditCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'EditOrDuplicate',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, fModel, EditOrDuplicate, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SupplierInvUnitSumEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = fModel.programId;
      vm.securedId = fModel.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = fModel.pageModel;
      vm.pageModelR = fModel.pageModelR;
      vm.formModel = fModel.dto;
      vm.selectedVatValue = vm.formModel.SelectedVatValue;

      vm.function;
      if ((!vm.formModel.UnitSumId || vm.formModel.UnitSumId === 0) && vm.EditOrDuplicate !== 'Duplicate') {
        vm.function = 'Create';
      } else {
        vm.function = EditOrDuplicate;
      }
      vm.pageModel.Fields.Net.FormlyFieldDescriptor.templateOptions.options.fieldFormat.format =
        '{0:n' + vm.formModel.CurrencyRounding + '}';
      vm.pageModel.Fields.Net.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals =
        vm.formModel.CurrencyRounding;
      vm.pageModel.Fields.Vat.FormlyFieldDescriptor.templateOptions.options.fieldFormat.format =
        '{0:n' + vm.formModel.CurrencyRounding + '}';
      vm.pageModel.Fields.Vat.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals =
        vm.formModel.CurrencyRounding;
      vm.pageModel.Fields.Gross.FormlyFieldDescriptor.templateOptions.options.fieldFormat.format =
        '{0:n' + vm.formModel.CurrencyRounding + '}';
      vm.pageModel.Fields.Gross.FormlyFieldDescriptor.templateOptions.options.fieldFormat.decimals =
        vm.formModel.CurrencyRounding;

      var customExpressionProperties = {
        ProcUser: {
          'templateOptions.disabled': function() {
            return vm.formModel.OrgPartId === 0;
          },
        },
        Net: {
          'templateOptions.required': function() {
            return true;
          },
        },
        Vat: {
          'templateOptions.required': function() {
            return true;
          },
        },
      };

      var syncValidators = {};

      var onChangeFunctions = {
        Net: function() {
          calculateValueFrom('net');
        },
        Vat: function() {
          calculateValueFrom('vat');
        },
        Gross: function() {
          calculateValueFrom('gross');
        },
        VatCode: function(selectedItem) {
          vm.selectedVatValue = selectedItem?.key
            ? parseFloat(selectedItem.extraProperties.find(x => x.key == 'Vat').value.replace(',', '.'))
            : 0;
          if (!!selectedItem && selectedItem.key !== '') {
            vm.formModel.VatCodeId = parseInt(selectedItem.extraProperties.find(x => x.key == 'VatCodeId').value);
          }
          calculateValueFrom(!!vm.formModel.Net || vm.formModel.Net === 0 ? 'net' : 'gross');
        },
        OrgPartId: function(selectedItem) {
          vm.pageModel.Fields.ProcUser.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            id: selectedItem.key,
          };
          vm.formModel.ProcUser = null;
          vm.pageModel.Fields.ProcUser.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertSyncValidators(vm.pageModel, syncValidators);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      var formlyFormRowPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModelR);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      vm.unitSumFields = formlyFormRowPanelDescriptors.PanelUnitSum.FormlyDescriptor;

      //combo parameters
      vm.pageModel.Fields.ProcUser.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        id: vm.formModel.OrgPartId,
      };

      vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        invoiceId: vm.formModel.InvoiceId,
      };

      vm.save = function() {
        $http
          .post('Invoice/SupplierInvUnitSum' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };

      var calculateValueFrom = function(from) {
        if (from === 'net') {
          vm.formModel.Net = roundByCurrency(vm.formModel.Net);
          vm.formModel.Vat = roundByCurrency(vm.formModel.Net * (vm.selectedVatValue / 100));
          vm.formModel.Gross = roundByCurrency(vm.formModel.Net + vm.formModel.Vat);
        } else if (from === 'vat') {
          vm.formModel.Vat = roundByCurrency(vm.formModel.Vat);
          vm.formModel.Net = roundByCurrency(vm.formModel.Net);
          vm.formModel.Gross = roundByCurrency(vm.formModel.Net + vm.formModel.Vat);
        } else if (from === 'gross') {
          vm.formModel.Net = roundByCurrency(vm.formModel.Gross / (1 + vm.selectedVatValue / 100));
          vm.formModel.Gross = roundByCurrency(vm.formModel.Gross);
          vm.formModel.Vat = roundByCurrency(vm.formModel.Gross - vm.formModel.Net);
        }
      };

      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.CurrencyRounding || 0));
      }

      function numericEditor(container, options) {
        $('<input data-bind="value:' + options.field + '"/>')
          .appendTo(container)
          .kendoNumericTextBox({
            decimals: vm.formModel.Rounding,
            format: options.format,
          });
      }

      function parseLocaleNumber(number) {
        if (!number) {
          number = 0;
        }
        var thousandSeparator = (1111).toLocaleString().replace(/1/g, '');
        var decimalSeparator = (1.1).toLocaleString().replace(/1/g, '');

        return Number(
          parseFloat(
            parseFloat(
              (number + '')
                .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
                .replace(new RegExp('\\' + decimalSeparator), '.')
            ).toFixed(vm.formModel.CurrencyRounding || 0)
          )
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TenancyDivisionCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$window',
    '$scope',
    'DasService',
    'LockService',
    'gridService',
    function($http, options, $state, $stateParams, $window, $scope, dasService, lockService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenancyDivisionCtrl', stateParams);
      }
      var vm = this;

      init($http, options, $state, $stateParams, $window, $scope, dasService, lockService);

      vm.back = function() {
        $state.go('Invoice.SupplierInvoiceEdit', {
          id: vm.invoiceId,
          openedPanelGroup: 'PGJovahagyasFelosztas',
        });
      };

      function init($http, options, $state, $stateParams, $window, $scope, dasService, lockService) {
        // vm.securedProgramId = options.programId;
        // vm.securedId = options.id;
        // Lock
        // This will spawn a modal what cannot be closed until the lock is done
        // lockService.initiateLock(vm.securedProgramId, vm.securedId);

        vm.formModel = options.dto;
        vm.pageModel = options.pageModel;

        vm.invoiceId = $stateParams.invoiceId;
        vm.formModel.InvoiceId = $stateParams.invoiceId;
        vm.formModel.InvoiceUnitSumId = $stateParams.id;

        vm.save = save;

        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        generateForm(vm);

        vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.FormlyFormPanelDescriptors.PanelInvoice.Model = {};
        vm.FormlyFormPanelDescriptors.PanelDetailsForm.Model = {};

        vm.selectedBudgetId = null;
        vm.selectedMeterId = null;

        vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          meterId: vm.formModel.MeterId,
        };

        vm.pageModel.Fields.MeterId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return 'ParentalMeterAreaId~isnull';
        };

        // additional parameter to dropdown custom controller
        vm.pageModel.Fields.OrgPartId.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return { id: vm.invoiceId };
        };

        vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          serviceId: null,
          invoiceId: vm.formModel.InvoiceId,
          orgPartId: vm.formModel.OrgPartId,
        };

        var onChangeFunctions = {
          DividedUp: function(selectedItem) {
            if (vm.formModel.DividedUp > vm.formModel.RestNet) {
              vm.formModel.DividedUp = vm.formModel.RestNet;
            }
            if (vm.VatPercent) {
              vm.formModel.VatAmount = roundByCurrency((vm.formModel.DividedUp * vm.VatPercent) / 100);
            }
          },
          AccountingFrom: function(selectedItem) {
            updateGrid(vm);
          },
          MeterId: function(selectedItem) {
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              meterId: selectedItem.Value,
            };
            //hogy az F2 setFirstElement lefusson:
            if (selectedItem.Value > 0) {
              vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.selectFirstElement();
            } else {
              vm.formModel.MeterId = { Value: null, Text: null };
              updateGrid(vm);
            }
          },
          BudgetId: function(selectedItem) {
            var budgetId = selectedItem?.BudgetId || 0;
            var budgetName = selectedItem?.Name;
            vm.selectedBudgetId = budgetId;
            updateGrid(vm);

            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              budgetId: vm.selectedBudgetId,
            };
          },
          ServiceId: function(selectedItem) {
            if (selectedItem) {
              var serviceId = selectedItem.ServiceId;
              vm.formModel.Object = selectedItem.ServiceName;
              vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                serviceId: serviceId,
                invoiceId: vm.formModel.InvoiceId,
                orgPartId: vm.formModel.OrgPartId,
              };
              //hogy az F2 setFirstElement lefusson:
              vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.selectFirstElement();
            }
          },
          VatCode: function(selectedItem) {
            vm.VatPercent = !!selectedItem ? selectedItem.Vat : 0;
            if (vm.VatPercent) {
              vm.formModel.VatAmount = roundByCurrency((vm.formModel.DividedUp * vm.VatPercent) / 100);
            }
          },
        };

        var syncValidators = {
          AccountFrom: {
            /**
             * @return {boolean}
             */
            ValidFromValidator: function(modelValue, viewValue) {
              if (!modelValue || !viewValue) {
                return true;
              }

              var AccountFromValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
              var AccountToValue = new moment(
                vm.formModel.AccountTo,
                kendo.culture().calendar.patterns.d.toUpperCase()
              );

              if (isNaN(AccountToValue)) {
                return true;
              }

              return AccountToValue.isSameOrAfter(AccountFromValue);
            },
          },
          AccountTo: {
            /**
             * @return {boolean}
             */
            ValidFromValidator: function(modelValue, viewValue) {
              if (!modelValue || !viewValue) {
                return true;
              }
              var AccountFromValue = new moment(
                vm.formModel.AccountFrom,
                kendo.culture().calendar.patterns.d.toUpperCase()
              );
              var AccountToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
              return AccountToValue.isSameOrAfter(AccountFromValue);
            },
          },
        };

        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertSyncValidators(vm.pageModel, syncValidators);

        // Grid
        vm.GridRentUnitGridOptions = [];
        vm.GridRentUnitGrid = null;
        vm.GridRentUnitGridIdField = null;

        vm.selectedItems = [];

        updateGrid(vm);
      }

      initGrid(
        function(grid) {
          vm.GridRentUnitGrid = grid;
        },
        function(gridIdField) {
          vm.GridRentUnitGridIdField = gridIdField;
        },
        function(gridOptions, grid) {
          vm.GridRentUnitGridOptions = gridOptions;
        },
        dataBoundTenancyDivision,
        'GridRentUnitGrid',
        '', // readUrl
        function(e) {
          // select function
        },
        null,
        function() {
          // detail init
        },
        null,
        true
      );

      function updateGrid(vm) {
        if (vm.GridRentUnitGrid) {
          vm.GridRentUnitGrid.dataSource.read();
        }
      }

      function select(row) {
        var vm = this;
        var data = row.dataItem;

        console.log(data);
      }

      function initGrid(
        setGridFn,
        setGridIdFieldFn,
        setGridOptionsFn,
        setDataBoundFunction,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';

        var idColumn = null;
        if (vm.pageModel.Grids[gridName]) {
          idColumn = vm.pageModel.Grids[gridName].IdColumn;
        }

        if (!idColumn) {
          debugger;
        }

        setGridIdFieldFn(idColumn);

        if (!readUrl || readUrl === '') {
          if (vm.pageModel.Grids[gridName].Table) {
            readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          }
        }

        if (!transportData) {
          transportData = {};
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        var grid = $('#' + mainGrid).data('kendoGrid');

        setGridFn(grid);

        vm.getTransportData = function() {
          return {
            meterId: vm.formModel.MeterId?.Value,
            budgetId: vm.selectedBudgetId,
            accountingFrom: vm.formModel.AccountingFrom,
          };
        };

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';

        var gridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign({}, vm.pageModel.Grids[gridName], {
            ControllerMethod: 'Invoice/TDRentUnitToInvoiceList',
          }),
          transportData: vm.getTransportData,
          selectFunction,
          dataBound: setDataBoundFunction,
          detailInit,
          multiselect: {
            idField: idColumn,
            selectHandler: function() {
              $scope.$applyAsync();
            },
            selectAllHandler: function() {
              $scope.$applyAsync();
            },
          },
        });

        setGridOptionsFn(gridOptions, mainGrid);
      }

      function dataBoundFnBase(e) {
        var rows = e.sender.content.find('tr');
        var indexColor = e.sender.wrapper.find('.k-grid-header [data-field=' + 'Color' + ']').index();
        if (indexColor > 0) {
          rows.each(function(index, row) {
            var dataItem = e.sender.dataItem(row);
            var fieldColor = $(row).children('td:eq(' + indexColor + ')');
            fieldColor.html(
              "<span style='background-color: #" + dataItem.Color.replace('#', '') + "; display: block'>&nbsp</span>"
            );
            //fieldColor.css("background", "#"+dataItem.Color.replace("#", ""));
          });
        }
      }

      function dataBoundTenancyDivision(e) {
        dataBoundFnBase(e);
      }

      function save() {
        console.log(vm.GridRentUnitGrid.selectedIds);
        console.log(vm.GridRentUnitGrid.selectedItems);
        console.log('save!');

        vm.formModel.RentUnitGridSelectedTenements = vm.GridRentUnitGrid.selectedIds;

        $http.post('Invoice/TenancyDivision', vm.formModel).then(function(result) {
          var dto = result.data.result;

          if (dto.Errors && dto.Errors.length > 0) {
            var errorMsg = dto.Errors[0].Message;
            toastr.error(errorMsg);
          } else {
            toastr.success('A felosztás sikeresen megtörtént!');
            vm.back();
          }
        });
      }

      function roundByCurrency(value) {
        return parseFloat(parseFloat(value).toFixed(vm.formModel.Rounding || 0));
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SuppInvoiceAppCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SuppInvoiceAppCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.InvoiceType = 'INTSU';
      vm.Modifyable = false;
      vm.activeSubItemTab = 0;
      vm.allCheck = false;

      vm.usedInvoiceGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.approveInvoice = approveInvoice;
      vm.rejectInvoice = rejectInvoice;
      vm.viewInvoice = viewInvoice;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = History;

      //Van-e kompetenciája a usernek:
      if (!vm.formModel.HasCompetence) {
        toastr.error('A felhasználó nem jóváhagyó, vagy nincs beállítva kompetenciaszint!');
        $state.go('main');
      }

      //lapfül mentés
      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      var onChangeFunctions = {
        Period: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.formModel.Period.Value = selectedItem ? selectedItem.Period : null;
          vm.checkedIds = [];
          vm.allCheck = false;
          vm.mainGrid.dataSource.read();
        },
        InvoiceType: function(selectedItem) {
          vm.checkedIds = [];
          vm.allCheck = false;
          vm.mainGrid.dataSource.read();
          //A látszó tabokon ürítem a gridet:
          var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
          angular.forEach(tabs, function(value, key) {
            vm.detailItemGrids[value].dataSource.data([]);
          });
        },
        PartnerId: function(selectedItem) {
          //Törölhető, ha az F2 időben beírja majd az értéket
          vm.formModel.PartnerId.Value = selectedItem ? selectedItem.PartnerId : null;
          vm.mainGrid.dataSource.read();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        InvoiceType: {
          'templateOptions.disabled': function() {
            return vm.InvoiceType === 'INTRM' || vm.InvoiceType === 'INTSU';
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      /**
       * @return {string}
       */
      vm.InvoiceTypeName = function() {
        if (vm.InvoiceType === 'INTRM') {
          return 'Bérleti díj számla';
        } else if (vm.InvoiceType === 'INTCU') {
          return 'Vevő számla';
        } else if (vm.InvoiceType === 'INTSU') {
          return 'Szállítói számla';
        } else if (vm.InvoiceType === 'INTCO') {
          return 'Óvadék/Biztosítás';
        } else if (vm.InvoiceType === 'INTCP') {
          return 'Bérbeszámítás';
        } else if (vm.InvoiceType === 'INTDI') {
          return 'Elidegenítés';
        }
        return '';
      };

      // Látható oszlopok beállítása
      function getColumnsByInvoiceType(invoiceType) {
        switch (invoiceType) {
          case 'INTSU':
            return {
              GridInvoice: [
                'InvoiceStatusName',
                'Period',
                'Invoice',
                'InvoiceDate',
                'Fulfilment',
                'PaymentDueDate',
                'PartnerCode',
                'PartnerName',
                'InvoiceAddress',
                'OriginalDoc',
                'Pay',
                'ControllSumma',
              ],
              GridInvoiceRow: [
                'RowNum',
                'Object',
                'Period',
                'AccountingFrom',
                'AccountingTo',
                'Quantity',
                'UnitCode',
                'UnitPrice',
                'Discount',
                'Net',
                'Vat',
                'VatAmount',
                'Gross',
                'OrgPartName',
                'TenementName',
              ],
              GridInvoiceUnitSum: [
                'RowNum',
                'OrgPartName',
                'Net',
                'VatCode',
                'Vat',
                'Gross',
                'ModUser',
                'ModDate',
                'TechFlag',
                'ProcUser',
              ],
              GridInvoiceApproval: ['Level', 'OrgPartName', 'AppUserName', 'AppDate', 'MaxAmount'],
            };
          default:
            return {
              GridInvoice: [
                'InvoiceStatusName',
                'Period',
                'Invoice',
                'InvoiceTypeName',
                'InvoiceDate',
                'Fulfilment',
                'PaymentDueDate',
                'Net',
                'Vat',
                'Gross',
                'PartnerCode',
                'PartnerName',
                'InvoiceAddress',
                'OriginalDoc',
                'Pay',
                'Contract',
                'RentEventNumber',
                'BundleId',
                'CashDeposit',
                'SettleAnInvoice',
              ],
              GridInvoiceRow: [
                'RowNum',
                'Tenement',
                'Object',
                'AccountingFrom',
                'AccountingTo',
                'Quantity',
                'UnitCode',
                'UnitPrice',
                'Discount',
                'Net',
                'Vat',
                'VatAmount',
                'Gross',
                'Period',
                'OrgPartName',
              ],
              GridInvoiceCorr: ['RowNum', 'Object', 'Gross'],
            };
        }
      }
      //Tab-Grid-Számlatípus összerendelés
      function getDetailGridAndTabByInvoiceType(invoiceType) {
        switch (invoiceType) {
          case 'INTSU':
            return {
              TabInvoiceRow: 'GridInvoiceRow',
              TabInvoiceUnitSum: 'GridInvoiceUnitSum',
              TabInvoiceApproval: 'GridInvoiceApproval',
            };
          default:
            return {
              TabInvoiceRow: 'GridInvoiceRow',
              TabInvoiceCorr: 'GridInvoiceCorr',
            };
        }
      }

      function setColumnVisible(invoiceType) {
        var columns = getColumnsByInvoiceType(invoiceType);
        angular.forEach(columns, function(value, key) {
          angular.forEach(vm.pageModel.Grids[key].Columns, function(valueC, keyC) {
            valueC.hidden = value.indexOf(valueC.field) === -1;
          });
          //sort:
          vm.pageModel.Grids[key].Columns.sort(function(a, b) {
            return columns[key].indexOf(a.field) - columns[key].indexOf(b.field);
          });
        });
      }

      setColumnVisible(vm.formModel.InvoiceType);

      vm.mainGridIdField = vm.pageModel.Grids['GridInvoice'].IdColumn;

      var getInvoiceFilter = function() {
        return (
          "InvoiceType~eq~'" +
          vm.formModel.InvoiceType +
          "'" +
          "~and~InvoiceStatus~eq~'INSCO'" +
          (vm.formModel.Period && vm.formModel.Period.Value !== null
            ? "~and~Period~eq~'" + vm.formModel.Period.Value + "'"
            : '') +
          (vm.formModel.PartnerId && vm.formModel.PartnerId.Value !== null
            ? "~and~PartnerId~eq~'" + vm.formModel.PartnerId.Value + "'"
            : '') +
          "~and~OrgPartId~neq~''"
        );
      };

      var getInvoiceDtoFilter = function() {
        return {
          invoiceType: vm.formModel.InvoiceType,
          period: vm.formModel.Period ? vm.formModel.Period.Value : null,
          partnerId: vm.formModel.PartnerId ? vm.formModel.PartnerId.Value : null,
        };
      };

      initMainGrid(
        vm,
        'GridInvoice',
        'Invoice/SuppInvoiceAppList/',
        function() {
          changeMainGridFilter(vm.mainGrid);
        },
        getInvoiceDtoFilter,
        false,
        getInvoiceFilter,
        null
      );

      vm.selectedMainGridItemId = 0;

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect
      ///////////////////////////////////////////////////////////////////////////////////////
      vm.toggleSelect = toggleSelect;
      vm.selectRow = selectRow;
      vm.selectAllTip = 'Összes';
      vm.checkedIds = [];

      var checkboxColumn = {
        field: 'checkAll',
        title: 'Összes kijelölése',
        filterable: false,
        sortable: false,
        pageable: false,
        menu: false,
        resizable: false,
        headerTemplate:
          "<input type='checkbox' ng-model='vm.allCheck' ng-click='vm.toggleSelect($event)' title='{{vm.selectAllTip}}' />",
        template:
          "<input type='checkbox' class='checkbox' ng-model='dataItem.checked' ng-click='vm.selectRow($event, this)'/>",
        width: '48px',
        lockable: false,
      };
      vm.mainGridOptions.columns.splice(0, 0, checkboxColumn);
      vm.mainGridOptions.dataBound = function() {
        refreshCheckbox(this);
      };
      //vm.mainGridOptions.dataSource.schema.model.Id = vm.mainGridIdField;

      vm.mainGridOptions.dataBound = function(e) {
        var grid = this;
        //Checked selected row;
        var items = e.sender.items();
        var gridPage = e.sender;
        items.each(function(index) {
          var dataItem = gridPage.dataItem(this);
          dataItem.checked = vm.checkedIds.indexOf(dataItem.InvoiceId) !== -1;
        });

        $scope.$applyAsync();
      };

      function manageSelectedIdArray(id, add) {
        if (add) vm.checkedIds.push(id);
        else
          vm.checkedIds = vm.checkedIds.filter(function(e) {
            return e !== id;
          });
      }

      function getAllIdFromFIC() {
        var filterString = '';
        if (vm.mainGrid.dataSource.filter() !== undefined) {
          var filters = vm.mainGrid.dataSource.filter().filters;
          if (!!filters[0].field) {
            for (var i = 0; i < filters.length; i++) {
              filterString += filters[i].field;
              filterString += '~';
              filterString += filters[i].operator;
              filterString += '~';
              filterString += "'" + filters[i].value + "'";
              if (i != filters.length - 1) {
                filterString += '~and~';
              }
            }
          }
        }
        $http
          .post('Invoice/SuppInvoiceAppList', {
            page: 1,
            pageSize: 0,
            sort: '',
            group: '',
            filter: filterString,
            aggregates: '',
            InvoiceType: vm.formModel.InvoiceType,
            PartnerId: vm.formModel.PartnerId.Value,
            Period: vm.formModel.Period.Value,
          })
          .then(function(response) {
            vm.checkedIds = _.map(response.data.Data, vm.pageModel.Grids['GridInvoice'].IdColumn);
            refreshCheckbox(vm.mainGrid);
          });
      }

      function toggleSelect(event) {
        var checked = event.target.checked;
        vm.checkedIds = [];
        if (vm.mainGrid.dataSource.total() > 0) {
          if (!checked) {
            vm.selectAllTip = 'Összes';
            refreshCheckbox(vm.mainGrid);
          } else {
            vm.selectAllTip = 'Egy sem';
            getAllIdFromFIC();
          }
        }
      }

      function selectRow(event, item) {
        var checked = event.target.checked;
        var dataItem = item.dataItem;
        manageSelectedIdArray(dataItem.InvoiceId, checked);
      }

      function refreshCheckbox(grid) {
        var view = vm.mainGrid.dataSource.view();
        angular.forEach(view, function(value, key) {
          value.checked = vm.checkedIds.indexOf(value.InvoiceId) !== -1;
        });
      }

      function getSelectedIDs() {
        var row = vm.selectedItems;
        if (!row || row.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        var ids = [];
        angular.forEach(vm.selectedItems, function(value, key) {
          ids.push(value[vm.mainGridIdField]);
        });
        return ids;
      }

      ///////////////////////////////////////////////////////////////////////////////////////
      // Grid multiselect end
      ///////////////////////////////////////////////////////////////////////////////////////

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          targetInvoiceId: vm.selectedMainGridItemId,
        };
      };

      vm.selectedContractId = 0;
      vm.getSelectedContractId = function() {
        return {
          contractId: vm.selectedContractId,
        };
      };

      // Kendo-grid reference for sub GRIDs

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelInvoiceRow', 'PanelInvoiceCorr', 'PanelInvoiceUnitSum', 'PanelInvoiceApproval'],
        function(gridModel) {
          if (gridModel.Name === 'GridInvoiceRow') {
            gridModel.ControllerMethod = 'Invoice/InvoiceRowForSuppInvoiceAppList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoiceCorr') {
            gridModel.ControllerMethod = 'Invoice/InvoiceCorrList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoiceUnitSum') {
            gridModel.ControllerMethod = 'Invoice/InvoiceUnitSumList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }
          if (gridModel.Name === 'GridInvoiceApproval') {
            gridModel.ControllerMethod = 'Invoice/InvoiceApprovalList/';

            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          }

          return null;
        }
      );
      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      vm.filterTab = function(item) {
        var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
        var retVal = tabs[item.key] !== undefined;
        return retVal;
      };

      vm.pageModel.Fields.InvoiceType.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        invoiceType: vm.InvoiceType,
      };

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) {
          // ha nincs kijelölt elem, akkor töröljük az Id-t
          vm.selectedMainGridItemId = 0;
          $scope.$applyAsync();
          return;
        }

        vm.Modifyable = selectedItems[0].InvoiceStatus === 'INSOP';

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.selectedContractId = selectedItems[0]['ContractId'];
        //$scope.$apply();

        //Csak a látszó tabokon frissítem a gridet:
        var tabs = getDetailGridAndTabByInvoiceType(vm.formModel.InvoiceType);
        angular.forEach(tabs, function(value, key) {
          if (!!vm.detailItemGrids[value]) {
            vm.detailItemGrids[value].dataSource.read();
          }
        });
        $scope.$applyAsync();
      }

      var filteredRows = [];

      var refreshAllGrids = function() {
        vm.mainGrid.dataSource.read();
        for (let i = 0; i < vm.detailItemGrids.length; i++) {
          var gridName = vm.detailItemGrids[i];
          var grid = vm.detailItemGrids[gridName];
          if (!!grid && !!grid.dataSource) {
            var dataSource = grid.dataSource;
            dataSource.read();
          }
        }
      };

      function approveInvoice() {
        //var selectedItems = getSelectedIDs();
        var selectedItems = vm.checkedIds;
        if (selectedItems !== false) {
          $http
            .get('Invoice/ApproveSuppInvoice', {
              params: { invoiceIds: selectedItems },
            })
            .then(function() {
              toastr.success('Számla jóváhagyás sikeres!');
              vm.checkedIds = [];
              refreshAllGrids();
            });
        }
      }

      function rejectInvoice() {
        var selectedItems = vm.checkedIds;
        if (selectedItems !== false) {
          // open modal
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Invoice/SuppInvoiceReject.html',
            controller: 'SuppInvoiceRejectCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              model: RouteResolveFunc('Invoice/GetRejectSuppInvoiceModal', { invoiceIds: selectedItems }),
            },
            backdrop: 'static',
          });

          modalInstance.result
            .then(function() {
              toastr.success('A kijelölt számlák visszautasításra kerültek!');
              vm.checkedIds = [];
              refreshAllGrids();
            })
            .catch(function() {});
        }
      }

      function viewInvoice() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          if (vm.InvoiceType === 'INTRM') {
            $state.go(vm.module + '.RentAccountView', { id: id });
          } else if (vm.InvoiceType === 'INTCU') {
            $state.go(vm.module + '.RentAccountView', { id: id });
          } else if (vm.InvoiceType === 'INTSU') {
            $state.go(vm.module + '.SupplierInvoiceAppView', { id: id, buttons: false });
          }
        }
      }

      vm.back = function() {
        var backTo = $state.current.params.BackTo;
        $state.go(!backTo || backTo === '' ? 'main' : backTo);
      };

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Invoice.DasDocumentsNav', 'FlgInvoice', id);
      }

      function WAL(usedGrid) {
        switch (usedGrid) {
          case vm.usedInvoiceGridEnum.MAIN:
            walService.NavigateToWal('Invoice', 'SupplierInvoiceWal', 'FlgInvoiceView');
            break;
          case vm.usedInvoiceGridEnum.SUB:
            switch (vm.activeSubItemTab) {
              case 0: // Számla tételek
                walService.NavigateToWal('Invoice', 'SupplierInvoiceRowWal', 'FlgInvoiceRowView');
                break;
              case 1: // Szervezetekre jutó rész
                walService.NavigateToWal('Invoice', 'SupplierInvoiceUnitSumWal', 'FlgInvoiceUnitSumView');
                break;
              case 2: // Jóváhagyások
                walService.NavigateToWal('Invoice', 'SupplierInvoiceApprovalWal', 'FlgInvoiceApprovalView');
                break;
            }
            break;
          default:
            break;
        }
      }

      function History() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = selectedItems[0][vm.mainGridIdField];
        HistoryService.NavigateToHistory('FlgInvoice', id, vm, $state);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SuppInvoiceRejectCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, model, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SuppInvoiceRejectCtrl', stateParams);
      }
      var vm = this;
      vm.formModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.invoiceIds = model.invoiceIds;

      vm.cancel = cancel;
      vm.save = save;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelInvoiceReject.FormlyDescriptor;

      initMainGrid(
        vm,
        'GridApprovedInvoiceList',
        'Invoice/ApprovedInvoiceList/',
        function() {
          //changeMainGridFilter(vm.mainGrid);
        },
        function() {
          return {
            invoiceIds: vm.formModel.InvoiceIds,
          };
        },
        false,
        null,
        null
      );

      function cancel() {
        uibModalInstance.dismiss();
      }

      function save() {
        $http
          .post('Invoice/RejectSuppInvoice', { invoiceIds: vm.formModel.InvoiceIds, comment: vm.formModel.Comment })
          .then(function() {
            uibModalInstance.close();
          });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('SuppInvoiceRowEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    '$q',
    'InvoiceValuesCalculatorService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $scope,
      dasService,
      lockService,
      UIHelperService,
      $q,
      InvoiceValuesCalculatorService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SuppInvoiceRowEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = options.dto;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.EditOrDuplicate = $stateParams.EditOrDuplicate;
      vm.UIHelperService = UIHelperService;
      vm.fieldsDisabledState = [];
      vm.function;

      InvoiceValuesCalculatorService.setModel(vm.formModel);
      InvoiceValuesCalculatorService.setCurrentRound(vm.formModel.Rounding);

      if (!vm.formModel.InvoiceRowId) {
        vm.function = 'Create';
      } else {
        vm.function = vm.EditOrDuplicate;
      }
      vm.attachDocument = attachDocument;

      if (vm.formModel.HasERP) {
        vm.pageModel.Fields.Object.MaxLength = 70;
      }

      var setPropertyFilter = function() {
        return {
          invoiceId: vm.formModel.InvoiceId,
          zoneId: vm.formModel.ZoneId,
          opUnitId: vm.formModel.OpUnitId,
          meterId: vm.formModel.MeterId?.Value,
        };
      };

      $scope.$watch('vm.formModel.BudgetId.Value', function(newValue, oldValue) {
        if (
          (oldValue || newValue) &&
          angular.isFunction(vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue)
        )
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
            vm.formModel.ServiceId.Value || ''
          );
      });

      var onChangeFunctions = {
        ZoneId: function(selectedItem) {
          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = setPropertyFilter();
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        OpUnitId: function(selectedItem) {
          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = setPropertyFilter();
        },
        PropertyId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.BudgetId && !vm.formModel.BudgetId?.Value) {
            vm.formModel.BudgetId = { Value: selectedItem.BudgetId, Text: null };
          }
        },
        BudgetId: function(selectedItem) {
          if (
            !!selectedItem &&
            selectedItem.PropertyId > 0 &&
            (!vm.formModel.PropertyId || !vm.formModel.PropertyId.Value)
          ) {
            vm.formModel.PropertyId = { Value: selectedItem.PropertyId, Text: null };
          }
        },
        ServiceId: function(selectedItem) {
          if (!!selectedItem.GridItem) {
            if (!vm.formModel.BudgetId.Value) {
              vm.formModel.BudgetId.Value = selectedItem.GridItem.BudgetId;
            }
            vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              serviceId: selectedItem.GridItem.ServiceId,
              invoiceId: vm.formModel.InvoiceId,
              orgPartId: vm.formModel.OrgPartId,
              unitSumId: $stateParams.unitSumId,
            };
            $http({
              method: 'GET',
              url: 'Invoice/GetDataForSuppInvoiceRow',
              params: {
                invoiceId: vm.formModel.InvoiceId,
                serviceId: selectedItem.GridItem.ServiceId,
                budgetId: selectedItem.GridItem.BudgetId,
                orgPartId: vm.formModel.OrgPartId,
              },
            }).then(function successCallback(response) {
              if (response.data.Dto !== null) {
                vm.formModel.OpUnitId = response.data.Dto.OpUnitId;
                vm.formModel.UnitId = { Value: response.data.Dto.UnitId, Text: null };
                vm.formModel.Object = vm.formModel.INOBGE ? response.data.Dto.Object : null;
                //hogy az F2 setFirstElement lefusson:
                vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.selectFirstElement();
              } else {
                //TODO
                //console.log("Nincs visszatérő érték!");
              }
            });
          } else {
            if (!selectedItem.Value) {
              vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
                serviceId: null,
                invoiceId: vm.formModel.InvoiceId,
                orgPartId: vm.formModel.OrgPartId,
                vatCode: $stateParams.vatCode,
              };
              vm.formModel.VatCode = { Value: null, Text: null };
            }
          }
        },
        UnitPrice: function(selectedItem) {
          vm.formModel.BaseUnitPrice = vm.formModel.UnitPrice;
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.UnitPrice > 0);
          toggleField('Gross', vm.formModel.UnitPrice > 0);
        },
        GrossUnitPrice: function(selectedItem) {
          vm.formModel.BaseGrossUnitPrice = vm.formModel.GrossUnitPrice;
          InvoiceValuesCalculatorService.CalcFromBaseUnitPrice();
          toggleField('Net', vm.formModel.UnitPrice > 0);
          toggleField('Gross', vm.formModel.UnitPrice > 0);
        },
        Gross: function(selectedItem) {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('GrossUnitPrice', vm.formModel.Gross > 0);
          toggleField('Net', vm.formModel.Gross > 0 && vm.formModel.UnitPrice > 0);
        },
        VatCode: function(selectedItem) {
          if (!vm.formModel.VatCode || !vm.formModel.VatCode.Value || (!!selectedItem && !!selectedItem._events)) {
            vm.formModel.Vat = !!selectedItem ? selectedItem.Vat : 0;
            InvoiceValuesCalculatorService.ReCalc();
          }
        },
        Quantity: function(selectedItem) {
          InvoiceValuesCalculatorService.ReCalc();
        },
        Net: function(selectedItem) {
          InvoiceValuesCalculatorService.CalcFromTotalAmount();
          toggleField('UnitPrice', vm.formModel.Net > 0);
          toggleField('Gross', vm.formModel.Net > 0 && vm.formModel.UnitPrice > 0);
        },
        MeterId: function(selectedItem) {
          vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = setPropertyFilter();
          if (!!selectedItem.GridItem && !vm.formModel.PropertyId?.Value) {
            $http({
              method: 'GET',
              url: 'Invoice/GetPropertyAndBudgetData',
              params: {
                invoiceId: vm.formModel.InvoiceId,
                meterId: vm.formModel.MeterId.Value,
              },
            }).then(function successCallback(response) {
              if (response.data.Dto.BudgetId) {
                vm.formModel.BudgetId = { Value: response.data.Dto.BudgetId, Text: null };
              }

              if (!!response.data.Dto.PropertyId) {
                vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.selectFirstElement();
              }
            });
          } else {
            if (!selectedItem.Value) {
              vm.formModel.NotCons = false;
            }
          }
        },
        CalcMode: function(selectedItem) {
          vm.formModel.VatAmount = null;
          vm.formModel.UnitPrice = null;
          vm.formModel.GrossUnitPrice = null;
          vm.formModel.Net = null;
          vm.formModel.Gross = null;
          vm.formModel.BaseUnitPrice = null;
          vm.formModel.BaseGrossUnitPrice = null;

          toggleField('UnitPrice', false);
          toggleField('GrossUnitPrice', false);
          toggleField('Net', false);
          toggleField('Gross', false);
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var onBlurFunctions = {};
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var customExpressionProperties = {
        AccountingTo: {
          'templateOptions.required': function() {
            //TODO: itt kötelezővé kellene tenni, ha a meterId ki van töltve, de a dátum mező ha megbukik a validáción, akkor a modelbe undefined kerül, így nem vizsgálható az érték!
            return vm.formModel.AccountingFrom !== null;
          },
        },
        AccountingFrom: {
          'templateOptions.required': function() {
            //TODO: itt kötelezővé kellene tenni, ha a meterId ki van töltve, de a dátum mező ha megbukik a validáción, akkor a modelbe undefined kerül, így nem vizsgálható az érték!
            return vm.formModel.AccountingTo !== null || (!!vm.formModel.MeterId && !!vm.formModel.MeterId.Value);
          },
        },
        NotCons: {
          'templateOptions.disabled': function() {
            return !vm.formModel.MeterId || !vm.formModel.MeterId.Value;
          },
        },
        Net: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 1 ||
              vm.fieldsDisabledState['Net'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        Gross: {
          'templateOptions.disabled': function() {
            return (
              vm.formModel.CalcMode == 0 ||
              vm.fieldsDisabledState['Gross'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        UnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['UnitPrice'] || (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
        GrossUnitPrice: {
          'templateOptions.disabled': function() {
            return (
              vm.fieldsDisabledState['GrossUnitPrice'] ||
              (!!vm.formModel.ServiceId && vm.formModel.ServiceId.Value === null)
            );
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var syncValidators = {
        UnitPrice: {
          /**
           * @return {boolean}
           */
          UnitPriceValidator: function(modelValue, value) {
            return value > 0;
          },
        },
        NotCons: {
          NotConsValidator: function(modelValue) {
            return !modelValue || (modelValue && !!vm.formModel.MeterId && !!vm.formModel.MeterId.Value);
          },
        },
        AccountingTo: {
          AccountingToValidator: function(modelValue) {
            var AccountingToValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var AccountingFromValue = new moment(
              vm.formModel.AccountingFrom,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );
            return modelValue === null || AccountingToValue.isSameOrAfter(AccountingFromValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      var dynamicQueryParameters = {
        BudgetId: {
          invoiceId: function() {
            return vm.formModel.InvoiceId;
          },
          propertyId: function() {
            return vm.formModel.PropertyId.Value;
          },
          opUnitId: function() {
            return vm.formModel.OpUnitId;
          },
        },
        OpUnitId: {
          zoneId: function() {
            return vm.formModel.ZoneId;
          },
        },
      };
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      var hideExpressions = {
        GrossUnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 0;
        },
        UnitPrice: function($viewValue, $modelValue, scope) {
          return vm.formModel.CalcMode == 1;
        },
      };

      InsertHideExpressions(vm.pageModel, hideExpressions);

      vm.pageModel.Fields.AccountingTo.FormlyFieldDescriptor.templateOptions.requied = true;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = vm.FormlyFormPanelDescriptors.PanelForm.FormlyDescriptor;
      vm.pageModel.Fields.AccountingTo.FormlyFieldDescriptor.templateOptions.requied = true;

      //F2/F22 where conditions
      vm.pageModel.Fields.VatCode.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        serviceId: !!vm.formModel.ServiceId ? vm.formModel.ServiceId.Value : 0,
        invoiceId: vm.formModel.InvoiceId,
        orgPartId: vm.formModel.OrgPartId,
      };
      vm.pageModel.Fields.MeterId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        if (!!vm.formModel.OpUnitId)
          return 'ParentalMeterAreaId~isnull~and~ValidTo~isnull~and~OpUnitId~eq~' + vm.formModel.OpUnitId;
        if (!!vm.formModel.ZoneId)
          return 'ParentalMeterAreaId~isnull~and~ValidTo~isnull~and~ZoneId~eq~' + vm.formModel.ZoneId;
        return 'ParentalMeterAreaId~isnull~and~ValidTo~isnull';
      };
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        if (!!vm.formModel.BudgetId && vm.formModel.BudgetId.Value > 0) {
          return 'Name~isnotnull~and~BudgetId~eq~' + vm.formModel.BudgetId.Value;
        } else {
          return 'Name~isnotnull';
        }
      };

      var toggleField = function(_field, _bool) {
        vm.fieldsDisabledState[_field] = _bool;
      };

      //letiltom előtöltésnél a net, gross mezőt
      toggleField('Net', vm.formModel.UnitPrice > 0);
      toggleField('Gross', vm.formModel.UnitPrice > 0);

      vm.save = function() {
        vm.formModel.BaseUnitPrice = vm.formModel.UnitPrice;
        vm.formModel.BaseGrossUnitPrice = vm.formModel.GrossUnitPrice;
        var defer = $q.defer();
        vm.formModel.DeletePrevValueInMeterReading = null;
        if (vm.formModel.InvoiceRowId == 0 && !!vm.formModel.MeterId && !!vm.formModel.MeterId.Value) {
          getMeterReadExistAndSave(defer);
        } else {
          saveRow(defer);
        }
        return defer.promise;
      };

      var getMeterReadExistAndSave = function(defer) {
        if (!vm.formModel.NotCons) {
          $http({
            method: 'GET',
            url: 'Invoice/GetMeterReadingRowIsExists',
            params: {
              invoiceId: vm.formModel.InvoiceId,
              readingDate: vm.formModel.AccountingTo,
              meterId: vm.formModel.MeterId.Value,
            },
          }).then(function successCallback(response) {
            if (!!response.data.Dto.Period) {
              bootbox.dialog({
                message:
                  'A leolvasás adatokban van már tétel a  ' +
                  response.data.Dto.Period +
                  ' időszak ' +
                  vm.formModel.AccountingTo +
                  ' leolvasás dátumra! Töröljük? ',
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: 'Nem', //vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {
                      vm.formModel.DeletePrevValueInMeterReading = false;
                      saveRow(defer);
                    },
                  },
                  confirm: {
                    label: 'Igen', //vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      vm.formModel.DeletePrevValueInMeterReading = true;
                      saveRow(defer);
                    },
                  },
                },
              });
            } else {
              saveRow(defer);
            }
          });
        } else {
          saveRow(defer);
        }
      };

      var saveRow = function(defer) {
        $http
          .post('Invoice/SuppInvoiceRow' + vm.function, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (response.data.Message) {
              toastr.warning(response.data.Message);
            }
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Invoice.SupplierInvoiceEdit', {
              id: vm.formModel.InvoiceId,
              openedPanelGroup: 'PGJovahagyasFelosztas',
            });
            //defer.resolve();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Invoice.SupplierInvoiceEdit', { id: vm.formModel.InvoiceId, openedPanelGroup: 'PGHeader' });
      };

      function attachDocument() {
        var id = vm.formModel.InvoiceRowId;
        dasService.NavigateToDas(vm.messages, 'Invoice.DasDocumentsNav', 'FlgInvoiceRow', id);
      }

      function roundByCurrency(value, precision) {
        return parseFloat(parseFloat(value).toFixed(!!precision ? precision : vm.formModel.Rounding || 0));
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceGenCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    function(mi, $http, model, $stateParams, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceGenCtrl', stateParams);
      }
      var vm = this;
      if (!!model.dto.PartnerId?.Value && !!model.dto.ContractId?.Value) {
        model.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.disabled = true;
        model.pageModel.Fields.ContractId.FormlyFieldDescriptor.templateOptions.disabled = true;
      }

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;

      var onChangeFunctions = {
        ContractId: function(selectedItem) {
          if (!!selectedItem) {
            if (vm.formModel.PartnerId.Value !== selectedItem.TenantPartId) {
              vm.formModel.PartnerId = selectedItem.TenantPartId;
            }
            vm.formModel.Payment = selectedItem.Payment;
            getVatamount();
          }
        },
        ServiceId: function(selectedItem) {
          vm.formModel.ServiceId.Value = selectedItem.ServiceId;
          getVatamount();
        },
        InvoicePad: function(selectedItem) {
          getVatamount();
        },
      };

      var dynamicQueryParameters = {
        ContractId: function() {
          var partnerId = vm.formModel.PartnerId.Value === null ? 0 : vm.formModel.PartnerId.Value;
          return [
            {
              key: partnerId,
              text: 'partnerId',
            },
          ];
        },
        ServiceId: function() {
          return [
            {
              key: vm.formModel.InvoiceRowId,
              text: 'invoiceRowId',
            },
          ];
        },
      };

      var syncValidators = {
        PaymentDueDate: {
          PaymentDueDateValidator: function(modelValue) {
            var paymentDueDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoiceDateValue = new moment(
              vm.formModel.InvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            return paymentDueDateValue.isSameOrAfter(invoiceDateValue);
          },
        },
        Fulfilment: {
          FulfilmentDateValidator: function(modelValue) {
            var fulfilmentValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoiceDateValue = new moment(
              vm.formModel.InvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            return fulfilmentValue.isSameOrBefore(invoiceDateValue);
          },
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      InsertSyncValidators(vm.pageModel, syncValidators);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.Panelgen.FormlyDescriptor;
      vm.gen = function() {
        $http
          .post('Invoice/InvoiceGen', vm.formModel)
          .then(function(response) {
            if (!!response.statusText) {
              toastr.success(response.statusText);
            } else {
              toastr.success(vm.pageModel.Messages.GenerateSuccessful);
            }
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close();
      };

      var getVatamount = function() {
        if (
          !!vm.formModel.ContractId.Value &&
          !!vm.formModel.ServiceId.Value &&
          vm.formModel.InvoicePad != null &&
          vm.formModel.InvoicePad != ''
        ) {
          $http({
            method: 'GET',
            url: 'Invoice/GetVatamount',
            params: {
              serviceId: vm.formModel.ServiceId.Value,
              contractId: vm.formModel.ContractId.Value,
              invoicePad: vm.formModel.InvoicePad,
            },
          }).then(function successCallback(response) {
            vm.formModel.Vatamount = response.data.Dto.Vatamount;
          });
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PartnerAccountBalanceCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    function(mi, $http, model, $stateParams, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PartnerAccountBalanceCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelInfo.FormlyDescriptor;

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceImportCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'FileUploadService',
    '$uibModal',
    function(mi, $http, model, $stateParams, AuthService, fus, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceImportCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;

      var eventHandlers = {
        FileName: {
          onError: function() {},
          onSuccess: function() {},
          onComplete: function() {},
        },
      };
      InsertEventHandlers(vm.pageModel, eventHandlers);

      vm.pageModel.Fields.FileName.FormlyFieldDescriptor.templateOptions.accept = '.xlsx';
      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelInvoiceImport.FormlyDescriptor;

      vm.save = function() {
        //if (!vm.formModel.FileName) return;
        var model = angular.copy(vm.formModel);
        model.FileName = vm.formModel.FileName.getFile();
        var msg = toastr.warning(vm.pageModel.Labels.LabelCheckWait.Title, vm.pageModel.Labels.LabelWait.Title, {
          timeOut: '0',
          extendedTimeOut: '0',
        });
        fus
          .postWithFile('Invoice/InvoiceImportFromXls', model)
          .then(function(response) {
            msg.remove();

            if (response.data.FormatErrorList.length > 0) {
              // open modal
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Invoice/InvoiceImportFormatErrorModal.html',
                controller: 'InvoiceImportFormatErrorModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  fModel: {
                    data: response.data.FormatErrorList,
                    grid: vm.pageModel.Grids.GridFormatError,
                    labels: vm.pageModel.Labels,
                    actions: vm.pageModel.Actions,
                  },
                },
                backdrop: 'static',
              });
              modalInstance.result.then(function() {});
              mi.close();
            } else if (response.data.DataErrorList.length > 0) {
              // open modal
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Invoice/InvoiceImportDataErrorModal.html',
                controller: 'InvoiceImportDataErrorModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  fModel: {
                    data: response.data.DataErrorList,
                    grid: vm.pageModel.Grids.GridDataError,
                    labels: vm.pageModel.Labels,
                    actions: vm.pageModel.Actions,
                  },
                },
                backdrop: 'static',
              });
              modalInstance.result.then(function() {});
              mi.close();
            } else if (response.data.SuccessList.length > 0) {
              // open modal
              var modalInstance = $uibModal.open({
                templateUrl: 'App/Invoice/InvoiceImportSuccessModal.html',
                controller: 'InvoiceImportSuccessModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  fModel: {
                    data: response.data.SuccessList,
                    grid: vm.pageModel.Grids.GridSuccess,
                    labels: vm.pageModel.Labels,
                    actions: vm.pageModel.Actions,
                  },
                },
                backdrop: 'static',
              });
              modalInstance.result.then(function() {});
              mi.close();
            }
          })
          .catch(function() {
            msg.remove();
          });
      };

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceImportFormatErrorModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceImportFormatErrorModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grid;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.labels = fModel.labels;
      vm.actions = fModel.actions;

      vm.row = fModel.data;
      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceImportDataErrorModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceImportDataErrorModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grid;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.labels = fModel.labels;
      vm.actions = fModel.actions;

      vm.row = fModel.data;
      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceImportSuccessModalCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceImportSuccessModalCtrl', stateParams);
      }
      var vm = this;
      vm.resultGridOptions = new kendo.data.DataSource({ data: [], pageSize: 20, page: 1 });
      vm.gridModel = fModel.grid;
      vm.resultGrid = $('#resultGrid').data('kendoGrid');
      vm.cancel = cancel;
      vm.exportExcel = exportExcel;
      vm.labels = fModel.labels;
      vm.actions = fModel.actions;

      vm.row = fModel.data;
      var resultGridOptions = getGridOptions(vm.gridModel, '', function() {}, vm.dump);
      resultGridOptions.dataSource = new kendo.data.DataSource({ data: vm.row, pageSize: 20, page: 1 });
      resultGridOptions.gridstates = { all: false, filter: false };
      vm.resultGridOptions = angular.copy(resultGridOptions);

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceExportCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'FileSaver',
    function(mi, $http, model, $stateParams, AuthService, FileSaver) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceExportCtrl', stateParams);
      }
      var vm = this;

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelInvoiceExport.FormlyDescriptor;

      vm.save = function() {
        var msg = toastr.warning(vm.pageModel.Labels.LabelCheckWait.Title, vm.pageModel.Labels.LabelWait.Title, {
          timeOut: '0',
          extendedTimeOut: '0',
        });

        $http
          .post('Invoice/InvoiceExportToXls', vm.formModel)
          .then(function(response) {
            var data = response.data.FileContent;

            if (!response.data.ResultStatus || !data) {
              toastr.error(response.data.Errors[0].Message, 'Sikertelen generálás!');
              return false;
            }
            msg.remove();
            saveFileAs(data, response.data.FileName);
            toastr.success('Sikeres generálás!');
            mi.close();
          })
          .catch(function(response) {
            msg.remove();
            toastr.error('Sikertelen generálás!');
          });
      };

      function saveFileAs(data, fileName) {
        var raw = window.atob(data);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var fs = new Blob([array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(fs, fileName);
      }

      vm.cancel = function() {
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

function TileMenuController($scope, $location) {
  $scope.isActive = function(viewLocation) {
    return viewLocation === $location.path();
  };
}

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      FLGRDocument: {
        url: '/flgrdocument',
        templateUrl: 'App/FLGRDocument/DocumentLayout.html',
        controller: 'FLGRDocumentLayoutCtrl as vm',
        redirectTo: 'FLGRDocument.Nav',
        ncyBreadcrumb: {
          label: 'Dokumentumok modul',
          parent: 'main',
        },
      },
      'FLGRDocument.Nav': {
        url: '/nav/{entity:string}/{id:string}',
        params: {
          module: 'flgrdocument',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'FLGRDocumentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/FLGRDocument/DocumentNav.html',
            controller: 'FLGRDocumentNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('FLGRDocument/DocumentNavOptions/', undefined, ['entity', 'id']),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum navigáció',
        },
      },
      'FLGRDocument.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'FLGRDocumentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'FLGRDocument.Upload': {
        url: '/upload',
        params: { module: 'flgrdocument' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'FLGRDocumentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/FLGRDocument/DocumentUpload.html',
            controller: 'FLGRDocumentUploadCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('FLGRDocument/DocumentUploadOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum feltöltés',
        },
      },
      'FLGRDocument.Edit': {
        url: '/edit',
        params: { module: 'flgrdocument' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'FLGRDocumentMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Document/DocumentEdit.html',
            controller: 'FLGRDocumentEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('FLGRDocument/DocumentEdit/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum feltöltés',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Document");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('FLGRDocumentNavCtrl', [
    '$scope',
    '$http',
    '$state',
    'options',
    '$filter',
    'AuthService',
    '$uibModal',
    'WalService',
    function($scope, $http, $state, options, $filter, authService, $uibModal, walService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FLGRDocumentNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.back = function() {
        $state.go('main');
      };

      if (!!$state.previous.name && $state.previous.name !== '') {
        vm.back = function() {
          $state.go($state.previous.name);
        };
        if (!!$state.params.id) {
          vm.back = function() {
            $state.go($state.previous.name, { id: $state.params.id });
          };
        }
      }

      var entityId = vm.formModel.EntityId;

      vm.getEntityId = function() {
        return {
          entityId: entityId,
        };
      };

      vm.selectedMainGridItemId = 0;

      vm.getSelectedMainGridItem = function() {
        return {
          docId: vm.selectedMainGridItemId,
        };
      };

      /// TODO REMOVE WHEN (IF) FINAL SPECS ARRIVE
      vm.labels.TitleLabel = 'Csatolt Dokumentumok';
      ///

      // IdField of mainGrid
      vm.mainGridIdField = vm.pageModel.Grids['GridDocument'].IdColumn;

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridDocument,
        'Document/DocumentList/',
        function() {
          changeMainGridSelectedItemId();
        },
        vm.getEntityId
      );

      vm.detailGridOptions = getGridOptions(
        options.pageModel.Grids.GridDocFiles,
        'Document/DocFilesList/',
        function() {},
        vm.getSelectedMainGridItem
      );
      vm.mainGridOptions.columns.push({
        name: 'download',
        template: function(e) {
          var downid = 'downloadhelper-' + e.uid;
          var delid = 'deletehelper-' + e.uid;
          var download = "vm.downloadMainItem('" + e.DocId + "', '" + e.Name + "')";
          var del = "vm.deleteMainItem('" + e.DocId + "')";
          return (
            '<button id="' +
            downid +
            '" title="{{vm.actions.ActionDownload.Title}}" type="button" class ="btn btn-default" ng-click="' +
            download +
            '">' +
            '<span class ="fa fa-download">' +
            '</span>' +
            '</button>' +
            '<button id="' +
            delid +
            '" type="button" title="{{vm.actions.ActionDelete.Title}}" class ="btn btn-default" ng-click="' +
            del +
            '">' +
            '<span class ="fa fa-trash-o">' +
            '</span>' +
            '</button>'
          );
        },
        title: ' ',
        width: '51px',
      });

      vm.detailGridOptions.columns.push({
        name: 'download',
        template: function(e) {
          var downid = 'downloadhelper-' + e.uid;
          var delid = 'deletehelper-' + e.uid;
          var download = "vm.downloadFile('" + e.DocName + "', '" + e.GenDoc + "')";
          var del = "vm.deleteFile('" + e.DocFilesId + "')";
          return (
            '<button id="' +
            downid +
            '" type="button" title="{{vm.actions.ActionDownload.Title}}" class ="btn btn-default" ng-click="' +
            download +
            '">' +
            '<span class ="fa fa-download">' +
            '</span>' +
            '</button>' +
            '<button id="' +
            delid +
            '" type="button" title="{{vm.actions.ActionDelete.Title}}" class ="btn btn-default" ng-click="' +
            del +
            '">' +
            '<span class ="fa fa-trash-o">' +
            '</span>' +
            '</button>'
          );
        },
        title: ' ',
        width: '51px',
      });

      /// Main item menu actions
      vm.createMainItem = function() {
        var id = 0;
        var url = 'FLGRDocument/DocumentEdit/?id=' + id + '&entityId=' + entityId;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/FLGRDocument/DocumentEdit.html',
          controller: 'FLGRDocumentEditCtrl',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      };

      vm.editMainItem = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var url = 'FLGRDocument/DocumentEdit/?id=' + id + '&entityId=' + entityId;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/FLGRDocument/DocumentEdit.html',
            controller: 'FLGRDocumentEditCtrl',
            controllerAs: 'vm',
            resolve: {
              options: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.mainGrid.dataSource.read();
          });
        }
      };

      vm.deleteMainItem = function(docid) {
        var dialogMessage = vm.pageModel.Labels.LabelDelConfirmMessage.Title;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Labels.LabelDelConfirmTitle.Title,
          buttons: {
            cancel: {
              label: vm.pageModel.Labels.LabelCancel.Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Labels.LabelDelOk.Title,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('FLGRDocument/DocumentDelete', { id: docid })
                  .then(function(data, status, headers, config) {
                    toastr.success('Sikeres törlés');
                    vm.mainGrid.dataSource.read();
                  })
                  .catch(function(data, status, headers, config) {
                    //TODO when WS error
                  });
              },
            },
          },
        });
      };

      vm.downloadMainItem = function(docid, docname) {
        $http
          .post(
            'FLGRDocument/DocumentDownloadByDocId',
            { docId: docid },
            {
              responseType: 'arraybuffer',
              transformResponse: function(data) {
                var pdf;
                if (data) {
                  pdf = new Blob([data], {
                    type: 'application/pdf',
                  });
                }
                return {
                  response: pdf,
                };
              },
            }
          )
          .then(function(data, status, headers, config) {
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(data.response, docname + '.zip');
            } else {
              var fileURL = URL.createObjectURL(data.response);
              var a = document.createElement('a');
              a.href = fileURL;
              a.target = '_blank';
              a.download = docname + '.zip';
              document.body.appendChild(a);
              a.click();
            }
          })
          .catch(function(data, status, headers, config) {
            //TODO when WS error
          });
      };

      vm.deleteFile = function(docfileid) {
        var dialogMessage = vm.pageModel.Labels.LabelDelConfirmMessage.Title;
        bootbox.dialog({
          message: dialogMessage,
          title: vm.pageModel.Labels.LabelDelConfirmTitle.Title,
          buttons: {
            cancel: {
              label: vm.pageModel.Labels.LabelCancel.Title,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.pageModel.Labels.LabelDelOk.Title,
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('FLGRDocument/DocumentFileDelete', { id: docfileid })
                  .then(function(data, status, headers, config) {
                    toastr.success('Sikeres törlés');
                    vm.detailGrid.dataSource.read();
                  })
                  .catch(function(data, status, headers, config) {
                    //TODO when WS error
                  });
              },
            },
          },
        });
      };

      vm.downloadFile = function(docname, genDoc) {
        var file = { GenDoc: genDoc, DocName: docname };
        $http
          .post('FLGRDocument/DocumentFileDownloadBygridItemDto', file, {
            responseType: 'arraybuffer',
            transformResponse: function(data) {
              var pdf;
              if (data) {
                pdf = new Blob([data], {
                  type: 'application/pdf',
                });
              }
              return {
                response: pdf,
              };
            },
          })
          .then(function(data, status, headers, config) {
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(data.response, file.DocName);
            } else {
              var fileURL = URL.createObjectURL(data.response);
              var a = document.createElement('a');
              a.href = fileURL;
              a.target = '_blank';
              a.download = file.DocName;
              document.body.appendChild(a);
              a.click();
            }
          })
          .catch(function(data, status, headers, config) {
            //TODO when WS error
          });
      };

      vm.feedbackMainItem = function() {};

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('FLGRDocument.DasDocumentsNav', { tableId: 'FlgDocument', ownerId: id });
        }
      }

      function WAL() {
        walService.NavigateToWal('Document', 'DocumentNavWal', 'FlgDocumentView');
      }
      ///

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridSelectedItemId() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        if (!!vm.detailGrid) {
          vm.detailGrid.dataSource.read();
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FLGRDocumentMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FLGRDocumentMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('FLGRDocument.Nav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {};

      buildMenu($state, authService, 'FLGRDocument', 'equipment', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FLGRDocumentUploadCtrl', [
    '$state',
    '$location',
    '$http',
    '$uibModal',
    'options',
    function($state, $location, $http, $uibModal, options) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FLGRDocumentUploadCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FLGRDocumentLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FLGRDocumentLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('FLGRDocumentEditCtrl', [
    '$uibModalInstance',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'lodash',
    'LockService',
    function(mi, options, $http, $state, $stateParams, authService, lodash, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'FLGRDocumentEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;

      var entityId = vm.formModel.RowId;

      vm.save = save;

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('FLGRDocument.Nav');
      };

      console.log(vm.pageModel);

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      var eventHandlers = {
        Files: {
          onComplete: function(e) {},
          onError: function(e) {},
          onSuccess: function(e) {
            if (e.response) {
              if (e.response.ResultStatus) {
                if (e.operation === 'upload') {
                  if (!vm.formModel.UploadedFiles) {
                    vm.formModel.UploadedFiles = e.response.FileIdentifiers;
                  } else {
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      vm.formModel.UploadedFiles.push({
                        StoredName: value.StoredName,
                        OriginalName: value.OriginalName,
                      });
                    });
                  }
                } else if (e.operation === 'remove') {
                  if (vm.formModel.UploadedFiles) {
                    var forDelete = [];
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      forDelete.push(value);
                    });
                    for (var i = 0; i < forDelete.length; i++) {
                      for (var j = 0; j < vm.formModel.UploadedFiles.length; j++) {
                        if (forDelete[i] === vm.formModel.UploadedFiles[j].StoredName) {
                          vm.formModel.UploadedFiles.splice(j, 1);
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          onRemoveFileFromDb: function(file) {
            if (file) {
              var sf = lodash.findLast(vm.formModel.StoredFiles, function(sf) {
                return sf.DocFilesId === file.storedDoc.DocFilesId;
              });
              sf.ToRemove = true;
            }
          },
        },
      };
      ////////////////////////////////////////////////////////////////////////////////////////

      var customExpressionProperties = {
        TableName: {
          'templateOptions.disabled': function() {
            return !(entityId === 0 || entityId === null);
          },
        },
        RowId: {
          'templateOptions.disabled': function() {
            return !(entityId === 0 || entityId === null);
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertEventHandlers(vm.pageModel, eventHandlers);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelDoc.FormlyDescriptor;

      vm.cancel = function() {
        mi.close();
      };

      function save() {
        $http
          .post('FLGRDocument/DocumentEdit', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('LockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'LockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'LockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLocked = false;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();
      vm.SILENT = lockService.shouldSilent();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Locking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            var lockable = response.ResultStatus;
            vm.isLocked = !lockable;
            vm.lockedBy = response.LockedBy;

            if (vm.isLocked) {
              console.log('Editor is locked by: ' + vm.lockedBy);
              if (vm.SILENT === true) $uibModalInstance.close({ isLocked: vm.isLocked, lockedBy: vm.lockedBy });
            } else {
              console.log('Editor is accessible.');
            }

            if (lockable) {
              lockService.lock(
                programId,
                id,
                function() {
                  // lock succeeded
                  console.log('Lock succeeded.');
                  $uibModalInstance.close();
                },
                function() {
                  // error
                  console.log('Lock FAILED!');
                  vm.hasError = true;
                }
              );
            }

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('UnlockOverlayCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$uibModalInstance',
    'lockParameters',
    'LockService',
    function($scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UnlockOverlayCtrl', stateParams);
      }
      var vm = this;
      vm.isLockable = true;
      vm.hasError = false;
      vm.lockedBy = [];
      vm.SHOW_LOCK_MESSAGES_IN_MODALS = lockService.shouldShowInitialiLockAndUnlockMessageInModals();

      init(vm, $scope, $http, $state, $stateParams, $uibModal, $uibModalInstance, lockParameters, lockService);

      function init(
        vm,
        $scope,
        $http,
        $state,
        $stateParams,
        $uibModal,
        $uibModalInstance,
        lockParameters,
        lockService
      ) {
        var programId = lockParameters.programId;
        var id = lockParameters.id;

        console.log('Unlocking: programId:' + programId + ', id:' + id);

        lockService.isLockable(
          programId,
          id,
          function(response) {
            // success
            vm.isLockable = response.ResultStatus;
            vm.lockedBy = response.LockedBy;

            if (vm.isLockable) {
              // No need to unlock
              // This can happen - maybe we have unlocked the record after save, and the modal remained open and calls an unlock on close
              //
              // If the installService cannot handle this, uncomment below
              // However, this can cause missing unlock calls when the lock feature is turned on at the server side, as vm.IsLockable will always be true in that case
              //console.log('Record is already unlocked. Unlock succeeded.');
              //$uibModalInstance.close();
              //return;
            }

            lockService.unlock(
              programId,
              id,
              function() {
                // unlock succeeded
                console.log('Unlock succeeded.');
                $uibModalInstance.close();
              },
              function() {
                // error
                console.log('Unlock FAILED!');
                vm.hasError = true;
              }
            );

            // end success
          },
          function(response) {
            // error
            vm.hasError = true;
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

'use strict';

function sbUtilizationInvoiceDetailComponent(gridService) {
  const ctrl = this;

  //#region Private fields

  //#endregion

  //#region Public fields

  /**
   * @type number
   */
  ctrl.activeTab = 0;

  ctrl.generatedTabs = undefined;

  // @Input
  ctrl.contrFee = undefined;

  // @Input
  ctrl.tabs = undefined;

  // @Input
  ctrl.panels = undefined;

  // @Input
  ctrl.grids = undefined;

  //#endregion

  //#region Public methods

  ctrl.$onChanges = function $onChanges() {
    ctrl.activeTab = 0;
    ctrl.generatedTabs = gridService.buildTabModelsWithGrids(
      ctrl.tabs,
      ctrl.panels,
      ctrl.grids,
      ['PanelInvoiceRow'],
      function(gridModel) {
        if (gridModel.Name === 'GridInvoiceRow') {
          gridModel.ControllerMethod = 'Utilization/InvoiceRowList/';

          return {
            gridModel,
            transportData: function() {
              return {
                invoiceId: ctrl.invoice.InvoiceId,
              };
            },
            selectFunction: function() {},
          };
        }

        return null;
      }
    );
  };

  ctrl.showTabs = function(tab) {
    return true;
  };

  //#endregion
}

const sbUtilizationInvoiceDetailComponentOptions = {
  templateUrl: 'App/Utilization/utilization-invoice-detail/utilization-invoice-detail.component.html',
  controller: sbUtilizationInvoiceDetailComponent,
  bindings: {
    invoice: '<',
    tabs: '<',
    panels: '<',
    grids: '<',
  },
};

'use strict';

(function() {
  const components = {
    sbUtilizationInvoiceDetail: sbUtilizationInvoiceDetailComponentOptions,
  };

  const sbUtilizationInvoiceDetailModule = angular.module('sbUtilizationInvoiceDetail', []);

  Object.entries(components).forEach(([componentTag, componentOptions]) => {
    sbUtilizationInvoiceDetailModule.component(componentTag, componentOptions);
  });
})();

'use strict';

(function() {
  const modules = ['sbUtilizationInvoiceDetail'];

  const sbUtilizationModule = angular.module('sbUtilization', modules);
})();

(function(module) {
  'use strict';

  module.controller('RentEventCreateCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    function($http, options, $stateParams, AuthService, $scope, $state) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentEventCreateCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.rentStatusIsApproved = options.rentStatusIsApproved;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        ApproverUserId: {
          'templateOptions.disabled': function() {
            addApprovalButton(); // Jóváhagyás gomb hozzáadása a form-hoz
            return vm.rentStatusIsApproved === 'True';
          },
          'templateOptions.required': function() {
            return vm.rentStatusIsApproved !== 'True';
          },
        },
        Date: {
          'templateOptions.disabled': function() {
            return true;
          },
          'templateOptions.required': function() {
            return false;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        RentStatusId: function(selectedItem) {
          if (selectedItem.extraProperties) {
            vm.rentStatusIsApproved = selectedItem.extraProperties['0'].value;
          }
        },
        ContractTypeId: function() {
          $http({
            method: 'GET',
            url: 'Utilization/GetRentEventNumber',
            params: { ContractTypeId: vm.formModel.ContractTypeId },
          }).then(function successCallback(response) {
            if (response.data) {
              vm.formModel.RentEventNumber = response.data.Prefix + response.data.Year + '-' + response.data.Number;
              vm.contractNumberDto = response.data;
            } else {
              vm.formModel.RentEventNumber = '';
            }
          });
        },

        RentEventNumber: function() {
          var prefix = vm.formModel.RentEventNumber.substring(0, 2);
          var year = vm.formModel.RentEventNumber.substring(2, 6);
          var number = vm.formModel.RentEventNumber.substring(7);

          //vm.contractNumberDto.ContrNumberId = 0;
          //vm.contractNumberDto.Prefix = prefix;
          //vm.contractNumberDto.Year = year
          //vm.contractNumberDto.Number = number;
        },
        ApproverUserId: function() {
          vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.required = false;
          $http({
            method: 'get',
            url: 'utilization/GetUserIdResult',
            params: { ApproverUserId: vm.formModel.ApproverUserId.Value },
          }).then(function successcallback(response) {
            vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.required = !!response.data.required;
          });
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      vm.formModel = options.dto;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      var onChangeFunctions = function(selectedScope) {
        var selectedItem = selectedScope.gridSelectedItem;
        if (selectedItem) {
          $http({
            method: 'get',
            url: 'utilization/GetPartnerDetails',
            params: { PartnerId: vm.formModel.PartnerId.Value },
          }).then(function successcallback(response) {
            if (response.data) {
              vm.formModel.PartnerInvoiceName = response.data.PartnerInvoiceName;
              vm.formModel.PartnerAddress = response.data.PartnerAddress;
              vm.formModel.PartnerAccount = response.data.PartnerAccount;
              vm.formModel.PartnerTaxNumber = response.data.PartnerTaxNumber;
            } else {
              vm.formModel.PartnerInvoiceName = '';
              vm.formModel.PartnerAddress = '';
              vm.formModel.PartnerAccount = '';
              vm.formModel.PartnerTaxNumber = '';
            }
          });
        }
      };
      vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.InputChanged = onChangeFunctions;

      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      today = yyyy + '-' + mm + '-' + dd;
      vm.formModel.Date = today;

      vm.save = function() {
        var param = { model: vm.formModel, contractNumberDtoParam: vm.contractNumberDto, id: null };
        $http
          .post('Utilization/RentEventSave', param)
          .then(function(response) {
            toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' sikeresen megtörtént!'); // TODO általános label
            $state.go('Utilization.RentEventNav');
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Labels['LabelTitle'].Title + ' sikertelen'); // TODO általános label
          });
      };

      vm.back = function() {
        $state.go('Utilization.RentEventNav');
      };

      function addApprovalButton() {
        var btn = document.getElementById('formBtn');

        if (!btn) {
          var approvalUserF2 = document.getElementById('formly_f2Input_ApproverUserId_0');

          if (approvalUserF2) {
            var element = approvalUserF2.offsetParent;
            element = element.parentElement;

            var d = document.createElement('div');
            var l = document.createElement('label');
            l.innerHTML = 'JóváhagyásLabel';
            l.style.color = '#e2eced';

            btn = document.createElement('input');
            btn.type = 'button';

            d.classList.add('col-md-4');
            d.classList.add('ng-scope');
            d.classList.add('ng-isolate-scope');
            d.classList.add('col-md-offset-right-0');
            d.classList.add('formly-field');
            d.classList.add('formly-field-button');

            d.appendChild(l);
            d.appendChild(btn);

            btn.id = 'formBtn';
            btn.value = 'Jóváhagyás';
            btn.style.width = '100%';
            btn.style.bottom = '0px';
            btn.style.paddingBottom = '7px';
            btn.style.textAlign = 'center';
            btn.disabled = 'to.disabled';
            btn.style.backgroundColor = '#eee';

            element.appendChild(d);
          }
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('RentEventEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentEventEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.createOrEdit = $stateParams.createOrEdit;
      vm.rentEventStatusIsApproved = options.rentEventStatusIsApproved;
      vm.currentRenEventNumber = options.RentEventNumber;
      vm.currentContractTypeId = options.ContractTypeId;
      vm.UIHelperService = UIHelperService;

      if (vm.createOrEdit == 'Edit') vm.isDateEnabled = 'False';
      vm.currentRentStatusId = vm.formModel.RentStatusId;
      $scope.isInvoiceGenerateEnabled = isInvoiceGenerateEnabled;
      vm.serviceSubGridItemIsInvoiced = serviceSubGridItemIsInvoiced;

      vm.WAL = WAL;

      vm.messages = options.pageModel.Messages;

      vm.generateInvoice = generateInvoice;

      vm.isDuplicate = isDuplicate;
      vm.History = History;
      vm.attachDocument = attachDocument;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      if (vm.createOrEdit === 'View') {
        vm.formModel.IsReadOnly = true;
      }

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      if (!vm.formModel.IsReadOnly) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.getDate = function(date) {
        if (!date instanceof Date) return date;
        var dd = date.getDate();
        var mm = date.getMonth() + 1; //January is 0!
        var yyyy = date.getFullYear();

        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
      };
      vm.formModel.Date = vm.getDate(new Date(vm.formModel.Date));

      vm.setcolumtodatetime = SetGridColumnToDateTime(
        vm.pageModel.Grids,
        ['GridRentEventService'],
        ['StartDateTime', 'EndDateTime']
      );

      vm.currentRentEventStatusDate = vm.formModel.Date;

      if (vm.createOrEdit == 'Edit') {
        var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
          vm.pageModel.Tabs,
          vm.pageModel.Panels,
          vm.pageModel.Grids,
          ['PanelInvoice', 'PanelRentEventService', 'PanelStatus'],
          function(gridModel) {
            if (gridModel.Name === 'GridRentEventService') {
              gridModel.ControllerMethod = 'Utilization/RentEventServiceList/';
              return {
                gridModel,
                transportData: { rentEventId: vm.formModel.RentEventId },
              };
            }
            if (gridModel.Name === 'GridInvoice') {
              return {
                gridModel,
                transportData: {
                  InvoiceId: function() {
                    var selecteditem = GetSelectedItems('GridInvoice');
                    return !!selecteditem ? selecteditem[0].InvoiceId : null;
                  },
                },
              };
            }

            return null;
          }
        );

        vm.subItemTabs = generatedGridTabs.tabs;
        vm.subGridOptions = generatedGridTabs.gridOptions;
        vm.subGrids = generatedGridTabs.grids;
        vm.subGridOptions['GridRentEventService'].selectable = 'multiple';

        vm.subGridOptions.GridInvoice.dataSource.transport.read.data = function() {
          return { rentEventId: vm.formModel.RentEventId };
        };

        vm.subGridOptions.GridInvoice['detailInit'] = function(e) {
          if (vm.subGrids.GridInvoice.dataSource)
            vm.subGrids.GridInvoice.dataSource.read({ rentEventId: e.data.RentEventId });
        };

        vm.subGridOptions.GridInvoice.autoBind = false;

        vm.subGridOptions.GridStatus.dataSource.transport.read.data = function() {
          return { rentEventId: vm.formModel.RentEventId };
        };

        angular.forEach(vm.subGridOptions['GridRentEventService'].columns, function(val, key) {
          /*if (val.field === "Invoiced")
                {
                    val.template = '<input type="checkbox" class="checkbox" #: Invoiced == 1 ? "checked" : "" # #: Invoiced == 1 ? disabled : "" #/>';
                }*/
        });
      } else {
        vm.isDuplicate();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {
        //"PartnerTaxNumber": "kendoNTB",
        //"PartnerAccount": "maskedInput"
        //"RentEventNumber": "maskedInput"
      };

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        /*
        ApproverUserId: {
          'templateOptions.disabled': function() {
            if (vm.createOrEdit == 'Edit') {
              vm.subGrids.GridRentEventService &&
                vm.subGrids.GridRentEventService.table.on('click', '.checkbox', selectRow);
              function selectRow() {
                var checked = this.checked,
                  row = $(this).closest('tr'),
                  grid = vm.subGrids.GridRentEventService,
                  dataItem = grid.dataItem(row);

                if (checked) {
                  //-select the row
                  row.addClass('k-state-selected');
                } else {
                  //-remove selection
                  row.removeClass('k-state-selected');
                }

                isInvoiceGenerateEnabled();
              }
            }

            addApprovalButton(); // Jóváhagyás gomb hozzáadása a form-hoz
            return vm.rentEventStatusIsApproved !== 'True';
          },
          'templateOptions.required': function() {
            return vm.rentStatusIsApproved === 'True';
          },
        },
        */
        RentStatusId: {
          'templateOptions.disabled': function() {
            return vm.rentEventStatusIsApproved === 'True';
          },
        },
        ContractTypeId: {
          'templateOptions.disabled': function() {
            return vm.createOrEdit === 'Edit';
          },
        },
        Date: {
          'templateOptions.disabled': function() {
            return vm.createOrEdit === 'Create' ? true : vm.isDateEnabled !== 'True';
          },
          'templateOptions.required': function() {
            return vm.createOrEdit === 'Create' ? false : vm.isDateEnabled === 'True';
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        PartnerId: function(selectedItem) {
          if (selectedItem) {
            $http({
              method: 'get',
              url: 'utilization/GetPartnerDetails',
              params: { PartnerId: selectedItem.PartnerId },
            }).then(function successcallback(response) {
              if (response.data) {
                vm.formModel.PartnerInvoiceName = response.data.PartnerInvoiceName;
                vm.formModel.PartnerAddress = response.data.PartnerAddress;
                vm.formModel.PartnerAccount = response.data.PartnerAccount;
                vm.formModel.PartnerTaxNumber = response.data.PartnerTaxNumber;
              } else {
                vm.formModel.PartnerInvoiceName = '';
                vm.formModel.PartnerAddress = '';
                vm.formModel.PartnerAccount = '';
                vm.formModel.PartnerTaxNumber = '';
              }
            });
          } else {
            vm.formModel.PartnerInvoiceName = '';
            vm.formModel.PartnerAddress = '';
            vm.formModel.PartnerAccount = '';
            vm.formModel.PartnerTaxNumber = '';
          }
        },

        RentStatusId: function(selectedItem) {
          if (selectedItem.extraProperties) {
            vm.rentStatusIsApproved = selectedItem.extraProperties['0'].value;
            if (selectedItem.key !== String(vm.currentRentStatusId)) {
              vm.isDateEnabled = 'True';
              vm.formModel.Date = vm.getDate(new Date());
            } else {
              vm.isDateEnabled = 'False';
              vm.formModel.Date = vm.currentRentEventStatusDate;
            }
          }
        },
        ContractTypeId: function() {
          if (vm.formModel.ContractTypeId == vm.currentContractTypeId)
            vm.formModel.RenEventNumber = vm.currentRenEventNumber;
          else {
            $http({
              method: 'GET',
              url: 'Utilization/GetRentEventNumber',
              params: { ContractTypeId: vm.formModel.ContractTypeId },
            }).then(function successCallback(response) {
              if (response.data) {
                vm.formModel.RentEventNumber =
                  response.data.Prefix + response.data.Year + '-' + response.data.Number.toString().padStart(5, '0');
                vm.contractNumberDto = response.data;
              } else {
                vm.formModel.RentEventNumber = '';
              }
            });
          }
        },

        RentEventNumber: function() {
          var prefix = vm.formModel.RentEventNumber.substring(0, 2);
          var year = vm.formModel.RentEventNumber.substring(2, 6);
          var number = vm.formModel.RentEventNumber.substring(7);

          //vm.contractNumberDto.ContrNumberId = 0;
          //vm.contractNumberDto.Prefix = prefix;
          //vm.contractNumberDto.Year = year
          //vm.contractNumberDto.Number = number;
        },
        /*
        ApproverUserId: function(selectedItem) {
          if (selectedItem) {
            vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.required = false;
            $http({
              method: 'get',
              url: 'utilization/GetUserIdResult',
              params: { ApproverUserId: vm.formModel.ApproverUserId.Value },
            }).then(function successcallback(response) {
              if (response.data.required && vm.rentStatusIsApproved) {
                vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.required = true;
              } else {
                vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.required = false;
              }
            });
          } else {
            var btn = document.getElementById('rentEventApproveFormBtn');
            if (btn) {
              if (vm.rentEventStatusIsApproved === 'False' && vm.rentEventStatusIsApprove === 'True') {
                btn.disabled = '';
              } else {
                btn.disabled = 'to.disabled';
              }
            }
          }
        },*/
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        ContactEmail: {
          email: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            return sysEmailValidate(modelValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {
        Installment: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        NumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        ActNumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },

        TouristTaxNumber: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
      };

      // Usage: "fieldName": "inputMask"
      var inputMasks = {
        //"PartnerAccount": "99999999-99999999-99999999",
        //"PartnerTaxNumber": "99999999-9-99",
        //"RentEventNumber": "AA9999-99999",
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.formModel.IsReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      if (vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      function isDuplicate() {
        return vm.activeSubItemTab !== 0;
      }

      vm.addSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;

        var name = urlPrefix.replace(/grid/gi, '');
        const nameWithEditSuffix = name + 'Edit';
        name = name + 'Create';

        var url = 'Utilization/' + name + '?rentEventId=' + vm.formModel.RentEventId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/' + nameWithEditSuffix + '.html',
          controller: nameWithEditSuffix + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            rentEventId: vm.formModel.RentEventId,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.subGrids[urlPrefix].dataSource.read();
        });
      };

      vm.editSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;

        var name = urlPrefix.replace(/grid/gi, '');
        name = name + 'Edit';

        var selectedItem = GetSelectedItem(urlPrefix);

        if (selectedItem) {
          var url =
            'Utilization/' +
            name +
            '?rentEventId=' +
            vm.formModel.RentEventId +
            '&rentEventServiceId=' +
            selectedItem.RentEventServiceId;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Utilization/SubItems/' + name + '.html',
            controller: name + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              rentEventId: vm.formModel.RentEventId,
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrids[urlPrefix].dataSource.read();
          });
        }
      };

      vm.deleteSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;

        var name = urlPrefix.replace(/grid/gi, '');
        name = name + 'Delete';

        var selectedItem = GetSelectedItem(urlPrefix);

        if (selectedItem) {
          var url = 'Utilization/' + name + '?id=' + selectedItem.RentEventServiceId;

          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(url).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.subGrids[urlPrefix].dataSource.read();
                  });
                },
              },
            },
          });
        }
      };

      function generateInvoice() {
        var selectedItems = GetSelectedItems('GridRentEventService');
        if (!selectedItems) {
          toastr.warning('Nem jelölt ki elemet!', vm.messages.Warning);
          return;
        }

        if (selectedItems[0].IsInvoiced) {
          toastr.warning('A tétel már számlázva van!', vm.messages.Warning);
          return;
        }

        var indices = [];

        angular.forEach(selectedItems, function(value, key) {
          indices.push(value.RentEventServiceId);
        });

        var url = 'Utilization/InvoiceGeneratorModal?idList=' + JSON.stringify(indices);
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/InvoiceGenerator.html',
          controller: 'InvoiceGeneratorCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function serviceSubGridItemIsInvoiced() {
        return true;
      }

      vm.save = function() {
        $http({
          method: 'GET',
          url: 'Utilization/GetRentEventNumber',
          params: { ContractTypeId: vm.formModel.ContractTypeId },
        }).then(function successCallback(response) {
          if (response.data) {
            vm.contractNumberDto = response.data;

            var param = {
              model: vm.formModel,
              contractNumberDtoParam: vm.contractNumberDto,
              id: vm.formModel.RentEventId,
            };

            $http
              .post('Utilization/RentEventSave', param)
              .then(function successCallback(response) {
                if (!vm.formModel.IsReadOnly) {
                  lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                }
                toastr.success(vm.messages.SaveSuccessful);
                vm.back();
              })
              .catch(function errorCallback(response) {
                toastr.error(vm.messages.SaveFailed);
              });
          }
        });
      };

      vm.back = function() {
        if (!vm.formModel.IsReadOnly) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Utilization.RentEventNav');
      };
      function attachDocument() {
        var id = vm.formModel.RentEventId;
        dasService.NavigateToDas(vm.messages, 'Utilization.DasDocumentsNav', 'FlgRentEvent', id);
      }

      function History() {
        // TODO
        HistoryService.NavigateToHistory('FlgRentEvent', $state.params.id, vm, $state);
      }

      function GetSelectedItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function GetSelectedItems(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);

        if (selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems;
        }
      }

      function addApprovalButton() {
        var btn = document.getElementById('rentEventApproveFormBtn');

        if (!btn) {
          var approvalUserF2 = document.getElementById('formly_f22Input_ApproverUserId_0');

          if (approvalUserF2) {
            var element = approvalUserF2.offsetParent;
            element = element.parentElement;

            var d = document.createElement('div');
            var l = document.createElement('label');
            l.innerHTML = '&nbsp';

            btn = document.createElement('input');
            btn.type = 'button';
            btn.classList.add('btn');
            btn.classList.add('btn-default');

            d.classList.add('col-md-4');
            d.classList.add('ng-scope');
            d.classList.add('ng-isolate-scope');
            d.classList.add('col-md-offset-right-0');
            d.classList.add('formly-field');
            d.classList.add('formly-field-button');

            d.appendChild(l);
            d.appendChild(btn);

            btn.id = 'rentEventApproveFormBtn';
            btn.value = 'Jóváhagyás';
            btn.disabled =
              vm.rentEventStatusIsApprove !== 'True' || vm.rentEventStatusIsApproved === 'True' ? 'to.disabled' : '';

            element.appendChild(d);

            btn.addEventListener('click', function(e) {
              var dialogMessage = vm.messages.ApproveRentEvent;
              bootbox.dialog({
                message: dialogMessage,
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      $http({
                        method: 'POST',
                        url: 'Utilization/ApproveRentEvent',
                        params: {
                          rentEventId: vm.formModel.RentEventId,
                          comment: vm.formModel.Comment,
                        },
                      }).then(
                        function successCallback(response) {
                          var btn = document.getElementById('rentEventApproveFormBtn');
                          if (btn) {
                            btn.disabled = 'to.disabled';
                            vm.rentEventStatusIsApproved = 'True';
                            //vm.pageModel.RentStatusId.dataSource.read();
                          }

                          toastr.success(vm.messages.SuccessApprove);
                        },
                        function errorCallback(response) {
                          toastr.error('Rendezvény jóváhagyása sikertelen!'); // TODO általános label
                        }
                      );
                    },
                  },
                },
              });
            });
          }
        }
      }

      function isInvoiceGenerateEnabled() {
        var selectedItems = GetSelectedItems('GridRentEventService');

        if (selectedItems) {
          var btn = document.getElementById('generateInvoiceBtn');

          if (btn) {
            btn.disabled = false;
          }
        } else {
          var btn = document.getElementById('generateInvoiceBtn');

          if (btn) {
            btn.disabled = true;
          }
        }
      }

      function WAL() {
        switch (vm.activeSubItemTab) {
          case 0: // Keretértékek
            walService.NavigateToWal('Utilization', 'RentEventMODRentEventServiceWal', 'FlgRentEventServiceView');
            break;
          case 1: // Bizonylatok
            walService.NavigateToWal('Utilization', 'RentEventMODInvoiceWal', 'FlgInvoiceView');
            break;
          case 2: // Státuszok
            walService.NavigateToWal('Utilization', 'RentEventMODRentStatusWal', 'FlgRentStatus');
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('RentEventServiceEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'rentEventId',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      dasService,
      uibModalInstance,
      rentEventId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentEventServiceEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.Dto;
      vm.rentEventServiceModel = model.Dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      //Set default values
      if (vm.rentEventServiceModel.ModelState === 2) {
        vm.rentEventServiceModel.Quantity = 1;
        vm.rentEventServiceModel.Discount = 0;
        vm.rentEventServiceModel.Occasion = 1;
        vm.rentEventServiceModel.StartDateTime = null;
        vm.rentEventServiceModel.EndDateTime = null;
        vm.modalTitle = vm.pageModel.Labels.LabelTitle.Title;
      } else {
        vm.rentEventServiceModel.Occasion = 1;
        vm.modalTitle = vm.pageModel.Labels.LabelEditTitle.Title;
      }

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = function() {
        var id = vm.formModel.RentEventServiceId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgRentEventService', id);
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        Weeks: {
          'templateOptions.disabled': function() {
            return vm.rentEventServiceModel.ModelState !== 2 || vm.rentEventServiceModel.Occasion <= 1;
          },
        },
        Days: {
          'templateOptions.disabled': function() {
            return vm.rentEventServiceModel.ModelState !== 2 || vm.rentEventServiceModel.Occasion <= 1;
          },
        },
        Occasion: {
          'templateOptions.disabled': function() {
            return vm.rentEventServiceModel.ModelState !== 2;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ServiceId: function(selecteditem) {
          if (!!selecteditem) {
            vm.rentEventServiceModel.UnitName = selecteditem.UnitName;
          }
        },
        RentLocationId: function(selecteditem) {
          if (!!selecteditem) {
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
              rentLocationId: selecteditem.RentLocationId,
            };
          }
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}

      var syncValidators = {
        StartDateTime: {
          StartDateTimeValidator: function(modelValue) {
            if (modelValue == '' || !modelValue) return false;
            return true;
          },
        },
        Occasion: {
          OccasionValidator: function(modelValue) {
            if (modelValue) return true;
            return false;
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {
        Discount: {
          format: '##.## \\%',
          max: 100,
          min: 0,
        },
        Quantity: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 0,
        },
        Occasion: {
          decimals: 0,
          format: 'n0',
          max: 999999999,
          min: 0,
        },
      };

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.rentEventServiceModel, id: vm.rentEventServiceModel.RentEventServiceId };
        $http
          .post('Utilization/RentEventServiceEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('RentEventCalCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    function($scope, options, $http, $state, walService, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentEventCalCtrl', stateParams);
      }
      var vm = this;
      vm.RentCalendarMeeting = options.dto.RentCalendarMeeting;
      vm.RentCalendarRes = options.dto.RentCalendarRes;
      $scope.schedulerOptions = {
        selectable: true,
        editable: {
          destroy: false,
          resize: false,
          update: false,
          move: false,
        },
        //date: Date.now(),
        date: new Date('2013/6/13'),
        startTime: new Date('2013/6/13 07:00 AM'),
        eventHeight: 50,
        majorTick: 60,
        views: [
          'timeline',
          'timelineWeek',
          'timelineWorkWeek',
          {
            type: 'timelineMonth',
            startTime: new Date('2013/6/13 00:00 AM'),
            majorTick: 1440,
          },
        ],
        timezone: 'Etc/UTC',

        dataSource: {
          batch: true,
          /*          
                    transport: {
                        read: {
                            url: "https://demos.telerik.com/kendo-ui/service/meetings",
                            dataType: "jsonp"
                        },

                        parameterMap: function (options, operation) {
                            if (operation !== "read" && options.models) {
                                return { models: kendo.stringify(options.models) };
                            }
                        }
                    },
                    */
          /*
                    data: [
                                   {
                                       ServiceId: 3,
                                       ServiceName: "Call Charlie about the project",
                                       Start: new Date("2013/6/13 10:30"),
                                       End: new Date("2013/6/13 11:30"),
                                       RentEventId: 1,
                                   },
                                   {
                                       ServiceId: 4,
                                       ServiceName: "Performance review",
                                       Start: new Date("2013/6/13 9:00"),
                                       End: new Date("2013/6/13 12:30"),
                                       RentEventId: 2,
                                   },
                                   {
                                       ServiceId: 5,
                                       ServiceName: "HR Lecture",
                                       Start: new Date("2013/6/13 13:00"),
                                       End: new Date("2013/6/13 14:30"),
                                       RentEventId: 1,
                                   }
                    ],
                    */
          data: vm.RentCalendarMeeting,
          schema: {
            model: {
              id: 'serviceId',
              fields: {
                serviceId: { from: 'ServiceId', type: 'number' },
                title: { from: 'ServiceName', defaultValue: 'No title', validation: { required: true } },
                start: { type: 'date', from: 'Start' },
                end: { type: 'date', from: 'End' },
                description: { from: 'Description' },
                rentEventId: { from: 'RentEventId', nullable: true },
              },
            },
          },
        },
        group: {
          resources: ['RentEvents'],
          orientation: 'vertical',
        },
        resources: [
          {
            field: 'rentEventId',
            name: 'RentEvents',
            /*
                        dataSource: [
                            { text: "Meeting Room 101", value: 1, color: "#6eb3fa" },
                            { text: "Meeting Room 201", value: 2, color: "#6eb3fa" }
                        ],
                        */
            dataSource: vm.RentCalendarRes,

            title: 'RentEvent',
          },
        ],
        change: function(e) {
          var id = 0;
          if (e.events[0] && e.events[0].serviceId > 0) id = e.events[0].serviceId;

          if (id > 0) {
            $state.go('Utilization.RentEventEdit', {
              id: id,
              cal: '1',
            });
          } else {
            $state.go('Utilization.RentEventCreate', {
              id: id,
              cal: '1',
            });
          }
        },
        edit: function(e) {
          e.preventDefault();
        },
      };
      console.log(options);
      /*
            $scope.schedulerOptions.resources = [
                    {
                        field: "RentEventId",
                        name: "RentEvents",
                        dataSource: [
                            { text: "service Room 601", value: 1, color: "#6eb3fa" },
                            { text: "service Room 701", value: 2, color: "#f58a8a" }
                        ],
                        title: "Room"
                    }
            ];
            */
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('RentEventNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $filter,
      authService,
      HistoryService,
      dasService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentEventNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.createRentEvent = createRentEvent;
      vm.editRentEvent = editRentEvent;
      vm.viewRentEvent = viewRentEvent;
      vm.deleteRentEvent = deleteRentEvent;
      vm.duplicateRentEvent = duplicateRentEvent;
      vm.calendarView = calendarView;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.mainGridIdField = vm.pageModel.Grids['GridRentEvent'].IdColumn;
      vm.mainGrid = $('#mainGrid').data('kendoGrid');

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(
        options.pageModel.Grids.GridRentEvent,
        'Utilization/RentEventList/',
        function() {}
      );

      // Actions

      vm.back = function() {
        $state.go('main');
      };

      function createRentEvent() {
        $state.go('Utilization.RentEventCreate');
      }

      function editRentEvent() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.RentEventEdit', { id: selectedItem.RentEventId });
        }
      }

      function viewRentEvent() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.RentEventView', { id: selectedItem.RentEventId });
        }
      }

      function duplicateRentEvent() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.RentEventDuplicate', { id: selectedItem.RentEventId });
        }
      }

      function deleteRentEvent() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Utilization/RentEventDelete/' + selectedItem.RentEventId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function calendarView() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.RentEventCalendarView', { id: selectedItem.RentEventId });
        }
      }

      function GetSelectedItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          dasService.NavigateToDas(vm.messages, 'Utilization.DasDocumentsNav', 'FlgRentEvent', id);
        }
      }

      function WAL() {
        walService.NavigateToWal('Utilization', 'RentEventNavWal', 'FlgRentEventView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          HistoryService.NavigateToHistory('FlgRentEvent', selectedItems, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceGeneratorCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    function($http, model, fus, $state, $stateParams, $uibModal, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceGeneratorCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.invoiceGeneratorModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      // MenuItems
      vm.generate = generate;
      vm.cancel = cancelItem;

      vm.invoiceGeneratorModel.DueDate = null;
      vm.invoiceGeneratorModel.InvoiceDate = null;
      vm.invoiceGeneratorModel.FulfilmentDay = null;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      function generate() {
        $http
          .post('Utilization/GenerateInvoice', vm.invoiceGeneratorModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
        uibModalInstance.close();
      }

      function cancelItem() {
        uibModalInstance.close();
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('InvoiceGenFromReservationCtrl', [
    '$http',
    'model',
    'callFromNav',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    '$uibModalInstance',
    function($http, model, callFromNav, fus, $state, $stateParams, $uibModal, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceGenFromReservationCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.invoiceGeneratorModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      // MenuItems
      vm.generate = generate;
      vm.cancel = cancelItem;

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {};

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        DueDate: {
          PaymentDueDateValidator: function(modelValue) {
            var paymentDueDateValue = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            var invoiceDateValue = new moment(
              vm.invoiceGeneratorModel.InvoiceDate,
              kendo.culture().calendar.patterns.d.toUpperCase()
            );

            return paymentDueDateValue.isSameOrAfter(invoiceDateValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      function generate() {
        $http
          .post('Utilization/InvoiceGenFromReservation', vm.invoiceGeneratorModel)
          .then(function(response) {
            var modalInstanceResult = $uibModal.open({
              templateUrl: 'App/Utilization/SubItems/InvoiceGenFromReservationResult.html',
              controller: 'InvoiceGenFromReservationResultCtrl',
              controllerAs: 'vm',
              size: 'lg',
              resolve: {
                fModel: {
                  data: response.data,
                  labels: vm.pageModel.Labels,
                  actions: vm.pageModel.Actions,
                  grid: vm.pageModel.Grids.GridInvoiceGenError,
                },
              },
              backdrop: 'static',
            });

            modalInstanceResult.result
              .then(function() {
                refreshPage();
              })
              .catch(function() {
                refreshPage();
              });
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
        uibModalInstance.close();
      }

      function refreshPage() {
        if (callFromNav) {
          $state.go('Utilization.ReservationNav', {}, { reload: true });
        } else {
          $state.go(
            'Utilization.ReservationEdit',
            { id: vm.invoiceGeneratorModel.RentEventIdList[0] },
            { reload: true }
          );
        }
      }

      function cancelItem() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('InvoiceGenFromReservationResultCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    '$stateParams',
    'AuthService',
    '$uibModal',
    '$state',
    function(uibModalInstance, $http, fModel, $stateParams, AuthService, $uibModal, $state) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'InvoiceGenFromReservationResultCtrl', stateParams);
      }
      var vm = this;
      vm.close = close;
      vm.errorGridModel = angular.copy(fModel.grid);
      vm.actions = fModel.actions;
      vm.labels = fModel.labels;
      vm.errorRow = fModel.data.ErrorList;
      vm.successfulMessage = fModel.data.SuccessfulMessage.Message;
      vm.exportExcel = function() {
        exportExcel([vm.errorGrid], ['Hibajegyzék'], vm.labels.LabelResultTitle.Title + '.xlsx');
      };

      var errorGridOptions = getGridOptions(vm.errorGridModel, '', function() {}, vm.dump);
      errorGridOptions.dataSource = new kendo.data.DataSource({
        data: vm.errorRow,
        schema: {
          model: {
            fields: {
              Contract: { type: 'string' },
              EmsContractDate: { type: 'date' },
            },
          },
        },
        pageSize: 20,
        page: 1,
      });
      vm.errorGridOptions = angular.copy(errorGridOptions);
      vm.errorGrid = $('#errorGrid').data('kendoGrid');

      function close() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UtilizationMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilizationMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        Utilization_RentEventNav: { icon: 'fa fa-file-text' },
        Masterdata_Utilization: { icon: 'fa fa-file-text' },
      };

      buildMenu($state, authService, 'Utilization', 'Utilization', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

var myApp = angular.module('myApp');

myApp.config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Utilization: {
        url: '/utilization',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'Utilization.ReservationNav',
        ncyBreadcrumb: {
          label: 'Hasznosítás modul',
          parent: 'main',
        },
      },
      'Utilization.MasterDataNav': {
        url: '/master-data/utilization',
        params: { module: 'utilization', documentEntity: 'utilization_masterdatanav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Utilization/UtilizationMasterDataView.html',
            controller: 'UtilizationMasterDataViewCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('UtilizationMasterData/ListOptions'),
        },
        ncyBreadcrumb: {
          label: 'Törzsek',
          parent: 'main',
        },
      },
      'Utilization.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Utilization.RentEventNav': {
        url: '/utilizationeventnav',
        params: {
          module: 'utilization',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utilization.RentEventCreate', 'Utilization.RentEventEdit', 'Utilization.RentEventDuplicate'],
          documentEntity: 'utilization_renteventnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/RentEventNav.html',
            controller: 'RentEventNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Rendezvények',
          parent: 'Utilization',
        },
      },
      'Utilization.RentEventCreate': {
        url: '/utilizationeventcreate',
        params: {
          module: 'utilization',
          formMode: 'Create',
          createOrEdit: 'Create',
          documentEntity: 'utilization_renteventcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/RentEventEdit.html',
            controller: 'RentEventEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventCreate/'),
        },
        params: {
          formMode: 'Create',
          createOrEdit: 'Create',
        },
        ncyBreadcrumb: {
          label: 'Rendezvény létrehozása',
        },
      },
      'Utilization.RentEventEdit': {
        url: '/utilizationeventedit/{id:int}',
        params: {
          module: 'utilization',
          formMode: 'Edit',
          createOrEdit: 'Edit',
          documentEntity: 'utilization_renteventcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/RentEventEdit.html',
            controller: 'RentEventEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventEdit/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Rendezvény módosítása',
        },
      },
      'Utilization.RentEventView': {
        url: '/utilizationeventview/{id:int}',
        params: {
          module: 'utilization',
          formMode: 'View',
          createOrEdit: 'View',
          documentEntity: 'utilization_renteventview',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/RentEventEdit.html',
            controller: 'RentEventEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventEdit/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Rendezvény megtekintése',
        },
      },
      'Utilization.RentEventDuplicate': {
        url: '/utilizationeventduplicate/{id:int}',
        params: {
          module: 'utilization',
          formMode: 'Create',
          createOrEdit: 'Create',
          documentEntity: 'utilization_renteventcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/RentEventEdit.html',
            controller: 'RentEventEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Rendezvény másolása',
        },
      },
      'Utilization.RentEventCalendarView': {
        url: '/utilizationeventcalendarview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/SubItems/RentEventCalendarView.html',
            controller: 'RentEventCalCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/RentEventCalendarView/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Ütemezési nézet',
        },
      },
      'Utilization.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Utilization/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
      'Utilization.ReservationNav': {
        url: '/utilizationreservationnav',
        params: {
          module: 'utilization',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Utilization.ReservationCreate', 'Utilization.ReservationEdit', 'Utilization.ReservationDuplicate'],
          documentEntity: 'utilization_reservationnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReservationNav.html',
            controller: 'ReservationNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReservationListOptions/'),
        },
        params: {
          bstates: ['Utilization.ReservationCreate', 'Utilization.ReservationEdit', 'Utilization.ReservationDuplicate'],
        },
        ncyBreadcrumb: {
          label: 'Foglalások',
          parent: 'Utilization',
        },
      },
      'Utilization.ReservationCreate': {
        url: 'utilizationreservationcreate',
        params: {
          module: 'utilization',
          formMode: 'Create',
          backState: 'main',
          createOrEdit: 'Create',
          documentEntity: 'utilization_reservationcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReservationEdit.html',
            controller: 'ReservationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReservationCreate/'),
        },
        params: {
          formMode: 'Create',
          createOrEdit: 'Create',
        },
        ncyBreadcrumb: {
          label: 'Foglalás létrehozása',
        },
      },
      'Utilization.ReservationEdit': {
        url: '/utilizationreservationedit/{id:int}',
        params: {
          module: 'utilization',
          backState: 'Nav',
          formMode: 'Edit',
          createOrEdit: 'Edit',
          documentEntity: 'utilization_reservationcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReservationEdit.html',
            controller: 'ReservationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReservationEdit/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Foglalás módosítása',
        },
      },
      'Utilization.ReservationView': {
        url: '/utilizationreservationview/{id:int}',
        params: {
          module: 'utilization',
          backState: 'main',
          formMode: 'View',
          createOrEdit: 'View',
          documentEntity: 'utilization_reservationview',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReservationEdit.html',
            controller: 'ReservationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReservationEdit/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Foglalás megtekintése',
        },
      },
      'Utilization.ReservationDuplicate': {
        url: '/utilizationreservationduplicate/{id:int}',
        params: {
          module: 'utilization',
          backState: 'main',
          formMode: 'Create',
          createOrEdit: 'Create',
          documentEntity: 'utilization_reservationcreate',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReservationEdit.html',
            controller: 'ReservationEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReservationDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          label: 'Foglalás másolása',
        },
      },
      'Utilization.ReportNav': {
        url: '/utilizationreportnav',
        params: {
          module: 'utilization',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'utilization_reportnav',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'UtilizationMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Utilization/ReportNav.html',
            controller: 'UtilizationReportNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Utilization/ReportListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Riportok',
          parent: 'Utilization',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('ReservationEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    '$scope',
    '$state',
    'WalService',
    '$uibModal',
    'HistoryService',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    '$q',
    function(
      $http,
      options,
      $stateParams,
      $scope,
      $state,
      walService,
      $uibModal,
      HistoryService,
      dasService,
      lockService,
      gridService,
      UIHelperService,
      $q
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationEditCtrl', stateParams);
      }
      var vm = this;

      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'Panelalapa',
        disableRunExpression: false,
      };
      vm.saveButtonHandling = function saveButtonHandling() {
        return !($stateParams.isFormReadOnly || vm.formModel.IsReadOnly);
      };
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.createOrEdit = $stateParams.createOrEdit;
      vm.currentRenEventNumber = options.RentEventNumber;
      vm.currentContractTypeId = options.ContractTypeId;
      vm.UIHelperService = UIHelperService;

      if (vm.createOrEdit == 'Edit') vm.isDateEnabled = 'False';
      vm.currentRentStatusId = vm.formModel.RentStatusId;
      $scope.isInvoiceGenerateEnabled = isInvoiceGenerateEnabled;
      vm.serviceSubGridItemIsInvoiced = serviceSubGridItemIsInvoiced;

      vm.WAL = WAL;

      vm.messages = options.pageModel.Messages;

      vm.generateInvoice = generateInvoice;

      vm.isDuplicate = isDuplicate;
      vm.History = History;
      vm.attachDocument = attachDocument;
      vm.reject = reject;
      vm.approve = approve;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;

      if (vm.createOrEdit === 'View') {
        vm.formModel.IsReadOnly = true;
      }
      vm.formModel.Discount = vm.formModel.Discount ?? 0;

      if (!vm.formModel.IsReadOnly) {
        lockService.initiateLock(vm.securedProgramId, vm.securedId);
      }

      vm.getDate = function(date) {
        if (!date instanceof Date) return date;
        var dd = date.getDate();
        var mm = date.getMonth() + 1; //January is 0!
        var yyyy = date.getFullYear();

        if (dd < 10) {
          dd = '0' + dd;
        }

        if (mm < 10) {
          mm = '0' + mm;
        }
        return yyyy + '-' + mm + '-' + dd;
      };
      vm.formModel.Date = vm.getDate(new Date(vm.formModel.Date));

      vm.setcolumtodatetime = SetGridColumnToDateTime(
        vm.pageModel.Grids,
        ['GridService'],
        ['StartDateTime', 'EndDateTime']
      );
      vm.pageModel.Fields.Comment.FormlyFieldDescriptor.templateOptions.rows = 3;
      vm.currentReservationStatusDate = vm.formModel.Date;

      if (['Edit', 'View'].includes(vm.createOrEdit)) {
        var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
          vm.pageModel.Tabs,
          vm.pageModel.Panels,
          vm.pageModel.Grids,
          ['PanelInvoice', 'PanelService', 'PanelStatus', 'PanelInvoiceRow', 'PanelDoc'],
          function(gridModel) {
            return {
              gridModel,
              transportData: { rentEventId: vm.formModel.RentEventId },
            };
          }
        );

        vm.subItemTabs = generatedGridTabs.tabs.filter(x => !x.gridName.includes('Row'));
        vm.subGridOptions = generatedGridTabs.gridOptions;
        vm.subGrids = generatedGridTabs.grids;
        vm.subGridOptions['GridService'].selectable = 'multiple';

        vm.subGridOptions.GridInvoice.dataSource.transport.read.data = function() {
          return { rentEventId: vm.formModel.RentEventId };
        };

        vm.subGridOptions.GridStatus.dataSource.transport.read.data = function() {
          return { rentEventId: vm.formModel.RentEventId };
        };

        angular.forEach(vm.subGridOptions['GridService'].columns, function(val, key) {});
      } else {
        vm.isDuplicate();
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      var customTypes = {};
      var customClasses = {};
      var customExpressionProperties = {
        RentStatusId: {
          'templateOptions.disabled': function() {
            return (
              vm.createOrEdit !== 'Edit' ||
              (vm.formModel.StatusCode && ['UTSUB', 'UTSDE', 'UTSDO', 'UTSSC'].includes(vm.formModel.StatusCode))
            );
          },
        },
        ContractTypeId: {
          'templateOptions.disabled': function() {
            return vm.createOrEdit === 'Edit';
          },
        },
        Date: {
          'templateOptions.disabled': function() {
            return vm.createOrEdit === 'Create' ? true : vm.isDateEnabled !== 'True';
          },
          'templateOptions.required': function() {
            return vm.createOrEdit === 'Create' ? false : vm.isDateEnabled === 'True';
          },
        },
      };

      var hideExpressions = {};
      var onChangeFunctions = {
        ReservationReasonTMId: function(selectedItem) {
          let isInvoicing = selectedItem.extraProperties?.find(x => x.key == 'IsInvoicing');
          if (selectedItem && !!isInvoicing) {
            vm.formModel.IsInvoicing = isInvoicing?.value?.toLocaleLowerCase() == 'true';
          }
        },
        RentLocationTMId: function(selectedItem) {
          if (selectedItem?.GridItem) {
            if (selectedItem.GridItem.ServiceId) {
              vm.formModel.RentLocationServiceId = selectedItem.GridItem.ServiceId;
            }
            if (selectedItem.GridItem.OtherServiceIds) {
              vm.formModel.RentLocationServiceId +=
                (selectedItem.GridItem.ServiceId ? ',' : '') + selectedItem.GridItem.OtherServiceIds;
            }
          }
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.setFunctions.dataSourceRead();
          vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
            vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.value().Value
          );
        },
        ServiceId: function(selectedItem) {
          if (selectedItem) {
          }
          vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.setFunctions.dataSourceRead();
          vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
            vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.value().Value
          );
        },
        RentStatusId: function(selectedItem) {
          if (selectedItem.extraProperties) {
            vm.rentStatusIsApproved = selectedItem.extraProperties['0'].value;
            if (selectedItem.key !== String(vm.currentRentStatusId)) {
              vm.isDateEnabled = 'True';
              vm.formModel.Date = vm.getDate(new Date());
            } else {
              vm.isDateEnabled = 'False';
              vm.formModel.Date = vm.currentReservationStatusDate;
            }
          }
        },
        PriceListRowId: function(selectedItem) {
          if (selectedItem?.GridItem) {
            vm.formModel.UnitName = selectedItem.GridItem.UnitName ?? '';
          }
        },
      };
      var customCallbackFunctions = {
        IsInvoicing: function(selectedItem) {
          vm.pageModel.Fields.RentStatusId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };
      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      var onBlurFunctions = {
        StartDateTime: function() {
          vm.pageModel.Fields.ReservationReasonTMId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };
      Object.entries(vm.pageModel.Fields).forEach(x => {
        if (x[1]?.FormlyFieldDescriptor?.type == 'kendoNTB') {
          onBlurFunctions[x[0]] = function() {
            vm.minMax(vm, 'formModel');
          };
        }
      });
      var syncValidators = {
        ContactEmail: {
          email: function(modelValue) {
            return sysEmailValidate(modelValue);
          },
        },
        StartDateTime: {
          ReservationStartDateTimeValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var StartDateTimeValue = new moment(
              modelValue,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            var EndDateTimeValue = new moment(
              vm.formModel.EndDateTime,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            if (isNaN(EndDateTimeValue)) {
              return true;
            }
            return EndDateTimeValue.isAfter(StartDateTimeValue);
          },
        },
        EndDateTime: {
          ReservationEndDateTimeValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var EndDateTimeValue = new moment(
              modelValue,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            var StartDateTimeValue = new moment(
              vm.formModel.StartDateTime,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            if (isNaN(StartDateTimeValue)) {
              return true;
            }
            return EndDateTimeValue.isAfter(StartDateTimeValue);
          },
        },
        NumberOfPerson: {
          ReservationNumberOfPerson: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            if (!vm.formModel.DiscNumberOfPerson) {
              return true;
            }
            return parseInt(modelValue) >= parseInt(vm.formModel.DiscNumberOfPerson);
          },
        },
        DiscNumberOfPerson: {
          ReservationDiscNumberOfPerson: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            if (!vm.formModel.NumberOfPerson) {
              return true;
            }
            return parseInt(vm.formModel.NumberOfPerson) >= parseInt(modelValue);
          },
        },
      };
      var parsers = {};
      var formatters = {};

      var numericOptions = {
        NumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        DiscNumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        Quantity: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 1,
        },
        Discount: {
          format: '##.## \\%',
          max: 100,
          min: 0,
        },
      };
      vm.minMax = function(scope, model) {
        Object.entries(vm.pageModel.Fields).forEach(x => {
          if (x[1]?.FormlyFieldDescriptor?.type == 'kendoNTB') {
            let opt = x[1].FormlyFieldDescriptor?.templateOptions?.options;
            if (Number(opt?.max) != NaN && opt.max < scope[model][x[0]]) {
              scope[model][x[0]] = opt.max;
            } else if (Number(opt?.min) != NaN && opt.min > scope[model][x[0]]) {
              scope[model][x[0]] = opt.min;
            }
          }
        });
      };
      var inputMasks = {};
      var dynamicQueryParameters = {
        RentStatusId: function() {
          var result = [
            {
              key: 'RentStatusId',
              value: vm.formModel.RentStatusId,
            },
            {
              key: 'RentEventId',
              value: vm.formModel.RentEventId,
            },
            {
              key: 'IsInvoicing',
              value: vm.formModel.IsInvoicing,
            },
          ];
          return result;
        },
      };
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      if (!vm.formModel.IsReadOnly) {
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
      if (vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.pageModel.Fields.ReservationReasonTMId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        date: function() {
          return vm.formModel.StartDateTime;
        },
      };
      function priceListRowIdWhereCondition() {
        let date = vm.formModel.CreatedDate ?? Date.now(),
          formatedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
        return (
          "ValidFrom~lte~datetime'" +
          formatedDate +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          formatedDate +
          "')~and~Net~isnotnull~and~ServiceId~eq~'" +
          (vm.formModel.ServiceId?.Value ?? 0) +
          "'"
        );
      }
      vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.options.whereCondition = priceListRowIdWhereCondition;

      function serviceIdWhereCondition() {
        return "ServiceId~in~'" + (vm.formModel.RentLocationServiceId ?? '') + "'";
      }
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = serviceIdWhereCondition;

      function partnerIdWhereCondition() {
        return 'ValidTo~isnull';
      }
      vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.whereCondition = partnerIdWhereCondition;

      function isDuplicate() {
        return vm.activeSubItemTab !== 0;
      }

      vm.addSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;

        var name = 'Reservation' + urlPrefix.replace(/grid/gi, '').replace(/reservation/gi, '');
        const nameWithEditSuffix = name + 'Edit';
        name = name + 'Create';

        var url = 'Utilization/' + name + '?rentEventId=' + vm.formModel.RentEventId;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/' + nameWithEditSuffix + '.html',
          controller: nameWithEditSuffix + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            rentEventId: vm.formModel.RentEventId,
            model: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.subGrids[urlPrefix].dataSource.read();
        });
      };

      vm.duplicateSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var tab = urlPrefix.replace(/grid/gi, '').replace(/reservation/gi, '');
        const nameWithEditSuffix = 'Reservation' + tab + 'Edit';
        var name = 'Reservation' + tab + 'Duplicate';
        var selectedItem = GetSelectedItem(urlPrefix);

        var paramName = 'entEventServiceId';
        if (tab === 'Doc') {
          paramName = 'eservationDocId';
        }

        if (selectedItem) {
          var url =
            'Utilization/' +
            name +
            '?rentEventId=' +
            vm.formModel.RentEventId +
            '&r' +
            paramName +
            '=' +
            selectedItem['R' + paramName];

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Utilization/SubItems/' + nameWithEditSuffix + '.html',
            controller: nameWithEditSuffix + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              rentEventId: vm.formModel.RentEventId,
              model: RouteResolveFunc(url),
            },
            param: {
              test: 'dsd',
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrids[urlPrefix].dataSource.read();
          });
        }
      };

      vm.editSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var tab = urlPrefix.replace(/grid/gi, '').replace(/reservation/gi, '');
        var name = 'Reservation' + tab + 'Edit';
        var selectedItem = GetSelectedItem(urlPrefix);
        var paramName = 'entEventServiceId';
        if (tab === 'Doc') {
          paramName = 'eservationDocId';
        }

        if (selectedItem) {
          var url =
            'Utilization/' +
            name +
            '?rentEventId=' +
            vm.formModel.RentEventId +
            '&r' +
            paramName +
            '=' +
            selectedItem['R' + paramName];

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Utilization/SubItems/' + name + '.html',
            controller: name + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              rentEventId: vm.formModel.RentEventId,
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function(isSaved) {
            vm.subGrids[urlPrefix].dataSource.read();
            if (tab === 'Service' && isSaved && selectedItem.IsMainService) {
              $state.go('Utilization.ReservationEdit', { id: vm.formModel.RentEventId }, { reload: true });
            }
          });
        }
      };
      vm.viewSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var tab = urlPrefix.replace(/grid/gi, '').replace(/reservation/gi, '');
        var name = 'Reservation' + tab;
        var selectedItem = GetSelectedItem(urlPrefix);

        var paramName = 'entEventServiceId';
        if (tab === 'Doc') {
          paramName = 'eservationDocId';
        }

        if (selectedItem) {
          var url =
            'Utilization/' +
            name +
            'View' +
            '?rentEventId=' +
            vm.formModel.RentEventId +
            '&r' +
            paramName +
            '=' +
            selectedItem['R' + paramName];
          name += 'Edit';
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Utilization/SubItems/' + name + '.html',
            controller: name + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              rentEventId: vm.formModel.RentEventId,
              model: RouteResolveFunc(url),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.subGrids[urlPrefix].dataSource.read();
          });
        }
      };
      vm.deleteSubItem = function() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;

        var name = 'Reservation' + urlPrefix.replace(/grid/gi, '').replace(/reservation/gi, '');
        const nameWithEditSuffix = name + 'Delete';

        var selectedItem = GetSelectedItem(urlPrefix);

        if (selectedItem) {
          var url = 'Utilization/' + nameWithEditSuffix + '?id=' + selectedItem.RentEventServiceId;

          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get(url).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.subGrids[urlPrefix].dataSource.read();
                  });
                },
              },
            },
          });
        }
      };

      function generateInvoice() {
        var url = 'Utilization/InvoiceGenFromReservationModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/InvoiceGenFromReservation.html',
          controller: 'InvoiceGenFromReservationCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: [vm.formModel.RentEventId] }),
            callFromNav: false,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function serviceSubGridItemIsInvoiced() {
        return true;
      }

      vm.save = function() {
        var defer = $q.defer();
        vm.minMax(vm, 'formModel');
        var param = {
          model: vm.formModel,
        };
        $http
          .post('Utilization/Reservation' + vm.createOrEdit, param)
          .then(function successCallback(response) {
            if (!vm.formModel.IsReadOnly) {
              lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            }
            toastr.success(vm.messages.SaveSuccessful);
            //defer.resolve();
            let id = !!response.data?.id ? response.data.id : vm.formModel.RentEventId;
            if (id > 0) {
              $state.go('Utilization.ReservationEdit', { id: id }, { reload: true });
            } else {
              vm.back();
            }
          })
          .catch(function errorCallback(response) {
            defer.resolve();
            toastr.error(vm.messages.SaveFailed);
          });
        return defer.promise;
      };

      vm.back = function() {
        if (!vm.formModel.IsReadOnly) {
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        }
        $state.go('Utilization.ReservationNav');
      };
      function attachDocument() {
        var urlPrefix = vm.subItemTabs[vm.activeSubItemTab].gridName;
        var selectedItem = GetSelectedItem(urlPrefix);
        switch (vm.activeSubItemTab) {
          case 0: // Szolgáltatás
            dasService.NavigateToDas(
              vm.messages,
              'Utilization.DasDocumentsNav',
              'FlgReservationServiceView',
              selectedItem.RentEventServiceId
            );
            break;
          case 3: // Generált Dokumentumok
            dasService.NavigateToDas(
              vm.messages,
              'Utilization.DasDocumentsNav',
              'FlgReservationDocView',
              selectedItem.ReservationDocId
            );
            break;
          default:
            break;
        }
      }

      function History() {
        // TODO
        HistoryService.NavigateToHistory('FlgReservation', $state.params.id, vm, $state);
      }

      function GetSelectedItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function GetSelectedItems(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);

        if (selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems;
        }
      }

      function isInvoiceGenerateEnabled() {
        var selectedItems = GetSelectedItems('GridReservationService');

        if (selectedItems) {
          var btn = document.getElementById('generateInvoiceBtn');

          if (btn) {
            btn.disabled = false;
          }
        } else {
          var btn = document.getElementById('generateInvoiceBtn');

          if (btn) {
            btn.disabled = true;
          }
        }
      }

      var rentEventIdArray = [];
      rentEventIdArray.push(vm.formModel.RentEventId);

      function approve() {
        var url = 'Utilization/ReservationApprovalModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/ReservationApproval.html',
          controller: 'ReservationApprovalCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: rentEventIdArray }),
            callFromNav: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function reject() {
        var url = 'Utilization/ReservationRejectionModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/ReservationRejection.html',
          controller: 'ReservationRejectionCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: rentEventIdArray }),
            callFromNav: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }
      function WAL() {
        switch (vm.activeSubItemTab) {
          case 0: // Szolgáltatás
            walService.NavigateToWal('Utilization', 'ReservationMODServiceWal', 'FlgReservationServiceView');
            break;
          case 3: // Generált Dokumentumok
            walService.NavigateToWal('Utilization', 'ReservationMODDocWal', 'FlgReservationDocView');
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReservationNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$uibModal',
    '$filter',
    'AuthService',
    'HistoryService',
    'DasService',
    'UIHelperService',
    'gridService',
    function(
      $scope,
      options,
      $http,
      $state,
      walService,
      $uibModal,
      $filter,
      authService,
      HistoryService,
      dasService,
      UIHelperService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationNavCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.createReservation = createReservation;
      vm.editReservation = editReservation;
      vm.viewReservation = viewReservation;
      vm.deleteReservation = deleteReservation;
      vm.duplicateReservation = duplicateReservation;
      vm.calendarView = calendarView;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      vm.generateInvoice = generateInvoice;
      vm.rejectItems = rejectItems;
      vm.approveItems = approveItems;
      vm.mainGridSelectedItem = null;

      vm.mainGridIdField = vm.pageModel.Grids['GridReservation'].IdColumn;
      vm.mainGrid = $('#GridReservation').data('kendoGrid');

      vm.getGenButtonState = function() {
        return (
          !vm.mainGrid ||
          !vm.mainGrid.selectedItems ||
          _.isEmpty(vm.mainGrid.selectedItems) ||
          Object.values(vm.mainGrid.selectedItems).some(function(item) {
            return item.StatusCode != 'UTSTB' || item.IsInvoicing == false;
          })
        );
      };

      vm.getApproveButtonState = function() {
        var statusCode = null;
        return (
          !vm.mainGrid ||
          !vm.mainGrid.selectedItems ||
          _.isEmpty(vm.mainGrid.selectedItems) ||
          Object.values(vm.mainGrid.selectedItems).some(function(item) {
            if (!statusCode) {
              statusCode = item.StatusCode;
            }
            return item.StatusCode != statusCode || !item.IsApprove;
          })
        );
      };

      vm.getRejectButtonState = function() {
        var statusCode = null;
        return (
          !vm.mainGrid ||
          !vm.mainGrid.selectedItems ||
          _.isEmpty(vm.mainGrid.selectedItems) ||
          Object.values(vm.mainGrid.selectedItems).some(function(item) {
            if (!statusCode) {
              statusCode = item.StatusCode;
            }
            return !item.IsApprove || !item.IsFirstApproved || item.StatusCode != statusCode;
          })
        );
      };

      vm.getEditButtonState = function() {
        return (
          !vm.mainGrid ||
          !vm.mainGridSelectedItem ||
          (vm.mainGridSelectedItem.IsInvoicing === true &&
            (vm.mainGridSelectedItem.StatusCode === 'UTSUB' || vm.mainGridSelectedItem.StatusCode === 'UTSDO'))
        );
      };
      // Kendo-grid reference for main GRID
      // vm.mainGridOptions = getGridOptions(
      //   options.pageModel.Grids.GridReservation,
      //   'Utilization/ReservationList/',
      //   function() {
      //     vm.subGrids[vm.subItemTabs[vm.activeSubItemTab]?.gridName]?.dataSource?.read();
      //   }
      // );
      vm.setcolumtodatetime = SetGridColumnToDateTime(
        vm.pageModel.Grids,
        ['GridService'],
        ['StartDateTime', 'EndDateTime']
      );
      vm.setcolumtodatetime = SetGridColumnToDateTime(
        vm.pageModel.Grids,
        ['GridReservation'],
        ['StartDateTime', 'EndDateTime']
      );
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelInvoice', 'PanelService', 'PanelStatus', 'PanelInvoiceRow', 'PanelReservation', 'PanelDoc'],
        function(gridModel) {
          return {
            gridModel,
            transportData: function() {
              if (gridModel.Name !== 'GridReservation') {
                return { rentEventId: GetSelectedGridItems(vm.mainGrid)[0]?.RentEventId };
              }
              return null;
            },
            selectFunction: function(selectedItem) {
              if (gridModel.Name === 'GridReservation') {
                vm.mainGridSelectedItem = GetSelectedItem();
                vm.subGrids[vm.subItemTabs[vm.activeSubItemTab]?.gridName]?.dataSource?.read();
              }
            },
          };
        }
      );
      function selectHandlerCore() {
        $scope.$applyAsync();
      }
      vm.subItemTabs = generatedGridTabs.tabs.filter(
        x => !x.gridName.includes('Row') && x.gridName !== 'GridReservation'
      );
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;
      vm.mainGrid = vm.subGrids['GridReservation'];
      vm.mainGridOptions = generatedGridTabs.tabs.find(x => x.name == 'TabReservation');

      gridService.setupMultiSelect(vm.mainGridOptions.kendoConfig, {
        idField: 'RentEventId',
        selectHandler: selectHandlerCore,
        selectAllHandler: selectHandlerCore,
      });

      // Actions

      vm.back = function() {
        $state.go('main');
      };

      function createReservation() {
        $state.go('Utilization.ReservationCreate');
      }

      function editReservation() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.ReservationEdit', { id: selectedItem.RentEventId });
        }
      }

      function viewReservation() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.ReservationView', { id: selectedItem.RentEventId });
        }
      }

      function duplicateReservation() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.ReservationDuplicate', { id: selectedItem.RentEventId });
        }
      }

      function deleteReservation() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Utilization/ReservationDelete/' + selectedItem.RentEventId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.mainGrid.dataSource.read();
                  });
                },
              },
            },
          });
        }
      }

      function generateInvoice() {
        var selectedItems = vm.mainGrid.selectedIds;
        if (!selectedItems || selectedItems.length == 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }

        var url = 'Utilization/InvoiceGenFromReservationModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/InvoiceGenFromReservation.html',
          controller: 'InvoiceGenFromReservationCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: selectedItems }),
            callFromNav: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function approveItems() {
        var selectedItems = vm.mainGrid.selectedIds;
        if (!selectedItems || selectedItems.length == 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }

        var url = 'Utilization/ReservationApprovalModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/ReservationApproval.html',
          controller: 'ReservationApprovalCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: selectedItems }),
            callFromNav: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function rejectItems() {
        var selectedItems = vm.mainGrid.selectedIds;
        if (!selectedItems || selectedItems.length == 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return;
        }

        var url = 'Utilization/ReservationRejectionModal';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Utilization/SubItems/ReservationRejection.html',
          controller: 'ReservationRejectionCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            model: RouteResolveFunc(url, { idList: selectedItems }),
            callFromNav: true,
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {});
      }

      function calendarView() {
        var selectedItem = GetSelectedItem();
        if (selectedItem) {
          $state.go('Utilization.ReservationCalendarView', { id: selectedItem.ReservationId });
        }
      }

      function GetSelectedItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);

        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        if (!!id) {
          dasService.NavigateToDas(vm.messages, 'Utilization.DasDocumentsNav', 'FlgReservation', id);
        }
      }

      function WAL() {
        walService.NavigateToWal('Utilization', 'ReservationNavWal', 'FlgReservationView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          HistoryService.NavigateToHistory('FlgReservation', selectedItems, vm, $state, true);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ReservationServiceEditCtrl', [
    '$http',
    'model',
    'FileUploadService',
    '$state',
    '$stateParams',
    '$uibModal',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'rentEventId',
    'LockService',
    function(
      $http,
      model,
      fus,
      $state,
      $stateParams,
      $uibModal,
      $scope,
      dasService,
      uibModalInstance,
      rentEventId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationServiceEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.Dto;
      vm.reservationServiceModel = model.Dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      if (vm.formModel.ModelState == 1) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
      //Set default values
      if (vm.reservationServiceModel.ModelState === 2) {
        vm.modalTitle = vm.pageModel.Labels.LabelTitle.Title;
      } else {
        vm.modalTitle = vm.pageModel.Labels.LabelEditTitle.Title;
      }

      // MenuItems
      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = function() {
        var id = vm.formModel.ReservationServiceId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgRentEventService', id);
      };

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        Weeks: {
          'templateOptions.disabled': function() {
            return vm.reservationServiceModel.ModelState !== 2 || vm.reservationServiceModel.Occasion <= 1;
          },
        },
        Days: {
          'templateOptions.disabled': function() {
            return vm.reservationServiceModel.ModelState !== 2 || vm.reservationServiceModel.Occasion <= 1;
          },
        },
        Occasion: {
          'templateOptions.disabled': function() {
            return vm.reservationServiceModel.ModelState !== 2;
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ServiceId: function(selectedItem) {
          if (selectedItem) {
          }
          vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.setFunctions.dataSourceRead();
          vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
            vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.value().Value
          );
        },
        PriceListRowId: function(selectedItem) {
          if (selectedItem?.GridItem) {
            vm.formModel.UnitName = selectedItem.GridItem.UnitName ?? '';
          } else {
            let tempWhereCondition = "~and~PriceListRowId~eq~'" + (vm.formModel.PriceListRowId?.Value ?? 0) + "'";
            this.getFunctions.getRows(function(response) {
              if (response.data?.Data?.length > 0) {
                vm.formModel.UnitName = response.data.Data[0]['UnitName'];
              }
            }, tempWhereCondition);
          }
        },
        Quantity: function() {
          if (vm.formModel.Quantity < 1) {
            vm.formModel.Quantity = 1;
          } else if (vm.formModel.Quantity > 100) {
            vm.formModel.Quantity = 100;
          }
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}

      var syncValidators = {
        StartDateTime: {
          ReservationStartDateTimeValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var StartDateTimeValue = new moment(
              modelValue,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            var EndDateTimeValue = new moment(
              vm.formModel.EndDateTime,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            if (isNaN(EndDateTimeValue)) {
              return true;
            }
            return EndDateTimeValue.isAfter(StartDateTimeValue);
          },
        },
        EndDateTime: {
          ReservationEndDateTimeValidator: function(modelValue) {
            if (!modelValue) {
              return true;
            }
            var EndDateTimeValue = new moment(
              modelValue,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            var StartDateTimeValue = new moment(
              vm.formModel.StartDateTime,
              kendo
                .culture()
                .calendar.patterns.g.toUpperCase()
                .replace(':MM', ':mm')
            );
            if (isNaN(StartDateTimeValue)) {
              return true;
            }
            return EndDateTimeValue.isAfter(StartDateTimeValue);
          },
        },
        NumberOfPerson: {
          ReservationNumberOfPerson: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            if (!vm.formModel.DiscNumberOfPerson) {
              return true;
            }
            return parseInt(modelValue) >= parseInt(vm.formModel.DiscNumberOfPerson);
          },
        },
        DiscNumberOfPerson: {
          ReservationDiscNumberOfPerson: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            if (!vm.formModel.NumberOfPerson) {
              return true;
            }
            return parseInt(vm.formModel.NumberOfPerson) >= parseInt(modelValue);
          },
        },
      };

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {
        NumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        DiscNumberOfPerson: {
          decimals: 0,
          format: 'n0',
          max: 999999,
          min: 0,
        },
        Quantity: {
          decimals: 2,
          format: 'n2',
          max: 100,
          min: 1,
        },
        Discount: {
          format: '##.## \\%',
          max: 100,
          min: 0,
        },
      };
      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////////////// [ Dynamic Form generation ] //////////////////////////////
      // Set editability of fields based on controllerOptions

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      function priceListRowIdWhereCondition() {
        let date = vm.formModel.StartDateTime ?? Date.now(),
          formatedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
        return (
          "ValidFrom~lte~datetime'" +
          formatedDate +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          formatedDate +
          "')~and~Net~isnotnull~and~ServiceId~eq~'" +
          (vm.formModel.ServiceId?.Value ?? 0) +
          "'"
        );
      }
      vm.pageModel.Fields.PriceListRowId.FormlyFieldDescriptor.templateOptions.options.whereCondition = priceListRowIdWhereCondition;

      function serviceIdWhereCondition() {
        return "ServiceId~in~'" + (vm.formModel.RentLocationServiceId ?? '') + "'";
      }
      vm.pageModel.Fields.ServiceId.FormlyFieldDescriptor.templateOptions.options.whereCondition = serviceIdWhereCondition;
      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      ////////////////////////////////////////////////////////////////////////////////////////
      ///////////////////// [ Dynamic executor functions for main item ] /////////////////////
      /// Transistions to a new state to create a new partner

      /// Saves the current main item
      function saveItem() {
        var params = { model: vm.reservationServiceModel, id: vm.reservationServiceModel.RentEventServiceId };
        $http
          .post('Utilization/ReservationServiceEdit', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close(true);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close(false);
      }

      vm.isCollapsed1 = false;
      vm.isCollapsed2 = false;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ReservationDocEditCtrl', [
    '$http',
    'model',
    '$stateParams',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $stateParams, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationDocEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.Dto;
      vm.rentEventDocModel = model.Dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.modelState = model.Dto.ModelState;

      var dtoState = ['', 'View', 'Create', 'Edit', 'Duplicate'];
      if ([3].includes(vm.modelState)) {
        vm.pageModel.Actions['Save'] = vm.pageModel.Actions['ActionSave'];
      } else {
        vm.pageModel.Actions['Save'] = vm.pageModel.Actions['ActionGenerate'];
      }
      vm.modalTitle =
        vm.pageModel.Labels['LabelTitle'].Title + ' ' + vm.pageModel.Labels['Label' + dtoState[vm.modelState]].Title;

      vm.save = saveItem;
      vm.cancel = cancelItem;
      vm.attachDocument = function() {
        var id = vm.formModel.RentEventServiceId;
        dasService.NavigateToDas(vm.messages, 'Utility.DasDocumentsNav', 'FlgReservationDoc', id);
      };

      var dynamicQueryParameters = {
        TemplateId: function() {
          var result = [
            {
              key: 'DocType',
              value: vm.formModel.DocTypeId,
            },
            {
              key: 'DocTypeCode',
              value: 'reservation',
            },
          ];
          if ([3].includes(vm.modelState)) {
            result.push({
              key: 'TemplateId',
              value: vm.formModel.TemplateId,
            });
          }
          return result;
        },
      };

      var customExpressionProperties = {
        TemplateId: {
          'templateOptions.disabled': function() {
            return typeof vm.formModel.DocTypeId === 'undefined' || ![2, 4].includes(vm.modelState);
          },
        },
        DocTypeId: {
          'templateOptions.disabled': function() {
            return ![2, 4].includes(vm.modelState);
          },
        },
      };

      if (vm.modelState === 1) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var onChangeFunctions = {
        DocTypeId: function() {
          vm.pageModel.Fields.TemplateId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };
      var hideExpressions = {};
      var onBlurFunctions = {};
      var syncValidators = {};
      var parsers = {};
      var formatters = {};
      var numericOptions = {};
      var inputMasks = {};
      var customTypes = {};
      var customClasses = {};

      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      // function saveItem() {
      // var params = { model: vm.rentEventDocModel, id: vm.rentEventDocModel.RenservationDocId };
      // $http
      // .post('Utilization/ReservationDocEdit', params)
      // .then(function(response) {
      // toastr.success(vm.pageModel.Messages.SaveSuccessful);
      // lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
      // uibModalInstance.close();
      // })
      // .catch(function(response) {
      // toastr.error(vm.pageModel.Messages.SaveFailed);
      // });
      // }
      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
      function saveItem() {
        if (!isNaN(vm.formModel.TemplateId)) {
          saveAndGenerateReport();
        } else {
          $http
            .post('Contract/GetDocumentTemplateParamCount', {
              templateId: vm.formModel.TemplateId,
            })
            .then(
              function(res) {
                var result = res.data;
                saveAndGenerateReport();
              },
              function(err) {
                // TODO err
              }
            );
        }
      }

      function saveAndGenerateReport() {
        var params = { model: vm.rentEventDocModel };
        var states = ['', 'View', 'Create', 'Edit', 'Create'];
        $http
          .post('Utilization/ReservationDoc' + states[vm.modelState], params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            generateReport();
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      function generateReport() {
        if ([3].includes(vm.modelState)) {
          return;
        }
        $http
          .post('Template/GetTemplateData', {
            templateId: vm.formModel.TemplateId,
            id: { RentEventId: vm.formModel.RentEventId },
          })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
            },
            function(result) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            }
          );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ReservationRejectionCtrl', [
    '$http',
    'model',
    'callFromNav',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    function($http, model, callFromNav, $state, $stateParams, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationRejectionCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.rejectionModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;

      vm.save = save;
      vm.cancel = cancelItem;

      var customTypes = {};
      var customClasses = {};
      var customExpressionProperties = {};
      var hideExpressions = {};
      var onChangeFunctions = {};
      var onBlurFunctions = {};
      var syncValidators = {};
      var parsers = {};
      var formatters = {};
      var numericOptions = {};
      var inputMasks = {};

      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      function save() {
        $http
          .post('Utilization/ReservationRejection', vm.rejectionModel)
          .then(function(response) {
            toastr.success(vm.messages.SaveSuccessful);
            refreshPage();
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function refreshPage() {
        if (callFromNav) {
          $state.go('Utilization.ReservationNav', {}, { reload: true });
        } else {
          $state.go('Utilization.ReservationEdit', { id: vm.rejectionModel.RentEventIdList[0] }, { reload: true });
        }
      }

      function cancelItem() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('ReservationApprovalCtrl', [
    '$http',
    'model',
    'callFromNav',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    function($http, model, callFromNav, $state, $stateParams, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReservationApprovalCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.approvalModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.save = save;
      vm.cancel = cancelItem;

      vm.approvalModel.Email = vm.approvalModel.StatusCode === 'UTSTA';

      var customTypes = {};
      var customClasses = {};
      var customExpressionProperties = {};
      var hideExpressions = {
        Email: function($viewValue, $modelValue, scope) {
          return vm.approvalModel.StatusCode !== 'UTSTA';
        },
      };
      var onChangeFunctions = {};
      var onBlurFunctions = {};
      var syncValidators = {};
      var parsers = {};
      var formatters = {};
      var numericOptions = {};
      var inputMasks = {};

      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      function save() {
        $http
          .post('Utilization/ReservationApproval', vm.approvalModel)
          .then(function(response) {
            toastr.success(vm.messages.SaveSuccessful);
            refreshPage();
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function refreshPage() {
        if (callFromNav) {
          $state.go('Utilization.ReservationNav', {}, { reload: true });
        } else {
          $state.go('Utilization.ReservationEdit', { id: vm.approvalModel.RentEventIdList[0] }, { reload: true });
        }
      }

      function cancelItem() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UtilizationReportNavCtrl', [
    'options',
    '$state',
    'gridService',
    function(options, $state, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilizationReportNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.Dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      var hideExpressions = {
        Year: function($viewValue, $modelValue, scope) {
          return vm.formModel.ReportTypeCode !== 'UTRSU';
        },
        ServiceId: function($viewValue, $modelValue, scope) {
          return vm.formModel.ReportTypeCode !== 'UTRSU';
        },
      };
      InsertHideExpressions(vm.pageModel, hideExpressions);

      var onChangeFunctions = {
        ServiceId: function(selectedItem) {
          if (!!selectedItem && !!vm.formModel.Year && vm.formModel.ReportTypeCode === 'UTRSU') {
            vm.sumGrid.dataSource.read();
          }
        },
        Year: function(selectedItem) {
          if (!!selectedItem && !!vm.formModel.ServiceId && vm.formModel.ReportTypeCode === 'UTRSU') {
            vm.sumGrid.dataSource.read();
          }
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.downloadDisabled = function() {
        let grid = vm[(vm.formModel.ReportTypeCode == 'UTRCA' ? 'cap' : 'sum') + 'Grid'];
        return !grid?.dataItems().length;
      };

      vm.getReportType = function(field) {
        return vm.formModel.ReportTypeCode == field;
      };
      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        vm.pageModel.Grids,
        ['PanelReservationCap', 'PanelReservationSum'],
        function(gridModel) {
          return {
            gridModel,
            transportData: function() {
              if (gridModel.Name == 'GridReservationSum') {
                return { year: vm.formModel.Year, serviceId: vm.formModel.ServiceId };
              }
              return null;
            },
          };
        }
      );
      vm.subGrids = generatedGridTabs.grids;
      vm.capGrid = vm.subGrids['GridReservationCap'];
      vm.capGridOptions = generatedGridTabs.tabs.find(x => x.name == 'TabReservationCap');
      vm.sumGrid = vm.subGrids['GridReservationSum'];
      vm.sumGridOptions = generatedGridTabs.tabs.find(x => x.name == 'TabReservationSum');
      vm.addAggregateToReservationSum = function(withTags = true) {
        let template = "#= kendo.toString(sum, '\\#\\#,\\#') #";
        if (withTags) {
          template = "<span style='float:right; padding:5px 0;'>" + template + '</span>';
        }
        ['Gross', 'InvQuantity', 'NumberOfPerson', 'Quantity'].forEach(element =>
          vm.addAggregateToFooter(element, 'sum', template)
        );
        ['LocationName'].forEach(element => vm.addAggregateToFooter(element, 'sum', 'Összesen:'));
      };
      vm.addAggregateToFooter = function(field, type = 'sum', template) {
        gridService.addAggregateToFooter(generatedGridTabs.gridOptions.GridReservationSum, type, field, '', template);
      };

      vm.addAggregateToReservationSum();

      // Actions

      vm.back = function() {
        $state.go('main');
      };
      vm.download = function() {
        let grid = vm[(vm.formModel.ReportTypeCode == 'UTRCA' ? 'cap' : 'sum') + 'Grid'];
        grid.bind('excelExport', function(e) {
          e.workbook.fileName =
            vm.pageModel.Fields.ReportTypeCode.FormlyFieldDescriptor.templateOptions.options.dataSource
              .data()
              .find(x => x.key == vm.formModel.ReportTypeCode).text + '_riport.xlsx';
          var sheet = e.workbook.sheets[0];
          sheet.rows
            .filter(x => x.type == 'footer')
            .forEach(x => {
              for (var i = 0; i < x.cells.length; i++) {
                x.cells[i].bold = true;
                x.cells[i].textAlign = 'right';
                x.cells[i].value = x.cells[i].value.replaceAll(/<[^>]+>/gi, '');
              }
            });
        });
        grid.saveAsExcel();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UtilizationMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilizationMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'UtilizationMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {};
      ////////////////////////////////////////////////////////////////////////////////////////

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          //console.log("going to state with: " + JSON.stringify(vm.formModifiers));
          $state.go(vm.type + 'List', {
            formModifiers: vm.formModifiers[vm.type],
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('UtilizationMasterDataViewCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    'WalService',
    'DasService',
    function($scope, options, $http, $state, $stateParams, $uibModal, AuthService, walService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'UtilizationMasterDataViewCtrl', stateParams);
      }
      var vm = this;
      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.MDType = $stateParams.MDType;
      vm.secondMDType = $stateParams.secondMDType;
      vm.getMDType = function() {
        return vm.MDType;
      };
      vm.getSecondMDType = function() {
        return vm.secondMDType;
      };
      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      vm.back = function() {
        $state.go('Masterdata.Utilization');
      };

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1 };
      Object.freeze(vm.WhichGridEnum);

      vm.serviceCallerFunc = '';

      vm.isServiceEdit = false;
      vm.selectedgridItemId = 0;
      // MenuItems
      vm.create = createItem;
      vm.createSecondItem = createSecondItem;
      vm.edit = editItem;
      vm.editSecondItem = editSecondItem;
      vm.delete = deleteItem;
      vm.deleteSecondItem = deleteSecondItem;
      vm.duplicate = duplicateItem;
      vm.duplicateSecondItem = duplicateSecondItem;
      // vm.sort = sortItem;
      vm.sort = priorityRentStatus;
      vm.isDuplicateable = isItemDuplicateable;
      vm.isSortable = isItemSortable;
      vm.isEditDisabled = isEditDisabled;
      vm.isDuplicateDisabled = isDuplicateDisabled;
      vm.isDeleteDisabled = isDeleteDisabled;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.clickisValidDate = function() {
        vm.isValidDate = !vm.isValidDate;
        $('#MDVGrid')
          .data('kendoGrid')
          .dataSource.read();
      };
      // Dynamic grid configuration
      vm.gridOptions = getGridOptions(
        vm.pageModel.Grids['Grid' + vm.getMDType()],
        vm.getModulType() + 'MasterData/' + vm.getMDType() + 'List/',
        function() {
          if (vm.MDType == 'EquipmentGroup') {
            selectGridItem();
          }
        },
        function(e) {
          if (vm.MDType == 'ReservationReason' || vm.MDType == 'RentLocation') {
            return {
              isValidDate: vm.isValidDate,
            };
          }
        }
      );
      // Get Id column of Grid to perform data manipulation on selected item(s)
      vm.gridIdField = vm.pageModel.Grids['Grid' + vm.getMDType()].IdColumn;
      if (vm.getSecondMDType()) {
        vm.secondGridIdField = vm.pageModel.Grids['Grid' + vm.getSecondMDType()].IdColumn;
      }
      // Kendo-grid reference
      vm.grid = $('#MDVGrid').data('kendoGrid');

      //Szolgáltatások esetén a második grid inicializálása
      vm.secondGrid = $('MDVSecondGrid').data('kendoGrid');

      vm.getSelectedGridItemId = function() {
        return {
          id: vm.selectedgridItemId,
        };
      };

      if (vm.MDType == 'ServiceGroup') {
        vm.secondGridOptions = getGridOptions(
          vm.pageModel.Grids['GridService'],
          vm.getModulType() + 'MasterData/ServiceList',
          function() {},
          vm.getSelectedGridItemId
        );
      } else if (vm.MDType == 'PriceList') {
        vm.secondGridOptions = getGridOptions(
          vm.pageModel.Grids['GridPriceListRow'],
          vm.getModulType() + 'MasterData/PriceListRowList',
          function() {},
          vm.getSelectedGridItemId
        );
      }

      // Grid elem kiválasztás eseménykezelőjének definiálása
      $scope.gridOnSelection = function(kendoEvent) {
        if (vm.MDType == 'ServiceGroup') {
          // kiválasztott grid elem elővétele
          var selectedItem = kendoEvent.sender.select();
          var item = kendoEvent.sender.dataItem(selectedItem);
          // szervernek post-olandó adat eltárolása
          vm.selectedgridItemId = item.ServiceGroupId;
          // grid feltöltése paraméter értéke alapján a szerverről
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        } else if (vm.MDType == 'PriceList') {
          // kiválasztott grid elem elővétele
          var selectedItem = kendoEvent.sender.select();
          var item = kendoEvent.sender.dataItem(selectedItem);
          // szervernek post-olandó adat eltárolása
          vm.selectedgridItemId = item.PriceListId;
          // grid feltöltése paraméter értéke alapján a szerverről
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        }
      };

      if (vm.MDType == 'RentStatus') {
        angular.forEach(vm.gridOptions.columns, function(val, key) {
          if (val.field === 'IsApproved') {
            val.template = '<input disabled type="checkbox" #: IsApproved == 1 ? "checked" : "" # />';
          } else if (val.field === 'IsActive') {
            val.template = '<input disabled type="checkbox" #: IsActive == 1 ? "checked" : "" # />';
          }
        });
        vm.isEditDisabled = vm.isDuplicateDisabled = vm.isDeleteDisabled = function() {
          return !GetSelectedGridItems(vm.grid)[0]?.IsModifiable;
        };
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////
      vm.formModifiers = {
        Floor: {
          customTypes: {
            Ranking: 'maskedInput',
          },
          inputMasks: {
            Ranking: '9?9?9',
          },
        },
        Bank: {
          customTypes: {
            Bank: 'maskedInput',
          },
          inputMasks: {
            Bank: '99999999',
          },
        },
        Annexe: {
          customTypes: {
            Ordering: 'maskedInput',
          },
          inputMasks: {
            Ordering: '9?9?9?9?9?9?9?9?9?9',
          },
        },
        VatCode: {
          customTypes: {
            // "Vat": "kendoNTB"
          },
          inputMasks: {
            Vat: '9?9?9?,?9?9?9?9?9?9?',
          },
        },
      };

      if (vm.MDType == 'EquipmentGroup') {
        vm.pageModelR = options.pageModelR;

        function selectGridItem() {
          var selectedItems = GetSelectedGridItems(vm.grid);

          if (selectedItems.length === 0) return;

          vm.selectedgridItemId = selectedItems[0][vm.gridIdField];
          vm.equipmentRecipientGrid.dataSource.read();
        }

        vm.getSelectedGridItemEqGroupId = function() {
          return {
            EqGroupId: vm.selectedgridItemId,
          };
        };

        vm.equipmentRecipientGrid = options.pageModel.Grids.GridEquipmentRecipient;
        vm.equipmentRecipientGridOptions = getGridOptions(
          options.pageModel.Grids.GridEquipmentRecipient,
          'EquipmentMasterData/EquipmentRecipientList/',
          function() {},
          getSelectedGridItemEqGroupId
        );
      } else if (vm.MDType == 'ServiceGroup') {
        for (var i = 0; i < vm.gridOptions.columns.length; i++) {
          if (vm.gridOptions.columns[i].field == 'ServiceGroupTypeName') {
            vm.gridOptions.columns[i].hidden = true;
          }
        }
      }

      function isItemDuplicateable() {
        return vm.MDType !== 'ReservationReason';
      }
      function isDuplicateDisabled() {
        return false;
      }
      function isDeleteDisabled() {
        return false;
      }
      function isEditDisabled() {
        return false;
      }

      function isItemSortable() {
        if (vm.MDType == 'RentStatus') return true;
        return false;
      }

      ////////////////////////////////////////////////////////////////////////////////////////
      /////////////////////////// [ Dynamic executor functions ] /////////////////////////////
      /// Creates a new item for the current MasterData type
      function createItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Create/';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getMDType()],
            parameters: {
              id: 0,
              Operation: 'Create',
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      //Második grid esetén ez a create metódus fog futni
      function createSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
          if (
            typeof vm.selectedgridItemId == 'undefined' ||
            vm.selectedgridItemId == null ||
            vm.selectedgridItemId == 0
          ) {
            toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            return;
          }
        } else if (vm.getMDType() == 'PriceList') {
          vm.serviceCallerFunc = 'PriceListRow';
          if (
            typeof vm.selectedgridItemId == 'undefined' ||
            vm.selectedgridItemId == null ||
            vm.selectedgridItemId == 0
          ) {
            toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
            return;
          }
        }
        var url =
          vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Create?Id=' + vm.selectedgridItemId + '&subId=0';

        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataEdit.html',
          controller: 'MasterDataEditCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: RouteResolveFunc(url),
            formModifiers: vm.formModifiers[vm.getSecondMDType()],
            parameters: {
              id: vm.selectedgridItemId,
              Operation: 'Create',
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
        });
      }

      /// Edits the selected item of the MasterData grid for the current MasterData type
      function editItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Edit/' + encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
                Operation: 'Edit',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function editSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
        } else if (vm.getMDType() == 'PriceList') {
          vm.serviceCallerFunc = 'PriceListRow';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url =
            vm.getModulType() +
            'MasterData/' +
            vm.getSecondMDType() +
            'Edit?id=' +
            encodeURIComponent(vm.selectedgridItemId) +
            '&subId=' +
            encodeURIComponent(id);
          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataEdit.html',
            controller: 'MasterDataEditCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: id,
                Operation: 'Edit',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }

      // TODO kell-e multiselectes torles?
      /// Deletes the selected item(s) of the MasterData grid from the current MasterData type
      function deleteItem() {
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.gridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Delete/' + id).then(function() {
                    toastr.success('Sikeres törlés!'); // TODO ezt valami Labelből hozni
                    vm.grid.dataSource.read();
                  });
                  //.error(function () {
                  //    toastr.warning("sikertelen törlés", vm.pageModel.Messages.Warning);
                  //})
                },
              },
            },
          });
        }
      }

      function deleteSecondItem() {
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.pageModel.Messages.NotSelectedItem, vm.pageModel.Messages.Warning);
        } else {
          var id = selectedItems[0][vm.secondGridIdField];

          var dialogMessage = vm.pageModel.Messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Messages.Warning,
            buttons: {
              cancel: {
                label: vm.pageModel.Messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Messages.Confirm,
                className: 'btn-primary',
                callback: function() {
                  $http.get(vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Delete/' + id).then(function() {
                    toastr.success('Sikeres törlés!'); // TODO ezt valami Labelből hozni
                    vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
                  });
                },
              },
            },
          });
        }
      }

      /// Duplicates the selected item of the MasterData grid from the current MasterData type
      function duplicateItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'ServiceGroup';
        }
        var selectedItems = GetSelectedGridItems(vm.grid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.gridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getMDType()],
              parameters: {
                id: id,
                Operation: 'Duplicate',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.grid.dataSource.read();
          });
        }
      }

      function duplicateSecondItem() {
        if (vm.getMDType() == 'ServiceGroup') {
          vm.serviceCallerFunc = 'Service';
        }
        var selectedItems = GetSelectedGridItems(vm.secondGrid);
        if (selectedItems.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        } else {
          var id = selectedItems[0][vm.secondGridIdField];
          var url = vm.getModulType() + 'MasterData/' + vm.getSecondMDType() + 'Duplicate/' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/MasterData/MasterDataDuplicate.html',
            controller: 'MasterDataDuplicateCtrl',
            controllerAs: 'vm',
            resolve: {
              fModel: RouteResolveFunc(url),
              formModifiers: vm.formModifiers[vm.getSecondMDType()],
              parameters: {
                id: id,
                Operation: 'Duplicate',
              },
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function() {
            vm.secondGrid.dataSource.read({ id: vm.selectedgridItemId });
          });
        }
      }
      function priorityRentStatus() {
        var url = vm.ModulType + 'MasterData/' + vm.MDType + 'PriorityList';
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/Utilization/RentStatusPriorityEdit.html',
          controller: 'RentStatusPriorityCtrl',
          controllerAs: 'vm',
          resolve: {
            options: RouteResolveFunc(url),
            fModel: vm.pageModel,
            formModifiers: vm.formModifiers[vm.getMDType()],
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      function sortItem() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/MasterDataSort.html',
          controller: 'MasterDataSortCtrl',
          controllerAs: 'vm',
          resolve: {
            fModel: vm.pageModel,
            formModifiers: vm.formModifiers[vm.getMDType()],
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.grid.dataSource.read();
        });
      }

      function getSelectedId(second = false) {
        var id = 0;

        var selectedItems = GetSelectedGridItems(second ? vm.secondGrid : vm.grid);
        if (selectedItems.length == 0) {
          id = 0;
        } else {
          id = selectedItems[0][second ? vm.secondGridIdField : vm.gridIdField];
        }
        if (id == 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!'); // TODO ezt is Labelből kellene hozni
        }

        vm.selectedMainGridItemId = 0; // Különben a következő action gomb lenyomáskor rosszul veheti (a korábbi értéket)
        return id;
      }

      function attachDocument(second = false) {
        var id = getSelectedId(second),
          table;
        var _state =
          $state.$current.name.search('Masterdatamodule') === -1
            ? 'Masterdata.' + vm.ModulType + 'DasDocumentsNav'
            : 'Masterdatamodule.' + vm.ModulType + 'DasDocumentsNav';
        dasService.NavigateToDas(
          vm.messages,
          _state,
          'Flg' + (second ? vm.secondMDType : vm.MDType.includes('Utilization') ? 'PriceType' : vm.MDType),
          id
        );
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal(
              vm.ModulType + 'MasterData',
              vm.MDType + 'NavWal',
              'Flg' + (vm.MDType.includes('Utilization') ? 'PriceType' : vm.MDType)
            ); // vm.ModulType + "MasterData"; "MasterData" szükséges, különben nem működik
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            // Ebben a két törzsben van subgrid is:
            if (vm.MDType == 'PriceList') {
              walService.NavigateToWal(vm.ModulType + 'MasterData', 'PriceListRowNavWal', 'FlgPriceListRowView');
            } else if (vm.MDType == 'ServiceGroup') {
              walService.NavigateToWal(vm.ModulType + 'MasterData', 'ServiceNavWal', 'FlgServiceView');
            }
            break;
          }

          default: {
            break;
          }
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('RentStatusPriorityCtrl', [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    function($scope, $rootScope, mi, options, $http, $state, $stateParams, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'RentStatusPriorityCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        if (!vm.close) {
          event.preventDefault();
        }
      });
      $scope.$on('modal.closing', function(event, reason, closed) {
        if (!vm.close && reason !== 'escape key press') {
          event.preventDefault();
        }
      });
      vm.close = false;
      vm.options = options;
      vm.saveData = [];
      vm.optionsKey = [];
      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoLB',
          templateOptions: {
            required: true,
            label: '',
            options: FormlyCreateLBOption({
              url: 'UtilizationMasterdata/RentStatusPriorityList',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            reorder: function(e) {
              var items = e.items[0].parentNode.children;
              var temprows = [];
              for (var i = 0; i < items.length; i++) {
                if (items[i].id === '') {
                  continue;
                }
                if (e.dataItems[0].uid === items[i].id)
                  if (e.offset > 0) temprows[(i + e.offset) * 10 + 2] = items[i];
                  else temprows[(i + e.offset) * 10] = items[i];
                else temprows[i * 10 + 1] = items[i];
              }
              vm.saveData = [];
              if (vm.optionsKey.length < 1) {
                e.sender.dataSource._data.forEach(function(element) {
                  vm.optionsKey[element.uid] = element.key;
                });
              }
              var row = 1;
              temprows.forEach(function(element) {
                items[element.id].innerHTML = items[element.id].innerHTML.replace(/^[0-9]{1,2}\. {1,2}/i, '');
                vm.saveData[row - 1] = {
                  extraProperties: null,
                  key: vm.optionsKey[items[element.id].id],
                  text: items[element.id].innerHTML,
                  ModelState: 0,
                };
                var number = (row + '.').padEnd(4);
                items[element.id].innerHTML = number + items[element.id].innerHTML;
                row++;
              });
              vm.options = vm.saveData;
              console.log(vm.options);
            },
          },
        },
      ];

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }
      vm.save = function() {
        $http.post('UtilizationMasterData/RentStatusPrioritySave', vm.options).then(
          function(response) {
            toastr.success('Státuszok prioritásának mentése sikeresen megtörtént!'); // TODO általános label
            vm.close = true;
            mi.close();
          },
          function(response) {
            //toastr.error(vm.pageModel.Labels["LabelTitle"].Title + " mentése nem jött össze...!", "Gubi van!"); // TODO általános label
            //mi.close();
          }
        );
      };

      vm.cancel = function() {
        vm.close = true;
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('MasterDataSortCtrl', [
    '$uibModalInstance',
    '$http',
    'fModel',
    'formModifiers',
    '$stateParams',
    'AuthService',
    '$scope',
    function(mi, $http, fModel, formModifiers, $stateParams, AuthService, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'MasterDataSortCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = fModel;
      vm.formModifiers = formModifiers;
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      if (!!vm.formModifiers) {
        InsertCustomClasses(vm.pageModel, vm.formModifiers.customClasses);
        InsertFormatters(vm.pageModel, vm.formModifiers.formatters);
        InsertParsers(vm.pageModel, vm.formModifiers.parsers);
        InsertInputMasks(vm.pageModel, vm.formModifiers.inputMasks);
        InsertCustomTypes(vm.pageModel, vm.formModifiers.customTypes);
        InsertHideExpressions(vm.pageModel, vm.formModifiers.hideExpressions);
        InsertOnChangeFunctions(vm.pageModel, vm.formModifiers.onChangeFunctions);
      }
      ////////////////////////////////////////////////////////////////////////////////////////

      vm.formModel = fModel.dto;
      vm.MDType = $stateParams.MDType;

      vm.ModulType = $stateParams.ModulType;
      vm.getModulType = function() {
        return vm.ModulType;
      };

      if (vm.MDType === 'RentStatus') {
        vm.pageModel.Labels['LabelTitle'].Title = 'Státuszok sorbarendezése';
        vm.gridOptions = getGridOptions(
          vm.pageModel.Grids['Grid' + vm.MDType + 'Sort'],
          vm.ModulType + 'MasterData/' + vm.MDType + 'List/',
          function() {
            if (vm.MDType === 'EquipmentGroup') {
              selectGridItem();
            }
          }
        );

        vm.gridIdField = vm.pageModel.Grids['Grid' + vm.MDType + 'Sort'].IdColumn;

        // Kendo-grid reference
        vm.grid = $('#SortableGrid').data('kendoGrid');
      }

      //Kendo sort:
      $scope.$on('kendoRendered', function(e) {
        vm.grid.table.kendoSortable({
          filter: '>tbody >tr',
          hint: function(element) {
            //customize the hint
            var table = $('<table style="width: 600px;" class="k-grid k-widget"></table>'),
              hint;
            table.append(element.clone()); //append the dragged element
            table.css('opacity', 0.7);
            return table; //return the hint element
          },
          cursor: 'move',
          placeholder: function(element) {
            return $('<tr colspan="4" class="placeholder"></tr>');
          },
          change: function(e) {
            var skip = vm.grid.dataSource.skip(),
              oldIndex = e.oldIndex + skip,
              newIndex = e.newIndex + skip,
              data = vm.grid.dataSource.data(),
              dataItem = vm.grid.dataSource.getByUid(e.item.data('uid'));

            vm.grid.dataSource.remove(dataItem);
            vm.grid.dataSource.insert(newIndex, dataItem);
          },
        });
      });

      vm.save = function() {
        var gridMixedValues = vm.grid.dataSource._data;
        var gridValues = [];
        //Minden grid elemen végigmegyek => hozzáadom egy listához. Ezzel a listával kell visszatérni.
        gridMixedValues.forEach(function(row) {
          var r = {};
          r.Color = row.Color;
          r.IsActive = row.IsActive;
          r.IsApproved = row.IsApproved;
          r.Name = row.Name;
          r.RentStatusId = row.RentStatusId;
          r.Ranking = row.Ranking;
          gridValues.push(r);
        });

        $http({
          method: 'POST',
          url: vm.ModulType + 'MasterData/' + vm.MDType + 'SortSave',
          params: {
            //Grid értékeinek átadása
            grid: gridValues,
          },
        }).then(function successCallback(response) {
          toastr.success(vm.pageModel.Labels['LabelTitle'].Title + ' mentése sikeresen megtörtént!'); // TODO általános label
          mi.close();
        });
      };

      vm.cancel = function() {
        mi.dismiss('cancel');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BuildingConstructionNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'WalService',
    'HistoryService',
    'DasService',
    'gridService',
    'UIHelperService',
    function(
      $scope,
      options,
      $http,
      $state,
      $uibModal,
      walService,
      HistoryService,
      dasService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingConstructionNavCtrl', stateParams);
      }
      var vm = this;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.UIHelperService = UIHelperService;

      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;
      vm.UIHelperService.setDefaultSidebarStatus();
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      vm.mainGridIdField = 'PropertyId';
      vm.mainGrid = $('#mainGrid').data('kendoGrid');
      vm.selectedMainGridItemId = 0;
      vm.selectedTestGridId = 0;

      // Main / SubGrid általános lekérdező megkülönböztetésére
      vm.WhichGridEnum = { MainGrid: 0, SubGrid: 1, SecondarySubGrid: 2 };
      Object.freeze(vm.WhichGridEnum);

      vm.back = function() {
        $state.go('main');
      };

      // Kendo-grid reference for main GRID
      vm.mainGridOptions = getGridOptions(options.pageModel.Grids.GridPyramid, 'Construction/PyramidList/', function() {
        changeMainGridFilter(vm.mainGrid);
      });

      ////////// setting unitId param ///////////////////////////////////
      vm.getSelectedMainGridItemId = function() {
        return {
          targetPropertyId: vm.selectedMainGridItemId,
        };
      };

      vm.activeSubItemTab = 0;

      // Kendo-grid reference for sub GRIDs
      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelBuildingConstruction', 'PanelBuildingExamination'],
        function(gridModel) {
          if (gridModel.Name === 'GridBuildingConstruction') {
            gridModel.ControllerMethod = 'Construction/BuildingConstructionList/';
            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
            };
          } else if (gridModel.Name === 'GridBuildingExamination') {
            gridModel.ControllerMethod = 'Construction/BuildingExaminationList/';
            return {
              gridModel,
              transportData: vm.getSelectedMainGridItemId,
              selectFunction: function() {
                changeTestGridFilter(vm.detailItemGrids['GridBuildingExamination']);
              },
            };
          }
        }
      );

      vm.detailItemGrids = generatedDetailGridTabs.grids;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      vm.detailItemGridOptions = generatedDetailGridTabs.gridOptions;

      vm.getExaminationGridItemId = function() {
        return {
          targetExaminationId: vm.selectedTestGridId,
        };
      };

      // ResultOfExamination/Vizsgálati eredmények grid
      vm.activeResultTab = 0;

      var generatedResultTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelResultOfExamination'],
        function(gridModel) {
          gridModel.ControllerMethod = 'Construction/ResultOfExaminationList/';
          return {
            gridModel,
            transportData: vm.getExaminationGridItemId,
          };
        }
      );

      vm.resultTab = generatedResultTabs.tabs;
      vm.resultGridOptions = generatedResultTabs.gridOptions;
      vm.resultGrid = generatedResultTabs.grids;

      ////////// Changes the seledtedItem on mainGrid ////////////////////
      ////////// and reload the subGrid //////////////////////////////////
      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
        vm.detailItemGrids['GridBuildingConstruction'] &&
          vm.detailItemGrids['GridBuildingConstruction'].dataSource.read();
        vm.detailItemGrids['GridBuildingExamination'] &&
          vm.detailItemGrids['GridBuildingExamination'].dataSource.read();
      }

      ///////// Changes the seledtedItem on test grid ////////////////////
      ////////// and reload the result grid //////////////////////////////////

      vm.examinationGridIdField = 'ExaminationId';

      function changeTestGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedTestGridId = selectedItems[0][vm.examinationGridIdField];
        console.log('sub grid id ' + vm.selectedTestGridId);
        if (vm.resultGrid['GridResultOfExamination']) {
          vm.resultGrid['GridResultOfExamination'].dataSource.read();
        }
      }

      // MAIN BUTTONS
      vm.constructionData = function constructionData() {
        toastr.warning('A funkció fejlesztés alatt', 'Figyelmeztetés!');
      };

      vm.constructionView = function constructionView() {
        toastr.warning('A funkció fejlesztés alatt', 'Figyelmeztetés!');
      };

      vm.constructionMap = function constructionMap() {
        toastr.warning('A funkció fejlesztés alatt', 'Figyelmeztetés!');
      };

      vm.constructionDocuments = function constructionDocuments() {
        toastr.warning('A funkció fejlesztés alatt', 'Figyelmeztetés!');
      };

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Construction.DasDocumentsNav', 'FlgBuildingConstruction', id);
      }

      function WAL(whichGrid) {
        // Melyik gridről jött az ált. lek. lehívás?
        switch (whichGrid) {
          case vm.WhichGridEnum.MainGrid: {
            // Fő grid -- oldal felső része
            walService.NavigateToWal('Construction', 'ConstructionPropertyNavWal', 'FlgPropertyView');
            break;
          }

          case vm.WhichGridEnum.SubGrid: {
            // Subgrid -- oldal alsó része
            switch (vm.activeSubItemTab) {
              case 0: {
                walService.NavigateToWal(
                  'Construction',
                  'ConstructionBuildingConstructionNavWal',
                  'FlgBuildingConstructionView'
                );
                break;
              }
              case 1: {
                walService.NavigateToWal(
                  'Construction',
                  'ConstructionBuildingExaminationNavWal',
                  'FlgBuildingExaminationView'
                );
                break;
              }
              default: {
                break;
              }
            }
            break;
          }

          case vm.WhichGridEnum.SecondarySubGrid: {
            // SecondarySubgrid -- Subgrid második tabjával nyitható subgrid
            walService.NavigateToWal(
              'Construction',
              'ConstructionResultOfExaminationNavWal',
              'FlgResultOfExaminationView'
            );
            break;
          }

          default: {
            break;
          }
        }
      }

      function history() {
        var id = vm.selectedMainGridItemId;
        if (typeof id === 'undefined' || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        HistoryService.NavigateToHistory('FlgBuildingConstruction', id, vm, $state, true);
      }
      function createSubModal(fnct, param1, param2) {
        var url = 'Construction/' + getUrlPrefix() + fnct + '/?id=' + param1 + '&PropertyId=' + param2;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Construction/' + getUrlPrefix() + 'Mod.html',
          controller: getUrlPrefix() + 'ModCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            options: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function() {
            vm.mainGrid.dataSource.read();
          })
          .catch(function(response) {});
      }

      // GRID BUTTONS
      vm.createSubItem = function createSubItem() {
        var id = vm.selectedMainGridItemId;
        if (typeof id === 'undefined' || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createSubModal('Create', 0, id);
      };

      vm.editSubItem = function editSubItem() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createSubModal('Edit', id, vm.selectedMainGridItemId);
      };

      vm.duplicateSubItem = function duplicateSubItem() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createSubModal('Duplicate', id, vm.selectedMainGridItemId);
      };

      vm.deleteSubItem = function deleteSubItem() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Construction/' + getUrlPrefix() + 'Delete/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  refreshActiveGrid();
                });
              },
            },
          },
        });
      };

      function getUrlPrefix() {
        var urlPrefix = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      }

      function getSelectedSubGridItem() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var gridRef = vm.detailItemGrids[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedSubGridItemId() {
        var gridName = vm.detailItemTabs[vm.activeSubItemTab].gridName;
        var item = getSelectedSubGridItem();
        if (item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      // RESULT GRID BUTTONS
      function createResultModal(fnct, param1, param2) {
        var url = 'Construction/' + getResultUrlPrefix() + fnct + '/?id=' + param1 + '&ExaminationId=' + param2;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Construction/' + getResultUrlPrefix() + 'Mod.html',
          controller: getResultUrlPrefix() + 'ModCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            options: RouteResolveFunc(url),
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function() {
            vm.mainGrid.dataSource.read();
          })
          .catch(function(response) {});
      }
      vm.createResultSubItem = function createResultSubItem() {
        var id = getSelectedSubGridItemId();
        if (typeof id === 'undefined' || id === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createResultModal('Create', 0, id);
      };

      vm.editResultSubItem = function editResultSubItem() {
        var id = getSelectedResultSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createResultModal('Edit', id, getSelectedSubGridItemId());
      };

      vm.duplicateResultSubItem = function duplicateResultSubItem() {
        var url = 'Construction.' + getResultUrlPrefix() + 'Duplicate';

        var id = getSelectedResultSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        createResultModal('duplicate', id, getSelectedSubGridItemId());
      };

      vm.deleteResultSubItem = function deleteResultSubItem() {
        var id = getSelectedResultSubGridItemId();
        if (typeof id === 'undefined') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return false;
        }
        bootbox.dialog({
          message: vm.messages.ConfirmDelete,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('Construction/' + getResultUrlPrefix() + 'Delete/' + id).then(function() {
                  toastr.success(vm.messages.DeleteSuccessful);
                  refreshActiveGrid();
                });
              },
            },
          },
        });
      };

      vm.resultSubItem = function resultSubItem() {};

      function getResultUrlPrefix() {
        var urlPrefix = vm.resultTab[vm.activeResultTab].gridName;
        if (urlPrefix.substring(0, 4) === 'Grid') {
          urlPrefix = urlPrefix.substring(4);
        }
        return urlPrefix;
      }

      function getSelectedResultSubGridItem() {
        var gridName = vm.resultTab[vm.activeResultTab].gridName;
        var gridRef = vm.resultGrid[gridName];
        var selectedItems = GetSelectedGridItems(gridRef);
        if (!!selectedItems[0] && !!vm.pageModel.Grids[gridName]) {
          return selectedItems[0];
        }
        return undefined;
      }

      function getSelectedResultSubGridItemId() {
        var gridName = vm.resultTab[vm.activeResultTab].gridName;
        var item = getSelectedResultSubGridItem();
        if (item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return undefined;
      }

      ////////////////////////////////////////////////////////////////////////////////

      var refreshActiveGrid = function() {
        vm.detailItemGrids[vm.detailItemGrids[vm.activeSubItemTab]].dataSource.read();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ConstructionMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ConstructionMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      if (backTo == 'Nav') {
        backMenu.event = function() {
          $state.go('Construction.BuildingConstructionNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        BuildingConstruction_Nav: { icon: 'fa fa-file-text' },
        Masterdata_Construction: { icon: 'fa fa-file-text-o' },
      };

      buildMenu($state, authService, 'BuildingConstruction', 'buildingconstruction', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Construction: {
        url: '/construction',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'Construction.BuildingConstructionNav',
        ncyBreadcrumb: {
          label: 'Épület szerkezet',
          parent: 'main',
        },
      },
      'Construction.BuildingConstructionMasterDataNav': {
        url: '/masternav',
        params: {
          module: 'Construction',
          formMode: 'Nav',
          backState: 'main',
          bstates: ['Task.TaskCreate', 'Task.TaskEdit'],
          documentEntity: 'masterdata_construction',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingConstructionMasterDataNav.html',
            controller: 'BuildingConstructionMasterDataNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/MasterListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezeti törzsek',
        },
      },
      'Construction.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },

      'Construction.ConstructionClassifyModEdit': {
        url: '/constructionclassifymod/{id:int}',
        params: { module: 'Construction', documentEntity: 'masterdata_construction_ConstructionClassifylist' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ConstructionClassifyModEdit.html',
            controller: 'ConstructionClassifyModEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ConstructionClassifyModEdit/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezet besorolás szerkesztés',
        },
      },
      'Construction.ConstructionClassifyDuplicate': {
        url: '/constructionclassifyduplicate/{id:int}',
        params: { module: 'Construction', documentEntity: 'masterdata_construction_ConstructionClassifylist' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ConstructionClassifyModEdit.html',
            controller: 'ConstructionClassifyModEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ConstructionClassifyDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezet besorolás szerkesztés',
        },
      },
      'Construction.BuildingConstructionNav': {
        url: '/construction',
        params: {
          module: 'Construction',
          formMode: 'Nav',
          documentEntity: 'construction_buildingconstructionnav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingConstructionNav.html',
            controller: 'BuildingConstructionNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Épületszerkezet nyilvántartás',
        },
      },
      'Construction.BuildingConstructionCreate': {
        url: '/buildingconstruction/{id:int}?PropertyId',
        params: { module: 'Construction', documentEntity: 'construction_buildingconstructionedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingConstructionMod.html',
            controller: 'BuildingConstructionModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingConstructionCreate/', undefined, ['id', 'PropertyId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezeti elem szerkesztés',
        },
      },
      'Construction.BuildingConstructionEdit': {
        url: '/buildingconstruction/{id:int}?PropertyId',
        params: { module: 'Construction', documentEntity: 'construction_buildingconstructionedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingConstructionMod.html',
            controller: 'BuildingConstructionModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingConstructionEdit/', undefined, ['id', 'PropertyId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezeti elem szerkesztés',
        },
      },
      'Construction.BuildingConstructionDuplicate': {
        url: '/buildingconstructionduplicate/{id:int}',
        params: { module: 'Construction', documentEntity: 'construction_buildingconstructionedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingConstructionMod.html',
            controller: 'BuildingConstructionModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingConstructionDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Szerkezeti elem szerkesztés',
        },
      },
      'Construction.BuildingExaminationNav': {
        url: '/nav',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingExaminationNav.html',
            controller: 'BuildingExaminationNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálat nyilvántartás',
        },
      },
      'Construction.BuildingExaminationCreate': {
        url: '/buildingexamination/{id:int}?PropertyId',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingExaminationMod.html',
            controller: 'BuildingExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingExaminationCreate/', undefined, ['id', 'PropertyId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálat szerkesztés',
        },
      },
      'Construction.BuildingExaminationEdit': {
        url: '/buildingexamination/{id:int}?PropertyId',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingExaminationMod.html',
            controller: 'BuildingExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingExaminationEdit/', undefined, ['id', 'PropertyId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálat szerkesztés',
        },
      },
      'Construction.BuildingExaminationDuplicate': {
        url: '/buildingexaminationduplicate/ { id: int }',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationnav' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/BuildingExaminationMod.html',
            controller: 'BuildingExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/BuildingExaminationDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálat szerkesztés',
        },
      },
      'Construction.ResultOfExaminationNav': {
        url: '/nav',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ResultOfExaminationNav.html',
            controller: 'ResultOfExaminationNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ListOptions/'),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálati eredmény nyilvántartás',
        },
      },
      'Construction.ResultOfExaminationCreate': {
        url: '/resultofexamination/{id:int}?ExaminationId',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ResultOfExaminationMod.html',
            controller: 'ResultOfExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ResultOfExaminationCreate/', undefined, ['id', 'ExaminationId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálati eredmény szerkesztés',
        },
      },
      'Construction.ResultOfExaminationEdit': {
        url: '/resultofexamination/{id:int}?ExaminationId',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ResultOfExaminationMod.html',
            controller: 'ResultOfExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ResultOfExaminationEdit/', undefined, ['id', 'ExaminationId']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálati eredmény szerkesztés',
        },
      },
      'Construction.ResultOfExaminationDuplicate': {
        url: '/resultofexaminationduplicate/{id:int}',
        params: { module: 'Construction', documentEntity: 'construction_buildingexaminationedit' },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Construction/ResultOfExaminationMod.html',
            controller: 'ResultOfExaminationModCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Construction/ResultOfExaminationDuplicate/', undefined, ['id']),
        },
        ncyBreadcrumb: {
          skip: true,
          label: 'Vizsgálati eredmény szerkesztés',
        },
      },
      'Construction.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ConstructionMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Construction/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('BuildingExaminationModCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModalInstance',
    'HistoryService',
    'LockService',
    function($scope, options, $http, $state, uibModalInstance, HistoryService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingExaminationModCtrl', stateParams);
      }
      var vm = this;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ExaminationDate: function() {
          nextExamination(vm.formModel.PropertyId, vm.formModel.ExaminationDate);
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      nextExamination(vm.formModel.PropertyId, vm.formModel.ExaminationDate);

      // MAIN BUTTONS
      vm.save = function save() {
        vm.action = 'BuildingExamination';
        if (vm.formModel.ModelState === 4) vm.action = vm.action + 'Duplicate';
        else if (vm.formModel.ModelState > 1) vm.action = vm.action + 'Edit';

        $http
          .post('Construction/' + vm.action, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Mentés sikeresen megtörtént!'); // TODO általános label
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(response.data.message); // TODO általános label
          });
      };

      vm.cancel = function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      };

      vm.attachDocument = attachDocument;
      vm.history = history;

      function attachDocument() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }

      function history() {
        HistoryService.NavigateToHistory('FlgBuildingExamination', vm.formModel.BuildingExaminationId, vm, $state);
      }

      //következő vizsgálat dátuma
      function nextExamination(propertyId, examinationDate) {
        $http({
          method: 'GET',
          url: 'Construction/NextExamination/',
          params: { propertyId: propertyId, examinationDate: examinationDate },
        }).then(function successCallback(response) {
          vm.formModel.NextExamination = response.data.NextExamination;
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('BuildingConstructionModCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModalInstance',
    'HistoryService',
    'LockService',
    function($scope, options, $http, $state, uibModalInstance, HistoryService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'BuildingConstructionModCtrl', stateParams);
      }
      var vm = this;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      var validFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {
        Floor: {
          'templateOptions.disabled': function() {
            return vm.formModel.Level === 'PPRRU';
          },
        },
        PremiseId: {
          'templateOptions.required': function() {
            return vm.formModel.Level === 'PPRRU';
          },
        },
      };

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        GroupId: function() {
          SetConstructionElementComboListFilter();
        },
        ElementId: function() {
          if (!!vm.formModel.ElementId) {
            vm.unitName(vm.formModel.ElementId);
          }
        },
        ConstructionClassify: function() {
          SetConstructionGroupComboListFilter();
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {
        ValidFrom: {
          ObjectValidFromValidator: function(modelValue, viewValue) {
            var currValidFrom = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return currValidFrom.isSameOrAfter(validFrom);
          },
        },
        ValidTo: {
          ObjectValidToValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            var currValidFrom = new moment(vm.formModel.ValidFrom, kendo.culture().calendar.patterns.d.toUpperCase());
            var currValidTo = new moment(modelValue, kendo.culture().calendar.patterns.d.toUpperCase());
            return currValidTo.isSameOrAfter(currValidFrom);
          },
        },
        Quantity: {
          ObjectValidToValidator: function(modelValue, viewValue) {
            if ((!modelValue || !viewValue) && modelValue < 1) {
              return false;
            }
            return true;
          },
        },
      };

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertParsers(vm.pageModel, parsers);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      SetConstructionGroupComboListFilter();
      SetConstructionElementComboListFilter();
      SetPremiseListFilter(vm.formModel.Level, vm.formModel.PropertyId);

      // MAIN BUTTONS
      vm.save = function save() {
        vm.action = 'BuildingConstruction';
        if (vm.formModel.ModelState === 4) vm.action = vm.action + 'Duplicate';
        else if (vm.formModel.ModelState > 1) vm.action = vm.action + 'Edit';

        $http
          .post('Construction/' + vm.action, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Mentés sikeresen megtörtént!'); // TODO általános label
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(response.data.message); // TODO általános label
          });
      };

      vm.cancel = function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      };

      vm.history = history;
      function history() {
        HistoryService.NavigateToHistory('FlgBuildingConstruction', vm.formModel.ConstrcuctionId, vm, $state);
      }

      /////////////////////////////// [ combolist filters ] ///////////////////////////////////
      function SetConstructionGroupComboListFilter() {
        vm.pageModel.Fields.GroupId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          level: vm.formModel.Level,
          floor: vm.formModel.Floor,
          constructionClassify: vm.formModel.ConstructionClassify,
        };

        vm.pageModel.Fields.GroupId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      function SetConstructionElementComboListFilter() {
        vm.pageModel.Fields.ElementId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          groupId: vm.formModel.GroupId,
        };

        vm.pageModel.Fields.ElementId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      function SetPremiseListFilter(level, id) {
        vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return level === 'PPRRU' ? 'RentUnitId~eq~' + id : 'PropertyId~eq~' + id;
        };
      }

      //mértékegység meghatározása
      vm.unitName = function(elementId) {
        $http({
          method: 'GET',
          url: 'Construction/GetUnitName/',
          params: { elementId: elementId },
        }).then(function successCallback(response) {
          vm.formModel.UnitName = response.data.UnitName;
        });
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ResultOfExaminationModCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModalInstance',
    'HistoryService',
    'LockService',
    function($scope, options, $http, $state, uibModalInstance, HistoryService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ResultOfExaminationModCtrl', stateParams);
      }
      var vm = this;
      vm.module = $state.current.params.module;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      // Usage: "fieldName": "typeName"
      var customTypes = {};

      // Usage: "fieldName": "className"
      var customClasses = {};

      var customExpressionProperties = {};

      // Usage: "fieldName": hideExpression($viewValue, $modelValue, scope)
      var hideExpressions = {};

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        ConstructionId: function(selectedItem) {
          if (!!selectedItem.key) {
            SetConstructionDetails(vm.formModel.ConstructionId);
          }
        },
      };

      // Usage: "fieldName": onBlurFunction(selectedItem)
      var onBlurFunctions = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var syncValidators = {};

      // Usage: "fieldName": {validatorFnName1: validatuonFn1, validatorFnName2: validatorFn2}
      var asyncValidators = {};

      // Usage: "fieldName": [parserFunction1,parserFunctionN]
      var parsers = {};

      // Usage: "fieldName": [formatterFunction1,formatterFunctionN]
      var formatters = {};

      var numericOptions = {};

      // Usage: "fieldName": "inputMask"
      var inputMasks = {};

      ////////////////////////////////////////////////////////////////////////////////////////
      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be ran before generating formly descriptors from general field descriptors
      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      SetBuildingConstructionViewComboListFilter();

      // MAIN BUTTONS
      vm.save = function save() {
        vm.action = 'ResultOfExamination';
        if (vm.formModel.ModelState === 4) vm.action = vm.action + 'Duplicate';
        else if (vm.formModel.ModelState > 1) vm.action = vm.action + 'Edit';

        $http
          .post('Construction/' + vm.action, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Mentés sikeresen megtörtént!'); // TODO általános label
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(response.data.message); // TODO általános label
          });
      };

      vm.cancel = function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss();
      };

      vm.attachDocument = attachDocument;
      vm.history = history;

      function attachDocument() {
        toastr.warning('Ez a funkció még nincs megvalósítva', vm.messages.Warning);
      }

      function history() {
        HistoryService.NavigateToHistory('FlgResultOfExamination', vm.formModel.ResultOfExaminationId, vm, $state);
      }

      /////////////////////////////// [ ComboList Filters ] ///////////////////////////////////
      function SetBuildingConstructionViewComboListFilter() {
        vm.pageModel.Fields.ConstructionId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          propertyId: vm.formModel.PropertyId,
          actual: true,
        };

        vm.pageModel.Fields.ConstructionId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      //Konstruciótól függű mezők kitöltése
      function SetConstructionDetails(constructionId) {
        $http({
          method: 'GET',
          url: 'Construction/ConstructionDetails/',
          params: { constructionId: constructionId },
        }).then(function successCallback(response) {
          vm.formModel.Floor = response.data.Floor;
          vm.formModel.ClassifyName = response.data.ClassifyName;
          vm.formModel.GroupName = response.data.GroupName;
          vm.formModel.ElementName = response.data.ElementName;
          vm.formModel.Quantity = response.data.Quantity;
          vm.formModel.UnitName = response.data.UnitName;
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ApportionMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name + '({ApportionType : "' + $state.params.ApportionType + '"})';
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var id = $state.params.BudgetId;

      //ncyBreadcrumbLabel:
      var appType = $state.params.ApportionType;
      var getApportionTypeName = function(type) {
        switch (type) {
          case 'BATAP':
            return 'Közvetlen átterhelés';
          case 'BATJO':
            return 'Munkaszámos átterhelés';
          case 'BATPE':
            return 'Százalékos átterhelés';
        }
      };
      if (!!appType && appType != '') $state.current.ncyBreadcrumb.label = getApportionTypeName(appType);
      //----

      //Routesban kap értéket: {Nav, Edit}
      var backTo = $state.params.backTo;
      if (backTo === 'ApportionNav') {
        backMenu.event = function() {
          $state.go('Budget.Apportion.ApportionNav');
        };
      } else if (backTo === 'Edit') {
        backMenu.event = function() {
          $state.go('Budget.Apportion.ApportionEdit', { id: id });
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Budget_Apportion_ApportionNav_Apportion: { icon: 'fa fa-file-text' },
        Budget_Apportion_ApportionNav_JobNum: { icon: 'fa fa-file-text' },
        Budget_Apportion_ApportionNav_Percent: { icon: 'fa fa-file-text' },
        Budget_Apportion_ApportionNav_Plan: { icon: 'fa fa-file-text' },
      };
      buildMenu($state, authService, 'Budget_Apportion_ApportionNav', 'budget', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  //module.controller("ApportionNavCtrl", ["$scope", "options", "$http", "$state",
  //   function ($scope, options, $http, $state) {
  module.controller('ApportionNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    '$stateParams',
    '$window',
    'HistoryService',
    'DasService',
    function($scope, options, $http, $state, walService, $stateParams, $window, HistoryService, dasService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionNavCtrl', stateParams);
      }
      var vm = this;
      init();

      // Set combo default
      vm.dataModel.BudgetDateId = localStorage.getItem('BudgetDateId');

      //Paraméter ellenőrzése!
      if (['BATAP', 'BATJO', 'BATPE'].indexOf(vm.dataModel.ApportionType) < 0) {
        toastr.error(vm.messages.WrongParam, vm.messages.Warning);
        $state.go('Budget.Apportion');
      }

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setOnChangeFunction('BudgetDateId', function(selectedItem) {
          localStorage.setItem('BudgetDateId', !selectedItem || selectedItem.key == '' ? null : selectedItem.key);
          vm.mainGrid.dataSource.read();
        });

        vm.getFilter = function() {
          return {
            BudgetDateId: vm.dataModel.BudgetDateId,
            apportionType: vm.dataModel.ApportionType,
          };
        };

        initMainGrid(
          vm,
          'GridApportion',
          'Budget/ApportionList',
          function() {
            changeSubItemGridFilter(vm.mainGrid);
          },
          vm.getFilter
        );

        initSubGrids(
          vm,
          'Budget',
          function() {
            return {
              ApportionId: getSelectedRowIdFromMainGrid(vm),
            };
          },
          ['PanelApportionRow']
        );

        //Látható oszlopok beállítása
        function getColumnsByType(apporationType) {
          switch (apporationType) {
            case 'BATJO':
              return {
                GridApportion: [
                  'RanKing',
                  'BudgetFromName',
                  'BudgetToName',
                  'ServiceToCode',
                  'ServiceToName',
                  'BudJobNumberName',
                ],
              };
            case 'BATPE':
              return {
                GridApportion: [
                  'RanKing',
                  'BudgetFromName',
                  'BudgetToName',
                  'ServiceToCode',
                  'ServiceToName',
                  'PercentRate',
                ],
              };
            default:
              return {
                GridApportion: ['RanKing', 'BudgetFromName', 'BudgetToName', 'ServiceToCode', 'ServiceToName'],
              };
          }
        }
        function setColumnVisible(apporationType) {
          var columns = getColumnsByType(apporationType);
          angular.forEach(columns, function(value, key) {
            angular.forEach(vm.pageModel.Grids[key].Columns, function(valueC, keyC) {
              valueC.hidden = value.indexOf(valueC.field) == -1;
            });
          });
        }
        setColumnVisible(vm.dataModel.ApportionType);
        generateForm(vm);
      }

      function changeSubItemGridFilter(targetGrid) {
        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);
        $scope.$applyAsync();
        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });
        //ha nem lenyitjuk csak kijelöljök, a subGridRefs Gridjei undefined-ok, erre a plusz ellenőrzés
        //if (subGridRefs.GridPartAddress != null) {
        //    angular.forEach(subGridRefs, function (value, key) {
        //        value.dataSource.read();
        //    });
        //}
      }

      vm.createApportion = createApportion;
      vm.editApportion = editApportion;
      vm.duplicateApportion = duplicateApportion;
      vm.deleteApportion = deleteApportion;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      function createApportion() {
        var ApportionType = vm.dataModel.ApportionType;
        var BudgetDateId = vm.dataModel.BudgetDateId;

        if (BudgetDateId === null) {
          BudgetDateId = 0;
        }

        $state.go('Budget.Apportion.ApportionCreate', { ApportionType: ApportionType, BudgetDateId: BudgetDateId });
      }

      function editApportion() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var ApportionType = vm.dataModel.ApportionType;
          $state.go('Budget.Apportion.ApportionEdit', { id: id, ApportionType: ApportionType });
        }
      }

      function duplicateApportion() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var ApportionType = vm.dataModel.ApportionType;
          $state.go('Budget.Apportion.ApportionDuplicate', { id: id, ApportionType: ApportionType });
        }
      }

      function deleteApportion() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          var ApportionType = vm.dataModel.ApportionType;
          $http.get('Budget/ApportionDelete' + ApportionType + '/' + id).then(function() {
            toastr.success(vm.pageModel.Actions.ActionDelete.Title);
            vm.mainGrid.dataSource.read();
          });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportion', id);
      }

      function WAL() {
        // A három átterhelés oldal közül melyiken vagyunk?
        switch (vm.dataModel.ApportionType) {
          // Általános lekérdező gombként másik controller metódust kell meghívni a jogosultságkezelés miatt:
          case 'BATJO': {
            walService.NavigateToWal('Budget', 'ApportionBATJONavWal', 'FlgApportionView');
            break;
          }
          case 'BATAP': {
            walService.NavigateToWal('Budget', 'ApportionBATAPNavWal', 'FlgApportionView');
            break;
          }
          case 'BATPE': {
            walService.NavigateToWal('Budget', 'ApportionBATPENavWal', 'FlgApportionView');
            break;
          }
        }
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgApportion', selectedItems[0][vm.subGridIdField], vm, $state, true);
      }

      /*
         var vm = this;
         vm.pageModel = options.pageModel;
         vm.formModel = options.dto;
         vm.messages = options.pageModel.Messages;
         vm.labels = options.pageModel.Labels;
         vm.actions = options.pageModel.Actions;       

     

         vm.apportion = "TabApportion";
         vm.apportionRow = "TabApportionRow";

         vm.back = function () {
            $state.go("Budget.BudgetNav");
         }

         vm.getFilter = function () {
            return {
                "BudgetDateId": vm.formModel.BudgetDateId,
                "apportionType": vm.formModel.ApportionType
            };
         }

         function filter() {
            vm.mainGrid.dataSource.read();
         }

         // Usage: "fieldName": onChangeFunction(selectedItem)
         var onChangeFunctions = {
            "BudgetDateId": function (selectedItem) {
               vm.formModel.BudgetDateId = selectedItem.key;
//               localStorage.setItem('BudgetDate', vm.formModel.BudgetDateId);
               vm.filter();
            }
         };
         InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

         vm.mainGrid = $("#apportionGrid").data("kendoGrid");
         vm.mainGridIdField = "ApportionId";
         vm.apportionRowGrid = vm.pageModel.Grids["GridApportionRow"];


         vm.apportionGridOptions = getGridOptions(options.pageModel.Grids.GridApportion,
            "Budget/ApportionList/", function () {
               changeMainGridFilter(vm.mainGrid);
            }, vm.getFilter
         );

         vm.getSelectedMainGridItemId = function () {
            //console.log(vm.selectedMainGridItemId);
            return {
               "ApportionId": vm.selectedMainGridItemId
            };
         }

         //vm.activeDetailItemTab = 0;

         vm.apportionRowGridOptions = getGridOptions(options.pageModel.Grids.GridApportionRow,
            "Budget/ApportionRowList/", function () {
               //changeMainGridFilter();
            }, vm.getSelectedMainGridItemId);

         //function setMainGridSelectedItemId() {
         //   vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];
         //}

         var generatedMainGridTabs = CreateGridContainerTabsWithGrids(vm.pageModel.Tabs,
            vm.pageModel.Panels,
            options.pageModel.Grids,
            "Budget/ApportionList",
            vm.getSelectedMainGridItemId,
            [
               "PanelApportion"
            ],
            vm
         );

         var generatedDetailGridTabs = CreateGridContainerTabsWithGrids(vm.pageModel.Tabs,
            vm.pageModel.Panels,
            options.pageModel.Grids,
            "Budget/ApportionRowList",
            vm.getSelectedMainGridItemId,
            [
               "PanelApportionRow"
            ],
            vm
         );

         vm.mainItemTabs = generatedMainGridTabs.tabs;
         vm.detailItemTabs = generatedDetailGridTabs.tabs;

         var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
         vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

         function changeMainGridFilter(targetGrid) {
            var selectedItems = GetSelectedGridItems(targetGrid);
            if (selectedItems.length === 0)
               return;

            vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

            // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
            var subGridRefs = {};
            angular.forEach(vm.subGrids, function (value) {
               subGridRefs[value] = $("#" + value).data("kendoGrid");
            });

            if (vm.apportionRowGrid.dataSource) {
               vm.apportionRowGrid.dataSource.read();
            }
         }

         */
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ApportionJobNumNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionJobNumNavCtrl', stateParams);
      }
      //debugger;
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createApportionJobNum = createApportionJobNum;
      vm.editApportionJobNum = editApportionJobNum;
      vm.duplicateApportionJobNum = duplicateApportionJobNum;
      vm.deleteApportionJobNum = deleteApportionJobNum;
      vm.viewApportionJobNum = viewApportionJobNum;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.filter = filter;

      vm.apportion = 'TabApportion';
      vm.apportionRow = 'TabApportionRow';

      vm.back = function() {
        $state.go('Budget.Budget.BudgetNav');
      };

      vm.getFilter = function() {
        return {
          BudgetDateId: vm.formModel.BudgetDateId,
        };
      };

      function filter() {
        vm.mainGrid.dataSource.read();
      }

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeDetailTab', vm.activeDetailItemTab);
      });

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        BudgetDateId: function(selectedItem) {
          vm.formModel.BudgetDateId = selectedItem.key;
          //               localStorage.setItem('BudgetDate', vm.formModel.BudgetDateId);
          vm.filter();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.mainGrid = $('#apportionJobNumGrid').data('kendoGrid');
      vm.mainGridIdField = 'ApportionId';
      vm.apportionJobNumRowGrid = vm.pageModel.Grids['GridApportionJobNumRow'];

      vm.getSelectedMainGridItemId = function() {
        //console.log(vm.selectedMainGridItemId);
        return {
          ApportionId: vm.selectedMainGridItemId,
        };
      };

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelApportionJobNum'],
        function(gridDescriptor) {
          if (gridDescriptor.Name === 'GridApportionJobNum') {
            return {
              gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Budget/ApportionJobNumList/' }),
              transportData: vm.getFilter,
              selectionChanged: function() {
                changeMainGridFilter(vm.mainGrid);
              },
            };
          }
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;
      vm.apportionJobNumGridOptions = generatedMainGridTabs.gridOptions.GridApportionJobNum;

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelApportionJobNumRow'],
        function(gridDescriptor) {
          return {
            gridModel: Object.assign({}, gridDescriptor, { ControllerMethod: 'Budget/ApportionJobNumRowList/' }),
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );

      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      $scope.activeDetailItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeDetailTab')) || 0;
      vm.activeDetailItemTab = $scope.activeDetailItemTab;
      vm.apportionJobNumRowGridOptions = generatedDetailGridTabs.gridOptions.GridApportionJobNumRow;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        if (vm.apportionJobNumRowGrid.dataSource) {
          vm.apportionJobNumRowGrid.dataSource.read();
        }
      }

      function createApportionJobNum() {
        $state.go('Budget.Apportion.ApportionJobNumEdit', { id: 0 });
      }

      function editApportionJobNum() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionJobNumEdit', { id: id });
        }
      }

      function duplicateApportionJobNum() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionJobNumDuplicate', { id: id });
        }
      }

      function deleteApportionJobNum() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $http.get('Budget/ApportionJobNumDelete/' + id).then(function() {
            toastr.success(vm.labels.LabelDelete.Title);
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function viewApportionJobNum() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionJobNumView', { id: id });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportionJobNum', id);
      }

      function WAL() {
        toastr.warning(vm.messages.FunctionNotExists, vm.messages.Warning);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ApportionPercentNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionPercentNavCtrl', stateParams);
      }
      //debugger;
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createApportionPercent = createApportionPercent;
      vm.editApportionPercent = editApportionPercent;
      vm.duplicateApportionPercent = duplicateApportionPercent;
      vm.deleteApportionPercent = deleteApportionPercent;
      vm.viewApportionPercent = viewApportionPercent;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;

      vm.filter = filter;

      vm.apportion = 'TabApportionPercent';
      vm.apportionRow = 'TabApportionPercentRow';

      vm.back = function() {
        $state.go('Budget.Budget.BudgetNav');
      };

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeDetailTab', vm.activeDetailItemTab);
      });

      vm.getFilter = function() {
        return {
          BudgetDateId: vm.formModel.BudgetDateId,
        };
      };

      function filter() {
        vm.mainGrid.dataSource.read();
      }

      // Usage: "fieldName": onChangeFunction(selectedItem)
      var onChangeFunctions = {
        BudgetDateId: function(selectedItem) {
          vm.formModel.BudgetDateId = selectedItem.key;
          //               localStorage.setItem('BudgetDate', vm.formModel.BudgetDateId);
          vm.filter();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.mainGrid = $('#apportionPercentGrid').data('kendoGrid');
      vm.mainGridIdField = 'ApportionId';
      vm.apportionPercentRowGrid = vm.pageModel.Grids['GridApportionPercentRow'];

      vm.getSelectedMainGridItemId = function() {
        //console.log(vm.selectedMainGridItemId);
        return {
          ApportionId: vm.selectedMainGridItemId,
        };
      };

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelApportionPercent'],
        function(gridDescriptor) {
          gridDescriptor.ControllerMethod = 'Budget/ApportionPercentList/';

          return {
            gridModel: gridDescriptor,
            transportData: vm.getFilter,
            selectFunction: function() {
              changeMainGridFilter(vm.mainGrid);
            },
          };
        },
        'Budget/ApportionPercentList',
        vm.getSelectedMainGridItemId,
        vm
      );
      vm.apportionPercentGridOptions = generatedMainGridTabs.gridOptions.GridApportionPercent;
      vm.mainItemTabs = generatedMainGridTabs.tabs;
      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;

      var generatedDetailGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelApportionPercentRow'],
        function(gridDescriptor) {
          gridDescriptor.ControllerMethod = 'Budget/ApportionPercentRowList/';

          return {
            gridModel: gridDescriptor,
            transportData: vm.getSelectedMainGridItemId,
          };
        }
      );
      vm.apportionPercentRowGridOptions = generatedDetailGridTabs.gridOptions.GridApportionPercentRow;
      vm.detailItemTabs = generatedDetailGridTabs.tabs;
      $scope.activeDetailItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeDetailTab')) || 0;
      vm.activeDetailItemTab = $scope.activeDetailItemTab;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        if (vm.apportionPercentRowGrid.dataSource) {
          vm.apportionPercentRowGrid.dataSource.read();
        }
      }

      function createApportionPercent() {
        $state.go('Budget.Apportion.ApportionPercentEdit', { id: 0 });
      }

      function editApportionPercent() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPercentEdit', { id: id });
        }
      }

      function duplicateApportionPercent() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPercentDuplicate', { id: id });
        }
      }

      function deleteApportionPercent() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $http.get('Budget/ApportionPercentDelete/' + id).then(function() {
            toastr.success(vm.pageModel.Actions.ActionDelete.Title);
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function viewApportionPercent() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPercentView', { id: id });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportionPercent', id);
      }

      function WAL() {
        toastr.warning(vm.pageModel.Messages.FunctionNotExists, vm.messages.Warning);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ApportionPlanNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    'HistoryService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, walService, HistoryService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionPlanNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      vm.createApportionPlan = createApportionPlan;
      vm.editApportionPlan = editApportionPlan;
      vm.duplicateApportionPlan = duplicateApportionPlan;
      vm.deleteApportionPlan = deleteApportionPlan;
      vm.viewApportionPlan = viewApportionPlan;
      vm.attachDocument = attachDocument;
      vm.WAL = WAL;
      vm.History = history;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
      });
      //vm.filter = filter;

      //vm.getFilter = function () {
      //   return {
      //      "BudgetDateId": vm.formModel.BudgetDateId
      //   };
      //}

      //function filter() {
      //   vm.mainGrid.dataSource.read();
      //}

      vm.mainGrid = $('#apportionPlanGrid').data('kendoGrid');
      vm.mainGridIdField = 'ApportionPlanId';

      vm.getSelectedMainGridItemId = function() {
        //console.log(vm.selectedMainGridItemId);
        return {
          ApportionPlanId: vm.selectedMainGridItemId,
        };
      };

      //vm.activeDetailItemTab = 0;

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelApportionPlan'],
        function(gridModel) {
          gridModel.ControllerMethod = 'Budget/ApportionPlanList/';
          return {
            gridModel,
          };
        },
        'Budget/ApportionPlanList',
        vm.getSelectedMainGridItemId,
        vm
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;

      vm.apportionPlanGridOptions = generatedMainGridTabs.gridOptions.GridApportionPlan;

      //var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      //vm.formFields = formlyFormPanelDescriptors.PanelFilter.FormlyDescriptor;

      function changeMainGridFilter(targetGrid) {
        var selectedItems = GetSelectedGridItems(targetGrid);
        if (selectedItems.length === 0) return;

        vm.selectedMainGridItemId = selectedItems[0][vm.mainGridIdField];

        // TODO only refresh subGrid currently selected to preserve precious bandwidth (:
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        if (!!vm.apportionPlanRowGrid.dataSource) {
          vm.apportionPlanRowGrid.dataSource.read();
        }
      }

      function createApportionPlan() {
        $state.go('Budget.Apportion.ApportionPlanCreate', { id: 0 });
      }

      function editApportionPlan() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPlanEdit', { id: id });
        }
      }

      function duplicateApportionPlan() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPlanDuplicate', { id: id });
        }
      }

      function deleteApportionPlan() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $http.get('Budget/ApportionPlanDelete/' + id).then(function() {
            toastr.success(vm.pageModel.Actions.ActionDelete.Title);
            vm.mainGrid.dataSource.read();
          });
        }
      }

      function viewApportionPlan() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Budget.Apportion.ApportionPlanView', { id: id });
        }
      }
      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Budget.Apportion.ApportionDasDocumentsNav', 'FlgApportionPlan', id);
      }

      function WAL() {
        walService.NavigateToWal('Budget', 'ApportionPlanNavWal', 'FlgApportionPlanView');
      }

      function history() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        HistoryService.NavigateToHistory('FlgApportionPlan', selectedItems[0][vm.subGridIdField], vm, $state, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ApportionLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ApportionLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SampleLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SampleLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SampleControlsCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'AuthService',
    '$httpParamSerializer',
    function($scope, model, $http, $state, $stateParams, $uibModal, $window, authService, $httpParamSerializer) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SampleControlsCtrl', stateParams);
      }
      var vm = this;
      vm.dtoDateTime = model.dtoDateTime;
      vm.pageModelDateTime = model.pageModelDateTime;
      vm.dtoF22 = model.dtoF22;
      vm.pageModelF22 = model.pageModelF22;
      vm.dtoF4 = model.dtoF4;
      vm.pageModelF4 = model.pageModelF4;
      vm.dtoF22Modal = model.dtoF22Modal;
      vm.pageModelModalF22 = model.pageModelModalF22;

      //collapsed
      vm.isSignatureCollapsed = true;
      vm.isFormDateTimeCollapsed = true;
      vm.isFormF22Collapsed = true;
      vm.isF22GeneratedFormlyCollapsed = false;

      //#region Signature

      vm.signatureSaveHandle = function(data) {
        alert('Save handler called');
      };

      vm.signatureSettings1 = {
        resetLabel: '#reset#',
        saveLabel: '#save#',
        color: '#fff',
        lineWidth: 6,
        width: 350,
        height: 100,
        background: '#000',
        saveHandle: function(data) {
          vm.signatureSaveHandle(data);
        },
      };

      vm.submit1 = function() {
        $http.post('Sample/SampleForms', { model: vm.dtoDateTime }).then(function(result) {
          alert(result.returnedDates);
        });
      };

      vm.submitF4 = function() {
        $http.post('Sample/SampleFormsF4', { model: vm.dtoF4 }).then(function(result) {
          alert(result.selectedValues);
        });
      };

      vm.openModal = function() {
        $('#f22ModalTest').modal('show');
      };

      vm.closeF22TestModal = function() {
        $('#f22ModalTest').modal('hide');
      };

      //#endregion Signature
      vm.formlyFormDescriptor = GenerateFormlyFormPanelsFromPageModel(vm.pageModelDateTime);

      //#region F22Native
      /*
            var grOpt = {
                fields: JSON.parse('{ "PartnerCode": { "type": "string" }, "Name": { "type": "string" }, "PartnerCatName": { "type": "string" }, "InvoiceAddress": { "type": "string" } }'),
                columns: JSON.parse("[{\"field\":\"PartnerCode\",\"title\":\"Partner kód\",\"width\":\"120px\",\"format\":null,\"hidden\":false,\"color\":false},{\"field\":\"Name\",\"title\":\"Név\",\"width\":\"120px\",\"format\":null,\"hidden\":false,\"color\":false},{\"field\":\"PartnerCatName\",\"title\":\"Partner kategória\",\"width\":\"120px\",\"format\":null,\"hidden\":false,\"color\":false},{\"field\":\"InvoiceAddress\",\"title\":\"Számlázási cím\",\"width\":\"120px\",\"format\":null,\"hidden\":false,\"color\":false}]")                
            };

            vm.varf2Model1 = {
                turnOff: false,
                testDescription: "Modális felület címsora: 'Cimsor teszt', Szűrés módja: 'lenyitható', megjelenítendő mező nincs megadva,  maximális hossz 12  (tab index 1)",
                required: true,
                disabled: false,
                tabIndex: 1,
                options: {
                    name: "PartnerCode",
                    modalTitle: "Cimsor teszt",
                    dataSourceTable: "FlgPartnerDataView",
                    valueField: "PartnerCode",
                    filteringMode: 0,
                    maxlength: 12,
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }

            vm.varf2Model2 = {
                turnOff: false,
                testDescription: "Nem írható, alapértlmezett érték \"Próba Péter\", alapértelmezett címsor (tab index 2)",
                required: true,
                disabled: false,
                tabIndex: 2,
                options: {
                    name: "PartnerCode",
                    defaultText: "Próba Péter",
                    filteringMode: 1,
                    dataSourceTable: "FlgPartnerDataView",
                    writable: 0,
                    textField: "Name",
                    valueField: "PartnerCode",
                    patternMatchMode: 1,
                    freeText: 0,
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }

            vm.varf2Model3 = {
                turnOff: false,
                testDescription: "Inaktív, alapértelmezett érték \"óba Pét\", alapértelmezet illeszkedésvizsgálat (tab index 3)",
                required: true,
                disabled: true,
                tabIndex: 3,                
                options: {
                    name: "PartnerCode",
                    defaultText: "óba Pét",
                    dataSourceTable: "FlgPartnerDataView",
                    textField: "Name",
                    valueField: "PartnerCode",
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }


            vm.varf2Model4 = {
                turnOff: false,
                testDescription: "Alapértelmezett érték \"óba Pét\", \"Kezdete\" illeszkedésvizsgálat (tab index 6)",
                required: true,
                disabled: false,
                tabIndex: 6,
                options: {
                    name: "PartnerCode",
                    defaultText: "óba Pét",                    
                    dataSourceTable: "FlgPartnerDataView",
                    textField: "Name",
                    valueField: "PartnerCode",
                    patternMatchMode: 1,
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }

            vm.varf2Model5 = {
                turnOff: false,
                testDescription: "Alapértelmezett érték \"Próba Pét\", illeszkedésvizsgálat eredményt adna, de szabadszöveges, maximális hossz 12 (tab index 5)",
                required: true,
                disabled: false,
                tabIndex: 5,
                options: {
                    maxlength: 12,
                    name: "PartnerCode",
                    defaultText: "Próba Pét",
                    dataSourceTable: "FlgPartnerDataView",
                    textField: "Name",
                    valueField: "PartnerCode",
                    patternMatchMode: 1,
                    freeText: 1,
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }

            vm.varf2Model6 = {
                turnOff: false,
                testDescription: "Alapértelmezett érték \"Jerry Lee\", de 987654 érték miatt \"Próba Péter\" jelenik meg (tab index 4)",
                required: true,
                disabled: false,
                tabIndex: 4,
                Value: 987654,
                options: {
                    name: "PartnerCode",
                    defaultText: "Jerry Lee",
                    dataSourceTable: "FlgPartnerDataView",
                    textField: "Name",
                    valueField: "PartnerCode",
                    errorhandler: toastr.error,
                    gridOptions: grOpt
                },
            }

            vm.blurTest = function (e) {
                console.log("blur handler called");
            }

            vm.changedTest = function (e) {
                console.log("changed handler called");
            }
//#endregion F22Native
*/

      //f22 formly
      vm.formlyFormDescriptorf22_generated = GenerateFormlyFormPanelsFromPageModel(vm.pageModelF22);

      //f4 formly
      vm.formlyFormF4Descriptor = GenerateFormlyFormPanelsFromPageModel(vm.pageModelF4);

      //f22 modal
      vm.formlyFormF22ModalDescriptor = GenerateFormlyFormPanelsFromPageModel(vm.pageModelModalF22);
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SampleFormlyCtrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'AuthService',
    '$httpParamSerializer',
    '$interval',
    function(
      $scope,
      model,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      authService,
      $httpParamSerializer,
      $interval
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SampleFormlyCtrl', stateParams);
      }
      var vm = this;

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;

        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.dataModel.Combo_1 = '3';
        vm.dataModel.isCombo_1Hidden = false;

        setTestFields(vm);
        generateForm(vm);

        console.log(vm.FormlyFormPanelDescriptors);
      }

      vm.baseNTBModel = {
        plainNTB1: 12.34,
      };

      vm.baseNTBTemplateOptions = {
        options: {
          key: 'plainNTB1',
          min: -100,
          max: 200,
          decimals: 5,
        },
        disabled: false,
        changed: function() {
          console.log('plainNTB1 onChange called');
        },
        spinner: false,
      };

      function setTestFields(vm) {
        var fs = fieldSetter;
        fs.vm = vm;

        fs.hideField('Combo_1', function() {
          return vm.dataModel.isCombo_1Hidden;
        });

        fs.setOnChangeFunction('Combo_1', function(selectedItem) {
          console.log('Running onChange function for Combo_1: ', selectedItem);
        });

        fs.setSyncValidator('Float_Required', 'Float_Required_v1', function(a, b, c) {
          return kendo.parseFloat(a) > 12;
        });
      }

      vm.hideCombo_1 = function() {
        console.log('Toggle Combo_1: ', vm.dataModel.isCombo_1Hidden, ' --> ', vm.dataModel.isCombo_1Hidden);
        vm.dataModel.isCombo_1Hidden = !vm.dataModel.isCombo_1Hidden;
        console.log('FD: ', vm.FormlyFormPanelDescriptors.PanelComboPanel.FormlyDescriptor);
      };

      vm.profTest = function() {
        $http({
          method: 'GET',
          url: '/Sample/ProfileTest1',
        }).then(
          function successCallback(response) {
            console.log('Megtortent');
          },
          function errorCallback(response) {}
        );
      };
      vm.profTest2 = function() {
        $http({
          method: 'GET',
          url: '/Sample/ProfileTest3',
        }).then(
          function successCallback(response) {
            console.log('Megtortent');
          },
          function errorCallback(response) {}
        );
      };

      // setInterval(function() {
      //     var IDs = ['1', '2', '7', '3'];
      //     console.log('changing model...');
      //     vm.dataModel.Combo_1 = IDs[Math.floor(Math.random()*IDs.length)];
      //     $scope.$apply();
      // }, 2000)

      // $interval(function () {
      //     var IDs = ['1', '2', '7', '3'];
      //     console.log('changing model [the angular way]...');
      //     vm.dataModel.Combo_1 = IDs[Math.floor(Math.random() * IDs.length)];
      // }, 2000);

      init();
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SampleDynamicF22Ctrl', [
    '$scope',
    'model',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'AuthService',
    '$httpParamSerializer',
    function($scope, model, $http, $state, $stateParams, $uibModal, $window, authService, $httpParamSerializer) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SampleDynamicF22Ctrl', stateParams);
      }
      var vm = this;
      vm.dtoDyn = model.dtoDyn;
      vm.pageModelDyn = model.pageModelDyn;

      var whereConditionFunction = function() {
        if (model.dtoDyn.Filter) {
          return "PartnerCode~startswith~'" + model.dtoDyn.Filter + "'";
        }
        return '';
      };

      vm.formlyFormDynDescriptor = GenerateFormlyFormPanelsFromPageModel(vm.pageModelDyn);
      vm.pageModelDyn.Fields.Partner.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;
      vm.pageModelDyn.Fields.PartnerF4.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionFunction;

      var onChangeFunctions = {
        InvoicePadId: function(value, selectedItem) {
          console.log('Kijelölt számlatömb:', value, selectedItem);
        },
      };

      var hideExpressions = {
        InvoicePadId: function($viewValue, $modelValue, scope) {
          return vm.dtoDyn.InvoicePadHide;
        },
        ACStatic: function($viewValue, $modelValue, scope) {
          return vm.dtoDyn.ACHide;
        },
        ACDynamic: function($viewValue, $modelValue, scope) {
          return vm.dtoDyn.ACHide;
        },
      };

      var customExpressionProperties = {
        InvoicePadId: {
          'templateOptions.required': function() {
            return vm.dtoDyn.InvoicePadRequired;
          },
          'templateOptions.disabled': function() {
            return vm.dtoDyn.InvoicePadDisabled;
          },
        },
        ACStatic: {
          'templateOptions.required': function() {
            return vm.dtoDyn.ACRequired;
          },
          'templateOptions.disabled': function() {
            return vm.dtoDyn.ACDisabled;
          },
        },
        ACDynamic: {
          'templateOptions.required': function() {
            return vm.dtoDyn.ACRequired;
          },
          'templateOptions.disabled': function() {
            return vm.dtoDyn.ACDisabled;
          },
        },
      };

      //InsertSyncValidators(vm.pageModelDyn, syncValidators);
      InsertOnChangeFunctions(vm.pageModelDyn, onChangeFunctions);
      InsertHideExpressions(vm.pageModelDyn, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModelDyn, customExpressionProperties);
    },
  ]);
})(angular.module('myApp'));

var myApp = angular.module('myApp');

myApp.config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Sample: {
        url: '/sample',
        templateUrl: 'App/Sample/SampleLayout.html',
        controller: 'SampleLayoutCtrl as vm',
        redirectTo: 'Sample.SampleControls',
        ncyBreadcrumb: {
          label: 'Minta oldal',
          parent: 'main',
        },
      },
      'Sample.SampleControls': {
        url: '/controls',
        views: {
          content: {
            templateUrl: 'App/Sample/SampleControls.html',
            controller: 'SampleControlsCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Sample/SampleForms/'),
        },
        ncyBreadcrumb: {
          label: 'Minta kontrolok',
        },
      },
      'Sample.SampleFormly': {
        url: '/formly',
        views: {
          content: {
            templateUrl: 'App/Sample/SampleFormly.html',
            controller: 'SampleFormlyCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Sample/FormlyForm/'),
        },
        ncyBreadcrumb: {
          label: 'Formly <-> plain control comparator',
        },
      },
      'Sample.SampleDynamicF22': {
        url: '/dynf22',
        views: {
          content: {
            templateUrl: 'App/Sample/SampleDynamicF22.html',
            controller: 'SampleDynamicF22Ctrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Sample/DynamicF22/'),
        },
        ncyBreadcrumb: {
          label: 'Dinamikus F22',
        },
      },
      'Sample.SampleInvoiceValuesCalculator': {
        url: '/invoiceValuesCalculator',
        views: {
          content: {
            templateUrl: 'App/Sample/SampleInvoiceValuesCalculator.html',
            controller: 'SampleInvoiceValuesCalculatorCtrl as vm',
          },
        },
        resolve: {},
        ncyBreadcrumb: {
          label: 'Nettó/Bruttó kalkulátor',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('SampleInvoiceValuesCalculatorCtrl', [
    '$scope',
    'InvoiceValuesCalculatorService',
    function($scope, InvoiceValuesCalculatorService) {
      var vm = this;
      vm.formModel = {};

      vm.formModel.Vat = 27;
      vm.formModel.CalcMode = 0;
      vm.formModel.Quantity = 1;

      vm.formModel.BaseUnitPrice = 0;
      vm.formModel.BaseGrossUnitPrice = 0;

      vm.formModel.UnitPrice = 0;
      vm.formModel.GrossUnitPrice = 0;

      vm.formModel.Discount = 0;
      vm.formModel.DiscountPercent = 0;

      vm.formModel.Net = 0;
      vm.formModel.VatAmount = 0;
      vm.formModel.Gross = 0;

      vm.ivc = InvoiceValuesCalculatorService;
      vm.ivc.setModel(vm.formModel);

      function calc1() {
        vm.ivc.CalcFromBaseUnitPrice();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.directive('f22Input', [
    '$http',
    'gridService',
    '$rootScope',
    'AuthService',
    function($http, gridService, $rootScope, authservice) {
      return {
        restrict: 'E',
        require: 'ngModel',
        templateUrl: 'App/F22/f22.html',
        scope: {
          f2Value: '=ngModel',
          f2Options: '=',
          disabled: '=ngDisabled',
          changed: '&',
          blur: '&',
          ngClick: '&',
          gridModel: '<',
          formlyFocus: '@',
          formlyWait: '@',
          hideInput: '=',
        },
        controller: [
          '$scope',
          '$rootScope',
          'AuthService',
          function($scope, $rootScope, authService) {
            $scope.disableGridState = function() {
              if (!!authService.parameters?.FWCOID) {
                $scope.f2Options.disableOptions = { GridStateSave: true, GridStateRestore: true };
              }
              $scope.parameters = authService.parameters;
            };

            if (!authService?.parameters) {
              authService.getUserContext(false, $scope.disableGridState);
            } else {
              $scope.disableGridState();
            }
            //set precision
            $scope.gridModel?.Columns?.filter(
              x => ($scope.gridModel.DefaultPrecisionFields || []).indexOf(x.field) !== -1
            ).forEach(x => (x.format = '{0:n' + (authService.parameters?.DEFFPR || 2) + '}'));
          },
        ],
        link: function(scope, element, attrs, ngModCont) {
          scope.isInit = true;
          scope.restoredConfig = undefined;
          $rootScope.$emit('$stateAndRefreshForElement', scope.f2Options);
          scope.f2Options.isInit = scope.isInit;
          scope.f2Options.setFunctions.setText = SetTextToBox;
          scope.f2Options.setFunctions.setValue = SetValueToBox;
          scope.f2Options.clearFilterModal = clearFilterModal;
          scope.f2Options.setFunctions.dataSourceRead = dataSourceRead;
          scope.f2Options.getFunctions.getRows = getRows;

          scope.grid = {};
          scope.errorHandler =
            scope.f2Options.errorHandler ||
            function(message) {
              alert(message);
            };

          if (!scope.f2Value) {
            scope.f2Value = {
              Value: null,
              Text: null,
            };
          }
          if (!scope.f2Value.Value && attrs.required && scope.f2Options.selectFirst) {
            SelectFirstElement();
          }
          if (!scope.f2Value.hasOwnProperty('Value')) {
            scope.f2Value.Value = null;
          }

          if (!scope.f2Value.hasOwnProperty('Text')) {
            scope.f2Value.Text = null;
          }

          if (scope.f2Value.turnOff) {
            return;
          }

          if (!scope.f2Options.gridOptions) {
            //ERROR
            scope.errorHandler('no options');
          }
          // default values
          if (scope.f2Options.valueField === null) {
            scope.errorHandler('tarolando mezo hianyzik');
          }

          if (scope.f2Options.textField === null) {
            scope.f2Options.textField = scope.f2Options.valueField;
          }

          if (scope.f2Options.freeText && scope.f2Options.textField !== scope.f2Options.valueField) {
            scope.errorHandler('Szabadszöveges mező érték és megjelenítendő mezője különböző');
          }

          if (scope.f2Options.writable === null) {
            scope.f2Options.writable = 1;
          }

          if (scope.f2Options.filteringMode === null) {
            scope.f2Options.filteringMode = 1;
          }

          if (scope.f2Options.modalTitle === null) {
            scope.f2Options.modalTitle = scope.f2Options.name;
          }

          scope.gridId = function() {
            return 'f22_' + scope.f2Options.valueField;
          };

          scope.whereCondition = function() {
            var whereCondition = '';
            if (angular.isFunction(scope.f2Options.whereCondition)) {
              whereCondition = scope.f2Options.whereCondition(scope.$parent.model);
            } else {
              whereCondition = scope.f2Options.whereCondition;
            }
            return whereCondition;
          };

          scope.gridrequestParams = function() {
            var transportData = {
              tableName: scope.f2Options.dataSourceTable,
              whereCondition: scope.whereCondition(),
              columnCsv: scope.f2Options.gridOptions.columnCsv,
              idColumn: scope.f2Options.gridOptions.tableKey,
              adopter: scope.f2Options.adopter,
              installAdopter: scope.f2Options.installAdopter,
            };

            if (scope.f2Options.gridOptions.selectById) {
              angular.extend(transportData, {
                selectById: scope.f2Options.gridOptions.selectById(),
              });
            }

            return transportData;
          };

          scope.gridSelectionChanged = function(selection) {
            scope.$apply(function() {
              scope.isGridRowSelected = !!selection;
              if (selection) {
                scope.gridSelectedItem = selection;
              } else {
                scope.gridSelectedItem = null;
              }
            });
          };
          scope.f2Value.firstText = scope.f2Value.Text;
          angular.extend(scope.f2Options.gridOptions, { filteringMode: scope.f2Options.filteringMode });
          scope.gridOptions = function() {
            const { customControllerMethod, dsChanged, fields, toolbar, groupable } = scope.f2Options.gridOptions;
            const initialOptions = scope.f2Options.gridOptions.initialOptions || {};
            const columns =
              scope.f2Options.gridOptions.columns ||
              Object.keys(fields).map(function(fieldKey) {
                return Object.assign({ field: key }, fields[fieldKey]);
              });
            if (typeof scope.f2Options.disableOptions?.AutoComplete !== 'boolean') {
              if (!scope.f2Options.disableOptions) {
                scope.f2Options.disableOptions = {};
              }
              scope.f2Options.disableOptions.AutoComplete = true;
              scope.f2Options.disableOptions.FilterRestore = true;
            }

            return gridService.buildKendoConfig({
              autoBind: true,
              gridId: scope.gridId(),
              dataSourceOptions: {
                url: customControllerMethod || 'F22/GridData',
                schema: {
                  data: 'Data',
                  total: 'Total',
                  fields,
                  model: {
                    fields,
                  },
                },
                errorHandler: function(error) {
                  const msg = `F22 grid: ${error.errorThrown.message || error.errorThrown}`;
                  if (typeof scope.errorHandler === 'function') {
                    scope.errorHandler.call(this, msg);
                  } else {
                    alert(msg);
                  }
                },
                transportData: scope.gridrequestParams,
                change: function() {
                  if (typeof dsChanged === 'function') {
                    dsChanged.call(this, this.data());
                  }
                },
                filter: initialOptions.filter,
                sort: initialOptions.sort,
                pageSize: 10,
              },
              columns,
              toolbar,
              groupable,
              selectionChanged: function(e) {
                const grid = e.sender;
                const selectedItem = grid.dataItem(this.select());
                scope.gridSelectionChanged(selectedItem);
              },
              disableOptions: scope.f2Options.disableOptions,
              filterMode: 'row',
            });
          };
          function getRows(callback, whereCondition = '', whereReplace = false) {
            let tempWhereCondition,
              origWhereCondition = angular.isFunction(scope.f2Options.whereCondition)
                ? scope.f2Options.whereCondition()
                : scope.f2Options.whereCondition;
            origWhereCondition = !!origWhereCondition ? origWhereCondition : '';
            if (whereReplace && whereCondition) {
              tempWhereCondition = whereCondition;
            } else {
              tempWhereCondition = origWhereCondition + whereCondition;
            }
            $http
              .post('F22/GridData', {
                tableName: scope.f2Options.dataSourceTable,
                whereCondition: tempWhereCondition,
                columnCsv: scope.f2Options.gridOptions.columnCsv,
                idColumn: scope.f2Options.valueField,
                adopter: scope.f2Options.adopter,
                installAdopter: scope.f2Options.installAdopter,
                pageSize: 2,
                page: 1,
              })
              .then(function(response) {
                callback(response);
              });
          }
          function SelectFirstElement(one = true) {
            getRows(function(response) {
              if (response.data?.Data?.length === 1 || !one) {
                scope.f2Value.Value = response.data.Data[0][scope.f2Options.valueField];
                scope.f2Value.Text = response.data.Data[0][scope.f2Options.textField];
                RaiseChanged(response.data.Data[0]);
              }
            });
          }

          function SetValueToBox(value) {
            if (!value && attrs.required && scope.f2Options.selectFirst) {
              SelectFirstElement();
            }
            if (value === null) {
              scope.f2Value = {
                Value: value,
                Text: value,
              };
              RaiseChanged();
            } else if (scope.f2Options.textField === scope.f2Options.valueField) {
              // ez szabadszovegesre mindig igaz
              scope.f2Value = {
                Value: value,
                Text: value,
              };
            } else {
              scope.isLoading = true;
              $http
                .post('F22/F22TextSearch', {
                  key: value,
                  keyColumn: scope.f2Options.valueField,
                  showColumn: scope.f2Options.textField,
                  tableName: scope.f2Options.dataSourceTable,
                  whereCondition: scope.whereCondition(),
                  adopter: scope.f2Options.adopter,
                  installAdopter: scope.f2Options.installAdopter,
                })
                .then(function(result) {
                  if (result.data.Text !== null) {
                    scope.f2Value = {
                      Value: value,
                      Text: result.data.Text,
                    };
                  } else if (scope.f2Options.freeText) {
                    scope.f2Value = {
                      Value: value,
                      Text: value,
                    };
                  } else {
                    scope.f2Value = {
                      Value: null,
                      Text: null,
                    };
                  }
                  RaiseChanged();
                  scope.isLoading = false;
                });
            }
          }

          function SetTextToBox(text) {
            if (text === null || text === '' || scope.f2Options.freeText) {
              scope.f2Value = {
                Value: text,
                Text: text,
              };
              RaiseChanged();
            } else {
              scope.isLoading = true;
              $http
                .post('F22/F22PatternSearch', {
                  pattern: text,
                  keyColumn: scope.f2Options.valueField,
                  showColumn: scope.f2Options.textField,
                  columnCsv: scope.f2Options.gridOptions.columnCsv,
                  searchMode: scope.f2Options.patternMatchMode,
                  tableName: scope.f2Options.dataSourceTable,
                  whereCondition: scope.whereCondition(),
                  adopter: scope.f2Options.adopter,
                  installAdopter: scope.f2Options.installAdopter,
                })
                .then(function(result) {
                  if (result.data.HitCount === 1) {
                    scope.f2Value = {
                      Value: result.data.Value,
                      Text: result.data.Text,
                    };
                    RaiseChanged(result.data.Row);
                  } else {
                    if (result.data.HitCount === 0) {
                      ngModCont.$setValidity('f22NopatternMatch', false);
                    } else {
                      ngModCont.$setValidity('f22tooMuchPatternMatch', false);
                    }
                    scope.isDirty = true;
                  }
                  scope.isLoading = false;
                });
            }
          }

          function validate() {
            let valid = !attrs.required || !scope.f2Value || !!scope.f2Value.Value;
            ngModCont.$setValidity('required', valid);
            ngModCont.$setValidity('f22NopatternMatch', valid);
            ngModCont.$setValidity('f22tooMuchPatternMatch', valid);
          }

          function RaiseBlur(gridSelectedItem) {
            validate();
            if (angular.isFunction(scope.blur)) {
              scope.blur({
                selectedItem: {
                  Value: scope.f2Value.Value,
                  Text: scope.f2Value.Text,
                  // a kivalasztott grid item elkuldese, ha valasztassal toltottuk a mezot
                  GridItem: gridSelectedItem,
                  FormModel: scope.$parent.model,
                },
              });
            }
            if (angular.isFunction(scope.f2Options.InputChanged)) {
              scope.f2Options.InputChanged(scope);
            }
            if (scope.isInit === false) {
              ngModCont.$setViewValue(scope.f2Value);
            }
            scope.isInit = false;
          }

          function RaiseChanged(gridSelectedItem) {
            validate();
            if (angular.isFunction(scope.changed)) {
              scope.changed({
                selectedItem: {
                  Value: scope.f2Value.Value,
                  Text: scope.f2Value.Text,
                  // a kivalasztott grid item elkuldese, ha valasztassal toltottuk a mezot
                  GridItem: gridSelectedItem,
                  FormModel: scope.$parent.model,
                },
              });
            }
            if (angular.isFunction(scope.f2Options.InputChanged)) {
              scope.f2Options.InputChanged(scope);
            }
            if (scope.isInit === false) {
              ngModCont.$setViewValue(scope.f2Value);
            }
            scope.isInit = false;
          }

          function getGridElements() {
            return element.find('.f2-grid');
          }

          if (scope.f2Value.Value != null) {
            SetValueToBox(scope.f2Value.Value);
          } else if (scope.f2Value.Text != null) {
            SetTextToBox(scope.f2Value.Text);
          } else if (scope.f2Options.defaultText) {
            SetTextToBox(scope.f2Options.defaultText);
          } else {
            scope.isInit = false;
          }

          scope.gridId = function() {
            return 'f22_' + scope.f2Options.valueField;
          };

          scope.onClear = function(event) {
            SetValueToBox(null);
            validate();
          };

          scope.openF2Modal = function(scope2) {
            scope.$parent.$parent.$on('modal.closing', function(e) {
              if (!!element.find('.f2-modal.in').length) {
                e.preventDefault();
                e.preventDefault();
              }
            });
            $(document).on('keydown', function(evt) {
              if (evt.keyCode == 27) {
                evt.preventDefault();
                scope.closeF2Modal();
              }
            });
            if (!scope.grid.kendoGrid) {
              gridService.restoreState(scope.gridOptions()).subscribe(restoredConfig => {
                scope.restoredConfig = restoredConfig;
                scope.isGridRowSelected = false;
              });
            } else {
              dataSourceRead();
            }

            // if (scope.isDirty || scope.f2Value.Text) {
            // var filterOperator = 'contains';
            // if (scope.f2Options.patternMatchMode == 1) {
            // filterOperator = 'startswith';
            // }
            // if (scope.f2Value.Text) {
            // scope.grid.dataSource.filter({
            // field: scope.f2Options.textField,
            // operator: filterOperator,
            // value: scope.f2Value.Text,
            // });
            // }
            // }

            element.find('.f2-modal').modal('show');
            scope.showUp = true;
          };

          scope.closeF2Modal = function() {
            // store grid state
            var grid = getGridElements()[0];
            if (grid) {
              gridService.saveKendoGrid($(grid).data('kendoGrid'));
            }
            if (!!scope.parameters?.FWCOID) {
              scope.showUp = false;
            }
            element.find('.f2-modal').modal('hide');
          };

          scope.cancelF2Modal = function() {
            scope.closeF2Modal();

            if (scope.isDirty) {
              element
                .find('input')
                .get(0)
                .focus();
            }
          };

          scope.okF2Modal = function() {
            scope.isDirty = false;
            scope.f2Value = {
              Value: scope.gridSelectedItem[scope.f2Options.valueField],
              Text: scope.gridSelectedItem[scope.f2Options.textField],
            };

            RaiseBlur(scope.gridSelectedItem);
            RaiseChanged(scope.gridSelectedItem);
            scope.closeF2Modal();
          };
          scope.clearFilterModal = clearFilterModal;
          function clearFilterModal() {
            if (!!scope.grid.kendoGrid && !!scope.grid.kendoGrid.dataSource) {
              scope.grid.kendoGrid.dataSource.filter([]);
            }
          }
          scope.clearFilterModal = clearFilterModal;

          function clearFilterModal() {
            if (!!scope.grid.kendoGrid && !!scope.grid.kendoGrid.dataSource) {
              scope.grid.kendoGrid.dataSource.filter([]);
            }
          }
          function dataSourceRead() {
            if (!!scope.grid.kendoGrid && !!scope.grid.kendoGrid.dataSource) {
              scope.grid.kendoGrid.dataSource.read();
            }
          }

          scope.inputOnChange = function() {
            scope.isDirty = true;
          };

          scope.inputOnKeypress = function(e) {
            if (e.which === 113) {
              e.preventDefault();
              scope.openF2Modal();
            }
          };

          scope.inputOnBlur = function(e) {
            if (scope.isDirty) {
              setTimeout(function() {
                var x = element.find('.f2-btn')[0];
                if (document.activeElement !== x) {
                  scope.$apply(function() {
                    SetTextToBox(scope.f2Value.Text);
                    scope.isDirty = false;
                    RaiseBlur();
                  });
                }
              }, 0);
            } else {
              RaiseBlur();
            }
          };

          scope.f2Options.openF2Modal = scope.openF2Modal;

          scope.$watch('f2Value', function(newValue, oldValue) {
            validate();
          });
          attrs.$observe('required', function() {
            validate();
          });
        },
      };
    },
  ]);
})(angular.module('myApp'));

var F22Helpers = F22Helpers || {};

F22Helpers.setF22Options = function(field) {
  if (field.templateOptions.hideInput) {
    field.templateOptions.DynamicOptions.ModalTitle = field.templateOptions.label;
    field.templateOptions.label = null;
  }
  if (!field.templateOptions.GridOptions || !field.templateOptions.GridOptions.gridModel) return;
  var columns = field.templateOptions.GridOptions.gridModel.Columns;
  var columnCsv = '';
  if (columns.length > 0) {
    columnCsv = columns[0].field;
    for (var i = 1; i < columns.length; i++) {
      columnCsv = columnCsv.concat(',' + columns[i].field);
    }
  }

  angular.extend(field.templateOptions, {
    setFunctions: {
      setValue: null,
      setText: null,
    },
    getFunctions: {},
    clearFilterModal: null,
  });

  var f2options = {
    defaultText: field.templateOptions.defaultValue,
    filteringMode: field.templateOptions.DynamicOptions.FilteringMode ?? 1,
    freeText: field.templateOptions.DynamicOptions.FreeText,
    modalTitle: field.templateOptions.DynamicOptions.ModalTitle,
    name: field.templateOptions.label,
    patternMatchMode: field.templateOptions.DynamicOptions.PatternMatchMode,
    dataSourceTable: field.templateOptions.DynamicOptions.TableName,
    textField: field.templateOptions.DynamicOptions.TextFieldName,
    valueField: field.templateOptions.DynamicOptions.ValueFieldName,
    writable: field.templateOptions.DynamicOptions.Writable,
    errorHandler: toastr.error,
    maxlength: field.templateOptions.f2maxlength,
    mask: field.templateOptions.mask,
    fieldsToSet: field.templateOptions.DynamicOptions.FieldsToSet,
    RouteState: field.templateOptions.RouteState,
    gridOptions: {
      //otherParams: field.templateOptions.QueryParameters,
      groupable: false,
      height: 350,
      fields: JSONfn.parse(field.templateOptions.GridOptions.gridModel.Fields),
      columns: field.templateOptions.GridOptions.gridModel.Columns,
      columnCsv: columnCsv,
      tableKey: field.templateOptions.GridOptions.gridModel.IdColumn,
    },
    adopter: field.templateOptions.DynamicOptions.Adopter,
    whereCondition: field.templateOptions.DynamicOptions.whereCondition || field.templateOptions.options.whereCondition,
    setFunctions: field.templateOptions.setFunctions,
    getFunctions: field.templateOptions.getFunctions,
    clearFilterModal: field.templateOptions.clearFilterModal,
    selectFirst: field.templateOptions.selectFirst ?? true,
    hideInput: field.templateOptions.hideInput ?? false,
    //otherParams: field.templateOptions.QueryParameters
  };
  field.templateOptions.options = f2options;
};

(function(module) {
  'use strict';

  module.controller('HelpDeskLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        HelpDesk_TicketNav: { icon: 'fa fa-university' },
        HelpDesk_TaskDateNav: { icon: 'fa fa-university' },
        Masterdata_HelpDesk: { icon: 'fa fa-university' },
      };

      buildMenu($state, authService, 'HelpDesk', 'helpdesk', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      HelpDesk: {
        url: '/helpdesk',
        templateUrl: 'App/HelpDesk/HelpDeskLayout.html',
        controller: 'HelpDeskLayoutCtrl as vm',
        redirectTo: 'HelpDesk.TicketNav',
        ncyBreadcrumb: {
          label: 'HelpDesk',
          parent: 'main',
        },
      },
      'HelpDesk.TicketNav': {
        url: '/nav',
        params: {
          module: 'helpdesk',
          formMode: 'Nav',
          backState: 'main',
          createState: 'HelpDesk.TicketCreate',
          editState: 'HelpDesk.TicketEdit',
          documentEntity: 'helpdesk_ticketnav',
          //duplicateState: "Partner.Duplicate",
          //deleteState: "Partner/PartnerDelete/",
          //viewState: "Partner.View",
          //documentEntity: "Partner",
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskNav.html',
            controller: 'HelpDeskNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDesk/HelpDeskListOptions/'),
        },
        options: {
          mvcController: 'HelpDesk/HelpDeskListOptions/',
        },
        ncyBreadcrumb: {
          //skip: true,
          label: 'Bejelentések áttekintése, szűrése',
        },
      },
      'HelpDesk.TaskDateNav': {
        url: '/taskdatenav',
        params: {
          module: 'helpdesk',
          formMode: 'Nav',
          backState: 'main',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskTaskDateNav.html',
            controller: 'HelpDeskTaskDateNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDesk/HelpDeskTaskDateListOptions/'),
        },
        options: {
          mvcController: 'HelpDesk/HelpDeskTaskDateListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Karbantartási terv',
        },
      },

      'HelpDesk.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        options: {
          mvcController: 'Das/Documents/DocumentsListOptions/',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'HelpDesk.TicketTemplateCreate': {
        url: '/tickettemplatecreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/HelpDesk/TicketTemplateEdit.html',
            controller: 'TicketTemplateEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/TicketTemplateCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/TicketTemplateCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          backTo: 'MasterData.HelpDesk.TicketTemplateList',
          documentEntity: 'masterdata_helpdesk_tickettemplate',
        },
        ncyBreadcrumb: {
          label: 'Munkalap sablon',
        },
      },
      'HelpDesk.TicketTemplateEdit': {
        url: '/tickettemplateedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/HelpDesk/TicketTemplateEdit.html',
            controller: 'TicketTemplateEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/TicketTemplateEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/TicketTemplateEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          backTo: 'MasterData.HelpDesk.TicketTemplateList',
        },
        ncyBreadcrumb: {
          label: 'Munkalap sablon',
        },
      },
      'HelpDesk.TicketTemplateDuplicate': {
        url: '/tickettemplateduplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/HelpDesk/TicketTemplateEdit.html',
            controller: 'TicketTemplateEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/TicketTemplateDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/TicketTemplateDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          backTo: 'MasterData.HelpDesk.TicketTemplateList',
        },
        ncyBreadcrumb: {
          label: 'Munkalap sablon',
        },
      },
      'HelpDesk.TicketHDJEXCreate': {
        url: '/createHDJEX',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskEditHDJEX.html',
            controller: 'HelpDeskEditHDJEXCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TicketCreateHDJEX/', undefined),
        },
        options: {
          mvcController: 'HelpDesk/TicketCreateHDJEX/',
        },
        params: {
          formMode: 'Create',
          postUrl: 'HelpDesk/TicketCreateHDJEX',
          backStateAfterSave: 'HelpDesk.TicketHDJEXView',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'InsertedId' }],
          backState: 'HelpDesk.TicketNav',
          controllerOptions: {
            isFormReadOnly: false,
            ctrlIdTemplate: '{ctrl}',
          },
          CreateOrEdit: 'Create',
          backTo: 'HelpDesk.TicketNav',
          documentEntity: 'helpdesk_ticketcreate',
        },
        ncyBreadcrumb: {
          label: 'Bejelentés hozzáadása',
        },
      },
      'HelpDesk.TicketHDJEXView': {
        url: '/viewHDJEX/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskEditHDJEX.html',
            controller: 'HelpDeskEditHDJEXCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TicketViewHDJEX/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TicketViewHDJEX/',
        },
        params: {
          formMode: 'Edit',
          postUrl: 'HelpDesk/TicketEditHDJEX',
          backStateAfterSave: 'HelpDesk.TicketEditHDJEX',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TicketId' }],
          backState: 'HelpDesk.TicketNav',
          controllerOptions: {
            isFormReadOnly: true,
          },
          CreateOrEdit: 'Edit',
          createState: 'HelpDesk.TicketHDJEXCreate',
          backTo: 'HelpDesk.TicketNav',
          documentEntity: 'helpdesk_ticketcreate',
        },
        ncyBreadcrumb: {
          label: 'Bejelentés megtekintése',
        },
      },
      'HelpDesk.TicketCreate': {
        url: '/create/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskEdit.html',
            controller: 'HelpDeskEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TicketCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TicketCreate/',
        },
        params: {
          formMode: 'Create',
          postUrl: 'HelpDesk/TicketEdit',
          backStateAfterSave: 'HelpDesk.TicketEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'InsertedId' }],
          backState: 'HelpDesk.TicketNav',
          controllerOptions: {
            isFormReadOnly: false,
            ctrlIdTemplate: '{ctrl}_Create',
          },
          CreateOrEdit: 'Create',
          backTo: 'HelpDesk.TicketNav',
          documentEntity: 'helpdesk_ticketcreate',
        },
        ncyBreadcrumb: {
          label: 'Bejelentés hozzáadása',
        },
      },
      'HelpDesk.TicketDuplicate': {
        url: '/duplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskEdit.html',
            controller: 'HelpDeskEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TicketDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TicketDuplicate/',
        },
        params: {
          formMode: 'Create',
          postUrl: 'HelpDesk/TicketEdit',
          backStateAfterSave: 'HelpDesk.TicketEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'InsertedId' }],
          backState: 'HelpDesk.TicketNav',
          controllerOptions: {
            isFormReadOnly: false,
            ctrlIdTemplate: '{ctrl}_Create',
          },
          CreateOrEdit: 'Create',
          backTo: 'HelpDesk.TicketNav',
          documentEntity: 'helpdesk_ticketcreate',
        },
        ncyBreadcrumb: {
          label: 'Bejelentés hozzáadása',
        },
      },
      'HelpDesk.TicketEdit': {
        url: '/edit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskEdit.html',
            controller: 'HelpDeskEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TicketEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TicketEdit/',
        },
        params: {
          formMode: 'Edit',
          postUrl: 'HelpDesk/TicketEdit',
          backStateAfterSave: 'HelpDesk.TicketEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TicketId' }],
          backState: 'HelpDesk.TicketNav',
          controllerOptions: {
            isFormReadOnly: false,
            ctrlIdTemplate: '{ctrl}_{statusCode}',
            formModel: 'dto',
          },
          CreateOrEdit: 'Edit',
          createState: 'HelpDesk.TicketCreate',
          backTo: 'HelpDesk.TicketNav',
          documentEntity: 'helpdesk_ticketcreate',
        },
        ncyBreadcrumb: {
          label: 'Bejelentés szerkesztése',
        },
      },
      'HelpDesk.TicketDoc': {
        url: '/doc/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskDoc.html',
            controller: 'HelpDeskDocCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('HelpDesk/TicketDoc/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TicketDoc/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          backTo: 'Nav',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'HelpDesk.TenderCreate': {
        url: '/edit/{ticketId:int}/tender/create',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskTenderEdit.html',
            controller: 'HelpDeskTenderEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TenderEdit/', undefined, ['ticketId']),
        },
        options: {
          mvcController: 'HelpDesk/TenderEdit/',
        },
        params: {
          formMode: 'Create',
          postUrl: 'HelpDesk/TenderEdit',
          backStateAfterSave: 'HelpDesk.TenderEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'InsertedId' }],
          backState: 'HelpDesk.TicketEdit',
          backStateParams: [{ name: 'id', modelName: 'TicketId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Create',
          backTo: 'HelpDesk.TicketEdit',
        },
        ncyBreadcrumb: {
          label: 'Árajánlat hozzáadása',
        },
      },
      'HelpDesk.TenderEdit': {
        url: '/tender/edit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/HelpDesk/HelpDeskTenderEdit.html',
            controller: 'HelpDeskTenderEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDesk/TenderEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDesk/TenderEdit/',
        },
        params: {
          formMode: 'Edit',
          postUrl: 'HelpDesk/TenderEdit',
          backStateAfterSave: 'HelpDesk.TenderEdit',
          backStateAfterSaveParams: [{ name: 'id', modelName: 'TenderId' }],
          backState: 'HelpDesk.TicketEdit',
          backStateParams: [{ name: 'id', modelName: 'TicketId' }],
          controllerOptions: {
            isFormReadOnly: false,
          },
          CreateOrEdit: 'Edit',
          createState: 'HelpDesk.TicketCreate',
          backTo: 'HelpDesk.TicketEdit',
        },
        ncyBreadcrumb: {
          label: 'Árajánlat szerkesztése',
        },
      },
      'HelpDesk.HelpDeskSpecializationEdit': {
        url: '/helpdeskSpecializationEdit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/SpecializationEdit/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/SpecializationEdit/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          backTo: 'Masterdata.HelpDesk.SpecializationList',
          documentEntity: 'masterdata_helpdesk_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület szerkesztése',
        },
      },
      'HelpDesk.HelpDeskSpecializationCreate': {
        url: '/helpdeskSpecializationCreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/SpecializationCreate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/SpecializationCreate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          backTo: 'Masterdata.HelpDesk.SpecializationList',
          documentEntity: 'masterdata_helpdesk_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület hozzáadása',
        },
      },
      'HelpDesk.HelpDeskSpecializationDuplicate': {
        url: '/helpdeskSpecializationDuplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('HelpDeskMasterData/SpecializationDuplicate/', undefined, ['id']),
        },
        options: {
          mvcController: 'HelpDeskMasterData/SpecializationDuplicate/',
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          backTo: 'Masterdata.HelpDesk.SpecializationList',
          documentEntity: 'masterdata_helpdesk_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület másolása',
        },
      },
      'HelpDesk.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'HelpDeskMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('History/HistoryListOptions/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };
    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('HelpDeskNavCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    'options',
    '$http',
    '$state',
    'WalService',
    '$stateParams',
    'HistoryService',
    'DasService',
    'AuthService',
    '$uibModal',
    'gridService',
    'UIHelperService',
    'SurveyService',
    function(
      $rootScope,
      $scope,
      $timeout,
      options,
      $http,
      $state,
      walService,
      $stateParams,
      HistoryService,
      dasService,
      authService,
      $uibModal,
      gridService,
      UIHelperService,
      SurveyService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskNavCtrl', stateParams);
      }
      var vm = this;

      if (options.dto.UserType !== 'HDJEX' && options.dto.UserType !== 'HDJIO') {
        vm.showPage = false;
        bootbox.dialog({
          message:
            'Ön nem rendelkezik a Bejelentések eléréséhez szükséges jogosultsági szinttel. <br><br> Kérem tájékoztassa a felhasználók kezeléséért felelős kollégáját, hogy a <em>Szervíz modul - Felhasználók</em> felületén a <b>Helpdesk Szerepköröknél</b> rendelje Önt hozzá a megfelelő <b>Bejelentő típushoz</b>.',
          title: 'Hozzáférés megtagadva',
          buttons: {
            cancel: {
              label: 'Vissza a főoldalra',
              className: 'btn-primary',
              callback: function() {
                $state.go('main');
              },
            },
          },
        });
      } else {
        var autoRefreshTimer = SBTimer.getInstance('helpdeskAutoRefresh');
        var autoRefreshTickHandler = null;
        init();
        vm.UIHelperService = UIHelperService;
        vm.showPage = true;
        vm.WAL = WAL;
        vm.multiApprove = multiApprove;
        vm.History = history;
        vm.historyPageModel = options.historyPageModel;
        vm.customFilterPageModel = options.customFilterPageModel;
        vm.CustomFilterComboRef;
        vm.searchBackground = 'transparent';
        vm.generateInvoice = generateInvoice;
        vm.filteredStatus = [];
        vm.selectedFilterButtons = selectedFilterButtons;
        vm.gridLoaded = false;
        vm.dataBoundFunction = dataBoundFunction;
        vm.generateSurveyReports = generateSurveyReports;

        vm.dropdownsToUpdate = [
          vm.pageModel.Fields.HelpDeskPriorityId,
          vm.pageModel.Fields.ServiceLevelId,
          vm.pageModel.Fields.SpecializationId,
          vm.pageModel.Fields.TicketTypeId,
          vm.pageModel.Fields.ShowedTicket,
        ];
        vm.isBox = authService?.parameters?.SBBox;
        function getKeyName(panelName, loggedUser) {
          return 'Is.' + loggedUser + '.HelpDeskNav.' + panelName;
        }

        function getRefreshIntervalKey() {
          return 'Is.' + vm.dataModel.LoggedUser + '.HelpDeskNav.RefreshInterval';
        }

        vm.isCollapsed1 =
          localStorage.getItem(getKeyName('panelFilter', vm.dataModel.LoggedUser)) === 'true' || !!vm.isBox;
        vm.isCollapsed2 =
          localStorage.getItem(getKeyName('panelStat', vm.dataModel.LoggedUser)) === 'true' || !!vm.isBox;

        $scope.$watch('vm.isCollapsed1', function(newvalue, oldvalue) {
          if (oldvalue !== newvalue) {
            localStorage.setItem(getKeyName('panelFilter', vm.dataModel.LoggedUser), vm.isCollapsed1);
          }
        });

        $scope.$watch('vm.isCollapsed2', function(newvalue, oldvalue) {
          if (oldvalue !== newvalue) {
            localStorage.setItem(getKeyName('panelStat', vm.dataModel.LoggedUser), vm.isCollapsed2);
          }
        });

        $scope.$on('$destroy', function() {
          if (autoRefreshTickHandler) {
            autoRefreshTimer.unsubscribe('tick', autoRefreshTickHandler);
            autoRefreshTickHandler = null;
          }
          autoRefreshTimer.stop();
          if (authService && authService.isLoggedIn) {
            vm.setFilterFieldState();
            if (!authService?.parameters?.FWCOID) {
              sessionStorage.setItem(
                'Is.' + authService.user.id + '.HelpdeskNav.SelectedFilter',
                JSON.stringify(vm.selectedFilter)
              );
            }
          }
        });

        vm.detailGridExpanded =
          localStorage.getItem(getKeyName('detailGridExpanded', vm.dataModel.LoggedUser)) === 'true';

        vm.detailGridExpand = function(change = true) {
          vm.mainGrid.tbody.find('tr.k-master-row').each(function(i, e) {
            if (vm.detailGridExpanded) {
              vm.mainGrid.expandRow(e);
            } else {
              vm.mainGrid.collapseRow(e);
            }
          });
          if (change) {
            vm.detailGridExpanded = !vm.detailGridExpanded;
            if (vm.detailGridExpanded) {
              $('#mainGrid')
                .find('.detailGridExpand')
                .removeClass('k-i-collapse')
                .addClass('k-i-expand');
              $('#mainGrid')
                .find('.detailGridExpand')
                .attr('title', 'Tömeges csukás');
            } else {
              $('#mainGrid')
                .find('.detailGridExpand')
                .removeClass('k-i-expand')
                .addClass('k-i-collapse');
              $('#mainGrid')
                .find('.detailGridExpand')
                .attr('title', 'Tömeges nyitás');
            }
            localStorage.setItem(getKeyName('detailGridExpanded', vm.dataModel.LoggedUser), vm.detailGridExpanded);
          }
        };

        var onChangeFunctions = {
          ShowedTicket: function(e) {
            filter();
          },
          HelpDeskPriorityId: function(e) {
            filter();
          },
          ServiceLevelId: function(e) {
            filter();
          },
          SpecializationId: function(e) {
            filter();
          },
          TicketTypeId: function(e) {
            filter();
          },
          CustomFilter: function(selected) {
            // if (!!vm.dataModel.PreFilter) {
            // delete vm.dataModel.PreFilter;
            // return;
            // }

            if (selected && selected.extraProperties) {
              vm.selectedFilter = JSON.parse(selected.extraProperties[0].value);
              vm.setFilter();
            }
          },
          AutoRefreshInterval: function(e) {
            vm.onRefreshIntervalChange();
          },
        };
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

        function getWC() {
          return {
            tableName: vm.pageModel.Grids.Gridticket.Table,
            adopter: vm.pageModel.Grids.Gridticket.Adopter,
            installAdopter: vm.pageModel.Grids.Gridticket.InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids.Gridticket.Columns, 'field').join(),
            idColumn: vm.pageModel.Grids.Gridticket.IdColumn,
            dto: vm.dataModel,
          };
        }

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: vm.pageModel.Grids.Gridticket,
          transportData: getWC,
          dataBound: vm.dataBoundFunction,
          selectFunction: function(e) {
            if (vm.gridLoaded) {
              setDasModel();
            }
          },
        });

        vm.mainGridOptions.disableOptions = vm.mainGridOptions.disableOptions || {};
        vm.mainGridOptions.disableOptions.FilterRestore = true;

        function dataBoundFunction(e) {
          vm.gridLoaded = false;

          var rows = e.sender.tbody.children();
          for (var j = 0; j < rows.length; j++) {
            var row = $(rows[j]);
            var dataItem = e.sender.dataItem(row);
            if (!!dataItem.IsSuspended) {
              $(row)
                .find('.k-hierarchy-cell')
                .html(
                  $(row)
                    .find('.k-hierarchy-cell')
                    .html() +
                    '&nbsp;<span style="color: #fd9c1a" title="' +
                    Math.floor(dataItem.SuspendedMinutes / 60 / 24) +
                    ' Nap ' +
                    Math.floor((dataItem.SuspendedMinutes / 60) % 24) +
                    ' óra ' +
                    Math.floor(dataItem.SuspendedMinutes % 60) +
                    ' perc"><i class="fa fa-clock-o"></i></span>'
                );
            }

            if (dataItem.HelpDeskStatusColor.startsWith('#')) {
              $($(row).find('.status-cell')[0]).html(
                generateProgressBar(vm.stateProgressBars, dataItem.HelpDeskStatusId, dataItem.HelpDeskStatusColor)
              );
            }
          }
          var hierarchyCell = e.sender.element.find('th.k-hierarchy-cell.k-header');
          var link = $(hierarchyCell);
          $('#mainGrid').on('click', 'th.k-hierarchy-cell.k-header', function() {
            vm.detailGridExpand();
          });
          if (!link.find('.detailGridExpand')[0]) {
            let html =
              '<span class="k-icon detailGridExpand" style="font-size: 19px; height:15px; color:green;" ' +
              'title=""></span>';
            link.append(html);
            $('#mainGrid')
              .find('.detailGridExpand')
              .parent()
              .css('padding-left', '5px');
          }
          if (!!vm.mainGrid) {
            $('#mainGrid').on('dblclick', 'tr.k-state-selected', function() {
              vm.editTicket();
            });
          }

          let grid = this;
          vm.detailGridExpanded = !vm.detailGridExpanded;
          vm.detailGridExpand();
          this.tbody.find('tr.k-state-selected').removeClass('k-state-selected');

          vm.gridLoaded = true;
        }

        function startRefreshTimer() {
          if (autoRefreshTimer.running || autoRefreshTimer.paused) {
            autoRefreshTimer.stop();
          }
          if (autoRefreshTickHandler) {
            autoRefreshTimer.unsubscribe('tick', autoRefreshTickHandler);
            autoRefreshTickHandler = null;
          }
          var interval = parseInt(vm.dataModel.AutoRefreshInterval);
          if (interval > 0) {
            autoRefreshTimer.tickTime = interval * 60000;
            autoRefreshTickHandler = function() {
              filter();
              //console.log('Auto refresh triggered at ' + new Date().toLocaleString());
            };
            autoRefreshTimer.subscribe('tick', autoRefreshTickHandler);
            autoRefreshTimer.start();
          }
        }

        vm.onRefreshIntervalChange = function() {
          var interval = parseInt(vm.dataModel.AutoRefreshInterval) || 0;
          localStorage.setItem(getRefreshIntervalKey(), interval);
          startRefreshTimer();
        };

        vm.mainGridIdField = vm.pageModel.Grids.Gridticket.IdColumn;

        vm.pageModel.Grids['Gridticket'].Columns[0].attributes = { class: 'status-cell' };

        var originalOptions = getGridCurrentOptions(angular.copy(vm.mainGridOptions));

        // Remove default text from filter dropdowns
        var dropdownsToClear = [
          vm.pageModel.Fields.ShowedTicket,
          vm.pageModel.Fields.HelpDeskPriorityId,
          vm.pageModel.Fields.ServiceLevelId,
          vm.pageModel.Fields.SpecializationId,
          vm.pageModel.Fields.TicketTypeId,
          vm.pageModel.Fields.AutoRefreshInterval,
        ];
        angular.forEach(dropdownsToClear, function(value, key) {
          var ddOptions = value.FormlyFieldDescriptor.templateOptions.options;
          delete ddOptions.optionLabel;
        });
        vm.filterFields = vm.FormlyFormPanelDescriptors.Panelfilter.FormlyDescriptor;
        vm.otherFields = vm.FormlyFormPanelDescriptors.Panelother.FormlyDescriptor;
        function init() {
          vm.pageModel = options.pageModel;
          vm.dataModel = options.dto;
          vm.states = options.states;
          vm.messages = options.pageModel.Messages;
          vm.labels = options.pageModel.Labels;
          vm.actions = options.pageModel.Actions;
          vm.reportList = options.reportList;
          vm.filter = filter;
          vm.filterState = filterState;
          vm.suspendedChange = suspendedChange;
          vm.createTicket = createTicket;
          vm.editTicket = editTicket;
          vm.duplicateTicket = duplicateTicket;
          vm.docLinks = docLinks;
          vm.back = back;

          SetGridColumnToDateTime(
            vm.pageModel.Grids,
            ['Gridticket'],
            ['CreateDateTime', 'StatusModDate', 'MessageModDate', 'ModDate']
          );

          vm.stateButtons = [];
          angular.forEach(vm.states, function(value, key) {
            vm.stateButtons.push(value);
          });

          //Sorrendbe rakás, ha az Id nem sorban lenne:
          vm.stateButtons = vm.stateButtons.sort(function(a, b) {
            return a['Number'] < b['Number'] ? -1 : a['Number'] > b['Number'] ? 1 : 0;
          });
          //transzformáció a progressBarokhoz (visszavonva kerüljön előre)
          vm.stateProgressBars = angular.copy(vm.stateButtons);
          vm.stateProgressBars.unshift(vm.stateProgressBars.pop());

          //Default value for ShowedTicket:
          if (!vm.dataModel.ShowedTicket || vm.dataModel.ShowedTicket == '') {
            vm.dataModel.ShowedTicket = 'HDTRE';
          }

          var savedInterval = localStorage.getItem(getRefreshIntervalKey());
          if (savedInterval && !vm.dataModel.AutoRefreshInterval) {
            vm.dataModel.AutoRefreshInterval = savedInterval;
          }
          startRefreshTimer();

          // Generate Formly form descriptors from pageModel
          vm.pageModel.Grids.Gridticket.ControllerMethod = 'HelpDesk/TicketList';
          vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
          vm.customFilterFields = vm.FormlyFormPanelDescriptors.Panelcustomfilter.FormlyDescriptor;

          vm.searchFields = vm.FormlyFormPanelDescriptors.Panelsearch.FormlyDescriptor;
          vm.FormlyFormPanelDescriptors.Panelfilter.FormlyDescriptor[0].className = 'col-md-12';
          vm.FormlyFormPanelDescriptors.Panelsearch.FormlyDescriptor[0].className = 'col-md-12';
        }

        function filter() {
          vm.mainGrid?.dataSource?.page(1);
          vm.mainGrid?.dataSource?.read();
        }

        function filterState(statusId) {
          if (statusId === -1) {
            vm.filteredStatus.splice(0);
          } else {
            vm.index = vm.filteredStatus.findIndex(function(a) {
              return a === statusId;
            });
            if (vm.index == -1) {
              vm.filteredStatus.push(statusId);
            } else {
              vm.filteredStatus.splice(vm.index, 1);
            }
          }
          filter();
        }
        function suspendedChange() {
          filter();
        }
        function selectedFilterButtons(statusId) {
          if (vm.filteredStatus.length > 0) {
            for (var key in vm.filteredStatus) {
              if (vm.filteredStatus[key] === statusId) {
                return true;
              }
            }
          } else {
            return false;
          }
        }

        function createTicket() {
          if (vm.dataModel.UserType === 'HDJIO' && vm.dataModel.UseSimplifiedCreateForm === false) {
            $state.go('HelpDesk.TicketCreate', { id: 0 });
          } else {
            $state.go('HelpDesk.TicketHDJEXCreate');
          }
        }

        function editTicket() {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var id = selectedItems[0][vm.mainGridIdField];

            if (vm.dataModel.UserType === 'HDJIO') {
              $state.go('HelpDesk.TicketEdit', { id: id });
            } else {
              //$state.go('HelpDesk.TicketHDJEXView', { id: id });
              $state.go('HelpDesk.TicketEdit', { id: id });
            }
          }
        }

        function duplicateTicket() {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var id = selectedItems[0][vm.mainGridIdField];
            $state.go('HelpDesk.TicketDuplicate', { id: id });
          }
        }

        function docLinks() {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('HelpDesk.TicketDoc', { id: id });
        }

        function back() {
          $state.go('main');
        }

        function WAL() {
          walService.NavigateToWal('HelpDesk', 'HelpDeskNavWal', 'FlgTicketView');
        }

        function multiApprove() {
          vm.dataModel.IsMultipleApprove = true;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/MultiApproveModal.html',
            controller: 'HelpDeskMultiApproveModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: {
                pageModel: vm.pageModel,
                dto: {
                  gridOptions: getGridCurrentOptions(null, true),
                  userId: authService.user.id,
                },
              },
            },
            keyboard: false,
            size: 'lg',
          });

          modalInstance.result
            .then(function(result) {
              vm.dataModel.IsMultipleApprove = false;
            })
            .catch(function(result) {
              vm.dataModel.IsMultipleApprove = false;
            });
        }

        function history() {
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (selectedItems.length === 0) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          } else {
            var TicketId = selectedItems[0][vm.mainGridIdField];
            var modalInstance = $uibModal.open({
              templateUrl: 'App/HelpDesk/HistoryModal.html',
              controller: 'HelpDeskHistoryModalCtrl',
              controllerAs: 'vm',
              resolve: {
                model: {
                  pageModel: vm.historyPageModel,
                  dto: { TicketId },
                },
              },
              keyboard: false,
              size: 'lg',
            });

            modalInstance.result.then(function(result) {});
          }
        }
        vm.setFilterFieldState = function() {
          if (!!vm.selectedFilter) {
            vm.selectedFilter.FieldState = JSON.stringify({
              ShowedTicket: vm.dataModel.ShowedTicket,
              SpecializationId: vm.dataModel.SpecializationId,
              ServiceLevelId: vm.dataModel.ServiceLevelId,
              TicketTypeId: vm.dataModel.TicketTypeId,
              HelpDeskPriorityId: vm.dataModel.HelpDeskPriorityId,
              Status: vm.filteredStatus,
            });
          }
        };
        vm.saveFilter = function() {
          if (!vm.selectedFilter) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return;
          }
          if (vm.selectedFilter.Type != 2) {
            toastr.warning('Csak felhasználói szűrő menthető!');
            return;
          }
          vm.setFilterFieldState();

          $http({
            url: 'HelpDesk/SaveCustomFilter',
            method: 'POST',
            data: { dto: vm.selectedFilter },
          }).then(function(response) {
            toastr.success('Sikeres mentés');
          });
        };

        vm.deleteFilter = function() {
          if (!vm.selectedFilter) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return;
          }
          if (vm.selectedFilter.Type != 2) {
            toastr.warning('Csak felhasználói szűrő törölhető!');
            return;
          }
          bootbox.dialog({
            message: vm.customFilterPageModel.Labels.LabelDeleteConfirm.Title,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http({
                    url: 'HelpDesk/DeleteCustomFilter',
                    method: 'POST',
                    data: { helpDeskFilterId: vm.selectedFilter.HelpDeskFilterId },
                  }).then(function(response) {
                    vm.CustomFilterComboRef.dataSource.read();
                    toastr.success('Sikeres törlés');
                  });
                },
              },
            },
          });
        };

        vm.setDefaultFilter = function() {
          bootbox.dialog({
            message: vm.customFilterPageModel.Labels.LabelSetDefaultConfirm.Title,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  let combo = vm.pageModel.Fields.CustomFilter.FormlyFieldDescriptor.formControl.$$element.data(
                    'kendoDropDownList'
                  );
                  combo.trigger('change');
                },
              },
            },
          });
        };

        vm.setTemporaryFilter = function() {
          var fieldState = JSON.stringify({
            ShowedTicket: vm.dataModel.ShowedTicket,
            SpecializationId: vm.dataModel.SpecializationId,
            ServiceLevelId: vm.dataModel.ServiceLevelId,
            TicketTypeId: vm.dataModel.TicketTypeId,
            HelpDeskPriorityId: vm.dataModel.HelpDeskPriorityId,
            Status: vm.filteredStatus,
          });
        };

        vm.addFilter = function() {
          customFilterModal(true);
        };

        vm.editFilter = function() {
          if (!vm.selectedFilter) {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            return;
          }
          if (vm.selectedFilter.Type != 2) {
            toastr.warning('Csak felhasználói szűrő szerkeszthető!');
            return;
          }
          customFilterModal();
        };

        vm.getDescriptions = function(id) {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketDescriptionsModal.html',
            controller: 'TicketDescriptionsModalCtrl',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              model: RouteResolveFunc('HelpDesk/GetTicketDescriptions', { ticketId: id }),
            },
            backdrop: 'static',
          });
        };

        function getGridCurrentOptions(options, forMultiApprove = false) {
          if (!options) {
            options = vm.mainGrid.getOptions();
          }
          var currentFilter = options.dataSource.filter;
          var dataSource = {
            filter:
              currentFilter && typeof currentFilter === 'object' && Object.keys(currentFilter).length > 0
                ? currentFilter
                : undefined,
            group: options.dataSource.group,
            page: options.dataSource.page,
            pageSize: options.dataSource.pageSize,
            sort: options.dataSource.sort || null,
          };
          if (forMultiApprove) {
            return options;
          } else {
            return JSON.stringify({ columns: options.columns, dataSource: dataSource });
          }
        }

        function customFilterModal(isNew = false) {
          var helpDeskFilter;
          if (isNew) {
            helpDeskFilter = {
              HelpDeskFilterId: 0,
              FilterName: null,
              IsDefault: false,
              Type: 2,
              FieldState: JSON.stringify({
                ShowedTicket: vm.dataModel.ShowedTicket,
                SpecializationId: vm.dataModel.SpecializationId,
                ServiceLevelId: vm.dataModel.ServiceLevelId,
                TicketTypeId: vm.dataModel.TicketTypeId,
                HelpDeskPriorityId: vm.dataModel.HelpDeskPriorityId,
                Status: vm.filteredStatus,
              }),
            };
          } else {
            helpDeskFilter = angular.copy(vm.selectedFilter);
          }
          helpDeskFilter.isFilter = true;
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/CustomFilterModal.html',
            controller: 'HelpDeskCustomFilterModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: {
                pageModel: vm.customFilterPageModel,
                dto: helpDeskFilter,
              },
            },
            keyboard: false,
            size: 'lg',
          });

          modalInstance.result.then(function(result) {
            if (result && !authService?.parameters?.FWCOID) {
              sessionStorage.setItem('Is.' + authService.user.id + '.HelpdeskNav.SelectedFilter', result);
              vm.CustomFilterComboRef.dataSource.read();
            }
          });
        }

        function generateInvoice() {
          var id = 0;
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (selectedItems && selectedItems.length > 0) {
            id = selectedItems[0][vm.mainGridIdField];
          }

          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/PreGenerateInvoiceModal.html',
            controller: 'PreGenerateInvoiceModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: RouteResolveFunc('HelpDesk/PreGenerateInvoice', { ticketId: id }),
            },
            backdrop: 'static',
          });

          modalInstance.result.then(function(resultData) {
            if (resultData.InvoicingType === 0) {
              /* Egyedi számlagenerálás */
              var invoicingGenModalInstance = $uibModal.open({
                templateUrl: 'App/HelpDesk/GenerateInvoiceModal.html',
                controller: 'GenerateInvoiceModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  model: RouteResolveFunc('HelpDesk/GenerateSingleInvoice', {
                    ticketId: parseInt(resultData.WorkSheet.Value),
                  }),
                },
                backdrop: 'static',
              });
            } else {
              /* Összevont számlagenerálás */
              var invoicingMassGenModalInstance = $uibModal.open({
                templateUrl: 'App/HelpDesk/GenerateMassInvoiceModal.html',
                controller: 'GenerateMassInvoiceModalCtrl',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                  model: RouteResolveFunc('HelpDesk/MassGenerateInvoice', {
                    partnerId: resultData.PartnerId,
                  }),
                },
                backdrop: 'static',
              });

              invoicingMassGenModalInstance.result.then(function(resultDataModel) {
                var invoicingGenFormModalInstance = $uibModal.open({
                  templateUrl: 'App/HelpDesk/GenerateInvoiceModal.html',
                  controller: 'GenerateInvoiceModalCtrl',
                  controllerAs: 'vm',
                  size: 'lg',
                  resolve: {
                    model: RouteResolveFunc('HelpDesk/MassGenerateInvoiceForm', {
                      ticketIds: resultDataModel.TicketIds,
                      certDateTimeFrom: new Date(resultDataModel.CertDateTimeFrom),
                      certDateTime: resultDataModel.CertDateTime,
                      partnerId: resultDataModel.PartnerId,
                    }),
                  },
                  backdrop: 'static',
                });
              });
            }
          });
        }

        vm.setFilter = function() {
          if (!vm.selectedFilter) {
            return;
          }
          var filter = JSON.parse(vm.selectedFilter.FieldState);
          vm.dataModel.ShowedTicket = filter.ShowedTicket;
          vm.dataModel.TicketTypeId = filter.TicketTypeId;
          vm.dataModel.SpecializationId = filter.SpecializationId;
          vm.dataModel.ServiceLevelId = filter.ServiceLevelId;
          vm.dataModel.HelpDeskPriorityId = filter.HelpDeskPriorityId;
          vm.dataModel.HDStates = filter.Status;
          vm.filteredStatus = filter.Status || [];

          angular.forEach(vm.dropdownsToUpdate, function(value, key) {
            if (value.FormlyFieldDescriptor.formControl) {
              var ref = value.FormlyFieldDescriptor.formControl.$$element.data('kendoDropDownList');
              ref?.trigger('change');
            }
          });

          $timeout(function() {
            vm.filter();
          }, 100);
        };

        vm.setSearch = function() {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/CustomFilterModal.html',
            controller: 'HelpDeskCustomFilterModalCtrl',
            controllerAs: 'vm',
            resolve: {
              model: {
                pageModel: vm.customFilterPageModel,
                dto: {
                  Expression: vm.dataModel.Expression,
                  InSubject: vm.dataModel.PlaceOfSearch == 1 || vm.dataModel.PlaceOfSearch == 2,
                  InDescription: vm.dataModel.PlaceOfSearch == 1 || vm.dataModel.PlaceOfSearch == 3,
                  isFilter: false,
                },
              },
            },
            keyboard: false,
            size: 'lg',
          });

          modalInstance.result.then(function(result) {
            if (result) {
              vm.dataModel.PlaceOfSearch = 1;
              vm.dataModel.Expression = result.Expression;
              vm.dataModel.InSubject = result.InSubject;
              vm.dataModel.InDescription = result.InDescription;
              vm.searchBackground = '#f18b00';
              filter();
            }
          });
        };

        vm.deleteSearch = function() {
          vm.dataModel.Expression = '';
          vm.dataModel.PlaceOfSearch = 1;
          vm.dataModel.InSubject = false;
          vm.dataModel.InDescription = false;
          vm.searchBackground = 'transparent';
          filter();
        };
        const getFilter = new Promise((resolve, reject) => {
          vm.selectedFilter = JSON.parse(vm.dataModel.PreFilter.extraProperties[0].value);
          if (!authService?.parameters?.FWCOID) {
            let sessionStorageSelectedFilter = sessionStorage.getItem(
              'Is.' + authService.user.id + '.HelpdeskNav.SelectedFilter'
            );
            if (!!sessionStorageSelectedFilter) {
              try {
                vm.selectedFilter = JSON.parse(sessionStorageSelectedFilter);
              } catch (e) {}
            }
          }
          resolve();
        });

        //Set Default filter
        getFilter.then(value => {
          vm.setFilter();
        });

        function setDasModel() {
          var dasDescriptor = vm.pageModel.Grids.Gridticket.DasDescriptor;
          var selectedItems = GetSelectedGridItems(vm.mainGrid);
          if (!!selectedItems && !!selectedItems[0] && !!selectedItems[0][dasDescriptor.ownerColumn]) {
            vm.dasModel = {
              routeId: dasDescriptor.routeId,
              tableId: dasDescriptor.tableId,
              ownerId: selectedItems[0][dasDescriptor.ownerColumn],
            };
            $scope.$applyAsync();
          }
        }

        function findProgressPositionById(states, id) {
          return states.findIndex(function(x) {
            return x.HelpDeskStatusId == id;
          });
        }

        function generateProgressBar(states, statusId, color) {
          let statusNum = findProgressPositionById(states, statusId);
          let statusCount = states.length - 1;
          let div = '';
          let widthStr = 'calc((100% - 60px)/' + statusCount + ')';
          for (let i = 0; i < statusCount; i++) {
            div +=
              '<div style="width: ' +
              widthStr +
              '; background-color: ' +
              color +
              ';" class="progressBox ' +
              (i >= statusNum ? 'empty' : '') +
              '"></div>';
          }
          return div;
        }
      } //else vége

      function generateSurveyReports(reportName) {
        SurveyService.generateSurveyReports('SUEHD', 'SUCHC', 'RTYEX', reportName);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskDocCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskDocCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$timeout',
    '$window',
    'WalService',
    '$uibModal',
    'DasService',
    'LockService',
    'gridService',
    'UIHelperService',
    '$q',
    'SurveyService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      $timeout,
      $window,
      walService,
      $uibModal,
      dasService,
      lockService,
      gridService,
      UIHelperService,
      $q,
      SurveyService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.collapseHelper = {
        disableRunExpression: false,
      };

      vm.disableTenderTab = function() {
        return !vm.dataModel.HDTEACParamValues.includes(vm.statusCode);
      };

      vm.disableTenderTabButton = function() {
        return !vm.dataModel.HDTEACParamValues.includes(vm.statusCode) || vm.dataModel.IsReadOnly;
      };

      vm.collapseHelper.showTab = function(panelId) {
        if (panelId == 'PanelAlapPanel') {
          vm.activeDataTab = 0;
        } else {
          vm.activeStatusSubItemTab = vm.statusTabs.findIndex(x => x.Panel.indexOf(panelId) != -1);
        }
      };

      switch (model.statusCode) {
        case 'HDSVA':
          if (!model.dto?.ApprDateTime) {
            SetDateTimeToNow(model.dto, 'ApprDateTime');
          }
          break;
        case 'HDSER':
          if (!model.dto?.CertDateTime) {
            SetDateTimeToNow(model.dto, 'CertDateTime');
          }
          break;
        case 'HDSCH':
          if (!model.dto?.VerifDateTime) {
            SetDateTimeToNow(model.dto, 'VerifDateTime');
          }
          break;
        case 'HDSPL':
          if ((!model.dto?.ApproverId || _.isEmpty(model.dto?.ApproverId)) && !!model.dto?.IsSimplified) {
            model.dto.ApproverId = [model.userId];
          }
          break;
      }
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.oldDataModel = angular.copy(model.dto);
      vm.reportList = model.reportList;
      vm.securedId = model.id;
      vm.isLocked = false;
      vm.SBBox = model.SBBox;
      vm.formMode = $stateParams.formMode;
      vm.userId = model.userId;
      vm.SubPanelCollapsed = {};
      vm.existHDSCHU = model.existHDSCHU;
      vm.paramHDSURV = model.paramHDSURV;
      vm.propertyNotChanged = true;
      vm.ticketTypeNotChanged = true;
      vm.SubPanelCollapsed['TabMunkafelvetel'] =
        (localStorage
          .getItem($state.current.name + '_' + $state.previous.name + '_SubPanelCollapsed_TabMunkafelvetel')
          ?.toLowerCase() ?? 'false') == 'true';
      vm.collapse = function(name) {
        vm.SubPanelCollapsed[name] = !vm.SubPanelCollapsed[name];
        localStorage.setItem(
          $state.current.name + '_' + $state.previous.name + '_SubPanelCollapsed_' + name,
          vm.SubPanelCollapsed[name]
        );
      };
      vm.updateFieldParameters = function() {
        if (!!vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options?.gridOptions) {
          vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/FilteredGridDataByUserRole';
        }
        if (!!vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options.whereCondition = tenementWhereCondition;
        }
        if (!!vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options?.gridOptions) {
          vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/FilteredGridDataByUserRole';
        }
        if (!!vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.whereCondition = propertyWhereCondition;
        }
        if (!!vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseWhereCondition;
        }
        if (!!vm.pageModel.Fields.RelatedTicket.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.RelatedTicket.FormlyFieldDescriptor.templateOptions.options.whereCondition = relatedTicketWhereCondition;
        }
        if (!!vm.pageModel.Fields.CertUserId.FormlyFieldDescriptor.templateOptions.options?.gridOptions) {
          vm.pageModel.Fields.CertUserId.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/CertUserIdGridData';
        }
        if (!!vm.pageModel.Fields.VerifUserId.FormlyFieldDescriptor.templateOptions.options?.gridOptions) {
          vm.pageModel.Fields.VerifUserId.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/VerifUserIdGridData';
        }
        if (!!vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.whereCondition = roomInventoryWhereCondition;
        }
        if (vm.statusCode === 'HDSPL' && vm.dataModel.Property.Value > 0) {
          vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
        }
        if (vm.statusCode !== 'HDSCR') {
          vm.pageModel.Fields.OwnerId.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.OwnerName.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.OwnerEmail.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.OwnerPhoneNumber.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.Subject.FormlyFieldDescriptor.templateOptions.disabled = true;
        }
        if (vm.statusCode !== 'HDSVA') {
          vm.pageModel.Fields.RealApproverId.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.RealApproverName.FormlyFieldDescriptor.templateOptions.disabled = true;
        }
        if (vm.statusCode !== 'HDSER') {
          vm.pageModel.Fields.RealCertUserId.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.pageModel.Fields.RealCertUserName.FormlyFieldDescriptor.templateOptions.disabled = true;
        }
      };
      vm.generatePanelToForm = function(scope, descriptor, model, panel, reload) {
        if (!!descriptor[panel]?.FormlyDescriptor?.length && !reload) {
          return;
        }
        for (const [key, value] of Object.entries(model.Fields)) {
          if (value.ContainerPanelId2 == panel) {
            value.ContainerPanelId = value.ContainerPanelId2;
          } else {
            value.ContainerPanelId = null;
          }
        }
        Object.assign(descriptor, GenerateFormlyFormPanelsFromPageModel(model));
        scope.updateFieldParameters();
        setBehavior(scope);
      };
      vm.removeTabsFromFormGenerate = function(model, tabs = null) {
        let panelsRemove = [];
        let tabsRemove = [];
        if (!!tabs) {
          for (const [key, value] of Object.entries(tabs)) {
            if (!!value?.Name) {
              tabsRemove[value.Name] = true;
            }
          }
        }
        let tabsRemoveEmpty = !Object.keys(tabsRemove).length;
        for (const [key, value] of Object.entries(model.Panels)) {
          if (tabsRemoveEmpty || !!tabsRemove[value.ContainerTabId]) {
            panelsRemove[value.Name] = true;
          }
        }
        for (const [key, value] of Object.entries(model.Fields)) {
          if (!!value.ContainerPanelId) {
            value.ContainerPanelId2 = value.ContainerPanelId;
          }
          if (!!panelsRemove[value.ContainerPanelId2]) {
            value.ContainerPanelId = null;
          }
        }
      };

      lockService.SILENT = true;
      lockService.initiateLock(vm.securedProgramId, vm.securedId, function(response) {
        // Set editability of fields based on controllerOptions
        vm.isLocked = !!response && response.isLocked === true;
        if (vm.isLocked === true) {
          toastr.error('A bejelentést ' + response.lockedBy[0] + ' zárolta!', vm.messages.Warning);
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }
      });

      vm.statusMap = {
        Bejelentes: 'HDSCR',
        Munkafelvetel: 'HDSPL',
        Jovahagyas: 'HDSVA',
        Vegrehajtas: 'HDSTD',
        Teljesitesigazolas: 'HDSER',
        Ellenorzes: 'HDSCH',
        Lezaras: 'HDSCL',
      };

      vm.WAL = WAL;
      vm.WALSubItem = WALSubItem;
      vm.newMessage = newMessage;
      vm.viewMessage = viewMessage;
      vm.newSuspension = newSuspension;
      vm.editSuspension = editSuspension;
      vm.editStatuszok = editStatuszok;

      // Bottom tab állítása a státusTab-hoz ( kiemelve az init-ből )
      vm.setBottomTabs = function setBottomTabs(activeStatusSubItemTab) {
        vm.bottomTabs = [
          vm.pageModel.Tabs.TabElvegzendoFeladatok,
          vm.pageModel.Tabs.TabFelhasznalandoAnyagok,
          vm.pageModel.Tabs.TabStatuszok,
          vm.pageModel.Tabs.TabArajanlatok,
          //vm.pageModel.Tabs.TabSzamlazasiAdatok,
          vm.pageModel.Tabs.TabUzenofal,
          vm.pageModel.Tabs.TabDokumentumok,
        ];
        vm.bottomTabs[0].disabled = false;
        vm.bottomTabs[1].disabled = false;
        vm.bottomTabs[2].disabled = false;
        vm.bottomTabs[3].disabled = false;
        vm.bottomTabs[4].disabled = false;
        switch (activeStatusSubItemTab) {
          case 0:
            vm.bottomTabs[0].disabled = true;
            vm.bottomTabs[1].disabled = true;
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            vm.bottomTabs[4].disabled = !vm.dataModel.TicketId;
            break;
          case 1:
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
          case 2:
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
          case 3:
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
          case 4:
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
          case 5:
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
          case 6:
            vm.bottomTabs[0].disabled = true;
            vm.bottomTabs[1].disabled = true;
            vm.bottomTabs[3].disabled = vm.disableTenderTab();
            break;
        }
        //vm.bottomTabs[5].disabled = false;
        vm.bottomTabs.forEach(function(tab, index) {
          if (!tab.disabled) {
            vm.activeBottomSubItemTab = index;
          }
        });
      };

      vm.dasModel = {
        routeId: 'HelpDesk.DasDocumentsNav',
        tableId: 'FlgTicket',
        ownerId: model.dto.TicketId,
      };
      init();

      vm.getFilter = function() {
        return "TicketId~eq~'" + vm.dataModel.TicketId + "'";
      };

      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridUzenofalGrid'], ['ModDateTime']);
      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridStatuszokGrid'], ['ModDateTime']);
      SetGridColumnToDateTime(vm.pageModel.Grids, ['GridDokumentumokGrid'], ['ModDate']);

      vm.GridFeladatokGridIdField = vm.pageModel.Grids['GridFeladatokGrid'].IdColumn;
      vm.GridFeladatokGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign({}, vm.pageModel.Grids['GridFeladatokGrid'], { ControllerMethod: 'Grid/Data' }),
        transportData: {
          tableName: vm.pageModel.Grids['GridFeladatokGrid'].Table,
          whereCondition: vm.getFilter,
          adopter: vm.pageModel.Grids['GridFeladatokGrid'].Adopter,
          installAdopter: vm.pageModel.Grids['GridFeladatokGrid'].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids['GridFeladatokGrid'].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids['GridFeladatokGrid'].IdColumn,
        },
      });

      vm.standardTimeAggregate = function(data) {
        var hour = 0;
        var minute = 0;

        angular.forEach(data.get.group.items, function(item) {
          hour += parseInt(item.StandardTime.substring(0, 2));
          minute += parseInt(item.StandardTime.substring(2, 4));

          hour += Math.floor(minute / 60);
          minute = minute % 60;
        });

        return "<span style='float:right; padding:5px 0;'>(" + hour + ') óra (' + minute + ') perc</span>';
      };

      gridService.addAggregateToFooter(
        vm.GridFeladatokGridOptions,
        'sum',
        'StandardTime',
        'Currency',
        vm.standardTimeAggregate
      );
      gridService.addAggregateToFooter(
        vm.GridFeladatokGridOptions,
        'sum',
        'SumPrice',
        'Currency',
        "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
      );

      initGrid(
        vm,
        'GridArajanlatokGrid',
        'Grid/Data', // readUrl
        function(selectedItem) {
          vm.dasModelTender = {
            routeId: 'HelpDesk.DasDocumentsNav',
            tableId: 'FlgTender',
            ownerId: selectedItem.TenderId,
          };
          $scope.$applyAsync();
        },
        null,
        false,
        vm.getFilter,
        true
      );

      vm.GridAnyagokGridIdField = vm.pageModel.Grids['GridAnyagokGrid'].IdColumn;
      vm.GridAnyagokGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign({}, vm.pageModel.Grids['GridAnyagokGrid'], { ControllerMethod: 'Grid/Data' }),
        transportData: {
          tableName: vm.pageModel.Grids['GridAnyagokGrid'].Table,
          whereCondition: vm.getFilter,
          adopter: vm.pageModel.Grids['GridAnyagokGrid'].Adopter,
          installAdopter: vm.pageModel.Grids['GridAnyagokGrid'].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids['GridAnyagokGrid'].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids['GridAnyagokGrid'].IdColumn,
        },
      });
      vm.GridAnyagokGridOptions.selectable = 'multiple, row';

      gridService.addAggregateToFooter(
        vm.GridAnyagokGridOptions,
        'sum',
        'SumPrice',
        'Currency',
        "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
      );

      initGrid(
        vm,
        'GridStatuszokGrid',
        'Grid/Data', // readUrl
        function(selectedItem) {
          vm.GridStatuszokEditDisabledValue = selectedItem?.StatusType != 1;
        },
        null,
        false,
        vm.getFilter,
        true,
        [{ field: 'ModDateTime', dir: 'asc' }]
      );
      vm.GridStatuszokEditDisabled = function() {
        return vm.GridStatuszokEditDisabledValue ?? true;
      };
      vm.GridDokumentumokSSRS = function() {
        return vm.GridDokumentumokSSRSValue ?? true;
      };

      initGrid(
        vm,
        'GridDokumentumokGrid',
        'Grid/Data', // readUrl
        function(selectedItem) {
          vm.GridDokumentumokSSRSValue = selectedItem.Type === 'PDF';
        },
        null,
        false,
        vm.getFilter,
        true,
        [{ field: 'DocDate', dir: 'desc' }]
      );
      initGrid(
        vm,
        'GridSzamlazasiAdatokGrid',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );
      initGrid(
        vm,
        'GridBerletiSzerzodes',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      initGrid(
        vm,
        'GridIngatlan',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      initGrid(
        vm,
        'GridFelelosok',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );

      initGrid(
        vm,
        'GridUzenofalGrid',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.getFilter,
        true
      );
      //#endregion Init Grids
      vm.pageModel.Fields.Description.FormlyFieldDescriptor.templateOptions.rows = 6;
      vm.pageModel.Fields.WorkDescription.FormlyFieldDescriptor.templateOptions.rows = 6;
      vm.pageModel.Fields.ExecWorkDescription.FormlyFieldDescriptor.templateOptions.rows = 3;
      vm.pageModel.Fields.WorkComment.FormlyFieldDescriptor.templateOptions.rows = 3;
      vm.pageModel.Fields.CreateComment.FormlyFieldDescriptor.templateOptions.rows = 3;

      if (
        (!vm.dataModel.RespUser || _.isEmpty(vm.dataModel.RespUser)) &&
        (!!vm.dataModel.Property?.Value || !!vm.dataModel.TicketType)
      ) {
        $http
          .get('HelpDesk/GetStatusDefaultUsers', {
            params: {
              ticketTypeId: vm.dataModel.TicketType,
              specializationId: 0,
              propertyId: vm.dataModel.Property?.Value,
              status: 'HDSPL',
              ticketId: vm.dataModel.TicketId,
            },
          })
          .then(function(result) {
            // if (
            //   vm.statusCode === 'HDSCR' &&
            //   vm.dataModel.OwnerId?.Value &&
            //   !result.data.Value.includes(vm.dataModel.OwnerId.Value)
            // ) {
            //   result.data.Value.push(vm.dataModel.OwnerId.Value);
            // }
            vm.firstRespUser = result.data.Value;

            vm.firstRespUserExists = true;
          });
      }

      // F4Helpers.ShowColumns(vm, 'RespUser', [
      //   'userid',
      //   'name1',
      //   'PhoneNumber',
      //   'OrgPartName',
      //   'PostName',
      //   'Competence',
      // ]);
      // if (!!vm.dataModel.OpenUserId) {
      //   F4Helpers.GetRows(
      //     $http,
      //     vm,
      //     'RespUser',
      //     'openUserGridItem',
      //     vm.pageModel.Fields.RespUser.FormlyFieldDescriptor.templateOptions.DynamicOptions?.KeyField +
      //       "~eq~'" +
      //       vm.dataModel.OpenUserId +
      //       "'",
      //     { first: true }
      //   );
      // }
      vm.pageModel.Fields.ApproverId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Jóváhagyó</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.CalcDeadline.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Amennyiben lett Becsült átfutási idő megadva, akkor a<br><i>Bejelentés időpontja + Becsült átfutási idő + Reakció idő + Felfüggesztések&nbsp;</i><br>négyesből kapja az értékét.' +
        '<br><br>Egyéb esetben a<br><i>Bejelentés időpontja + Elvégzendő feladatoknál<br>megadott összesített normaidő + Reakció idő + Felfüggesztések</i><br>négyesből kapja az értékét.' +
        '<br><br>A szolgáltatási szintek törzsben megadott munkaidőt<br>mindkét esetben figyelembe veszi.';
      vm.pageModel.Fields.ReactionTime.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Értékét a <i>Szakterületek</i> törzsben beállított<br><i>Szakterület</i>, <i>Szolgáltatási szint</i>, <i>Prioritás</i><br>hármas alapján kapja meg.';
      vm.pageModel.Fields.IsSimplified.FormlyFieldDescriptor.templateOptions.tooltip =
        "<div style='text-align: center;'>Ha ki van pipálva, akkor gyorsítja a bejelentés<br>adminisztrálásának folyamatát.<br><br><strong>A következő státuszok átugrásával:</strong><br>Jóváhagyás, Teljesítésigazolás, Ellenőrzés<br><br><strong>A következő mezők automatikus kitöltésével:</strong><br>Műszaki ügyintéző(k): Adatrögzítő felhasználó adataival<br>Felelős szervezet: Adatrögzítő felhasználó szervezetével<br>Jóváhagyó, Teljesítésigazoló, Ellenőrzó: Adatrögzítő felhasználó<br>adataival";
      vm.pageModel.Fields.IsSimplifiedMf.FormlyFieldDescriptor.templateOptions.tooltip =
        vm.pageModel.Fields.IsSimplified.FormlyFieldDescriptor.templateOptions.tooltip;
      vm.pageModel.Fields.RealApproverId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Jóváhagyó</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.RealCertUserId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Teljesítésigazoló</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.VerifUserId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Ellenőrző</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.RealVerifUserId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Ellenőrző</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.CertUserId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Azon felhasználók jelennek meg, akik a<br><i>Szerepkörök</i> törzs <i>Teljesítésigazoló</i><br>szerepkörhöz hozzá lettek rendelve.';
      vm.pageModel.Fields.IsSimplified.FormlyFieldDescriptor.templateOptions.customCallback = function(selectedItem) {
        // if (
        //   !!selectedItem &&
        //   vm.statusCode === 'HDSCR' &&
        //   !vm.dataModel.RespUser?.length &&
        //   !!vm.openUserGridItem &&
        //   !!vm.dataModel.OpenUserId
        // ) {
        //   F4Helpers.SelectRows(vm, 'dataModel', 'RespUser', vm.ReservationNumberCode);
        // }
      };
      vm.onBlurFunctions = {};

      vm.customExpressionProperties = {
        IsSimplified: {
          'templateOptions.disabled': function() {
            return vm.dataModel.IsReadOnly || (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL');
          },
        },
        IsSimplifiedMf: {
          'templateOptions.disabled': function() {
            return vm.dataModel.IsReadOnly || (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL');
          },
        },
        RespUser: {
          'templateOptions.disabled': function() {
            if (
              !!vm.firstRespUserExists &&
              vm.pageModel.Fields.RespUser.FormlyFieldDescriptor.templateOptions.options.f4scope
            ) {
              vm.firstRespUserExists = false;
              vm.pageModel.Fields.RespUser.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Values(
                vm.firstRespUser
              );
              vm.firstRespUser = null;
            }
            return vm.dataModel.IsReadOnly || vm.statusCode !== 'HDSCR';
          },
        },
        PartnerId: {
          'templateOptions.required': function() {
            return vm.dataModel.PaymentMode === 'HDPIN' && !vm.SBBox;
          },
        },
        Tenement: {
          'templateOptions.disabled': function() {
            return (
              (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD') ||
              vm.dataModel.IsReadOnly ||
              vm.partnerTenementList?.length == 1
            );
          },
        },
        Property: {
          'templateOptions.disabled': function() {
            return (
              (!!vm.dataModel.Tenement && !!vm.dataModel.Tenement.Value) ||
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD')
            );
          },
        },
        Premise: {
          'templateOptions.disabled': function() {
            return (
              (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD') ||
              vm.dataModel.IsReadOnly ||
              !vm.dataModel.Property ||
              !vm.dataModel.Property.Value
            );
          },
        },
        Address: {
          'templateOptions.disabled': function() {
            return (
              (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD') ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        RoomInventoryId: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSCR' && vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD') ||
              !vm.dataModel.Property ||
              !vm.dataModel.Property.Value
            );
          },
        },
        OwnerName: {
          'templateOptions.disabled': function() {
            return (
              (!!vm.dataModel.OwnerId && !!vm.dataModel.OwnerId.Value) ||
              (!!vm.dataModel.PartnerTMId && !!vm.dataModel.PartnerTMId.Value) ||
              vm.statusCode !== 'HDSCR' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        OwnerId: {
          'templateOptions.disabled': function() {
            return (
              (!vm.dataModel.OwnerId?.Value && !!vm.dataModel.OwnerName) ||
              vm.statusCode !== 'HDSCR' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        PartnerTMId: {
          'templateOptions.disabled': function() {
            return (
              (!vm.dataModel.PartnerTMId?.Value && !!vm.dataModel.OwnerName) ||
              vm.statusCode !== 'HDSCR' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        OwnerEmail: {
          'templateOptions.required': function() {
            return !!vm.dataModel.OwnerId && !!vm.dataModel.OwnerId.Value;
          },
        },
        OwnerPhoneNumber: {
          'templateOptions.required': function() {
            return !!vm.dataModel.OwnerId && !!vm.dataModel.OwnerId.Value;
          },
        },
        RealApproverName: {
          'templateOptions.disabled': function() {
            return (
              (!!vm.dataModel.RealApproverId && !!vm.dataModel.RealApproverId.Value) ||
              vm.statusCode !== 'HDSVA' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        RealCertUserName: {
          'templateOptions.disabled': function() {
            return (
              (!!vm.dataModel.RealCertUserId && !!vm.dataModel.RealCertUserId.Value) ||
              vm.statusCode !== 'HDSER' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        RealVerifUserName: {
          'templateOptions.disabled': function() {
            return (
              (!!vm.dataModel.RealVerifUserId && !!vm.dataModel.RealVerifUserId.Value) ||
              vm.statusCode !== 'HDSCH' ||
              vm.dataModel.IsReadOnly
            );
          },
        },
        ExSystemId: {
          'templateOptions.disabled': function() {
            return vm.dataModel.IsReadOnly || vm.statusCode === 'HDSRV' || vm.statusCode === 'HDSCL';
          },
        },
        PaymentMode: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        BudgetPeriodId: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        BudgetId: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        PartnerId: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        ContactPerson: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        ContactPersonEmail: {
          'templateOptions.disabled': function() {
            return (
              vm.dataModel.IsReadOnly ||
              (vm.statusCode !== 'HDSPL' && (vm.statusCode !== 'HDSTD' || !vm.dataModel.BudgetEditable))
            );
          },
        },
        HelpDeskPriorityId: {
          'templateOptions.disabled': function() {
            return vm.dataModel.IsReadOnly || (vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD');
          },
        },
      };
      vm.onChangeFunctions = {
        /*TicketType: function(selectedItem) {
          $http({
            method: 'GET',
            url: `HelpDesk/TicketTypeGet?ticketTypeId=${selectedItem.key}`,
          }).then(function successCallback(response) {
            if (response !== null && response.data.Dto.ModifiableDate) {
              vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.disabled = false;
            } else {
              vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.disabled = true;
              vm.pageModel.Fields.CreateDateTime = vm.createDateTime;
              vm.dataModel.CreateDateTime = vm.createDateTime;
            }
          });
        },*/
        RespUser: function(selectedItem) {
          $('#' + vm.pageModel.Fields.RespUser.FormlyFieldDescriptor?.templateOptions.options.f4scope.f4id)
            .data('kendoMultiSelect')
            .value(vm.pageModel.Fields.RespUser.FormlyFieldDescriptor?.templateOptions.options.f4scope.f4Values);
        },
        Tenement: function(selectedItem) {
          setAddress(selectedItem);
          if (!!selectedItem && selectedItem.Value && selectedItem.GridItem) {
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
              selectedItem.GridItem.ConPropertyId
            );
          }
          if (!!selectedItem.GridItem || (!!selectedItem.GridItem && !selectedItem.Value)) {
            resetPremiseF4();
            resetRoomInventoryF4();
          }
          if (!!selectedItem && !!selectedItem.Value) {
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.disabled = true;
          } else {
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.disabled =
              vm.statusCode !== 'HDSCH' || vm.dataModel.IsReadOnly;
          }
        },
        Property: function(selectedItem) {
          setAddress(selectedItem);
          //vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseWhereCondition;
          if (!!selectedItem.GridItem || (selectedItem.GridItem == null && selectedItem.Value == null)) {
            resetPremiseF4();
            resetRoomInventoryF4();
          }
          if ((vm.oldDataModel.Property?.Value ?? 0) === (selectedItem.Value ?? 0) && vm.propertyNotChanged) {
            return;
          } else {
            vm.propertyNotChanged = false;
          }
          defaultUsersHDSPL(null, selectedItem.Value);
        },
        TicketType: function(selectedItem) {
          if ((vm.oldDataModel.TicketType?.Key ?? 0) === (selectedItem.key ?? 0) && vm.ticketTypeNotChanged) {
            return;
          } else {
            vm.ticketTypeNotChanged = false;
          }
          defaultUsersHDSPL(selectedItem.key, null);
        },
        PaymentMode: function(selectedItem) {
          vm.dataModel.PaymentMode = selectedItem.key;
        },
        HelpDeskPriorityId: function() {
          getCalulatedDeadline();
        },
        SpecializationId: function(selectedItem) {
          if (
            !vm.dataModel.ApproverId ||
            _.isEmpty(vm.dataModel.ApproverId) ||
            (!!vm.dataModel.IsSimplified && vm.dataModel.ApproverId[0] == vm.userId)
          ) {
            $http
              .get('HelpDesk/GetStatusDefaultUsers', {
                params: {
                  ticketTypeId: vm.dataModel.TicketType,
                  specializationId: selectedItem.key,
                  propertyId: vm.dataModel.Property?.Value,
                  status: 'HDSVA',
                  ticketId: vm.dataModel.TicketId,
                },
              })
              .then(function(result) {
                if (!!vm.dataModel.IsSimplified && !result.data.Value.includes(vm.userId)) {
                  result.data.Value.push(vm.userId);
                }
                vm.pageModel.Fields.ApproverId.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Values(
                  result.data.Value
                );
              });
          }
          getCalulatedDeadline();
        },
        ServiceLevelId: function() {
          getCalulatedDeadline();
        },
        EstimatedTime: function() {
          getCalulatedDeadline();
        },
        OwnerId: function(selectedItem) {
          if (vm.statusCode === 'HDSCR') {
            if (!!selectedItem && selectedItem.Value) {
              vm.pageModel.Fields.OwnerName.FormlyFieldDescriptor.templateOptions.disabled = true;
              vm.pageModel.Fields.PartnerTMId.FormlyFieldDescriptor.templateOptions.disabled = true;
              if (!!selectedItem.GridItem) {
                if (!!selectedItem.GridItem.name1) {
                  vm.dataModel.OwnerName = selectedItem.GridItem.name1;
                } else {
                  vm.dataModel.OwnerName = null;
                }
                if (!!selectedItem.GridItem.email) {
                  vm.dataModel.OwnerEmail = selectedItem.GridItem.email;
                } else {
                  vm.dataModel.OwnerEmail = null;
                }
                if (!!selectedItem.GridItem.PhoneNumber) {
                  vm.dataModel.OwnerPhoneNumber = selectedItem.GridItem.PhoneNumber;
                } else {
                  vm.dataModel.OwnerPhoneNumber = null;
                }
              }
            } else {
              clearUserAndPartnerData(selectedItem?.Value);
              //vm.pageModel.Fields.OwnerName.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
              //vm.pageModel.Fields.PartnerTMId.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
            }
          }
        },
        PartnerTMId: function(selectedItem) {
          if (vm.statusCode === 'HDSCR') {
            if (!!selectedItem && selectedItem.Value) {
              $http
                .post('HelpDesk/GetValidPartLinks', { partnerTmId: selectedItem.Value })
                .then(function(response) {
                  //partner bérleményei szűkítés:
                  vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.disabled =
                    vm.dataModel.IsReadOnly || response.data.TenementList?.length === 1;
                  vm.partnerTenementList = response.data.TenementList;
                  if (response.data.TenementList?.length === 1) {
                    vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
                      response.data.TenementList[0]
                    );
                    vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
                      response.data.ConProperty?.ConPropertyId
                    );
                    setAddress({
                      GridItem: response.data.ConProperty,
                      Value: response.data.ConProperty?.ConPropertyId,
                    });
                  }

                  //partner elérhetőségei:
                  vm.pageModel.Fields.OwnerPhoneNumber.FormlyFieldDescriptor.templateOptions.options.dataSource.data(
                    response.data.PartPhoneNumberList
                  );

                  if (!vm.dataModel.OwnerPhoneNumber) {
                    vm.dataModel.OwnerPhoneNumber = response.data.PartPhoneNumberList.find(item =>
                      item.extraProperties?.some(p => p.key === 'highlight' && p.value === '1')
                    )?.text;
                  }

                  vm.pageModel.Fields.OwnerEmail.FormlyFieldDescriptor.templateOptions.options.dataSource.data(
                    response.data.PartEmailList
                  );

                  if (!vm.dataModel.OwnerEmail) {
                    vm.dataModel.OwnerEmail = response.data.PartEmailList.find(item =>
                      item.extraProperties?.some(p => p.key === 'highlight' && p.value === '1')
                    )?.text;
                  }
                })
                .catch(function() {});

              vm.pageModel.Fields.OwnerName.FormlyFieldDescriptor.templateOptions.disabled = true;
              vm.pageModel.Fields.OwnerId.FormlyFieldDescriptor.templateOptions.disabled = true;
              if (!!selectedItem.GridItem) {
                if (!!selectedItem.GridItem.Name) {
                  vm.dataModel.OwnerName = selectedItem.GridItem.Name;
                } else {
                  vm.dataModel.OwnerName = null;
                }
              }
            } else {
              clearUserAndPartnerData(selectedItem?.Value);

              //vm.pageModel.Fields.OwnerName.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
              //vm.pageModel.Fields.OwnerId.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
            }
          }
        },
        OwnerName: function(selectedItem) {
          if (vm.statusCode === 'HDSCR') {
            if (!!selectedItem) {
              vm.pageModel.Fields.OwnerId.FormlyFieldDescriptor.templateOptions.disabled = true;
              vm.pageModel.Fields.PartnerTMId.FormlyFieldDescriptor.templateOptions.disabled = true;
            } else {
              vm.pageModel.Fields.OwnerId.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
              vm.pageModel.Fields.PartnerTMId.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
            }
          }
        },
        RealApproverId: function(selectedItem) {
          if (vm.statusCode === 'HDSVA') {
            if (!!selectedItem && selectedItem.Value) {
              vm.pageModel.Fields.RealApproverName.FormlyFieldDescriptor.templateOptions.disabled = true;
              if (!!selectedItem.GridItem) {
                if (!!selectedItem.GridItem.name1) {
                  vm.dataModel.RealApproverName = selectedItem.GridItem.name1;
                } else {
                  vm.dataModel.RealApproverName = null;
                }
              }
            } else {
              vm.pageModel.Fields.RealApproverName.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        RealApproverName: function(selectedItem) {
          if (vm.statusCode === 'HDSVA') {
            if (!!selectedItem) {
              vm.pageModel.Fields.RealApproverId.FormlyFieldDescriptor.templateOptions.disabled = true;
            } else {
              vm.pageModel.Fields.RealApproverId.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        RealCertUserId: function(selectedItem) {
          if (vm.statusCode === 'HDSER') {
            if (!!selectedItem && selectedItem.Value) {
              vm.pageModel.Fields.RealCertUserName.FormlyFieldDescriptor.templateOptions.disabled = true;
              if (!!selectedItem.GridItem) {
                if (!!selectedItem.GridItem.name1) {
                  vm.dataModel.RealCertUserName = selectedItem.GridItem.name1;
                } else {
                  vm.dataModel.RealCertUserName = null;
                }
              }
            } else {
              vm.pageModel.Fields.RealCertUserName.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        RealCertUserName: function(selectedItem) {
          if (vm.statusCode === 'HDSER') {
            if (!!selectedItem) {
              vm.pageModel.Fields.RealCertUserId.FormlyFieldDescriptor.templateOptions.disabled = true;
            } else {
              vm.pageModel.Fields.RealCertUserId.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        RealVerifUserId: function(selectedItem) {
          if (vm.statusCode === 'HDSCH') {
            if (!!selectedItem && selectedItem.Value) {
              vm.pageModel.Fields.RealVerifUserName.FormlyFieldDescriptor.templateOptions.disabled = true;
              if (!!selectedItem.GridItem) {
                if (!!selectedItem.GridItem.name1) {
                  vm.dataModel.RealVerifUserName = selectedItem.GridItem.name1;
                } else {
                  vm.dataModel.RealVerifUserName = null;
                }
              }
            } else {
              vm.pageModel.Fields.RealVerifUserName.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        RealVerifUserName: function(selectedItem) {
          if (vm.statusCode === 'HDSCH') {
            if (!!selectedItem) {
              vm.pageModel.Fields.RealVerifUserId.FormlyFieldDescriptor.templateOptions.disabled = true;
            } else {
              vm.pageModel.Fields.RealVerifUserId.FormlyFieldDescriptor.templateOptions.disabled =
                vm.dataModel.IsReadOnly;
            }
          }
        },
        WorkStartTime: function(selectedItem) {
          vm.pageModel.Fields.WorkEndTime.FormlyFieldDescriptor.formControl.$validate();
        },
        WorkEndTime: function(selectedItem) {
          vm.pageModel.Fields.WorkStartTime.FormlyFieldDescriptor.formControl.$validate();
        },
        Premise: function(selectedItem) {
          changePremiseBudgetModal();
        },
      };
      function defaultUsersHDSPL(ticketTypeId, propertyId) {
        if (!vm.dataModel.RespUser || _.isEmpty(vm.dataModel.RespUser)) {
          $http
            .get('HelpDesk/GetStatusDefaultUsers', {
              params: {
                ticketTypeId: ticketTypeId ?? vm.dataModel.Property?.Value,
                specializationId: 0,
                propertyId: propertyId,
                status: 'HDSPL',
                ticketId: vm.dataModel.TicketId,
              },
            })
            .then(function(result) {
              vm.pageModel.Fields.RespUser.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Values(
                result.data.Value
              );
            });
        }
      }
      vm.syncValidators = {
        WorkStartTime: {
          /**
           * @return {boolean}
           */
          StartDateTimeValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            if (modelValue && !!vm.dataModel.WorkEndTime && new Date(vm.dataModel.WorkEndTime) < new Date(modelValue)) {
              return false;
            }
            return true;
          },
        },
        WorkEndTime: {
          /**
           * @return {boolean}
           */
          EndDateTimeValidator: function(modelValue, viewValue) {
            if (!modelValue || !viewValue) {
              return true;
            }
            if (
              modelValue &&
              !!vm.dataModel.WorkStartTime &&
              new Date(vm.dataModel.WorkStartTime) > new Date(modelValue)
            ) {
              return false;
            }
            return true;
          },
        },
        OwnerEmail: {
          email: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            return sysEmailValidate(modelValue);
          },
        },
        ContactPersonEmail: {
          email: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            return sysEmailValidate(modelValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, vm.syncValidators);
      InsertOnChangeFunctions(vm.pageModel, vm.onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, vm.onBlurFunctions);
      InsertCustomExpressionProperties(vm.pageModel, vm.customExpressionProperties);
      vm.IsDisabled = function() {
        return model.dto.IsApproved !== null ? model.dto.IsApproved : false;
      };
      vm.IsSuspended = function() {
        let tempModel = vm.dataModel ?? model.dto;
        var validToValue = new moment(tempModel.SuspendedValidTo, kendo.culture().calendar.patterns.d.toUpperCase());
        var now = new moment(moment(), kendo.culture().calendar.patterns.d.toUpperCase());
        return tempModel.TicketSuspensionId > 0 && (!tempModel.SuspendedValidTo || validToValue.isSameOrAfter(now));
      };
      //StatusTab váltás vizsgálata
      $scope.$watch('vm.activeStatusSubItemTab', function() {
        if (
          !$stateParams.controllerOptions?.waitFormGenerate ||
          $stateParams.controllerOptions?.isFormReadOnly ||
          vm.dataModel.IsReadOnly
        ) {
          vm.generateFormly(false);
        }
      });
      // IsSimplified <-> IsSimplifiedMf szinkron (Bejelentés és Munkafelvétel panel checkbox)
      vm.dataModel.IsSimplifiedMf = vm.dataModel.IsSimplified;
      $scope.$watch('vm.dataModel.IsSimplified', function(newVal, oldVal) {
        if (newVal !== oldVal && vm.dataModel.IsSimplifiedMf !== newVal) {
          vm.dataModel.IsSimplifiedMf = newVal;
        }
      });
      $scope.$watch('vm.dataModel.IsSimplifiedMf', function(newVal, oldVal) {
        if (newVal !== oldVal && vm.dataModel.IsSimplified !== newVal) {
          vm.dataModel.IsSimplified = newVal;
        }
      });
      vm.disabledExceptionFields = [
        'Tenement',
        'Property',
        'Premise',
        'Address',
        'RoomInventoryId',
        'PaymentMode',
        'BudgetPeriodId',
        'BudgetId',
        'PartnerId',
        'ContactPerson',
        'ContactPersonEmail',
        'HelpDeskPriorityId',
        'IsSimplified',
        'IsSimplifiedMf',
      ];
      vm.generateFormly = function(reload = true) {
        InsertCustomExpressionProperties(vm.pageModel, vm.customExpressionProperties);
        vm.bottomTabs = [];
        for (const [key, value] of Object.entries(vm.pageModel.Panels)) {
          if (value.ContainerTabId == vm.statusTabs[vm.activeStatusSubItemTab]?.Name)
            vm.generatePanelToForm(vm, vm.FormlyFormPanelDescriptors, vm.pageModel, value.Name, reload);
        }
        angular.forEach(vm.pageModel.Fields, function(field, fieldName) {
          if (vm.disabledExceptionFields.includes(fieldName)) {
            return;
          }
          angular.forEach(vm.prevStatuses, function(tabName) {
            let panel = vm.statusTabs.find(x => x.Name == tabName)?.Panel;
            if (!!panel && (panel.includes(field.ContainerPanelId) || panel.includes(field.ContainerPanelId2))) {
              field.FormlyFieldDescriptor.templateOptions.disabled = true;
            }
          });
        });
        vm.setBottomTabs(vm.activeStatusSubItemTab);
        //#91626 Tabváltáskor ne fusson:
        //getCalulatedDeadline();
      };
      vm.updateFieldParameters();
      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.pageModel.Fields.WorkRespUser.FormlyFieldDescriptor.templateOptions.disabled = true;

        if (vm.dataModel.UserType === 'HDJEX') {
          vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.disabled = true;
        } else {
          if (model.statusCode == 'HDSCR') {
            vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
            vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.DateTimeOptions.customEdit = true;
          } else {
            vm.pageModel.Fields.CreateDateTime.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        }

        if (vm.dataModel.IsReadOnly) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }

        // additional f22 pre-filters
        vm.pageModel.Fields.ApproverId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~eq~'HDAPPR'";
        };
        vm.pageModel.Fields.CertUserId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~eq~'HDACER'";
        };
        vm.pageModel.Fields.VerifUserId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "ParameterId~contains~'HDACHE'";
        };
        vm.pageModel.Fields.RealApproverId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
          return "ParameterId~contains~'HDAPPR'";
        };
        vm.pageModel.Fields.RealCertUserId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
          return "ParameterId~contains~'HDACER'";
        };
        vm.pageModel.Fields.RealVerifUserId.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
          return "ParameterId~contains~'HDACHE'";
        };
        vm.statusCode = model.statusCode;
        vm.statuses = model.statuses;
        vm.sendMailDisabled = function() {
          return (
            !vm.dataModel.ContactPersonEmail ||
            vm.pageModel.Fields.ContactPersonEmail.FormlyFieldDescriptor.formControl?.$valid !== true
          );
        };
        vm.closeTicket = closeTicket;
        vm.setNewTicketStatus = setNewTicketStatus;
        vm.linkTicket = linkTicket;
        vm.sendMail = sendMail;
        vm.notificationMail = notificationMail;
        vm.generateWorksheet = generateWorksheet;
        vm.createTender = createTender;
        vm.editTender = editTender;
        vm.deleteTender = deleteTender;
        vm.createTicketTask = createTicketTask;
        vm.editTicketTask = editTicketTask;
        vm.deleteTicketTask = deleteTicketTask;
        vm.createTicketMaterial = createTicketMaterial;
        vm.editTicketMaterial = editTicketMaterial;
        vm.deleteTicketMaterial = deleteTicketMaterial;
        vm.activeBottomSubItemTab = 0;
        vm.attachDocument = attachDocument;
        vm.attachDocumentToTender = attachDocumentToTender;
        vm.attachDocumentToGenDocs = attachDocumentToGenDocs;
        vm.ticketMaterialGenerateInvoice = ticketMaterialGenerateInvoice;
        vm.setTicketMaterialStatus = setTicketMaterialStatus;
        vm.history = history;
        vm.ticketTaskCustPriceGen = ticketTaskCustPriceGen;
        vm.ticketMaterialCustPriceGen = ticketMaterialCustPriceGen;

        vm.activeDataTab = 0;

        vm.statusTabs = [];
        // Tabs
        vm.statusTabs = [
          vm.pageModel.Tabs.TabBejelentes,
          vm.pageModel.Tabs.TabMunkafelvetel,
          vm.pageModel.Tabs.TabJovahagyas,
          vm.pageModel.Tabs.TabVegrehajtas,
          vm.pageModel.Tabs.TabTeljesitesigazolas,
          vm.pageModel.Tabs.TabEllenorzes,
          vm.pageModel.Tabs.TabLezaras,
        ];
        if (!vm.existHDSCHU && vm.statusCode !== 'HDSCH') {
          vm.statusTabs.splice(
            vm.statusTabs.findIndex(x => x?.Name === 'TabEllenorzes'),
            1
          );
          vm.pageModel.Fields.VerifUserId.FormlyFieldDescriptor.hide = true;
        }
        // fejléc tabs
        vm.dataTabs = [
          vm.pageModel.Tabs.TabAlap,
          vm.pageModel.Tabs.TabBerletiSzerzodes,
          vm.pageModel.Tabs.TabIngatlan,
          vm.pageModel.Tabs.TabFelelosok,
        ];

        for (const [key, value] of Object.entries(vm.pageModel.Panels)) {
          let element = vm.statusTabs.find(x => x.Name == value.ContainerTabId);
          if (!!element) {
            if (!element.Panel) {
              element.Panel = [];
            }
            element.Panel.push(value.Name);
          }
        }

        vm.FormlyFormPanelDescriptors = {};
        vm.removeTabsFromFormGenerate(vm.pageModel, vm.statusTabs);
        generateForm(vm);
        // Disable later status tabs
        var prevStatus;
        var prevStatuses = [];
        var disable = false;
        for (var i = 0; i < vm.statusTabs.length; i++) {
          vm.statusTabs[i].disabled = disable || (vm.dataModel.StatesRole[i] || {}).Role == 'HDOTI';
          var statusName = vm.statusTabs[i].Name.substring(3);
          var statusTabName = vm.statusTabs[i].Name;
          if (prevStatus && !disable) {
            prevStatuses.push(prevStatus);
          }

          if (vm.statusMap[statusName] == vm.statusCode) {
            disable = true;
          }
          prevStatus = statusTabName;
        }
        vm.prevStatuses = prevStatuses;
        vm.statusTabs.forEach(function(tab, index) {
          if (!tab.disabled) {
            vm.activeStatusSubItemTab = index;
          }
        });

        // Disable fields of previous statuses
        vm.bottomTabs = [];
        vm.setBottomTabs(vm.activeStatusSubItemTab);

        if (model.dto.IsApproved === null) {
          model.dto.IsApproved = false;
        }
        if (vm.statusCode !== 'HDSTD' || !(vm.dataModel.SentBackToExecution ?? false)) {
          vm.pageModel.Fields.SentBackToExecution.FormlyFieldDescriptor.hide = true;
        }
        vm.createDateTime = vm.dataModel.CreateDateTime || new Date();
        vm.dataModel.CurrentUrl = window.location.href;
      }

      vm.saveItem = function() {
        var defer = $q.defer();
        if (vm.statusCode === 'HDSCR' && vm.dataModel.RelatedTicket.Value > 0) {
          bootbox.dialog({
            message: 'Értesíti a bejelentőt a meglévő bejelentéshez kapcsolásról?',
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: 'Nem',
                className: 'btn-default',
                callback: function() {
                  toastr.warning('A bejelentés nem menthető.', vm.messages.Warning);
                },
              },
              confirm: {
                label: 'Igen',
                className: 'btn-primary',
                callback: function() {
                  vm.save(defer);
                },
              },
            },
          });
        } else {
          vm.save(defer);
        }
        return defer.promise;
      };

      vm.saveAndSendEmail = function() {
        vm.savingInProgress = true;
        vm.dataModel.ContactPersonNotMailDateTime = moment().format('YYYY-MM-DDTHH:mm:ss');
        $http
          .post('HelpDesk/TicketEdit', vm.dataModel)
          .then(function(response) {
            $http.post('HelpDesk/SendMailToContact/', { ticketId: vm.dataModel.TicketId }).then(function() {
              vm.savingInProgress = false;
              toastr.success('Sikeres üzenetküldés!');
            });
          })
          .catch(function() {
            vm.savingInProgress = false;
            toastr.warning('Sikertlen üzenetküldés adathiba miatt!');
          });
      };

      vm.save = function(defer) {
        $http
          .post('HelpDesk/TicketEdit', vm.dataModel)
          .then(function(response) {
            if (vm.dataModel.ModelState === 2) {
              $state.go('HelpDesk.TicketEdit', {
                id: response.data?.InsertedId ?? response.data?.Parameters?.InsertedId,
              });
            } else {
              defer.resolve();
            }
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
          })
          .catch(function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            defer.resolve();
          });
      };
      vm.duplicateTicket = function() {
        const url = $state.href('HelpDesk.TicketDuplicate', { id: vm.dataModel.TicketId });
        $window.open(url, '_blank');
      };
      function calcRowTotal() {
        return this.get('UnitPrice') * this.get('Quantity');
      }

      function resetPremiseF4() {
        vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options.f4scope.resetModel();
      }
      function resetRoomInventoryF4() {
        vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.f4scope.resetModel();
      }

      function setAddress(selectedItem) {
        if (!!selectedItem && selectedItem.Value && selectedItem.GridItem) {
          var gridItem = selectedItem.GridItem;
          vm.dataModel.Address =
            (gridItem.Country ? gridItem.Country : '') +
            (gridItem.PostCode ? gridItem.PostCode : '') +
            ' ' +
            (gridItem.Locality ? gridItem.Locality : '') +
            ' ' +
            (gridItem.Quarter ? gridItem.Quarter : '') +
            ', ' +
            (gridItem.Street ? gridItem.Street : '') +
            ' ' +
            (gridItem.StreetChar ? gridItem.StreetChar : '');
          //vm.dataModel.Address = gridItem.Country + ' ' + gridItem.PostCode + ' ' + gridItem.Locality + ' ' + gridItem.Quarter + ', ' + gridItem.Street + ' ' + gridItem.StreetChar;
          if (gridItem.StreetNumber) {
            vm.dataModel.Address +=
              ' ' +
              (gridItem.StreetNumber ? gridItem.StreetNumber : '') +
              ' ' +
              (gridItem.Building ? gridItem.Building : '') +
              ' ' +
              (gridItem.StairWay ? gridItem.StairWay : '') +
              ' ' +
              (gridItem.Floor ? gridItem.Floor : '') +
              ' ' +
              (gridItem.Door ? gridItem.Door : '');
            //vm.dataModel.Address += ' ' + gridItem.StreetNumber + ' ' + gridItem.Building + ' ' + gridItem.StairWay + ' ' + gridItem.Floor + ' ' + gridItem.Door;
          } else if (gridItem.TopogrNumber) {
            vm.dataModel.Address += ' ' + (gridItem.TopogrNumber ? gridItem.TopogrNumber : '');
            //vm.dataModel.Address += ' ' + gridItem.TopogrNumber;
          }
        }
      }

      function roomInventoryWhereCondition() {
        var createDate = moment(new Date(vm.dataModel.CreateDateTime)).format('YYYY-MM-DDTHH:mm:ss');
        var propertyId = roomInventorySelectById() || 0;
        var whereCondition =
          'PropertyId~eq~' +
          propertyId +
          "~and~ValidFrom~lte~datetime'" +
          createDate +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          createDate +
          "')";

        if (!!vm.dataModel.Premise) {
          whereCondition += "~and~PremiseId~in~'" + vm.dataModel.Premise?.join(',') + "'";
        }
        return whereCondition;
      }

      function propertyWhereCondition() {
        var createDate = moment(new Date(vm.dataModel.CreateDateTime)).format('YYYY-MM-DDTHH:mm:ss');
        var whereCondition =
          "(Level~eq~'PPRBU'~or~Level~eq~'PPRED'~or~Level~eq~'PPRLA')" +
          "~and~ValidFrom~lte~datetime'" +
          createDate +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          createDate +
          "')";
        return whereCondition;
      }

      function premiseWhereCondition() {
        var createDate = moment(new Date(vm.dataModel.CreateDateTime)).format('YYYY-MM-DDTHH:mm:ssZ');
        var whereCondition = vm.dataModel.Property.Value
          ? "PropertyId~eq~'" +
            (vm.dataModel.Property.Value ? vm.dataModel.Property.Value : 0) +
            "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
            createDate +
            "')"
          : "(ValidTo~isnull~or~ValidTo~gte~datetime'" + createDate + "')";
        //Nincs szűrés rá a 36083/1.megj szerint
        // if (!!vm.dataModel.Tenement.Value) {
        // var tenement = vm.dataModel.Tenement.Text.split(' ');
        // whereCondition += "~and~Tenement~eq~'" + tenement[0] + "'";
        // }

        return whereCondition;
      }

      function tenementWhereCondition() {
        var createDate = moment(new Date(vm.dataModel.CreateDateTime)).format('YYYY-MM-DDTHH:mm:ss');
        var whereCondition =
          "Level~eq~'PPRRU'~and~ValidFrom~lte~datetime'" +
          createDate +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          createDate +
          "')" +
          (vm.partnerTenementList?.length > 0 ? "~and~PropertyId~in~'" + vm.partnerTenementList.join(',') + "'" : '');

        return whereCondition;
      }

      function relatedTicketWhereCondition() {
        return 'RelatedTicketId~isnull';
      }

      function roomInventorySelectById() {
        if (vm.dataModel.Property !== null) {
          return vm.dataModel.Property.Value;
        } else {
          return null;
        }
      }

      function closeTicket() {
        $http.post('HelpDesk/CloseTicket', vm.dataModel).then(function() {
          toastr.warning('Bejelentés visszavonva!');
          $state.go('HelpDesk.TicketEdit', { id: vm.securedId }, { reload: true });
        });
      }

      //TODO ezt még lehetne egyszerűsíteni
      function setNewTicketStatus(toStatusCode, forward) {
        var dialogMessage = '';
        var dialogTitle = '';
        var forwardBackwardStr = '';
        if (forward) {
          dialogTitle = 'Bejelentés továbbküldése';
          forwardBackwardStr = 'továbbküldi';
        } else {
          dialogTitle = 'Bejelentés visszaléptetése';
          forwardBackwardStr = 'visszalépteti';
        }
        switch (toStatusCode) {
          case 'HDSRV':
            dialogTitle = 'Bejelentés visszavonása';
            dialogMessage = 'Valóban visszavonja az érintett bejelentést?';
            break;
          case 'HDSCR':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Bejelentve</i> státuszba?';
            break;
          case 'HDSPL':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Munkafelvételre</i> státuszba?';
            break;
          case 'HDSVA':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Jóváhagyásra</i> státuszba?';
            break;
          case 'HDSTD':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Végrehajtásra</i> státuszba?';
            break;
          case 'HDSER':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Teljesítésigazolásra</i> státuszba?';
            break;
          case 'HDSCH':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Ellenőrzésre</i> státuszba?';
            break;
          case 'HDSCL':
            dialogMessage = 'Biztosan ' + forwardBackwardStr + ' a bejelentést <i>Lezárva</i> státuszba?';
            break;
          default:
            dialogMessage = 'Biztosan megváltoztatja a státuszt?';
        }
        var isRollbackToExecution = !forward && toStatusCode === 'HDSTD';
        var modalId = 'statusChangeModal_' + Date.now();
        dialogMessage +=
          '<br /><strong>Azonosító: ' +
          vm.dataModel.TicketId +
          '</strong><br /><br />' +
          '<span' +
          (isRollbackToExecution ? ' style="font-weight:bold;"' : '') +
          '>' +
          (isRollbackToExecution ? 'Megjegyzés *' : 'Megjegyzés') +
          '</span>' +
          '<textarea id="comment-text" class="bootbox-input bootbox-input-textarea form-control"></textarea>';

        bootbox.dialog({
          message: dialogMessage,
          title: dialogTitle,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                var comment = $('#comment-text').val();
                //kérdőív feldobása (ha van) a paraméter szerinti státuszban
                if (forward && vm.statusCode === (vm.paramHDSURV || 'HDSCL')) {
                  SurveyService.openSurveyModal(
                    'SUEHD',
                    'SUCHC',
                    vm.dataModel.TicketId,
                    setNewTicketStatusPost,
                    toStatusCode,
                    forward,
                    comment
                  );
                } else {
                  setNewTicketStatusPost(toStatusCode, forward, comment);
                }
              },
            },
          },
        });

        if (isRollbackToExecution) {
          var modalInstance = $('.bootbox');
          var confirmButton = modalInstance.find('.btn-primary');
          var cancelButton = modalInstance.find('.btn-default');
          confirmButton.prop('disabled', true);
          var commentTextarea = modalInstance.find('#comment-text');
          commentTextarea.on('input', function() {
            var comment = $(this).val();
            confirmButton.prop('disabled', !comment || comment.trim() === '');
          });
        }
      }

      function setNewTicketStatusPost(toStatusCode, forward, comment, surveyResponseList) {
        $http
          .post('HelpDesk/SetNewTicketStatus', {
            model: vm.dataModel,
            toStatusCode: toStatusCode,
            forward: forward,
            comment: comment,
          })
          .then(function(response) {
            if (response.data.result.ResultStatus) {
              toastr.success('Státusz megváltoztatva!');
              if (vm.dataModel.TicketId === 0) {
                $state.go('HelpDesk.TicketEdit', { id: response.data.Data });
              } else {
                lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                $window.location.reload();
              }
            } else {
              toastr.error(response.data.result.Errors[0].Message);
              //ha valami hiba van a mentésben, ki kell törölni/inaktívvá tenni a válaszokat
              SurveyService.deleteResponses('SUEHD', 'SUCHC', vm.dataModel.TicketId);
            }
          })
          .catch(function() {
            //ha valami hiba van a mentésben, ki kell törölni/inaktívvá tenni a válaszokat
            SurveyService.deleteResponses('SUEHD', 'SUCHC', vm.dataModel.TicketId);
          });
      }

      //#region Árajánlatok
      function createTender() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('HelpDesk.TenderCreate', { ticketId: vm.dataModel.TicketId });
      }

      function editTender() {
        var selectedItems = GetSelectedGridItems(vm.GridArajanlatokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.GridArajanlatokGridIdField];
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('HelpDesk.TenderEdit', { id: id });
        }
      }

      function deleteTender() {
        var id = getSelectedRowId(vm.GridArajanlatokGrid, 'TenderId');
        if (id === -1) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var dialogMessage = 'Biztos, hogy törli a kijelölt árajánlatot?';
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('HelpDesk/TenderDelete/' + id).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.GridArajanlatokGrid.dataSource?.read();
                  });
                },
              },
            },
          });
        }
      }

      //#endregion Árajánlatok

      //#region Elvégzendő feladatok
      function createTicketTask(isCustomTask = false) {
        if (vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD') {
          return null;
        }
        var modalInstance;
        if (isCustomTask) {
          modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketCustomTaskEdit.html',
            controller: 'TicketCustomTaskEditCtrl as vm',
            windowClass: 'ticket-task-modal-window',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketCustomTaskEditNew/?ticketId=' + vm.dataModel.TicketId),
            },
          });
        } else {
          modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketTaskEdit.html',
            controller: 'TicketTaskEditCtrl as vm',
            windowClass: 'ticket-task-modal-window',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketTaskEditCreate/?ticketId=' + vm.dataModel.TicketId),
            },
          });
        }

        modalInstance.result.then(function() {
          vm.GridFeladatokGrid.dataSource?.read();
          getCalulatedDeadline();
        });
      }
      function changePremiseBudgetModal() {
        if (!vm.changePremiseBudgetValue) {
          vm.changePremiseBudgetValue = vm.oldDataModel?.Premise?.toString();
        }
        if (
          !vm.oldDataModel ||
          !vm.dataModel.BudgetEditable ||
          vm.changeBudgetModalOpened ||
          !(
            vm.pageModel.Fields.Premise.FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems
              ?.length > 0
          ) ||
          vm.dataModel.Premise?.toString() === vm.changePremiseBudgetValue ||
          (vm.statusCode !== 'HDSPL' && vm.statusCode !== 'HDSTD')
        ) {
          return null;
        }
        vm.changeBudgetModalOpened = true;
        try {
          var modalInstance;
          modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketChangeBudgetModal.html',
            controller: 'TicketChangeBudgetModalCtrl as vm',
            windowClass: 'ticket-task-modal-window',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketChangeBudget/?budgetId=' + vm.dataModel.BudgetId?.Value),
              premiseIds: function() {
                return vm.dataModel.Premise;
              },
            },
          });

          modalInstance.result.then(function(result) {
            if (result > 0) {
              vm.dataModel.BudgetId = { Value: result };
              vm.changePremiseBudgetValue = vm.dataModel.Premise.toString();
              if (vm.formly.$valid) {
                vm.saveItem();
              }
            }
          });
          modalInstance.opened.then(function() {
            vm.changeBudgetModalOpened = true;
          });
          modalInstance.closed.then(function() {
            vm.changeBudgetModalOpened = false;
          });
          modalInstance.result.catch(function() {
            vm.changeBudgetModalOpened = false;
          });
        } catch (err) {
          vm.changeBudgetModalOpened = false;
        }
      }

      function editTicketTask() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridFeladatokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          id = selectedItems[0][vm.GridFeladatokGridIdField];
          var actTemplateUrl, actController, actRouteResolveFunc;
          if (selectedItems[0]['Type'] == 'TicketTask') {
            actTemplateUrl = 'App/HelpDesk/TicketTaskEdit.html';
            actController = 'TicketTaskEditCtrl as vm';
            actRouteResolveFunc = 'HelpDesk/TicketTaskEditMod';
          } else {
            actTemplateUrl = 'App/HelpDesk/TicketCustomTaskEdit.html';
            actController = 'TicketCustomTaskEditCtrl as vm';
            actRouteResolveFunc = 'HelpDesk/TicketCustomTaskEdit';
          }

          var modalInstance = $uibModal.open({
            templateUrl: actTemplateUrl,
            controller: actController,
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc(actRouteResolveFunc + '/?ticketId=' + vm.dataModel.TicketId + '&id=' + id),
            },
          });

          modalInstance.result.then(function() {
            vm.GridFeladatokGrid.dataSource?.read();
            getCalulatedDeadline();
          });
        }
      }

      function SetDateTimeToNow(model, field) {
        if (!!model) {
          let date = Date.now(),
            formatedDate = moment(date).format('YYYY-MM-DDTHH:mm:ss');
          model[field] = formatedDate;
        }
      }

      function deleteTicketTask() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridFeladatokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          if (selectedItem['CodeId'] === 'HDSPL' && vm.statusCode !== 'HDSPL') {
            toastr.warning(
              'A korábban felvett feladatok már jóvá lettek hagyva, így azok nem törölhetőek!',
              vm.messages.Warning
            );
          } else {
            id = selectedItem[vm.GridFeladatokGridIdField];
            var dialogMessage = 'Biztos, hogy törli a kijelölt tételt?';
            var getUrl;
            if (selectedItems[0]['Type'] == 'TicketTask') {
              getUrl = 'HelpDesk/TicketTaskDelete/';
            } else {
              getUrl = 'HelpDesk/TicketCustomTaskDelete/';
            }
            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http.get(getUrl + id).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.GridFeladatokGrid.dataSource?.read();
                      getCalulatedDeadline();
                    });
                  },
                },
              },
            });
          }
        }
      }
      function ticketTaskCustPriceGen() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TicketTaskCustomerPriceGenModal.html',
          controller: 'TicketTaskCustomerPriceGenModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TicketTaskCustomerPriceGen', { id: vm.dataModel.TicketId }),
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function() {
          vm.GridFeladatokGrid.dataSource?.read();
        });
      }
      //#endregion Elvégzendő feladatok

      //#region Felhasználandó anyagok
      function createTicketMaterial(isCustomMaterial = false) {
        var modalInstance;
        if (isCustomMaterial) {
          modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketCustomMaterialEdit.html',
            controller: 'TicketCustomMaterialEditCtrl as vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketCustomMaterialEditNew/?ticketId=' + vm.dataModel.TicketId),
            },
          });
        } else {
          modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketMaterialEdit.html',
            controller: 'TicketMaterialEditCtrl as vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketMaterialEdit/?ticketId=' + vm.dataModel.TicketId),
            },
          });
        }

        modalInstance.result.then(function() {
          vm.GridAnyagokGrid.dataSource?.read();
        });
      }

      function editTicketMaterial() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridAnyagokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          if (selectedItem['HelpDeskStatusCode'] === 'HDSPL' && vm.statusCode !== 'HDSPL') {
            toastr.warning(
              'A korábban felvett anyagok már jóvá lettek hagyva, így azok nem szerkeszthetők.',
              vm.messages.Warning
            );
          } else {
            id = selectedItems[0][vm.GridAnyagokGridIdField];
            var actTemplateUrl, actController, actRouteResolveFunc;
            if (selectedItems[0]['Type'] === 'TMTDM') {
              actTemplateUrl = 'App/HelpDesk/TicketMaterialEdit.html';
              actController = 'TicketMaterialEditCtrl as vm';
              actRouteResolveFunc = 'HelpDesk/TicketMaterialEditNew';
            } else {
              actTemplateUrl = 'App/HelpDesk/TicketCustomMaterialEdit.html';
              actController = 'TicketCustomMaterialEditCtrl as vm';
              actRouteResolveFunc = 'HelpDesk/TicketCustomMaterialEdit';
            }

            var modalInstance = $uibModal.open({
              templateUrl: actTemplateUrl,
              controller: actController,
              size: 'lg',
              backdrop: 'static',
              resolve: {
                model: RouteResolveFunc(actRouteResolveFunc + '/?ticketId=' + vm.dataModel.TicketId + '&id=' + id),
              },
            });

            modalInstance.result.then(function() {
              vm.GridAnyagokGrid.dataSource?.read();
            });
          }
        }
      }

      function deleteTicketMaterial() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridAnyagokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          if (selectedItem['HelpDeskStatusCode'] === 'HDSPL' && vm.statusCode !== 'HDSPL') {
            toastr.warning(
              'A korábban felvett anyagok már jóvá lettek hagyva, így azok nem törölhetők.',
              vm.messages.Warning
            );
          } else {
            id = selectedItem[vm.GridAnyagokGridIdField];
            var dialogMessage = 'Biztos, hogy törli a kijelölt tételt?';
            var getUrl;
            if (selectedItems[0]['Type'] == 'TMTDM') {
              getUrl = 'HelpDesk/TicketMaterialDelete/';
            } else {
              getUrl = 'HelpDesk/TicketCustomMaterialDelete/';
            }
            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http.get(getUrl + id).then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.GridAnyagokGrid.dataSource?.read();
                    });
                  },
                },
              },
            });
          }
        }
      }

      function ticketMaterialGenerateInvoice() {
        var selectedItems = GetSelectedGridItems(vm.GridAnyagokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          toastr.warning('Ez a funkció még nincs megvalósítva.', vm.messages.Warning);
        }
      }

      function setTicketMaterialStatus() {
        var dialogMessage = 'Biztos, hogy átadásra jelöli a piszkozat státuszban lévő tételeket?';
        bootbox.dialog({
          message: dialogMessage,
          title: vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.get('KulcsSoft/SetTicketMaterialStatusToPass?ticketId=' + vm.dataModel.TicketId).then(function() {
                  toastr.success(vm.messages.SaveSuccessful);
                  vm.GridAnyagokGrid.dataSource?.read();
                });
              },
            },
          },
        });
      }

      function ticketMaterialCustPriceGen() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TicketMaterialCustomerPriceGenModal.html',
          controller: 'TicketMaterialCustomerPriceGenModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TicketMaterialCustomerPriceGen', { id: vm.dataModel.TicketId }),
          },
          backdrop: 'static',
        });
        modalInstance.result.then(function() {
          vm.GridAnyagokGrid.dataSource?.read();
        });
      }

      //#endregion Felhasználandó anyagok

      function linkTicket() {
        // TODO
        alert('TODO - Link ticket');
      }

      function sendMail() {
        var dialogMessage = 'Biztosan elküldi az értesítő üzenetet az alábbi címre?';
        dialogMessage += '<br /><strong>' + vm.dataModel.ContactPersonEmail + '</strong>';
        bootbox.dialog({
          message: dialogMessage,
          title: 'Értesítő üzenet elküldése',
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                vm.saveAndSendEmail();
              },
            },
          },
        });
      }

      function sendMultipleMails() {
        toastr.warning('Ez a funkció még nincs megvalósítva.', vm.messages.Warning);
      }

      function generateWorksheet(sheetId) {
        $http
          .post('HelpDesk/GenerateWorksheetByReportId', { ticketId: vm.dataModel.TicketId, reportId: sheetId })
          .then(function(response) {
            if (response.data.ResultStatus) {
              var data = response.data;
              if (data.ResultStatus) {
                var raw = atob(data.File);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
                }

                var fs = new Blob([array], { type: data.MimeType });
                saveAs(fs, decodeURIComponent(data.FileName));

                toastr.success('Sikeres generálás!');
              }
              toastr.success('Munkalap létrehozva!');
              vm.GridDokumentumokGrid?.dataSource?.read();
            } else {
              toastr.error(response.data.Errors[0].Message);
            }
          });
      }

      function attachDocument() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicket', vm.dataModel.TicketId);
      }

      function history() {
        // TODO?
        bootbox.dialog({
          message: 'A nem mentett adatok elvesznek. Biztos, hogy továbblép?', //vm.messages.HistoryConfimMessage,
          title: 'Megerősítés', //vm.messages.Confirm,
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                $state.go('HelpDesk.HistoryNav', {
                  tableId: 'FlgTicket',
                  idColumn: 'TicketId',
                  ownerId: vm.dataModel.TicketId,
                });
              },
            },
          },
        });
      }

      function attachDocumentToTender() {
        var selectedItems = GetSelectedGridItems(vm.GridArajanlatokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.GridArajanlatokGridIdField];
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          $state.go('HelpDesk.DasDocumentsNav', { tableId: 'FlgTender', ownerId: id });
        }
      }
      function attachDocumentToGenDocs() {
        var selectedItems = GetSelectedGridItems(vm.GridDokumentumokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.GridDokumentumokGridIdField];
          lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
          dasService.NavigateToDas(
            vm.messages,
            'HelpDesk.DasDocumentsNav',
            selectedItems[0]['Type'] === 'PDF' ? 'FlgTicketSSRSDocument' : 'FlgTicketDocument',
            id
          );
        }
      }
      function TicketMaterialGenerateInvoice() {
        var selectedItems = GetSelectedGridItems(vm.GridAnyagokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          toastr.warning('Ez a funkció még nincs megvalósítva.', vm.messages.Warning);
        }
      }

      function initGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars,
        sort = null
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

        if (vm.pageModel.Grids[gridName].Table) {
          readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.pageModel.Grids[gridName].Table,
            whereCondition: whereCondition,
            adopter: vm.pageModel.Grids[gridName].Adopter,
            installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids[gridName].IdColumn,
            sort: sort,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#' + mainGrid).data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );
      }

      function notificationMail() {
        $uibModal.open({
          templateUrl: 'App/HelpDesk/NotificationMail.html',
          controller: 'NotificationMailCtrl as vm',
          backdrop: 'static',
          resolve: {
            model: RouteResolveFunc('HelpDesk/NotificationMail'),
          },
        });

        //modalInstance.result.then(function () {
        //    toastr.success("Értesítés(ek) kiküldve!");
        //});
      }

      function getCalulatedDeadline() {
        if (!!vm.dataModel.HelpDeskPriorityId && !!vm.dataModel.SpecializationId && !!vm.dataModel.ServiceLevelId) {
          $http
            .post('HelpDesk/GetCalculatedDeadline', vm.dataModel)
            .then(function(response) {
              vm.dataModel.CalcDeadline = response.data.CalcDeadline;
              vm.dataModel.ExecCalcDeadline = response.data.CalcDeadline;
              vm.dataModel.ReactionTime = response.data.ReactionTime;
            })
            .catch(function() {
              vm.dataModel.CalcDeadline = null;
              vm.dataModel.ExecCalcDeadline = null;
              vm.dataModel.ReactionTime = null;
            });
        }
      }

      /* function generateWorksheet(attachment = false) {
        $http
          .post('HelpDesk/GenerateWorksheet', { model: vm.dataModel, attachment: attachment })
          .then(function(response) {
            if (response.data.ResultStatus) {
              toastr.success('Munkalap létrehozva!');
            } else {
              toastr.error(response.data.Errors[0].Message);
            }
          });
      }*/

      function WAL() {
        walService.NavigateToWal('HelpDesk', 'HelpDeskNavWal', 'FlgTicketView');
      }

      function WALSubItem() {
        switch (vm.bottomTabs[vm.activeBottomSubItemTab].Name) {
          case 'TabElvegzendoFeladatok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODTicketTaskWal', 'FlgTicketTaskView');
            break;
          case 'TabFelhasznalandoAnyagok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODTicketMaterialWal', 'FlgTicketMaterialView');
            break;
          case 'TabStatuszok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODStatusWal', 'FlgHelpDeskStatusView');
            break;
          case 'TabArajanlatok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODTenderWal', 'FlgTenderView');
            break;
          case 'TabSzamlazasiAdatok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODInvoiceWal', 'FlgTicketLedgerCode');
            break;
          case 'TabUzenofal':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODMessageWal', 'FlgTicketMessageView');
            break;
          case 'TabDokumentumok':
            walService.NavigateToWal('HelpDesk', 'HelpDeskMODGenDocsWal', 'FlgTicketGenDocView');
            break;
          default:
            break;
        }
      }

      function newMessage() {
        var modalInstance;
        modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TicketMessageCreate.html',
          controller: 'TicketMessageCreateCtrl as vm',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TicketMessageCreate/?ticketId=' + vm.dataModel.TicketId),
          },
        });

        modalInstance.result.then(function() {
          vm.GridUzenofalGrid.dataSource?.read();
        });
      }
      function editStatuszok() {
        var selectedItems = GetSelectedGridItems(vm.GridStatuszokGrid);
        if (selectedItems.length === 0 || selectedItems[0].StatusType != 1) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var ticketSuspensionId = selectedItems[0][vm.GridStatuszokGridIdField];
          let url = 'HelpDesk/TicketSuspensionEdit/?ticketSuspensionId=' + ticketSuspensionId;
          modalSuspension(url, callback, 'edit');
          function callback(result) {
            if (!!result?.dto) {
              getCalulatedDeadline();
              vm.GridStatuszokGrid?.dataSource?.read();
            }
          }
        }
      }
      function newSuspension() {
        let url = 'HelpDesk/TicketSuspensionCreate/?ticketId=' + vm.dataModel.TicketId;
        modalSuspension(url, callback, 'new');
        function callback(result) {
          if (result?.response?.data?.InsertedId > 0) {
            vm.dataModel.TicketSuspensionId = result.response.data.InsertedId;
            vm.dataModel.SuspendedValidTo = result.dto.ValidTo;
            vm.dataModel.SuspendedValidFrom = result.dto.ValidFrom;
            getCalulatedDeadline();
            vm.GridStatuszokGrid?.dataSource?.read();
          }
        }
      }
      function editSuspension() {
        let url = 'HelpDesk/TicketSuspensionEdit/?ticketSuspensionId=' + vm.dataModel.TicketSuspensionId;
        modalSuspension(url, callback, 'edit');
        function callback(result) {
          if (!!result?.dto) {
            vm.dataModel.TicketSuspensionId = result.dto.TicketSuspensionId;
            vm.dataModel.SuspendedValidTo = result.dto.ValidTo;
            vm.dataModel.SuspendedValidFrom = result.dto.ValidFrom;
            getCalulatedDeadline();
            vm.GridStatuszokGrid?.dataSource?.read();
          }
        }
      }
      function modalSuspension(url, callback, type) {
        var modalInstance;
        modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TicketSuspensionEdit.html',
          controller: 'TicketSuspensionEditCtrl as vm',
          resolve: {
            model: RouteResolveFunc(url),
            params: {
              type: type,
              ticketDto: vm.dataModel,
              statusCode: vm.statusCode,
            },
          },
        });

        modalInstance.result.then(function(result) {
          if (Object.prototype.toString.call(callback) == '[object Function]') {
            callback(result);
          }
        });
      }

      function viewMessage() {
        var selectedItems = GetSelectedGridItems(vm.GridUzenofalGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var ticketMessageId = selectedItems[0][vm.GridUzenofalGridIdField];
          $uibModal.open({
            templateUrl: 'App/HelpDesk/TicketMessageCreate.html',
            controller: 'TicketMessageCreateCtrl as vm',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TicketMessageView/?ticketMessageId=' + ticketMessageId),
            },
          });
        }
      }
      vm.newTicketDoc = function() {
        var modalInstance;
        modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TicketDocEdit.html',
          controller: 'TicketDocEditCtrl as vm',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TicketDocCreate/?ticketId=' + vm.dataModel.TicketId),
          },
        });

        modalInstance.result.then(function() {
          vm.GridDokumentumokGrid.dataSource?.read();
        });
      };
      vm.editTicketDoc = function() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridDokumentumokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          let ssrs = selectedItem['Type'] === 'PDF' ? 'SSRS' : '';
          id = selectedItems[0][vm.GridDokumentumokGridIdField];
          var actTemplateUrl, actController, actRouteResolveFunc;
          actTemplateUrl = 'App/HelpDesk/TicketDocEdit.html';
          actController = 'TicketDocEditCtrl as vm';
          actRouteResolveFunc = 'HelpDesk/TicketDoc' + ssrs + 'Edit';

          var modalInstance = $uibModal.open({
            templateUrl: actTemplateUrl,
            controller: actController,
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc(actRouteResolveFunc + '/?id=' + id),
            },
          });

          modalInstance.result.then(function() {
            vm.GridDokumentumokGrid.dataSource?.read();
          });
        }
      };
      vm.duplicateTicketDoc = function() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridDokumentumokGrid);
        if (selectedItems.length === 0 || selectedItems[0]['Type'] !== 'DOC') {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          id = selectedItems[0][vm.GridDokumentumokGridIdField];
          var actTemplateUrl, actController, actRouteResolveFunc;
          actTemplateUrl = 'App/HelpDesk/TicketDocEdit.html';
          actController = 'TicketDocEditCtrl as vm';
          actRouteResolveFunc = 'HelpDesk/TicketDocDuplicate';

          var modalInstance = $uibModal.open({
            templateUrl: actTemplateUrl,
            controller: actController,
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc(actRouteResolveFunc + '/?id=' + id),
            },
          });

          modalInstance.result.then(function() {
            vm.GridDokumentumokGrid.dataSource?.read();
          });
        }
      };
      vm.viewTicketDoc = function() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridDokumentumokGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var selectedItem = selectedItems[0];
          let ssrs = selectedItem['Type'] === 'PDF' ? 'SSRS' : '';
          id = selectedItems[0][vm.GridDokumentumokGridIdField];
          var actTemplateUrl, actController, actRouteResolveFunc;
          actTemplateUrl = 'App/HelpDesk/TicketDocEdit.html';
          actController = 'TicketDocEditCtrl as vm';
          actRouteResolveFunc = 'HelpDesk/TicketDoc' + ssrs + 'View';

          var modalInstance = $uibModal.open({
            templateUrl: actTemplateUrl,
            controller: actController,
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc(actRouteResolveFunc + '/?id=' + id),
            },
          });
        }
      };

      function clearUserAndPartnerData(value) {
        //Mivel máshogy nem udjuk megitélni, hogy inicializáltunk (value == '') vagy töröltünk (value==null) egy hack-et alkalmazunk:
        if (value == null) {
          vm.dataModel.OwnerId = { Value: null, Text: null };
          vm.dataModel.PartnerTMId = { Value: null, Text: null };
          vm.dataModel.OwnerName = undefined;
          vm.dataModel.OwnerPhoneNumber = undefined;
          vm.dataModel.OwnerEmail = undefined;

          vm.pageModel.Fields.OwnerPhoneNumber.FormlyFieldDescriptor.templateOptions.options.dataSource.data([]);
          vm.pageModel.Fields.OwnerEmail.FormlyFieldDescriptor.templateOptions.options.dataSource.data([]);
          vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.disabled = vm.dataModel.IsReadOnly;
          vm.partnerTenementList = [];
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskEditHDJEXCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    'DasService',
    'UIHelperService',
    '$q',
    function($http, model, $state, $stateParams, AuthService, $scope, $uibModal, dasService, UIHelperService, $q) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskEditHDJEXCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.reportList = model.reportList;
      init();
      vm.generateWorksheet = generateWorksheet;

      vm.getAttachedDocumentList = function() {
        $http
          .post('Dms/Document/AttachedDocumentList', {
            adopter: '',
            columnCsv: 'name,extension,filesize',
            page: 1,
            pageSize: 999,
            tableName: 'dms_UserDocView',
            idColumn: 'docID',
            whereCondition: "(f_tableid~eq~'FlgTicket'~and~f_ownerid~eq~'" + vm.dataModel.TicketId + "')",
          })
          .then(function(response) {
            response.data.Data.map(function(x) {
              vm.dataModel.StoredFiles.push({ DocName: x.name, DocSize: x.filesize, DocExt: x.extension });
            });
            vm.storedFilesLoad = true;
          })
          .catch(function(response) {
            toastr.warning('Hiba a csatolt dokumentumok letöltése közben!');
            console.log('Errors:', response.data);
            vm.storedFilesLoad = true;
          });
      };
      vm.getAttachedDocumentList();
      vm.save = function() {
        var defer = $q.defer();
        $http
          .post('HelpDesk/TicketCreateHDJEX', vm.dataModel)
          .then(function(response) {
            var insertedId = response.data.InsertedId;
            vm.dataModel.TicketId = insertedId;
            if (!vm.dataModel.Files) {
              toastr.success(vm.pageModel.Messages.SaveSuccessful);
              defer.resolve();
              $state.go('HelpDesk.TicketHDJEXView', { id: insertedId });
            } else {
              // attach the files if there are any
              $http
                .post('HelpDesk/TicketAttachFiles', vm.dataModel)
                .then(function(response) {
                  if (response.data.result.ResultStatus) {
                    toastr.success(vm.pageModel.Messages.SaveSuccessful);
                    defer.resolve();
                    // go to the view
                    $state.go('HelpDesk.TicketHDJEXView', { id: insertedId });
                  } else {
                    toastr.success(vm.pageModel.Messages.SaveSuccessful);
                    defer.resolve();
                    toastr.error('Hiba fájlfeltöltés közben!');
                  }
                })
                .catch(function(response) {
                  toastr.success(vm.pageModel.Messages.SaveSuccessful);
                  defer.resolve();
                  toastr.error('Hiba fájlfeltöltés közben!');
                });
            }
            // end
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
            defer.resolve();
          });
        return defer.promise;
      };

      var customExpressionProperties = {
        Premises: {
          'templateOptions.disabled': function() {
            return vm.isReadOnly || !vm.dataModel.Property || vm.dataModel.Property.Value === null;
          },
        },
        RoomInventoryId: {
          'templateOptions.disabled': function() {
            return vm.isReadOnly || !vm.dataModel.Property || !vm.dataModel.Property.Value;
          },
        },
      };

      vm.updateFieldParameters = function() {
        if (!!vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options) {
          vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseWhereCondition;
        }
      };

      var onChangeFunctions = {
        Tenement: function(selectedItem) {
          setAddress(selectedItem);
          if (!!selectedItem && selectedItem.Value && selectedItem.GridItem) {
            vm.dataModel.Zone = selectedItem.GridItem.ZoneId;
            vm.dataModel.OpUnit = selectedItem.GridItem.OpUnitId;
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
              selectedItem.GridItem.ConPropertyId
            );
          }
          if (!!selectedItem.GridItem || (!!selectedItem.GridItem && !selectedItem.Value)) {
            resetPremiseF4();
            resetRoomInventoryF4();
          }
          if (!!selectedItem && !!selectedItem.Value) {
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.disabled = true;
          } else {
            vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.disabled = vm.isReadOnly;
          }
        },
        Zone: function(selectedItem) {
          vm.pageModel.Fields.OpUnit.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
            id: selectedItem.key,
          };
          vm.pageModel.Fields.OpUnit.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        OpUnit: function(selectedItem) {
          if (selectedItem.key !== null || selectedItem.key !== '') {
            $http.post('HelpDesk/GetZoneFromOp', { id: parseInt(selectedItem.key, 10) }).then(function(response) {
              console.log('Resp: ' + response);
              vm.dataModel.Zone = response.data.Value;
            });
          }
        },
        Property: function(selectedItem) {
          setAddress(selectedItem);
          if (selectedItem.Value !== null || selectedItem.Value !== '') {
            $http
              .post('HelpDesk/GetZoneFromProperty', { id: parseInt(selectedItem.Value, 10) })
              .then(function(response) {
                // console.log('Resp: ' + response);
                vm.dataModel.Zone = response.data.Value;
              });
            $http
              .post('HelpDesk/GetOpUnitFromProperty', { id: parseInt(selectedItem.Value, 10) })
              .then(function(response) {
                // console.log('Resp: ' + response);
                vm.dataModel.OpUnit = response.data.Value;
              });
          }
          //vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseWhereCondition;
          if (!!selectedItem.GridItem || (selectedItem.GridItem == null && selectedItem.Value == null)) {
            resetPremiseF4();
            resetRoomInventoryF4();
          }
        },
        Premises: function(selectedItem) {
          var premiseCodes = this.options?.f4scope?.multiselectSelectedItems?.map(x => x.PremiseCode)?.join(',');
          if (premiseCodes) {
            vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Filter(
              {
                field: 'PremiseCode',
                operator: 'eq',
                value: premiseCodes,
              },
              true
            );
          } else {
            vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Filter(
              {},
              true
            );
          }
        },
      };

      var onBlurFunctions = {};
      var syncValidators = {
        OwnerEmail: {
          email: function(modelValue) {
            if (modelValue == '' || !modelValue) return true;
            return sysEmailValidate(modelValue);
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.updateFieldParameters();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.dataModel.CurrentUrl = window.location.href;

        var eventHandlers = {
          Files: {
            onComplete: function(e) {
              console.log('File upload completed. ' + e);
            },
            onError: function(e) {
              console.log('File upload error. ' + e);
            },
            onSuccess: function(e) {
              console.log('File upload success. ' + e);
              if (e.response) {
                if (e.response.ResultStatus) {
                  if (e.operation === 'upload') {
                    //Csak akkor vegye át a fájlnevet, ha az üres
                    if (!vm.dataModel.Name || vm.dataModel.Name.trim() == '')
                      vm.dataModel.Name = e.response.FileIdentifiers[0].OriginalName.replace(/\.[^.$]+$/, '');
                    $scope.$applyAsync();
                    if (!vm.dataModel.UploadedFiles) {
                      vm.dataModel.UploadedFiles = e.response.FileIdentifiers;
                    } else {
                      angular.forEach(e.response.FileIdentifiers, function(value) {
                        vm.dataModel.UploadedFiles.push({
                          StoredName: value.StoredName,
                          OriginalName: value.OriginalName,
                        });
                      });
                    }
                  } else if (e.operation === 'remove') {
                    if (vm.dataModel.UploadedFiles) {
                      var forDelete = [];
                      angular.forEach(e.response.FileIdentifiers, function(value) {
                        forDelete.push(value);
                      });
                      for (var i = 0; i < forDelete.length; i++) {
                        for (var j = 0; j < vm.dataModel.UploadedFiles.length; j++) {
                          if (forDelete[i].StoredName === vm.dataModel.UploadedFiles[j].StoredName) {
                            vm.dataModel.UploadedFiles.splice(j, 1);
                          }
                        }
                      }
                    }
                  }
                }
              }
            },
            onRemoveFileFromDb: function(file) {
              //if (file) {
              //    var sf = lodash.findLast(vm.formModel.StoredFiles, function (sf) { return sf.DocFilesId === file.storedDoc.DocFilesId; });
              //    sf.ToRemove = true;
              //}
            },
          },
        };
        InsertEventHandlers(vm.pageModel, eventHandlers);
        vm.generateFormly = function() {
          generateForm(vm);
          vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/FilteredGridDataByUserRole';
          vm.pageModel.Fields.Tenement.FormlyFieldDescriptor.templateOptions.options.whereCondition = tenementWhereCondition;
          vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
            'HelpDesk/FilteredGridDataByUserRole';
          vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.whereCondition = propertyWhereCondition;
          vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.options.whereCondition = premiseWhereCondition;
        };
        if (
          !$stateParams.controllerOptions?.waitFormGenerate ||
          $stateParams.controllerOptions?.isFormReadOnly ||
          vm.dataModel.IsReadOnly
        ) {
          vm.generateFormly(false);
        }
        vm.controllerOptions = $stateParams.controllerOptions;
        vm.isReadOnly = vm.controllerOptions.isFormReadOnly || vm.dataModel.IsReadOnly;
        // Set editability of fields based on controllerOptions
        if (vm.isReadOnly) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }

        vm.attachDocument = function attachDocument() {
          dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicket', vm.dataModel.TicketId);
        };

        vm.statusCode = model.statusCode;
      }

      function generateWorksheet(sheetId) {
        $http
          .post('HelpDesk/GenerateWorksheetByReportId', { ticketId: vm.dataModel.TicketId, reportId: sheetId })
          .then(function(response) {
            if (response.data.ResultStatus) {
              var data = response.data;
              if (data.ResultStatus) {
                var raw = atob(data.File);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
                }

                var fs = new Blob([array], { type: data.MimeType });
                saveAs(fs, decodeURIComponent(data.FileName));

                toastr.success('Sikeres generálás!');
              }
              toastr.success('Munkalap létrehozva!');
            } else {
              toastr.error(response.data.Errors[0].Message);
            }
          });
      }

      function setAddress(selectedItem) {
        if (!!selectedItem && selectedItem.Value && selectedItem.GridItem) {
          var gridItem = selectedItem.GridItem;
          vm.dataModel.Address =
            (gridItem.Country ? gridItem.Country : '') +
            (gridItem.PostCode ? gridItem.PostCode : '') +
            ' ' +
            (gridItem.Locality ? gridItem.Locality : '') +
            ' ' +
            (gridItem.Quarter ? gridItem.Quarter : '') +
            ', ' +
            (gridItem.Street ? gridItem.Street : '') +
            ' ' +
            (gridItem.StreetChar ? gridItem.StreetChar : '');
          //vm.dataModel.Address = gridItem.Country + ' ' + gridItem.PostCode + ' ' + gridItem.Locality + ' ' + gridItem.Quarter + ', ' + gridItem.Street + ' ' + gridItem.StreetChar;
          if (gridItem.StreetNumber) {
            vm.dataModel.Address +=
              ' ' +
              (gridItem.StreetNumber ? gridItem.StreetNumber : '') +
              ' ' +
              (gridItem.Building ? gridItem.Building : '') +
              ' ' +
              (gridItem.StairWay ? gridItem.StairWay : '') +
              ' ' +
              (gridItem.Floor ? gridItem.Floor : '') +
              ' ' +
              (gridItem.Door ? gridItem.Door : '');
            //vm.dataModel.Address += ' ' + gridItem.StreetNumber + ' ' + gridItem.Building + ' ' + gridItem.StairWay + ' ' + gridItem.Floor + ' ' + gridItem.Door;
          } else if (gridItem.TopogrNumber) {
            vm.dataModel.Address += ' ' + (gridItem.TopogrNumber ? gridItem.TopogrNumber : '');
            //vm.dataModel.Address += ' ' + gridItem.TopogrNumber;
          }
        }
      }

      function tenementWhereCondition() {
        var date = moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ');
        var whereCondition =
          "Level~eq~'PPRRU'~and~ValidFrom~lte~datetime'" +
          date +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          date +
          "')";
        return whereCondition;
      }

      function propertyWhereCondition() {
        var date = moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ');
        var whereCondition =
          "(Level~eq~'PPRBU'~or~Level~eq~'PPRED'~or~Level~eq~'PPRLA')" +
          "~and~ValidFrom~lte~datetime'" +
          date +
          "'~and~(ValidTo~isnull~or~ValidTo~gte~datetime'" +
          date +
          "')";

        if (vm.dataModel.Zone) {
          whereCondition += "~and~ZoneId~eq~'" + vm.dataModel.Zone + "'";
        }

        if (vm.dataModel.OpUnit) {
          whereCondition += "~and~OpUnitId~eq~'" + vm.dataModel.OpUnit + "'";
        }

        return whereCondition;
      }

      function premiseWhereCondition() {
        var date = moment(new Date()).format('YYYY-MM-DDTHH:mm:ssZ');
        var whereCondition = "(ValidTo~isnull~or~ValidTo~gte~datetime'" + date + "')";
        if (vm.dataModel.Tenement?.Value) {
          whereCondition +=
            "~and~RentUnitId~eq~'" + (vm.dataModel.Tenement.Value ? vm.dataModel.Tenement.Value : 0) + "'";
        } else if (vm.dataModel.Property?.Value) {
          whereCondition +=
            "~and~PropertyId~eq~'" + (vm.dataModel.Property.Value ? vm.dataModel.Property.Value : 0) + "'";
        }
        // if (!!vm.dataModel.Premises) {
        //   whereCondition += "~and~PremiseId~in~'" + vm.dataModel.Premises?.join(',') + "'";
        // }

        return whereCondition;
      }

      function resetPremiseF4() {
        vm.pageModel.Fields.Premises.FormlyFieldDescriptor.templateOptions.options.f4scope.resetModel();
      }
      function resetRoomInventoryF4() {
        vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.f4scope.resetModel();
        vm.pageModel.Fields.RoomInventoryId.FormlyFieldDescriptor.templateOptions.options.f4scope.setF4Filter({}, true);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskTenderEditCtrl', [
    '$rootScope',
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$timeout',
    '$window',
    '$uibModal',
    'DasService',
    'LockService',
    'gridService',
    function(
      $rootScope,
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      $timeout,
      $window,
      $uibModal,
      dasService,
      lockService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskTenderEditCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
        vm.tokenLogin = !!AuthService?.user?.tokenLogin;
        if (vm.tokenLogin) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            if (key !== 'Status' || !['HDNEM', 'HDNIP'].includes(vm.tenderStatus)) {
              value.FormlyFieldDescriptor.templateOptions.disabled = true;
            }
          });
        }
      });

      vm.showTenderTabButton = function() {
        return (
          (vm.dataModel.HasTenderRows ||
            vm.dataModel.TotalNetAmountCalc === undefined ||
            vm.dataModel.TotalNetAmountCalc === null) &&
          vm.dataModel.HDTEACParamValues.includes(vm.ticketStatus) &&
          vm.tokenLoginBtnShowFunc()
        );
      };

      vm.tokenLogin = !!AuthService?.user?.tokenLogin;
      vm.tokenLoginFunc = function() {
        return vm.tokenLogin;
      };
      vm.tokenLoginBtnShowFunc = function() {
        return ['HDNEM', 'HDNIP'].includes(vm.tenderStatus) || !vm.tokenLogin;
      };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      vm.CreateOrEdit = $stateParams.CreateOrEdit;

      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.backWithUnlock = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.back();
      };

      init();
      vm.save = function() {
        $http
          .post($stateParams.postUrl, vm.dataModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            if (!!response.data.InsertedId) {
              $state.go('HelpDesk.TenderEdit', { ticketId: vm.dataModel.TenderId, id: response.data.InsertedId });
            } else {
              let statusChanged = response.data.Status !== vm.tenderStatus;
              vm.dataModel.Status = response.data.Status || vm.tenderStatus;
              vm.Status = vm.dataModel.Status;
              vm.dataModel.LastMailDate = response.data.LastMailDate;
              if (statusChanged) {
                if (vm.tokenLogin) {
                  $state.go('HelpDesk.TenderEdit', { id: vm.dataModel.TenderId }, { reload: true });
                }
                vm.pageModel.Fields.Status.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              }
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      vm.getTotalAmount = function() {
        if (vm.dataModel.TenderId > 0) {
          $http
            .post('HelpDesk/GetTenderTotalNetAmount', { tenderId: vm.dataModel.TenderId })
            .then(function(response) {
              if (!!response.data.TenderTotalNetAmount) {
                vm.dataModel.TotalNetAmountCalc = response.data.TenderTotalNetAmount;
                vm.dataModel.HasTenderRows = true;
              } else {
                delete vm.dataModel.TotalNetAmountCalc;
                vm.dataModel.HasTenderRows = false;
              }
            })
            .catch(function(response) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            });
        }
      };
      if (vm.tokenLogin) {
        vm.originalSave = vm.save;
        vm.save = function() {
          if (vm.dataModel.Status === 'HDNIP') {
            var dialogMessage =
              'Amennyiben már végzett az árajánlat összeállításával, kérem állítsa Kész-re az árajánlat státuszát, majd nyomjon a mentés gombra.' +
              '<br>Kollégánk csak ezután fogja megkapni elbírálásra az ajánlatát.';
            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Confirm,
              buttons: {
                cancel: {
                  label: vm.pageModel.Actions['btnCancel'].Title,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.pageModel.Actions['btnOk'].Title,
                  className: 'btn-primary',
                  callback: function() {
                    vm.originalSave();
                  },
                },
              },
            });
          } else if (vm.dataModel.Status === 'HDNDO') {
            bootbox.confirm({
              message:
                'Biztosan rögzített minden munkát és anyagot az árajánlatához?<br>Kész státuszra állítás után az árajánlat módosítása nem lehetséges.',
              title: 'Jóváhagyás',
              buttons: {
                cancel: {
                  label: vm.pageModel.Messages['No'],
                  className: 'btn-default',
                },
                confirm: {
                  label: vm.pageModel.Messages['Yes'],
                  className: 'btn-primary',
                },
              },
              callback: function(result) {
                if (result) {
                  vm.originalSave();
                }
              },
            });
          } else {
            vm.originalSave();
          }
        };
      }
      function disableField(field) {
        if (vm.tokenLogin) {
          field.FormlyFieldDescriptor.templateOptions.disabled = true;
        }
      }

      vm.canUserApproveTender = model.canUserApproveTender;
      var customExpressionProperties = {
        IsApproved: {
          'templateOptions.disabled': function() {
            if (vm.tokenLogin) {
              return true;
            }
            return ['HDNDO', 'HDNAP'].indexOf(vm.tenderStatus) == -1;
          },
        },
        TotalNetAmountCalc: {
          'templateOptions.disabled': function() {
            return vm.dataModel.HasTenderRows;
          },
        },
        Status: {
          'templateOptions.disabled': function() {
            if (vm.tokenLogin) {
              return !['HDNEM', 'HDNIP'].includes(vm.tenderStatus);
            }
            return ['HDNNE', 'HDNAP', 'HDNOK'].indexOf(vm.tenderStatus) > -1;
          },
        },
        SupplierRefNumF22: {
          'templateOptions.disabled': function() {
            return vm.tokenLogin || !vm.dataModel.PartnerId || !vm.dataModel.PartnerId.Value;
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      var syncValidators = {
        ContactPersonEmail: {
          email: function(modelValue) {
            return !modelValue || sysEmailValidate(modelValue);
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidators);

      var onChangeFunctions = {
        Status: function(value) {
          if (vm.dataModel.Status == 'HDNAP') vm.dataModel.IsApproved = true;
        },

        IsApproved: function(value) {
          if (vm.dataModel.IsApproved) vm.dataModel.Status = 'HDNAP';
        },
        PartnerId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.Value && !!selectedItem.GridItem) {
            //Ha változott a partnerId töröljük a RefNumot:
            if (selectedItem.Value != vm.prevSelectedPartnerId) {
              vm.dataModel.SupplierRefNumF22 = { Value: null, Text: null };
            }

            $http
              .post('HelpDesk/GetValidPartLinks', { partnerTmId: selectedItem.GridItem.PartnerTMId })
              .then(function(response) {
                //partner elérhetőségei:
                if (!vm.dataModel.ContactPerson) {
                  let emailData = response.data.PartEmailList.find(item =>
                    item.extraProperties?.some(p => p.key === 'highlight' && p.value === '1')
                  );
                  if (emailData) {
                    vm.dataModel.ContactPerson = emailData?.extraProperties?.find(p => p.key === 'name')?.value;
                    vm.dataModel.ContactPersonEmail = emailData?.text;
                  }
                }
              })
              .catch(function() {});

            vm.prevSelectedPartnerId = selectedItem.Value;
          } else if (!!selectedItem && !selectedItem.Value) {
            //Ha üres a partnerId töröljük a RefNumot:
            vm.dataModel.SupplierRefNumF22 = { Value: null, Text: null };
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customCallbackFunctions = {
        IsApproved: function(value) {
          if (vm.dataModel.IsApproved) vm.dataModel.Status = 'HDNAP';
        },
      };

      InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

      vm.sendMailDisabled = function() {
        return (
          vm.dataModel.Status !== 'HDNNE' ||
          !vm.dataModel.ContactPersonEmail ||
          !sysEmailValidate(vm.dataModel.ContactPersonEmail)
        );
      };

      vm.getFilter = function() {
        return "TenderId~eq~'" + vm.dataModel.TenderId + "'";
      };

      vm.aggregates = [
        {
          field: 'totalPrice()',
          aggregate: 'sum',
          groupFooterTemplate: "<span style='float:right; padding:5px 0;'>Összesen: #= sum #</span>",
        },
      ];

      const totalColumn = {
        field: 'totalPrice()',
        title: 'Nettó összár',
        width: '120px',
        attributes: {
          style: 'text-align:right;',
        },
      };
      vm.GridTenderTaskIdField = vm.pageModel.Grids['GridTenderTask'].IdColumn;
      vm.GridTenderTaskOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign({}, vm.pageModel.Grids['GridTenderTask'], { ControllerMethod: 'Grid/Data' }),
        transportData: {
          tableName: vm.pageModel.Grids['GridTenderTask'].Table,
          whereCondition: vm.getFilter,
          adopter: vm.pageModel.Grids['GridTenderTask'].Adopter,
          installAdopter: vm.pageModel.Grids['GridTenderTask'].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids['GridTenderTask'].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids['GridTenderTask'].IdColumn,
        },
        groupable: true,
        group: { field: 'Currency', aggregates: angular.copy(vm.aggregates) },
        aggregate: angular.copy(vm.aggregates),
      });

      vm.GridTenderTaskOptions.dataSource.schema.model.totalPrice = calcRowTotal;
      vm.GridTenderTaskOptions.columns.push(totalColumn);

      vm.GridTenderMaterialIdField = vm.pageModel.Grids['GridTenderMaterial'].IdColumn;
      vm.GridTenderMaterialOptions = gridService.buildKendoConfigForGridModel({
        gridModel: Object.assign({}, vm.pageModel.Grids['GridTenderMaterial'], { ControllerMethod: 'Grid/Data' }),
        transportData: {
          tableName: vm.pageModel.Grids['GridTenderMaterial'].Table,
          whereCondition: vm.getFilter,
          adopter: vm.pageModel.Grids['GridTenderMaterial'].Adopter,
          installAdopter: vm.pageModel.Grids['GridTenderMaterial'].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids['GridTenderMaterial'].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids['GridTenderMaterial'].IdColumn,
        },
        groupable: true,
        group: { field: 'Currency', aggregates: angular.copy(vm.aggregates) },
        aggregate: angular.copy(vm.aggregates),
      });

      vm.GridTenderMaterialOptions.dataSource.schema.model.totalPrice = calcRowTotal;
      vm.GridTenderMaterialOptions.columns.push(totalColumn);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        generateForm(vm);
        if (vm.tokenLogin) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }
        vm.createTenderTask = createTenderTask;
        vm.editTenderTask = editTenderTask;
        vm.deleteTenderTask = deleteTenderTask;
        vm.createTenderMaterial = createTenderMaterial;
        vm.editTenderMaterial = editTenderMaterial;
        vm.deleteTenderMaterial = deleteTenderMaterial;
        vm.sendMail = sendMail;
        vm.ticketStatus = model.ticketStatus;
        vm.tenderStatus = angular.copy(vm.dataModel.Status);
        vm.attachDocument = attachDocument;

        var ddOptions = vm.pageModel.Fields.Status.FormlyFieldDescriptor.templateOptions.options;
        ddOptions.dataSource.transport.options.read.data = {
          tenderId: vm.dataModel.TenderId,
        };
        delete ddOptions.optionLabel;

        vm.pageModel.Fields.SupplierRefNumF22.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return !!vm.dataModel.PartnerId?.Value ? 'SupplierPartId~eq~' + vm.dataModel.PartnerId?.Value + '' : '';
        };
      }

      function calcRowTotal() {
        return this.get('UnitPrice') * this.get('Quantity');
      }

      function sendMail() {
        var dialogMessage = 'Biztosan elküldi az értesítő üzenetet az alábbi címre?';
        dialogMessage += '<br /><strong>' + vm.dataModel.ContactPersonEmail + '</strong>';
        bootbox.dialog({
          message: dialogMessage,
          title: 'Értesítő üzenet elküldése',
          buttons: {
            cancel: {
              label: vm.messages.Cancel,
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: vm.messages.Ok,
              className: 'btn-primary',
              callback: function() {
                $http.post('HelpDesk/TenderSendMail/', { model: vm.dataModel }).then(function(response) {
                  let statusChanged = response.data.Status !== vm.tenderStatus;
                  vm.dataModel.Status = response.data.Status || vm.tenderStatus;
                  vm.dataModel.LastMailDate = response.data.LastMailDate;
                  if (statusChanged) {
                    vm.pageModel.Fields.Status.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
                  }

                  toastr.success('Sikeres üzenetküldés!');
                });
              },
            },
          },
        });
      }

      function createTenderTask() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TenderTaskEdit.html',
          controller: 'TenderTaskEditCtrl as vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TenderTaskCreate/?tenderId=' + vm.dataModel.TenderId),
          },
        });

        modalInstance.result.then(function() {
          vm.GridTenderTask.dataSource.read();
          vm.getTotalAmount();
        });
      }

      function editTenderTask() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridTenderTask);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          id = selectedItems[0][vm.GridTenderTaskIdField];
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TenderTaskEdit.html',
            controller: 'TenderTaskEditCtrl as vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TenderTaskEdit/?id=' + id),
            },
          });

          modalInstance.result.then(function() {
            vm.GridTenderTask.dataSource.read();
            vm.getTotalAmount();
          });
        }
      }

      function deleteTenderTask() {
        var id = getSelectedRowId(vm.GridTenderTask, 'TenderTaskId');
        if (id === -1) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var dialogMessage = 'Biztos, hogy törli a kijelölt tételt?';
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.post('HelpDesk/TenderTaskDelete', { id: id, tenderId: vm.dataModel.TenderId }).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    vm.GridTenderTask.dataSource.read();
                    vm.getTotalAmount();
                  });
                },
              },
            },
          });
        }
      }

      function createTenderMaterial() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/HelpDesk/TenderMaterialEdit.html',
          controller: 'TenderMaterialEditCtrl as vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            model: RouteResolveFunc('HelpDesk/TenderMaterialCreate/?tenderId=' + vm.dataModel.TenderId),
          },
        });

        modalInstance.result.then(function() {
          vm.GridTenderMaterial.dataSource.read();
          vm.getTotalAmount();
        });
      }

      function editTenderMaterial() {
        var id;
        var selectedItems = GetSelectedGridItems(vm.GridTenderMaterial);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          id = selectedItems[0][vm.GridTenderMaterialIdField];
          var modalInstance = $uibModal.open({
            templateUrl: 'App/HelpDesk/TenderMaterialEdit.html',
            controller: 'TenderMaterialEditCtrl as vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              model: RouteResolveFunc('HelpDesk/TenderMaterialEdit/?id=' + id),
            },
          });

          modalInstance.result.then(function() {
            vm.GridTenderMaterial.dataSource.read();
            vm.getTotalAmount();
          });
        }
      }

      function deleteTenderMaterial() {
        var id = getSelectedRowId(vm.GridTenderMaterial, 'TenderMaterialId');
        if (id === -1) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var dialogMessage = 'Biztos, hogy törli a kijelölt tételt?';
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Confirm,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .post('HelpDesk/TenderMaterialDelete', { id: id, tenderId: vm.dataModel.TenderId })
                    .then(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.GridTenderMaterial.dataSource.read();
                      vm.getTotalAmount();
                    });
                },
              },
            },
          });
        }
      }

      function attachDocument() {
        var id = vm.dataModel.TenderId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTender', id);
      }

      function initGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

        if (vm.pageModel.Grids[gridName].Table) {
          readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.pageModel.Grids[gridName].Table,
            whereCondition: whereCondition,
            adopter: vm.pageModel.Grids[gridName].Adopter,
            installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids[gridName].IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#' + mainGrid).data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketMessageCreateCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketMessageCreateCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.isCreate = vm.formModel.TicketMessageId === 0;

      if (vm.isCreate) {
        vm.title = vm.pageModel.Labels['LabelTitle_New'].Title;
      } else {
        vm.title = vm.pageModel.Labels['LabelTitle_View'].Title;
      }

      /////////////////////////////// [ Formly Modifiers ] ///////////////////////////////////

      var hideExpressions = {
        ModUserName: function() {
          return vm.isCreate;
        },
        ModDateTime: function() {
          return vm.isCreate;
        },
        HelpDeskStatusName: function() {
          return vm.isCreate;
        },
      };
      var customExpressionProperties = {
        ModUserName: {
          'templateOptions.disabled': 'true',
        },
        ModDateTime: {
          'templateOptions.disabled': 'true',
        },
        HelpDeskStatusName: {
          'templateOptions.disabled': 'true',
        },
        Message: {
          'templateOptions.disabled': function() {
            return !vm.isCreate;
          },
        },
      };

      //////////////// [ Insert static validators / formatters / parsers ] ///////////////////
      // These must be run before generating formly descriptors from general field descriptors

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      ////////////////////////////////////////////////////////////////////////////////////////

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        $http
          .post('HelpDesk/TicketMessageCreate', vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketSuspensionEditCtrl', [
    '$uibModalInstance',
    '$http',
    'model',
    'params',
    '$stateParams',
    'AuthService',
    'DasService',
    'LockService',
    function(mi, $http, model, params, $stateParams, AuthService, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketSuspensionEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = model.pageModel;
      vm.pageModel.Fields.ValidFrom.FormlyFieldDescriptor.templateOptions.DateTimeOptions.customEdit = true;
      vm.pageModel.Fields.ValidTo.FormlyFieldDescriptor.templateOptions.DateTimeOptions.customEdit = true;
      vm.formModel = model.dto;
      vm.ticketDto = params.ticketDto;
      vm.type = params.type;
      if (vm.type === 'new') {
        vm.formModel.TicketId = vm.ticketDto.TicketId;
        vm.formModel.HelpDeskStatusId = vm.ticketDto.HelpDeskStatusId;
      }
      vm.messages = model.pageModel.Messages;
      vm.isCreate = vm.formModel.TicketMessageId === 0;

      if (vm.type === 'new') {
        vm.title = vm.pageModel.Labels['LabelTitle_New'].Title;
      } else {
        vm.title = vm.pageModel.Labels['LabelTitle_Edit'].Title;
      }

      var customExpressionProperties = {
        ValidTo: {
          'templateOptions.required': function() {
            return vm.formModel.TicketSuspensionId > 0;
          },
        },
      };

      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.save = function() {
        let url = vm.type === 'new' ? 'HelpDesk/TicketSuspensionCreate' : 'HelpDesk/TicketSuspensionEdit';
        $http
          .post(url, vm.formModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            mi.close({ response: response, dto: vm.formModel });
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };
      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketTaskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketTaskEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      var syncValidator = {
        StartDateTime: {
          StartDateTimeValidator: function(modelValue) {
            if (
              vm.dataModel.TicketStatusCode == 'HDSTD' &&
              !!vm.dataModel.EndDateTime &&
              !!modelValue &&
              new Date(vm.dataModel.EndDateTime) < new Date(modelValue)
            ) {
              return false;
            }
            return true;
          },
        },
        EndDateTime: {
          EndDateTimeValidator: function(modelValue) {
            if (
              vm.dataModel.TicketStatusCode == 'HDSTD' &&
              !!vm.dataModel.StartDateTime &&
              !!modelValue &&
              new Date(vm.dataModel.StartDateTime) > new Date(modelValue)
            ) {
              return false;
            }
            return true;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidator);

      var onChangeFunctions = {
        TaskId: function(selectedItem) {
          if (selectedItem && !!selectedItem.GridItem && selectedItem.Value > 0) {
            // FrequencyId
            setFrequencyListOptions(selectedItem.Value);

            vm.dataModel.UnitName = selectedItem.GridItem.UnitName;
            vm.dataModel.Description = selectedItem.GridItem.Description;
            vm.dataModel.StandardTime = selectedItem.GridItem.StandardTime;

            // UnitPrice, CurrencyId
            // getUnitPrice(selectedItem.Value, vm.dataModel.FrequencyId, vm.dataModel.UnitPriceCollectionId.Value);
          }
        },
        PartnerId: function(selectedItem) {
          if (selectedItem && selectedItem.Value > 0) {
            if (vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.f4scope.gridLeft) {
              vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.f4scope.gridLeft.dataSource.read();
            }
          }
        },
        Quantity: function() {
          sumNetPrice();
        },
        FrequencyId: function(selectedItem) {
          getUnitPrice(vm.dataModel.TaskId.Value, selectedItem.key, vm.dataModel.UnitPriceCollectionId.Value);
        },
        UnitPriceCollectionId: function(selectedItem) {
          if (!!selectedItem.GridItem) {
            getUnitPrice(vm.dataModel.TaskId.Value, vm.dataModel.FrequencyId, selectedItem.Value);
          }
        },
        Currency: function(selectedItem) {
          sumNetPrice();
          setNetCurrency(selectedItem.key);
        },
        UnitPrice: function() {
          sumNetPrice();
        },
        StartDateTime: function(selectedItem) {
          vm.pageModel.Fields.EndDateTime.FormlyFieldDescriptor.formControl.$validate();
        },
        EndDateTime: function(selectedItem) {
          vm.pageModel.Fields.StartDateTime.FormlyFieldDescriptor.formControl.$validate();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var customExpressionProperties = {
        UnitPriceCollectionId: {
          'templateOptions.disabled': function() {
            return (
              !(vm.dataModel.TaskId && vm.dataModel.TaskId.Value > 0) ||
              (vm.dataModel.CodeId == 'HDSPL' && vm.dataModel.TicketStatusCode != 'HDSPL')
            );
          },
        },
        FrequencyId: {
          'templateOptions.disabled': function() {
            return (
              !(vm.dataModel.TaskId && vm.dataModel.TaskId.Value > 0) ||
              (vm.dataModel.CodeId == 'HDSPL' && vm.dataModel.TicketStatusCode != 'HDSPL')
            );
          },
        },
        UnitPrice: {
          'templateOptions.disabled': function() {
            return vm.dataModel.UnitPriceCollectionId && vm.dataModel.UnitPriceCollectionId.Value > 0;
          },
        },
        Currency: {
          'templateOptions.disabled': function() {
            return vm.dataModel.UnitPriceCollectionId && vm.dataModel.UnitPriceCollectionId.Value > 0;
          },
          'templateOptions.required': function() {
            // Csak felületen követeljük meg a kötelezőséget, dto szinten nem. Ennek a munakalap generálás során keletkező feladatoknál van jelentősége.
            return true;
          },
        },
        CustomerPrice: {
          'templateOptions.disabled': function() {
            return vm.dataModel.UnitPriceCollectionId && vm.dataModel.UnitPriceCollectionId.Value > 0;
          },
        },
        StartDateTime: {
          'templateOptions.required': function() {
            // Csak végrahajtási státuszban és csak szerkesztéskor
            return vm.dataModel.TicketStatusCode === 'HDSTD' && vm.dataModel.ModelState === 3;
          },
        },
        EndDateTime: {
          'templateOptions.required': function() {
            // Csak végrahajtási státuszban és csak szerkesztéskor
            return vm.dataModel.TicketStatusCode === 'HDSTD' && vm.dataModel.ModelState === 3;
          },
        },
        TaskId: {
          'templateOptions.disabled': function() {
            return vm.dataModel.CodeId == 'HDSPL' && vm.dataModel.TicketStatusCode != 'HDSPL';
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var customTypes = {
          StandardTime: 'maskedInput',
        };

        var inputMasks = {
          StandardTime: '(99) óra (99) perc',
        };

        InsertInputMasks(vm.pageModel, inputMasks);
        InsertCustomTypes(vm.pageModel, customTypes);

        var dynamicQueryParameters = {
          SupplyContrId: function() {
            return [
              {
                value: vm.dataModel.PartnerId.Value,
                key: 'PartnerId',
              },
            ];
          },
        };
        InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

        generateForm(vm);
        setFrequencyListOptions(vm.dataModel.TaskId?.Value);
        vm.cancel = cancel;
        vm.save = save;

        vm.pageModel.Fields.TaskId.FormlyFieldDescriptor.templateOptions.options.whereCondition = taskIdWhereCondition;
        vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.whereCondition = solverWhereCondition;

        //vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.gridOptions.customControllerMethod =
        //  'HelpDesk/UnitPriceCollectionGridData';
        vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.whereCondition = unitPriceCollectionIdWhereCondition;
      }

      function save() {
        $http.post('HelpDesk/TicketTaskEdit', vm.dataModel).then(
          function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
            $state.go('HelpDesk.TicketEdit', {
              ticketId: vm.dataModel.TicketId,
            });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      function taskIdWhereCondition() {
        return "HelpDesk~eq~'1'";
      }

      function solverWhereCondition() {
        return (
          "OrgPartId~eq~'" +
          (vm.dataModel.PartnerId.Value ? vm.dataModel.PartnerId.Value : 0) +
          "'~and~ParameterId~contains~' HDEXEC'"
        );
      }

      function unitPriceCollectionIdWhereCondition() {
        //return vm.dataModel.TaskId ? vm.dataModel.TaskId.Value : '';
        return vm.dataModel.TaskId ? 'TaskId~eq~' + vm.dataModel.TaskId.Value : '';
      }

      function getUnitPrice(taskId, frequencyId, unitPriceCollectionId) {
        $http
          .get(
            'HelpDesk/GetUnitPrice?taskId=' +
              taskId +
              '&frequencyId=' +
              frequencyId +
              '&unitPriceCollectionId=' +
              unitPriceCollectionId
          )
          .then(function(response) {
            if (response.data.ResultStatus) {
              vm.dataModel.UnitPrice = response.data.Dto.Price;
              vm.dataModel.CustomerPrice = response.data.Dto.Price;
              vm.dataModel.Currency = response.data.Dto.CurrencyName;
              vm.dataModel.NetCurrency = response.data.Dto.CurrencyName;

              if (!vm.dataModel.PartnerId || !vm.dataModel.PartnerId.Value) {
                vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
                  response.data.Dto.PartnerId
                );
              }
            } else {
              vm.dataModel.UnitPrice = 0;
              vm.dataModel.CustomerPrice = 0;
              vm.dataModel.Currency = null;
              vm.dataModel.NetCurrency = null;
              if (!vm.dataModel.PartnerId || !vm.dataModel.PartnerId.Value) {
                vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(null);
              }
            }
            sumNetPrice();
          });
      }

      function sumNetPrice() {
        vm.dataModel.Net = vm.dataModel.UnitPrice * vm.dataModel.Quantity;
      }

      function setNetCurrency(netCurrencyId) {
        vm.dataModel.NetCurrency = netCurrencyId;
      }

      function setFrequencyListOptions(taskId) {
        vm.pageModel.Fields.FrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          taskId: taskId,
        };
        vm.pageModel.Fields.FrequencyId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TicketTaskId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicketTask', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketCustomTaskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketCustomTaskEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();
      var syncValidator = {
        StartDateTime: {
          StartDateTimeValidator: function(modelValue) {
            if (
              vm.dataModel.TicketStatusCode == 'HDSTD' &&
              !!vm.dataModel.EndDateTime &&
              !!modelValue &&
              new Date(vm.dataModel.EndDateTime) < new Date(modelValue)
            ) {
              return false;
            }
            return true;
          },
        },
        EndDateTime: {
          EndDateTimeValidator: function(modelValue) {
            if (
              vm.dataModel.TicketStatusCode == 'HDSTD' &&
              !!vm.dataModel.StartDateTime &&
              !!modelValue &&
              new Date(vm.dataModel.StartDateTime) > new Date(modelValue)
            ) {
              return false;
            }
            return true;
          },
        },
      };
      InsertSyncValidators(vm.pageModel, syncValidator);

      var onBlurFunctions = {
        CurrencyId: function(selectedItem) {
          vm.dataModel.NetCurrency = selectedItem;
        },
        PartnerId: function(selectedItem) {
          if (selectedItem && selectedItem.Value > 0) {
            if (vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.f4scope.gridLeft) {
              vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.f4scope.gridLeft.dataSource.read();
            }
          }
        },
      };
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var customExpressionProperties = {
        StartDateTime: {
          'templateOptions.required': function() {
            // Csak végrahajtási státuszban és csak szerkesztéskor
            return vm.dataModel.TicketStatusCode === 'HDSTD' && vm.dataModel.ModelState === 3;
          },
        },
        EndDateTime: {
          'templateOptions.required': function() {
            // Csak végrahajtási státuszban és csak szerkesztéskor
            return vm.dataModel.TicketStatusCode === 'HDSTD' && vm.dataModel.ModelState === 3;
          },
        },
      };
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      var onChangeFunctions = {
        Quantity: function() {
          sumNetPrice();
        },
        UnitPrice: function() {
          sumNetPrice();
        },
        StartDateTime: function(selectedItem) {
          vm.pageModel.Fields.EndDateTime.FormlyFieldDescriptor.formControl.$validate();
        },
        EndDateTime: function(selectedItem) {
          vm.pageModel.Fields.StartDateTime.FormlyFieldDescriptor.formControl.$validate();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var customTypes = {
          StandardTime: 'maskedInput',
        };

        var inputMasks = {
          StandardTime: '(99) óra (99) perc',
        };

        InsertInputMasks(vm.pageModel, inputMasks);
        InsertCustomTypes(vm.pageModel, customTypes);

        var dynamicQueryParameters = {
          SupplyContrId: function() {
            return [
              {
                value: vm.dataModel.PartnerId.Value,
                key: 'PartnerId',
              },
            ];
          },
        };
        InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

        generateForm(vm);

        vm.cancel = cancel;
        vm.save = save;

        vm.pageModel.Fields.Solver.FormlyFieldDescriptor.templateOptions.options.whereCondition = solverWhereCondition;
      }

      function save() {
        $http.post('HelpDesk/TicketCustomTaskEdit', vm.dataModel).then(
          function() {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
            $state.go('HelpDesk.TicketEdit', {
              ticketId: vm.dataModel.TicketId,
            });
          },
          function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      function solverWhereCondition() {
        return (
          "OrgPartId~eq~'" +
          (vm.dataModel.PartnerId.Value ? vm.dataModel.PartnerId.Value : 0) +
          "'~and~ParameterId~contains~' HDEXEC'"
        );
      }

      function sumNetPrice() {
        vm.dataModel.Net = vm.dataModel.UnitPrice * vm.dataModel.Quantity;
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TicketCustomTaskId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicketCustomTask', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TenderTaskEditCtrl', [
    '$rootScope',
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function(
      $rootScope,
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenderTaskEditCtrl', stateParams);
      }
      var vm = this;
      $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
        vm.tokenLogin = !!AuthService?.user?.tokenLogin;
      });
      vm.tokenLogin = !!AuthService?.user?.tokenLogin;
      vm.tokenLoginFunc = function() {
        return vm.tokenLogin;
      };
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.title =
          vm.dataModel.ModelState == 2
            ? vm.pageModel.Labels['LabelTitleCreate'].Title
            : vm.pageModel.Labels['LabelTitle'].Title;

        generateForm(vm);

        vm.cancel = cancel;
        vm.save = save;
      }

      function save() {
        $http.post('HelpDesk/TenderTaskEdit', vm.dataModel).then(
          function(response) {
            toastr.warning(vm.pageModel.Labels['LabelWarningToSave'].Title);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TenderTaskId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTenderTask', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TenderMaterialEditCtrl', [
    '$rootScope',
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function(
      $rootScope,
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TenderMaterialEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);
      $rootScope.$on('AuthService:setLocalUserContextSuccess', function() {
        vm.tokenLogin = !!AuthService?.user?.tokenLogin;
      });
      vm.tokenLogin = !!AuthService?.user?.tokenLogin;
      vm.tokenLoginFunc = function() {
        return vm.tokenLogin;
      };
      init();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.title =
          vm.dataModel.ModelState == 2
            ? vm.pageModel.Labels['LabelTitleCreate'].Title
            : vm.pageModel.Labels['LabelTitle'].Title;

        generateForm(vm);

        vm.cancel = cancel;
        vm.save = save;
      }

      function save() {
        $http.post('HelpDesk/TenderMaterialEdit', vm.dataModel).then(
          function(response) {
            toastr.warning(vm.pageModel.Labels['LabelWarningToSave'].Title);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TenderMaterialId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTenderMaterial', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketCustomMaterialEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketCustomMaterialEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      var onBlurFunctions = {
        CurrencyId: function(selectedItem) {
          vm.dataModel.NetCurrency = selectedItem;
        },
      };
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var onChangeFunctions = {
        Quantity: function() {
          sumNetPrice();
        },
        UnitPrice: function() {
          sumNetPrice();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        generateForm(vm);

        vm.cancel = cancel;
        vm.save = save;
      }

      function save() {
        $http.post('HelpDesk/TicketCustomMaterialEdit', vm.dataModel).then(
          function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
            $state.go('HelpDesk.TicketEdit', {
              ticketId: vm.dataModel.TicketId,
            });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      function sumNetPrice() {
        vm.dataModel.Net = vm.dataModel.UnitPrice * vm.dataModel.Quantity;
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TicketCustomMaterialId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicketCustomMaterial', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketMaterialEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketMaterialEditCtrl', stateParams);
      }
      var vm = this;

      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      init();

      var onBlurFunctions = {
        CurrencyId: function(selectedItem) {
          vm.dataModel.NetCurrency = selectedItem;
        },
      };
      //InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      var onChangeFunctions = {
        MaterialId: function(selectedItem) {
          vm.dataModel.AvailableQuantity = selectedItem.GridItem.Quantity;
          vm.dataModel.UnitId = selectedItem.GridItem.UnitId;
          vm.dataModel.CurrencyId = selectedItem.GridItem.CurrencyId;
          vm.dataModel.UnitPrice = selectedItem.GridItem.UnitPrice;
          vm.dataModel.CustomerPrice = selectedItem.GridItem.CustomerPrice;
          vm.dataModel.DepName = selectedItem.GridItem.DepName;
          vm.dataModel.Name = selectedItem.GridItem.Name;
          //vm.dataModel.DepositoryId = {Value: selectedItem.GridItem.DepositoryId, Text: selectedItem.GridItem.DepCode};
          vm.pageModel.Fields.DepositoryId.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(
            selectedItem.GridItem.DepositoryId
          );
          sumNetPrice();
          if (vm.pageModel.Fields.AvailableQuantity.FormlyFieldDescriptor.formControl) {
            vm.pageModel.Fields.AvailableQuantity.FormlyFieldDescriptor.formControl.$validate();
          }
        },
        RequestedQuantity: function() {
          sumNetPrice();
        },
      };
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      var syncValidators = {
        RequestedQuantity: {
          MaterialRequestedQuantityValidator: function(modelValue, viewValue) {
            return modelValue <= vm.dataModel.AvailableQuantity;
          },
        },
      };

      InsertSyncValidators(vm.pageModel, syncValidators);

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        if (!!vm.dataModel.VoucherId && vm.dataModel.VoucherId.Value > 0) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }

        generateForm(vm);

        var whereConditionMaterial = function() {
          if (!!vm.dataModel.DepositoryId && vm.dataModel.DepositoryId.Value > 0) {
            return "DepositoryId~eq~'" + vm.dataModel.DepositoryId.Value + "'";
          }
          return '';
        };
        vm.pageModel.Fields.MaterialId.FormlyFieldDescriptor.templateOptions.options.whereCondition = whereConditionMaterial;

        vm.cancel = cancel;
        vm.save = save;
      }

      function save() {
        $http.post('HelpDesk/TicketMaterialEdit', vm.dataModel).then(
          function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
            $state.go('HelpDesk.TicketEdit', {
              ticketId: vm.dataModel.TicketId,
            });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }

      function sumNetPrice() {
        vm.dataModel.SumPrice = vm.dataModel.UnitPrice * vm.dataModel.RequestedQuantity;
      }

      vm.attachDocument = function() {
        var id = vm.dataModel.TicketMaterialId;
        dasService.NavigateToDas(vm.messages, 'HelpDesk.DasDocumentsNav', 'FlgTicketMaterial', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketDescriptionsModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    'gridService',
    function($scope, $http, $state, $stateParams, model, uibModalInstance) {
      var vm = this;
      vm.cancel = cancel;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('NotificationMailCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'NotificationMailCtrl', stateParams);
      }
      var vm = this;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        generateForm(vm);

        vm.cancel = cancel;
        vm.send = send;
      }

      function send() {
        var Indata = { dto: vm.dataModel, ticketId: $stateParams.id };
        if (!vm.dataModel.UserMail) {
          toastr.warning('Ön nem fog másolatot kapni, ugyanis felhasználójának nincs beállítva email címe.');
        }
        $http.post('HelpDesk/NotificationMail', Indata).then(
          function() {
            toastr.success('Értesítés(ek) kiküldve!');
            uibModalInstance.close();
            $state.reload();
          },
          function() {
            toastr.error('Értesítés(ek) küldése sikertelen!');
          }
        );
      }

      function cancel() {
        uibModalInstance.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskCustomFilterModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    function($scope, $http, $state, $stateParams, model, mi) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskCustomFilterModalCtrl', stateParams);
      }
      var vm = this;
      vm.isFilter = model.dto.isFilter;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.save = function() {
        $http({
          url: 'HelpDesk/SaveCustomFilter',
          method: 'POST',
          data: { dto: vm.dataModel },
        }).then(function(response) {
          toastr.success('Sikeres mentés');
          mi.close(response.data.Value);
        });
      };

      vm.search = function() {
        mi.close(angular.copy(vm.dataModel));
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        generateForm(vm);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskHistoryModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    'gridService',
    function($scope, $http, $state, $stateParams, model, mi, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskHistoryModalCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        vm.mainGridIdField = vm.pageModel.Grids['GridHistory'].IdColumn;
        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: vm.pageModel.Grids['GridHistory'],
          transportData: {
            tableName: vm.pageModel.Grids['GridHistory'].Table,
            whereCondition: "TicketId~eq~'" + vm.dataModel.TicketId + "'",
            adopter: vm.pageModel.Grids['GridHistory'].Adopter,
            installAdopter: vm.pageModel.Grids['GridHistory'].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids['GridHistory'].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids['GridHistory'].IdColumn,
          },
          groupable: true,
          group: { field: 'Currency', aggregates: angular.copy(vm.GridFeladatokAggregates) },
          aggregate: angular.copy(vm.GridFeladatokAggregates),
        });
        vm.mainGridOptions.autoBind = true;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('PreGenerateInvoiceModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'PreGenerateInvoiceModalCtrl', stateParams);
      }
      var vm = this;
      vm.generate = generate;
      vm.cancel = cancel;
      init();

      vm.pageModel.Fields.InvoicingType.FormlyFieldDescriptor.templateOptions.onClick = function() {
        if (vm.dataModel.InvoicingType === 1) {
          vm.pageModel.Fields.WorkSheet.FormlyFieldDescriptor.templateOptions.disabled = true;
          vm.dataModel.WorkSheet.Text = '';
          vm.dataModel.WorkSheet.Value = '';
        } else {
          vm.pageModel.Fields.WorkSheet.FormlyFieldDescriptor.templateOptions.disabled = false;
        }
      };

      vm.pageModel.Fields.WorkSheet.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "InvoiceId~eq~'0'~and~IsCompleted~eq~'1'";
      };

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);
      }

      function generate() {
        if (vm.dataModel.InvoicingType === 0 && !(vm.dataModel.WorkSheet.Value > 0)) {
          toastr.error('Kötelező mező: Számlázandó munkalap');
        } else {
          uibModalInstance.close(vm.dataModel);
        }
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('GenerateMassInvoiceModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'GenerateMassInvoiceModalCtrl', stateParams);
      }
      var vm = this;
      vm.generate = generate;
      vm.cancel = cancel;
      init();

      vm.gridTicketFilter = function() {
        if (
          !vm.dataModel.PaymentMode ||
          !vm.dataModel.CertDateTime ||
          !vm.dataModel.PartnerId.Value ||
          !vm.dataModel.PropertyId
        ) {
          return "PropertyId~eq~'-1'";
        } else {
          var dateString = moment(new Date(vm.dataModel.CertDateTime)).format('YYYY-MM-DDTHH:mm:ss');
          var dateStringFrom = moment(new Date(vm.dataModel.CertDateTimeFrom)).format('YYYY-MM-DDTHH:mm:ss');
          if (!vm.dataModel.CertDateTimeFrom) {
            return (
              "PaymentMode~eq~'" +
              vm.dataModel.PaymentMode +
              "'~and~CertDateTime~lte~'" +
              dateString +
              "'~and~PartnerId~eq~'" +
              vm.dataModel.PartnerId.Value +
              "'~and~PropertyId~in~'" +
              vm.dataModel.PropertyId +
              "'~and~InvoiceId~eq~0"
            );
          } else {
            return (
              "PaymentMode~eq~'" +
              vm.dataModel.PaymentMode +
              "'~and~CertDateTime~gte~'" +
              dateStringFrom +
              "'~and~CertDateTime~lte~'" +
              dateString +
              "'~and~PartnerId~eq~'" +
              vm.dataModel.PartnerId.Value +
              "'~and~PropertyId~in~'" +
              vm.dataModel.PropertyId +
              "'~and~InvoiceId~eq~0"
            );
          }
        }
      };

      var checkBoxColumn = {
        headerTemplate: '<a class="k-link" href="#">Számlázandó</a>',
        selectable: 'multiple',
        width: '90px',
        attributes: {
          style: 'text-align: right; padding-left: 50px',
        },
      };

      vm.pageModel.Grids['GridTicket'].Columns.unshift(checkBoxColumn);

      // GridTicket
      initMainGrid(
        vm,
        'GridTicket',
        'Grid/Data', // readUrl
        function() {
          // select function
        },
        null,
        false,
        vm.gridTicketFilter,
        false
      );

      vm.mainGridOptions.selectable = 'multiple, row';
      vm.mainGridOptions.persistSelection = true;

      var onChangeFunctions = {
        CertDateTimeFrom: function() {
          vm.mainGrid.dataSource.read();
        },
        CertDateTime: function() {
          vm.mainGrid.dataSource.read();
        },
        PropertyId: function() {
          vm.mainGrid.dataSource.read();
        },
      };
      var customExpressionProperties = {
        SelectAll: {
          'templateOptions.disabled': function() {
            return vm.dataModel.PropertyId === null;
          },
        },
      };
      var onBlurFunctions = {
        PaymentMode: function() {
          vm.mainGrid.dataSource.read();
        },
        PartnerId: function() {
          vm.mainGrid.dataSource.read();
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);

      vm.pageModel.Fields.PropertyId.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Level~eq~'PPRBU'";
      };

      vm.mainGridOptions.change = function() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 1) {
          vm.dataModel.OwnerName = selectedItems[0].OwnerName;
          vm.dataModel.CreateDateTime = selectedItems[0].CreateDateTime;
          vm.dataModel.Deadline = selectedItems[0].Deadline;
          vm.dataModel.ApproverName = selectedItems[0].ApproverName;
          vm.dataModel.ApprDateTime = selectedItems[0].ApprDateTime;
          vm.dataModel.Subject = selectedItems[0].Subject;
          vm.dataModel.Description = selectedItems[0].Description;
          vm.dataModel.WorkDescription = selectedItems[0].WorkDescription;
        }
      };

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);
        vm.dataModel.SelectAll = false;
      }

      function generate() {
        var selectedIds = [];

        $('input:checked')
          .closest('tr')
          .each(function() {
            if (this.dataset && this.dataset.uid && vm.mainGrid.dataSource.getByUid(this.dataset.uid)) {
              selectedIds.push(vm.mainGrid.dataSource.getByUid(this.dataset.uid).TicketId);
            }
          });

        if (selectedIds.length > 0) {
          vm.dataModel.TicketIds = selectedIds;
          vm.dataModel.PartnerId = vm.dataModel.PartnerId.Value;
          uibModalInstance.close(vm.dataModel);
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function cancel() {
        uibModalInstance.dismiss();
      }

      function initMainGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars === null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

        if (vm.pageModel.Grids[gridName].Table) {
          readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          if (!transportData) {
            transportData = {};
          }
          angular.extend(transportData, {
            tableName: vm.pageModel.Grids[gridName].Table,
            whereCondition: whereCondition,
            adopter: vm.pageModel.Grids[gridName].Adopter,
            installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
            idColumn: vm.pageModel.Grids[gridName].IdColumn,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#mainGrid').data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );
      }

      $(document).ready(function() {
        $('#filterForm').on('click', '.formly-field-checkbox', onSelectAllClick);
      });

      function onSelectAllClick() {
        var grid = $('#mainGrid').data('kendoGrid');
        var rowCheckboxes = $('#mainGrid').find('.k-checkbox');
        var isChecked = $('.formly-field-checkbox').is(':checked');
        if (isChecked) {
          grid.clearSelection();
          rowCheckboxes.prop('checked', true);
        } else {
          grid.clearSelection();
          rowCheckboxes.prop('checked', false);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('GenerateInvoiceModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'GenerateInvoiceModalCtrl', stateParams);
      }
      var vm = this;
      vm.generate = generate;
      vm.cancel = cancel;
      vm.massGeneration = false;
      vm.partnerId = model.partnerId;

      if (model.dto.TicketIds && model.dto.TicketIds.length > 0) {
        vm.massGeneration = true;
      }

      init();

      vm.pageModel.Fields.Period.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
        return "Active~eq~'1'";
      };

      if (!vm.massGeneration) {
        vm.pageModel.Fields.Unit.FormlyFieldDescriptor.hide = true;
        vm.pageModel.Fields.CertDateTimeFrom.FormlyFieldDescriptor.hide = true;
        vm.pageModel.Fields.CertDateTime.FormlyFieldDescriptor.hide = true;
      }

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        //Sor törlés
        var onClickFunctions = {
          SpecializationLedgerCodeId: function(value, model, event, scope) {
            vm.dataModel.LedgerCodeList = vm.dataModel.LedgerCodeList.filter(
              item => item.$$hashKey !== model.$$hashKey
            );
          },
        };

        vm.readData = function() {
          let id = vm.ledgerCodeIdList.shift();
          return { ledgerCodeId: id };
        };

        vm.ledgerCodeIdList = vm.dataModel.LedgerCodeList.map(x => x.LedgerCodeId);
        vm.pageModel.Fields.LedgerCodeValueId.transData = vm.readData;

        var onChangeFunctions = {
          LedgerCodeId: function(value, model, scope) {
            scope.fields
              .find(x => x.key == 'LedgerCodeValueId')
              .templateOptions.options.dataSource.read({
                ledgerCodeId: value.key,
              });
          },
          LedgerCodeValueId: function(value, model, scope) {},
        };

        InsertOnClickFunctions(vm.pageModel, onClickFunctions);
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        vm.pageModel.Fields.LedgerCodeValueId.FormlyFieldDescriptor.templateOptions.dataBound = function(e) {
          vm.dataModel;
        };
        generateForm(vm);
      }

      function generate() {
        var data = { model: vm.dataModel, partnerId: vm.partnerId };

        $http.post('HelpDesk/GenerateInvoice', data).then(function(result) {
          var data = result.data;
          if (data.ResultStatus) {
            toastr.success('Sikeres generálás!');
            uibModalInstance.close();
          }
        });
        //uibModalInstance.close(vm.dataModel);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskMultiApproveModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    'gridService',
    function($scope, $http, $state, $stateParams, model, mi, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskMultiApproveModalCtrl', stateParams);
      }
      var vm = this;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.multiApprove = function() {
        var gridDataSource = angular.copy(vm.mainGrid.dataSource);
        gridDataSource.pageSize(999999999);
        gridDataSource.read().then(
          function(result) {
            var ids = gridDataSource.data().map(function(e) {
              return e.TicketId;
            });
            gridDataSource = null;

            $http({
              url: 'HelpDesk/MultiApprove',
              method: 'POST',
              data: { ticketIds: ids },
            }).then(function(response) {
              toastr.success('Sikeres jóváhagyás');
              mi.close(true);
            });
          },
          function(error) {}
        );
      };

      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var tempOptions = angular.copy(vm.dataModel.gridOptions);
        tempOptions.autoBind = true;
        vm.mainGridOptions = tempOptions;
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketTaskCustomerPriceGenModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketTaskCustomerPriceGenModalCtrl', stateParams);
      }
      var vm = this;
      vm.generate = generate;
      vm.cancel = cancel;
      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);
      }
      console.log(vm);
      function generate() {
        $http
          .post('Helpdesk/TicketTaskCustomerPriceGen', vm.dataModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
        uibModalInstance.close(vm.dataModel);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketMaterialCustomerPriceGenModalCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModalInstance',
    function($http, model, $state, $stateParams, AuthService, $scope, uibModalInstance) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketMaterialCustomerPriceGenModalCtrl', stateParams);
      }
      var vm = this;
      vm.generate = generate;
      vm.cancel = cancel;
      init();

      function init() {
        vm.controllerOptions = $stateParams.controllerOptions;
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);
        generateForm(vm);
      }
      console.log(vm);
      function generate() {
        $http
          .post('Helpdesk/TicketMaterialCustomerPriceGen', vm.dataModel)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.GenerateSuccessful);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
        uibModalInstance.close(vm.dataModel);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskTaskDateNavCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    'options',
    '$http',
    '$state',
    '$stateParams',
    'WalService',
    'gridService',
    'UIHelperService',
    function(
      $rootScope,
      $scope,
      $timeout,
      options,
      $http,
      $state,
      $stateParams,
      walService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskTaskDateNavCtrl', stateParams);
      }
      var vm = this;

      init();
      vm.UIHelperService = UIHelperService;

      vm.WAL = WAL;
      vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
        gridModel: vm.pageModel.Grids.GridTaskDate,
        transportData: {
          tableName: vm.pageModel.Grids.GridTaskDate.Table,
          whereCondition: '',
          adopter: vm.pageModel.Grids.GridTaskDate.Adopter,
          installAdopter: vm.pageModel.Grids.GridTaskDate.InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids.GridTaskDate.Columns, 'field').join(),
          idColumn: 'Date',
        },
      });

      function init() {
        vm.pageModel = options.pageModel;
        vm.states = options.states;
        vm.messages = options.pageModel.Messages;
        vm.labels = options.pageModel.Labels;
        vm.actions = options.pageModel.Actions;
        vm.back = back;
        vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      }

      function back() {
        $state.go('main');
      }

      function WAL() {
        walService.NavigateToWal('HelpDesk', 'HelpDeskTaskDateNavWal', 'FlgHelpDeskTaskDateView');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketDocEditCtrl', [
    '$http',
    'model',
    '$stateParams',
    'DasService',
    '$uibModalInstance',
    'LockService',
    function($http, model, $stateParams, dasService, uibModalInstance, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketDocEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.Dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.modelState = model.Dto.ModelState;

      var dtoState = ['', 'View', 'Create', 'Edit', 'Duplicate'];
      if ([3].includes(vm.modelState)) {
        vm.pageModel.Actions['Save'] = vm.pageModel.Actions['ActionSave'];
      } else {
        vm.pageModel.Actions['Save'] = vm.pageModel.Actions['ActionGenerate'];
      }
      vm.modalTitle =
        vm.pageModel.Labels['LabelTitle'].Title + ' ' + vm.pageModel.Labels['Label' + dtoState[vm.modelState]].Title;

      vm.save = saveItem;
      vm.cancel = cancelItem;

      var dynamicQueryParameters = {
        TemplateId: function() {
          var result = [
            {
              key: 'DocType',
              value: vm.formModel.DocTypeId,
            },
            {
              key: 'DocTypeCode',
              value: 'ticket',
            },
          ];
          if ([3].includes(vm.modelState)) {
            result.push({
              key: 'TemplateId',
              value: vm.formModel.TemplateId,
            });
          }
          return result;
        },
      };

      var customExpressionProperties = {
        TemplateId: {
          'templateOptions.disabled': function() {
            return typeof vm.formModel.DocTypeId === 'undefined' || ![2, 4].includes(vm.modelState);
          },
          'templateOptions.required': function() {
            return vm.formModel.Type === 'DOC';
          },
        },
        DocTypeId: {
          'templateOptions.disabled': function() {
            return ![2, 4].includes(vm.modelState);
          },
          'templateOptions.required': function() {
            return vm.formModel.Type === 'DOC';
          },
        },
        DocDate: {
          'templateOptions.disabled': function() {
            return ![2, 4].includes(vm.modelState);
          },
        },
      };

      if (vm.modelState === 1) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      var onChangeFunctions = {
        DocTypeId: function() {
          vm.pageModel.Fields.TemplateId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
      };
      var hideExpressions = {
        DocType: function($viewValue, $modelValue, scope) {
          return vm.formModel.Type === 'DOC';
        },
        DocName: function($viewValue, $modelValue, scope) {
          return vm.formModel.Type === 'DOC';
        },
        DocTypeId: function($viewValue, $modelValue, scope) {
          return vm.formModel.Type !== 'DOC' && !!vm.formModel.Type;
        },
        TemplateId: function($viewValue, $modelValue, scope) {
          return vm.formModel.Type !== 'DOC' && !!vm.formModel.Type;
        },
      };
      var onBlurFunctions = {};
      var syncValidators = {};
      var parsers = {};
      var formatters = {};
      var numericOptions = {};
      var inputMasks = {};
      var customTypes = {};
      var customClasses = {};

      InsertCustomClasses(vm.pageModel, customClasses);
      InsertSyncValidators(vm.pageModel, syncValidators);
      InsertFormatters(vm.pageModel, formatters);
      InsertNumericOptions(vm.pageModel, numericOptions);
      InsertParsers(vm.pageModel, parsers);
      InsertInputMasks(vm.pageModel, inputMasks);
      InsertCustomTypes(vm.pageModel, customTypes);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertOnBlurFunctions(vm.pageModel, onBlurFunctions);
      InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );
      function cancelItem() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.close();
      }
      function saveItem() {
        if (!isNaN(vm.formModel.TemplateId)) {
          generateReport(save);
        } else {
          $http
            .post('Contract/GetDocumentTemplateParamCount', {
              templateId: vm.formModel.TemplateId,
            })
            .then(
              function(res) {
                var result = res.data;
                generateReport(save);
              },
              function(err) {
                // TODO err
              }
            );
        }
      }

      function save() {
        var params = { model: vm.formModel };
        var states = ['', 'View', 'Create', 'Edit', 'Create'];
        let ssrs = vm.formModel.Type !== 'DOC' ? 'SSRS' : '';
        $http
          .post('HelpDesk/TicketDoc' + ssrs + states[vm.modelState], params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }
      function generateReport(saveFn) {
        if ([3].includes(vm.modelState)) {
          if (angular.isFunction(saveFn)) {
            saveFn();
          }
          return;
        }
        $http
          .post('Template/GetTemplateData', {
            templateId: vm.formModel.TemplateId,
            id: { TicketId: vm.formModel.TicketId },
          })
          .then(
            function(result) {
              var file = JSON.parse(result.data);
              var raw = atob(file.Report);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));
              for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
              }
              var fs = new Blob([array], { type: file.MimeType });
              saveAs(fs, decodeURIComponent(file.FileName));
              if (angular.isFunction(saveFn)) {
                saveFn();
              }
            },
            function(result) {
              toastr.error(vm.pageModel.Messages.SaveFailed);
            }
          );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TicketChangeBudgetModalCtrl', [
    '$http',
    'model',
    'premiseIds',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    '$sce',
    function($http, model, premiseIds, $state, $stateParams, uibModalInstance, $sce) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketChangeBudgetModalCtrl', stateParams);
      }
      var vm = this;

      init();

      vm.labelBudgetName = $sce.trustAsHtml(vm.dataModel.BudgetName);
      if (!premiseIds || premiseIds?.length === 0) {
        uibModalInstance.dismiss();
      }

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        var dynamicQueryParameters = {
          SupplyContrId: function() {
            return [
              {
                value: vm.dataModel.PartnerId.Value,
                key: 'PartnerId',
              },
            ];
          },
        };
        InsertDynamicQueryParameters(vm.pageModel, dynamicQueryParameters);
        generateForm(vm);
        vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
          var ids = premiseIds.toString();

          return { premiseIds: ids };
        };

        const dataBound = vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataBound;
        vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          let dataItems = e.sender.dataItems();
          if ((dataItems?.length == 1 && vm.dataModel.BudgetId != dataItems[0]) || dataItems?.length > 1) {
            $('#TicketChangeBudgetModal').show();
          } else {
            uibModalInstance.dismiss();
          }
        };

        vm.cancel = cancel;
        vm.save = save;
      }

      function save() {
        uibModalInstance.close(vm.dataModel.BudgetId);
      }

      function cancel() {
        uibModalInstance.dismiss();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketTemplateEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      $uibModal,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketTemplateEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.dto;
      vm.oldFormModel = angular.copy(model.dto);
      vm.firstRespPartnerId = true;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.operation = $stateParams.Operation;

      vm.subGridIdField = vm.pageModel.Grids['GridTicketTemplateTask'].IdColumn;
      vm.subGrid = vm.pageModel.Grids['GridTicketTemplateTask'];

      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.deleteSubItem = deleteSubItem;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      vm.selectedItem = 0;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Masterdata.HelpDesk.TicketTemplateList');
      };

      vm.getTicketTemplateId = function() {
        return {
          ticketTemplateId: vm.formModel.TicketTemplateId,
        };
      };

      if (vm.formModel.TicketTemplateId === 0 || vm.formModel.TicketTemplateId === null) {
        vm.formModel.RespPartnerId = { Value: null, Text: null, firstText: null };
      }

      var customExpressionProperties = {
        // TicketTemplateRespUser: {
        //   'templateOptions.disabled': function() {
        //     return vm.formModel.RespPartnerId.Value === null;
        //   },
        // },
      };

      var onChangeFunctions = {
        RespPartnerId: function(selectedItem) {
          vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            partnerId: selectedItem.Value,
          });
          if (vm.firstRespPartnerId && selectedItem?.Value != vm.oldFormModel.RespPartnerId?.Value) {
            vm.firstRespPartnerId = false;
          }

          if (!vm.firstRespPartnerId) {
            vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.templateOptions.selectedItems = [];
          }
        },
        TicketTemplateRespUser: function(selectedItem) {
          if (selectedItem?.length == 1 && !vm.formModel.RespPartnerId?.Value) {
            let element = this.options.dataSource.data().find(x => x.key == selectedItem[0]);
            let orgPartId = parseInt(element?.extraProperties.find(z => z.key == 'OrgPartId')?.value);
            if (!!orgPartId) {
              vm.formModel.RespPartnerId = {
                Value: orgPartId,
                Text: element?.extraProperties.find(z => z.key == 'OrgPartName')?.value,
              };
              vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
                partnerId: orgPartId,
              });
            }
          }
        },
      };

      // InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.templateOptions.itemType = 'Array';

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelTicketTemplate.FormlyDescriptor;

      vm.pageModel.Fields.TicketTemplateRespUser.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { partnerId: vm.formModel.RespPartnerId.Value };
      };

      function save() {
        $http.post('HelpDeskMasterData/TicketTemplate' + vm.operation, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            //$state.go('Masterdata.HelpDesk.TicketTemplateList');
            $state.go('HelpDesk.TicketTemplateEdit', { id: response.data.TicketTemplateId }, { reload: true });
          },
          function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }

      vm.subGridOptions = getGridOptions(
        model.pageModel.Grids.GridTicketTemplateTask,
        'HelpDeskMasterData/TicketTemplateTaskList/',
        function() {
          getSelectedSubGridItem();
        },
        vm.getTicketTemplateId()
      );

      function getSelectedSubGridItem() {
        vm.selectedItem = GetSelectedGridItems(vm.subGrid);
      }

      function createSubItem() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/HelpDesk/TicketTemplateTaskEdit.html',
          controller: 'TicketTemplateTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(
              'HelpDeskMasterData/TicketTemplateTaskCreate/?ticketTemplateId=' + vm.formModel.TicketTemplateId
            ),
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function(newStatus) {
            vm.formModel.Status = newStatus;
            vm.subGrid.dataSource.read();
          })
          .catch(function(response) {});
      }

      function editSubItem() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/MasterData/HelpDesk/TicketTemplateTaskEdit.html',
          controller: 'TicketTemplateTaskEditCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(
              'HelpDeskMasterData/TicketTemplateTaskEdit/?id=' + vm.selectedItem[0].TicketTemplateTaskId
            ),
          },
          backdrop: 'static',
        });

        modalInstance.result
          .then(function(newStatus) {
            vm.formModel.Status = newStatus;
            vm.subGrid.dataSource.read();
          })
          .catch(function(response) {});
      }

      function deleteSubItem() {
        if (vm.selectedItem.length === 0) {
          toastr.warning('Nem jelölt ki elemet!', 'Figyelmeztetés!');
        } else {
          var dialogMessage = vm.pageModel.Labels.LabelConfirmDelete.Title;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.pageModel.Labels.LabelDeleteWarning.Title,
            buttons: {
              cancel: {
                label: vm.pageModel.Labels.LabelDeleteCancel.Title,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.pageModel.Labels.LabelDeleteOk.Title,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get('HelpDeskMasterData/TicketTemplateTaskDelete/' + vm.selectedItem[0].TicketTemplateTaskId)
                    .then(function() {
                      toastr.success(vm.pageModel.Labels.LabelDeleteSuccessful.Title);
                      vm.subGrid.dataSource.read();
                    });
                },
              },
            },
          });
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TicketTemplateTaskEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    '$uibModal',
    '$uibModalInstance',
    'DasService',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      $uibModal,
      $uibModalInstance,
      dasService,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TicketTemplateTaskEditCtrl', stateParams);
      }
      var vm = this;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.formModel = model.dto;
      vm.pageModel = model.pageModel;
      vm.messages = model.pageModel.Messages;
      vm.modalInstance = $uibModalInstance;
      vm.operation = vm.formModel.TaskId === 0 ? 'Create' : 'Edit';

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.save = save;

      vm.cancel = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        vm.modalInstance.dismiss();
      };

      var onChangeFunctions = {
        PartnerId: function(selectedItem) {
          vm.pageModel.Fields.Solvers.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            partnerId: selectedItem.Value,
          });
        },
        Solvers: function(selectedItem) {
          if (selectedItem?.length == 1 && !vm.formModel.PartnerId?.Value) {
            let element = this.options.dataSource.data().find(x => x.key == selectedItem[0]);
            let orgPartId = parseInt(element?.extraProperties.find(z => z.key == 'OrgPartId')?.value);
            if (!!orgPartId) {
              vm.formModel.PartnerId = {
                Value: orgPartId,
                Text: element?.extraProperties.find(z => z.key == 'OrgPartName')?.value,
              };
              vm.pageModel.Fields.Solvers.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
                partnerId: orgPartId,
              });
            }
          }
        },
        TaskId: function(selectedItem) {
          vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            taskId: selectedItem.key,
          });
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.pageModel.Fields.Solvers.FormlyFieldDescriptor.type = 'kendoMS';
      vm.pageModel.Fields.Solvers.FormlyFieldDescriptor.templateOptions.itemType = 'Array';

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.pageModel.Fields.TaskId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
        ticketTemplateId: vm.formModel.TicketTemplateId,
        taskId: vm.formModel.TaskId,
      };

      if (vm.formModel.TicketTemplateTaskId > 0) {
        vm.pageModel.Fields.UnitPriceCollectionId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = {
          taskId: vm.formModel.TaskId,
        };
      }
      vm.pageModel.Fields.Solvers.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { partnerId: vm.formModel.PartnerId?.Value };
      };

      function save() {
        $http
          .post('HelpDeskMasterData/GetStatusesForTemplateByTask', {
            taskId: vm.formModel.TaskId,
            ticketTemplateId: vm.formModel.TicketTemplateId,
          })
          .then(function(response) {
            if (response.data.Dto.CurrentStatus === true && response.data.Dto.NewStatus === false) {
              bootbox.dialog({
                message:
                  'A kiválasztott tevékenységre már létezik aktív munkalap sablon, rögzítés esetén a jelenleg szerkesztett munkalapsablon inaktiválódni fog! Kívánja folytatni?',
                title: vm.messages.Warning,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                    callback: function() {},
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      saveForm(response.data.Dto.NewStatus);
                    },
                  },
                },
              });
            } else {
              saveForm(response.data.Dto.CurrentStatus);
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function saveForm(templateStatus) {
        $http.post('HelpDeskMasterData/TicketTemplateTask' + vm.operation, vm.formModel).then(
          function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            vm.modalInstance.close(templateStatus);
          },
          function() {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          }
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HelpDeskMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HelpDeskMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.grid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) vm.type = '';
      else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'HelpDeskMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') $state.go(vm.type + 'List');
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HistoryLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, AuthService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HistoryLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HistoryMenuCtrl', [
    '$http',
    '$state',
    'authService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HistoryMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      backMenu.state = 'main';

      var desc = {
        History_Nav: { icon: 'fa fa-university' },
      };

      buildMenu($state, authService, 'History', 'history', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('HistoryNavCtrl', [
    '$scope',
    '$timeout',
    'model',
    '$http',
    '$state',
    'WalService',
    '$stateParams',
    '$window',
    function($scope, $timeout, model, $http, $state, walService, $stateParams, $window) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'HistoryNavCtrl', stateParams);
      }
      var vm = this;

      init();

      initMainGrid(
        vm,
        'GridHistory',
        'History/GetHistoryData', // readUrl
        function() {
          // select function
        },
        null,
        false,
        '',
        false
      );

      function init() {
        initModel($http, $state, $stateParams, vm, model);
        initViewModel($http, $state, $stateParams, vm, model);
        initFormModel($http, $state, $stateParams, vm, model);

        generateForm(vm);
      }

      vm.back = function() {
        $window.history.back();
      };

      vm.exportPdf = function() {
        toastr.warning('Ez a funkció még nincs megvalósítva.', vm.messages.Warning);
      };

      vm.exportExcel = function() {
        toastr.warning('Ez a funkció még nincs megvalósítva.', vm.messages.Warning);
      };

      function initMainGrid(
        vm,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';
        vm[mainGridIdField] = vm.pageModel.Grids[gridName].IdColumn;

        if (vm.pageModel.Grids[gridName].Table) {
          if (!readUrl) {
            readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          }
          if (!transportData) {
            transportData = {};
          }

          var tableId;
          var idColumn;
          if (vm.dataModel.TableId && vm.dataModel.IdColumn) {
            tableId = vm.dataModel.TableId;
            idColumn = vm.dataModel.IdColumn;
          } else {
            var tableJSON = JSON.parse(vm.dataModel.TableName);
            if (tableJSON) {
              tableId = tableJSON.tableId;
              idColumn = tableJSON.idColumn;
            }
          }

          angular.extend(transportData, {
            tableName: vm.pageModel.Grids[gridName].Table,
            whereCondition: whereCondition,
            adopter: vm.pageModel.Grids[gridName].Adopter,
            installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
            columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
            idColumn: idColumn,
            tableId: tableId,
            ownerId: vm.dataModel.OwnerId,
          });
        }

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        vm[mainGrid] = $('#mainGrid').data('kendoGrid');

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        vm[mainGridOptions] = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('CustomerServiceMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CustomerServiceMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var id = $state.params.BudgetId;
      //Routesban kap értéket: {Nav, Edit}
      var backTo = $state.params.backTo;
      if (backTo === 'Nav') {
        backMenu.event = function() {
          $state.go('CustomerService.Nav');
        };
      } else if (backTo === 'Edit') {
        backMenu.event = function() {
          $state.go('CustomerService.Edit', { id: id });
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        CustomerService_CustomerService: { icon: 'fa fa-file-text' },
        CustomerService_Group: { icon: 'fa fa-file-text' },
        CustomerService_Reports: { icon: 'fa fa-file-text' },
      };
      buildMenu($state, authService, 'CustomerService', 'customerservice', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      CustomerService: {
        url: '/customerservice',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'CustomerService.Nav',
        ncyBreadcrumb: {
          label: 'Ügyfélszolgálat',
          parent: 'main',
        },
      },
      'CustomerService.Nav': {
        url: '/nav/:partnerId/:propertyId',
        params: {
          module: 'CustomerService',
          formMode: 'Nav',
          backState: 'CustomerService.Nav',
          partnerId: { value: null },
          propertyId: { value: null },
          documentEntity: 'customerservice_nav',
          backStateParams: [
            { name: 'partnerId', modelName: 'partnerId' },
            { name: 'propertyId', modelName: 'propertyId' },
          ],
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'CustomerServiceMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/CustomerService/CustomerServiceNav.html',
            controller: 'CustomerServiceNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('CustomerService/ListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Ügyfélszolgálat navigáció',
          parent: 'CustomerService',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

/// <reference path="CustomerServiceNav.js" />
(function(module) {
  'use strict';
  module.controller('CustomerServiceNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$q',
    '$state',
    '$stateParams',
    '$window',
    '$timeout',
    '$location',
    'HistoryService',
    'gridService',
    function(
      $scope,
      options,
      $http,
      $q,
      $state,
      $stateParams,
      $window,
      $timeout,
      $location,
      HistoryService,
      gridService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'CustomerServiceNavCtrl', stateParams);
      }
      var vm = this;
      init();
      function init() {
        vm.pageModel = options.pageModel;
        vm.hasKKR = options.hasKKR;
        vm.hasDMSOne = options.hasDMSOne;

        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        var fs = fieldSetter;
        fs.vm = vm;

        // Init F22s
        vm.FormlyDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
        vm.FormlyDescriptors.PanelFilter.Model = {};

        // Filter F22s
        var partnerId = $stateParams.partnerId;
        var propertyId = $stateParams.propertyId;

        vm.firstClickCollapsedPanelDMSOne = vm.hasDMSOne;
        vm.isCollapsedPanelDMSOne = true;

        vm.clickDMSOnePanel = function() {
          vm.isCollapsedPanelDMSOne = !vm.isCollapsedPanelDMSOne;
          if (vm.firstClickCollapsedPanelDMSOne) {
            vm.initDMSOneGrid();
            vm.firstClickCollapsedPanelDMSOne = false;
          }
        };

        vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          propertyId: propertyId,
        };

        var shouldAutoFilter = false;
        if (partnerId) {
          shouldAutoFilter = true;
          vm.FormlyDescriptors.PanelFilter.Model.PartnerId = { Value: partnerId, Text: null };
        }
        if (propertyId) {
          shouldAutoFilter = true;
          vm.FormlyDescriptors.PanelFilter.Model.Property = { Value: propertyId, Text: null };
        }

        vm.back = function() {
          $state.go('main');
        };

        // Property F22 onChange
        vm.pageModel.Fields.Property.FormlyFieldDescriptor.templateOptions.options.InputChanged = function(
          selectedScope
        ) {
          if (
            !!vm.FormlyDescriptors.PanelFilter.Model.Property &&
            vm.FormlyDescriptors.PanelFilter.Model.Property.Value != selectedScope.f2Value.Value
          ) {
            vm.FormlyDescriptors.PanelFilter.Model.PartnerId = { Value: null, Text: null };
          }
          vm.pageModel.Fields.PartnerId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
            propertyId: selectedScope.f2Value.Value,
          };
        };

        // Load grids
        vm.pageModel.GridOptions = [];
        vm.activeSubItemTab = 0;
        vm.GridTenantPerson = null;
        vm.GridTenantCompany = null;
        vm.GridUser = null;
        vm.GridTenement = null;
        vm.GridMeter = null;
        vm.GridMailReg = null;
        vm.GridContract = null;
        vm.GridKKRHatralek = null;
        vm.GridKKRNaplo = null;
        vm.GridDMSOne = null;
        vm.GridCSTicketGridItem = null;

        // Functions
        vm.search = search;
        vm.goto = goto;

        // max trials for panel state updates
        vm.currentPanelStateTrials = 0;
        vm.maxPanelStateTrials = 10;

        if (shouldAutoFilter) {
          vm.search();
        }
      }

      function initGrid(
        setGridFn,
        setGridIdFieldFn,
        setGridOptionsFn,
        setDataBoundFunction,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;
        var mainGridIdField = custGridVars ? gridName + 'IdField' : 'mainGridIdField';

        var idColumn = null;
        if (vm.pageModel.Grids[gridName]) {
          idColumn = vm.pageModel.Grids[gridName].IdColumn;
        }

        if (!idColumn) {
          debugger;
        }

        setGridIdFieldFn(idColumn);

        if (!readUrl || readUrl === '') {
          if (vm.pageModel.Grids[gridName].Table) {
            readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          }
        }

        if (!transportData) {
          transportData = {};
        }
        angular.extend(transportData, {
          tableName: vm.pageModel.Grids[gridName].Table,
          whereCondition: whereCondition,
          adopter: vm.pageModel.Grids[gridName].Adopter,
          installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids[gridName].IdColumn,
        });

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        var grid = $('#' + mainGrid).data('kendoGrid');
        setGridFn(grid);

        // Kendo-grid reference for main GRID
        var mainGridOptions = custGridVars ? gridName + 'Options' : 'mainGridOptions';
        var gridOptions = getGridOptions(
          vm.pageModel.Grids[gridName],
          readUrl,
          selectFunction,
          transportData,
          detailInit
        );

        gridOptions.dataBound = setDataBoundFunction;

        setGridOptionsFn(gridOptions, mainGrid);
      }

      function goto(row, gridName, state = null) {
        var vm = this;
        var data = row.dataItem;

        var flgrUrlBase = $location.absUrl().replace($location.url(), '');

        var url = '';
        switch (gridName) {
          case 'GridTenantPerson':
            url = flgrUrlBase + '/partner/' + state + '/' + data.PartnerId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridTenantCompany':
            //$state.go("Partner.Edit", { "id": data.PartnerId });
            url = flgrUrlBase + '/partner/' + state + '/' + data.PartnerId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridUser':
            //$state.go("Contract.GridUsersEdit", { "id": data.PartnerId });
            url =
              flgrUrlBase + '/contract/contrusers' + state + '/' + data.ContrUserId + '?ContractId=' + data.ContractId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridTenement':
            url = flgrUrlBase + '/property/pyramid/rentableunit/' + data.PropertyId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridMeter':
            //$state.go("Utility.MeterEdit", { "id": data.MeterId });
            url = flgrUrlBase + '/utility/' + state + '/' + data.MeterId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridMailReg':
            var mrsDocumentId = data.DocumentId;
            url = vm.pageModel.Settings['mrsUrl'] + '/document' + state + '/' + mrsDocumentId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridDMSOne':
            if (!data.Url) {
              $http
                .post('CustomerService/GetDMSOneUrl', { DocumentId: data.DocumentId })
                .then(function(response) {
                  if (!response.data.Url) {
                    toastr.error('Nem található url!');
                    return false;
                  }
                  url = response.data.Url;
                  $window.open(url, '_blank');
                })
                .catch(function(response) {
                  toastr.error('Nem található url!');
                });
            } else {
              url = data.Url;
              $window.open(url, '_blank');
            }

            break;

          case 'GridCSTicketGridItem':
            url = flgrUrlBase + '/helpdesk/edit/' + data.TicketId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          case 'GridContract':
            //$state.go("Contract.ContractEdit", { "id": data.ContractId });
            url = flgrUrlBase + '/contract/contract' + state + '/' + data.ContractId;
            if (state === 'view') {
              $http.post('CustomerService/ViewItem').then(function() {
                $window.open(url, '_blank');
              });
            } else {
              $http.post('CustomerService/EditItem').then(function() {
                $window.open(url, '_blank');
              });
            }
            break;

          default:
            break;
        }
        // End.
      }

      function search() {
        var vm = this;
        $http
          .post('CustomerService/ViewItem')
          .then(function() {
            var partnerId = null;
            var propertyId = null;
            var tenement = null;

            if (typeof vm.FormlyDescriptors.PanelFilter.Model.PartnerId !== 'undefined') {
              partnerId = vm.FormlyDescriptors.PanelFilter.Model.PartnerId.Value;
            }
            if (typeof vm.FormlyDescriptors.PanelFilter.Model.Property !== 'undefined') {
              propertyId = vm.FormlyDescriptors.PanelFilter.Model.Property.Value;
            }

            if (partnerId === null) {
              // init
              vm.showGrids = false;
              return;
            }

            var shouldProceedUpdatingTheGrids = setBackUrl(partnerId, propertyId);
            if (shouldProceedUpdatingTheGrids) {
              // Enable grids
              vm.showGrids = true;

              updateGrids(vm, partnerId);
            }
          })
          .catch(function() {
            return;
          });
      }

      function setBackUrl(partnerId, propertyId) {
        // Setup FormBuilder back button
        vm.dataModel['partnerId'] = partnerId;
        vm.dataModel['propertyId'] = propertyId;

        // This will work with the following
        // (defined in the *Routes.js file
        /*
                $stateParams.backState = "CustomerService.Nav";
                $stateParams.backStateParams = [
                    { name: "partnerId", modelName: "partnerId" },
                    { name: "propertyId", modelName: "propertyId" }
                ];
                */

        // Setup browser back button
        // rewrite browser url (for back button)
        //var url = $location.path();
        var url = '/customerservice/nav';
        if (partnerId) {
          url += '/' + partnerId + '/';
        }
        if (propertyId) {
          url += propertyId;
        }

        // check if we will have a redirect
        var currentUrl = $location.url();
        if (currentUrl !== url) {
          // This will reload the page with the new parameters
          $location.path(url).replace();
          return false;
        }

        // should proceed with updating the grids
        return true;
      }

      function updateGrids(vm, partnerId) {
        // Always have partnerId

        // GridTenantPerson - Magánszemély bérlő
        var whereCondition = 'PartnerId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridTenantPerson = grid;
          },
          function(gridIdField) {
            vm.GridTenantPersonIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Partner szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Partner megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            vm.GridTenantPersonOptions = gridOptions;
          },
          dataBoundFnGridTenantPerson,
          'GridTenantPerson',
          '', // readUrl
          function(e) {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridTenantCompany - Társaság bérlő
        whereCondition = 'PartnerId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridTenantCompany = grid;
          },
          function(gridIdField) {
            vm.GridTenantCompanyIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Partner szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Partner megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            vm.GridTenantCompanyOptions = gridOptions;
          },
          dataBoundFnGridTenantCompany,
          'GridTenantCompany',
          '', // readUrl
          function() {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridUser - Használók
        whereCondition = 'TenantPartId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridUser = grid;
          },
          function(gridIdField) {
            vm.GridUserIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Használó szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Használó megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            gridOptions.dataSource.sort = [{ field: 'Name', dir: 'asc' }];
            vm.GridUserOptions = gridOptions;
          },
          dataBoundFnGridUser,
          'GridUser',
          '', // readUrl
          function() {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridTenement - Bérlemények
        whereCondition = 'TenantPartId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridTenement = grid;
          },
          function(gridIdField) {
            vm.GridTenementIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Bérlemény szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Bérlemény megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            gridOptions.dataSource.sort = [{ field: 'Address', dir: 'asc' }];
            vm.GridTenementOptions = gridOptions;
          },
          dataBoundFnGridTenement,
          'GridTenement',
          '', // readUrl
          function() {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridMeter - Mérőórák
        whereCondition = 'TenantPartId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridMeter = grid;
          },
          function(gridIdField) {
            vm.GridMeterIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '85px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Mérőóra szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Mérőóra megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            gridOptions.dataSource.sort = [
              { field: 'Contract', dir: 'asc' },
              { field: 'UtilityName', dir: 'asc' },
              { field: 'SerialNumber', dir: 'asc' },
            ];
            vm.GridMeterOptions = gridOptions;
          },
          dataBoundFnGridMeter,
          'GridMeter',
          '', // readUrl
          function() {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridMailReg - Posta iktatás
        // toString fontos, mert a view-ban a szűrt mezőkben lehet pl M000012234 formátumú adat, és az crash-el!
        whereCondition = "ClientPartnerId~eq~'" + partnerId.toString() + "'";
        whereCondition += "~or~SenderPartnerId~eq~'" + partnerId.toString() + "'";
        whereCondition += "~or~TargetPartnerId~eq~'" + partnerId.toString() + "'";
        initGrid(
          function(grid) {
            vm.GridMailReg = grid;
          },
          function(gridIdField) {
            vm.GridMailRegIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Posta iktatás szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Posta iktatás megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            gridOptions.dataSource.sort = [{ field: 'ArrivalDate', dir: 'desc' }];
            vm.GridMailRegOptions = gridOptions;
          },
          dataBoundFnGridMailReg,
          'GridMailReg',
          '', // readUrl
          function() {
            // select function
          },
          null,
          null,
          whereCondition,
          true
        );

        // GridDMSOne - Posta iktatás DMSOne
        vm.initDMSOneGrid = function() {
          initGrid(
            function(grid) {
              vm.GridDMSOne = grid;
            },
            function(gridIdField) {
              vm.GridDMSOneIdField = gridIdField;
            },
            function(gridOptions, mainGrid) {
              gridOptions.columns.push({
                field: '',
                width: '100px',
                title: 'Funkció',
                template:
                  '<button type="button" class="btn btn-default" title="Posta iktatás szerkesztése" ng-click="vm.goto(this, \'' +
                  mainGrid +
                  '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button>',
              });
              gridOptions.dataSource.sort = [{ field: 'ArrivalDate', dir: 'desc' }];
              vm.GridDMSOneOptions = gridOptions;
            },
            dataBoundFnGridDMSOne,
            'GridDMSOne',
            'CustomerService/GetGridDMSOneData', // readUrl
            function() {
              // select function
            },
            {
              PartnerId: partnerId,
            },
            null,
            whereCondition,
            true
          );
        };

        // GridCSTicketGridItem - Bejelentések nézet
        initGrid(
          function(grid) {
            vm.GridCSTicketGridItem = grid;
          },
          function(gridIdField) {
            vm.GridCSTicketField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Bejelentés megtekintése" ng-click="vm.goto(this, \'GridCSTicketGridItem\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            vm.GridCSTicketGridItemOptions = gridOptions;
          },
          dataBoundGridCSTicketGridItem,
          'GridCSTicketGridItem',
          'CustomerService/GridCSTicketGridItem',
          null,
          function() {
            return { tenantPartId: partnerId };
          }
        );

        // GridContract - Bérleti szerződés
        whereCondition = 'TenantPartId~eq~' + partnerId;
        initGrid(
          function(grid) {
            vm.GridContract = grid;
          },
          function(gridIdField) {
            vm.GridContractIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template: function(dataItem) {
                console.log(dataItem);
                if (dataItem.ContractStatusCode === 'CCSCL') {
                  return (
                    '<button type="button" class="btn btn-default" title="Bérleti szerződés megtekintése"  ng-click="vm.goto(this, \'' +
                    mainGrid +
                    '\',\'view\')"><i class="fa fa-eye"></i></button>'
                  );
                } else {
                  return (
                    '<button type="button" class="btn btn-default" title="Bérleti szerződés szerkesztése"  ng-click="vm.goto(this, \'' +
                    mainGrid +
                    '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Bérleti szerződés megtekintése" ng-click="vm.goto(this, \'' +
                    mainGrid +
                    '\',\'view\')"><i class="fa fa-eye"></i></button>'
                  );
                }
              },
            });
            gridOptions.dataSource.sort = [
              { field: 'ContractStatusOrder', dir: 'asc' },
              { field: 'Contract', dir: 'desc' },
            ];
            vm.GridContractOptions = gridOptions;
            angular.forEach(gridOptions.columns, function(value, key) {
              if (value.field === 'ContractStatusCode') {
                gridOptions.columns[key].menu = false;
                return false;
              }
            });
          },
          dataBoundFnGridContract,
          'GridContract',
          '', // readUrl
          function(arg) {
            // select function
            var tenantPartId = arg.TenantPartId;
            var propertyId = arg.PropertyId;
            var contractId = arg.ContractId;
            updateContractSubGrids(tenantPartId, propertyId, contractId);
          },
          null,
          function(e) {
            // detail init
            generateContractSubGridHtmls(vm, e);
          },
          whereCondition,
          true
        );

        // Init KKR GRIDS
        if (vm.showGrids && vm.hasKKR) {
          vm.GridKKRHatralek = null;
          vm.GridKKRNaplo = null;
          $http.post('CustomerService/GetKKRData', { partnerId: partnerId }).then(function(result) {
            var hatralekList = result.data.HatralekList;
            var naploList = result.data.NaploList;

            initKKRGrids(vm, hatralekList, naploList);
          });
        }
      }

      function initKKRGrids(vm, hatralekList, naploList) {
        var gridOptionsHatralek = {
          columns: [
            { field: 'Toke', title: 'Tőke' },
            { field: 'Koltseg', title: 'Költség' },
            { field: 'Kamat', title: 'Kamat' },
          ],
          dataSource: hatralekList,
          pageSize: 20,
        };

        var gridOptionsNaplo = {
          columns: [
            { field: 'Tipus', title: 'Folyamat' },
            {
              field: 'Kezdete',
              title: 'Kezdete',
              sortable: {
                initialDirection: 'desc',
              },
            },
            { field: 'Vege', title: 'Vége' },
            { field: 'Statusz', title: 'Státusz' },
          ],
          sortable: true,
          dataSource: naploList,
          pageSize: 20,
        };

        // GridKKRHatralek - Hátrelékok
        $('#GridKKRHatralek').kendoGrid(gridOptionsHatralek);
        vm.GridKKRHatralek = $('#GridKKRHatralek').data('kendoGrid');

        // GridKKRNaplo - Napló
        $('#GridKKRNaplo').kendoGrid(gridOptionsNaplo);
        vm.GridKKRNaplo = $('#GridKKRNaplo').data('kendoGrid');
        vm.GridKKRNaplo.dataSource.sort([{ field: 'Kezdete', dir: 'desc' }]);

        vm.isCollapsedPanelKKR = hatralekList.length === 0 && naploList.length === 0;
      }

      function generateContractSubGridHtmls(vm, e) {
        var rowId = e.data.uid;

        // TabContractFee/GridContractFee
        var tabContractFee = e.detailCell.find('#TabContractFee');
        var gridContractFee = e.detailCell.find('#GridContractFee');

        // TabContractDeposit/GridContractDeposit
        var tabContractDeposit = e.detailCell.find('#TabContractDeposit');
        var gridContractDeposit = e.detailCell.find('#GridContractDeposit');

        // change ids to include row uid
        var gridContractFeeId = 'GridContractFee-' + rowId;
        gridContractFee.attr('id', gridContractFeeId);
        var gridContractDepositId = 'GridContractDeposit-' + rowId;
        gridContractDeposit.attr('id', gridContractDepositId);

        var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
          vm.pageModel.Tabs,
          vm.pageModel.Panels,
          options.pageModel.Grids,
          ['PanelContractFee', 'PanelContractDeposit'],
          function(gridModel) {
            if (gridModel.Name === 'GridContractFee') {
              return {
                gridModel,
                transportData: {
                  tableName: gridModel.Table,
                  adopter: gridModel.Adopter,
                  installAdopter: gridModel.InstallAdopter,
                  columnCsv: _.map(gridModel.Columns, 'field').join(),
                  idColumn: gridModel.IdColumn,
                  whereCondition: function() {
                    return 'ContractId~eq~' + e.data.ContractId;
                  },
                },
              };
            }

            if (gridModel.Name === 'GridContractDeposit') {
              return {
                gridModel,
                transportData: {
                  tableName: gridModel.Table,
                  adopter: gridModel.Adopter,
                  installAdopter: gridModel.InstallAdopter,
                  columnCsv: _.map(gridModel.Columns, 'field').join(),
                  idColumn: gridModel.IdColumn,
                  whereCondition: function() {
                    return 'ContractId~eq~' + e.data.ContractId;
                  },
                },
              };
            }

            return null;
          }
        );

        gridService.addAggregateToFooter(
          generatedGridTabs.gridOptions.GridContractDeposit,
          'sum',
          'SumDeposit',
          '',
          "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
        );

        gridService.addAggregateToFooter(
          generatedGridTabs.gridOptions.GridContractDeposit,
          'sum',
          'Deposit',
          '',
          "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
        );

        gridService.addAggregateToFooter(
          generatedGridTabs.gridOptions.GridContractDeposit,
          'sum',
          'PaidDeposit',
          '',
          "<span style='float:right; padding:5px 0;'>Összesen: #= kendo.toString(sum, '\\#\\#,\\#.00') #</span>"
        );

        // init grids
        var grid1 = $('#' + gridContractFeeId);
        generatedGridTabs.gridOptions.GridContractFee.autoBind = true;
        generatedGridTabs.gridOptions.GridContractFee.dataSource.sort = [
          { field: 'ServiceName', dir: 'asc' },
          { field: 'InvoicingFrom', dir: 'desc' },
        ];
        grid1.kendoGrid(generatedGridTabs.gridOptions.GridContractFee);

        var grid2 = $('#' + gridContractDepositId);
        generatedGridTabs.gridOptions.GridContractDeposit.autoBind = true;
        generatedGridTabs.gridOptions.GridContractDeposit.dataSource.sort = [{ field: 'DueDate', dir: 'desc' }];
        grid2.kendoGrid(generatedGridTabs.gridOptions.GridContractDeposit);
      }

      function updateContractSubGrids(partnerId, propertyId, contractId) {
        // GridContractFee - Díjak
        var whereCondition = 'ContractId~eq~' + contractId;
        initGrid(
          function(grid) {
            vm.GridContractFee = grid;
          },
          function(gridIdField) {
            vm.GridContractFeeIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Díjak szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Díjak megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            vm.GridContractFeeOptions = gridOptions;
          },
          function(e) {
            dataBoundFnBase(e);
          },
          'GridContractFee',
          '', // readUrl
          function() {
            // select function
          },
          null,
          function(e) {
            // detail init
            console.log('detail init: GridContractFee: ', e);
          },
          whereCondition,
          true
        );

        // GridContractDeposit - Óvadékok
        whereCondition = null;
        initGrid(
          function(grid) {
            vm.GridContractDeposit = grid;
          },
          function(gridIdField) {
            vm.GridContractDepositIdField = gridIdField;
          },
          function(gridOptions, mainGrid) {
            gridOptions.columns.push({
              field: '',
              width: '100px',
              title: 'Funkció',
              template:
                '<button type="button" class="btn btn-default" title="Óvadékok szerkesztése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'edit\')"><i class="glyphicon glyphicon-pencil"></i></button><button type="button" class="btn btn-default" title="Óvadékok megtekintése" ng-click="vm.goto(this, \'' +
                mainGrid +
                '\',\'view\')"><i class="fa fa-eye"></i></button>',
            });
            vm.GridContractDepositOptions = gridOptions;
          },
          function(e) {
            dataBoundFnBase(e);
          },
          'GridContractDeposit',
          '', // readUrl
          function() {
            // select function
          },
          null,
          function() {
            // detail init
            console.log('detail init: GridContractDeposit: ', e);
          },
          whereCondition,
          true
        );
      }

      function dataBoundFnBase(e) {
        var rows = e.sender.content.find('tr');
        var indexColor = e.sender.wrapper.find('.k-grid-header [data-field=' + 'Color' + ']').index();
        if (indexColor > 0) {
          rows.each(function(index, row) {
            var dataItem = e.sender.dataItem(row);
            var fieldColor = $(row).children('td:eq(' + indexColor + ')');
            fieldColor.html(
              "<span style='background-color: #" + dataItem.Color.replace('#', '') + "; display: block'>&nbsp</span>"
            );
            //fieldColor.css("background", "#"+dataItem.Color.replace("#", ""));
          });
        }
      }

      function dataBoundFnGridTenantPerson(e) {
        dataBoundFnBase(e);
        var total = vm.GridTenantPerson.dataSource.total();
        vm.isCollapsedPanelTenantPerson = total == 0;
      }

      function dataBoundFnGridTenantCompany(e) {
        dataBoundFnBase(e);
        var total = vm.GridTenantCompany.dataSource.total();
        vm.isCollapsedPanelTenantCompany = total == 0;
      }

      function dataBoundFnGridUser(e) {
        dataBoundFnBase(e);
        var total = vm.GridUser.dataSource.total();
        vm.isCollapsedPanelUser = total == 0;
      }

      function dataBoundFnGridTenement(e) {
        dataBoundFnBase(e);
        var total = vm.GridTenement.dataSource.total();
        vm.isCollapsedPanelTenement = total == 0;
      }

      function dataBoundFnGridMeter(e) {
        dataBoundFnBase(e);
        var total = vm.GridMeter.dataSource.total();
        vm.isCollapsedPanelMeter = total == 0;
      }

      function dataBoundFnGridMailReg(e) {
        dataBoundFnBase(e);
        var total = vm.GridMailReg.dataSource.total();
        vm.isCollapsedPanelMailReg = total == 0;
      }

      function dataBoundFnGridDMSOne(e) {
        dataBoundFnBase(e);
        var total = vm.GridDMSOne.dataSource.total();
        vm.isCollapsedPanelDMSOne = total == 0;
      }

      function dataBoundGridCSTicketGridItem(e) {
        dataBoundFnBase(e);
        var total = vm.GridCSTicketGridItem.dataSource.total();
        vm.isCollapsedPanelDMSOne = total == 0;
      }

      function dataBoundFnGridContract(e) {
        dataBoundFnBase(e);
        var total = vm.GridContract.dataSource.total();
        vm.isCollapsedPanelContract = total == 0;
      }
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Project: {
        url: '/Project',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'Project.ProjectNav',
        ncyBreadcrumb: {
          label: 'Projekt modul',
          parent: 'main',
        },
      },
      'Project.ProjectNav': {
        url: '/nav',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectNav.html',
            controller: 'ProjectNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ListOptions/'),
        },
        params: {
          module: 'Project',
          formMode: 'Nav',
          documentEntity: 'project_projectnav',
        },
        ncyBreadcrumb: {
          label: 'Project navigáció',
        },
      },
      'Project.DasDocumentsNav': {
        url: '/list/:tableId/:ownerId',
        params: {
          module: 'documents',
          formMode: 'Nav',
          backTo: 'Nav',
          lockPreviousState: true,
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Das/Documents/DocumentsNav.html',
            controller: 'DocumentsNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Das/Documents/DocumentsListOptions/'),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum csatolás',
        },
      },
      'Project.ProjectEdit': {
        url: '/projectedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectEdit.html',
            controller: 'ProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.ProjectNav',
          documentEntity: 'project_projectedit',
        },
        ncyBreadcrumb: {
          label: 'Főprojekt',
        },
      },
      'Project.ProjectCreate': {
        url: '/projectcreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectEdit.html',
            controller: 'ProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.ProjectNav',
          documentEntity: 'project_projectedit',
        },
        ncyBreadcrumb: {
          label: 'Főprojekt',
        },
      },
      'Project.ProjectDuplicate': {
        url: '/ProjectDuplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectEdit.html',
            controller: 'ProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.ProjectNav',
          documentEntity: 'project_projectedit',
        },
        ncyBreadcrumb: {
          label: 'Főprojekt',
        },
      },
      'Project.ProjectView': {
        url: '/ProjectView/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectEdit.html',
            controller: 'ProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: true,
          },
          EditOrDuplicate: 'Edit',
          BackTo: 'ProjectNav',
          module: 'Project',
          documentEntity: 'project_projectedit',
        },
        ncyBreadcrumb: {
          label: 'Főprojekt',
        },
      },
      'Project.SubProjectEdit': {
        url: '/subprojectedit/{id:int}/{mainProjectId:int}/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/SubProjectEdit.html',
            controller: 'SubProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectEdit/', undefined, ['id', 'mainProjectId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.ProjectNav',
          projectId: ['projectId'],
          activeSubItemTab: ['activeSubItemTab'],
          documentEntity: 'project_subprojectedit',
        },
        ncyBreadcrumb: {
          label: 'Alprojekt',
        },
      },
      'Project.SubProjectCreate': {
        url: '/subprojectcreate/{id:int}/{mainProjectId:int}/',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/SubProjectEdit.html',
            controller: 'SubProjectEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Project/ProjectCreate/', undefined, ['id', 'mainProjectId']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.ProjectNav',
          projectId: ['projectId'],
          activeSubItemTab: ['activeSubItemTab'],
          documentEntity: 'project_subprojectedit',
        },
        ncyBreadcrumb: {
          label: 'Alprojekt',
        },
      },
      //"Project.ProjectMasterData": {
      //    url: "/masterdata?selectedMasterData",
      //    params: {
      //        module: "Project",
      //        formMode: "Nav"
      //    },
      //    views: {
      //        "menu": {
      //            templateUrl: "App/TileMenu.html",
      //            controller: "ProjectMenuCtrl as vm"
      //        },
      //        "content": {
      //            templateUrl: "App/MasterData/Project/ProjectMasterData.html",
      //            controller: "ProjectMasterDataCtrl as vm",
      //            resolve: {
      //                options: RouteResolveFunc("Project/ProjectMasterDataListOptions/", undefined, ["selectedMasterData"])
      //            }
      //        }
      //    },
      //    ncyBreadcrumb: {
      //        label: "Projekt"
      //    }
      //},
      'Project.ProjectSpecializationEdit': {
        url: '/projectSpecializationEdit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('ProjectMasterData/SpecializationEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Edit',
          backTo: 'Masterdata.Project.SpecializationList',
          documentEntity: 'masterdata_project_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület',
        },
      },
      'Project.ProjectSpecializationCreate': {
        url: '/projectSpecializationCreate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('ProjectMasterData/SpecializationCreate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          Operation: 'Create',
          backTo: 'Masterdata.Project.SpecializationList',
          documentEntity: 'masterdata_project_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület',
        },
      },
      'Project.ProjectSpecializationDuplicate': {
        url: '/projectSpecializationDuplicate/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/MasterData/Project/ProjectSpecializationEdit.html',
            controller: 'ProjectSpecializationEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('ProjectMasterData/SpecializationDuplicate/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Duplicate',
          Operation: 'Duplicate',
          backTo: 'Masterdata.Project.SpecializationList',
          documentEntity: 'masterdata_project_specialization',
        },
        ncyBreadcrumb: {
          label: 'Szakterület másolása',
        },
      },
      'Project.ProjectIngredientEdit': {
        url: '/projectIngredientEdit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Project/ProjectIngredientEdit.html',
            controller: 'ProjectIngredientEditCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveFunc('Project/ProjectIngredientEdit/', undefined, ['id']),
        },
        params: {
          controllerOptions: {
            isFormReadOnly: false,
          },
          EditOrDuplicate: 'Edit',
          backTo: 'Project.SubProjectEdit',
          projectId: ['projectId'],
          mainProjectId: ['mainProjectId'],
          activeSubItemTab: ['activeSubItemTab'],
        },
        ncyBreadcrumb: {
          label: 'Hely/berendezés',
        },
      },
      'Project.HistoryNav': {
        url: '/history/:tableId/:idColumn/:ownerId',
        params: {
          module: 'history',
          formMode: 'Nav',
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ProjectMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/History/HistoryNav.html',
            controller: 'HistoryNavCtrl as vm',
          },
        },
        resolve: {
          model: RouteResolveParamFunc('Project/{tableId}History/', undefined, ['tableId', 'idColumn', 'ownerId']),
        },
        ncyBreadcrumb: {
          label: 'Történetiségi adatok',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('ProjectMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.backTo;

      if (backTo == 'Nav') {
        backMenu.event = function() {
          $state.go('Project.ProjectNav');
        };
      } else if (backTo === 'Project.ProjectNav') {
        backMenu.event = function() {
          $state.go('Project.ProjectNav');
        };
      } else {
        backMenu.state = 'main';
      }

      var desc = {
        Project_ProjectNav: { icon: 'fa fa-exchange' },
        Masterdata_Project: { icon: 'fa fa-exchange' },
      };

      buildMenu($state, authService, 'Project', 'project', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectNavCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'AuthService',
    '$httpParamSerializer',
    'options',
    'HistoryService',
    'WalService',
    'DasService',
    'UIHelperService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      authService,
      $httpParamSerializer,
      options,
      HistoryService,
      walService,
      dasService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectNavCtrl', stateParams);
      }
      $scope.myFilter = function(item) {
        return item.gridName !== 'GridSubprojects';
      };

      var vm = this;
      vm.UIHelperService = UIHelperService;

      vm.viewProject = viewProject;
      vm.createMainProject = createMainProject;
      vm.createSubProject = createSubProject;
      vm.editProject = editProject;
      vm.deleteProject = deleteProject;
      vm.duplicateProject = duplicateProject;
      vm.attachDocument = attachDocument;
      vm.editComments = editComments;
      vm.WAL = WAL;

      vm.usedProjectGridEnum = Object.freeze({ MAIN: 1, SUB: 2 });

      vm.History = history;

      vm.back = function() {
        $state.go('main');
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        PlannedYear: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        FinancingName: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        PropertyName: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        BudgetName: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        PriorityName: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
        MainProjectName: function(selectedItem) {
          vm.mainGrid.dataSource.read();
        },
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.formModel = vm.dataModel;

        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

        vm.filter = filter;

        vm.getFilter = function() {
          return {
            dto: vm.formModel,
          };
        };

        initMainGrid(
          vm,
          'Gridprojects',
          'Project/PProjectList/',
          function() {
            changeSubItemGridFilter(vm.mainGrid);
          },
          vm.getFilter
        );

        initSubGrids(
          vm,
          'Project',
          function() {
            return {
              mainProjectId: vm.selectedMainGridItemId,
            };
          },
          ['PanelSubprojects', 'PanelMainProject', 'Panelprojectsvalue']
        );

        generateForm(vm);

        vm.filterFields = vm.FormlyFormPanelDescriptors.Panelfilter.FormlyDescriptor;

        angular.forEach(vm.mainGridOptions.columns, function(val, key) {
          if (val.field === 'StatusName') {
            val.template = "<div class='statusName' style='background-color: #: Color #;'>#: StatusName #</div>";
          }
          if (val.field === 'SubProjectStatus') {
            val.template = '#= SubProjectStatus #';
            if (val.template === null) {
              val.template = '';
            }
          }
        });

        angular.forEach(vm.subGridOptions['GridSubprojects'].columns, function(val, key) {
          if (val.field === 'StatusName') {
            val.template = "<div class='statusName' style='background-color: #: Color #;'>#: StatusName #</div>";
          }
        });
      }

      $scope.gridOnSelection = function(kendoEvent) {
        subGridChanged();
      };

      function changeSubItemGridFilter(targetGrid) {
        vm.selectedSubGridItem = null;

        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);

        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          if (value === 'GridSubprojects') {
            subGridRefs[value] = $('#' + value + '-' + vm.selectedMainGridItemId).data('kendoGrid');
          } else {
            subGridRefs[value] = $('#' + value).data('kendoGrid');
          }
        });
        //ha nem lenyitjuk csak kijelöljök, a subGridRefs Gridjei undefined-ok, erre a plusz ellenőrzés
        angular.forEach(subGridRefs, function(value, key) {
          if (!!value) {
            value.dataSource.read();
          }
        });
      }

      function subGridChanged() {
        vm.selectedMainGridItemId = getSelectedRowIdFromMainGrid(vm);

        if (!!vm.selectedMainGridItemId) {
          var selectedSubGrid = $('#GridSubprojects-' + vm.selectedMainGridItemId).data('kendoGrid');
          if (!!selectedSubGrid) {
            var selectedSubGridItem = getSelectedSubGridItem(selectedSubGrid);
            if (!!selectedSubGridItem) {
              vm.selectedSubGridItem = selectedSubGridItem;
            }
          }
        }
      }

      function filter() {
        vm.mainGrid.dataSource.read();
      }

      function viewProject() {
        var selectedItemsId = getSelectedRowIdFromMainGrid(vm);
        if (!!selectedItemsId) {
          $state.go('Project.ProjectView', { id: selectedItemsId });
        } else {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        }
      }

      function createMainProject() {
        $state.go('Project.ProjectCreate', { id: 0, mainProjectId: null });
      }

      function editProject() {
        if (vm.selectedSubGridItem) {
          var id = vm.selectedSubGridItem.ProjectId;
          var mainProjectId = vm.selectedSubGridItem.MainProjectId;

          if (!!id && id > 0) {
            $state.go('Project.SubProjectEdit', { id: id, mainProjectId: mainProjectId });
          } else {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          }
        } else {
          var selectedItem = getSelectedMainGridItem();
          if (!!selectedItem) {
            var id = selectedItem.ProjectId;

            if (!!id && id > 0) {
              $state.go('Project.ProjectEdit', { id: id, mainProjectId: null });
            } else {
              toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
            }
          }
        }
      }

      function createSubProject() {
        var selectedItem = getSelectedMainGridItem();
        if (selectedItem) {
          var mainProjectId = selectedItem.ProjectId;

          if (!!mainProjectId && mainProjectId > 0) {
            $state.go('Project.SubProjectCreate', { id: 0, mainProjectId: mainProjectId });
          } else {
            toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          }
        }
      }

      function deleteProject() {
        // Fő- vagy Alprojekt törlése kijelöléstől függően
        var selectedItem = getSelectedMainGridItem();
        if (selectedItem) {
          var id = vm.selectedSubGridItem !== null ? vm.selectedSubGridItem.ProjectId : selectedItem.ProjectId;
          if (!!id && id > 0) {
            var url = 'Project/ProjectDelete?id=' + id;
            var dialogMessage = vm.messages.DialogConfirmDelete;
            bootbox.dialog({
              message: dialogMessage,
              title: vm.messages.Warning,
              buttons: {
                cancel: {
                  label: vm.messages.Cancel,
                  className: 'btn-default',
                  callback: function() {},
                },
                confirm: {
                  label: vm.messages.Ok,
                  className: 'btn-primary',
                  callback: function() {
                    $http
                      .get(url)
                      .then(function(response) {
                        toastr.success(vm.messages.DeleteSuccessful);
                        vm.mainGrid.dataSource.read();
                      })
                      .catch(function(response) {
                        toastr.error(vm.pageModel.Messages.DeleteFailed);
                      });
                  },
                },
              },
            });
          }
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Equipment.DasDocumentsNav', 'FlgEquipment', id);
      }

      function duplicateProject() {
        var selectedItems = getSelectedMainGridItem();
        if (!!selectedItems && selectedItems.length !== 0) {
          var id = selectedItems[vm.mainGridIdField];
          $state.go('Project.ProjectDuplicate', { id: id });
        }
      }
      function attachDocument() {}

      function duplicateProject() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          var id = selectedItems[0][vm.mainGridIdField];
          $state.go('Project.ProjectDuplicate', { id: id });
        }
      }

      function attachDocument() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        var id = !!selectedItems[0] ? selectedItems[0][vm.mainGridIdField] : null;
        dasService.NavigateToDas(vm.messages, 'Project.DasDocumentsNav', 'FlgProject', id);
      }

      function editComments() {}

      function getSelectedSubGridItem(grid) {
        var selectedItems = GetSelectedGridItems(grid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedMainGridItem() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }

      function history() {
        var selectedItem = getSelectedMainGridItem();
        if (!!selectedItem) {
          HistoryService.NavigateToHistory('FlgProject', selectedItem, vm, $state, true);
        }
      }

      function WAL(whichGrid) {
        switch (whichGrid) {
          case vm.usedProjectGridEnum.MAIN:
            walService.NavigateToWal('Project', 'ProjectProjectNavWal', 'FlgPProject');
            break;
          case vm.usedProjectGridEnum.SUB:
            debugger;
            switch (vm.activeSubItemTab) {
              case 0:
                walService.NavigateToWal('Project', 'ProjectProjectValueView1Wal', 'FlgProjectValueView1');
                break;
              case 1:
                walService.NavigateToWal('Project', 'ProjectProjectValueView2Wal', 'FlgProjectValueView2');
                break;
            }
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    'WalService',
    'DasService',
    'LockService',
    'UIHelperService',
    function(
      $http,
      options,
      $state,
      $stateParams,
      $uibModal,
      AuthService,
      $scope,
      walService,
      dasService,
      lockService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.createSubProject = createSubProject;
      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.isEdit = isEdit;

      vm.WAL = WAL;

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.attachDocument = attachDocument;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Project.ProjectNav');
      };

      if (vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.formModifiers = {};

      var onChangeFunctions = {
        ProjectTypeId: function(selectedItem) {
          var currentUrl =
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read
              .url;
          if (currentUrl.indexOf('?') > -1) {
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.url = currentUrl.substring(
              0,
              currentUrl.indexOf('?')
            );
          }

          vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            projectTypeId: selectedItem.key,
          });
        },
      };

      var customExpressionProperties = {
        ProjectCode: {
          'templateOptions.required': function() {
            return vm.formModel.ModelState !== 2;
          },
        },
      };

      //Insert static validators / formatters / parsers
      if (!!vm.formModifiers || !(vm.controllerOptions.isFormReadOnly || vm.formModel.IsReadOnly)) {
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.url =
        'Project/ProjectBudgetList?projectTypeId=' + vm.formModel.ProjectTypeId;

      vm.pageModel.Fields.TechnicalContent.FormlyFieldDescriptor.type = 'textarea';

      delete vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      delete vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      delete vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      if (vm.formModel.ModelState === 1) {
        vm.pageModel.Fields.ModName.FormlyFieldDescriptor.templateOptions.required = 'false';
      }

      initSubGrids(
        vm,
        'Project',
        function() {
          return {
            PProjectId: vm.formModel.PProjectId,
          };
        },
        ['PanelProjectPlannedValue2', 'PanelProjectStatus']
      );

      function isEdit() {
        return vm.formModel.ModelState === 3;
      }

      // Actions
      function save() {
        var params = { model: vm.formModel, isMainProject: true };
        $http
          .post('Project/ProjectSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);

            if (response) {
              if (response.projectId && response.projectId > 0) {
                $state.go('Project.ProjectEdit', { id: response.projectId });
              } else {
                lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
                $state.go('Project.ProjectNav');
              }
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createSubProject() {
        // TODO: Új alprojekt felvétele
        $state.go('Project.SubProjectEdit', { id: 0, mainProjectId: vm.formModel.PProjectId });
      }

      function createSubItem() {
        var id = 0;
        var name =
          'Project' +
          vm.subGrids[vm.activeSubItemTab]
            .replace(/grid/gi, '')
            .replace(/project/gi, '')
            .replace('2', '') +
          'Edit';
        var url = 'Project/' + name + '?id=' + id;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/Project/' + name + '.html',
          controller: name + 'Ctrl',
          controllerAs: 'vm',
          resolve: {
            projectId: vm.formModel.PProjectId,
            isMainProject: true,
            model: RouteResolveFunc(url),
          },
        });

        modalInstance.result.then(function() {
          vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
        });
      }

      function editSubItem() {
        var id = getSelectedGridItemId(vm.subItemTabs[vm.activeSubItemTab].gridName);

        if (!!id) {
          var name =
            'Project' +
            vm.subGrids[vm.activeSubItemTab]
              .replace(/grid/gi, '')
              .replace(/project/gi, '')
              .replace('2', '') +
            'Edit';
          var url = 'Project/' + name + '?id=' + id;

          var modalInstance = $uibModal.open({
            templateUrl: 'App/Project/' + name + '.html',
            controller: name + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              projectId: vm.formModel.PProjectId,
              isMainProject: true,
              model: RouteResolveFunc(url),
            },
          });

          modalInstance.result.then(function() {
            vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
          });
        }
      }

      function deleteSubItem() {
        var id = getSelectedGridItemId(vm.subItemTabs[vm.activeSubItemTab].gridName);
        if (!!id) {
          var url =
            'Project/' +
            vm.subItemTabs[vm.activeSubItemTab].gridName.replace(/grid/gi, '').replace('2', '') +
            'Delete?id=' +
            id;
          var dialogMessage = vm.messages.DeleteDialogConfirmMessage;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .success(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
                    })
                    .error(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function attachSubItem() {}

      function attachDocument() {
        var id = vm.formModel.EqId;
        dasService.NavigateToDas(vm.messages, 'Equipment.DasDocumentsNav', 'FlgEquipment', id);
      }

      function getSelectedGridItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }

      function WAL() {
        switch (vm.activeSubItemTab) {
          case 0: // Keretértékek
            walService.NavigateToWal('Project', 'ProjectMODProjectValueView1Wal', 'FlgProjectPlannedValueView2');
            break;
          case 1: // Státuszok
            walService.NavigateToWal('Project', 'PartnerMODPartAddressNavWal', 'FlgProjectStatusView');
            break;
          default:
            break;
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SubProjectEditCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$uibModal',
    'AuthService',
    '$scope',
    function($http, options, $state, $stateParams, $uibModal, AuthService, $scope) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SubProjectEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = options.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.createSubItem = createSubItem;
      vm.editSubItem = editSubItem;
      vm.deleteSubItem = deleteSubItem;
      vm.isEdit = isEdit;

      vm.back = function() {
        $state.go('Project.ProjectNav');
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        ProjectTypeId: function(selectedItem) {
          var currentUrl =
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read
              .url;
          if (currentUrl.indexOf('?') > -1) {
            vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.url = currentUrl.substring(
              0,
              currentUrl.indexOf('?')
            );
          }

          vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.read({
            projectTypeId: selectedItem.key,
          });
        },
      };

      var customExpressionProperties = {
        ProjectCode: {
          'templateOptions.required': function() {
            return vm.formModel.ModelState !== 2;
          },
        },
      };

      //Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
        InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.BudgetId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.url =
        'Project/ProjectBudgetList?projectTypeId=' + vm.formModel.ProjectTypeId;

      vm.pageModel.Fields.TechnicalContent.FormlyFieldDescriptor.type = 'textarea';

      delete vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible1.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      delete vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible2.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      delete vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoComboBox.html';
      vm.pageModel.Fields.Responsible3.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      if (vm.formModel.ModelState === 1) {
        vm.pageModel.Fields.ModName.FormlyFieldDescriptor.templateOptions.required = 'false';
      }

      angular.forEach(vm.pageModel.Fields, function(val, key) {
        if (key === 'MainProjectId' || key === 'MainProjectName') {
          val.FormlyFieldDescriptor.hide = false;
        }
      });

      initSubGrids(
        vm,
        'Project',
        function() {
          return {
            PProjectId: vm.formModel.PProjectId,
          };
        },
        [
          'PanelProjectPlannedValue',
          'PanelProjectIngredient',
          'PanelProjectStatus',
          'PanelProjectTenderValue',
          'PanelInvocie',
        ]
      );

      angular.forEach(vm.subGridOptions.GridProjectTenderValue.columns, function(val, key) {
        if (val.field === 'IsUsed') {
          val.template = '<input type="checkbox" #: IsUsed === "true" ? "checked" : "" # disabled/>';
        }
      });

      function isEdit() {
        return vm.formModel.ModelState === 3;
      }

      // Actions
      function save() {
        var params = { model: vm.formModel, isMainProject: false };
        $http
          .post('Project/ProjectSave', params)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);

            if (response) {
              if (response.projectId && response.projectId > 0) {
                $state.go('Project.SubProjectEdit', { id: response.projectId });
              } else {
                $state.go('Project.ProjectNav');
              }
            }
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function createSubItem() {
        var id = 0;
        var name = 'Project' + vm.subGrids[vm.activeSubItemTab].replace(/grid/gi, '').replace(/project/gi, '') + 'Edit';
        var url = 'Project/' + name + '?id=' + id;

        if (name === 'ProjectIngredientEdit') {
          $state.go('Project.ProjectIngredientEdit', {
            id: id,
            projectId: vm.formModel.PProjectId,
            mainProjectId: vm.formModel.MainProjectId ? vm.formModel.MainProjectId.Value : null,
            activeSubItemTab: vm.activeSubItemTab,
          });
        } else {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/Project/' + name + '.html',
            controller: name + 'Ctrl',
            controllerAs: 'vm',
            resolve: {
              projectId: vm.formModel.PProjectId,
              isMainProject: false,
              model: RouteResolveFunc(url),
            },
          });

          modalInstance.result.then(function() {
            vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
          });
        }
      }

      function editSubItem() {
        var id = getSelectedGridItemId(vm.subItemTabs[vm.activeSubItemTab].gridName);

        if (!!id) {
          var name =
            'Project' + vm.subGrids[vm.activeSubItemTab].replace(/grid/gi, '').replace(/project/gi, '') + 'Edit';
          var url = 'Project/' + name + '?id=' + id;

          if (name === 'ProjectIngredientEdit') {
            $state.go('Project.ProjectIngredientEdit', {
              id: id,
              projectId: vm.formModel.PProjectId,
              mainProjectId: vm.formModel.MainProjectId ? vm.formModel.MainProjectId.Value : null,
              activeSubItemTab: vm.activeSubItemTab,
            });
          } else {
            var modalInstance = $uibModal.open({
              templateUrl: 'App/Project/' + name + '.html',
              controller: name + 'Ctrl',
              controllerAs: 'vm',
              resolve: {
                projectId: vm.formModel.PProjectId,
                isMainProject: false,
                model: RouteResolveFunc(url),
              },
            });

            modalInstance.result.then(function() {
              vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
            });
          }
        }
      }

      function deleteSubItem() {
        var id = getSelectedGridItemId(vm.subItemTabs[vm.activeSubItemTab].gridName);
        if (!!id) {
          var url = 'Project/' + vm.subItemTabs[vm.activeSubItemTab].gridName.replace(/grid/gi, '') + 'Delete?id=' + id;
          var dialogMessage = vm.messages.DeleteDialogConfirmMessage;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(url)
                    .success(function() {
                      toastr.success(vm.messages.DeleteSuccessful);
                      vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
                    })
                    .error(function(response) {
                      toastr.error(vm.pageModel.Messages.DeleteFailed);
                    });
                },
              },
            },
          });
        }
      }

      function attachSubItem() {}

      function getSelectedGridItem(gridName) {
        var selectedItems = GetSelectedGridItems(vm.subGrids[gridName]);
        if (selectedItems.length === 0) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
          return null;
        } else {
          return selectedItems[0];
        }
      }

      function getSelectedGridItemId(gridName) {
        var item = getSelectedGridItem(gridName);
        if (!!item) {
          return item[vm.pageModel.Grids[gridName].IdColumn];
        }
        return null;
      }

      if (!isNaN($stateParams.activeSubItemTab)) vm.activeSubItemTab = $stateParams.activeSubItemTab;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectPlannedValueEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'projectId',
    'isMainProject',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      projectId,
      isMainProject,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectPlannedValueEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.currentVat = 1;

      vm.formModifiers = {};

      var onChangeFunctions = {
        FinancialYearId: function(selectedItem) {
          if (!!selectedItem && !!selectedItem.key) {
            var id = parseInt(selectedItem.key);
            if (!!id) {
              $http({
                method: 'GET',
                url: 'Project/GetMainProjectPlannedValueForSelectedYear/',
                params: { projectId: projectId, financialYearId: id },
              }).then(function successCallback(response) {
                vm.formModel.Reminder = response.data.Reminder;
              });
            }
          }
        },
        PlannedNetValue: function(selectedItem) {
          if (!!vm.formModel.VatCodeId) {
            vm.formModel.GrossValue = vm.formModel.PlannedNetValue * (vm.currentVat / 100 + 1);
          }
        },
        VatCodeId: function(selectedItem) {
          if (!!selectedItem) {
            vm.currentVat = selectedItem.Vat;
            vm.formModel.GrossValue = vm.formModel.PlannedNetValue * (vm.currentVat / 100 + 1);
          }
        },
      };

      var customExpressionProperties = {
        PlannedNetValue: {
          'templateOptions.disabled': function() {
            if (!!vm.formModel.VatCodeId) {
              vm.formModel.GrossValue = vm.formModel.PlannedNetValue * (vm.currentVat / 100 + 1);
            }

            return false;
          },
        },
      };

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);

      if (isMainProject) {
        vm.pageModel.Labels['LabelTitleNew'].Title = 'Új keretérték felvétele';
        vm.pageModel.Labels['LabelTitleModify'].Title = 'Keretérték módosítása';

        angular.forEach(vm.pageModel.Fields, function(val, key) {
          if (key === 'FinancialYearId' || key === 'PlannedNetValue') {
            val.FormlyFieldDescriptor.hide = false;
            if (key === 'PlannedNetValue') {
              val.FormlyFieldDescriptor.templateOptions.label = 'Nettó keretérték (eFt)';
            }
          } else {
            val.FormlyFieldDescriptor.hide = true;
          }
        });
      }

      // Actions
      function save() {
        var params = { model: vm.formModel, projectId: projectId };

        $http
          .post('Project/ProjectPlannedValueSave', params)
          .success(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .error(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ProjectIngerientId;
        dasService.NavigateToDas(vm.messages, 'Project.DasDocumentsNav', 'FlgProjectPlannedValue', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectStatusEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'projectId',
    'isMainProject',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      projectId,
      isMainProject,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectStatusEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      delete vm.pageModel.Fields.DateFrom.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.DateFrom.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoDatePicker.html';
      vm.pageModel.Fields.DateFrom.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      vm.pageModel.Fields.StatusMasterId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { isMainProject: isMainProject };
      };

      // Set editability of fields
      if (vm.formModel.ModelState === 3 && !vm.formModel.IsActive) {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          if (key !== 'Valid') {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          }
        });
      }

      // Actions
      function save() {
        vm.formModel.ProjectId = projectId;

        $http
          .post('Project/ProjectStatusSave', vm.formModel)
          .success(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            uibModalInstance.close();
          })
          .error(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ProjectStatusId;
        dasService.NavigateToDas(vm.messages, 'Project.DasDocumentsNav', 'FlgProjectStatus', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectIngredientEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectIngredientEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.back = function() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Project.SubProjectEdit', {
          id: $stateParams.projectId,
          mainProjectId: $stateParams.mainProjectId,
          activeSubItemTab: $stateParams.activeSubItemTab,
        });
      };

      vm.attachDocument = function() {
        var id = vm.formModel.ProjectIngerientId;
        dasService.NavigateToDas(vm.messages, 'Project.DasDocumentsNav', 'FlgProjectIngredient', id);
      };

      vm.formModifiers = {};

      var onChangeFunctions = {
        ZoneId: function(selectedItem) {
          vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          vm.formModel.OpUnitId = null;
          SetObjectIdOtherParams();
          vm.formModel.ObjectId = null;
        },
        OpUnitId: function(selectedItem) {
          SetObjectIdOtherParams();
          vm.formModel.ObjectId = null;
        },
        ObjectId: function(selectedItem) {
          if (selectedItem !== undefined) {
            SetBuildingIdOtherParams();
            if (selectedItem === null) vm.formModel.BuildingId = null;
          }
        },
        BuildingId: function(selectedItem) {
          if (selectedItem !== undefined) {
            SetPremiseIdOtherParams();
            if (selectedItem === null) vm.formModel.PremiseId = null;
            vm.pageModel.Fields.ConstructionId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
        PremiseId: function(selectedItem) {
          if (selectedItem !== undefined) {
            vm.formModel.Stairway = selectedItem ? selectedItem.StairWay : null;
            vm.formModel.AnnexeName = selectedItem ? selectedItem.AnnexeName : null;
            vm.formModel.Block = selectedItem ? selectedItem.BlockName : null;
            vm.formModel.Floor = selectedItem ? selectedItem.Floor : null;
            vm.pageModel.Fields.InventoryId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          }
        },
      };

      //Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.pageModel.Fields.OpUnitId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { ZoneId: vm.formModel.ZoneId };
      };

      vm.pageModel.Fields.ConstructionId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { buildingId: vm.formModel.BuildingId ? vm.formModel.BuildingId.Value : null };
      };

      vm.pageModel.Fields.InventoryId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { premiseId: vm.formModel.PremiseId ? vm.formModel.PremiseId.Value : null };
      };

      function SetObjectIdOtherParams() {
        vm.pageModel.Fields.ObjectId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          zoneId: vm.formModel.ZoneId,
          opUnitId: vm.formModel.OpUnitId,
        };
      }

      function SetBuildingIdOtherParams() {
        vm.pageModel.Fields.BuildingId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          objectId: vm.formModel.ObjectId != null ? vm.formModel.ObjectId.Value : null,
        };
      }

      function SetPremiseIdOtherParams() {
        vm.pageModel.Fields.PremiseId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          buildingId: vm.formModel.BuildingId != null ? vm.formModel.BuildingId.Value : null,
        };
      }

      SetBuildingIdOtherParams();
      SetObjectIdOtherParams();
      SetPremiseIdOtherParams();

      // Actions
      function save() {
        vm.formModel.ProjectId = $stateParams.projectId;
        $http
          .post('Project/ProjectIngredientSave', vm.formModel)
          .success(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            $state.go('Project.SubProjectEdit', {
              id: $stateParams.projectId,
              mainProjectId: $stateParams.mainProjectId,
              activeSubItemTab: $stateParams.activeSubItemTab,
            });
          })
          .error(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        $state.go('Project.SubProjectEdit', {
          id: $stateParams.projectId,
          mainProjectId: $stateParams.mainProjectId,
          activeSubItemTab: $stateParams.activeSubItemTab,
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectTenderValueEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$uibModalInstance',
    'projectId',
    'LockService',
    function(
      $http,
      model,
      $state,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      uibModalInstance,
      projectId,
      lockService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectTenderValueEditCtrl', stateParams);
      }
      var vm = this;

      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.actions = model.pageModel.Actions;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.formModifiers = {};

      var onChangeFunctions = {
        PartnerId: function(selectedItem) {
          if (selectedItem !== undefined) {
            SetSupplyContrIdOtherParams();
            if (selectedItem === null) vm.formModel.SupplyContrId = null;
          }
        },
      };

      //Insert static validators / formatters / parsers
      if (!!vm.formModifiers) {
        InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      }

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      delete vm.pageModel.Fields.TenderDate.FormlyFieldDescriptor.type;
      vm.pageModel.Fields.TenderDate.FormlyFieldDescriptor.templateUrl = 'App/templates/formly/kendoDatePicker.html';
      vm.pageModel.Fields.TenderDate.FormlyFieldDescriptor.wrapper = ['bootstrapLabel', 'bootstrapHasError'];

      vm.pageModel.Fields.ProjectStatusMasterId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { projectId: projectId };
      };

      if (vm.formModel.ModelState === 2)
        vm.pageModel.Fields.SupplyContrId.FormlyFieldDescriptor.templateOptions.disabled = true;

      function SetSupplyContrIdOtherParams() {
        vm.pageModel.Fields.SupplyContrId.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          partnerId: vm.formModel.PartnerId != null ? vm.formModel.PartnerId.Value : null,
        };
      }

      SetSupplyContrIdOtherParams();

      // Actions
      function save() {
        vm.formModel.ProjectId = projectId;

        $http
          .post('Project/ProjectTenderValueSave', vm.formModel)
          .success(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            uibModalInstance.close();
          })
          .error(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
        uibModalInstance.dismiss('cancel');
      }

      vm.attachDocument = function() {
        var id = vm.formModel.ProjectTenderValueId;
        dasService.NavigateToDas(vm.messages, 'Project.DasDocumentsNav', 'FlgProjectTenderValue', id);
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectMasterDataCtrl', [
    'options',
    '$http',
    '$state',
    '$stateParams',
    'AuthService',
    'UIHelperService',
    function(options, $http, $state, $stateParams, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectMasterDataCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.grid = null;
      vm.subGrid = null;

      vm.back = function() {
        $state.go('main');
      };

      if (!$stateParams.type) {
        vm.type = '';
      } else {
        vm.type = $stateParams.type;
      }

      if (!$stateParams.module) {
        vm.module = '';
      } else {
        vm.module = $stateParams.module;
      }

      vm.typeChanged = setByType;

      vm.MDSelectorModel = {
        selectedData: '',
      };

      vm.MDSelectorFields = [
        {
          key: 'selectedData',
          type: 'kendoDDL',
          templateOptions: {
            required: true,
            label: 'Törzs',
            options: FormlyCreateDDLOption({
              url: 'ProjectMasterData/ListDDLOptions',
              transData: function() {
                return {
                  module: $stateParams.module,
                };
              },
              textField: 'text',
              valueField: 'key',
            }),
            changed: function(selectedItem) {
              vm.type = selectedItem.key;
              vm.typeChanged();
            },
          },
        },
      ];

      function setByType() {
        if (!!vm.type && vm.type !== '') {
          $state.go(vm.type + 'List');
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ProjectSpecializationEditCtrl', [
    '$http',
    'model',
    '$state',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    'LockService',
    'UIHelperService',
    function($http, model, $state, $stateParams, AuthService, $scope, dasService, lockService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ProjectSpecializationEditCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.controllerOptions = $stateParams.controllerOptions;
      vm.backTo = $stateParams.backTo;
      vm.actions = model.pageModel.Actions;
      vm.operation = $stateParams.Operation;
      vm.pageType = $stateParams.backTo.split('.')[1];
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      vm.securedProgramId = model.programId;
      vm.securedId = model.id;
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.pageModel.Fields.Arrangement.FormlyFieldDescriptor.templateOptions.required = false;
      vm.pageModel.Fields.Cost.FormlyFieldDescriptor.templateOptions.required = false;
      vm.pageModel.Fields.Delivery.FormlyFieldDescriptor.templateOptions.required = false;
      vm.pageModel.Fields.Product.FormlyFieldDescriptor.templateOptions.required = false;

      vm.SpecializationId = vm.formModel.SpecializationId;

      vm.UIHelperService.setDefaultSidebarStatus();
      if (vm.formModel.ModelState === 4) vm.formModel.SpecializationId = 0;

      //MenuItems
      vm.save = save;
      vm.cancel = cancel;

      vm.back = function() {
        // Unlock
        // This will spawn a modal what cannot be closed until the unlock is done
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);

        $('#ReactionTimeGrid')
          .data('kendoGrid')
          ?.clearSelection();
        $('#SpecializationLedgerCodeGrid')
          .data('kendoGrid')
          ?.clearSelection();
        $state.go(vm.backTo);
      };

      //vm.formModel.LedgerCodeList = [{},{},{}];
      //Sor törlés
      var onClickFunctions = {
        SpecializationLedgerCodeId: function(value, model, event, scope) {
          vm.formModel.LedgerCodeList = vm.formModel.LedgerCodeList.filter(item => item.$$hashKey !== model.$$hashKey);
        },
      };

      vm.readData = function() {
        let id = vm.ledgerCodeIdList.shift();
        return { ledgerCodeId: id };
      };

      if (!vm.formModel.LedgerCodeList) vm.formModel.LedgerCodeList = [];

      vm.ledgerCodeIdList = vm.formModel.LedgerCodeList?.map(x => x.LedgerCodeId);
      vm.pageModel.Fields.LedgerCodeValueId.transData = vm.readData;

      var onChangeFunctions = {
        LedgerCodeId: function(value, model, scope) {
          scope.fields
            .find(x => x.key == 'LedgerCodeValueId')
            .templateOptions.options.dataSource.read({
              ledgerCodeId: value.key,
            });
        },
      };

      InsertOnClickFunctions(vm.pageModel, onClickFunctions);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      // Generate Formly form descriptors from pageModel
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);

      // Extract fomrly panels to tabs
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );

      vm.reactionTimeGridOptions = getGridOptions(
        model.pageModel.Grids.GridReactionTime,
        'ProjectMasterData/ReactionTimeList/',
        function() {},
        { SpecializationId: vm.SpecializationId }
      );

      //--- Egyedi "Reakciók grid" beállítások:
      vm.reactionTimeGridOptions.disableOptions.GridStateRestore = true;
      vm.reactionTimeGridOptions.dataSource.serverPaging = false;
      vm.reactionTimeGridOptions.dataSource.serverSorting = false;
      vm.reactionTimeGridOptions.dataSource.serverFiltering = false;
      vm.reactionTimeGridOptions.dataSource.serverAggregates = false;
      vm.reactionTimeGridOptions.dataSource.serverGroupping = false;
      vm.reactionTimeGridOptions.editable = true;
      //vm.reactionTimeGridOptions.sortable = false;
      //vm.reactionTimeGridOptions.filterable = false;
      //vm.reactionTimeGridOptions.pageable = false;
      vm.reactionTimeGridOptions.selectable = 'cell';
      angular.forEach(vm.reactionTimeGridOptions.columns, function(val, key) {
        if (val.field === 'HelpDeskPriorityName') {
          val['editable'] = function() {
            return false;
          };
        }
        if (val.field === 'ServiceLevelName') {
          val['editable'] = function() {
            return false;
          };
        }
        if (val.field === 'ReactionTime') {
          val.format = '{0:n0} perc';
        }
      });
      //--- Vége: Egyedi "Reakciók grid" beállítások:

      vm.collapseBooleans = {
        headerIsCollapsed: false,
        specializationIsCollapsed: true,
        reactionIsCollapsed: true,
      };
      vm.activeBooleans = {
        headerIsActive: true,
        specializationIsActive: false,
        reactionIsActive: false,
      };

      //-------------------------------------------------------------------------------------

      vm.collapsePanel = function(indexName) {
        vm.collapseBooleans[indexName] = !vm.collapseBooleans[indexName];
        for (let b in vm.collapseBooleans) {
          if (b.valueOf() !== indexName) {
            vm.collapseBooleans[b] = true;
          }
        }
        for (let b in vm.activeBooleans) {
          vm.activeBooleans[b] = false;
        }

        switch (indexName) {
          case 'headerIsCollapsed':
            vm.activeBooleans['headerIsActive'] = true;
            break;
          case 'specializationIsCollapsed':
            vm.activeBooleans['specializationIsActive'] = true;
            break;
          case 'reactionIsCollapsed':
            vm.activeBooleans['reactionIsActive'] = true;
            break;
        }
      };

      // Actions
      function save() {
        var formData = {
          model: vm.formModel,
          reactionTime: $('#ReactionTimeGrid')
            .data('kendoGrid')
            .dataSource.data(),
        };

        $http
          .post('ProjectMasterData/' + vm.pageType + 'Specialization' + vm.operation, formData)
          .then(function(response) {
            toastr.success(vm.pageModel.Messages.SaveSuccessful);
            $('#ReactionTimeGrid')
              .data('kendoGrid')
              .clearSelection();
            $state.go(vm.backTo);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      }

      function cancel() {
        // Unlock
        // This will spawn a modal what cannot be closed until the unlock is done
        lockService.initiateUnlock(vm.securedProgramId, vm.securedId);

        $state.go('Masterdata.Project.SpecializationList');
      }

      vm.attachDocument = function() {
        var id = vm.formModel.SpecializationId;
        dasService.NavigateToDas(vm.messages, 'Equipment.DasDocumentsNav', 'FlgSpecialization', id);
      };

      if (vm.formModel.LedgerCode) {
        vm.formModel.LedgerCode.unshift({
          key: -1,
          text: '-Válasszon-',
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      backMenu.state = 'main'; //TODO: nem toltodik oldalso menu

      var desc = {
        ReportModule_Report: { icon: 'fa fa-file' },
      };

      vm.reportNav = function() {
        $state.go('ReportModul.ReportNav');
      };

      buildMenu($state, authService, 'ReportModul', 'report', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

var myApp = angular.module('myApp');

myApp.config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      ReportModul: {
        url: '/ReportModul',
        templateUrl: 'App/Report/ReportLayout.html',
        controller: 'ReportLayoutCtrl as vm',
        redirectTo: 'ReportModul.ReportNav',
        ncyBreadcrumb: {
          label: 'Riport modul',
          parent: 'main',
        },
      },
      'ReportModul.ReportNav': {
        url: '/reportnav',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'ReportMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Report/ReportNav.html',
            controller: 'ReportNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('ReportModule/ReportListOptions/'),
        },
        params: {
          module: 'report',
          formMode: 'Nav',
          backState: 'main',
        },
        ncyBreadcrumb: {
          label: 'Riport navigáció',
        },
      },
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('ReportLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    'UIHelperService',
    function($http, $state, $uibModal, $filter, authService, UIHelperService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportLayoutCtrl', stateParams);
      }
      var vm = this;
      vm.UIHelperService = UIHelperService;
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ReportNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    'WalService',
    function($scope, options, $http, $state, walService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ReportNavCtrl', stateParams);
      }
      var vm = this;

      // Init ////////////////////////////////////////////////////////////////////////////////
      vm.pageModel = options.pageModel;
      vm.formModel = options.dto;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      vm.selectedItem = undefined;

      vm.WAL = WAL;
      vm.back = function() {
        $state.go('main');
      };

      var onChangeFunctions = {
        ReportTable: function(selectedItem) {
          vm.selectedItem = selectedItem;
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      function WAL() {
        if (vm.selectedItem !== undefined) {
          walService.NavigateToWal('ReportModule', 'ReportModuleNavWal', vm.selectedItem.key);
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SandBoxMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SandBoxMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza' };
      var backTo = $state.params.BackTo;
      backMenu.state = 'main';

      var desc = {
        SandBox_SandBoxNav: { icon: 'fa fa-coffee' },
      };

      vm.sandboxNav = function() {
        $state.go('SandBox.SandBoxNav');
      };

      buildMenu($state, authService, 'SandBox', 'sandbox', backMenu, desc).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SandBoxLayoutCtrl', [
    '$http',
    '$state',
    '$uibModal',
    '$filter',
    'AuthService',
    function($http, $state, $uibModal, $filter, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'SandBoxLayoutCtrl', stateParams);
      }
      var vm = this;
    },
  ]);
})(angular.module('myApp'));

var myApp = angular.module('myApp');

myApp.config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      SandBox: {
        url: '/SandBox',
        templateUrl: 'App/SandBox/SandBoxLayout.html',
        controller: 'SandBoxLayoutCtrl as vm',
        redirectTo: 'SandBox.SandBoxNav',
        ncyBreadcrumb: {
          label: 'SandBox modul',
          parent: 'main',
        },
      },
      //TODO
      //nav
      //edit
      //duplicate
      //view
      //etc.
    };

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  app.directive('resize', function($window) {
    return function(scope) {
      var w = angular.element($window);
      scope.windowWidth = w.width();
      scope.windowHeight = w.height();
      w.on('resize', function() {
        scope.windowWidth = w.width();
        scope.windowHeight = w.height();
        if (!scope.$$phase) {
          scope.$apply();
        }
      });
    };
  });

  module.directive('f4Input', [
    '$http',
    'gridService',
    '$rootScope',
    function($http, gridService, $rootScope) {
      const { merge } = rxjs;
      const { tap } = rxjs.operators;

      return {
        restrict: 'E',
        require: 'ngModel',
        templateUrl: 'App/F4/f4.html',
        scope: {
          f4Values: '=ngModel',
          f4Options: '=',
          gridModel: '<',
          disabled: '=ngDisabled',
          required: '=',
          changed: '&',
          blur: '&',
          ngClick: '&',
          hideInput: '=',
          fieldKey: '<',
        },
        controller: [
          '$scope',
          '$rootScope',
          'AuthService',
          function($scope, $rootScope, authService) {
            $scope.disableGridState = function() {
              if (!!authService.parameters?.FWCOID) {
                $scope.f4Options.disableOptions = { GridStateSave: true, GridStateRestore: true };
              }
            };

            if (!authService?.parameters) {
              authService.getUserContext(false, $scope.disableGridState);
            } else {
              $scope.disableGridState();
            }
            //set precision
            $scope.gridModel?.Columns?.filter(
              x => ($scope.gridModel.DefaultPrecisionFields || []).indexOf(x.field) !== -1
            ).forEach(x => (x.format = '{0:n' + (authService.parameters?.DEFFPR || 2) + '}'));
          },
        ],
        link: function(scope, element, attrs, ngModCont) {
          // scope.f4Options.desktop = $( document ).width() > 1200;

          //  $( window ).on( "resize", function() {
          //   if($( document ).width() < 1201 && !scope.f4Options.showRight){
          //     element.find('.right-td').hide();
          //   }
          //   else {
          //     element.find('.right-td').show()
          //   }
          // } );

          scope.grids = { showRightGrid: true };
          $rootScope.$emit('$stateAndRefreshForElement', scope.f4Options);

          scope.f4id = 'f4_' + (scope.fieldKey || scope.f4Options.valueField);

          //disable while loading
          scope.initalized = false;
          //set up error handler
          if (!angular.isFunction(scope.f4Options.errorhandler)) {
            scope.f4Options.errorhandler = function(error) {
              alert(error);
            };
          }
          //Error strings
          scope.ErrorStrings = [];
          scope.ErrorStrings['maxItemCount'] = 'Maximálisan {0} elem választható!';
          scope.ErrorStrings['zeroItemCount'] = 'Nem választott ki elemet!';
          scope.f4Options.f4scope = scope;
          scope.justResult = function() {
            return !!scope.f4Options.singleTagType && scope.disabled;
          };

          scope.whereCondition = function() {
            var whereCondition = '';
            if (angular.isFunction(scope.f4Options.whereCondition)) {
              whereCondition = scope.f4Options.whereCondition();
            }
            return whereCondition;
          };

          scope.requestParams = function() {
            var transportData = {
              tableName: scope.f4Options.dataSourceTable,
              whereCondition: scope.whereCondition(),
              columnCsv: scope.f4Options.gridOptions.columnCsv,
              idColumn: scope.f4Options.gridOptions.tableKey,
              adopter: scope.f4Options.adopter,
            };

            if (scope.f4Options.gridOptions.selectById) {
              angular.extend(transportData, {
                selectById: scope.f4Options.gridOptions.selectById,
              });
            }

            if (scope.f4Options.gridOptions.secondId) {
              angular.extend(transportData, {
                secondId: scope.f4Options.gridOptions.secondId,
              });
            }

            if (scope.f4Options.gridOptions.addtitonalParams) {
              let _params = angular.isFunction(scope.f4Options.gridOptions.addtitonalParams)
                ? scope.f4Options.gridOptions.addtitonalParams()
                : scope.f4Options.gridOptions.addtitonalParams;
              angular.forEach(_params, function(v, k) {
                transportData[k] = v;
              });
            }
            return transportData;
          };

          function RaiseChanged() {
            if (angular.isFunction(scope.changed)) {
              scope.changed({
                selectedItems: scope.multiselectSelectedItems,
              });
            }
            if (angular.isFunction(scope.f4Options.InputChanged)) {
              scope.f4Options.InputChanged(scope);
            }
          }

          scope.updateMultiselectSelectedItems = function(e) {
            var ms = $('#' + scope.f4id).data('kendoMultiSelect'),
              selectedItems = ms?.$angular_scope?.multiselectSelectedItems;
            if (!!selectedItems && selectedItems.length != scope.multiselectSelectedItems.length) {
              scope.multiselectSelectedItems = selectedItems;
            }
            if (ms.dataSource?.data().length != scope.multiselectSelectedItems.length) {
              ms.dataSource?.data(angular.copy(scope.multiselectSelectedItems));
            }
            if (!scope.$$phase) {
              scope.$apply(function() {
                scope.refreshSelectedIds();
                if (!!scope.grids.gridRight && !!scope.grids.gridRight.dataSource) {
                  scope.grids.gridRight.dataSource?.data(angular.copy(scope.multiselectSelectedItems));
                }
                //scope.grids.showRightGrid = false;
                if (scope.grids.gridLeft?.dataSource) RaiseChanged();
              });
            }
          };

          //configure multiselect
          var getMultiselectParams = function() {
            var multiselectParams = scope.requestParams(); // angular.copy(scope.f4Options.otherParams);
            angular.extend(multiselectParams, {
              mandatoryIds: scope.f4Values,
              keyColumn: scope.f4Options.valueField,
              dynamicField: scope.f4Options.dynamicField,
            });
            return multiselectParams;
          };

          function CreateMultiselectOptions() {
            if (!!scope.selectOptions) return;
            scope.selectOptions = F4Helpers.CreateMultiselectOptions(
              {
                maxItemCount: scope.f4Options.maxItemCount,
                valueField: scope.f4Options.valueField,
                textField: scope.f4Options.textField,
                singleTagType: scope.f4Options.singleTagType,
                singleTagNumber: scope.f4Options.singleTagNumber,
                singleTagText: scope.f4Options.singleTagText,
                otherParams: getMultiselectParams,
                autoClose: false,
              },
              function(e) {
                //refresh model on selection changed - kendo events are not in digest
                if (!scope.$$phase) {
                  scope.$apply(function() {
                    ngModCont.$setViewValue(scope.f4Values);
                    scope.refreshSelectedIds();
                  });
                }
              },
              scope.updateMultiselectSelectedItems,
              scope.f4id
            );
          }

          scope.openF4Modal = function() {
            scope.$parent.$parent.$on('modal.closing', function(e) {
              if (!!element.find('.f4-modal.in').length) {
                e.preventDefault();
                e.preventDefault();
              }
            });
            $(document).on('keydown', function(evt) {
              if (evt.keyCode == 27) {
                evt.preventDefault();
                scope.cancelF4Modal();
              }
            });
            scope.grids.showRightGrid = true;
            element.find('.f4-modal').modal('show');
            if (!!scope.grids.gridLeft) {
              scope.grids.gridLeft.dataSource?.read();
            }
            if (!!scope.grids.gridRight) {
              scope.grids.gridRight.dataSource?.data(scope.multiselectSelectedItems);
              scope.grids.gridRight.origKendoConfig.dataSource.data = angular.copy(scope.multiselectSelectedItems);
              //scope.grids.gridRight.dataSource?.read();
            }
          };
          if (typeof scope.f4Options.disableOptions?.AutoComplete !== 'boolean') {
            if (!scope.f4Options.disableOptions) {
              scope.f4Options.disableOptions = {};
            }
            scope.f4Options.disableOptions.AutoComplete = true;
            scope.f4Options.disableOptions.FilterRestore = true;
          }
          scope.setF4Filter = function(filter, force = false) {
            let dataSource = scope.grids.gridLeft?.dataSource;
            if (!dataSource || (!force && !!dataSource?.filter().filters.length)) return;
            dataSource?.filter(filter);
          };
          scope.setF4Values = function(values, gridInit = false) {
            scope.f4Values = angular.copy(values);
            Promise.resolve()
              .then(async () => {
                if (scope?.f4Values === null || !angular.isArray(scope.f4Values) || scope.f4Values.length === 0) {
                  return [];
                } else {
                  return $http
                    .post('F22/SelectedItems', {
                      ids: scope.f4Values,
                      columnCsv: scope.f4Options.gridOptions?.columnCsv,
                      idColumn: scope.f4Options.gridOptions?.tableKey,
                      storeColumn: scope.f4Options.valueField,
                      tableName: scope.f4Options.dataSourceTable,
                      whereCondition: angular.isFunction(scope.f4Options.whereCondition)
                        ? scope.f4Options.whereCondition()
                        : '',
                      adopter: scope.f4Options.adopter,
                    })
                    .then(
                      result => {
                        return result.data.Data;
                      },
                      error => {
                        scope.f4Options.errorhandler(error.statusText);
                      }
                    );
                }
              })
              .then(selectedValues => {
                if (!!selectedValues) {
                  selectedValues = angular.copy(
                    selectedValues.sort((x, y) =>
                      localizeCompare(x[scope.f4Options.textField], y[scope.f4Options.textField])
                    )
                  );
                }
                scope.multiselectSelectedItems = angular.copy(selectedValues);
                scope.grids.gridRight?.dataSource?.data(angular.copy(scope.multiselectSelectedItems));
                CreateMultiselectOptions();

                const { gridOptions, filteringMode, errorHandler, selectionChanged } = scope.f4Options;
                const { tableKey, fields, sort, toolbar } = gridOptions;
                var columns =
                  gridOptions.columns ||
                  Object.keys(fields).map(function(fieldKey) {
                    return Object.assign({ field: key }, fields[fieldKey]);
                  });
                Object.keys(columns).map(function(fieldKey) {
                  columns[fieldKey].stickable = true;
                });
                var rightColumns = angular.copy(columns);
                var rightIdColumns = columns.filter(
                  x => x.field === scope.f4Options.textField || x.field === scope.f4Options.valueField
                );
                if (rightIdColumns.length == 2) {
                  rightColumns = rightColumns.map(x => {
                    x.hidden = x.field !== scope.f4Options.textField && x.field !== scope.f4Options.valueField;
                    return x;
                  });
                }
                if (gridInit) {
                  merge(
                    gridService
                      .restoreState(
                        gridService.buildKendoConfig({
                          autoBind: true,
                          gridId: `${scope.f4id}.Left`,
                          dataSourceOptions: {
                            url: gridOptions.customControllerMethod || 'F22/GridData',
                            schema: {
                              model: {
                                id: tableKey,
                                fields,
                              },
                              data: 'Data',
                              total: 'Total',
                              fields,
                            },
                            transportData: scope.requestParams,
                            errorHandler: function(error) {
                              var msg = 'F4 grid: ' + (error.errorThrown.message || error.errorThrown);
                              if (typeof errorHandler === 'function') {
                                errorHandler(msg);
                              } else {
                                alert(msg);
                              }
                            },
                            sort,
                          },
                          columns,
                          toolbar,
                          dataBound: function(e) {
                            var touchtimeL = 0;
                            $(`#${scope.f4id}\\.Left tr`).on('click', function() {
                              e.preventDefault();
                              e.preventDefault();
                              if (touchtimeL == 0) {
                                touchtimeL = new Date().getTime();
                              } else {
                                if (new Date().getTime() - touchtimeL < 800) {
                                  let row = e.sender.select();
                                  let item = e.sender.dataItem(row);
                                  if (scope.isSelected(item)) {
                                    let rightItem = scope.grids.gridRight?.dataItems().find(x => x.id === item.id);
                                    scope.pushSelectedLeft(rightItem);
                                  } else {
                                    scope.pushSelectedRight();
                                  }
                                  touchtimeL = 0;
                                } else {
                                  touchtimeL = new Date().getTime();
                                }
                              }
                            });
                            scope.refreshLeftTableRows();
                          },
                          disableOptions: scope.f4Options.disableOptions,
                          additionalOptions: {
                            pageSizes: [5, 10, 20],
                            textSizeCombo: true,
                            textSize: 16,
                            textChange: function(value) {
                              scope.grids.gridRight.textDDL?.value(value);
                              scope.grids.gridRight.textDDL?.trigger('change');
                            },
                          },
                        })
                      )
                      .pipe(
                        tap(restoredConfig => {
                          scope.gridLeftOptions = restoredConfig;
                        })
                      ),
                    gridService
                      .restoreState(
                        gridService.buildKendoConfig({
                          autoBind: true,
                          gridId: `${scope.f4id}.Right`,
                          dataSourceOptions: {
                            data: scope.multiselectSelectedItems ?? [],
                            schema: {
                              model: {
                                fields,
                              },
                              fields,
                            },
                            serverPaging: false,
                            serverSorting: false,
                            serverFiltering: false,
                            serverAggregates: false,
                            serverGrouping: false,
                          },
                          columns: rightColumns,
                          filterMode: filteringMode === 1 ? 'row' : undefined,
                          toolbar,
                          selectionChanged: function(e) {
                            if (typeof selectionChanged === 'function') {
                              selectionChanged();
                            }
                          },
                          dataBound: function(e) {
                            var touchtimeR;
                            $(`#${scope.f4id}\\.Right tr`).on('click', function() {
                              e.preventDefault();
                              e.preventDefault();
                              if (touchtimeR == 0) {
                                touchtimeR = new Date().getTime();
                              } else {
                                if (new Date().getTime() - touchtimeR < 800) {
                                  let row = e.sender.select();
                                  let item = e.sender.dataItem(row);
                                  if (scope.isSelected(item)) {
                                    scope.pushSelectedLeft(item);
                                  }
                                  touchtimeR = 0;
                                } else {
                                  touchtimeR = new Date().getTime();
                                }
                              }
                            });
                            scope.refreshLeftTableRows();
                          },
                          disableOptions: scope.f4Options.disableOptions,
                          additionalOptions: {
                            pageSizes: [5, 10, 20],
                            textSizeCombo: true,
                            textSize: 16,
                            textChange: function(value) {
                              scope.grids.gridLeft.textDDL?.value(value);
                              scope.grids.gridLeft.textDDL?.trigger('change');
                            },
                          },
                        })
                      )
                      .pipe(
                        tap(restoredConfig => {
                          scope.gridRightOptions = restoredConfig;
                        })
                      )
                  ).subscribe({
                    complete: () => {
                      scope.gridRightOptions.pageable.refresh = false;
                      scope.initalized = true;
                      var kendoMultiSelect = $('#' + scope.f4id).data('kendoMultiSelect');
                      if (!!kendoMultiSelect) {
                        kendoMultiSelect.$angular_scope.multiselectSelectedItems = scope.multiselectSelectedItems;
                      }
                    },
                  });
                }
              });
          };

          scope.setF4Values(scope.f4Values, true);

          function refreshF4Multiselect() {
            scope.multiselectSelectedItems = angular.copy(scope.grids.gridRight?.dataSource?.data());
            scope.refreshSelectedIds();
            scope.selectOptions.dataSource?.read();
            ngModCont.$setViewValue(scope.f4Values);
            var kendoMultiSelect = $('#' + scope.f4id).data('kendoMultiSelect');
            if (!!kendoMultiSelect) {
              kendoMultiSelect.$angular_scope.multiselectSelectedItems = scope.multiselectSelectedItems;
            }
            RaiseChanged();
          }

          scope.cancelF4Modal = function() {
            element.find('.f4-modal').modal('hide');
            element.find('.f4-grid-left, .f4-grid-right').each(function() {
              gridService.saveKendoGrid($(this).data('kendoGrid'));
            });
          };

          scope.okF4Modal = function() {
            if (scope.grids.gridRight?.dataSource?.data().length === 0) {
              toastr.warning(scope.ErrorStrings['zeroItemCount']);
            }
            if (scope.grids.gridRight?.dataSource?.data().length > scope.f4Options.maxItemCount) {
              scope.f4Options.errorHandler(
                scope.ErrorStrings['maxItemCount'].replace('{0}', scope.f4Options.maxItemCount)
              );
              return;
            }
            //update multiselect and model if changes in modal are accepted
            refreshF4Multiselect();

            element.find('.f4-modal').modal('hide');
            element.find('.f4-grid-left, .f4-grid-right').each(function() {
              gridService.saveKendoGrid($(this).data('kendoGrid'));
            });
          };

          //check if item is already in the right grid
          scope.isSelected = function(item) {
            var idProperty = scope.grids.gridLeft.dataSource?.options.schema.model.id;
            var hit = false;
            let selectedItems = scope.grids.gridRight?.dataSource?.data();
            for (var i = 0; i < selectedItems?.length && !hit; i++) {
              hit = item[idProperty] === selectedItems[i][idProperty];
            }

            return hit;
          };

          scope.inputOnKeypress = function(e) {
            if (e.which === 115) {
              e.preventDefault();
              scope.openF4Modal();
            }
          };

          scope.pushAllRight = function() {
            var items = scope.grids.gridLeft.dataSource?.view();
            if (items) {
              var allLeftItems = angular.copy(items);
              for (var i = 0; i < allLeftItems.length; i++) {
                if (!scope.isSelected(allLeftItems[i])) {
                  scope.grids.gridRight.dataSource?.add(allLeftItems[i]);
                }
              }
              scope.grids.gridRight.dataSource?.data(
                angular
                  .element(scope.grids.gridRight.dataSource?.data())
                  .sort((x, y) => localizeCompare(x[scope.f4Options.textField], y[scope.f4Options.textField]))
              );
              scope.refreshLeftTableRows();
            }
          };

          scope.pushSelectedRight = function() {
            var row = scope.grids.gridLeft.select();
            if (row.length > 0) {
              var item = scope.grids.gridLeft.dataItem(row);
              if (!scope.isSelected(item)) {
                var rightItem = angular.copy(item);
                scope.grids.gridRight.dataSource?.add(rightItem);
                scope.grids.gridRight.dataSource?.data(
                  angular
                    .element(scope.grids.gridRight.dataSource?.data())
                    .sort((x, y) => localizeCompare(x[scope.f4Options.textField], y[scope.f4Options.textField]))
                );
                scope.refreshLeftTableRows();
              }
            }
          };

          scope.pushAllLeft = function() {
            scope.grids.gridRight.dataSource?.data([]);
            scope.refreshLeftTableRows();
          };

          scope.pushSelectedLeft = function(item) {
            let row = scope.grids.gridRight.select();
            if (row || item) {
              item = item ?? scope.grids.gridRight.dataItem(row);
              if (item) {
                scope.grids.gridRight.dataSource?.remove(item);
                scope.refreshLeftTableRows();
              }
            }
          };

          scope.refreshLeftTableRows = function() {
            var grid = scope.grids.gridLeft;
            if (!grid?.dataSource) {
              return;
            }
            var idProperty = grid.dataSource?.options.schema.model.id;
            var selectedIds = {};
            let selectedItems = scope.grids.gridRight?.dataSource?.data();
            for (var i = 0; i < selectedItems?.length; i++) {
              selectedIds[selectedItems[i][idProperty]] = true;
            }

            var pageData = grid.dataSource?._data;
            for (var i = 0; i < pageData.length; i++) {
              var row = grid.table.find("tr[data-uid='" + pageData[i].uid + "']");
              row.removeClass('f4-selected');
              if (selectedIds[pageData[i].id]) {
                row.addClass('f4-selected');
              }
            }
          };

          scope.refreshSelectedIds = function() {
            if (scope.multiselectSelectedItems.length > 0) {
              scope.f4Values = scope.multiselectSelectedItems.map(a => a[scope.f4Options.valueField]);
            } else {
              scope.f4Values = null;
            }
          };
          scope.clearFilterModal = function() {
            scope;
            debugger;
          };

          scope.resetModel = function() {
            //reset multiselect and model
            if (!!scope.f4Values) {
              scope.f4Values = null;
            }
            if (!!scope.multiselectSelectedItems) {
              scope.multiselectSelectedItems.length = 0;
            }
            if (!!scope.selectOptions) {
              scope.selectOptions.dataSource?.read();
            }
            ngModCont.$setViewValue(scope.f4Values);
          };
        },
      };
    },
  ]);
})(angular.module('myApp'));

var F4Helpers = F4Helpers || {};

F4Helpers.setF4Options = function(field) {
  if (!field.templateOptions.GridOptions || !field.templateOptions.GridOptions.gridModel) return;
  var columns = field.templateOptions.GridOptions.gridModel.Columns;
  var columnCsv = '';
  if (columns.length > 0) {
    columnCsv = columns[0].field;
    for (var i = 1; i < columns.length; i++) {
      columnCsv = columnCsv.concat(',' + columns[i].field);
    }
  }

  var f4options = {
    defaultText: field.templateOptions.defaultValue,
    filteringMode: field.templateOptions.DynamicOptions.FilteringMode ?? 1,
    maxItemCount: field.templateOptions.DynamicOptions.MaxItemCount,
    modalTitle: field.templateOptions.DynamicOptions.ModalTitle || field.templateOptions.label,
    name: field.templateOptions.label,
    patternMatchMode: field.templateOptions.DynamicOptions.PatternMatchMode,
    dataSourceTable: field.templateOptions.DynamicOptions.TableName,
    textField: field.templateOptions.DynamicOptions.TextFieldName,
    singleTagType: field.templateOptions.singleTagType ?? true,
    singleTagNumber: field.templateOptions.singleTagNumber ?? 3,
    valueField: field.templateOptions.DynamicOptions.ValueFieldName,
    writable: field.templateOptions.DynamicOptions.Writable,
    errorHandler: toastr.error,
    maxlength: field.templateOptions.f2maxlength,
    mask: field.templateOptions.mask,
    fieldsToSet: field.templateOptions.DynamicOptions.FieldsToSet,
    whereCondition: angular.isFunction(field.templateOptions.options.whereCondition)
      ? field.templateOptions.options.whereCondition
      : '',
    dynamicField: field.templateOptions.DynamicOptions.DynamicField,
    RouteState: field.templateOptions.RouteState,
    gridOptions: {
      //otherParams: field.templateOptions.QueryParameters,
      groupable: false,
      height: 350,
      fields: JSONfn.parse(field.templateOptions.GridOptions.gridModel.Fields),
      columns: field.templateOptions.GridOptions.gridModel.Columns,
      columnCsv: columnCsv,
      tableKey: field.templateOptions.GridOptions.gridModel.IdColumn,
    },
    adopter: field.templateOptions.DynamicOptions.Adopter,
    //otherParams: field.templateOptions.QueryParameters
  };
  field.templateOptions.options = f4options;
};

F4Helpers.CreateMultiselectOptions = function(settings, onChange, onDataBound, name) {
  var tagText = settings.singleTagText || 'elem kiválasztva';
  var options = {
    filter: 'contains',
    autoClose: false,
    dataTextField: settings.textField,
    dataValueField: settings.valueField,
    singleTagType: settings.singleTagType,
    singleTagNumber: settings.singleTagNumber,
    valuePrimitive: false,
    autoBind: true,
    maxSelectedItems: settings.maxItemCount,
    tagMode: !!settings.singleTagType ? 'single' : 'multiple',
    tagTemplate: !!settings.singleTagType
      ? '   # if (dataItems.length < ' +
        (settings.singleTagNumber + 1) +
        ') { # ' +
        '  # for (var idx = 0; idx < values.length; idx++) { console.log(dataItems);# ' +
        '      <span style="white-space:nowrap">#:dataItems[idx].' +
        settings.textField +
        '## if (idx < values.length - 1) {#, #} #</span>  ' +
        '  # } # ' +
        ' # } else { # ' +
        ' <span style="white-space:nowrap">#:values.length# ' +
        tagText +
        '</span> ' +
        '# } #'
      : null,
    dataSource: new kendo.data.DataSource({
      type: 'aspnetmvc-ajax',
      serverFiltering: true,
      transport: {
        read: {
          url: 'F22/MultiselectData',
          contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
          type: 'POST',
          data: settings.otherParams,
        },
      },
      model: {
        id: settings.valueField,
      },
      schema: {
        data: 'Data',
      },
      sort: {
        field: settings.textField,
        dir: 'asc',
      },
    }),

    dataBound: function(e) {
      // console.log(name + " F4 data bound.");
      onDataBound(e);
      //if (e.sender.dataSource.transport.options.read.data.hasOwnProperty("mandatoryIds")) {
      //    delete e.sender.dataSource.transport.options.read.data.mandatoryIds;
      //}

      //if (e.sender.dataSource.transport.options.read.data.hasOwnProperty("keyColumn")) {
      //    delete e.sender.dataSource.transport.options.read.data.keyColumn;
      //}
    },
    change: function(e) {
      onChange(e);
    },
    //change: onChange
  };

  return options;
};

F4Helpers.createRightKendoGridDataSource = function(settings, model) {
  return new kendo.data.DataSource({
    data: model,
    schema: {
      fields: settings.gridOptions.fields,
    },
  });
};

F4Helpers.ShowColumns = function(scope, f4Element, f4RealFields) {
  if (!scope.pageModel.Fields[f4Element]?.FormlyFieldDescriptor?.templateOptions?.GridOptions?.gridModel) {
    return;
  }
  let f4Columns = [];
  let f4FieldsList = JSONfn.parse(
    scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Fields
  );
  let f4Fields = {};
  f4RealFields.forEach(function(element) {
    let findedColumn = scope.pageModel.Fields[
      f4Element
    ].FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns.find(x => x.field === element);
    let findedField = f4FieldsList[element];
    if (!!findedColumn) {
      f4Columns.push(findedColumn);
    }
    if (!!findedField) {
      f4Fields[element] = findedField;
    }
  });
  scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns = f4Columns;
  scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Fields = JSON.stringify(
    f4Fields
  );
};

F4Helpers.GetRows = function($http, scope, f4Element, result, whereCondition = '', options) {
  if (!scope?.pageModel?.Fields[f4Element]?.FormlyFieldDescriptor?.templateOptions) {
    if (result && !result instanceof Function) {
      scope[result] = null;
    }
    return;
  }
  $http
    .post('F22/GridData', {
      tableName: scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.DynamicOptions.TableName,
      whereCondition: '',
      columnCsv: _.map(
        scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.GridOptions.gridModel.Columns,
        'field'
      ).join(),
      idColumn: scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.DynamicOptions?.KeyField,
      adopter: scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.DynamicOptions?.Adopter,
      pageSize: !!options?.first ? 1 : -1,
      page: 1,
      whereCondition: whereCondition,
    })
    .then(function(response) {
      let rows;
      if (!!response.data?.Data?.length) {
        if (!!options?.first) {
          rows = response.data.Data[0];
        } else {
          rows = response.data.Data;
        }
      }
      if (result && result instanceof Function) {
        result(rows);
      } else {
        scope[result] = rows;
      }
    });
};

F4Helpers.SelectRows = function(scope, model, f4Element, dataItems) {
  if (
    !!dataItems &&
    !!scope?.pageModel?.Fields[f4Element]?.FormlyFieldDescriptor?.templateOptions?.options?.f4scope &&
    !!scope[model]
  ) {
    scope.pageModel.Fields[
      f4Element
    ].FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems.length = 0;
    scope[model][f4Element] = [];
    if (!dataItems.length) return;
    let rows = !dataItems?.length ? [dataItems] : dataItems;
    rows.forEach(function(row) {
      scope.pageModel.Fields[
        f4Element
      ].FormlyFieldDescriptor.templateOptions.options.f4scope.multiselectSelectedItems.push(row);
      scope[model][f4Element].push(
        row[scope.pageModel.Fields[f4Element].FormlyFieldDescriptor.templateOptions.DynamicOptions?.KeyField]
      );
    });
  }
};

(function(module) {
  'use strict';
  module.controller('TemplateQueriesNavCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$window',
    '$scope',
    'DasService',
    'LockService',
    'gridService',
    function($http, options, $state, $stateParams, $window, $scope, dasService, lockService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateQueriesNavCtrl', stateParams);
      }
      var vm = this;

      init($http, options, $state, $stateParams, $window, $scope, dasService, lockService);

      vm.back = function() {
        $state.go('main');
      };
      vm.GridTemplateQueriesRowOptions = options.pageModelRow.Grids.GridTemplateQueriesRow;
      vm.exportExcel = function() {
        var selectedItems = GetSelectedGridItems(vm.GridTemplateQueries);
        if (selectedItems.length === 0 && !vm.GridTemplateQueries.selectedIds.length) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          let param = !vm.GridTemplateQueries.selectedIds.length
            ? [selectedItems[0].TemplateQueryId]
            : vm.GridTemplateQueries.selectedIds;

          $http
            .post('Template/TemplateQueriesRowList', param)
            .then(function(response) {
              var firstRowCells = [];
              let columns = [];
              let sheets = [];
              var worksheet = '';
              angular.forEach(vm.GridTemplateQueriesRowOptions.Columns, function(value) {
                firstRowCells.push({ value: value.title });
                columns.push({ autoWidth: true });
              });
              var rows = [
                {
                  cells: firstRowCells,
                },
              ];

              let data = response.data.Data.sort((a, b) => {
                let fa = a.QueryName.toLowerCase(),
                  fb = b.QueryName.toLowerCase();

                if (fa < fb) {
                  return -1;
                }
                if (fa > fb) {
                  return 1;
                }
                return 0;
              });
              angular.forEach(data, function(value) {
                if (worksheet != value.QueryName) {
                  if (worksheet != '') {
                    sheets.push({
                      columns: columns,
                      title: worksheet,
                      rows: angular.copy(rows),
                    });
                    rows = [
                      {
                        cells: firstRowCells,
                      },
                    ];
                  }
                  worksheet = value.QueryName;
                }

                let cells = [];
                angular.forEach(vm.GridTemplateQueriesRowOptions.Columns, function(item) {
                  cells.push({ value: value[item.field] });
                });
                rows.push({
                  cells: cells,
                });
              });

              sheets.push({
                columns: columns,
                title: worksheet,
                rows: angular.copy(rows),
              });
              var workbook = new kendo.ooxml.Workbook({
                sheets: sheets,
              });
              workbook.toDataURLAsync().then(function(dataURL) {
                kendo.saveAs({
                  dataURI: dataURL,
                  fileName: 'Sablonok.xlsx',
                });
              });
            })
            .catch(function() {
              return;
            });
        }
      };

      vm.viewTemplateQuery = function() {
        var selectedItems = GetSelectedGridItems(vm.GridTemplateQueries);
        if (selectedItems.length === 0 && !vm.GridTemplateQueries.selectedIds.length) {
          toastr.warning(vm.messages.NotSelectedItem, vm.messages.Warning);
        } else {
          let param = !vm.GridTemplateQueries.selectedIds.length
            ? [selectedItems[0].TemplateQueryId]
            : vm.GridTemplateQueries.selectedIds;
          $state.go('Template.TemplateQueriesRowNav', { templateQueryIds: param });
        }
      };

      function init($http, options, $state, $stateParams, $window, $scope, dasService, lockService) {
        vm.pageModel = options.pageModel;

        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);

        // Grid
        vm.GridTemplateQueriesOptions = [];
        vm.GridTemplateQueries = null;
        vm.GridTemplateQueriesIdField = null;

        vm.selectedItems = [];
      }

      // GridTemplateQueries

      initGrid(
        function(grid) {
          vm.GridTemplateQueries = grid;
        },
        function(gridIdField) {
          vm.GridTemplateQueriesIdField = gridIdField;
        },
        function(gridOptions, grid) {
          vm.GridTemplateQueriesOptions = gridOptions;
        },
        null,
        'GridTemplateQueries',
        '', // readUrl
        function(e) {
          // select function
        },
        null,
        null,
        function() {
          return '';
        },
        true
      );

      function initGrid(
        setGridFn,
        setGridIdFieldFn,
        setGridOptionsFn,
        setDataBoundFunction,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;

        var idColumn = null;
        if (vm.pageModel.Grids[gridName]) {
          idColumn = vm.pageModel.Grids[gridName].IdColumn;
        }

        if (!idColumn) {
          debugger;
        }

        setGridIdFieldFn(idColumn);

        if (!readUrl || readUrl === '') {
          if (vm.pageModel.Grids[gridName].Table) {
            readUrl = vm.pageModel.Grids[gridName].ControllerMethod;
          }
        }

        if (!transportData) {
          transportData = {};
        }
        angular.extend(transportData, {
          tableName: vm.pageModel.Grids[gridName].Table,
          whereCondition: whereCondition,
          adopter: vm.pageModel.Grids[gridName].Adopter,
          installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids[gridName].IdColumn,
        });

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        var grid = $('#' + mainGrid).data('kendoGrid');

        setGridFn(grid);

        // Kendo-grid reference for main GRID

        var gridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign({}, vm.pageModel.Grids[gridName], { ControllerMethod: readUrl }),
          transportData,
          selectFunction,
          dataBound: null,
          detailInit,
          multiselect: {
            idField: idColumn,
            selectHandler: function(id, checked) {},
          },
        });

        setGridOptionsFn(gridOptions, mainGrid);
      }
    },
  ]);
})(angular.module('myApp'));

angular.module('myApp').config([
  '$stateProvider',
  function($stateProvider) {
    var states = {
      Template: {
        url: '/template',
        templateUrl: 'App/AllLayout.html',
        controller: 'AllLayoutCtrl as vm',
        redirectTo: 'Template.TemplateQueriesNav',
        ncyBreadcrumb: {
          skip: true,
          label: 'Sablonok',
          parent: 'main',
        },
      },
      'Template.TemplateQueriesNav': {
        url: '/templatequeries',
        params: {
          module: 'Template',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'template_templatequeries',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateQueriesNav.html',
            controller: 'TemplateQueriesNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateQueriesListOptions/', undefined),
        },
        ncyBreadcrumb: {
          label: 'Sablonok',
          parent: 'main',
        },
      },
      'Template.TemplateQueriesRowNav': {
        url: '/templatequeriesrow/:templateQueryIds',
        params: {
          module: 'Template',
          formMode: 'Nav',
          backState: 'Template.TemplateQueriesNav',
          documentEntity: 'template_templatequeriesrow',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateQueriesRowNav.html',
            controller: 'TemplateQueriesRowNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateQueriesRowListOptions/', undefined, ['templateQueryIds']),
        },
        ncyBreadcrumb: {
          label: 'Adatkészletek',
          parent: 'Template.TemplateQueriesNav',
        },
      },
      'Template.TemplateEdit': {
        url: '/templateedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEdit.html',
            controller: 'TemplateEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEdit/', undefined, ['id']),
        },
        params: {
          documentEntity: 'template_templateedit',
          actionType: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum sablon szerkesztése',
          parent: 'Template.TemplateNav',
        },
      },
      'Template.TemplateCreate': {
        url: '/templatecreate',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEdit.html',
            controller: 'TemplateEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateCreate/', undefined),
        },
        params: {
          documentEntity: 'template_templatecreate',
          actionType: 'Create',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum sablon létrehozása',
          parent: 'Template.TemplateNav',
        },
      },
      'Template.TemplateView': {
        url: '/templateview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEdit.html',
            controller: 'TemplateEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEdit/', undefined, ['id']),
        },
        params: {
          documentEntity: 'template_templateview',
          actionType: 'View',
        },
        ncyBreadcrumb: {
          label: 'Dokumentum sablon megtekintése',
          parent: 'Template.TemplateNav',
        },
      },
      'Template.TemplateVersion': {
        url: '/templateversion/{id:string}/{isEdit:bool}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEdit.html',
            controller: 'TemplateEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEdit/', undefined, ['id', 'isEdit']),
        },
        params: {
          documentEntity: 'template_templateversion',
          actionType: 'Version',
        },
        ncyBreadcrumb: {
          label: 'Új dokumentum sablon verzió létrehozása',
          parent: 'Template.TemplateNav',
        },
      },
      'Template.TemplateNav': {
        url: '/template',
        params: {
          module: 'Template',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'template_template',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateNav.html',
            controller: 'TemplateNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/ListOptions/', undefined),
        },
        ncyBreadcrumb: {
          label: 'Dokumentum sablonok',
          parent: 'main',
        },
      },
      'Template.EmailNav': {
        url: '/email',
        params: {
          module: 'Template',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'template_email',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailNav.html',
            controller: 'TemplateEmailNavCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailListOptions/', undefined),
        },
        ncyBreadcrumb: {
          label: 'Email sablonok',
          parent: 'main',
        },
      },
      'Template.EmailEdit': {
        url: '/emailedit/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailEdit.html',
            controller: 'TemplateEmailEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailEdit/', undefined, ['id']),
        },
        params: {
          documentEntity: 'template_templateemailedit',
          actionType: 'Edit',
        },
        ncyBreadcrumb: {
          label: 'Email sablon szerkesztése',
          parent: 'Template.EmailNav',
        },
      },
      'Template.EmailCreate': {
        url: '/emailcreate',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailEdit.html',
            controller: 'TemplateEmailEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailCreate/', undefined),
        },
        params: {
          documentEntity: 'template_templateemailcreate',
          actionType: 'Create',
        },
        ncyBreadcrumb: {
          label: 'Email sablon létrehozása',
          parent: 'Template.EmailNav',
        },
      },
      'Template.EmailView': {
        url: '/emailview/{id:int}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailEdit.html',
            controller: 'TemplateEmailEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailEdit/', undefined, ['id']),
        },
        params: {
          documentEntity: 'template_templateemailview',
          actionType: 'View',
        },
        ncyBreadcrumb: {
          label: 'Email sablon megtekintése',
          parent: 'Template.EmailNav',
        },
      },
      'Template.EmailVersion': {
        url: '/emailversion/{id:string}/{isEdit:bool}',
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailEdit.html',
            controller: 'TemplateEmailEditCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailEdit/', undefined, ['id', 'isEdit']),
        },
        params: {
          documentEntity: 'template_templateemailversion',
          actionType: 'Version',
        },
        ncyBreadcrumb: {
          label: 'Új email sablon verzió létrehozása',
          parent: 'Template.EmailNav',
        },
      },
      'Template.EmailAddressNav': {
        url: '/emailaddress',
        params: {
          module: 'Template',
          formMode: 'Nav',
          backState: 'main',
          documentEntity: 'template_emailaddress',
          stateTransitionInfo: {
            // TODO to be filled by OEM
          },
        },
        views: {
          menu: {
            templateUrl: 'App/TileMenu.html',
            controller: 'TemplateMenuCtrl as vm',
          },
          content: {
            templateUrl: 'App/Template/TemplateEmailAddressNav.html',
            controller: 'TemplateEmailAddressCtrl as vm',
          },
        },
        resolve: {
          options: RouteResolveFunc('Template/TemplateEmailAddressListOptions/', undefined),
        },
        ncyBreadcrumb: {
          label: 'Email címek',
          parent: 'main',
        },
      },
    };

    //var initInjector = angular.injector(['ng']);
    //var $http = initInjector.get('$http');
    //stateUpdate($http, $stateProvider, states, "Invoice");

    angular.forEach(states, function(value, key) {
      key = key.replace('_', '.');
      $stateProvider.state(key, value);
    });
  },
]);

(function(module) {
  'use strict';

  module.controller('TemplateMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;

      buildMenu($state, authService, 'Template', 'template', null, null).then(function(m) {
        vm.menus = m;
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TemplateQueriesRowNavCtrl', [
    '$http',
    'options',
    '$state',
    '$stateParams',
    '$window',
    '$scope',
    'DasService',
    'LockService',
    'gridService',
    function($http, options, $state, $stateParams, $window, $scope, dasService, lockService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateQueriesRowNavCtrl', stateParams);
      }
      var vm = this;
      vm.templateQueryIds = options.templateQueryIds;

      init($http, options, $state, $stateParams, $window, $scope, dasService, lockService);

      vm.back = function() {
        $state.go('Template.TemplateQueriesNav');
      };

      vm.exportExcel = function() {
        $http
          .post('Template/TemplateQueriesRowList', vm.templateQueryIds)
          .then(function(response) {
            var firstRowCells = [];
            let columns = [];
            let sheets = [];
            var worksheet = '';
            angular.forEach(vm.GridTemplateQueriesRowOptions.columns, function(value) {
              firstRowCells.push({ value: value.title });
              columns.push({ autoWidth: true });
            });
            var rows = [
              {
                cells: firstRowCells,
              },
            ];

            let data = response.data.Data.sort((a, b) => {
              let fa = a.QueryName.toLowerCase(),
                fb = b.QueryName.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
            angular.forEach(data, function(value) {
              if (worksheet != value.QueryName) {
                if (worksheet != '') {
                  sheets.push({
                    columns: columns,
                    title: worksheet,
                    rows: angular.copy(rows),
                  });
                  rows = [
                    {
                      cells: firstRowCells,
                    },
                  ];
                }
                worksheet = value.QueryName;
              }

              let cells = [];
              angular.forEach(vm.GridTemplateQueriesRowOptions.columns, function(item) {
                cells.push({ value: value[item.field] });
              });
              rows.push({
                cells: cells,
              });
            });

            sheets.push({
              columns: columns,
              title: worksheet,
              rows: angular.copy(rows),
            });
            var workbook = new kendo.ooxml.Workbook({
              sheets: sheets,
            });
            workbook.toDataURLAsync().then(function(dataURL) {
              kendo.saveAs({
                dataURI: dataURL,
                fileName: 'Sablonok.xlsx',
              });
            });
          })
          .catch(function() {
            return;
          });
      };

      function init($http, options, $state, $stateParams, $window, $scope, dasService, lockService) {
        vm.pageModel = options.pageModel;

        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);

        // Grid
        vm.GridTemplateQueriesRowOptions = [];
        vm.GridTemplateQueriesRow = null;
        vm.GridTemplateQueriesRowIdField = null;

        vm.selectedItems = [];
      }

      // GridTemplateQueries
      new ClipboardJS('.btnC');
      initGrid(
        function(grid) {
          vm.GridTemplateQueriesRow = grid;
        },
        function(gridIdField) {
          vm.GridTemplateQueriesRowIdField = gridIdField;
        },
        function(gridOptions, grid) {
          vm.GridTemplateQueriesRowOptions = gridOptions;
          gridOptions.columns.map(x => {
            if (x.field != 'Name') {
              x.template = function(dataItem) {
                return (
                  '<button type="button" class="btn btn-default btnC" title="Vágólapra másolás"  data-clipboard-action="copy" data-clipboard-Text="' +
                  kendo.htmlEncode(dataItem[x.field]) +
                  '"><i class="fa fa-scissors"></i></button> ' +
                  kendo.htmlEncode(dataItem[x.field])
                );
              };
            }
            return x;
          });
        },
        null,
        'GridTemplateQueriesRow',
        '', // readUrl
        function(e) {
          // select function
        },
        null,
        null,
        function() {
          return '';
        },
        true
      );

      function initGrid(
        setGridFn,
        setGridIdFieldFn,
        setGridOptionsFn,
        setDataBoundFunction,
        gridName,
        readUrl,
        selectFunction,
        transportData,
        detailInit,
        whereCondition,
        custGridVars
      ) {
        // Get Id column of Grid to perform data manipulation on selected item(s)
        if (custGridVars == null) custGridVars = false;

        var idColumn = null;
        if (vm.pageModel.Grids[gridName]) {
          idColumn = vm.pageModel.Grids[gridName].IdColumn;
        }

        if (!idColumn) {
          debugger;
        }

        setGridIdFieldFn(idColumn);

        if (!transportData) {
          transportData = {};
        }
        angular.extend(transportData, {
          tableName: vm.pageModel.Grids[gridName].Table,
          whereCondition: whereCondition,
          adopter: vm.pageModel.Grids[gridName].Adopter,
          installAdopter: vm.pageModel.Grids[gridName].InstallAdopter,
          columnCsv: _.map(vm.pageModel.Grids[gridName].Columns, 'field').join(),
          idColumn: vm.pageModel.Grids[gridName].IdColumn,
          templateQueryIds: vm.templateQueryIds,
        });

        var mainGrid = custGridVars ? gridName : 'mainGrid';
        var grid = $('#' + mainGrid).data('kendoGrid');

        setGridFn(grid);

        // Kendo-grid reference for main GRID

        var gridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign({}, vm.pageModel.Grids[gridName]),
          transportData,
          selectFunction,
          dataBound: null,
          detailInit,
        });

        setGridOptionsFn(gridOptions, mainGrid);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';
  module.controller('TemplateNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'WalService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, $uibModal, HistoryService, walService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(options.pageModel);
      vm.activeMainItemTab = 0;
      vm.docTypes = [];
      angular.forEach(options.docTypeList.ListOptions, function(value, key) {
        vm.docTypes[value.key] = value.extraProperties[0].value;
      });
      vm.modalScope = [];
      function changeF22(field) {
        $scope.$watch(
          'vm.pageModel.Fields.' + field + '.FormlyFieldDescriptor.templateOptions.options.isInit',
          function(newValue) {
            if (!!newValue) {
              let id = vm.pageModel.Fields[field].FormlyFieldDescriptor.id;
              vm.pageModel.Fields[field].FormlyFieldDescriptor.templateOptions.options.hideInput = true;
              vm.pageModel.Fields[field].FormlyFieldDescriptor.templateOptions.disabled = true;
              vm.modalScope[field] = angular.element($('#' + id + ' .f2-modal')).scope();
              $('#' + id + ' .f22OK').text('Generálás');
              const openF2Modal = vm.modalScope[field].openF2Modal;
              vm.modalScope[field].openF2Modal = function() {
                this.gridSelectedItem = null;
                return openF2Modal();
              };
              vm.modalScope[field].okF2Modal = function() {
                let dict = {};
                if (!this.gridSelectedItem) {
                  return toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
                }
                dict[field] = this.gridSelectedItem[field];
                dict['preview'] = true;
                $('.f22OK')
                  .parent()
                  .prop('disabled', true);
                $http
                  .post('Template/GetTemplateData', {
                    id: dict,
                    templateId: vm.modalScope[field].templateId,
                  })
                  .then(
                    function(result) {
                      vm.downloadResult(result);
                      $('.f22OK')
                        .parent()
                        .prop('disabled', false);
                      vm.modalScope[field].closeF2Modal();
                    },
                    function(result) {
                      toastr.error('Sikertelen sablon letöltés');
                      $('.f22OK')
                        .parent()
                        .prop('disabled', false);
                    }
                  );
              };
            }
          }
        );
      }
      Object.keys(vm.pageModel.Fields).forEach(x => {
        if (vm.pageModel.Fields[x].FormlyFieldDescriptor.type == 'f22Input') changeF22(x);
      });

      vm.mainGridIdField = vm.pageModel.Grids['GridTemplate'].IdColumn;
      vm.mainGrid = $('#GridTemplate').data('kendoGrid');

      vm.templateSubGridIdField = vm.pageModel.Grids['GridTemplateSub'].IdColumn;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      function changeMainGridFilter() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        changeGridFilter(vm, $scope, selectedGrid, selectedGrid.options.idColumn);
      }

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelTemplate', 'PanelAllTemplate'],
        function(gridModel) {
          return {
            gridModel,
            transportData: {
              tableName: vm.pageModel.Grids[gridModel.Id].Table,
              whereCondition:
                "(Extension~eq~'docx'~or~Extension~eq~'pdf')" +
                (gridModel.Id == 'GridTemplate' ? '~and~Active~eq~1' : ''),
              adopter: vm.pageModel.Grids[gridModel.Id].Adopter,
              installAdopter: vm.pageModel.Grids[gridModel.Id].InstallAdopter,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
              idColumn: vm.pageModel.Grids[gridModel.Id].IdColumn,
            },
            selectFunction: function() {
              changeMainGridFilter();
              changeSubItemGridFilter();
            },
          };
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      vm.mainGrids = generatedMainGridTabs.grids;

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelTemplateSub'],
        function(gridModel) {
          vm.pageModel.Grids[gridModel.Id].Table;
          return {
            gridModel,
            transportData: {
              tableName: vm.pageModel.Grids[gridModel.Id].Table,
              whereCondition: function() {
                let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
                return (
                  "(Extension~eq~'docx'~or~Extension~eq~'pdf')~and~OrigTemplateId~eq~" +
                  (selectedItem[0]?.OrigTemplateId ?? 0)
                );
              },
              adopter: vm.pageModel.Grids[gridModel.Id].Adopter,
              installAdopter: vm.pageModel.Grids[gridModel.Id].InstallAdopter,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
              idColumn: vm.pageModel.Grids[gridModel.Id].IdColumn,
              sort: [{ field: 'ModDate', dir: 'desc' }],
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
        localStorage.setItem($state.previous.name + '_' + 'activeSubTab', vm.activeSubItemTab);
      });

      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;
      $scope.activeSubItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeSubTab')) || 0;
      vm.activeSubItemTab = $scope.activeSubItemTab;

      vm.tabChange = function(index) {
        vm.activeMainItemTab = index;
        changeSubItemGridFilter();
      };
      vm.preview = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0]) {
          let docTypeId = parseInt(selectedItem[0].DocTypeId);
          if (vm.docTypes[docTypeId]?.includes('contract')) {
            vm.modalScope['ContractId'].templateId = selectedItem[0].TemplateId;
            vm.modalScope['ContractId'].openF2Modal();
          } else if (vm.docTypes[docTypeId]?.includes('invoice')) {
            vm.modalScope['InvoiceId'].templateId = selectedItem[0].TemplateId;
            vm.modalScope['InvoiceId'].openF2Modal();
          } else if (vm.docTypes[docTypeId]?.includes('reservation')) {
            vm.modalScope['RentEventId'].templateId = selectedItem[0].TemplateId;
            vm.modalScope['RentEventId'].openF2Modal();
          } else if (vm.docTypes[docTypeId]?.includes('ticket')) {
            vm.modalScope['TicketId'].templateId = selectedItem[0].TemplateId;
            vm.modalScope['TicketId'].openF2Modal();
          } else if (vm.docTypes[docTypeId]?.includes('TenCheckReport')) {
            vm.modalScope['TenChequeId'].templateId = selectedItem[0].TemplateId;
            vm.modalScope['TenChequeId'].openF2Modal();
          } else {
            toastr.warning('Nincs elegendő adat a megjelenítéshez', vm.messages.Warning);
          }
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.downloadResult = function(result) {
        var file = JSON.parse(result.data);
        var raw = atob(file.Report);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var fs = new Blob([array], { type: file.MimeType });
        saveAs(fs, decodeURIComponent(file.FileName));
      };
      vm.download = function(grid) {
        let selectedItem = GetSelectedGridItems(grid);
        if (!!selectedItem[0] && !!grid) {
          $http
            .post('Template/GetTemplateBase', {
              templateId: selectedItem[0].TemplateId,
            })
            .then(
              function(result) {
                vm.downloadResult(result);
              },
              function(result) {
                toastr.error('Sikertelen sablon letöltés');
              }
            );
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.edit = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.TemplateEdit', { id: selectedItem[0].TemplateId });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.version = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.TemplateVersion', { id: selectedItem[0].TemplateId, isEdit: false });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.view = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.TemplateView', { id: selectedItem[0].TemplateId });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.new = function() {
        $state.go('Template.TemplateCreate');
      };
      function changeSubItemGridFilter() {
        //
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        var selectedItems = GetSelectedItems(selectedGrid);
        if (!selectedItems || (!!selectedItems && selectedItems.length === 0)) {
          vm.selectedMainGridItemId = 0;
        } else {
          vm.selectedMainGridItemId = selectedItems[vm.mainGridIdField];
        }
        reloadGridData();
      }

      function reloadGridData() {
        var subGridRefs = {};
        angular.forEach(vm.subGrids, function(value) {
          subGridRefs[value] = $('#' + value).data('kendoGrid');
        });

        angular.forEach(subGridRefs, function(value, key) {
          !!value && value.dataSource.read();
        });
      }

      vm.delete = function(grid) {
        var selectedItem = GetSelectedGridItems(grid);
        var selectedGrid = grid;
        if (!!selectedItem[0]) {
          if (selectedItem[0].OrigTemplateId === selectedItem[0].TemplateId || !!selectedItem[0].Active) {
            return toastr.error(
              'A törölni kívánt dokumentum sablon eredeti verzió vagy aktív állapotú, emiatt nem törölhető'
            );
          }
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Template/TemplateDelete/' + selectedItem[0].TemplateId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    selectedGrid.dataSource.read();
                    vm.subGrids[vm.subItemTabs[vm.activeSubItemTab].gridName].dataSource.read();
                    vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]].dataSource.read();
                    reloadGridData();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      function GetSelectedItems(selectedGrid) {
        var selectedItems = GetSelectedGridItems(selectedGrid);
        if (selectedItems.length === 0) {
          return null;
        } else {
          return selectedItems[0];
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TemplateEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'gridService',
    function($http, options, $stateParams, AuthService, $scope, dasService, $state, lockService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.actions = options.pageModel.Actions;
      vm.messages = options.pageModel.Messages;
      vm.pageModelPreview = options.pageModelPreview;
      vm.formModel = options.dto;
      vm.actionType = $stateParams.actionType;
      if (vm.actionType === 'Version' || vm.actionType === 'Create') {
        delete vm.pageModel.Fields['Version'];
      }
      vm.saveButtonHide = function() {
        return vm.actionType !== 'View';
      };

      vm.editButtonsHide = function() {
        return vm.actionType === 'Edit';
      };

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        $state.go('Template.TemplateNav');
      };
      vm.pageModel.Fields.OutputName.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Ezen a néven fog létrejönni a kigenerált fájl.<br><br>' +
        'Az adatkészletekben feltöltött értékeket is beírhat ide, egyedivé téve a kigenerált fájlnevet.<br>' +
        '<b>Például:</b> Lakásbérleti szerződés ||Berleti_szerzodes_adatai.Berlo_neve||_2024<br>' +
        '<b>Ennek eredménye:</b> Lakásbérleti szerződés Gipsz Jakab_2024.docx';

      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );
      if (vm.actionType === 'View') {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }
      if (vm.actionType === 'Edit') {
        //vm.formModel.StoredFiles = [];
        vm.FormlyFormPanelDescriptorsPreview = GenerateFormlyFormPanelsFromPageModel(options.pageModelPreview);
        vm.docTypes = [];
        angular.forEach(options.docTypeList.ListOptions, function(value, key) {
          vm.docTypes[value.key] = value.extraProperties[0].value;
        });
        vm.modalScope = [];
        function changeF22(field) {
          $scope.$watch(
            'vm.pageModelPreview.Fields.' + field + '.FormlyFieldDescriptor.templateOptions.options.isInit',
            function(newValue) {
              if (!!newValue) {
                let id = vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.id;
                vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.templateOptions.options.hideInput = true;
                vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.templateOptions.disabled = true;

                vm.modalScope[field] = angular.element($('#' + id + ' .f2-modal')).scope();
                $('#' + id + ' .f22OK').text('Generálás');
                const openF2Modal = vm.modalScope[field].openF2Modal;
                vm.modalScope[field].openF2Modal = function() {
                  this.gridSelectedItem = null;
                  return openF2Modal();
                };
                vm.modalScope[field].okF2Modal = function() {
                  let dict = {};
                  if (!this.gridSelectedItem) {
                    return toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
                  }
                  dict[vm.modalScope[field].f2Options.valueField] = this.gridSelectedItem[
                    vm.modalScope[field].f2Options.valueField
                  ];
                  dict['preview'] = true;
                  $('.f22OK')
                    .parent()
                    .prop('disabled', true);
                  $http
                    .post('Template/GetTemplateData', {
                      id: dict,
                      templateId: vm.modalScope[field].templateId,
                    })
                    .then(
                      function(result) {
                        vm.downloadResult(result);
                        $('.f22OK')
                          .parent()
                          .prop('disabled', false);
                        vm.modalScope[field].closeF2Modal();
                      },
                      function(result) {
                        toastr.error('Sikertelen sablon letöltés');
                        $('.f22OK')
                          .parent()
                          .prop('disabled', false);
                      }
                    );
                };
              }
            }
          );
        }
        Object.keys(options.pageModelPreview.Fields).forEach(x => {
          if (options.pageModelPreview.Fields[x].FormlyFieldDescriptor.type == 'f22Input') changeF22(x);
        });
      }
      var customExpressionProperties = {
        FileUpload: {
          accept: '.docx',
        },
      };
      InsertOptions(vm.pageModel, customExpressionProperties);

      var generatedGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelTemplateGrid'],
        function(gridModel) {
          vm.pageModel.Grids[gridModel.Id].Table;
          return {
            gridModel,
            transportData: {
              tableName: vm.pageModel.Grids[gridModel.Id].Table,
              whereCondition: function() {
                return "Extension~eq~'docx'~and~OrigTemplateId~eq~" + vm.formModel.OrigTemplateId;
              },
              adopter: vm.pageModel.Grids[gridModel.Id].Adopter,
              installAdopter: vm.pageModel.Grids[gridModel.Id].InstallAdopter,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
              idColumn: vm.pageModel.Grids[gridModel.Id].IdColumn,
              sort: [{ field: 'ModDate', dir: 'desc' }],
            },
          };
        }
      );

      vm.subItemTabs = generatedGridTabs.tabs;
      vm.subGridOptions = generatedGridTabs.gridOptions;
      vm.subGrids = generatedGridTabs.grids;
      var eventHandlers = {
        FileUpload: {
          onSelect: function(e) {
            if (e.files[0]?.extension != '.docx') {
              e.preventDefault();
              toastr.warning(
                'A kiválasztott fájl formátuma nem megfelelő, csak ’.docx’ típusú nyomtatványt lehet feltölteni.',
                vm.messages.Warning
              );
            }
          },
          onComplete: function(e) {},
          onError: function(e) {},
          onSuccess: function(e) {
            if (e.response) {
              if (e.response.ErrorCode > 400) {
                toastr.warning(
                  e.response.ErrorMessages.replaceAll(/\\r\\n/g, ' ')
                    .replace(/^\["/, '')
                    .replace(/"\]$/, '')
                );
                e.preventDefault();
                if (e.operation === 'upload') {
                  //e.sender.clearAllFiles();
                } else {
                }
                return;
              }
              if (e.response.ResultStatus) {
                if (e.operation === 'upload') {
                  $scope.$applyAsync();
                  if (!vm.formModel.UploadedFiles) {
                    vm.formModel.UploadedFiles = e.response.FileIdentifiers;
                  } else {
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      vm.formModel.UploadedFiles.push({
                        StoredName: value.StoredName,
                        OriginalName: value.OriginalName,
                      });
                    });
                  }
                } else if (e.operation === 'remove') {
                  if (vm.formModel.UploadedFiles) {
                    var forDelete = [];
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      forDelete.push(value);
                    });
                    for (var i = 0; i < forDelete.length; i++) {
                      for (var j = 0; j < vm.formModel.UploadedFiles.length; j++) {
                        if (forDelete[i].StoredName === vm.formModel.UploadedFiles[j].StoredName) {
                          vm.formModel.UploadedFiles.splice(j, 1);
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          onRemoveFileFromDb: function(file) {},
        },
      };
      InsertEventHandlers(vm.pageModel, eventHandlers);

      vm.downloadResult = function(result) {
        var file = JSON.parse(result.data);
        var raw = atob(file.Report);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var fs = new Blob([array], { type: file.MimeType });
        saveAs(fs, decodeURIComponent(file.FileName));
      };
      vm.preview = function() {
        let docTypeId = parseInt(vm.formModel.DocTypeId);
        if (vm.docTypes[docTypeId]?.includes('contract')) {
          vm.modalScope['ContractId'].templateId = vm.formModel.TemplateId;
          vm.modalScope['ContractId'].openF2Modal();
        } else if (vm.docTypes[docTypeId]?.includes('invoice')) {
          vm.modalScope['InvoiceId'].templateId = vm.formModel.TemplateId;
          vm.modalScope['InvoiceId'].openF2Modal();
        } else if (vm.docTypes[docTypeId]?.includes('reservation')) {
          vm.modalScope['ReservationId'].templateId = vm.formModel.TemplateId;
          vm.modalScope['ReservationId'].openF2Modal();
        } else if (vm.docTypes[docTypeId]?.includes('ticket')) {
          vm.modalScope['TicketId'].templateId = vm.formModel.TemplateId;
          vm.modalScope['TicketId'].openF2Modal();
        } else if (vm.docTypes[docTypeId]?.includes('TenCheckReport')) {
          vm.modalScope['TenChequeId'].templateId = vm.formModel.TemplateId;
          vm.modalScope['TenChequeId'].openF2Modal();
        } else {
          toastr.warning('Nincs elegendő adat a megjelenítéshez', vm.messages.Warning);
        }
      };
      vm.download = function(grid, isMain = true) {
        let selectedItem = GetSelectedGridItems(grid);
        if ((!!selectedItem[0] && !!grid) || isMain) {
          $http
            .post('Template/GetTemplateBase', {
              templateId: isMain ? vm.formModel.TemplateId : selectedItem[0].TemplateId,
            })
            .then(
              function(result) {
                vm.downloadResult(result);
              },
              function(result) {
                toastr.error('Sikertelen sablon letöltés');
              }
            );
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.save = function() {
        $http
          .post('Template/CheckTemplateRow', vm.formModel)
          .then(function(response) {
            if (!!response.data?.ExistsActive) {
              bootbox.dialog({
                message:
                  'A(z) <b>' +
                  response.data.ExistsActive +
                  '</b> sablon státusza inaktív lesz,<br/>amennyiben aktív státusszal menti el ezt a sablont.<br/><br/>Biztosan folytatja?',
                title: vm.messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      vm.saveCore();
                    },
                  },
                },
              });
            } else {
              vm.saveCore();
            }
          })
          .catch(function(response) {
            toastr.error('Sikertelen mentés!'); // TODO általános label
          });
      };
      vm.saveCore = function() {
        $http
          .post('Template/Template' + vm.actionType, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Sikeres mentés!'); // TODO általános label
            $state.go('Template.TemplateEdit', { id: response.data.InsertedId }, { reload: true });
          })
          .catch(function(response) {
            toastr.error('Sikertelen mentés!'); // TODO általános label
          });
      };
      vm.delete = function(grid) {
        var selectedItem = GetSelectedGridItems(grid);
        var selectedGrid = grid;
        if (!!selectedItem[0]) {
          if (selectedItem[0].OrigTemplateId === selectedItem[0].TemplateId || !!selectedItem[0].Active) {
            return toastr.error(
              'A törölni kívánt dokumentum sablon eredeti verzió vagy aktív állapotú, emiatt nem törölhető'
            );
          }
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Template/TemplateDelete/' + selectedItem[0].TemplateId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    selectedGrid.dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';
  module.controller('TemplateEmailNavCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'HistoryService',
    'WalService',
    'DasService',
    'gridService',
    function($scope, options, $http, $state, $uibModal, HistoryService, walService, dasService, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateEmailNavCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(options.pageModel);
      vm.activeMainItemTab = 0;
      vm.modalScope = [];
      vm.mainGridIdField = vm.pageModel.Grids['GridTemplate'].IdColumn;
      vm.mainGrid = $('#GridTemplate').data('kendoGrid');

      vm.setcolumtodatetime = SetGridColumnToDateTime(vm.pageModel.Grids, ['GridTemplate'], ['ModDate']);
      vm.setcolumtodatetime = SetGridColumnToDateTime(vm.pageModel.Grids, ['GridAllTemplate'], ['ModDate']);

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      function changeMainGridFilter() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        changeGridFilter(vm, $scope, selectedGrid, selectedGrid.options.idColumn);
      }

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelTemplate', 'PanelAllTemplate'],
        function(gridModel) {
          return {
            gridModel,
            transportData: {
              tableName: vm.pageModel.Grids[gridModel.Id].Table,
              whereCondition: "Extension~eq~'html'" + (gridModel.Id == 'GridTemplate' ? '~and~Active~eq~1' : ''),
              adopter: vm.pageModel.Grids[gridModel.Id].Adopter,
              installAdopter: vm.pageModel.Grids[gridModel.Id].InstallAdopter,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
              idColumn: vm.pageModel.Grids[gridModel.Id].IdColumn,
            },
            selectFunction: function() {
              changeMainGridFilter();
            },
          };
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      vm.mainGrids = generatedMainGridTabs.grids;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
      });

      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;

      vm.tabChange = function(index) {
        vm.activeMainItemTab = index;
      };
      vm.edit = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.EmailEdit', { id: selectedItem[0].TemplateId });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.version = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.EmailVersion', { id: selectedItem[0].TemplateId, isEdit: false });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.view = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          $state.go('Template.EmailView', { id: selectedItem[0].TemplateId });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.new = function() {
        $state.go('Template.EmailCreate');
      };

      vm.delete = function(grid) {
        var selectedItem = GetSelectedGridItems(grid);
        var selectedGrid = grid;
        if (!!selectedItem[0]) {
          if (selectedItem[0].OrigTemplateId === selectedItem[0].TemplateId || !!selectedItem[0].Active) {
            return toastr.error(
              'A törölni kívánt dokumentum sablon eredeti verzió vagy aktív állapotú, emiatt nem törölhető'
            );
          }
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Template/TemplateDelete/' + selectedItem[0].TemplateId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    selectedGrid.dataSource.read();
                    vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]].dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('TemplateEmailEditCtrl', [
    '$http',
    'options',
    '$stateParams',
    'AuthService',
    '$scope',
    'DasService',
    '$state',
    'LockService',
    'gridService',
    'UIHelperService',
    function(
      $http,
      options,
      $stateParams,
      AuthService,
      $scope,
      dasService,
      $state,
      lockService,
      gridService,
      UIHelperService
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateEmailEditCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.actions = options.pageModel.Actions;
      vm.messages = options.pageModel.Messages;
      vm.pageModelPreview = options.pageModelPreview;
      vm.formModel = options.dto;
      vm.actionType = $stateParams.actionType;
      vm.editOptions = {};
      vm.editOptions.rowData = {};
      Object.defineProperty(vm.editOptions, 'parameterId', {
        get: function() {
          return vm.formModel.QueryId;
        },
        set: function(value) {
          vm.formModel.QueryId = value;
        },
      });
      Object.defineProperty(vm.editOptions, 'model', {
        get: function() {
          return vm.formModel.Content;
        },
        set: function(value) {
          vm.formModel.Content = value;
        },
      });
      vm.getPreviewField = function(code) {
        let field;
        switch (vm.formModel.TemplateTypeCode?.trim()?.substring(0, 4)) {
          case 'EMTC':
            field = 'ContractId';
            break;
          case 'EMTI':
            field = 'InvoiceId';
            break;
          case 'EMTU':
            field = 'RentEventId';
            break;
          case 'EMTB':
            field = 'ReservationId';
            break;
          case 'EMTH':
            field = 'TicketId';
            break;
          case 'EMTP':
            field = 'PropertyId';
            break;
          case 'EMTT':
            field = 'TenChequeId';
            break;
          case 'EMTA':
            field = 'TenderId';
            break;
          default:
            '';
        }
        return field;
      };
      let field = vm.getPreviewField(vm.formModel.TemplateTypeCode?.trim()?.substring(0, 4));
      if (field) {
        vm.editOptions.parameterIdName =
          vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.templateOptions.DynamicOptions.ValueFieldName;
      } else {
        vm.editOptions.parameterIdName = 'ContractId';
      }
      vm.editOptions.parameterId = vm.formModel.QueryId;
      vm.editOptions.preview = true;
      if (vm.actionType === 'View') {
        vm.editOptions.disable = true;
      }
      vm.formModel.removedFilesId = [];

      if (vm.actionType === 'Version' || vm.actionType === 'Create') {
        delete vm.pageModel.Fields['Version'];
      }
      vm.saveButtonHide = function() {
        return vm.actionType !== 'View';
      };

      vm.editButtonsHide = function() {
        return vm.actionType === 'Edit';
      };

      vm.securedProgramId = options.programId;
      vm.securedId = options.id;
      // Lock
      // This will spawn a modal what cannot be closed until the lock is done
      lockService.initiateLock(vm.securedProgramId, vm.securedId);

      vm.back = function() {
        $state.go('Template.EmailNav');
      };
      vm.pageModel.Fields.OutputName.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Az adatkészletekben feltöltött értékeket is beírhat ide, egyedivé téve a kiküldött email tárgyát.<br>' +
        '<b>Például:</b> Díjközlő értesítő |{Berleti_szerzodes_adatai.Berlo_neve}|_2024<br>' +
        '<b>Ennek eredménye:</b> Díjközlő értesítő Gipsz Jakab_2024';

      vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions.tooltipToLabel =
        'Lehetősége van a rendszerbe szereplő adatokat beilleszteni az email szövegébe, ezzel személyre szabni a kimenő emaileket.<br>' +
        'Például bérleményellenőrzés kiértesítőnél a bérlőre tud név szerint hivatkozni.<br>' +
        'Az Előnézet ablakban látható, hogy hogy fog kinézni a kimenő email, a felugró ablakban kiválasztott példa adatsoron szemléltetve';

      vm.UIHelperService = UIHelperService;
      vm.UIHelperService.setDefaultSidebarStatus();
      vm.collapseHelper = {
        startPanelGroupName: $stateParams.openedPanelGroup || 'PGMain',
        disableRunExpression: false,
      };
      var onChangeFunctions = {
        TemplateQueryId: function(selectedItem) {
          let queryName = vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions?.sObject?.extraProperties?.find(
            x => x.key == 'QueryName'
          )?.value;
          vm.QueryColumnDataChange(queryName);
        },
        TemplateTypeCode: function(selectedItem) {
          vm.formModel.TemplateQueryId = 0;
          vm.editOptions.parameterId = 0;
          vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
          vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        },
        QueryColumn: function(selectedItem) {
          if (!!selectedItem?.key) {
            vm.editOptions.insert(`|{${selectedItem.key}}|`);
          }
        },
      };

      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);

      vm.QueryColumnDataChange = function(queryName) {
        queryName = queryName?.toLowerCase();
        if (
          !Object.keys(vm.editOptions.rowData).some(key => key.includes(queryName + '.')) &&
          !!vm.editOptions.parameterId &&
          !!vm.editOptions.parameterIdName
        ) {
          $http
            .post('Template/GetTemplateQueryData', {
              queryName: queryName,
              id: { [vm.editOptions.parameterIdName]: vm.editOptions.parameterId },
            })
            .then(function(response) {
              let keys = Object.keys(response.data?.QueryData[0]);
              if (keys?.length > 0) {
                let values = response.data?.QueryData[0];
                keys.forEach(x => {
                  let concreteKey = `|{${queryName}.${x.toLowerCase()}}|`;
                  if (!vm.editOptions.rowData.hasOwnProperty(concreteKey)) {
                    vm.editOptions.rowData[concreteKey] = values[x];
                  }
                });
              }
              vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
              vm.editOptions.onChange();
            })
            .catch(function(response) {
              vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
            });
        } else {
          vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        }
      };

      vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.schemaDataFunc = function(data) {
        data.map(x => {
          if (x) {
            let concreteKey = `|{${x.key}}|`;
            if (!!vm.editOptions.rowData.hasOwnProperty(concreteKey)) {
              if (!x.extraProperties) {
                x.extraProperties = [];
              }
              if (!x.extraProperties.find(x => (x.key = 'extText'))) {
                x.extraProperties.push({ key: 'extText', value: null });
              }
              x.extraProperties.find(x => (x.key = 'extText')).value = vm.editOptions.rowData[concreteKey];
            }
          }
        });
        return data;
      };
      if (vm.actionType !== 'View') {
        vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions.button = {
          click: function() {
            vm.preview();
          },
          class: 'btn btn-default f2-btn f2-btn-height',
          title: vm.actions.ActionPreview.Title,
          icon: 'glyphicon glyphicon-th-list',
        };
        vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.button = {
          click: function() {
            if (!!vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.sObject?.key) {
              vm.editOptions.insert(
                `|{${vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.sObject.key}}|`
              );
            }
          },
          class: 'btn btn-default f2-btn f2-btn-height',
          icon: 'glyphicon glyphicon-arrow-right',
        };
      }
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { templateQueryId: vm.formModel.TemplateQueryId };
      };
      vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions.options.dataSource.transport.options.read.data = function() {
        return { templateTypeCode: vm.formModel.TemplateTypeCode?.trim()?.substring(0, 4) };
      };
      var t = $(`[id='${vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.id}']`).data('kendoDropDownList');
      var t2 = $(`#${vm.pageModel.Fields.QueryColumn.FormlyFieldDescriptor.id}`).data('kendoDropDownList');
      vm.MainItemTabs = ExtractFormlyPanelsInTabs(
        vm.pageModel.Panels,
        vm.pageModel.Tabs,
        vm.FormlyFormPanelDescriptors
      );
      if (vm.actionType === 'View') {
        angular.forEach(vm.pageModel.Fields, function(value, key) {
          value.FormlyFieldDescriptor.templateOptions.disabled = true;
        });
      }

      vm.FormlyFormPanelDescriptorsPreview = GenerateFormlyFormPanelsFromPageModel(options.pageModelPreview);
      vm.modalScope = [];
      function changeF22(field) {
        $scope.$watch(
          'vm.pageModelPreview.Fields.' + field + '.FormlyFieldDescriptor.templateOptions.options.isInit',
          function(newValue) {
            if (!!newValue) {
              vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.templateOptions.options.hideInput = true;
              vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.templateOptions.disabled = true;
              let id = vm.pageModelPreview.Fields[field].FormlyFieldDescriptor.id;
              vm.modalScope[field] = angular.element($('#' + id + ' .f2-modal')).scope();
              const openF2Modal = vm.modalScope[field].openF2Modal;
              vm.modalScope[field].openF2Modal = function() {
                this.gridSelectedItem = null;
                return openF2Modal();
              };
              vm.modalScope[field].okF2Modal = function() {
                if (!this.gridSelectedItem) {
                  return toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
                }
                if (vm.editOptions.parameterId != this.gridSelectedItem[vm.modalScope[field].f2Options.valueField]) {
                  vm.editOptions.parameterId = this.gridSelectedItem[vm.modalScope[field].f2Options.valueField];
                  vm.editOptions.rowData = {};
                  let queryName = vm.pageModel.Fields.TemplateQueryId.FormlyFieldDescriptor.templateOptions?.sObject?.extraProperties?.find(
                    x => x.key == 'QueryName'
                  )?.value;
                  if (!!queryName) {
                    vm.QueryColumnDataChange(queryName);
                  } else {
                    vm.editOptions.onChange();
                  }
                }
                vm.modalScope[field].closeF2Modal();
              };
            }
          }
        );
      }
      Object.keys(vm.pageModelPreview.Fields).forEach(x => {
        if (vm.pageModelPreview.Fields[x].FormlyFieldDescriptor.type == 'f22Input') changeF22(x);
      });

      var customExpressionProperties = {
        FileUpload: {
          // accept: '.docx',
        },
      };
      InsertOptions(vm.pageModel, customExpressionProperties);

      var eventHandlers = {
        FileUpload: {
          onSelect: function(e) {
            // if (e.files[0]?.extension != '.docx') {
            //   e.preventDefault();
            //   toastr.warning(
            //     'A kiválasztott fájl formátuma nem megfelelő, csak ’.docx’ típusú nyomtatványt lehet feltölteni.',
            //     vm.messages.Warning
            //   );
            // }
          },
          onComplete: function(e) {},
          onError: function(e) {},
          onSuccess: function(e) {
            if (e.response) {
              if (e.response.ErrorCode > 400) {
                toastr.warning(
                  e.response.ErrorMessages.replaceAll(/\\r\\n/g, ' ')
                    .replace(/^\["/, '')
                    .replace(/"\]$/, '')
                );
                e.preventDefault();
                if (e.operation === 'upload') {
                  //e.sender.clearAllFiles();
                } else {
                }
                return;
              }
              if (e.response.ResultStatus) {
                if (e.operation === 'upload') {
                  $scope.$applyAsync();
                  if (!vm.formModel.UploadedFiles) {
                    vm.formModel.UploadedFiles = e.response.FileIdentifiers;
                  } else {
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      vm.formModel.UploadedFiles.push({
                        StoredName: value.StoredName,
                        OriginalName: value.OriginalName,
                      });
                    });
                  }
                } else if (e.operation === 'remove') {
                  if (vm.formModel.UploadedFiles) {
                    var forDelete = [];
                    angular.forEach(e.response.FileIdentifiers, function(value) {
                      forDelete.push(value);
                    });
                    for (var i = 0; i < forDelete.length; i++) {
                      for (var j = 0; j < vm.formModel.UploadedFiles.length; j++) {
                        if (forDelete[i].StoredName === vm.formModel.UploadedFiles[j].StoredName) {
                          vm.formModel.UploadedFiles.splice(j, 1);
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          onRemoveFileFromDb: function(file) {
            if (file?.storedDoc?.DocId) {
              vm.formModel.removedFilesId.push(file.storedDoc.DocId);
            }
          },
        },
      };
      InsertEventHandlers(vm.pageModel, eventHandlers);

      vm.preview = function() {
        let field = vm.getPreviewField(vm.formModel.TemplateTypeCode?.trim()?.substring(0, 4));
        if (field) {
          let id = vm.modalScope[field].f2Options.valueField;
          vm.editOptions.parameterIdName = id;
          vm.modalScope[field][id] = vm.editOptions.parameterId;
          vm.modalScope[field].openF2Modal();
        } else {
          toastr.warning('Nincs típus kiválasztva!', vm.messages.Warning);
        }
      };
      vm.save = function() {
        vm.formModel2 = angular.copy(vm.formModel);
        if (vm.actionType === 'Version') {
          vm.formModel2.TemplateId = -1;
        }
        $http
          .post('Template/CheckTemplateEmailRow', vm.formModel2)
          .then(function(response) {
            if (!!response.data?.ExistsActive) {
              bootbox.dialog({
                message:
                  'A(z) <b>' +
                  response.data.ExistsActive +
                  '</b> sablon státusza inaktív lesz,<br/>amennyiben aktív státusszal menti el ezt a sablont.<br/><br/>Biztosan folytatja?',
                title: vm.messages.Confirm,
                buttons: {
                  cancel: {
                    label: vm.messages.Cancel,
                    className: 'btn-default',
                  },
                  confirm: {
                    label: vm.messages.Ok,
                    className: 'btn-primary',
                    callback: function() {
                      vm.saveCore();
                    },
                  },
                },
              });
            } else {
              vm.saveCore();
            }
          })
          .catch(function(response) {
            toastr.error('Sikertelen mentés!'); // TODO általános label
          });
      };
      vm.saveCore = function() {
        $http
          .post('Template/TemplateEmail' + vm.actionType, vm.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            toastr.success('Sikeres mentés!'); // TODO általános label
            $state.go('Template.EmailEdit', { id: response.data.InsertedId }, { reload: true });
          })
          .catch(function(response) {
            toastr.error('Sikertelen mentés!'); // TODO általános label
          });
      };
      vm.delete = function(grid) {
        var selectedItem = GetSelectedGridItems(grid);
        var selectedGrid = grid;
        if (!!selectedItem[0]) {
          if (selectedItem[0].OrigTemplateId === selectedItem[0].TemplateId || !!selectedItem[0].Active) {
            return toastr.error(
              'A törölni kívánt dokumentum sablon eredeti verzió vagy aktív állapotú, emiatt nem törölhető'
            );
          }
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http.get('Template/TemplateEmailDelete/' + selectedItem[0].TemplateId).then(function() {
                    toastr.success(vm.messages.DeleteSuccessful);
                    selectedGrid.dataSource.read();
                  });
                },
              },
            },
          });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
    },
  ]);
})(angular.module('sbPartner'));

(function(module) {
  'use strict';
  module.controller('TemplateEmailAddressCtrl', [
    '$scope',
    'options',
    '$http',
    '$state',
    '$uibModal',
    'gridService',
    'LockService',
    function($scope, options, $http, $state, $uibModal, gridService, lockService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'TemplateEmailAddressCtrl', stateParams);
      }
      var vm = this;
      vm.pageModel = options.pageModel;
      vm.messages = options.pageModel.Messages;
      vm.labels = options.pageModel.Labels;
      vm.actions = options.pageModel.Actions;
      vm.FormlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(options.pageModel);
      vm.activeMainItemTab = 0;
      vm.modalScope = [];
      vm.mainGridIdField = vm.pageModel.Grids['GridTemplateEmailAddress'].IdColumn;
      vm.mainGrid = $('#GridTemplateEmailAddress').data('kendoGrid');

      vm.setcolumtodatetime = SetGridColumnToDateTime(vm.pageModel.Grids, ['GridTemplateEmailAddress'], ['ModDate']);
      vm.setcolumtodatetime = SetGridColumnToDateTime(vm.pageModel.Grids, ['GridAllTemplateEmailAddress'], ['ModDate']);

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeTab', vm.activeSubItemTab);
      });

      vm.back = function() {
        $state.go('main');
      };

      function changeMainGridFilter() {
        var selectedGrid = vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]];
        changeGridFilter(vm, $scope, selectedGrid, selectedGrid.options.idColumn);
      }

      var generatedMainGridTabs = gridService.CreateGridContainerTabsWithGrids(
        vm.pageModel.Tabs,
        vm.pageModel.Panels,
        options.pageModel.Grids,
        ['PanelTemplateEmailAddress', 'PanelAllTemplateEmailAddress'],
        function(gridModel) {
          return {
            gridModel,
            transportData: {
              tableName: vm.pageModel.Grids[gridModel.Id].Table,
              whereCondition: gridModel.Id == 'GridTemplateEmailAddress' ? 'Active~eq~1' : '',
              adopter: vm.pageModel.Grids[gridModel.Id].Adopter,
              installAdopter: vm.pageModel.Grids[gridModel.Id].InstallAdopter,
              columnCsv: _.map(vm.pageModel.Grids[gridModel.Id].Columns, 'field').join(),
              idColumn: vm.pageModel.Grids[gridModel.Id].IdColumn,
            },
            selectFunction: function() {
              changeMainGridFilter();
            },
          };
        }
      );

      vm.mainItemTabs = generatedMainGridTabs.tabs;
      vm.mainGrids = generatedMainGridTabs.grids;

      $scope.$on('$destroy', function() {
        localStorage.setItem($state.previous.name + '_' + 'activeMainTab', vm.activeMainItemTab);
      });

      $scope.activeMainItemTab = Number(localStorage.getItem($state.current.name + '_' + 'activeMainTab')) || 0;
      vm.activeMainItemTab = $scope.activeMainItemTab;

      vm.tabChange = function(index) {
        vm.activeMainItemTab = index;
      };
      vm.edit = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          editModal('edit', selectedItem[0].TemplateEmailAddressId);
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.view = function() {
        let selectedItem = GetSelectedGridItems(vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]);
        if (!!selectedItem[0] && !!vm.mainGrids[vm.mainGrids[vm.activeMainItemTab]]) {
          editModal('view', selectedItem[0].TemplateEmailAddressId);
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
      vm.new = function() {
        editModal('new', 0);
      };
      vm.addingFieldProperties = function(pageModel, model) {
        var syncValidators = {
          EmailAddress: {
            email: function(modelValue, viewValue) {
              return sysEmailValidate(modelValue);
            },
          },
        };
        InsertSyncValidators(pageModel, syncValidators);
      };
      function editModal(type, id) {
        vm.saveType = type;
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ui-kit/sb-card-list/sb-card-list-edit-modal.html',
          controller: 'SbCardListEditModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc(
              'Template/TemplateEmailAddress' + (type == 'new' ? 'Create' : type == 'view' ? 'View' : 'Edit'),
              { id: id }
            ),
            params: {
              id: id,
              state: type,
              panelName: 'PanelMain',
              btnSave: { text: vm.pageModel.Actions.btnSave.Title },
              title: vm.labels.LabelCreateTitle.Title,
              preGenerateCallback: vm.addingFieldProperties,
              afterGenerateCallback: vm.addingFieldProperties,
              preSave: vm.preSave,
            },
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function(result) {});
      }
      vm.preSave = function(scope) {
        $http
          .post('Template/TemplateEmailAddress' + (vm.saveType == 'new' ? 'Create' : 'Edit'), scope.formModel)
          .then(function(response) {
            lockService.initiateUnlock(vm.securedProgramId, vm.securedId);
            if (response.data?.Message == 'EMATO') {
              bootbox.dialog({
                message:
                  'A kért módosítás elvégzése maga után vonja a sablonhoz tartozó egyéb email címek inaktiválását. Biztosan folytatja?',
                title: 'Megerősítés',
                buttons: {
                  confirm: {
                    label: 'Igen',
                    className: 'btn-primary',
                    callback: function() {
                      scope.formModel.refTo = true;
                      vm.preSave(scope);
                    },
                  },
                  cancel: {
                    label: 'Nem',
                    className: 'btn-default',
                    callback: function() {
                      scope.formModel.refTo = null;
                    },
                  },
                },
              });
            } else {
              toastr.success(vm.messages.SaveSuccessful);
              scope.closeWithData();
              vm.mainGrids[vm.mainGrids[0]].dataSource.read();
              vm.mainGrids[vm.mainGrids[1]].dataSource.read();
            }
          })
          .catch(function(response) {
            toastr.error(vm.messages.SaveFailed);
            return false;
          });
      };
      vm.delete = function(grid, forced = false) {
        var selectedItem = GetSelectedGridItems(grid);
        if (!!selectedItem[0]) {
          var dialogMessage = vm.messages.ConfirmDelete;
          bootbox.dialog({
            message: dialogMessage,
            title: vm.messages.Warning,
            buttons: {
              cancel: {
                label: vm.messages.Cancel,
                className: 'btn-default',
                callback: function() {},
              },
              confirm: {
                label: vm.messages.Ok,
                className: 'btn-primary',
                callback: function() {
                  $http
                    .get(
                      'Template/TemplateEmailAddressDelete/' + selectedItem[0].TemplateEmailAddressId + '?refTo=true'
                    )
                    .then(function(response) {
                      if (response.data?.Message == 'EMATO') {
                        bootbox.dialog({
                          message:
                            'A kért módosítás elvégzése maga után vonja a sablonhoz tartozó egyéb email címek inaktiválását. Biztosan folytatja?',
                          title: 'Megerősítés',
                          buttons: {
                            confirm: {
                              label: 'Igen',
                              className: 'btn-primary',
                              callback: function() {
                                vm.delete(grid, true);
                              },
                            },
                            cancel: {
                              label: 'Nem',
                              className: 'btn-default',
                              callback: function() {},
                            },
                          },
                        });
                      } else {
                        toastr.success(vm.messages.DeleteSuccessful);
                        vm.mainGrids[vm.mainGrids[0]].dataSource.read();
                        vm.mainGrids[vm.mainGrids[1]].dataSource.read();
                      }
                    });
                },
              },
            },
          });
        } else {
          toastr.warning('Nincs kijelölt sor.', vm.messages.Warning);
          return false;
        }
      };
    },
  ]);
})(angular.module('myApp'));

function forrasDoclibRouting() {
  return {
    ForrasDoclib: {
      url: '/forrasdoclib',
      templateUrl: 'App/AllLayout.html',
      controller: 'AllLayoutCtrl as vm',
      redirectTo: 'ForrasDoclib.DocumentNav',
      ncyBreadcrumb: {
        label: 'Forrás Dokumentumkezelő modul',
        parent: 'main',
      },
    },
    'ForrasDoclib.DocumentNav': {
      url: '/nav/:tableId/:ownerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ForrasDoclibMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/ForrasDoclib/DocumentNav.html',
          controller: 'ForrasDoclib_DocumentNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('DocumentWF/DocLibNavListOptions', undefined, ['tableId', 'ownerId']),
      },
      params: {
        module: 'forrasdoclib',
        formMode: 'Nav',
        documentEntity: 'forrasdoclib_documentnav',
        helpAndManualPageId: 'forrasdoclib',
      },
      ncyBreadcrumb: {
        label: 'Csatolt dokumentumok',
      },
    },
    'ForrasDoclib.MainNumberAssignNav': {
      url: '/mainnumberassignnav/:tableId/:ownerId',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ForrasDoclibMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/ForrasDoclib/MainNumberAssignNav.html',
          controller: 'ForrasDoclib_MainNumberAssignNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('DocumentWF/MainNumberAssignNavListOptions', undefined, ['tableId', 'ownerId']),
      },
      params: {
        module: 'forrasdoclib',
        formMode: 'Nav',
        documentEntity: 'forrasdoclib_mainnumberassignav',
        helpAndManualPageId: 'forrasdoclib',
      },
      ncyBreadcrumb: {
        label: 'Dosszié-főszám összerendelés',
      },
    },
    'ForrasDoclib.AllDocumentNav': {
      url: '/alldocuments',
      views: {
        menu: {
          templateUrl: 'App/TileMenu.html',
          controller: 'ForrasDoclibMenuCtrl as vm',
        },
        content: {
          templateUrl: 'App/ForrasDoclib/AllDocumentNav.html',
          controller: 'ForrasDoclib_AllDocumentNavCtrl as vm',
        },
      },
      resolve: {
        options: RouteResolveFunc('DocumentWF/AllDocumentNavOptions/'),
      },
      params: {
        module: 'forrasdoclib',
        formMode: 'Nav',
        documentEntity: 'forrasdoclib_alldocumentnav',
        helpAndManualPageId: 'forrasdoclib',
      },
      ncyBreadcrumb: {
        label: 'Teljes dokumentum lista',
      },
    },
  };
}

'use strict';

(function() {
  const modules = [];

  const sbForrasDoclibModule = angular.module('sbForrasDoclib', modules).config([
    '$stateProvider',
    function($stateProvider) {
      let forrasDoclibRoutingStates = forrasDoclibRouting();

      angular.forEach(forrasDoclibRoutingStates, function(value, key) {
        $stateProvider.state(key, value);
      });
    },
  ]);
})();

(function(module) {
  'use strict';

  module.controller('ForrasDoclibMenuCtrl', [
    '$http',
    '$state',
    'AuthService',
    function($http, $state, authService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'ForrasDoclibMenuCtrl', stateParams);
      }
      var vm = this;
      vm.currentState = $state.current.name;
      var backMenu = { icon: 'fa fa-reply', text: 'Vissza', state: 'main' };

      vm.menus = [];
    },
  ]);
})(angular.module('sbForrasDoclib'));


(function(module) {
  'use strict';

  module.controller('ForrasDoclib_DocumentNavCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'FileUploadService',
    'DoclibcsService',
    'AuthService',
    '$httpParamSerializer',
    'WalService',
    'options',
    'HistoryService',
    'DasService',
    '$timeout',
    'gridService',
    'LanguageService',
    'lodash',
    '$q',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      FileUploadService,
      DoclibcsService,
      authService,
      $httpParamSerializer,
      walService,
      options,
      HistoryService,
      dasService,
      $timeout,
      gridService,
      LanguageService,
      lodash,
      $q
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocLibNavCtrl', stateParams);
      }
      var vm = this;

      // tesztpartner: '100754',

      //Forrás miatt a int ownerId-t 10 hosszon balról szóközzel feltöltve kell kezelni.
      vm.ownerId = /^\d+$/.test($stateParams.ownerId) ? $stateParams.ownerId.padStart(10, ' ') : $stateParams.ownerId;
      vm.tableId = $stateParams.tableId;
      vm.adopter = null;
      vm.adopterType = null;

      vm.getFilter = function() {
        return {
          f_ownerid: vm.ownerId,
          f_tableid: vm.tableId,
          f_uzletiAdopter: vm.adopter,
          linkeddoc: vm.selectedDossier || null,
        };
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.installId =
          vm.pageModel.Fields.AdopterInfo.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter;
        vm.adopter = vm.pageModel.Fields.AdopterInfo.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter;
        vm.adopterType = vm.pageModel.Fields.AdopterInfo.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter;

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign(vm.pageModel.Grids.GridDocuments, {
            ControllerMethod: 'DocumentWF/Documents/',
          }),
          transportData: vm.getFilter,
          selectFunction: function(e) {
            $timeout(function() {
              var selectedItems = GetSelectedGridItems(vm.mainGrid);
              vm.selectedItem = selectedItems ? selectedItems[0] : null;
            });
          },
          disableOptions: {
            AutoComplete: true,
          },
          groupable: false,
          group: { field: 'Type', dir: 'desc' },
          dataBound: dataBoundFunction,
        });

        vm.mainGridOptions.dataSource.serverPaging = false;
        vm.mainGridOptions.dataSource.serverFiltering = false;
        vm.mainGridOptions.dataSource.serverSorting = false;

        gridService.setupMultiSelect(vm.mainGridOptions, {
          idField: 'f_docid',
          disableCheckbox: false,
          selectHandler: selectHandlerCore,
          selectAllHandler: selectAllHandlerCore,
          checkBoxVisibilityStatementStr: "dataItem.DocType == 0 && dataItem.f_szabad == 'IVNN'",
        });

        generateForm(vm);

        function selectHandlerCore(e) {
          $scope.$applyAsync();
        }

        function selectAllHandlerCore(e) {
          $scope.$applyAsync();
        }

        vm.addDynamicDocument = addDynamicDocument;
        vm.attachDossier = attachDossier;
        vm.attachReference = attachReference;
        vm.getDocLibVersion = getDocLibVersion;
        vm.getDocumentInfo = getDocumentInfo;
        vm.closeDossier = closeDossier;
        vm.reOpenDossier = reOpenDossier;
        vm.selectedRowTypeIs = selectedRowTypeIs;
        vm.removeAttach = removeAttach;
        vm.downloadDocument = downloadDocument;
        vm.downloadSelectedDocument = downloadSelectedDocument;
        vm.newVersion = newVersion;
        vm.attachText = attachText;
        vm.attachTextView = attachTextView;
        vm.documentHistory = documentHistory;
        vm.documentHome = documentHome;
        vm.downloadAllDocument = downloadAllDocument;
        vm.docRef = docRef;
        vm.inheritedDocsRefresh = inheritedDocsRefresh;
        vm.otherSettings = otherSettings;
        vm.mainNumAssign = mainNumAssign;
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridDocuments'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function dataBoundFunction(e) {
        var rows = e.sender.tbody.children();

        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.DocType == 2) {
            $(row)
              .css('font-weight', 'bold')
              .css('font-style', 'italic');
          }
        }

        vm.gridLoaded = false;
        if (!!vm.mainGrid) {
          $('#mainGrid').off('dblclick', 'tr.k-state-selected');
          $('#mainGrid').on('dblclick', 'tr.k-state-selected', function() {
            var selectedItems = GetSelectedGridItems(vm.mainGrid);
            if (!!selectedItems && selectedItems[0]?.DocType == 2) {
              vm.selectedDossier = selectedItems ? selectedItems[0] : null;
              if (selectedItems[0]?.f_doctype == ' >>>') {
                vm.selectedDossier = selectedItems[0].f_docid == '<<<' ? null : selectedItems[0];
              } else {
                vm.selectedDossier = null;
              }
              vm.mainGrid.dataSource.read();
            } else {
              //vm.selectedDossier = null;
            }
          });
        }
        vm.gridLoaded = true;
      }

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////

      function addDynamicDocument() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentInsertGenericModal.html',
          controller: 'DocumentInsertGenericModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            //szulodok: vm.dataModel.Workflow.DocumentID,
            options: RouteResolvePostFunc('DocumentWF/LetrehozOptionsGeneric/', {
              f_ownerid: vm.ownerId,
              f_tableid: vm.tableId,
              adopter: vm.adopter,
              f_docsrcid: vm.dataModel.f_docsrcid,
            }),
            selectedDossier: vm.selectedDossier,
          },
        });

        modalInstance.result
          .then(function(result) {
            if (result) {
              result.documentDataModel.Fajl =
                !!result.documentDataModel.Fajl && !!result.documentDataModel.Fajl.name ? 'ok' : '';
              switch (result.attachmentType) {
                case 'DCSS':
                  $http({
                    url: 'DocumentWF/GetDynamicDocumentUploadFields',
                    method: 'GET',
                    params: {
                      f_docsrcid: result.f_docsrcid,
                      f_ownerid: result.f_ownerid,
                      f_tableid: result.f_tableid,
                      linkedtype: result.linkedtype,
                      uzletiAdopter: vm.adopter,
                      dosszie: result.documentDataModel.Dossziek,
                    },
                  })
                    .then(function(fieldRes) {
                      addDynamicDocumentUploadFields(
                        result.documentDataModel,
                        result.documentFileName,
                        fieldRes.data.parameters,
                        fieldRes.data.dossierParameters
                      );
                    })
                    .catch(function(error) {
                      console.error(error); // Note: this logs the js type error
                    });
                  break;
                case 'DCSD':
                  $http({
                    url: 'DocumentWF/GetDynamicDocumentSearchFields',
                    method: 'GET',
                    params: {
                      f_docsrcid: result.f_docsrcid,
                      f_ownerid: result.f_ownerid,
                      f_tableid: result.f_tableid,
                      uzletiAdopter: vm.adopter,
                    },
                  })
                    .then(function(fieldRes) {
                      addDynamicDocumentSearchFields(
                        result.f_docsrcid,
                        fieldRes.data.parameters,
                        result.f_ownerid,
                        result.f_tableid,
                        result.documentDataModel.Dossziek
                      );
                    })
                    .catch(function(error) {
                      console.error(error); // Note: this logs the js type error
                    });
                  break;
                default:
                  break;
              }
            }
          })
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function addDynamicDocumentUploadFields(
        documentDataModel,
        documentFileName,
        uploadParameters,
        dossierParameters
      ) {
        var dynamicModalInstance = DoclibcsService.openDocumentDynamicModalInstance(
          'Dokumentum adatok',
          'Mégse',
          'Rendben',
          vm.adopterType,
          vm.adopter,
          vm.installId,
          vm.tableId,
          vm.ownerId,
          uploadParameters,
          vm.module
        );

        dynamicModalInstance.result
          .then(function(result) {
            if (dossierParameters && dossierParameters.length > 0) {
              addDynamicDocumentAddToDossierFields(
                documentDataModel,
                documentFileName,
                dossierParameters,
                result.bejovoParameterek
              );
            } else {
              insertDocument(documentDataModel, documentFileName, result.bejovoParameterek, null, vm.adopter);
            }
          })
          .catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
      }

      function addDynamicDocumentAddToDossierFields(
        documentDataModel,
        documentFileName,
        dossierParameters,
        uploadInParameters
      ) {
        var dynamicModalInstance = DoclibcsService.openDocumentDynamicModalInstance(
          'Iktatás adatok',
          'Mégse',
          'Rendben',
          vm.adopterType,
          vm.adopter,
          vm.installId,
          vm.tableId,
          vm.ownerId,
          dossierParameters,
          vm.module
        );

        dynamicModalInstance.result
          .then(function(result) {
            insertDocument(
              documentDataModel,
              documentFileName,
              uploadInParameters,
              result.bejovoParameterek,
              vm.adopter
            );
          })
          .catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
      }

      function insertDocument(
        documentDataModel,
        documentFileName,
        bejovoParameterek,
        dossierBejovoParameterek,
        uzletiAdopter
      ) {
        FileUploadService.postWithFileWf('DocumentWF/Insert', {
          model: documentDataModel,
          files: documentFileName,
          bejovoParameterek: bejovoParameterek,
          dossierBejovoParameterek: dossierBejovoParameterek,
          uzletiAdopter: uzletiAdopter,
        })
          .then(function(response) {
            toastr.success('Sikeres mentés');
            vm.mainGrid.dataSource.read();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function addDynamicDocumentSearchFields(f_docsrcid, searchParameters, f_ownerid, f_tableid, dosszie) {
        var dynamicModalInstance = DoclibcsService.openDocumentDynamicModalInstance(
          'Dokumentum keresési feltételek megadása',
          'Mégse',
          'Rendben',
          vm.adopterType,
          vm.adopter,
          vm.installId,
          vm.tableId,
          vm.ownerId,
          searchParameters,
          vm.module
        );

        dynamicModalInstance.result
          .then(function(result) {
            if (result) {
              addDynamicDocumentGridRows(f_docsrcid, result.bejovoParameterek, f_ownerid, f_tableid, dosszie);
            }
          })
          .catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
      }

      function addDynamicDocumentGridRows(f_docsrcid, searchParameters, f_ownerid, f_tableid, dosszie) {
        var dynamicModalInstance = DoclibcsService.openDynamicDocumentGridRowsModalInstance(
          'Dokumentumok listája',
          'Mégse',
          'Rendben',
          vm.adopterType,
          vm.adopter,
          vm.dataModel.installId,
          f_docsrcid,
          searchParameters
        );

        dynamicModalInstance.result
          .then(function(result) {
            if (result) {
              var selectedDocumentData =
                '<returns>' +
                Object.entries(result.selectedDocument)
                  .map(([key, value]) => `<return><controlid>${key}</controlid><value>${value || ''}</value></return>`)
                  .join('\n') +
                '</returns>';

              $http({
                url: 'DocumentWF/GetDynamicAttachmentFields',
                method: 'POST',
                data: {
                  f_docsrcid: f_docsrcid,
                  f_ownerid: f_ownerid,
                  f_tableid: f_tableid,
                  dosszie: dosszie,
                  selectedDocumentId: result.selectedDocumentId,
                  doctype: result.doctype,
                  selectedDocumentData: selectedDocumentData,
                  uzletiAdopter: vm.adopter,
                },
              })
                .then(function(fieldRes) {
                  addDocumentAttachmentFields(
                    f_docsrcid,
                    f_ownerid,
                    f_tableid,
                    dosszie,
                    fieldRes.data.currentIdc,
                    result.selectedDocument['f_filename'],
                    fieldRes.data.parameters,
                    fieldRes.data.linkedType
                  );
                })
                .catch(function(error) {
                  console.error(error); // Note: this logs the js type error
                });
            }
          })
          .catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
      }

      function attachDossier() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/AttachDossierModal.html',
          controller: 'AttachDossierModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            //szulodok: vm.dataModel.Workflow.DocumentID,
            options: RouteResolvePostFunc('DocumentWF/AttachDossier/', {
              f_ownerid: vm.ownerId,
              f_tableid: vm.tableId,
              f_docsrcid: vm.dataModel.f_docsrcid,
              adopter: vm.adopter,
            }),
          },
        });

        modalInstance.result
          .then(function(result) {
            $http({
              url: 'DocumentWF/SetAttachDossierFlag',
              method: 'POST',
              data: {
                model: result,
              },
            })
              .then(function(fieldRes) {
                vm.mainGrid.dataSource.read();
              })
              .catch(function(error) {
                console.error(error); // Note: this logs the js type error
              });
          })
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function attachReference() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/AttachReferenceModal.html',
          controller: 'AttachReferenceModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            //szulodok: vm.dataModel.Workflow.DocumentID,
            options: RouteResolvePostFunc('DocumentWF/AttachReferenceModal/', {
              f_ownerid: vm.ownerId,
              f_tableid: vm.tableId,
              f_adopter: vm.adopter,
              f_docsrcid: vm.dataModel.f_docsrcid,
            }),
          },
        });

        modalInstance.result
          .then(function(result) {
            $http({
              url: 'DocumentWF/AttachReference',
              method: 'POST',
              data: {
                model: result,
              },
            })
              .then(function(fieldRes) {
                vm.mainGrid.dataSource.read();
              })
              .catch(function(error) {
                console.error(error); // Note: this logs the js type error
              });
          })
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function addDocumentAttachmentFields(
        f_docsrcid,
        f_ownerid,
        f_tableid,
        dosszie,
        selectedDocumentId,
        selectedDocumentFileName,
        attachmentParameters,
        linkedType
      ) {
        var modalTitle = 'Dokumentum adatainak megadása csatoláshoz';
        if (dosszie) modalTitle = 'Dokumentum adatainak megadása dossziéba rakáshoz';

        var dynamicModalInstance = DoclibcsService.openDocumentDynamicModalInstance(
          modalTitle,
          'Mégse',
          'Rendben',
          vm.adopterType,
          vm.adopter,
          vm.installId,
          vm.tableId,
          vm.ownerId,
          attachmentParameters,
          vm.module
        );

        dynamicModalInstance.result
          .then(function(result) {
            if (result) {
              FileUploadService.postWithFile('DocumentWF/InsertFromDokutar', {
                f_docsrcid: f_docsrcid,
                f_ownerid: f_ownerid,
                f_tableid: f_tableid,
                dosszie: dosszie || '',
                selectedDocumentId: selectedDocumentId,
                selectedDocumentFileName: selectedDocumentFileName,
                linkedType: linkedType,
                bejovoParameterek: result.bejovoParameterek,
                uzletiAdopter: vm.adopter,
              })
                .then(function(response) {
                  toastr.success('Sikeres mentés');
                  vm.mainGrid.dataSource.read();
                })
                .catch(function(error) {
                  console.error(error); // Note: this logs the js type error
                });
            }
          })
          .catch(function(res) {
            if (!(res === 'cancel' || res === 'escape key press' || res === 'backdrop click')) {
              throw res;
            }
          });
      }

      function closeDossier() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        $http({
          url: 'DocumentWF/CloseDossier',
          method: 'POST',
          data: {
            f_docsrcid: vm.dataModel.f_docsrcid,
            dossier: selectedItems[0].dosszie,
            uzletiAdopter: vm.adopter,
          },
        })
          .then(function(fieldRes) {
            toastr.success('A dosszié lezárásra került!');
            vm.mainGrid.dataSource.read();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function reOpenDossier() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        $http({
          url: 'DocumentWF/ReOpenDossier',
          method: 'POST',
          data: {
            f_docsrcid: vm.dataModel.f_docsrcid,
            dossier: selectedItems[0].dosszie,
            uzletiAdopter: vm.adopter,
          },
        })
          .then(function(fieldRes) {
            toastr.success('A dosszié visszanyitásra került!');
            vm.mainGrid.dataSource.read();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function selectedRowTypeIs(docType) {
        return vm.selectedItem?.DocType == docType;
      }

      function getDocumentInfo() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }

        if (selectedRow[0].f_doclibid == 0 && selectedRow[0].f_szabad == 'IVNI') {
          //akkor ez szöveg csatolás lesz
          return attachTextView(selectedRow[0].f_docid, true);
        }

        selectedRow[0].dosszie = vm.selectedDossier?.dosszie;

        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentInformationModal.html',
          controller: 'DocumentInformationModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolvePostFunc('DocumentWF/InfoDocument/', {
              linkedDoc: selectedRow[0],
              f_uzletiAdopter: vm.adopter,
            }),
          },
        });

        modalInstance.result
          .then(function(result) {})
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function removeAttach() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }

        bootbox.dialog({
          title: vm.pageModel.Labels.LabelDetach.Title,
          message: 'Biztosan törölni akarja a dokumentum csatolását?',
          buttons: {
            cancel: {
              label: 'Mégsem',
              className: 'btn-default',
              callback: function() {},
            },
            confirm: {
              label: 'Törlés',
              className: 'btn-primary',
              callback: function() {
                $http
                  .post('DocumentWF/RemoveDocument', {
                    f_docid: !!vm.selectedDossier?.dosszie ? selectedRow[0].f_doclibidc : selectedRow[0].f_docid,
                    f_docsrcid: selectedRow[0].f_docsrcid,
                    f_uzletiAdopter: vm.adopter,
                    f_currentDossier: vm.selectedDossier?.dosszie,
                  })
                  .then(function(response) {
                    toastr.success('Sikeres törlés!');
                    vm.mainGrid.dataSource.read();
                  })
                  .catch(function(response) {
                    toastr.error('Sikertelen törlés');
                  });
              },
            },
          },
        });
      }

      function canOpenInBrowser(contentType) {
        if (!contentType) return false;

        const allowedTypes = ['application/pdf', 'text/plain', 'text/html'];

        // az allowedTypes közvetlen egyezését, és az image/* prefixet is elfogadjuk
        return allowedTypes.includes(contentType.toLowerCase()) || contentType.toLowerCase().startsWith('image/');
      }

      function generateTabembededFrame(contentType, url) {
        if (!contentType) return false;

        if (contentType.toLowerCase().startsWith('image/')) {
          return `<embed src="${url}" type="${contentType}" max-height="100%"/>`;
        } else {
          return `<embed src="${url}" type="${contentType}" width="100%" height="100%"/>`;
        }

        const allowedTypes = ['application/pdf', 'text/plain', 'text/html'];

        // az allowedTypes közvetlen egyezését, és az image/* prefixet is elfogadjuk
        return allowedTypes.includes(contentType.toLowerCase()) || contentType.toLowerCase().startsWith('image/');
      }

      function downloadDocument(showOnly) {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }

        if (selectedRow[0].f_doclibid == 0 && selectedRow[0].f_szabad == 'IVNI') {
          //akkor ez szöveg csatolás lesz
          return attachTextView(selectedRow[0].f_docid, showOnly);
        }

        var params = {
          docsrcid: selectedRow[0].f_docsrcid,
          doclibidc: selectedRow[0].idFieldValue,
          uzletiAdopter: vm.adopter,
          hashvalue: selectedRow[0].f_hashvalue,
        };

        $http
          .post('DocumentWF/Download', params)
          .then(function(data) {
            var byteArray = new Uint8Array(data.data.FileData.FileContents);

            try {
              var blob = new Blob([byteArray], { type: data.data.Mime || 'application/octet-stream' });
              var url = window.URL.createObjectURL(blob);

              if (showOnly) {
                if (canOpenInBrowser(data.data.Mime)) {
                  const newTab = window.open('', '_blank');
                  newTab.document.title = 'Előnézet: ' + data.data.FileName;
                  newTab.document.body.innerHTML = generateTabembededFrame(blob.type, url);
                } else {
                  toastr.warning('A fájl nem tekinthető meg böngészőben!');
                }
              } else {
                var linkElement = document.createElement('a');
                linkElement.setAttribute('href', url);
                linkElement.setAttribute('download', data.data.FileName);

                var clickEvent = new MouseEvent('click', {
                  view: window,
                  bubbles: true,
                  cancelable: false,
                });
                linkElement.dispatchEvent(clickEvent);
              }
            } catch (ex) {
              console.log(ex);
            }
          })
          .catch(function(data) {
            console.log(data);
          });
      }

      function downloadSelectedDocument() {
        // if (vm.intervalFunctionId) {
        // clearInterval(vm.intervalFunctionId);
        // }

        var mapped = vm.mainGrid.selectedItems;
        var promises = [];

        for (const [key, currentDokument] of Object.entries(mapped)) {
          var params = {
            docsrcid: currentDokument.f_docsrcid,
            doclibidc: currentDokument.idFieldValue.toString(),
            uzletiAdopter: vm.adopter,
            hashvalue: currentDokument.f_hashvalue,
          };

          promises.push($http.post('DocumentWF/Download', params));
        }

        $q.all(promises).then(data => {
          downloadAllFile(data);
        });
      }

      function downloadAllFile(data) {
        var zip = new JSZip();
        var zipName = 'dokumentumok.zip';
        var fileNameCounterDictionary = {};

        for (var i = 0; i < data.length; i++) {
          var byteArray = new Uint8Array(data[i].data.FileData.FileContents);
          var blob = new Blob([byteArray], { type: 'application/octet-stream' });

          var currentFileNameCounter = fileNameCounterDictionary[data[i].data.FileName];
          if (currentFileNameCounter) {
            fileNameCounterDictionary[data[i].data.FileName] = currentFileNameCounter + 1;
          } else {
            fileNameCounterDictionary[data[i].data.FileName] = 1;
          }

          if (currentFileNameCounter) {
            const dotIndex = data[i].data.FileName.lastIndexOf('.');
            const beforeDot = data[i].data.FileName.slice(0, dotIndex);
            const afterDot = data[i].data.FileName.slice(dotIndex + 1);
            zip.file(beforeDot + ' (' + currentFileNameCounter.toString() + ').' + afterDot, byteArray);
          } else {
            zip.file(data[i].data.FileName, byteArray);
          }
        }

        zip.generateAsync({ type: 'blob' }).then(function(content) {
          // letöltés elindítása
          if (window.navigator.msSaveOrOpenBlob) {
            // IE / Edge support
            window.navigator.msSaveOrOpenBlob(content, zipName);
          } else {
            var link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = zipName;
            link.click();
            URL.revokeObjectURL(link.href);
            toastr.success('Sikeres fájlletöltés!');
            mi.close();
          }
        });
      }

      function getDocLibVersion(docsrcid, adopter) {
        $http({
          url: 'DocumentWF/GetDocLibVersion',
          method: 'POST',
          data: {
            f_docsrcid: vm.dataModel.f_docsrcid,
            adopter: vm.adopter,
          },
        })
          .then(function(fieldRes) {})
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function newVersion() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/NewVersionModal.html',
          controller: 'NewVersionModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            //szulodok: vm.dataModel.Workflow.DocumentID,
            options: RouteResolvePostFunc('DocumentWF/NewVersionModal/', {
              f_ownerid: vm.ownerId,
              f_tableid: vm.tableId,
              f_docsrcid: selectedRow[0].f_docsrcid,
              f_doctype: selectedRow[0].f_doctype,
              docId: selectedRow[0].f_doclibidc,
              attachId: selectedRow[0].f_docid,
              adopter: vm.adopter,
            }),
          },
        });

        modalInstance.result
          .then(function(result) {
            FileUploadService.postWithFileWf('DocumentWF/NewVersion', { model: result.model, file: result.file })
              .then(function(response) {
                vm.mainGrid.dataSource.read();
                toastr.success('A dokumentum csere sikeres!');
              })
              .catch(function(error) {
                console.error(error); // Note: this logs the js type error
              });
          })
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function documentHistory() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentHistoryModal.html',
          controller: 'DocumentHistoryModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'xl',
          backdrop: 'static',
          resolve: {
            selectedRow: selectedRow[0],
            options: RouteResolvePostFunc('DocumentWF/DocumentHistory/', {}),
          },
        });

        modalInstance.result
          .then(function(result) {})
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function attachText() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/AttachTextModal.html',
          controller: 'AttachTextModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('DocumentWF/AttachTextModal/', {
              f_ownerid: vm.ownerId,
              f_tableid: vm.tableId,
              f_docsrcid: vm.dataModel.f_docsrcid,
              f_uzletiAdopter: vm.adopter,
            }),
            viewOnly: false,
          },
        });

        modalInstance.result
          .then(function(result) {
            $http({
              url: 'DocumentWF/AttachText',
              method: 'POST',
              data: {
                model: result,
              },
            })
              .then(function(fieldRes) {
                toastr.success('A szöveg csatolás sikeres!');
                vm.mainGrid.dataSource.read();
              })
              .catch(function(error) {
                console.error(error);
              });
          })
          .catch(function(error) {
            //console.error(error);
          });
      }

      function attachTextView(docid, showOnly) {
        if (showOnly === true) {
          var modalInstance = $uibModal.open({
            templateUrl: 'App/ForrasDoclib/AttachTextModal.html',
            controller: 'AttachTextModalCtrl_ForrasDoclib',
            controllerAs: 'vm',
            size: 'lg',
            backdrop: 'static',
            resolve: {
              options: RouteResolveFunc('DocumentWF/AttachTextView/', {
                f_docid: docid,
              }),
              viewOnly: true,
            },
          });
        } else {
          $http({
            url: 'DocumentWF/AttachTextView/',
            method: 'POST',
            data: {
              f_docid: docid,
            },
          })
            .then(function(fieldRes) {
              const text = fieldRes.data.dto.text;

              const blob = new Blob([text], { type: 'text/plain' });
              const link = document.createElement('a');

              link.href = URL.createObjectURL(blob);
              link.download = vm.dataModel.tableName + '-' + vm.dataModel.ownerName + ' csatolmánya.txt'; // fájlnév
              link.click();
            })
            .catch(function(error) {
              //console.error(error); // Note: this logs the js type error
            });
        }
      }

      function documentHome() {
        vm.selectedDossier = null;
        vm.mainGrid.dataSource.read();
      }

      function downloadAllDocument() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentDownloadModal.html',
          controller: 'DocumentDownloadModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'xlg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('DocumentWF/MultipleDownloadListOptions/'),
            additionalOptions: { f_ownerid: vm.ownerId, f_tableid: vm.tableId, f_uzletiAdopter: vm.adopter },
          },
        });

        modalInstance.result
          .then(function(result) {
            toastr.success('A program sikeresen letöltötte a fájlokat.');
          })
          .catch(function(error) {
            //console.error(error); // Note: this logs the js type error
          });
      }

      function docRef() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.warning('Nincs kijelölt elem!');
          return false;
        }

        if (selectedRow[0].f_doclibid == 0 && selectedRow[0].f_szabad == 'IVNI') {
          toastr.warning('A szabad szövegre más nem tud hivatkozni!');
          return false;
        }

        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentReferencesModal.html',
          controller: 'DocumentReferencesModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('DocumentWF/DocumentReferencesNav/'),
            selectedRow: selectedRow[0],
          },
        });

        modalInstance.result
          .then(function(result) {})
          .catch(function(error) {
            //console.error(error);
          });
      }

      function inheritedDocsRefresh() {
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        $http({
          url: 'DocumentWF/InheritedDocsRefresh',
          method: 'POST',
          data: {
            f_ownerid: vm.ownerId,
            f_tableid: vm.tableId,
            adopter: vm.adopter,
          },
        })
          .then(function(fieldRes) {
            toastr.success('Az örökölt dokumentumok frissítése elkészült!');
            vm.mainGrid.dataSource.read();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function otherSettings() {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/OtherSettingsMod.html',
          controller: 'OtherSettingsModCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          backdrop: 'static',
          resolve: {
            options: RouteResolveFunc('DocumentWF/OtherSettings'),
          },
        });

        modalInstance.result
          .then(function(result) {
            toastr.success('Egyéb beállítások mentése sikeres!');
          })
          .catch(function(error) {
            //console.error(error);
          });
      }

      function mainNumAssign() {
        $state.go('ForrasDoclib.MainNumberAssignNav', { tableId: vm.tableId, ownerId: $stateParams.ownerId });
      }
    },
  ]);
})(angular.module('sbForrasDoclib'));

(function(module) {
  'use strict';

  module.controller('ForrasDoclib_AllDocumentNavCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'FileUploadService',
    'DoclibcsService',
    'AuthService',
    '$httpParamSerializer',
    'options',
    'HistoryService',
    'DasService',
    '$timeout',
    'gridService',
    'LanguageService',
    'lodash',
    '$q',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      FileUploadService,
      DoclibcsService,
      authService,
      $httpParamSerializer,
      options,
      HistoryService,
      dasService,
      $timeout,
      gridService,
      LanguageService,
      lodash,
      $q
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocLibNavCtrl', stateParams);
      }
      var vm = this;

      vm.getFilter = function() {
        return {
          docsrcid: vm.dataModel.f_docsrcid,
        };
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.getDocLibVersion = getDocLibVersion;
        vm.getDocumentInfo = getDocumentInfo;
        vm.downloadDocument = downloadDocument;
        vm.downloadSelectedDocument = downloadSelectedDocument;

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setOnChangeFunction('f_docsrcid', function(selectedItem) {
          console.log('Grid refresh');
          vm.mainGrid.dataSource.read();
        });

        SetGridColumnToDateTime(vm.pageModel.Grids, ['GridDocuments'], ['idopont']);

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign(vm.pageModel.Grids.GridDocuments, {
            ControllerMethod: 'DocumentWF/AllDocuments/',
          }),
          transportData: vm.getFilter,
          selectFunction: function(e) {
            $timeout(function() {
              var selectedItems = GetSelectedGridItems(vm.mainGrid);
              vm.selectedItem = selectedItems ? selectedItems[0] : null;
            });
          },
          disableOptions: {
            AutoComplete: true,
          },
        });

        gridService.setupMultiSelect(vm.mainGridOptions, {
          idField: 'f_doclibidc',
          disableCheckbox: false,
          selectHandler: selectHandlerCore,
          selectAllHandler: selectAllHandlerCore,
          //checkBoxVisibilityStatementStr: '',
        });

        generateForm(vm);

        function selectHandlerCore(e) {
          $scope.$applyAsync();
        }

        function selectAllHandlerCore(e) {
          $scope.$applyAsync();
        }
      }

      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////

      function getDocumentInfo() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.success('Nincs kijelölt elem!');
          return false;
        }

        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/DocumentInformationModal.html',
          controller: 'DocumentInformationModalCtrl_ForrasDoclib',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            options: RouteResolvePostFunc('DocumentWF/InfoDocument/', {
              linkedDoc: selectedRow[0],
              f_uzletiAdopter: vm.adopter,
            }),
          },
        });

        modalInstance.result
          .then(function(result) {})
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function downloadDocument() {
        var selectedRow = GetSelectedGridItems(vm.mainGrid);
        if (!selectedRow || !selectedRow.length) {
          toastr.success('Nincs kijelölt elem!');
          return false;
        }

        var params = {
          docsrcid: selectedRow[0].f_docsrcid,
          doclibidc: selectedRow[0].idFieldValue,
          uzletiAdopter: vm.adopter,
          hashvalue: selectedRow[0].f_hashvalue,
        };

        $http
          .post('DocumentWF/Download', params)
          .then(function(data) {
            //headers = headers();

            //var filename = headers['x-filename'];
            //var contentType = headers['content-type'];
            var byteArray = new Uint8Array(data.data.FileData.FileContents);

            var linkElement = document.createElement('a');
            try {
              var blob = new Blob([byteArray], { type: 'application/octet-stream' });
              var url = window.URL.createObjectURL(blob);

              linkElement.setAttribute('href', url);
              linkElement.setAttribute('download', data.data.FileName);

              var clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false,
              });
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              console.log(ex);
            }
          })
          .catch(function(data) {
            console.log(data);
          });
      }

      function downloadSelectedDocument() {
        // if (vm.intervalFunctionId) {
        // clearInterval(vm.intervalFunctionId);
        // }

        var mapped = vm.mainGrid.selectedItems;
        var promises = [];

        for (const [key, currentDokument] of Object.entries(mapped)) {
          var params = {
            docsrcid: currentDokument.f_docsrcid,
            doclibidc: currentDokument.idFieldValue.toString(),
            uzletiAdopter: vm.adopter,
            hashvalue: currentDokument.f_hashvalue,
          };

          promises.push($http.post('DocumentWF/Download', params));
        }

        $q.all(promises).then(data => {
          downloadAllFile(data);
        });
      }

      function getDocLibVersion(docsrcid, adopter) {
        $http({
          url: 'DocumentWF/GetDocLibVersion',
          method: 'POST',
          data: {
            f_docsrcid: vm.dataModel.f_docsrcid,
            adopter: vm.adopter,
          },
        })
          .then(function(fieldRes) {})
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      function downloadAllFile(data) {
        var zip = new JSZip();
        var zipName = 'dokumentumok.zip';
        var fileNameCounterDictionary = {};

        for (var i = 0; i < data.length; i++) {
          var byteArray = new Uint8Array(data[i].data.FileData.FileContents);
          var blob = new Blob([byteArray], { type: 'application/octet-stream' });

          var currentFileNameCounter = fileNameCounterDictionary[data[i].data.FileName];
          if (currentFileNameCounter) {
            fileNameCounterDictionary[data[i].data.FileName] = currentFileNameCounter + 1;
          } else {
            fileNameCounterDictionary[data[i].data.FileName] = 1;
          }

          if (currentFileNameCounter) {
            const dotIndex = data[i].data.FileName.lastIndexOf('.');
            const beforeDot = data[i].data.FileName.slice(0, dotIndex);
            const afterDot = data[i].data.FileName.slice(dotIndex + 1);
            zip.file(beforeDot + ' (' + currentFileNameCounter.toString() + ').' + afterDot, byteArray);
          } else {
            zip.file(data[i].data.FileName, byteArray);
          }
        }

        zip.generateAsync({ type: 'blob' }).then(function(content) {
          // letöltés elindítása
          if (window.navigator.msSaveOrOpenBlob) {
            // IE / Edge support
            window.navigator.msSaveOrOpenBlob(content, zipName);
          } else {
            var link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = zipName;
            link.click();
            URL.revokeObjectURL(link.href);
            toastr.success('Sikeres fájlletöltés!');
            mi.close();
          }
        });
      }
    },
  ]);
})(angular.module('sbForrasDoclib'));

(function(module) {
  'use strict';

  module.controller('DocumentDownloadModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'lodash',
    'options',
    'additionalOptions',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$window',
    '$q',
    '$timeout',
    'gridService',
    function(
      $scope,
      $stateParams,
      mi,
      fus,
      authService,
      lodash,
      options,
      additionalOptions,
      $state,
      $location,
      $http,
      $uibModal,
      $window,
      $q,
      $timeout,
      gridService
    ) {
      var vm = this;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        vm.ownerId = additionalOptions.f_ownerid;
        vm.tableId = additionalOptions.f_tableid;
        vm.adopter = additionalOptions.f_uzletiAdopter;

        vm.downloadSelectedDocument = downloadSelectedDocument;

        var fs = fieldSetter;
        fs.vm = vm;

        vm.getFilter = function() {
          return {
            f_ownerid: vm.ownerId,
            f_tableid: vm.tableId,
            f_uzletiAdopter: vm.adopter,
            linkeddoc: vm.selectedDossier || null,
          };
        };

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign(vm.pageModel.Grids.GridDocuments, {
            ControllerMethod: 'DocumentWF/MultipleDownloadGridData/',
          }),
          transportData: vm.getFilter,
          selectFunction: function(e) {
            $timeout(function() {
              var selectedItems = GetSelectedGridItems(vm.mainGrid);
              vm.selectedItem = selectedItems ? selectedItems[0] : null;
            });
          },
          disableOptions: {
            AutoComplete: true,
          },
          groupable: false,
          group: { field: 'Type', dir: 'desc' },
          dataBound: dataBoundFunction,
        });

        vm.mainGridOptions.dataSource.serverPaging = false;
        vm.mainGridOptions.dataSource.serverFiltering = false;
        vm.mainGridOptions.dataSource.serverSorting = false;

        gridService.setupMultiSelect(vm.mainGridOptions, {
          idField: 'f_doclibidc',
          disableCheckbox: false,
          selectHandler: selectHandlerCore,
          selectAllHandler: selectAllHandlerCore,
          checkBoxVisibilityStatementStr: 'dataItem.DocType == 0 ',
        });

        generateForm(vm);

        function selectHandlerCore(e) {
          $scope.$applyAsync();
        }

        function selectAllHandlerCore(e) {
          $scope.$applyAsync();
        }
      }

      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function dataBoundFunction(e) {
        var rows = e.sender.tbody.children();

        for (var j = 0; j < rows.length; j++) {
          var row = $(rows[j]);
          var dataItem = e.sender.dataItem(row);
          if (dataItem.DocType == 2) {
            $(row)
              .css('font-weight', 'bold')
              .css('font-style', 'italic');
          }
        }

        vm.gridLoaded = false;
        if (!!vm.mainGrid) {
          $('#mainGrid').off('dblclick', 'tr.k-state-selected');
          $('#mainGrid').on('dblclick', 'tr.k-state-selected', function() {
            var selectedItems = GetSelectedGridItems(vm.mainGrid);
            vm.selectedDossier = selectedItems ? selectedItems[0] : null;
            if (vm.selectedDossier?.DocType == 2) {
              if (vm.selectedDossier.f_doctype == ' >>>') {
                vm.selectedDossier = selectedItems[0].f_docid == '<<<' ? null : selectedItems[0];
              } else {
                vm.selectedDossier = null;
              }
              vm.mainGrid.dataSource.read();
            } else {
              vm.selectedDossier = null;
            }
          });
        }
        vm.gridLoaded = true;
      }

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////

      function downloadSelectedDocument() {
        // if (vm.intervalFunctionId) {
        // clearInterval(vm.intervalFunctionId);
        // }

        vm.loadIsProgress = true;

        var mapped = vm.mainGrid.selectedItems;
        var promises = [];

        for (const [key, currentDokument] of Object.entries(mapped)) {
          var params = {
            docsrcid: currentDokument.f_docsrcid,
            doclibidc: currentDokument.idFieldValue.toString(),
            uzletiAdopter: vm.adopter,
            hashvalue: currentDokument.f_hashvalue,
          };

          promises.push($http.post('DocumentWF/Download', params));
        }

        $q.all(promises).then(data => {
          downloadAllFile(data);
        });
      }

      function downloadAllFile(data) {
        var zip = new JSZip();
        var zipName = 'dokumentumok.zip';
        var fileNameCounterDictionary = {};

        for (var i = 0; i < data.length; i++) {
          var byteArray = new Uint8Array(data[i].data.FileData.FileContents);
          var blob = new Blob([byteArray], { type: 'application/octet-stream' });

          var currentFileNameCounter = fileNameCounterDictionary[data[i].data.FileName];
          if (currentFileNameCounter) {
            fileNameCounterDictionary[data[i].data.FileName] = currentFileNameCounter + 1;
          } else {
            fileNameCounterDictionary[data[i].data.FileName] = 1;
          }

          if (currentFileNameCounter) {
            const dotIndex = data[i].data.FileName.lastIndexOf('.');
            const beforeDot = data[i].data.FileName.slice(0, dotIndex);
            const afterDot = data[i].data.FileName.slice(dotIndex + 1);
            zip.file(beforeDot + ' (' + currentFileNameCounter.toString() + ').' + afterDot, byteArray);
          } else {
            zip.file(data[i].data.FileName, byteArray);
          }
        }

        zip.generateAsync({ type: 'blob' }).then(function(content) {
          // letöltés elindítása
          if (window.navigator.msSaveOrOpenBlob) {
            // IE / Edge support
            window.navigator.msSaveOrOpenBlob(content, zipName);
          } else {
            var link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = zipName;
            link.click();
            URL.revokeObjectURL(link.href);
            vm.loadIsProgress = false;
            mi.close();
          }
        });
      }

      vm.cancel = function() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        mi.dismiss('cancel');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentDynamicGridModalCtrl_ForrasDoclib', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'options',
    'additionalOptions',
    '$uibModalInstance',
    'FileUploadService',
    '$q',
    '$uibModal',
    'lodash',
    'DoclibcsService',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      options,
      additionalOptions,
      mi,
      fus,
      $q,
      $uibModal,
      lodash,
      DoclibcsService
    ) {
      var vm = this;

      vm.ModalTitle = additionalOptions.modalTitle;
      vm.CancelTitle = additionalOptions.cancelTitle;
      vm.SubmitTitle = additionalOptions.submitTitle;
      vm.adopterType = additionalOptions.adopterType;
      vm.uzletiAdopter = additionalOptions.uzletiAdopter;
      vm.installId = additionalOptions.installId;
      vm.docLibs = additionalOptions.f_docsrcid;
      vm.close = close;
      vm.gridData = [];
      vm.gridColumns = [];
      vm.skipFromAutoFit = [];
      vm.gridDataSourceFields = {};
      vm.gridModelFields = {};
      vm.gridLoaded = false;
      vm.autofitCompleted = false;

      vm.srcIdField = '';
      vm.parameters = '';
      vm.isError = false;
      if (options) {
        vm.parameters = JSON.parse(options.parameters || '[]');
        vm.srcIdField = options.srcIdField;
      } else {
        vm.isError = true;
      }

      mi.opened
        .then(function(e) {
          if (vm.isError) {
            mi.dismiss('cancel');
          }
        })
        .catch(function(error) {
          console.error(error); // Note: this logs the js type error
        });

      if (!vm.isError) {
        init();
      }

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        var fs = fieldSetter;
        fs.vm = vm;

        generateForm(vm);

        initGridDynamic();
      }

      function initGridDynamic() {
        // add frontend grid id column
        var tempGridColumnId = {};
        tempGridColumnId['field'] = 'TelerikGridId';
        tempGridColumnId['type'] = 'int';
        tempGridColumnId['title'] = 'TelerikGridId';
        tempGridColumnId['hidden'] = 'true';
        vm.gridColumns.push(tempGridColumnId);

        // add download button
        var tempCommandButton = {};
        tempCommandButton['command'] = [
          {
            name: 'download',
            title: 'Letöltés',
            click: function(e) {
              var tr = $(e.target).closest('tr');
              var data = this.dataItem(tr);
              var params = {
                docsrcid: vm.docLibs,
                doclibidc: data[vm.srcIdField].toString(),
                uzletiAdopter: vm.uzletiAdopter,
                hashvalue: data.f_hashvalue,
              };

              $http
                .post('DocumentWF/Download', params)
                .then(function(data) {
                  var byteArray = new Uint8Array(data.data.FileData.FileContents);

                  var linkElement = document.createElement('a');
                  try {
                    var blob = new Blob([byteArray], { type: 'application/octet-stream' });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute('download', data.data.FileName);

                    var clickEvent = new MouseEvent('click', {
                      view: window,
                      bubbles: true,
                      cancelable: false,
                    });
                    linkElement.dispatchEvent(clickEvent);
                  } catch (ex) {
                    console.log(ex);
                  }
                })
                .catch(function(data) {
                  console.log(data);
                });
            },
            template: '<a class="btn k-button k-grid-download"><span class="glyphicon glyphicon-download"></span></a>',
          },
        ];
        vm.gridColumns.push(tempCommandButton);

        // get grid columns (from the first row)
        for (var i = 0; i < vm.parameters[0].rowData.length; i++) {
          var tempGridColumn = {};
          tempGridColumn['field'] = vm.parameters[0].rowData[i].controlid;
          tempGridColumn['type'] = GetType(vm.parameters[0].rowData[i].controltype);
          tempGridColumn['title'] = vm.parameters[0].rowData[i].header;

          switch (tempGridColumn['type']) {
            case 'number': {
              tempGridColumn['width'] = 120;
              tempGridColumn['filterable'] = {
                cell: {
                  template: function(args) {
                    args.element.kendoNumericTextBox({
                      format: '#',
                      decimals: 0,
                    });
                  },
                },
              };

              vm.gridDataSourceFields[tempGridColumn['field']] = {
                type: tempGridColumn['type'],
                filterable: tempGridColumn['filterable'],
              };

              vm.gridModelFields[tempGridColumn['field']] = {
                type: tempGridColumn['type'],
              };

              vm.skipFromAutoFit.push(tempGridColumn['field']);

              break;
            }
            case 'date': {
              tempGridColumn['width'] = 200;
              tempGridColumn['format'] = '{0:' + vm.pageModel.Labels.DateFormat.Title + '}';
              tempGridColumn['filterable'] = DoclibcsService.getKendoDateFormat();

              vm.gridDataSourceFields[tempGridColumn['field']] = {
                type: tempGridColumn['type'],
                format: tempGridColumn['format'],
                filterable: tempGridColumn['filterable'],
              };

              vm.skipFromAutoFit.push(tempGridColumn['field']);

              break;
            }
            default: {
              tempGridColumn['width'] = 120;
              break;
            }
          }

          if (tempGridColumn.field !== 'f_hashvalue') vm.gridColumns.push(tempGridColumn);
        }

        // get grid data rows
        var telerikGridId = 1;
        for (var i = 0; i < vm.parameters.length; i++) {
          var tempRow = vm.parameters[i].rowData;
          var tempGridElement = {
            TelerikGridId: telerikGridId,
          };
          telerikGridId++;

          for (var j = 0; j < tempRow.length; j++) {
            switch (tempRow[j].controltype) {
              case 'int': {
                tempGridElement[tempRow[j].controlid] = parseInt(tempRow[j].default);
                break;
              }
              case 'datetime': {
                tempGridElement[tempRow[j].controlid] = kendo.parseDate(
                  getShortenedDate(tempRow[j].default),
                  'yyyyMMdd'
                );
                break;
              }
              case 'smalldatetime': {
                tempGridElement[tempRow[j].controlid] = kendo.parseDate(
                  getShortenedDate(tempRow[j].default),
                  'yyyyMMdd'
                );
                break;
              }
              case 'date': {
                tempGridElement[tempRow[j].controlid] = kendo.parseDate(
                  getShortenedDate(tempRow[j].default),
                  'yyyyMMdd'
                );
                break;
              }
              default: {
                tempGridElement[tempRow[j].controlid] = tempRow[j].default;
                break;
              }
            }
          }
          vm.gridData.unshift(tempGridElement);
        }
      }

      // Show grid
      vm.GridDynamicOptions = {
        columns: vm.gridColumns,
        dataSource: {
          data: [],
          pageSize: 20,
          schema: {
            model: {
              fields: vm.gridModelFields,
            },
          },
        },
        pageable: {
          refresh: false,
          pageSizes: [5, 10, 20, 50, 100],
          buttonCount: 5,
        },
        height: 450,
        resizable: true,
        selectable: true,
        dataBound: function(e) {
          var dataSource = this.dataSource;
          if (dataSource.data().length > 0 && !vm.autofitCompleted) {
            for (var i = 0; i < this.columns.length; i++) {
              if (!vm.skipFromAutoFit.includes(this.columns[i].field)) this.autoFitColumn(i);
            }

            vm.autofitCompleted = true;
          }
        },
        filterable: {
          mode: 'row',
          operators: {
            string: {
              contains: kendo.ui.FilterMenu.prototype.options.operators.string.contains,
              startswith: kendo.ui.FilterMenu.prototype.options.operators.string.startswith,
              eq: kendo.ui.FilterMenu.prototype.options.operators.string.eq,
              neq: kendo.ui.FilterMenu.prototype.options.operators.string.neq,
              doesnotcontain: kendo.ui.FilterMenu.prototype.options.operators.string.doesnotcontain,
              endswith: kendo.ui.FilterMenu.prototype.options.operators.string.endswith,
              isnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnull,
              isnotnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnotnull,
              isempty: kendo.ui.FilterMenu.prototype.options.operators.string.isempty,
              isnotempty: kendo.ui.FilterMenu.prototype.options.operators.string.isnotempty,
            },
          },
        },
      };

      vm.cancel = function() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        mi.dismiss('cancel');
      };

      function close() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        getSelectedGridDynamicItem();

        if (vm.selectedGridDynamicItemId === -1) {
          return;
        }

        mi.close({
          selectedDocumentId: vm.selectedGridDynamicItem[vm.srcIdField].toString(),
          doctype: vm.selectedGridDynamicItem['f_doctype'].toString(),
          selectedDocument: vm.selectedGridDynamicItem,
        });
      }

      function GetType(param) {
        if (param.includes('char')) {
          return 'string';
        }

        if (param === 'int') {
          return 'number';
        }

        if (param === 'datetime') {
          return 'date';
        }

        if (param === 'smalldatetime') {
          return 'date';
        }

        if (param === 'date') {
          return 'date';
        }

        return 'string';
      }

      function getSelectedGridDynamicItem() {
        vm.selectedGridDynamicItemId = getSelectedRowId(vm.GridDynamic, 'TelerikGridId');

        var gridData = vm.GridDynamic.dataSource.data();
        var element = gridData.filter(obj => {
          return obj.TelerikGridId === vm.selectedGridDynamicItemId;
        });

        vm.selectedGridDynamicItem = element[0];
      }

      vm.intervalFunctionId = setInterval(loadGrid, 1000);

      function loadGrid() {
        if (vm.GridDynamic && !vm.gridLoaded) {
          vm.GridDynamic.setDataSource(
            new kendo.data.DataSource({
              data: vm.gridData,
              pageSize: 20,
              schema: {
                model: {
                  fields: vm.gridDataSourceFields,
                },
              },
            })
          );

          vm.gridLoaded = true;
        }
      }

      function getShortenedDate(dateString) {
        return dateString.replace(/\D/g, '').substring(0, 8);
      }

      setTimeout(function() {
        $('#GridDynamic').on('dblclick', 'tr', function() {
          vm.close();
        });
      });
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentDynamicModalCtrl_ForrasDoclib', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'additionalOptions',
    '$uibModalInstance',
    'FileUploadService',
    '$q',
    '$uibModal',
    'lodash',
    function($scope, $http, $state, $stateParams, additionalOptions, mi, fus, $q, $uibModal, lodash) {
      var vm = this;

      vm.ModalTitle = additionalOptions.modalTitle;
      vm.CancelTitle = additionalOptions.cancelTitle;
      vm.SubmitTitle = additionalOptions.submitTitle;
      vm.adopterType = additionalOptions.adopterType;
      vm.uzletiAdopter = additionalOptions.uzletiAdopter;
      vm.installId = additionalOptions.installId;
      vm.tableId = additionalOptions.tableId;
      vm.ownerId = additionalOptions.ownerId;

      vm.save = save;
      vm.module = additionalOptions.module;
      var parsed = JSON.parse(additionalOptions.parameters || '[]');
      vm.infoForm = true;

      vm.autoLoadFields = [];
      vm.checkBoxFields = [];
      vm.isLoadingDefaultValues = false;
      vm.defaulValuesLoaded = false;
      vm.validRadioButtonSelected = true;
      vm.XrecSelectedRadiobutton;

      $scope.formInvalid = true;

      mi.opened
        .then(function(e) {
          if (Object.keys(parsed).length < 1) {
            vm.save();
          }
        })
        .catch(function(error) {
          console.error(error); // Note: this logs the js type error
        });

      vm.cancel = function() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        mi.dismiss('cancel');
      };

      var tempParsed = [];
      var tempRadioButtonElement;

      vm.dynamicModel = {};
      var referenceControlIdArrays = {};
      var isFirstRun = [];
      var delayTimer;

      var radioButtonElementIndex = 0;

      let prefilledControlids = ['partner_kod', 'irat_targy'];
      let controlIds = parsed.filter(x => prefilledControlids.includes(x.controlid) && !x.default);
      if (controlIds.length > 0 && !!vm.tableId && !!vm.ownerId) {
        $http({
          url: 'DocumentWF/GetFieldPrefillByTable',
          method: 'GET',
          params: {
            controlidList: controlIds.map(a => a.controlid),
            f_ownerid: vm.ownerId,
            f_tableid: vm.tableId,
          },
        })
          .then(function(result) {
            if (!!result.data.message) {
              console.log(result.data.message.map(x => x.Message));
            }

            angular.forEach(result.data.fillValue, function(value, key) {
              controlIds.find(x => x.controlid == key).default = value;
            });

            process();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      } else {
        process();
      }

      //műveletek
      function process() {
        for (var i = 0; i < parsed.length; i++) {
          switch (parsed[i].controltype) {
            case 'radiobutton': {
              if (!tempRadioButtonElement) {
                // save the index
                radioButtonElementIndex = i;

                // Create the initial radio button and we will have only one radio group (radioButton1)
                tempRadioButtonElement = _.clone(parsed[i]);
                tempRadioButtonElement.controlid = 'radioButton1';
                tempRadioButtonElement.header = '';
                tempRadioButtonElement.radioOptions = [{ key: parsed[i].controlid, value: parsed[i].header }];

                if (parsed[i].setcontrols) {
                  tempRadioButtonElement.setControlOptions = [
                    { key: parsed[i].controlid, value: parsed[i].setcontrols },
                  ];
                }

                tempRadioButtonElement.setcontrols = '';

                // az első radio button elem alapból ki lesz választva, később ez felülíródhat
                tempRadioButtonElement.default = parsed[i].controlid;
              } else {
                // Add radio option to the existing radio buttons
                var tempRadioOption = { key: parsed[i].controlid, value: parsed[i].header };
                tempRadioButtonElement.radioOptions.push(tempRadioOption);

                if (parsed[i].setcontrols) {
                  var tempSetControlOptions = { key: parsed[i].controlid, value: parsed[i].setcontrols };
                  tempRadioButtonElement.setControlOptions.push(tempSetControlOptions);
                }

                if (parsed[i].default === 'true') {
                  tempRadioButtonElement.default = parsed[i].controlid;
                }
              }

              if (parsed[i].controlid == 'noselect') {
                vm.validRadioButtonSelected = false;
              }

              break;
            }
            default: {
              var tempElement = _.clone(parsed[i]);
              if (parsed[i].setcontrols) {
                tempElement.setControlOptions = [{ key: parsed[i].controlid, value: parsed[i].setcontrols }];
              }
              tempParsed.push(tempElement);

              if (tempElement.controltype === 'textbox') {
                if (tempElement.jointable && tempElement.joinlabel && tempElement.visible) {
                  if (tempElement.jointable.length !== 0 && tempElement.visible == 'true') {
                    // if the element is f22 then we add a caption field
                    var tempCaptionElement = {
                      controlid: tempElement.controlid + '_caption',
                      controltype: 'textbox',
                      default: '',
                      enabled: 'false',
                      header: '  ',
                      mandatory: 'false',
                      picture: '',
                      readonly: 'true',
                      visible: 'true',
                      f22caption: 'true',
                    };

                    tempParsed.push(tempCaptionElement);
                  }
                }
              }

              break;
            }
          }
        }

        if (tempRadioButtonElement) {
          // insert into specific array index
          tempParsed.splice(radioButtonElementIndex, 0, tempRadioButtonElement);
        }

        parsed = tempParsed;

        vm.dynamicFieldsPromises = [];
        vm.dynamicFields = [];
        for (var i = 0; i < parsed.length; i++) {
          if (parsed[i].visible === undefined && parsed[i].enabled === undefined) {
            vm.infoForm = false;
          }

          if (parsed[i].visible == 'true' && parsed[i].enabled != 'false') {
            vm.infoForm = false;
          }

          vm.dynamicFieldsPromises.push(ConvertParameterToFormlyDescriptor(parsed[i], vm, i));
        }

        $q.all(vm.dynamicFieldsPromises)
          .then(function(result) {
            vm.dynamicFormlyDescriptor = GenerateFormlyDescriptor(vm.dynamicFields);
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });

        vm.intervalFunctionId = setInterval(loadDefaultValues, 1000);
      }

      //--------------------------------------------------------------------

      function GenerateFormlyDescriptor(fields) {
        var formlyDescriptor = [
          {
            className: 'col-lg-12',
            fieldGroup: [
              {
                className: 'row',
                fieldGroup: fields.map(function(f) {
                  return processFieldDescriptor(f).FormlyFieldDescriptor;
                }),
              },
              {
                className: 'col-lg-12',
                template: '',
              },
            ],
          },
        ];

        return formlyDescriptor;
      }

      function ConvertParameterToFormlyDescriptor(param, vm, index) {
        var type = GetType(param);
        var options = {};
        var maxLength = 255;
        var numberFormat = 'n0';
        var numberDecimals = 0;
        var mask = null;
        var upperCase = false;

        var pictureParameters = '';
        if (param.picture) {
          var lastChar = param.picture.slice(-1);
          if (lastChar === ';') {
            pictureParametersJSONString = param.picture.substring(0, param.picture.length - 1);
          } else {
            pictureParametersJSONString = param.picture;
          }

          var pictureParametersJSONString = '{"' + pictureParametersJSONString + '"}';
          pictureParametersJSONString = pictureParametersJSONString.split('=').join('":"');
          pictureParametersJSONString = pictureParametersJSONString.split(';').join('","');

          pictureParameters = JSON.parse(pictureParametersJSONString);
        }

        if (pictureParameters.M) {
          maxLength = pictureParameters.M;
        }

        if (pictureParameters.D) {
          if (pictureParameters.D !== '0') {
            numberFormat = 'n' + pictureParameters.D;
          }
          numberDecimals = pictureParameters.D;
        }

        if (pictureParameters.P) {
          if (type === 'input') {
            type = 'maskedInput';
            mask = pictureParameters.P;
          }
        }

        if (pictureParameters.O) {
          if (pictureParameters.O === 'U') {
            upperCase = true;
          }
        }

        if (param.visible === undefined) {
          param.visible = 'true';
        }

        if (param.readonly === undefined) {
          param.readonly = 'false';
        }

        if (param.enabled === undefined) {
          param.enabled = 'true';
        }

        var paramRequired = param.mandatory == 'true' ? true : false;
        var paramHide = param.visible == 'true' ? false : true;
        var paramClass =
          param.f22caption == 'true' ? 'col-lg-6 col-md-offset-right-0' : 'col-lg-12 col-md-offset-right-0';
        if (param.joinlabel) {
          paramClass = 'col-lg-6 col-md-offset-right-0';
        }

        var paramDisabled = true;
        if (param.enabled == 'true' && param.readonly == 'false') {
          paramDisabled = false;
        }

        // if the type is checkbox and mandatory then it is set to true by default and not enabled
        /*if (type === "checkbox") {
                    if (paramRequired) {
                        paramDisabled = true;
                        param.default = "true";
                    }
                }*/

        switch (type) {
          case 'input':
            vm.autoLoadFields.push([param.controlid, param.default]);
            break;

          case 'radio':
            vm.autoLoadFields.push([param.controlid, param.default]);

            var desc = {
              Key: param.controlid,
              FieldGroup: 1,
              ControllerMethod: '',
              MaxLength: maxLength,
              EnabledDisabledFieldsList: param.setControlOptions,
              FormlyFieldDescriptor: {
                key: param.controlid,
                className: 'col-lg-12 col-md-offset-right-0',
                hide: paramHide,
                templateUrl: 'App/templates/formly/radio_template.html',
                templateOptions: {
                  //"label": param.header,
                  required: param.mandatory == 'true' ? true : false,
                  disabled: false,
                  ComboOptions: null,
                  GridOptions: null,
                  DateTimeOptions: null,
                  DynamicOptions: null,
                  changed: null,
                  options: param.radioOptions,
                },
              },
            };

            vm.dynamicFields[index] = desc;
            return $q.resolve(desc);

            break;

          case 'checkbox':
            vm.autoLoadFields.push([param.controlid, param.default]);
            break;

          case 'kendoDP':
            vm.autoLoadFields.push([param.controlid, param.default]);
            break;

          case 'kendoNTB':
            options = {
              format: numberFormat,
              decimals: numberDecimals,
            };

            if (pictureParameters.O) {
              if (pictureParameters.O === 'S') {
                options.min = 0;
              }
            }

            vm.autoLoadFields.push([param.controlid, param.default]);
            break;

          case 'kendoDDL':
            vm.autoLoadFields.push([param.controlid, param.default]);

            var desc = {
              Key: param.controlid,
              FieldGroup: 1,
              ControllerMethod: '',
              MaxLength: maxLength,
              OriginalRequired: paramRequired,
              FormlyFieldDescriptor: {
                key: param.controlid,
                type: type,
                className: 'col-lg-12 col-md-offset-right-0',
                hide: paramHide,
              },
            };
            desc.ControllerMethod = 'DocumentWF/ListFromItemSource';
            desc.transData = function() {
              var parameter = { itemSource: param.itemssource };
              return parameter;
            };
            desc.FormlyFieldDescriptor.templateOptions = {
              QueryParameters: '',
              label: param.header,
              required: paramRequired && !paramDisabled,
              disabled: paramDisabled,
              ComboOptions: {
                valueField: 'key',
                textField: 'text',
              },
            };
            vm.dynamicFields[index] = desc;
            return $q.resolve(desc);

          case 'f22Input':
            var desc = {
              Key: param.controlid,
              FieldGroup: 1,
              ControllerMethod: '',
              OriginalRequired: paramRequired,
              MaxLength: 255, // Do not use maxLength variable beacuse if the maxLength is smaller then the f22 joinfield length it will cause form invalid error
              FormlyFieldDescriptor: {
                key: param.controlid,
                type: type,
                className: paramClass,
                hide: paramHide,
              },
            };

            var F22TableName = param.jointable;
            var F22AdopterId = vm.uzletiAdopter;

            if (F22TableName.startsWith('install..')) {
              F22TableName = 'INSTALL:' + F22TableName.substring(9);
            }

            var whereParameter = param.joinfilter;
            // If the joinfilter has a reference for other control in square brackets (e.g.: f_docsrcid=4~and~ikt_konyvid=[IktatokonyvDmsId])
            if (whereParameter && whereParameter.match(/(\[.+?\])/)) {
              var tempWhereParameter = '';
              var tempWhereParameterList = [];
              var controlIdList = [];
              var processIterator = 0;

              // split the joinfilter and determine the reference control id
              var whereParameterArray = whereParameter.split(/(\[.+?\])/).filter(Boolean);
              for (var i = 0; i < whereParameterArray.length; i++) {
                if (whereParameterArray[i].match(/(\[.+?\])/)) {
                  var currentControlId = whereParameterArray[i].slice(1, -1);

                  // get control id and type
                  var currentLocalField = lodash.find(parsed, function(f) {
                    return f.controlid == currentControlId;
                  });
                  var currentTypeLocalField = GetType(currentLocalField);
                  controlIdList.push({ controlId: currentControlId, controlType: currentTypeLocalField });

                  // push where parameter to the array
                  tempWhereParameterList[processIterator] = tempWhereParameter;
                  processIterator++;
                  tempWhereParameter = '';
                } else {
                  tempWhereParameter += whereParameterArray[i];
                }
              }

              // last part of the where parameter
              if (tempWhereParameter) {
                tempWhereParameterList[processIterator] = tempWhereParameter;
              }

              // based on the type of the reference control, crate a whereCondition function
              whereParameter = function() {
                return getF22WhereParameter(tempWhereParameterList, controlIdList);
              };

              // add reference control id to an array for the "change" function
              for (var i = 0; i < controlIdList.length; i++) {
                if (!referenceControlIdArrays[controlIdList[i].controlId]) {
                  referenceControlIdArrays[controlIdList[i].controlId] = {
                    ControlIds: new Array(param.controlid),
                    Type: controlIdList[i].controlType,
                  };
                } else {
                  referenceControlIdArrays[controlIdList[i].controlId].ControlIds.push(param.controlid);
                }
              }
            }

            return $http
              .post('F22/GetDynamicF22FieldModel', {
                table: F22TableName,
                key: param.joinfield,
                value: param.joinfield,
                freeText: false,
                writable: true,
                filteringMode: 1,
                patternMatchMode: 0,
                adopter: vm.adopterType,
                module: vm.module,
                uzletiAdopter: F22AdopterId,
                installAdopter: vm.installId,
                whereCondition: param.joinfilter,
              })
              .then(function(fieldModel) {
                // update whereCondition (it can be a function)
                fieldModel.data.templateOptions.DynamicOptions.whereCondition = whereParameter;
                fieldModel.data.templateOptions.DynamicOptions.ModalTitle = param.header;

                var to = fieldModel.data.templateOptions;
                to.DynamicOptions.extraTransportData = function() {
                  return { uzletiAdopter: F22AdopterId, whereCondition: whereParameter };
                };
                angular.extend(to, {
                  label: param.header,
                  required: paramRequired && !paramDisabled,
                  disabled: paramDisabled,
                  options: {
                    freeText: false,
                    writable: false,
                  },
                });
                desc.FormlyFieldDescriptor.templateOptions = to;
                vm.autoLoadFields.push([param.controlid, param.default]);
                vm.dynamicFields[index] = desc;
              })
              .catch(function(error) {
                console.error(error); // Note: this logs the js type error
              });

          default:
            vm.autoLoadFields.push([param.controlid, param.default]);
            break;
        }

        var desc = {
          Key: param.controlid,
          FieldGroup: 1,
          //"FieldOrder": param.f_tevpid,
          ControllerMethod: '',
          MaxLength: maxLength,
          UpperCase: upperCase,
          EnabledDisabledFieldsList: param.setControlOptions,
          OriginalRequired: paramRequired,
          FormlyFieldDescriptor: {
            key: param.controlid,
            type: type,
            className: paramClass,
            hide: paramHide,
            templateOptions: {
              label: param.header,
              required: paramRequired && !paramDisabled,
              disabled: paramDisabled,
              mask: mask,
              ComboOptions: null,
              GridOptions: null,
              DateTimeOptions: null,
              defaultValue: param.default,
              DynamicOptions: null,
              options: options,
              changed: null,
            },
          },
        };

        vm.dynamicFields[index] = desc;
        return $q.resolve(desc);
      }

      function GetType(param) {
        if (param.controltype === 'textbox') {
          if (param.picture.includes('T=D')) {
            return 'kendoDP';
          }

          if (param.jointable) {
            if (param.jointable.length !== 0) {
              return 'f22Input';
            }
          }

          if (param.picture.includes('T=N')) {
            return 'kendoNTB';
          }

          return 'input';
        }

        if (param.controltype === 'combobox') {
          return 'kendoDDL';
        }

        if (param.controltype === 'checkbox') {
          return 'checkbox';
        }

        if (param.controltype === 'radiobutton') {
          return 'radio';
        }

        return '';
      }

      function getDynamicModel() {
        var tempDynamicModel = angular.copy(vm.dynamicModel);

        angular.forEach(parsed, function(f) {
          var type = GetType(f);
          switch (type) {
            case 'f22Input':
              if (f.visible == 'false') {
                if (f.default) {
                  tempDynamicModel[f.controlid] = f.default;
                }
              } else {
                tempDynamicModel[f.controlid] = tempDynamicModel[f.controlid].Value;
              }
              break;
            case 'radio':
              var tempControlId = tempDynamicModel[f.controlid];
              if (tempControlId) {
                delete tempDynamicModel[f.controlid];
                tempDynamicModel[tempControlId] = 'true';
              }
              break;
          }
        });

        angular.forEach(parsed, function(f) {
          if (f.enabled == 'false') {
            delete tempDynamicModel[f.controlid];
          } else {
            if (f.visible == 'false' && f.default) {
              tempDynamicModel[f.controlid] = f.default;
            }
          }

          if (f.controltype == 'checkbox' && !tempDynamicModel[f.controlid]) {
            delete tempDynamicModel[f.controlid];
          }
        });

        return {
          tempDynamicModel,
        };
      }

      function save() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        var dm = getDynamicModel();
        var dynamicParams = dm.tempDynamicModel;

        mi.close({
          bejovoParameterek: dynamicParams,
        });
      }

      function selectionChanged(field, fieldkey, isChecked) {
        var enabledDisabledFieldsListString = lodash.find(field.EnabledDisabledFieldsList, function(f) {
          return f.key == fieldkey;
        });
        if (!enabledDisabledFieldsListString) return;

        var enabledDisabledFieldsListArray = enabledDisabledFieldsListString.value.split(';');
        console.log('Checked', isChecked, 'EnabledDisabledFieldsList', enabledDisabledFieldsListString);

        for (var i = 0; i < enabledDisabledFieldsListArray.length; i++) {
          var index = enabledDisabledFieldsListArray[i].indexOf(':');
          var controlId = enabledDisabledFieldsListArray[i].substr(0, index);
          var enebledOrDisabledString = enabledDisabledFieldsListArray[i].substr(index + 1);

          var disabledBool = isChecked;
          if (enebledOrDisabledString === 'E') {
            disabledBool = !isChecked;
          }

          setFieldDisable(controlId, disabledBool);
        }
      }

      function setFieldDisable(controlId, disabledBool, required) {
        var localField = lodash.find(vm.dynamicFields, function(f) {
          return f.Key == controlId;
        });

        if (localField) {
          var originalRequired = localField.OriginalRequired;
          var required = originalRequired && !disabledBool;

          var parsedElement = lodash.find(parsed, function(f) {
            return f.controlid == controlId;
          });
          if (parsedElement) {
            if (disabledBool) {
              parsedElement.enabled = 'false';
            } else {
              parsedElement.enabled = 'true';
            }

            if (required) {
              parsedElement.mandatory = 'true';
            } else {
              parsedElement.mandatory = 'false';
            }
          }

          switch (localField.FormlyFieldDescriptor.type) {
            case 'kendoDDL': {
              var ddl = $('#' + localField.FormlyFieldDescriptor.id).data('kendoDropDownList');
              ddl.enable(!disabledBool);
              localField.FormlyFieldDescriptor.templateOptions.required = required;
              break;
            }
            case 'kendoDP': {
              var dp = $('#' + localField.FormlyFieldDescriptor.id).data('kendoDatePicker');
              dp.enable(!disabledBool);
              localField.FormlyFieldDescriptor.templateOptions.required = required;
              break;
            }
            case 'kendoDTP': {
              var dtp = $('#' + localField.FormlyFieldDescriptor.id).data('kendoDateTimePicker');
              dtp.enable(!disabledBool);
              localField.FormlyFieldDescriptor.templateOptions.required = required;
              break;
            }
            case 'kendoNTB': {
              var ntb = $('#' + localField.FormlyFieldDescriptor.id).data('kendoNumericTextBox');
              ntb.enable(!disabledBool);
              localField.FormlyFieldDescriptor.templateOptions.required = required;
              break;
            }
            case 'f22Input': {
              localField.FormlyFieldDescriptor.templateOptions.disabled = disabledBool;
              localField.FormlyFieldDescriptor.templateOptions.required = required;
              break;
            }
            case 'input':
            case 'maskedInput':
            case 'checkbox': {
              if (localField.FormlyFieldDescriptor.id) {
                localField.FormlyFieldDescriptor.templateOptions.required = required;

                var inputField = $('#' + localField.FormlyFieldDescriptor.id);

                if (
                  disabledBool &&
                  !inputField[0].disabled &&
                  !required &&
                  inputField[0].required &&
                  !inputField[0].value
                ) {
                  localField.FormlyFieldDescriptor.formControl.$error = {};
                  localField.FormlyFieldDescriptor.formControl.$invalid = false;
                }

                inputField[0].disabled = disabledBool;
                inputField[0].required = required;
              }
              break;
            }
          }
        }
      }

      function updateReferenceField(field) {
        if (!isFirstRun[field.Key]) {
          isFirstRun[field.Key] = true;
          return;
        }

        updateFormInvalidProperty();

        if (!referenceControlIdArrays[field.Key]) return;

        // if the new value is null, then return
        if (referenceControlIdArrays[field.Key].Type === 'f22Input') {
          if (!vm.dynamicModel[field.Key].Value) return;
        } else {
          if (!vm.dynamicModel[field.Key]) return;
        }

        angular.forEach(referenceControlIdArrays[field.Key].ControlIds, function(refField) {
          var field2 = lodash.find(vm.dynamicFields, function(f) {
            return f.Key == refField;
          });
          if (field2) {
            var promises = [];

            // check if the current value fulfill the whereCondition
            var params = getF22PatternSearchParams(field2, vm.dynamicModel[field2.Key].Value ?? '');
            promises.push($http.post('F22/F22PatternSearch', params));

            // check then total number of the elements which fulfill the whereCondition
            var params2 = getF22PatternSearchParams(field2, '');
            promises.push($http.post('F22/F22PatternSearch', params2));

            $q.all(promises).then(data => {
              updateReferenceFieldValue(field2, data);
            });
          }
        });
      }

      function getF22PatternSearchParams(field2, searchPattern) {
        var whereCondition = field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition();
        return {
          pattern: searchPattern,
          keyColumn: field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.ValueFieldName,
          showColumn: field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.ValueFieldName,
          searchMode: 0,
          tableName: field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.TableName,
          whereCondition: whereCondition,
          adopter: vm.adopterType,
          uzletiAdopter: field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.UzletiAdopter,
          columnCsv: field2.FormlyFieldDescriptor.templateOptions.DynamicOptions.ValueFieldName,
          module: vm.module,
        };
      }

      function updateReferenceFieldValue(field2, data) {
        if (vm.dynamicModel[field2.Key].Value) {
          // if the current value fulfill the new whereCondition then return
          if (data[0].data.HitCount == 1 && vm.dynamicModel[field2.Key].Value == data[0].data.Value) return;
        }

        // if total number of the elements which fulfill the whereCondition is only 1 then we select it, otherwise set the F22 value to null
        if (data[1].data.HitCount == 1) {
          field2.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(data[1].data.Value);
          field2.FormlyFieldDescriptor.templateOptions.setFunctions.setText(data[1].data.Value);
        } else {
          field2.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(null);
          field2.FormlyFieldDescriptor.templateOptions.setFunctions.setText(null);
        }
      }

      function updateFormInvalidProperty() {
        var isInvalidElement = false;

        lodash.forEach(vm.dynamicFields, function(element) {
          if (element.FormlyFieldDescriptor) {
            if (element.FormlyFieldDescriptor.templateOptions.required) {
              var tempField = vm.dynamicModel[element.FormlyFieldDescriptor.key];
              if (tempField) {
                if (element.FormlyFieldDescriptor.type === 'f22Input') {
                  // f22 Value érték ellenőrzés (Value lehet null)
                  if (!tempField.Value) {
                    isInvalidElement = true;
                  }
                }
              } else {
                // required field-nek nincs értéke
                isInvalidElement = true;
              }
            }
          }
        });

        $scope.formInvalid = isInvalidElement;
      }

      function getF22WhereParameter(tempWhereParameterList, controlIdList) {
        // Ha a controlIdList 0-a elemű, akkor nem kell paramétert behelyettesíteni az F22 where feltételben
        if (controlIdList === undefined || controlIdList.length == 0) {
          return tempWhereParameterList.join('');
        }

        var returnString = '';

        // végigmegyünk a tempWhereParameterList tömb elemein és mindegyik után hozzáfűzzük a megfelelő controlId értékét, ha van ilyen
        for (var i = 0; i < tempWhereParameterList.length; i++) {
          // A controlIdList mindig eggyel kevesebb elemet tartalmaz, mint a tempWhereParameterList
          if (i < tempWhereParameterList.length - 1) {
            if (controlIdList[i].controlType == 'f22Input') {
              if (vm.dynamicModel[controlIdList[i].controlId].Value != null) {
                returnString +=
                  tempWhereParameterList[i] + "'" + vm.dynamicModel[controlIdList[i].controlId].Value + "'";
              } else {
                returnString += tempWhereParameterList[i] + "''";
              }
            } else {
              if (vm.dynamicModel[controlIdList[i].controlId] != null) {
                returnString += tempWhereParameterList[i] + "'" + vm.dynamicModel[controlIdList[i].controlId] + "'";
              } else {
                returnString += tempWhereParameterList[i] + "''";
              }
            }
          } else {
            returnString += tempWhereParameterList[i];
          }
        }

        // ha checkbox-ot hasonlítunk beégetett sql true / false értékhez, akkor az 1-et le kell cserélni true-ra
        returnString = returnString.replace("'false'~eq~1", "'false'~eq~'true'");
        returnString = returnString.replace("'true'~eq~1", "'true'~eq~'true'");

        return returnString;
      }

      function loadDefaultValues() {
        if (vm.defaulValuesLoaded) {
          updateFormInvalidProperty();
        }

        if (!vm.defaulValuesLoaded) {
          //check if every dynamic is rendered
          var dynamicFildsReady = true;
          for (var i = 0; i < vm.dynamicFieldsPromises.length; i++) {
            if (!vm.dynamicFields[i]) {
              dynamicFildsReady = false;
            }
          }

          //if everything is rendered and the deafult values wasn't loaded yet then load the default values
          if (dynamicFildsReady && !vm.isLoadingDefaultValues) {
            vm.isLoadingDefaultValues = true;

            //default érték miatti hack. Automatikusan le kell kérni a datasource-ot
            lodash.forEach(vm.autoLoadFields, function(af) {
              var field = lodash.find(vm.dynamicFields, function(f) {
                return f.Key == af[0];
              });
              if (field) {
                switch (field.FormlyFieldDescriptor.type) {
                  case 'kendoDDL': {
                    field.FormlyFieldDescriptor.templateOptions.changed = function() {
                      updateReferenceField(field);
                    };

                    var ddl = $('#' + field.FormlyFieldDescriptor.id).data('kendoDropDownList');
                    if (ddl) {
                      setTimeout(function() {
                        ddl.dataSource.read().then(function() {
                          if (af[1]) {
                            ddl.select(function(dataItem) {
                              return (
                                dataItem[
                                  field.FormlyFieldDescriptor.templateOptions.ComboOptions.valueField
                                ].toString() === af[1]
                              );
                            });
                          }
                          ddl.trigger('change');
                        });
                      }, 300);
                    }

                    break;
                  }
                  case 'f22Input': {
                    field.FormlyFieldDescriptor.templateOptions.options.writable = false;

                    field.FormlyFieldDescriptor.templateOptions.changed = function(e) {
                      var fieldCaption = lodash.find(vm.dynamicFields, function(f) {
                        return f.Key == field.Key + '_caption';
                      });
                      if (fieldCaption) {
                        var parsedElement = lodash.find(parsed, function(f) {
                          return f.controlid == field.Key;
                        });

                        var inputField = $('#' + fieldCaption.FormlyFieldDescriptor.id);
                        if (inputField[0]) {
                          if (e.GridItem) {
                            if (e.GridItem[parsedElement.joinlabel]) {
                              inputField[0].value = e.GridItem[parsedElement.joinlabel];
                            } else {
                              inputField[0].value = '';
                            }
                          } else {
                            inputField[0].value = '';
                          }
                        }
                      }

                      // update reference F22
                      updateReferenceField(field);
                    };

                    isFirstRun[field.Key] = true;
                    if (af[1]) {
                      setTimeout(function() {
                        if (field.FormlyFieldDescriptor.templateOptions.setFunctions.setValue) {
                          field.FormlyFieldDescriptor.templateOptions.setFunctions.setValue(af[1]);
                          field.FormlyFieldDescriptor.templateOptions.setFunctions.setText(af[1]);
                        }
                      }, 1000);
                    }

                    break;
                  }
                  case 'kendoDP': {
                    field.FormlyFieldDescriptor.templateOptions.changed = function() {
                      updateReferenceField(field);
                    };

                    if (af[1]) {
                      var dateobj = kendo.parseDate(af[1], 'yyyy.MM.dd');
                      var datestring = kendo.toString(dateobj, 'yyyy-MM-dd');

                      var dp = $('#' + field.FormlyFieldDescriptor.id).data('kendoDatePicker');
                      if (dp) {
                        dp.value(datestring);
                        dp.trigger('change');
                      }
                    } else {
                      isFirstRun[field.Key] = true;
                    }

                    break;
                  }
                  case 'kendoDTP': {
                    field.FormlyFieldDescriptor.templateOptions.changed = function() {
                      updateReferenceField(field);
                    };

                    if (af[1]) {
                      var dateobj = kendo.parseDate(af[1], 'yyyy.MM.dd hh:mm:ss');
                      var datestring = kendo.toString(dateobj, 'yyyy-MM-ddTHH:mm:ss');

                      var dtp = $('#' + field.FormlyFieldDescriptor.id).data('kendoDateTimePicker');
                      if (dtp) {
                        dtp.value(datestring);
                        dtp.trigger('change');
                      }
                    } else {
                      isFirstRun[field.Key] = true;
                    }

                    break;
                  }
                  case 'kendoNTB': {
                    field.FormlyFieldDescriptor.templateOptions.changed = function() {
                      updateReferenceField(field);
                    };

                    if (af[1]) {
                      var ntb = $('#' + field.FormlyFieldDescriptor.id).data('kendoNumericTextBox');
                      if (ntb) {
                        ntb.value(af[1]);
                        ntb.trigger('change');
                      }
                    } else {
                      isFirstRun[field.Key] = true;
                    }
                    break;
                  }
                  case 'input':
                  case 'maskedInput':
                  case 'checkbox': {
                    // Convert value to upper case
                    if (field.UpperCase) {
                      field.FormlyFieldDescriptor.templateOptions.customCallback = function() {
                        var inputField = $('#' + field.FormlyFieldDescriptor.id);
                        vm.dynamicModel[af[0]] = inputField[0].value.toUpperCase();
                        inputField[0].value = inputField[0].value.toUpperCase();

                        // call updateReferenceField with input delay
                        clearTimeout(delayTimer);
                        delayTimer = setTimeout(function() {
                          updateReferenceField(field);
                        }, 1000);
                      };
                    } else {
                      field.FormlyFieldDescriptor.templateOptions.customCallback = function() {
                        // call updateReferenceField with input delay
                        clearTimeout(delayTimer);
                        delayTimer = setTimeout(function() {
                          updateReferenceField(field);
                        }, 1000);
                      };
                    }

                    if (field.FormlyFieldDescriptor.type == 'checkbox' && field.EnabledDisabledFieldsList) {
                      field.FormlyFieldDescriptor.templateOptions.customCallback = function(e) {
                        //var inputField = $("#" + field.FormlyFieldDescriptor.id);
                        //var checked = inputField[0].checked;
                        //selectionChanged(field, field.Key, checked);
                        if (vm.checkBoxFields[field.FormlyFieldDescriptor.id] != e) {
                          selectionChanged(field, field.Key, e);
                        }
                        vm.checkBoxFields[field.FormlyFieldDescriptor.id] = e;

                        // call updateReferenceField with input delay
                        clearTimeout(delayTimer);
                        delayTimer = setTimeout(function() {
                          updateReferenceField(field);
                        }, 1000);
                      };
                    }

                    if (af[1]) {
                      var currentValue = af[1];
                      if (field.FormlyFieldDescriptor.type == 'checkbox') {
                        // convert string value to boolean
                        currentValue = af[1].toUpperCase() === 'TRUE';
                        vm.checkBoxFields[field.FormlyFieldDescriptor.id] = currentValue;

                        // run setselectionChange
                        /*if (currentValue == true) {
                                                        if (field.EnabledDisabledFieldsList) {
                                                            selectionChanged(field, field.Key, currentValue);
                                                        }
                                                    }*/
                      }
                      var inputField =
                        $('#' + field.FormlyFieldDescriptor.id) ||
                        $("input[name='" + field.FormlyFieldDescriptor.id + "']");
                      if (inputField && inputField[0]) {
                        vm.dynamicModel[af[0]] = currentValue;
                        if (typeof field.FormlyFieldDescriptor.updateInitialValue === 'function') {
                          field.FormlyFieldDescriptor.updateInitialValue();
                          field.FormlyFieldDescriptor.resetModel();
                          inputField[0].value = currentValue;
                        }
                      }
                    } else {
                      isFirstRun[field.Key] = true;
                    }

                    break;
                  }
                }

                // Handle radio type template
                if (field.FormlyFieldDescriptor.templateUrl) {
                  if (af[1]) {
                    var inputField = $('#' + field.FormlyFieldDescriptor.id);
                    vm.dynamicModel[af[0]] = af[1];

                    if (af[1] == 'noselect') {
                      vm.validRadioButtonSelected = false;
                    }

                    // run setelectionChange if there is a default radio button value
                    if (field.EnabledDisabledFieldsList) {
                      selectionChanged(field, af[1], true);
                    }

                    vm.XrecSelectedRadiobutton = af[1];
                  }

                  field.FormlyFieldDescriptor.templateOptions.changed = function() {
                    if (vm.XrecSelectedRadiobutton) {
                      if (field.EnabledDisabledFieldsList) {
                        selectionChanged(field, vm.XrecSelectedRadiobutton, false);
                      }
                    }
                    vm.XrecSelectedRadiobutton = vm.dynamicModel['radioButton1'];

                    // Set other controls to enabled or disabled
                    var radioButtonSelected = vm.dynamicModel['radioButton1'];
                    if (radioButtonSelected) {
                      if (radioButtonSelected == 'noselect') {
                        vm.validRadioButtonSelected = false;
                      } else {
                        vm.validRadioButtonSelected = true;
                      }

                      if (field.EnabledDisabledFieldsList) {
                        selectionChanged(field, radioButtonSelected, true);
                      }
                    }
                  };
                }
              }
            });

            vm.defaulValuesLoaded = true;
          }
        }

        if (!$scope.formInvalid && vm.defaulValuesLoaded) {
          var filteredParsed = parsed.filter(function(x) {
            return x.enabled === undefined || x.enabled === 'true';
          });
          if (filteredParsed.length === 0) {
            // konzulensi kérésre kivettük az automatikus bezárást
            //vm.save();
          }
        }
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentInformationModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'AuthService',
    'lodash',
    'options',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$window',
    '$q',
    '$timeout',
    function(
      $scope,
      $stateParams,
      mi,
      authService,
      lodash,
      options,
      $state,
      $location,
      $http,
      $uibModal,
      $window,
      $q,
      $timeout
    ) {
      mi.opened
        .then(function(e) {
          if (options.parameters === '') {
            toastr.error('Nincs megjeleníthető dokumentum paraméter!');
            vm.ok();
          }
        })
        .catch(function(error) {
          console.error(error); // Note: this logs the js type error
        });

      var vm = this;

      var parsed = JSON.parse(options.parameters || '[]');
      vm.autoLoadFields = [];
      vm.defaulValuesLoaded = false;
      vm.isLoadingDefaultValues = false;

      vm.dynamicFieldsPromises = [];
      vm.dynamicFields = [];
      for (var i = 0; i < parsed.length; i++) {
        vm.dynamicFieldsPromises.push(ConvertParameterToFormlyDescriptor(parsed[i], vm, i));
      }

      vm.dynamicModel = {};

      $q.all(vm.dynamicFieldsPromises)
        .then(function(result) {
          vm.dynamicFormlyDescriptor = GenerateFormlyDescriptor(vm.dynamicFields);
        })
        .catch(function(error) {
          console.error(error); // Note: this logs the js type error
        });

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        var fs = fieldSetter;
        fs.vm = vm;

        generateForm(vm);
      }

      function GenerateFormlyDescriptor(fields) {
        var formlyDescriptor = [
          {
            className: 'col-lg-12',
            fieldGroup: [
              {
                className: 'row',
                fieldGroup: fields.map(function(f) {
                  return processFieldDescriptor(f).FormlyFieldDescriptor;
                }),
              },
              {
                className: 'col-lg-12',
                template: '',
              },
            ],
          },
        ];

        return formlyDescriptor;
      }

      function ConvertParameterToFormlyDescriptor(param, vm, index) {
        var type = 'input';
        var options = {};
        var maxLength = 255;

        switch (type) {
          case 'input':
            vm.autoLoadFields.push([param.controlid, param.default]);
            break;
        }

        var desc = {
          Key: param.controlid,
          FieldGroup: 1,
          ControllerMethod: '',
          FormlyFieldDescriptor: {
            key: param.controlid,
            type: type,
            className: 'col-lg-6 col-md-offset-right-0',
            hide: false,
            templateOptions: {
              label: param.header,
              required: false,
              disabled: true,
              ComboOptions: null,
              GridOptions: null,
              DateTimeOptions: null,
              defaultValue: param.default,
              DynamicOptions: null,
              changed: null,
            },
          },
        };

        vm.dynamicFields[index] = desc;
        return $q.resolve(desc);
      }

      vm.intervalFunctionId = setInterval(loadDefaultValues, 1000);

      function loadDefaultValues() {
        if (!vm.defaulValuesLoaded) {
          //check if every dynamic is rendered
          var dynamicFildsReady = true;
          for (var i = 0; i < vm.dynamicFieldsPromises.length; i++) {
            if (!vm.dynamicFields[i]) {
              dynamicFildsReady = false;
            }
          }

          //if everything is rendered and the deafult values wasn't loaded yet then load the default values
          if (dynamicFildsReady && !vm.isLoadingDefaultValues) {
            vm.isLoadingDefaultValues = true;

            //default érték miatti hack. Automatikusan le kell kérni a datasource-ot
            lodash.forEach(vm.autoLoadFields, function(af) {
              var field = lodash.find(vm.dynamicFields, function(f) {
                return f.Key == af[0];
              });
              if (field) {
                switch (field.FormlyFieldDescriptor.type) {
                  case 'input': {
                    if (af[1]) {
                      var currentValue = af[1];
                      var inputField = $('#' + field.FormlyFieldDescriptor.id);
                      if (inputField) {
                        vm.dynamicModel[af[0]] = currentValue;
                        field.FormlyFieldDescriptor.updateInitialValue();
                        field.FormlyFieldDescriptor.resetModel();
                        inputField[0].value = currentValue;
                      }
                    }
                    break;
                  }
                }
              }
            });

            vm.defaulValuesLoaded = true;
          }
        }
      }

      vm.cancel = function() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        mi.dismiss('cancel');
      };

      vm.ok = function() {
        if (vm.intervalFunctionId) {
          clearInterval(vm.intervalFunctionId);
        }

        mi.close();
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentInsertGenericModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    'selectedDossier',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function(
      $scope,
      $stateParams,
      mi,
      fus,
      authService,
      options,
      selectedDossier,
      $state,
      $location,
      $http,
      $uibModal,
      $timeout
    ) {
      var vm = this;
      vm.title = 'Dokumentum alap adatok';
      vm.processCaption = '';
      vm.process = process;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.getSaveDisabledState = function() {
        return vm.formly.$invalid || (vm.dataModel.AttachmentType == 'DCSS' && !vm.dataModel.Fajl);
      };

      vm.selectedFile = [];
      vm.tableid = options.dto.f_tableid;
      vm.ownerid = options.dto.f_ownerid;
      vm.uzletiAdopter = options.adopter;
      vm.maxFileSizeMegabyte = options.maxFileSizeMegabyte;
      vm.docAttachRuleMode = options.docAttachRuleMode;
      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        vm.dataModel.AttachMode = vm.docAttachRuleMode === '2' ? 1 : 0;
        vm.dataModel.AttachFile = true;
        vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;

        delete vm.pageModel.Fields.Fajl.MaxLength;
        vm.pageModel.Fields.Fajl.FormlyFieldDescriptor.templateOptions.options.validation = {
          maxFileSize: vm.maxFileSizeMegabyte * 1024 * 1024,
        };

        var eventHandlers = {
          Fajl: {
            onError: function() {},
            onSuccess: function() {
              debugger;
            },
            onComplete: function() {
              debugger;
            },
            onSelect: function(f) {
              $scope.$apply(function() {
                vm.dataModel.Fajl = f.files == null ? '' : 'ok';
                vm.selectedFile.push(...f.files.map(f => f.rawFile));
              });
            },
            onRemove: function(f) {
              $scope.$apply(function() {
                vm.selectedFile = vm.selectedFile.filter(function(item1) {
                  return !f.files.some(item2 => item2.name === item1.name);
                });
              });
            },
          },
        };
        InsertEventHandlers(vm.pageModel, eventHandlers);

        var fs = fieldSetter;
        fs.vm = vm;

        vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[0].disabled =
          vm.docAttachRuleMode === '2';
        vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[1].disabled =
          vm.docAttachRuleMode === '1';

        vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[2].disabled =
          !vm.dataModel.hasDossierAttachAction || vm.docAttachRuleMode === '1';
        vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[3].disabled =
          !vm.dataModel.hasDossierAttachAction || vm.docAttachRuleMode === '1';

        fs.setOnChangeFunction('AttachmentType', function(selectedItem) {
          switch (selectedItem.key) {
            case 'DCSS':
              vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;
              vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[2].hide = false;
              vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[3].hide = false;
              break;
            case 'DCSD':
              vm.processCaption = vm.pageModel.Labels.ProcessCaption2.Title;
              vm.dataModel.AttachFile = true;
              vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[2].hide = true;
              vm.pageModel.Fields.AttachMode.FormlyFieldDescriptor.templateOptions.options.dataSource[3].hide = true;
              if (vm.dataModel.AttachMode > 1) vm.dataModel.AttachMode = 1;
              break;
            default:
              vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;
          }
        });

        fs.setOnChangeFunction('AttachMode', function(selectedItem) {
          vm.dataModel.AttachFile = vm.dataModel.AttachMode == '0';
          vm.dataModel.AttachDossier = vm.dataModel.AttachMode == '2' || vm.dataModel.AttachMode == '3';
        });

        fs.hideField('AttachFile', function() {
          return vm.dataModel.AttachmentType == 'DCSD';
        });

        fs.hideField('AttachDossier', function() {
          return !(vm.dataModel.AttachMode == '2' || vm.dataModel.AttachMode == '3');
        });

        fs.hideField('Dossziek', function() {
          return !(vm.dataModel.AttachMode == '1');
        });

        fs.setRequired('Dossziek', function() {
          return vm.dataModel.AttachMode == '1';
        });

        fs.hideField('NewDossier', function() {
          return !(vm.dataModel.AttachMode == '2');
        });

        fs.setRequired('NewDossier', function() {
          return vm.dataModel.AttachMode == '2';
        });

        fs.hideField('DossziekFilter', function() {
          return !(vm.dataModel.AttachMode == '3');
        });

        fs.setOnBlurFunction('DossziekFilter', function(value, v2) {
          vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        });

        fs.hideField('AllDossier', function() {
          return !(vm.dataModel.AttachMode == '3');
        });

        fs.setRequired('AllDossier', function() {
          return vm.dataModel.AttachMode == '3';
        });

        fs.setRequired('f_doctype', function() {
          return vm.dataModel.AttachmentType == 'DCSS';
        });

        fs.hideField('f_doctype', function() {
          return vm.dataModel.AttachmentType == 'DCSD';
        });

        fs.setRequired('Fajl', function() {
          return vm.dataModel.AttachmentType == 'DCSS';
        });

        fs.hideField('Fajl', function() {
          return vm.dataModel.AttachmentType == 'DCSD';
        });

        generateForm(vm);

        vm.pageModel.Fields.f_doctype.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          f_tableid: vm.tableid,
          f_ownerid: vm.ownerid,
          f_uzletiAdopter: vm.uzletiAdopter,
        };

        // vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
        // f_docsrcid: vm.dataModel.f_docsrcid, uzletiAdopter: options.adopter
        // };

        vm.pageModel.Fields.AttachmentType.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          if (e.sender.dataSource.data().length == 0) {
            e.sender.select(0);
          } else {
            e.sender.select(function(dataItem) {
              return dataItem['key'].toString() === 'DCSS';
            });
          }
          e.sender.trigger('change');
        };

        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.autoBind = false;
        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.contentType =
          'application/x-www-form-urlencoded; charset=UTF-8';
        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return {
            f_ownerid: vm.dataModel.f_ownerid,
            f_tableid: vm.dataModel.f_tableid,
            f_docsrcid: vm.dataModel.f_docsrcid,
            uzletiAdopter: options.adopter,
          };
        };

        vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.autoBind = false;
        vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.contentType =
          'application/x-www-form-urlencoded; charset=UTF-8';
        vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return {
            f_docsrcid: vm.dataModel.f_docsrcid,
            uzletiAdopter: options.adopter,
            filter: vm.dataModel.DossziekFilter,
          };
        };

        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          if (e.sender.dataSource.data().length == 0) {
            e.sender.select(0);
          } else {
            e.sender.select(1);
          }
          e.sender.trigger('change');
        };

        /*
		vm.pageModel.Fields.DocLibs.FormlyFieldDescriptor.templateOptions.options.autoBind = true;
        vm.pageModel.Fields.DocLibs.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return {
            uzletiAdopter: options.adopter,
          };
        };
        vm.pageModel.Fields.DocLibs.FormlyFieldDescriptor.templateOptions.options.dataBound = function (e) {
                    var selectedIndex = e.sender.selectedIndex - 1;
                };

        vm.pageModel.Fields.DocLibs.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          if (e.sender.dataSource.data().length == 0) {
            e.sender.select(0);
          } else {
            e.sender.select(1);
          }
          e.sender.trigger('change');
        };
		*/
      }

      function process() {
        if (
          vm.dataModel.AttachFile !== true &&
          (vm.dataModel.AttachMode == 0 ||
            ([2, 3].includes(vm.dataModel.AttachMode) && vm.dataModel.AttachDossier !== true))
        ) {
          bootbox.dialog({
            message: 'Biztos, hogy nem akar csatolást létrehozni?',
            title: vm.messages.Confirm,
            buttons: {
              confirm: {
                label: vm.messages.Yes,
                className: 'btn-primary',
                callback: function() {
                  verifyDossier();
                },
              },
              cancel: {
                label: vm.messages.No,
                className: 'btn-default',
              },
            },
          });
        } else {
          verifyDossier();
        }
      }

      function verifyDossier() {
        if (vm.dataModel.AttachMode == 2) {
          $http({
            url: 'DocumentWF/GetDossierExists',
            method: 'POST',
            data: {
              f_docsrcid: vm.dataModel.f_docsrcid,
              dossier: vm.dataModel.NewDossier,
              adopter: '',
            },
          })
            .then(function(fieldRes) {
              if (!!fieldRes.data.messages && fieldRes.data.messages.length > 0) {
                bootbox.dialog({
                  title: 'Figyelmeztetés!',
                  message: fieldRes.data.messages.map(x => x.Message).join('<br/>'),
                  buttons: {
                    cancel: {
                      label: 'Rendben',
                      className: 'btn-default',
                      callback: function() {},
                    },
                  },
                });
              } else {
                closeAndSave();
              }
            })
            .catch(function(error) {
              console.error(error); // Note: this logs the js type error
            });
        } else {
          closeAndSave();
        }
      }

      function closeAndSave() {
        var model = angular.copy(vm.dataModel);

        if (vm.docAttachRuleMode == '1') {
          model.Dossziek = '';
        }

        if (vm.dataModel.AttachmentType == 'DCSD') {
          vm.dataModel.AttachFile = true;
        }

        mi.close({
          f_docsrcid: vm.dataModel.f_docsrcid,
          f_ownerid: vm.dataModel.f_ownerid,
          f_tableid: vm.dataModel.f_tableid,
          linkedtype: vm.dataModel.f_doctype.Value,
          attachmentType: vm.dataModel.AttachmentType,
          documentDataModel: model,
          documentFileName: vm.selectedFile,
        });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  var wftTipusok = [
    { key: 'WFT1', text: 'titkos, csak dosszién keresztül látható' },
    { key: 'WFT2', text: 'nem titkos, de kell hozzá jogosultság' },
    { key: 'WFT3', text: 'teljesen publikus, mindenki láthatja' },
  ];

  module.controller('DocumentInsertModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function($scope, $stateParams, mi, fus, authService, options, $state, $location, $http, $uibModal, $timeout) {
      var vm = this;
      vm.title = 'Dokumentum feltöltése';
      vm.adopter = options.adopter;
      vm.save = save;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };
      vm.selectedFile = [];
      vm.linkedTypeFilter = options.linkedTypeFilter;
      vm.maxFileSizeMegabyte = options.maxFileSizeMegabyte;

      //if (options.data.dto.dokudatum) {
      //    options.data.dto.dokudatum = options.data.dto.dokudatum.substring(0, 10).replace('-', '.').replace('-', '.') + ".";
      //}

      /*if (options.dto.dokudatum) {
                options.dto.dokudatum = options.dto.dokudatum.substring(0, 10).replace('-', '.').replace('-', '.') + ".";
            }*/

      /*vm.changed = function (f) {
                $scope.$apply(function () {
                    vm.dataModel.Fajl = f == null ? "" : "ok";
                    vm.selectedFile = f;
                });
            };*/

      vm.changed = function(f) {
        if (f.eventType == 'Add') {
          $scope.$apply(function() {
            vm.dataModel.Fajl = f == null ? '' : 'ok';
            vm.selectedFile.push(f);
          });
        }
        if (f.eventType == 'Remove') {
          $scope.$apply(function() {
            vm.selectedFile = vm.selectedFile.filter(function(obj) {
              return obj.name !== f.name;
            });
          });
        }

        if (vm.selectedFile.length > 0) {
          vm.dataModel.Fajl = 'ok';
        } else {
          vm.dataModel.Fajl = null;
        }
      };

      init();

      function init() {
        //initModel($http, $state, $stateParams, vm, options.data, $uibModal);
        //initViewModel($http, $state, $stateParams, vm, options.data, $uibModal);
        //initFormModel($http, $state, $stateParams, vm, options.data, $uibModal);
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setOnChangeFunction('f_docsrcid', function(selectedItem) {
          vm.dataModel.Dossziek = '';
          vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource.read();
        });

        //vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.type = "kendoMS";
        //vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options = FormlyCreateDDLOption({ url: "Combo/ListDosszie", autoClose: false });

        //vm.pageModel.Fields.Fajl.FormlyFieldDescriptor.type = "file";
        vm.pageModel.Fields.Fajl.FormlyFieldDescriptor.type = 'multipleFile';
        delete vm.pageModel.Fields.Fajl.MaxLength;
        vm.pageModel.Fields.Fajl.FormlyFieldDescriptor.templateOptions.options.validation = {
          maxFileSize: vm.maxFileSizeMegabyte * 1024 * 1024,
        };
        vm.pageModel.Fields.Fajl.FormlyFieldDescriptor.templateOptions.changed = vm.changed;

        //szerintem ezek feleslegesek
        //whereconditions
        //vm.pageModel.Fields.f_ugylet.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function whereCondition() {
        //    if (vm.dataModel.f_ugylet) {
        //        return "f_ugylet~eq~'" + vm.dataModel.f_ugylet.Value + "'";
        //    }
        //    return "";
        //};
        //vm.pageModel.Fields.f_partner.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function whereCondition() {
        //    if (vm.dataModel.f_partner) {
        //        return "f_partner~eq~'" + vm.dataModel.f_partner.Value + "'";
        //    }
        //    return "";
        //};
        //vm.pageModel.Fields.naptariev.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function whereCondition() {
        //    if (vm.dataModel.naptariev) {
        //        return "f_penzev~eq~'" + vm.dataModel.naptariev.Value + "'";
        //    }
        //    return "";
        //};
        //vm.pageModel.Fields.f_doctype.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function whereCondition() {
        //    if (vm.dataModel.f_doctype) {
        //        return "f_doctype~eq~'" + vm.dataModel.f_doctype.Value + "'";
        //    }
        //    return "";
        //};

        if (vm.linkedTypeFilter) {
          vm.pageModel.Fields.f_doctype.FormlyFieldDescriptor.templateOptions.DynamicOptions.whereCondition = function() {
            return "f_doctype~in~'" + vm.linkedTypeFilter + "'";
          };
        }

        generateForm(vm);

        //vm.pageModel.Fields.f_partner.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function () { return { uzletiAdopter: options.data.uzletiAdopter }; };
        //vm.pageModel.Fields.f_ugylet.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function () { return { uzletiAdopter: options.data.uzletiAdopter }; };
        //vm.pageModel.Fields.naptariev.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function () { return { uzletiAdopter: options.data.uzletiAdopter }; };
        //vm.pageModel.Fields.f_doctype.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function () { return { uzletiAdopter: options.data.uzletiAdopter }; };
        //vm.pageModel.Fields.f_fldhely.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function () { return { uzletiAdopter: options.data.uzletiAdopter }; };
        vm.pageModel.Fields.f_partner.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function() {
          return { uzletiAdopter: options.adopter };
        };
        vm.pageModel.Fields.f_ugylet.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function() {
          return { uzletiAdopter: options.adopter };
        };
        vm.pageModel.Fields.naptariev.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function() {
          return { uzletiAdopter: options.adopter };
        };
        vm.pageModel.Fields.f_doctype.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function() {
          return { uzletiAdopter: options.uzletiAdopter };
        };
        vm.pageModel.Fields.f_fldhely.FormlyFieldDescriptor.templateOptions.options.extraTransportData = function() {
          return { uzletiAdopter: options.adopter };
        };

        // Map Dossiers
        //var mapped = options.data.dossiers.map(function (d) { return { text: d, key: d }; });
        /*var mapped = options.dossiers.map(function (d) { return { text: d, key: d }; });
                if (mapped.length === 1) {
                    mapped[0].selected = true;
                }
                vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataBound = function (e) {
                    if (mapped.length === 1) {
                        this.select(1);
                        this.trigger("change");
                    }
                };
                vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource = { data: mapped };
                vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.autoBind = true;*/

        vm.pageModel.Fields.dokudatum.FormlyFieldDescriptor.templateOptions.defaultValue = options.dto.dokudatum;

        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.autoBind = false;
        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.contentType =
          'application/x-www-form-urlencoded; charset=UTF-8';
        vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return {
            f_ownerid: vm.dataModel.f_ownerid,
            f_tableid: vm.dataModel.f_tableid,
            f_docsrcid: vm.dataModel.f_docsrcid,
            uzletiAdopter: vm.adopter,
          };
        };

        vm.pageModel.Fields.f_docsrcid.FormlyFieldDescriptor.templateOptions.options.autoBind = true;
        vm.pageModel.Fields.f_docsrcid.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
          return {
            uzletiAdopter: vm.adopter,
          };
        };
        vm.pageModel.Fields.f_docsrcid.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          var selectedIndex = e.sender.selectedIndex - 1;
        };

        vm.pageModel.Fields.f_docsrcid.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          if (e.sender.dataSource.data().length == 0) {
            e.sender.select(0);
          } else {
            e.sender.select(1);
          }
          e.sender.trigger('change');
        };

        vm.pageModel.Fields.titkosjel.FormlyFieldDescriptor.templateOptions.options.autoBind = true;
        vm.pageModel.Fields.titkosjel.FormlyFieldDescriptor.templateOptions.options.dataBound = function(e) {
          if (e.sender.dataSource.data().length == 0) {
            e.sender.select(0);
          } else {
            e.sender.select(3);
          }
          e.sender.trigger('change');
        };
      }

      function save() {
        //vm.dataModel.Dossziek = vm.pageModel.Fields.Dossziek.FormlyFieldDescriptor.templateOptions.selectedItems;
        //vm.dataModel.Dossziek = [vm.dataModel.Dossziek];
        var model = angular.copy(vm.dataModel);
        //var file;
        //if (model.Fajl) {
        //    file = vm.dataModel.Fajl.getFile();
        //}

        var dynamicParams = {};
        dynamicParams['f_partner'] = model['f_partner'].Value;
        dynamicParams['naptariev'] = model['naptariev'].Value;
        dynamicParams['f_fldhely'] = model['f_fldhely'].Value;
        dynamicParams['f_ugylet'] = model['f_ugylet'].Value;
        dynamicParams['dokudatum'] = model['dokudatum'];
        dynamicParams['kulbiz'] = model['kulbiz'];
        dynamicParams['titkosjel'] = model['titkosjel'];
        dynamicParams['mgj'] = model['mgj'];

        fus
          .postWithFile('DocumentWF/Insert', {
            model: model,
            files: vm.selectedFile,
            bejovoParameterek: dynamicParams,
            uzletiAdopter: vm.adopter,
          })
          .then(function(response) {
            //$http.post("Document/Insert", model).success(function (response) {
            toastr.success('Sikeres mentés');
            mi.close();
          })
          .catch(function(error) {
            console.error(error); // Note: this logs the js type error
          });
      }

      /*scope.$watch('$viewContentLoaded', function () {
                $timeout(function () {
                    var field = vm.pageModel.Fields.dokudatum;
                    var ddl = $("#" + field.FormlyFieldDescriptor.id).data("kendoDatePicker");
                    ddl.trigger("change");
                }, 1500);
            });*/

      setTimeout(function() {
        //default érték miatti hack.
        var field = vm.pageModel.Fields.dokudatum;
        var ddl = $('#' + field.FormlyFieldDescriptor.id).data('kendoDatePicker');
        ddl.trigger('change');
      }, 1500);
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('AttachDossierModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function($scope, $stateParams, mi, fus, authService, options, $state, $location, $http, $uibModal, $timeout) {
      var vm = this;
      vm.title = 'Dosszié csatolása';
      vm.processCaption = '';
      vm.process = process;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        vm.dataModel.AttachMode = 0;
        vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;

        var fs = fieldSetter;
        fs.vm = vm;

        fs.hideField('NewDossier', function() {
          return !(vm.dataModel.AttachMode == '0');
        });

        fs.hideField('AllDossier', function() {
          return !(vm.dataModel.AttachMode == '1');
        });

        fs.setOnChangeFunction('AttachMode', function(selectedItem) {
          if (vm.dataModel.AttachMode == '1') {
            vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.autoBind = false;
            vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.contentType =
              'application/x-www-form-urlencoded; charset=UTF-8';
            vm.pageModel.Fields.AllDossier.FormlyFieldDescriptor.templateOptions.options.dataSource.options.transport.read.data = function() {
              return {
                f_docsrcid: vm.dataModel.f_docsrcid,
                uzletiAdopter: options.adopter,
              };
            };
          }
        });

        generateForm(vm);
      }
      function process() {
        var model = angular.copy(vm.dataModel);

        if (vm.docAttachRuleMode == '1') {
          model.Dossziek = '';
        }

        mi.close(vm.dataModel);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('AttachReferenceModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function($scope, $stateParams, mi, fus, authService, options, $state, $location, $http, $uibModal, $timeout) {
      var vm = this;

      vm.process = process;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };
      vm.f_lnkidF22_ngif = false;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        vm.dataModel.AttachMode = 0;
        //vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setOnChangeFunction('f_lnktbl', function(selectedItem) {
          var tableName = selectedItem.Value.trim();
          var tableText = selectedItem.Text;
          var label = vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions.label;
          vm.f_lnkidF22_ngif = false;
          if (tableName) {
            $http
              .post('F22/GetDynamicF22FieldModel', {
                installAdopter:
                  vm.pageModel.Fields.f_lnktbl.FormlyFieldDescriptor.templateOptions.DynamicOptions.InstallAdopter,
                adopter: vm.pageModel.Fields.f_lnktbl.FormlyFieldDescriptor.templateOptions.DynamicOptions.Adopter,
                table: tableName.includes(':') ? tableName.split(':')[1] : tableName,
                key: selectedItem.GridItem.idcolumn,
                value: '',
                freeText: false,
                writable: false,
                filteringMode: 0,
                patternMatchMode: 0,
              })
              .then(function(result) {
                // Set it on the appropriate f22 value input
                var f22_fieldModel = result.data;
                // generate options by field model
                f22_fieldModel.templateOptions.DynamicOptions.ModalTitle = tableText;
                F22Helpers.setF22Options(f22_fieldModel);
                vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions;
                //vm.row[rowUniqId].ngIf = true;
                vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions = f22_fieldModel.templateOptions;
                vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions.label = label;
                vm.pageModel.Fields.f_lnkid.FormlyFieldDescriptor.templateOptions.required = true;
                vm.f_lnkidF22_ngif = true;
              });
          }
        });

        generateForm(vm);
      }
      function process() {
        var model = angular.copy(vm.dataModel);
        mi.close(vm.dataModel);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('AttachTextModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    'viewOnly',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function(
      $scope,
      $stateParams,
      mi,
      fus,
      authService,
      options,
      viewOnly,
      $state,
      $location,
      $http,
      $uibModal,
      $timeout
    ) {
      var vm = this;
      vm.processCaption = '';
      vm.process = process;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };
      vm.viewOnly = viewOnly;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        vm.title = vm.viewOnly === true ? 'Csatolt szöveg' : 'Szöveg  csatolása';
        vm.processCaption = vm.pageModel.Labels.ProcessCaption1.Title;

        var fs = fieldSetter;
        fs.vm = vm;

        if (vm.viewOnly === true) {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }

        fs.hideField('ModUser', function() {
          return vm.viewOnly !== true;
        });

        fs.hideField('ModDate', function() {
          return vm.viewOnly !== true;
        });

        vm.pageModel.Fields.text.FormlyFieldDescriptor.templateOptions.rows = 9;

        generateForm(vm);

        vm.pageModel.Fields.linkedtype.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "f_aktiv~neq~'IVNN'";
        };
        vm.pageModel.Fields.linkedform.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          return "f_szabad~eq~'IVNI'";
        };
      }
      function process() {
        var model = angular.copy(vm.dataModel);

        mi.close(vm.dataModel);
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('NewVersionModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function($scope, $stateParams, mi, fus, authService, options, $state, $location, $http, $uibModal, $timeout) {
      var vm = this;
      vm.process = process;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };
      vm.selectedFile = [];

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        var eventHandlers = {
          Fajl: {
            onError: function() {},
            onSuccess: function() {
              debugger;
            },
            onComplete: function() {
              debugger;
            },
            onSelect: function(f) {
              $scope.$apply(function() {
                vm.selectedFile = f.files[0].rawFile;
              });
            },
            onRemove: function(f) {
              $scope.$apply(function() {
                vm.selectedFile = null;
              });
            },
          },
        };
        InsertEventHandlers(vm.pageModel, eventHandlers);

        var fs = fieldSetter;
        fs.vm = vm;

        generateForm(vm);
      }
      function process() {
        vm.dataModel.Fajl = !vm.dataModel.Fajl ? '' : 'ok';
        mi.close({ model: vm.dataModel, file: vm.selectedFile });
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentHistoryModalCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'FileUploadService',
    'AuthService',
    'options',
    'selectedRow',
    '$state',
    '$location',
    '$http',
    '$uibModal',
    '$timeout',
    function(
      $scope,
      $stateParams,
      mi,
      fus,
      authService,
      options,
      selectedRow,
      $state,
      $location,
      $http,
      $uibModal,
      $timeout
    ) {
      var vm = this;
      vm.ok = ok;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);
        vm.filter;

        vm.dataModel.dosszie = selectedRow.DocType == 2;
        vm.dataModel.ownerId = true;
        vm.dataModel.docId = true;

        var fs = fieldSetter;
        fs.vm = vm;

        var getGridFilter = function() {
          var filter = [];
          if (selectedRow.DocType == 0) {
            //Dokumentum
            var subFilter = [];
            if (vm.dataModel.ownerId == true) {
              subFilter.push("ownerid~eq~'" + selectedRow.f_ownerid + "'");
            }
            if (vm.dataModel.docId == true) {
              subFilter.push("docid~eq~'" + selectedRow.f_doclibidc + "'");
            }
            var statement = subFilter.join('~or~');
            if (statement) {
              filter.push('(' + statement + ')');
            }
          } else if (selectedRow.DocType == 1) {
            if (vm.dataModel.ownerId == true) {
              filter.push("ownerid~eq~'" + selectedRow.f_ownerid + "'");
            }
          } else if (selectedRow.DocType == 2) {
            var subFilter = [];
            if (vm.dataModel.ownerId == true) {
              subFilter.push("ownerid~eq~'" + selectedRow.f_ownerid + "'");
            }
            if (vm.dataModel.dosszie == true) {
              subFilter.push("dosszie~eq~'" + selectedRow.dosszie + "'");
            }
            var statement = subFilter.join('~or~');
            if (statement) {
              filter.push('(' + statement + ')');
            }
          }

          if (vm.dataModel.isFailed == true) {
            filter.push("status~eq~'FAILED'");
          }

          vm.filter = filter.join('~and~');
          return filter.join('~and~');
        };

        initMainGrid(vm, 'GridHistory', 'Grid/Data', function() {}, null, false, getGridFilter, null);

        fs.setDisabled('dosszie', function() {
          return selectedRow.DocType != 2;
        });

        var customCallbackFunctions = {
          ownerId: function() {
            vm.mainGrid.dataSource.read();
          },
          docId: function() {
            vm.mainGrid.dataSource.read();
          },
          dosszie: function() {
            vm.mainGrid.dataSource.read();
          },
          isFailed: function() {
            vm.mainGrid.dataSource.read();
          },
        };

        InsertCustomCallbackFunctions(vm.pageModel, customCallbackFunctions);

        generateForm(vm);
      }
      function ok() {
        mi.close();
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('DocumentReferencesModalCtrl_ForrasDoclib', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    '$window',
    'options',
    'selectedRow',
    'gridService',
    function($scope, $http, $state, $stateParams, mi, $window, options, selectedRow, gridService) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocLibNavCtrl', stateParams);
      }
      var vm = this;

      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.getFilter = function() {
        return {
          f_docsrcid: selectedRow.f_docsrcid,
          f_doclibidc: selectedRow.f_doclibidc,
        };
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign(vm.pageModel.Grids.GridReferences, {
            ControllerMethod: 'DocumentWF/DocumentReferencesList/',
          }),
          transportData: vm.getFilter,
          selectFunction: function(e) {},
          disableOptions: {
            AutoComplete: true,
          },
        });

        generateForm(vm);
      }

      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('sbForrasDoclib'));

(function(module) {
  'use strict';

  module.controller('OtherSettingsModCtrl_ForrasDoclib', [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    'AuthService',
    'options',
    '$state',
    '$http',
    '$uibModal',
    function($scope, $stateParams, mi, authService, options, $state, $http, $uibModal) {
      var vm = this;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $uibModal);
        initViewModel($http, $state, $stateParams, vm, options, $uibModal);
        initFormModel($http, $state, $stateParams, vm, options, $uibModal);

        var fs = fieldSetter;
        fs.vm = vm;

        generateForm(vm);

        vm.save = function() {
          $http({
            url: 'DocumentWF/OtherSettingsEdit',
            method: 'POST',
            data: {
              model: vm.dataModel,
            },
          })
            .then(function(fieldRes) {
              mi.close();
            })
            .catch(function(error) {
              console.error(error); // Note: this logs the js type error
            });
        };

        vm.cancel = function() {
          mi.dismiss('cancel');
        };
      }
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('ForrasDoclib_MainNumberAssignNavCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModal',
    '$window',
    'FileUploadService',
    'DoclibcsService',
    'AuthService',
    '$httpParamSerializer',
    'WalService',
    'options',
    'HistoryService',
    'DasService',
    '$timeout',
    'gridService',
    'LanguageService',
    'lodash',
    '$q',
    function(
      $scope,
      $http,
      $state,
      $stateParams,
      $uibModal,
      $window,
      FileUploadService,
      DoclibcsService,
      authService,
      $httpParamSerializer,
      walService,
      options,
      HistoryService,
      dasService,
      $timeout,
      gridService,
      LanguageService,
      lodash,
      $q
    ) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocLibNavCtrl', stateParams);
      }
      var vm = this;

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        vm.ownerId = /^\d+$/.test($stateParams.ownerId) ? $stateParams.ownerId.padStart(10, ' ') : $stateParams.ownerId;

        vm.openAssignModal = openAssignModal;
        vm.deleteAssign = deleteAssign;

        vm.back = function() {
          $state.go('ForrasDoclib.DocumentNav', { tableId: $stateParams.tableId, ownerId: $stateParams.ownerId });
        };

        vm.mainGridOptions = gridService.buildKendoConfigForGridModel({
          gridModel: Object.assign(vm.pageModel.Grids.GridMainNumbers, {
            ControllerMethod: 'DocumentWF/MainNumberAssignList/',
          }),
          transportData: vm.getFilter,
          selectFunction: function(e) {
            $timeout(function() {
              var selectedItems = GetSelectedGridItems(vm.mainGrid);
              vm.selectedItem = selectedItems ? selectedItems[0] : null;
            });
          },
        });

        generateForm(vm);
      }

      function openAssignModal(editMode) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/ForrasDoclib/MainNumberAssignMod.html',
          controller: 'MainNumberAssignModCtrl_ForrasDoclib',
          controllerAs: 'vm',
          resolve: {
            editMode: function() {
              return editMode;
            },
            options: RouteResolveFunc('DocumentWF/MainNumberAssign' + (editMode == 'View' ? 'Edit' : editMode), {
              ikt_id: vm.selectedItem.ikt_id,
            }),
          },
          backdrop: 'static',
        });

        modalInstance.result.then(function() {
          vm.mainGrid.dataSource.read();
        });
      }

      function deleteAssign() {
        $http
          .get('DocumentWF/MainNumberAssignDelete/' + vm.selectedItem.ikt_id)
          .then(function(response) {
            vm.mainGrid.dataSource.read();
          })
          .catch(function(response) {});
      }

      function setDasModel() {
        var dasDescriptor = vm.pageModel.Grids['GridMainNumbers'].DasDescriptor;
        var selectedItems = GetSelectedGridItems(vm.mainGrid);
        vm.dasModel = {
          routeId: dasDescriptor.routeId,
          tableId: dasDescriptor.tableId,
          ownerId: selectedItems[0][dasDescriptor.ownerColumn],
        };
        $scope.$applyAsync();
      }

      //////// GRID state playground /////////////////////////////////////////////////////////
      vm.saveGridOptions = saveGridOptions;

      function saveGridOptions() {
        localStorage.setItem('options', kendo.stringify(vm.mainGrid.getOptions()));
      }

      vm.loadGridOptions = loadGridOptions;

      function loadGridOptions() {
        var options = localStorage.options;
        vm.mainGrid.setOptions(JSON.parse(options));
      }
      //////////////////////////////////////////////////////////////////////////////////////
    },
  ]);
})(angular.module('sbForrasDoclib'));

(function(module) {
  'use strict';

  module.controller('MainNumberAssignModCtrl_ForrasDoclib', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    '$uibModalInstance',
    '$window',
    'options',
    'editMode',
    function($scope, $http, $state, $stateParams, mi, $window, options, editMode) {
      if (typeof ctrlInit !== 'undefined') {
        let stateParams = typeof $stateParams !== 'undefined' ? $stateParams : null;
        ctrlInit(this, 'DocLibNavCtrl', stateParams);
      }
      var vm = this;

      vm.editMode = editMode;

      vm.cancel = function() {
        mi.dismiss('cancel');
      };

      vm.save = function() {
        $http
          .post('DocumentWF/MainNumberAssign' + vm.editMode, vm.dataModel)
          .then(function(response) {
            mi.close(response);
          })
          .catch(function(response) {
            toastr.error(vm.pageModel.Messages.SaveFailed);
          });
      };

      init();

      function init() {
        initModel($http, $state, $stateParams, vm, options, $window);
        initViewModel($http, $state, $stateParams, vm, options, $window);
        initFormModel($http, $state, $stateParams, vm, options, $window);

        if (vm.editMode == 'View') {
          angular.forEach(vm.pageModel.Fields, function(value, key) {
            value.FormlyFieldDescriptor.templateOptions.disabled = true;
          });
        }

        vm.pageModel.Fields.dosszie.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          let id = vm.dataModel.f_docsrcid || 0;
          return 'docsrcid~eq~' + (vm.dataModel.f_docsrcid?.Value || 0) + '';
        };

        vm.pageModel.Fields.ikt_konyvid.FormlyFieldDescriptor.templateOptions.options.whereCondition = function() {
          let id = vm.dataModel.f_docsrcid || 0;
          return 'f_docsrcid~eq~' + (vm.dataModel.f_docsrcid?.Value || 0) + '';
        };

        var fs = fieldSetter;
        fs.vm = vm;

        fs.setOnChangeFunction('f_docsrcid', function(selectedItem, x) {
          if (!!selectedItem && !!selectedItem.GridItem) {
            vm.dataModel.f_docsrctype = selectedItem.GridItem.f_docsrctype;
          } else if (!selectedItem.Value) {
            vm.dataModel.f_docsrctype = null;
          }
          setIktSzervF2Condition();
          //újratölteni a mezőket
        });

        fs.setOnChangeFunction('ikt_konyvid', function(selectedItem, x) {
          if (!!selectedItem && !!selectedItem.GridItem) {
            vm.dataModel.f_azon = selectedItem.GridItem.f_azon;
            vm.dataModel.f_ev = selectedItem.GridItem.f_ev;
            vm.dataModel.f_lezart = selectedItem.GridItem.f_lezart == 'IVNI';
            vm.dataModel.f_nev = selectedItem.GridItem.f_nev;
            vm.dataModel.f_szervkod = selectedItem.GridItem.f_szervkod;
          } else if (!selectedItem.Value) {
            vm.dataModel.f_azon = null;
            vm.dataModel.f_ev = null;
            vm.dataModel.f_lezart = null;
            vm.dataModel.f_nev = null;
            vm.dataModel.f_szervkod = null;
          }
          setIktSzervF2Condition();
        });

        generateForm(vm);
      }

      function setIktSzervF2Condition() {
        vm.pageModel.Fields.f_elozo.FormlyFieldDescriptor.templateOptions.options.gridOptions.otherParams = {
          f_docsrcid: vm.dataModel.f_docsrcid?.Value || 0,
          ikt_id: vm.dataModel.ikt_id || 0,
        };
      }
    },
  ]);
})(angular.module('sbForrasDoclib'));

(function(module) {
  'use strict';

  module.controller('DocumentModalCtrl_ForrasDoclib', [
    '$uibModalInstance',
    'workflow',
    '$state',
    '$http',
    '$window',
    function(mi, workflow, $state, $http, $window) {
      var vm = this;
      vm.cancel = function() {
        mi.dismiss('cancel');
      };
      vm.documentData = [];
      vm.getDocument = getDocument;

      vm.treeData = [
        {
          text: workflow.Comment + ' (' + workflow.CurrentStepName + ')',
          extendedDoc: null,
          items: [],
        },
      ];

      function getDocument(id) {
        $window.location = 'Document/Download/' + id;
      }

      vm.treeOptions = {
        dataSource: {
          data: vm.treeData,
        },
        select: function(e) {
          var data = e.sender.dataItem(e.node);

          var current = vm.treeData[0];
          if (data.extendedDoc) {
            while (
              current.items &&
              current.items.length > 0 &&
              (!current.extendedDoc || current.extendedDoc.docID != data.extendedDoc.docID)
            ) {
              current = current.items[0];
            }
          }
          current.items = [];
          vm.loadDocumentData(data.extendedDoc);
        },
        dataBound: function(e) {
          if (e.sender) {
            e.sender.expand('.k-item');
          }
        },
      };

      vm.loadDocumentData = function(data) {
        $http({
          method: 'Post',
          url: 'Document/Documents',
          data: {
            id: workflow.WorkFlowID,
            extendedDoc: data,
          },
        }).then(
          function(response) {
            vm.documentData = response.data.Data.Data;
            vm.tree.setDataSource(
              new kendo.data.HierarchicalDataSource({
                data: vm.treeData,
              })
            );
            vm.mainGrid.setDataSource(
              new kendo.data.DataSource({
                data: vm.documentData,
                pageSize: 25,
                group: {
                  field: 'Type',
                },
                schema: {
                  model: {
                    fields: {
                      dokTarID: { type: 'number' },
                      docID: { type: 'number' },
                    },
                  },
                },
              })
            );
          },
          function(error) {
            //kiszedjük az előre belepakolt tree nodeot
            var node = vm.treeData[0];
            var items = vm.treeData[0].items;
            while (items && items.length > 0) {
              items = items[0].items;
              if (items && items.length > 0) {
                node = items[0];
              }
            }
            node.items = [];
            vm.tree.setDataSource(
              new kendo.data.HierarchicalDataSource({
                data: vm.treeData,
              })
            );
          }
        );
      };

      vm.mainGridOptions = {
        columns: [
          {
            field: 'dokumentumJellege',
            title: 'Dokumentum jellege',
            hidden: false,
          },
          {
            field: 'megnevezes',
            title: 'Megnevezés',
            hidden: false,
          },
          {
            field: 'mgj',
            title: 'Megjegyzés',
            hidden: false,
          },
          {
            field: 'bejegyzo',
            title: 'Bejegyző',
            hidden: false,
          },
          {
            field: 'datum',
            title: 'Dátum',
            hidden: false,
          },
          {
            field: 'dosszie',
            title: 'Dosszié',
            hidden: false,
          },
          {
            field: 'egyediAzonosito',
            title: 'Egyedazonosító',
            hidden: false,
          },
          {
            field: 'tablaKapcsolat',
            title: 'Tábla kapcsolat',
            hidden: false,
          },
          {
            field: 'dokTarID',
            title: 'Dok.tár.id',
            type: 'number',
            hidden: false,
          },
          {
            field: 'docID',
            title: 'Azonosító',
            type: 'number',
            hidden: false,
          },
          {
            field: 'esemDatum',
            title: 'Int/esem.dát.',
            hidden: false,
          },
          {
            field: 'hivatkozottTabla',
            title: 'Hivatkozott tábla',
            hidden: false,
          },
          {
            field: 'hivatkozottDokumentum',
            title: 'Hivatkozott dokumentum',
            hidden: false,
          },
          {
            field: 'Type',
            title: 'Típus',
            hidden: true,
          },
          {
            locked: true,
            command: [
              {
                name: 'download',
                title: 'Letöltés',
                click: function(e) {
                  var tr = $(e.target).closest('tr');
                  var data = this.dataItem(tr);
                  $window.location = 'Document/Download/' + data.dokTarID;
                },
                //iconClass: 'glyphicon glyphicon-download',
                template:
                  '<a class="btn k-button k-grid-download"><span class="glyphicon glyphicon-download"></span></a>',
                visible: function(d) {
                  return d.DocType == 0;
                },
              },
              {
                name: 'list',
                title: 'Listáz',
                click: function(e) {
                  var tr = $(e.target).closest('tr');
                  var data = this.dataItem(tr);
                  var newItem = { text: data.megnevezes, extendedDoc: data, items: [] };
                  var items = vm.treeData[0].items;
                  while (items && items.length > 0) {
                    items = items[0].items;
                  }
                  items.push(newItem);

                  vm.loadDocumentData(data);
                },
                //iconClass: 'glyphicon glyphicon-download',
                template: '<a class="btn k-button k-grid-list"><span class="glyphicon glyphicon-list"></span></a>',
                visible: function(d) {
                  return d.DocType != 0;
                },
              },
            ],
          },
        ],
        dataSource: {
          data: [],
          pageSize: 25,
          group: {
            field: 'Type',
          },
          schema: {
            model: {
              fields: {
                dokTarID: { type: 'number' },
                docID: { type: 'number' },
              },
            },
          },
        },
        pageable: {
          refresh: false,
          pageSizes: [5, 10, 20, 50, 100],
          buttonCount: 5,
        },
        height: 350,
        resizable: true,
        dataBound: function() {
          var dataSource = this.dataSource;
          for (var i = 0; i < this.columns.length; i++) {
            this.autoFitColumn(i);
          }
        },
        filterable: {
          mode: 'row',
          operators: {
            string: {
              contains: kendo.ui.FilterMenu.prototype.options.operators.string.contains,
              startswith: kendo.ui.FilterMenu.prototype.options.operators.string.startswith,
              eq: kendo.ui.FilterMenu.prototype.options.operators.string.eq,
              neq: kendo.ui.FilterMenu.prototype.options.operators.string.neq,
              doesnotcontain: kendo.ui.FilterMenu.prototype.options.operators.string.doesnotcontain,
              endswith: kendo.ui.FilterMenu.prototype.options.operators.string.endswith,
              isnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnull,
              isnotnull: kendo.ui.FilterMenu.prototype.options.operators.string.isnotnull,
              isempty: kendo.ui.FilterMenu.prototype.options.operators.string.isempty,
              isnotempty: kendo.ui.FilterMenu.prototype.options.operators.string.isnotempty,
            },
          },
        },
        //mégsem kell a detail
        //detailTemplate: function (e) {
        //    console.log(e);
        //    return 'Files: <div class="grid"></div>';
        //},
        //detailInit: function (e) {
        //    e.detailRow.find(".grid").kendoGrid({
        //        dataSource: ["A", "B"]
        //    });
        //},
        //dataBound: function (e) {
        //    var dataSource = this.dataSource;
        //    this.element.find('tr.k-master-row').each(function () {
        //        var row = $(this);
        //        var data = dataSource.getByUid(row.data('uid'));
        //        if (data.DocType != 2) {
        //            row.find("td.k-hierarchy-cell .k-icon").removeClass();
        //        }
        //    });
        //}
      };

      vm.loadDocumentData(null);
    },
  ]);
})(angular.module('myApp'));

'use strict';
(function(module) {
  module.service('SurveyService', [
    '$http',
    '$uibModal',
    function($http, $uibModal) {
      this.openSurveyModal = function(entityType, surveyCode, entityId, callbackFunction, ...args) {
        $http
          .get('Survey/GetSurveyModel', { params: { entityType: entityType, surveyCode: surveyCode } })
          .then(function(result) {
            if (result.data.hasSurvey === true) {
              result.data['entityId'] = entityId;
              result.data['callbackFunction'] = callbackFunction;
              result.data['callbackArgs'] = args;

              var modalInstance = $uibModal.open({
                templateUrl: 'App/Survey/SurveyModal.html',
                controller: 'SurveyModalCtrl as vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'modal-survey',
                resolve: {
                  model: result.data,
                },
              });

              modalInstance.result
                .then(function(response) {
                  if (angular.isFunction(callbackFunction)) {
                    callbackFunction(...args);
                  }
                })
                .catch(function(response) {});
            } else {
              if (angular.isFunction(callbackFunction)) {
                callbackFunction(...args);
              }
            }
          });
      };

      this.deleteResponses = function(entityType, surveyCode, entityId) {
        $http
          .post('Survey/DeleteResponsesFromEntity', {
            entityType: entityType,
            surveyCode: surveyCode,
            entityId: entityId,
          })
          .then(function(result) {})
          .catch(function(result) {});
      };

      this.generateSurveyReports = function(entityType, surveyCode, reportType, reportName) {
        var modalInstance = $uibModal.open({
          templateUrl: 'App/Survey/SurveyReportModal.html',
          controller: 'SurveyReportModalCtrl',
          controllerAs: 'vm',
          resolve: {
            model: RouteResolveFunc('Survey/GetSurveyReportModal/', {
              entityType: entityType,
              surveyCode: surveyCode,
              reportType: reportType,
              reportName: reportName,
            }),
          },
          backdrop: 'static',
        });
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SurveyModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    function($scope, $http, $state, $stateParams, model, mi) {
      var vm = this;

      vm.pageModel = model.pageModel;
      vm.hasRequiredQuestion = model.hasRequiredQuestion;
      vm.hasSurvey = model.hasSurvey;
      vm.surveyId = model.surveyId;
      vm.entityId = model.entityId;
      vm.formModel = model.dto;
      vm.messages = model.pageModel.Messages;
      vm.saveInProgress = false;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelSurvey.FormlyDescriptor;

      vm.compileModel = function() {
        vm.dataList = [];
        angular.forEach(vm.formModel, function(value, key) {
          let row = JSON.parse(vm.pageModel.Fields[key].FormlyFieldDescriptor.templateOptions.DynamicOptions);
          row['Response'] = row.QuestionType === 'STYNU' ? parseInt(value) : value;
          vm.dataList.push(row);
        });

        let json = { SurveyId: vm.surveyId, EntityId: vm.entityId, SurveyResponses: vm.dataList };
        return json;
      };

      vm.save = function() {
        console.log(vm);
        vm.saveInProgress = true;
        vm.compileModel();
        $http
          .post('Survey/InsertResponses', { responses: vm.compileModel() })
          .then(function(result) {
            mi.close('save');
          })
          .catch(function(result) {
            vm.saveInProgress = false;
          });
      };

      vm.cancel = function() {
        mi.close('cancel');
      };
    },
  ]);
})(angular.module('myApp'));

(function(module) {
  'use strict';

  module.controller('SurveyReportModalCtrl', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'model',
    '$uibModalInstance',
    'FileSaver',
    function($scope, $http, $state, $stateParams, model, mi, FileSaver) {
      var vm = this;

      vm.pageModel = model.pageModel;
      vm.formModel = model.dto;
      vm.origModel = angular.copy(model.dto);
      vm.messages = model.pageModel.Messages;

      var formlyFormPanelDescriptors = GenerateFormlyFormPanelsFromPageModel(vm.pageModel);
      vm.formFields = formlyFormPanelDescriptors.PanelForm.FormlyDescriptor;

      var hideExpressions = {
        EntityType: function($viewValue, $modelValue, scope) {
          return !!vm.origModel.EntityType;
        },
        SurveyCode: function($viewValue, $modelValue, scope) {
          return !!vm.origModel.SurveyCode;
        },
        ReportType: function($viewValue, $modelValue, scope) {
          return !!vm.origModel.ReportType;
        },
        ReportName: function($viewValue, $modelValue, scope) {
          return !!vm.origModel.ReportName;
        },
      };

      var customExpressionProperties = {};

      var onChangeFunctions = {};

      var syncValidators = {};

      InsertHideExpressions(vm.pageModel, hideExpressions);
      InsertCustomExpressionProperties(vm.pageModel, customExpressionProperties);
      InsertOnChangeFunctions(vm.pageModel, onChangeFunctions);
      InsertSyncValidators(vm.pageModel, syncValidators);

      vm.generate = function() {
        console.log(vm);
        vm.saveInProgress = true;

        $http
          .post('Survey/GenerateReport', vm.formModel)
          .then(function(result) {
            var reportFullName =
              vm.pageModel.Fields.ReportName.FormlyFieldDescriptor.templateOptions.options.dataSource
                .data()
                ?.find(function(x) {
                  return x.key == vm.formModel.ReportName;
                })?.text || result.data.FileName;
            var ext = result.data.FileName.split('.').pop();
            var raw = window.atob(result.data.Report);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));
            for (var i = 0; i < rawLength; i++) {
              array[i] = raw.charCodeAt(i);
            }
            var fs = new Blob([array], { type: result.data.MimeType });
            saveAs(fs, decodeURIComponent(reportFullName + '.' + ext));
            mi.close('cancel');
          })
          .catch(function(result) {
            vm.saveInProgress = false;
            toastr.error(vm.pageModel.Messages.GenerateFailed);
          });
      };

      vm.cancel = function() {
        mi.close('cancel');
      };
    },
  ]);
})(angular.module('myApp'));

//# sourceMappingURL=application-concat.js.map